const _excluded = ["editor", "innerRef"],
  _excluded2 = ["start"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import * as e from "react";
import t, { useState as n, useEffect as r, useRef as o, createElement as i, Component as a, forwardRef as c, useMemo as s, useCallback as l, useContext as u, createContext as d, Fragment as f, useLayoutEffect as p, cloneElement as m, useImperativeHandle as h, useDebugValue as A } from "react";
import g, { oneOf as v } from "prop-types";
import { DateRangePicker as C, SingleDatePicker as b } from "react-dates";
import E, { components as y } from "react-select";
import I, { createPortal as B, flushSync as x } from "react-dom";
import { NavLink as w, Link as Q } from "react-router-dom";
function H(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function z(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? H(Object(n), !0).forEach(function (t) {
      k(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : H(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function M(e) {
  return M = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, M(e);
}
function k(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function N() {
  return N = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N.apply(this, arguments);
}
function S(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function V(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var r,
      o,
      i = [],
      a = !0,
      c = !1;
    try {
      for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
    } catch (e) {
      c = !0, o = e;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (c) throw o;
      }
    }
    return i;
  }(e, t) || P(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function L(e) {
  return function (e) {
    if (Array.isArray(e)) return O(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || P(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function P(e, t) {
  if (e) {
    if ("string" == typeof e) return O(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? O(e, t) : void 0;
  }
}
function O(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function T(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function D(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? T(Object(n), !0).forEach(function (t) {
      F(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function R(e) {
  return R = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, R(e);
}
function G(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function F(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function j(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var r,
      o,
      i = [],
      a = !0,
      c = !1;
    try {
      for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
    } catch (e) {
      c = !0, o = e;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (c) throw o;
      }
    }
    return i;
  }(e, t) || Z(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function J(e) {
  return function (e) {
    if (Array.isArray(e)) return W(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Z(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Z(e, t) {
  if (e) {
    if ("string" == typeof e) return W(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? W(e, t) : void 0;
  }
}
function W(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
var X = function () {},
  U = {},
  K = {},
  Y = null,
  q = {
    mark: X,
    measure: X
  };
try {
  "undefined" != typeof window && (U = window), "undefined" != typeof document && (K = document), "undefined" != typeof MutationObserver && (Y = MutationObserver), "undefined" != typeof performance && (q = performance);
} catch (SZ) {}
var _ = (U.navigator || {}).userAgent,
  $ = void 0 === _ ? "" : _,
  ee = U,
  te = K,
  ne = Y,
  re = q;
ee.document;
var oe,
  ie,
  ae,
  ce,
  se,
  le = !!te.documentElement && !!te.head && "function" == typeof te.addEventListener && "function" == typeof te.createElement,
  ue = ~$.indexOf("MSIE") || ~$.indexOf("Trident/"),
  de = ["HTML", "HEAD", "STYLE", "SCRIPT"],
  fe = function () {
    try {
      return "production" === process.env.NODE_ENV;
    } catch (e) {
      return !1;
    }
  }(),
  pe = ["classic", "sharp"];
function me(e) {
  return new Proxy(e, {
    get: function (e, t) {
      return t in e ? e[t] : e.classic;
    }
  });
}
var he = me((F(oe = {}, "classic", {
    fa: "solid",
    fas: "solid",
    "fa-solid": "solid",
    far: "regular",
    "fa-regular": "regular",
    fal: "light",
    "fa-light": "light",
    fat: "thin",
    "fa-thin": "thin",
    fad: "duotone",
    "fa-duotone": "duotone",
    fab: "brands",
    "fa-brands": "brands",
    fak: "kit",
    "fa-kit": "kit"
  }), F(oe, "sharp", {
    fa: "solid",
    fass: "solid",
    "fa-solid": "solid",
    fasr: "regular",
    "fa-regular": "regular",
    fasl: "light",
    "fa-light": "light"
  }), oe)),
  Ae = me((F(ie = {}, "classic", {
    solid: "fas",
    regular: "far",
    light: "fal",
    thin: "fat",
    duotone: "fad",
    brands: "fab",
    kit: "fak"
  }), F(ie, "sharp", {
    solid: "fass",
    regular: "fasr",
    light: "fasl"
  }), ie)),
  ge = me((F(ae = {}, "classic", {
    fab: "fa-brands",
    fad: "fa-duotone",
    fak: "fa-kit",
    fal: "fa-light",
    far: "fa-regular",
    fas: "fa-solid",
    fat: "fa-thin"
  }), F(ae, "sharp", {
    fass: "fa-solid",
    fasr: "fa-regular",
    fasl: "fa-light"
  }), ae)),
  ve = me((F(ce = {}, "classic", {
    "fa-brands": "fab",
    "fa-duotone": "fad",
    "fa-kit": "fak",
    "fa-light": "fal",
    "fa-regular": "far",
    "fa-solid": "fas",
    "fa-thin": "fat"
  }), F(ce, "sharp", {
    "fa-solid": "fass",
    "fa-regular": "fasr",
    "fa-light": "fasl"
  }), ce)),
  Ce = /fa(s|r|l|t|d|b|k|ss|sr|sl)?[\-\ ]/,
  be = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp|Kit)?.*/i,
  Ee = me((F(se = {}, "classic", {
    900: "fas",
    400: "far",
    normal: "far",
    300: "fal",
    100: "fat"
  }), F(se, "sharp", {
    900: "fass",
    400: "fasr",
    300: "fasl"
  }), se)),
  ye = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  Ie = ye.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]),
  Be = ["class", "data-prefix", "data-icon", "data-fa-transform", "data-fa-mask"],
  xe = "duotone-group",
  we = "swap-opacity",
  Qe = "primary",
  He = "secondary",
  ze = new Set();
Object.keys(Ae.classic).map(ze.add.bind(ze)), Object.keys(Ae.sharp).map(ze.add.bind(ze));
var Me = [].concat(pe, J(ze), ["2xs", "xs", "sm", "lg", "xl", "2xl", "beat", "border", "fade", "beat-fade", "bounce", "flip-both", "flip-horizontal", "flip-vertical", "flip", "fw", "inverse", "layers-counter", "layers-text", "layers", "li", "pull-left", "pull-right", "pulse", "rotate-180", "rotate-270", "rotate-90", "rotate-by", "shake", "spin-pulse", "spin-reverse", "spin", "stack-1x", "stack-2x", "stack", "ul", xe, we, Qe, He]).concat(ye.map(function (e) {
    return "".concat(e, "x");
  })).concat(Ie.map(function (e) {
    return "w-".concat(e);
  })),
  ke = ee.FontAwesomeConfig || {};
if (te && "function" == typeof te.querySelector) {
  [["data-family-prefix", "familyPrefix"], ["data-css-prefix", "cssPrefix"], ["data-family-default", "familyDefault"], ["data-style-default", "styleDefault"], ["data-replacement-class", "replacementClass"], ["data-auto-replace-svg", "autoReplaceSvg"], ["data-auto-add-css", "autoAddCss"], ["data-auto-a11y", "autoA11y"], ["data-search-pseudo-elements", "searchPseudoElements"], ["data-observe-mutations", "observeMutations"], ["data-mutate-approach", "mutateApproach"], ["data-keep-original-source", "keepOriginalSource"], ["data-measure-performance", "measurePerformance"], ["data-show-missing-icons", "showMissingIcons"]].forEach(function (e) {
    var t = j(e, 2),
      n = t[0],
      r = t[1],
      o = function (e) {
        return "" === e || "false" !== e && ("true" === e || e);
      }(function (e) {
        var t = te.querySelector("script[" + e + "]");
        if (t) return t.getAttribute(e);
      }(n));
    null != o && (ke[r] = o);
  });
}
var Ne = {
  styleDefault: "solid",
  familyDefault: "classic",
  cssPrefix: "fa",
  replacementClass: "svg-inline--fa",
  autoReplaceSvg: !0,
  autoAddCss: !0,
  autoA11y: !0,
  searchPseudoElements: !1,
  observeMutations: !0,
  mutateApproach: "async",
  keepOriginalSource: !0,
  measurePerformance: !1,
  showMissingIcons: !0
};
ke.familyPrefix && (ke.cssPrefix = ke.familyPrefix);
var Se = D(D({}, Ne), ke);
Se.autoReplaceSvg || (Se.observeMutations = !1);
var Ve = {};
Object.keys(Ne).forEach(function (e) {
  Object.defineProperty(Ve, e, {
    enumerable: !0,
    set: function (t) {
      Se[e] = t, Le.forEach(function (e) {
        return e(Ve);
      });
    },
    get: function () {
      return Se[e];
    }
  });
}), Object.defineProperty(Ve, "familyPrefix", {
  enumerable: !0,
  set: function (e) {
    Se.cssPrefix = e, Le.forEach(function (e) {
      return e(Ve);
    });
  },
  get: function () {
    return Se.cssPrefix;
  }
}), ee.FontAwesomeConfig = Ve;
var Le = [];
var Pe = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: !1,
  flipY: !1
};
function Oe() {
  for (var e = 12, t = ""; e-- > 0;) t += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
  return t;
}
function Te(e) {
  for (var t = [], n = (e || []).length >>> 0; n--;) t[n] = e[n];
  return t;
}
function De(e) {
  return e.classList ? Te(e.classList) : (e.getAttribute("class") || "").split(" ").filter(function (e) {
    return e;
  });
}
function Re(e) {
  return "".concat(e).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Ge(e) {
  return Object.keys(e || {}).reduce(function (t, n) {
    return t + "".concat(n, ": ").concat(e[n].trim(), ";");
  }, "");
}
function Fe(e) {
  return e.size !== Pe.size || e.x !== Pe.x || e.y !== Pe.y || e.rotate !== Pe.rotate || e.flipX || e.flipY;
}
function je() {
  var e = "fa",
    t = "svg-inline--fa",
    n = Ve.cssPrefix,
    r = Ve.replacementClass,
    o = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Solid";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Regular";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Light";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Thin";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-counter-scale, 0.25));\n          transform: scale(var(--fa-counter-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  -webkit-transform: scale(var(--fa-layers-scale, 0.25));\n          transform: scale(var(--fa-layers-scale, 0.25));\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(var(--fa-li-width, 2em) * -1);\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  -webkit-animation-name: fa-beat;\n          animation-name: fa-beat;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  -webkit-animation-name: fa-bounce;\n          animation-name: fa-bounce;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  -webkit-animation-name: fa-fade;\n          animation-name: fa-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  -webkit-animation-name: fa-beat-fade;\n          animation-name: fa-beat-fade;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n          animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  -webkit-animation-name: fa-flip;\n          animation-name: fa-flip;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, ease-in-out);\n          animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  -webkit-animation-name: fa-shake;\n          animation-name: fa-shake;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-delay: var(--fa-animation-delay, 0s);\n          animation-delay: var(--fa-animation-delay, 0s);\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 2s);\n          animation-duration: var(--fa-animation-duration, 2s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, linear);\n          animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  -webkit-animation-name: fa-spin;\n          animation-name: fa-spin;\n  -webkit-animation-direction: var(--fa-animation-direction, normal);\n          animation-direction: var(--fa-animation-direction, normal);\n  -webkit-animation-duration: var(--fa-animation-duration, 1s);\n          animation-duration: var(--fa-animation-duration, 1s);\n  -webkit-animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n          animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  -webkit-animation-timing-function: var(--fa-animation-timing, steps(8));\n          animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    -webkit-animation-delay: -1ms;\n            animation-delay: -1ms;\n    -webkit-animation-duration: 1ms;\n            animation-duration: 1ms;\n    -webkit-animation-iteration-count: 1;\n            animation-iteration-count: 1;\n    -webkit-transition-delay: 0s;\n            transition-delay: 0s;\n    -webkit-transition-duration: 0s;\n            transition-duration: 0s;\n  }\n}\n@-webkit-keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  45% {\n    -webkit-transform: scale(var(--fa-beat-scale, 1.25));\n            transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@-webkit-keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    -webkit-transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n            transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    -webkit-transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n            transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    -webkit-transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n            transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    -webkit-transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n            transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    -webkit-transform: scale(1, 1) translateY(0);\n            transform: scale(1, 1) translateY(0);\n  }\n}\n@-webkit-keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@-webkit-keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: scale(var(--fa-beat-fade-scale, 1.125));\n            transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@-webkit-keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    -webkit-transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n            transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@-webkit-keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@keyframes fa-shake {\n  0% {\n    -webkit-transform: rotate(-15deg);\n            transform: rotate(-15deg);\n  }\n  4% {\n    -webkit-transform: rotate(15deg);\n            transform: rotate(15deg);\n  }\n  8%, 24% {\n    -webkit-transform: rotate(-18deg);\n            transform: rotate(-18deg);\n  }\n  12%, 28% {\n    -webkit-transform: rotate(18deg);\n            transform: rotate(18deg);\n  }\n  16% {\n    -webkit-transform: rotate(-22deg);\n            transform: rotate(-22deg);\n  }\n  20% {\n    -webkit-transform: rotate(22deg);\n            transform: rotate(22deg);\n  }\n  32% {\n    -webkit-transform: rotate(-12deg);\n            transform: rotate(-12deg);\n  }\n  36% {\n    -webkit-transform: rotate(12deg);\n            transform: rotate(12deg);\n  }\n  40%, 100% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n}\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  -webkit-transform: rotate(var(--fa-rotate-angle, none));\n          transform: rotate(var(--fa-rotate-angle, none));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.fad.fa-inverse,\n.fa-duotone.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}';
  if (n !== e || r !== t) {
    var i = new RegExp("\\.".concat(e, "\\-"), "g"),
      a = new RegExp("\\--".concat(e, "\\-"), "g"),
      c = new RegExp("\\.".concat(t), "g");
    o = o.replace(i, ".".concat(n, "-")).replace(a, "--".concat(n, "-")).replace(c, ".".concat(r));
  }
  return o;
}
var Je = !1;
function Ze() {
  Ve.autoAddCss && !Je && (!function (e) {
    if (e && le) {
      var t = te.createElement("style");
      t.setAttribute("type", "text/css"), t.innerHTML = e;
      for (var n = te.head.childNodes, r = null, o = n.length - 1; o > -1; o--) {
        var i = n[o],
          a = (i.tagName || "").toUpperCase();
        ["STYLE", "LINK"].indexOf(a) > -1 && (r = i);
      }
      te.head.insertBefore(t, r);
    }
  }(je()), Je = !0);
}
var We = {
    mixout: function () {
      return {
        dom: {
          css: je,
          insertCss: Ze
        }
      };
    },
    hooks: function () {
      return {
        beforeDOMElementCreation: function () {
          Ze();
        },
        beforeI2svg: function () {
          Ze();
        }
      };
    }
  },
  Xe = ee || {};
Xe.___FONT_AWESOME___ || (Xe.___FONT_AWESOME___ = {}), Xe.___FONT_AWESOME___.styles || (Xe.___FONT_AWESOME___.styles = {}), Xe.___FONT_AWESOME___.hooks || (Xe.___FONT_AWESOME___.hooks = {}), Xe.___FONT_AWESOME___.shims || (Xe.___FONT_AWESOME___.shims = []);
var Ue = Xe.___FONT_AWESOME___,
  Ke = [],
  Ye = !1;
function qe(e) {
  le && (Ye ? setTimeout(e, 0) : Ke.push(e));
}
function _e(e) {
  var t = e.tag,
    n = e.attributes,
    r = void 0 === n ? {} : n,
    o = e.children,
    i = void 0 === o ? [] : o;
  return "string" == typeof e ? Re(e) : "<".concat(t, " ").concat(function (e) {
    return Object.keys(e || {}).reduce(function (t, n) {
      return t + "".concat(n, '="').concat(Re(e[n]), '" ');
    }, "").trim();
  }(r), ">").concat(i.map(_e).join(""), "</").concat(t, ">");
}
function $e(e, t, n) {
  if (e && e[t] && e[t][n]) return {
    prefix: t,
    iconName: n,
    icon: e[t][n]
  };
}
le && ((Ye = (te.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(te.readyState)) || te.addEventListener("DOMContentLoaded", function e() {
  te.removeEventListener("DOMContentLoaded", e), Ye = 1, Ke.map(function (e) {
    return e();
  });
}));
var et,
  tt,
  nt,
  rt = function (e, t, n, r) {
    var o,
      i,
      a,
      c = Object.keys(e),
      s = c.length,
      l = void 0 !== r ? function (e, t) {
        return function (n, r, o, i) {
          return e.call(t, n, r, o, i);
        };
      }(t, r) : t;
    for (void 0 === n ? (o = 1, a = e[c[0]]) : (o = 0, a = n); o < s; o++) a = l(a, e[i = c[o]], i, e);
    return a;
  };
function ot(e) {
  var t = function (e) {
    for (var t = [], n = 0, r = e.length; n < r;) {
      var o = e.charCodeAt(n++);
      if (o >= 55296 && o <= 56319 && n < r) {
        var i = e.charCodeAt(n++);
        56320 == (64512 & i) ? t.push(((1023 & o) << 10) + (1023 & i) + 65536) : (t.push(o), n--);
      } else t.push(o);
    }
    return t;
  }(e);
  return 1 === t.length ? t[0].toString(16) : null;
}
function it(e) {
  return Object.keys(e).reduce(function (t, n) {
    var r = e[n];
    return !!r.icon ? t[r.iconName] = r.icon : t[n] = r, t;
  }, {});
}
function at(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
    r = n.skipHooks,
    o = void 0 !== r && r,
    i = it(t);
  "function" != typeof Ue.hooks.addPack || o ? Ue.styles[e] = D(D({}, Ue.styles[e] || {}), i) : Ue.hooks.addPack(e, it(t)), "fas" === e && at("fa", t);
}
var ct = Ue.styles,
  st = Ue.shims,
  lt = (F(et = {}, "classic", Object.values(ge.classic)), F(et, "sharp", Object.values(ge.sharp)), et),
  ut = null,
  dt = {},
  ft = {},
  pt = {},
  mt = {},
  ht = {},
  At = (F(tt = {}, "classic", Object.keys(he.classic)), F(tt, "sharp", Object.keys(he.sharp)), tt);
function gt(e, t) {
  var n,
    r = t.split("-"),
    o = r[0],
    i = r.slice(1).join("-");
  return o !== e || "" === i || (n = i, ~Me.indexOf(n)) ? null : i;
}
var vt,
  Ct = function () {
    var e = function (e) {
      return rt(ct, function (t, n, r) {
        return t[r] = rt(n, e, {}), t;
      }, {});
    };
    dt = e(function (e, t, n) {
      if (t[3] && (e[t[3]] = n), t[2]) {
        var r = t[2].filter(function (e) {
          return "number" == typeof e;
        });
        r.forEach(function (t) {
          e[t.toString(16)] = n;
        });
      }
      return e;
    }), ft = e(function (e, t, n) {
      if (e[n] = n, t[2]) {
        var r = t[2].filter(function (e) {
          return "string" == typeof e;
        });
        r.forEach(function (t) {
          e[t] = n;
        });
      }
      return e;
    }), ht = e(function (e, t, n) {
      var r = t[2];
      return e[n] = n, r.forEach(function (t) {
        e[t] = n;
      }), e;
    });
    var t = "far" in ct || Ve.autoFetchSvg,
      n = rt(st, function (e, n) {
        var r = n[0],
          o = n[1],
          i = n[2];
        return "far" !== o || t || (o = "fas"), "string" == typeof r && (e.names[r] = {
          prefix: o,
          iconName: i
        }), "number" == typeof r && (e.unicodes[r.toString(16)] = {
          prefix: o,
          iconName: i
        }), e;
      }, {
        names: {},
        unicodes: {}
      });
    pt = n.names, mt = n.unicodes, ut = Bt(Ve.styleDefault, {
      family: Ve.familyDefault
    });
  };
function bt(e, t) {
  return (dt[e] || {})[t];
}
function Et(e, t) {
  return (ht[e] || {})[t];
}
function yt(e) {
  return pt[e] || {
    prefix: null,
    iconName: null
  };
}
function It() {
  return ut;
}
vt = function (e) {
  ut = Bt(e.styleDefault, {
    family: Ve.familyDefault
  });
}, Le.push(vt), Ct();
function Bt(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    n = t.family,
    r = void 0 === n ? "classic" : n,
    o = he[r][e],
    i = Ae[r][e] || Ae[r][o],
    a = e in Ue.styles ? e : null;
  return i || a || null;
}
var xt = (F(nt = {}, "classic", Object.keys(ge.classic)), F(nt, "sharp", Object.keys(ge.sharp)), nt);
function wt(e) {
  var t,
    n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    r = n.skipLookups,
    o = void 0 !== r && r,
    i = (F(t = {}, "classic", "".concat(Ve.cssPrefix, "-").concat("classic")), F(t, "sharp", "".concat(Ve.cssPrefix, "-").concat("sharp")), t),
    a = null,
    c = "classic";
  (e.includes(i.classic) || e.some(function (e) {
    return xt.classic.includes(e);
  })) && (c = "classic"), (e.includes(i.sharp) || e.some(function (e) {
    return xt.sharp.includes(e);
  })) && (c = "sharp");
  var s = e.reduce(function (e, t) {
    var n = gt(Ve.cssPrefix, t);
    if (ct[t] ? (t = lt[c].includes(t) ? ve[c][t] : t, a = t, e.prefix = t) : At[c].indexOf(t) > -1 ? (a = t, e.prefix = Bt(t, {
      family: c
    })) : n ? e.iconName = n : t !== Ve.replacementClass && t !== i.classic && t !== i.sharp && e.rest.push(t), !o && e.prefix && e.iconName) {
      var r = "fa" === a ? yt(e.iconName) : {},
        s = Et(e.prefix, e.iconName);
      r.prefix && (a = null), e.iconName = r.iconName || s || e.iconName, e.prefix = r.prefix || e.prefix, "far" !== e.prefix || ct.far || !ct.fas || Ve.autoFetchSvg || (e.prefix = "fas");
    }
    return e;
  }, {
    prefix: null,
    iconName: null,
    rest: []
  });
  return (e.includes("fa-brands") || e.includes("fab")) && (s.prefix = "fab"), (e.includes("fa-duotone") || e.includes("fad")) && (s.prefix = "fad"), s.prefix || "sharp" !== c || !ct.fass && !Ve.autoFetchSvg || (s.prefix = "fass", s.iconName = Et(s.prefix, s.iconName) || s.iconName), "fa" !== s.prefix && "fa" !== a || (s.prefix = It() || "fas"), s;
}
var Qt = function () {
    function e() {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.definitions = {};
    }
    var t, n, r;
    return t = e, n = [{
      key: "add",
      value: function () {
        for (var e = this, t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
        var o = n.reduce(this._pullDefinitions, {});
        Object.keys(o).forEach(function (t) {
          e.definitions[t] = D(D({}, e.definitions[t] || {}), o[t]), at(t, o[t]);
          var n = ge.classic[t];
          n && at(n, o[t]), Ct();
        });
      }
    }, {
      key: "reset",
      value: function () {
        this.definitions = {};
      }
    }, {
      key: "_pullDefinitions",
      value: function (e, t) {
        var n = t.prefix && t.iconName && t.icon ? {
          0: t
        } : t;
        return Object.keys(n).map(function (t) {
          var r = n[t],
            o = r.prefix,
            i = r.iconName,
            a = r.icon,
            c = a[2];
          e[o] || (e[o] = {}), c.length > 0 && c.forEach(function (t) {
            "string" == typeof t && (e[o][t] = a);
          }), e[o][i] = a;
        }), e;
      }
    }], n && G(t.prototype, n), r && G(t, r), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e;
  }(),
  Ht = [],
  zt = {},
  Mt = {},
  kt = Object.keys(Mt);
function Nt(e, t) {
  for (var n = arguments.length, r = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++) r[o - 2] = arguments[o];
  var i = zt[e] || [];
  return i.forEach(function (e) {
    t = e.apply(null, [t].concat(r));
  }), t;
}
function St(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  var o = zt[e] || [];
  o.forEach(function (e) {
    e.apply(null, n);
  });
}
function Vt() {
  var e = arguments[0],
    t = Array.prototype.slice.call(arguments, 1);
  return Mt[e] ? Mt[e].apply(null, t) : void 0;
}
function Lt(e) {
  "fa" === e.prefix && (e.prefix = "fas");
  var t = e.iconName,
    n = e.prefix || It();
  if (t) return t = Et(n, t) || t, $e(Pt.definitions, n, t) || $e(Ue.styles, n, t);
}
var Pt = new Qt(),
  Ot = {
    i2svg: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
      return le ? (St("beforeI2svg", e), Vt("pseudoElements2svg", e), Vt("i2svg", e)) : Promise.reject("Operation requires a DOM of some kind.");
    },
    watch: function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.autoReplaceSvgRoot;
      !1 === Ve.autoReplaceSvg && (Ve.autoReplaceSvg = !0), Ve.observeMutations = !0, qe(function () {
        Rt({
          autoReplaceSvgRoot: t
        }), St("watch", e);
      });
    }
  },
  Tt = {
    icon: function (e) {
      if (null === e) return null;
      if ("object" === R(e) && e.prefix && e.iconName) return {
        prefix: e.prefix,
        iconName: Et(e.prefix, e.iconName) || e.iconName
      };
      if (Array.isArray(e) && 2 === e.length) {
        var t = 0 === e[1].indexOf("fa-") ? e[1].slice(3) : e[1],
          n = Bt(e[0]);
        return {
          prefix: n,
          iconName: Et(n, t) || t
        };
      }
      if ("string" == typeof e && (e.indexOf("".concat(Ve.cssPrefix, "-")) > -1 || e.match(Ce))) {
        var r = wt(e.split(" "), {
          skipLookups: !0
        });
        return {
          prefix: r.prefix || It(),
          iconName: Et(r.prefix, r.iconName) || r.iconName
        };
      }
      if ("string" == typeof e) {
        var o = It();
        return {
          prefix: o,
          iconName: Et(o, e) || e
        };
      }
    }
  },
  Dt = {
    noAuto: function () {
      Ve.autoReplaceSvg = !1, Ve.observeMutations = !1, St("noAuto");
    },
    config: Ve,
    dom: Ot,
    parse: Tt,
    library: Pt,
    findIconDefinition: Lt,
    toHtml: _e
  },
  Rt = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
      t = e.autoReplaceSvgRoot,
      n = void 0 === t ? te : t;
    (Object.keys(Ue.styles).length > 0 || Ve.autoFetchSvg) && le && Ve.autoReplaceSvg && Dt.dom.i2svg({
      node: n
    });
  };
function Gt(e, t) {
  return Object.defineProperty(e, "abstract", {
    get: t
  }), Object.defineProperty(e, "html", {
    get: function () {
      return e.abstract.map(function (e) {
        return _e(e);
      });
    }
  }), Object.defineProperty(e, "node", {
    get: function () {
      if (le) {
        var t = te.createElement("div");
        return t.innerHTML = e.html, t.children;
      }
    }
  }), e;
}
function Ft(e) {
  var t = e.icons,
    n = t.main,
    r = t.mask,
    o = e.prefix,
    i = e.iconName,
    a = e.transform,
    c = e.symbol,
    s = e.title,
    l = e.maskId,
    u = e.titleId,
    d = e.extra,
    f = e.watchable,
    p = void 0 !== f && f,
    m = r.found ? r : n,
    h = m.width,
    A = m.height,
    g = "fak" === o,
    v = [Ve.replacementClass, i ? "".concat(Ve.cssPrefix, "-").concat(i) : ""].filter(function (e) {
      return -1 === d.classes.indexOf(e);
    }).filter(function (e) {
      return "" !== e || !!e;
    }).concat(d.classes).join(" "),
    C = {
      children: [],
      attributes: D(D({}, d.attributes), {}, {
        "data-prefix": o,
        "data-icon": i,
        class: v,
        role: d.attributes.role || "img",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 ".concat(h, " ").concat(A)
      })
    },
    b = g && !~d.classes.indexOf("fa-fw") ? {
      width: "".concat(h / A * 16 * .0625, "em")
    } : {};
  p && (C.attributes["data-fa-i2svg"] = ""), s && (C.children.push({
    tag: "title",
    attributes: {
      id: C.attributes["aria-labelledby"] || "title-".concat(u || Oe())
    },
    children: [s]
  }), delete C.attributes.title);
  var E = D(D({}, C), {}, {
      prefix: o,
      iconName: i,
      main: n,
      mask: r,
      maskId: l,
      transform: a,
      symbol: c,
      styles: D(D({}, b), d.styles)
    }),
    y = r.found && n.found ? Vt("generateAbstractMask", E) || {
      children: [],
      attributes: {}
    } : Vt("generateAbstractIcon", E) || {
      children: [],
      attributes: {}
    },
    I = y.children,
    B = y.attributes;
  return E.children = I, E.attributes = B, c ? function (e) {
    var t = e.prefix,
      n = e.iconName,
      r = e.children,
      o = e.attributes,
      i = e.symbol,
      a = !0 === i ? "".concat(t, "-").concat(Ve.cssPrefix, "-").concat(n) : i;
    return [{
      tag: "svg",
      attributes: {
        style: "display: none;"
      },
      children: [{
        tag: "symbol",
        attributes: D(D({}, o), {}, {
          id: a
        }),
        children: r
      }]
    }];
  }(E) : function (e) {
    var t = e.children,
      n = e.main,
      r = e.mask,
      o = e.attributes,
      i = e.styles,
      a = e.transform;
    if (Fe(a) && n.found && !r.found) {
      var c = {
        x: n.width / n.height / 2,
        y: .5
      };
      o.style = Ge(D(D({}, i), {}, {
        "transform-origin": "".concat(c.x + a.x / 16, "em ").concat(c.y + a.y / 16, "em")
      }));
    }
    return [{
      tag: "svg",
      attributes: o,
      children: t
    }];
  }(E);
}
function jt(e) {
  var t = e.content,
    n = e.width,
    r = e.height,
    o = e.transform,
    i = e.title,
    a = e.extra,
    c = e.watchable,
    s = void 0 !== c && c,
    l = D(D(D({}, a.attributes), i ? {
      title: i
    } : {}), {}, {
      class: a.classes.join(" ")
    });
  s && (l["data-fa-i2svg"] = "");
  var u = D({}, a.styles);
  Fe(o) && (u.transform = function (e) {
    var t = e.transform,
      n = e.width,
      r = void 0 === n ? 16 : n,
      o = e.height,
      i = void 0 === o ? 16 : o,
      a = e.startCentered,
      c = void 0 !== a && a,
      s = "";
    return s += c && ue ? "translate(".concat(t.x / 16 - r / 2, "em, ").concat(t.y / 16 - i / 2, "em) ") : c ? "translate(calc(-50% + ".concat(t.x / 16, "em), calc(-50% + ").concat(t.y / 16, "em)) ") : "translate(".concat(t.x / 16, "em, ").concat(t.y / 16, "em) "), s += "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "), s + "rotate(".concat(t.rotate, "deg) ");
  }({
    transform: o,
    startCentered: !0,
    width: n,
    height: r
  }), u["-webkit-transform"] = u.transform);
  var d = Ge(u);
  d.length > 0 && (l.style = d);
  var f = [];
  return f.push({
    tag: "span",
    attributes: l,
    children: [t]
  }), i && f.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [i]
  }), f;
}
function Jt(e) {
  var t = e.content,
    n = e.title,
    r = e.extra,
    o = D(D(D({}, r.attributes), n ? {
      title: n
    } : {}), {}, {
      class: r.classes.join(" ")
    }),
    i = Ge(r.styles);
  i.length > 0 && (o.style = i);
  var a = [];
  return a.push({
    tag: "span",
    attributes: o,
    children: [t]
  }), n && a.push({
    tag: "span",
    attributes: {
      class: "sr-only"
    },
    children: [n]
  }), a;
}
var Zt = Ue.styles;
function Wt(e) {
  var t = e[0],
    n = e[1],
    r = j(e.slice(4), 1)[0];
  return {
    found: !0,
    width: t,
    height: n,
    icon: Array.isArray(r) ? {
      tag: "g",
      attributes: {
        class: "".concat(Ve.cssPrefix, "-").concat(xe)
      },
      children: [{
        tag: "path",
        attributes: {
          class: "".concat(Ve.cssPrefix, "-").concat(He),
          fill: "currentColor",
          d: r[0]
        }
      }, {
        tag: "path",
        attributes: {
          class: "".concat(Ve.cssPrefix, "-").concat(Qe),
          fill: "currentColor",
          d: r[1]
        }
      }]
    } : {
      tag: "path",
      attributes: {
        fill: "currentColor",
        d: r
      }
    }
  };
}
var Xt = {
  found: !1,
  width: 512,
  height: 512
};
function Ut(e, t) {
  var n = t;
  return "fa" === t && null !== Ve.styleDefault && (t = It()), new Promise(function (r, o) {
    if (Vt("missingIconAbstract"), "fa" === n) {
      var i = yt(e) || {};
      e = i.iconName || e, t = i.prefix || t;
    }
    if (e && t && Zt[t] && Zt[t][e]) return r(Wt(Zt[t][e]));
    !function (e, t) {
      fe || Ve.showMissingIcons || !e || console.error('Icon with name "'.concat(e, '" and prefix "').concat(t, '" is missing.'));
    }(e, t), r(D(D({}, Xt), {}, {
      icon: Ve.showMissingIcons && e && Vt("missingIconAbstract") || {}
    }));
  });
}
var Kt = function () {},
  Yt = Ve.measurePerformance && re && re.mark && re.measure ? re : {
    mark: Kt,
    measure: Kt
  },
  qt = function (e) {
    Yt.mark("".concat('FA "6.4.2"', " ").concat(e, " ends")), Yt.measure("".concat('FA "6.4.2"', " ").concat(e), "".concat('FA "6.4.2"', " ").concat(e, " begins"), "".concat('FA "6.4.2"', " ").concat(e, " ends"));
  },
  _t = function (e) {
    return Yt.mark("".concat('FA "6.4.2"', " ").concat(e, " begins")), function () {
      return qt(e);
    };
  },
  $t = function () {};
function en(e) {
  return "string" == typeof (e.getAttribute ? e.getAttribute("data-fa-i2svg") : null);
}
function tn(e) {
  return te.createElementNS("http://www.w3.org/2000/svg", e);
}
function nn(e) {
  return te.createElement(e);
}
function rn(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
    n = t.ceFn,
    r = void 0 === n ? "svg" === e.tag ? tn : nn : n;
  if ("string" == typeof e) return te.createTextNode(e);
  var o = r(e.tag);
  Object.keys(e.attributes || []).forEach(function (t) {
    o.setAttribute(t, e.attributes[t]);
  });
  var i = e.children || [];
  return i.forEach(function (e) {
    o.appendChild(rn(e, {
      ceFn: r
    }));
  }), o;
}
var on = {
  replace: function (e) {
    var t = e[0];
    if (t.parentNode) if (e[1].forEach(function (e) {
      t.parentNode.insertBefore(rn(e), t);
    }), null === t.getAttribute("data-fa-i2svg") && Ve.keepOriginalSource) {
      var n = te.createComment(function (e) {
        var t = " ".concat(e.outerHTML, " ");
        return "".concat(t, "Font Awesome fontawesome.com ");
      }(t));
      t.parentNode.replaceChild(n, t);
    } else t.remove();
  },
  nest: function (e) {
    var t = e[0],
      n = e[1];
    if (~De(t).indexOf(Ve.replacementClass)) return on.replace(e);
    var r = new RegExp("".concat(Ve.cssPrefix, "-.*"));
    if (delete n[0].attributes.id, n[0].attributes.class) {
      var o = n[0].attributes.class.split(" ").reduce(function (e, t) {
        return t === Ve.replacementClass || t.match(r) ? e.toSvg.push(t) : e.toNode.push(t), e;
      }, {
        toNode: [],
        toSvg: []
      });
      n[0].attributes.class = o.toSvg.join(" "), 0 === o.toNode.length ? t.removeAttribute("class") : t.setAttribute("class", o.toNode.join(" "));
    }
    var i = n.map(function (e) {
      return _e(e);
    }).join("\n");
    t.setAttribute("data-fa-i2svg", ""), t.innerHTML = i;
  }
};
function an(e) {
  e();
}
function cn(e, t) {
  var n = "function" == typeof t ? t : $t;
  if (0 === e.length) n();else {
    var r = an;
    "async" === Ve.mutateApproach && (r = ee.requestAnimationFrame || an), r(function () {
      var t = !0 === Ve.autoReplaceSvg ? on.replace : on[Ve.autoReplaceSvg] || on.replace,
        r = _t("mutate");
      e.map(t), r(), n();
    });
  }
}
var sn = !1;
function ln() {
  sn = !0;
}
function un() {
  sn = !1;
}
var dn = null;
function fn(e) {
  if (ne && Ve.observeMutations) {
    var t = e.treeCallback,
      n = void 0 === t ? $t : t,
      r = e.nodeCallback,
      o = void 0 === r ? $t : r,
      i = e.pseudoElementsCallback,
      a = void 0 === i ? $t : i,
      c = e.observeMutationsRoot,
      s = void 0 === c ? te : c;
    dn = new ne(function (e) {
      if (!sn) {
        var t = It();
        Te(e).forEach(function (e) {
          if ("childList" === e.type && e.addedNodes.length > 0 && !en(e.addedNodes[0]) && (Ve.searchPseudoElements && a(e.target), n(e.target)), "attributes" === e.type && e.target.parentNode && Ve.searchPseudoElements && a(e.target.parentNode), "attributes" === e.type && en(e.target) && ~Be.indexOf(e.attributeName)) if ("class" === e.attributeName && function (e) {
            var t = e.getAttribute ? e.getAttribute("data-prefix") : null,
              n = e.getAttribute ? e.getAttribute("data-icon") : null;
            return t && n;
          }(e.target)) {
            var r = wt(De(e.target)),
              i = r.prefix,
              c = r.iconName;
            e.target.setAttribute("data-prefix", i || t), c && e.target.setAttribute("data-icon", c);
          } else (function (e) {
            return e && e.classList && e.classList.contains && e.classList.contains(Ve.replacementClass);
          })(e.target) && o(e.target);
        });
      }
    }), le && dn.observe(s, {
      childList: !0,
      attributes: !0,
      characterData: !0,
      subtree: !0
    });
  }
}
function pn(e) {
  var t = e.getAttribute("style"),
    n = [];
  return t && (n = t.split(";").reduce(function (e, t) {
    var n = t.split(":"),
      r = n[0],
      o = n.slice(1);
    return r && o.length > 0 && (e[r] = o.join(":").trim()), e;
  }, {})), n;
}
function mn(e) {
  var t = e.getAttribute("data-prefix"),
    n = e.getAttribute("data-icon"),
    r = void 0 !== e.innerText ? e.innerText.trim() : "",
    o = wt(De(e));
  return o.prefix || (o.prefix = It()), t && n && (o.prefix = t, o.iconName = n), o.iconName && o.prefix || (o.prefix && r.length > 0 && (o.iconName = function (e, t) {
    return (ft[e] || {})[t];
  }(o.prefix, e.innerText) || bt(o.prefix, ot(e.innerText))), !o.iconName && Ve.autoFetchSvg && e.firstChild && e.firstChild.nodeType === Node.TEXT_NODE && (o.iconName = e.firstChild.data)), o;
}
function hn(e) {
  var t = Te(e.attributes).reduce(function (e, t) {
      return "class" !== e.name && "style" !== e.name && (e[t.name] = t.value), e;
    }, {}),
    n = e.getAttribute("title"),
    r = e.getAttribute("data-fa-title-id");
  return Ve.autoA11y && (n ? t["aria-labelledby"] = "".concat(Ve.replacementClass, "-title-").concat(r || Oe()) : (t["aria-hidden"] = "true", t.focusable = "false")), t;
}
function An(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
      styleParser: !0
    },
    n = mn(e),
    r = n.iconName,
    o = n.prefix,
    i = n.rest,
    a = hn(e),
    c = Nt("parseNodeAttributes", {}, e),
    s = t.styleParser ? pn(e) : [];
  return D({
    iconName: r,
    title: e.getAttribute("title"),
    titleId: e.getAttribute("data-fa-title-id"),
    prefix: o,
    transform: Pe,
    mask: {
      iconName: null,
      prefix: null,
      rest: []
    },
    maskId: null,
    symbol: !1,
    extra: {
      classes: i,
      styles: s,
      attributes: a
    }
  }, c);
}
var gn = Ue.styles;
function vn(e) {
  var t = "nest" === Ve.autoReplaceSvg ? An(e, {
    styleParser: !1
  }) : An(e);
  return ~t.extra.classes.indexOf("fa-layers-text") ? Vt("generateLayersText", e, t) : Vt("generateSvgReplacementMutation", e, t);
}
var Cn = new Set();
function bn(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  if (!le) return Promise.resolve();
  var n = te.documentElement.classList,
    r = function (e) {
      return n.add("".concat("fontawesome-i2svg", "-").concat(e));
    },
    o = function (e) {
      return n.remove("".concat("fontawesome-i2svg", "-").concat(e));
    },
    i = Ve.autoFetchSvg ? Cn : pe.map(function (e) {
      return "fa-".concat(e);
    }).concat(Object.keys(gn));
  i.includes("fa") || i.push("fa");
  var a = [".".concat("fa-layers-text", ":not([").concat("data-fa-i2svg", "])")].concat(i.map(function (e) {
    return ".".concat(e, ":not([").concat("data-fa-i2svg", "])");
  })).join(", ");
  if (0 === a.length) return Promise.resolve();
  var c = [];
  try {
    c = Te(e.querySelectorAll(a));
  } catch (e) {}
  if (!(c.length > 0)) return Promise.resolve();
  r("pending"), o("complete");
  var s = _t("onTree"),
    l = c.reduce(function (e, t) {
      try {
        var n = vn(t);
        n && e.push(n);
      } catch (e) {
        fe || "MissingIcon" === e.name && console.error(e);
      }
      return e;
    }, []);
  return new Promise(function (e, n) {
    Promise.all(l).then(function (n) {
      cn(n, function () {
        r("active"), r("complete"), o("pending"), "function" == typeof t && t(), s(), e();
      });
    }).catch(function (e) {
      s(), n(e);
    });
  });
}
function En(e) {
  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
  vn(e).then(function (e) {
    e && cn([e], t);
  });
}
function yn(e) {
  return function (t) {
    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      r = (t || {}).icon ? t : Lt(t || {}),
      o = n.mask;
    return o && (o = (o || {}).icon ? o : Lt(o || {})), e(r, D(D({}, n), {}, {
      mask: o
    }));
  };
}
pe.map(function (e) {
  Cn.add("fa-".concat(e));
}), Object.keys(he.classic).map(Cn.add.bind(Cn)), Object.keys(he.sharp).map(Cn.add.bind(Cn)), Cn = J(Cn);
var In = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
      n = t.transform,
      r = void 0 === n ? Pe : n,
      o = t.symbol,
      i = void 0 !== o && o,
      a = t.mask,
      c = void 0 === a ? null : a,
      s = t.maskId,
      l = void 0 === s ? null : s,
      u = t.title,
      d = void 0 === u ? null : u,
      f = t.titleId,
      p = void 0 === f ? null : f,
      m = t.classes,
      h = void 0 === m ? [] : m,
      A = t.attributes,
      g = void 0 === A ? {} : A,
      v = t.styles,
      C = void 0 === v ? {} : v;
    if (e) {
      var b = e.prefix,
        E = e.iconName,
        y = e.icon;
      return Gt(D({
        type: "icon"
      }, e), function () {
        return St("beforeDOMElementCreation", {
          iconDefinition: e,
          params: t
        }), Ve.autoA11y && (d ? g["aria-labelledby"] = "".concat(Ve.replacementClass, "-title-").concat(p || Oe()) : (g["aria-hidden"] = "true", g.focusable = "false")), Ft({
          icons: {
            main: Wt(y),
            mask: c ? Wt(c.icon) : {
              found: !1,
              width: null,
              height: null,
              icon: {}
            }
          },
          prefix: b,
          iconName: E,
          transform: D(D({}, Pe), r),
          symbol: i,
          title: d,
          maskId: l,
          titleId: p,
          extra: {
            attributes: g,
            styles: C,
            classes: h
          }
        });
      });
    }
  },
  Bn = {
    mixout: function () {
      return {
        icon: yn(In)
      };
    },
    hooks: function () {
      return {
        mutationObserverCallbacks: function (e) {
          return e.treeCallback = bn, e.nodeCallback = En, e;
        }
      };
    },
    provides: function (e) {
      e.i2svg = function (e) {
        var t = e.node,
          n = void 0 === t ? te : t,
          r = e.callback;
        return bn(n, void 0 === r ? function () {} : r);
      }, e.generateSvgReplacementMutation = function (e, t) {
        var n = t.iconName,
          r = t.title,
          o = t.titleId,
          i = t.prefix,
          a = t.transform,
          c = t.symbol,
          s = t.mask,
          l = t.maskId,
          u = t.extra;
        return new Promise(function (t, d) {
          Promise.all([Ut(n, i), s.iconName ? Ut(s.iconName, s.prefix) : Promise.resolve({
            found: !1,
            width: 512,
            height: 512,
            icon: {}
          })]).then(function (s) {
            var d = j(s, 2),
              f = d[0],
              p = d[1];
            t([e, Ft({
              icons: {
                main: f,
                mask: p
              },
              prefix: i,
              iconName: n,
              transform: a,
              symbol: c,
              maskId: l,
              title: r,
              titleId: o,
              extra: u,
              watchable: !0
            })]);
          }).catch(d);
        });
      }, e.generateAbstractIcon = function (e) {
        var t,
          n = e.children,
          r = e.attributes,
          o = e.main,
          i = e.transform,
          a = Ge(e.styles);
        return a.length > 0 && (r.style = a), Fe(i) && (t = Vt("generateAbstractTransformGrouping", {
          main: o,
          transform: i,
          containerWidth: o.width,
          iconWidth: o.width
        })), n.push(t || o.icon), {
          children: n,
          attributes: r
        };
      };
    }
  },
  xn = {
    mixout: function () {
      return {
        layer: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.classes,
            r = void 0 === n ? [] : n;
          return Gt({
            type: "layer"
          }, function () {
            St("beforeDOMElementCreation", {
              assembler: e,
              params: t
            });
            var n = [];
            return e(function (e) {
              Array.isArray(e) ? e.map(function (e) {
                n = n.concat(e.abstract);
              }) : n = n.concat(e.abstract);
            }), [{
              tag: "span",
              attributes: {
                class: ["".concat(Ve.cssPrefix, "-layers")].concat(J(r)).join(" ")
              },
              children: n
            }];
          });
        }
      };
    }
  },
  wn = {
    mixout: function () {
      return {
        counter: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.title,
            r = void 0 === n ? null : n,
            o = t.classes,
            i = void 0 === o ? [] : o,
            a = t.attributes,
            c = void 0 === a ? {} : a,
            s = t.styles,
            l = void 0 === s ? {} : s;
          return Gt({
            type: "counter",
            content: e
          }, function () {
            return St("beforeDOMElementCreation", {
              content: e,
              params: t
            }), Jt({
              content: e.toString(),
              title: r,
              extra: {
                attributes: c,
                styles: l,
                classes: ["".concat(Ve.cssPrefix, "-layers-counter")].concat(J(i))
              }
            });
          });
        }
      };
    }
  },
  Qn = {
    mixout: function () {
      return {
        text: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.transform,
            r = void 0 === n ? Pe : n,
            o = t.title,
            i = void 0 === o ? null : o,
            a = t.classes,
            c = void 0 === a ? [] : a,
            s = t.attributes,
            l = void 0 === s ? {} : s,
            u = t.styles,
            d = void 0 === u ? {} : u;
          return Gt({
            type: "text",
            content: e
          }, function () {
            return St("beforeDOMElementCreation", {
              content: e,
              params: t
            }), jt({
              content: e,
              transform: D(D({}, Pe), r),
              title: i,
              extra: {
                attributes: l,
                styles: d,
                classes: ["".concat(Ve.cssPrefix, "-layers-text")].concat(J(c))
              }
            });
          });
        }
      };
    },
    provides: function (e) {
      e.generateLayersText = function (e, t) {
        var n = t.title,
          r = t.transform,
          o = t.extra,
          i = null,
          a = null;
        if (ue) {
          var c = parseInt(getComputedStyle(e).fontSize, 10),
            s = e.getBoundingClientRect();
          i = s.width / c, a = s.height / c;
        }
        return Ve.autoA11y && !n && (o.attributes["aria-hidden"] = "true"), Promise.resolve([e, jt({
          content: e.innerHTML,
          width: i,
          height: a,
          transform: r,
          title: n,
          extra: o,
          watchable: !0
        })]);
      };
    }
  },
  Hn = new RegExp('"', "ug"),
  zn = [1105920, 1112319];
function Mn(e, t) {
  var n = "".concat("data-fa-pseudo-element-pending").concat(t.replace(":", "-"));
  return new Promise(function (r, o) {
    if (null !== e.getAttribute(n)) return r();
    var i,
      a,
      c,
      s = Te(e.children).filter(function (e) {
        return e.getAttribute("data-fa-pseudo-element") === t;
      })[0],
      l = ee.getComputedStyle(e, t),
      u = l.getPropertyValue("font-family").match(be),
      d = l.getPropertyValue("font-weight"),
      f = l.getPropertyValue("content");
    if (s && !u) return e.removeChild(s), r();
    if (u && "none" !== f && "" !== f) {
      var p = l.getPropertyValue("content"),
        m = ~["Sharp"].indexOf(u[2]) ? "sharp" : "classic",
        h = ~["Solid", "Regular", "Light", "Thin", "Duotone", "Brands", "Kit"].indexOf(u[2]) ? Ae[m][u[2].toLowerCase()] : Ee[m][d],
        A = function (e) {
          var t = e.replace(Hn, ""),
            n = function (e, t) {
              var n,
                r = e.length,
                o = e.charCodeAt(t);
              return o >= 55296 && o <= 56319 && r > t + 1 && (n = e.charCodeAt(t + 1)) >= 56320 && n <= 57343 ? 1024 * (o - 55296) + n - 56320 + 65536 : o;
            }(t, 0),
            r = n >= zn[0] && n <= zn[1],
            o = 2 === t.length && t[0] === t[1];
          return {
            value: ot(o ? t[0] : t),
            isSecondary: r || o
          };
        }(p),
        g = A.value,
        v = A.isSecondary,
        C = u[0].startsWith("FontAwesome"),
        b = bt(h, g),
        E = b;
      if (C) {
        var y = (a = mt[i = g], c = bt("fas", i), a || (c ? {
          prefix: "fas",
          iconName: c
        } : null) || {
          prefix: null,
          iconName: null
        });
        y.iconName && y.prefix && (b = y.iconName, h = y.prefix);
      }
      if (!b || v || s && s.getAttribute("data-prefix") === h && s.getAttribute("data-icon") === E) r();else {
        e.setAttribute(n, E), s && e.removeChild(s);
        var I = {
            iconName: null,
            title: null,
            titleId: null,
            prefix: null,
            transform: Pe,
            symbol: !1,
            mask: {
              iconName: null,
              prefix: null,
              rest: []
            },
            maskId: null,
            extra: {
              classes: [],
              styles: {},
              attributes: {}
            }
          },
          B = I.extra;
        B.attributes["data-fa-pseudo-element"] = t, Ut(b, h).then(function (o) {
          var i = Ft(D(D({}, I), {}, {
              icons: {
                main: o,
                mask: {
                  prefix: null,
                  iconName: null,
                  rest: []
                }
              },
              prefix: h,
              iconName: E,
              extra: B,
              watchable: !0
            })),
            a = te.createElementNS("http://www.w3.org/2000/svg", "svg");
          "::before" === t ? e.insertBefore(a, e.firstChild) : e.appendChild(a), a.outerHTML = i.map(function (e) {
            return _e(e);
          }).join("\n"), e.removeAttribute(n), r();
        }).catch(o);
      }
    } else r();
  });
}
function kn(e) {
  return Promise.all([Mn(e, "::before"), Mn(e, "::after")]);
}
function Nn(e) {
  return !(e.parentNode === document.head || ~de.indexOf(e.tagName.toUpperCase()) || e.getAttribute("data-fa-pseudo-element") || e.parentNode && "svg" === e.parentNode.tagName);
}
function Sn(e) {
  if (le) return new Promise(function (t, n) {
    var r = Te(e.querySelectorAll("*")).filter(Nn).map(kn),
      o = _t("searchPseudoElements");
    ln(), Promise.all(r).then(function () {
      o(), un(), t();
    }).catch(function () {
      o(), un(), n();
    });
  });
}
var Vn = {
    hooks: function () {
      return {
        mutationObserverCallbacks: function (e) {
          return e.pseudoElementsCallback = Sn, e;
        }
      };
    },
    provides: function (e) {
      e.pseudoElements2svg = function (e) {
        var t = e.node,
          n = void 0 === t ? te : t;
        Ve.searchPseudoElements && Sn(n);
      };
    }
  },
  Ln = !1,
  Pn = function (e) {
    return e.toLowerCase().split(" ").reduce(function (e, t) {
      var n = t.toLowerCase().split("-"),
        r = n[0],
        o = n.slice(1).join("-");
      if (r && "h" === o) return e.flipX = !0, e;
      if (r && "v" === o) return e.flipY = !0, e;
      if (o = parseFloat(o), isNaN(o)) return e;
      switch (r) {
        case "grow":
          e.size = e.size + o;
          break;
        case "shrink":
          e.size = e.size - o;
          break;
        case "left":
          e.x = e.x - o;
          break;
        case "right":
          e.x = e.x + o;
          break;
        case "up":
          e.y = e.y - o;
          break;
        case "down":
          e.y = e.y + o;
          break;
        case "rotate":
          e.rotate = e.rotate + o;
      }
      return e;
    }, {
      size: 16,
      x: 0,
      y: 0,
      flipX: !1,
      flipY: !1,
      rotate: 0
    });
  },
  On = {
    mixout: function () {
      return {
        parse: {
          transform: function (e) {
            return Pn(e);
          }
        }
      };
    },
    hooks: function () {
      return {
        parseNodeAttributes: function (e, t) {
          var n = t.getAttribute("data-fa-transform");
          return n && (e.transform = Pn(n)), e;
        }
      };
    },
    provides: function (e) {
      e.generateAbstractTransformGrouping = function (e) {
        var t = e.main,
          n = e.transform,
          r = e.containerWidth,
          o = e.iconWidth,
          i = {
            transform: "translate(".concat(r / 2, " 256)")
          },
          a = "translate(".concat(32 * n.x, ", ").concat(32 * n.y, ") "),
          c = "scale(".concat(n.size / 16 * (n.flipX ? -1 : 1), ", ").concat(n.size / 16 * (n.flipY ? -1 : 1), ") "),
          s = "rotate(".concat(n.rotate, " 0 0)"),
          l = {
            outer: i,
            inner: {
              transform: "".concat(a, " ").concat(c, " ").concat(s)
            },
            path: {
              transform: "translate(".concat(o / 2 * -1, " -256)")
            }
          };
        return {
          tag: "g",
          attributes: D({}, l.outer),
          children: [{
            tag: "g",
            attributes: D({}, l.inner),
            children: [{
              tag: t.icon.tag,
              children: t.icon.children,
              attributes: D(D({}, t.icon.attributes), l.path)
            }]
          }]
        };
      };
    }
  },
  Tn = {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%"
  };
function Dn(e) {
  var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
  return e.attributes && (e.attributes.fill || t) && (e.attributes.fill = "black"), e;
}
var Rn = {
    hooks: function () {
      return {
        parseNodeAttributes: function (e, t) {
          var n = t.getAttribute("data-fa-mask"),
            r = n ? wt(n.split(" ").map(function (e) {
              return e.trim();
            })) : {
              prefix: null,
              iconName: null,
              rest: []
            };
          return r.prefix || (r.prefix = It()), e.mask = r, e.maskId = t.getAttribute("data-fa-mask-id"), e;
        }
      };
    },
    provides: function (e) {
      e.generateAbstractMask = function (e) {
        var t,
          n = e.children,
          r = e.attributes,
          o = e.main,
          i = e.mask,
          a = e.maskId,
          c = e.transform,
          s = o.width,
          l = o.icon,
          u = i.width,
          d = i.icon,
          f = function (e) {
            var t = e.transform,
              n = e.containerWidth,
              r = e.iconWidth,
              o = {
                transform: "translate(".concat(n / 2, " 256)")
              },
              i = "translate(".concat(32 * t.x, ", ").concat(32 * t.y, ") "),
              a = "scale(".concat(t.size / 16 * (t.flipX ? -1 : 1), ", ").concat(t.size / 16 * (t.flipY ? -1 : 1), ") "),
              c = "rotate(".concat(t.rotate, " 0 0)");
            return {
              outer: o,
              inner: {
                transform: "".concat(i, " ").concat(a, " ").concat(c)
              },
              path: {
                transform: "translate(".concat(r / 2 * -1, " -256)")
              }
            };
          }({
            transform: c,
            containerWidth: u,
            iconWidth: s
          }),
          p = {
            tag: "rect",
            attributes: D(D({}, Tn), {}, {
              fill: "white"
            })
          },
          m = l.children ? {
            children: l.children.map(Dn)
          } : {},
          h = {
            tag: "g",
            attributes: D({}, f.inner),
            children: [Dn(D({
              tag: l.tag,
              attributes: D(D({}, l.attributes), f.path)
            }, m))]
          },
          A = {
            tag: "g",
            attributes: D({}, f.outer),
            children: [h]
          },
          g = "mask-".concat(a || Oe()),
          v = "clip-".concat(a || Oe()),
          C = {
            tag: "mask",
            attributes: D(D({}, Tn), {}, {
              id: g,
              maskUnits: "userSpaceOnUse",
              maskContentUnits: "userSpaceOnUse"
            }),
            children: [p, A]
          },
          b = {
            tag: "defs",
            children: [{
              tag: "clipPath",
              attributes: {
                id: v
              },
              children: (t = d, "g" === t.tag ? t.children : [t])
            }, C]
          };
        return n.push(b, {
          tag: "rect",
          attributes: D({
            fill: "currentColor",
            "clip-path": "url(#".concat(v, ")"),
            mask: "url(#".concat(g, ")")
          }, Tn)
        }), {
          children: n,
          attributes: r
        };
      };
    }
  },
  Gn = {
    provides: function (e) {
      var t = !1;
      ee.matchMedia && (t = ee.matchMedia("(prefers-reduced-motion: reduce)").matches), e.missingIconAbstract = function () {
        var e = [],
          n = {
            fill: "currentColor"
          },
          r = {
            attributeType: "XML",
            repeatCount: "indefinite",
            dur: "2s"
          };
        e.push({
          tag: "path",
          attributes: D(D({}, n), {}, {
            d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
          })
        });
        var o = D(D({}, r), {}, {
            attributeName: "opacity"
          }),
          i = {
            tag: "circle",
            attributes: D(D({}, n), {}, {
              cx: "256",
              cy: "364",
              r: "28"
            }),
            children: []
          };
        return t || i.children.push({
          tag: "animate",
          attributes: D(D({}, r), {}, {
            attributeName: "r",
            values: "28;14;28;28;14;28;"
          })
        }, {
          tag: "animate",
          attributes: D(D({}, o), {}, {
            values: "1;0;1;1;0;1;"
          })
        }), e.push(i), e.push({
          tag: "path",
          attributes: D(D({}, n), {}, {
            opacity: "1",
            d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
          }),
          children: t ? [] : [{
            tag: "animate",
            attributes: D(D({}, o), {}, {
              values: "1;0;0;0;0;1;"
            })
          }]
        }), t || e.push({
          tag: "path",
          attributes: D(D({}, n), {}, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
          }),
          children: [{
            tag: "animate",
            attributes: D(D({}, o), {}, {
              values: "0;0;1;1;0;0;"
            })
          }]
        }), {
          tag: "g",
          attributes: {
            class: "missing"
          },
          children: e
        };
      };
    }
  },
  Fn = [We, Bn, xn, wn, Qn, Vn, {
    mixout: function () {
      return {
        dom: {
          unwatch: function () {
            ln(), Ln = !0;
          }
        }
      };
    },
    hooks: function () {
      return {
        bootstrap: function () {
          fn(Nt("mutationObserverCallbacks", {}));
        },
        noAuto: function () {
          dn && dn.disconnect();
        },
        watch: function (e) {
          var t = e.observeMutationsRoot;
          Ln ? un() : fn(Nt("mutationObserverCallbacks", {
            observeMutationsRoot: t
          }));
        }
      };
    }
  }, On, Rn, Gn, {
    hooks: function () {
      return {
        parseNodeAttributes: function (e, t) {
          var n = t.getAttribute("data-fa-symbol"),
            r = null !== n && ("" === n || n);
          return e.symbol = r, e;
        }
      };
    }
  }];
!function (e, t) {
  var n = t.mixoutsTo;
  Ht = e, zt = {}, Object.keys(Mt).forEach(function (e) {
    -1 === kt.indexOf(e) && delete Mt[e];
  }), Ht.forEach(function (e) {
    var t = e.mixout ? e.mixout() : {};
    if (Object.keys(t).forEach(function (e) {
      "function" == typeof t[e] && (n[e] = t[e]), "object" === R(t[e]) && Object.keys(t[e]).forEach(function (r) {
        n[e] || (n[e] = {}), n[e][r] = t[e][r];
      });
    }), e.hooks) {
      var r = e.hooks();
      Object.keys(r).forEach(function (e) {
        zt[e] || (zt[e] = []), zt[e].push(r[e]);
      });
    }
    e.provides && e.provides(Mt);
  });
}(Fn, {
  mixoutsTo: Dt
});
var jn = Dt.parse,
  Jn = Dt.icon;
function Zn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Zn(Object(n), !0).forEach(function (t) {
      Un(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Zn(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function Xn(e) {
  return Xn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xn(e);
}
function Un(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Kn(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function Yn(e) {
  return function (e) {
    if (Array.isArray(e)) return qn(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return qn(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return qn(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function qn(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _n(e) {
  return t = e, (t -= 0) == t ? e : (e = e.replace(/[\-_\s]+(.)?/g, function (e, t) {
    return t ? t.toUpperCase() : "";
  })).substr(0, 1).toLowerCase() + e.substr(1);
  var t;
}
var $n = ["style"];
function er(e) {
  return e.split(";").map(function (e) {
    return e.trim();
  }).filter(function (e) {
    return e;
  }).reduce(function (e, t) {
    var n,
      r = t.indexOf(":"),
      o = _n(t.slice(0, r)),
      i = t.slice(r + 1).trim();
    return o.startsWith("webkit") ? e[(n = o, n.charAt(0).toUpperCase() + n.slice(1))] = i : e[o] = i, e;
  }, {});
}
var tr = !1;
try {
  tr = "production" === process.env.NODE_ENV;
} catch (SZ) {}
function nr(e) {
  return e && "object" === Xn(e) && e.prefix && e.iconName && e.icon ? e : jn.icon ? jn.icon(e) : null === e ? null : e && "object" === Xn(e) && e.prefix && e.iconName ? e : Array.isArray(e) && 2 === e.length ? {
    prefix: e[0],
    iconName: e[1]
  } : "string" == typeof e ? {
    prefix: "fas",
    iconName: e
  } : void 0;
}
function rr(e, t) {
  return Array.isArray(t) && t.length > 0 || !Array.isArray(t) && t ? Un({}, e, t) : {};
}
var or = /*#__PURE__*/t.forwardRef(function (e, t) {
  var n = e.icon,
    r = e.mask,
    o = e.symbol,
    i = e.className,
    a = e.title,
    c = e.titleId,
    s = e.maskId,
    l = nr(n),
    u = rr("classes", [].concat(Yn(function (e) {
      var t,
        n = e.beat,
        r = e.fade,
        o = e.beatFade,
        i = e.bounce,
        a = e.shake,
        c = e.flash,
        s = e.spin,
        l = e.spinPulse,
        u = e.spinReverse,
        d = e.pulse,
        f = e.fixedWidth,
        p = e.inverse,
        m = e.border,
        h = e.listItem,
        A = e.flip,
        g = e.size,
        v = e.rotation,
        C = e.pull,
        b = (Un(t = {
          "fa-beat": n,
          "fa-fade": r,
          "fa-beat-fade": o,
          "fa-bounce": i,
          "fa-shake": a,
          "fa-flash": c,
          "fa-spin": s,
          "fa-spin-reverse": u,
          "fa-spin-pulse": l,
          "fa-pulse": d,
          "fa-fw": f,
          "fa-inverse": p,
          "fa-border": m,
          "fa-li": h,
          "fa-flip": !0 === A,
          "fa-flip-horizontal": "horizontal" === A || "both" === A,
          "fa-flip-vertical": "vertical" === A || "both" === A
        }, "fa-".concat(g), null != g), Un(t, "fa-rotate-".concat(v), null != v && 0 !== v), Un(t, "fa-pull-".concat(C), null != C), Un(t, "fa-swap-opacity", e.swapOpacity), t);
      return Object.keys(b).map(function (e) {
        return b[e] ? e : null;
      }).filter(function (e) {
        return e;
      });
    }(e)), Yn(i.split(" ")))),
    d = rr("transform", "string" == typeof e.transform ? jn.transform(e.transform) : e.transform),
    f = rr("mask", nr(r)),
    p = Jn(l, Wn(Wn(Wn(Wn({}, u), d), f), {}, {
      symbol: o,
      title: a,
      titleId: c,
      maskId: s
    }));
  if (!p) return function () {
    var e;
    !tr && console && "function" == typeof console.error && (e = console).error.apply(e, arguments);
  }("Could not find icon", l), null;
  var m = p.abstract,
    h = {
      ref: t
    };
  return Object.keys(e).forEach(function (t) {
    or.defaultProps.hasOwnProperty(t) || (h[t] = e[t]);
  }), ir(m[0], h);
});
or.displayName = "FontAwesomeIcon", or.propTypes = {
  beat: g.bool,
  border: g.bool,
  beatFade: g.bool,
  bounce: g.bool,
  className: g.string,
  fade: g.bool,
  flash: g.bool,
  mask: g.oneOfType([g.object, g.array, g.string]),
  maskId: g.string,
  fixedWidth: g.bool,
  inverse: g.bool,
  flip: g.oneOf([!0, !1, "horizontal", "vertical", "both"]),
  icon: g.oneOfType([g.object, g.array, g.string]),
  listItem: g.bool,
  pull: g.oneOf(["right", "left"]),
  pulse: g.bool,
  rotation: g.oneOf([0, 90, 180, 270]),
  shake: g.bool,
  size: g.oneOf(["2xs", "xs", "sm", "lg", "xl", "2xl", "1x", "2x", "3x", "4x", "5x", "6x", "7x", "8x", "9x", "10x"]),
  spin: g.bool,
  spinPulse: g.bool,
  spinReverse: g.bool,
  symbol: g.oneOfType([g.bool, g.string]),
  title: g.string,
  titleId: g.string,
  transform: g.oneOfType([g.string, g.object]),
  swapOpacity: g.bool
}, or.defaultProps = {
  border: !1,
  className: "",
  mask: null,
  maskId: null,
  fixedWidth: !1,
  inverse: !1,
  flip: !1,
  icon: null,
  listItem: !1,
  pull: null,
  pulse: !1,
  rotation: null,
  size: null,
  spin: !1,
  spinPulse: !1,
  spinReverse: !1,
  beat: !1,
  fade: !1,
  beatFade: !1,
  bounce: !1,
  shake: !1,
  symbol: !1,
  title: "",
  titleId: null,
  transform: null,
  swapOpacity: !1
};
var ir = function e(t, n) {
    var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
    if ("string" == typeof n) return n;
    var o = (n.children || []).map(function (n) {
        return e(t, n);
      }),
      i = Object.keys(n.attributes || {}).reduce(function (e, t) {
        var r = n.attributes[t];
        switch (t) {
          case "class":
            e.attrs.className = r, delete n.attributes.class;
            break;
          case "style":
            e.attrs.style = er(r);
            break;
          default:
            0 === t.indexOf("aria-") || 0 === t.indexOf("data-") ? e.attrs[t.toLowerCase()] = r : e.attrs[_n(t)] = r;
        }
        return e;
      }, {
        attrs: {}
      }),
      a = r.style,
      c = void 0 === a ? {} : a,
      s = Kn(r, $n);
    return i.attrs.style = Wn(Wn({}, i.attrs.style), c), t.apply(void 0, [n.tag, Wn(Wn({}, i.attrs), s)].concat(Yn(o)));
  }.bind(null, t.createElement),
  ar = {
    prefix: "fas",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
  },
  cr = {
    prefix: "fas",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"]
  },
  sr = {
    prefix: "fas",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm448 0c0-11.1-5.7-21.4-15.2-27.2s-21.2-6.4-31.1-1.4l-64 32c-15.8 7.9-22.2 27.1-14.3 42.9s27.1 22.2 42.9 14.3l17.7-8.8V384H416c-17.7 0-32 14.3-32 32s14.3 32 32 32h64 64c17.7 0 32-14.3 32-32s-14.3-32-32-32H512V96z"]
  },
  lr = {
    prefix: "fas",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z"]
  },
  ur = {
    prefix: "fas",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
  },
  dr = {
    prefix: "fas",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 232c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V232zM128 392v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40zM160 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V72zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM160 392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392zM448 72v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V232zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]
  },
  fr = {
    prefix: "fas",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z"]
  },
  pr = {
    prefix: "fas",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
  },
  mr = {
    prefix: "fas",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M192 0c-41.8 0-77.4 26.7-90.5 64H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H282.5C269.4 26.7 233.8 0 192 0zm0 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z"]
  },
  hr = {
    prefix: "fas",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64C0 46.3 14.3 32 32 32zm0 128H480V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V160zm128 80c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16z"]
  },
  Ar = {
    prefix: "fas",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  gr = {
    prefix: "fas",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]
  },
  vr = {
    prefix: "fas",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H480c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  Cr = {
    prefix: "fas",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M205 34.8c11.5 5.1 19 16.6 19 29.2v64H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224v64c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4z"]
  },
  br = {
    prefix: "fas",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M435.4 121.9l67.2-67.2c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2L9.4 457.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l67.2-67.2c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1zm-91.2 .7L122.5 344.2C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5zm-176.5 267L389.5 167.8C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z"]
  },
  Er = {
    prefix: "fas",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
  },
  yr = {
    prefix: "fas",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M72 88a56 56 0 1 1 112 0A56 56 0 1 1 72 88zM64 245.7C54 256.9 48 271.8 48 288s6 31.1 16 42.3V245.7zm144.4-49.3C178.7 222.7 160 261.2 160 304c0 34.3 12 65.8 32 90.5V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V389.2C26.2 371.2 0 332.7 0 288c0-61.9 50.1-112 112-112h32c24 0 46.2 7.5 64.4 20.3zM448 416V394.5c20-24.7 32-56.2 32-90.5c0-42.8-18.7-81.3-48.4-107.7C449.8 183.5 472 176 496 176h32c61.9 0 112 50.1 112 112c0 44.7-26.2 83.2-64 101.2V416c0 17.7-14.3 32-32 32H480c-17.7 0-32-14.3-32-32zm8-328a56 56 0 1 1 112 0A56 56 0 1 1 456 88zM576 245.7v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM320 32a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM240 304c0 16.2 6 31 16 42.3V261.7c-10 11.3-16 26.1-16 42.3zm144-42.3v84.7c10-11.3 16-26.1 16-42.3s-6-31.1-16-42.3zM448 304c0 44.7-26.2 83.2-64 101.2V448c0 17.7-14.3 32-32 32H288c-17.7 0-32-14.3-32-32V405.2c-37.8-18-64-56.5-64-101.2c0-61.9 50.1-112 112-112h32c61.9 0 112 50.1 112 112z"]
  },
  Ir = {
    prefix: "fas",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  Br = {
    prefix: "fas",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48h-8v40H464c30.9 0 56 25.1 56 56v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-4.4-3.6-8-8-8H312v40h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V280H112c-4.4 0-8 3.6-8 8v32h8c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48h8V288c0-30.9 25.1-56 56-56H264V192h-8c-26.5 0-48-21.5-48-48V80z"]
  },
  xr = {
    prefix: "fas",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 288c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32s-14.3 32-32 32v64H544V320c-17.7 0-32-14.3-32-32s14.3-32 32-32h32c17.7 0 32 14.3 32 32v96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V288zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  wr = {
    prefix: "fas",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  Qr = {
    prefix: "fas",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
  },
  Hr = {
    prefix: "fas",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"]
  },
  zr = {
    prefix: "fas",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M272 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L295.8 82.8C280.7 69.1 272 49.7 272 29.2V24zM0 320v16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v64zm128 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zm112 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-16c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V336c0-8.8 7.2-16 16-16zM360 0c-13.3 0-24 10.7-24 24v5.2c0 34 14.4 66.4 39.7 89.2l16.4 14.8c15.2 13.7 23.8 33.1 23.8 53.5V200c0 13.3 10.7 24 24 24s24-10.7 24-24V186.8c0-34-14.4-66.4-39.7-89.2L407.8 82.8C392.7 69.1 384 49.7 384 29.2V24c0-13.3-10.7-24-24-24zM64 128A64 64 0 1 0 64 0a64 64 0 1 0 0 128z"]
  },
  Mr = {
    prefix: "fas",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M0 128V352c0 70.7 57.3 128 128 128H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-35.3 0-64-28.7-64-64s28.7-64 64-64H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H368c44.2 0 80-35.8 80-80V128c0-53-43-96-96-96H96C43 32 0 75 0 128z"]
  },
  kr = {
    prefix: "fas",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192h42.7c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0H21.3C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7h42.7C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3H405.3zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352H378.7C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7H154.7c-14.7 0-26.7-11.9-26.7-26.7z"]
  },
  Nr = {
    prefix: "fas",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z"]
  },
  Sr = {
    prefix: "fas",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-53 0-96 43-96 96s43 96 96 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c53 0 96-43 96-96s-43-96-96-96H352c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c88.4 0 160 71.6 160 160zM192 224H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  Vr = {
    prefix: "fas",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm64 320H64V320c35.3 0 64 28.7 64 64zM64 192V128h64c0 35.3-28.7 64-64 64zM448 384c0-35.3 28.7-64 64-64v64H448zm64-192c-35.3 0-64-28.7-64-64h64v64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
  },
  Lr = {
    prefix: "fas",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]
  },
  Pr = {
    prefix: "fas",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80zM0 272c0-26.5 21.5-48 48-48H80c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V272zM368 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H368c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48z"]
  },
  Or = {
    prefix: "fas",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M448 256A192 192 0 1 0 64 256a192 192 0 1 0 384 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 0h48c17.7 0 32-14.3 32-32s-14.3-32-32-32H232v64zm48 64H232v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V288 168c0-22.1 17.9-40 40-40h72c53 0 96 43 96 96s-43 96-96 96z"]
  },
  Tr = {
    prefix: "fas",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM400 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H514.7l-89.4 89.4c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h72c30.9 0 56 25.1 56 56s-25.1 56-56 56H455.4c-11.7 0-21.7-8.5-23.7-20.1l-.2-1.2c-2.9-17.4-19.4-29.2-36.8-26.3s-29.2 19.4-26.3 36.8l.2 1.2c7.1 42.4 43.8 73.5 86.8 73.5H520c66.3 0 120-53.7 120-120c0-64.6-51-117.2-114.9-119.9l89.5-89.5c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H400z"]
  },
  Dr = {
    prefix: "fas",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96zM64 352c35.3 0 64 28.7 64 64H64V352zm64-208c0 35.3-28.7 64-64 64V144h64zM512 304v64H448c0-35.3 28.7-64 64-64zM448 96h64v64c-35.3 0-64-28.7-64-64z"]
  },
  Rr = {
    prefix: "fas",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  Gr = {
    prefix: "fas",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"]
  },
  Fr = {
    prefix: "fas",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm128 72c8.8 0 16 7.2 16 16v17.3c8.5 1.2 16.7 3.1 24.1 5.1c8.5 2.3 13.6 11 11.3 19.6s-11 13.6-19.6 11.3c-11.1-3-22-5.2-32.1-5.3c-8.4-.1-17.4 1.8-23.6 5.5c-5.7 3.4-8.1 7.3-8.1 12.8c0 3.7 1.3 6.5 7.3 10.1c6.9 4.1 16.6 7.1 29.2 10.9l.5 .1 0 0 0 0c11.3 3.4 25.3 7.6 36.3 14.6c12.1 7.6 22.4 19.7 22.7 38.2c.3 19.3-9.6 33.3-22.9 41.6c-7.7 4.8-16.4 7.6-25.1 9.1V440c0 8.8-7.2 16-16 16s-16-7.2-16-16V422.2c-11.2-2.1-21.7-5.7-30.9-8.9l0 0c-2.1-.7-4.2-1.4-6.2-2.1c-8.4-2.8-12.9-11.9-10.1-20.2s11.9-12.9 20.2-10.1c2.5 .8 4.8 1.6 7.1 2.4l0 0 0 0 0 0c13.6 4.6 24.6 8.4 36.3 8.7c9.1 .3 17.9-1.7 23.7-5.3c5.1-3.2 7.9-7.3 7.8-14c-.1-4.6-1.8-7.8-7.7-11.6c-6.8-4.3-16.5-7.4-29-11.2l-1.6-.5 0 0c-11-3.3-24.3-7.3-34.8-13.7c-12-7.2-22.6-18.9-22.7-37.3c-.1-19.4 10.8-32.8 23.8-40.5c7.5-4.4 15.8-7.2 24.1-8.7V232c0-8.8 7.2-16 16-16z"]
  },
  jr = {
    prefix: "fas",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zm-112.4 5.1c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94zm215.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
  },
  Jr = {
    prefix: "fas",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M479 103.8L441 256H576V96c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V320H400c-9.9 0-19.2-4.5-25.2-12.3s-8.2-17.9-5.8-27.5l48-192c4.3-17.1 21.7-27.6 38.8-23.3s27.6 21.7 23.3 38.8zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
  },
  Zr = {
    prefix: "fas",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  },
  Wr = {
    prefix: "fas",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M96 77.3c0-7.3 5.9-13.3 13.3-13.3c3.5 0 6.9 1.4 9.4 3.9l14.9 14.9C130 91.8 128 101.7 128 112c0 19.9 7.2 38 19.2 52c-5.3 9.2-4 21.1 3.8 29c9.4 9.4 24.6 9.4 33.9 0L289 89c9.4-9.4 9.4-24.6 0-33.9c-7.9-7.9-19.8-9.1-29-3.8C246 39.2 227.9 32 208 32c-10.3 0-20.2 2-29.2 5.5L163.9 22.6C149.4 8.1 129.7 0 109.3 0C66.6 0 32 34.6 32 77.3V256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H96V77.3zM32 352v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352H32z"]
  },
  Xr = {
    prefix: "fas",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M16 64c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H128V224c0 53 43 96 96 96s96-43 96-96V96H304c-17.7 0-32-14.3-32-32s14.3-32 32-32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V96H48C30.3 96 16 81.7 16 64zM0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  Ur = {
    prefix: "fas",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z"]
  },
  Kr = {
    prefix: "fas",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-192 0c-17.7 0-32-14.3-32-32zm32 64H288c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 96H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  Yr = {
    prefix: "fas",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
  },
  qr = {
    prefix: "fas",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
  },
  _r = {
    prefix: "fas",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M48.5 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L98.6 96.6c87.6-86.5 228.7-86.2 315.8 1c87.5 87.5 87.5 229.3 0 316.8s-229.3 87.5-316.8 0c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0c62.5 62.5 163.8 62.5 226.3 0s62.5-163.8 0-226.3c-62.2-62.2-162.7-62.5-225.3-1L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8H48.5z"]
  },
  $r = {
    prefix: "fas",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L481.4 352H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H399.7l-81.7-64H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H236.4L154.8 96H512c17.7 0 32-14.3 32-32s-14.3-32-32-32H128c-13.4 0-24.8 8.2-29.6 19.8L38.8 5.1zM324.9 352l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H324.9zM162.5 224l-61.8-48.7c-3 4.9-4.7 10.6-4.7 16.7c0 17.7 14.3 32 32 32h34.5zM487.4 480l-81.2-64H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H487.4z"]
  },
  eo = {
    prefix: "fas",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
  },
  to = eo,
  no = {
    prefix: "fas",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.3-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z"]
  },
  ro = {
    prefix: "fas",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L355.7 253.5 400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2L38.8 5.1zm168 131.7c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l-94.5-74.1zM243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1L272.9 311 243.3 416z"]
  },
  oo = {
    prefix: "fas",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM111 257.1l26.8 89.2 31.6-90.3c3.4-9.6 12.5-16.1 22.7-16.1s19.3 6.4 22.7 16.1l31.6 90.3L273 257.1c3.8-12.7 17.2-19.9 29.9-16.1s19.9 17.2 16.1 29.9l-48 160c-3 10-12 16.9-22.4 17.1s-19.8-6.2-23.2-16.1L192 336.6l-33.3 95.3c-3.4 9.8-12.8 16.3-23.2 16.1s-19.5-7.1-22.4-17.1l-48-160c-3.8-12.7 3.4-26.1 16.1-29.9s26.1 3.4 29.9 16.1z"]
  },
  io = {
    prefix: "fas",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z"]
  },
  ao = {
    prefix: "fas",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z"]
  },
  co = {
    prefix: "fas",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M416 176c0 97.2-93.1 176-208 176c-38.2 0-73.9-8.7-104.7-23.9c-7.5 4-16 7.9-25.2 11.4C59.8 346.4 37.8 352 16 352c-6.9 0-13.1-4.5-15.2-11.1s.2-13.8 5.8-17.9l0 0 0 0 .2-.2c.2-.2 .6-.4 1.1-.8c1-.8 2.5-2 4.3-3.7c3.6-3.3 8.5-8.1 13.3-14.3c5.5-7 10.7-15.4 14.2-24.7C14.7 250.3 0 214.6 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM231.5 383C348.9 372.9 448 288.3 448 176c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 38.6-14.7 74.3-39.6 103.4c3.5 9.4 8.7 17.7 14.2 24.7c4.8 6.2 9.7 11 13.3 14.3c1.8 1.6 3.3 2.9 4.3 3.7c.5 .4 .9 .7 1.1 .8l.2 .2 0 0 0 0c5.6 4.1 7.9 11.3 5.8 17.9c-2.1 6.6-8.3 11.1-15.2 11.1c-21.8 0-43.8-5.6-62.1-12.5c-9.2-3.5-17.8-7.4-25.2-11.4C505.9 503.3 470.2 512 432 512c-95.6 0-176.2-54.6-200.5-129zM228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72z"]
  },
  so = {
    prefix: "fas",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M137.4 41.4c12.5-12.5 32.8-12.5 45.3 0l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128zm0 429.3l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128c-12.5 12.5-32.8 12.5-45.3 0z"]
  },
  lo = {
    prefix: "fas",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  uo = {
    prefix: "fas",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64-96c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  fo = {
    prefix: "fas",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96H128V192c0-12.9-7.8-24.6-19.8-29.6s-25.7-2.2-34.9 6.9l-64 64c-12.5 12.5-12.5 32.8 0 45.3l64 64c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V288h96v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288h96v32c0 12.9 7.8 24.6 19.8 29.6s25.7 2.2 34.9-6.9l64-64c12.5-12.5 12.5-32.8 0-45.3l-64-64c-9.2-9.2-22.9-11.9-34.9-6.9s-19.8 16.6-19.8 29.6v32H288V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64z"]
  },
  po = {
    prefix: "fas",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M320 376.4l.1-.1 26.4 14.1 85.2 45.5-16.5-97.6-4.8-28.7 20.7-20.5 70.1-69.3-96.1-14.2-29.3-4.3-12.9-26.6L320.1 86.9l-.1 .3V376.4zm175.1 98.3c2 12-3 24.2-12.9 31.3s-23 8-33.8 2.3L320.1 439.8 191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18s23.4 7 28.8 18l64.3 132.3 143.6 21.2c12 1.8 22 10.2 25.7 21.7s.7 24.2-7.9 32.7L470.5 329l24.6 145.7z"]
  },
  mo = {
    prefix: "fas",
    iconName: "code",
    icon: [640, 512, [], "f121", "M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6zm80.6 120.1c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]
  },
  ho = {
    prefix: "fas",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 256 192 160 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32v96H64V32zM512 256H256c-17.7 0-32 14.3-32 32v96H64V192H256 512v64zM192 304a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM144 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
  },
  Ao = {
    prefix: "fas",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]
  },
  go = {
    prefix: "fas",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM155.7 250.2L192 302.1l36.3-51.9c7.6-10.9 22.6-13.5 33.4-5.9s13.5 22.6 5.9 33.4L221.3 344l46.4 66.2c7.6 10.9 5 25.8-5.9 33.4s-25.8 5-33.4-5.9L192 385.8l-36.3 51.9c-7.6 10.9-22.6 13.5-33.4 5.9s-13.5-22.6-5.9-33.4L162.7 344l-46.4-66.2c-7.6-10.9-5-25.8 5.9-33.4s25.8-5 33.4 5.9z"]
  },
  vo = {
    prefix: "fas",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  Co = {
    prefix: "fas",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm44.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM144 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM400 240c13.3 0 24 10.7 24 24v8h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H280c-13.3 0-24-10.7-24-24s10.7-24 24-24h96v-8c0-13.3 10.7-24 24-24zM288 464V352H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zM24 464H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  bo = {
    prefix: "fas",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 64c44.2 0 80 35.8 80 80v48H144V144c0-44.2 35.8-80 80-80zM80 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H368V144C368 64.5 303.5 0 224 0S80 64.5 80 144zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  Eo = {
    prefix: "fas",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M352 144c0-44.2 35.8-80 80-80s80 35.8 80 80v48c0 17.7 14.3 32 32 32s32-14.3 32-32V144C576 64.5 511.5 0 432 0S288 64.5 288 144v48H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V144z"]
  },
  yo = {
    prefix: "fas",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
  },
  Io = {
    prefix: "fas",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M177.5 446c-8.8 3.8-19 2-26-4.6l-144-136C2.7 300.9 0 294.6 0 288s2.7-12.9 7.5-17.4l144-136c7-6.6 17.2-8.4 26-4.6s14.5 12.5 14.5 22l0 88 192 0c17.7 0 32-14.3 32-32l0-144c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 144c0 70.7-57.3 128-128 128l-192 0 0 88c0 9.6-5.7 18.2-14.5 22z"]
  },
  Bo = {
    prefix: "fas",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  xo = {
    prefix: "fas",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
  },
  wo = {
    prefix: "fas",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
  },
  Qo = {
    prefix: "fas",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32zM32 96c17.7 0 32 14.3 32 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C144.3 320.4 160 367.5 160 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96L44.8 294.4C15.7 255.6 0 208.5 0 160V128c0-17.7 14.3-32 32-32zm320 32v32c0 34.6 11.2 68.3 32 96l19.2 25.6C432.3 320.4 448 367.5 448 416v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V416c0-34.6-11.2-68.3-32-96l-19.2-25.6C303.7 255.6 288 208.5 288 160V128c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  Ho = {
    prefix: "fas",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  zo = {
    prefix: "fas",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z"]
  },
  Mo = {
    prefix: "fas",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M64 128c0-17.7 14.3-32 32-32h12.8l34 84.9C95 215.9 64 272.3 64 336v8c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344v-8c0-63.7-31-120.1-78.8-155.1L478.1 68.8c1.3-3.2 1.9-6.6 1.9-10C480 44 468 32 453.2 32H192 122.8 96C43 32 0 75 0 128v64c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm65 192c5.2-41.4 30.1-76.6 65-96H382c34.9 19.4 59.8 54.6 65 96H129z"]
  },
  ko = {
    prefix: "fas",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M135.2 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8c-12.1 0-23.2 6.8-28.6 17.7zM416 128H32L53.2 467c1.6 25.3 22.6 45 47.9 45H346.9c25.3 0 46.3-19.7 47.9-45L416 128z"]
  },
  No = {
    prefix: "fas",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
  },
  So = {
    prefix: "fas",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
  },
  Vo = {
    prefix: "fas",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM64 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V288zM300.9 397.9L256 368V304l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1z"]
  },
  Lo = {
    prefix: "fas",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6V32c0-17.7-14.3-32-32-32H352zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
  },
  Po = {
    prefix: "fas",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
  },
  Oo = {
    prefix: "fas",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  To = {
    prefix: "fas",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H96L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM112 128c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112zm96 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-80-48V400 320 288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80V416zM578.1 288l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]
  },
  Do = {
    prefix: "fas",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM368 304A144 144 0 1 0 80 304a144 144 0 1 0 288 0zM88 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM208 88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm16 328c-61.9 0-112-50.1-112-112c0-16.5 3.6-32.2 10-46.3c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5C328.5 373 281.3 416 224 416z"]
  },
  Ro = {
    prefix: "fas",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z"]
  },
  Go = {
    prefix: "fas",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z"]
  },
  Fo = {
    prefix: "fas",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M537 116l-35.3 44.1C578.6 163.1 640 226.4 640 304c0 79.5-64.5 144-144 144s-144-64.5-144-144c0-38.3 13-75.5 37-105.5L487 76c11-13.8 31.2-16 45-5s16 31.2 5 45zM416 304a80 80 0 1 0 160 0 80 80 0 1 0 -160 0zM32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z"]
  },
  jo = {
    prefix: "fas",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
  },
  Jo = {
    prefix: "fas",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zm96 96c0-17.7 14.3-32 32-32l96 0c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm96 64H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm160 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  Zo = {
    prefix: "fas",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"]
  },
  Wo = {
    prefix: "fas",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M495.9 166.6c3.2 8.7 .5 18.4-6.4 24.6l-43.3 39.4c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l43.3 39.4c6.9 6.2 9.6 15.9 6.4 24.6c-4.4 11.9-9.7 23.3-15.8 34.3l-4.7 8.1c-6.6 11-14 21.4-22.1 31.2c-5.9 7.2-15.7 9.6-24.5 6.8l-55.7-17.7c-13.4 10.3-28.2 18.9-44 25.4l-12.5 57.1c-2 9.1-9 16.3-18.2 17.8c-13.8 2.3-28 3.5-42.5 3.5s-28.7-1.2-42.5-3.5c-9.2-1.5-16.2-8.7-18.2-17.8l-12.5-57.1c-15.8-6.5-30.6-15.1-44-25.4L83.1 425.9c-8.8 2.8-18.6 .3-24.5-6.8c-8.1-9.8-15.5-20.2-22.1-31.2l-4.7-8.1c-6.1-11-11.4-22.4-15.8-34.3c-3.2-8.7-.5-18.4 6.4-24.6l43.3-39.4C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L22.4 191.2c-6.9-6.2-9.6-15.9-6.4-24.6c4.4-11.9 9.7-23.3 15.8-34.3l4.7-8.1c6.6-11 14-21.4 22.1-31.2c5.9-7.2 15.7-9.6 24.5-6.8l55.7 17.7c13.4-10.3 28.2-18.9 44-25.4l12.5-57.1c2-9.1 9-16.3 18.2-17.8C227.3 1.2 241.5 0 256 0s28.7 1.2 42.5 3.5c9.2 1.5 16.2 8.7 18.2 17.8l12.5 57.1c15.8 6.5 30.6 15.1 44 25.4l55.7-17.7c8.8-2.8 18.6-.3 24.5 6.8c8.1 9.8 15.5 20.2 22.1 31.2l4.7 8.1c6.1 11 11.4 22.4 15.8 34.3zM256 336a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"]
  },
  Xo = {
    prefix: "fas",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z"]
  },
  Uo = {
    prefix: "fas",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z"]
  },
  Ko = {
    prefix: "fas",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
  },
  Yo = {
    prefix: "fas",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z"]
  },
  qo = {
    prefix: "fas",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z"]
  },
  _o = {
    prefix: "fas",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"]
  },
  $o = {
    prefix: "fas",
    iconName: "download",
    icon: [512, 512, [], "f019", "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  ei = {
    prefix: "fas",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M0 96v64H448V96c0-53-43-96-96-96H96C43 0 0 43 0 96zM56 80a24 24 0 1 1 48 0A24 24 0 1 1 56 80zM176 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm72 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm16 200V448H64l0-192H384zM64 192H0v64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256 192H384 64zm48 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]
  },
  ti = {
    prefix: "fas",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z"]
  },
  ni = {
    prefix: "fas",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
  },
  ri = {
    prefix: "fas",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z"]
  },
  oi = {
    prefix: "fas",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M416 0C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V352 240 32c0-17.7-14.3-32-32-32zM64 16C64 7.8 57.9 1 49.7 .1S34.2 4.6 32.4 12.5L2.1 148.8C.7 155.1 0 161.5 0 167.9c0 45.9 35.1 83.6 80 87.7V480c0 17.7 14.3 32 32 32s32-14.3 32-32V255.6c44.9-4.1 80-41.8 80-87.7c0-6.4-.7-12.8-2.1-19.1L191.6 12.5c-1.8-8-9.3-13.3-17.4-12.4S160 7.8 160 16V150.2c0 5.4-4.4 9.8-9.8 9.8c-5.1 0-9.3-3.9-9.8-9L127.9 14.6C127.2 6.3 120.3 0 112 0s-15.2 6.3-15.9 14.6L83.7 151c-.5 5.1-4.7 9-9.8 9c-5.4 0-9.8-4.4-9.8-9.8V16zm48.3 152l-.3 0-.3 0 .3-.7 .3 .7z"]
  },
  ii = {
    prefix: "fas",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M32 64C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zM160 224c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zM128 416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-17.7 0-32 14.3-32 32zM32 224c-17.7 0-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
  },
  ai = {
    prefix: "fas",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  ci = {
    prefix: "fas",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
  },
  si = {
    prefix: "fas",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48h8V196.9c-1.9 1.4-3.8 2.9-5.6 4.4C10.9 214.5 0 232.9 0 256c0 46.9 14.3 84.1 37 112.5c14.2 17.7 31.1 31.3 48.5 41.8L65.6 469.9c-3.3 9.8-1.6 20.5 4.4 28.8s15.7 13.3 26 13.3H352c10.3 0 19.9-4.9 26-13.3s7.7-19.1 4.4-28.8l-19.8-59.5c17.4-10.5 34.3-24.1 48.5-41.8c22.7-28.4 37-65.5 37-112.5c0-23.1-10.9-41.5-26.4-54.6c-1.8-1.5-3.7-3-5.6-4.4V48h8c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM384 256.3c0 1-.3 2.6-3.8 5.6c-4.8 4.1-14 9-29.3 13.4C320.5 284 276.1 288 224 288s-96.5-4-126.9-12.8c-15.3-4.4-24.5-9.3-29.3-13.4c-3.5-3-3.8-4.6-3.8-5.6l0-.3 0-.1c0-1 0-2.5 3.8-5.8c4.8-4.1 14-9 29.3-13.4C127.5 228 171.9 224 224 224s96.5 4 126.9 12.8c15.3 4.4 24.5 9.3 29.3 13.4c3.8 3.2 3.8 4.8 3.8 5.8l0 .1 0 .3zM328.2 384l-.2 .5 0-.5h.2zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  li = {
    prefix: "fas",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 256H192V416c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-11.8 6.4-22.2 16-27.7c15.3-8.9 20.5-28.4 11.7-43.7s-28.4-20.5-43.7-11.7C83.4 349.4 64 380.4 64 416c0 53 43 96 96 96s96-43 96-96V256zm64 128c0 53 43 96 96 96s96-43 96-96c0-35.6-19.4-66.6-48-83.1c-15.3-8.8-34.9-3.6-43.7 11.7s-3.6 34.9 11.7 43.7c9.6 5.6 16 15.9 16 27.7c0 17.7-14.3 32-32 32s-32-14.3-32-32V256H320V384z"]
  },
  ui = {
    prefix: "fas",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"]
  },
  di = {
    prefix: "fas",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
  },
  fi = {
    prefix: "fas",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
  },
  pi = {
    prefix: "fas",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm0 256h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
  },
  mi = {
    prefix: "fas",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM41.4 105.4c12.5-12.5 32.8-12.5 45.3 0l64 64c.7 .7 1.3 1.4 1.9 2.1c14.2-7.3 30.4-11.4 47.5-11.4H312c17.1 0 33.2 4.1 47.5 11.4c.6-.7 1.2-1.4 1.9-2.1l64-64c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-64 64c-.7 .7-1.4 1.3-2.1 1.9c6.2 12 10.1 25.3 11.1 39.5H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H416c0 24.6-5.5 47.8-15.4 68.6c2.2 1.3 4.2 2.9 6 4.8l64 64c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-63.1-63.1c-24.5 21.8-55.8 36.2-90.3 39.6V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c-34.5-3.4-65.8-17.8-90.3-39.6L86.6 502.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l64-64c1.9-1.9 3.9-3.4 6-4.8C101.5 367.8 96 344.6 96 320H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H96.3c1.1-14.1 5-27.5 11.1-39.5c-.7-.6-1.4-1.2-2.1-1.9l-64-64c-12.5-12.5-12.5-32.8 0-45.3z"]
  },
  hi = {
    prefix: "fas",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
  },
  Ai = {
    prefix: "fas",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  gi = {
    prefix: "fas",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M32 32c17.7 0 32 14.3 32 32V320H288V160c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H352 320 64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32zm144 96a80 80 0 1 1 0 160 80 80 0 1 1 0-160z"]
  },
  vi = {
    prefix: "fas",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32zm45.3 493.3c12-12 18.7-28.3 18.7-45.3H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7z"]
  },
  Ci = {
    prefix: "fas",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  bi = {
    prefix: "fas",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm384 64H256V0L384 128z"]
  },
  Ei = {
    prefix: "fas",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M309.5 178.4L447.9 297.1c-1.6 .9-3.2 2-4.8 3c-18 12.4-40.1 20.3-59.2 20.3c-19.6 0-40.8-7.7-59.2-20.3c-22.1-15.5-51.6-15.5-73.7 0c-17.1 11.8-38 20.3-59.2 20.3c-10.1 0-21.1-2.2-31.9-6.2C163.1 193.2 262.2 96 384 96h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-26.9 0-52.3 6.6-74.5 18.4zM160 160A64 64 0 1 1 32 160a64 64 0 1 1 128 0zM306.5 325.9C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1c11.1-7.9 25.9-7.9 37 0z"]
  },
  yi = {
    prefix: "fas",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]
  },
  Ii = {
    prefix: "fas",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M215.4 96H144 107.8 96v8.8V144v40.4 89L.2 202.5c1.6-18.1 10.9-34.9 25.7-45.8L48 140.3V96c0-26.5 21.5-48 48-48h76.6l49.9-36.9C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L339.4 48H416c26.5 0 48 21.5 48 48v44.3l22.1 16.4c14.8 10.9 24.1 27.7 25.7 45.8L416 273.4v-89V144 104.8 96H404.2 368 296.6 215.4zM0 448V242.1L217.6 403.3c11.1 8.2 24.6 12.7 38.4 12.7s27.3-4.4 38.4-12.7L512 242.1V448v0c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64v0zM176 160H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Bi = {
    prefix: "fas",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H384l0 352c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-352H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]
  },
  xi = {
    prefix: "fas",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M120 0c13.3 0 24 10.7 24 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C181.3 60 192 80 192 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C106.7 68 96 48 96 26.6V24c0-13.3 10.7-24 24-24zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM256 24v2.6c0 5.3 2.7 10.3 7.1 13.3l12.4 8.3C293.3 60 304 80 304 101.4V104c0 13.3-10.7 24-24 24s-24-10.7-24-24v-2.6c0-5.3-2.7-10.3-7.1-13.3l-12.4-8.3C218.7 68 208 48 208 26.6V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  wi = {
    prefix: "fas",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"]
  },
  Qi = {
    prefix: "fas",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
  },
  Hi = {
    prefix: "fas",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
  },
  zi = {
    prefix: "fas",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
  },
  Mi = {
    prefix: "fas",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z"]
  },
  ki = {
    prefix: "fas",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
  },
  Ni = {
    prefix: "fas",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"]
  },
  Si = {
    prefix: "fas",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32zM288 416c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32h64c17.7 0 32 14.3 32 32z"]
  },
  Vi = {
    prefix: "fas",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z"]
  },
  Li = {
    prefix: "fas",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
  },
  Pi = {
    prefix: "fas",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zm385.9 47.4c11.6-9.9 26.4-15.4 41.7-15.4H496c35.3 0 64 28.7 64 64v5.8c0 17.9-7.5 35.1-20.8 47.2L378.4 392.4c-9.7 8.9-13 22.9-8.2 35.2S386.8 448 400 448H608c17.7 0 32-14.3 32-32s-14.3-32-32-32H482.3l100.2-91.9c26.4-24.2 41.5-58.5 41.5-94.4V192c0-70.7-57.3-128-128-128h-4.5c-30.6 0-60.1 10.9-83.3 30.8l-29 24.9c-13.4 11.5-15 31.7-3.5 45.1s31.7 15 45.1 3.5l29-24.9z"]
  },
  Oi = {
    prefix: "fas",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M384 476.1L192 421.2V35.9L384 90.8V476.1zm32-1.2V88.4L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2V423.6L32.9 474.5C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3z"]
  },
  Ti = {
    prefix: "fas",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  Di = {
    prefix: "fas",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
  },
  Ri = {
    prefix: "fas",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
  },
  Gi = {
    prefix: "fas",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M374.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-320 320c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l320-320zM128 128A64 64 0 1 0 0 128a64 64 0 1 0 128 0zM384 384a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  },
  Fi = {
    prefix: "fas",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
  },
  ji = {
    prefix: "fas",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"]
  },
  Ji = {
    prefix: "fas",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
  },
  Zi = {
    prefix: "fas",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32C14.3 0 0 14.3 0 32zm608 96H32V480c0 17.7 14.3 32 32 32h96V352c0-88.4 71.6-160 160-160s160 71.6 160 160V512h96c17.7 0 32-14.3 32-32V128zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
  },
  Wi = {
    prefix: "fas",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75zm181 53c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
  },
  Xi = {
    prefix: "fas",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"]
  },
  Ui = {
    prefix: "fas",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm128-64V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V224c0-17.7 14.3-32 32-32zM480 96V320c0 17.7-14.3 32-32 32s-32-14.3-32-32V96c0-17.7 14.3-32 32-32s32 14.3 32 32z"]
  },
  Ki = {
    prefix: "fas",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M145.6 7.7C141 2.8 134.7 0 128 0s-13 2.8-17.6 7.7l-104 112c-6.5 7-8.2 17.2-4.4 25.9S14.5 160 24 160H80V352H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7s13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V160h56c9.5 0 18.2-5.7 22-14.4s2.1-18.9-4.4-25.9l-104-112z"]
  },
  Yi = {
    prefix: "fas",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"]
  },
  qi = {
    prefix: "fas",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M64 131.9C64 112.1 80.1 96 99.9 96c9.5 0 18.6 3.8 25.4 10.5l16.2 16.2c-21 38.9-17.4 87.5 10.9 123L151 247c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-1.3 1.3c-35.5-28.3-84.2-31.9-123-10.9L170.5 61.3C151.8 42.5 126.4 32 99.9 32C44.7 32 0 76.7 0 131.9V448c0 17.7 14.3 32 32 32s32-14.3 32-32V131.9zM256 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-128a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  _i = {
    prefix: "fas",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H346.7L336 416H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z"]
  },
  $i = {
    prefix: "fas",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M64 96c0-17.7-14.3-32-32-32S0 78.3 0 96V256 416c0 17.7 14.3 32 32 32s32-14.3 32-32V288H256V416c0 17.7 14.3 32 32 32s32-14.3 32-32V256 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H64V96zM432 64c-15.1 0-28.2 10.6-31.3 25.4l-32 152c-2 9.4 .4 19.3 6.5 26.8s15.2 11.8 24.8 11.8H524c28.7 0 52 23.3 52 52s-23.3 52-52 52H456.4c-10.3 0-19.5-6.6-22.8-16.4l-3.2-9.7c-5.6-16.8-23.7-25.8-40.5-20.2s-25.8 23.7-20.2 40.5l3.2 9.7c12 35.9 45.6 60.2 83.5 60.2H524c64.1 0 116-51.9 116-116s-51.9-116-116-116H439.4L458 128H576c17.7 0 32-14.3 32-32s-14.3-32-32-32H432z"]
  },
  ea = {
    prefix: "fas",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
  },
  ta = {
    prefix: "fas",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  na = {
    prefix: "fas",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M307 34.8c-11.5 5.1-19 16.6-19 29.2v64H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96v64c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4z"]
  },
  ra = {
    prefix: "fas",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M512 256c0 141.4-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l21-57.7 35.8-13c23.9-8.7 38.3-32 36.8-56.1c-1.3-24.4-16.5-46.1-39.2-55.6L166.2 257.3c-8.1-3.4-17.5 .4-21 8.5s.4 17.5 8.5 21l82.4 34.7L144 355v-3c0-30.9-25.1-56-56-56s-56 25.1-56 56v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256zM208.4 176a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm128 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM112 352v48.6l151.8-55.2c12.5-4.5 26.2 1.9 30.8 14.4s-1.9 26.2-14.4 30.8l-49.8 18.1-26.1 71.7c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  oa = {
    prefix: "fas",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480V396.4c0-4 1.5-7.8 4.2-10.7L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z"]
  },
  ia = {
    prefix: "fas",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z"]
  },
  aa = {
    prefix: "fas",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
  },
  ca = {
    prefix: "fas",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
  },
  sa = {
    prefix: "fas",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zM256 0V128H384L256 0zM80 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 96H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32zm0 32v64H288V256H96zM240 416h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  la = {
    prefix: "fas",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M128 0C92.7 0 64 28.7 64 64v96h64V64H354.7L384 93.3V160h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM384 352v32 64H128V384 368 352H384zm64 32h32c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64v96c0 17.7 14.3 32 32 32H64v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  ua = {
    prefix: "fas",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M243.4 2.6l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24v-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96c-8-3.4-17.2-3.4-25.2 0zM128 224H64V420.3c-.6 .3-1.2 .7-1.8 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V224H384V416H344V224H280V416H232V224H168V416H128V224zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]
  },
  da = {
    prefix: "fas",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  fa = {
    prefix: "fas",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M350 177.5c3.8-8.8 2-19-4.6-26l-136-144C204.9 2.7 198.6 0 192 0s-12.9 2.7-17.4 7.5l-136 144c-6.6 7-8.4 17.2-4.6 26s12.5 14.5 22 14.5h88l0 192c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32v32c0 17.7 14.3 32 32 32l80 0c70.7 0 128-57.3 128-128l0-192h88c9.6 0 18.2-5.7 22-14.5z"]
  },
  pa = {
    prefix: "far",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M170.5 51.6L151.5 80h145l-19-28.4c-1.5-2.2-4-3.6-6.7-3.6H177.1c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80H368h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V128H24c-13.3 0-24-10.7-24-24S10.7 80 24 80h8H80 93.8l36.7-55.1C140.9 9.4 158.4 0 177.1 0h93.7c18.7 0 36.2 9.4 46.6 24.9zM80 128V432c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V128H80zm80 64V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  ma = {
    prefix: "far",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192h80v56H48V192zm0 104h80v64H48V296zm128 0h96v64H176V296zm144 0h80v64H320V296zm80-48H320V192h80v56zm0 160v40c0 8.8-7.2 16-16 16H320V408h80zm-128 0v56H176V408h96zm-144 0v56H64c-8.8 0-16-7.2-16-16V408h80zM272 248H176V192h96v56z"]
  },
  ha = {
    prefix: "far",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zm456 0c0-8.5-4.5-16.4-11.8-20.7s-16.4-4.4-23.8-.3l-72 40c-11.6 6.4-15.8 21-9.3 32.6s21 15.8 32.6 9.3L456 128.8V400H408c-13.3 0-24 10.7-24 24s10.7 24 24 24h72 72c13.3 0 24-10.7 24-24s-10.7-24-24-24H504V88z"]
  },
  Aa = {
    prefix: "far",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M512 80H128c-8.8 0-16 7.2-16 16V320H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V320H528V96c0-8.8-7.2-16-16-16zM96 432H544c20.9 0 38.7-13.4 45.3-32H50.7c6.6 18.6 24.4 32 45.3 32zM0 384c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32c0 53-43 96-96 96H96c-53 0-96-43-96-96z"]
  },
  ga = {
    prefix: "far",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
  },
  va = {
    prefix: "far",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M88 72v48H40V72H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 232v48H40V232H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 200H88v48H40V392zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 72v48H200V72h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 200h48v48H200V232zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 160v48H200V392h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 72h48v48H360V72zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 160v48H360V232h48zm-48-40c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 200h48v48H360V392zm-40 0v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
  },
  Ca = {
    prefix: "far",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M145.5 138c4-21.5 17.9-37.4 41.7-47.4c24.7-10.4 59.4-13.7 99.9-7.5c12.8 2 52.4 9.5 64.9 12.8c12.8 3.3 25.9-4.3 29.3-17.2s-4.3-25.9-17.2-29.3c-14.7-3.8-56.1-11.7-69.7-13.8c-46.2-7.1-90.4-4.1-125.7 10.7c-36.1 15.1-63.3 43.1-70.5 83.9c-.1 .4-.1 .9-.2 1.3c-2.8 23.4 .5 44.2 9.8 62.2c9.2 17.8 23.2 31.2 38.8 41.5c2.4 1.6 5 3.2 7.5 4.7H24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H295.8c-9.9-3.1-19.7-6-29.2-8.8l-.3-.1c-37.7-11.1-70.5-20.7-93.3-35.8c-10.9-7.2-18.2-14.9-22.6-23.5c-4.2-8.2-6.6-18.9-4.9-33.8zM364 337.1c3.7 8.6 5.5 20.1 2.6 36.3c-3.8 21.8-17.8 37.9-41.8 48c-24.7 10.4-59.4 13.7-99.8 7.5c-20.1-3.2-54.3-14.6-81.2-23.6l0 0 0 0c-5.9-2-11.4-3.8-16.3-5.4c-12.6-4.1-26.1 2.8-30.3 15.4s2.8 26.2 15.4 30.3c4 1.3 8.8 2.9 14 4.7c26.6 8.9 66.4 22.2 90.9 26.2l.1 0c46.2 7.1 90.4 4.1 125.7-10.7c36.1-15.1 63.3-43.1 70.5-83.9c4-22.9 2.4-43.5-5-61.7H351.6c5.7 5.3 9.7 11 12.3 17.1z"]
  },
  ba = {
    prefix: "far",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"]
  },
  Ea = {
    prefix: "far",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M320 64H280h-9.6C263 27.5 230.7 0 192 0s-71 27.5-78.4 64H104 64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM80 112v24c0 13.3 10.7 24 24 24h88 88c13.3 0 24-10.7 24-24V112h16c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V128c0-8.8 7.2-16 16-16H80zm88-32a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  ya = {
    prefix: "far",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M48 80v48H464V80H48zM32 32H480c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32zM160 248c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM32 416V208H80V416c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V208h48V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64z"]
  },
  Ia = {
    prefix: "far",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM169.8 117.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Ba = {
    prefix: "far",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M512 80c8.8 0 16 7.2 16 16V384c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H512zM64 32C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8H464v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM432 136V344c0 13.3 10.7 24 24 24s24-10.7 24-24V136c0-13.3-10.7-24-24-24s-24 10.7-24 24zm-312-8c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z"]
  },
  xa = {
    prefix: "far",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3C119.6 157.2 32 252.4 32 368H80c0-97.2 78.8-176 176-176s176 78.8 176 176h48c0-115.6-87.6-210.8-200-222.7V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM24 400c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  wa = {
    prefix: "far",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M224 240h96c66.2 0 122 44.7 138.8 105.5c3.3-12.4 5.2-26.2 5.2-41.5c0-70.7-57.3-128-128-128H224 200c-13.3 0-24-10.7-24-24V128 99.9L55.9 208 176 316.1V288 264c0-13.3 10.7-24 24-24h24zm0 48v48 16c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V80v48h48 64c97.2 0 176 78.8 176 176c0 78-38.6 126.2-68.7 152.1c-4.1 3.5-8.1 6.6-11.7 9.3c-3.2 2.4-6.2 4.4-8.9 6.2c-4.5 3-8.3 5.1-10.8 6.5c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-6.8 3.6-13.2 8.3-18.1c.5-.5 .9-.9 1.4-1.4c2.4-2.3 5.1-5.1 7.7-8.6c1.7-2.3 3.4-5 5-7.9c5.3-9.7 9.5-22.9 9.5-40.2c0-53-43-96-96-96H272 224z"]
  },
  Qa = {
    prefix: "far",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M505 41c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L396.5 81.5C358.1 50.6 309.2 32 256 32C132.3 32 32 132.3 32 256c0 53.2 18.6 102.1 49.5 140.5L7 471c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l74.5-74.5c38.4 31 87.3 49.5 140.5 49.5c123.7 0 224-100.3 224-224c0-53.2-18.6-102.1-49.5-140.5L505 41zM362.3 115.7L115.7 362.3C93.3 332.8 80 295.9 80 256c0-97.2 78.8-176 176-176c39.9 0 76.8 13.3 106.3 35.7zM149.7 396.3L396.3 149.7C418.7 179.2 432 216.1 432 256c0 97.2-78.8 176-176 176c-39.9 0-76.8-13.3-106.3-35.7z"]
  },
  Ha = {
    prefix: "far",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM0 248c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM448 408c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24z"]
  },
  za = {
    prefix: "far",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M128 128a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-16 32C50.1 160 0 210.1 0 272c0 44.7 26.2 83.2 64 101.2V416c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v16H112l0-16V336l0-128h32c12.6 0 24.3 3.6 34.2 9.9c7.9-14.2 18.1-26.9 30.2-37.6C190.2 167.5 168 160 144 160H112zM64 229.7v84.7C54 303.1 48 288.2 48 272s6-31.1 16-42.3zM496 208h32V336v48 16H496V384c0-13.3-10.7-24-24-24s-24 10.7-24 24v32c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V373.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-24 0-46.2 7.5-64.4 20.3c12 10.7 22.3 23.4 30.2 37.6c9.9-6.3 21.6-9.9 34.2-9.9zm96 64c0 16.2-6 31.1-16 42.3V229.7c10 11.3 16 26.1 16 42.3zM560 80a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM320 144a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm-16 32c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V389.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304zm0 224V352 224h32l0 128v48 32H304V400zm-48-69.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3v84.7zm128 0V245.7c10 11.3 16 26.1 16 42.3s-6 31.1-16 42.3z"]
  },
  Ma = {
    prefix: "far",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-13.3 0-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  ka = {
    prefix: "far",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M320 80v64H256V80h64zM256 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h8v40H112c-30.9 0-56 25.1-56 56v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-4.4 3.6-8 8-8H264v40h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V280H464c4.4 0 8 3.6 8 8v32h-8c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48h-8V288c0-30.9-25.1-56-56-56H312V192h8c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256zM48 368h64v64H48V368zm208 0h64v64H256V368zm208 0h64v64H464V368z"]
  },
  Na = {
    prefix: "far",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M293.5 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8zM370 273c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78c18 0 34-5 49-15zM32 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80H560V304H536c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V280zM48 464H164.3c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H48v32zm171.7 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H219.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zm128 0h72.6c-2.7-4.7-4.3-10.2-4.3-16s1.6-11.3 4.3-16H347.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16zM592 464V432H475.7c2.7 4.7 4.3 10.2 4.3 16s-1.6 11.3-4.3 16H592z"]
  },
  Sa = {
    prefix: "far",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M168.2 384.9c-15-5.4-31.7-3.1-44.6 6.4c-8.2 6-22.3 14.8-39.4 22.7c5.6-14.7 9.9-31.3 11.3-49.4c1-12.9-3.3-25.7-11.8-35.5C60.4 302.8 48 272 48 240c0-79.5 83.3-160 208-160s208 80.5 208 160s-83.3 160-208 160c-31.6 0-61.3-5.5-87.8-15.1zM26.3 423.8c-1.6 2.7-3.3 5.4-5.1 8.1l-.3 .5c-1.6 2.3-3.2 4.6-4.8 6.9c-3.5 4.7-7.3 9.3-11.3 13.5c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c5.1 0 10.2-.3 15.3-.8l.7-.1c4.4-.5 8.8-1.1 13.2-1.9c.8-.1 1.6-.3 2.4-.5c17.8-3.5 34.9-9.5 50.1-16.1c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9zM152 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
  },
  Va = {
    prefix: "far",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM184 72c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zm0 160c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
  },
  La = {
    prefix: "far",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M144 128v64H304V128c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zM48 256V448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16z"]
  },
  Pa = {
    prefix: "far",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M64 0a64 64 0 1 1 0 128A64 64 0 1 1 64 0zM48 336V448c0 8.8 7.2 16 16 16h48V304H48v16 16zM160 464h72V304H160V464zm120 0h72V304l-72 0V464zm-2.7-208H376l24 0 48 0c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V336 320 280 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8zM48 256l88 0h40l-51.2-38.4c-8.3-6.2-18.4-9.6-28.8-9.6c-26.5 0-48 21.5-48 48zm352 48V464h48c8.8 0 16-7.2 16-16V320c0-8.8-7.2-16-16-16H400zM272 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zm112 0v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  Oa = {
    prefix: "far",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M48 144V276.1C66.1 263.4 88.2 256 112 256H380c7 0 13.7 1 20 3V144c0-35.3-28.7-64-64-64H112c-35.3 0-64 28.7-64 64zM0 368V144C0 82.1 50.1 32 112 32H336c61.9 0 112 50.1 112 112V320h-.1c.1 1.3 .1 2.7 .1 4c0 37.6-30.4 68-68 68H120c-13.3 0-24-10.7-24-24s10.7-24 24-24H380c11 0 20-9 20-20s-9-20-20-20H112c-35.3 0-64 28.7-64 64s28.7 64 64 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H112C50.1 480 0 429.9 0 368z"]
  },
  Ta = {
    prefix: "far",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M144 160A80 80 0 1 0 144 0a80 80 0 1 0 0 160zm368 0A80 80 0 1 0 512 0a80 80 0 1 0 0 160zM0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7C47.8 192 0 239.8 0 298.7zM405.3 320H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96c.2 0 .4 0 .7 0zM320 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 80H378.7c39.8 0 73.2 27.2 82.6 64H178.7c9.5-36.8 42.9-64 82.6-64zm0-48C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"]
  },
  Da = {
    prefix: "far",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"]
  },
  Ra = {
    prefix: "far",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C98.1 144 48 194.1 48 256s50.1 112 112 112h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c61.9 0 112-50.1 112-112s-50.1-112-112-112H344c-13.3 0-24-10.7-24-24s10.7-24 24-24h72c88.4 0 160 71.6 160 160zM184 232H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  Ga = {
    prefix: "far",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M112 112c0 35.3-28.7 64-64 64V336c35.3 0 64 28.7 64 64H464c0-35.3 28.7-64 64-64V176c-35.3 0-64-28.7-64-64H112zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm288 32a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
  },
  Fa = {
    prefix: "far",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  ja = {
    prefix: "far",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M240 80V432H208V80h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 272V432H48V272H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-80h32V432H368V144zm-48 0V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
  },
  Ja = {
    prefix: "far",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216 16h64c26.5 0 48-21.5 48-48s-21.5-48-48-48H216v96zm64 48H216v40c0 13.3-10.7 24-24 24s-24-10.7-24-24V296 160c0-17.7 14.3-32 32-32h80c53 0 96 43 96 96s-43 96-96 96z"]
  },
  Za = {
    prefix: "far",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM400 64c-13.3 0-24 10.7-24 24s10.7 24 24 24H542.1L423 231c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8h88c35.3 0 64 28.7 64 64s-28.7 64-64 64H455.4c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2c6.4 38.6 39.8 66.8 78.9 66.8H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H497.9L617 105c6.9-6.9 8.9-17.2 5.2-26.2S609.7 64 600 64H400z"]
  },
  Wa = {
    prefix: "far",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4l0 0c55.9-14.3 119.4-30.6 185.3-28.7c4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9c-47-1.7-96.8 9.5-153.7 24c-4.5 1.1-9 2.3-13.5 3.5l0 0c-55.9 14.3-119.4 30.6-185.3 28.7C107.4 167.7 80.5 192 48 192V368c35.3 0 63.9 28.6 64 63.9c47 1.7 96.8-9.5 153.7-24zM0 421.5V113C0 88.8 25.4 72.7 48.4 79C128.2 101 208.1 80.6 288 60.3c86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34C447.8 411 367.9 431.4 288 451.7c-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z"]
  },
  Xa = {
    prefix: "far",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  Ua = {
    prefix: "far",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.6 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"]
  },
  Ka = {
    prefix: "far",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M336 448V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320c8.8 0 16-7.2 16-16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 215.6c11 0 20 9 20 20v10.1c7.2 1.1 14.2 2.5 20.6 4.1c10.7 2.5 17.4 13.3 14.9 24.1s-13.3 17.4-24.1 14.9c-11-2.6-21.8-4.5-31.7-4.7c-8.2-.1-16.7 1.6-22.4 4.6c-5.2 2.8-5.3 4.7-5.3 5.9c0 .4 0 .4 0 .4c0 0 0 0 0 0c.3 .4 1.4 1.6 4.4 3.2c6.5 3.5 15.8 6 28.6 9.5l.7 .2c11.2 3 25.4 6.8 36.8 13.2c12.4 7 25.2 19.2 25.4 39.3c.3 20.7-11.7 34.8-25.7 42.5c-6.9 3.8-14.6 6.3-22.3 7.8v10.1c0 11-9 20-20 20s-20-9-20-20V409.7c-10-1.9-19.3-4.8-27.5-7.3l0 0c-2.1-.7-4.2-1.3-6.1-1.9c-10.6-3.1-16.6-14.3-13.5-24.9s14.3-16.6 24.9-13.5c2.5 .7 4.9 1.5 7.2 2.2l0 0 0 0c13.6 4.1 24.2 7.3 35.7 7.7c8.9 .3 17.2-1.5 22.4-4.4c4.4-2.5 5.1-4.5 5-6.9l0-.1c0-.5 .2-2-5-4.8c-6.4-3.6-15.7-6.3-28.3-9.7l-1.7-.5c-10.9-2.9-24.5-6.6-35.4-12.4c-12.2-6.5-25.4-18.4-25.6-38.6c-.1-21 13.2-34.4 26.7-41.5c6.7-3.5 14-5.9 21.3-7.3V235.6c0-11 9-20 20-20zM96 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Ya = {
    prefix: "far",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M325.8 152.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104l13.8 48.3zM115.7 346.2L75.5 307l55.5-8.1c15.6-2.3 29.2-12.1 36.1-26.3l24.8-50.3 24.8 50.3c7 14.2 20.5 24 36.1 26.3l55.5 8.1-40.2 39.2c-11.3 11-16.4 26.9-13.8 42.4l9.5 55.4-49.5-26.1c-14-7.4-30.7-7.4-44.7 0L120 444l9.5-55.4c2.7-15.6-2.5-31.4-13.8-42.4zm54.7-188.8l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94c-8.8-17.9-34.3-17.9-43.1 0zm258.4 85.8l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z"]
  },
  qa = {
    prefix: "far",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M455.5 92.9L421.5 256H592V88c0-13.3 10.7-24 24-24s24 10.7 24 24V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V304H392c-7.2 0-14.1-3.3-18.6-8.9s-6.3-13-4.9-20l40-192c2.7-13 15.4-21.3 28.4-18.6s21.3 15.4 18.6 28.4zM24 64c13.3 0 24 10.7 24 24V224H272V88c0-13.3 10.7-24 24-24s24 10.7 24 24V248 424c0 13.3-10.7 24-24 24s-24-10.7-24-24V272H48V424c0 13.3-10.7 24-24 24s-24-10.7-24-24V248 88C0 74.7 10.7 64 24 64z"]
  },
  _a = {
    prefix: "far",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M39.9 185.7C114.6 119.9 212.6 80 320 80s205.4 39.9 280.1 105.7c9.9 8.8 25.1 7.8 33.9-2.2s7.8-25.1-2.2-33.9C548.7 76.4 439.5 32 320 32S91.3 76.4 8.2 149.6c-9.9 8.8-10.9 23.9-2.2 33.9s23.9 10.9 33.9 2.2zM320 256c64.6 0 123.5 24.7 167.6 65.2c9.8 9 24.9 8.3 33.9-1.5s8.3-24.9-1.5-33.9C467.4 237.5 397.1 208 320 208s-147.4 29.5-200.1 77.9c-9.8 9-10.4 24.1-1.5 33.9s24.1 10.4 33.9 1.5C196.5 280.7 255.4 256 320 256zm56 168a56 56 0 1 0 -112 0 56 56 0 1 0 112 0z"]
  },
  $a = {
    prefix: "far",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M101.3 48C89.5 48 80 57.5 80 69.3V256H432h48 8c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8H432 80 32 24c-13.3 0-24-10.7-24-24s10.7-24 24-24h8V69.3C32 31 63 0 101.3 0c18.4 0 36 7.3 49 20.3l4.8 4.8c11.1-5.8 23.7-9.1 37-9.1c23.9 0 45.4 10.5 60.1 27.2c9.2-5.3 21.1-4 28.9 3.9c9.4 9.4 9.4 24.6 0 33.9L177 185c-9.4 9.4-24.6 9.4-33.9 0c-7.8-7.8-9.1-19.7-3.9-28.9C122.5 141.4 112 119.9 112 96c0-13.4 3.3-25.9 9.1-37l-4.8-4.8c-4-4-9.4-6.2-15-6.2zM32 336H80v32c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V336h48v32c0 28.4-12.4 54-32 71.6V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V462.7c-5.2 .9-10.5 1.3-16 1.3H128c-5.5 0-10.8-.5-16-1.3V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V439.6C44.4 422 32 396.4 32 368V336zM192 64c-17.7 0-32 14.3-32 32c0 10.4 4.9 19.6 12.6 25.5l44.8-44.8C211.6 68.9 202.4 64 192 64z"]
  },
  ec = {
    prefix: "far",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M16 56c0-13.3 10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H112V224c0 61.9 50.1 112 112 112s112-50.1 112-112V80H312c-13.3 0-24-10.7-24-24s10.7-24 24-24h96c13.3 0 24 10.7 24 24s-10.7 24-24 24H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V80H40C26.7 80 16 69.3 16 56zM0 456c0-13.3 10.7-24 24-24H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
  },
  tc = {
    prefix: "far",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 56C0 42.7 10.7 32 24 32H72 88 212c68.5 0 124 55.5 124 124c0 34.7-14.3 66.2-37.3 88.7C339.7 264.9 368 307.1 368 356c0 68.5-55.5 124-124 124H88 72 24c-13.3 0-24-10.7-24-24s10.7-24 24-24H48V256 80H24C10.7 80 0 69.3 0 56zM212 232c42 0 76-34 76-76s-34-76-76-76H96V232H212zM96 280V432H244c42 0 76-34 76-76s-34-76-76-76H212 96z"]
  },
  nc = {
    prefix: "far",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l208 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-208 0c-13.3 0-24-10.7-24-24zm24 72H296c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  rc = {
    prefix: "far",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM152 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z"]
  },
  oc = {
    prefix: "far",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]
  },
  ic = {
    prefix: "far",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M140.8 122.9C171.7 96.2 212 80 256 80c97.2 0 176 78.8 176 176s-78.8 176-176 176c-39.7 0-76.2-13.1-105.6-35.2c-10.6-8-25.6-5.8-33.6 4.8s-5.8 25.6 4.8 33.6C159 463.3 205.6 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-57.3 0-109.6 21.5-149.2 56.9L76.3 58.3C69.7 51.7 60.7 48 51.3 48C31.8 48 16 63.8 16 83.3V200c0 13.3 10.7 24 24 24H156.7c19.5 0 35.3-15.8 35.3-35.3c0-9.4-3.7-18.3-10.3-25l-40.8-40.8zm-76.8-9L126.1 176H64V113.9z"]
  },
  ac = {
    prefix: "far",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L471.2 344H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H409.9L307.9 216H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H246.6L144.6 88H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-9 0-16.9 5-21 12.3L38.8 5.1zM152.3 216l-50.4-39.7C98.2 180.5 96 186 96 192c0 13.3 10.7 24 24 24h32.3zM314.8 344l-60.9-48H120c-13.3 0-24 10.7-24 24s10.7 24 24 24H314.8zM120 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H477.2l-60.9-48H120z"]
  },
  cc = {
    prefix: "far",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"]
  },
  sc = cc,
  lc = {
    prefix: "far",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M178.7 122.2c11.2-6.5 19.3-17.2 22.5-29.8l5.3-20.9 15 15.5c9 9.3 21.4 14.5 34.4 14.5s25.4-5.2 34.4-14.5l15-15.5 5.3 20.9c3.2 12.6 11.3 23.3 22.5 29.8s24.6 8.1 37 4.6l20.8-5.9-5.9 20.8c-3.5 12.5-1.9 25.8 4.6 37s17.2 19.3 29.8 22.5l20.9 5.3-15.5 15c-9.3 9-14.5 21.4-14.5 34.4s5.2 25.4 14.5 34.4l15.5 15-20.9 5.3c-12.6 3.2-23.3 11.3-29.8 22.5s-8.1 24.6-4.6 37l5.9 20.8-20.8-5.9c-12.5-3.5-25.8-1.9-37 4.6s-19.3 17.2-22.5 29.8l-5.3 20.9-15-15.5c-9-9.3-21.4-14.5-34.4-14.5s-25.4 5.2-34.4 14.5l-15 15.5-5.3-20.9c-3.2-12.6-11.3-23.3-22.5-29.8s-24.6-8.1-37-4.6l-20.8 5.9 5.9-20.8c3.5-12.5 1.9-25.8-4.6-37s-17.2-19.3-29.8-22.5l-20.9-5.3 15.5-15c9.3-9 14.5-21.4 14.5-34.4s-5.2-25.4-14.5-34.4l-15.5-15 20.9-5.3c12.6-3.2 23.3-11.3 29.8-22.5s8.1-24.6 4.6-37l-5.9-20.8 20.8 5.9c12.5 3.5 25.8 1.9 37.1-4.6zM222.5 19.1L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-4 15.9L154.7 80.6 108.5 67.5 92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l4.5 15.8 13.1 46.2L34.1 166.5l-15.9 4c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l11.8 11.5L53.5 256 19.1 289.5 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l15.9 4 46.5 11.8L67.5 403.5l-4.5 15.8c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l15.8-4.5 46.2-13.1 11.8 46.5 4 15.9c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L222.5 493 256 458.5 289.5 493 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l4-15.9 11.8-46.5 46.2 13.1 15.8 4.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-4.5-15.8-13.1-46.2 46.5-11.8 15.9-4c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L493 289.5 458.5 256 493 222.5 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-15.9-4-46.5-11.8 13.1-46.2 4.5-15.8c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-15.8 4.5L357.3 80.6 345.5 34.1l-4-15.9c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L289.5 19.1 256 53.5 222.5 19.1z"]
  },
  uc = {
    prefix: "far",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-281.9-221L396.4 80H521.3l-8.5 34.2c-3.2 12.9 4.6 25.9 17.5 29.1s25.9-4.6 29.1-17.5l11-44.1C576.6 56.5 557.5 32 531.5 32h-335c-18.4 0-34.4 12.5-38.8 30.3l-7.5 30.1L38.8 5.1zM191.5 124.8L202.7 80H346.5L308.1 216.2 191.5 124.8zm57.4 300.7l-1.8 6.5H192c-13.3 0-24 10.7-24 24s10.7 24 24 24H352c13.3 0 24-10.7 24-24s-10.7-24-24-24H296.9l23.6-83.5-40.8-32.1L248.9 425.5z"]
  },
  dc = {
    prefix: "far",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm55 241.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l25-83.4 25 83.4c3 10.2 12.4 17.1 23 17.1s19.9-7 23-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-25 83.4-25-83.4c-3-10.2-12.4-17.1-23-17.1s-19.9 7-23 17.1l-25 83.4-25-83.4z"]
  },
  fc = {
    prefix: "far",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"]
  },
  pc = {
    prefix: "far",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 56c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H291.3L144.7 432H232c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H92.7L239.3 80H152c-13.3 0-24-10.7-24-24z"]
  },
  mc = {
    prefix: "far",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M80.7 253.2c14.3 15 17.3 37.6 7.5 55.8c-1.1 2-2.2 4-3.2 5.9c-2.5 4.5-5.2 9-7.9 13.6c17.1-4.5 33.9-10.7 49.9-18c4.3-1.9 8.5-3.9 12.6-6c9.5-4.8 20.3-6.2 30.7-4.2c12.1 2.4 24.8 3.6 37.8 3.6c96.2 0 160-64.5 160-128s-63.8-128-160-128S48 112.5 48 176c0 28 11.4 54.9 32.7 77.2zM416 176c0 97.2-93.1 176-208 176c-16.2 0-31.9-1.6-47.1-4.5c-4.6 2.3-9.4 4.6-14.2 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.8-2-19 4.6-25.9c14.2-15.6 26.2-33.7 36.6-52.1c.9-1.7 1.9-3.4 2.8-5.1C17.2 256.1 0 217.8 0 176C0 78.8 93.1 0 208 0S416 78.8 416 176zM245.2 381.5c17.2-2.4 34-6.3 50-11.8C322 405.5 370.3 432 432 432c13.1 0 25.8-1.3 37.8-3.6c10.4-2 21.2-.6 30.7 4.2c4.1 2.1 8.3 4.1 12.6 6c16 7.2 32.9 13.5 49.9 18c-2.8-4.6-5.4-9.1-7.9-13.6c-1.1-1.9-2.2-3.9-3.2-5.9c-9.8-18.3-6.8-40.8 7.5-55.8C580.6 358.9 592 332 592 304c0-59.9-56.8-120.7-144-127.4l0-.6c0-16.6-2.2-32.6-6.2-47.8C552.1 132.5 640 209.6 640 304c0 41.8-17.2 80.1-45.9 110.3c.9 1.7 1.9 3.5 2.8 5.1c10.3 18.4 22.3 36.5 36.6 52.1c6.6 7 8.3 17.2 4.6 25.9c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.8-2.2-9.6-4.5-14.2-6.8c-15.1 3-30.9 4.5-47.1 4.5c-82 0-153-40.2-186.8-98.5zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  hc = {
    prefix: "far",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M70.6 176H249.4L160 86.6 70.6 176zm112-134.6l128 128c9.2 9.2 11.9 22.9 6.9 34.9s-16.6 19.8-29.6 19.8H32c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9l128-128c12.5-12.5 32.8-12.5 45.3 0zM70.6 336L160 425.4 249.4 336H70.6zm112 134.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z"]
  },
  Ac = {
    prefix: "far",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM216 72H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 160H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  gc = {
    prefix: "far",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm120-72v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72-88c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24zM480 88V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  vc = {
    prefix: "far",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M256 55.8L289.5 96h-67L256 55.8zM229.8 12.3L168.2 86.2c-5.3 6.3-8.2 14.3-8.2 22.6c0 19.5 15.8 35.2 35.2 35.2H232v88H144V195.2c0-19.5-15.8-35.2-35.2-35.2c-8.2 0-16.2 2.9-22.6 8.2L12.3 229.8C4.5 236.2 0 245.9 0 256s4.5 19.8 12.3 26.2l73.9 61.6c6.3 5.3 14.3 8.2 22.6 8.2c19.5 0 35.2-15.8 35.2-35.2V280h88v88H195.2c-19.5 0-35.2 15.8-35.2 35.2c0 8.2 2.9 16.2 8.2 22.6l61.6 73.9c6.5 7.8 16.1 12.3 26.2 12.3s19.8-4.5 26.2-12.3l61.6-73.9c5.3-6.3 8.2-14.3 8.2-22.6c0-19.5-15.8-35.2-35.2-35.2H280V280h88v36.8c0 19.5 15.8 35.2 35.2 35.2c8.2 0 16.2-2.9 22.6-8.2l73.9-61.6c7.8-6.5 12.3-16.1 12.3-26.2s-4.5-19.8-12.3-26.2l-73.9-61.6c-6.3-5.3-14.3-8.2-22.6-8.2c-19.5 0-35.2 15.8-35.2 35.2V232H280V144h36.8c19.5 0 35.2-15.8 35.2-35.2c0-8.2-2.9-16.2-8.2-22.6L282.2 12.3C275.8 4.5 266.1 0 256 0s-19.8 4.5-26.2 12.3zM256 456.2L222.5 416h67L256 456.2zM456.2 256L416 289.5v-67L456.2 256zM96 289.5L55.8 256 96 222.5v67z"]
  },
  Cc = {
    prefix: "far",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M341.5 13.5C337.5 5.2 329.1 0 319.9 0s-17.6 5.2-21.6 13.5L229.7 154.8 76.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L174.2 328.4 148 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L465.6 328.4 576.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L410.1 154.8 341.5 13.5zM320 384.7V79.1l52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L423 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L331.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"]
  },
  bc = {
    prefix: "far",
    iconName: "code",
    icon: [640, 512, [], "f121", "M399.1 1.1c-12.7-3.9-26.1 3.1-30 15.8l-144 464c-3.9 12.7 3.1 26.1 15.8 30s26.1-3.1 30-15.8l144-464c3.9-12.7-3.1-26.1-15.8-30zm71.4 118.5c-9.1 9.7-8.6 24.9 1.1 33.9L580.9 256 471.6 358.5c-9.7 9.1-10.2 24.3-1.1 33.9s24.3 10.2 33.9 1.1l128-120c4.8-4.5 7.6-10.9 7.6-17.5s-2.7-13-7.6-17.5l-128-120c-9.7-9.1-24.9-8.6-33.9 1.1zm-301 0c-9.1-9.7-24.3-10.2-33.9-1.1l-128 120C2.7 243 0 249.4 0 256s2.7 13 7.6 17.5l128 120c9.7 9.1 24.9 8.6 33.9-1.1s8.6-24.9-1.1-33.9L59.1 256 168.4 153.5c9.7-9.1 10.2-24.3 1.1-33.9z"]
  },
  Ec = {
    prefix: "far",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M24 0C37.3 0 48 10.7 48 24V160H256V40c0-22.1 17.9-40 40-40H456c66.3 0 120 53.7 120 120v64 96V439.7 488c0 13.3-10.7 24-24 24s-24-10.7-24-24V463.7H280 48V488c0 13.3-10.7 24-24 24s-24-10.7-24-24V439.7 184 24C0 10.7 10.7 0 24 0zM256 415.7V296c0-22.1 17.9-40 40-40H528V208H280 48V415.7H256zM528 160V120c0-39.8-32.2-72-72-72H304V160H528zm0 144H304V415.7H528V304zM96 328a56 56 0 1 1 112 0A56 56 0 1 1 96 328zM152 16a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
  },
  yc = {
    prefix: "far",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M77 48L51.4 240H208c7.4 0 14.4 3.4 18.9 9.2s6.2 13.4 4.4 20.6l-23 91.8L322.8 192H176c-7.9 0-15.3-3.9-19.8-10.4s-5.4-14.9-2.6-22.2L196.9 48H77zM30.4 34.7C33 14.8 50 0 70 0H208.6c28.1 0 47.5 28.3 37.3 54.5L211.1 144H337.9c32.1 0 51.1 35.8 33.2 62.4l-199.2 295c-6.5 9.7-19 13.2-29.7 8.5s-16.3-16.4-13.5-27.7L177.3 288H42.3C18.1 288-.6 266.7 2.6 242.7l27.7-208z"]
  },
  Ic = {
    prefix: "far",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M48 448V64c0-8.8 7.2-16 16-16H224v80c0 17.7 14.3 32 32 32h80V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V154.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0H64zm90.9 233.3c-8.1-10.5-23.2-12.3-33.7-4.2s-12.3 23.2-4.2 33.7L161.6 320l-44.5 57.3c-8.1 10.5-6.3 25.5 4.2 33.7s25.5 6.3 33.7-4.2L192 359.1l37.1 47.6c8.1 10.5 23.2 12.3 33.7 4.2s12.3-23.2 4.2-33.7L222.4 320l44.5-57.3c8.1-10.5 6.3-25.5-4.2-33.7s-25.5-6.3-33.7 4.2L192 280.9l-37.1-47.6z"]
  },
  Bc = {
    prefix: "far",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  xc = {
    prefix: "far",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M240 144A96 96 0 1 0 48 144a96 96 0 1 0 192 0zm46 24c-11.4 68.1-70.7 120-142 120C64.5 288 0 223.5 0 144S64.5 0 144 0c71.4 0 130.6 51.9 142 120h66.7c3.8-22.7 23.6-40 47.3-40h96c26.5 0 48 21.5 48 48v32c0 26.5-21.5 48-48 48H400c-23.8 0-43.5-17.3-47.3-40H286zM80 144a64 64 0 1 1 128 0A64 64 0 1 1 80 144zM376 264c0-13.3 10.7-24 24-24s24 10.7 24 24v8h40 56c13.3 0 24 10.7 24 24s-10.7 24-24 24h-8V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320h-8c-13.3 0-24-10.7-24-24s10.7-24 24-24h56 40v-8zm-40 56V464H464V320H336zM32 336c0-8.8 7.2-16 16-16h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm128 48h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32zM0 488c0-13.3 10.7-24 24-24H200c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24zM400 128v32h96V128H400z"]
  },
  wc = {
    prefix: "far",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 48c44.2 0 80 35.8 80 80v64H144V128c0-44.2 35.8-80 80-80zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16zm184 80c0-13.3-10.7-24-24-24s-24 10.7-24 24v64c0 13.3 10.7 24 24 24s24-10.7 24-24V320z"]
  },
  Qc = {
    prefix: "far",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M352 128c0-44.2 35.8-80 80-80s80 35.8 80 80v72c0 13.3 10.7 24 24 24s24-10.7 24-24V128C560 57.3 502.7 0 432 0S304 57.3 304 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128zM64 240H384c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16z"]
  },
  Hc = {
    prefix: "far",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  zc = {
    prefix: "far",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M6.5 271.6c-8.7 9.2-8.7 23.7 0 32.9l121.4 129c8.8 9.3 21 14.6 33.7 14.6c25.6 0 46.3-20.7 46.3-46.3l0-41.7 144 0c88.4 0 160-71.6 160-160l0-112c0-30.9-25.1-56-56-56l-32 0c-30.9 0-56 25.1-56 56l0 120c0 4.4-3.6 8-8 8l-152 0 0-41.7c0-25.6-20.7-46.3-46.3-46.3c-12.8 0-25 5.3-33.7 14.6L6.5 271.6zm153.5-93l0 61.5c0 13.3 10.7 24 24 24l176 0c30.9 0 56-25.1 56-56l0-120c0-4.4 3.6-8 8-8l32 0c4.4 0 8 3.6 8 8l0 112c0 61.9-50.1 112-112 112l-168 0c-13.3 0-24 10.7-24 24l0 61.5L57 288 160 178.5z"]
  },
  Mc = {
    prefix: "far",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm169.8-90.7c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  kc = {
    prefix: "far",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
  },
  Nc = {
    prefix: "far",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"]
  },
  Sc = {
    prefix: "far",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c13.3 0 24 10.7 24 24v88c0 36.4 11.8 71.7 33.6 100.8l19.2 25.6c28 37.4 43.2 82.9 43.2 129.6v56c0 13.3-10.7 24-24 24s-24-10.7-24-24V400c0-36.3-11.8-71.7-33.6-100.8l-19.2-25.6C167.2 236.2 152 190.7 152 144V56c0-13.3 10.7-24 24-24zM24 96c13.3 0 24 10.7 24 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V418.1c0-33.2-9.8-65.6-28.2-93.2L36.3 277.7C12.6 242.2 0 200.5 0 157.9V120c0-13.3 10.7-24 24-24zm328 24v37.9c0 33.2 9.8 65.6 28.2 93.2l31.5 47.3c23.7 35.5 36.3 77.2 36.3 119.8V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V418.1c0-33.2-9.8-65.6-28.2-93.2l-31.5-47.3C316.6 242.2 304 200.5 304 157.9V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  Vc = {
    prefix: "far",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"]
  },
  Lc = {
    prefix: "far",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0s0 0 0 0"]
  },
  Pc = {
    prefix: "far",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M88 80c-22.1 0-40 17.9-40 40v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V120C0 71.4 39.4 32 88 32h34.4H192 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L103.1 80H88zm296.8 80l35.6-80H192 155.6l35.6 80H384.8zm1.2 48H190c-41.8 21.6-71.7 63.1-77.1 112H463.1c-5.4-48.9-35.3-90.4-77.1-112zm32.2 224H157.7c.1 0 .1 0 .2 0H418c.1 0 .1 0 .2 0z"]
  },
  Oc = {
    prefix: "far",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M177.1 48h93.7c2.7 0 5.2 1.3 6.7 3.6l19 28.4h-145l19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0H177.1c-18.7 0-36.2 9.4-46.6 24.9L93.8 80H80.1 32 24C10.7 80 0 90.7 0 104s10.7 24 24 24H35.6L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3H324.6c33.5 0 61.3-25.9 63.8-59.3L412.4 128H424c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8H367.9 354.2zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8H123.4c-8.4 0-15.3-6.5-16-14.8L83.7 128H364.3z"]
  },
  Tc = {
    prefix: "far",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M7.4 273.4C2.7 268.8 0 262.6 0 256s2.7-12.8 7.4-17.4l176-168c9.6-9.2 24.8-8.8 33.9 .8s8.8 24.8-.8 33.9L83.9 232 424 232c13.3 0 24 10.7 24 24s-10.7 24-24 24L83.9 280 216.6 406.6c9.6 9.2 9.9 24.3 .8 33.9s-24.3 9.9-33.9 .8l-176-168z"]
  },
  Dc = {
    prefix: "far",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M24 40C10.7 40 0 50.7 0 64S10.7 88 24 88H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm0 128c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM0 320c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H24c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  Rc = {
    prefix: "far",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM80 288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v16l44.9-29.9c2-1.3 4.4-2.1 6.8-2.1c6.8 0 12.3 5.5 12.3 12.3V387.7c0 6.8-5.5 12.3-12.3 12.3c-2.4 0-4.8-.7-6.8-2.1L240 368v16c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V288z"]
  },
  Gc = {
    prefix: "far",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"]
  },
  Fc = {
    prefix: "far",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M64 464H96v48H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V288H336V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
  },
  jc = {
    prefix: "far",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 336H424c22 0 41.2 15 46.6 36.4l3.6 14.3c6.7 26.6 30.6 45.3 58 45.3c33 0 59.8-26.8 59.8-59.8v-2.8c0-3.5-.3-7.1-.9-10.6L558.4 168c-6.2-36-27.8-60.4-54.6-67.1C461.4 90.3 399.7 80 320 80s-141.5 10.3-183.7 20.9C109.4 107.6 87.8 132 81.6 168L48.9 358.8c-.6 3.5-.9 7-.9 10.6v2.8c0 33 26.8 59.8 59.8 59.8c27.4 0 51.4-18.7 58-45.3l3.6-14.3C174.8 351 194 336 216 336zm211.6 62.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM232 168v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H232v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H152c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
  },
  Jc = {
    prefix: "far",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H520c48.6 0 88 39.4 88 88v40c0 22.5-15.5 41.4-36.4 46.6l53.1 41.7c9.7 7.6 15.3 19.2 15.3 31.5V376c0 22.1-17.9 40-40 40H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H408 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7 .9-13.7 2.6-20.1c-1.3-.8-2.4-1.8-3.5-2.9L21.1 335C7.6 321.5 0 303.2 0 284.1V104C0 64.2 32.2 32 72 32H224V24zM72 80c-13.3 0-24 10.7-24 24V284.1c0 6.4 2.5 12.5 7 17L121.9 368H128c13.4-10 30-16 48-16s34.6 6 48 16H384V256 184c0-13.3 10.7-24 24-24h16 80 56V120c0-22.1-17.9-40-40-40H72zM556.8 256l-61.1-48H432v48H556.8zM208 432a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm320 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM120 128H264c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24z"]
  },
  Zc = {
    prefix: "far",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M384 48c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM314.6 319.7c-3.5 .2-7 .3-10.6 .3c-32 0-56-16-80-32s-48-32-80-32c-3.5 0-7.1 .2-10.7 .4C146.4 218.9 182 192 224 192c53 0 96 43 96 96c0 11.1-1.9 21.8-5.4 31.7zM368 288A144 144 0 1 0 80 288a144 144 0 1 0 288 0z"]
  },
  Wc = {
    prefix: "far",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 112c-8.8 0-16 7.2-16 16v22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1V128c0-8.8-7.2-16-16-16H64zM48 212.2V384c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V212.2L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
  },
  Xc = {
    prefix: "far",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M375 73c-26-26-68.1-26-94.1 0L89 265C45.3 308.6 45.3 379.4 89 423s114.4 43.6 158.1 0L399 271c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L281 457c-62.4 62.4-163.5 62.4-225.9 0S-7.4 293.4 55 231L247 39C291.7-5.7 364.2-5.7 409 39s44.7 117.2 0 161.9L225.2 384.7c-31.6 31.6-83.6 28.7-111.5-6.2c-23.8-29.8-21.5-72.8 5.5-99.8L271 127c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L153.2 312.7c-9.7 9.7-10.6 25.1-2 35.8c10 12.5 28.7 13.6 40 2.2L375 167c26-26 26-68.1 0-94.1z"]
  },
  Uc = {
    prefix: "far",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM519 69.3c-10.3-8.3-25.5-6.6-33.7 3.7l-98 122.5C364.4 224 352 259.5 352 296h.2c-.1 2.6-.2 5.3-.2 8c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-6.8 0-13.4 .5-20 1.4L522.7 103c8.3-10.4 6.6-25.5-3.8-33.7zM496 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]
  },
  Kc = {
    prefix: "far",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  Yc = {
    prefix: "far",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM128 136c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zm88 72H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm160 96h80c13.3 0 24 10.7 24 24s-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  qc = {
    prefix: "far",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"]
  },
  _c = {
    prefix: "far",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M256 0c17 0 33.6 1.7 49.8 4.8c7.9 1.5 21.8 6.1 29.4 20.1c2 3.7 3.6 7.6 4.6 11.8l9.3 38.5C350.5 81 360.3 86.7 366 85l38-11.2c4-1.2 8.1-1.8 12.2-1.9c16.1-.5 27 9.4 32.3 15.4c22.1 25.1 39.1 54.6 49.9 86.3c2.6 7.6 5.6 21.8-2.7 35.4c-2.2 3.6-4.9 7-8 10L459 246.3c-4.2 4-4.2 15.5 0 19.5l28.7 27.3c3.1 3 5.8 6.4 8 10c8.2 13.6 5.2 27.8 2.7 35.4c-10.8 31.7-27.8 61.1-49.9 86.3c-5.3 6-16.3 15.9-32.3 15.4c-4.1-.1-8.2-.8-12.2-1.9L366 427c-5.7-1.7-15.5 4-16.9 9.8l-9.3 38.5c-1 4.2-2.6 8.2-4.6 11.8c-7.7 14-21.6 18.5-29.4 20.1C289.6 510.3 273 512 256 512s-33.6-1.7-49.8-4.8c-7.9-1.5-21.8-6.1-29.4-20.1c-2-3.7-3.6-7.6-4.6-11.8l-9.3-38.5c-1.4-5.8-11.2-11.5-16.9-9.8l-38 11.2c-4 1.2-8.1 1.8-12.2 1.9c-16.1 .5-27-9.4-32.3-15.4c-22-25.1-39.1-54.6-49.9-86.3c-2.6-7.6-5.6-21.8 2.7-35.4c2.2-3.6 4.9-7 8-10L53 265.7c4.2-4 4.2-15.5 0-19.5L24.2 218.9c-3.1-3-5.8-6.4-8-10C8 195.3 11 181.1 13.6 173.6c10.8-31.7 27.8-61.1 49.9-86.3c5.3-6 16.3-15.9 32.3-15.4c4.1 .1 8.2 .8 12.2 1.9L146 85c5.7 1.7 15.5-4 16.9-9.8l9.3-38.5c1-4.2 2.6-8.2 4.6-11.8c7.7-14 21.6-18.5 29.4-20.1C222.4 1.7 239 0 256 0zM218.1 51.4l-8.5 35.1c-7.8 32.3-45.3 53.9-77.2 44.6L97.9 120.9c-16.5 19.3-29.5 41.7-38 65.7l26.2 24.9c24 22.8 24 66.2 0 89L59.9 325.4c8.5 24 21.5 46.4 38 65.7l34.6-10.2c31.8-9.4 69.4 12.3 77.2 44.6l8.5 35.1c24.6 4.5 51.3 4.5 75.9 0l8.5-35.1c7.8-32.3 45.3-53.9 77.2-44.6l34.6 10.2c16.5-19.3 29.5-41.7 38-65.7l-26.2-24.9c-24-22.8-24-66.2 0-89l26.2-24.9c-8.5-24-21.5-46.4-38-65.7l-34.6 10.2c-31.8 9.4-69.4-12.3-77.2-44.6l-8.5-35.1c-24.6-4.5-51.3-4.5-75.9 0zM208 256a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 96a96 96 0 1 1 0-192 96 96 0 1 1 0 192z"]
  },
  $c = {
    prefix: "far",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M48 448c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V368H48v80zm0-128H400V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V320zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM192 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H192c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  es = {
    prefix: "far",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c48.6 0 88-39.4 88-88l0-342.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40L24 464z"]
  },
  ts = {
    prefix: "far",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
  },
  ns = {
    prefix: "far",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M64 448c0 8.8 7.2 16 16 16H304c8.8 0 16-7.2 16-16V368H64v80zm0-128H320V64c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16V320zM16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM160 400h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H160c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  rs = {
    prefix: "far",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 13.3 10.7 24 24 24l59.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 440c13.3 0 24-10.7 24-24s-10.7-24-24-24l-251.7 0c-10.2-32.5-40.5-56-76.3-56s-66.1 23.5-76.3 56L24 392c-13.3 0-24 10.7-24 24zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-35.8 0-66.1 23.5-76.3 56L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l251.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56l59.7 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-59.7 0c-10.2-32.5-40.5-56-76.3-56zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm76.3-56C258.1 39.5 227.8 16 192 16s-66.1 23.5-76.3 56L24 72C10.7 72 0 82.7 0 96s10.7 24 24 24l91.7 0c10.2 32.5 40.5 56 76.3 56s66.1-23.5 76.3-56L488 120c13.3 0 24-10.7 24-24s-10.7-24-24-24L268.3 72z"]
  },
  is = {
    prefix: "far",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 368a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm0-160a48 48 0 1 0 0 96 48 48 0 1 0 0-96zM112 96A48 48 0 1 0 16 96a48 48 0 1 0 96 0z"]
  },
  as = {
    prefix: "far",
    iconName: "download",
    icon: [512, 512, [], "f019", "M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V294.1l-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95V24zM128.8 304H64c-35.3 0-64 28.7-64 64v80c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V368c0-35.3-28.7-64-64-64H383.2l-48 48H448c8.8 0 16 7.2 16 16v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16H176.8l-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  cs = {
    prefix: "far",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M352 48c26.5 0 48 21.5 48 48v64H48V96c0-26.5 21.5-48 48-48H352zm48 160V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V208H400zM96 0C43 0 0 43 0 96V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-53-43-96-96-96H96zm32 104a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm104-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm56 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM112 240c-17.7 0-32 14.3-32 32V400c0 17.7 14.3 32 32 32H336c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H112zm32 48H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  ss = {
    prefix: "far",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M120 40c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM24 168c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM96 320c0 13.3 10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zM24 424c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24z"]
  },
  ls = {
    prefix: "far",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V245.5l24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM112 432V204.8L288 55.5 464 204.8V432c0 17.7-14.3 32-32 32H384V312c0-22.1-17.9-40-40-40H232c-22.1 0-40 17.9-40 40V464H144c-17.7 0-32-14.3-32-32zm128 32V320h96V464H240z"]
  },
  us = {
    prefix: "far",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448V113.9z"]
  },
  ds = {
    prefix: "far",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M71.9 26.7c1.5-13.2-8-25-21.2-26.5s-25 8-26.5 21.2l-16 144L8 166.7V168v16c0 48.6 39.4 88 88 88h8V488c0 13.3 10.7 24 24 24s24-10.7 24-24V272h8c48.6 0 88-39.4 88-88V168v-1.3l-.1-1.3-16-144C230.4 8.2 218.5-1.3 205.3 .1s-22.7 13.3-21.2 26.5L200 169.3V184c0 22.1-17.9 40-40 40H128 96c-22.1 0-40-17.9-40-40V169.3L71.9 26.7zM152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V168c0 13.3 10.7 24 24 24s24-10.7 24-24V24zM336 176c0-57.7 21.7-88.6 41.4-105.7c7.7-6.6 15.5-11.6 22.6-15.2V248v56H352c-8.8 0-16-7.2-16-16V176zm64 176V488c0 13.3 10.7 24 24 24s24-10.7 24-24V352 304 248 32c0-17.7-14.3-32-32-32C400 0 288 32 288 176V288c0 35.3 28.7 64 64 64h48z"]
  },
  fs = {
    prefix: "far",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M24 72C10.7 72 0 82.7 0 96s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zM152 232c-13.3 0-24 10.7-24 24s10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zM128 416c0 13.3 10.7 24 24 24H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H152c-13.3 0-24 10.7-24 24zM0 424c0 13.3 10.7 24 24 24s24-10.7 24-24l0-176c0-13.3-10.7-24-24-24s-24 10.7-24 24V424z"]
  },
  ps = {
    prefix: "far",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M280 360c0 13.3-10.7 24-24 24s-24-10.7-24-24V81.9l-95 95c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 7c9.4-9.4 24.6-9.4 33.9 0L409 143c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-95-95V360zm32-8V304H448c35.3 0 64 28.7 64 64v80c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V368c0-35.3 28.7-64 64-64H200v48H64c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16H312zm72 56a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  ms = {
    prefix: "far",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M321.7 0c19.1 0 32.9 18.3 27.6 36.6L295.8 224h85.2c19.3 0 34.9 15.6 34.9 34.9c0 10.3-4.5 20-12.3 26.6L144.9 505.2c-5.2 4.4-11.8 6.8-18.6 6.8c-19.1 0-32.9-18.3-27.6-36.6L152.2 288H65.7C47.1 288 32 272.9 32 254.3c0-9.9 4.3-19.2 11.8-25.6L303.1 6.9C308.3 2.4 314.9 0 321.7 0zM285.6 85L104.4 240H184c7.5 0 14.6 3.5 19.2 9.5s6 13.8 3.9 21L162.3 427.5 345.5 272H264c-7.5 0-14.6-3.5-19.2-9.5s-6-13.8-3.9-21L285.6 85z"]
  },
  hs = {
    prefix: "far",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M0 24C0 37.3 10.7 48 24 48H56 392h32c13.3 0 24-10.7 24-24s-10.7-24-24-24H392 56 24C10.7 0 0 10.7 0 24zM81.6 182.9l-1.6 .5V80H32V207.1l-.4 .4C17.5 219.4 8 235.7 8 256c0 72.7 33.4 120.2 78.4 148.3c1.7 1.1 3.5 2.1 5.2 3.2L69.3 448.2c-3.5 6.3-5.3 13.5-5.3 20.7c0 23.8 19.3 43.1 43.1 43.1H340.9c23.8 0 43.1-19.3 43.1-43.1c0-7.2-1.8-14.4-5.3-20.7l-22.3-40.7c1.8-1 3.5-2.1 5.2-3.2c45-28.1 78.4-75.6 78.4-148.3c0-20.3-9.5-36.6-23.6-48.5l-.4-.4V80H368V183.4l-1.6-.5C328.4 172 277.7 168 224 168s-104.4 4-142.4 14.9zM373.8 326.8c-9.8 15.7-22.9 27.6-37.6 36.9C303 384.4 259.9 392 224 392s-79-7.6-112.2-28.3c-14.7-9.2-27.8-21.2-37.6-36.9c2.4 .8 4.9 1.5 7.4 2.3C119.6 340 170.3 344 224 344s104.4-4 142.4-14.9c2.5-.7 4.9-1.5 7.4-2.3zM56 256c0-3.7 1.2-7.4 6.6-12c6.1-5.1 16.5-10.4 32.3-15C126.3 220 171.6 216 224 216s97.7 4 129.1 13.1c15.8 4.5 26.2 9.8 32.2 15c5.4 4.6 6.6 8.2 6.6 12s-1.2 7.4-6.6 12c-6.1 5.1-16.5 10.4-32.2 15C321.7 292 276.4 296 224 296s-97.7-4-129.1-13.1c-15.8-4.5-26.2-9.8-32.3-15c-5.4-4.6-6.6-8.2-6.6-12zM312.3 426.8L332.6 464H115.4l20.4-37.2c30.5 9.7 61.8 13.2 88.3 13.2s57.7-3.5 88.3-13.2zM128 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h48c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]
  },
  As = {
    prefix: "far",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 48c-8.8 0-16 7.2-16 16V192c0 8.8 7.2 16 16 16H512c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm120 64H456c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24zM368 288V392c0 22.1 17.9 40 40 40s40-17.9 40-40c0-14.8-8-27.7-20-34.7c-11.5-6.6-15.4-21.3-8.7-32.8s21.3-15.4 32.8-8.7C478.3 331 496 359.4 496 392c0 48.6-39.4 88-88 88s-88-39.4-88-88V288h48zM208 424V288h48V424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-32.6 17.7-61 43.9-76.2c11.5-6.6 26.2-2.7 32.8 8.7s2.7 26.2-8.7 32.8c-12 7-20 19.9-20 34.7c0 22.1 17.9 40 40 40s40-17.9 40-40z"]
  },
  gs = {
    prefix: "far",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"]
  },
  vs = {
    prefix: "far",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M505 273c9.4-9.4 9.4-24.6 0-33.9L369 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l95 95L24 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l406.1 0-95 95c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L505 273z"]
  },
  Cs = {
    prefix: "far",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M432 256a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-160 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 304a48 48 0 1 1 0-96 48 48 0 1 1 0 96z"]
  },
  bs = {
    prefix: "far",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M176 80H80v96h96V80zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 304H80v96h96V336zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 80v96h96V80H336zm-48 0c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c13.3 0 24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H408v64c0 13.3-10.7 24-24 24s-24-10.7-24-24V408H296c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V296c0-13.3 10.7-24 24-24z"]
  },
  Es = {
    prefix: "far",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M256 0c53 0 96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96c0-53 43-96 96-96zM39 103c9.4-9.4 24.6-9.4 33.9 0l72.4 72.4C161.3 165.7 180 160 200 160H312c20 0 38.7 5.7 54.6 15.5L439 103c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-72.4 72.4C410.3 225.3 416 244 416 264h72c13.3 0 24 10.7 24 24s-10.7 24-24 24H416v8c0 27.2-6.8 52.8-18.8 75.3L473 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-70.9-70.9C339.3 462.5 299.7 480 256 480s-83.3-17.5-112.2-45.9L73 505c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l75.8-75.8C102.8 372.8 96 347.2 96 320v-8H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H96c0-20 5.7-38.7 15.5-54.6L39 137c-9.4-9.4-9.4-24.6 0-33.9zM144 264v56c0 53.6 37.7 98.4 88 109.4V280c0-13.3 10.7-24 24-24s24 10.7 24 24V429.4c50.3-11 88-55.8 88-109.4V264c0-30.9-25.1-56-56-56H200c-30.9 0-56 25.1-56 56z"]
  },
  ys = {
    prefix: "far",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M512 80c8.8 0 16 7.2 16 16v32H48V96c0-8.8 7.2-16 16-16H512zm16 144V416c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V224H528zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24h48c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H248z"]
  },
  Is = {
    prefix: "far",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M208 416c0-26.5-21.5-48-48-48H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H309.3c-10.4 0-20.5 3.4-28.8 9.6L208 432V416zm-.2 76.2l.2-.2 101.3-76H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 496l5.1-3.8zM144 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm144-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm80 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  Bs = {
    prefix: "far",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V360v96c0 13.3 10.7 24 24 24s24-10.7 24-24V384H312 592v80c0 13.3 10.7 24 24 24s24-10.7 24-24V360 248c0-66.3-53.7-120-120-120H344c-30.9 0-56 25.1-56 56V336H48V56zM592 248v88H336V184c0-4.4 3.6-8 8-8H520c39.8 0 72 32.2 72 72zM128 216a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm128 0A88 88 0 1 0 80 216a88 88 0 1 0 176 0z"]
  },
  xs = {
    prefix: "far",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M224 0c-17.7 0-32 14.3-32 32V49.9C119.5 61.4 64 124.2 64 200v33.4c0 45.4-15.5 89.5-43.8 124.9L5.3 377c-5.8 7.2-6.9 17.1-2.9 25.4S14.8 416 24 416H424c9.2 0 17.6-5.3 21.6-13.6s2.9-18.2-2.9-25.4l-14.9-18.6C399.5 322.9 384 278.8 384 233.4V200c0-75.8-55.5-138.6-128-150.1V32c0-17.7-14.3-32-32-32zm0 96h8c57.4 0 104 46.6 104 104v33.4c0 47.9 13.9 94.6 39.7 134.6H72.3C98.1 328 112 281.3 112 233.4V200c0-57.4 46.6-104 104-104h8zm64 352H224 160c0 17 6.7 33.3 18.7 45.3s28.3 18.7 45.3 18.7s33.3-6.7 45.3-18.7s18.7-28.3 18.7-45.3z"]
  },
  ws = {
    prefix: "far",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"]
  },
  Qs = {
    prefix: "far",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
  },
  Hs = {
    prefix: "far",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M32 160a64 64 0 1 0 128 0A64 64 0 1 0 32 160zM80 334.1C62.8 349 41 360.8 18.8 365.8C5.9 368.7-2.3 381.5 .6 394.5s15.7 21.1 28.7 18.2C58 406.2 81.6 392.2 96 382.2c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c28.1 19.5 61.4 33.8 96 33.8s67.9-14.3 96-33.8c14.4 10 38 24 66.7 30.4c12.9 2.9 25.8-5.2 28.7-18.2s-5.2-25.8-18.2-28.7c-22-4.9-44.3-16.7-61.3-31.8c-9.1-8.1-22.8-8.1-31.9 0c-21.6 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0c-21.5 18.6-51.2 33.9-80 33.9s-58.5-15.3-80-33.9c-9.1-8.1-22.8-8.1-31.9 0zM256.5 193.9L403 318.1c13.8-3.2 27.9-9.6 40.2-18c2.4-1.7 4.9-3.2 7.5-4.5L295.9 164.3C319.7 151.4 347 144 376 144h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H376c-119.3 0-216 96.7-216 216v2.2c10.8 4 21.9 6.2 32 6.2c5.4 0 10.7-.5 16-1.6V312c0-46.1 18.5-87.8 48.5-118.1z"]
  },
  zs = {
    prefix: "far",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M48 336h81.2l20.9 41.9c6.8 13.6 20.6 22.1 35.8 22.1H326.1c15.1 0 29-8.6 35.8-22.1L382.8 336H464v80c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V336zm406.5-48H377.9c-15.1 0-29 8.6-35.8 22.1L321.2 352H190.8l-20.9-41.9c-6.8-13.6-20.6-22.1-35.8-22.1H57.5l49-195.9C108.2 85 114.6 80 122 80H390c7.3 0 13.7 5 15.5 12.1l49 195.9zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
  },
  Ms = {
    prefix: "far",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M392 48H120c-4.4 0-8 3.6-8 8V225.2L69.2 190.1c-1.7-1.4-3.4-2.6-5.2-3.8V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V186.2c-1.8 1.2-3.5 2.5-5.2 3.8L400 225.2V56c0-4.4-3.6-8-8-8zM160 120c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zm0 80c0-13.3 10.7-24 24-24H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24zM48 276.2V456c0 4.4 3.6 8 8 8H456c4.4 0 8-3.6 8-8V276.2L322 392.8c-38.4 31.5-93.7 31.5-132 0L48 276.2zM0 237.9C0 221.4 13.4 208 29.9 208c6.9 0 13.6 2.4 19 6.8l171.6 141c20.7 17 50.4 17 71.1 0l171.6-141c5.3-4.4 12.1-6.8 19-6.8c16.5 0 29.9 13.4 29.9 29.9V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V237.9z"]
  },
  ks = {
    prefix: "far",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H384l0 376c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-376H288V456c0 13.3-10.7 24-24 24s-24-10.7-24-24V352H192c-88.4 0-160-71.6-160-160zM240 304V80H192C130.1 80 80 130.1 80 192s50.1 112 112 112h48z"]
  },
  Ns = {
    prefix: "far",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M120 0C106.7 0 96 10.7 96 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24c0-13.3-10.7-24-24-24zM48.9 208H399.1c-8 72-69 128-143.1 128H192c-74.1 0-135.2-56-143.1-128zM32 160c-17.7 0-32 14.3-32 32c0 78.1 46.6 145.3 113.6 175.3l-7.5 17.5c-3.3-.5-6.7-.8-10.1-.8c-35.3 0-64 28.7-64 64s28.7 64 64 64c26.9 0 49.9-16.5 59.3-40H327l10.9 25.5c5.2 12.2 19.3 17.8 31.5 12.6s17.8-19.3 12.6-31.5L334.4 367.3c67-30 113.6-97.2 113.6-175.3c0-17.7-14.3-32-32-32H32zM147.5 410l12.3-28.7c10.5 1.8 21.2 2.7 32.2 2.7h64c11 0 21.7-.9 32.2-2.7L306.5 424H155.3c-2-5-4.7-9.7-7.8-14zM72 448a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM256 24c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z"]
  },
  Ss = {
    prefix: "far",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M580.3 267.2c56.2-56.2 56.2-147.3 0-203.5C526.8 10.2 440.9 7.3 383.9 57.2l-6.1 5.4c-10 8.7-11 23.9-2.3 33.9s23.9 11 33.9 2.3l6.1-5.4c38-33.2 95.2-31.3 130.9 4.4c37.4 37.4 37.4 98.1 0 135.6L433.1 346.6c-37.4 37.4-98.2 37.4-135.6 0c-35.7-35.7-37.6-92.9-4.4-130.9l4.7-5.4c8.7-10 7.7-25.1-2.3-33.9s-25.1-7.7-33.9 2.3l-4.7 5.4c-49.8 57-46.9 142.9 6.6 196.4c56.2 56.2 147.3 56.2 203.5 0L580.3 267.2zM59.7 244.8C3.5 301 3.5 392.1 59.7 448.2c53.6 53.6 139.5 56.4 196.5 6.5l6.1-5.4c10-8.7 11-23.9 2.3-33.9s-23.9-11-33.9-2.3l-6.1 5.4c-38 33.2-95.2 31.3-130.9-4.4c-37.4-37.4-37.4-98.1 0-135.6L207 165.4c37.4-37.4 98.1-37.4 135.6 0c35.7 35.7 37.6 92.9 4.4 130.9l-5.4 6.1c-8.7 10-7.7 25.1 2.3 33.9s25.1 7.7 33.9-2.3l5.4-6.1c49.9-57 47-142.9-6.5-196.5c-56.2-56.2-147.3-56.2-203.5 0L59.7 244.8z"]
  },
  Vs = {
    prefix: "far",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"]
  },
  Ls = {
    prefix: "far",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M39.6 5.8C32.5-.3 22.5-1.7 14 2.2S0 14.6 0 24V488c0 9.4 5.5 17.9 14 21.8s18.5 2.5 25.6-3.6L80 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L192 471.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L304 471.6l40.4 34.6c7.1 6.1 17.1 7.5 25.6 3.6s14-12.4 14-21.8V24c0-9.4-5.5-17.9-14-21.8s-18.5-2.5-25.6 3.6L304 40.4 263.6 5.8c-9-7.7-22.3-7.7-31.2 0L192 40.4 151.6 5.8c-9-7.7-22.3-7.7-31.2 0L80 40.4 39.6 5.8zm8.4 430V76.2l16.4 14c9 7.7 22.3 7.7 31.2 0L136 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0L248 55.6l40.4 34.6c9 7.7 22.3 7.7 31.2 0l16.4-14V435.8l-16.4-14c-9-7.7-22.3-7.7-31.2 0L248 456.4l-40.4-34.6c-9-7.7-22.3-7.7-31.2 0L136 456.4 95.6 421.8c-9-7.7-22.3-7.7-31.2 0L48 435.8zM120 144c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zm0 176c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120zM96 256c0 13.3 10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
  },
  Ps = {
    prefix: "far",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"]
  },
  Os = {
    prefix: "far",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 48c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16H576c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM120 464H520c13.3 0 24 10.7 24 24s-10.7 24-24 24H120c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
  },
  Ts = {
    prefix: "far",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM216 120H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24zM192 256c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H216c-13.3 0-24 10.7-24 24zM160 416c0 13.3 10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H184c-13.3 0-24 10.7-24 24zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Ds = {
    prefix: "far",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M406.5 399.6C387.4 352.9 341.5 320 288 320H224c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3h64c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"]
  },
  Rs = {
    prefix: "far",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 88C0 74.7 10.7 64 24 64H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24C10.7 112 0 101.3 0 88zM64 248c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H88c-13.3 0-24-10.7-24-24zM288 408c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24h80c13.3 0 24 10.7 24 24z"]
  },
  Gs = {
    prefix: "far",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24V232H40c-13.3 0-24 10.7-24 24s10.7 24 24 24H200V440c0 13.3 10.7 24 24 24s24-10.7 24-24V280H408c13.3 0 24-10.7 24-24s-10.7-24-24-24H248V72z"]
  },
  Fs = {
    prefix: "far",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"]
  },
  js = {
    prefix: "far",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zm397.3 40.8C457.9 118 474 112 490.7 112h9.2c42.1 0 76.2 34.1 76.2 76.2c0 21.3-8.9 41.5-24.5 56L375.7 406.4c-7.3 6.7-9.7 17.2-6.1 26.4s12.5 15.3 22.4 15.3H616c13.3 0 24-10.7 24-24s-10.7-24-24-24H453.4L584.1 279.4c25.5-23.5 39.9-56.6 39.9-91.2C624 119.6 568.4 64 499.8 64h-9.2c-28.1 0-55.3 10.1-76.6 28.3l-29.7 25.4c-10.1 8.6-11.2 23.8-2.6 33.8s23.8 11.2 33.8 2.6l29.7-25.4z"]
  },
  Js = {
    prefix: "far",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M565.6 36.2C572.1 40.7 576 48.1 576 56V392c0 10-6.2 18.9-15.5 22.4l-168 64c-5.2 2-10.9 2.1-16.1 .3L192.5 417.5l-160 61c-7.4 2.8-15.7 1.8-22.2-2.7S0 463.9 0 456V120c0-10 6.1-18.9 15.5-22.4l168-64c5.2-2 10.9-2.1 16.1-.3L383.5 94.5l160-61c7.4-2.8 15.7-1.8 22.2 2.7zM48 136.5V421.2l120-45.7V90.8L48 136.5zM360 422.7V137.3l-144-48V374.7l144 48zm48-1.5l120-45.7V90.8L408 136.5V421.2z"]
  },
  Zs = {
    prefix: "far",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M48 56c0-13.3-10.7-24-24-24S0 42.7 0 56V408c0 39.8 32.2 72 72 72H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H72c-13.3 0-24-10.7-24-24V56zM192 192a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM160 352a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
  },
  Ws = {
    prefix: "far",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"]
  },
  Xs = {
    prefix: "far",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"]
  },
  Us = {
    prefix: "far",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M369 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 399c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L369 113zM112 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM368 384a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
  },
  Ks = {
    prefix: "far",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M94 187.1C120.8 124.1 183.3 80 256 80c39.7 0 77.8 15.8 105.9 43.9l4.1 4.1-35.7 35.7c-6.6 6.6-10.3 15.6-10.3 25c0 19.5 15.8 35.3 35.3 35.3H472c13.3 0 24-10.7 24-24V83.3C496 63.8 480.2 48 460.7 48c-9.4 0-18.3 3.7-25 10.3L400 94.1l-4.1-4.1C358.8 52.8 308.5 32 256 32C163.4 32 83.9 88.2 49.8 168.3c-5.2 12.2 .5 26.3 12.7 31.5s26.3-.5 31.5-12.7zm368 157c5.2-12.2-.4-26.3-12.6-31.5s-26.3 .4-31.5 12.6C391 388.1 328.6 432 256 432c-39.7 0-77.8-15.8-105.9-43.9l-4.1-4.1 35.7-35.7c6.6-6.6 10.3-15.6 10.3-25c0-19.5-15.8-35.3-35.3-35.3H40c-13.3 0-24 10.7-24 24V428.7C16 448.2 31.8 464 51.3 464c9.4 0 18.3-3.7 25-10.3L112 417.9l4.1 4.1C153.2 459.2 203.5 480 256 480c92.5 0 171.8-56 206-135.9zM448 176H385.9L448 113.9V176zM64 336h62.1L64 398.1V336z"]
  },
  Ys = {
    prefix: "far",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M288 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0 448a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM448 256a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zM32 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM75 437a32 32 0 1 0 45.3-45.3A32 32 0 1 0 75 437zm316.8 0A32 32 0 1 0 437 391.8 32 32 0 1 0 391.8 437zM75 75a32 32 0 1 0 45.3 45.3A32 32 0 1 0 75 75z"]
  },
  qs = {
    prefix: "far",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M47 239c-9.4 9.4-9.4 24.6 0 33.9L207 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L97.9 256 241 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L47 239zM399 79L239 239c-9.4 9.4-9.4 24.6 0 33.9L399 433c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-143-143L433 113c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0z"]
  },
  _s = {
    prefix: "far",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M48 48H592V80H48V48zM32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32l0 360c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V368c0-88.4 71.6-160 160-160s160 71.6 160 160V488c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM80 464V128H560V464H528V368c0-114.9-93.1-208-208-208s-208 93.1-208 208v96H80zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z"]
  },
  $s = {
    prefix: "far",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M48 106.7V56c0-13.3-10.7-24-24-24S0 42.7 0 56V168c0 13.3 10.7 24 24 24H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H80.7c37-57.8 101.7-96 175.3-96c114.9 0 208 93.1 208 208s-93.1 208-208 208c-42.5 0-81.9-12.7-114.7-34.5c-11-7.3-25.9-4.3-33.3 6.7s-4.3 25.9 6.7 33.3C155.2 496.4 203.8 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C170.3 0 94.4 42.1 48 106.7zM256 128c-13.3 0-24 10.7-24 24V256c0 6.4 2.5 12.5 7 17l72 72c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-65-65V152c0-13.3-10.7-24-24-24z"]
  },
  el = {
    prefix: "far",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M188.7 32.5c13 2.6 21.4 15.2 18.8 28.2L192.5 136h111l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8s21.4 15.2 18.8 28.2L352.5 136H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H342.9L314.1 328H392c13.3 0 24 10.7 24 24s-10.7 24-24 24H304.5l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L255.5 376h-111l-16.9 84.7c-2.6 13-15.2 21.4-28.2 18.8s-21.4-15.2-18.8-28.2L95.5 376H24c-13.3 0-24-10.7-24-24s10.7-24 24-24h81.1l28.8-144H56c-13.3 0-24-10.7-24-24s10.7-24 24-24h87.5l16.9-84.7c2.6-13 15.2-21.4 28.2-18.8zM182.9 184L154.1 328h111l28.8-144h-111z"]
  },
  tl = {
    prefix: "far",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M24 32c13.3 0 24 10.7 24 24V408c0 13.3 10.7 24 24 24H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H72c-39.8 0-72-32.2-72-72V56C0 42.7 10.7 32 24 32zM168 224c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24s-24-10.7-24-24V248c0-13.3 10.7-24 24-24zm120-72V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24s24 10.7 24 24zm72 40c13.3 0 24 10.7 24 24V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V216c0-13.3 10.7-24 24-24zM480 88V328c0 13.3-10.7 24-24 24s-24-10.7-24-24V88c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  nl = {
    prefix: "far",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M111.7 6.4c9.2-8.5 23.4-8.5 32.6 0l96.8 89.4c9.5 8.8 14.9 21.1 14.9 34c0 25.5-20.7 46.3-46.3 46.3H200V336h9.7c25.5 0 46.3 20.7 46.3 46.3c0 12.9-5.4 25.2-14.9 34l-96.8 89.4c-9.2 8.5-23.4 8.5-32.6 0L14.9 416.2C5.4 407.5 0 395.2 0 382.3C0 356.7 20.7 336 46.3 336H56V176H46.3C20.7 176 0 155.3 0 129.7c0-12.9 5.4-25.2 14.9-34L111.7 6.4zM50.7 128H80c13.3 0 24 10.7 24 24V360c0 13.3-10.7 24-24 24H50.7L128 455.3 205.3 384H176c-13.3 0-24-10.7-24-24V152c0-13.3 10.7-24 24-24h29.3L128 56.7 50.7 128zM47.4 381s0 0 0 0l-1.2 1.3 1.2-1.3 0 0z"]
  },
  rl = {
    prefix: "far",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64z"]
  },
  ol = {
    prefix: "far",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M48 123.9C48 99.6 67.6 80 91.9 80c11.6 0 22.8 4.6 31 12.9l6.7 6.7c-27.8 43.4-22.8 101.7 15.1 139.6l7 7-.8 .8c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0L345 121c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-.8 .8L303.4 81l-.2-.2c-37.9-37.9-96.2-43-139.6-15.1l-6.7-6.7C139.6 41.7 116.3 32 91.9 32C41.1 32 0 73.1 0 123.9V456c0 13.3 10.7 24 24 24s24-10.7 24-24V123.9zM269.5 115l6.8 6.8-90.5 90.5-7-7c-25-25-25-65.5 0-90.5s65.5-25 90.5 0l.2 .2 0 0zM416 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-64 64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm32 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm64-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm96-96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  il = {
    prefix: "far",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 48H64c-8.8 0-16 7.2-16 16V256H528V64c0-8.8-7.2-16-16-16zm64 208v48 48c0 35.3-28.7 64-64 64H364.3l8 48H424c13.3 0 24 10.7 24 24s-10.7 24-24 24H352 224 152c-13.3 0-24-10.7-24-24s10.7-24 24-24h51.7l8-48H64c-35.3 0-64-28.7-64-64V304 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM48 304v48c0 8.8 7.2 16 16 16H239.5c.3 0 .6 0 .8 0h95.2c.3 0 .6 0 .8 0H512c8.8 0 16-7.2 16-16V304H48zM252.3 464h71.3l-8-48H260.3l-8 48z"]
  },
  al = {
    prefix: "far",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88V248 424c0 13.3 10.7 24 24 24s24-10.7 24-24V272H272V424c0 13.3 10.7 24 24 24s24-10.7 24-24V248 88c0-13.3-10.7-24-24-24s-24 10.7-24 24V224H48V88zM440 64c-11.4 0-21.3 8.1-23.5 19.3l-32 160c-1.4 7.1 .4 14.4 5 19.9s11.4 8.8 18.6 8.8H528c35.3 0 64 28.7 64 64s-28.7 64-64 64H464.4c-13.8 0-26-8.8-30.4-21.9l-3.2-9.7c-4.2-12.6-17.8-19.4-30.4-15.2s-19.4 17.8-15.2 30.4l3.2 9.7C399.4 426 429.9 448 464.4 448H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H437.3l22.4-112H584c13.3 0 24-10.7 24-24s-10.7-24-24-24H440z"]
  },
  cl = {
    prefix: "far",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M441 103c9.4 9.4 9.4 24.6 0 33.9L177 401c-9.4 9.4-24.6 9.4-33.9 0L7 265c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l119 119L407 103c9.4-9.4 24.6-9.4 33.9 0z"]
  },
  sl = {
    prefix: "far",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M248.4 84.3c1.6-2.7 4.5-4.3 7.6-4.3s6 1.6 7.6 4.3L461.9 410c1.4 2.3 2.1 4.9 2.1 7.5c0 8-6.5 14.5-14.5 14.5H62.5c-8 0-14.5-6.5-14.5-14.5c0-2.7 .7-5.3 2.1-7.5L248.4 84.3zm-41-25L9.1 385c-6 9.8-9.1 21-9.1 32.5C0 452 28 480 62.5 480h387c34.5 0 62.5-28 62.5-62.5c0-11.5-3.2-22.7-9.1-32.5L304.6 59.3C294.3 42.4 275.9 32 256 32s-38.3 10.4-48.6 27.3zM288 368a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-8-184c0-13.3-10.7-24-24-24s-24 10.7-24 24v96c0 13.3 10.7 24 24 24s24-10.7 24-24V184z"]
  },
  ll = {
    prefix: "far",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M288 240H192c-66.2 0-122 44.7-138.8 105.5C49.9 333.1 48 319.3 48 304c0-70.7 57.3-128 128-128H288h24c13.3 0 24-10.7 24-24V128 99.9L456.1 208 336 316.1V288 264c0-13.3-10.7-24-24-24H288zm0 48v48 16c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V80v48H240 176C78.8 128 0 206.8 0 304c0 78 38.6 126.2 68.7 152.1c4.1 3.5 8.1 6.6 11.7 9.3c3.2 2.4 6.2 4.4 8.9 6.2c4.5 3 8.3 5.1 10.8 6.5c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-6.8-3.6-13.2-8.3-18.1c-.5-.5-.9-.9-1.4-1.4c-2.4-2.3-5.1-5.1-7.7-8.6c-1.7-2.3-3.4-5-5-7.9c-5.3-9.7-9.5-22.9-9.5-40.2c0-53 43-96 96-96h48 48z"]
  },
  ul = {
    prefix: "far",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M256 464c114.9 0 208-93.1 208-208s-93.1-208-208-208S48 141.1 48 256c0 17.7 2.2 34.8 6.4 51.2C40.8 317.4 32 333.7 32 352v28C11.6 343.3 0 301 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-10.6 0-21.1-.6-31.4-1.9c4-5.7 7.3-12 9.8-18.8l10.1-27.7c3.8 .2 7.7 .3 11.6 .3zm43-158.9c-9.9-2-20.5-1.3-30.7 2.5L237.9 319l-65.5-15.4c-8.6-2-13.9-10.6-11.9-19.2s10.6-13.9 19.2-11.9l97.1 22.8c8.2 1.9 15.7 5.3 22.3 9.8zM144.4 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-16a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-120-31.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3zM112 352v48.4l167.6-62.8c12.4-4.7 26.2 1.6 30.9 14s-1.6 26.2-14 30.9L230.9 407c-.1 .4-.3 .8-.4 1.2l-26.3 72.2c-6.9 19-24.9 31.6-45.1 31.6H112c-26.5 0-48-21.5-48-48V352c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
  },
  dl = {
    prefix: "far",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M16.1 260.2c-22.6 12.9-20.5 47.3 3.6 57.3L160 376V479.3c0 18.1 14.6 32.7 32.7 32.7c9.7 0 18.9-4.3 25.1-11.8l62-74.3 123.9 51.6c18.9 7.9 40.8-4.5 43.9-24.7l64-416c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256zm52.1 25.5L409.7 90.6 190.1 336l1.2 1L68.2 285.7zM403.3 425.4L236.7 355.9 450.8 116.6 403.3 425.4z"]
  },
  fl = {
    prefix: "far",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M424 40c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zm0 128c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424zm24 152c0 13.3-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24H424c13.3 0 24 10.7 24 24zM424 424c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24H424z"]
  },
  pl = {
    prefix: "far",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"]
  },
  ml = {
    prefix: "far",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M323.8 34.8c-38.2-10.9-78.1 11.2-89 49.4l-5.7 20c-3.7 13-10.4 25-19.5 35l-51.3 56.4c-8.9 9.8-8.2 25 1.6 33.9s25 8.2 33.9-1.6l51.3-56.4c14.1-15.5 24.4-34 30.1-54.1l5.7-20c3.6-12.7 16.9-20.1 29.7-16.5s20.1 16.9 16.5 29.7l-5.7 20c-5.7 19.9-14.7 38.7-26.6 55.5c-5.2 7.3-5.8 16.9-1.7 24.9s12.3 13 21.3 13L448 224c8.8 0 16 7.2 16 16c0 6.8-4.3 12.7-10.4 15c-7.4 2.8-13 9-14.9 16.7s.1 15.8 5.3 21.7c2.5 2.8 4 6.5 4 10.6c0 7.8-5.6 14.3-13 15.7c-8.2 1.6-15.1 7.3-18 15.1s-1.6 16.7 3.6 23.3c2.1 2.7 3.4 6.1 3.4 9.9c0 6.7-4.2 12.6-10.2 14.9c-11.5 4.5-17.7 16.9-14.4 28.8c.4 1.3 .6 2.8 .6 4.3c0 8.8-7.2 16-16 16H286.5c-12.6 0-25-3.7-35.5-10.7l-61.7-41.1c-11-7.4-25.9-4.4-33.3 6.7s-4.4 25.9 6.7 33.3l61.7 41.1c18.4 12.3 40 18.8 62.1 18.8H384c34.7 0 62.9-27.6 64-62c14.6-11.7 24-29.7 24-50c0-4.5-.5-8.8-1.3-13c15.4-11.7 25.3-30.2 25.3-51c0-6.5-1-12.8-2.8-18.7C504.8 273.7 512 257.7 512 240c0-35.3-28.6-64-64-64l-92.3 0c4.7-10.4 8.7-21.2 11.8-32.2l5.7-20c10.9-38.2-11.2-78.1-49.4-89zM32 192c-17.7 0-32 14.3-32 32V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32z"]
  },
  hl = {
    prefix: "far",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M64 464H320c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm80 48c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM192 400c0-8.8 7.2-16 16-16h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zM112 224H272c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V256c0-17.7 14.3-32 32-32z"]
  },
  Al = {
    prefix: "far",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M112 160V64c0-8.8 7.2-16 16-16H357.5c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3V160h48V90.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0H128C92.7 0 64 28.7 64 64v96h48zm16 208H384v96H128V368zm-16-48c-17.7 0-32 14.3-32 32H48V256c0-8.8 7.2-16 16-16H448c8.8 0 16 7.2 16 16v96H432c0-17.7-14.3-32-32-32H112zm320 80h48c17.7 0 32-14.3 32-32V256c0-35.3-28.7-64-64-64H64c-35.3 0-64 28.7-64 64V368c0 17.7 14.3 32 32 32H80v80c0 17.7 14.3 32 32 32H400c17.7 0 32-14.3 32-32V400z"]
  },
  gl = {
    prefix: "far",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M267.6 3c-7.2-4-16-4-23.2 0L17.6 128.1C6.7 134.1 0 145.5 0 157.9C0 176.8 15.2 192 34.1 192H477.9c18.8 0 34.1-15.2 34.1-34.1c0-12.4-6.7-23.8-17.6-29.8L267.6 3zM228.3 144H88.2L256 51.4 423.8 144H283.7c2.7-4.7 4.3-10.2 4.3-16c0-17.7-14.3-32-32-32s-32 14.3-32 32c0 5.8 1.6 11.3 4.3 16zM64 224V384c-13.3 0-24 10.7-24 24s10.7 24 24 24H456c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V224H400V384H336V224H288V384H224V224H176V384H112V224H64zM32 464c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H32z"]
  },
  vl = {
    prefix: "far",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-13.3 10.7-24 24-24H616c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24z"]
  },
  Cl = {
    prefix: "far",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M175.6 6.5c9.2-8.7 23.7-8.7 32.9 0l129 121.4c9.3 8.8 14.6 21 14.6 33.7c0 25.6-20.7 46.3-46.3 46.3H264V352c0 88.4-71.6 160-160 160H56c-30.9 0-56-25.1-56-56V424c0-30.9 25.1-56 56-56h56c4.4 0 8-3.6 8-8V208H78.3C52.7 208 32 187.3 32 161.7c0-12.8 5.3-25 14.6-33.7L175.6 6.5zM82.5 160H144c13.3 0 24 10.7 24 24V360c0 30.9-25.1 56-56 56H56c-4.4 0-8 3.6-8 8v32c0 4.4 3.6 8 8 8h48c61.9 0 112-50.1 112-112V184c0-13.3 10.7-24 24-24h61.5L192 57 82.5 160z"]
  },
  bl = {
    prefix: "fal",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M164.2 39.5L148.9 64H299.1L283.8 39.5c-2.9-4.7-8.1-7.5-13.6-7.5H177.7c-5.5 0-10.6 2.8-13.6 7.5zM311 22.6L336.9 64H384h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H416V432c0 44.2-35.8 80-80 80H112c-44.2 0-80-35.8-80-80V96H16C7.2 96 0 88.8 0 80s7.2-16 16-16H32 64h47.1L137 22.6C145.8 8.5 161.2 0 177.7 0h92.5c16.6 0 31.9 8.5 40.7 22.6zM64 96V432c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V96H64zm80 80V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  El = {
    prefix: "fal",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M112 0c8.8 0 16 7.2 16 16V64H320V16c0-8.8 7.2-16 16-16s16 7.2 16 16V64h32c35.3 0 64 28.7 64 64v32 32V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V192 160 128C0 92.7 28.7 64 64 64H96V16c0-8.8 7.2-16 16-16zM416 192H312v72H416V192zm0 104H312v80H416V296zm0 112H312v72h72c17.7 0 32-14.3 32-32V408zM280 376V296H168v80H280zM168 408v72H280V408H168zm-32-32V296H32v80H136zM32 408v40c0 17.7 14.3 32 32 32h72V408H32zm0-144H136V192H32v72zm136 0H280V192H168v72zM384 96H64c-17.7 0-32 14.3-32 32v32H416V128c0-17.7-14.3-32-32-32z"]
  },
  yl = {
    prefix: "fal",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M496 80c0-5.7-3-10.9-7.9-13.8s-10.9-2.9-15.9-.2l-72 40c-7.7 4.3-10.5 14-6.2 21.8s14 10.5 21.8 6.2L464 107.2V416H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h80 80c8.8 0 16-7.2 16-16s-7.2-16-16-16H496V80zM32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80z"]
  },
  Il = {
    prefix: "fal",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M512 64H128c-17.7 0-32 14.3-32 32V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H544V96c0-17.7-14.3-32-32-32zM76.8 448H563.2c20.3 0 37.4-13.5 42.9-32H33.9c5.5 18.5 22.7 32 42.9 32zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"]
  },
  Bl = {
    prefix: "fal",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM200 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zm133.1 0H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H333.1c-7.2 0-13.1 5.9-13.1 13.1c0 5.2 3 9.9 7.8 12l37.4 16.6c16.3 7.2 26.8 23.4 26.8 41.2c0 24.9-20.2 45.1-45.1 45.1H304c-8.8 0-16-7.2-16-16s7.2-16 16-16h42.9c7.2 0 13.1-5.9 13.1-13.1c0-5.2-3-9.9-7.8-12l-37.4-16.6c-16.3-7.2-26.8-23.4-26.8-41.2c0-24.9 20.2-45.1 45.1-45.1zm98.9 0c8.8 0 16 7.2 16 16v31.6c0 23 5.5 45.6 16 66c10.5-20.3 16-42.9 16-66V368c0-8.8 7.2-16 16-16s16 7.2 16 16v31.6c0 34.7-10.3 68.7-29.6 97.6l-5.1 7.7c-3 4.5-8 7.1-13.3 7.1s-10.3-2.7-13.3-7.1l-5.1-7.7c-19.3-28.9-29.6-62.9-29.6-97.6V368c0-8.8 7.2-16 16-16z"]
  },
  xl = {
    prefix: "fal",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M88 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 224c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 192H88c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H40c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 64c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 64h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V72c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V232c0-4.4 3.6-8 8-8h48zm-48-32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 192h48c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8zm-40 8v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
  },
  wl = {
    prefix: "fal",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M129.7 132c4.8-25.9 22-44.8 49.7-56.2c28.3-11.7 67-15 111-8.4c13.8 2.1 56.1 10 69.7 13.5c8.6 2.2 17.3-3 19.5-11.5s-3-17.3-11.5-19.5c-15.1-3.9-58.6-12-72.9-14.1c-47.7-7.2-92.7-4.1-127.9 10.5c-35.7 14.7-62.1 41.6-69.1 80.6c-.1 .3-.1 .6-.1 .9c-2.8 22.9 .6 42.7 9.5 59.7c8.8 16.8 22.4 29.6 37.9 39.8c18.7 12.2 41.6 21.2 65.2 28.9H16c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H319.4c-18.1-6.6-37-12.1-55.3-17.3l-1.2-.3c-39-11.2-74.8-21.6-100.2-38.1c-12.5-8.1-21.5-17.2-27.1-27.8c-5.4-10.4-8.1-23.3-6.1-40.5zM379 336.8c4.7 10.8 6.6 24.5 3.4 42.7c-4.7 26.1-21.9 45.2-49.8 56.6c-28.3 11.7-66.9 15-110.9 8.4c-22.1-3.5-59.5-15.7-88-25.1l0 0 0 0c-6.1-2-11.8-3.9-16.8-5.5c-8.4-2.7-17.4 1.9-20.1 10.4s1.9 17.4 10.4 20.1c4.4 1.4 9.6 3.1 15.3 5c28.3 9.3 69.3 22.8 94.4 26.7l.1 0c47.7 7.2 92.7 4.1 127.9-10.5c35.7-14.7 62.1-41.6 69.1-80.6c4.2-23.3 2.2-43.7-5.6-61.3c-.6-1.3-1.2-2.7-1.9-4H367.7c4.9 5.2 8.6 10.8 11.3 16.8z"]
  },
  Ql = {
    prefix: "fal",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6l-219 219V400c0-8.8-7.2-16-16-16H128V352c0-8.8-7.2-16-16-16H99.4l219-219zM66.9 379.5c1.2-4 2.7-7.9 4.7-11.5H96v32c0 8.8 7.2 16 16 16h32v24.4c-3.7 1.9-7.5 3.5-11.6 4.7L39.6 472.4l27.3-92.8zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17zM331.3 202.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z"]
  },
  Hl = {
    prefix: "fal",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36c1.8 7.1 8.2 12 15.5 12h18c8.8 0 16 7.2 16 16v32H192 96V96c0-8.8 7.2-16 16-16h18c7.3 0 13.7-4.9 15.5-12zM192 0c-32.8 0-61 19.8-73.3 48H112C91.1 48 73.3 61.4 66.7 80H64C28.7 80 0 108.7 0 144V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V144c0-35.3-28.7-64-64-64h-2.7c-6.6-18.6-24.4-32-45.3-32h-6.7C253 19.8 224.8 0 192 0zM320 112c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32v16c0 17.7 14.3 32 32 32h96 96c17.7 0 32-14.3 32-32V112zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM136 272a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm40-16c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm-64 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  zl = {
    prefix: "fal",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M480 64H32v64H64 448h32V64zm0 96H448 64 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32zM160 240c0-8.8 7.2-16 16-16H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16zm288-48h32V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V192H64V416c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V192z"]
  },
  Ml = {
    prefix: "fal",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168.7 121.8l-.2 .7c-2.2 8.5 2.9 17.3 11.4 19.5s17.3-2.9 19.5-11.4l.2-.7c2.8-10.6 12.3-17.9 23.2-17.9H280c17.6 0 32 14.5 32 32.3c0 12.1-6.8 23.2-17.5 28.7l-45.8 23.4c-5.4 2.7-8.7 8.2-8.7 14.3V240c0 8.8 7.2 16 16 16s16-7.2 16-16V220.3l37.1-18.9c21.5-11 34.9-33.2 34.9-57.2C344 109 315.5 80 280 80H222.9c-25.5 0-47.7 17.2-54.2 41.8zM280 304a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  kl = {
    prefix: "fal",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M512 64c17.7 0 32 14.3 32 32V384c0 17.7-14.3 32-32 32H496 80 64c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32H512zM480 448v16c0 8.8 7.2 16 16 16s16-7.2 16-16V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 16c0 8.8 7.2 16 16 16s16-7.2 16-16V448H480zM464 128V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16s-16 7.2-16 16zM128 320V160H384V320H128zM96 152V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24z"]
  },
  Nl = {
    prefix: "fal",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M208 64c-8.8 0-16 7.2-16 16s7.2 16 16 16h32v48.6C123.8 152.8 32 249.7 32 368v16H64V368c0-106 86-192 192-192s192 86 192 192v16h32V368c0-118.3-91.8-215.2-208-223.4V96h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H256 208zM16 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  Sl = {
    prefix: "fal",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M216 160c-13.3 0-24-10.7-24-24v-8V112 64L32 208 192 352l0-48V288v-8c0-13.3 10.7-24 24-24h8 96c70.7 0 128 57.3 128 128c0 8.3-.7 16.1-2 23.2c18.2-23.4 34-57.1 34-103.2c0-79.5-64.5-144-144-144H224h-8zm8 144v16 32c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2V96v16 16h32 80c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H256 224v16z"]
  },
  Vl = {
    prefix: "fal",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M491.3 43.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66 66C363.4 52.6 312.1 32 256 32C132.3 32 32 132.3 32 256c0 56.1 20.6 107.4 54.7 146.7l-66 66c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l66-66C148.6 459.4 199.9 480 256 480c123.7 0 224-100.3 224-224c0-56.1-20.6-107.4-54.7-146.7l66-66zM380 109.4L109.4 380C81.1 346.5 64 303.3 64 256C64 150 150 64 256 64c47.3 0 90.5 17.1 124 45.4zM132 402.6L402.6 132c28.3 33.5 45.4 76.7 45.4 124c0 106-86 192-192 192c-47.3 0-90.5-17.1-124-45.4z"]
  },
  Ll = {
    prefix: "fal",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16z"]
  },
  Pl = {
    prefix: "fal",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M128 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM0 280c0 43.3 26.4 80.4 64 96v48c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v32H96V208.4c2.6-.3 5.3-.4 8-.4h48c9.3 0 18.1 1.7 26.2 4.9c8.2 3.2 17.5-.9 20.7-9.1s-.9-17.5-9.1-20.7c-11.7-4.6-24.5-7.1-37.8-7.1H104C46.6 176 0 222.6 0 280zm64 59.9C44.7 327 32 304.9 32 280c0-25 12.7-47 32-59.9V339.9zM512 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM640 280c0-57.4-46.6-104-104-104H488c-13.3 0-26.1 2.5-37.8 7.1c-8.2 3.2-12.3 12.5-9.1 20.7s12.5 12.3 20.7 9.1c8.1-3.2 16.9-4.9 26.2-4.9h48c2.7 0 5.4 .1 8 .4V416H480V384c0-8.8-7.2-16-16-16s-16 7.2-16 16v40c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V376c37.6-15.7 64-52.7 64-96zm-64 59.9V220.1C595.3 233 608 255 608 280c0 24.9-12.7 47-32 59.9zM288 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zm-80 96c-57.4 0-104 46.6-104 104c0 40.1 22.7 74.9 56 92.3V456c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V388.3c33.3-17.3 56-52.1 56-92.3c0-57.4-46.6-104-104-104H304zm-48 50.3V349.7c-14.7-13.2-24-32.4-24-53.7c0-21.3 9.3-40.5 24-53.7zM288 448V225.8c5.1-1.2 10.5-1.8 16-1.8h32c5.5 0 10.9 .6 16 1.8V448H288zm96-98.3V242.3c14.7 13.2 24 32.3 24 53.7c0 21.3-9.3 40.5-24 53.7z"]
  },
  Ol = {
    prefix: "fal",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16V272c0 8.8 7.2 16 16 16s16-7.2 16-16V144c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  Tl = {
    prefix: "fal",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M320 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H304 272 256c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h64zM256 192h16v48H112c-26.5 0-48 21.5-48 48v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H96V288c0-8.8 7.2-16 16-16H272v48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H304V272H464c8.8 0 16 7.2 16 16v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H512V288c0-26.5-21.5-48-48-48H304V192h16c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48zM48 352h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm208 0h64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H464c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16z"]
  },
  Dl = {
    prefix: "fal",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M349.4 93.5c-9.6 .1-18.8-4.1-25-11.5c-12.9-15.5-26.5-30-40.8-43.7c-26.1 25-48 52.3-64 78.1c-18.3 29.6-27.6 57.9-27.6 75.8C192 262.5 248.2 320 320 320c71 0 128-57.6 128-127.8c0-12.8-7-38.2-20.6-64.3c-10.9-21.1-25.4-42.6-41.8-60.5c-3.8 4.4-7.7 9.1-11.6 14c-6 7.5-15.1 12-24.7 12.1zM327.5 37.1c7.4 7.9 14.5 16 21.5 24.4c6.4-8.1 13.6-16.8 21.2-24.5c1.7-1.7 3.5-3.4 5.2-5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c11.8 10.6 23.1 21.7 34 33.4zM285.1 96c4.8 0 9.4 2.2 12.4 6c2.1 2.6 17.6 22.4 32.6 41.5l17.5 22.3 23.3-27.2c3.2-3.7 7.8-5.7 12.7-5.6s9.4 2.5 12.3 6.4c3.9 5.2 6.4 10.3 8.3 14.1l0 0 0 .1c21.3 39.3 12.3 90.4-25 116.5l-.3 .2 0 0C361.3 282 342.3 288 321 288c-25.9 0-50.2-8.4-68.2-24.8C234.7 246.6 224 222.7 224 194c0-15.7 5-29.7 13.4-44.2c8.2-14.1 20.2-29.5 35.1-47.9c3-3.8 7.6-5.9 12.5-5.9zm94.8 81.3l-20.7 24.1c-3.1 3.6-7.7 5.7-12.5 5.6s-9.3-2.4-12.2-6.1L347 191l-12.6 9.9 0 0 0 0 0 0-.1-.2-.5-.6-1.8-2.4-6.6-8.5-20.4-26-20-25.5c-8.6 11-15.1 20.1-19.8 28.2c-6.6 11.3-9.1 19.8-9.1 28.1c0 20.3 7.3 35.4 18.4 45.6C285.7 249.9 301.9 256 321 256c14.7 0 27.6-4 40-12.2c20.1-14.2 27.8-41.8 18.9-66.5zM32 272c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H64v96H576V288H528c-8.8 0-16-7.2-16-16s7.2-16 16-16h64c8.8 0 16 7.2 16 16V386.7c18.6 6.6 32 24.4 32 45.3v32c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V432c0-20.9 13.4-38.7 32-45.3V272zm0 160v32c0 8.8 7.2 16 16 16H592c8.8 0 16-7.2 16-16V432c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zm160-8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm104 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm152-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  Rl = {
    prefix: "fal",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M32 240c0-91.4 93.8-176 224-176s224 84.6 224 176s-93.8 176-224 176c-32 0-63-5.9-93.5-16.2c-9.9-3.3-20.7-1.8-29.2 4.2c-15.4 10.7-31.4 20-48.4 27.4L91.2 446l-6.4-14.7c-10.5 4.6-21.5 8.6-32.7 11.5c.5-.9 1.1-1.8 1.6-2.6C68 416.5 76.3 391 79.4 363.9c1-9.2-2.1-17.7-7.4-23.9c-24.5-29.4-40-62.9-40-100zM256 32C114.5 32 0 125.2 0 240c0 46.6 19.6 87.1 47.4 120.5c0 .1 .1 .1 .1 .2c-2.6 22.6-9.5 43.5-21.3 63.1c-6.5 10.8-13.5 20.8-21.7 29c-4.5 4.6-5.9 11.5-3.4 17.4s8.3 9.8 14.8 9.8c28.7 0 57.6-8.9 81.6-19.3c19.2-8.4 37.1-18.7 53.9-30.5c.2-.1 .5-.2 .7-.1C185.5 441.3 220 448 256 448c141.5 0 256-93.2 256-208S397.5 32 256 32zM144 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
  },
  Gl = {
    prefix: "fal",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M48 112V80H80v32H48zM16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40C26.7 48 16 58.7 16 72zm160 8c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zM48 240H80v32H48V240zm-8-32c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40zm8 224V400H80v32H48zM16 392v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24z"]
  },
  Fl = {
    prefix: "fal",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M128 128v64H320V128c0-53-43-96-96-96s-96 43-96 96zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h16c44.2 0 80 35.8 80 80V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V272c0-44.2 35.8-80 80-80H96zM32 272V432c0 26.5 21.5 48 48 48H368c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H80c-26.5 0-48 21.5-48 48z"]
  },
  jl = {
    prefix: "fal",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M240 0c-8.8 0-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C307.7 128.4 320 151.4 320 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L288.8 77.3C268.3 63.6 256 40.6 256 16c0-8.8-7.2-16-16-16zM32 336V320 288H272c.5 0 1 0 1.6-.1c1.3 0 2.5 .1 3.8 .1H448c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336zm170.7-80H32c0-35.3 28.7-64 64-64c13.8 0 27.3 4.5 38.4 12.8L202.7 256zM0 272v48 16V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V320c0-35.3-28.7-64-64-64H277.3c-13.8 0-27.3-4.5-38.4-12.8l-85.3-64C137 166.7 116.8 160 96 160c-53 0-96 43-96 96v16zM384 16c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 35.3 17.7 68.3 47.1 87.9l16.1 10.7C435.7 128.4 448 151.4 448 176c0 8.8 7.2 16 16 16s16-7.2 16-16c0-35.3-17.7-68.3-47.1-87.9L416.8 77.3C396.3 63.6 384 40.6 384 16zM112 336c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V352c0-8.8-7.2-16-16-16zM32 64a32 32 0 1 1 64 0A32 32 0 1 1 32 64zm96 0A64 64 0 1 0 0 64a64 64 0 1 0 128 0z"]
  },
  Jl = {
    prefix: "fal",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M32 128V312.4C49 297.2 71.4 288 96 288H392c8.6 0 16.7 1.9 24 5.4V128c0-35.3-28.7-64-64-64H96c-35.3 0-64 28.7-64 64zM0 384V128C0 75 43 32 96 32H352c53 0 96 43 96 96V344c0 30.9-25.1 56-56 56H96c-8.8 0-16-7.2-16-16s7.2-16 16-16H392c13.3 0 24-10.7 24-24s-10.7-24-24-24H96c-35.3 0-64 28.7-64 64s28.7 64 64 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-53 0-96-43-96-96z"]
  },
  Zl = {
    prefix: "fal",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 64H378.7c54.2 0 98.4 42.5 101.2 96H160.1c2.8-53.5 47-96 101.2-96zm0-32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 32a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 128A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm16 64c44.2 0 80 35.8 80 80c0 8.8 7.2 16 16 16s16-7.2 16-16c0-61.9-50.1-112-112-112H444c2.6 10.2 4 21 4 32h80zm-336 0c0-11 1.4-21.8 4-32H112C50.1 192 0 242.1 0 304c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80h80z"]
  },
  Wl = {
    prefix: "fal",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M244.7 116.7c6.2-6.2 16.4-6.2 22.6 0l192 192c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L256 150.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l192-192z"]
  },
  Xl = {
    prefix: "fal",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C89.3 128 32 185.3 32 256s57.3 128 128 128h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c70.7 0 128-57.3 128-128s-57.3-128-128-128H336c-8.8 0-16-7.2-16-16s7.2-16 16-16h80c88.4 0 160 71.6 160 160zM152 240H424c8.8 0 16 7.2 16 16s-7.2 16-16 16H152c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Ul = {
    prefix: "fal",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M480 96c0 35.3 28.7 64 64 64V128c0-17.7-14.3-32-32-32H480zm-32 0H128c0 53-43 96-96 96V320c53 0 96 43 96 96H448c0-53 43-96 96-96V192c-53 0-96-43-96-96zM32 384c0 17.7 14.3 32 32 32H96c0-35.3-28.7-64-64-64v32zm512-32c-35.3 0-64 28.7-64 64h32c17.7 0 32-14.3 32-32V352zM64 96c-17.7 0-32 14.3-32 32v32c35.3 0 64-28.7 64-64H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zM352 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
  },
  Kl = {
    prefix: "fal",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 192c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  Yl = {
    prefix: "fal",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M240 64c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H208c-8.8 0-16-7.2-16-16V80c0-8.8 7.2-16 16-16h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 256c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H48c-8.8 0-16-7.2-16-16V272c0-8.8 7.2-16 16-16H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zm320-96h32c8.8 0 16 7.2 16 16V432c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16zm-48 16V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
  },
  ql = {
    prefix: "fal",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm208 32h80c35.3 0 64-28.7 64-64s-28.7-64-64-64H208V288zm80 32H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V304 152c0-13.3 10.7-24 24-24h88c53 0 96 43 96 96s-43 96-96 96z"]
  },
  _l = {
    prefix: "fal",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM400 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H560L421 228.4c-4.7 4.5-6.3 11.5-3.8 17.5s8.3 10.1 14.9 10.1h96c44.2 0 80 35.8 80 80s-35.8 80-80 80H455.4c-19.6 0-36.2-14.1-39.5-33.4l-.2-1.2c-1.5-8.7-9.7-14.6-18.4-13.2s-14.6 9.7-13.2 18.4l.2 1.2c5.8 34.7 35.8 60.2 71 60.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H472L611 91.6c4.7-4.5 6.3-11.5 3.8-17.5S606.5 64 600 64H400z"]
  },
  $l = {
    prefix: "fal",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M32 184c35.3 0 64-28.7 64-64v-.5c-18.5-1.4-37.1-4.4-55.8-9.5c-2.2-.6-4.9-.2-6.9 1.2c-.9 .6-1.2 1.1-1.3 1.2l0 0 0 0 0 0s0 0 0 0l0 .1V184zm0 192v46.3c0 6.8 3.7 10.4 6.2 11.3C57.3 440.8 76.5 445 96 446.8V440c0-35.3-28.7-64-64-64zm0-32c53 0 96 43 96 96v8c44.7-1 91.1-11.7 141.3-24.5c4.3-1.1 8.6-2.2 13-3.3c51.8-13.3 108-27.6 165.7-28.6c.2-52.8 43.1-95.6 96-95.6V168c-53 0-96-43-96-96V64c-44.7 1-91.1 11.7-141.3 24.5c-4.3 1.1-8.6 2.2-13 3.3c-51.8 13.3-108 27.6-165.7 28.6c-.2 52.8-43.1 95.6-96 95.6V344zm503.8 58c2.2 .6 4.9 .2 6.9-1.2c.9-.6 1.2-1.1 1.3-1.2c0 0 0 0 0 0s0 0 0-.1V328c-35.3 0-64 28.7-64 64v.5c18.5 1.4 37.1 4.4 55.8 9.5zM480 72c0 35.3 28.7 64 64 64V89.7c0-6.8-3.7-10.4-6.2-11.3C518.7 71.2 499.5 67 480 65.2V72zM0 422.3V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM224 256c0 47 31.3 80 64 80s64-33 64-80s-31.3-80-64-80s-64 33-64 80zm64-112c55.6 0 96 53 96 112s-40.4 112-96 112s-96-53-96-112s40.4-112 96-112z"]
  },
  eu = {
    prefix: "fal",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M402.7 425.3l-316-316C52.6 148.6 32 199.9 32 256c0 123.7 100.3 224 224 224c56.1 0 107.4-20.6 146.7-54.7zm22.6-22.6C459.4 363.4 480 312.1 480 256C480 132.3 379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7l316 316zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  tu = {
    prefix: "fal",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M226.5 168.8L287.9 42.3l61.4 126.5c4.6 9.5 13.6 16.1 24.1 17.7l137.4 20.3-99.8 98.8c-7.4 7.3-10.8 17.8-9 28.1l23.5 139.5L303 407.7c-9.4-5-20.7-5-30.2 0L150.2 473.2l23.5-139.5c1.7-10.3-1.6-20.7-9-28.1L65 206.8l137.4-20.3c10.5-1.5 19.5-8.2 24.1-17.7zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"]
  },
  nu = {
    prefix: "fal",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm144 99.6v13.6c8.3 1.1 16.3 2.7 23.7 4.5c8.6 2 13.9 10.7 11.9 19.3s-10.7 13.9-19.3 11.9c-11.2-2.6-22.2-4.6-32.5-4.8c-8.7-.1-17.9 1.7-24.3 5.1c-6.1 3.2-7.4 6.3-7.4 9.4c0 1.5 .2 3.6 6.6 7c7 3.7 16.8 6.4 29.4 9.8l.5 .1c11.3 3 25.2 6.8 36.1 12.9c11.8 6.6 23.1 17.7 23.4 35.9c.3 18.9-10.6 31.7-23.6 38.9c-7.5 4.1-15.9 6.6-24.4 7.9v13.5c0 8.8-7.2 16-16 16s-16-7.2-16-16V414.4c-10.9-1.9-21.2-5-30.3-7.8l0 0 0 0c-2.1-.7-4.2-1.3-6.2-1.9c-8.5-2.5-13.3-11.4-10.8-19.9s11.4-13.3 19.9-10.8c2.4 .7 4.8 1.4 7.1 2.1c13.6 4.1 24.8 7.5 36.8 7.9c9.4 .3 18.5-1.6 24.4-4.9c5.4-3 7.2-6.2 7.1-10.4c0-2.4-.8-4.9-7-8.4c-6.9-3.9-16.8-6.7-29.2-10l-1.6-.4c-11-3-24.2-6.5-34.6-12.1c-11.5-6.2-23.3-16.9-23.4-35.1c-.1-19 11.9-31.3 24.5-37.9c7.3-3.8 15.4-6.2 23.4-7.5V243.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  ru = {
    prefix: "fal",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M352 16V80h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H352v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V112H256c-8.8 0-16-7.2-16-16s7.2-16 16-16h64V16c0-8.8 7.2-16 16-16s16 7.2 16 16zM152.8 265.5c-4.7 9.5-13.7 16-24.1 17.5L41.2 295.8l63.4 61.9c7.5 7.3 11 17.9 9.2 28.3l-15 87.3L177 432.1c9.3-4.9 20.5-4.9 29.8 0L285 473.3l-15-87.3c-1.8-10.4 1.7-20.9 9.2-28.3l63.4-61.9-87.5-12.7c-10.4-1.5-19.4-8.1-24.1-17.5l-39.1-79.4-39.1 79.4zm17.6-108.1c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94zM448 160c8.8 0 16 7.2 16 16v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H464v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H400c-8.8 0-16-7.2-16-16s7.2-16 16-16h32V176c0-8.8 7.2-16 16-16z"]
  },
  ou = {
    prefix: "fal",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M447.7 83L411.4 272H608V80c0-8.8 7.2-16 16-16s16 7.2 16 16V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V304H392c-4.8 0-9.3-2.1-12.3-5.8s-4.3-8.5-3.4-13.2l40-208c1.7-8.7 10.1-14.4 18.7-12.7s14.4 10.1 12.7 18.7zM16 64c8.8 0 16 7.2 16 16V240H288V80c0-8.8 7.2-16 16-16s16 7.2 16 16V256 432c0 8.8-7.2 16-16 16s-16-7.2-16-16V272H32V432c0 8.8-7.2 16-16 16s-16-7.2-16-16V256 80c0-8.8 7.2-16 16-16z"]
  },
  iu = {
    prefix: "fal",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M27.3 184.4C102.4 110 205.8 64 320 64s217.6 46 292.7 120.4c6.3 6.2 16.4 6.2 22.6-.1s6.2-16.4-.1-22.6C554.3 81.5 442.9 32 320 32S85.7 81.5 4.7 161.7c-6.3 6.2-6.3 16.3-.1 22.6s16.3 6.3 22.6 .1zM320 224c70.5 0 134.4 28.5 180.7 74.7c6.3 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6c-52.1-51.9-123.9-84-203.3-84s-151.2 32.1-203.3 84c-6.3 6.2-6.3 16.4 0 22.6s16.4 6.3 22.6 0C185.6 252.5 249.5 224 320 224zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  au = {
    prefix: "fal",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M93.3 32C77.1 32 64 45.1 64 61.3V256H448h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H480 448 64 32 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V61.3C32 27.4 59.4 0 93.3 0c16.2 0 31.8 6.5 43.3 17.9L161.7 43c11.1-7 24.2-11 38.3-11c20.2 0 38.5 8.3 51.6 21.8l1.1-1.1c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-104 104c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l1.1-1.1C136.3 142.5 128 124.2 128 104c0-14.1 4-27.2 11-38.3L113.9 40.6C108.5 35.1 101 32 93.3 32zM32 320H64v48c0 26.2 12.6 49.4 32 64h0v0c13.4 10 30 16 48 16H368c18 0 34.6-6 48-16v0h0c19.4-14.6 32-37.8 32-64V320h32v48c0 30.5-12.2 58.2-32 78.4V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V446.4C44.2 426.2 32 398.5 32 368V320zM200 64c-22.1 0-40 17.9-40 40c0 11.4 4.8 21.7 12.4 29L229 76.4C221.7 68.8 211.4 64 200 64z"]
  },
  cu = {
    prefix: "fal",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M0 48c0-8.8 7.2-16 16-16H144c8.8 0 16 7.2 16 16s-7.2 16-16 16H96V224c0 70.7 57.3 128 128 128s128-57.3 128-128V64H304c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384V224c0 88.4-71.6 160-160 160s-160-71.6-160-160V64H16C7.2 64 0 56.8 0 48zM0 464c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
  },
  su = {
    prefix: "fal",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 48c0-8.8 7.2-16 16-16H48 80 232c66.3 0 120 53.7 120 120c0 38.8-18.4 73.3-46.9 95.2C351.1 264 384 308.1 384 360c0 66.3-53.7 120-120 120H80 48 16c-8.8 0-16-7.2-16-16s7.2-16 16-16H32V256 64H16C7.2 64 0 56.8 0 48zM64 448H80 264c48.6 0 88-39.4 88-88s-39.4-88-88-88H232 64V448zm0-208H232c48.6 0 88-39.4 88-88s-39.4-88-88-88H80 64V240z"]
  },
  lu = {
    prefix: "fal",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 80H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  uu = {
    prefix: "fal",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zm0 96c-8.8 0-16 7.2-16 16s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H144z"]
  },
  du = {
    prefix: "fal",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M64 64C46.3 64 32 78.3 32 96V329.4l67.7-67.7c15.6-15.6 40.9-15.6 56.6 0L224 329.4 355.7 197.7c15.6-15.6 40.9-15.6 56.6 0L480 265.4V96c0-17.7-14.3-32-32-32H64zM32 374.6V416c0 17.7 14.3 32 32 32h41.4l96-96-67.7-67.7c-3.1-3.1-8.2-3.1-11.3 0L32 374.6zM389.7 220.3c-3.1-3.1-8.2-3.1-11.3 0L150.6 448H448c17.7 0 32-14.3 32-32V310.6l-90.3-90.3zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm160 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z"]
  },
  fu = {
    prefix: "fal",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M94.7 360.2c-3.2-5-8.7-8.2-14.7-8.2c-12.3 0-20.3 12.8-13.7 23.2C106 438.2 176.1 480 256 480c123.7 0 224-100.3 224-224S379.7 32 256 32c-56.1 0-107.4 20.6-146.7 54.7L78.6 56c-5.1-5.1-12.1-8-19.3-8C44.2 48 32 60.2 32 75.3V176c0 8.8 7.2 16 16 16H148.7c15.1 0 27.3-12.2 27.3-27.3c0-7.2-2.9-14.2-8-19.3l-36-36C165.5 81.1 208.7 64 256 64c106 0 192 86 192 192s-86 192-192 192c-67.6 0-127.1-35-161.3-87.8zM64 86.6L137.4 160H64V86.6z"]
  },
  pu = {
    prefix: "fal",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM528 336c8.8 0 16-7.2 16-16s-7.2-16-16-16H484.1l40.5 32H528zm0-128c8.8 0 16-7.2 16-16s-7.2-16-16-16H322l40.5 32H528zm-372.1 0l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h43.9zM528 48H159.8l40.5 32H528c8.8 0 16-7.2 16-16s-7.2-16-16-16zM318 336l-40.5-32H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H318zm121.6 96H112c-8.8 0-16 7.2-16 16s7.2 16 16 16H480.2l-40.5-32z"]
  },
  mu = {
    prefix: "fal",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z"]
  },
  hu = mu,
  Au = {
    prefix: "fal",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M170.7 108.3c7.5-4.3 12.9-11.5 15-19.8l12.3-48.6 35 36c6 6.2 14.3 9.7 22.9 9.7s16.9-3.5 22.9-9.7l35-36 12.3 48.6c2.1 8.4 7.5 15.5 15 19.8s16.4 5.4 24.7 3.1l48.3-13.6L400.6 146c-2.3 8.3-1.2 17.2 3.1 24.7s11.5 12.9 19.8 15l48.6 12.3-36 35c-6.2 6-9.7 14.3-9.7 22.9s3.5 16.9 9.7 22.9l36 35-48.6 12.3c-8.4 2.1-15.5 7.5-19.8 15s-5.4 16.4-3.1 24.7l13.6 48.3L366 400.6c-8.3-2.3-17.2-1.2-24.7 3.1s-12.9 11.5-15 19.8l-12.3 48.6-35-36c-6-6.2-14.3-9.7-22.9-9.7s-16.9 3.5-22.9 9.7l-35 36-12.3-48.6c-2.1-8.4-7.5-15.5-15-19.8s-16.4-5.4-24.7-3.1L97.8 414.2 111.4 366c2.3-8.3 1.2-17.2-3.1-24.7s-11.5-12.9-19.8-15L39.8 313.9l36-35c6.2-6 9.7-14.3 9.7-22.9s-3.5-16.9-9.7-22.9l-36-35 48.6-12.3c8.4-2.1 15.5-7.5 19.8-15s5.4-16.4 3.1-24.7L97.8 97.8 146 111.4c8.3 2.3 17.2 1.2 24.7-3.1zM49.6 162.6l-31.5 8c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l23.3 22.6L53.5 256 30.5 278.3 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l31.5 8 31 7.9-8.7 30.8-8.8 31.2c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l31.2-8.8 30.8-8.7 7.9 31 8 31.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l22.6-23.3L256 458.5l22.3 22.9L301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l8-31.5 7.9-31 30.8 8.7 31.2 8.8c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-8.8-31.2-8.7-30.8 31-7.9 31.5-8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-23.3-22.6L458.5 256l22.9-22.3L504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-31.5-8-31-7.9 8.7-30.8 8.8-31.2c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-31.2 8.8-30.8 8.7-7.9-31-8-31.5c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L278.3 30.5 256 53.5 233.7 30.5 211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-8 31.5-7.9 31-30.8-8.7L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l8.8 31.2 8.7 30.8-31 7.9z"]
  },
  gu = {
    prefix: "fal",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M25.9 3.4C19-2 8.9-.8 3.4 6.1S-.8 23.1 6.1 28.6l608 480c6.9 5.5 17 4.3 22.5-2.6s4.3-17-2.6-22.5L25.9 3.4zM390.4 64l149.1 0-11 44.1c-2.1 8.6 3.1 17.3 11.6 19.4s17.3-3.1 19.4-11.6l11-44.1c5-20.2-10.2-39.8-31-39.8h-383c-4.7 0-9.2 1-13.3 2.9L180.1 64l177.1 0L325.1 178.5 352.3 200 390.4 64zM287.7 312L249.6 448H176c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H282.9l32.1-114.5L287.7 312z"]
  },
  vu = {
    prefix: "fal",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm39.2 235.1c-2.7-8.4-11.7-13.1-20.1-10.4s-13.1 11.7-10.4 20.1l56 176c2.2 6.8 8.5 11.3 15.6 11.1s13.2-4.9 15.1-11.8L192 300.8l32.6 119.4c1.9 6.8 8 11.6 15.1 11.8s13.4-4.4 15.6-11.1l56-176c2.7-8.4-2-17.4-10.4-20.1s-17.4 2-20.1 10.4L241.2 359.5 207.4 235.8c-1.9-7-8.2-11.8-15.4-11.8s-13.5 4.8-15.4 11.8L142.8 359.5 103.2 235.1z"]
  },
  Cu = {
    prefix: "fal",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"]
  },
  bu = {
    prefix: "fal",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 48c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H283L135.3 448H240c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16h85L248.7 64H144c-8.8 0-16-7.2-16-16z"]
  },
  Eu = {
    prefix: "fal",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M208 32C105.7 32 32 101.2 32 176c0 37.1 18 68.2 45.1 96.6c4.8 5 5.8 12.5 2.5 18.6c-10.9 20.2-22.7 40.8-37.6 59.9c31.3-3 63.2-13.2 91.5-26c6-2.7 11.9-5.6 18-8.7c3.2-1.6 6.8-2.1 10.2-1.4c15.6 3.1 30.9 5 46.3 5c102.3 0 176-69.2 176-144s-73.7-144-176-144zM0 176C0 78.9 93.1 0 208 0S416 78.9 416 176s-93.1 176-208 176c-16.1 0-31.7-1.8-47-4.6c-4.6 2.3-9.4 4.6-14.3 6.8C110.5 370.7 67 384 24 384c-9.6 0-18.2-5.7-22-14.5c-3.8-8.7-2-18.9 4.4-25.8l.1-.1 0 0C22 326.6 34.3 307.1 46 286C19.8 256.1 0 220.2 0 176zm441.8-47.8C552.2 132.5 640 209.6 640 304c0 44.2-19.8 80.1-46 110c11.7 21 24 40.6 39.5 57.5l0 0 .1 .1c6.5 7 8.2 17.1 4.4 25.8c-3.8 8.8-12.5 14.5-22 14.5c-43 0-86.5-13.3-122.7-29.7c-4.9-2.2-9.6-4.5-14.3-6.8c-15.3 2.8-30.9 4.6-47 4.6c-82.1 0-153-40.2-186.8-98.5c11.5-1.6 22.8-3.9 33.8-6.8C308.4 417.3 363.8 448 432 448c15.3 0 30.6-1.9 46.3-5c3.5-.7 7.1-.2 10.2 1.4c6.1 3.1 12 6 18 8.7c28.4 12.9 60.2 23.1 91.5 26c-14.9-19-26.8-39.7-37.6-59.9c-3.3-6.1-2.3-13.6 2.5-18.6C590 372.2 608 341.1 608 304c0-71-66.4-137-160.6-143.5c-.9-11.1-2.8-21.9-5.6-32.3zM224 83.6V97.4c7.2 1.1 14.1 2.7 20.5 4.4c8.5 2.2 13.7 11 11.4 19.5s-11 13.7-19.5 11.4c-10-2.6-19.7-4.5-28.6-4.7c-7.4-.1-15.1 1.6-20.5 4.7c-4.8 2.8-6.5 5.8-6.4 9.8c0 2.3 .6 4.4 5.7 7.4c6 3.6 14.5 6.2 25.9 9.6l.5 .2 0 0c10.1 3 22.9 6.8 33 13.1c11.2 7 21 18.2 21.2 35.5c.2 18-9.1 30.9-21.5 38.5c-6.7 4.1-14.2 6.7-21.7 8v13.7c0 8.8-7.2 16-16 16s-16-7.2-16-16V254.1c-9.7-1.9-18.8-5-26.7-7.7l0 0 0 0c-1.9-.7-3.8-1.3-5.5-1.9c-8.4-2.8-13-11.8-10.2-20.2s11.8-13 20.2-10.2c2.2 .7 4.4 1.5 6.5 2.2l0 0c12.2 4.1 21.9 7.4 32.3 7.7c8 .3 15.6-1.5 20.5-4.5c4.2-2.6 6.3-5.7 6.2-10.8c0-3.2-1.1-5.6-6.1-8.7c-5.9-3.7-14.5-6.4-25.7-9.8l-1.5-.4 0 0c-9.8-2.9-22-6.6-31.6-12.3c-11-6.6-21.2-17.4-21.3-34.7c-.1-18.1 10.2-30.5 22.3-37.6c6.5-3.8 13.7-6.2 20.8-7.6V83.6c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  yu = {
    prefix: "fal",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M34.2 179.7L154.4 66.2c1.4-1.3 3.5-2.2 5.6-2.2s4.2 .8 5.6 2.2L285.8 179.7c1.4 1.3 2.2 3.2 2.2 5.2c0 3.9-3.2 7.1-7.1 7.1H39.1c-3.9 0-7.1-3.2-7.1-7.1c0-2 .8-3.8 2.2-5.2zm-22-23.3C4.4 163.8 0 174.1 0 184.9C0 206.5 17.5 224 39.1 224H280.9c21.6 0 39.1-17.5 39.1-39.1c0-10.8-4.4-21.1-12.3-28.4L187.6 42.9C180.1 35.9 170.2 32 160 32s-20.1 3.9-27.6 10.9L12.3 156.4zm22 175.9c-1.4-1.3-2.2-3.2-2.2-5.2c0-3.9 3.2-7.1 7.1-7.1H280.9c3.9 0 7.1 3.2 7.1 7.1c0 2-.8 3.8-2.2 5.2L165.6 445.8c-1.4 1.3-3.5 2.2-5.6 2.2s-4.2-.8-5.6-2.2L34.2 332.3zm-22 23.3L132.4 469.1c7.4 7 17.4 10.9 27.6 10.9s20.1-3.9 27.6-10.9L307.7 355.6c7.8-7.4 12.3-17.7 12.3-28.5c0-21.6-17.5-39.1-39.1-39.1H39.1C17.5 288 0 305.5 0 327.1c0 10.8 4.4 21.1 12.3 28.5z"]
  },
  Iu = {
    prefix: "fal",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M32 48c0 8.8 7.2 16 16 16H64V192H32c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H96V48c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3c9.2 10.5 8.9 26.2-.6 36.3L12.3 453.1c-4.3 4.7-5.5 11.5-3 17.3s8.3 9.6 14.7 9.6H128c8.8 0 16-7.2 16-16s-7.2-16-16-16H60.8l60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3c-22.5-25.7-62.1-27.1-86.3-2.9L20.7 316.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z"]
  },
  Bu = {
    prefix: "fal",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 224c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm112-80v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80-80c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16zM448 80V336c0 8.8-7.2 16-16 16s-16-7.2-16-16V80c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  xu = {
    prefix: "fal",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M252.9 33.4L196 96H316L259.1 33.4c-.8-.9-1.9-1.4-3.1-1.4s-2.3 .5-3.1 1.4zm29.8-21.5l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H272V240H384v32H272V384h51.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H240V272H128l0 51.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 51.2H240V128l-51.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM316 416H196l56.9 62.6c.8 .9 1.9 1.4 3.1 1.4s2.3-.5 3.1-1.4L316 416zM478.6 259.1c.9-.8 1.4-1.9 1.4-3.1s-.5-2.3-1.4-3.1L416 196V316l62.6-56.9zm-46.4 85.4c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM33.4 252.9c-.9 .8-1.4 1.9-1.4 3.1s.5 2.3 1.4 3.1L96 316 96 196 33.4 252.9z"]
  },
  wu = {
    prefix: "fal",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M234.4 186.5L97 206.8l99.8 98.8c7.4 7.3 10.8 17.8 9 28.1L182.2 473.2 304 408.1V75.1l-45.5 93.7c-4.6 9.5-13.6 16.1-24.1 17.7zM336 408.2l121.6 65L434.1 333.7c-1.7-10.3 1.6-20.7 9-28.1l99.8-98.8L405.4 186.5c-10.5-1.5-19.5-8.2-24.1-17.7L336 75.4V408.2zm146.2 99.2c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"]
  },
  Qu = {
    prefix: "fal",
    iconName: "code",
    icon: [640, 512, [], "f121", "M405.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1l-160 480c-2.8 8.4 1.7 17.4 10.1 20.2s17.4-1.7 20.2-10.1l160-480c2.8-8.4-1.7-17.4-10.1-20.2zM172 117.4c-5.9-6.6-16-7.2-22.6-1.3l-144 128C2 247.1 0 251.4 0 256s2 8.9 5.4 12l144 128c6.6 5.9 16.7 5.3 22.6-1.3s5.3-16.7-1.3-22.6L40.1 256 170.6 140c6.6-5.9 7.2-16 1.3-22.6zm296.1 0c-5.9 6.6-5.3 16.7 1.3 22.6L599.9 256 469.4 372c-6.6 5.9-7.2 16-1.3 22.6s16 7.2 22.6 1.3l144-128c3.4-3 5.4-7.4 5.4-12s-2-8.9-5.4-12l-144-128c-6.6-5.9-16.7-5.3-22.6 1.3z"]
  },
  Hu = {
    prefix: "fal",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M32 16C32 7.2 24.8 0 16 0S0 7.2 0 16V176 431.7 496c0 8.8 7.2 16 16 16s16-7.2 16-16V447.7H240 544V496c0 8.8 7.2 16 16 16s16-7.2 16-16V431.7 272 176 112C576 50.1 525.9 0 464 0H256c-17.7 0-32 14.3-32 32V160H32V16zM224 288V415.7H32V192H240 544v64H256c-17.7 0-32 14.3-32 32zM544 112v48H256V32H464c44.2 0 80 35.8 80 80zM256 288l288 0V415.7H256V288zM128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 128 0a64 64 0 1 0 0 128zm0 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  zu = {
    prefix: "fal",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M32 30.9C32 13.8 45.9 0 62.9 0H226.2C242.7 0 256 13.3 256 29.8c0 3.2-.5 6.4-1.5 9.4L214.2 160H355.8c15.6 0 28.2 12.6 28.2 28.2c0 5.7-1.7 11.2-4.9 15.9l-203.2 297c-4.6 6.8-12.3 10.8-20.5 10.8c-16.2 0-28-15.2-24.1-30.9L179.5 288H30.9C13.9 288 0 274.1 0 257.1c0-1.5 .1-2.9 .3-4.4L32 30.9zM64 32c0 1.1-.1 2.2-.3 3.3L32.2 256H200c4.9 0 9.6 2.3 12.6 6.2s4.1 8.9 2.9 13.7L171.9 450.2 348.6 192H192c-5.1 0-10-2.5-13-6.6s-3.8-9.5-2.2-14.4L223.1 32H64z"]
  },
  Mu = {
    prefix: "fal",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3L172.5 336l-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9L192 363.9l42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z"]
  },
  ku = {
    prefix: "fal",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm136 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM208 352a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
  },
  Nu = {
    prefix: "fal",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M144 256a112 112 0 1 0 0-224 112 112 0 1 0 0 224zm143.1-96c-8 72-69 128-143.1 128C64.5 288 0 223.5 0 144S64.5 0 144 0c74.1 0 135.2 56 143.1 128h67.6c6.6-18.6 24.4-32 45.3-32h96c26.5 0 48 21.5 48 48s-21.5 48-48 48H400c-20.9 0-38.7-13.4-45.3-32H287.1zM272 320h16 32V288c0-17.7 14.3-32 32-32h96c17.7 0 32 14.3 32 32v32h32 16c8.8 0 16 7.2 16 16s-7.2 16-16 16H512V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V352H272c-8.8 0-16-7.2-16-16s7.2-16 16-16zm80 0h96V288H352v32zm-32 32V464c0 8.8 7.2 16 16 16H464c8.8 0 16-7.2 16-16V352H320zM496 128H400c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16zM192 144a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM64 144a80 80 0 1 1 160 0A80 80 0 1 1 64 144zM0 496c0-8.8 7.2-16 16-16H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16zM160 352v32h16c8.8 0 16-7.2 16-16s-7.2-16-16-16H160zm0-32h16c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h80 16 16zm-32 64V352H64v64h64V384z"]
  },
  Su = {
    prefix: "fal",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 32c53 0 96 43 96 96v64H128V128c0-53 43-96 96-96zM96 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM80 224H368c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48zm160 88c0-8.8-7.2-16-16-16s-16 7.2-16 16v80c0 8.8 7.2 16 16 16s16-7.2 16-16V312z"]
  },
  Vu = {
    prefix: "fal",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M352 128c0-53 43-96 96-96s96 43 96 96v80c0 8.8 7.2 16 16 16s16-7.2 16-16V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H80c-44.2 0-80 35.8-80 80V432c0 44.2 35.8 80 80 80H368c44.2 0 80-35.8 80-80V272c0-44.2-35.8-80-80-80H352V128zm-16 96h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V272c0-26.5 21.5-48 48-48H336z"]
  },
  Lu = {
    prefix: "fal",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
  },
  Pu = {
    prefix: "fal",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M160 208l0-57.3c0-3.7-3-6.7-6.7-6.7c-1.9 0-3.7 .8-5 2.2L35.8 272 148.3 397.8c1.3 1.4 3.1 2.2 5 2.2c3.7 0 6.7-3 6.7-6.7l0-57.3c0-17.7 14.3-32 32-32l176 0c61.9 0 112-50.1 112-112l0-112c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16l0 112c0 26.5-21.5 48-48 48l-176 0c-17.7 0-32-14.3-32-32zM5.3 286C1.9 282.1 0 277.2 0 272s1.9-10.1 5.3-14L124.5 124.9c7.3-8.2 17.8-12.9 28.8-12.9c21.4 0 38.7 17.3 38.7 38.7l0 25.3 0 32 32 0 144 0c8.8 0 16-7.2 16-16l0-112c0-26.5 21.5-48 48-48l32 0c26.5 0 48 21.5 48 48l0 112c0 79.5-64.5 144-144 144l-144 0-32 0 0 32 0 25.3c0 21.4-17.3 38.7-38.7 38.7c-11 0-21.5-4.7-28.8-12.9L5.3 286z"]
  },
  Ou = {
    prefix: "fal",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8H280c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3V288c0 8.8-7.2 16-16 16s-16-7.2-16-16V258.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3H222.9c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  Tu = {
    prefix: "fal",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H176c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm16 128h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H192v96zM456 352h16c22.1 0 40 17.9 40 40v8c0 8.8-7.2 16-16 16s-16-7.2-16-16v-8c0-4.4-3.6-8-8-8H456c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8v-8c0-8.8 7.2-16 16-16s16 7.2 16 16v8c0 22.1-17.9 40-40 40H456c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40zM288 392c0-22.1 17.9-40 40-40h16c22.1 0 40 17.9 40 40v80c0 22.1-17.9 40-40 40H328c-22.1 0-40-17.9-40-40V392zm40-8c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H328z"]
  },
  Du = {
    prefix: "fal",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z"]
  },
  Ru = {
    prefix: "fal",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c8.8 0 16 7.2 16 16v96c0 38.1 12.4 75.1 35.2 105.6l19.2 25.6c27 36 41.6 79.8 41.6 124.8v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V400c0-38.1-12.4-75.1-35.2-105.6l-19.2-25.6C174.6 232.8 160 189 160 144V48c0-8.8 7.2-16 16-16zM16 96c8.8 0 16 7.2 16 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6L34.9 273.2C12.2 239.1 0 198.9 0 157.9V112c0-8.8 7.2-16 16-16zm336 16v45.9c0 34.7 10.3 68.7 29.6 97.6l31.5 47.3c22.8 34.2 34.9 74.3 34.9 115.4V464c0 8.8-7.2 16-16 16s-16-7.2-16-16V418.1c0-34.7-10.3-68.7-29.6-97.6l-31.5-47.3C332.2 239.1 320 198.9 320 157.9V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  Gu = {
    prefix: "fal",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V65.8c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V96zM96 64H288v96H96V64zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]
  },
  Fu = {
    prefix: "fal",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64v0C0 300.7 183.5 494.5 416 510.9c4.5 .3 9.1 .6 13.7 .8c0 0 0 0 0 0c0 0 0 0 .1 0c6.1 .2 12.1 .4 18.3 .4l0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM447.7 480C218.1 479.8 32 293.7 32 64v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0-3.8 2.6-7 6.3-7.8l112-24c3.7-.8 7.5 1.2 9 4.7l48 112c1.4 3.3 .5 7.1-2.3 9.3l-40.6 33.2c-12.1 9.9-15.3 27.2-7.4 40.8c29.5 50.9 71.9 93.3 122.7 122.7c13.6 7.9 30.9 4.7 40.8-7.4l33.2-40.6c2.3-2.8 6.1-3.7 9.3-2.3l112 48c3.5 1.5 5.5 5.3 4.7 9l-24 112c-.8 3.7-4.1 6.3-7.8 6.3c-.1 0-.2 0-.3 0z"]
  },
  ju = {
    prefix: "fal",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M80 64c-26.5 0-48 21.5-48 48v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V112C0 67.8 35.8 32 80 32h42.4H128 453.6C468.2 32 480 43.8 480 58.4c0 3.7-.8 7.3-2.3 10.7l-48.4 109c50 34.7 82.7 92.5 82.7 157.9v8c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344v-8c0-65.4 32.7-123.2 82.7-157.9L98.3 69.1c-.7-1.6-1.3-3.4-1.7-5.1H80zm365 0H131l49.8 112H395.2L445 64zM416 208H160l0 0c-26.4 19.9-46.5 47.7-56.7 80H472.7c-10.1-32.3-30.2-60.1-56.7-80l0 0zm63.2 112H96.8c-.5 5.3-.8 10.6-.8 16v8c0 42.6 27.2 78.8 46.8 98.8c2.7 2.8 7.7 5.2 15.2 5.2H418c7.5 0 12.5-2.4 15.2-5.2c19.6-20 46.8-56.2 46.8-98.8v-8c0-5.4-.3-10.7-.8-16z"]
  },
  Ju = {
    prefix: "fal",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M177.7 32h92.5c5.5 0 10.6 2.8 13.6 7.5L299.1 64H148.9l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0H177.7C161.2 0 145.8 8.5 137 22.6L111.1 64H64.1 32 16C7.2 64 0 71.2 0 80s7.2 16 16 16H34.3L59.8 452.6C62.1 486.1 90 512 123.6 512H324.4c33.6 0 61.4-25.9 63.8-59.4L413.7 96H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H416 383.9 336.9zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480H123.6c-16.8 0-30.7-13-31.9-29.7L66.4 96H381.6z"]
  },
  Zu = {
    prefix: "fal",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z"]
  },
  Wu = {
    prefix: "fal",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M16 48C7.2 48 0 55.2 0 64s7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zm0 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM0 320c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16s-7.2-16-16-16H16c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  Xu = {
    prefix: "fal",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM208 288v24 48 24H96V288H208zm32 96v-.4l58.1 23.2c4.9 2 10.5 1.4 14.9-1.6s7-7.9 7-13.2V280c0-5.3-2.6-10.3-7-13.2s-10-3.6-14.9-1.6L240 288.4V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H208c17.7 0 32-14.3 32-32zm48-15.6l-48-19.2V322.8l48-19.2v64.7z"]
  },
  Uu = {
    prefix: "fal",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M320 33c0-18.2 14.8-33 33-33H480c17.7 0 32 14.3 32 32V159c0 18.2-14.8 33-33 33c-8.7 0-17.1-3.5-23.3-9.7L404 130.6 235.3 299.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L381.4 108 329.7 56.3C323.5 50.1 320 41.7 320 33zm33-1c-.5 0-1 .4-1 1c0 .3 .1 .5 .3 .7L478.3 159.7c.2 .2 .4 .3 .7 .3c.5 0 1-.4 1-1V32H353zM0 96C0 60.7 28.7 32 64 32H208c8.8 0 16 7.2 16 16s-7.2 16-16 16H64C46.3 64 32 78.3 32 96V448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32V304c0-8.8 7.2-16 16-16s16 7.2 16 16V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"]
  },
  Ku = {
    prefix: "fal",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M64 480H96v32H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V288H352V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM176 352h32c30.9 0 56 25.1 56 56s-25.1 56-56 56H192v32c0 8.8-7.2 16-16 16s-16-7.2-16-16V448 368c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24H192v48h16zm96-80h32c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H304c-8.8 0-16-7.2-16-16V368c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H320v96h16zm80-112c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v32h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H448v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V432 368z"]
  },
  Yu = {
    prefix: "fal",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 352H424c14.7 0 27.5 10 31 24.2l3.6 14.3c8.4 33.8 38.8 57.4 73.6 57.4c41.9 0 75.8-33.9 75.8-75.8v-2.8c0-4.5-.4-8.9-1.1-13.3L574.1 165.3c-7-40.7-32.2-71.3-66.5-79.9C464.1 74.5 401.1 64 320 64s-144.1 10.5-187.6 21.4C98 93.9 72.8 124.5 65.9 165.3L33.1 356.1c-.8 4.4-1.1 8.8-1.1 13.3v2.8c0 41.9 33.9 75.8 75.8 75.8c34.8 0 65.1-23.7 73.6-57.4l3.6-14.3c3.6-14.2 16.4-24.2 31-24.2zm211.6 46.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM208 160v48h48c8.8 0 16 7.2 16 16s-7.2 16-16 16H208v48c0 8.8-7.2 16-16 16s-16-7.2-16-16V240H128c-8.8 0-16-7.2-16-16s7.2-16 16-16h48V160c0-8.8 7.2-16 16-16s16 7.2 16 16zM408 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88-120a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  qu = {
    prefix: "fal",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M224 24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H496c61.9 0 112 50.1 112 112v8c0 22.1-17.9 40-40 40H549.6L628 254.7c7.6 6.1 12 15.3 12 25V384c0 17.7-14.3 32-32 32H574.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-5.5 .6-10.8 1.6-16H400 254.4c1 5.2 1.6 10.5 1.6 16c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-7.7 1.1-15.2 3.1-22.2L18.7 329.4C6.7 317.4 0 301.1 0 284.1V96C0 60.7 28.7 32 64 32H224V24zM64 64C46.3 64 32 78.3 32 96V284.1c0 8.5 3.4 16.6 9.4 22.6l73.6 73.6C129.6 363 151.5 352 176 352c26.2 0 49.4 12.6 64 32H384V176c0-8.8 7.2-16 16-16H568c4.4 0 8-3.6 8-8v-8c0-44.2-35.8-80-80-80H384 352V32H256V64H224 64zM176 384a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm320 0a48 48 0 1 0 0 96 48 48 0 1 0 0-96zm-64 0c14.6-19.4 37.8-32 64-32s49.4 12.6 64 32h48V288H416v96h16zM416 192v64H578.4l-80-64H416zM128 224H288V160H128v64zM96 152c0-13.3 10.7-24 24-24H296c13.3 0 24 10.7 24 24v80c0 13.3-10.7 24-24 24H120c-13.3 0-24-10.7-24-24V152z"]
  },
  _u = {
    prefix: "fal",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M64 32C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm104 8a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM325.7 351c-7 .7-14.3 1-21.7 1c-41.8 0-72.9-20.8-95.7-36l-2.1-1.4c-25-16.7-41.3-26.6-62.2-26.6c-9.8 0-20.6 1.6-31.4 4c-.4 3.9-.6 7.9-.6 12c0 61.9 50.1 112 112 112c45.1 0 84-26.6 101.7-65zm9.5-33.4c.5-4.4 .8-8.9 .8-13.5c0-61.9-50.1-112-112-112c-45.3 0-84.4 27-102 65.7c7.4-1.1 14.8-1.7 22-1.7c32 0 56 16 80 32s48 32 80 32c10.9 0 21.4-.9 31.2-2.5zM80 304a144 144 0 1 1 288 0A144 144 0 1 1 80 304z"]
  },
  $u = {
    prefix: "fal",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 96c-17.7 0-32 14.3-32 32v39.9L227.6 311.3c16.9 12.4 39.9 12.4 56.8 0L480 167.9V128c0-17.7-14.3-32-32-32H64zM32 207.6V384c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V207.6L303.3 337.1c-28.2 20.6-66.5 20.6-94.6 0L32 207.6zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
  },
  ed = {
    prefix: "fal",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M380.7 67.3c-29.1-29.1-76.3-29.1-105.4 0l-192 192c-46.8 46.8-46.8 122.6 0 169.4s122.6 46.8 169.4 0l152-152c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-152 152c-59.3 59.3-155.4 59.3-214.6 0S1.4 296 60.7 236.7l192-192c41.6-41.6 109-41.6 150.6 0s41.6 109 0 150.6L219.5 379.1c-28.2 28.2-74.6 25.6-99.6-5.5c-21.3-26.6-19.2-65 4.9-89.1L276.7 132.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L147.5 307.1c-12.6 12.6-13.7 32.6-2.6 46.5c13 16.2 37.2 17.6 51.9 2.9L380.7 172.7c29.1-29.1 29.1-76.3 0-105.4z"]
  },
  td = {
    prefix: "fal",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM505.4 67.1c-7.1-5.2-17.2-3.6-22.4 3.5L383.3 207.8C363 235.7 352 269.4 352 304c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-15 0-29.6 2.3-43.2 6.6l56.1-77.2c5.2-7.1 3.6-17.2-3.5-22.4zM496 192a112 112 0 1 1 0 224 112 112 0 1 1 0-224z"]
  },
  nd = {
    prefix: "fal",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V240c0-8.8-7.2-16-16-16H216c-8.8 0-16 7.2-16 16s7.2 16 16 16h24v96H208zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  rd = {
    prefix: "fal",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0c-8.8 0-16-7.2-16-16zm80 80H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm160 96h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  od = {
    prefix: "fal",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z"]
  },
  id = {
    prefix: "fal",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.1-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.1-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z"]
  },
  ad = {
    prefix: "fal",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M384 32c17.7 0 32 14.3 32 32V320H32V64c0-17.7 14.3-32 32-32H384zm32 320v96c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V352H416zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM176 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H192c-8.8 0-16 7.2-16 16z"]
  },
  cd = {
    prefix: "fal",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0c44.2 0 80-35.8 80-80l0-377.4L308.7 155.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0l-128 128c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 54.6 176 432c0 26.5-21.5 48-48 48L16 480z"]
  },
  sd = {
    prefix: "fal",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112V256c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4V112c0-8.8-7.2-16-16-16s-16 7.2-16 16z"]
  },
  ld = {
    prefix: "fal",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M288 32c17.7 0 32 14.3 32 32V320H64V64c0-17.7 14.3-32 32-32H288zm32 320v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V352H320zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm48 416c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16z"]
  },
  ud = {
    prefix: "fal",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z"]
  },
  dd = {
    prefix: "fal",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z"]
  },
  fd = {
    prefix: "fal",
    iconName: "download",
    icon: [512, 512, [], "f019", "M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16V329.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4V16zM140.1 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H371.9l-32 32H448c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V384c0-17.7 14.3-32 32-32H172.1l-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  pd = {
    prefix: "fal",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M96 32C60.7 32 32 60.7 32 96v64H416V96c0-35.3-28.7-64-64-64H96zM32 192V448c0 17.7 14.3 32 32 32H384c17.7 0 32-14.3 32-32V192H32zM0 96C0 43 43 0 96 0H352c53 0 96 43 96 96V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM104 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM264 80a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM96 256V416H352V256H96zm-32 0c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 48c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H144c-8.8 0-16-7.2-16-16z"]
  },
  md = {
    prefix: "fal",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M112 48c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112zM16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM96 320c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM16 432c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  hd = {
    prefix: "fal",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235V432c0 44.2 35.8 80 80 80H432c44.2 0 80-35.8 80-80V235l37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432V206.7L288 37.3 480 206.7V432c0 26.5-21.5 48-48 48H368V320c0-17.7-14.3-32-32-32H240c-17.7 0-32 14.3-32 32V480H144c-26.5 0-48-21.5-48-48zm144 48V320h96V480H240z"]
  },
  Ad = {
    prefix: "fal",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M417.3 360.2c3.2-5 8.7-8.2 14.7-8.2c12.3 0 20.3 12.8 13.7 23.2C406 438.2 335.9 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c56.1 0 107.4 20.6 146.7 54.7L433.4 56c5.1-5.1 12.1-8 19.3-8C467.8 48 480 60.2 480 75.3V176c0 8.8-7.2 16-16 16H363.3c-15.1 0-27.3-12.2-27.3-27.3c0-7.2 2.9-14.2 8-19.3l36-36C346.5 81.1 303.3 64 256 64C150 64 64 150 64 256s86 192 192 192c67.6 0 127.1-35 161.3-87.8zM448 86.6L374.6 160H448V86.6z"]
  },
  gd = {
    prefix: "fal",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9V176c0 26.5 21.5 48 48 48h32 32c26.5 0 48-21.5 48-48V165.3c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2V176c0 44.2-35.8 80-80 80H128V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V256H80c-44.2 0-80-35.8-80-80V165.3c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176V288c0 17.7 14.3 32 32 32h64V32.2l-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32V320v16 16V496c0 8.8-7.2 16-16 16s-16-7.2-16-16V352H352c-35.3 0-64-28.7-64-64V176C288 32 400 0 416 0z"]
  },
  vd = {
    prefix: "fal",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M16 80C7.2 80 0 87.2 0 96s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM144 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144zM128 416c0 8.8 7.2 16 16 16H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H144c-8.8 0-16 7.2-16 16zM0 432c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16s-16 7.2-16 16V432z"]
  },
  Cd = {
    prefix: "fal",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M272 54.6V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V54.6L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352H64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V384c0-17.7-14.3-32-32-32H304V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H208v32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  bd = {
    prefix: "fal",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M306.8 6.3C311.4 2.2 317.3 0 323.4 0c17.2 0 29.2 17.1 23.4 33.3L278.7 224H389c14.9 0 27 12.1 27 27c0 7.8-3.3 15.1-9.1 20.3L141.1 505.8c-4.5 4-10.4 6.2-16.5 6.2c-17.2 0-29.2-17.1-23.5-33.3L169.3 288H57.8C43.6 288 32 276.4 32 262.2c0-7.4 3.2-14.4 8.7-19.3L306.8 6.3zm.5 42.4L74.1 256H192c5.2 0 10.1 2.5 13.1 6.8s3.7 9.7 2 14.6L140.6 463.6 375.8 256H256c-5.2 0-10.1-2.5-13.1-6.8s-3.7-9.7-2-14.6l66.4-186z"]
  },
  Ed = {
    prefix: "fal",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M0 16C0 7.2 7.2 0 16 0H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 32 0 24.8 0 16zM64 196.8c5-1.6 10.2-3.2 15.4-4.6C121 181.2 174.5 176 224 176s103 5.2 144.6 16.3c5.3 1.4 10.4 2.9 15.4 4.6V64h32V210.6c2.1 1.2 4.2 2.5 6.1 3.8c13.9 9.4 25.9 23 25.9 41.6c0 69.8-35.8 118.1-81 148.5l15.2 51c1.2 4.1 1.8 8.3 1.8 12.5c0 24.3-19.7 43.9-43.9 43.9H107.9C83.7 512 64 492.3 64 468.1c0-4.2 .6-8.5 1.8-12.5l15.2-51C35.8 374.1 0 325.8 0 256c0-18.5 12-32.2 25.9-41.6c1.9-1.3 4-2.6 6.1-3.8V64H64V196.8zM40.3 305.7c11.3 31.6 33.2 55.4 59.7 72.9C139.4 404.7 188.2 416 224 416s84.6-11.3 124.1-37.3c26.5-17.5 48.4-41.3 59.7-72.9c-11.5 5.6-24.9 10.2-39.2 14C327 330.8 273.5 336 224 336s-103-5.2-144.6-16.3c-14.3-3.8-27.6-8.4-39.2-14zM416 256c0-3.1-1.8-8.3-11.8-15c-9.8-6.6-24.7-12.7-43.9-17.8C322.2 213.1 271.7 208 224 208s-98.2 5.1-136.3 15.2c-19.2 5.1-34.1 11.2-43.9 17.8C33.8 247.7 32 252.9 32 256s1.8 8.3 11.8 15c9.8 6.6 24.7 12.7 43.9 17.8C125.8 298.9 176.3 304 224 304s98.2-5.1 136.3-15.2c19.2-5.1 34.1-11.2 43.9-17.8c9.9-6.7 11.8-11.9 11.8-15zM112 64h32c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM351.5 464.7l-13.1-43.8C299.6 439.7 257.3 448 224 448s-75.6-8.3-114.4-27.2L96.5 464.7c-.3 1.1-.5 2.3-.5 3.4c0 6.6 5.3 11.9 11.9 11.9H340.1c6.6 0 11.9-5.3 11.9-11.9c0-1.2-.2-2.3-.5-3.4z"]
  },
  yd = {
    prefix: "fal",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 32C46.3 32 32 46.3 32 64V192c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V192c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zm112 64H464c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 288V432c0 44.2-35.8 80-80 80s-80-35.8-80-80c0-29.6 16.1-55.5 40-69.3c7.6-4.4 17.4-1.8 21.9 5.8s1.8 17.4-5.8 21.9c-14.4 8.3-24 23.8-24 41.6c0 26.5 21.5 48 48 48s48-21.5 48-48V288h32zm64 112V288h32V400c0 26.5 21.5 48 48 48s48-21.5 48-48c0-17.7-9.6-33.3-24-41.6c-7.6-4.4-10.3-14.2-5.8-21.9s14.2-10.3 21.9-5.8c23.9 13.8 40 39.7 40 69.3c0 44.2-35.8 80-80 80s-80-35.8-80-80z"]
  },
  Id = {
    prefix: "fal",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M288.8 430.3c3.5 12.8 16.7 20.3 29.5 16.8s20.3-16.7 16.8-29.5l-4.5-16.4c-5.5-20.2-13.9-39.3-24.7-56.9c-3.1-4.9-3.2-11.1-.4-16.2s8.2-8.2 14-8.2H448c17.7 0 32-14.3 32-32c0-11.3-5.9-21.3-14.8-27c-7.2-4.6-9.5-13.9-5.3-21.3c2.6-4.6 4.1-10 4.1-15.7c0-12.4-7-23.1-17.3-28.5c-4.2-2.2-7.3-6.1-8.3-10.8s.1-9.5 3-13.2c4.2-5.4 6.7-12.2 6.7-19.5c0-14.2-9.2-26.3-22.1-30.4c-7.8-2.5-12.4-10.6-10.7-18.6c.5-2.2 .7-4.5 .7-6.9c0-17.7-14.3-32-32-32H294.5c-15.8 0-31.2 4.7-44.4 13.4l-38.5 25.7c-9 6-16.6 13.7-22.4 22.6c-4.9 7.4-14.8 9.4-22.2 4.6s-9.4-14.8-4.6-22.2c8.1-12.3 18.7-23.1 31.4-31.6l38.5-25.7c18.4-12.3 40-18.8 62.1-18.8H384c35.3 0 64 28.7 64 64l0 .6c19.1 11.1 32 31.7 32 55.4c0 8.7-1.8 17.1-4.9 24.7C487.9 188.4 496 205.2 496 224c0 6.5-1 12.8-2.8 18.7C504.8 254.3 512 270.3 512 288c0 35.3-28.7 64-64 64H346.4c6.2 13.1 11.3 26.7 15.1 40.9l4.5 16.4c8.1 29.8-9.5 60.6-39.3 68.8s-60.6-9.5-68.8-39.3l-4.5-16.4c-8.9-32.6-29.6-60.8-58.2-79l-3.1-2 8.2-12.9-8.2 12.9c-11.8-7.5-21.7-17.1-29.5-28.2c-5.1-7.2-3.3-17.2 4-22.3s17.2-3.3 22.3 4c5.4 7.7 12.2 14.4 20.4 19.5l3.1 2c35.3 22.4 60.9 57.2 71.9 97.5l4.5 16.4zM32 352H96V128H32V352zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  Bd = {
    prefix: "fal",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-144-144c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l441.4 0L340.7 388.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l144-144z"]
  },
  xd = {
    prefix: "fal",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"]
  },
  wd = {
    prefix: "fal",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M176 64H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 288H80c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V336c0-8.8-7.2-16-16-16zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c8.8 0 16 7.2 16 16v80h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H400v80c0 8.8-7.2 16-16 16s-16-7.2-16-16V400H288c-8.8 0-16-7.2-16-16s7.2-16 16-16h80V288c0-8.8 7.2-16 16-16z"]
  },
  Qd = {
    prefix: "fal",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M256 32c-35.3 0-64 28.7-64 64H320c0-35.3-28.7-64-64-64zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM36.7 100.7c6.2-6.2 16.4-6.2 22.6 0L138.6 180c17.2-12.6 38.4-20 61.4-20H312c22.9 0 44.2 7.4 61.4 20l79.3-79.3c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L396 202.6c12.6 17.2 20 38.4 20 61.4v8h80c8.8 0 16 7.2 16 16s-7.2 16-16 16H416v16c0 30.2-8.4 58.4-22.9 82.5l82.2 82.2c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-79-79C344.5 460.1 302.6 480 256 480s-88.5-19.9-117.7-51.6l-79 79c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l82.2-82.2C104.4 378.4 96 350.2 96 320V304H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H96v-8c0-22.9 7.4-44.2 20-61.4L36.7 123.3c-6.2-6.2-6.2-16.4 0-22.6zM128 320c0 65.3 48.9 119.1 112 127V256c0-8.8 7.2-16 16-16s16 7.2 16 16V447c63.1-7.9 112-61.7 112-127V288 264c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v24 32z"]
  },
  Hd = {
    prefix: "fal",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 64C46.3 64 32 78.3 32 96v32H544V96c0-17.7-14.3-32-32-32H64zM32 160v64H544V160H32zm0 96V416c0 17.7 14.3 32 32 32H512c17.7 0 32-14.3 32-32V256H32zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 368c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16zm128 0c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"]
  },
  zd = {
    prefix: "fal",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M192 416c0-17.7-14.3-32-32-32H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H448c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H309.3c-6.9 0-13.7 2.2-19.2 6.4L192 464V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h64 32v32 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  Md = {
    prefix: "fal",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V336v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V416H608v48c0 8.8 7.2 16 16 16s16-7.2 16-16V400 336 240c0-61.9-50.1-112-112-112H304c-26.5 0-48 21.5-48 48V320H32V48zM608 384H32V352H272 608v32zm0-144v80H288V176c0-8.8 7.2-16 16-16H528c44.2 0 80 35.8 80 80zM96 208a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"]
  },
  kd = {
    prefix: "fal",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16V32.8c80.9 8 144 76.2 144 159.2v29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3H44.3C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1V192c0-83 63.1-151.2 144-159.2V16zm16 48C153.3 64 96 121.3 96 192v29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3H403.7c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2V192c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z"]
  },
  Nd = {
    prefix: "fal",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M352 192c0-88.4-71.6-160-160-160S32 103.6 32 192c0 15.6 5.4 37 16.6 63.4c10.9 25.9 26.2 54 43.6 82.1c34.1 55.3 74.4 108.2 99.9 140c25.4-31.8 65.8-84.7 99.9-140c17.3-28.1 32.7-56.3 43.6-82.1C346.6 229 352 207.6 352 192zm32 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-240 0a48 48 0 1 0 96 0 48 48 0 1 0 -96 0zm48 80a80 80 0 1 1 0-160 80 80 0 1 1 0 160z"]
  },
  Sd = {
    prefix: "fal",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M352 448V192H240c-26.5 0-48-21.5-48-48V32H64C46.3 32 32 46.3 32 64V448c0 17.7 14.3 32 32 32H320c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2V144c0 8.8 7.2 16 16 16H351.5zM0 64C0 28.7 28.7 0 64 0H220.1c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
  },
  Vd = {
    prefix: "fal",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M104 128a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm0 112a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm29.8 122.8c-9.7-6.6-18-14-25.9-21.9c-6.6-6.5-17.2-6.5-23.8 0c-7.9 7.9-16.1 15.2-25.9 21.9c-12.8 8.7-28.1 16.6-44 19.8C6.4 384.1 0 390.4 0 398.2c0 9.8 8 17.9 17.7 16.2c23.1-4 43.6-15 58.5-25.2c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C134.4 401.9 161.7 416 192 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3C326.4 401.9 353.7 416 384 416s57.5-14.1 76.2-26.8c7.9-5.4 14.6-10.8 19.8-15.3c5.1 4.5 11.9 9.9 19.8 15.3c15 10.2 35.4 21.2 58.5 25.2c9.7 1.7 17.7-6.4 17.7-16.2c0-7.9-6.4-14.1-14.1-15.7c-16-3.1-31.3-11.1-44.1-19.8c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C425.6 374 404.9 384 384 384s-41.7-9.9-58.2-21.2c-9.8-6.7-18-14-26-21.9c-6.6-6.5-17.2-6.5-23.7 0c-7.9 7.9-16.1 15.2-25.9 21.9C233.6 374 212.9 384 192 384s-41.7-9.9-58.2-21.2zM258.4 185L412.3 315.5c10.7-3.5 21.4-8.8 30.9-15.4l.2-.2-163-138.3C309.5 140.5 345.3 128 384 128h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-114.9 0-208 93.1-208 208v14.8c5.5 1.1 10.9 1.7 16 1.7c5.4 0 10.7-.5 16-1.6V304c0-46.8 18.3-89.4 48.1-121l2.3 2z"]
  },
  Ld = {
    prefix: "fal",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M32 416V327.9c0-2.6 .3-5.2 1-7.8l0-.1H134.1l23.2 46.3c5.4 10.8 16.5 17.7 28.6 17.7H326.1c12.1 0 23.2-6.8 28.6-17.7L377.9 320H479l0 .1c.6 2.5 1 5.1 1 7.8V416c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32zM471 288H377.9c-12.1 0-23.2 6.8-28.6 17.7L326.1 352H185.9l-23.2-46.3c-5.4-10.8-16.5-17.7-28.6-17.7H41L90.9 88.2C94.5 74 107.3 64 122 64H390c14.7 0 27.5 10 31 24.2L471 288zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
  },
  Pd = {
    prefix: "fal",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M392 32H120c-13.3 0-24 10.7-24 24V222.5L77.5 207.2c-4.2-3.4-8.7-6.3-13.5-8.6V56C64 25.1 89.1 0 120 0H392c30.9 0 56 25.1 56 56V198.6c-4.8 2.3-9.3 5.2-13.4 8.6L416 222.5V56c0-13.3-10.7-24-24-24zM35 256c-1.6 0-3 1.3-3 3V448c0 17.7 14.3 32 32 32H448c17.7 0 32-14.3 32-32V259c0-1.6-1.3-3-3-3c-.7 0-1.3 .2-1.9 .7L294.5 405.1C283.7 414 270 418.9 256 418.9s-27.7-4.9-38.5-13.8L36.8 256.7c-.5-.4-1.2-.7-1.9-.7zM0 259c0-19.3 15.6-35 35-35c8.1 0 15.9 2.8 22.2 7.9L237.8 380.3c5.1 4.2 11.6 6.5 18.2 6.5s13.1-2.3 18.2-6.5L454.9 231.9c6.3-5.1 14.1-7.9 22.2-7.9c19.3 0 35 15.6 35 35V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V259zM176 128H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Od = {
    prefix: "fal",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M32 192c0-88.4 71.6-160 160-160h64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H384l0 400c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-400H288V464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-112H192c-88.4 0-160-71.6-160-160zM256 320V64H192C121.3 64 64 121.3 64 192s57.3 128 128 128h64z"]
  },
  Td = {
    prefix: "fal",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M112 0c-8.8 0-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16c0-8.8-7.2-16-16-16zM256 352H192c-88.4 0-160-71.6-160-160H416c0 88.4-71.6 160-160 160zM32 160c-17.7 0-32 14.3-32 32c0 80.5 49.5 149.4 119.7 177.9l-7.4 16.2c-5.2-1.4-10.7-2.1-16.4-2.1c-35.3 0-64 28.7-64 64s28.7 64 64 64c29.8 0 54.9-20.4 62-48H335.9l17.6 38.6c3.7 8 13.1 11.6 21.2 7.9s11.6-13.1 7.9-21.2L328.3 369.9C398.5 341.4 448 272.5 448 192c0-17.7-14.3-32-32-32H32zM140.4 401.9l10.2-22.4c13.4 2.9 27.2 4.5 41.5 4.5h64c14.2 0 28.1-1.5 41.5-4.5L321.3 432H158c-3-11.7-9.2-22-17.6-30.1zM64 448a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM224 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v4c0 17.6 8.3 34.2 22.4 44.8l32 24c6 4.5 9.6 11.6 9.6 19.2v4c0 8.8 7.2 16 16 16s16-7.2 16-16v-4c0-17.6-8.3-34.2-22.4-44.8l-32-24c-6-4.5-9.6-11.6-9.6-19.2V16z"]
  },
  Dd = {
    prefix: "fal",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z"]
  },
  Rd = {
    prefix: "fal",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z"]
  },
  Gd = {
    prefix: "fal",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M26.5 4C21.8-.2 15.1-1.2 9.4 1.4S0 9.7 0 16V496c0 6.3 3.7 12 9.4 14.6s12.4 1.6 17.1-2.5l52.7-46.1 45.4 45.4c6.2 6.2 16.4 6.2 22.6 0L192 462.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0l45.4-45.4L357.5 508c4.7 4.1 11.4 5.1 17.1 2.5s9.4-8.3 9.4-14.6V16c0-6.3-3.7-12-9.4-14.6S362.2-.2 357.5 4L304.7 50.1 259.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L192 49.4 147.3 4.7c-6.2-6.2-16.4-6.2-22.6 0L79.3 50.1 26.5 4zM32 460.7V51.3L69.5 84c6.3 5.5 15.9 5.2 21.8-.7L136 38.6l44.7 44.7c6.2 6.2 16.4 6.2 22.6 0L248 38.6l44.7 44.7c6 6 15.5 6.3 21.8 .7L352 51.3V460.7L314.5 428c-6.3-5.5-15.9-5.2-21.8 .7L248 473.4l-44.7-44.7c-6.2-6.2-16.4-6.2-22.6 0L136 473.4 91.3 428.7c-6-6-15.5-6.3-21.8-.7L32 460.7zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z"]
  },
  Fd = {
    prefix: "fal",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M267.3 395.3c-6.2 6.2-16.4 6.2-22.6 0l-192-192c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L256 361.4 436.7 180.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-192 192z"]
  },
  jd = {
    prefix: "fal",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M64 32C46.3 32 32 46.3 32 64V384c0 17.7 14.3 32 32 32H576c17.7 0 32-14.3 32-32V64c0-17.7-14.3-32-32-32H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM112 480H528c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]
  },
  Jd = {
    prefix: "fal",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
  },
  Zd = {
    prefix: "fal",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M412.1 416.6C398.1 361.1 347.9 320 288 320H224c-59.9 0-110.1 41.1-124.1 96.6C58 375.9 32 319 32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 63-26 119.9-67.9 160.6zm-28.5 23.4C347.5 465.2 303.5 480 256 480s-91.5-14.8-127.7-39.9c4-49.3 45.3-88.1 95.7-88.1h64c50.4 0 91.6 38.8 95.7 88.1zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-256a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm-80-48a80 80 0 1 0 160 0 80 80 0 1 0 -160 0z"]
  },
  Wd = {
    prefix: "fal",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 80c0-8.8 7.2-16 16-16H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zM288 400c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16h96c8.8 0 16 7.2 16 16z"]
  },
  Xd = {
    prefix: "fal",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32c-8.8 0-16 7.2-16 16s7.2 16 16 16H208V448c0 8.8 7.2 16 16 16s16-7.2 16-16V272H416c8.8 0 16-7.2 16-16s-7.2-16-16-16H240V64z"]
  },
  Ud = {
    prefix: "fal",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"]
  },
  Kd = {
    prefix: "fal",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zm400.1 41.5c19.2-16.5 43.7-25.5 69-25.5H507c47 0 85 38.1 85 85c0 23.1-9.4 45.2-26.1 61.2l-185 178.2c-4.7 4.5-6.2 11.5-3.7 17.5s8.3 10 14.8 10H624c8.8 0 16-7.2 16-16s-7.2-16-16-16H431.7L588.1 265.3C611.1 243.3 624 212.8 624 181c0-64.6-52.4-117-117-117h-5.8c-33 0-64.8 11.8-89.9 33.2l-21.7 18.6c-6.7 5.8-7.5 15.9-1.7 22.6s15.8 7.5 22.6 1.7l21.7-18.6z"]
  },
  Yd = {
    prefix: "fal",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M170.1 33.1c3.3-1.3 6.9-1.5 10.3-.5L399.1 95.1l144-57.6c15.8-6.3 32.9 5.3 32.9 22.3V394.6c0 9.8-6 18.6-15.1 22.3l-155 62c-3.3 1.3-6.9 1.5-10.3 .5L176.9 416.9l-144 57.6C17.1 480.8 0 469.2 0 452.2V117.4c0-9.8 6-18.6 15.1-22.3l155-62zM32 122.8V440.4l128-51.2V71.6L32 122.8zm352 320V124.1L192 69.2V387.9l192 54.9zm32-2.4l128-51.2V71.6L416 122.8V440.4z"]
  },
  qd = {
    prefix: "fal",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48V400c0 44.2 35.8 80 80 80H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-26.5 0-48-21.5-48-48V48zM192 184a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm120 72a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm56-216a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM160 344a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]
  },
  _d = {
    prefix: "fal",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z"]
  },
  $d = {
    prefix: "fal",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z"]
  },
  ef = {
    prefix: "fal",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z"]
  },
  tf = {
    prefix: "fal",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M426.1 301.2C406.2 376.5 337.6 432 256 432c-51 0-96.9-21.7-129-56.3l41-41c5.1-5.1 8-12.1 8-19.3c0-15.1-12.2-27.3-27.3-27.3H48c-8.8 0-16 7.2-16 16V404.7C32 419.8 44.2 432 59.3 432c7.2 0 14.2-2.9 19.3-8l25.7-25.7C142.3 438.7 196.2 464 256 464c97.4 0 179.2-67 201.8-157.4c2.4-9.7-5.2-18.6-15.2-18.6c-7.8 0-14.5 5.6-16.5 13.2zM385 136.3l-41 41c-5.1 5.1-8 12.1-8 19.3c0 15.1 12.2 27.3 27.3 27.3H464c8.8 0 16-7.2 16-16V107.3C480 92.2 467.8 80 452.7 80c-7.2 0-14.2 2.9-19.3 8l-25.7 25.7C369.7 73.3 315.8 48 256 48C158.6 48 76.8 115 54.2 205.4c-2.4 9.7 5.2 18.6 15.2 18.6c7.8 0 14.5-5.6 16.5-13.2C105.8 135.5 174.4 80 256 80c51 0 96.9 21.7 129.1 56.3zM448 192H374.6L448 118.6V192zM64 320h73.4L64 393.4V320z"]
  },
  nf = {
    prefix: "fal",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M256 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 480a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM64 256a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 16a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM120.2 391.8A16 16 0 1 0 97.6 414.4a16 16 0 1 0 22.6-22.6zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM97.6 120.2a16 16 0 1 0 22.6-22.6A16 16 0 1 0 97.6 120.2zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM414.4 414.4a16 16 0 1 0 -22.6-22.6 16 16 0 1 0 22.6 22.6zm-45.3-45.3A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
  },
  rf = {
    prefix: "fal",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M52.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L86.6 256 235.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-160 160zm352-160l-160 160c-6.2 6.2-6.2 16.4 0 22.6l160 160c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256 427.3 107.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0z"]
  },
  of = {
    prefix: "fal",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M32 0C14.3 0 0 14.3 0 32V96c0 17.7 14.3 32 32 32V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V352c0-88.4 71.6-160 160-160s160 71.6 160 160V480c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V128c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM576 128V480H512V352c0-106-86-192-192-192s-192 86-192 192V480H64V128H576zM32 32H608V96H32V32zM341.4 332.7c9.6-.1 18.7-4.5 24.7-12.1l1.7-2.1c8.7 10.6 16.4 22.6 22.5 34.5c9.6 18.5 14 35.5 14 42.7c0 46.3-37.6 84.3-84.4 84.3c-47.3 0-84.4-37.9-84.4-84.3c0-10.7 5.9-29.6 18.8-50.6c9.9-16.1 23.3-33.1 39.1-49.2c8 8 15.6 16.4 22.9 25.2c6.2 7.4 15.3 11.6 25 11.5zm77.3 5.6c-10.7-20.7-25.9-42.5-43.9-59c-3.2-2.9-7.8-3.6-11.6-1.9c-1.1 .5-2.1 1.1-2.9 1.9c-7 6.4-13.5 14.3-19.2 21.5c-7-8.4-14.2-16.4-21.7-24.1c-6-6.2-12.3-12.1-18.6-17.9c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4zM307 353.4c-3.1-3.9-7.8-6.2-12.7-6.1s-9.6 2.4-12.6 6.3c-4.7 6.2-8.6 11.8-11.8 17.2c-5.5 9.4-8.2 17.5-8.2 26.3c0 8.8 7.2 16 16 16s16-7.2 16-16c0-1 .1-2.8 1.8-6.4l18.8 24 0 0c5.9 7.5 14.9 12 24.5 12.2s18.8-3.9 25-11.2l9.6-11.2c5.8-6.7 5-16.8-1.7-22.6s-16.8-5-22.6 1.7l-9.6 11.2 0 0-21.5-27.4 0 0L307 353.4z"]
  },
  af = {
    prefix: "fal",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M32 132V48c0-8.8-7.2-16-16-16S0 39.2 0 48V176c0 8.8 7.2 16 16 16H144c8.8 0 16-7.2 16-16s-7.2-16-16-16H53.6C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16V256c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4V144c0-8.8-7.2-16-16-16z"]
  },
  cf = {
    prefix: "fal",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H48c-8.8 0-16 7.2-16 16s7.2 16 16 16h98L109.1 336H16c-8.8 0-16 7.2-16 16s7.2 16 16 16h85.7L80.4 460.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H261.7l-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6H400c8.8 0 16-7.2 16-16s-7.2-16-16-16H302l36.9-160H432c8.8 0 16-7.2 16-16s-7.2-16-16-16H346.3l21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6H186.3l21.3-92.4zM178.9 176H306L269.1 336H142l36.9-160z"]
  },
  sf = {
    prefix: "fal",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M16 32c8.8 0 16 7.2 16 16V400c0 26.5 21.5 48 48 48H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-44.2 0-80-35.8-80-80V48c0-8.8 7.2-16 16-16zM144 256c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V272c0-8.8 7.2-16 16-16zM256 144V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V144c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 48c8.8 0 16 7.2 16 16V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V208c0-8.8 7.2-16 16-16zm112-80V368c0 8.8-7.2 16-16 16s-16-7.2-16-16V112c0-8.8 7.2-16 16-16s16 7.2 16 16z"]
  },
  lf = {
    prefix: "fal",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M103.3 9.7C110 3.5 118.8 0 128 0s18 3.5 24.7 9.7l91 84c7.8 7.2 12.3 17.4 12.3 28.1c0 21.1-17.1 38.3-38.3 38.3H192V352h25.7c21.1 0 38.3 17.1 38.3 38.3c0 10.7-4.5 20.9-12.3 28.1l-91 84c-6.7 6.2-15.6 9.7-24.7 9.7s-18-3.5-24.7-9.7l-91-84C4.5 411.1 0 400.9 0 390.3C0 369.1 17.1 352 38.3 352H64V160H38.3C17.1 160 0 142.9 0 121.7c0-10.7 4.5-20.9 12.3-28.1l91-84zM128 32c-1.1 0-2.2 .4-3 1.2l-91 84c-1.3 1.2-2 2.9-2 4.6c0 3.5 2.8 6.3 6.3 6.3H80c8.8 0 16 7.2 16 16V368v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0c0 8.8-7.2 16-16 16H38.3c-3.5 0-6.3 2.8-6.3 6.3c0 1.7 .7 3.4 2 4.6l91 84c.8 .8 1.9 1.2 3 1.2s2.2-.4 3-1.2l91-84c1.3-1.2 2-2.8 2-4.6c0-3.5-2.8-6.3-6.3-6.3H176c-8.8 0-16-7.2-16-16v0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0V144c0-8.8 7.2-16 16-16h41.7c3.5 0 6.3-2.8 6.3-6.3c0-1.7-.7-3.4-2-4.6l-91-84c-.8-.8-1.9-1.2-3-1.2z"]
  },
  uf = {
    prefix: "fal",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16V272h80c8.8 0 16-7.2 16-16s-7.2-16-16-16H272V160c0-8.8-7.2-16-16-16s-16 7.2-16 16v80H160c-8.8 0-16 7.2-16 16s7.2 16 16 16h80v80z"]
  },
  df = {
    prefix: "fal",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M32 115.9C32 87.2 55.2 64 83.9 64c13.8 0 27 5.5 36.7 15.2l28.1 28.1c.5 .5 1.1 1 1.7 1.5c-33 43.9-29.5 106.5 10.4 146.4l4.7 4.7-16.8 16.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l192-192c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-16.8 16.8-4.7-4.7C279.3 56.9 216.7 53.4 172.8 86.4c-.4-.6-.9-1.2-1.5-1.7L143.2 56.6C127.5 40.8 106.1 32 83.9 32C37.6 32 0 69.6 0 115.9V464c0 8.8 7.2 16 16 16s16-7.2 16-16V115.9zm151.4 3.5c31.2-31.2 81.9-31.2 113.1 0l4.7 4.7L188.1 237.3l-4.7-4.7c-31.2-31.2-31.2-81.9 0-113.1zM416 200a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-88 88a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-40 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 56a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-64 64a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM424 320a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm88-88a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  ff = {
    prefix: "fal",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 32H64C46.3 32 32 46.3 32 64V256H544V64c0-17.7-14.3-32-32-32zm64 224v32 64c0 35.3-28.7 64-64 64H362.9l10.7 64H432c8.8 0 16 7.2 16 16s-7.2 16-16 16H360 216 144c-8.8 0-16-7.2-16-16s7.2-16 16-16h58.4l10.7-64H64c-35.3 0-64-28.7-64-64V288 256 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64V256zM32 288v64c0 17.7 14.3 32 32 32H231.7c.2 0 .4 0 .6 0H343.7c.2 0 .4 0 .6 0H512c17.7 0 32-14.3 32-32V288H32zM234.9 480H341.1l-10.7-64H245.6l-10.7 64z"]
  },
  pf = {
    prefix: "fal",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M32 80c0-8.8-7.2-16-16-16S0 71.2 0 80V256 432c0 8.8 7.2 16 16 16s16-7.2 16-16V272H288V432c0 8.8 7.2 16 16 16s16-7.2 16-16V256 80c0-8.8-7.2-16-16-16s-16 7.2-16 16V240H32V80zM432 64c-7.6 0-14.2 5.4-15.7 12.9l-32 160c-.9 4.7 .3 9.6 3.3 13.3s7.6 5.9 12.4 5.9H528c44.2 0 80 35.8 80 80s-35.8 80-80 80H456.4c-17.2 0-32.5-11-37.9-27.4l-3.2-9.7c-2.8-8.4-11.9-12.9-20.2-10.1s-12.9 11.9-10.1 20.2l3.2 9.7c9.8 29.4 37.3 49.2 68.3 49.2H528c61.9 0 112-50.1 112-112s-50.1-112-112-112H419.5L445.1 96H592c8.8 0 16-7.2 16-16s-7.2-16-16-16H432z"]
  },
  mf = {
    prefix: "fal",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z"]
  },
  hf = {
    prefix: "fal",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M34.5 420.4c-1.6 2.8-2.5 6-2.5 9.3c0 10.2 8.2 18.4 18.4 18.4H461.6c10.2 0 18.4-8.2 18.4-18.4c0-3.3-.9-6.4-2.5-9.3L276.5 75.8C272.2 68.5 264.4 64 256 64s-16.2 4.5-20.5 11.8L34.5 420.4zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c8.8 0 16 7.2 16 16V304c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16zM232 384a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]
  },
  Af = {
    prefix: "fal",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M296 160c13.3 0 24-10.7 24-24v-8V112 64L480 208 320 352l0-48V288v-8c0-13.3-10.7-24-24-24h-8H192c-70.7 0-128 57.3-128 128c0 8.3 .7 16.1 2 23.2C47.9 383.7 32 350.1 32 304c0-79.5 64.5-144 144-144H288h8zm-8 144v16 32c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2V96v16 16H256 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h64 32v16z"]
  },
  gf = {
    prefix: "fal",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M32 256C32 132.3 132.3 32 256 32s224 100.3 224 224c0 108.4-76.9 198.8-179.2 219.5c-8.7 1.8-14.3 10.2-12.5 18.9s10.2 14.3 18.9 12.5C424 483.2 512 379.9 512 256C512 114.6 397.4 0 256 0S0 114.6 0 256c0 23.6 3.2 46.5 9.2 68.3c2.4 8.5 11.2 13.5 19.7 11.2s13.5-11.2 11.2-19.7c-5.2-19-8.1-39-8.1-59.7zm165.1 .8c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2l70.5 23.5L160 348.8V320c0-26.5-21.5-48-48-48s-48 21.5-48 48V440c0 39.8 32.2 72 72 72h47.8c29.4 0 55.9-17.9 66.9-45.3l23.9-59.6 47-18.4c20.9-8.2 32.8-29.4 30.1-50.7c-2.3-18.7-15.1-34.7-33.3-40.8L197.1 256.8zM320 342.7c0 .4 0 .9 0 1.3h0c0 6.4-3.9 12.4-10.2 14.9l-53.5 20.9c-4.3 1.7-7.7 5.2-9.2 9.5c-.1 .2-.1 .4-.2 .6l-26 64.9C214.8 470 200.1 480 183.8 480H136c-22.1 0-40-17.9-40-40V320c0-8.8 7.2-16 16-16s16 7.2 16 16v52.2c0 5.3 2.6 10.2 7 13.2s9.9 3.6 14.9 1.7l148.3-58c8.2-3.2 17.5 .8 20.7 9.1c.6 1.5 .9 3 1.1 4.5zM200.4 192a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm136 40a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm-120-87.2l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 94.1 162.3 90 127.1 110.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4c23.5-13.4 52.9-10.6 73.4 7z"]
  },
  vf = {
    prefix: "fal",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M511.6 36.9c1.9-12.1-3.4-24.3-13.5-31.2s-23.3-7.5-34-1.4l-448 256C5.5 266.3-.7 277.8 .1 290s8.4 22.9 19.6 27.6L160 376v93c0 23.8 19.3 43 43 43c13.1 0 25.4-5.9 33.6-16.1l52.8-66 .1 0 114.2 47.6c9.1 3.8 19.4 3.2 28-1.6s14.5-13.3 16-23l64-416zm-253 380.2l-47 58.8c-2.1 2.6-5.3 4.1-8.6 4.1c-6.1 0-11-4.9-11-11V389.3l66.6 27.8zm43.1-16.7l-96.6-40.3L474.1 70.5 416 448 301.8 400.4zM450.5 48.8L173.6 347 32 288 450.5 48.8z"]
  },
  Cf = {
    prefix: "fal",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M432 48c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm0 128c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432zm16 144c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16H432c8.8 0 16 7.2 16 16zM432 432c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16s7.2-16 16-16H432z"]
  },
  bf = {
    prefix: "fal",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z"]
  },
  Ef = {
    prefix: "fal",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M288.8 81.7c3.5-12.8 16.7-20.3 29.5-16.8s20.3 16.7 16.8 29.5l-4.5 16.4c-5.5 20.2-13.9 39.3-24.7 56.9c-3.1 4.9-3.2 11.1-.4 16.2s8.2 8.2 14 8.2H448c17.7 0 32 14.3 32 32c0 11.3-5.9 21.3-14.8 27c-7.2 4.6-9.5 13.9-5.3 21.3c2.6 4.6 4.1 10 4.1 15.7c0 12.4-7 23.1-17.3 28.5c-4.2 2.2-7.3 6.1-8.3 10.8s.1 9.5 3 13.2c4.2 5.4 6.7 12.2 6.7 19.5c0 14.2-9.2 26.3-22.1 30.4c-7.8 2.6-12.4 10.6-10.7 18.6c.5 2.2 .7 4.5 .7 6.9c0 17.7-14.3 32-32 32H294.5c-15.8 0-31.2-4.7-44.4-13.4l-38.5-25.7c-9-6-16.6-13.7-22.4-22.6c-4.9-7.4-14.8-9.4-22.2-4.6s-9.4 14.8-4.6 22.2c8.1 12.3 18.7 23.1 31.4 31.6l38.5 25.7c18.4 12.3 40 18.8 62.1 18.8H384c35.3 0 64-28.7 64-64l0-.6c19.1-11.1 32-31.7 32-55.4c0-8.7-1.8-17.1-4.9-24.7C487.9 323.6 496 306.8 496 288c0-6.5-1-12.8-2.8-18.7C504.8 257.7 512 241.7 512 224c0-35.3-28.7-64-64-64H346.4c6.2-13.1 11.3-26.7 15.1-40.9l4.5-16.4c8.1-29.8-9.5-60.6-39.3-68.8s-60.6 9.5-68.8 39.3l-4.5 16.4c-8.9 32.6-29.6 60.8-58.2 79l-3.1 2c-11.8 7.5-21.7 17.1-29.5 28.2c-5.1 7.2-3.3 17.2 4 22.3s17.2 3.3 22.3-4c5.4-7.7 12.2-14.4 20.4-19.5l3.1-2c35.3-22.4 60.9-57.2 71.9-97.5l4.5-16.4zM32 224H96V448H32V224zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
  },
  yf = {
    prefix: "fal",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M320 480H64c-17.7 0-32-14.3-32-32V64c0-17.7 14.3-32 32-32H192V144c0 26.5 21.5 48 48 48H352V448c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16V32.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4H240zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V163.9c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zM224 432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240c-8.8 0-16 7.2-16 16zm64-96H96V272H288v64zM96 240c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32H96z"]
  },
  If = {
    prefix: "fal",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M96 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H416V90.5c0-8.5-3.4-16.6-9.4-22.6L380.1 41.4c-6-6-14.1-9.4-22.6-9.4H128c-17.7 0-32 14.3-32 32v96zm352 64H64c-17.7 0-32 14.3-32 32V384H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v32h32V256c0-17.7-14.3-32-32-32zm0 192v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 352l0 128H416V352H96zM432 248a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]
  },
  Bf = {
    prefix: "fal",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192H256 480.8c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24H34.3L256 34.4 477.7 160H306.6zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16H448c8.8 0 16-7.2 16-16s-7.2-16-16-16V224H416V352H336V224H304V352H208V224H176V352H96V224H64V352zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16H472c8.8 0 16-7.2 16-16s-7.2-16-16-16H40zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H496c8.8 0 16-7.2 16-16s-7.2-16-16-16H16z"]
  },
  xf = {
    prefix: "fal",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-8.8 7.2-16 16-16H624c8.8 0 16 7.2 16 16s-7.2 16-16 16H16c-8.8 0-16-7.2-16-16z"]
  },
  wf = {
    prefix: "fal",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M128 160H70.7c-3.7 0-6.7-3-6.7-6.7c0-1.9 .8-3.7 2.2-5L192 35.8 317.8 148.3c1.4 1.3 2.2 3.1 2.2 5c0 3.7-3 6.7-6.7 6.7H256c-17.7 0-32 14.3-32 32V368c0 61.9-50.1 112-112 112H48c-8.8 0-16-7.2-16-16V432c0-8.8 7.2-16 16-16l64 0c26.5 0 48-21.5 48-48V192c0-17.7-14.3-32-32-32zM206 5.3C202.1 1.9 197.2 0 192 0s-10.1 1.9-14 5.3L44.9 124.5C36.7 131.8 32 142.3 32 153.3C32 174.7 49.3 192 70.7 192H96h32v32V368c0 8.8-7.2 16-16 16l-64 0c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h64c79.5 0 144-64.5 144-144V224 192h32 25.3c21.4 0 38.7-17.3 38.7-38.7c0-11-4.7-21.5-12.9-28.8L206 5.3z"]
  },
  Qf = {
    prefix: "fat",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", "M157.4 27.3L134.4 64H313.6l-23-36.7c-4.4-7-12.1-11.3-20.4-11.3H177.7c-8.3 0-16 4.3-20.4 11.3zM115.6 64l28.2-45.2C151.1 7.1 163.9 0 177.7 0h92.5c13.8 0 26.6 7.1 33.9 18.8L332.4 64H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H115.6zM40 112c4.4 0 8 3.6 8 8V440c0 30.9 25.1 56 56 56H344c30.9 0 56-25.1 56-56V120c0-4.4 3.6-8 8-8s8 3.6 8 8V440c0 39.8-32.2 72-72 72H104c-39.8 0-72-32.2-72-72V120c0-4.4 3.6-8 8-8zm96 48V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8zm96 0V416c0 4.4-3.6 8-8 8s-8-3.6-8-8V160c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Hf = {
    prefix: "fat",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", "M128 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H64C28.7 64 0 92.7 0 128v48 16 96 16 96 16 32c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V416 400 304 288 192 176 128c0-35.3-28.7-64-64-64H336V8c0-4.4-3.6-8-8-8s-8 3.6-8 8V64H128V8zM432 288H304V192H432v96zM288 192v96H160V192H288zm-144 0v96H16V192H144zM16 304H144v96H16V304zm0 112H144v80H64c-26.5 0-48-21.5-48-48V416zm144 80V416H288v80H160zm144 0V416H432v32c0 26.5-21.5 48-48 48H304zm128-96H304V304H432v96zM112 80v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80H320v40c0 4.4 3.6 8 8 8s8-3.6 8-8V80h48c26.5 0 48 21.5 48 48v48H16V128c0-26.5 21.5-48 48-48h48zM288 400H160V304H288v96z"]
  },
  zf = {
    prefix: "fat",
    iconName: "h1",
    icon: [576, 512, [], "f313", "M496 72c0-2.9-1.6-5.6-4.1-7s-5.7-1.3-8.1 .2l-64 40c-3.7 2.3-4.9 7.3-2.5 11s7.3 4.9 11 2.5L480 86.4V432H424c-4.4 0-8 3.6-8 8s3.6 8 8 8h64 64c4.4 0 8-3.6 8-8s-3.6-8-8-8H496V72zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72z"]
  },
  Mf = {
    prefix: "fat",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", "M512 48H128c-26.5 0-48 21.5-48 48V352H64V96c0-35.3 28.7-64 64-64H512c35.3 0 64 28.7 64 64V352H560V96c0-26.5-21.5-48-48-48zM19.2 400c-1.8 0-3.2 1.4-3.2 3.2C16 436.8 43.2 464 76.8 464H563.2c33.6 0 60.8-27.2 60.8-60.8c0-1.8-1.4-3.2-3.2-3.2H19.2zM0 403.2C0 392.6 8.6 384 19.2 384H620.8c10.6 0 19.2 8.6 19.2 19.2c0 42.4-34.4 76.8-76.8 76.8H76.8C34.4 480 0 445.6 0 403.2z"]
  },
  kf = {
    prefix: "fat",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM200 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H200c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 17.7-14.3 32-32 32H200c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zm133.1 0H368c4.4 0 8 3.6 8 8s-3.6 8-8 8H333.1c-11.7 0-21.1 9.4-21.1 21.1c0 8.3 4.9 15.9 12.5 19.3L362 441c13.4 6 22 19.2 22 33.9c0 20.5-16.6 37.1-37.1 37.1H304c-4.4 0-8-3.6-8-8s3.6-8 8-8h42.9c11.7 0 21.1-9.4 21.1-21.1c0-8.3-4.9-15.9-12.5-19.3L318 439c-13.4-6-22-19.2-22-33.9c0-20.5 16.6-37.1 37.1-37.1zm98.9 0c4.4 0 8 3.6 8 8v31.6c0 29.1 8.3 57.5 24 82c15.7-24.5 24-52.9 24-82V376c0-4.4 3.6-8 8-8s8 3.6 8 8v31.6c0 33.2-9.8 65.6-28.2 93.2l-5.1 7.7c-1.5 2.2-4 3.6-6.7 3.6s-5.2-1.3-6.7-3.6l-5.1-7.7c-18.4-27.6-28.2-60-28.2-93.2V376c0-4.4 3.6-8 8-8z"]
  },
  Nf = {
    prefix: "fat",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", "M88 48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24H88zM40 32C17.9 32 0 49.9 0 72v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H40zM88 208c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24H88zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zm0 176H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24zM0 392v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H40c-22.1 0-40 17.9-40 40zM248 48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24h48zM200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zm0 176h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zm88 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H200c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24h48zm-48-16c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200zM360 48h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V72c0-13.3 10.7-24 24-24zM320 72v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40zm88 136c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24h48zm-48-16c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360zm0 176h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H360c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24zm-40 24v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H360c-22.1 0-40 17.9-40 40z"]
  },
  Sf = {
    prefix: "fat",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", "M113.9 125.9c5.6-30.4 26.3-52.3 57.8-65c31.8-12.9 74.4-16.3 121.9-9.3C308.2 53.8 353.2 62 368 65.8c4.3 1.1 8.6-1.5 9.7-5.8s-1.5-8.6-5.8-9.7c-15.5-3.9-61.1-12.3-76-14.5c-49.3-7.3-95-4-130.3 10.3c-35.5 14.4-60.8 40.2-67.6 77.2l0 0-.1 .4c-2.8 22.3 .6 41.1 9.1 57c8.4 15.8 21.5 28.1 37.1 38.1c25.8 16.5 59.7 27.4 93.8 37.2H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H295.4c-11-3.4-22.2-6.6-33.3-9.7l-2.2-.6c-40.4-11.5-79.3-22.5-107.2-40.4c-14-9-24.8-19.4-31.6-32.1c-6.7-12.5-9.7-27.9-7.3-47.2zM394 336.5c5.8 13 7.8 29 4.1 49.3c-5.6 30.5-26.2 52.4-57.9 65.3c-31.8 12.9-74.4 16.3-121.9 9.3c-24.2-3.7-64.7-16.8-94.7-26.5l0 0 0 0c-6.3-2-12.2-3.9-17.3-5.5c-4.2-1.3-8.7 1-10 5.2s1 8.7 5.2 10c4.8 1.5 10.4 3.3 16.6 5.3l0 0c29.9 9.7 72.2 23.3 97.8 27.3l0 0c49.3 7.3 95 4 130.3-10.3c35.5-14.4 60.8-40.2 67.6-77.2c4.2-22.9 2.1-42.2-5.3-58.7c-1.6-3.5-3.3-6.8-5.3-10H383.5c4.3 5.1 7.8 10.6 10.5 16.5z"]
  },
  Vf = {
    prefix: "fat",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M395 25.9c12.5-12.5 32.8-12.5 45.3 0l45.8 45.8c12.5 12.5 12.5 32.8 0 45.3l-66.9 66.9L328.1 92.8 395 25.9zm-78.2 78.2l91.1 91.1L164.7 438.4c-1.5 1.5-3.1 3-4.7 4.4V408c0-4.4-3.6-8-8-8H112V360c0-4.4-3.6-8-8-8H69.2c1.4-1.6 2.9-3.2 4.4-4.7L316.8 104.1zM51.4 384.7c1.7-5.8 4-11.4 6.8-16.7H96v40c0 4.4 3.6 8 8 8h40v37.7c-5.3 2.8-10.9 5.1-16.7 6.8L19.8 492.2 51.4 384.7zm400.1-370c-18.7-18.7-49.1-18.7-67.9 0L62.3 336C50 348.3 41 363.5 36.1 380.2L.3 501.7c-.8 2.8-.1 5.8 2 7.9s5.1 2.8 7.9 2l121.6-35.8c16.7-4.9 31.9-13.9 44.2-26.2L497.4 128.3c18.7-18.7 18.7-49.1 0-67.9L451.5 14.6zM317.7 173.1c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-144 144c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l144-144z"]
  },
  Lf = {
    prefix: "fat",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", "M120.4 64c4-36 34.5-64 71.6-64s67.6 28 71.6 64H272c20.9 0 38.7 13.4 45.3 32H320c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V160c0-35.3 28.7-64 64-64h2.7C73.3 77.4 91.1 64 112 64h8.4zM64 112c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H320c26.5 0 48-21.5 48-48V160c0-26.5-21.5-48-48-48v16c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V112zM192 16c-30.9 0-56 25.1-56 56c0 4.4-3.6 8-8 8H112c-17.7 0-32 14.3-32 32v16c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16V112c0-17.7-14.3-32-32-32H256c-4.4 0-8-3.6-8-8c0-30.9-25.1-56-56-56zM176 80a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM160 224c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 96c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm0 96c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zM96 400a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM80 320a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 208a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  },
  Pf = {
    prefix: "fat",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", "M480 48H32c-8.8 0-16 7.2-16 16v48c0 8.8 7.2 16 16 16H48 464h16c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16zm0 96H464 48 32c-17.7 0-32-14.3-32-32V64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32v48c0 17.7-14.3 32-32 32zM160 232c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8zm304-56h16V416c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V176H48V416c0 26.5 21.5 48 48 48H416c26.5 0 48-21.5 48-48V176z"]
  },
  Of = {
    prefix: "fat",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 136l0 6.5c0 4.4 3.6 8 8 8s8-3.6 8-8l0-6.5c0-22.1 17.9-40 40-40h56.2c26.4 0 47.8 21.4 47.8 47.8c0 16.1-8.1 31.1-21.5 39.9l-54.9 36.2c-2.2 1.5-3.6 4-3.6 6.7V256c0 4.4 3.6 8 8 8s8-3.6 8-8V230.9L315.3 197c17.9-11.8 28.7-31.8 28.7-53.3c0-35.2-28.6-63.8-63.8-63.8H224c-30.9 0-56 25.1-56 56zM272 304a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  Tf = {
    prefix: "fat",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", "M512 48c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96c0-26.5 21.5-48 48-48H512zM64 32C28.7 32 0 60.7 0 96V384c0 35.3 28.7 64 64 64l0 24c0 4.4 3.6 8 8 8s8-3.6 8-8V448H496v24c0 4.4 3.6 8 8 8s8-3.6 8-8V448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm432 72V376c0 4.4 3.6 8 8 8s8-3.6 8-8V104c0-4.4-3.6-8-8-8s-8 3.6-8 8zM104 128H408c4.4 0 8 3.6 8 8V344c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8zm-24 8V344c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24V136c0-13.3-10.7-24-24-24H104c-13.3 0-24 10.7-24 24z"]
  },
  Df = {
    prefix: "fat",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", "M200 64c-4.4 0-8 3.6-8 8s3.6 8 8 8h48v64.1C128 148.4 32 247 32 368v32H48V368c0-114.9 93.1-208 208-208s208 93.1 208 208v32h16V368c0-121-96-219.6-216-223.9V80h48c4.4 0 8-3.6 8-8s-3.6-8-8-8H256 200zM8 432c-4.4 0-8 3.6-8 8s3.6 8 8 8H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  Rf = {
    prefix: "fat",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", "M224 144c-8.8 0-16-7.2-16-16V64c0-6.3-3.7-12-9.5-14.6s-12.5-1.5-17.2 2.7l-160 144c-3.4 3-5.3 7.4-5.3 11.9s1.9 8.9 5.3 11.9l160 144c4.7 4.2 11.4 5.3 17.2 2.7s9.5-8.3 9.5-14.6V288c0-8.8 7.2-16 16-16h96c61.9 0 112 50.1 112 112c0 35.5-15.2 57.1-27.3 68.4c-3.7 3.5-4.7 6.5-4.7 7.8c0 2.1 1.7 3.7 3.7 3.7c.3 0 .5 0 .6 0c17.1-9.3 91.8-55.7 91.8-160c0-88.4-71.6-160-160-160H224zm0 160v48c0 12.6-7.4 24.1-19 29.2s-25 3-34.4-5.4l-160-144C3.9 225.7 0 217.1 0 208s3.9-17.7 10.6-23.8l160-144c9.4-8.5 22.9-10.6 34.4-5.4s19 16.6 19 29.2v48 16h16 96c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H240 224v16z"]
  },
  Gf = {
    prefix: "fat",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", "M485.7 37.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L408.6 92.1C368.6 54.8 315 32 256 32C132.3 32 32 132.3 32 256c0 59 22.8 112.6 60.1 152.6L26.3 474.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l65.7-65.7C143.4 457.2 197 480 256 480c123.7 0 224-100.3 224-224c0-59-22.8-112.6-60.1-152.6l65.7-65.7zm-88.3 65.7L103.4 397.3C69 360.2 48 310.6 48 256C48 141.1 141.1 48 256 48c54.6 0 104.2 21 141.3 55.4zM114.7 408.6L408.6 114.7C443 151.8 464 201.4 464 256c0 114.9-93.1 208-208 208c-54.6 0-104.2-21-141.3-55.4z"]
  },
  Ff = {
    prefix: "fat",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", "M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM0 248c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM448 408c0 4.4-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8z"]
  },
  jf = {
    prefix: "fat",
    iconName: "people-group",
    icon: [640, 512, [], "e533", "M88 88a40 40 0 1 1 80 0A40 40 0 1 1 88 88zm96 0A56 56 0 1 0 72 88a56 56 0 1 0 112 0zm288 0a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm96 0A56 56 0 1 0 456 88a56 56 0 1 0 112 0zM64 256c-4.4 0-8 3.6-8 8v98.2c-24.2-16.9-40-45-40-76.7c0-51.7 41.9-93.5 93.5-93.5h36.9c18.8 0 36.3 5.6 51 15.1c3.7-4 7.6-7.8 11.7-11.4c-17.8-12.4-39.4-19.7-62.7-19.7H109.5C49 176 0 225 0 285.5c0 41.1 22.6 76.8 56 95.6V432c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V403.6c-5.9-6.2-11.3-12.8-16-20V432c0 8.8-7.2 16-16 16H88c-8.8 0-16-7.2-16-16V264c0-4.4-3.6-8-8-8zM440 432c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V381.1c33.4-18.7 56-54.5 56-95.6C640 225 591 176 530.5 176H493.5c-23.3 0-44.9 7.3-62.7 19.7c4.1 3.6 8 7.4 11.7 11.4c14.7-9.6 32.2-15.1 51-15.1h36.9c51.7 0 93.5 41.9 93.5 93.5c0 31.7-15.8 59.8-40 76.7V264c0-4.4-3.6-8-8-8s-8 3.6-8 8V432c0 8.8-7.2 16-16 16H472c-8.8 0-16-7.2-16-16V383.6c-4.7 7.1-10.1 13.8-16 20V432zM272 96a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm112 0A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 272c-4.4 0-8 3.6-8 8v98.2c-24.2-16.9-40-45-40-76.7c0-51.7 41.9-93.5 93.5-93.5h36.9c51.7 0 93.5 41.9 93.5 93.5c0 31.7-15.8 59.8-40 76.7V280c0-4.4-3.6-8-8-8s-8 3.6-8 8V448c0 8.8-7.2 16-16 16H280c-8.8 0-16-7.2-16-16V280c0-4.4-3.6-8-8-8zm-8 125.1V448c0 17.7 14.3 32 32 32h80c17.7 0 32-14.3 32-32V397.1c33.4-18.7 56-54.5 56-95.6C448 241 399 192 338.5 192H301.5C241 192 192 241 192 301.5c0 41.1 22.6 76.8 56 95.6z"]
  },
  Jf = {
    prefix: "fat",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-4.4 0-8 3.6-8 8V296c0 4.4 3.6 8 8 8s8-3.6 8-8V136c0-4.4-3.6-8-8-8zm16 224a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  Zf = {
    prefix: "fat",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", "M320 48c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h64zM256 32c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h24v56H112c-22.1 0-40 17.9-40 40v32H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H88V288c0-13.3 10.7-24 24-24H280v56H256c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H296V264H464c13.3 0 24 10.7 24 24v32H464c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h64c26.5 0 48-21.5 48-48V368c0-26.5-21.5-48-48-48H504V288c0-22.1-17.9-40-40-40H296V192h24c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H256zM48 336h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm208 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H256c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32zm208 0h64c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H464c-17.7 0-32-14.3-32-32V368c0-17.7 14.3-32 32-32z"]
  },
  Wf = {
    prefix: "fat",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", "M349.2 77.5c-4.8 .1-9.4-2.1-12.5-5.8c-16.5-19.9-34.2-38.3-53.1-55.3C251.8 44.9 225 77.2 206 107.9c-19 30.8-30 62.1-30 84.2c0 79 63.2 143.8 144 143.8c79.9 0 144-64.8 144-143.8c0-16.5-8.3-44.5-22.4-71.6c-14-26.9-33.5-54.9-56.2-76c-8.3 7.7-16.3 17.4-23.9 26.9c-3 3.8-7.5 6-12.3 6zM338.4 49.1c3.6 4.1 7.1 8.2 10.6 12.4c3.3-4.1 6.7-8.4 10.3-12.6c5.1-5.9 10.5-11.8 16.1-16.9c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7c3.5 0 7 1.3 9.8 3.8c15.8 14.2 30.7 29.3 44.9 45.3zM281.7 96c2.4 0 4.7 1.1 6.2 3c2.2 2.8 19.4 24.6 35.9 45.7l22.5 28.7 4 5.2 33.4-38.9c1.6-1.8 3.9-2.9 6.3-2.8s4.7 1.3 6.1 3.2c3.7 5 6.2 10 8.4 14.3l0 0 0 .1c21.5 39.6 12.2 90.5-24.6 116.2l-.2 .1 0 0c-17.8 11.9-37 17.9-58.5 17.9c-26.5 0-50.9-8.6-68.7-24.9c-17.9-16.4-28.7-40.1-28.7-69.2c0-15.1 4.8-28.9 13.5-43.9c8.6-14.8 21.4-31.3 37.9-51.6c1.5-1.9 3.8-3 6.2-3zm68.4 95.2l-6.3 4.9 0 0 0 0 0 0-.1-.2-.5-.7-2-2.6-7.3-9.3-22.5-28.7c-11.3-14.4-22.7-29-29.6-37.8c-13.4 16.7-23.4 30-30.3 41.8c-7.8 13.4-11.3 24.4-11.3 35.8c0 24.9 9.1 44.3 23.5 57.4c14.5 13.2 34.8 20.7 57.9 20.7c18.2 0 34.3-5 49.5-15.2c29.4-20.6 37.7-62.3 19.6-95.5l-.1-.3 0 0c-.6-1.1-1.1-2.2-1.7-3.3l-32.6 38c-1.6 1.8-3.9 2.8-6.2 2.8s-4.6-1.2-6.1-3.1l6.3-4.9zM32 264c0-4.4 3.6-8 8-8H88c4.4 0 8 3.6 8 8s-3.6 8-8 8H48V384H592V272H552c-4.4 0-8-3.6-8-8s3.6-8 8-8h48c4.4 0 8 3.6 8 8V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V264zm0 136c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H608c8.8 0 16-7.2 16-16V416c0-8.8-7.2-16-16-16h-8H40 32zm288 32a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm112 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM192 432a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  },
  Xf = {
    prefix: "fat",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", "M157.3 415c-5-1.8-10.6-1-14.9 2.1c-11 8-29.4 19.3-51.2 28.8C68.3 456 41.6 464 16 464l.1-.1 0 0 0 0 .3-.3 .1-.1c.4-.4 .9-.9 1.5-1.6c1.3-1.4 3.2-3.6 5.4-6.3l-12.2-10 12.2 10C28 450 34 442 40 432c10.7-17.9 21.4-42.1 23.6-69.9c.3-4.3-1.1-8.6-3.9-11.8C31.9 318.8 16 280.7 16 240C16 136.9 120.2 48 256 48s240 88.9 240 192s-104.2 192-240 192c-35.2 0-68.6-6.1-98.7-17zM4.7 452.7l0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0zM136 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H136z"]
  },
  Uf = {
    prefix: "fat",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", "M40 64c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V72c0-4.4-3.6-8-8-8H40zM16 72c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72zM176 88H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H176c-4.4 0-8-3.6-8-8s3.6-8 8-8zM88 224H40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM40 208H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232c0-13.3 10.7-24 24-24zm0 176c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8H88c4.4 0 8-3.6 8-8V392c0-4.4-3.6-8-8-8H40zm-24 8c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392z"]
  },
  Kf = {
    prefix: "fat",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", "M112 128v64H336V128c0-61.9-50.1-112-112-112s-112 50.1-112 112zM96 192V128C96 57.3 153.3 0 224 0s128 57.3 128 128v64h32c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H96zm0 16H64c-26.5 0-48 21.5-48 48V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V256c0-26.5-21.5-48-48-48H352 336 112 96z"]
  },
  Yf = {
    prefix: "fat",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", "M248 0c4.4 0 8 3.6 8 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C336 115.4 352 148.7 352 184c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.6-13.9-59-36.7-75.6L283.2 96.5C256 76.6 240 43.3 240 8c0-4.4 3.6-8 8-8zM16 336V448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V320c0-26.5-21.5-48-48-48H277.3c-1.4 0-2.7 0-4-.1c-.4 .1-.8 .1-1.3 .1H16v48 16zm213.3-80L144 192c-13.8-10.4-30.7-16-48-16c-44.2 0-80 35.8-80 80H229.3zM0 336V320 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2l85.3 64c11.1 8.3 24.6 12.8 38.4 12.8H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V336zM384 8c0 30.6 13.9 59 36.7 75.6l16.1 11.8C464 115.4 480 148.7 480 184c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-30.6-13.9-59-36.7-75.6L411.2 96.5C384 76.6 368 43.3 368 8c0-4.4 3.6-8 8-8s8 3.6 8 8zM112 320c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8V440c0 4.4-3.6 8-8 8s-8-3.6-8-8V328c0-4.4 3.6-8 8-8zM112 64A48 48 0 1 0 16 64a48 48 0 1 0 96 0zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z"]
  },
  qf = {
    prefix: "fat",
    iconName: "blanket",
    icon: [448, 512, [], "f498", "M16 120V341.4C31.9 318.8 58.2 304 88 304H400c12.3 0 23.5 4.6 32 12.2V120c0-39.8-32.2-72-72-72H88c-39.8 0-72 32.2-72 72zM.4 384H0V120C0 71.4 39.4 32 88 32H360c48.6 0 88 39.4 88 88V352c0 26.5-21.5 48-48 48H88c-4.4 0-8-3.6-8-8s3.6-8 8-8H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H88c-39.8 0-72 32.2-72 72s32.2 72 72 72H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H88c-48.6 0-88-39.4-88-88c0-2.7 .1-5.4 .4-8z"]
  },
  _f = {
    prefix: "fat",
    iconName: "users",
    icon: [640, 512, [], "f0c0", "M80 80a64 64 0 1 1 128 0A64 64 0 1 1 80 80zm144 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 64a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm0 176a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 48H378.7C443.5 368 496 420.5 496 485.3c0 5.9-4.8 10.7-10.7 10.7H154.7c-5.9 0-10.7-4.8-10.7-10.7C144 420.5 196.5 368 261.3 368zm0-16C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3zM512 16a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 144A80 80 0 1 0 512 0a80 80 0 1 0 0 160zm24 48c48.6 0 88 39.4 88 88c0 4.4 3.6 8 8 8s8-3.6 8-8c0-57.4-46.6-104-104-104H444c1.3 5.2 2.4 10.6 3 16h89zm-343 0c.7-5.4 1.7-10.8 3-16H104C46.6 192 0 238.6 0 296c0 4.4 3.6 8 8 8s8-3.6 8-8c0-48.6 39.4-88 88-88h89z"]
  },
  $f = {
    prefix: "fat",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", "M250.3 114.3c3.1-3.1 8.2-3.1 11.3 0l216 216c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L256 131.3 45.7 341.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l216-216z"]
  },
  ep = {
    prefix: "fat",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", "M0 256C0 167.6 71.6 96 160 96h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H160C80.5 112 16 176.5 16 256s64.5 144 144 144h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H160C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c79.5 0 144-64.5 144-144s-64.5-144-144-144H328c-4.4 0-8-3.6-8-8s3.6-8 8-8h88c88.4 0 160 71.6 160 160zm-440-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  tp = {
    prefix: "fat",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", "M64 80c-26.5 0-48 21.5-48 48V384c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V128c0-26.5-21.5-48-48-48H64zM0 128C0 92.7 28.7 64 64 64H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128zm536 56h-8c-39.8 0-72-32.2-72-72v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8s-3.6 8-8 8zM32 176c0-4.4 3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40c-4.4 0-8-3.6-8-8zM536 328c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8zM32 336c0-4.4 3.6-8 8-8h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8zm336-80a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-176 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z"]
  },
  np = {
    prefix: "fat",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", "M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 192c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 312c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  rp = {
    prefix: "fat",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", "M240 48c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H208c-17.7 0-32-14.3-32-32V80c0-17.7 14.3-32 32-32h32zM208 32c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H208zM80 240c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H48c-17.7 0-32-14.3-32-32V272c0-17.7 14.3-32 32-32H80zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48zM368 112h32c17.7 0 32 14.3 32 32V432c0 17.7-14.3 32-32 32H368c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm-48 32V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368c-26.5 0-48 21.5-48 48z"]
  },
  op = {
    prefix: "fat",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM192 128h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H192v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V296 144c0-8.8 7.2-16 16-16zm96 160c39.8 0 72-32.2 72-72s-32.2-72-72-72H192V288h96z"]
  },
  ip = {
    prefix: "fat",
    iconName: "h3",
    icon: [640, 512, [], "f315", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm376-8c-4.4 0-8 3.6-8 8s3.6 8 8 8H580.7L418.3 242.3c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9h96c48.6 0 88 39.4 88 88s-39.4 88-88 88H447.4c-23.5 0-43.5-17-47.3-40.1l-.2-1.2c-.7-4.4-4.8-7.3-9.2-6.6s-7.3 4.8-6.6 9.2l.2 1.2c5.1 30.9 31.8 53.5 63.1 53.5H520c57.4 0 104-46.6 104-104s-46.6-104-104-104H443.3L605.7 77.7c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9H392z"]
  },
  ap = {
    prefix: "fat",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", "M16 422.3c0 12.4 6.9 22.7 16.6 26.3c78.1 29.1 156.8 11.7 240.7-9.6c4-1 8-2 12-3.1c78.7-20.1 162.3-41.4 246.3-18.5c15.2 4.2 28.4-6.9 28.4-17.9V89.7c0-12.4-6.9-22.7-16.6-26.3C465.3 34.2 386.7 51.7 302.8 73c-4 1-8 2-12 3l0 0 0 0 0 0C212 96.2 128.4 117.5 44.4 94.6C29.2 90.4 16 101.5 16 112.5V422.3zm-16 0V112.5C0 88.6 25.6 72.8 48.7 79.1c79.8 21.8 159.6 1.5 239.3-18.9c87-22.2 174-44.4 261-11.9c16.9 6.3 27 23.2 27 41.3V399.5c0 23.9-25.6 39.7-48.7 33.4c-79.8-21.8-159.6-1.5-239.3 18.9c-87 22.2-174 44.4-261 11.9c-16.9-6.3-27-23.2-27-41.3zM216 256c0 50 33.5 88 72 88s72-38 72-88s-33.5-88-72-88s-72 38-72 88zm72-104c49.9 0 88 48 88 104s-38.1 104-88 104s-88-48-88-104s38.1-104 88-104zm256 0c0 4.4-3.6 8-8 8h-8c-39.8 0-72-32.2-72-72V80c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 30.9 25.1 56 56 56h8c4.4 0 8 3.6 8 8zM40 216c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c30.9 0 56-25.1 56-56v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 39.8-32.2 72-72 72H40zm504 88c0 4.4-3.6 8-8 8h-8c-30.9 0-56 25.1-56 56v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-39.8 32.2-72 72-72h8c4.4 0 8 3.6 8 8zM40 352h8c39.8 0 72 32.2 72 72v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-30.9-25.1-56-56-56H40c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  cp = {
    prefix: "fat",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", "M420 431.3L80.7 92C40.6 134.9 16 192.6 16 256c0 132.5 107.5 240 240 240c63.4 0 121.1-24.6 164-64.7zM431.3 420C471.4 377.1 496 319.4 496 256C496 123.5 388.5 16 256 16C192.6 16 134.9 40.6 92 80.7L431.3 420zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  sp = {
    prefix: "fat",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", "M212.1 161.8L280.7 20.5c1.3-2.8 4.1-4.5 7.2-4.5s5.9 1.7 7.2 4.5l68.6 141.3c2.3 4.8 6.8 8.1 12.1 8.8L529 193.3c3 .4 5.5 2.5 6.4 5.4s.2 6-2 8.2L422.4 317c-3.7 3.7-5.4 8.9-4.5 14l26.2 155.6c.5 3-.7 6-3.2 7.8s-5.8 2-8.4 .6l-137-73.2c-4.7-2.5-10.4-2.5-15.1 0L143.4 495c-2.7 1.4-6 1.2-8.4-.6s-3.7-4.8-3.2-7.8L158 331c.9-5.1-.8-10.4-4.5-14L42.4 206.9 31.2 218.1l11.2-11.3c-2.2-2.1-2.9-5.3-2-8.2s3.4-5 6.4-5.4l153.2-22.6c5.2-.8 9.7-4.1 12.1-8.8zM424.9 509.1c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2z"]
  },
  lp = {
    prefix: "fat",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 72c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zM192 242.7c-4.4 0-8 3.6-8 8v13.7c-8.3 .6-16 2.3-22.7 5c-12.1 4.9-22.1 13.6-24.5 26.2c-1.5 7.6-.6 14.4 2.6 20.4c3.1 5.8 8 10.1 13.4 13.3c10 6 23.5 9.6 35.7 12.9l1.7 .4c13.4 3.6 25.1 6.9 33 12c3.8 2.4 6.2 5 7.5 7.7c1.3 2.6 1.9 6 .9 11c-1.3 6.6-6 11.8-14.8 15.2c-9 3.4-21.4 4.5-35.8 2.5c-7.2-1-19.4-4.7-28.9-7.6c-2.1-.6-4-1.2-5.7-1.7c-4.2-1.3-8.7 1.2-9.9 5.4s1.2 8.7 5.4 9.9c1.4 .4 3.1 .9 5 1.5c9.4 2.9 23.3 7.1 31.9 8.3l0 0c1.8 .2 3.6 .5 5.3 .6v13.9c0 4.4 3.6 8 8 8s8-3.6 8-8l0-13.5c8.2-.4 15.8-1.9 22.4-4.4c12.4-4.7 22.2-13.6 24.8-27.1c1.5-7.8 .8-14.9-2.3-21.1c-3-6.1-7.8-10.6-13.2-14.1c-10.4-6.7-24.8-10.6-37.5-14l-.3-.1c-13.4-3.6-25-6.7-33-11.5c-3.9-2.3-6.2-4.7-7.5-7.1c-1.2-2.3-1.9-5.3-1-9.8c1-5.4 5.6-10.8 14.8-14.5c9.1-3.7 21.7-5.1 35.9-3.2c4.6 .6 18.6 3.1 23 4.1c4.3 1 8.6-1.6 9.6-5.9s-1.6-8.6-5.9-9.6c-5.1-1.2-19.7-3.7-24.5-4.4c-1.8-.2-3.6-.5-5.3-.6V250.7c0-4.4-3.6-8-8-8z"]
  },
  up = {
    prefix: "fat",
    iconName: "stars",
    icon: [512, 512, [], "f762", "M344 0c4.4 0 8 3.6 8 8V72h64c4.4 0 8 3.6 8 8s-3.6 8-8 8H352v64c0 4.4-3.6 8-8 8s-8-3.6-8-8V88H272c-4.4 0-8-3.6-8-8s3.6-8 8-8h64V8c0-4.4 3.6-8 8-8zM138.4 258.5c-2.3 4.7-6.8 8-12 8.8L22.9 282.3c-6.6 1-9.2 9-4.4 13.6l74.9 73.2c3.8 3.7 5.5 9 4.6 14.1L80.3 486.6c-1.1 6.5 5.7 11.5 11.6 8.4l92.6-48.8c4.7-2.5 10.2-2.5 14.9 0L291.9 495c5.9 3.1 12.7-1.9 11.6-8.4L285.9 383.3c-.9-5.2 .8-10.5 4.6-14.1l74.9-73.2c4.7-4.6 2.1-12.7-4.4-13.6L257.4 267.2c-5.2-.8-9.7-4-12-8.8l-46.3-94c-2.9-6-11.4-6-14.4 0l-46.3 94zM7.2 307.4C-7 293.5 .9 269.3 20.5 266.5l103.5-15.1 46.3-94c8.8-17.9 34.3-17.9 43.1 0l46.3 94 103.5 15.1c19.7 2.9 27.5 27 13.3 40.9l-74.9 73.2 17.7 103.3c3.4 19.6-17.2 34.6-34.8 25.3l-92.6-48.8L99.3 509.2c-17.6 9.3-38.2-5.7-34.8-25.3L82.2 380.6 7.2 307.4zM464 160v48h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H464v48c0 4.4-3.6 8-8 8s-8-3.6-8-8V224H400c-4.4 0-8-3.6-8-8s3.6-8 8-8h48V160c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  dp = {
    prefix: "fat",
    iconName: "h4",
    icon: [640, 512, [], "f86a", "M433.5 64.1c-4.3-.8-8.5 2-9.4 6.3l-40 208c-.5 2.3 .2 4.8 1.7 6.6s3.8 2.9 6.2 2.9H624V440c0 4.4 3.6 8 8 8s8-3.6 8-8V72c0-4.4-3.6-8-8-8s-8 3.6-8 8V272H401.7L439.9 73.5c.8-4.3-2-8.5-6.3-9.4zM16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72z"]
  },
  fp = {
    prefix: "fat",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", "M13.8 175.3C92 96.6 200.3 48 320 48s228 48.6 306.2 127.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3C556.4 82.5 444.1 32 320 32S83.6 82.5 2.5 164c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0zM320 208c72.2 0 137.8 28.1 186.5 74c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3C465.9 221.8 396.4 192 320 192s-145.9 29.8-197.5 78.4c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3c48.7-45.9 114.3-74 186.5-74zm0 160a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  pp = {
    prefix: "fat",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", "M85.3 16C64.7 16 48 32.7 48 53.3V272H464h16 24c4.4 0 8 3.6 8 8s-3.6 8-8 8H480 464 48 32 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V53.3C32 23.8 55.8 0 85.3 0c14.1 0 27.7 5.6 37.7 15.6l32.1 32.1C167.4 37.9 183 32 200 32c23.1 0 43.7 10.9 56.9 27.8l1.5-1.5c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-104 104c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l1.5-1.5C138.9 147.7 128 127.1 128 104c0-17 5.9-32.6 15.7-44.9L111.6 26.9c-7-7-16.5-10.9-26.3-10.9zM32 320H48v48c0 53 43 96 96 96H368c53 0 96-43 96-96V320h16v48c0 38.1-19 71.7-48 91.9V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V469.2c-14.5 6.9-30.8 10.8-48 10.8H144c-17.2 0-33.5-3.9-48-10.8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V459.9C51 439.7 32 406.1 32 368V320zM200 48c-30.9 0-56 25.1-56 56c0 18.7 9.2 35.3 23.3 45.4l78.2-78.2C235.3 57.2 218.7 48 200 48z"]
  },
  mp = {
    prefix: "fat",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", "M0 40c0-4.4 3.6-8 8-8H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H80V240c0 79.5 64.5 144 144 144s144-64.5 144-144V48H312c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H384V240c0 88.4-71.6 160-160 160s-160-71.6-160-160V48H8c-4.4 0-8-3.6-8-8zM0 472c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z"]
  },
  hp = {
    prefix: "fat",
    iconName: "bold",
    icon: [384, 512, [], "f032", "M0 40c0-4.4 3.6-8 8-8H40 72 224c61.9 0 112 50.1 112 112c0 43.1-24.4 80.5-60.1 99.3C328.7 255.8 368 303.3 368 360c0 66.3-53.7 120-120 120H72 40 8c-4.4 0-8-3.6-8-8s3.6-8 8-8H32V248 48H8c-4.4 0-8-3.6-8-8zM48 464H72 248c57.4 0 104-46.6 104-104s-46.6-104-104-104H224 48V464zm0-224H224c53 0 96-43 96-96s-43-96-96-96H72 48V240z"]
  },
  Ap = {
    prefix: "fat",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm96 104c0-8.8 7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H256c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm0 96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16zm16-224c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-192 0zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H128zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H128z"]
  },
  gp = {
    prefix: "fat",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm72 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H376c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm0 96c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H136z"]
  },
  vp = {
    prefix: "fat",
    iconName: "image",
    icon: [512, 512, [], "f03e", "M64 48C37.5 48 16 69.5 16 96V356.7l89.4-89.4c12.5-12.5 32.8-12.5 45.3 0L224 340.7 361.4 203.3c12.5-12.5 32.8-12.5 45.3 0L496 292.7V96c0-26.5-21.5-48-48-48H64zM16 379.3V416c0 26.5 21.5 48 48 48h36.7l112-112-73.4-73.4c-6.2-6.2-16.4-6.2-22.6 0L16 379.3zM395.3 214.6c-6.2-6.2-16.4-6.2-22.6 0L123.3 464H448c26.5 0 48-21.5 48-48V315.3L395.3 214.6zM0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm168 64a40 40 0 1 0 -80 0 40 40 0 1 0 80 0zm-96 0a56 56 0 1 1 112 0A56 56 0 1 1 72 160z"]
  },
  Cp = {
    prefix: "fat",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", "M419.9 384.1c-70.7 90.5-201.4 106.6-292 35.8C105 402 86.9 380.2 73.7 356.3c-2.1-3.9-7-5.3-10.9-3.2s-5.3 7-3.2 10.9c14.2 25.8 33.7 49.3 58.4 68.6c97.5 76.2 238.3 58.9 314.4-38.6s58.9-238.3-38.6-314.4C304.1 9.3 177.5 18.5 98.6 96.6l11.3 11.3c73.3-72.5 190.8-81 274.2-15.8c90.5 70.7 106.6 201.4 35.8 292zM32 192c-4.4 0-8-3.6-8-8V64c0-3.2 1.9-6.2 4.9-7.4s6.4-.6 8.7 1.7l120 120c2.3 2.3 3 5.7 1.7 8.7s-4.2 4.9-7.4 4.9H32zm120 16c9.7 0 18.5-5.8 22.2-14.8s1.7-19.3-5.2-26.2L49 47c-6.9-6.9-17.2-8.9-26.2-5.2S8 54.3 8 64V184c0 13.3 10.7 24 24 24H152z"]
  },
  bp = {
    prefix: "fat",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", "M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM274.7 312H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H295l-20.3-16zm252.7 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H507.1l20.3 16zM536 200c4.4 0 8-3.6 8-8s-3.6-8-8-8H345l20.3 16H536zm-403.1 0l-20.3-16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8h28.9zM536 56H182.9l20.3 16H536c4.4 0 8-3.6 8-8s-3.6-8-8-8zM457.1 456l-20.3-16H104c-4.4 0-8 3.6-8 8s3.6 8 8 8H457.1z"]
  },
  Ep = {
    prefix: "fat",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM357.7 197.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L224 308.7l-58.3-58.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l64 64c3.1 3.1 8.2 3.1 11.3 0l128-128z"]
  },
  yp = Ep,
  Ip = {
    prefix: "fat",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", "M162.7 94.5c3.7-2.2 6.4-5.7 7.5-9.9L186.1 22c.7-2.8 2.9-5 5.7-5.8s5.8 .1 7.8 2.1l45 46.2c3 3.1 7.1 4.8 11.5 4.8s8.5-1.7 11.5-4.8l45-46.2c2-2.1 5-2.9 7.8-2.1s5 3 5.7 5.8l15.8 62.5c1.1 4.2 3.8 7.8 7.5 9.9s8.2 2.7 12.3 1.5l62-17.5c2.8-.8 5.8 0 7.8 2s2.8 5 2 7.8l-17.5 62c-1.2 4.2-.6 8.6 1.5 12.3s5.7 6.4 9.9 7.5L490 186.1c2.8 .7 5 2.9 5.8 5.7s-.1 5.8-2.1 7.8l-46.2 45c-3.1 3-4.8 7.1-4.8 11.5s1.7 8.5 4.8 11.5l46.2 45c2.1 2 2.9 5 2.1 7.8s-3 5-5.8 5.7l-62.5 15.8c-4.2 1.1-7.8 3.8-9.9 7.5s-2.7 8.2-1.5 12.3l17.5 62c.8 2.8 0 5.8-2 7.8s-5 2.8-7.8 2l-62-17.5c-4.2-1.2-8.6-.6-12.3 1.5s-6.4 5.7-7.5 9.9L325.9 490c-.7 2.8-2.9 5-5.7 5.8s-5.8-.1-7.8-2.1l-45-46.2c-3-3.1-7.1-4.8-11.5-4.8s-8.5 1.7-11.5 4.8l-45 46.2c-2 2.1-5 2.9-7.8 2.1s-5-3-5.7-5.8l-15.8-62.5c-1.1-4.2-3.8-7.8-7.5-9.9s-8.2-2.7-12.3-1.5l-62 17.5c-2.8 .8-5.8 0-7.8-2s-2.8-5-2-7.8l17.5-62c1.2-4.2 .6-8.6-1.5-12.3s-5.7-6.4-9.9-7.5L22 325.9c-2.8-.7-5-2.9-5.8-5.7s.1-5.8 2.1-7.8l46.2-45c3.1-3 4.8-7.1 4.8-11.5s-1.7-8.5-4.8-11.5l-46.2-45c-2.1-2-2.9-5-2.1-7.8s3-5 5.8-5.7l62.5-15.8c4.2-1.1 7.8-3.8 9.9-7.5s2.7-8.2 1.5-12.3l-17.5-62c-.8-2.8 0-5.8 2-7.8s5-2.8 7.8-2l62 17.5c4.2 1.2 8.6 .6 12.4-1.5zM244.8 42L211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3l-11.9 47-3.9 15.5-15.4-4.4L92.7 63.1c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l13.2 46.6 4.4 15.4-15.5 3.9-47 11.9c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211L42 244.8 53.5 256 42 267.2 7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l47 11.9 15.5 3.9-4.4 15.4L63.1 419.3c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l46.6-13.2 15.4-4.4 3.9 15.5 11.9 47c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4L244.8 470 256 458.5 267.2 470 301 504.7c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l11.9-47 3.9-15.5 15.4 4.4 46.6 13.2c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-13.2-46.6-4.4-15.4 15.5-3.9 47-11.9c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4L470 267.2 458.5 256 470 244.8 504.7 211c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-47-11.9-15.5-3.9 4.4-15.4 13.2-46.6c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1L372.7 76.2l-15.4 4.4-3.9-15.5-11.9-47c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L267.2 42 256 53.5 244.8 42z"]
  },
  Bp = {
    prefix: "fat",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", "M13 1.7C9.5-1 4.5-.4 1.7 3S-.4 11.5 3 14.3l624 496c3.5 2.7 8.5 2.2 11.2-1.3s2.2-8.5-1.3-11.2L13 1.7zM390 48H547.5c5.2 0 9 4.9 7.8 9.9l-11 44.1c-1.1 4.3 1.5 8.6 5.8 9.7s8.6-1.5 9.7-5.8l11-44.1c3.8-15.1-7.7-29.8-23.3-29.8H384.2h-.4H180.5c-9.8 0-18.5 6-22.2 14.8l13.6 10.7 .9-3.5c.9-3.6 4.1-6.1 7.8-6.1H373.3L332.8 184.6l13.5 10.7L390 48zM293.7 316.7L250 464H168c-4.4 0-8 3.6-8 8s3.6 8 8 8h87.8 .4H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H266.7l40.5-136.6-13.5-10.7z"]
  },
  xp = {
    prefix: "fat",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", "M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM87.7 245.8c-1.2-4.2-5.7-6.7-9.9-5.4s-6.7 5.7-5.4 9.9l56 192c1 3.4 4.1 5.8 7.7 5.8s6.7-2.3 7.7-5.8L192 276.6l48.3 165.7c1 3.4 4.1 5.8 7.7 5.8s6.7-2.3 7.7-5.8l56-192c1.2-4.2-1.2-8.7-5.4-9.9s-8.7 1.2-9.9 5.4L248 411.4 199.7 245.8c-1-3.4-4.1-5.8-7.7-5.8s-6.7 2.3-7.7 5.8L136 411.4 87.7 245.8z"]
  },
  wp = {
    prefix: "fat",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", "M288 0c-6.4 0-12.8 1.4-18.6 4.1L43.9 109.4C36.6 112.7 32 120 32 128s4.6 15.3 11.9 18.6L269.4 251.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 146.6C539.4 143.3 544 136 544 128s-4.6-15.3-11.9-18.6L306.6 4.1C300.8 1.4 294.4 0 288 0zM276.1 18.6c3.7-1.7 7.8-2.6 11.9-2.6s8.2 .9 11.9 2.6L525.4 123.9c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 237.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 132.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1L276.1 18.6zM43.9 237.4C36.6 240.7 32 248 32 256s4.6 15.3 11.9 18.6L269.4 379.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 274.6C539.4 271.3 544 264 544 256s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 365.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 260.1c-1.6-.7-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8L43.9 237.4zm0 128C36.6 368.7 32 376 32 384s4.6 15.3 11.9 18.6L269.4 507.9c5.8 2.7 12.2 4.1 18.6 4.1s12.8-1.4 18.6-4.1L532.1 402.6C539.4 399.3 544 392 544 384s-4.6-15.3-11.9-18.6l-59.4-27.7-18.9 8.8 71.5 33.4c1.6 .7 2.6 2.4 2.6 4.1s-1 3.4-2.6 4.1L299.9 493.4c-3.7 1.7-7.8 2.6-11.9 2.6s-8.2-.9-11.9-2.6L50.6 388.1c-1.6-.8-2.6-2.4-2.6-4.1s1-3.4 2.6-4.1l71.5-33.4-18.9-8.8L43.9 365.4z"]
  },
  Qp = {
    prefix: "fat",
    iconName: "italic",
    icon: [384, 512, [], "f033", "M128 40c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H285.4L115.9 464H248c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H98.6L268.1 48H136c-4.4 0-8-3.6-8-8z"]
  },
  Hp = {
    prefix: "fat",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", "M208 16C99.4 16 16 90 16 176c0 36.1 15.1 68.8 38.9 96.5c1.9 2.2 2.4 5.3 1.4 8c-8 21.5-21.4 41.2-40.2 55.4L16 336c28.8 0 57.3-10.1 83.4-23.9c2.3-1.2 5-1.2 7.3-.1c31.7 15.7 65.9 24 101.3 24c108.6 0 192-74 192-160s-83.4-160-192-160zM0 176C0 78.8 93.1 0 208 0S416 78.8 416 176s-93.1 176-208 176c-36.5 0-71.9-8.4-104.7-23.9C76.8 341.7 47 352 16 352c-6.9 0-13.1-4.5-15.2-11.1c-2.1-6.6 .2-13.7 5.7-17.8c14.7-11.2 25.9-26.6 33.1-43.9C15.7 250.1 0 215.2 0 176zm448 0c0-5.2-.2-10.4-.6-15.5C555.1 167.1 640 243.2 640 336c0 39.2-15.7 74.1-39.6 103.2c7.2 17.3 18.4 32.7 33.1 43.9c5.5 4.1 7.9 11.3 5.7 17.8c-2.1 6.6-8.3 11.1-15.2 11.1c-31 0-60.8-10.3-87.3-23.9C503.9 503.6 468.5 512 432 512c-95.7 0-176.2-54.6-200.5-129c5.5-.5 10.9-1.1 16.3-1.9C271 446.3 343 496 432 496c35.3 0 69.6-8.4 101.3-24c2.3-1.1 5-1.1 7.3 .1C566.7 485.9 595.2 496 624 496l-.1-.1c-18.7-14.2-32.2-33.9-40.2-55.4c-1-2.7-.5-5.8 1.4-8C608.9 404.9 624 372.1 624 336c0-81.7-75.3-152.6-176-159.5l0-.5zM215.1 90.7v14.8c1.7 .2 3.3 .4 5 .6c4.3 .7 17.5 3.2 22.1 4.4c3.8 1 6.1 4.9 5.1 8.7s-4.9 6.1-8.7 5.1c-4-1-16.6-3.5-20.7-4.1c-12.7-2-23.9-.5-32 3.1c-8.1 3.6-12.5 9-13.6 15.1c-.8 4.8-.2 8.2 1 10.8c1.3 2.7 3.5 5.1 7 7.4c7.2 4.8 17.6 7.9 29.6 11.5l.2 .1c11.4 3.4 24.4 7.3 33.8 14.1c4.9 3.5 9.1 8 11.7 13.8c2.6 5.9 3.3 12.6 1.9 20.1c-2.2 12.8-10.7 21.6-22.1 26.4c-6.1 2.6-13 4-20.5 4.4v14.3c0 3.9-3.2 7.1-7.1 7.1s-7.1-3.2-7.1-7.1V246.6c-1.7-.2-3.3-.4-5-.6l0 0c-7.7-1.2-20.3-5.5-28.8-8.3l0 0c-1.7-.6-3.2-1.1-4.5-1.5c-3.7-1.2-5.8-5.2-4.5-9s5.2-5.8 9-4.5c1.6 .5 3.3 1.1 5.1 1.7l0 0 0 0 0 0 0 0c8.6 2.9 19.5 6.6 25.9 7.6c12.9 2 24 .9 32-2.4c7.7-3.3 12.3-8.6 13.6-15.8c.9-5.3 .3-9.1-.9-12c-1.3-2.9-3.6-5.6-6.9-8c-7.1-5.1-17.5-8.4-29.6-12l-1.5-.4c-11-3.3-23.3-6.9-32.2-12.9c-4.9-3.3-9.2-7.5-11.9-13.1c-2.7-5.7-3.5-12.2-2.2-19.4c2.1-11.9 10.7-20.7 21.8-25.6c6.1-2.7 13.2-4.4 20.7-5V90.7c0-3.9 3.2-7.1 7.1-7.1s7.1 3.2 7.1 7.1z"]
  },
  zp = {
    prefix: "fat",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", "M19.5 186.7L144.6 54.6c4-4.2 9.6-6.6 15.4-6.6s11.4 2.4 15.4 6.6L300.5 186.7c2.2 2.3 3.5 5.4 3.5 8.7c0 7-5.6 12.6-12.6 12.6H28.6c-7 0-12.6-5.6-12.6-12.6c0-3.2 1.2-6.3 3.5-8.7zm-11.6-11C2.8 181 0 188.1 0 195.4C0 211.2 12.8 224 28.6 224H291.4c15.8 0 28.6-12.8 28.6-28.6c0-7.3-2.8-14.4-7.8-19.7L187 43.6C180 36.2 170.2 32 160 32s-20 4.2-27 11.6L7.8 175.7zM19.5 325.3c-2.2-2.3-3.5-5.4-3.5-8.7c0-7 5.6-12.6 12.6-12.6H291.4c7 0 12.6 5.6 12.6 12.6c0 3.2-1.2 6.3-3.5 8.7L175.4 457.4c-4 4.2-9.6 6.6-15.4 6.6s-11.4-2.4-15.4-6.6L19.5 325.3zm-11.6 11L133 468.4c7 7.4 16.8 11.6 27 11.6s20-4.2 27-11.6L312.2 336.3c5-5.3 7.8-12.4 7.8-19.7c0-15.8-12.8-28.6-28.6-28.6H28.6C12.8 288 0 300.8 0 316.6c0 7.3 2.8 14.4 7.8 19.7z"]
  },
  Mp = {
    prefix: "fat",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", "M40 48c0-4.4 3.6-8 8-8H80c4.4 0 8 3.6 8 8V208h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H32c-4.4 0-8-3.6-8-8s3.6-8 8-8H72V56H48c-4.4 0-8-3.6-8-8zm71.2 270.7c-13.3-15.2-36.4-16.9-51.7-3.7L37.2 334.1c-3.4 2.9-8.4 2.5-11.3-.9s-2.5-8.4 .9-11.3l22.3-19.1c22-18.9 55.1-16.5 74.2 5.3c17.9 20.5 17.4 51.1-1.2 71L42.5 464H136c4.4 0 8 3.6 8 8s-3.6 8-8 8H24c-3.2 0-6.1-1.9-7.3-4.8s-.7-6.3 1.5-8.7l92.2-98.4c13-13.8 13.3-35.2 .8-49.5zM208 88H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 160H496c4.4 0 8 3.6 8 8s-3.6 8-8 8H208c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  kp = {
    prefix: "fat",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM336 80c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16zm-96 64c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V160c0-8.8 7.2-16 16-16zm-96 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM432 80c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16s-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM336 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zM464 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]
  },
  Np = {
    prefix: "fat",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", "M332.7 90.5L270.9 22.6c-3.8-4.2-9.2-6.6-14.9-6.6s-11.1 2.4-14.9 6.6L179.3 90.5c-2.1 2.4-3.3 5.4-3.3 8.6c0 7.1 5.8 12.8 12.8 12.8l134.3 0c7.1 0 12.8-5.8 12.8-12.8c0-3.2-1.2-6.3-3.3-8.6zM282.8 11.8l61.7 67.9c4.8 5.3 7.5 12.2 7.5 19.4c0 15.9-12.9 28.8-28.8 28.8H264V248H384v16H264V384h59.2c15.9 0 28.8 12.9 28.8 28.8c0 7.2-2.7 14.1-7.5 19.4l-61.7 67.9c-6.9 7.5-16.6 11.8-26.8 11.8s-19.9-4.3-26.8-11.8l-61.7-67.9c-4.8-5.3-7.5-12.2-7.5-19.4c0-15.9 12.9-28.8 28.8-28.8H248V264H128l0 59.2c0 15.9-12.9 28.8-28.8 28.8c-7.2 0-14.1-2.7-19.4-7.5L11.8 282.8C4.3 275.9 0 266.2 0 256s4.3-19.9 11.8-26.8l67.9-61.7c5.3-4.8 12.2-7.5 19.4-7.5c15.9 0 28.8 12.9 28.8 28.8l0 59.2H248V128l-59.2 0c-15.9 0-28.8-12.9-28.8-28.8c0-7.2 2.7-14.1 7.5-19.4l61.7-67.9C236.1 4.3 245.8 0 256 0s19.9 4.3 26.8 11.8zM270.9 489.4l61.7-67.9c2.2-2.4 3.3-5.4 3.3-8.6c0-7.1-5.8-12.8-12.8-12.8H188.8c-7.1 0-12.8 5.8-12.8 12.8c0 3.2 1.2 6.3 3.3 8.6l61.7 67.9c3.8 4.2 9.2 6.6 14.9 6.6s11.1-2.4 14.9-6.6zM489.4 270.9c4.2-3.8 6.6-9.2 6.6-14.9s-2.4-11.1-6.6-14.9l-67.9-61.7c-2.4-2.1-5.4-3.3-8.6-3.3c-7.1 0-12.8 5.8-12.8 12.8V323.2c0 7.1 5.8 12.8 12.8 12.8c3.2 0 6.3-1.2 8.6-3.3l67.9-61.7zm-57.1 73.6c-5.3 4.8-12.2 7.5-19.4 7.5c-15.9 0-28.8-12.9-28.8-28.8V188.8c0-15.9 12.9-28.8 28.8-28.8c7.2 0 14.1 2.7 19.4 7.5l67.9 61.7c7.5 6.9 11.8 16.6 11.8 26.8s-4.3 19.9-11.8 26.8l-67.9 61.7zM90.5 332.7c2.4 2.2 5.4 3.3 8.6 3.3c7.1 0 12.8-5.8 12.8-12.8l0-134.3c0-7.1-5.8-12.8-12.8-12.8c-3.2 0-6.3 1.2-8.6 3.3L22.6 241.1c-4.2 3.8-6.6 9.2-6.6 14.9s2.4 11.1 6.6 14.9l67.9 61.7z"]
  },
  Sp = {
    prefix: "fat",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", "M232.1 170.7L78.8 193.3c-3 .4-5.5 2.5-6.4 5.4s-.2 6 2 8.2L63.2 218.1l11.2-11.3L185.5 317c3.7 3.7 5.4 8.9 4.5 14L163.8 486.6c-.5 3 .7 6 3.2 7.8s5.8 2 8.4 .6L312 422V22L244.1 161.8c-2.3 4.8-6.8 8.1-12.1 8.8zM328 422.1L464.4 495c2.7 1.4 6 1.2 8.4-.6s3.7-4.8 3.2-7.8L449.9 331c-.9-5.1 .8-10.4 4.5-14L565.5 206.9c2.2-2.1 2.9-5.3 2-8.2s-3.4-5-6.4-5.4L407.8 170.7c-5.2-.8-9.7-4.1-12.1-8.8L328 22.3V422.1zm154.2 85.3c-7.4 5.3-17.3 6-25.3 1.7l-137-73.2L183 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L63.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L298.3 13.5C302.4 5.2 310.7 0 319.9 0s17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L465.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5z"]
  },
  Vp = {
    prefix: "fat",
    iconName: "code",
    icon: [640, 512, [], "f121", "M410.7 .5c-4.2-1.5-8.7 .7-10.2 4.9l-176 496c-1.5 4.2 .7 8.7 4.9 10.2s8.7-.7 10.2-4.9l176-496c1.5-4.2-.7-8.7-4.9-10.2zm71.5 122.1c-3 3.2-2.9 8.3 .3 11.3L612.3 256 482.5 378.2c-3.2 3-3.4 8.1-.3 11.3s8.1 3.4 11.3 .3l136-128c1.6-1.5 2.5-3.6 2.5-5.8s-.9-4.3-2.5-5.8l-136-128c-3.2-3-8.3-2.9-11.3 .3zm-324.3 0c-3-3.2-8.1-3.4-11.3-.3l-136 128C8.9 251.7 8 253.8 8 256s.9 4.3 2.5 5.8l136 128c3.2 3 8.3 2.9 11.3-.3s2.9-8.3-.3-11.3L27.7 256 157.5 133.8c3.2-3 3.4-8.1 .3-11.3z"]
  },
  Lp = {
    prefix: "fat",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", "M16 8c0-4.4-3.6-8-8-8S0 3.6 0 8V200 439.7 504c0 4.4 3.6 8 8 8s8-3.6 8-8V447.7H216 560V504c0 4.4 3.6 8 8 8s8-3.6 8-8V439.7 280 200 136c0-57.4-46.6-104-104-104H232c-13.3 0-24 10.7-24 24V192H16V8zM208 296V431.7H16V208H216 560v64H232c-13.3 0-24 10.7-24 24zM560 136v56H224V56c0-4.4 3.6-8 8-8H472c48.6 0 88 39.4 88 88zM232 288H560V431.7H224V296c0-4.4 3.6-8 8-8zM112 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm0 128a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]
  },
  Pp = {
    prefix: "fat",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", "M28.3 34.5C31 14.7 47.9 0 67.9 0h153C240.3 0 256 15.7 256 35.1c0 4.2-.8 8.4-2.2 12.3L211.5 160H357.7c14.5 0 26.3 11.8 26.3 26.3c0 5.3-1.6 10.6-4.7 15L170.4 503c-3.9 5.7-10.4 9-17.2 9c-13.9 0-24-13.3-20.2-26.7L189.4 288H40c-22.1 0-40-17.9-40-40v-8c0-.4 0-.7 .1-1.1L28.3 34.5zM67.9 16c-12 0-22.1 8.8-23.8 20.7L16 240.5V248c0 13.3 10.7 24 24 24H200c2.5 0 4.9 1.2 6.4 3.2s2 4.6 1.3 7L148.4 489.7c-.9 3.2 1.5 6.3 4.8 6.3c1.6 0 3.2-.8 4.1-2.1L366.2 192.1c1.2-1.7 1.8-3.8 1.8-5.9c0-5.7-4.6-10.3-10.3-10.3H200c-2.6 0-5.1-1.3-6.6-3.4s-1.8-4.9-.9-7.4L238.8 41.8c.8-2.1 1.2-4.4 1.2-6.7c0-10.5-8.5-19.1-19.1-19.1H67.9z"]
  },
  Op = {
    prefix: "fat",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", "M16 448V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm70.7 227.6c-2.5-3.7-7.4-4.7-11.1-2.2s-4.7 7.4-2.2 11.1l61 91.6-61 91.6c-2.5 3.7-1.5 8.6 2.2 11.1s8.6 1.5 11.1-2.2l57.3-86 57.3 86c2.5 3.7 7.4 4.7 11.1 2.2s4.7-7.4 2.2-11.1l-61-91.6 61-91.6c2.5-3.7 1.5-8.6-2.2-11.1s-8.6-1.5-11.1 2.2l-57.3 86-57.3-86z"]
  },
  Tp = {
    prefix: "fat",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm176.4-64a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm144 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM200 352a56 56 0 1 0 112 0 56 56 0 1 0 -112 0zm56 72a72 72 0 1 1 0-144 72 72 0 1 1 0 144z"]
  },
  Dp = {
    prefix: "fat",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", "M144 272a128 128 0 1 0 0-256 128 128 0 1 0 0 256zM287.8 152c-4.2 75.8-66.9 136-143.8 136C64.5 288 0 223.5 0 144S64.5 0 144 0c76.8 0 139.6 60.2 143.8 136H353c3.6-13.8 16.1-24 31-24H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H384c-14.9 0-27.4-10.2-31-24H287.8zm96.2 8H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H384c-8.8 0-16 7.2-16 16s7.2 16 16 16zM264 320h8 16 48V296c0-13.3 10.7-24 24-24h80c13.3 0 24 10.7 24 24v24h48 16 8c4.4 0 8 3.6 8 8s-3.6 8-8 8h-8V464c0 26.5-21.5 48-48 48H320c-26.5 0-48-21.5-48-48V336h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8zm88 0h96V296c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v24zm160 16H288V464c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32V336zM224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zM48 144a96 96 0 1 1 192 0A96 96 0 1 1 48 144zM0 504c0-4.4 3.6-8 8-8H216c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM160 336v64h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm16 80H160v16c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16h96 16 16c26.5 0 48 21.5 48 48s-21.5 48-48 48zM48 336v96c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V416 400 336H48z"]
  },
  Rp = {
    prefix: "fat",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", "M224 16c61.9 0 112 50.1 112 112v64H112V128c0-61.9 50.1-112 112-112zM96 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H352V128C352 57.3 294.7 0 224 0S96 57.3 96 128zM64 208H96h16H336h16 32c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48zM240 320v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V320c0-8.8 7.2-16 16-16s16 7.2 16 16zm-48 0v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320c0-17.7-14.3-32-32-32s-32 14.3-32 32z"]
  },
  Gp = {
    prefix: "fat",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", "M336 128c0-61.9 50.1-112 112-112s112 50.1 112 112v88c0 4.4 3.6 8 8 8s8-3.6 8-8V128C576 57.3 518.7 0 448 0S320 57.3 320 128v64H64c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H336V128zm-16 80h16 48c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V256c0-26.5 21.5-48 48-48H320z"]
  },
  Fp = {
    prefix: "fat",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"]
  },
  jp = {
    prefix: "fat",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", "M176 240l0-89.1c0-3.8-3.1-6.9-6.9-6.9c-1.8 0-3.5 .7-4.7 1.9L16.8 286.1c-.5 .5-.8 1.2-.8 1.9s.3 1.4 .8 1.9L164.4 430.1c1.3 1.2 3 1.9 4.7 1.9c3.8 0 6.9-3.1 6.9-6.9l0-89.1c0-8.8 7.2-16 16-16l208 0c53 0 96-43 96-96l0-152c0-13.3-10.7-24-24-24l-16 0c-13.3 0-24 10.7-24 24l0 152c0 17.7-14.3 32-32 32l-208 0c-8.8 0-16-7.2-16-16zM5.8 274.5L153.4 134.3c4.3-4 9.9-6.3 15.8-6.3c12.6 0 22.9 10.2 22.9 22.9l0 73.1 0 16 16 0 192 0c8.8 0 16-7.2 16-16l0-152c0-22.1 17.9-40 40-40l16 0c22.1 0 40 17.9 40 40l0 152c0 61.9-50.1 112-112 112l-192 0-16 0 0 16 0 73.1c0 12.6-10.2 22.9-22.9 22.9c-5.9 0-11.5-2.3-15.8-6.3L5.8 301.5C2.1 298 0 293.1 0 288s2.1-10 5.8-13.5z"]
  },
  Jp = {
    prefix: "fat",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", "M496 256A240 240 0 1 0 16 256a240 240 0 1 0 480 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-56c0-30.9 25.1-56 56-56h56.2c35.2 0 63.8 28.6 63.8 63.8c0 21.4-10.8 41.5-28.7 53.3L264 294.9V320c0 4.4-3.6 8-8 8s-8-3.6-8-8V290.5c0-2.7 1.4-5.2 3.6-6.7l54.9-36.2c13.4-8.8 21.5-23.8 21.5-39.9c0-26.4-21.4-47.8-47.8-47.8H224c-22.1 0-40 17.9-40 40l0 6.5c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-6.5zm72 168a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  Zp = {
    prefix: "fat",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM176 368h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H176c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H184V496zM456 368h16c17.7 0 32 14.3 32 32v8c0 4.4-3.6 8-8 8s-8-3.6-8-8v-8c0-8.8-7.2-16-16-16H456c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-8c0-4.4 3.6-8 8-8s8 3.6 8 8v8c0 17.7-14.3 32-32 32H456c-17.7 0-32-14.3-32-32V400c0-17.7 14.3-32 32-32zM296 400c0-17.7 14.3-32 32-32h16c17.7 0 32 14.3 32 32v80c0 17.7-14.3 32-32 32H328c-17.7 0-32-14.3-32-32V400zm32-16c-8.8 0-16 7.2-16 16v80c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H328z"]
  },
  Wp = {
    prefix: "fat",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", "M106.3 124.3C151.4 82.4 212.4 48 288 48s136.6 34.4 181.7 76.3c44.9 41.7 75 91.7 89.1 125.6c1.6 3.9 1.6 8.4 0 12.3C544.7 296 514.6 346 469.7 387.7C424.6 429.6 363.6 464 288 464s-136.6-34.4-181.7-76.3C61.4 346 31.3 296 17.2 262.2c-1.6-3.9-1.6-8.4 0-12.3C31.3 216 61.4 166 106.3 124.3zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm208 0a112 112 0 1 0 -224 0 112 112 0 1 0 224 0z"]
  },
  Xp = {
    prefix: "fat",
    iconName: "heat",
    icon: [448, 512, [], "e00c", "M176 32c4.4 0 8 3.6 8 8V144c0 39.8 12.9 78.6 36.8 110.4L240 280c26 34.6 40 76.7 40 120v72c0 4.4-3.6 8-8 8s-8-3.6-8-8V400c0-39.8-12.9-78.6-36.8-110.4L208 264c-26-34.6-40-76.7-40-120V40c0-4.4 3.6-8 8-8zM8 96c4.4 0 8 3.6 8 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C100.3 340 112 378.6 112 418.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V418.1c0-36.3-10.8-71.8-30.9-102.1L33.6 268.8C11.7 236 0 197.4 0 157.9V104c0-4.4 3.6-8 8-8zm344 8v53.9c0 36.3 10.8 71.8 30.9 102.1l31.5 47.3C436.3 340 448 378.6 448 418.1V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V418.1c0-36.3-10.8-71.8-30.9-102.1l-31.5-47.3C347.7 236 336 197.4 336 157.9V104c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Up = {
    prefix: "fat",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", "M16 96c0-26.5 21.5-48 48-48l0 112c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V49.2c8.8 2 17 6.4 23.4 12.9l74.5 74.5c9 9 14.1 21.2 14.1 33.9V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V96zM80 48H304V160c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V48zM0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V170.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7H64C28.7 32 0 60.7 0 96zM296 328a72 72 0 1 1 -144 0 72 72 0 1 1 144 0zm-72-88a88 88 0 1 0 0 176 88 88 0 1 0 0-176z"]
  },
  Kp = {
    prefix: "fat",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", "M317.1 378.1c-4.7 5.7-12.6 7.5-19.2 4.3c-73.8-34.8-133.5-94.5-168.3-168.3c-3.1-6.6-1.3-14.6 4.3-19.2l49.3-40.4c8.2-6.7 11-18 7-27.8l-40-96c-4.6-11.1-16.8-17.1-28.5-13.9l-88 24C23.2 43.7 16 53.2 16 64c0 238.6 193.4 432 432 432c10.8 0 20.3-7.2 23.2-17.7l24-88c3.2-11.6-2.8-23.8-13.9-28.5l-96-40c-9.8-4.1-21.1-1.3-27.8 7l-40.4 49.3zM304.7 368L345 318.7c11.2-13.7 30-18.4 46.3-11.6l96 40c18.6 7.7 28.5 28 23.2 47.4l-24 88C481.8 499.9 466 512 448 512C200.6 512 0 311.4 0 64C0 46 12.1 30.2 29.5 25.4l88-24c19.4-5.3 39.7 4.6 47.4 23.2l40 96c6.8 16.3 2.1 35.2-11.6 46.3L144 207.3c33.3 70.4 90.3 127.4 160.7 160.7z"]
  },
  Yp = {
    prefix: "fat",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", "M72 48c-30.9 0-56 25.1-56 56V216c0 4.4-3.6 8-8 8s-8-3.6-8-8V104C0 64.2 32.2 32 72 32h37.2H120 454.1C468.4 32 480 43.6 480 57.9c0 4-.9 8-2.7 11.6L421.5 181c54.3 33.9 90.5 94.2 90.5 163c0 55.5-34.6 99.4-55.9 121.2C446.2 475.3 432.3 480 418 480H158c-14.2 0-28.1-4.7-38.1-14.8C98.6 443.4 64 399.5 64 344c0-69 36.4-129.5 91-163.3L97.1 50.6c-.4-.8-.6-1.7-.8-2.6H72zm98.4 128H406.1L463 62.3c.7-1.4 1-2.9 1-4.4c0-5.5-4.4-9.9-9.9-9.9H120h-6.5l56.9 128zM416 192H160v0h7.2c-41.1 24.1-71.6 64.3-82.7 112H491.4c-11.1-47.7-41.6-87.9-82.7-112H416v0zm78.4 128H81.6c-1.1 7.8-1.6 15.9-1.6 24c0 49.1 30.9 89.1 51.3 110c6.3 6.5 15.8 10 26.6 10H418c10.9 0 20.3-3.6 26.6-10c20.4-20.9 51.3-60.9 51.3-110c0-8.1-.6-16.2-1.6-24z"]
  },
  qp = {
    prefix: "fat",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", "M177.7 16h92.5c8.3 0 16 4.3 20.4 11.3l23 36.7H134.4l23-36.7c4.4-7 12.1-11.3 20.4-11.3zm-33.9 2.8L115.6 64H8c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H332.4L304.2 18.8C296.9 7.1 284.1 0 270.3 0H177.7c-13.8 0-26.6 7.1-33.9 18.8zM48 119.3c-.4-4.4-4.2-7.7-8.6-7.3s-7.7 4.2-7.3 8.6l28.3 340c2.4 29 26.7 51.4 55.8 51.4H331.8c29.1 0 53.4-22.3 55.8-51.4l28.3-340c.4-4.4-2.9-8.3-7.3-8.6s-8.3 2.9-8.6 7.3l-28.3 340C370 480.1 352.6 496 331.8 496H116.2c-20.8 0-38.1-15.9-39.9-36.7L48 119.3z"]
  },
  _p = {
    prefix: "fat",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", "M2.5 250.2C.9 251.7 0 253.8 0 256s.9 4.3 2.5 5.8l192 184c3.2 3.1 8.3 3 11.3-.2s2.9-8.3-.2-11.3L27.9 264 440 264c4.4 0 8-3.6 8-8s-3.6-8-8-8L27.9 248 205.5 77.8c3.2-3.1 3.3-8.1 .2-11.3s-8.1-3.3-11.3-.2l-192 184z"]
  },
  $p = {
    prefix: "fat",
    iconName: "align-left",
    icon: [448, 512, [], "f036", "M8 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM0 320c0 4.4 3.6 8 8 8H280c4.4 0 8-3.6 8-8s-3.6-8-8-8H8c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  em = {
    prefix: "fat",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zM224 272c8.8 0 16 7.2 16 16v24 48 24c0 8.8-7.2 16-16 16H112c-8.8 0-16-7.2-16-16V288c0-8.8 7.2-16 16-16H224zm32 112V373.8l42.6 24.3c2.2 1.2 4.6 1.9 7.1 1.9c7.9 0 14.3-6.4 14.3-14.3V286.3c0-7.9-6.4-14.3-14.3-14.3c-2.5 0-4.9 .7-7.1 1.9L256 298.2V288c0-17.7-14.3-32-32-32H112c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32H224c17.7 0 32-14.3 32-32zm48-1.2l-48-27.4V316.6l48-27.4v93.6z"]
  },
  tm = {
    prefix: "fat",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", "M345 16H472c13.3 0 24 10.7 24 24V167c0 13.8-11.2 25-25 25c-6.6 0-13-2.6-17.7-7.3L396 127.3 213.7 309.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L384.7 116 327.3 58.6c-4.7-4.7-7.3-11-7.3-17.7c0-13.8 11.2-25 25-25zm-9 25c0 2.4 .9 4.7 2.6 6.3L464.7 173.4c1.7 1.7 4 2.6 6.3 2.6c5 0 9-4 9-9V40c0-4.4-3.6-8-8-8H345c-5 0-9 4-9 9zM0 88C0 57.1 25.1 32 56 32H200c4.4 0 8 3.6 8 8s-3.6 8-8 8H56C33.9 48 16 65.9 16 88V456c0 22.1 17.9 40 40 40H424c22.1 0 40-17.9 40-40V312c0-4.4 3.6-8 8-8s8 3.6 8 8V456c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88z"]
  },
  nm = {
    prefix: "fat",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", "M64 496h48v16H64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V304H368V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48zM361.1 160c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM176 368h32c26.5 0 48 21.5 48 48s-21.5 48-48 48H184v40c0 4.4-3.6 8-8 8s-8-3.6-8-8V456 376c0-4.4 3.6-8 8-8zm32 80c17.7 0 32-14.3 32-32s-14.3-32-32-32H184v64h24zm96-80h32c22.1 0 40 17.9 40 40v64c0 22.1-17.9 40-40 40H304c-4.4 0-8-3.6-8-8V376c0-4.4 3.6-8 8-8zm8 128h24c13.3 0 24-10.7 24-24V408c0-13.3-10.7-24-24-24H312V496zM424 376c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v48h40c4.4 0 8 3.6 8 8s-3.6 8-8 8H440v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V440 376z"]
  },
  rm = {
    prefix: "fat",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", "M216 368H424c7.3 0 13.7 5 15.5 12.1l3.6 14.3C453.3 435.3 490 464 532.2 464c50.7 0 91.8-41.1 91.8-91.8v-2.8c0-5.4-.5-10.7-1.4-16L589.9 162.5c-7.8-45.5-36.6-82.3-78.4-92.7C466.8 58.7 402.5 48 320 48s-146.8 10.7-191.5 21.8c-41.9 10.4-70.6 47.3-78.4 92.7L17.4 353.4c-.9 5.3-1.4 10.6-1.4 16v2.8c0 50.7 41.1 91.8 91.8 91.8c42.1 0 78.9-28.7 89.1-69.5l3.6-14.3c1.8-7.1 8.2-12.1 15.5-12.1zm211.6 30.3L424 384H216l-3.6 14.3c-12 48-55.1 81.7-104.6 81.7C48.3 480 0 431.7 0 372.2v-2.8c0-6.3 .5-12.5 1.6-18.7L34.3 159.8c8.6-50.2 40.9-93.2 90.3-105.5C170.5 42.9 236.2 32 320 32s149.5 10.9 195.3 22.3c49.4 12.3 81.7 55.3 90.3 105.5l32.7 190.9c1.1 6.2 1.6 12.4 1.6 18.7v2.8C640 431.7 591.7 480 532.2 480c-49.5 0-92.6-33.7-104.6-81.7zM200 160v56h56c4.4 0 8 3.6 8 8s-3.6 8-8 8H200v56c0 4.4-3.6 8-8 8s-8-3.6-8-8V232H128c-4.4 0-8-3.6-8-8s3.6-8 8-8h56V160c0-4.4 3.6-8 8-8s8 3.6 8 8zM392 272a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm40 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm64-160a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24 40a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]
  },
  om = {
    prefix: "fat",
    iconName: "rv",
    icon: [640, 512, [], "f7be", "M248 16c-4.4 0-8 3.6-8 8v8H368V24c0-4.4-3.6-8-8-8H248zM224 32V24c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24v8H510.4c53.9 0 97.6 43.7 97.6 97.6c0 16.8-13.6 30.4-30.4 30.4H408c-13.3 0-24 10.7-24 24V392c0 4.4-3.6 8-8 8H284.7c2.2 7.6 3.3 15.7 3.3 24c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-10.5 1.8-20.6 5.2-30L22.9 324.8C8.5 314.3 0 297.5 0 279.7V88C0 57.1 25.1 32 56 32H224zM384 48H368 240 224 56C33.9 48 16 65.9 16 88V279.7c0 12.7 6.1 24.7 16.3 32.3l91.8 67.4C139.5 353.4 167.7 336 200 336c34.2 0 63.8 19.5 78.4 48H368V184c0-22.1 17.9-40 40-40H577.6c8 0 14.4-6.4 14.4-14.4C592 84.5 555.5 48 510.4 48H384zM200 496a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm288 0a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0-160a88 88 0 1 1 0 176 88 88 0 1 1 0-176zM272 128H112c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16H272c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16zM112 112H272c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H112c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32zm304 88c0-4.4 3.6-8 8-8h93.1c8.8 0 17.4 2.9 24.4 8.3l82.9 63.8c9.8 7.6 15.6 19.3 15.6 31.7V360c0 22.1-17.9 40-40 40h-8c-4.4 0-8-3.6-8-8s3.6-8 8-8h8c13.3 0 24-10.7 24-24V295.8c0-2.7-.4-5.3-1.3-7.8H424c-4.4 0-8-3.6-8-8s3.6-8 8-8H608.5l-76.7-59c-4.2-3.2-9.3-5-14.6-5H424c-4.4 0-8-3.6-8-8z"]
  },
  im = {
    prefix: "fat",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", "M384 16c26.5 0 48 21.5 48 48V448c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H384zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm0 48a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm80-32a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm48 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM351.6 314.3c-14.3 3.4-30.4 5.7-47.6 5.7c-32 0-56-16-80-32s-48-32-80-32c-13.4 0-27.4 2.2-40.7 5.4c17.6-49.7 65-85.4 120.7-85.4c70.7 0 128 57.3 128 128c0 3.5-.1 6.9-.4 10.3zm-2.5 16.9C336.6 388.8 285.3 432 224 432c-70.7 0-128-57.3-128-128c0-8.5 .8-16.8 2.4-24.9c15-4.2 30.9-7.1 45.6-7.1c26.5 0 46.6 13 71.1 29.3l1.2 .8C239.6 317.6 267.1 336 304 336c16.2 0 31.3-1.9 45.1-4.8zM224 448a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
  },
  am = {
    prefix: "fat",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", "M64 80c-26.5 0-48 21.5-48 48v28.2L220.8 321.4c20.5 16.5 49.8 16.5 70.3 0L496 156.2V128c0-26.5-21.5-48-48-48H64zM16 176.7V384c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V176.7L301.2 333.8c-26.4 21.3-64 21.3-90.4 0L16 176.7zM0 128C0 92.7 28.7 64 64 64H448c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
  },
  cm = {
    prefix: "fat",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", "M386.3 61.7c-32.2-32.2-84.5-32.2-116.7 0l-192 192c-49.9 49.9-49.9 130.8 0 180.7s130.8 49.9 180.7 0l152-152c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3l-152 152c-56.1 56.1-147.2 56.1-203.3 0s-56.1-147.2 0-203.3l192-192c38.5-38.5 100.8-38.5 139.3 0s38.5 100.8 0 139.3L213.9 373.4c-24.8 24.8-65.7 22.6-87.7-4.9c-18.8-23.4-16.9-57.2 4.3-78.5L282.3 138.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L141.9 301.4c-15.5 15.5-16.8 40.1-3.2 57.2c16 20 45.8 21.6 63.9 3.5L386.3 178.3c32.2-32.2 32.2-84.5 0-116.7z"]
  },
  sm = {
    prefix: "fat",
    iconName: "h6",
    icon: [640, 512, [], "e413", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm492.9-6.3c-3.5-2.7-8.5-2.1-11.2 1.4L383.3 213.3C363 239.2 352 271.1 352 304v0c0 79.5 64.5 144 144 144s144-64.5 144-144s-64.5-144-144-144c-22 0-42.8 4.9-61.5 13.7l75.8-96.8c2.7-3.5 2.1-8.5-1.4-11.2zM368 304c0-.7 0-1.3 0-2c1.1-69.8 58-126 128-126c70.7 0 128 57.3 128 128s-57.3 128-128 128s-128-57.3-128-128v0z"]
  },
  lm = {
    prefix: "fat",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-4.4 0-8 3.6-8 8s3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V216c0-4.4-3.6-8-8-8H224c-4.4 0-8 3.6-8 8s3.6 8 8 8h24V352H208zm48-176a16 16 0 1 0 0-32 16 16 0 1 0 0 32z"]
  },
  um = {
    prefix: "fat",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM144 144c0-8.8 7.2-16 16-16l96 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-96 0c-8.8 0-16-7.2-16-16zm64 96c0-8.8 7.2-16 16-16H352c8.8 0 16 7.2 16 16s-7.2 16-16 16H224c-8.8 0-16-7.2-16-16zm128 96c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16s-7.2 16-16 16H352c-8.8 0-16-7.2-16-16zM160 112c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm128 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H352z"]
  },
  dm = {
    prefix: "fat",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", "M424 256c0 4.4-3.6 8-8 8L32 264c-4.4 0-8-3.6-8-8s3.6-8 8-8l384 0c4.4 0 8 3.6 8 8z"]
  },
  fm = {
    prefix: "fat",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", "M211.6 28.5c1.6-7.3 8.1-12.5 15.6-12.5h57.6c7.5 0 14 5.2 15.6 12.5l12.9 57.1c.6 2.6 2.5 4.8 5 5.7c17.9 6.8 34.5 16.4 49.1 28.4c2.1 1.7 4.9 2.2 7.4 1.4l56-17.4c7.1-2.2 14.9 .8 18.6 7.3L478.3 161c3.7 6.5 2.5 14.7-3 19.8l-43.1 39.8c-2 1.8-2.9 4.5-2.5 7.2c1.5 9.2 2.3 18.7 2.3 28.4s-.8 19.1-2.3 28.4c-.4 2.6 .5 5.3 2.5 7.2l43.1 39.8c5.5 5.1 6.7 13.3 3 19.8L449.4 401c-3.7 6.5-11.5 9.5-18.6 7.3l-56-17.4c-2.6-.8-5.4-.3-7.4 1.4c-14.6 11.9-31.2 21.6-49.1 28.4c-2.5 1-4.4 3.1-5 5.7l-12.9 57.1c-1.6 7.3-8.1 12.5-15.6 12.5H227.2c-7.5 0-14-5.2-15.6-12.5l-12.9-57.1c-.6-2.6-2.5-4.8-5-5.7c-17.9-6.8-34.5-16.4-49.1-28.4c-2.1-1.7-4.9-2.2-7.4-1.4l-56 17.4c-7.1 2.2-14.9-.8-18.6-7.3L33.7 351c-3.7-6.5-2.5-14.7 3-19.8l43.1-39.8c2-1.8 2.9-4.5 2.5-7.2C80.8 275.1 80 265.7 80 256s.8-19.1 2.3-28.4c.4-2.6-.5-5.3-2.5-7.2L36.7 180.7c-5.5-5.1-6.7-13.3-3-19.8L62.6 111c3.7-6.5 11.5-9.5 18.6-7.3l2.4-7.6-2.4 7.6 56 17.4c2.6 .8 5.4 .3 7.4-1.4c14.6-12 31.2-21.6 49.1-28.4c2.5-1 4.4-3.1 5-5.7l12.9-57.1zM227.2 0c-15 0-27.9 10.4-31.2 25L184 78c-16.7 6.8-32.2 15.8-46.1 26.7L85.9 88.5C71.6 84 56.2 90.1 48.7 103L19.9 153c-7.5 13-5 29.4 6 39.5l39.9 36.9C64.6 238.1 64 247 64 256s.6 17.9 1.8 26.6L25.9 319.5l5.4 5.9-5.4-5.9c-11 10.1-13.5 26.6-6 39.5L48.7 409c7.5 13 22.9 19 37.2 14.6l51.9-16.2c14 10.9 29.5 19.9 46.1 26.7l12 53c3.3 14.6 16.3 25 31.2 25h57.6c15 0 27.9-10.4 31.2-25l12-53c16.7-6.7 32.2-15.8 46.1-26.7l51.9 16.2c14.3 4.4 29.7-1.6 37.2-14.6L492.1 359c7.5-13 5-29.4-6-39.5l-39.9-36.9c1.2-8.7 1.8-17.6 1.8-26.6s-.6-17.9-1.8-26.6l39.9-36.9c11-10.1 13.5-26.6 6-39.5L463.3 103c-7.5-13-22.9-19-37.2-14.6l-51.9 16.2C360.2 93.7 344.7 84.7 328 78L316 25c-3.3-14.6-16.3-25-31.2-25H227.2zM192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0zm144 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z"]
  },
  pm = {
    prefix: "fat",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", "M384 16c26.5 0 48 21.5 48 48V384H16V64c0-26.5 21.5-48 48-48H384zm48 384v48c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V400H432zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM168 448c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H176c-4.4 0-8 3.6-8 8z"]
  },
  mm = {
    prefix: "fat",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", "M8 496c-4.4 0-8 3.6-8 8s3.6 8 8 8l120 0c39.8 0 72-32.2 72-72l0-412.7L338.3 165.7c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0l-152 152c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L184 27.3 184 440c0 30.9-25.1 56-56 56L8 496z"]
  },
  hm = {
    prefix: "fat",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", "M496 256A240 240 0 1 1 16 256a240 240 0 1 1 480 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM248 104V256c0 2.7 1.3 5.2 3.6 6.7l96 64c3.7 2.5 8.6 1.5 11.1-2.2s1.5-8.6-2.2-11.1L264 251.7V104c0-4.4-3.6-8-8-8s-8 3.6-8 8z"]
  },
  Am = {
    prefix: "fat",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", "M288 16c26.5 0 48 21.5 48 48V384H48V64c0-26.5 21.5-48 48-48H288zm48 384v48c0 26.5-21.5 48-48 48H96c-26.5 0-48-21.5-48-48V400H336zM96 0C60.7 0 32 28.7 32 64V448c0 35.3 28.7 64 64 64H288c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H96zm40 448c0 4.4 3.6 8 8 8h96c4.4 0 8-3.6 8-8s-3.6-8-8-8H144c-4.4 0-8 3.6-8 8z"]
  },
  gm = {
    prefix: "fat",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", "M0 416c0 4.4 3.6 8 8 8l88.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56L504 424c4.4 0 8-3.6 8-8s-3.6-8-8-8l-280.5 0c-3.9-31.6-30.9-56-63.5-56s-59.6 24.4-63.5 56L8 408c-4.4 0-8 3.6-8 8zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-64c-32.6 0-59.6 24.4-63.5 56L8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l280.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56l88.5 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-88.5 0c-3.9-31.6-30.9-56-63.5-56zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm63.5-56c-3.9-31.6-30.9-56-63.5-56s-59.6 24.4-63.5 56L8 88c-4.4 0-8 3.6-8 8s3.6 8 8 8l120.5 0c3.9 31.6 30.9 56 63.5 56s59.6-24.4 63.5-56L504 104c4.4 0 8-3.6 8-8s-3.6-8-8-8L255.5 88z"]
  },
  vm = {
    prefix: "fat",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", "M64 400a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm0-128a16 16 0 1 1 0-32 16 16 0 1 1 0 32zM48 128a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  Cm = {
    prefix: "fat",
    iconName: "download",
    icon: [512, 512, [], "f019", "M264 8c0-4.4-3.6-8-8-8s-8 3.6-8 8V356.7L133.7 242.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l128 128c3.1 3.1 8.2 3.1 11.3 0l128-128c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L264 356.7V8zM143.4 320H64c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V384c0-35.3-28.7-64-64-64H368.6l-16 16H448c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V384c0-26.5 21.5-48 48-48h95.4l-16-16zM432 432a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
  },
  bm = {
    prefix: "fat",
    iconName: "oven",
    icon: [448, 512, [], "e01d", "M96 16C51.8 16 16 51.8 16 96v64H432V96c0-44.2-35.8-80-80-80H96zM0 168V96C0 43 43 0 96 0H352c53 0 96 43 96 96v72V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V168zm432 8H16V448c0 26.5 21.5 48 48 48H384c26.5 0 48-21.5 48-48V176zM80 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM272 80a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm80 16a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zM96 240c-8.8 0-16 7.2-16 16V416c0 8.8 7.2 16 16 16H352c8.8 0 16-7.2 16-16V256c0-8.8-7.2-16-16-16H96zM64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32V416c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zm64 40c0-4.4 3.6-8 8-8H312c4.4 0 8 3.6 8 8s-3.6 8-8 8H136c-4.4 0-8-3.6-8-8z"]
  },
  Em = {
    prefix: "fat",
    iconName: "align-center",
    icon: [448, 512, [], "f037", "M104 56c-4.4 0-8 3.6-8 8s3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104zM8 184c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM96 320c0 4.4 3.6 8 8 8H344c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM8 440c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8z"]
  },
  ym = {
    prefix: "fat",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M293.3 2c-3-2.7-7.6-2.7-10.6 0L2.7 250c-3.3 2.9-3.6 8-.7 11.3s8 3.6 11.3 .7L64 217.1V448c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V217.1L562.7 262c3.3 2.9 8.4 2.6 11.3-.7s2.6-8.4-.7-11.3L293.3 2zM80 448V202.9L288 18.7 496 202.9V448c0 26.5-21.5 48-48 48H368V328c0-13.3-10.7-24-24-24H232c-13.3 0-24 10.7-24 24V496H128c-26.5 0-48-21.5-48-48zm144 48V328c0-4.4 3.6-8 8-8H344c4.4 0 8 3.6 8 8V496H224z"]
  },
  Im = {
    prefix: "fat",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", "M92.1 384.1c70.7 90.5 201.4 106.6 292 35.8c22.9-17.9 41.1-39.7 54.2-63.7c2.1-3.9 7-5.3 10.9-3.2s5.3 7 3.2 10.9c-14.2 25.8-33.7 49.3-58.4 68.6c-97.5 76.2-238.3 58.9-314.4-38.6S20.6 155.7 118.1 79.5c89.8-70.2 216.4-61 295.3 17.1l-11.3 11.3c-73.3-72.5-190.8-81-274.2-15.8c-90.5 70.7-106.6 201.4-35.8 292zM480 192c4.4 0 8-3.6 8-8V64c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-120 120c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9H480zM360 208c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2L463 47c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V184c0 13.3-10.7 24-24 24H360z"]
  },
  Bm = {
    prefix: "fat",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", "M41.3 .1c4.4 .7 7.3 4.8 6.6 9.2L24.8 148.1c-.5 3-.8 6.1-.8 9.2V168c0 30.9 25.1 56 56 56h64c30.9 0 56-25.1 56-56V157.3c0-3.1-.3-6.2-.8-9.2L176.1 9.3c-.7-4.4 2.2-8.5 6.6-9.2s8.5 2.2 9.2 6.6L215 145.5c.7 3.9 1 7.9 1 11.8V168c0 39.8-32.2 72-72 72H120V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V240H80c-39.8 0-72-32.2-72-72V157.3c0-4 .3-7.9 1-11.8L32.1 6.7C32.8 2.3 37-.6 41.3 .1zM88.4 0c4.4 .2 7.8 4 7.6 8.4l-8 160c-.2 4.4-4 7.8-8.4 7.6s-7.8-4-7.6-8.4l8-160c.2-4.4 4-7.8 8.4-7.6zm47.2 0c4.4-.2 8.2 3.2 8.4 7.6l8 160c.2 4.4-3.2 8.2-7.6 8.4s-8.2-3.2-8.4-7.6l-8-160c-.2-4.4 3.2-8.2 7.6-8.4zM304 176V304c0 17.7 14.3 32 32 32h80V24c0-4.4-3.6-8-8-8l0 0c-.1 0-1.9 .1-5.7 1.1c-3.5 .9-8.1 2.5-13.4 4.8c-10.6 4.6-23.5 12.2-36 23.8C328.2 68.6 304 108.3 304 176zM408 0c13.3 0 24 10.7 24 24V336v8 8V504c0 4.4-3.6 8-8 8s-8-3.6-8-8V352H336c-26.5 0-48-21.5-48-48V176C288 32 392 0 408 0z"]
  },
  xm = {
    prefix: "fat",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", "M8 88c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H8zM136 248c-4.4 0-8 3.6-8 8s3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H136zm-8 168c0 4.4 3.6 8 8 8H440c4.4 0 8-3.6 8-8s-3.6-8-8-8H136c-4.4 0-8 3.6-8 8zM0 440c0 4.4 3.6 8 8 8s8-3.6 8-8l0-208c0-4.4-3.6-8-8-8s-8 3.6-8 8V440z"]
  },
  wm = {
    prefix: "fat",
    iconName: "upload",
    icon: [512, 512, [], "f093", "M264 27.3V376c0 4.4-3.6 8-8 8s-8-3.6-8-8V27.3L133.7 141.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l128-128c3.1-3.1 8.2-3.1 11.3 0l128 128c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L264 27.3zM216 336H64c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V384c0-26.5-21.5-48-48-48H296V320H448c35.3 0 64 28.7 64 64v64c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V384c0-35.3 28.7-64 64-64H216v16zm216 64a16 16 0 1 0 0 32 16 16 0 1 0 0-32zm32 16a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z"]
  },
  Qm = {
    prefix: "fat",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", "M309.9 6.3C314.4 2.2 320.3 0 326.4 0c17.8 0 29.9 18.3 22.9 34.7L268.1 224H391.4c13.6 0 24.6 11 24.6 24.6c0 7-3 13.7-8.3 18.4L138.1 505.7c-4.6 4-10.4 6.3-16.5 6.3c-17.9 0-29.9-18.3-22.9-34.7L179.9 288H55.3C42.5 288 32 277.5 32 264.7c0-6.7 2.8-13 7.8-17.4L309.9 6.3zM326.4 16c-2.2 0-4.3 .8-5.9 2.2L50.5 259.2c-1.6 1.4-2.5 3.4-2.5 5.5c0 4.1 3.3 7.3 7.3 7.3H192c2.7 0 5.2 1.4 6.7 3.6s1.7 5.1 .7 7.6L113.4 483.6c-2.5 5.9 1.8 12.4 8.2 12.4c2.2 0 4.3-.8 5.9-2.2L397.1 255c1.8-1.6 2.9-4 2.9-6.4c0-4.7-3.8-8.6-8.6-8.6H256c-2.7 0-5.2-1.4-6.7-3.6s-1.7-5.1-.7-7.6L334.6 28.4c2.5-5.8-1.8-12.4-8.1-12.4z"]
  },
  Hm = {
    prefix: "fat",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", "M8 0H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8S3.6 0 8 0zM48 202.6c9-3.5 19-6.6 29.5-9.4C120.2 182.1 174.9 176 224 176s103.8 6.1 146.5 17.3c10.6 2.8 20.5 5.9 29.5 9.4V48h16V209.7c2.9 1.5 5.6 3 8.1 4.6c13.3 8.3 23.9 19.4 23.9 33.7c0 67-32.9 117.2-77.2 150.4c-1.7 1.2-3.3 2.5-5 3.7l17 64.3c.8 3 1.2 6.2 1.2 9.3c0 20.1-16.3 36.3-36.3 36.3H100.3C80.3 512 64 495.7 64 475.7c0-3.1 .4-6.3 1.2-9.3l17-64.3c-1.7-1.2-3.4-2.4-5-3.7C32.9 365.2 0 315 0 248c0-14.3 10.6-25.4 23.9-33.7c2.5-1.6 5.3-3.1 8.1-4.6V48H48V202.6zM18.5 278.1c8 46.2 34.3 82 68.3 107.5C128.1 416.5 180.4 432 224 432s95.9-15.5 137.2-46.4c34-25.5 60.3-61.3 68.3-107.5c-1.7 1.2-3.5 2.4-5.3 3.6c-13.6 8.5-32.4 15.5-53.7 21.1C327.8 313.9 273.1 320 224 320s-103.8-6.1-146.5-17.3c-21.3-5.6-40-12.6-53.7-21.1c-1.8-1.1-3.6-2.3-5.3-3.6zM432 248c0-5.7-4.3-12.6-16.3-20.1c-11.7-7.3-28.7-13.8-49.3-19.2C325.4 197.9 272.1 192 224 192s-101.4 5.9-142.4 16.7C61 214.1 44 220.7 32.3 227.9C20.3 235.4 16 242.3 16 248s4.3 12.6 16.3 20.1C44 275.3 61 281.9 81.6 287.3C122.6 298.1 175.9 304 224 304s101.4-5.9 142.4-16.7c20.6-5.4 37.6-11.9 49.3-19.2c12-7.5 16.3-14.4 16.3-20.1zM104 80h48c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8zM367.3 470.5l-15.7-59.2C311.3 435.8 264.4 448 224 448s-87.3-12.2-127.6-36.7L80.7 470.5c-.4 1.7-.7 3.4-.7 5.2c0 11.2 9.1 20.3 20.3 20.3H347.7c11.2 0 20.3-9.1 20.3-20.3c0-1.8-.2-3.5-.7-5.2z"]
  },
  zm = {
    prefix: "fat",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", "M64 16C37.5 16 16 37.5 16 64v96c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V64c0-26.5-21.5-48-48-48H64zM0 64C0 28.7 28.7 0 64 0H512c35.3 0 64 28.7 64 64v96c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM256 424c0 48.6-39.4 88-88 88s-88-39.4-88-88c0-28.8 13.9-54.4 35.3-70.4c3.5-2.7 8.5-1.9 11.2 1.6s1.9 8.6-1.6 11.2C107.3 379.5 96 400.4 96 424c0 39.8 32.2 72 72 72s72-32.2 72-72V256h16V424zm64-168h16V392c0 39.8 32.2 72 72 72s72-32.2 72-72c0-23.6-11.3-44.5-28.8-57.6c-3.5-2.7-4.3-7.7-1.6-11.2s7.7-4.3 11.2-1.6c21.4 16 35.2 41.6 35.2 70.4c0 48.6-39.4 88-88 88s-88-39.4-88-88V256zM104 128H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  Mm = {
    prefix: "fat",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", "M281.1 440.4c4.6 17.1 22.2 27.1 39.3 22.5s27.1-22.2 22.5-39.3l-4.5-16.4c-5.7-20.8-22.3-56.7-33.7-75c-1.5-2.5-1.6-5.6-.2-8.1s4.1-4.1 7-4.1H448c22.1 0 40-17.9 40-40c0-14.2-7.3-26.6-18.5-33.7c-3.6-2.3-4.7-7-2.7-10.7c3.3-5.8 5.1-12.5 5.1-19.6c0-15.5-8.8-28.9-21.7-35.6c-2.1-1.1-3.6-3.1-4.1-5.4s0-4.7 1.5-6.6c5.2-6.8 8.3-15.2 8.3-24.4c0-17.8-11.6-32.8-27.6-38c-3.9-1.3-6.2-5.3-5.3-9.3c.6-2.8 .9-5.7 .9-8.6c0-22.1-17.9-40-40-40H286.5c-17.4 0-34.4 5.1-48.8 14.8L199.2 88.5c-10 6.6-18.3 15.1-24.7 24.8c-2.4 3.7-7.4 4.7-11.1 2.3s-4.7-7.4-2.3-11.1C168.7 93 178.6 83 190.3 75.1l38.5-25.7C245.9 38.1 266 32 286.5 32H384c30.9 0 56 25.1 56 56c0 1.8-.1 3.5-.2 5.3c19 8.9 32.2 28.3 32.2 50.7c0 9.7-2.5 18.9-6.9 26.9C479 181 488 197.5 488 216c0 7.4-1.4 14.5-4.1 21c12.3 10.3 20.1 25.7 20.1 43c0 30.9-25.1 56-56 56H325.4c10.9 20.3 23.4 48.5 28.5 67l4.5 16.4c7 25.6-8.1 52-33.7 58.9s-52-8.1-58.9-33.7l-4.5-16.4c-4.7-17.2-14.5-37.4-27.2-55.8c-12.7-18.4-27.7-34.5-42.5-43.8l-3.1-2c-10.9-6.9-20-15.8-27.2-26.1c-2.5-3.6-1.6-8.6 2-11.1s8.6-1.6 11.1 2c6 8.5 13.6 16 22.7 21.7l3.1 2c17.2 10.9 33.7 28.8 47.1 48.3c13.4 19.5 24.1 41.3 29.4 60.6l4.5 16.4zM32 368H96c8.8 0 16-7.2 16-16V128c0-8.8-7.2-16-16-16H32c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16zM0 352V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]
  },
  km = {
    prefix: "fat",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", "M509.7 261.7c3.1-3.1 3.1-8.2 0-11.3l-152-152c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L484.7 248 8 248c-4.4 0-8 3.6-8 8s3.6 8 8 8l476.7 0L346.3 402.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l152-152z"]
  },
  Nm = {
    prefix: "fat",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", "M368 256a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-128 0a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zM96 272a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"]
  },
  Sm = {
    prefix: "fat",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", "M176 48H80C62.3 48 48 62.3 48 80v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32zM80 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm96 272H80c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V336c0-17.7-14.3-32-32-32zM80 288h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336c0-26.5 21.5-48 48-48zM336 48c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32H336zM288 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80zm96 192c4.4 0 8 3.6 8 8v96h96c4.4 0 8 3.6 8 8s-3.6 8-8 8H392v96c0 4.4-3.6 8-8 8s-8-3.6-8-8V392H280c-4.4 0-8-3.6-8-8s3.6-8 8-8h96V280c0-4.4 3.6-8 8-8z"]
  },
  Vm = {
    prefix: "fat",
    iconName: "bug",
    icon: [512, 512, [], "f188", "M336 96c0-44.2-35.8-80-80-80s-80 35.8-80 80v3.6c0 6.9 5.6 12.4 12.4 12.4H323.6c6.9 0 12.4-5.6 12.4-12.4V96zM160 96c0-53 43-96 96-96s96 43 96 96v3.6c0 15.7-12.7 28.4-28.4 28.4H188.4c-15.7 0-28.4-12.7-28.4-28.4V96zM34.3 98.3c3.1-3.1 8.2-3.1 11.3 0L132.3 185c18.2-15.6 41.8-25 67.7-25H312c25.8 0 49.5 9.4 67.7 25l86.7-86.7c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3L391 196.3c15.6 18.2 25 41.8 25 67.7v16h88c4.4 0 8 3.6 8 8s-3.6 8-8 8H416v24c0 33.2-10.1 63.9-27.3 89.5c.4 .3 .7 .5 1 .9l88 88c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0L379 422.3C349.7 457.6 305.4 480 256 480s-93.7-22.4-123-57.7L45.7 509.7c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3l88-88c.3-.3 .7-.6 1-.9C106.1 383.9 96 353.2 96 320V296H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H96V264c0-25.8 9.4-49.5 25-67.7L34.3 109.7c-3.1-3.1-3.1-8.2 0-11.3zM264 232V463.8c75.8-4.2 136-66.9 136-143.8V288 264c0-48.6-39.4-88-88-88H200c-48.6 0-88 39.4-88 88v24 32c0 76.8 60.2 139.6 136 143.8V232c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Lm = {
    prefix: "fat",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", "M64 48C37.5 48 16 69.5 16 96v32H560V96c0-26.5-21.5-48-48-48H64zM16 144v96H560V144H16zm0 112V416c0 26.5 21.5 48 48 48H512c26.5 0 48-21.5 48-48V256H16zM0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM96 360c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8s-3.6 8-8 8H104c-4.4 0-8-3.6-8-8zm128 0c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H232c-4.4 0-8-3.6-8-8z"]
  },
  Pm = {
    prefix: "fat",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", "M176 416c0-8.8-7.2-16-16-16H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H448c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H309.3c-3.5 0-6.8 1.1-9.6 3.2L176 496V416zM64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h80 16v16 64c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zm80 208a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm144 32a16 16 0 1 1 -32 0 16 16 0 1 1 32 0zm-16-32a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm128 48a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm-32-16a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
  },
  Om = {
    prefix: "fat",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V328v80 64c0 4.4 3.6 8 8 8s8-3.6 8-8V416H624v56c0 4.4 3.6 8 8 8s8-3.6 8-8V408 328 232c0-57.4-46.6-104-104-104H312c-22.1 0-40 17.9-40 40V320H16V40zM624 400H16V336H280 624v64zm0-168v88H288V168c0-13.3 10.7-24 24-24H536c48.6 0 88 39.4 88 88zM80 208a64 64 0 1 1 128 0A64 64 0 1 1 80 208zm144 0A80 80 0 1 0 64 208a80 80 0 1 0 160 0z"]
  },
  Tm = {
    prefix: "fat",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", "M216 8c0-4.4 3.6-8 8-8s8 3.6 8 8V32l0 .2c84.6 4.2 152 74.1 152 159.8v36.6c0 41.8 14.2 82.3 40.3 114.9l16.7 20.9c4.5 5.6 6.9 12.6 6.9 19.8c0 17.5-14.2 31.7-31.7 31.7H31.7C14.2 416 0 401.8 0 384.3c0-7.2 2.4-14.2 6.9-19.8l16.7-20.9C49.8 311 64 270.4 64 228.6V192c0-85.7 67.4-155.6 152-159.8l0-.2V8zm8 40C144.5 48 80 112.5 80 192v36.6c0 45.4-15.5 89.5-43.8 124.9L19.4 374.5c-2.2 2.8-3.4 6.2-3.4 9.8C16 393 23 400 31.7 400H416.3c8.7 0 15.7-7 15.7-15.7c0-3.6-1.2-7-3.4-9.8l-16.7-20.9C383.5 318.1 368 274.1 368 228.6V192c0-79.5-64.5-144-144-144zM176 448c0 12.7 5.1 24.9 14.1 33.9s21.2 14.1 33.9 14.1s24.9-5.1 33.9-14.1s14.1-21.2 14.1-33.9c0-4.4 3.6-8 8-8s8 3.6 8 8c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3c0-4.4 3.6-8 8-8s8 3.6 8 8z"]
  },
  Dm = {
    prefix: "fat",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", "M368 192c0-97.2-78.8-176-176-176S16 94.8 16 192c0 18.7 6.4 42.5 17.8 69.6c11.3 26.9 27.1 55.8 44.7 84.3c35.2 57 76.8 111.4 102.3 143.2c5.9 7.3 16.6 7.3 22.4 0c25.5-31.8 67.1-86.2 102.3-143.2c17.6-28.5 33.4-57.4 44.7-84.3C361.6 234.5 368 210.7 368 192zm16 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm64 80a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]
  },
  Rm = {
    prefix: "fat",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", "M320 496c26.5 0 48-21.5 48-48V179.9c0-1.3-.1-2.6-.2-3.9H248c-22.1 0-40-17.9-40-40V16.2c-1.3-.2-2.6-.2-3.9-.2H64C37.5 16 16 37.5 16 64V448c0 26.5 21.5 48 48 48H320zm41.1-336c-.8-1-1.6-1.9-2.4-2.7L226.7 25.4c-.9-.9-1.8-1.7-2.7-2.4V136c0 13.3 10.7 24 24 24H361.1zM0 64C0 28.7 28.7 0 64 0H204.1c12.7 0 24.9 5.1 33.9 14.1L369.9 145.9c9 9 14.1 21.2 14.1 33.9V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"]
  },
  Gm = {
    prefix: "fat",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", "M314.4 203.7L433.8 306c3.2-1.8 6.4-3.8 9.4-5.9c1.6-1.1 3.1-2.1 4.8-3L338.2 203l-13.4-11.4c5.3-2.6 10.8-4.9 16.5-6.9c15.8-5.6 32.9-8.6 50.7-8.6h64c22.1 0 40-17.9 40-40s-17.9-40-40-40H392c-123.6 0-224.5 96.6-231.6 218.4c5.3 1.9 10.6 3.4 15.8 4.5C181 203.8 275.8 112 392 112h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H392c-26.6 0-51.8 6.2-74.2 17.2c-4.8 2.4-8.1 7-8.8 12.4s1.4 10.6 5.5 14.1zM144 160a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128zM294.6 339.4c-3-4.3-10.2-4.3-13.2 0c-8 11.2-17.5 21.4-27.6 30.7C236.6 385.8 214.5 400 192 400s-44.6-14.2-61.8-29.9c-10.1-9.2-19.7-19.5-27.6-30.7c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.3 10.3-15.9 19.6-25 28.3C48.7 382.5 28.3 396.9 7 399.6c-4.4 .6-7.5 4.6-6.9 8.9s4.6 7.5 8.9 6.9c26.5-3.3 50-20.7 66.4-36.1c8.8-8.3 15.9-16.4 20.6-22.2c5.2 6.4 13.2 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8l0 0 0 0c5.2 6.4 13.3 15.6 23.4 24.8c18 16.3 43.9 34.1 72.6 34.1s54.6-17.8 72.6-34.1c10.2-9.2 18.2-18.4 23.4-24.8c4.7 5.8 11.8 13.9 20.6 22.2c16.4 15.4 39.9 32.8 66.4 36.1c4.4 .6 8.4-2.6 8.9-6.9s-2.6-8.4-6.9-8.9c-21.3-2.7-41.7-17.1-57.4-31.9c-9.1-8.6-17.7-18-25-28.3c-1.5-2.1-3.9-3.4-6.6-3.4s-5.1 1.3-6.6 3.4c-7.9 11.2-17.5 21.5-27.6 30.7C428.6 385.8 406.5 400 384 400s-44.6-14.2-61.8-29.9c-10.1-9.2-19.6-19.5-27.6-30.7z"]
  },
  Fm = {
    prefix: "fat",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", "M16 416V327.9c0-2.6 .2-5.3 .7-7.9H118.1c3 0 5.8 1.7 7.2 4.4l23.2 46.3c4.1 8.1 12.4 13.3 21.5 13.3H342.1c9.1 0 17.4-5.1 21.5-13.3l23.2-46.3c1.4-2.7 4.1-4.4 7.2-4.4H495.4c.4 2.6 .6 5.2 .6 7.9V416c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48zM491.5 304H393.9c-9.1 0-17.4 5.1-21.5 13.3l-23.2 46.3c-1.4 2.7-4.1 4.4-7.2 4.4H169.9c-3 0-5.8-1.7-7.2-4.4l-23.2-46.3c-4.1-8.1-12.4-13.3-21.5-13.3H20.5L75.4 84.4C80.7 63 99.9 48 122 48H390c22 0 41.2 15 46.6 36.4L491.5 304zM0 327.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V327.9c0-5.2-.6-10.4-1.9-15.5l-58-231.9C445 52 419.4 32 390 32H122C92.6 32 67 52 59.9 80.5L1.9 312.4C.6 317.4 0 322.6 0 327.9z"]
  },
  jm = {
    prefix: "fat",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", "M256 16c-8.6 0-17 2.8-24 7.9L177.9 64H334.1L280 23.9C273 18.8 264.6 16 256 16zM120 64h31l71.5-53C232.2 3.9 243.9 0 256 0s23.8 3.9 33.5 11L361 64h31c30.9 0 56 25.1 56 56v8.5l38.1 28.2c16.3 12.1 25.9 31.1 25.9 51.4V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V208.1c0-20.3 9.6-39.4 25.9-51.4L64 128.5V120c0-30.9 25.1-56 56-56zM448 214.5l-16 13.1V120c0-22.1-17.9-40-40-40H120c-22.1 0-40 17.9-40 40V227.7L64 214.5V148.4L35.4 169.5C23.2 178.6 16 192.9 16 208.1v8.4l1.6 1.3L232.7 394.5c6.6 5.4 14.8 8.3 23.3 8.3s16.7-2.9 23.3-8.3L494.4 217.8l1.6-1.3v-8.4c0-15.2-7.2-29.5-19.4-38.6L448 148.4v66.1zM16 448c0 26.5 21.5 48 48 48H448c26.5 0 48-21.5 48-48V237.2L289.4 406.9c-9.4 7.7-21.2 12-33.4 12s-24-4.2-33.4-12L16 237.2V448zM168 160H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8zm0 80H344c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8z"]
  },
  Jm = {
    prefix: "fat",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", "M32 176C32 96.5 96.5 32 176 32h72 8H432c4.4 0 8 3.6 8 8s-3.6 8-8 8H368l0 424c0 4.4-3.6 8-8 8s-8-3.6-8-8l0-424H272V472c0 4.4-3.6 8-8 8s-8-3.6-8-8V320H176C96.5 320 32 255.5 32 176zM256 304l0-256h-8H176C105.3 48 48 105.3 48 176s57.3 128 128 128h80z"]
  },
  Zm = {
    prefix: "fat",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", "M104 0c4.4 0 8 3.6 8 8v9.4c0 11.2 5.9 21.7 15.5 27.4l41.2 24.7c14.5 8.7 23.3 24.3 23.3 41.2V120c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.4c0-11.2-5.9-21.7-15.5-27.4L119.3 58.5C104.8 49.8 96 34.2 96 17.4V8c0-4.4 3.6-8 8-8zm96 0c4.4 0 8 3.6 8 8v9.4c0 11.2 5.9 21.7 15.5 27.4l41.2 24.7c14.5 8.7 23.3 24.3 23.3 41.2V120c0 4.4-3.6 8-8 8s-8-3.6-8-8v-9.4c0-11.2-5.9-21.7-15.5-27.4L215.3 58.5C200.8 49.8 192 34.2 192 17.4V8c0-4.4 3.6-8 8-8zM32 176c-8.8 0-16 7.2-16 16c0 97.2 78.8 176 176 176h64c97.2 0 176-78.8 176-176c0-8.8-7.2-16-16-16H32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 81.9-51.3 151.8-123.5 179.4l58.8 129.3c1.8 4 0 8.8-4 10.6s-8.8 0-10.6-4L345.4 456H159.5c-3.9 31.6-30.9 56-63.5 56c-35.3 0-64-28.7-64-64s28.7-64 64-64c7.1 0 13.9 1.2 20.3 3.3l7.2-15.9C51.3 343.8 0 273.9 0 192zM309.3 376.5c-16.9 4.9-34.8 7.5-53.3 7.5H192c-18.5 0-36.4-2.6-53.3-7.5l-8 17.7c15.5 10 26.4 26.6 28.8 45.8H338.1l-28.9-63.5zM144 448a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z"]
  },
  Wm = {
    prefix: "fat",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", "M580.2 244.7c50-50 50-131 0-181s-131-50-181 0l-17 17c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l17-17c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4L433.1 369.1c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-39.6 39.6c-50 50-50 131 0 181s131 50 181 0L580.2 244.7zM59.8 267.3c-50 50-50 131 0 181s131 50 181 0l17-17c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-17 17c-43.7 43.7-114.7 43.7-158.4 0s-43.7-114.7 0-158.4L206.9 142.9c43.7-43.7 114.7-43.7 158.4 0s43.7 114.7 0 158.4l-39.6 39.6c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l39.6-39.6c50-50 50-131 0-181s-131-50-181 0L59.8 267.3z"]
  },
  Xm = {
    prefix: "fat",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", "M400 208A192 192 0 1 0 16 208a192 192 0 1 0 384 0zM349.3 360.6C312.2 395 262.6 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 54.6-21 104.2-55.4 141.3l149 149c3.1 3.1 3.1 8.2 0 11.3s-8.2 3.1-11.3 0l-149-149z"]
  },
  Um = {
    prefix: "fat",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", "M13.3 2C10.9-.1 7.6-.6 4.7 .7S0 4.9 0 8V504c0 3.1 1.8 6 4.7 7.3s6.2 .8 8.6-1.3L71.6 459l50.7 50.7c3 3 7.8 3.1 10.9 .4L192 458.6 250.7 510c3.2 2.8 7.9 2.6 10.9-.4L312.4 459 370.7 510c2.4 2.1 5.7 2.6 8.6 1.3s4.7-4.1 4.7-7.3V8c0-3.1-1.8-6-4.7-7.3s-6.2-.8-8.6 1.3L312.4 53.1 261.7 2.3c-3-3-7.8-3.1-10.9-.4L192.4 53.1 141.7 2.3c-3-3-7.8-3.1-10.9-.4L72 53.4 13.3 2zM16 486.4V25.6L66.7 70c3 2.6 7.5 2.6 10.5 0l58.4-51.1 50.7 50.7c3 3 7.8 3.1 10.9 .4l58.4-51.1 50.7 50.7c3 3 7.8 3.1 10.9 .4L368 25.6V486.4L317.3 442c-3.2-2.8-7.9-2.6-10.9 .4L255.6 493 197.3 442c-3-2.6-7.5-2.6-10.5 0L128.4 493 77.7 442.3c-3-3-7.8-3.1-10.9-.4L16 486.4zM96 152c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96zM88 352c0 4.4 3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96c-4.4 0-8 3.6-8 8zm8-104c-4.4 0-8 3.6-8 8s3.6 8 8 8H288c4.4 0 8-3.6 8-8s-3.6-8-8-8H96z"]
  },
  Km = {
    prefix: "fat",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", "M250.3 397.7c3.1 3.1 8.2 3.1 11.3 0l216-216c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 380.7 45.7 170.3c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3l216 216z"]
  },
  Ym = {
    prefix: "fat",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", "M576 16c26.5 0 48 21.5 48 48V384c0 26.5-21.5 48-48 48H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H576zM64 0C28.7 0 0 28.7 0 64V384c0 35.3 28.7 64 64 64H576c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM96 504c0 4.4 3.6 8 8 8H536c4.4 0 8-3.6 8-8s-3.6-8-8-8H104c-4.4 0-8 3.6-8 8zM80 80H560V368H80V80zM64 80V368c0 8.8 7.2 16 16 16H560c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]
  },
  qm = {
    prefix: "fat",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", "M157.7 53.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L63.5 125.2 21.1 89.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l48 40c3.2 2.6 7.9 2.4 10.8-.5l88-88zm0 160c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L63.5 285.2 21.1 249.9c-3.4-2.8-8.4-2.4-11.3 1s-2.4 8.4 1 11.3l48 40c3.2 2.6 7.9 2.4 10.8-.5l88-88zM200 96c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zm0 160c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H208c-4.4 0-8 3.6-8 8zM168 416c0 4.4 3.6 8 8 8H496c4.4 0 8-3.6 8-8s-3.6-8-8-8H176c-4.4 0-8 3.6-8 8zm-88 0a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  _m = {
    prefix: "fat",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", "M256 496c-54 0-103.9-17.9-144-48v0c0-61.9 50.1-112 112-112h64c61.9 0 112 50.1 112 112v0c5.3-4 10.4-8.2 15.4-12.6C409.1 370.6 354.5 320 288 320H224c-66.5 0-121.1 50.6-127.4 115.4C47.2 391.5 16 327.4 16 256C16 123.5 123.5 16 256 16s240 107.5 240 240s-107.5 240-240 240zm0 16A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm80-304a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zm-80-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
  },
  $m = {
    prefix: "fat",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", "M0 88c0-4.4 3.6-8 8-8H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8zM64 248c0-4.4 3.6-8 8-8H376c4.4 0 8 3.6 8 8s-3.6 8-8 8H72c-4.4 0-8-3.6-8-8zM288 408c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H280c4.4 0 8 3.6 8 8z"]
  },
  eh = {
    prefix: "fat",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", "M232 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248H40c-4.4 0-8 3.6-8 8s3.6 8 8 8H216V440c0 4.4 3.6 8 8 8s8-3.6 8-8V264H408c4.4 0 8-3.6 8-8s-3.6-8-8-8H232V72z"]
  },
  th = {
    prefix: "fat",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M338.1 413.4c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L203.3 256 349.4 109.9c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L192 244.7 45.9 98.6c-3.1-3.1-8.2-3.1-11.3 0s-3.1 8.2 0 11.3L180.7 256 34.6 402.1c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L192 267.3 338.1 413.4z"]
  },
  nh = {
    prefix: "fat",
    iconName: "h2",
    icon: [640, 512, [], "f314", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm410.9 35.5c20.7-17.7 47-27.5 74.2-27.5h4.2c52.2 0 94.6 42.4 94.6 94.6c0 24.5-9.5 48-26.5 65.7L386.2 434.4c-2.2 2.3-2.9 5.7-1.6 8.7s4.2 4.9 7.4 4.9H624c4.4 0 8-3.6 8-8s-3.6-8-8-8H410.8L585 251.4c19.9-20.6 31-48.1 31-76.8C616 113.5 566.5 64 505.4 64h-4.2c-31.1 0-61.1 11.1-84.7 31.3l-21.7 18.6c-3.4 2.9-3.7 7.9-.9 11.3s7.9 3.7 11.3 .9l21.7-18.6z"]
  },
  rh = {
    prefix: "fat",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", "M181.3 32.5c1.6-.6 3.4-.6 5.1-.1L391.8 95.6 533.1 44.2c20.9-7.6 42.9 7.9 42.9 30.1V391.2c0 13.5-8.4 25.5-21.1 30.1L394.7 479.5c-1.6 .6-3.4 .6-5.1 .1L184.2 416.4 42.9 467.8C22.1 475.4 0 459.9 0 437.7V120.8c0-13.5 8.4-25.5 21.1-30.1L181.3 32.5zM26.5 105.8c-6.3 2.3-10.5 8.3-10.5 15V437.7c0 11.1 11 18.8 21.5 15L176 402.4V51.4L26.5 105.8zM384 461.2V109.9L192 50.8V402.1l192 59.1zm16-.6l149.5-54.4c6.3-2.3 10.5-8.3 10.5-15V74.3c0-11.1-11-18.8-21.5-15L400 109.6v351z"]
  },
  oh = {
    prefix: "fat",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zM216 160a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm96 160a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm160 64a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80zm32-128a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-40-24a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zM184 320a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm-24-40a40 40 0 1 0 0 80 40 40 0 1 0 0-80z"]
  },
  ih = {
    prefix: "fat",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", "M18.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l216 216c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L35.3 256 245.7 45.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-216 216z"]
  },
  ah = {
    prefix: "fat",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", "M301.7 250.3c3.1 3.1 3.1 8.2 0 11.3l-216 216c-3.1 3.1-8.2 3.1-11.3 0s-3.1-8.2 0-11.3L284.7 256 74.3 45.7c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0l216 216z"]
  },
  ch = {
    prefix: "fat",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", "M64 80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 336a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 112a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM373.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-352 352c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l352-352z"]
  },
  sh = {
    prefix: "fat",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", "M43.6 224c-4.9 0-8.7-4.3-7.8-9.2c9.7-51.8 37.5-100.4 82.3-135.3c88.3-69 212.1-61.3 291.3 13.2L398 104C324.5 35.1 209.8 28.1 127.9 92.1c-41.4 32.3-67.2 77.2-76.3 125.1c-.7 3.9-4.1 6.8-8.1 6.8zm423.7 64c4.9 0 8.7 4.3 7.8 9.2c-9.7 51.8-37.5 100.4-82.3 135.4c-88.1 68.8-211.5 61.3-290.7-12.7L57 465c-6.9 6.9-17.2 8.9-26.2 5.2S16 457.7 16 448V344c0-13.3 10.7-24 24-24H144c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-47.6 47.6c73.5 68.4 187.9 75.1 269.5 11.4c41.4-32.4 67.2-77.3 76.3-125.1c.7-3.9 4.1-6.8 8.1-6.8zM368 176H472c4.4 0 8-3.6 8-8V64c0-3.2-1.9-6.2-4.9-7.4s-6.4-.6-8.7 1.7l-104 104c-2.3 2.3-3 5.7-1.7 8.7s4.2 4.9 7.4 4.9zm104 16H368c-9.7 0-18.5-5.8-22.2-14.8s-1.7-19.3 5.2-26.2L455 47c6.9-6.9 17.2-8.9 26.2-5.2s14.8 12.5 14.8 22.2V168c0 13.3-10.7 24-24 24zM144 336H40c-4.4 0-8 3.6-8 8V448c0 3.2 1.9 6.2 4.9 7.4s6.4 .6 8.7-1.7l104-104c2.3-2.3 3-5.7 1.7-8.7s-4.2-4.9-7.4-4.9z"]
  },
  lh = {
    prefix: "fat",
    iconName: "spinner",
    icon: [512, 512, [], "f110", "M256 80a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 496a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM80 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM0 256a48 48 0 1 1 96 0A48 48 0 1 1 0 256zm464 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm0-80a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM131.5 380.5A32 32 0 1 0 86.3 425.7a32 32 0 1 0 45.3-45.3zM75 437a48 48 0 1 1 67.9-67.9A48 48 0 1 1 75 437zM86.3 131.5a32 32 0 1 0 45.3-45.3A32 32 0 1 0 86.3 131.5zM142.9 75A48 48 0 1 1 75 142.9 48 48 0 1 1 142.9 75zM425.7 425.7a32 32 0 1 0 -45.3-45.3 32 32 0 1 0 45.3 45.3zm-56.6-56.6A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z"]
  },
  uh = {
    prefix: "fat",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", "M50.3 250.3c-3.1 3.1-3.1 8.2 0 11.3l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L67.3 256 237.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-176 176zm368-176l-176 176c-3.1 3.1-3.1 8.2 0 11.3l176 176c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L259.3 256 429.7 85.7c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0z"]
  },
  dh = {
    prefix: "fat",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", "M16 16l0 64H624V16H16zM0 16C0 7.2 7.2 0 16 0H624c8.8 0 16 7.2 16 16V80c0 8.8-7.2 16-16 16H608V488c0 13.3-10.7 24-24 24H504c-13.3 0-24-10.7-24-24V352c0-88.4-71.6-160-160-160s-160 71.6-160 160V488c0 13.3-10.7 24-24 24H56c-13.3 0-24-10.7-24-24V96H16C7.2 96 0 88.8 0 80V16zM48 96V488c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V352c0-97.2 78.8-176 176-176s176 78.8 176 176V488c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V96H48zM341.2 316.7c-4.8 .1-9.4-2.1-12.5-5.8c-11-13.3-22.8-25.6-35.3-37.1c-21.6 19.8-39.8 42-52.7 63c-13.6 22.1-21.2 44-21.2 59c0 55.1 44.1 100.3 100.4 100.3c55.7 0 100.4-45.2 100.4-100.3c0-11-5.7-30.7-15.8-50.1c-9.3-18.1-22.2-36.7-37-51.2c-4.8 4.8-9.4 10.5-14 16.2c-3 3.8-7.5 6-12.3 6zm-10.8-28.3c3.6 4 7.2 8.1 10.7 12.3c3.2-4.1 6.7-8.4 10.4-12.5c2.8-3.2 5.8-6.2 8.8-9c4.1-3.7 10.5-3.7 14.5 0c18 16.5 33.2 38.3 43.9 59c10.6 20.4 17.6 42.8 17.6 57.4c0 63.9-51.8 116.3-116.4 116.3c-65.2 0-116.4-52.4-116.4-116.3c0-19.2 9.2-44.1 23.6-67.4c14.5-23.5 35-48.1 59.2-69.7c2-1.8 4.7-2.7 7.3-2.7c2.6 0 5.1 .9 7.1 2.7c10.4 9.3 20.3 19.2 29.7 29.7zm-32.1 38.2c1.6 2 14.1 17.9 26.1 33.3l16.3 20.9 1.3 1.7 22.5-26.3c1.6-1.8 3.9-2.9 6.3-2.8s4.7 1.3 6.1 3.2c2.8 3.8 4.7 7.5 6.3 10.7l0 .1c5.1 9.4 7.9 19.6 8.4 29.7c.2 4.4-3.1 8.2-7.5 8.4s-8.2-3.1-8.4-7.5c-.4-7.8-2.5-15.6-6.4-22.8l-21.6 25.2c-1.6 1.8-3.9 2.8-6.2 2.8s-4.6-1.2-6.1-3.1l6.3-4.9c-6.3 4.9-6.3 4.9-6.3 4.9l0 0 0 0 0 0-.1-.1-.4-.5-1.5-1.9-5.3-6.8-16.3-20.8c-7.3-9.3-14.8-18.8-19.8-25.3c-8.9 11.1-15.5 20-20.1 28c-5.6 9.6-7.9 17.2-7.9 25c0 4.4-3.6 8-8 8s-8-3.6-8-8c0-11.5 3.6-21.9 10.1-33c6.4-10.9 15.8-23 27.8-37.8c1.5-1.9 3.8-3 6.2-3s4.7 1.1 6.2 3z"]
  },
  fh = {
    prefix: "fat",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", "M16 166.7V56c0-4.4-3.6-8-8-8s-8 3.6-8 8V184c0 4.4 3.6 8 8 8H136c4.4 0 8-3.6 8-8s-3.6-8-8-8H29.7C62.6 82.8 151.5 16 256 16c132.5 0 240 107.5 240 240s-107.5 240-240 240c-73.5 0-139.3-33.1-183.4-85.2c-2.9-3.4-7.9-3.8-11.3-.9s-3.8 7.9-.9 11.3C107.3 476.7 177.6 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C146 0 52.2 69.4 16 166.7zM256 128c-4.4 0-8 3.6-8 8V256c0 2.1 .8 4.2 2.3 5.7l88 88c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L264 252.7V136c0-4.4-3.6-8-8-8z"]
  },
  ph = {
    prefix: "fat",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", "M169.7 32.2c4.3 1 7 5.2 6.1 9.5L153.1 144H328.7L352.2 38.3c1-4.3 5.2-7 9.5-6.1s7 5.2 6.1 9.5L345.1 144H440c4.4 0 8 3.6 8 8s-3.6 8-8 8H341.5L298.9 352H408c4.4 0 8 3.6 8 8s-3.6 8-8 8H295.3L271.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L278.9 368H103.3L79.8 473.7c-1 4.3-5.2 7-9.5 6.1s-7-5.2-6.1-9.5L86.9 368H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H90.5l42.7-192H40c-4.4 0-8-3.6-8-8s3.6-8 8-8h96.7L160.2 38.3c1-4.3 5.2-7 9.5-6.1zM149.5 160L106.9 352H282.5l42.7-192H149.5z"]
  },
  mh = {
    prefix: "fat",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", "M16 40c0-4.4-3.6-8-8-8s-8 3.6-8 8V408c0 39.8 32.2 72 72 72H504c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-30.9 0-56-25.1-56-56V40zm416 72c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16s-16-7.2-16-16V128c0-8.8 7.2-16 16-16zM240 176c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16s-16-7.2-16-16V192c0-8.8 7.2-16 16-16zm-96 96c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288c0-8.8 7.2-16 16-16zm192-32c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16s-16-7.2-16-16V256c0-8.8 7.2-16 16-16zM464 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V128zM272 192c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V192zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V288zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V256c0-17.7-14.3-32-32-32z"]
  },
  hh = {
    prefix: "fat",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", "M108.7 8c5.1-5.1 12.1-8 19.3-8s14.2 2.9 19.3 8L247 107.7c5.7 5.7 9 13.5 9 21.7c0 16.9-13.7 30.6-30.6 30.6H176V352h49.4c16.9 0 30.6 13.7 30.6 30.6c0 8.1-3.2 15.9-9 21.7L147.3 504c-5.1 5.1-12.1 8-19.3 8s-14.2-2.9-19.3-8L9 404.3c-5.7-5.7-9-13.5-9-21.7C0 365.7 13.7 352 30.6 352H80V160H30.6C13.7 160 0 146.3 0 129.4c0-8.1 3.2-15.9 9-21.7L108.7 8zM128 16c-3 0-5.9 1.2-8 3.3L20.3 119c-2.7 2.7-4.3 6.5-4.3 10.3c0 8.1 6.5 14.6 14.6 14.6H88c4.4 0 8 3.6 8 8V360c0 4.4-3.6 8-8 8H30.6c-8.1 0-14.6 6.6-14.6 14.6c0 3.9 1.5 7.6 4.3 10.3L120 492.7l-5.7 5.7 5.7-5.7c2.1 2.1 5 3.3 8 3.3s5.9-1.2 8-3.3l5.7 5.7-5.7-5.7L235.7 393c2.7-2.7 4.3-6.5 4.3-10.3c0-8.1-6.5-14.6-14.6-14.6H168c-4.4 0-8-3.6-8-8V152c0-4.4 3.6-8 8-8h57.4c8.1 0 14.6-6.5 14.6-14.6c0-3.9-1.5-7.6-4.3-10.3L136 19.3c-2.1-2.1-5-3.3-8-3.3z"]
  },
  Ah = {
    prefix: "fat",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm-8-160c0 4.4 3.6 8 8 8s8-3.6 8-8V264h88c4.4 0 8-3.6 8-8s-3.6-8-8-8H264V160c0-4.4-3.6-8-8-8s-8 3.6-8 8v88H160c-4.4 0-8 3.6-8 8s3.6 8 8 8h88v88z"]
  },
  gh = {
    prefix: "fat",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", "M16 107.9C16 74.8 42.8 48 75.9 48c15.9 0 31.1 6.3 42.3 17.5l36.1 36.1c.3 .3 .7 .6 1.1 .9c-38.3 44-36.5 110.8 5.4 152.6l18.3 18.3-16.8 16.8c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0l192-192c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0l-16.8 16.8L319.2 96.8c-41.9-41.9-108.6-43.7-152.6-5.4c-.3-.4-.6-.7-.9-1.1L129.5 54.2C115.3 40 96 32 75.9 32C34 32 0 66 0 107.9V472c0 4.4 3.6 8 8 8s8-3.6 8-8V107.9zm310.2 18.6L190.5 262.2l-18.3-18.3c-37.5-37.5-37.5-98.3 0-135.8s98.3-37.5 135.8 0l18.3 18.3zM416 208a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-80 80a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-48 48a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm80 48a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm-64 64a16 16 0 1 0 0-32 16 16 0 1 0 0 32zM432 320a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm80-80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z"]
  },
  vh = {
    prefix: "fat",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", "M512 16c26.5 0 48 21.5 48 48V352c0 26.5-21.5 48-48 48H344.2h-.3H232.1h-.3H64c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H512zM64 416H222.6l-13.3 80H136c-4.4 0-8 3.6-8 8s3.6 8 8 8h80H360h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H366.8l-13.3-80H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64zm161.4 80l13.3-80h98.4l13.3 80H225.4zM80 80H496V272H80L80 80zM64 80V272c0 8.8 7.2 16 16 16H496c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16z"]
  },
  Ch = {
    prefix: "fat",
    iconName: "h5",
    icon: [640, 512, [], "e412", "M16 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V248 440c0 4.4 3.6 8 8 8s8-3.6 8-8V256H304V440c0 4.4 3.6 8 8 8s8-3.6 8-8V248 72c0-4.4-3.6-8-8-8s-8 3.6-8 8V240H16V72zm416-8c-3.7 0-7 2.6-7.8 6.2l-40 176c-.5 2.4 0 4.9 1.5 6.8s3.8 3 6.3 3H536c48.6 0 88 39.4 88 88s-39.4 88-88 88H448.4c-20.7 0-39-13.2-45.5-32.8l-3.2-9.7c-1.4-4.2-5.9-6.5-10.1-5.1s-6.5 5.9-5.1 10.1l3.2 9.7c8.7 26.1 33.2 43.8 60.7 43.8H536c57.4 0 104-46.6 104-104s-46.6-104-104-104H402L438.4 80H600c4.4 0 8-3.6 8-8s-3.6-8-8-8H432z"]
  },
  bh = {
    prefix: "fat",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", "M437.7 106.3c3.1 3.1 3.1 8.2 0 11.3l-272 272c-3.1 3.1-8.2 3.1-11.3 0l-144-144c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L160 372.7 426.3 106.3c3.1-3.1 8.2-3.1 11.3 0z"]
  },
  Eh = {
    prefix: "fat",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M20.7 412.3c-3.1 5.3-4.7 11.2-4.7 17.3c0 19 15.4 34.4 34.4 34.4H461.6c19 0 34.4-15.4 34.4-34.4c0-6.1-1.6-12.1-4.7-17.3L290.3 67.7C283.2 55.5 270.1 48 256 48s-27.2 7.5-34.3 19.7L20.7 412.3zM6.9 404.2l201-344.6C217.9 42.5 236.2 32 256 32s38.1 10.5 48.1 27.6l201 344.6c4.5 7.7 6.9 16.5 6.9 25.4c0 27.8-22.6 50.4-50.4 50.4H50.4C22.6 480 0 457.4 0 429.6c0-8.9 2.4-17.7 6.9-25.4zM256 160c4.4 0 8 3.6 8 8V328c0 4.4-3.6 8-8 8s-8-3.6-8-8V168c0-4.4 3.6-8 8-8zM240 384a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  yh = {
    prefix: "fat",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", "M288 144c8.8 0 16-7.2 16-16V64c0-6.3 3.7-12 9.5-14.6s12.5-1.5 17.2 2.7l160 144c3.4 3 5.3 7.4 5.3 11.9s-1.9 8.9-5.3 11.9l-160 144c-4.7 4.2-11.4 5.3-17.2 2.7s-9.5-8.3-9.5-14.6V288c0-8.8-7.2-16-16-16H192c-61.9 0-112 50.1-112 112c0 35.5 15.2 57.1 27.3 68.4c3.7 3.5 4.7 6.5 4.7 7.8c0 2.1-1.7 3.7-3.7 3.7c-.3 0-.5 0-.6 0C90.6 454.7 16 408.2 16 304c0-88.4 71.6-160 160-160H288zm0 160v48c0 12.6 7.4 24.1 19 29.2s25 3 34.4-5.4l160-144c6.7-6.1 10.6-14.7 10.6-23.8s-3.8-17.7-10.6-23.8l-160-144c-9.4-8.5-22.9-10.6-34.4-5.4s-19 16.6-19 29.2v48 16H272 176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h80 16v16z"]
  },
  Ih = {
    prefix: "fat",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", "M256 16C123.5 16 16 123.5 16 256c0 36.9 8.3 71.9 23.2 103.1c1.9 4 .2 8.8-3.8 10.7s-8.8 .2-10.7-3.8C8.9 332.7 0 295.4 0 256C0 114.6 114.6 0 256 0S512 114.6 512 256s-114.6 256-256 256c-4.4 0-8-3.6-8-8s3.6-8 8-8c132.5 0 240-107.5 240-240S388.5 16 256 16zM139 130.9l-7.1 4c-3.8 2.2-8.7 .9-10.9-3s-.9-8.7 3-10.9l7.1-4c32.3-18.5 72.7-14.6 100.9 9.6l13.2 11.3c3.4 2.9 3.7 7.9 .9 11.3s-7.9 3.7-11.3 .9l-13.2-11.3c-23.1-19.8-56.2-22.9-82.6-7.8zM176.4 176a16 16 0 1 1 0 32 16 16 0 1 1 0-32zm17.6 88.2l81.4 20.4c30.5 7.6 52 34.7 52.6 66c.6 16.9-9.6 33-26.3 39l-42.8 15.6-23.5 64.7c-9.2 25.3-33.2 42.1-60.1 42.1H128c-35.3 0-64-28.7-64-64V328c0-22.1 17.9-40 40-40s40 17.9 40 40v33.8l130.3-47.4c6.7-2.4 13.7-3 20.3-1.9c-6.4-5.9-14.3-10.2-23.1-12.4l-81.4-20.4c-4.3-1.1-6.9-5.4-5.8-9.7s5.4-6.9 9.7-5.8zm118.1 87c-.1-2.5-.5-5-1.4-7.4c-4.5-12.5-18.3-18.9-30.8-14.4L138.7 380.7c-2.5 .9-5.2 .5-7.3-1s-3.4-3.9-3.4-6.6V328c0-13.3-10.7-24-24-24s-24 10.7-24 24V448c0 26.5 21.5 48 48 48h47.2c20.2 0 38.2-12.6 45.1-31.6l24.8-68.2c.8-2.2 2.6-4 4.8-4.8l46.3-16.8C306 371 312 361.8 312 352h0c0-.3 0-.5 0-.8zM320.4 208a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z"]
  },
  Bh = {
    prefix: "fat",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", "M403.7 477.5L289.5 429.9l-37.7 65.9c-7.2 12.6-22 18.8-36 15.1s-23.8-16.4-23.8-30.9V389.3L19.7 317.5C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l7.9 13.9c-5.3 3-8.4 8.8-8 14.9s4.2 11.4 9.8 13.8l168.9 70.4L479.6 16c-2.6 .1-5.2 .8-7.6 2.1l-448 256-7.9-13.9 448-256c8.3-4.7 18-5.5 26.7-2.3c2.5 .9 5 2.2 7.3 3.7c1.3 .9 2.5 1.8 3.6 2.8c.9 .8 1.7 1.6 2.4 2.5c6.1 7 9 16.5 7.5 25.9l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6zm-193.6-98l85.5 35.6c0 0 0 0 .1 0l114.2 47.6c4.5 1.9 9.7 1.6 14-.8s7.2-6.7 8-11.5l64-416c.6-3.7-.2-7.4-2-10.5L210.1 379.5zM208 396v84c0 7.3 4.9 13.6 11.9 15.5s14.4-1.2 18-7.5l36.7-64.2L208 396z"]
  },
  xh = {
    prefix: "fat",
    iconName: "align-right",
    icon: [448, 512, [], "f038", "M440 56c4.4 0 8 3.6 8 8s-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H440zm0 128c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440zm8 136c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8s3.6-8 8-8H440c4.4 0 8 3.6 8 8zm-8 120c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8s3.6-8 8-8H440z"]
  },
  wh = {
    prefix: "fat",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 16a240 240 0 1 1 0 480 240 240 0 1 1 0-480zm0 496A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM178.3 178.3c-3.1 3.1-3.1 8.2 0 11.3L244.7 256l-66.3 66.3c-3.1 3.1-3.1 8.2 0 11.3s8.2 3.1 11.3 0L256 267.3l66.3 66.3c3.1 3.1 8.2 3.1 11.3 0s3.1-8.2 0-11.3L267.3 256l66.3-66.3c3.1-3.1 3.1-8.2 0-11.3s-8.2-3.1-11.3 0L256 244.7l-66.3-66.3c-3.1-3.1-8.2-3.1-11.3 0z"]
  },
  Qh = {
    prefix: "fat",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", "M281.1 71.6c4.6-17.1 22.2-27.1 39.3-22.5s27.1 22.2 22.5 39.3l-4.5 16.4c-5.7 20.8-22.3 56.7-33.7 75c-1.5 2.5-1.6 5.6-.2 8.1s4.1 4.1 7 4.1H448c22.1 0 40 17.9 40 40c0 14.2-7.3 26.6-18.5 33.7c-3.6 2.3-4.7 7-2.7 10.7c3.3 5.8 5.1 12.5 5.1 19.6c0 15.5-8.8 28.9-21.7 35.6c-2.1 1.1-3.6 3.1-4.1 5.4s0 4.7 1.5 6.6c5.2 6.8 8.3 15.2 8.3 24.4c0 17.8-11.6 32.8-27.6 38c-3.9 1.3-6.2 5.3-5.3 9.3c.6 2.8 .9 5.7 .9 8.6c0 22.1-17.9 40-40 40H286.5c-17.4 0-34.4-5.1-48.8-14.8l-38.5-25.7c-10-6.6-18.3-15.1-24.7-24.8c-2.4-3.7-7.4-4.7-11.1-2.3s-4.7 7.4-2.3 11.1c7.6 11.5 17.4 21.5 29.2 29.3l38.5 25.7C245.9 473.9 266 480 286.5 480H384c30.9 0 56-25.1 56-56c0-1.8-.1-3.5-.2-5.3c19-8.9 32.2-28.3 32.2-50.7c0-9.7-2.5-18.9-6.9-26.9C479 331 488 314.5 488 296c0-7.4-1.4-14.5-4.1-21c12.3-10.3 20.1-25.7 20.1-43c0-30.9-25.1-56-56-56H325.4c10.9-20.3 23.4-48.5 28.5-67l4.5-16.4c7-25.6-8.1-52-33.7-58.9s-52 8.1-58.9 33.7l-4.5 16.4c-4.7 17.2-14.5 37.4-27.2 55.8c-12.7 18.4-27.7 34.5-42.5 43.8l-3.1 2c-10.9 6.9-20 15.8-27.2 26.1c-2.5 3.6-1.6 8.6 2 11.1s8.6 1.6 11.1-2c6-8.5 13.6-16 22.7-21.7l3.1-2c17.2-10.9 33.7-28.8 47.1-48.3c13.4-19.5 24.1-41.3 29.4-60.6l4.5-16.4zM32 208H96c8.8 0 16 7.2 16 16V448c0 8.8-7.2 16-16 16H32c-8.8 0-16-7.2-16-16V224c0-8.8 7.2-16 16-16zM0 224V448c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32z"]
  },
  Hh = {
    prefix: "fat",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", "M64 496c-26.5 0-48-21.5-48-48V64c0-26.5 21.5-48 48-48H204.1c1.3 0 2.6 .1 3.9 .2V136c0 22.1 17.9 40 40 40H367.8c.2 1.3 .2 2.6 .2 3.9V448c0 26.5-21.5 48-48 48H64zM358.6 157.3c.9 .9 1.7 1.8 2.4 2.7H248c-13.3 0-24-10.7-24-24V22.9c1 .8 1.9 1.6 2.7 2.4L358.6 157.3zM64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V179.9c0-12.7-5.1-24.9-14.1-33.9L238.1 14.1c-9-9-21.2-14.1-33.9-14.1H64zm0 72c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zm0 64c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H72c-4.4 0-8 3.6-8 8zM224 440c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8s-3.6-8-8-8H232c-4.4 0-8 3.6-8 8zm64-200c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H96c-8.8 0-16-7.2-16-16V256c0-8.8 7.2-16 16-16H288zM96 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96z"]
  },
  zh = {
    prefix: "fat",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", "M80 160H64V64C64 28.7 92.7 0 128 0H357.5c17 0 33.3 6.7 45.3 18.7l26.5 26.5c12 12 18.7 28.3 18.7 45.3V160H432V90.5c0-12.7-5.1-24.9-14.1-33.9L391.4 30.1c-9-9-21.2-14.1-33.9-14.1H128c-26.5 0-48 21.5-48 48v96zm368 48H64c-26.5 0-48 21.5-48 48V384c0 8.8 7.2 16 16 16H64V352c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32v48h32c8.8 0 16-7.2 16-16V256c0-26.5-21.5-48-48-48zm0 208v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V416H32c-17.7 0-32-14.3-32-32V256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64V384c0 17.7-14.3 32-32 32H448zM96 336c-8.8 0-16 7.2-16 16V480c0 8.8 7.2 16 16 16H416c8.8 0 16-7.2 16-16V352c0-8.8-7.2-16-16-16H96zm336-80a16 16 0 1 1 0 32 16 16 0 1 1 0-32z"]
  },
  Mh = {
    prefix: "fat",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", "M252.7 .7c2.1-.9 4.5-.9 6.6 0L497.9 108.5c8.6 3.9 14.1 12.4 14.1 21.9V136c0 13.3-10.7 24-24 24H256 24c-13.3 0-24-10.7-24-24v-5.7c0-9.4 5.5-18 14.1-21.9L252.7 .7zM288 144H488c4.4 0 8-3.6 8-8v-5.7c0-3.1-1.8-6-4.7-7.3L256 16.8 20.7 123c-2.9 1.3-4.7 4.1-4.7 7.3V136c0 4.4 3.6 8 8 8H224c-5-6.7-8-15-8-24c0-22.1 17.9-40 40-40s40 17.9 40 40c0 9-3 17.3-8 24zm-32 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM72 192c4.4 0 8 3.6 8 8V368H184V200c0-4.4 3.6-8 8-8s8 3.6 8 8V368H312V200c0-4.4 3.6-8 8-8s8 3.6 8 8V368H432V200c0-4.4 3.6-8 8-8s8 3.6 8 8V376c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8V200c0-4.4 3.6-8 8-8zM32 440c0-4.4 3.6-8 8-8H472c4.4 0 8 3.6 8 8s-3.6 8-8 8H40c-4.4 0-8-3.6-8-8zM0 504c0-4.4 3.6-8 8-8H504c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z"]
  },
  kh = {
    prefix: "fat",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", "M0 256c0-4.4 3.6-8 8-8H632c4.4 0 8 3.6 8 8s-3.6 8-8 8H8c-4.4 0-8-3.6-8-8z"]
  },
  Nh = {
    prefix: "fat",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", "M144 176H54.9c-3.8 0-6.9-3.1-6.9-6.9c0-1.8 .7-3.5 1.9-4.7L190.1 16.8c.5-.5 1.2-.8 1.9-.8s1.4 .3 1.9 .8L334.1 164.4c1.2 1.3 1.9 3 1.9 4.7c0 3.8-3.1 6.9-6.9 6.9H240c-8.8 0-16 7.2-16 16V400c0 53-43 96-96 96H40c-13.3 0-24-10.7-24-24V456c0-13.3 10.7-24 24-24l88 0c17.7 0 32-14.3 32-32V192c0-8.8-7.2-16-16-16zM178.5 5.8L38.3 153.4c-4 4.3-6.3 9.9-6.3 15.8C32 181.8 42.2 192 54.9 192H128h16v16V400c0 8.8-7.2 16-16 16l-88 0c-22.1 0-40 17.9-40 40v16c0 22.1 17.9 40 40 40h88c61.9 0 112-50.1 112-112V208 192h16 73.1c12.6 0 22.9-10.2 22.9-22.9c0-5.9-2.3-11.5-6.3-15.8L205.5 5.8C202 2.1 197.1 0 192 0s-10 2.1-13.5 5.8z"]
  },
  Sh = {
    prefix: "fad",
    iconName: "trash-can",
    icon: [448, 512, [61460, "trash-alt"], "f2ed", ["M416 96H32V448c0 35.3 28.7 64 64 64H352c35.3 0 64-28.7 64-64V96zM144 176V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16zm96 0V400c0 8.8-7.2 16-16 16s-16-7.2-16-16V176c0-8.8 7.2-16 16-16s16 7.2 16 16z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
  },
  Vh = {
    prefix: "fad",
    iconName: "calendar-days",
    icon: [448, 512, ["calendar-alt"], "f073", ["M0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16zM80 384c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336z", "M160 32c0-17.7-14.3-32-32-32S96 14.3 96 32V64H48C21.5 64 0 85.5 0 112v80H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32z"]]
  },
  Lh = {
    prefix: "fad",
    iconName: "h1",
    icon: [576, 512, [], "f313", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M496.8 68.8C506.3 74.6 512 84.9 512 96V384h32c17.7 0 32 14.3 32 32s-14.3 32-32 32H480 416c-17.7 0-32-14.3-32-32s14.3-32 32-32h32V147.8l-17.7 8.8c-15.8 7.9-35 1.5-42.9-14.3s-1.5-35 14.3-42.9l64-32c9.9-5 21.7-4.4 31.1 1.4z"]]
  },
  Ph = {
    prefix: "fad",
    iconName: "laptop",
    icon: [640, 512, [128187], "f109", ["M128 32C92.7 32 64 60.7 64 96V352h64V96H512V352h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2C0 445.6 34.4 480 76.8 480H563.2c42.4 0 76.8-34.4 76.8-76.8c0-10.6-8.6-19.2-19.2-19.2H19.2z", "M128 96H512V352H128V96z"]]
  },
  Oh = {
    prefix: "fad",
    iconName: "file-csv",
    icon: [512, 512, [], "f6dd", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM200 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H200c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40H200zm133.1 0c-24.9 0-45.1 20.2-45.1 45.1c0 17.8 10.5 34 26.8 41.2l37.4 16.6c4.7 2.1 7.8 6.8 7.8 12c0 7.2-5.9 13.1-13.1 13.1H304c-8.8 0-16 7.2-16 16s7.2 16 16 16h42.9c24.9 0 45.1-20.2 45.1-45.1c0-17.8-10.5-34-26.8-41.2l-37.4-16.6c-4.7-2.1-7.8-6.8-7.8-12c0-7.2 5.9-13.1 13.1-13.1H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H333.1zm98.9 0c-8.8 0-16 7.2-16 16v31.6c0 34.7 10.3 68.7 29.6 97.6l5.1 7.7c3 4.5 8 7.1 13.3 7.1s10.3-2.7 13.3-7.1l5.1-7.7c19.3-28.9 29.6-62.9 29.6-97.6V368c0-8.8-7.2-16-16-16s-16 7.2-16 16v31.6c0 23-5.5 45.6-16 66c-10.5-20.3-16-42.9-16-66V368c0-8.8-7.2-16-16-16z"]]
  },
  Th = {
    prefix: "fad",
    iconName: "grid",
    icon: [448, 512, ["grid-3"], "e195", ["M200 32c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V72c0-22.1-17.9-40-40-40H200zM40 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40H88c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H40zM160 392v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H200c-22.1 0-40 17.9-40 40zM360 192c-22.1 0-40 17.9-40 40v48c0 22.1 17.9 40 40 40h48c22.1 0 40-17.9 40-40V232c0-22.1-17.9-40-40-40H360z", "M0 72C0 49.9 17.9 32 40 32H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V72zM0 392c0-22.1 17.9-40 40-40H88c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H40c-22.1 0-40-17.9-40-40V392zM288 232v48c0 22.1-17.9 40-40 40H200c-22.1 0-40-17.9-40-40V232c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40zM320 72c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V72zM448 392v48c0 22.1-17.9 40-40 40H360c-22.1 0-40-17.9-40-40V392c0-22.1 17.9-40 40-40h48c22.1 0 40 17.9 40 40z"]]
  },
  Dh = {
    prefix: "fad",
    iconName: "strikethrough",
    icon: [512, 512, [], "f0cc", ["M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z", "M0 256c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
  },
  Rh = {
    prefix: "fad",
    iconName: "pencil",
    icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", ["M492.7 58.2c25 25 25 65.5 0 90.5l-60 60L302.7 78.7l60-60c25-25 65.5-25 90.5 0l39.4 39.4zM315.3 186.7l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z", "M432.7 208.7L302.7 78.7 58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L432.7 208.7zM89.3 360.5l22.7-9.1v32c0 8.8 7.2 16 16 16h32l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3zm226-196.4c6.2 6.2 6.2 16.4 0 22.6l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0z"]]
  },
  Gh = {
    prefix: "fad",
    iconName: "clipboard-list",
    icon: [384, 512, [], "f46d", ["M113.2 66.3c.1-.8 .3-1.6 .4-2.3H64C28.7 64 0 92.7 0 128V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H270.4c.2 .8 .3 1.6 .4 2.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm104-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zM72 368a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm88 0c0-8.8 7.2-16 16-16H304c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16z", "M113.2 66.3C119.6 28.7 152.5 0 192 0s72.4 28.7 78.8 66.3C290.1 72.6 304 90.7 304 112v24c0 13.3-10.7 24-24 24H192 104c-13.3 0-24-10.7-24-24V112c0-21.3 13.9-39.4 33.2-45.7zM216 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM72 272a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm0 96a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"]]
  },
  Fh = {
    prefix: "fad",
    iconName: "box-archive",
    icon: [512, 512, ["archive"], "f187", ["M480 128H32V416c0 35.3 28.7 64 64 64H416c35.3 0 64-28.7 64-64V128zM192 192H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M0 64C0 46.3 14.3 32 32 32H480c17.7 0 32 14.3 32 32V96c0 17.7-14.3 32-32 32H32C14.3 128 0 113.7 0 96V64z"]]
  },
  jh = {
    prefix: "fad",
    iconName: "message-question",
    icon: [512, 512, [], "e1e3", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm169.8 53.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6c-23.7 0-44.8 14.9-52.8 37.3zM288 304a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M222.6 80c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V216c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  Jh = {
    prefix: "fad",
    iconName: "microwave",
    icon: [576, 512, [], "e01b", ["M120 128c-13.3 0-24 10.7-24 24V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120z", "M0 96C0 60.7 28.7 32 64 32H512c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64c0 17.7-14.3 32-32 32s-32-14.3-32-32H128c0 17.7-14.3 32-32 32s-32-14.3-32-32c-35.3 0-64-28.7-64-64V96zm96 56V328c0 13.3 10.7 24 24 24H392c13.3 0 24-10.7 24-24V152c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24zm400-40c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16s16-7.2 16-16V128c0-8.8-7.2-16-16-16z"]]
  },
  Zh = {
    prefix: "fad",
    iconName: "bell-concierge",
    icon: [512, 512, [128718, "concierge-bell"], "f562", ["M216 64c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v33.3c7.9-.8 15.9-1.3 24-1.3s16.1 .4 24 1.3V112h16c13.3 0 24-10.7 24-24s-10.7-24-24-24H256 216zM480 400H32 24c-13.3 0-24 10.7-24 24s10.7 24 24 24H488c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8z", "M480 368c0-123.7-100.3-224-224-224S32 244.3 32 368v32H480V368z"]]
  },
  Wh = {
    prefix: "fad",
    iconName: "reply",
    icon: [512, 512, [61714, "mail-reply"], "f3e5", ["M224 288V128H336c97.2 0 176 78.8 176 176c0 113.3-81.5 163.9-100.2 174.1c-2.5 1.4-5.3 1.9-8.1 1.9c-10.9 0-19.7-8.9-19.7-19.7c0-7.5 4.3-14.4 9.8-19.5c9.4-8.8 22.2-26.4 22.2-56.7c0-53-43-96-96-96H224z", "M224 64c0-12.6-7.4-24.1-19-29.2s-25-3-34.4 5.4l-160 144C3.9 190.3 0 198.9 0 208s3.9 17.7 10.6 23.8l160 144c9.4 8.5 22.9 10.6 34.4 5.4s19-16.6 19-29.2V64z"]]
  },
  Xh = {
    prefix: "fad",
    iconName: "empty-set",
    icon: [512, 512, [8709, 216], "f656", ["M390.2 76.6C352.8 48.6 306.3 32 256 32C132.3 32 32 132.3 32 256c0 50.3 16.6 96.8 44.6 134.2l45.9-45.9C105.8 318.9 96 288.6 96 256c0-88.4 71.6-160 160-160c32.6 0 62.9 9.8 88.2 26.5l45.9-45.9zM167.8 389.5l-45.9 45.9c37.4 28 83.8 44.6 134.1 44.6c123.7 0 224-100.3 224-224c0-50.3-16.6-96.8-44.6-134.1l-45.9 45.9C406.2 193.1 416 223.4 416 256c0 88.4-71.6 160-160 160c-32.6 0-62.9-9.8-88.2-26.5z", "M502.6 9.4c12.5 12.5 12.5 32.8 0 45.3l-448 448c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l448-448c12.5-12.5 32.8-12.5 45.3 0z"]]
  },
  Uh = {
    prefix: "fad",
    iconName: "bars",
    icon: [448, 512, ["navicon"], "f0c9", ["M0 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zm0 320c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z"]]
  },
  Kh = {
    prefix: "fad",
    iconName: "people-group",
    icon: [640, 512, [], "e533", ["M128 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM48 304c0-16.2 6-31.1 16-42.3v84.7C54 335 48 320.2 48 304zm112 0c0-37.8 14.6-72.2 38.4-97.9c-16.1-9-34.7-14.1-54.4-14.1H112C50.1 192 0 242.1 0 304c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2 394.5c-20-24.7-32-56.2-32-90.5zM448 405.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H496c-19.7 0-38.3 5.1-54.4 14.1C465.4 231.8 480 266.2 480 304c0 34.3-12 65.8-32 90.5v10.7zM512 160a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm80 144c0 16.2-6 31-16 42.3V261.7c10 11.3 16 26.1 16 42.3z", "M384 96A64 64 0 1 0 256 96a64 64 0 1 0 128 0zM256 261.7v84.7c-10-11.3-16-26.1-16-42.3s6-31.1 16-42.3zm128 84.7V261.7c10 11.3 16 26.1 16 42.3s-6 31-16 42.3zm0 58.9c37.8-18 64-56.5 64-101.2c0-61.9-50.1-112-112-112H304c-61.9 0-112 50.1-112 112c0 44.7 26.2 83.2 64 101.2V448c0 17.7 14.3 32 32 32h64c17.7 0 32-14.3 32-32V405.2z"]]
  },
  Yh = {
    prefix: "fad",
    iconName: "circle-exclamation",
    icon: [512, 512, ["exclamation-circle"], "f06a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M280 152c0-13.3-10.7-24-24-24s-24 10.7-24 24V264c0 13.3 10.7 24 24 24s24-10.7 24-24V152zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  qh = {
    prefix: "fad",
    iconName: "sitemap",
    icon: [576, 512, [], "f0e8", ["M264 280v40h48V280H464c4.4 0 8 3.6 8 8v32h48V288c0-30.9-25.1-56-56-56H312V192H264v40H112c-30.9 0-56 25.1-56 56v32h48V288c0-4.4 3.6-8 8-8H264z", "M208 80c0-26.5 21.5-48 48-48h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V80zM48 320h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm208 0h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H256c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48zm208 0h64c26.5 0 48 21.5 48 48v64c0 26.5-21.5 48-48 48H464c-26.5 0-48-21.5-48-48V368c0-26.5 21.5-48 48-48z"]]
  },
  _h = {
    prefix: "fad",
    iconName: "fire-burner",
    icon: [640, 512, [], "e4f1", ["M321 288c-45 0-81-29-81-78c0-24 15-45 45-82c4 5 62 79 62 79l36-42c3 4 5 8 7 12c18 33 10 75-20 96c-15 10-31 15-49 15zM32 280c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24s-10.7 24-24 24H80v80H560V304H536c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24V384c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32V280zM320 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM192 480a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M283.7 0c3.5 0 7 1.3 9.8 3.8c19.7 17.8 38.2 37 55.5 57.7c7.9-9.9 16.8-20.7 26.5-29.5c5.6-5.1 14.4-5.1 20 0c24.7 22.7 45.6 52.7 60.4 81.1c14.5 28 24.2 58.8 24.2 79C480 280 408.7 352 320 352c-89.7 0-160-72.1-160-159.8c0-26.4 12.7-60.7 32.4-92.6c20-32.4 48.1-66.1 81.4-95.8c2.8-2.5 6.4-3.8 10-3.7zM321 288c18 0 34-5 49-15c30-21 38-63 20-96c-2-4-4-8-7-12l-36 42s-58-74-62-79c-30 37-45 58-45 82c0 49 36 78 81 78z"]]
  },
  $h = {
    prefix: "fad",
    iconName: "comment-lines",
    icon: [512, 512, [], "f4b0", ["M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM152 176H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24zm0 96H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24s10.7-24 24-24z", "M128 200c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
  },
  eA = {
    prefix: "fad",
    iconName: "list",
    icon: [512, 512, ["list-squares"], "f03a", ["M160 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M16 72c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V72zm0 160c0-13.3 10.7-24 24-24H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V232zM40 368H88c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H40c-13.3 0-24-10.7-24-24V392c0-13.3 10.7-24 24-24z"]]
  },
  tA = {
    prefix: "fad",
    iconName: "lock",
    icon: [448, 512, [128274], "f023", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
  },
  nA = {
    prefix: "fad",
    iconName: "hot-tub-person",
    icon: [512, 512, ["hot-tub"], "f593", ["M248 0c13.3 0 24 10.7 24 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C238.4 95.7 224 63.3 224 29.2V24c0-13.3 10.7-24 24-24zM0 256c0-53 43-96 96-96c20.8 0 41 6.7 57.6 19.2L256 256H0zM384 24v5.2c0 20.4 8.7 39.9 23.8 53.5l16.4 14.8c25.3 22.8 39.7 55.2 39.7 89.2V200c0 13.3-10.7 24-24 24s-24-10.7-24-24V186.8c0-20.4-8.7-39.9-23.8-53.5l-16.4-14.8C350.4 95.7 336 63.3 336 29.2V24c0-13.3 10.7-24 24-24s24 10.7 24 24zM0 64a64 64 0 1 1 128 0A64 64 0 1 1 0 64z", "M0 256H448c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256zm112 64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336zm80-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336c0-8.8-7.2-16-16-16zm112 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V336z"]]
  },
  rA = {
    prefix: "fad",
    iconName: "blanket",
    icon: [448, 512, [], "f498", ["M0 352V128C0 75 43 32 96 32H352c53 0 96 43 96 96V304c0-44.2-35.8-80-80-80H128C57.3 224 0 281.3 0 352z", "M128 288c-35.3 0-64 28.7-64 64s28.7 64 64 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H128C57.3 480 0 422.7 0 352s57.3-128 128-128H368c44.2 0 80 35.8 80 80s-35.8 80-80 80H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H368c8.8 0 16-7.2 16-16s-7.2-16-16-16H128z"]]
  },
  oA = {
    prefix: "fad",
    iconName: "users",
    icon: [640, 512, [], "f0c0", ["M224 80A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm368 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0zM106.7 192C47.8 192 0 239.8 0 298.7C0 310.4 9.6 320 21.3 320H234.7c.2 0 .4 0 .7 0c-26.6-23.5-43.3-57.8-43.3-96c0-7.6 .7-15 1.9-22.3c-13.6-6.3-28.7-9.7-44.6-9.7H106.7zm298 128c.2 0 .4 0 .7 0H618.7c11.8 0 21.3-9.6 21.3-21.3C640 239.8 592.2 192 533.3 192H490.7c-15.9 0-31 3.5-44.6 9.7c1.3 7.2 1.9 14.7 1.9 22.3c0 38.2-16.8 72.5-43.3 96z", "M320 320a96 96 0 1 0 0-192 96 96 0 1 0 0 192zm-58.7 32C187.7 352 128 411.7 128 485.3c0 14.7 11.9 26.7 26.7 26.7H485.3c14.7 0 26.7-11.9 26.7-26.7C512 411.7 452.3 352 378.7 352H261.3z"]]
  },
  iA = {
    prefix: "fad",
    iconName: "chevron-up",
    icon: [512, 512, [], "f077", ["M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z", ""]]
  },
  aA = {
    prefix: "fad",
    iconName: "link-simple",
    icon: [576, 512, [], "e1cd", ["M160 256c0-17.7 14.3-32 32-32H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32z", "M160 96C71.6 96 0 167.6 0 256s71.6 160 160 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160c-53 0-96-43-96-96s43-96 96-96h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm256 0H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c53 0 96 43 96 96s-43 96-96 96H352c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c88.4 0 160-71.6 160-160s-71.6-160-160-160z"]]
  },
  cA = {
    prefix: "fad",
    iconName: "money-bill",
    icon: [576, 512, [], "f0d6", ["M448 128H128c0 35.3-28.7 64-64 64V320c35.3 0 64 28.7 64 64H448c0-35.3 28.7-64 64-64V192c-35.3 0-64-28.7-64-64zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z", "M64 64C28.7 64 0 92.7 0 128V384c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64H64zm384 64c0 35.3 28.7 64 64 64V320c-35.3 0-64 28.7-64 64H128c0-35.3-28.7-64-64-64V192c35.3 0 64-28.7 64-64H448z"]]
  },
  sA = {
    prefix: "fad",
    iconName: "align-justify",
    icon: [448, 512, [], "f039", ["M32 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zM32 96C14.3 96 0 81.7 0 64S14.3 32 32 32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
  },
  lA = {
    prefix: "fad",
    iconName: "chart-simple",
    icon: [448, 512, [], "e473", ["M160 80c0-26.5 21.5-48 48-48h32c26.5 0 48 21.5 48 48V432c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V80z", "M368 96c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48h32c26.5 0 48-21.5 48-48V144c0-26.5-21.5-48-48-48H368zM48 224c-26.5 0-48 21.5-48 48V432c0 26.5 21.5 48 48 48H80c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48H48z"]]
  },
  uA = {
    prefix: "fad",
    iconName: "circle-parking",
    icon: [512, 512, ["parking-circle"], "f615", ["M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", "M240 192h48c17.7 0 32 14.3 32 32s-14.3 32-32 32H240V192zm0 128h48c53 0 96-43 96-96s-43-96-96-96H216c-22.1 0-40 17.9-40 40V288v64c0 17.7 14.3 32 32 32s32-14.3 32-32V320z"]]
  },
  dA = {
    prefix: "fad",
    iconName: "h3",
    icon: [640, 512, [], "f315", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M368 96c0-17.7 14.3-32 32-32H592c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-89.5 89.5C589 210.8 640 263.4 640 328c0 66.3-53.7 120-120 120H455.4c-43 0-79.7-31.1-86.8-73.5l-.2-1.2c-2.9-17.4 8.9-33.9 26.3-36.8s33.9 8.9 36.8 26.3l.2 1.2c1.9 11.6 11.9 20.1 23.7 20.1H520c30.9 0 56-25.1 56-56s-25.1-56-56-56H448c-12.9 0-24.6-7.8-29.6-19.8s-2.2-25.7 6.9-34.9L514.7 128H400c-17.7 0-32-14.3-32-32z"]]
  },
  fA = {
    prefix: "fad",
    iconName: "money-bill-wave",
    icon: [576, 512, [], "f53a", ["M512 160c-33.9 0-61.6-26.3-63.9-59.7c-40 .9-83.5 10.5-134.2 23.2c-4.6 1.2-9.4 2.3-14.2 3.6l0 0c-51.1 12.8-110.4 27.8-172.9 28.6C121.5 185.4 95.4 208 64 208V352c33.9 0 61.6 26.3 63.9 59.7c40-.9 83.5-10.5 134.2-23.2c4.7-1.2 9.4-2.3 14.2-3.6l0 0c51.1-12.8 110.4-27.8 172.9-28.6c5.5-29.8 31.6-52.4 63-52.4V160zM288 352c-44.2 0-80-43-80-96s35.8-96 80-96s80 43 80 96s-35.8 96-80 96z", "M0 112.5V422.3c0 18 10.1 35 27 41.3c87 32.5 174 10.3 261-11.9c79.8-20.3 159.6-40.7 239.3-18.9c23 6.3 48.7-9.5 48.7-33.4V89.7c0-18-10.1-35-27-41.3C462 15.9 375 38.1 288 60.3C208.2 80.6 128.4 100.9 48.7 79.1C25.6 72.8 0 88.6 0 112.5zM512 160V304c-31.4 0-57.5 22.6-63 52.4c-62.5 .8-121.8 15.7-172.9 28.6l0 0c-4.8 1.2-9.5 2.4-14.2 3.6c-50.7 12.6-94.1 22.2-134.2 23.2C125.6 378.3 97.9 352 64 352V208c31.4 0 57.5-22.6 63-52.4c62.5-.8 121.8-15.7 172.9-28.6l0 0c4.8-1.2 9.5-2.4 14.2-3.6c50.7-12.6 94.1-22.2 134.2-23.2c2.2 33.3 30 59.7 63.9 59.7z"]]
  },
  pA = {
    prefix: "fad",
    iconName: "ban",
    icon: [512, 512, [128683, "cancel"], "f05e", ["M99.5 144.8L367.2 412.5c17.5-12.5 32.8-27.8 45.3-45.3L144.8 99.5C127.3 112 112 127.3 99.5 144.8z", "M256 64a192 192 0 1 1 0 384 192 192 0 1 1 0-384zm0 448A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]]
  },
  mA = {
    prefix: "fad",
    iconName: "star",
    icon: [576, 512, [11088, 61446], "f005", ["M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z", ""]]
  },
  hA = {
    prefix: "fad",
    iconName: "file-invoice-dollar",
    icon: [384, 512, [], "f571", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm0 64c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 72c-8.8 0-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9V440c0 8.8 7.2 16 16 16s16-7.2 16-16V422.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V232c0-8.8-7.2-16-16-16z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM208 232c0-8.8-7.2-16-16-16s-16 7.2-16 16v17.3c-8.3 1.5-16.7 4.3-24.1 8.7c-13 7.7-23.9 21.1-23.8 40.5c.1 18.4 10.8 30.1 22.7 37.3c10.5 6.3 23.8 10.4 34.8 13.7l0 0 1.6 .5c12.5 3.8 22.2 6.9 29 11.2c5.9 3.7 7.7 7 7.7 11.6c.1 6.6-2.7 10.8-7.8 14c-5.8 3.6-14.5 5.6-23.7 5.3c-11.8-.4-22.7-4.1-36.3-8.7l0 0 0 0 0 0c-2.3-.8-4.7-1.6-7.1-2.4c-8.4-2.8-17.4 1.7-20.2 10.1s1.7 17.4 10.1 20.2c2 .7 4.1 1.4 6.2 2.1l0 0c9.2 3.2 19.7 6.8 30.9 8.9l0 17.8c0 8.8 7.2 16 16 16s16-7.2 16-16V422.9c8.7-1.4 17.4-4.3 25.1-9.1c13.3-8.3 23.2-22.2 22.9-41.6c-.2-18.5-10.6-30.6-22.7-38.2c-11-6.9-25-11.2-36.3-14.6l0 0 0 0-.5-.1c-12.6-3.8-22.3-6.8-29.2-10.9c-6-3.6-7.2-6.4-7.3-10.1c0-5.4 2.4-9.4 8.1-12.8c6.2-3.7 15.1-5.7 23.6-5.5c10.1 .2 21 2.3 32.1 5.3c8.5 2.3 17.3-2.8 19.6-11.3s-2.8-17.3-11.3-19.6c-7.5-2-15.6-3.9-24.1-5.1V232z"]]
  },
  AA = {
    prefix: "fad",
    iconName: "stars",
    icon: [512, 512, [], "f762", ["M312 104l13.8 48.3c1.3 4.6 5.5 7.7 10.2 7.7s8.9-3.1 10.2-7.7L360 104l48.3-13.8c4.6-1.3 7.7-5.5 7.7-10.2s-3.1-8.9-7.7-10.2L360 56 346.2 7.7C344.9 3.1 340.7 0 336 0s-8.9 3.1-10.2 7.7L312 56 263.7 69.8c-4.6 1.3-7.7 5.5-7.7 10.2s3.1 8.9 7.7 10.2L312 104zM428.8 243.2l11 38.6c1 3.6 4.4 6.2 8.2 6.2s7.1-2.5 8.2-6.2l11-38.6 38.6-11c3.6-1 6.2-4.4 6.2-8.2s-2.5-7.1-6.2-8.2l-38.6-11-11-38.6c-1-3.6-4.4-6.2-8.2-6.2s-7.1 2.5-8.2 6.2l-11 38.6-38.6 11c-3.6 1-6.2 4.4-6.2 8.2s2.5 7.1 6.2 8.2l38.6 11z", "M213.4 157.4c-8.8-17.9-34.3-17.9-43.1 0l-46.3 94L20.5 266.5C.9 269.3-7 293.5 7.2 307.4l74.9 73.2L64.5 483.9c-3.4 19.6 17.2 34.6 34.8 25.3l92.6-48.8 92.6 48.8c17.6 9.3 38.2-5.7 34.8-25.3L301.6 380.6l74.9-73.2c14.2-13.9 6.4-38.1-13.3-40.9L259.7 251.4l-46.3-94z"]]
  },
  gA = {
    prefix: "fad",
    iconName: "h4",
    icon: [640, 512, [], "f86a", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M479 103.8c4.3-17.1-6.1-34.5-23.3-38.8s-34.5 6.1-38.8 23.3l-48 192c-2.4 9.6-.2 19.7 5.8 27.5s15.4 12.3 25.2 12.3H576v96c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32s-32 14.3-32 32V256H441L479 103.8z"]]
  },
  vA = {
    prefix: "fad",
    iconName: "wifi",
    icon: [640, 512, ["wifi-3", "wifi-strong"], "f1eb", ["", "M54.2 202.9C123.2 136.7 216.8 96 320 96s196.8 40.7 265.8 106.9c12.8 12.2 33 11.8 45.2-.9s11.8-33-.9-45.2C549.7 79.5 440.4 32 320 32S90.3 79.5 9.8 156.7C-2.9 169-3.3 189.2 8.9 202s32.5 13.2 45.2 .9zM320 256c56.8 0 108.6 21.1 148.2 56c13.3 11.7 33.5 10.4 45.2-2.8s10.4-33.5-2.8-45.2C459.8 219.2 393 192 320 192s-139.8 27.2-190.5 72c-13.3 11.7-14.5 31.9-2.8 45.2s31.9 14.5 45.2 2.8c39.5-34.9 91.3-56 148.2-56zm64 160a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z"]]
  },
  CA = {
    prefix: "fad",
    iconName: "bath",
    icon: [512, 512, [128705, "bathtub"], "f2cd", ["M109.3 64C101.9 64 96 69.9 96 77.3V256H32V77.3C32 34.6 66.6 0 109.3 0c20.5 0 40.1 8.1 54.6 22.6l14.9 14.9C187.8 34 197.7 32 208 32c19.9 0 38 7.2 52 19.2c9.2-5.3 21.1-4 29 3.8c9.4 9.4 9.4 24.6 0 33.9L185 193c-9.4 9.4-24.6 9.4-33.9 0c-7.9-7.9-9.1-19.8-3.8-29c-12-14-19.2-32.1-19.2-52c0-10.3 2-20.2 5.5-29.2L118.6 67.9c-2.5-2.5-5.9-3.9-9.4-3.9z", "M32 256c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32zm448 96H32v16c0 28.4 12.4 54 32 71.6V480c0 17.7 14.3 32 32 32s32-14.3 32-32V464H384v16c0 17.7 14.3 32 32 32s32-14.3 32-32V439.6c19.6-17.6 32-43.1 32-71.6V352z"]]
  },
  bA = {
    prefix: "fad",
    iconName: "underline",
    icon: [448, 512, [], "f0cd", ["M48 32C30.3 32 16 46.3 16 64s14.3 32 32 32H64V224c0 88.4 71.6 160 160 160s160-71.6 160-160V96h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H304c-17.7 0-32 14.3-32 32s14.3 32 32 32h16V224c0 53-43 96-96 96s-96-43-96-96V96h16c17.7 0 32-14.3 32-32s-14.3-32-32-32H48z", "M0 448c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z"]]
  },
  EA = {
    prefix: "fad",
    iconName: "bold",
    icon: [384, 512, [], "f032", ["M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z", ""]]
  },
  yA = {
    prefix: "fad",
    iconName: "chart-bar",
    icon: [512, 512, ["bar-chart"], "f080", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L160 96zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H288c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm0 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H160z"]]
  },
  IA = {
    prefix: "fad",
    iconName: "message-lines",
    icon: [512, 512, ["comment-alt-lines"], "f4a6", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zm152 80c-13.3 0-24 10.7-24 24s10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H152zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24H264c13.3 0 24-10.7 24-24s-10.7-24-24-24H152z", "M128 168c0-13.3 10.7-24 24-24H360c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24zm0 96c0-13.3 10.7-24 24-24H264c13.3 0 24 10.7 24 24s-10.7 24-24 24H152c-13.3 0-24-10.7-24-24z"]]
  },
  BA = {
    prefix: "fad",
    iconName: "image",
    icon: [512, 512, [], "f03e", ["M0 96C0 60.7 28.7 32 64 32H448c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z", "M323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6h96 32H424c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176z"]]
  },
  xA = {
    prefix: "fad",
    iconName: "rotate-left",
    icon: [512, 512, ["rotate-back", "rotate-backward", "undo-alt"], "f2ea", ["M98.6 96.6l45.3 45.3c62.6-61.5 163.1-61.2 225.3 1c62.5 62.5 62.5 163.8 0 226.3s-163.8 62.5-226.3 0c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3c87.5 87.5 229.3 87.5 316.8 0s87.5-229.3 0-316.8c-87.2-87.2-228.3-87.5-315.8-1z", "M168 224H40c-13.3 0-24-10.7-24-24V72c0-9.7 5.8-18.5 14.8-22.2s19.3-1.7 26.2 5.2L185 183c6.9 6.9 8.9 17.2 5.2 26.2s-12.5 14.8-22.2 14.8z"]]
  },
  wA = {
    prefix: "fad",
    iconName: "align-slash",
    icon: [640, 512, [], "f846", ["M406.2 416l81.2 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H406.2zM243.7 288l81.2 64H128c-17.7 0-32-14.3-32-32s14.3-32 32-32H243.7zm-143-112.7L162.5 224H128c-17.7 0-32-14.3-32-32c0-6.1 1.7-11.8 4.7-16.7zM399.7 288H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H481.4l-81.7-64zM236.4 160H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H318.1l-81.7-64zM512 96H154.8L98.4 51.8C103.2 40.2 114.6 32 128 32H512c17.7 0 32 14.3 32 32s-14.3 32-32 32z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
  },
  QA = {
    prefix: "fad",
    iconName: "circle-check",
    icon: [512, 512, [61533, "check-circle"], "f058", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z", "M369 175c9.4 9.4 9.4 24.6 0 33.9L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0z"]]
  },
  HA = QA,
  zA = {
    prefix: "fad",
    iconName: "certificate",
    icon: [512, 512, [], "f0a3", ["M211 7.3C205 1 196-1.4 187.6 .8s-14.9 8.9-17.1 17.3L154.7 80.6l-62-17.5c-8.4-2.4-17.4 0-23.5 6.1s-8.5 15.1-6.1 23.5l17.5 62L18.1 170.6c-8.4 2.1-15 8.7-17.3 17.1S1 205 7.3 211l46.2 45L7.3 301C1 307-1.4 316 .8 324.4s8.9 14.9 17.3 17.1l62.5 15.8-17.5 62c-2.4 8.4 0 17.4 6.1 23.5s15.1 8.5 23.5 6.1l62-17.5 15.8 62.5c2.1 8.4 8.7 15 17.1 17.3s17.3-.2 23.4-6.4l45-46.2 45 46.2c6.1 6.2 15 8.7 23.4 6.4s14.9-8.9 17.1-17.3l15.8-62.5 62 17.5c8.4 2.4 17.4 0 23.5-6.1s8.5-15.1 6.1-23.5l-17.5-62 62.5-15.8c8.4-2.1 15-8.7 17.3-17.1s-.2-17.4-6.4-23.4l-46.2-45 46.2-45c6.2-6.1 8.7-15 6.4-23.4s-8.9-14.9-17.3-17.1l-62.5-15.8 17.5-62c2.4-8.4 0-17.4-6.1-23.5s-15.1-8.5-23.5-6.1l-62 17.5L341.4 18.1c-2.1-8.4-8.7-15-17.1-17.3S307 1 301 7.3L256 53.5 211 7.3z", ""]]
  },
  MA = {
    prefix: "fad",
    iconName: "text-slash",
    icon: [640, 512, ["remove-format"], "f87d", ["M355.7 253.5L400.2 96H503L497 120.2c-4.3 17.1 6.1 34.5 23.3 38.8s34.5-6.1 38.8-23.3l11-44.1C577.6 61.3 554.7 32 523.5 32H376.1h-.3H204.5c-22 0-41.2 15-46.6 36.4l-6.3 25.2 55.1 43.2c.1-.3 .2-.7 .3-1L217 96H333.7L301.3 210.8l54.4 42.7zM327.3 353.9L272.9 311 243.3 416H192c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H309.8l17.6-62.1z", "M5.1 9.2C13.3-1.2 28.4-3.1 38.8 5.1l592 464c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2z"]]
  },
  kA = {
    prefix: "fad",
    iconName: "file-word",
    icon: [384, 512, [], "f1c2", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM111 257.1c-3.8-12.7-17.2-19.9-29.9-16.1s-19.9 17.2-16.1 29.9l48 160c3 10 12 16.9 22.4 17.1s19.8-6.2 23.2-16.1L192 336.6l33.3 95.3c3.4 9.8 12.8 16.3 23.2 16.1s19.5-7.1 22.4-17.1l48-160c3.8-12.7-3.4-26.1-16.1-29.9s-26.1 3.4-29.9 16.1l-26.8 89.2-31.6-90.3c-3.4-9.6-12.5-16.1-22.7-16.1s-19.3 6.4-22.7 16.1l-31.6 90.3L111 257.1z"]]
  },
  NA = {
    prefix: "fad",
    iconName: "layer-group",
    icon: [576, 512, [], "f5fd", ["M324.9 279.8l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z", "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 337.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2z"]]
  },
  SA = {
    prefix: "fad",
    iconName: "italic",
    icon: [384, 512, [], "f033", ["M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z", ""]]
  },
  VA = {
    prefix: "fad",
    iconName: "comments-dollar",
    icon: [640, 512, [], "f653", ["M208 352c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 38.6 14.7 74.3 39.6 103.4c-3.5 9.4-8.7 17.7-14.2 24.7c-4.8 6.2-9.7 11-13.3 14.3c-1.8 1.6-3.3 2.9-4.3 3.7c-.5 .4-.9 .7-1.1 .8l-.2 .2 0 0 0 0C1 327.2-1.4 334.4 .8 340.9S9.1 352 16 352c21.8 0 43.8-5.6 62.1-12.5c9.2-3.5 17.8-7.4 25.2-11.4C134.1 343.3 169.8 352 208 352zM228 72V85.9c7.5 1.2 14.6 2.9 21.1 4.7c10.7 2.8 17 13.8 14.2 24.5s-13.8 17-24.5 14.2c-11-2.9-21.6-5-31.2-5.2c-7.9-.1-16 1.8-21.5 5c-4.8 2.8-6.2 5.6-6.2 9.3c0 1.8 .1 3.5 5.3 6.7c6.3 3.8 15.5 6.7 28.3 10.5l.7 .2c11.2 3.4 25.6 7.7 37.1 15c12.9 8.1 24.3 21.3 24.6 41.6c.3 20.9-10.5 36.1-24.8 45c-7.2 4.5-15.2 7.3-23.2 9V280c0 11-9 20-20 20s-20-9-20-20V265.4c-10.3-2.2-20-5.5-28.2-8.4l0 0 0 0c-2.1-.7-4.1-1.4-6.1-2.1c-10.5-3.5-16.1-14.8-12.6-25.3s14.8-16.1 25.3-12.6c2.5 .8 4.9 1.7 7.2 2.4c13.6 4.6 24 8.1 35.1 8.5c8.6 .3 16.5-1.6 21.4-4.7c4.1-2.5 6-5.5 5.9-10.5c0-2.9-.8-5-5.9-8.2c-6.3-4-15.4-6.9-28-10.7l-1.7-.5c-10.9-3.3-24.6-7.4-35.6-14c-12.7-7.7-24.6-20.5-24.7-40.7c-.1-21.1 11.8-35.7 25.8-43.9c6.9-4.1 14.5-6.8 22.2-8.5V72c0-11 9-20 20-20s20 9 20 20z", "M228 72c0-11-9-20-20-20s-20 9-20 20V86c-7.6 1.7-15.2 4.4-22.2 8.5c-13.9 8.3-25.9 22.8-25.8 43.9c.1 20.3 12 33.1 24.7 40.7c11 6.6 24.7 10.8 35.6 14l1.7 .5c12.6 3.8 21.8 6.8 28 10.7c5.1 3.2 5.8 5.4 5.9 8.2c.1 5-1.8 8-5.9 10.5c-5 3.1-12.9 5-21.4 4.7c-11.1-.4-21.5-3.9-35.1-8.5c-2.3-.8-4.7-1.6-7.2-2.4c-10.5-3.5-21.8 2.2-25.3 12.6s2.2 21.8 12.6 25.3c1.9 .6 4 1.3 6.1 2.1l0 0 0 0c8.3 2.9 17.9 6.2 28.2 8.4V280c0 11 9 20 20 20s20-9 20-20V266.2c8-1.7 16-4.5 23.2-9c14.3-8.9 25.1-24.1 24.8-45c-.3-20.3-11.7-33.4-24.6-41.6c-11.5-7.2-25.9-11.6-37.1-15l-.7-.2c-12.8-3.9-21.9-6.7-28.3-10.5c-5.2-3.1-5.3-4.9-5.3-6.7c0-3.7 1.4-6.5 6.2-9.3c5.4-3.2 13.6-5.1 21.5-5c9.6 .1 20.2 2.2 31.2 5.2c10.7 2.8 21.6-3.5 24.5-14.2s-3.5-21.6-14.2-24.5c-6.5-1.7-13.7-3.4-21.1-4.7V72zM448 176c0 112.3-99.1 196.9-216.5 207C255.8 457.4 336.4 512 432 512c38.2 0 73.9-8.7 104.7-23.9c7.5 4 16 7.9 25.2 11.4c18.3 6.9 40.3 12.5 62.1 12.5c6.9 0 13.1-4.5 15.2-11.1c2.1-6.6-.2-13.8-5.8-17.9l0 0 0 0-.2-.2c-.2-.2-.6-.4-1.1-.8c-1-.8-2.5-2-4.3-3.7c-3.6-3.3-8.5-8.1-13.3-14.3c-5.5-7-10.7-15.4-14.2-24.7c24.9-29 39.6-64.7 39.6-103.4c0-92.8-84.9-168.9-192.6-175.5c.4 5.1 .6 10.3 .6 15.5z"]]
  },
  LA = {
    prefix: "fad",
    iconName: "sort",
    icon: [320, 512, ["unsorted"], "f0dc", ["M182.6 470.6c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-9.2-9.2-11.9-22.9-6.9-34.9s16.6-19.8 29.6-19.8H288c12.9 0 24.6 7.8 29.6 19.8s2.2 25.7-6.9 34.9l-128 128z", "M182.6 41.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8H288c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z"]]
  },
  PA = {
    prefix: "fad",
    iconName: "list-ol",
    icon: [512, 512, ["list-1-2", "list-numeric"], "f0cb", ["M192 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H488c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32zm32 128H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M48 32C34.7 32 24 42.8 24 56s10.7 24 24 24h8v96H40c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24H104V56c0-13.3-10.7-24-24-24H48zM62.6 342.4c5.7-8.1 17.5-8.6 24-1.2c5.2 5.9 5 14.7-.3 20.5l-72 78c-6.5 7-8.2 17.2-4.3 25.9s12.5 14.4 22 14.4h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H86.8l34.8-37.7c22-23.8 22.4-60.3 1.1-84.7c-26.9-30.7-75.4-28.4-99.2 4.9L12.5 330.1c-7.7 10.8-5.2 25.8 5.6 33.5s25.8 5.2 33.5-5.6l11.1-15.6z"]]
  },
  OA = {
    prefix: "fad",
    iconName: "chart-waterfall",
    icon: [512, 512, [], "e0eb", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M352 64c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-64 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zM480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96z"]]
  },
  TA = {
    prefix: "fad",
    iconName: "up-down-left-right",
    icon: [512, 512, ["arrows-alt"], "f0b2", ["M278.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-64 64c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8h32v96l64 0V128h32c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-64-64zM288 288l-64 0v96H192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l64 64c12.5 12.5 32.8 12.5 45.3 0l64-64c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8H288V288z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l64-64c9.2-9.2 22.9-11.9 34.9-6.9s19.8 16.6 19.8 29.6l0 32 256 0 0-32c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l64 64c12.5 12.5 12.5 32.8 0 45.3l-64 64c-9.2 9.2-22.9 11.9-34.9 6.9s-19.8-16.6-19.8-29.6l0-32-256 0 0 32c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9l-64-64z"]]
  },
  DA = {
    prefix: "fad",
    iconName: "star-half-stroke",
    icon: [640, 512, ["star-half-alt"], "f5c0", ["M320.1 376.3l-.1 .1v63.5l.1-.1 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L470.5 329 574.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L413.2 150.3 348.9 18C343.6 7 332.4 0 320.1 0c-.5 0-1.1 0-1.6 0H320V87.1l.1-.3 42.7 87.9 12.9 26.6 29.3 4.3 96.1 14.2-70.1 69.3-20.7 20.5 4.8 28.7 16.5 97.6-85.2-45.5-26.4-14.1zM178.3 512c-1.1 .1-2.1 .1-3.2 0h3.2z", "M321.7 0H320V87.1 376.4v63.5L191.8 508.3C181 514 167.9 513.1 158 506s-14.9-19.3-12.9-31.3L169.8 329 65.6 225.9c-8.6-8.5-11.7-21.2-7.9-32.7s13.7-19.9 25.7-21.7L227 150.3 291.4 18c5.4-11 16.5-18 28.8-18c.5 0 1.1 0 1.6 0zM465.2 512c-1.1 .1-2.1 .1-3.2 0h3.2z"]]
  },
  RA = {
    prefix: "fad",
    iconName: "code",
    icon: [640, 512, [], "f121", ["M392.8 1.2c-17-4.9-34.7 5-39.6 22l-128 448c-4.9 17 5 34.7 22 39.6s34.7-5 39.6-22l128-448c4.9-17-5-34.7-22-39.6z", "M473.4 121.4c-12.5 12.5-12.5 32.8 0 45.3L562.7 256l-89.4 89.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l112-112c12.5-12.5 12.5-32.8 0-45.3l-112-112c-12.5-12.5-32.8-12.5-45.3 0zm-306.7 0c-12.5-12.5-32.8-12.5-45.3 0l-112 112c-12.5 12.5-12.5 32.8 0 45.3l112 112c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256l89.4-89.4c12.5-12.5 12.5-32.8 0-45.3z"]]
  },
  GA = {
    prefix: "fad",
    iconName: "bed-bunk",
    icon: [576, 512, [], "f8f8", ["M192 48A48 48 0 1 0 96 48a48 48 0 1 0 96 0zm0 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM256 0c-17.7 0-32 14.3-32 32v96H576C576 57.3 518.7 0 448 0H256zM240 256c-8.8 0-16 7.2-16 16V384H512V256H240z", "M64 32C64 14.3 49.7 0 32 0S0 14.3 0 32v96 64V480c0 17.7 14.3 32 32 32s32-14.3 32-32V448H256 512v32c0 17.7 14.3 32 32 32s32-14.3 32-32V448 416 288 192 160 128H544 256 64V32zM512 288v96H256 64V192H256 512v96z"]]
  },
  FA = {
    prefix: "fad",
    iconName: "bolt-lightning",
    icon: [384, 512, [], "e0b7", ["", "M0 256L28.5 28c2-16 15.6-28 31.8-28H228.9c15 0 27.1 12.1 27.1 27.1c0 3.2-.6 6.5-1.7 9.5L208 160H347.3c20.2 0 36.7 16.4 36.7 36.7c0 7.4-2.2 14.6-6.4 20.7l-192.2 281c-5.9 8.6-15.6 13.7-25.9 13.7h-2.9c-15.7 0-28.5-12.8-28.5-28.5c0-2.3 .3-4.6 .9-6.9L176 288H32c-17.7 0-32-14.3-32-32z"]]
  },
  jA = {
    prefix: "fad",
    iconName: "file-excel",
    icon: [384, 512, [], "f1c3", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM155.7 250.2c-7.6-10.9-22.6-13.5-33.4-5.9s-13.5 22.6-5.9 33.4L162.7 344l-46.4 66.2c-7.6 10.9-5 25.8 5.9 33.4s25.8 5 33.4-5.9L192 385.8l36.3 51.9c7.6 10.9 22.6 13.5 33.4 5.9s13.5-22.6 5.9-33.4L221.3 344l46.4-66.2c7.6-10.9 5-25.8-5.9-33.4s-25.8-5-33.4 5.9L192 302.1l-36.3-51.9z"]]
  },
  JA = {
    prefix: "fad",
    iconName: "face-surprise",
    icon: [512, 512, [128558, "surprise"], "f5c2", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM176.4 176a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM256 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  ZA = {
    prefix: "fad",
    iconName: "kitchen-set",
    icon: [576, 512, [], "e51a", ["M144 224a80 80 0 1 0 0-160 80 80 0 1 0 0 160zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16H208c8.8 0 16-7.2 16-16s-7.2-16-16-16H16zM256 296c0 13.3 10.7 24 24 24H520c13.3 0 24-10.7 24-24s-10.7-24-24-24H424v-8c0-13.3-10.7-24-24-24s-24 10.7-24 24v8H280c-13.3 0-24 10.7-24 24z", "M224 144A80 80 0 1 0 64 144a80 80 0 1 0 160 0zm60.4 32C269.9 240.1 212.5 288 144 288C64.5 288 0 223.5 0 144S64.5 0 144 0c68.5 0 125.9 47.9 140.4 112h71.8c8.8-9.8 21.6-16 35.8-16H496c26.5 0 48 21.5 48 48s-21.5 48-48 48H392c-14.2 0-27-6.2-35.8-16H284.4zM48 320h80 16 32c26.5 0 48 21.5 48 48s-21.5 48-48 48H160c0 17.7-14.3 32-32 32H64c-17.7 0-32-14.3-32-32V336c0-8.8 7.2-16 16-16zm128 64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160v32h16zm336-64V464c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V320H512z"]]
  },
  WA = {
    prefix: "fad",
    iconName: "lock-keyhole",
    icon: [448, 512, ["lock-alt"], "f30d", ["M224 64c-44.2 0-80 35.8-80 80v48H80V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48H304V144c0-44.2-35.8-80-80-80z", "M64 192c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V256c0-35.3-28.7-64-64-64H64zM256 320v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V320c0-17.7 14.3-32 32-32s32 14.3 32 32z"]]
  },
  XA = {
    prefix: "fad",
    iconName: "lock-open",
    icon: [576, 512, [], "f3c1", ["M432 64c-44.2 0-80 35.8-80 80v48H288V144C288 64.5 352.5 0 432 0s144 64.5 144 144v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V144c0-44.2-35.8-80-80-80z", "M0 256c0-35.3 28.7-64 64-64H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256z"]]
  },
  UA = {
    prefix: "fad",
    iconName: "circle",
    icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z", ""]]
  },
  KA = {
    prefix: "fad",
    iconName: "turn-down-left",
    icon: [512, 512, [], "e331", ["M192 240v96H400c61.9 0 112-50.1 112-112V64c0-17.7-14.3-32-32-32H448c-17.7 0-32 14.3-32 32V224c0 8.8-7.2 16-16 16H192z", "M151.5 441.4c7 6.6 17.2 8.4 26 4.6s14.5-12.5 14.5-22l0-272c0-9.6-5.7-18.2-14.5-22s-19-2-26 4.6l-144 136C2.7 275.1 0 281.4 0 288s2.7 12.9 7.5 17.4l144 136z"]]
  },
  YA = {
    prefix: "fad",
    iconName: "circle-question",
    icon: [512, 512, [62108, "question-circle"], "f059", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z", "M222.6 128c-23.7 0-44.8 14.9-52.8 37.3l-.4 1.2c-4.4 12.5 2.1 26.2 14.6 30.6s26.2-2.1 30.6-14.6l.4-1.2c1.1-3.2 4.2-5.3 7.5-5.3h58.3c8.4 0 15.1 6.8 15.1 15.1c0 5.4-2.9 10.4-7.6 13.1l-44.3 25.4c-7.5 4.3-12.1 12.2-12.1 20.8V264c0 13.3 10.7 24 24 24c13.1 0 23.8-10.5 24-23.6l32.3-18.5c19.6-11.3 31.7-32.2 31.7-54.8c0-34.9-28.3-63.1-63.1-63.1H222.6zM256 384a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  qA = {
    prefix: "fad",
    iconName: "file-doc",
    icon: [512, 512, [], "e5ed", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H176zm16 128V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H192zM456 352c-22.1 0-40 17.9-40 40v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40v-8c0-8.8-7.2-16-16-16s-16 7.2-16 16v8c0 4.4-3.6 8-8 8H456c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v8c0 8.8 7.2 16 16 16s16-7.2 16-16v-8c0-22.1-17.9-40-40-40H456zM288 392v80c0 22.1 17.9 40 40 40h16c22.1 0 40-17.9 40-40V392c0-22.1-17.9-40-40-40H328c-22.1 0-40 17.9-40 40zm40-8h16c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8V392c0-4.4 3.6-8 8-8z"]]
  },
  _A = {
    prefix: "fad",
    iconName: "eye",
    icon: [576, 512, [128065], "f06e", ["M95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 400a144 144 0 1 0 0-288 144 144 0 1 0 0 288z", "M224 256c35.3 0 64-28.7 64-64c0-7.1-1.2-13.9-3.3-20.3c-1.8-5.5 1.6-11.9 7.4-11.7c40.8 1.7 77.5 29.6 88.6 71.1c13.7 51.2-16.7 103.9-67.9 117.6s-103.9-16.7-117.6-67.9c-1.9-6.9-2.9-13.9-3.2-20.7c-.3-5.8 6.1-9.2 11.7-7.4c6.4 2.1 13.2 3.3 20.3 3.3z"]]
  },
  $A = {
    prefix: "fad",
    iconName: "heat",
    icon: [448, 512, [], "e00c", ["M176 32c17.7 0 32 14.3 32 32v80c0 34.6 11.2 68.3 32 96l19.2 25.6C288.3 304.4 304 351.5 304 400v48c0 17.7-14.3 32-32 32s-32-14.3-32-32V400c0-34.6-11.2-68.3-32-96l-19.2-25.6C159.7 239.6 144 192.5 144 144V64c0-17.7 14.3-32 32-32z", "M64 128c0-17.7-14.3-32-32-32S0 110.3 0 128v32c0 48.5 15.7 95.6 44.8 134.4L64 320c20.8 27.7 32 61.4 32 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-48.5-15.7-95.6-44.8-134.4L96 256c-20.8-27.7-32-61.4-32-96V128zm288 0c0-17.7-14.3-32-32-32s-32 14.3-32 32v32c0 48.5 15.7 95.6 44.8 134.4L352 320c20.8 27.7 32 61.4 32 96v32c0 17.7 14.3 32 32 32s32-14.3 32-32V416c0-48.5-15.7-95.6-44.8-134.4L384 256c-20.8-27.7-32-61.4-32-96V128z"]]
  },
  eg = {
    prefix: "fad",
    iconName: "floppy-disk",
    icon: [448, 512, [128190, 128426, "save"], "f0c7", ["M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V173.3c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32H64zm0 96c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V128zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z", "M224 288a64 64 0 1 0 0 128 64 64 0 1 0 0-128z"]]
  },
  tg = {
    prefix: "fad",
    iconName: "phone",
    icon: [512, 512, [128222, 128379], "f095", ["M505.7 412.3l-8.5 31.2c-71.8-8.7-138.9-32.9-197.8-69.1l20.5-25c55.4 33.4 118.4 55.4 185.8 62.9zM99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8l-25 20.5C101.4 153.7 77.2 86.6 68.4 14.8L99.7 6.3z", "M68.4 14.8l-39 10.6C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l10.6-39C273.2 416.4 95.6 238.8 68.4 14.8zM505.7 412.3l4.9-17.8c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6l-25.1 30.7c55.4 33.4 118.4 55.4 185.8 62.9zM162.6 192.1L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96c-7.7-18.6-28-28.5-47.4-23.2L99.7 6.3c7.5 67.4 29.5 130.4 62.9 185.8z"]]
  },
  ng = {
    prefix: "fad",
    iconName: "coffee-pot",
    icon: [512, 512, [], "e002", ["M160.4 176C103.4 202.9 64 260.8 64 328v16c0 55.5 34.6 99.4 55.9 121.2c9.9 10.2 23.9 14.8 38.1 14.8H418c14.2 0 28.1-4.7 38.1-14.8C477.4 443.4 512 399.5 512 344V328c0-67.2-39.4-125.1-96.4-152H160.4zM448 328v16c0 27.4-16.8 53.7-33.5 72H161.5c-16.7-18.3-33.5-44.6-33.5-72V328c0-57.4 46.6-104 104-104H344c57.4 0 104 46.6 104 104z", "M96 96c-17.7 0-32 14.3-32 32v64c0 17.7-14.3 32-32 32s-32-14.3-32-32V128C0 75 43 32 96 32h25.3H192 454.7c14 0 25.3 11.3 25.3 25.3c0 4.4-1.1 8.7-3.3 12.5L416 176H160L114.3 96H96zM448 344c0 27.4-16.8 53.7-33.5 72H161.5c-16.7-18.3-33.5-44.6-33.5-72V328c0-2.7 .1-5.4 .3-8H447.7c.2 2.6 .3 5.3 .3 8v16z"]]
  },
  rg = {
    prefix: "fad",
    iconName: "trash",
    icon: [448, 512, [], "f1f8", ["M394.6 466.8L416 96H32L53.4 466.8c1.5 25.4 22.5 45.2 47.9 45.2H346.7c25.4 0 46.5-19.8 47.9-45.2z", "M163.8 0c-12.1 0-23.2 6.8-28.6 17.7L128 32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H320l-7.2-14.3C307.4 6.8 296.3 0 284.2 0H163.8z"]]
  },
  og = {
    prefix: "fad",
    iconName: "arrow-left",
    icon: [448, 512, [8592], "f060", ["M109.3 288L416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0-32 32 32 32z", "M9.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l160-160c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L77.3 256 214.6 393.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-160-160z"]]
  },
  ig = {
    prefix: "fad",
    iconName: "align-left",
    icon: [448, 512, [], "f036", ["M256 352c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H256zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H256z", "M416 480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416zm0-256c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416z"]]
  },
  ag = {
    prefix: "fad",
    iconName: "file-video",
    icon: [384, 512, [], "f1c8", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM64 288v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V284.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304v64l44.9 29.9z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM64 288v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32V288c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zM300.9 397.9c2 1.3 4.4 2.1 6.8 2.1c6.8 0 12.3-5.5 12.3-12.3V284.3c0-6.8-5.5-12.3-12.3-12.3c-2.4 0-4.8 .7-6.8 2.1L256 304v64l44.9 29.9z"]]
  },
  cg = {
    prefix: "fad",
    iconName: "up-right-from-square",
    icon: [512, 512, ["external-link-alt"], "f35d", ["M0 112C0 67.8 35.8 32 80 32H192c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16H400c8.8 0 16-7.2 16-16V320c0-17.7 14.3-32 32-32s32 14.3 32 32V432c0 44.2-35.8 80-80 80H80c-44.2 0-80-35.8-80-80V112z", "M322.4 19.8C327.4 7.8 339.1 0 352 0H480c17.7 0 32 14.3 32 32V160c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L416 141.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L370.7 96 329.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9z"]]
  },
  sg = {
    prefix: "fad",
    iconName: "file-pdf",
    icon: [512, 512, [], "f1c1", ["M0 64C0 28.7 28.7 0 64 0H224V128c0 17.7 14.3 32 32 32H384V304H176c-35.3 0-64 28.7-64 64V512H64c-35.3 0-64-28.7-64-64V64z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM176 352c-8.8 0-16 7.2-16 16v80 48c0 8.8 7.2 16 16 16s16-7.2 16-16V464h16c30.9 0 56-25.1 56-56s-25.1-56-56-56H176zm32 80H192V384h16c13.3 0 24 10.7 24 24s-10.7 24-24 24zm96-80c-8.8 0-16 7.2-16 16V496c0 8.8 7.2 16 16 16h32c26.5 0 48-21.5 48-48V400c0-26.5-21.5-48-48-48H304zm32 128H320V384h16c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16zm80-112v64 64c0 8.8 7.2 16 16 16s16-7.2 16-16V448h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H448V384h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H432c-8.8 0-16 7.2-16 16z"]]
  },
  lg = {
    prefix: "fad",
    iconName: "gamepad-modern",
    icon: [640, 512, [127918, 63676, "gamepad-alt"], "e5a2", ["M0 369.4v2.8C0 431.7 48.3 480 107.8 480c49.5 0 92.6-33.7 104.6-81.7L216 384H424l3.6 14.3c12 48 55.1 81.7 104.6 81.7C591.7 480 640 431.7 640 372.2v-2.8c0-6.3-.5-12.5-1.6-18.7L605.7 159.8c-8.6-50.2-40.9-93.2-90.3-105.5C469.5 42.9 403.8 32 320 32s-149.5 10.9-195.3 22.3C75.2 66.6 42.9 109.6 34.3 159.8L1.6 350.7C.5 356.9 0 363.1 0 369.4zM432 232a40 40 0 1 1 0 80 40 40 0 1 1 0-80zm24-56a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zm-240-8v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24s24 10.7 24 24z", "M192 144c13.3 0 24 10.7 24 24v32h32c13.3 0 24 10.7 24 24s-10.7 24-24 24H216v32c0 13.3-10.7 24-24 24s-24-10.7-24-24V248H136c-13.3 0-24-10.7-24-24s10.7-24 24-24h32V168c0-13.3 10.7-24 24-24z"]]
  },
  ug = {
    prefix: "fad",
    iconName: "rv",
    icon: [640, 512, [], "f7be", ["M176 512a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm320 0a64 64 0 1 0 0-128 64 64 0 1 0 0 128z", "M224 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16V32H512c53 0 96 43 96 96c0 17.7-14.3 32-32 32H384V416H266.5c-13.2-37.3-48.7-64-90.5-64c-38.9 0-72.5 23.2-87.5 56.5L18.7 338.7C6.7 326.7 0 310.5 0 293.5V96C0 60.7 28.7 32 64 32H224V16zM96 144v64c0 8.8 7.2 16 16 16H240c8.8 0 16-7.2 16-16V144c0-8.8-7.2-16-16-16H112c-8.8 0-16 7.2-16 16zM416 320V288 216 192h24 76.6c12.9 0 25.5 4.5 35.5 12.7l67.4 55.2c13 10.6 20.5 26.5 20.5 43.3V320v64c0 17.7-14.3 32-32 32H586.5c-13.2-37.3-48.7-64-90.5-64c-33.4 0-62.8 17-80 42.9V320zm162.1-32l-56.5-46.2c-1.4-1.2-3.2-1.8-5.1-1.8H464v48H578.1z"]]
  },
  dg = {
    prefix: "fad",
    iconName: "washing-machine",
    icon: [448, 512, ["washer"], "f898", ["M184 112a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm40 336c77.6 0 140.9-61.4 143.9-138.2C350 315.4 328.1 320 304 320c-32 0-56-16-80-32s-48-32-80-32c-19.7 0-40.6 4.7-59 10.4c-3.2 12-5 24.6-5 37.6c0 79.5 64.5 144 144 144z", "M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM224 160a144 144 0 1 1 0 288 144 144 0 1 1 0-288zM64 88a24 24 0 1 1 48 0A24 24 0 1 1 64 88zM184 64a24 24 0 1 1 0 48 24 24 0 1 1 0-48z"]]
  },
  fg = {
    prefix: "fad",
    iconName: "envelope",
    icon: [512, 512, [128386, 9993, 61443], "f0e0", ["M0 112V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V112c0 15.1-7.1 29.3-19.2 38.4L275.2 313.6c-11.4 8.5-27 8.5-38.4 0L19.2 150.4C7.1 141.3 0 127.1 0 112z", "M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4c0-26.5-21.5-48-48-48H48z"]]
  },
  pg = {
    prefix: "fad",
    iconName: "paperclip",
    icon: [448, 512, [128206], "f0c6", ["M364.2 83.8c-24.4-24.4-64-24.4-88.4 0l-184 184c-42.1 42.1-42.1 110.3 0 152.4s110.3 42.1 152.4 0l152-152c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-152 152c-64 64-167.6 64-231.6 0s-64-167.6 0-231.6l184-184c46.3-46.3 121.3-46.3 167.6 0s46.3 121.3 0 167.6l-176 176c-28.6 28.6-75 28.6-103.6 0s-28.6-75 0-103.6l144-144c10.9-10.9 28.7-10.9 39.6 0s10.9 28.7 0 39.6l-144 144c-6.7 6.7-6.7 17.7 0 24.4s17.7 6.7 24.4 0l176-176c24.4-24.4 24.4-64 0-88.4z", ""]]
  },
  mg = {
    prefix: "fad",
    iconName: "h6",
    icon: [640, 512, [], "e413", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M537 116c11-13.8 8.8-33.9-5-45s-33.9-8.8-45 5L389 198.5c-24 29.9-37 67.1-37 105.5c0 79.5 64.5 144 144 144s144-64.5 144-144c0-77.6-61.4-140.9-138.3-143.9L537 116zm39 188a80 80 0 1 1 -160 0 80 80 0 1 1 160 0z"]]
  },
  hg = {
    prefix: "fad",
    iconName: "circle-info",
    icon: [512, 512, ["info-circle"], "f05a", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z", "M256 128a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM192 248c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h24V272H216c-13.3 0-24-10.7-24-24z"]]
  },
  Ag = {
    prefix: "fad",
    iconName: "chart-gantt",
    icon: [512, 512, [], "e0e4", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H160zm64 96c-17.7 0-32 14.3-32 32s14.3 32 32 32H352c17.7 0 32-14.3 32-32s-14.3-32-32-32H224zm160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384z"]]
  },
  gg = {
    prefix: "fad",
    iconName: "minus",
    icon: [448, 512, [8211, 8722, 10134, "subtract"], "f068", ["M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z", ""]]
  },
  vg = {
    prefix: "fad",
    iconName: "gear",
    icon: [512, 512, [9881, "cog"], "f013", ["M192 256a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z", "M489.6 191.2c6.9-6.2 9.6-15.9 6.4-24.6c-4.4-11.9-9.7-23.3-15.8-34.3l-4.7-8.1c-6.6-11-14-21.4-22.1-31.2c-5.9-7.2-15.7-9.6-24.5-6.8L389.1 98.8c-10 3.2-20.8 1.1-29.7-4.6c-4.9-3.1-9.9-6.1-15.1-8.7c-9.3-4.8-16.5-13.2-18.8-23.4l-8.9-40.7c-2-9.1-9-16.3-18.2-17.8C284.7 1.2 270.5 0 256 0s-28.7 1.2-42.5 3.5c-9.2 1.5-16.2 8.7-18.2 17.8l-8.9 40.7c-2.2 10.2-9.5 18.6-18.8 23.4c-5.2 2.7-10.2 5.6-15.1 8.7c-8.8 5.7-19.7 7.7-29.7 4.6L83.1 86.1c-8.8-2.8-18.6-.3-24.5 6.8c-8.1 9.8-15.5 20.2-22.1 31.2l-4.7 8.1c-6.1 11-11.4 22.4-15.8 34.3c-3.2 8.7-.5 18.4 6.4 24.6l30.9 28.1c7.7 7.1 11.4 17.5 10.9 27.9c-.1 2.9-.2 5.8-.2 8.8s.1 5.9 .2 8.8c.5 10.5-3.1 20.9-10.9 27.9L22.4 320.8c-6.9 6.2-9.6 15.9-6.4 24.6c4.4 11.9 9.7 23.3 15.8 34.3l4.7 8.1c6.6 11 14 21.4 22.1 31.2c5.9 7.2 15.7 9.6 24.5 6.8l39.7-12.6c10-3.2 20.8-1.1 29.7 4.6c4.9 3.1 9.9 6.1 15.1 8.7c9.3 4.8 16.5 13.2 18.8 23.4l8.9 40.7c2 9.1 9 16.3 18.2 17.8c13.8 2.3 28 3.5 42.5 3.5s28.7-1.2 42.5-3.5c9.2-1.5 16.2-8.7 18.2-17.8l8.9-40.7c2.2-10.2 9.4-18.6 18.8-23.4c5.2-2.7 10.2-5.6 15.1-8.7c8.8-5.7 19.7-7.7 29.7-4.6l39.7 12.6c8.8 2.8 18.6 .3 24.5-6.8c8.1-9.8 15.5-20.2 22.1-31.2l4.7-8.1c6.1-11 11.3-22.4 15.8-34.3c3.2-8.7 .5-18.4-6.4-24.6l-30.9-28.1c-7.7-7.1-11.4-17.5-10.9-27.9c.1-2.9 .2-5.8 .2-8.8s-.1-5.9-.2-8.8c-.5-10.5 3.1-20.9 10.9-27.9l30.9-28.1zM256 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"]]
  },
  Cg = {
    prefix: "fad",
    iconName: "tablet-screen",
    icon: [448, 512, ["tablet-android-alt"], "f3fc", ["M0 64C0 28.7 28.7 0 64 0H384c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM160 448c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16s-7.2-16-16-16H176c-8.8 0-16 7.2-16 16zM384 64H64V384H384V64z", "M64 64H384V384H64V64z"]]
  },
  bg = {
    prefix: "fad",
    iconName: "arrow-turn-up",
    icon: [384, 512, ["level-up"], "f148", ["M160 109.3L160 416c0 17.7-14.3 32-32 32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c53 0 96-43 96-96l0-306.7-32-32-32 32z", "M41.4 182.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L192 77.3 86.6 182.6c-12.5 12.5-32.8 12.5-45.3 0z"]]
  },
  Eg = {
    prefix: "fad",
    iconName: "clock",
    icon: [512, 512, [128339, "clock-four"], "f017", ["M256 0a256 256 0 1 1 0 512A256 256 0 1 1 256 0zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z", "M256 96c-13.3 0-24 10.7-24 24V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24z"]]
  },
  yg = {
    prefix: "fad",
    iconName: "mobile-screen",
    icon: [384, 512, ["mobile-android-alt"], "f3cf", ["M16 64C16 28.7 44.7 0 80 0H304c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H80c-35.3 0-64-28.7-64-64V64zM144 448c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H160c-8.8 0-16 7.2-16 16zM304 64H80V384H304V64z", "M80 64H304V384H80V64z"]]
  },
  Ig = {
    prefix: "fad",
    iconName: "sliders",
    icon: [512, 512, ["sliders-h"], "f1de", ["M0 416c0-17.7 14.3-32 32-32l54.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 448c-17.7 0-32-14.3-32-32zm233.3 32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L480 384c17.7 0 32 14.3 32 32s-14.3 32-32 32l-246.7 0zM0 256c0-17.7 14.3-32 32-32l246.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 288c-17.7 0-32-14.3-32-32zm425.3 32c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32l54.7 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-54.7 0zM32 64l86.7 0c-4.3 9.8-6.7 20.6-6.7 32s2.4 22.2 6.7 32L32 128C14.3 128 0 113.7 0 96S14.3 64 32 64zm233.3 64c4.3-9.8 6.7-20.6 6.7-32s-2.4-22.2-6.7-32L480 64c17.7 0 32 14.3 32 32s-14.3 32-32 32l-214.7 0z", "M128 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0A80 80 0 1 0 80 416a80 80 0 1 0 160 0zm80-160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0-112a80 80 0 1 0 0 160 80 80 0 1 0 0-160z"]]
  },
  Bg = {
    prefix: "fad",
    iconName: "ellipsis-vertical",
    icon: [128, 512, ["ellipsis-v"], "f142", ["M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256z", "M120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0zm0 320A56 56 0 1 0 8 416a56 56 0 1 0 112 0z"]]
  },
  xg = {
    prefix: "fad",
    iconName: "download",
    icon: [512, 512, [], "f019", ["M178.7 352H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H333.3l-54.6 54.6c-12.5 12.5-32.8 12.5-45.3 0L178.7 352zM408 432a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M256 0c17.7 0 32 14.3 32 32V306.7l73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L224 306.7V32c0-17.7 14.3-32 32-32z"]]
  },
  wg = {
    prefix: "fad",
    iconName: "oven",
    icon: [448, 512, [], "e01d", ["M448 160v32H0V160H448zM64 256H384V448H64V256zm32 48c0 8.8 7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H112c-8.8 0-16 7.2-16 16z", "M96 0H352c53 0 96 43 96 96v64H0V96C0 43 43 0 96 0zM80 104a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM200 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm72 24a24 24 0 1 0 0-48 24 24 0 1 0 0 48zM392 80a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zM64 256l0 192H384V256H64zM0 192H64 384h64v64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256 192z"]]
  },
  Qg = {
    prefix: "fad",
    iconName: "align-center",
    icon: [448, 512, [], "f037", ["M128 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H128z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
  },
  Hg = {
    prefix: "fad",
    iconName: "house",
    icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", ["M64 270.5L64.1 472c0 22.1 17.9 40 40 40H184c22.1 0 40-17.9 40-40V383.7c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V472c0 22.1 17.9 40 40 40h80.5c22.1 0 40-18 40-40.1l-.4-201.3L288 74.5 64 270.5z", "M266.9 7.9C279-2.6 297-2.6 309.1 7.9l256 224c13.3 11.6 14.6 31.9 3 45.2s-31.9 14.6-45.2 3L288 74.5 53.1 280.1c-13.3 11.6-33.5 10.3-45.2-3s-10.3-33.5 3-45.2l256-224z"]]
  },
  zg = {
    prefix: "fad",
    iconName: "rotate-right",
    icon: [512, 512, ["redo-alt", "rotate-forward"], "f2f9", ["M413.4 96.6l-45.3 45.3c-62.6-61.5-163.1-61.2-225.3 1c-62.5 62.5-62.5 163.8 0 226.3s163.8 62.5 226.3 0c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3c-87.5 87.5-229.3 87.5-316.8 0s-87.5-229.3 0-316.8c87.2-87.2 228.3-87.5 315.8-1z", "M344 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8z"]]
  },
  Mg = {
    prefix: "fad",
    iconName: "utensils",
    icon: [448, 512, [127860, 61685, "cutlery"], "f2e7", ["M288 176C288 32 400 0 416 0c17.7 0 32 14.3 32 32V352H352c-35.3 0-64-28.7-64-64V176zM49.7 .1C57.9 1 64 7.8 64 16V150.2c0 5.4 4.4 9.8 9.8 9.8c5.1 0 9.3-3.9 9.8-9L96.1 14.6C96.8 6.3 103.7 0 112 0s15.2 6.3 15.9 14.6L140.3 151c.5 5.1 4.7 9 9.8 9c5.4 0 9.8-4.4 9.8-9.8V16c0-8.2 6.1-15 14.3-15.9s15.6 4.5 17.4 12.4l30.3 136.3c1.4 6.3 2.1 12.7 2.1 19.1c0 48.6-39.4 88.1-88.1 88.1H88.1C39.4 256 0 216.6 0 167.9c0-6.4 .7-12.8 2.1-19.1L32.4 12.5C34.2 4.6 41.6-.8 49.7 .1zM112 167.4l-.3 .7 .3 0 .3 0-.3-.7z", "M144 480V256H80V480c0 17.7 14.3 32 32 32s32-14.3 32-32zm304 0V352H384V480c0 17.7 14.3 32 32 32s32-14.3 32-32z"]]
  },
  kg = {
    prefix: "fad",
    iconName: "block-quote",
    icon: [448, 512, [], "e0b5", ["M0 96C0 78.3 14.3 64 32 64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 128 0 113.7 0 96zM128 256c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32zm32 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H160c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M0 256c0-17.7 14.3-32 32-32s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256z"]]
  },
  Ng = {
    prefix: "fad",
    iconName: "upload",
    icon: [512, 512, [], "f093", ["M288 352v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H64c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H288zm120 80a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z", "M256 416c17.7 0 32-14.3 32-32V109.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L224 109.3V384c0 17.7 14.3 32 32 32z"]]
  },
  Sg = {
    prefix: "fad",
    iconName: "bolt",
    icon: [448, 512, [9889, "zap"], "f0e7", ["M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z", ""]]
  },
  Vg = {
    prefix: "fad",
    iconName: "toilet",
    icon: [448, 512, [128701], "f7d8", ["M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H424c13.3 0 24-10.7 24-24s-10.7-24-24-24H24zm88 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z", "M416 196.9c1.9 1.4 3.8 2.9 5.6 4.4C437.1 214.5 448 232.9 448 256c0 46.9-14.3 84.1-37 112.5c-14.2 17.7-31.1 31.3-48.5 41.8l19.8 59.5c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H96c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l19.8-59.5C68.1 399.8 51.2 386.2 37 368.5C14.3 340.1 0 302.9 0 256c0-23.1 10.9-41.5 26.4-54.6c1.8-1.5 3.7-3 5.6-4.4V48H416V196.9zM384 256l0-.1c0-1 0-2.5-3.8-5.8c-4.8-4.1-14-9-29.3-13.4C320.5 228 276.1 224 224 224s-96.5 4-126.9 12.8c-15.3 4.4-24.5 9.3-29.3 13.4C64 253.4 64 255 64 255.9l0 .1 0 .3c0 1 .3 2.6 3.8 5.6c4.8 4.1 14 9 29.3 13.4C127.5 284 171.9 288 224 288s96.5-4 126.9-12.8c15.3-4.4 24.5-9.3 29.3-13.4c3.5-3 3.8-4.6 3.8-5.6l0-.3zM112 80c-8.8 0-16 7.2-16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s-7.2-16-16-16H112z"]]
  },
  Lg = {
    prefix: "fad",
    iconName: "air-conditioner",
    icon: [576, 512, [], "f8f4", ["M80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16zm176 96V416c0 53-43 96-96 96s-96-43-96-96c0-35.6 19.4-66.6 48-83.1c15.3-8.9 34.9-3.6 43.7 11.7s3.6 34.9-11.7 43.7c-9.6 5.6-16 15.9-16 27.7c0 17.7 14.3 32 32 32s32-14.3 32-32V224h64zm64 0h64V384c0 17.7 14.3 32 32 32s32-14.3 32-32c0-11.8-6.4-22.2-16-27.7c-15.3-8.9-20.5-28.4-11.7-43.7s28.4-20.5 43.7-11.7c28.6 16.6 48 47.6 48 83.1c0 53-43 96-96 96s-96-43-96-96V224z", "M64 0C28.7 0 0 28.7 0 64v96c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM80 128H496c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
  },
  Pg = {
    prefix: "fad",
    iconName: "thumbs-down",
    icon: [512, 512, [128078, 61576], "f165", ["M351.1 422.6c5.2 26-11.7 51.3-37.7 56.5s-51.3-11.7-56.5-37.7L254.6 430c-6.6-33.2-24.8-63-51.2-84.2l-7.4-5.9c-22.8-18.2-36-45.8-36-75V240 192 153.7c0-32.1 16-62.1 42.7-79.9l38.5-25.7C257.1 37.6 275.6 32 294.5 32H392c26.5 0 48 21.5 48 48c0 3.6-.4 7-1.1 10.4C458.1 96.6 472 114.7 472 136c0 9.1-2.5 17.6-6.9 24.9c22.2 4.2 38.9 23.7 38.9 47.1c0 15.1-7 28.6-17.9 37.4c15.4 8 25.9 24.1 25.9 42.6c0 26.5-21.5 48-48 48H320c13.7 23.1 23.5 48.5 28.8 75.2l2.3 11.4z", "M0 352c0 17.7 14.3 32 32 32H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352z"]]
  },
  Og = {
    prefix: "fad",
    iconName: "arrow-right-long",
    icon: [512, 512, ["long-arrow-right"], "f178", ["M402.7 224L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0 32-32-32-32z", "M502.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L434.7 256 329.4 150.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l128 128z"]]
  },
  Tg = {
    prefix: "fad",
    iconName: "ellipsis",
    icon: [448, 512, ["ellipsis-h"], "f141", ["M168 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0z", "M64 312a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm320 0a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"]]
  },
  Dg = {
    prefix: "fad",
    iconName: "grid-2-plus",
    icon: [512, 512, [], "e197", ["M32 80c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V80zm0 256c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V336zM336 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H336c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48z", "M408 296c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H296c-13.3 0-24 10.7-24 24s10.7 24 24 24h64v64c0 13.3 10.7 24 24 24s24-10.7 24-24V408h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H408V296z"]]
  },
  Rg = {
    prefix: "fad",
    iconName: "bug",
    icon: [512, 512, [], "f188", ["M256 0c-53 0-96 43-96 96v3.6c0 15.7 12.7 28.4 28.4 28.4H323.6c15.7 0 28.4-12.7 28.4-28.4V96c0-53-43-96-96-96zm0 480c5.4 0 10.7-.3 16-.8V240c0-8.8-7.2-16-16-16s-16 7.2-16 16V479.2c5.3 .5 10.6 .8 16 .8z", "M86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l64 64c.7 .7 1.4 1.3 2.1 1.9c-6.2 12-10.1 25.3-11.1 39.5H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H96c0 24.6 5.5 47.8 15.4 68.6c-2.2 1.3-4.2 2.9-6 4.8l-64 64c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l63.1-63.1c24.5 21.8 55.8 36.2 90.3 39.6V240c0-8.8 7.2-16 16-16s16 7.2 16 16V479.2c34.5-3.4 65.8-17.8 90.3-39.6l63.1 63.1c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-64-64c-1.9-1.9-3.9-3.4-6-4.8c9.9-20.8 15.4-44.1 15.4-68.6h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H415.7c-1.1-14.1-5-27.5-11.1-39.5c.7-.6 1.4-1.2 2.1-1.9l64-64c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-64 64c-.7 .7-1.3 1.4-1.9 2.1C345.2 164.1 329.1 160 312 160H200c-17.1 0-33.2 4.1-47.5 11.4c-.6-.7-1.2-1.4-1.9-2.1l-64-64z"]]
  },
  Gg = {
    prefix: "fad",
    iconName: "credit-card",
    icon: [576, 512, [128179, 62083, "credit-card-alt"], "f09d", ["M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z", "M576 224H0V128H576v96z"]]
  },
  Fg = {
    prefix: "fad",
    iconName: "message-dots",
    icon: [512, 512, ["comment-alt-dots", "messaging"], "f4a3", ["M0 64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L185.6 508.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V416H64c-35.3 0-64-28.7-64-64V64zM128 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128 0a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm160-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M96 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm160-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
  },
  jg = {
    prefix: "fad",
    iconName: "bed",
    icon: [640, 512, [128716], "f236", ["M176 128a80 80 0 1 1 0 160 80 80 0 1 1 0-160zm112 32c0-17.7 14.3-32 32-32H544c53 0 96 43 96 96v64 32H608 320 288V288 160z", "M32 32c17.7 0 32 14.3 32 32V320H608h32v32 96c0 17.7-14.3 32-32 32s-32-14.3-32-32V416H64v32c0 17.7-14.3 32-32 32s-32-14.3-32-32V64C0 46.3 14.3 32 32 32z"]]
  },
  Jg = {
    prefix: "fad",
    iconName: "bell",
    icon: [448, 512, [128276, 61602], "f0f3", ["M224 0c-17.7 0-32 14.3-32 32V51.2C119 66 64 130.6 64 208v18.8c0 47-17.3 92.4-48.5 127.6l-7.4 8.3c-8.4 9.4-10.4 22.9-5.3 34.4S19.4 416 32 416H416c12.6 0 24-7.4 29.2-18.9s3.1-25-5.3-34.4l-7.4-8.3C401.3 319.2 384 273.9 384 226.8V208c0-77.4-55-142-128-156.8V32c0-17.7-14.3-32-32-32z", "M288 448c0 17-6.7 33.3-18.7 45.3s-28.3 18.7-45.3 18.7s-33.3-6.7-45.3-18.7s-18.7-28.3-18.7-45.3l64 0h64z"]]
  },
  Zg = {
    prefix: "fad",
    iconName: "location-dot",
    icon: [384, 512, ["map-marker-alt"], "f3c5", ["M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 112a80 80 0 1 1 0 160 80 80 0 1 1 0-160z", "M192 144a48 48 0 1 0 0 96 48 48 0 1 0 0-96z"]]
  },
  Wg = {
    prefix: "fad",
    iconName: "file",
    icon: [384, 512, [128196, 128459, 61462], "f15b", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64z", "M224 0L384 160H256c-17.7 0-32-14.3-32-32V0z"]]
  },
  Xg = {
    prefix: "fad",
    iconName: "person-swimming",
    icon: [576, 512, [127946, "swimmer"], "f5c4", ["M269.5 325.9c11.1-7.9 25.9-7.9 37 0C329 341.4 356.5 352 384 352c26.9 0 55.4-10.8 77.4-26.1l0 0c11.9-8.5 28.1-7.8 39.2 1.7c14.4 11.9 32.5 21 50.6 25.2c17.2 4 27.9 21.2 23.9 38.4s-21.2 27.9-38.4 23.9c-24.5-5.7-44.9-16.5-58.2-25C449.5 405.7 417 416 384 416c-31.9 0-60.6-9.9-80.4-18.9c-5.8-2.7-11.1-5.3-15.6-7.7c-4.5 2.4-9.7 5.1-15.6 7.7c-19.8 9-48.5 18.9-80.4 18.9c-33 0-65.5-10.3-94.5-25.8c-13.4 8.4-33.7 19.3-58.2 25c-17.2 4-34.4-6.7-38.4-23.9s6.7-34.4 23.9-38.4c18.1-4.2 36.2-13.3 50.6-25.2c11.1-9.4 27.3-10.1 39.2-1.7l0 0C136.7 341.2 165.1 352 192 352c27.5 0 55-10.6 77.5-26.1z", "M447.9 297.1L309.5 178.4C331.7 166.6 357.1 160 384 160h64c17.7 0 32-14.3 32-32s-14.3-32-32-32H384c-121.8 0-220.9 97.2-223.9 218.2c10.8 4 21.8 6.2 31.9 6.2c21.1 0 42-8.5 59.2-20.3c22.1-15.5 51.6-15.5 73.7 0c18.4 12.7 39.6 20.3 59.2 20.3c19 0 41.2-7.9 59.2-20.3c1.6-1.1 3.1-2.1 4.8-3zM96 224A64 64 0 1 0 96 96a64 64 0 1 0 0 128z"]]
  },
  Ug = {
    prefix: "fad",
    iconName: "inbox",
    icon: [512, 512, [], "f01c", ["M391 96H121L73 288h51.2c12.1 0 23.2 6.8 28.6 17.7l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7H316.2c12.1 0 23.2-6.8 28.6-17.7l14.3-28.6c5.4-10.8 16.5-17.7 28.6-17.7H439L391 96z", "M121 32C91.6 32 66 52 58.9 80.5L1.9 308.4C.6 313.5 0 318.7 0 323.9V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V323.9c0-5.2-.6-10.4-1.9-15.5l-57-227.9C446 52 420.4 32 391 32H121zm0 64H391l48 192H387.8c-12.1 0-23.2 6.8-28.6 17.7l-14.3 28.6c-5.4 10.8-16.5 17.7-28.6 17.7H195.8c-12.1 0-23.2-6.8-28.6-17.7l-14.3-28.6c-5.4-10.8-16.5-17.7-28.6-17.7H73L121 96z"]]
  },
  Kg = {
    prefix: "fad",
    iconName: "envelope-open-text",
    icon: [512, 512, [], "f658", ["M96 32C78.3 32 64 46.3 64 64V249.7L236.7 377.6c5.6 4.1 12.4 6.4 19.3 6.4s13.7-2.2 19.3-6.4L448 249.7V64c0-17.7-14.3-32-32-32H96zm80 96H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 64H336c8.8 0 16 7.2 16 16s-7.2 16-16 16H176c-8.8 0-16-7.2-16-16s7.2-16 16-16z", "M511.8 202.5c-1.6-18.1-10.9-34.9-25.7-45.8L448 128.5v79.6 41.6l63.8-47.2zM512 448V242.1L294.4 403.3C283.3 411.6 269.8 416 256 416s-27.3-4.4-38.4-12.7L0 242.1V448v0c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64v0zM64 249.7V208.1l0-79.6L25.9 156.7C11.1 167.6 1.8 184.4 .2 202.5L64 249.7zM289.5 11.1C279.8 3.9 268.1 0 256 0s-23.8 3.9-33.5 11L194.2 32H317.8L289.5 11.1zM176 128c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176zm0 64c-8.8 0-16 7.2-16 16s7.2 16 16 16H336c8.8 0 16-7.2 16-16s-7.2-16-16-16H176z"]]
  },
  Yg = {
    prefix: "fad",
    iconName: "paragraph",
    icon: [448, 512, [182], "f1dd", ["M320 448l0-352 64 0V448c0 17.7-14.3 32-32 32s-32-14.3-32-32z", "M192 32h64H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H288V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V352H192c-88.4 0-160-71.6-160-160s71.6-160 160-160z"]]
  },
  qg = {
    prefix: "fad",
    iconName: "grill-hot",
    icon: [448, 512, [], "e5a5", ["M144 24c0-13.3-10.7-24-24-24S96 10.7 96 24v2.6C96 48 106.7 68 124.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C192 80 181.3 60 163.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24zm112 0c0-13.3-10.7-24-24-24s-24 10.7-24 24v2.6C208 48 218.7 68 236.5 79.8l12.4 8.3c4.5 3 7.1 8 7.1 13.3V104c0 13.3 10.7 24 24 24s24-10.7 24-24v-2.6C304 80 293.3 60 275.5 48.2l-12.4-8.3c-4.5-3-7.1-8-7.1-13.3V24z", "M0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32c0 78.1-46.6 145.3-113.6 175.3l47.7 111.2c5.2 12.2-.4 26.3-12.6 31.5s-26.3-.4-31.5-12.6L327 472H155.3c-9.5 23.5-32.5 40-59.3 40c-35.3 0-64-28.7-64-64s28.7-64 64-64c3.4 0 6.8 .3 10.1 .8l7.5-17.5C46.6 337.3 0 270.1 0 192zM155.3 424H306.5l-18.3-42.7C277.7 383.1 267 384 256 384H192c-11 0-21.7-.9-32.2-2.7L147.5 410c3.2 4.3 5.8 9 7.8 14zM96 472a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"]]
  },
  _g = {
    prefix: "fad",
    iconName: "link",
    icon: [640, 512, [128279, "chain"], "f0c1", ["M579.8 63.2c56.5 56.5 56.5 148 0 204.5L467.5 380c-56.5 56.5-148 56.5-204.5 0c-50-50-56.5-128.8-15.4-186.3l1.1-1.6c10.3-14.4 30.3-17.7 44.6-7.4s17.7 30.3 7.4 44.6l-1.1 1.6c-22.9 32.1-19.3 76 8.6 103.8c31.5 31.5 82.5 31.5 114 0L534.5 222.5c31.5-31.5 31.5-82.5 0-114C506.7 80.6 462.7 77 430.7 99.9l-1.6 1.1c-14.4 10.3-34.4 6.9-44.6-7.4s-6.9-34.4 7.4-44.6l1.6-1.1C451 6.7 529.8 13.3 579.8 63.2z", "M60.2 448.8c-56.5-56.5-56.5-148 0-204.5L172.5 132c56.5-56.5 148-56.5 204.5 0c50 50 56.5 128.8 15.4 186.3l-1.1 1.6c-10.3 14.4-30.3 17.7-44.6 7.4s-17.7-30.3-7.4-44.6l1.1-1.6c22.9-32.1 19.3-76-8.6-103.9c-31.5-31.5-82.5-31.5-114 0L105.5 289.5C74 321 74 372 105.5 403.5c27.9 27.9 71.8 31.5 103.8 8.6l1.6-1.1c14.4-10.3 34.4-6.9 44.6 7.4s6.9 34.4-7.4 44.6l-1.6 1.1C189 505.3 110.2 498.7 60.2 448.8z"]]
  },
  $g = {
    prefix: "fad",
    iconName: "magnifying-glass",
    icon: [512, 512, [128269, "search"], "f002", ["M208 64a144 144 0 1 1 0 288 144 144 0 1 1 0-288zm0 352A208 208 0 1 0 208 0a208 208 0 1 0 0 416z", "M330.7 376L457.4 502.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L376 330.7C363.3 348 348 363.3 330.7 376z"]]
  },
  ev = {
    prefix: "fad",
    iconName: "receipt",
    icon: [384, 512, [129534], "f543", ["M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.3-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6s14 12.4 14 21.8V488c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6L304 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L192 471.6l-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488V24C0 14.6 5.5 6.1 14 2.2zM96 144c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96zM80 352c0 8.8 7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96c-8.8 0-16 7.2-16 16zM96 240c-8.8 0-16 7.2-16 16s7.2 16 16 16H288c8.8 0 16-7.2 16-16s-7.2-16-16-16H96z", "M80 160c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zm0 192c0-8.8 7.2-16 16-16H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16zM96 240H288c8.8 0 16 7.2 16 16s-7.2 16-16 16H96c-8.8 0-16-7.2-16-16s7.2-16 16-16z"]]
  },
  tv = {
    prefix: "fad",
    iconName: "chevron-down",
    icon: [512, 512, [], "f078", ["M278.6 406.6c-12.5 12.5-32.8 12.5-45.3 0l-192-192c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L256 338.7 425.4 169.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-192 192z", ""]]
  },
  nv = {
    prefix: "fad",
    iconName: "tv",
    icon: [640, 512, [63717, "television", "tv-alt"], "f26c", ["M64 64V352H576V64H64zM0 64C0 28.7 28.7 0 64 0H576c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64zM128 448H512c17.7 0 32 14.3 32 32s-14.3 32-32 32H128c-17.7 0-32-14.3-32-32s14.3-32 32-32z", "M64 64H576V352H64V64z"]]
  },
  rv = {
    prefix: "fad",
    iconName: "list-check",
    icon: [512, 512, ["tasks"], "f0ae", ["M160 416c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192c-17.7 0-32 14.3-32 32zm64-160c0 17.7 14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32zm32-128H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H256c-17.7 0-32 14.3-32 32s14.3 32 32 32z", "M153.8 72.1c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 101.1 41 79C31.6 69.7 16.4 69.7 7 79s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zm0 160c8.9-9.9 8.1-25-1.8-33.9s-25-8.1-33.9 1.8L63.1 261.1 41 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l40 40c4.7 4.7 11 7.2 17.6 7s12.8-3 17.2-7.9l72-80zM48 464a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"]]
  },
  ov = {
    prefix: "fad",
    iconName: "circle-user",
    icon: [512, 512, [62142, "user-circle"], "f2bd", ["M399 384.2C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z", "M256 272a72 72 0 1 0 0-144 72 72 0 1 0 0 144zm0 176c56.8 0 107.8-24.7 143-63.8C376.9 345.8 335.4 320 288 320H224c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8z"]]
  },
  iv = {
    prefix: "fad",
    iconName: "bars-filter",
    icon: [448, 512, [], "e0ad", ["M64 256c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H96c-17.7 0-32-14.3-32-32z", "M448 96c0-17.7-14.3-32-32-32H32C14.3 64 0 78.3 0 96s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM288 416c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32s14.3 32 32 32h64c17.7 0 32-14.3 32-32z"]]
  },
  av = {
    prefix: "fad",
    iconName: "plus",
    icon: [448, 512, [10133, 61543, "add"], "2b", ["M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32V224H48c-17.7 0-32 14.3-32 32s14.3 32 32 32H192V432c0 17.7 14.3 32 32 32s32-14.3 32-32V288H400c17.7 0 32-14.3 32-32s-14.3-32-32-32H256V80z", ""]]
  },
  cv = {
    prefix: "fad",
    iconName: "xmark",
    icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", ["M297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6z", ""]]
  },
  sv = {
    prefix: "fad",
    iconName: "h2",
    icon: [640, 512, [], "f314", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M491.5 128c-15.3 0-30.1 5.5-41.7 15.4l-29 24.9c-13.4 11.5-33.6 9.9-45.1-3.5s-9.9-33.6 3.5-45.1l29-24.9C431.4 74.9 461 64 491.5 64H496c70.7 0 128 57.3 128 128v5.8c0 35.9-15.1 70.1-41.5 94.4L482.3 384H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H400c-13.2 0-25-8.1-29.8-20.4s-1.5-26.3 8.2-35.2L539.2 244.9c13.2-12.1 20.8-29.2 20.8-47.2V192c0-35.3-28.7-64-64-64h-4.5z"]]
  },
  lv = {
    prefix: "fad",
    iconName: "map",
    icon: [576, 512, [128506, 62072], "f279", ["M192.1 416L384 480V96L192 32l.1 384z", "M0 114.5V464c0 11.3 11.5 19 22 14.8L192 416l-.1-384L10.1 99.6C4 102 0 107.9 0 114.5zM554 33.2L384 96V480l181.9-67.6c6.1-2.4 10.1-8.3 10.1-14.9V48c0-11.3-11.4-19.1-22-14.9z"]]
  },
  uv = {
    prefix: "fad",
    iconName: "chart-scatter",
    icon: [512, 512, [], "f7ee", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M384 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM160 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 96a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm128 32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-224 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
  },
  dv = {
    prefix: "fad",
    iconName: "chevron-left",
    icon: [320, 512, [9001], "f053", ["M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z", ""]]
  },
  fv = {
    prefix: "fad",
    iconName: "chevron-right",
    icon: [320, 512, [9002], "f054", ["M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z", ""]]
  },
  pv = {
    prefix: "fad",
    iconName: "percent",
    icon: [384, 512, [62101, 62785, "percentage"], "25", ["M374.6 73.4c12.5 12.5 12.5 32.8 0 45.3l-320 320c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l320-320c12.5-12.5 32.8-12.5 45.3 0z", "M64 192A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 448a64 64 0 1 0 0-128 64 64 0 1 0 0 128z"]]
  },
  mv = {
    prefix: "fad",
    iconName: "rotate",
    icon: [512, 512, [128260, "sync-alt"], "f2f1", ["M16 319.6l0-7.6c0-13.3 10.7-24 24-24h7.6c.2 0 .5 0 .7 0H168c9.7 0 18.5 5.8 22.2 14.8s1.7 19.3-5.2 26.2l-41.1 41.1c62.6 61.5 163.1 61.2 225.3-1c17.5-17.5 30.1-38 37.8-59.8c5.9-16.7 24.2-25.4 40.8-19.5s25.4 24.2 19.5 40.8c-10.8 30.6-28.4 59.3-52.9 83.8c-87.2 87.2-228.3 87.5-315.8 1L57 457c-6.9 6.9-17.2 8.9-26.2 5.2S16 449.7 16 440l0-119.6c0-.2 0-.5 0-.7z", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5z"]]
  },
  hv = {
    prefix: "fad",
    iconName: "spinner",
    icon: [512, 512, [], "f110", ["M369.1 75A48 48 0 1 1 437 142.9 48 48 0 1 1 369.1 75zM416 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM208 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zm294.2 0A48 48 0 1 1 437 437a48 48 0 1 1 -67.9-67.9z", "M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM96 256A48 48 0 1 0 0 256a48 48 0 1 0 96 0zM75 142.9A48 48 0 1 0 142.9 75 48 48 0 1 0 75 142.9z"]]
  },
  Av = {
    prefix: "fad",
    iconName: "angles-left",
    icon: [512, 512, [171, "angle-double-left"], "f100", ["M233.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]]
  },
  gv = {
    prefix: "fad",
    iconName: "fireplace",
    icon: [640, 512, [], "f79a", ["M32 0C14.3 0 0 14.3 0 32V64C0 81.7 14.3 96 32 96H608c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H32zM300.6 258.7c-2-1.8-4.6-2.7-7.1-2.7c-2.6 0-5.2 .9-7.3 2.7c-24.2 21.6-44.7 46.1-59.2 69.7c-14.3 23.2-23.6 48.2-23.6 67.4c0 63.8 51.1 116.3 116.4 116.3c64.5 0 116.4-52.4 116.4-116.3c0-14.7-7-37-17.6-57.4c-10.7-20.7-25.9-42.5-43.9-59c-4.1-3.7-10.4-3.8-14.5 0c-7 6.4-13.5 14.3-19.2 21.5c-12.6-15.1-26-29-40.4-42zm55.6 195.8c-10.9 7.3-22.5 10.9-35.6 10.9c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8z", "M32 96H608V480c0 17.7-14.3 32-32 32H480V352c0-88.4-71.6-160-160-160s-160 71.6-160 160V512H64c-17.7 0-32-14.3-32-32V96zM320.6 465.5c-32.7 0-58.9-21.1-58.9-56.7c0-17.5 10.9-32.7 32.7-59.6c2.9 3.6 45.1 57.5 45.1 57.5L365.7 376c2.2 2.9 3.6 5.8 5.1 8.7c13.1 24 7.3 54.5-14.5 69.8c-10.9 7.3-22.5 10.9-35.6 10.9z"]]
  },
  vv = {
    prefix: "fad",
    iconName: "clock-rotate-left",
    icon: [512, 512, ["history"], "f1da", ["M120.2 120.2C155 85.5 203 64 256 64c106 0 192 86 192 192s-86 192-192 192c-40.8 0-78.6-12.7-109.7-34.4c-14.5-10.1-34.4-6.6-44.6 7.9s-6.6 34.4 7.9 44.6C151.2 495 201.7 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C185.3 0 121.3 28.7 75 75L41 41C25.9 25.9 0 36.6 0 57.9V168c0 13.3 10.7 24 24 24H134.1c21.4 0 32.1-25.9 17-41l-30.8-30.8z", "M256 128c13.3 0 24 10.7 24 24v94.1l65 65c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-72-72c-4.5-4.5-7-10.6-7-17V152c0-13.3 10.7-24 24-24z"]]
  },
  Cv = {
    prefix: "fad",
    iconName: "hashtag",
    icon: [448, 512, [62098], "23", ["M207.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L132.9 128h64.9l9.8-58.7zM187.1 192H122.2L80.4 442.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L187.1 192zM367.6 69.3c2.9-17.4-8.9-33.9-26.3-36.8s-33.9 8.9-36.8 26.3L260.9 320h64.9L367.6 69.3zM315.1 384H250.2l-9.8 58.7c-2.9 17.4 8.9 33.9 26.3 36.8s33.9-8.9 36.8-26.3L315.1 384z", "M292.9 128H64c-17.7 0-32 14.3-32 32s14.3 32 32 32H282.2l10.7-64zm54.2 64H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H357.8l-10.7 64zm-192 192H384c17.7 0 32-14.3 32-32s-14.3-32-32-32H165.8l-10.7 64zm-54.2-64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H90.2l10.7-64z"]]
  },
  bv = {
    prefix: "fad",
    iconName: "chart-column",
    icon: [512, 512, [], "e0e3", ["M32 32c17.7 0 32 14.3 32 32V400c0 8.8 7.2 16 16 16H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H80c-44.2 0-80-35.8-80-80V64C0 46.3 14.3 32 32 32z", "M480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM288 160c0-17.7-14.3-32-32-32s-32 14.3-32 32V320c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V256zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32V224c0-17.7-14.3-32-32-32z"]]
  },
  Ev = {
    prefix: "fad",
    iconName: "up-down",
    icon: [256, 512, [8597, 11021, "arrows-alt-v"], "f338", ["M128 512c6.7 0 13-2.8 17.6-7.7l104-112c6.5-7 8.2-17.2 4.4-25.9s-12.5-14.4-22-14.4H176V256H80v96H24c-9.5 0-18.2 5.7-22 14.4s-2.1 18.9 4.4 25.9l104 112c4.5 4.9 10.9 7.7 17.6 7.7z", "M128 0c6.7 0 13 2.8 17.6 7.7l104 112c6.5 7 8.2 17.2 4.4 25.9s-12.5 14.4-22 14.4H176v96H80V160H24c-9.5 0-18.2-5.7-22-14.4s-2.1-18.9 4.4-25.9l104-112C115 2.8 121.3 0 128 0z"]]
  },
  yv = {
    prefix: "fad",
    iconName: "circle-plus",
    icon: [512, 512, ["plus-circle"], "f055", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344V280H168c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V168c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H280v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z", "M232 280v64c0 13.3 10.7 24 24 24s24-10.7 24-24V280h64c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V168c0-13.3-10.7-24-24-24s-24 10.7-24 24v64H168c-13.3 0-24 10.7-24 24s10.7 24 24 24h64z"]]
  },
  Iv = {
    prefix: "fad",
    iconName: "shower",
    icon: [512, 512, [128703], "f2cc", ["M384 224a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-32 32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm32-32a32 32 0 1 0 0-64 32 32 0 1 0 0 64z", "M99.9 96C80.1 96 64 112.1 64 131.9V448c0 17.7-14.3 32-32 32s-32-14.3-32-32V131.9C0 76.7 44.7 32 99.9 32c26.5 0 51.9 10.5 70.6 29.3l16.2 16.2c38.9-21 87.5-17.4 123 10.9L311 87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L185 281c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l1.3-1.3c-28.3-35.5-31.9-84.2-10.9-123l-16.2-16.2C118.5 99.8 109.4 96 99.9 96z"]]
  },
  Bv = {
    prefix: "fad",
    iconName: "desktop",
    icon: [576, 512, [128421, 61704, "desktop-alt"], "f390", ["M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM512 64V288H64V64H512z", "M512 64H64V288H512V64zM416 448H346.7L336 416H240l-10.7 32H160c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32z"]]
  },
  xv = {
    prefix: "fad",
    iconName: "h5",
    icon: [640, 512, [], "e412", ["M32 64c17.7 0 32 14.3 32 32V224H256V96c0-17.7 14.3-32 32-32s32 14.3 32 32V256 416c0 17.7-14.3 32-32 32s-32-14.3-32-32V288H64V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V256 96C0 78.3 14.3 64 32 64z", "M400.7 89.4C403.8 74.6 416.9 64 432 64H576c17.7 0 32 14.3 32 32s-14.3 32-32 32H458l-18.5 88H524c64.1 0 116 51.9 116 116s-51.9 116-116 116H456.4c-37.9 0-71.5-24.2-83.5-60.2l-3.2-9.7c-5.6-16.8 3.5-34.9 20.2-40.5s34.9 3.5 40.5 20.2l3.2 9.7c3.3 9.8 12.4 16.4 22.8 16.4H524c28.7 0 52-23.3 52-52s-23.3-52-52-52H400c-9.6 0-18.8-4.3-24.8-11.8s-8.5-17.3-6.5-26.8l32-152z"]]
  },
  wv = {
    prefix: "fad",
    iconName: "check",
    icon: [448, 512, [10003, 10004], "f00c", ["", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]]
  },
  Qv = {
    prefix: "fad",
    iconName: "triangle-exclamation",
    icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", ["M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z", "M280 184c0-13.3-10.7-24-24-24s-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184zM256 416a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]]
  },
  Hv = {
    prefix: "fad",
    iconName: "share",
    icon: [512, 512, ["arrow-turn-right", "mail-forward"], "f064", ["M288 288V128H176C78.8 128 0 206.8 0 304C0 417.3 81.5 467.9 100.2 478.1c2.5 1.4 5.3 1.9 8.1 1.9c10.9 0 19.7-8.9 19.7-19.7c0-7.5-4.3-14.4-9.8-19.5C108.8 431.9 96 414.4 96 384c0-53 43-96 96-96h96z", "M288 64c0-12.6 7.4-24.1 19-29.2s25-3 34.4 5.4l160 144c6.7 6.1 10.6 14.7 10.6 23.8s-3.8 17.7-10.6 23.8l-160 144c-9.4 8.5-22.9 10.6-34.4 5.4s-19-16.6-19-29.2V64z"]]
  },
  zv = {
    prefix: "fad",
    iconName: "face-thinking",
    icon: [512, 512, [], "e39b", ["M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256c0 45 11.6 87.3 32 124V352c0-30.9 25.1-56 56-56s56 25.1 56 56v3l92.2-33.5-82.4-34.7c-8.1-3.4-12-12.8-8.5-21s12.8-12 21-8.5l122.5 51.6c22.7 9.6 37.9 31.2 39.2 55.6c1.5 24.2-12.9 47.4-36.8 56.1l-35.8 13-21 57.7c-2.5 6.8-5.8 13.1-9.8 18.8c10.3 1.3 20.8 1.9 31.4 1.9zM176.4 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 48a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-88-63.2c-20.5-17.6-49.9-20.4-73.4-7l-7.1 4c-7.7 4.4-17.4 1.7-21.8-6s-1.7-17.4 6-21.8l7.1-4c35.2-20.1 79.3-15.9 110.1 10.5l13.2 11.3c6.7 5.8 7.5 15.9 1.7 22.6s-15.9 7.5-22.6 1.7l-13.2-11.3z", "M143 121.9c23.5-13.4 52.9-10.6 73.4 7l13.2 11.3c6.7 5.8 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-13.2-11.3C206.4 78.1 162.3 74 127.1 94.1l-7.1 4c-7.7 4.4-10.3 14.2-6 21.8s14.2 10.3 21.8 6l7.1-4zM176.4 208a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM112 352c0-13.3-10.7-24-24-24s-24 10.7-24 24V464c0 26.5 21.5 48 48 48h47.2c20.2 0 38.2-12.6 45.1-31.6l26.1-71.7 49.8-18.1c12.5-4.5 18.9-18.3 14.4-30.8s-18.3-18.9-30.8-14.4L112 400.6V352zM368.4 192a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]]
  },
  Mv = {
    prefix: "fad",
    iconName: "paper-plane",
    icon: [512, 512, [61913], "f1d8", ["M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L224 402.7V389.4L380.7 185.8c5.2-6.7 4.2-16.4-2.3-21.9s-16.1-5.1-22 1.1L178.8 350.6l-14.1 14.1c-3 3-4.7 7.1-4.7 11.3l-28.3-11.8-112-46.7C8.4 312.8 .8 302.2 .1 290s5.5-23.7 16.1-29.8l448-256c10.7-6.1 23.9-5.5 34 1.4z", "M380.7 185.8c5.1-6.7 4.2-16.2-2.1-21.8s-15.9-5.3-21.9 .7l-179 179-13 13c-3 3-4.7 7.1-4.7 11.3v8 56 48c0 13.2 8.1 25 20.3 29.8s26.2 1.6 35.2-8.1L284 427.7l-60-25V389.4L380.7 185.8z"]]
  },
  kv = {
    prefix: "fad",
    iconName: "align-right",
    icon: [448, 512, [], "f038", ["M192 352c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H192zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H192z", "M32 480c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32zm0-256c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32z"]]
  },
  Nv = {
    prefix: "fad",
    iconName: "circle-xmark",
    icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", ["M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z", "M209 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47z"]]
  },
  Sv = {
    prefix: "fad",
    iconName: "thumbs-up",
    icon: [512, 512, [128077, 61575], "f164", ["M351.1 89.4c5.2-26-11.7-51.3-37.7-56.5s-51.3 11.7-56.5 37.7L254.6 82c-6.6 33.2-24.8 63-51.2 84.2l-7.4 5.9c-22.8 18.2-36 45.8-36 75V272v48 38.3c0 32.1 16 62.1 42.7 79.9l38.5 25.7c15.8 10.5 34.3 16.1 53.3 16.1H392c26.5 0 48-21.5 48-48c0-3.6-.4-7-1.1-10.4c19.2-6.3 33.1-24.3 33.1-45.6c0-9.1-2.5-17.6-6.9-24.9c22.2-4.2 38.9-23.7 38.9-47.1c0-15.1-7-28.6-17.9-37.4c15.4-8 25.9-24.1 25.9-42.6c0-26.5-21.5-48-48-48H320c13.7-23.1 23.5-48.5 28.8-75.2l2.3-11.4z", "M0 224c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224z"]]
  },
  Vv = {
    prefix: "fad",
    iconName: "file-invoice",
    icon: [384, 512, [], "f570", ["M64 0C28.7 0 0 28.7 0 64V448c0 35.3 28.7 64 64 64H320c35.3 0 64-28.7 64-64V160H256c-17.7 0-32-14.3-32-32V0H64zm0 80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H80c-8.8 0-16-7.2-16-16zm0 112c0-17.7 14.3-32 32-32H288c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V256zM224 432c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z", "M384 160L224 0V128c0 17.7 14.3 32 32 32H384zM96 224c-17.7 0-32 14.3-32 32v64c0 17.7 14.3 32 32 32H288c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H96zm0 32H288v64H96V256zM240 416c-8.8 0-16 7.2-16 16s7.2 16 16 16h64c8.8 0 16-7.2 16-16s-7.2-16-16-16H240z"]]
  },
  Lv = {
    prefix: "fad",
    iconName: "print",
    icon: [512, 512, [128424, 128438, 9113], "f02f", ["M128 0C92.7 0 64 28.7 64 64V192h64V64H354.7L384 93.3V192h64V93.3c0-17-6.7-33.3-18.7-45.3L400 18.7C388 6.7 371.7 0 354.7 0H128zM64 384v64c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V384H384v64H128V384H64z", "M0 256c0-35.3 28.7-64 64-64H448c35.3 0 64 28.7 64 64v96c0 17.7-14.3 32-32 32H384V352H128v32H32c-17.7 0-32-14.3-32-32V256zm456 16a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"]]
  },
  Pv = {
    prefix: "fad",
    iconName: "building-columns",
    icon: [512, 512, ["bank", "institution", "museum", "university"], "f19c", ["M128 192H64V420.3c-.6 .3-1.2 .7-1.7 1.1l-48 32c-11.7 7.8-17 22.4-12.9 35.9S17.9 512 32 512H480c14.1 0 26.5-9.2 30.6-22.7s-1.1-28.1-12.9-35.9l-48-32c-.6-.4-1.2-.7-1.8-1.1V192H384V416H344V192H280V416H232V192H168V416H128V192z", "M268.6 2.6c-8-3.4-17.2-3.4-25.2 0l-224 96c-14 6-21.8 21-18.7 35.8S16.8 160 32 160v8c0 13.3 10.7 24 24 24H456c13.3 0 24-10.7 24-24l0-8c15.2 0 28.3-10.7 31.3-25.6s-4.8-29.9-18.7-35.8l-224-96zM256 64a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"]]
  },
  Ov = {
    prefix: "fad",
    iconName: "horizontal-rule",
    icon: [640, 512, [8213], "f86c", ["M0 256c0-17.7 14.3-32 32-32H608c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32z", ""]]
  },
  Tv = {
    prefix: "fad",
    iconName: "turn-up",
    icon: [384, 512, [10548, "level-up-alt"], "f3bf", ["M144 192h96V400c0 61.9-50.1 112-112 112H32c-17.7 0-32-14.3-32-32V448c0-17.7 14.3-32 32-32h96c8.8 0 16-7.2 16-16V192z", "M345.4 151.5c6.6 7 8.4 17.2 4.6 26s-12.5 14.5-22 14.5L56 192c-9.6 0-18.2-5.7-22-14.5s-2-19 4.6-26l136-144C179.1 2.7 185.4 0 192 0s12.9 2.7 17.4 7.5l136 144z"]]
  },
  Dv = {
    prefix: "fab",
    iconName: "cc-visa",
    icon: [576, 512, [], "f1f0", "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"]
  },
  Rv = {
    prefix: "fab",
    iconName: "cc-mastercard",
    icon: [576, 512, [], "f1f1", "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"]
  },
  Gv = {
    prefix: "fab",
    iconName: "cc-discover",
    icon: [576, 512, [], "f1f2", "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"]
  },
  Fv = {
    prefix: "fab",
    iconName: "stripe",
    icon: [640, 512, [], "f429", "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"]
  },
  jv = {
    prefix: "fab",
    iconName: "instagram",
    icon: [448, 512, [], "f16d", "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"]
  },
  Jv = {
    prefix: "fab",
    iconName: "facebook",
    icon: [512, 512, [62e3], "f09a", "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"]
  },
  Zv = {
    prefix: "fab",
    iconName: "snapchat",
    icon: [512, 512, [62124, "snapchat-ghost"], "f2ab", "M496.926,366.6c-3.373-9.176-9.8-14.086-17.112-18.153-1.376-.806-2.641-1.451-3.72-1.947-2.182-1.128-4.414-2.22-6.634-3.373-22.8-12.09-40.609-27.341-52.959-45.42a102.889,102.889,0,0,1-9.089-16.12c-1.054-3.013-1-4.724-.248-6.287a10.221,10.221,0,0,1,2.914-3.038c3.918-2.591,7.96-5.22,10.7-6.993,4.885-3.162,8.754-5.667,11.246-7.44,9.362-6.547,15.909-13.5,20-21.278a42.371,42.371,0,0,0,2.1-35.191c-6.2-16.318-21.613-26.449-40.287-26.449a55.543,55.543,0,0,0-11.718,1.24c-1.029.224-2.059.459-3.063.72.174-11.16-.074-22.94-1.066-34.534-3.522-40.758-17.794-62.123-32.674-79.16A130.167,130.167,0,0,0,332.1,36.443C309.515,23.547,283.91,17,256,17S202.6,23.547,180,36.443a129.735,129.735,0,0,0-33.281,26.783c-14.88,17.038-29.152,38.44-32.673,79.161-.992,11.594-1.24,23.435-1.079,34.533-1-.26-2.021-.5-3.051-.719a55.461,55.461,0,0,0-11.717-1.24c-18.687,0-34.125,10.131-40.3,26.449a42.423,42.423,0,0,0,2.046,35.228c4.105,7.774,10.652,14.731,20.014,21.278,2.48,1.736,6.361,4.24,11.246,7.44,2.641,1.711,6.5,4.216,10.28,6.72a11.054,11.054,0,0,1,3.3,3.311c.794,1.624.818,3.373-.36,6.6a102.02,102.02,0,0,1-8.94,15.785c-12.077,17.669-29.363,32.648-51.434,44.639C32.355,348.608,20.2,352.75,15.069,366.7c-3.868,10.528-1.339,22.506,8.494,32.6a49.137,49.137,0,0,0,12.4,9.387,134.337,134.337,0,0,0,30.342,12.139,20.024,20.024,0,0,1,6.126,2.741c3.583,3.137,3.075,7.861,7.849,14.78a34.468,34.468,0,0,0,8.977,9.127c10.019,6.919,21.278,7.353,33.207,7.811,10.776.41,22.989.881,36.939,5.481,5.778,1.91,11.78,5.605,18.736,9.92C194.842,480.951,217.707,495,255.973,495s61.292-14.123,78.118-24.428c6.907-4.24,12.872-7.9,18.489-9.758,13.949-4.613,26.163-5.072,36.939-5.481,11.928-.459,23.187-.893,33.206-7.812a34.584,34.584,0,0,0,10.218-11.16c3.434-5.84,3.348-9.919,6.572-12.771a18.971,18.971,0,0,1,5.753-2.629A134.893,134.893,0,0,0,476.02,408.71a48.344,48.344,0,0,0,13.019-10.193l.124-.149C498.389,388.5,500.708,376.867,496.926,366.6Zm-34.013,18.277c-20.745,11.458-34.533,10.23-45.259,17.137-9.114,5.865-3.72,18.513-10.342,23.076-8.134,5.617-32.177-.4-63.239,9.858-25.618,8.469-41.961,32.822-88.038,32.822s-62.036-24.3-88.076-32.884c-31-10.255-55.092-4.241-63.239-9.858-6.609-4.563-1.24-17.211-10.341-23.076-10.739-6.907-24.527-5.679-45.26-17.075-13.206-7.291-5.716-11.8-1.314-13.937,75.143-36.381,87.133-92.552,87.666-96.719.645-5.046,1.364-9.014-4.191-14.148-5.369-4.96-29.189-19.7-35.8-24.316-10.937-7.638-15.748-15.264-12.2-24.638,2.48-6.485,8.531-8.928,14.879-8.928a27.643,27.643,0,0,1,5.965.67c12,2.6,23.659,8.617,30.392,10.242a10.749,10.749,0,0,0,2.48.335c3.6,0,4.86-1.811,4.612-5.927-.768-13.132-2.628-38.725-.558-62.644,2.84-32.909,13.442-49.215,26.04-63.636,6.051-6.932,34.484-36.976,88.857-36.976s82.88,29.92,88.931,36.827c12.611,14.421,23.225,30.727,26.04,63.636,2.071,23.919.285,49.525-.558,62.644-.285,4.327,1.017,5.927,4.613,5.927a10.648,10.648,0,0,0,2.48-.335c6.745-1.624,18.4-7.638,30.4-10.242a27.641,27.641,0,0,1,5.964-.67c6.386,0,12.4,2.48,14.88,8.928,3.546,9.374-1.24,17-12.189,24.639-6.609,4.612-30.429,19.343-35.8,24.315-5.568,5.134-4.836,9.1-4.191,14.149.533,4.228,12.511,60.4,87.666,96.718C468.629,373.011,476.119,377.524,462.913,384.877Z"]
  },
  Wv = {
    prefix: "fab",
    iconName: "cc-amex",
    icon: [576, 512, [], "f1f3", "M48 480C21.49 480 0 458.5 0 432V80C0 53.49 21.49 32 48 32H528C554.5 32 576 53.49 576 80V82.43H500.5L483.5 130L466.6 82.43H369.4V145.6L341.3 82.43H262.7L181 267.1H246.8V430.9H450.5L482.4 395.8L514.3 430.9H576V432C576 458.5 554.5 480 528 480H48zM482.6 364L440.4 410.3H390.5L458 338.6L390.5 266.1H441.9L483.4 312.8L525.4 266.1H576L508 338.2L576 410.3H524.6L482.6 364zM576 296.9V380.2L536.7 338.3L576 296.9zM307.6 377.1H390.6V410.3H268.6V267.1H390.6V300.2H307.6V322.6H388.5V354.9H307.6V377.2V377.1zM537.3 145.7L500.4 246.3H466L429.2 146V246.3H390.5V103H451.7L483.6 192.3L515.8 103H576V246.3H537.3V145.7zM334.5 217.6H268.6L256.7 246.3H213.7L276.1 103H327.3L390.6 246.3H346.5L334.5 217.6zM301.5 138.5L282 185.4H320.9L301.5 138.5z"]
  },
  Xv = {
    prefix: "fab",
    iconName: "twitter",
    icon: [512, 512, [], "f099", "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"]
  },
  Uv = {
    prefix: "fab",
    iconName: "pinterest",
    icon: [496, 512, [], "f0d2", "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"]
  },
  Kv = ["solid", "regular", "light", "thin", "duotone"],
  Yv = {
    archive: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ya,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: hr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    arrowLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: og,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _p,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Zu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Tc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: No,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    bars: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Uh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ff,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ll,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ha,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Er,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    bug: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Es,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: mi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    calendarAlt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: El,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ma,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: cr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    check: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ea,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chevronDown: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Km,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ps,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: zi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chevronLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: dv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ih,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _d,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ws,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Di,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chevronRight: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ah,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $d,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ri,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chevronUp: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: iA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $f,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Da,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Nr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    clock: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Eg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ts,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ko,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    cog: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: id,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _c,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    commentLines: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $h,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: wr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    commentsDollar: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: VA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Eu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: co,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    conciergeBell: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Zh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Df,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Nl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: vr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    ellipsisH: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Tg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Nm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: fi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    ellipsisV: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: dd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: is,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: _o,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    emptySet: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: br,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    envelope: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: am,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $u,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ro,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    envelopeOpenText: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: jm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ms,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ii,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    exclamationTriangle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Eh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ta,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    externalLinkAlt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Uu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    inbox: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ug,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ld,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: yi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    infoCircle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: nd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: jo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    longArrowRight: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Og,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: km,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: di,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    messageLines: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: IA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: uu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    minus: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: dm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: od,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Zo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    paperclip: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ed,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Go,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    pencilAlt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ql,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ba,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: pr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    plus: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: av,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: eh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    questionCircle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: YA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ou,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Mc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    search: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $g,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    slidersH: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ig,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ud,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: qo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    spinner: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: nf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ys,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ji,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    star: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ua,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    stars: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: AA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: up,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ru,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ya,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: jr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    times: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: th,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ud,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Li,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    trash: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ju,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Oc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ko,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    trashAlt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ar,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    userCircle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ov,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _m,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Zd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ds,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ni,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    turnUp: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Tv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Nh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: fa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    arrowTurnUp: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: es,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Uo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    house: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ym,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ls,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ni,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    moneyBill: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ul,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ga,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    moneyBillWave: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ap,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $l,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Dr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    receipt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ev,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Um,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ls,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    anglesLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Av,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: uh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ji,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    phone: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: zo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    reply: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    thumbsUp: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ef,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ml,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ca,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    thumbsDown: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Mm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Id,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ui,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    lock: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: La,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    lockOpen: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: XA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Eo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    lockKeyhole: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: WA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Su,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: bo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    bell: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Tm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: kd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: vi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    circlePlus: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ah,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: uf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    rv: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ug,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: om,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: To,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    list: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: eA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Uf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Va,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    listCheck: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ts,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ki,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    download: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: as,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: $o,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    circleCheck: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: QA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ep,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: eo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    image: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: BA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: du,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: oc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: qr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    clockRotateLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: af,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $s,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    desktop: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ff,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: il,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: _i,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    laptop: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ph,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Mf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Il,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Aa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: lr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    tablet: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ad,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $c,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    mobile: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Am,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ld,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ns,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    messageQuestion: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: jh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Of,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ml,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ia,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ar,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    users: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: oA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _f,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Zl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ta,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: kr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    peopleGroup: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: jf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: za,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: yr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    fileInvoice: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: sa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    fileInvoiceDollar: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: nu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ka,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    messageDots: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Is,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ai,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    floppyDisk: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: eg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Up,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ho,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    rotate: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ks,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chartBar: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ap,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: nc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chartGantt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ag,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: um,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chartSimple: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ja,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chartWaterfall: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: OA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: kp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: uo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chartScatter: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: uv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: oh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Zs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ti,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    chartColumn: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ui,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    barsFilter: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: iv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $m,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Si,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    starHalfStroke: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: DA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: po,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    percent: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ch,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ef,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Us,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    faceSurprise: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: JA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Tp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ku,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: vo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    faceThinking: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ih,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ul,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ra,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    circle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: UA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: yo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    upload: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ng,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ps,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ai,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    layerGroup: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: NA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: io,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    eye: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _A,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Du,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Nc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: wo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    sort: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: LA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: so,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    ban: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: eu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Rr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    bold: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: EA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: su,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: tc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ur,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    italic: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: SA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ao,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    strikethrough: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Dh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ca,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: fr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    paragraph: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Od,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ks,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    h1: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ha,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: sr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    h2: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: nh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: js,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    h3: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: dA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ip,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _l,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Za,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Tr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    h4: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: dp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ou,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: qa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    h5: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ch,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: al,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: $i,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    h6: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: td,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Uc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    listOl: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: PA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Mp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Iu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ac,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: lo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    blockquote: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: kg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ii,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    horizontalRule: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ov,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: kh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: da,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    rotateLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ic,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: _r,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    rotateRight: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Im,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ad,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: us,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ri,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    turnDownLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: KA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: jp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Io,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    textSlash: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: MA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: uc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ro,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    alignSlash: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ac,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: $r,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    underline: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: mp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ec,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    link: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: _g,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Dd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ss,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: wi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    alignCenter: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Em,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: md,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ss,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ti,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    alignLeft: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ig,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: $p,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Wu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Dc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: So,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    alignRight: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: kv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: xh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: fl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ia,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    alignJustify: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: np,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Kl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Fa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    hashtag: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Cv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ph,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: cf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: el,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    map: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: rh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Js,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Oi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    linkSimple: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: aA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ep,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Xl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ra,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Sr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    creditCard: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: ys,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: hi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    clipboardList: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Gh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Lf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Hl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ea,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: mr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    code: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: RA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Vp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Qu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: mo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    paperPlane: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Mv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: vf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: dl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: oa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    certificate: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: zA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ip,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Au,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: lc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: no,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    checkCircle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: HA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: yp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: hu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: sc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: to,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    exclamationCircle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Yh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Jf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ol,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ma,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: Ir,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    stripe: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color,
        s = e.iconProps;
      return /*#__PURE__*/t.createElement(or, N({
        icon: Fv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      }, s));
    },
    timesCircle: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Nv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: wh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: bf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: pl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: aa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    university: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Pv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "thin":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Mh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "light":
            return /*#__PURE__*/t.createElement(or, N({
              icon: Bf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          case "regular":
            return /*#__PURE__*/t.createElement(or, N({
              icon: gl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
          default:
            return /*#__PURE__*/t.createElement(or, N({
              icon: ua,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s
            }, l));
        }
      }();
    },
    bed: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: jg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Om,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Md,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Bs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: gi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    shower: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Iv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: gh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: df,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ol,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: qi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    mapMarkerAlt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Zg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Dm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Nd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ws,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Ci,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    share: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Hv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: yh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Af,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ll,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: na,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    bath: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: CA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: pp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: au,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: $a,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Wr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    toilet: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Vg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Hm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ed,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: hs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: si,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    grid: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Th,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Nf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: xl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: va,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: dr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    bolt: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Sg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Qm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: bd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ms,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: ci,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    boltLightning: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: FA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Pp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: zu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: yc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Ao,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    airConditioner: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Lg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: zm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: yd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: As,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: li,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fireplace: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: gv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: dh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: of,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: _s,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Zi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    circleParking: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: uA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: op,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: ql,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ja,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Or,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    wifi: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: vA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: fp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: iu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: _a,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Zr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    heat: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: $A,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Xp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ru,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Sc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Qo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    washingMachine: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: dg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: im,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: _u,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Zc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Do,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    hotTubPerson: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: nA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Yf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: jl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Pa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: zr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    personSwimming: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Xg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Gm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Vd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Hs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Ei,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    tv: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: nv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ym,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: jd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Os,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Mi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    blanket: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: rA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: qf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Jl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Oa,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Mr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    gamepadModern: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: lg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: rm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Yu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: jc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Oo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    kitchenSet: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: ZA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Dp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Nu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: xc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Co,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    microwave: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Jh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Tf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: kl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ba,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: gr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    coffeePot: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: ng,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Yp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: ju,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Pc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Mo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    utensils: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Mg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Bm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: gd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ds,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: oi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    oven: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: wg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: bm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: pd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: cs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: ei,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fireBurner: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: _h,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Wf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Dl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Na,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: xr,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    grillHot: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: qg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Zm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Td,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ns,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: xi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    facebook: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Jv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    twitter: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Xv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    instagram: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: jv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    pinterest: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Uv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    snapchat: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Zv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    bedBunk: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: GA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Lp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Hu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ec,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: ho,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    ccVisa: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Dv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    ccMastercard: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Rv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    ccAmex: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Wv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    ccDiscover: function (e) {
      var n = e.spin,
        r = e.beat,
        o = e.fade,
        i = e.rotation,
        a = e.flip,
        c = e.color;
      return /*#__PURE__*/t.createElement(or, {
        icon: Gv,
        spin: n,
        beat: r,
        fade: o,
        rotation: i,
        flip: a,
        color: c
      });
    },
    sitemap: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: qh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Zf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Tl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ka,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Br,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    grid2Plus: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Dg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Sm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: wd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: bs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: pi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    upDownLeftRight: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: TA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Np,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: xu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: vc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: fo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    upDown: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ev,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: hh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: lf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: nl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Ki,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    file: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Wg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Rm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Sd,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Qs,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: bi,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    filePdf: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: sg,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: nm,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ku,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Fc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Po,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileExcel: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: jA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Op,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Mu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Ic,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: go,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileWord: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: kA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: xp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: vu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: dc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: oo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileDoc: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: qA,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: Zp,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Tu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: kc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: xo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileCsv: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Oh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: kf,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Bl,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: ga,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: ur,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    fileVideo: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: ag,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: em,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: Xu,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Rc,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: Vo,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    },
    print: function (e) {
      var n = e.style,
        r = e.spin,
        o = e.beat,
        i = e.fade,
        a = e.rotation,
        c = e.flip,
        s = e.color,
        l = e.iconProps;
      return function () {
        switch (n) {
          case "duotone":
            return /*#__PURE__*/t.createElement(or, {
              icon: Lv,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "thin":
            return /*#__PURE__*/t.createElement(or, {
              icon: zh,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "light":
            return /*#__PURE__*/t.createElement(or, {
              icon: If,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          case "regular":
            return /*#__PURE__*/t.createElement(or, {
              icon: Al,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
          default:
            return /*#__PURE__*/t.createElement(or, {
              icon: la,
              spin: r,
              beat: o,
              fade: i,
              rotation: a,
              flip: c,
              color: s,
              iconProps: l
            });
        }
      }();
    }
  },
  qv = function (e) {
    var n = e.iconStyle,
      r = e.name,
      o = e.spin,
      i = e.beat,
      a = e.fade,
      c = e.rotation,
      s = e.flip,
      l = e.color,
      u = e.iconProps,
      d = Yv["".concat(r)];
    return /*#__PURE__*/t.createElement(d, {
      style: n,
      spin: o,
      beat: i,
      fade: a,
      rotation: c,
      flip: s,
      color: l,
      iconProps: u
    });
  };
qv.propTypes = {
  name: g.oneOf(Object.keys(Yv)).isRequired,
  iconStyle: g.oneOf(Kv),
  spin: g.bool,
  beat: g.bool,
  fade: g.bool,
  rotation: g.number,
  flip: g.oneOf(["horizontal", "vertical", "both"]),
  iconProps: g.object,
  color: g.string
}, qv.defaultProps = {
  iconStyle: Kv[0],
  name: Object.keys(Yv)[0],
  spin: !1,
  beat: !1,
  fade: !1,
  iconProps: {}
};
var _v,
  $v = {
    icon: "logo-module_icon__2CW02",
    "is-black": "logo-module_is-black__2SzCX",
    "is-white": "logo-module_is-white__X8BrZ",
    iconText: "logo-module_iconText__WVtPZ",
    "is-defaultWhiteText": "logo-module_is-defaultWhiteText__3aRvX"
  },
  eC = {
    exports: {}
  };
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
_v = eC, function () {
  var e = {}.hasOwnProperty;
  function t() {
    for (var n = [], r = 0; r < arguments.length; r++) {
      var o = arguments[r];
      if (o) {
        var i = typeof o;
        if ("string" === i || "number" === i) n.push(o);else if (Array.isArray(o)) {
          if (o.length) {
            var a = t.apply(null, o);
            a && n.push(a);
          }
        } else if ("object" === i) if (o.toString === Object.prototype.toString) for (var c in o) e.call(o, c) && o[c] && n.push(c);else n.push(o.toString());
      }
    }
    return n.join(" ");
  }
  _v.exports ? (t.default = t, _v.exports = t) : window.classNames = t;
}();
var tC = eC.exports,
  nC = function (e) {
    var n = e.className,
      r = e.appearance;
    return /*#__PURE__*/t.createElement("svg", {
      viewBox: "0 0 178 47",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      className: tC("ds-base-logo-size", n)
    }, /*#__PURE__*/t.createElement("defs", null, /*#__PURE__*/t.createElement("path", {
      id: "prefix__a",
      d: "M0 .87h38.455V46H0z"
    })), /*#__PURE__*/t.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/t.createElement("g", {
      transform: "translate(0 .13)"
    }, /*#__PURE__*/t.createElement("mask", {
      id: "prefix__b",
      fill: "#fff"
    }, /*#__PURE__*/t.createElement("use", {
      xlinkHref: "#prefix__a"
    })), /*#__PURE__*/t.createElement("path", {
      d: "M11.7 23.419l2.815-2.815a1.947 1.947 0 012.752 0l2.815 2.815-2.815 2.815a1.95 1.95 0 01-2.752 0L11.7 23.419zm4.13 17.632L4.95 30.17l4.275-4.276 2.815 2.815a5.452 5.452 0 007.702 0l5.291-5.29-5.29-5.29a5.452 5.452 0 00-7.703 0l-2.815 2.815-4.2-4.2L15.95 5.82l17.555 17.556L15.83 41.05zM.076 16.745l6.674 6.674L0 30.169 15.83 46l22.625-22.623L15.95.87.076 16.745z",
      className: tC($v.icon, k({}, $v["is-".concat(r)], r)),
      mask: "url(#prefix__b)"
    })), /*#__PURE__*/t.createElement("path", {
      d: "M61.732 28.089h-3.296v-9.047h3.296c2.791 0 4.644 1.564 4.644 4.499 0 2.743-1.9 4.548-4.644 4.548m0-12.705l-7.242.024v16.338h7.242c5.101 0 8.638-3.44 8.638-8.205 0-4.716-3.248-8.181-8.638-8.157M76.948 31.746h3.946V15.384h-3.946zM96.701 24.023h-3.393V19.04h3.416c1.324 0 2.407 1.131 2.407 2.48 0 1.37-1.083 2.502-2.43 2.502m6.4-2.503c0-3.561-2.503-6.136-5.823-6.136h-7.916v16.363h3.946V27.68h2.887l2.454 4.067h4.91l-3.37-4.933c1.757-.939 2.911-2.936 2.911-5.294M111.184 31.746h12.535V28.09h-8.59v-2.816h7.17v-3.416h-7.17v-2.816h8.59v-3.657h-12.535zM139.19 18.657c2.069 0 3.584.986 4.353 2.478l3.345-1.95c-1.466-2.453-4.21-4.09-7.698-4.09-5.125 0-8.855 3.803-8.855 8.35 0 4.837 3.73 8.59 8.855 8.59 3.465 0 6.184-1.804 7.65-4.26l-3.344-1.923c-.794 1.443-2.286 2.477-4.306 2.477-2.863 0-4.86-2.285-4.86-4.884 0-2.695 1.996-4.788 4.86-4.788M152.335 15.384v3.657h5.799v12.705h3.994V19.041h5.799v-3.657zM174.822 17.35h-.488v-.72h.515c.184 0 .34.181.34.365a.372.372 0 01-.367.355zm.576.488c.272-.16.5-.477.5-.843 0-.588-.399-1.009-.943-1.009h-1.325v2.645h.704v-.633h.404l.372.633h.815l-.527-.793z",
      className: tC($v.iconText, k({}, $v["is-".concat(r)], r))
    }), /*#__PURE__*/t.createElement("path", {
      d: "M174.727 19.457a2.146 2.146 0 01-2.151-2.146c0-1.186.96-2.158 2.151-2.158a2.16 2.16 0 012.153 2.158 2.15 2.15 0 01-2.153 2.146m0-4.825a2.676 2.676 0 10-.007 5.35 2.676 2.676 0 00.007-5.35",
      className: tC($v.iconText, k({}, $v["is-".concat(r)], r))
    })));
  };
nC.propTypes = {
  className: g.string,
  appearance: g.oneOf(["default", "defaultWhiteText", "white", "black"])
}, nC.defaultProps = {
  appearance: "default"
};
var rC = {
    "logo-fill": "logomark-module_logo-fill__2Zp8F",
    "is-black": "logomark-module_is-black__3mM8F",
    "is-white": "logomark-module_is-white__2mfUa",
    "is-purple": "logomark-module_is-purple__3fcjS"
  },
  oC = function (e) {
    var n = e.appearance,
      r = e.className;
    return /*#__PURE__*/t.createElement("svg", {
      viewBox: "0 0 34.084 40",
      xmlns: "http://www.w3.org/2000/svg",
      xmlnsXlink: "http://www.w3.org/1999/xlink",
      className: tC("ds-base-svg-size", r)
    }, /*#__PURE__*/t.createElement("defs", null, /*#__PURE__*/t.createElement("path", {
      id: "prefix__a",
      d: "M0 0h34.084v40H0z"
    })), /*#__PURE__*/t.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/t.createElement("mask", {
      id: "prefix__b",
      fill: "#fff"
    }, /*#__PURE__*/t.createElement("use", {
      xlinkHref: "#prefix__a"
    })), /*#__PURE__*/t.createElement("path", {
      d: "M10.37 19.986l2.495-2.495a1.725 1.725 0 012.44 0l2.494 2.495-2.495 2.495a1.728 1.728 0 01-2.439 0l-2.495-2.495zm3.66 15.628l-9.644-9.645 3.79-3.79 2.495 2.495a4.832 4.832 0 006.827 0l4.69-4.688-4.69-4.689a4.832 4.832 0 00-6.827 0l-2.495 2.495-3.722-3.722 9.683-9.683 15.56 15.56L14.03 35.615zM.068 14.07l5.916 5.916L0 25.969 14.03 40l20.054-20.052L14.137 0 .067 14.07z",
      fillRule: "nonzero",
      mask: "url(#prefix__b)",
      className: tC(rC["logo-fill"], k({}, rC["is-".concat(n)], n))
    })));
  };
oC.propTypes = {
  appearance: g.oneOf(["default", "white", "black", "purple"]),
  className: g.string
};
var iC = {
    base: "ChannelLogo-module_base__1geL7",
    "height-s": "ChannelLogo-module_height-s__3jjsX",
    "height-m": "ChannelLogo-module_height-m__3Vx1a",
    "height-l": "ChannelLogo-module_height-l__39_ax",
    "height-xl": "ChannelLogo-module_height-xl__1rFES",
    "height-xxl": "ChannelLogo-module_height-xxl__3XysJ",
    isGrayscale: "ChannelLogo-module_isGrayscale__2vyXg"
  },
  aC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1000 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "airbnb-logo"), /*#__PURE__*/e.createElement("path", {
      d: "M526.897 78.39a20.26 20.26 0 0 1-20.3 20.3 20.26 20.26 0 0 1-20.3-20.3c0-11.243 8.744-20.3 20.3-20.3 11.555.312 20.3 9.37 20.3 20.3Zm-83.7 40.913v4.997s-9.681-12.492-30.294-12.492c-34.042 0-60.589 25.922-60.589 61.838 0 35.603 26.235 61.837 60.589 61.837 20.925 0 30.294-12.804 30.294-12.804v5.309c0 2.498 1.874 4.372 4.373 4.372h25.297V114.93H447.57c-2.499 0-4.373 2.187-4.373 4.373Zm0 75.268c-4.684 6.87-14.054 12.804-25.297 12.804-19.988 0-35.291-12.492-35.291-33.73 0-21.237 15.303-33.73 35.29-33.73 10.932 0 20.926 6.247 25.298 12.806v41.85Zm48.409-79.64h29.982v117.43h-29.982V114.93Zm447.855-3.123c-20.612 0-30.294 12.492-30.294 12.492V58.402h-29.982V232.36h25.297c2.499 0 4.373-2.186 4.373-4.372v-5.31s9.682 12.805 30.294 12.805c34.042 0 60.589-26.234 60.589-61.837 0-35.604-26.547-61.838-60.277-61.838Zm-4.997 95.255c-11.555 0-20.612-5.934-25.297-12.805v-41.85c4.685-6.246 14.679-12.804 25.297-12.804 19.988 0 35.292 12.492 35.292 33.73 0 21.237-15.304 33.73-35.292 33.73Zm-70.894-44.348v69.958h-29.982V166.15c0-19.363-6.247-27.171-23.112-27.171-9.057 0-18.426 4.685-24.36 11.556v81.825h-29.982V114.93h23.736c2.498 0 4.372 2.187 4.372 4.373v4.997c8.745-9.057 20.3-12.492 31.856-12.492 13.117 0 24.048 3.748 32.793 11.243 10.619 8.745 14.679 19.988 14.679 39.664Zm-180.205-50.907c-20.612 0-30.294 12.492-30.294 12.492V58.402H623.09V232.36h25.297c2.499 0 4.373-2.186 4.373-4.372v-5.31s9.681 12.805 30.294 12.805c34.042 0 60.589-26.234 60.589-61.837.312-35.604-26.235-61.838-60.277-61.838Zm-4.997 95.255c-11.555 0-20.612-5.934-25.297-12.805v-41.85c4.685-6.246 14.679-12.804 25.297-12.804 19.988 0 35.292 12.492 35.292 33.73 0 21.237-15.304 33.73-35.292 33.73Zm-81.2-95.255c9.056 0 13.74 1.561 13.74 1.561v27.796s-24.984-8.432-40.6 9.37v82.138h-29.982V114.93h25.298c2.498 0 4.372 2.186 4.372 4.372v4.997c5.622-6.558 17.802-12.492 27.171-12.492ZM285.791 221.742c-1.562-3.748-3.123-7.808-4.685-11.244-2.498-5.621-4.997-10.93-7.183-15.927l-.312-.313c-21.55-46.847-44.661-94.318-69.021-141.165l-.937-1.874c-2.499-4.684-4.997-9.681-7.496-14.678-3.123-5.622-6.246-11.556-11.243-17.178C174.92 6.871 160.555 0 145.25 0c-15.615 0-29.67 6.87-39.976 18.739-4.684 5.621-8.12 11.555-11.243 17.177-2.498 4.997-4.997 9.994-7.495 14.679l-.937 1.873c-24.048 46.847-47.472 94.319-69.021 141.166l-.313.624c-2.186 4.997-4.684 10.307-7.183 15.928a205.63 205.63 0 0 0-4.685 11.243C.338 232.985-.91 243.916.651 255.16c3.435 23.424 19.05 43.1 40.6 51.844C49.371 310.438 57.804 312 66.55 312c2.498 0 5.621-.312 8.12-.625 10.306-1.249 20.925-4.684 31.23-10.618 12.806-7.183 24.986-17.49 38.728-32.48 13.741 14.99 26.234 25.297 38.726 32.48 10.307 5.934 20.925 9.37 31.232 10.618 2.498.313 5.621.625 8.12.625 8.744 0 17.49-1.562 25.297-4.997 21.862-8.745 37.165-28.733 40.6-51.844 2.5-10.93 1.25-21.862-2.81-33.417Zm-140.853 16.24c-16.865-21.237-27.796-41.225-31.544-58.09-1.561-7.183-1.873-13.43-.937-19.051.625-4.997 2.499-9.37 4.997-13.117 5.934-8.433 15.928-13.742 27.484-13.742 11.555 0 21.862 4.997 27.483 13.742 2.499 3.747 4.373 8.12 4.997 13.117.937 5.621.625 12.18-.937 19.05-3.747 16.553-14.678 36.541-31.543 58.091Zm124.613 14.679c-2.187 16.24-13.118 30.294-28.42 36.54-7.496 3.123-15.616 4.06-23.737 3.123-7.807-.937-15.615-3.435-23.735-8.12-11.244-6.246-22.487-15.928-35.604-30.294 20.613-25.297 33.105-48.408 37.79-69.021 2.186-9.682 2.498-18.427 1.561-26.547-1.249-7.807-4.06-14.99-8.432-21.237-9.682-14.054-25.922-22.174-44.036-22.174s-34.354 8.432-44.036 22.174c-4.372 6.246-7.183 13.43-8.433 21.237-1.249 8.12-.936 17.178 1.562 26.547 4.685 20.613 17.49 44.036 37.79 69.333-12.805 14.367-24.36 24.048-35.604 30.295-8.12 4.684-15.928 7.183-23.736 8.12a49.956 49.956 0 0 1-23.735-3.123c-15.304-6.247-26.234-20.3-28.42-36.541-.938-7.808-.313-15.616 2.81-24.36.937-3.124 2.499-6.247 4.06-9.994 2.186-4.997 4.685-10.307 7.183-15.616l.313-.625c21.55-46.534 44.66-94.006 68.708-140.228l.937-1.874c2.499-4.684 4.997-9.681 7.496-14.366 2.498-4.997 5.31-9.682 8.745-13.742 6.558-7.495 15.303-11.555 24.985-11.555 9.681 0 18.426 4.06 24.985 11.555 3.435 4.06 6.246 8.745 8.744 13.742 2.499 4.685 4.997 9.682 7.496 14.366l.937 1.874c23.735 46.535 46.847 94.006 68.396 140.54v.313c2.499 4.997 4.685 10.619 7.183 15.616 1.562 3.747 3.123 6.87 4.06 9.994 2.499 8.12 3.436 15.928 2.187 24.048Z",
      fill: "#FF5A5F",
      fillRule: "nonzero"
    }));
  },
  cC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "airbnb-logo-icon"), /*#__PURE__*/e.createElement("path", {
      d: "M296.792 221.742c-1.562-3.748-3.123-7.808-4.685-11.244-2.498-5.621-4.997-10.93-7.183-15.927l-.312-.313c-21.55-46.847-44.661-94.318-69.021-141.165l-.937-1.874c-2.499-4.684-4.997-9.681-7.496-14.678-3.123-5.622-6.246-11.556-11.243-17.178C185.92 6.871 171.555 0 156.25 0c-15.615 0-29.67 6.87-39.976 18.739-4.684 5.621-8.12 11.555-11.243 17.177-2.498 4.997-4.997 9.994-7.495 14.679l-.937 1.873c-24.048 46.847-47.472 94.319-69.021 141.166l-.313.624c-2.186 4.997-4.684 10.307-7.183 15.928a205.63 205.63 0 0 0-4.685 11.243c-4.06 11.556-5.309 22.487-3.747 33.73 3.435 23.424 19.05 43.1 40.6 51.844C60.371 310.438 68.804 312 77.55 312c2.498 0 5.621-.312 8.12-.625 10.306-1.249 20.925-4.684 31.23-10.618 12.806-7.183 24.986-17.49 38.728-32.48 13.741 14.99 26.234 25.297 38.726 32.48 10.307 5.934 20.925 9.37 31.232 10.618 2.498.313 5.621.625 8.12.625 8.744 0 17.49-1.562 25.297-4.997 21.862-8.745 37.165-28.733 40.6-51.844 2.5-10.93 1.25-21.862-2.81-33.417Zm-140.853 16.24c-16.865-21.237-27.796-41.225-31.544-58.09-1.561-7.183-1.873-13.43-.937-19.051.625-4.997 2.499-9.37 4.997-13.117 5.934-8.433 15.928-13.742 27.484-13.742 11.555 0 21.862 4.997 27.483 13.742 2.499 3.747 4.373 8.12 4.997 13.117.937 5.621.625 12.18-.937 19.05-3.747 16.553-14.678 36.541-31.543 58.091Zm124.613 14.679c-2.187 16.24-13.118 30.294-28.42 36.54-7.496 3.123-15.616 4.06-23.737 3.123-7.807-.937-15.615-3.435-23.735-8.12-11.244-6.246-22.487-15.928-35.604-30.294 20.613-25.297 33.105-48.408 37.79-69.021 2.186-9.682 2.498-18.427 1.561-26.547-1.249-7.807-4.06-14.99-8.432-21.237-9.682-14.054-25.922-22.174-44.036-22.174s-34.354 8.432-44.036 22.174c-4.372 6.246-7.183 13.43-8.433 21.237-1.249 8.12-.936 17.178 1.562 26.547 4.685 20.613 17.49 44.036 37.79 69.333-12.805 14.367-24.36 24.048-35.604 30.295-8.12 4.684-15.928 7.183-23.736 8.12a49.956 49.956 0 0 1-23.735-3.123c-15.304-6.247-26.234-20.3-28.42-36.541-.938-7.808-.313-15.616 2.81-24.36.937-3.124 2.499-6.247 4.06-9.994 2.186-4.997 4.685-10.307 7.183-15.616l.313-.625c21.55-46.534 44.66-94.006 68.708-140.228l.937-1.874c2.499-4.684 4.997-9.681 7.496-14.366 2.498-4.997 5.31-9.682 8.745-13.742 6.558-7.495 15.303-11.555 24.985-11.555 9.681 0 18.426 4.06 24.985 11.555 3.435 4.06 6.246 8.745 8.744 13.742 2.499 4.685 4.997 9.682 7.496 14.366l.937 1.874c23.735 46.535 46.847 94.006 68.396 140.54v.313c2.499 4.997 4.685 10.619 7.183 15.616 1.562 3.747 3.123 6.87 4.06 9.994 2.499 8.12 3.436 15.928 2.187 24.048Z",
      fill: "#FF5A5F",
      fillRule: "nonzero"
    }));
  },
  sC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1161 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "direct-logo"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 0h265.854v312H0z"
    })), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("g", null, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("path", {
      d: "m80.887 155.889 19.46-19.461c5.241-5.247 13.779-5.254 19.026 0l19.461 19.461-19.46 19.461c-5.248 5.24-13.786 5.24-19.026 0L80.887 155.89Zm28.552 121.897L34.214 202.56 63.776 173l19.461 19.46c14.684 14.685 38.577 14.678 53.247 0l36.579-36.571-36.58-36.572c-14.676-14.684-38.569-14.677-53.246 0l-19.461 19.461L34.74 109.75l75.528-75.528 121.365 121.37-122.194 122.195ZM.525 109.749l46.14 46.14L0 202.561 109.439 312l156.415-156.408L110.268-.001.525 109.75Z",
      fill: "#40FFD8",
      fillRule: "nonzero",
      mask: "url(#b)"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M426.778 187.276h-22.787v-62.545h22.787c19.295 0 32.106 10.813 32.106 31.103 0 18.964-13.143 31.442-32.106 31.442m0-87.836-50.067.168v112.95h50.067c35.265 0 59.718-23.781 59.718-56.724 0-32.603-22.455-56.558-59.718-56.394M531.97 212.559h27.28V99.442h-27.28zM668.53 159.164h-23.457v-34.436h23.616c9.154 0 16.64 7.82 16.64 17.139 0 9.478-7.486 17.297-16.799 17.297m44.24-17.297c0-24.626-17.298-42.42-40.25-42.42h-54.727v113.116h27.28v-28.117h19.96l16.965 28.117h33.937l-23.29-34.104c12.146-6.485 20.124-20.298 20.124-36.592M768.653 212.56h86.659v-25.282h-59.38V167.81h49.57v-23.616h-49.57v-19.468h59.38V99.443h-86.66zM962.268 122.069c14.304 0 24.785 6.816 30.1 17.131l23.126-13.474c-10.142-16.965-29.105-28.276-53.226-28.276-35.431 0-61.211 26.285-61.211 57.72 0 33.44 25.78 59.386 61.211 59.386 23.955 0 42.752-12.472 52.894-29.444l-23.118-13.301c-5.49 9.976-15.804 17.124-29.776 17.124-19.793 0-33.599-15.797-33.599-33.765 0-18.632 13.806-33.101 33.6-33.101M1053.148 99.445v25.282h40.09v87.834h27.613v-87.834h40.09V99.445z",
      fill: "#474749",
      fillRule: "nonzero"
    })));
  },
  lC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "direct-logo-icon"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 0h265.854v312H0z"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(23)",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("path", {
      d: "m80.887 155.889 19.46-19.461c5.241-5.247 13.779-5.254 19.026 0l19.461 19.461-19.46 19.461c-5.248 5.24-13.786 5.24-19.026 0L80.887 155.89Zm28.552 121.897L34.214 202.56 63.776 173l19.461 19.46c14.684 14.685 38.577 14.678 53.247 0l36.579-36.571-36.58-36.572c-14.676-14.684-38.569-14.677-53.246 0l-19.461 19.461L34.74 109.75l75.528-75.528 121.365 121.37-122.194 122.195ZM.525 109.749l46.14 46.14L0 202.561 109.439 312l156.415-156.408L110.268-.001.525 109.75Z",
      fill: "#40FFD8",
      fillRule: "nonzero",
      mask: "url(#b)"
    })));
  },
  uC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "booking-com-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M312 61.585C312 29.25 285.737 3 253.403 3H58.596C26.263 3 0 29.25 0 61.585v187.964c0 32.325 26.263 58.584 58.596 58.584h194.808c32.333 0 58.596-26.26 58.596-58.584V61.585Z",
      fill: "#0C3B7C"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#0C3B7C",
      d: "M.01 192.564h155.826v115.57H.01z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m141.797 204.971-25.129-.025v-30.047c0-6.42 2.49-9.762 7.984-10.525h17.145c12.227 0 20.136 7.709 20.136 20.186 0 12.815-7.709 20.399-20.136 20.411Zm-25.129-81.045v-7.909c0-6.92 2.928-10.212 9.348-10.637h12.865c11.026 0 17.634 6.595 17.634 17.645 0 8.41-4.53 18.234-17.233 18.234h-22.614v-17.333Zm57.217 29.985-4.543-2.553 3.967-3.391c4.618-3.967 12.352-12.89 12.352-28.283 0-23.578-18.284-38.783-46.58-38.783h-32.287v-.013h-3.68c-8.384.313-15.105 7.134-15.192 15.569v133.781h51.798c31.45 0 51.748-17.12 51.748-43.638 0-14.28-6.558-26.481-17.583-32.689",
      fill: "#FFF"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M204.958 211.758c0-10.22 8.243-18.488 18.398-18.488 10.181 0 18.462 8.268 18.462 18.488 0 10.206-8.28 18.487-18.462 18.487-10.155 0-18.398-8.28-18.398-18.487",
      fill: "#00BAFC"
    })));
  },
  dC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      width: 1839,
      height: 312,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1839 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "booking-com-logo"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 312h1838.809V0H0v312z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "c",
      d: "M0 0h1838.81v312H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "e",
      d: "M0 312h1838.809V0H0v312z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "g",
      d: "M0 305.461h1838.417V0H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "i",
      d: "M0 0h1838.81v312H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "k",
      d: "M0 312h1838.809V0H0v312z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "m",
      d: "M0 0h1838.81v312H0z"
    })), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("g", {
      transform: "matrix(1 0 0 -1 0 312)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("g", {
      mask: "url(#b)"
    }, /*#__PURE__*/e.createElement("g", {
      transform: "translate(.002)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "d",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#c"
    })), /*#__PURE__*/e.createElement("g", {
      mask: "url(#d)",
      fillRule: "nonzero"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M721.097 277.846c0 15.487 12.5 28.014 27.888 28.014 15.44 0 27.989-12.527 27.989-28.014 0-15.467-12.549-28.007-27.989-28.007-15.388 0-27.888 12.54-27.888 28.007",
      fill: "#273B7D"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M1161.953 91.516c0 15.493 12.494 28.033 27.882 28.033 15.434 0 27.981-12.54 27.981-28.033 0-15.454-12.547-28.007-27.981-28.007-15.388 0-27.882 12.553-27.882 28.007",
      fill: "#499FDD"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M262.525 103.624c-24.064 0-40.787 19.111-40.787 46.421 0 27.304 16.723 46.402 40.787 46.402 24.202 0 41.11-19.098 41.11-46.402 0-27.74-16.556-46.421-41.11-46.421Zm0 133.622c-50.91 0-87.858-36.683-87.858-87.2 0-50.518 36.947-87.194 87.858-87.194 51.101 0 88.202 36.676 88.202 87.193 0 50.518-37.1 87.201-88.202 87.201M666.982 145.684c-1.979 3.724-4.248 6.877-6.664 9.38l-1.54 1.633 1.62 1.553c2.336 2.463 4.726 5.384 7.03 8.77l44.927 66.787h-54.54l-33.756-52.243c-1.91-2.801-5.77-4.215-11.544-4.215h-7.694v98.771c0 19.756-12.308 22.444-25.603 22.444h-22.763l.04-233.144h48.326v69.935h4.528c5.508 0 9.26-.637 10.98-3.631l26.66-50.318c7.446-13.655 14.868-15.986 28.83-15.986h37.034l-27.582 45.626-18.289 34.638M901.592 237.618c-24.581 0-40.267-10.92-49.056-20.154l-2.934-2.967-1.036 4.036c-2.582 9.89-11.285 15.334-24.383 15.334h-21.659l.137-168.387h47.997v77.609c0 7.587.987 14.172 2.993 20.18 5.343 18.182 20.246 29.487 38.874 29.487 14.982 0 20.837-7.906 20.837-28.339v-73.34c0-17.438 8.066-25.597 25.518-25.597h22.842l-.078 107.096c0 42.551-20.752 65.042-60.038 65.042M749.623 233.794h-22.75l.155-130.197h-.015V65.44h24.284c.305 0 .55-.033.856-.033l11.31.033h11.26v.067h.077l.098 142.723c0 17.22-8.233 25.564-25.26 25.564M451.058 103.624c-24.062 0-40.818 19.111-40.818 46.421 0 27.304 16.756 46.402 40.818 46.402 24.151 0 41.105-19.098 41.105-46.402 0-27.74-16.549-46.421-41.105-46.421Zm0 133.622c-50.961 0-87.916-36.683-87.916-87.2 0-50.518 36.955-87.194 87.916-87.194 51.049 0 88.21 36.676 88.21 87.193 0 50.518-37.161 87.201-88.21 87.201",
      fill: "#273B7D"
    }))))), /*#__PURE__*/e.createElement("g", {
      transform: "matrix(1 0 0 -1 0 312)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "f",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#e"
    })), /*#__PURE__*/e.createElement("g", null, /*#__PURE__*/e.createElement("g", {
      transform: "translate(.002 .398)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "h",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#g"
    })), /*#__PURE__*/e.createElement("g", null, /*#__PURE__*/e.createElement("g", {
      transform: "translate(0 -.398)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "j",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#i"
    })), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M1479.903 103.624c-24.052 0-40.82 19.111-40.82 46.421 0 27.304 16.768 46.402 40.82 46.402 24.156 0 41.117-19.098 41.117-46.402 0-27.74-16.557-46.421-41.117-46.421Zm0 133.622c-50.95 0-87.905-36.683-87.905-87.2 0-50.518 36.956-87.194 87.905-87.194 51.055 0 88.208 36.676 88.208 87.193 0 50.518-37.153 87.201-88.208 87.201",
      fill: "#499FDD"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M1062.85 111.032c-26.24 0-35.58 22.896-35.58 44.35 0 9.454 2.389 40.262 33.059 40.262 15.241 0 35.554-4.368 35.554-41.848 0-35.349-17.976-42.764-33.033-42.764Zm57.953 123.214c-9.108 0-16.117-3.631-19.63-10.263l-1.327-2.576-2.224 1.932c-7.748 6.705-21.64 14.657-44.197 14.657-44.883 0-75.1-33.71-75.1-83.875 0-50.106 31.266-85.122 76.003-85.122 15.28 0 27.356 3.564 36.928 10.813l3.704 2.782v-4.68c0-22.49-14.545-34.898-40.91-34.898-12.814 0-24.477 3.12-32.276 5.948-10.184 3.074-16.152.531-20.281-9.685l-3.81-9.427-5.39-13.767 3.339-1.78c16.874-8.955 38.84-14.298 58.696-14.298 40.878 0 88.607 20.923 88.607 79.805l.175 154.434h-22.3",
      fill: "#273B7D"
    }))))))), /*#__PURE__*/e.createElement("g", {
      transform: "matrix(1 0 0 -1 0 312)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "l",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#k"
    })), /*#__PURE__*/e.createElement("g", {
      mask: "url(#l)"
    }, /*#__PURE__*/e.createElement("g", {
      transform: "translate(.002)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "n",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#m"
    })), /*#__PURE__*/e.createElement("g", {
      mask: "url(#n)",
      fillRule: "nonzero"
    }, /*#__PURE__*/e.createElement("path", {
      d: "m83.768 105.556-39.072.038v46.714c0 9.984 3.87 15.175 12.426 16.37h26.646c19.018 0 31.306-11.995 31.32-31.399-.014-19.915-11.996-31.711-31.32-31.724ZM44.696 231.57v12.295c0 10.76 4.553 15.878 14.545 16.536h19.993c17.147 0 27.417-10.263 27.417-27.43 0-13.09-7.03-28.365-26.787-28.365H44.696v26.964Zm88.972-46.62-7.063 3.97 6.166 5.27c7.17 6.167 19.192 20.028 19.192 43.979 0 36.643-28.425 60.296-72.418 60.296H29.341v.013h-5.717C10.581 298 .146 287.392 0 274.268V66.27h23.04c.059-.013.078 0 .098-.013l57.4.013c48.904 0 80.47 26.62 80.47 67.85 0 22.199-10.203 41.178-27.35 50.83",
      fill: "#273B7D"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M1782.524 237.073c-19.916 0-39.168-9.326-51.528-24.966l-3.479-4.408-2.728 4.932c-8.889 16.211-24.19 24.442-45.466 24.442-22.311 0-37.274-12.446-44.225-19.848l-4.547-4.926-1.751 6.48c-2.538 9.326-10.84 14.464-23.42 14.464h-20.175l-.194-167.736h45.837v74.043c0 6.486.804 12.905 2.429 19.617 4.382 17.89 16.405 37.134 36.618 35.209 12.467-1.195 18.554-10.827 18.554-29.434V65.507h46.163v74.043c0 8.106.756 14.173 2.584 20.26 3.716 17.08 16.269 34.593 35.772 34.593 14.113 0 19.331-7.993 19.331-29.461V90.029c0-16.948 7.56-24.522 24.494-24.522h21.576l.039 107.082c0 42.777-18.834 64.484-55.894 64.484M1365.457 123.745c-.136-.166-19.86-20.964-45.83-20.964-23.659 0-47.563 14.518-47.563 46.926 0 27.98 18.534 47.537 45.061 47.537 8.616 0 18.413-3.087 19.947-8.278l.225-.877c3.532-11.77 14.228-12.4 16.332-12.4l25.113-.027v21.953c0 28.956-36.831 39.458-61.617 39.458-53 0-91.458-36.902-91.458-87.719 0-50.796 38.04-87.645 90.489-87.645 45.505 0 70.252 29.912 70.484 30.21l1.32 1.62-19.887 32.993-2.616-2.788",
      fill: "#499FDD"
    })))))));
  },
  fC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "expedia-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "m182.382 119.75-6.28-17.771-53.258-71.18 9.568-2.374 91.83 79.384 54.043-15.454c6.354-1.645 13.567-2 19.061-1.963-16.987-36.627-48.064-66.695-89.1-81.308-81.123-28.91-170.317 13.473-199.17 94.632-8.933 25.098-11.063 50.998-7.307 75.628l129.466-44.98 51.147-14.614ZM303.035 104.421c-4.747 3.083-11.717 7.12-18.632 9.344l-54.155 15.454-36.142 116.011-9.38 3.046 7.624-88.597-4.261-18.407-50.755 14.483L3.197 187.337C13.81 238.97 50.363 283.93 103.64 302.917c81.14 28.91 170.298-13.492 199.15-94.594 12.447-34.964 11.643-71.442.244-103.902",
      fill: "#072F54"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m188.085 141.284 4.28 18.388-7.643 88.597 9.38-3.046 36.142-115.993 54.156-15.454c6.914-2.224 13.884-6.298 18.631-9.344a157.364 157.364 0 0 0-5.681-14.034c-5.494-.037-12.707.336-19.061 1.944l-54.044 15.491-91.848-79.42-9.55 2.391 53.241 71.18 6.298 17.753-51.166 14.651L1.773 179.331c.41 2.691.878 5.363 1.42 8.017l134.156-31.582 50.736-14.482Z",
      fill: "#FBC108"
    })));
  },
  pC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1066 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "expedia-logo"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M530.27 244.141h-34.222c-.153 0-.245-.03-.337-.138l-29.486-36.015-29.518 36.015c-.061.107-.168.138-.322.138h-27.402c-.168 0-.291-.077-.414-.26-.046-.108-.046-.307.062-.43l43.433-53.348-42.928-52.843a.56.56 0 0 1-.076-.506c.076-.092.245-.245.383-.245h34.237c.108 0 .23.061.322.214l25.87 32.062 26.33-32.077c.076-.138.199-.2.321-.2h27.908c.169 0 .338.154.399.246a.504.504 0 0 1-.061.506l-40.751 48.935 46.544 57.256c.122.123.168.322.076.43a.397.397 0 0 1-.368.26M715.495 155.485c-15.157 0-25.502 9.195-28.46 25.18h51.556v-1.027c0-12.797-9.425-24.153-23.096-24.153m49.686 41.579a.451.451 0 0 1-.368.199h-78.33c1.625 18.237 13.472 28.628 32.644 28.628 11.801 0 24.337-4.03 42.054-13.456.322-.184.644.092.644.43l-.031 24.091c-.03.2-.123.322-.26.368-16.476 6.943-33.027 11.678-46.039 11.678-33.732 0-58.176-24.582-58.176-58.436 0-33.855 24.444-58.437 58.176-58.437 30.774 0 50.544 20.735 50.544 49.256 0 4.613-.797 15.341-.858 15.679M924.301 114.29c-9.609 0-17.425-7.694-17.425-17.165 0-9.747 7.816-17.64 17.425-17.64 9.61 0 17.44 7.893 17.44 17.64 0 9.471-7.83 17.165-17.44 17.165m-14.069 129.854c-.276 0-.444-.169-.444-.444V136.956c0-.214.153-.383.337-.429h28.291c.23.046.353.215.353.43V243.7c0 .275-.184.444-.414.444h-28.123ZM582.013 228.067c-5.103 0-10.33-.72-16.337-2.33l.061-68.474c7.035-2.238 13.15-3.295 19.203-3.295 19.617 0 32.782 14.467 32.782 35.954 0 23.172-14.023 38.145-35.709 38.145m7.694-95.923c-7.985 0-16.046 1.456-24.506 4.368h-28.153c-.23 0-.399.2-.399.444v175.05c8.506-1.165 18.927-4.2 29.042-11.402l-.015-53.242c6.942.981 12.674 1.64 18.207 1.64 38.56 0 63.51-23.11 63.51-58.896 0-34.115-23.74-57.962-57.686-57.962M858.716 219.203c-8.812 4.628-16.69 6.82-24.091 6.82-17.456 0-27.924-12.337-27.924-32.996 0-23.908 13.364-39.372 34.023-39.372 5.701 0 11.25 1.395 17.992 4.445v61.103Zm0-139.203v55.877c-8.26-2.36-15.54-3.448-22.88-3.448-33.549 0-58.882 25.287-58.882 58.881 0 33.441 22.345 57.686 53.088 57.686 10.651 0 20.613-2.666 32.337-8.705l-.015 9.64c7.74-1.471 16.628-4.567 25.395-10.774V68.567c-8.613 1.15-18.82 4.03-29.043 11.433M1036.787 218.992c-8.521 4.92-15.831 7.28-22.36 7.28-18.697 0-29.9-12.292-29.9-33.028 0-23.555 13.195-39.356 32.812-39.356 5.256 0 11.632 2.008 19.448 6.146v58.958Zm29.073-83.77c0-.66-.567-1.18-1.211-1.18l-22.866.03c-.674 0-1.241.582-1.241 1.226v3.893h-.583c-10.559-4.629-19.555-6.759-28.429-6.759-31.632 0-56.429 26.222-56.429 59.832 0 33.977 22.192 56.75 55.219 56.75 8.842 0 20.168-.612 30.773-12.812v13.732c7.495-1.594 16.338-4.782 24.736-10.82l.03-103.893ZM330.709 217.431l71.019-.03c-1.073 7.938-3.755 17.226-9.916 26.697h-73.885c-9.042 0-16.475-7.004-17.364-15.862-.046-.138-.092-.26-.107-.383V87.792c.015-.108.061-.261.107-.353.89-8.873 8.322-15.908 17.364-15.908.291 0 .567.03.812.03l82.836-.015c-1.088 7.924-3.77 17.456-9.916 26.897h-60.95v38.13h60.337c.245 0 .43.169.43.414v26.452a.425.425 0 0 1-.43.414h-60.337v53.578ZM150.198 98.313l-5.149-14.575-43.678-58.376 7.847-1.946 75.31 65.104 44.322-12.675c5.21-1.348 11.126-1.64 15.632-1.609-13.931-30.038-39.418-54.697-73.073-66.682C104.88-16.155 31.731 18.604 8.07 85.164c-7.326 20.582-9.074 41.823-5.993 62.022l106.176-36.889 41.946-11.984ZM249.147 85.741c-3.893 2.529-9.61 5.84-15.28 7.663l-44.413 12.674-29.64 95.142-7.694 2.498 6.253-72.659-3.494-15.096-41.625 11.878-110.007 25.9c8.705 42.345 38.682 79.218 82.375 94.79 66.544 23.708 139.663-11.066 163.326-77.58 10.207-28.674 9.548-58.59.2-85.21",
      fill: "#072F54"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m154.876 115.972 3.51 15.08-6.269 72.66 7.694-2.498 29.64-95.127 44.413-12.674c5.67-1.824 11.387-5.165 15.28-7.663a129.056 129.056 0 0 0-4.659-11.51c-4.506-.03-10.421.276-15.632 1.594L184.53 88.54l-75.326-65.134-7.831 1.962 43.663 58.376 5.165 14.559-41.962 12.015L2.079 147.175c.337 2.207.72 4.399 1.165 6.575l110.023-25.9 41.609-11.878Z",
      fill: "#FBC108"
    })));
  },
  mC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 948 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "google-logo"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M405.607 164.19c0 44.888-35.116 77.965-78.21 77.965-43.096 0-78.212-33.077-78.212-77.965 0-45.204 35.116-77.965 78.211-77.965s78.211 32.761 78.211 77.965Zm-34.237 0c0-28.05-20.352-47.243-43.974-47.243-23.621 0-43.974 19.193-43.974 47.243 0 27.77 20.353 47.243 43.974 47.243 23.622 0 43.974-19.509 43.974-47.243Z",
      fill: "#EA4335"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M574.332 164.19c0 44.888-35.116 77.965-78.211 77.965s-78.211-33.077-78.211-77.965c0-45.169 35.116-77.965 78.21-77.965 43.096 0 78.212 32.761 78.212 77.965Zm-34.237 0c0-28.05-20.353-47.243-43.974-47.243-23.622 0-43.974 19.193-43.974 47.243 0 27.77 20.352 47.243 43.974 47.243 23.621 0 43.974-19.509 43.974-47.243Z",
      fill: "#FBBC05"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M736.026 90.936v139.97c0 57.578-33.956 81.094-74.098 81.094-37.787 0-60.53-25.274-69.107-45.942l29.808-12.409c5.308 12.69 18.314 27.664 39.264 27.664 25.695 0 41.618-15.853 41.618-45.696v-11.213h-1.195c-7.663 9.455-22.426 17.716-41.056 17.716-38.982 0-74.696-33.956-74.696-77.649 0-44.009 35.714-78.246 74.696-78.246 18.595 0 33.358 8.26 41.056 17.435h1.195V90.97h32.515v-.034Zm-30.09 73.535c0-27.453-18.313-47.524-41.618-47.524-23.621 0-43.411 20.071-43.411 47.524 0 27.172 19.79 46.962 43.411 46.962 23.305 0 41.619-19.79 41.619-46.962Z",
      fill: "#4285F4"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#34A853",
      d: "M789.631 8.893v228.481h-33.393V8.894z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m919.76 189.85 26.574 17.716c-8.576 12.69-29.245 34.554-64.959 34.554-44.29 0-77.367-34.237-77.367-77.965 0-46.364 33.358-77.965 73.536-77.965 40.459 0 60.249 32.198 66.716 49.598l3.55 8.858-104.222 43.166c7.98 15.642 20.388 23.621 37.787 23.621 17.435 0 29.527-8.577 38.385-21.583Zm-81.796-28.05 69.67-28.93c-3.832-9.736-15.362-16.52-28.93-16.52-17.4 0-41.619 15.36-40.74 45.45Z",
      fill: "#EA4335"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M122.782 143.908v-33.077h111.464c1.09 5.765 1.652 12.584 1.652 19.966 0 24.816-6.784 55.503-28.648 77.367-21.266 22.145-48.438 33.956-84.433 33.956C56.101 242.12 0 187.776 0 121.06 0 54.343 56.1 0 122.817 0c36.909 0 63.202 14.482 82.957 33.358l-23.34 23.34c-14.166-13.287-33.359-23.62-59.652-23.62-48.719 0-86.823 39.263-86.823 87.982 0 48.72 38.104 87.983 86.823 87.983 31.601 0 49.598-12.69 61.128-24.22 9.35-9.35 15.501-22.707 17.927-40.95l-79.055.035Z",
      fill: "#4285F4"
    })));
  },
  hC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "google-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M308.37 159.51c0-10.27-.91-20.02-2.47-29.51H159v58.63h84.11c-3.77 19.24-14.82 35.49-31.2 46.54v39h50.18c29.38-27.17 46.28-67.21 46.28-114.66Z",
      fill: "#4285F4"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M159 312c42.12 0 77.35-14.04 103.09-37.83l-50.18-39c-14.04 9.36-31.85 15.08-52.91 15.08-40.69 0-75.14-27.43-87.49-64.48H19.77v40.17C45.38 276.9 98.03 312 159 312Z",
      fill: "#34A853"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M71.51 185.77c-3.25-9.36-4.94-19.37-4.94-29.77 0-10.4 1.82-20.41 4.94-29.77V86.06H19.77C9.11 107.12 3 130.78 3 156s6.11 48.88 16.77 69.94l51.74-40.17Z",
      fill: "#FBBC05"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M159 61.75c23.01 0 43.55 7.93 59.8 23.4l44.46-44.46C236.35 15.47 201.12 0 159 0 98.03 0 45.38 35.1 19.77 86.06l51.74 40.17c12.35-37.05 46.8-64.48 87.49-64.48Z",
      fill: "#EA4335"
    })));
  },
  AC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 982 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "rvshare-logo"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M111.548 162.154c1.698-1.15 3.379-2.33 5.098-3.449 17.701-11.517 34.9-23.714 46.122-42.166 8.7-14.306 10.953-29.959 2.806-44.957-8.34-15.353-22.454-26.108-34.762-38.2-1.953-1.918-4.503-3.305-6.942-4.636-12.525-6.834-25.594-8.72-40.017-7.308-16.126 1.578-32.05 3.509-46.951 9.738-10.903 4.557-21.309 10.465-31.5 16.506-6.815 4.04-7.117 11.802-1.273 17.276 7.688 7.203 15.641 14.122 23.718 21.376-.96 4.643-2.178 9.87-3.107 15.148-3.173 18.018-6.365 36.034-9.282 54.094-.906 5.61-3.577 8.862-9.156 10.018-4.401.912-6.39 5.213-3.981 9.059 1.65 2.635 4.347 4.593 6.24 7.107 1.093 1.449 2.229 3.453 2.107 5.117-.35 4.814-1.38 9.576-2.049 14.372-1.552 11.137-2.861 22.311-4.626 33.414-1.406 8.851-.232 13.094 6.703 15.033 5.23 1.463 10.972 1.256 16.499 1.458 4.71.171 9.437-.225 14.156-.2 3.704.02 7.74.458 8.605-4.404 1.734-9.742 3.103-19.548 4.68-29.319 1.29-7.999 2.664-15.984 4.18-25.046 5.542 7.349 10.315 13.942 15.361 20.318a10563.583 10563.583 0 0 0 43.85 55c6.94 8.65 13.699 17.491 21.237 25.597 4.255 4.574 9.435 9.277 15.12 11.21 4.3 1.46 8.893 1.853 12.662 4.91.944.765 2.481 1.412 3.61 1.238 8.084-1.253 17.612 6.325 24.254-3.869.186-.284.62-.459.973-.573 6.763-2.185 7.75-3.788 3.738-9.7-6.287-9.264-13.08-18.211-20.062-26.971-7.981-10.012-16.478-19.612-24.616-29.502a3609.788 3609.788 0 0 1-29.111-35.86c-8.999-11.225-17.86-22.559-27.111-34.26 4.496-2.56 8.36-4.758 12.827-7.569m201.926-39.703c9.926-15.737 20.329-31.197 29.63-47.294 7.759-13.428 20.41-24.809 18.187-42.832-.941-7.621.348-15.505.346-23.27 0-1.118-1.477-2.32-2.431-3.332-1.062-1.125-2.51-1.923-3.433-3.135-2.381-3.124-4.578-3.645-7.274-.316-6.979 8.616-14.356 16.924-21.045 25.756-15.722 20.759-31.472 41.512-46.565 62.727-12.195 17.14-23.422 34.969-35.162 52.436-.883 1.315-2.434 2.18-3.57 3.165V98.563c0-.191.012-.383.03-.574 1.644-17.658 3.523-35.4-.206-52.938-2.502-11.767-8.98-21.56-21.492-24.015-8.964-1.758-18.467-1.173-27.17 2.928-6.573 3.097-13.094 6.306-20.34 9.804 9.522 8.205 10.232 18.55 11.414 28.139 1.985 16.116 3.214 32.398 3.509 48.633.356 19.64-.609 39.305-.968 58.96-.405 22.146-.893 44.292-.94 66.439-.004 1.856 2.913 3.879 4.747 5.519 1.124 1.005 3.607 1.087 4.045 2.166 3.163 7.787 9.807 10.17 17.062 10.393 8.898.274 17.958.127 26.685-1.369 3.394-.582 8.66 1.831 10.837-3.752 3.165-8.116 6.403-16.226 10.096-24.11 7.657-16.345 15.184-32.777 23.6-48.732 9.451-17.917 19.825-35.348 30.408-53.603M454.98 42.195c0 64.423.123 128.847-.163 193.268-.034 7.736 4.1 10.233 10.202 10.56 7.456.4 14.956.271 22.427.049 8.057-.24 10.098-2.603 10.1-10.837.001-26.843-.037-53.686.071-80.529.009-2.106.428-4.72 1.698-6.215 3.461-4.077 7.297-7.888 11.315-11.429 8.894-7.837 21.496-8.21 27.807-.424 4.475 5.52 6.152 11.632 6.198 18.23.19 26.841.139 53.685.028 80.527-.022 5.253 1.477 9.253 7.175 9.598 9.661.585 19.4 1.308 29.012.634 4.492-.316 7.9-3.607 7.755-9.908-.758-32.699-.709-65.416-1.44-98.116-.288-12.869-5.395-24.715-14.822-33.15-19.163-17.148-49.24-16.378-69.84-.801-1.233.932-2.62 1.662-4.957 3.126v-6.844c0-19.749-.16-39.5.111-59.245.069-4.98-1.954-8.155-6.378-8.383a296.412 296.412 0 0 0-29.896-.02c-4.828.24-7.226 3.74-6.403 9.91m411.332 191.306c14.484 12.739 32.444 15.816 50.497 15.679 14.33-.109 28.94-2.517 42.857-6.105 13.16-3.392 15.957-5.885 15.331-20.206-.125-2.87.042-5.75-.03-8.623-.167-6.697-3.985-9.756-10.427-8.288-1.628.37-3.142 1.214-4.741 1.743-15.624 5.164-31.364 9.563-48.074 6.189-14.012-2.83-24.019-13.844-22.428-31.045h5.576c23.765 0 47.53-.096 71.295.04 12.473.07 15.078-5.918 15.6-14.888.793-13.66-.628-27.206-5.715-40.04-6.654-16.79-18.813-27.699-36.279-32.57-11.96-3.336-23.928-3.939-36.385-2.47-26.988 3.184-48.165 21.9-54.997 48.035-3.8 14.533-5.223 29.064-3.641 44.204 1.923 18.413 6.71 35.027 21.561 48.345m-189.245-105.82c9.863 2.15 14.071 14.722 11.884 26.403-5.432 0-10.963-.18-16.478.036-13.56.53-27.001 1.77-39.814 6.846-12.028 4.764-21.632 11.912-25.958 24.733-2.74 8.117-3.166 16.35-2.236 24.834.951 8.68 4.074 16.316 9.775 22.814 10.488 11.953 24.724 15.578 39.653 16.045 15.224.476 29.137-4.384 41.432-14.855-.124 6.038.46 11.277 7.421 11.523 7.084.252 14.213.439 21.267-.085 4.403-.327 8.325-2.221 8.253-7.986-.443-34.808-.243-69.637-1.395-104.42-.649-19.592-13.392-33.18-32.126-38.128-18.631-4.92-37.377-4.724-55.967.117-6.287 1.638-12.345 4.256-18.381 6.734-14.94 6.13-14.46 13.996-11.996 28.908 1.56 9.452 7.222 11.228 15.873 6.868 3.836-1.933 7.563-4.162 11.557-5.689 11.678-4.463 23.548-8.008 37.236-4.697m-342.411 27.44c1.028 2.18 1.83 4.505 3.123 6.515 6.723 10.441 16.697 16.605 27.918 21.246 8.617 3.565 17.043 7.589 25.576 11.36 5.266 2.328 6.09 7.204 4.73 11.465-1.018 3.187-4.296 6.396-7.393 8.027-7.573 3.99-15.861 3.079-23.593.413-7.408-2.553-14.436-6.22-21.606-9.451-6.525-2.941-11.33-.016-11.506 7.178-.117 4.816.23 9.653-.079 14.452-.586 9.125 5.225 13.6 12.031 16.342 18 7.255 36.543 8.338 55.38 4.501 10.653-2.17 20.456-6.839 28.137-14.506 12.097-12.075 13.47-27.739 11.001-43.39-2.05-13.008-10.729-22.384-22.418-28.145-11.908-5.869-24.394-10.559-36.394-16.254-7.371-3.499-8.925-12.815-2.5-16.46 4.733-2.684 11.305-4.417 16.505-3.487 9.44 1.69 18.514 5.544 27.649 8.758 5.107 1.796 8.817.49 9.533-4.648.834-5.976 1.233-12.081 1.056-18.109-.128-4.393-2.069-8.543-6.301-10.704-3.648-1.862-7.448-3.599-11.372-4.72-13.062-3.732-26.41-4.85-39.792-2.3-10.393 1.98-20.345 5.524-28.324 12.868-14.558 13.4-16.796 29.946-11.361 49.049m478.781-19.604c6.45-4.523 12.597-1.246 18.817.694 5.59 1.744 9.816-.517 10.33-6.097.729-7.926 1.248-15.913 1.13-23.863-.117-7.944-2.564-10.916-9.264-12.687-13.988-3.698-26.472-1.337-36.815 9.447-2.15 2.242-4.646 4.152-7.52 6.69-.869-12.27-.817-12.626-11.83-14.218-5.649-.816-11.533-.328-17.288-.014-7.18.391-9.2 2.76-9.2 9.942-.007 43.48.153 86.963-.164 130.441-.05 6.958 3.732 9.784 10.001 10.156 7.635.453 15.397.794 22.958-.08 8.03-.929 11.115-2.506 11.01-11.637-.273-23.94.168-47.89-.26-71.826-.118-6.676 2.372-11.663 6.384-16.207 3.327-3.768 7.207-7.047 11.711-10.74Z",
      fill: "#FFF"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M111.247 162.46c-4.166 2.505-8.03 4.704-12.526 7.263 9.25 11.701 18.112 23.035 27.11 34.26a3609.788 3609.788 0 0 0 29.112 35.86c8.138 9.89 16.635 19.49 24.616 29.502 6.982 8.76 13.775 17.707 20.062 26.971 4.012 5.912 3.025 7.515-3.738 9.7-.354.114-.787.29-.973.573-6.642 10.194-16.17 2.616-24.255 3.869-1.128.174-2.665-.473-3.609-1.239-3.769-3.056-8.362-3.448-12.661-4.91-5.686-1.932-10.866-6.635-15.12-11.21-7.54-8.105-14.298-16.946-21.238-25.596a10563.583 10563.583 0 0 1-43.85-55c-5.046-6.376-9.819-12.97-15.361-20.318-1.516 9.062-2.89 17.047-4.18 25.046-1.577 9.77-2.946 19.577-4.68 29.32-.866 4.86-4.9 4.423-8.605 4.403-4.719-.025-9.446.371-14.156.2-5.527-.202-11.268.005-16.5-1.458-6.934-1.94-8.108-6.182-6.702-15.033 1.765-11.103 3.074-22.277 4.626-33.414.668-4.796 1.698-9.558 2.05-14.372.12-1.664-1.015-3.668-2.107-5.117-1.894-2.514-4.59-4.472-6.241-7.107-2.409-3.846-.42-8.147 3.981-9.06 5.579-1.155 8.25-4.408 9.156-10.017 2.917-18.06 6.11-36.076 9.282-54.094.93-5.278 2.147-10.505 3.107-15.148C19.77 79.08 11.817 72.161 4.13 64.958c-5.844-5.474-5.542-13.236 1.273-17.276 10.191-6.04 20.597-11.949 31.5-16.506 14.902-6.23 30.825-8.16 46.95-9.738 14.424-1.412 27.493.474 40.018 7.308 2.439 1.33 4.99 2.718 6.942 4.636 12.308 12.092 26.422 22.847 34.762 38.2 8.147 14.998 5.894 30.651-2.806 44.957-11.222 18.452-28.42 30.649-46.122 42.166-1.72 1.119-3.4 2.298-5.4 3.755m-39.363-42.343-1.814 9.765c.852 0 1.57.229 1.96-.033 17.167-11.488 35.119-22.05 48.735-37.994 7.024-8.225 12.545-17.378 10.659-29.474-16.661-5.222-32.87-.758-48.379 2.062-3.48 17.846-6.756 34.68-10.068 51.509-.214 1.085-.718 2.113-1.093 4.165Z",
      fill: "#093B5E"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M313.169 122.757c-10.278 17.949-20.652 35.38-30.103 53.297-8.416 15.955-15.943 32.387-23.6 48.732-3.693 7.884-6.931 15.994-10.096 24.11-2.176 5.583-7.443 3.17-10.837 3.752-8.727 1.496-17.787 1.643-26.685 1.369-7.255-.224-13.899-2.606-17.062-10.393-.438-1.079-2.921-1.16-4.045-2.166-1.834-1.64-4.751-3.663-4.747-5.519.047-22.147.535-44.293.94-66.439.36-19.655 1.324-39.32.968-58.96-.295-16.235-1.524-32.517-3.51-48.633-1.18-9.59-1.89-19.934-11.413-28.14 7.246-3.497 13.767-6.706 20.34-9.803 8.703-4.101 18.206-4.686 27.17-2.928C233 23.49 239.479 33.284 241.98 45.051c3.729 17.539 1.85 35.28.205 52.938-.017.19-.028.383-.028.574l-.001 47.793c1.136-.984 2.687-1.85 3.57-3.165 11.74-17.467 22.967-35.295 35.162-52.436 15.093-21.215 30.843-41.968 46.565-62.727 6.689-8.832 14.066-17.14 21.045-25.756 2.696-3.329 4.893-2.808 7.274.316.923 1.212 2.371 2.01 3.433 3.135.954 1.012 2.431 2.214 2.431 3.332.002 7.765-1.287 15.649-.346 23.27 2.224 18.023-10.428 29.404-18.187 42.832-9.301 16.097-19.704 31.557-29.935 47.6Z",
      fill: "#093B5E"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M454.98 41.66c-.823-5.635 1.575-9.134 6.403-9.374 9.946-.495 19.952-.49 29.896.02 4.424.228 6.447 3.402 6.378 8.383-.27 19.745-.111 39.496-.111 59.245v6.844c2.338-1.464 3.724-2.194 4.957-3.126 20.6-15.577 50.677-16.347 69.84.8 9.427 8.436 14.534 20.282 14.822 33.151.731 32.7.682 65.417 1.44 98.116.146 6.301-3.263 9.592-7.755 9.908-9.612.674-19.351-.049-29.012-.634-5.698-.345-7.197-4.345-7.175-9.598.111-26.842.161-53.686-.028-80.527-.046-6.598-1.723-12.71-6.198-18.23-6.311-7.786-18.913-7.413-27.807.424-4.018 3.541-7.854 7.352-11.315 11.429-1.27 1.495-1.69 4.109-1.698 6.215-.108 26.843-.07 53.686-.072 80.529 0 8.234-2.042 10.597-10.1 10.837-7.47.222-14.97.352-22.426-.048-6.102-.328-10.236-2.825-10.202-10.56.286-64.422.163-128.846.163-193.804ZM866.015 233.216c-14.553-13.032-19.341-29.646-21.264-48.059-1.582-15.14-.158-29.671 3.641-44.204 6.832-26.135 28.009-44.85 54.997-48.034 12.457-1.47 24.425-.867 36.385 2.468 17.466 4.872 29.625 15.782 36.279 32.57 5.087 12.835 6.508 26.381 5.714 40.041-.52 8.97-3.126 14.959-15.6 14.888-23.763-.136-47.529-.04-71.294-.04h-5.576c-1.59 17.2 8.416 28.215 22.428 31.045 16.71 3.374 32.45-1.025 48.074-6.19 1.599-.528 3.113-1.371 4.741-1.742 6.442-1.468 10.26 1.591 10.427 8.288.072 2.873-.095 5.754.03 8.623.626 14.321-2.17 16.814-15.33 20.206-13.919 3.588-28.529 5.996-42.858 6.105-18.053.137-36.013-2.94-50.794-15.965M928.8 128.198c-19.353-9.33-36.879-.594-39.888 23.862h49.293c-1.145-8.293-.278-17.482-9.405-23.862ZM676.583 127.656c-13.204-3.284-25.074.261-36.752 4.724-3.994 1.527-7.72 3.756-11.557 5.689-8.65 4.36-14.312 2.584-15.873-6.868-2.464-14.912-2.944-22.777 11.996-28.908 6.036-2.478 12.094-5.096 18.38-6.734 18.591-4.841 37.337-5.037 55.968-.117 18.734 4.947 31.477 18.536 32.126 38.127 1.152 34.784.952 69.613 1.395 104.421.072 5.765-3.85 7.659-8.253 7.986-7.054.524-14.183.337-21.267.085-6.961-.246-7.545-5.485-7.421-11.523-12.295 10.471-26.208 15.33-41.432 14.855-14.93-.467-29.165-4.092-39.653-16.045-5.7-6.498-8.824-14.134-9.775-22.814-.93-8.485-.503-16.717 2.236-24.834 4.326-12.82 13.93-19.969 25.958-24.733 12.813-5.076 26.253-6.316 39.814-6.846 5.515-.216 11.046-.036 16.478-.036 2.187-11.681-2.02-24.253-12.368-26.43m-8.93 56.343c-3.616.858-7.584 1.044-10.775 2.713-6.887 3.604-10.777 7.301-9.806 17.257.525 5.384 4.789 11.087 10.203 12.049 15.915 2.828 38.93-8.375 31.428-32.02h-21.05ZM334.454 154.698c-5.233-18.678-2.995-35.224 11.563-48.624 7.98-7.344 17.93-10.887 28.324-12.868 13.383-2.55 26.73-1.432 39.792 2.3 3.924 1.121 7.724 2.858 11.372 4.72 4.232 2.161 6.173 6.311 6.301 10.704.177 6.028-.222 12.133-1.056 18.11-.716 5.136-4.426 6.443-9.533 4.647-9.135-3.214-18.21-7.069-27.65-8.758-5.2-.93-11.771.803-16.504 3.487-6.425 3.645-4.871 12.961 2.5 16.46 12 5.695 24.486 10.385 36.394 16.254 11.69 5.761 20.367 15.137 22.418 28.144 2.468 15.652 1.096 31.316-11 43.39-7.682 7.668-17.485 12.337-28.138 14.507-18.837 3.837-37.38 2.754-55.38-4.5-6.806-2.744-12.617-7.218-12.03-16.343.308-4.8-.04-9.636.078-14.452.175-7.194 4.98-10.12 11.506-7.178 7.17 3.231 14.198 6.898 21.606 9.451 7.732 2.666 16.02 3.576 23.593-.413 3.097-1.63 6.375-4.84 7.392-8.027 1.36-4.261.537-9.137-4.73-11.465-8.532-3.771-16.958-7.795-25.575-11.36-11.221-4.641-21.195-10.805-27.918-21.246-1.293-2.01-2.095-4.335-3.325-6.94ZM813.002 135.618c-4.07 3.595-7.95 6.874-11.276 10.642-4.012 4.544-6.502 9.53-6.383 16.207.427 23.936-.014 47.886.26 71.826.104 9.131-2.98 10.708-11.011 11.637-7.561.874-15.323.533-22.958.08-6.27-.372-10.05-3.198-10-10.156.316-43.478.156-86.96.163-130.441 0-7.181 2.02-9.55 9.2-9.942 5.755-.314 11.639-.802 17.289.014 11.012 1.592 10.96 1.948 11.83 14.218 2.873-2.538 5.369-4.448 7.519-6.69 10.343-10.784 22.827-13.145 36.815-9.447 6.7 1.77 9.147 4.743 9.265 12.687.117 7.95-.402 15.937-1.132 23.863-.513 5.58-4.739 7.841-10.329 6.097-6.22-1.94-12.367-5.217-19.252-.595Z",
      fill: "#39A06A"
    })));
  },
  gC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "rvshare-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M95.832 162.015c-3.588 2.16-6.917 4.058-10.79 6.265 7.969 10.093 15.603 19.87 23.354 29.55a3112.84 3112.84 0 0 0 25.078 30.932c7.01 8.53 14.33 16.81 21.205 25.446 6.015 7.556 11.866 15.273 17.282 23.264 3.456 5.1 2.606 6.482-3.22 8.366-.305.099-.678.25-.838.495-5.722 8.793-13.93 2.257-20.894 3.337-.972.15-2.296-.408-3.109-1.069-3.247-2.636-7.204-2.974-10.907-4.235-4.898-1.666-9.36-5.722-13.026-9.668-6.494-6.992-12.316-14.618-18.294-22.078a9109.626 9109.626 0 0 1-37.774-47.44c-4.347-5.5-8.458-11.187-13.233-17.525-1.306 7.816-2.489 14.704-3.6 21.603-1.36 8.427-2.538 16.886-4.032 25.289-.746 4.193-4.222 3.815-7.412 3.798-4.065-.022-8.138.32-12.195.173-4.761-.174-9.707.004-14.213-1.258-5.974-1.672-6.986-5.332-5.774-12.966 1.52-9.577 2.648-19.215 3.985-28.822.575-4.136 1.463-8.243 1.765-12.396.104-1.435-.874-3.164-1.814-4.414-1.632-2.168-3.955-3.857-5.377-6.13-2.075-3.317-.362-7.027 3.43-7.814 4.805-.996 7.106-3.802 7.887-8.64 2.513-15.578 5.263-31.118 7.996-46.659.8-4.552 1.85-9.06 2.677-13.065-6.958-6.257-13.81-12.226-20.432-18.438-5.035-4.722-4.774-11.417 1.097-14.901 8.779-5.211 17.743-10.307 27.135-14.238 12.837-5.373 26.553-7.038 40.445-8.399 12.425-1.218 23.682.41 34.472 6.304 2.101 1.147 4.298 2.344 5.98 3.998 10.603 10.43 22.762 19.707 29.946 32.949 7.018 12.937 5.077 26.438-2.418 38.778-9.666 15.915-24.482 26.436-39.73 36.37-1.482.965-2.93 1.982-4.652 3.238m-33.91-36.522-1.562 8.423c.734 0 1.353.197 1.689-.029 14.788-9.908 30.252-19.019 41.982-32.772 6.05-7.094 10.806-14.988 9.182-25.422-14.353-4.504-28.317-.654-41.675 1.778-3 15.393-5.82 29.914-8.674 44.43-.184.935-.618 1.822-.942 3.592Z",
      fill: "#093B5E"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M270.123 127.788c-8.88 15.468-17.843 30.489-26.009 45.93-7.271 13.75-13.774 27.91-20.39 41.995-3.19 6.794-5.988 13.783-8.722 20.778-1.88 4.81-6.431 2.732-9.364 3.233-7.54 1.29-15.368 1.415-23.055 1.18-6.27-.193-12.009-2.246-14.742-8.957-.379-.93-2.524-1-3.495-1.866-1.584-1.414-4.105-3.157-4.102-4.756.042-19.086.463-38.17.813-57.255.31-16.938 1.144-33.884.836-50.81-.255-13.991-1.316-28.022-3.032-41.91-1.02-8.264-1.634-17.18-9.861-24.25 6.26-3.014 11.894-5.78 17.574-8.449 7.519-3.534 15.73-4.038 23.474-2.523 10.81 2.115 16.407 10.555 18.569 20.695 3.222 15.115 1.599 30.404.178 45.62-.016.165-.025.33-.025.495v41.187c.98-.848 2.32-1.595 3.084-2.727 10.143-15.053 19.843-30.417 30.38-45.189 13.04-18.282 26.648-36.166 40.232-54.056 5.779-7.61 12.153-14.77 18.182-22.195 2.33-2.869 4.228-2.42 6.285.272.798 1.045 2.05 1.732 2.966 2.702.825.872 2.101 1.908 2.101 2.871.002 6.692-1.112 13.486-.3 20.054 1.922 15.531-9.009 25.34-15.713 36.91-8.036 13.873-17.024 27.196-25.864 41.02Z",
      fill: "#39A06A"
    })));
  },
  vC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 946 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "vrbo-logo"), /*#__PURE__*/e.createElement("g", {
      fill: "#245ABC",
      fillRule: "nonzero"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M857.85 100.836v.468c60.284 5.07 77.987 47.884 77.129 72.762-1.404 72.059-57.242 130.08-147.316 137.178v.39c98.964-5.927 156.908-57.086 158.156-130.394-.156-26.983-19.809-76.426-87.969-80.404Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M787.663 310.386c76.177-5.105 135.88-67.48 137.645-143.807 0-22.772-15.597-60.206-68.004-64.417v.39c43.36 4.601 58.646 36.186 58.334 56.852-1.248 69.486-55.136 143.105-127.508 150.514l-.467.468Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M788.286 309.06c64.027-6.629 115.576-88.982 116.98-157.22 0-18.483-11.776-44.297-48.352-48.43v.468c28.777 4.367 38.994 24.41 38.994 40.865-1.17 66.834-51.393 156.518-106.53 163.771l-1.092.546Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M789.144 307.266v.546c46.792-6.785 95.066-105.125 96.235-170.634.672-16.887-12.226-31.237-29.088-32.364v.468c11.858 1.992 20.142 12.834 18.95 24.8-1.793 64.026-48.585 170.244-86.097 177.184Zm-29.4-25.423c1.091-61.61 49.677-169.855 85.784-177.185v-.546c-45.232 6.707-95.221 106.763-96.39 170.244a30.649 30.649 0 0 0 29.166 32.91v-.468a21.836 21.836 0 0 1-18.56-24.955Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M739.857 267.181c1.17-65.118 53.499-156.518 106.685-163.771v-.468c-62.389 6.629-115.654 90.23-116.98 156.753 0 18.56 12.167 46.012 48.352 48.975v-.468c-28.23-3.665-38.37-24.566-38.057-41.02Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M719.97 252.52c1.17-68.238 56.774-143.105 127.196-150.514v-.468c-75.417 6.34-134.337 67.8-137.49 143.417 0 22.772 15.597 61.454 68.082 64.885v-.468c-45.232-4.055-58.1-36.42-57.788-56.852Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M700.084 237.858c1.248-71.669 63.013-130.315 147.706-137.1v-.468c-94.831 5.85-156.909 57.009-158.156 130.004-.546 26.983 19.184 76.894 87.266 80.794-59.425-4.68-77.206-48.352-76.816-73.23ZM651.888 101.85c-32.676-4.445-72.137 14.74-94.363 48.43l.39.546c21.056-30.259 56.618-48.274 85.785-44.219 19.652 2.652 33.144 17.547 30.414 46.792-6.94 74.477-69.72 158.157-170.166 157.923v.546c92.99 3.575 172.778-65.668 182.332-158.235 2.73-32.286-12.244-48.741-34.392-51.783Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M662.338 153.087c2.418-25.657-9.046-38.993-27.06-41.41-25.97-3.51-57.555 12.321-76.662 40.162l.39.468c17.547-24.02 45.622-38.993 68.16-35.873 15.598 2.105 25.892 13.803 23.396 36.42-6.005 64.104-67.146 152.229-146.302 157.142 88.437-.078 151.528-87.033 158.078-156.909Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M505.352 308.436v.468c73.697-8.812 128.287-98.34 134.136-156.363 1.716-19.028-7.018-29.167-20.042-31.194-19.653-2.73-44.14 10.528-59.27 31.74v.468c14.428-18.639 34.548-29.713 50.457-27.529 11.23 1.56 18.093 10.06 16.612 25.58-4.914 52.874-55.059 142.87-121.893 156.83Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M506.21 306.642v.702c54.59-14.661 105.203-109.18 109.18-155.972 1.092-11.932-4.21-18.951-12.945-20.12-13.024-1.795-29.557 7.798-41.645 23.395v.468c10.06-12.01 23.396-20.51 33.144-19.185 6.317.858 10.45 6.395 9.593 15.208-3.042 40.864-49.834 135.228-97.327 155.504Zm-8.579-53.108a163.07 163.07 0 0 0-12.322 39.929 14.895 14.895 0 0 0 7.799 12.634c.751.378 1.534.691 2.34.935v-.701a9.28 9.28 0 0 1-2.652-8.423 198.32 198.32 0 0 1 14.116-40.553L608.294 0l-14.272 2.808c.78 3.275-26.593 70.577-27.685 73.93l-68.706 176.796Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M478.992 245.501a174.456 174.456 0 0 0-11.074 38.447c-1.247 14.116 11.074 21.759 27.608 24.254v-.468c-11.309-2.027-20.043-7.798-19.03-18.716a197.695 197.695 0 0 1 11.855-38.994l67.536-173.753c1.638-4.602 27.295-66.679 23.396-70.656L565.4 8.423v.78c.546 15.129-17 56.54-20.588 66.288l-65.82 170.01Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M523.757 74.633 460.12 237.547a149.188 149.188 0 0 0-10.762 35.951c-1.716 19.887 14.583 33.612 45.076 35.718a79.546 79.546 0 0 1-18.405-4.29c-11.536-2.8-19.146-13.796-17.703-25.579a156.519 156.519 0 0 1 11.386-37.59l64.885-166.734c3.275-8.813 21.836-50.925 17.39-63.793l-13.413 2.652v.78c7.33 10.06-10.528 49.053-14.817 59.971Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M500.673 77.986 441.87 229.592a125.324 125.324 0 0 0-9.826 33.846c-2.106 24.878 19.496 45.232 62.389 46.792-35.952-2.028-55.527-19.029-53.577-41.489a131.173 131.173 0 0 1 10.294-34.782l60.752-155.973c5.459-14.271 21.602-49.287 12.867-60.985l-13.803 2.808v.78c9.358 12.867-4.055 41.8-10.294 57.397Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M493.81 311.166c-48.43-2.106-72.84-25.736-70.188-53.187a116.98 116.98 0 0 1 8.89-31.818l56.073-144.9c7.018-18.092 20.12-45.387 9.826-58.879l-12.712 2.652v.78c10.84 12.165.78 32.13-6.629 52.328l-55.838 143.495a103.488 103.488 0 0 0-8.656 31.195c-2.652 29.869 23.941 56.93 79.078 58.568l.156-.234Zm-63.793-182.644c-1.014-19.263-12.4-28.076-26.203-28.076-25.112 0-46.792 19.809-60.44 46.792v-9.514c-1.092-20.978-15.597-37.278-41.41-37.278-54.591 0-81.496 35.952-90.465 76.661h.468c9.514-38.135 34.938-72.527 83.991-72.527a34.314 34.314 0 0 1 37.356 33.612c1.326 24.722-6.863 43.984-15.597 66.21l-39.774 103.956h10.607l39.773-103.098c2.651-7.097 5.147-13.725 7.408-20.12 7.799-16.377 17.547-33.145 22.616-33.145 3.744 0 4.914 3.198 5.148 6.083a87.969 87.969 0 0 1-11.776 44.219l.468.468a82.198 82.198 0 0 0 20.51-49.132c0-5.38-2.652-9.202-7.799-9.202-8.5 0-19.34 17.469-27.295 35.952.936-2.964 1.716-5.927 2.496-8.813 8.5-18.483 20.276-34.236 31.194-34.236 6.707 0 10.762 4.601 11.152 12.166.936 18.405-15.597 45.232-29.479 54.044l.468.468c18.873-8.422 39.617-36.107 38.448-58.723-.546-10.06-5.85-15.598-14.272-15.598-13.881 0-27.295 16.144-36.576 36.108 0-1.56.624-3.12.858-4.757 10.373-21.446 25.58-38.447 42.503-38.447 9.202 0 16.221 6.239 16.845 18.404 1.482 26.828-23.864 55.37-46.792 63.715l.468.468c28.153-7.175 57.554-37.355 55.916-68.394-.78-14.661-9.124-21.758-19.964-21.758-19.497.078-36.888 17.547-47.728 40.943v-3.822c12.4-25.111 31.975-44.14 54.59-44.14 12.166 0 22.227 7.799 23.396 24.8 1.872 35.64-31.194 65.82-64.884 73.385l.468.39c38.993-5.927 75.413-38.213 73.307-78.064Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M323.566 138.972a31.195 31.195 0 0 0-33.457-30.57c-43.516 0-68.55 32.363-77.362 68.705h.546c9.67-33.846 31.818-64.495 70.733-64.495a26.983 26.983 0 0 1 29.48 26.828c1.091 20.51-8.58 43.126-16.3 63.715l-41.02 105.203h10.917l40.163-104.346c8.579-21.446 17.47-42.814 16.3-65.04Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M304.147 139.83a23.396 23.396 0 0 0-25.58-23.396c-34.158 0-55.058 29.479-64.104 60.751h.467c9.593-29.089 29.245-56.54 57.632-56.54a19.965 19.965 0 0 1 21.369 19.73c.858 16.3-10.372 42.737-17.781 61.22l-42.19 106.763h11.307l41.411-106.061c7.33-19.263 18.249-43.595 17.469-62.467Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M284.26 141.077a16.221 16.221 0 0 0-17.625-16.299c-23.395 0-42.034 25.424-50.925 52.33h.546c9.28-24.02 25.19-48.197 44.297-48.197a12.244 12.244 0 0 1 13.647 12.634c.702 12.946-12.4 42.347-18.639 58.646l-43.36 108.167h10.84l42.58-107.31c7.331-17.156 19.42-45.075 18.64-59.97Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M264.608 142.325a8.968 8.968 0 0 0-9.67-9.748c-13.804 0-28.7 21.758-37.668 44.374h.546c9.046-20.12 23.006-40.24 31.195-40.24 3.353 0 5.537 1.715 5.77 5.926.468 8.813-14.193 41.879-20.12 56.15l-44.14 109.181h10.918l43.75-108.557c6.161-15.13 19.965-46.558 19.419-57.086Zm-119.241 92.57 7.018-14.74L128.6 98.81c-6.63-34.158 1.325-49.054 28.153-54.2v-.469h-24.8c-7.175 3.588-22.382 14.35-13.882 54.59l27.296 136.165Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m131.33 264.218 6.94-14.662L107.075 98.03c-5.849-29.401-3.353-44.686 6.395-53.42v-.469H96.625c-5.147 10.996-6.707 21.992-.78 51.081l35.484 168.997Zm-14.35 29.245 6.94-14.506L84.927 94.831c-6.863-28.62-5.303-41.722-2.495-50.69H67.536a167.359 167.359 0 0 0 5.927 45.855l43.517 203.467ZM53.889 44.14H36.342v.468C44.14 54.123 46.48 65.743 52.719 91.4L99.51 308.436h10.528L63.247 90.698a398.354 398.354 0 0 1-9.358-46.558Zm-35.094 0H0v.468c17.157 6.785 25.58 19.809 32.364 50.301L78.61 308.36h10.528L42.581 93.583c-8.033-37.278-16.456-44.14-23.786-49.444Zm239.106 0c-22.148 12.946-35.328 36.888-62.935 96.235l.702.39c31.896-59.737 50.067-83.523 91.244-95.923v-.702H257.9Zm-64.495 95.066.702.468c26.204-61.688 33.066-78.923 43.75-95.066v-.468h-21.212v.624c2.184 24.722-6.083 47.494-23.24 94.442Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m192.002 138.27.702.468c16.611-55.293 21.993-79.702 7.331-94.598H179.37v.468c23.396 8.267 28.23 31.897 12.633 93.662Z"
    })));
  },
  CC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "vrbo-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fill: "#245ABC",
      fillRule: "nonzero"
    }, /*#__PURE__*/e.createElement("path", {
      d: "m158.078 219.435 7.632-16.029L139.845 71.45c-7.209-37.145 1.441-53.343 30.614-58.94V12h-26.968c-7.802 3.901-24.34 15.604-15.095 59.364l29.682 148.07Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m142.813 251.322 7.547-15.944-33.922-164.777c-6.36-31.972-3.646-48.594 6.954-58.092V12h-18.318c-5.597 11.958-7.293 23.915-.848 55.548l38.587 183.774Zm-15.605 31.802 7.548-15.774L92.353 67.124C84.89 36 86.587 21.753 89.64 12H73.442c-.17 16.84 2 33.622 6.445 49.866l47.321 221.258ZM58.601 12H39.519v.509C48 22.855 50.544 35.49 57.33 63.392l50.883 236.014h11.449L68.777 62.63A433.187 433.187 0 0 1 58.601 12Zm-38.163 0H0v.509c18.657 7.378 27.816 21.54 35.194 54.7l50.29 232.113h11.449L46.303 65.767C37.57 25.23 28.41 17.767 20.439 12Zm260.014 0c-24.085 14.078-38.417 40.113-68.438 104.65l.763.424c34.686-64.96 54.446-90.827 99.223-104.31V12h-31.548Zm-70.134 103.378.763.509c28.495-67.081 35.958-85.823 47.576-103.378V12H235.59v.678c2.375 26.884-6.615 51.647-25.272 102.7Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m208.792 114.36.763.51C227.618 54.741 233.47 28.197 217.527 12h-22.474v.509c25.442 8.99 30.7 34.685 13.739 101.851Z"
    })));
  },
  bC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "agoda-logo-icon"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 0h46.316v46.316H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "c",
      d: "M0 0h46.316v46.316H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "e",
      d: "M0 0h46.316v46.316H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "g",
      d: "M0 0h46.316v46.316H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "i",
      d: "M0 0h46.316v46.316H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "k",
      d: "M0 0h53.951v73.801H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "m",
      d: "M0 0h53.951v52.933H0z"
    })), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("g", {
      transform: "translate(68.202 189.483)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M23.156 0C10.386 0 0 10.388 0 23.158c0 12.77 10.385 23.159 23.156 23.159 12.774 0 23.16-10.388 23.16-23.159C46.316 10.388 35.93 0 23.156 0",
      fill: "#FCB615",
      mask: "url(#b)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(3.563 189.483)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "d",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#c"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M23.162 0C10.384 0 0 10.388 0 23.158c0 12.77 10.384 23.159 23.162 23.159 12.765 0 23.154-10.388 23.154-23.159C46.316 10.388 35.927 0 23.162 0",
      fill: "#EE363F",
      mask: "url(#d)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(132.842 189.483)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "f",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#e"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M23.162 0C10.392 0 0 10.388 0 23.158c0 12.77 10.391 23.159 23.162 23.159 12.766 0 23.154-10.388 23.154-23.159C46.316 10.388 35.928 0 23.162 0",
      fill: "#05B057",
      mask: "url(#f)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(261.612 189.483)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "h",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#g"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M23.164 0C10.399 0 0 10.388 0 23.158c0 12.77 10.4 23.159 23.164 23.159 12.767 0 23.152-10.388 23.152-23.159C46.316 10.388 35.931 0 23.164 0",
      fill: "#03A9E0",
      mask: "url(#h)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(196.972 189.483)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "j",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#i"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M23.161 0C10.387 0 0 10.388 0 23.158c0 12.774 10.387 23.159 23.157 23.159s23.16-10.385 23.16-23.159C46.316 10.388 35.933 0 23.16 0",
      fill: "#A1479A",
      mask: "url(#j)"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M0 124.542c0-14.906 12.059-26.165 26.976-26.165 15.026 0 26.975 11.154 26.975 26.065v22.91c0 2.332-1.635 3.958-4.094 3.958-2.553 0-4.081-1.626-4.081-3.957v-6.701h-.409c-3.169 5.386-9.497 10.045-18.904 10.045C11.955 150.697 0 139.543 0 124.542m45.982 0c0-10.757-8.178-18.853-19.006-18.853s-19.011 8.096-19.011 18.853c0 10.747 8.183 18.844 19.011 18.844s19.006-8.097 19.006-18.844M75.064 167.806c-2.146-1.024-3.165-2.856-2.355-4.982.815-2.234 2.86-3.154 5.013-2.141a31.319 31.319 0 0 0 13.18 2.945c12.158 0 19.52-7.215 19.52-19.51v-3.358h-.409c-3.166 5.395-9.506 10.066-18.909 10.066-14.513 0-26.465-11.182-26.465-26.222 0-14.944 12.056-26.227 26.979-26.227 15.02 0 26.973 11.177 26.973 26.126v19.103c0 16.468-10.623 27.554-27.995 27.554-5.318 0-10.633-1.015-15.532-3.354m35.557-43.202c0-10.78-8.175-18.902-19.003-18.902-10.834 0-19.013 8.121-19.013 18.902 0 10.774 8.179 18.897 19.013 18.897 10.828 0 19.003-8.123 19.003-18.897M128.77 124.594c0-14.935 11.958-26.217 26.978-26.217 15.015 0 26.973 11.282 26.973 26.217 0 14.935-11.958 26.207-26.973 26.207-15.02 0-26.978-11.272-26.978-26.207m45.983 0c0-10.778-8.18-18.891-19.005-18.891-10.832 0-19.008 8.113-19.008 18.89 0 10.77 8.176 18.882 19.008 18.882 10.825 0 19.005-8.113 19.005-18.881",
      fill: "#5A5B5B"
    }), /*#__PURE__*/e.createElement("g", {
      transform: "translate(193.41 77)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "l",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#k"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M0 47.322c0-15.09 11.856-26.49 26.472-26.49 9.398 0 15.733 4.727 18.898 10.17h.414V4.01c0-2.366 1.635-4.01 4.09-4.01 2.553 0 4.077 1.644 4.077 4.01v43.413c0 15.086-11.95 26.378-26.97 26.378C12.058 73.801 0 62.411 0 47.321m45.986 0c0-10.89-8.175-19.086-19.006-19.086-10.833 0-19.004 8.197-19.004 19.087 0 10.88 8.17 19.077 19.004 19.077 10.831 0 19.006-8.197 19.006-19.077",
      fill: "#5A5B5B",
      mask: "url(#l)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(258.049 98.377)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "n",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#m"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M0 26.165C0 11.26 12.065 0 26.973 0c15.02 0 26.979 11.154 26.979 26.065v22.91c0 2.332-1.642 3.958-4.09 3.958-2.553 0-4.093-1.626-4.093-3.957v-6.7h-.41C42.195 47.66 35.865 52.32 26.46 52.32 11.955 52.32 0 41.167 0 26.165m45.975 0c0-10.757-8.164-18.853-19.002-18.853-10.828 0-19.001 8.096-19.001 18.853 0 10.747 8.173 18.844 19 18.844 10.839 0 19.003-8.097 19.003-18.844",
      fill: "#5A5B5B",
      mask: "url(#n)"
    }))));
  },
  EC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 948 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "agoda-logo"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 0h91v91H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "c",
      d: "M0 0h91v91H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "e",
      d: "M0 0h91v91H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "g",
      d: "M0 0h91v91H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "i",
      d: "M0 0h91v91H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "k",
      d: "M0 0h106v145H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "m",
      d: "M0 0h106v104H0z"
    })), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("g", {
      transform: "translate(302 221)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M45.496 0C20.405 0 0 20.41 0 45.5 0 70.591 20.405 91 45.496 91 70.593 91 91 70.591 91 45.5 91 20.41 70.593 0 45.496 0",
      fill: "#FCB615",
      mask: "url(#b)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(175 221)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "d",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#c"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M45.508 0C20.401 0 0 20.41 0 45.5 0 70.591 20.401 91 45.508 91 70.588 91 91 70.591 91 45.5 91 20.41 70.588 0 45.508 0",
      fill: "#EE363F",
      mask: "url(#d)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(429 221)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "f",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#e"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M45.508 0C20.416 0 0 20.41 0 45.5 0 70.591 20.416 91 45.508 91 70.589 91 91 70.591 91 45.5 91 20.41 70.59 0 45.508 0",
      fill: "#05B057",
      mask: "url(#f)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(682 221)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "h",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#g"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M45.51 0C20.433 0 0 20.41 0 45.5 0 70.591 20.432 91 45.51 91 70.595 91 91 70.591 91 45.5 91 20.41 70.594 0 45.51 0",
      fill: "#03A9E0",
      mask: "url(#h)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(555 221)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "j",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#i"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M45.505 0C20.408 0 0 20.41 0 45.5 0 70.596 20.408 91 45.497 91 70.587 91 91 70.596 91 45.5 91 20.41 70.6 0 45.505 0",
      fill: "#A1479A",
      mask: "url(#j)"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M168 93.408C168 64.122 191.692 42 221.001 42 250.523 42 274 63.915 274 93.21v45.015c0 4.58-3.212 7.775-8.043 7.775-5.016 0-8.02-3.195-8.02-7.775V125.06h-.802c-6.226 10.582-18.66 19.736-37.143 19.736-28.504 0-51.992-21.914-51.992-51.388m90.343 0c0-21.135-16.068-37.042-37.342-37.042-21.274 0-37.352 15.907-37.352 37.042 0 21.115 16.078 37.023 37.352 37.023 21.274 0 37.342-15.908 37.342-37.023M315.481 178.411c-4.216-2.012-6.218-5.611-4.627-9.789 1.602-4.389 5.62-6.196 9.85-4.207 7.228 3.406 16.252 5.787 25.895 5.787 23.887 0 38.354-14.175 38.354-38.332v-6.597h-.806c-6.22 10.598-18.677 19.776-37.15 19.776-28.515 0-51.997-21.97-51.997-51.52C295 64.169 318.686 42 348.005 42 377.518 42 401 63.96 401 93.331v37.532C401 163.22 380.13 185 345.998 185c-10.449 0-20.892-1.994-30.517-6.589m69.86-84.882c0-21.18-16.06-37.137-37.336-37.137-21.286 0-37.355 15.956-37.355 37.137 0 21.17 16.069 37.129 37.355 37.129 21.276 0 37.337-15.96 37.337-37.13M421 93.51C421 64.165 444.494 42 474.005 42 503.505 42 527 64.166 527 93.51c0 29.343-23.494 51.49-52.995 51.49C444.495 145 421 122.853 421 93.51m90.344 0c0-21.177-16.072-37.116-37.339-37.116-21.283 0-37.347 15.939-37.347 37.115 0 21.158 16.064 37.097 37.347 37.097 21.267 0 37.34-15.939 37.34-37.097",
      fill: "#5A5B5B"
    }), /*#__PURE__*/e.createElement("g", {
      transform: "translate(548)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "l",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#k"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M0 92.975C0 63.327 23.295 40.93 52.011 40.93c18.464 0 30.911 9.287 37.13 19.98h.813V7.879c0-4.647 3.212-7.88 8.035-7.88 5.016 0 8.011 3.233 8.011 7.88v85.296C106 122.814 82.52 145 53.01 145 23.691 145 0 122.623 0 92.975m90.351 0c0-21.396-16.062-37.5-37.342-37.5-21.284 0-37.339 16.104-37.339 37.5 0 21.377 16.055 37.481 37.34 37.481 21.279 0 37.341-16.104 37.341-37.481",
      fill: "#5A5B5B",
      mask: "url(#l)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(675 42)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "n",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#m"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M0 51.408C0 22.122 23.704 0 52.994 0c29.51 0 53.008 21.915 53.008 51.21v45.015c0 4.58-3.226 7.775-8.037 7.775-5.015 0-8.041-3.195-8.041-7.775V83.06h-.805c-6.217 10.582-18.654 19.736-37.131 19.736C23.489 102.796 0 80.882 0 51.408m90.329 0c0-21.135-16.04-37.042-37.335-37.042-21.273 0-37.332 15.907-37.332 37.042 0 21.115 16.06 37.023 37.332 37.023 21.294 0 37.335-15.908 37.335-37.023",
      fill: "#5A5B5B",
      mask: "url(#n)"
    }))));
  },
  yC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "kayak-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("path", {
      fill: "#FF690F",
      d: "M0 312h312V0H0z"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#FFF",
      d: "M95 234h38V78H95z"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#FFF",
      d: "M215 234h-41.835L130 156.007 173.165 78H215l-43.424 78.007z"
    })));
  },
  IC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 948 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "kayak-logo"), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("path", {
      fill: "#FF690F",
      d: "M0 246.527h181.534V65H0zM191.613 246.527h181.534V65H191.613zM383.232 246.527h181.534V65H383.232zM574.846 246.527h181.533V65H574.846zM766.473 246.527H948V65H766.473z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m282.044 136.37-10.618 33.883h21.235l-10.617-33.883Zm-16.055 51.709-3.948 13.062H238.5l29.937-90.767h28.035l29.798 90.767h-24.225l-3.946-13.062h-32.109ZM665.276 136.37l-10.618 33.883h21.236l-10.618-33.883Zm-16.06 51.709-3.942 13.062H621.73l29.938-90.767h28.035L709.5 201.14h-24.224l-3.947-13.062h-32.114ZM485.227 201.142h-22.048v-40.003l-29.798-50.765h26.264l14.696 27.899 14.428-27.899h25.85l-29.392 50.765zM55.466 201.141h22.047v-90.767H55.466z",
      fill: "#FFF"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#FFF",
      d: "M125.063 201.142h-24.33l-25.103-45.38 25.103-45.388h24.33L99.81 155.762zM821.932 201.141h22.048v-90.767h-22.048z"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#FFF",
      d: "M891.527 201.142h-24.33l-25.103-45.38 25.103-45.388h24.33l-25.254 45.388z"
    })));
  },
  BC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "travelocity-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M21.549 191.733c2.02-1.004 4.377-1.004 6.397-2.008-3.367-3.68-7.07-7.027-9.764-11.377-1.01-1.339-.337-1.673.336-2.008.674 0 .337-1.339.674-2.008 1.347-.334 1.347-2.008 2.02-3.011 0-.335 0-1.339.337-1.674.336-.334 1.01-.669 1.683 0 2.694 3.347 5.724 5.354 8.755 7.697 3.703 2.677 7.744 4.685 10.774 8.03.337 0 1.347.67 1.347 0 .336-3.345 1.683-6.692 3.03-9.368.337-1.004.673-2.343 1.347-3.347 1.01-2.008 3.367-3.346 5.05-4.685 3.03-1.673 6.398 0 8.755-2.677.673-.669 2.02 0 2.693 0 2.02 1.004 4.714.335 6.398 2.008-2.694 6.023-2.694 12.381-4.714 18.74-.337 1.338-1.01 3.345-.337 4.015 3.03 1.003 10.775-.335 11.112-.67 4.04 0 7.744 0 11.784 1.004 3.03.67 5.05 2.008 7.744 4.35 4.377 3.346 4.377 9.37 3.704 14.724 0 .334-2.02 2.342-2.694 2.007-.336 0-.336-1.338-.673-1.673-1.683 1.339-4.714 4.35-5.724 4.35-.337 0-2.357-2.007-3.367-2.677-3.367-2.342-7.407-1.673-11.111-1.338-4.377.335-8.754-.335-13.132 1.673 1.684 3.012 4.378 4.685 7.071 7.027 4.04 4.016 8.081 7.027 12.121 11.043 2.694 3.011 5.388 5.019 7.071 8.365-1.01.67 0 1.004-.673 1.673-.673.335-.673-1.003-1.347-1.003-.673 0-1.01 1.004-1.01 1.673.337.334-.673 2.342-1.347 2.342-.336.335-2.02 1.339-2.693 1.339-.337 0-2.357-1.004-2.357-.67.673 1.004 1.347 2.343 1.01 2.677-1.684-.334-2.694-.334-3.704-1.673-5.387-4.684-10.438-9.704-16.162-14.723-2.02-2.008-3.367-4.685-6.06-6.693-4.04 9.37-6.734 16.062-10.775 25.432-1.01 1.673-1.347 6.023-2.357 6.358-.673.334-3.03-3.012-4.377-5.69 0-5.688.674-7.695 1.01-13.718v-1.004c.337-7.697 2.694-14.39 2.357-22.42 0-.67-1.01-1.004-2.02-1.004-10.101-1.004-19.866-2.343-29.967-3.681-2.357-.335-4.714-.335-7.07-1.338-.337-.335-1.684-1.004-2.02-1.004-.337-.335-.337-.335-.674-.335 4.04-4.015 7.407-8.365 13.131-10.708 2.694 0 6.734-1.673 8.418-2.342Z",
      fill: "#F58025"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M115.418 245.478c-.669-.341-.334-1.024-.334-1.024.67-1.025 2.008-1.025 2.677-1.025 2.678-.683 5.69 0 8.368-.683.67-.342 1.004-1.025 1.339-1.025 2.008-1.025 4.016-1.366 6.36-2.05.668-.34 2.007-1.024 1.338-2.048-2.343-2.733-4.686-5.124-6.025-8.198-.67-1.708-2.008-3.074-2.008-4.782 0-1.366 1.674-1.707 3.012-1.024 6.025 3.415 10.041 8.538 14.393 14.004.67 1.024 1.673-1.367 2.008-2.391 2.008-4.44 3.347-9.564 5.69-14.004.67-1.366 1.673-3.074 3.012-3.416 2.008-.683 3.347-2.049 5.02-3.074 1.34-.683 2.343 0 3.682-.683.67-.341 2.008 1.025 3.013.683 1.673-1.024 3.012-.341 4.686 0 1.004.683 1.338 1.708 1.004 2.733-1.674 4.098-2.343 8.197-5.02 12.296-2.009 3.074-3.348 6.148-5.69 9.222 0 .341-.336 1.024.334 1.024 1.339.342 3.012 0 4.016.683 4.017 1.367 8.033 1.025 12.384 1.708 2.009.683 2.009 3.757 4.017 5.465 1.004.683-.67 1.708-2.008 2.05-3.013 1.024-6.025-.342-9.037.682-5.02 1.025-10.041 0-14.727 2.05 1.673 1.707 3.347 3.074 4.685 4.782l4.017 6.148c1.339 2.39 2.008 4.44 2.678 6.83.67 1.025.334 2.733.334 4.1-.669-.342-.669-1.367-1.004-1.709-.67 0-1.004 1.025-2.008 1.025-.67-.341-1.004-1.025-1.339-1.366-1.004-1.025-2.008-2.732-2.343-4.099-2.008-4.44-5.69-7.172-9.037-9.905-3.347 7.173-5.69 14.345-10.375 21.177-.335.683-1.005.683-2.009.683-.334-.342-.669.683-1.004.683-.334-.683-.67-.683-1.004-1.025-1.339-1.024-3.347-2.39-3.682-4.099-.67-1.707-1.339-3.074-1.339-4.781 0-.342-.669-1.025-.669-1.025.67-1.025.67-2.732 1.004-3.415.67-1.025 2.008-2.05 2.008-3.074 1.34-3.416 3.682-6.149 4.352-9.564-6.36-1.025-13.054-.683-19.413-3.074-1.339-.683-3.012-1.025-4.352-2.05-.669-2.39-.334-3.073-1.004-3.415Z",
      fill: "#003E74"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M123.796 141.333c2.02-5.062 5.388-8.099 5.725-13.836-10.777-6.073-23.574-2.362-31.656-16.534-2.021-3.037 0-17.21 1.01-18.897 2.357-5.062 7.072-5.062 11.45-1.688.337-.337 3.704.675 4.378 1.013 4.378-.675 9.092 1.012 13.807 2.024 6.062.675 11.113 3.038 16.838 2.363.337-.338 1.01-1.687 1.01-3.375-1.346-8.436-3.367-15.86-5.388-24.633-1.01-2.025-.673-4.725-1.347-6.75-.336-5.06-3.704-12.822-.673-15.184.337-.338 1.01 1.012 1.347.675 1.01-.675 1.347-2.025 2.357-1.688 10.44 7.087 19.196 17.885 28.625 28.346 3.031 3.037 3.705-5.062 6.062-7.762.674-1.35 0-4.386.674-5.399 2.357-4.387 2.694-9.786 4.714-13.835 3.704-5.062 5.725-12.823 11.113-14.848 3.705-1.012 7.746.338 11.114 4.05.673.337 2.357 0 3.367 1.012 3.705 3.374 6.735 7.761 10.777 11.81 1.347 1.688 2.02 4.725 1.347 6.075-1.01 5.736-6.062 6.074-9.093 10.123-5.725 9.449-11.787 18.897-17.512 28.345-.673 1.35-2.357 4.387-1.01 5.737 8.082 8.099 15.154 16.535 24.247 22.947 5.725 3.711 11.787 3.374 16.838 8.436 3.705 4.386 6.399 9.11 8.083 14.847-20.543 13.16-43.78-8.436-65.67-8.099-1.683.338-1.346 2.7-1.346 3.713 1.01 9.448 2.694 18.559 3.704 27.67.337 6.411 3.704 12.823 4.715 18.897.336 2.362 2.357 8.436-.674 8.098-3.367 0-8.082-1.012-10.44-6.41-3.03-7.087-6.061-14.511-8.418-22.272-.337-2.362-1.348-4.387-.337-6.412.336-3.712-2.021-7.086-3.031-9.786-.674-1.35-2.02.675-3.031 1.35-3.031 4.05-6.062 7.761-8.756 12.486-5.051 7.086-10.776 11.473-17.512 14.51-5.051 2.025-12.46 3.037-15.828-4.725 1.684-.337 3.031-4.049 2.02-5.061-7.745-11.81 3.032-18.897 6.4-27.333Z",
      fill: "#7BAED4"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M290.88 275c-14.309 0-23.847-3.03-25.55-17.166v-71.02H250v-14.136h15.33v-27.6L284.406 137v35.678h24.527l-3.747 14.136h-20.44v68.664c0 2.692 1.363 5.385 10.56 5.385 4.77 0 8.517-.337 14.65-1.346l2.043-.337-3.747 14.136h-.682c-5.45 1.01-9.538 1.684-16.692 1.684Z",
      fill: "#003E74"
    })));
  },
  xC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 948 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "travelocity-logo"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M18.135 173.574c1.7-.847 3.684-.847 5.384-1.695-2.833-3.108-5.95-5.934-8.218-9.607-.85-1.13-.283-1.413.284-1.696.567 0 .283-1.13.567-1.696 1.133-.282 1.133-1.695 1.7-2.543 0-.282 0-1.13.283-1.412.283-.283.85-.566 1.417 0 2.267 2.825 4.817 4.52 7.367 6.499 3.117 2.26 6.518 3.956 9.068 6.781.283 0 1.133.566 1.133 0 .284-2.825 1.417-5.65 2.55-7.911.284-.848.567-1.979 1.134-2.826.85-1.696 2.834-2.826 4.25-3.956 2.551-1.413 5.385 0 7.368-2.26.567-.566 1.7 0 2.267 0 1.7.847 3.967.282 5.384 1.695-2.267 5.086-2.267 10.455-3.967 15.824-.284 1.13-.85 2.825-.284 3.39 2.55.848 9.068-.282 9.352-.565 3.4 0 6.517 0 9.917.848 2.55.565 4.25 1.695 6.518 3.673 3.683 2.826 3.683 7.912 3.117 12.434 0 .282-1.7 1.977-2.267 1.695-.284 0-.284-1.13-.567-1.413-1.417 1.13-3.967 3.673-4.817 3.673-.283 0-1.984-1.695-2.834-2.26-2.833-1.978-6.234-1.413-9.35-1.13-3.684.282-7.368-.283-11.052 1.412 1.417 2.544 3.684 3.957 5.95 5.935 3.401 3.39 6.801 5.934 10.202 9.324 2.267 2.543 4.534 4.239 5.95 7.065-.85.565 0 .847-.566 1.412-.567.283-.567-.847-1.134-.847-.566 0-.85.848-.85 1.413.284.282-.566 1.978-1.133 1.978-.284.282-1.7 1.13-2.267 1.13-.283 0-1.984-.848-1.984-.565.567.848 1.134 1.978.85 2.26-1.416-.282-2.266-.282-3.117-1.412-4.533-3.956-8.784-8.195-13.601-12.434-1.7-1.695-2.834-3.956-5.1-5.651-3.401 7.912-5.668 13.563-9.068 21.475-.85 1.413-1.134 5.087-1.984 5.37-.566.282-2.55-2.544-3.683-4.805 0-4.803.566-6.499.85-11.585v-.847c.283-6.5 2.267-12.151 1.983-18.933 0-.565-.85-.848-1.7-.848-8.501-.847-16.719-1.978-25.22-3.108-1.983-.282-3.967-.282-5.95-1.13-.283-.283-1.417-.848-1.7-.848-.284-.282-.284-.282-.567-.282 3.4-3.391 6.234-7.065 11.051-9.043 2.267 0 5.667-1.412 7.084-1.978Z",
      fill: "#F58025"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M97.35 219.31c-.56-.285-.28-.856-.28-.856.561-.857 1.683-.857 2.245-.857 2.244-.57 4.77 0 7.013-.57.562-.286.842-.857 1.123-.857 1.683-.857 3.367-1.142 5.33-1.713.562-.285 1.684-.856 1.123-1.713-1.964-2.284-3.928-4.282-5.05-6.851-.561-1.428-1.684-2.57-1.684-3.997 0-1.142 1.403-1.427 2.525-.856 5.05 2.854 8.417 7.136 12.065 11.704.56.857 1.402-1.142 1.683-1.998 1.683-3.712 2.805-7.994 4.77-11.705.56-1.142 1.402-2.57 2.524-2.855 1.684-.57 2.806-1.712 4.209-2.569 1.122-.57 1.964 0 3.086-.57.561-.286 1.683.856 2.525.57 1.403-.856 2.525-.285 3.928 0 .842.571 1.122 1.428.842 2.284-1.403 3.426-1.964 6.851-4.209 10.277-1.683 2.57-2.805 5.139-4.77 7.708 0 .286-.28.857.281.857 1.122.285 2.525 0 3.367.57 3.367 1.142 6.733.857 10.38 1.428 1.684.57 1.684 3.14 3.367 4.567.842.571-.56 1.428-1.683 1.713-2.525.857-5.05-.285-7.575.571-4.208.857-8.417 0-12.345 1.713 1.403 1.427 2.806 2.57 3.928 3.997l3.367 5.139c1.122 1.998 1.683 3.71 2.244 5.709.561.856.28 2.284.28 3.426-.56-.286-.56-1.142-.84-1.428-.562 0-.842.857-1.684.857-.561-.286-.842-.857-1.122-1.142-.842-.857-1.684-2.284-1.964-3.426-1.684-3.711-4.77-5.995-7.575-8.279-2.806 5.995-4.77 11.99-8.698 17.7-.28.571-.841.571-1.683.571-.28-.285-.561.571-.842.571-.28-.57-.56-.57-.841-.856-1.123-.857-2.806-1.999-3.087-3.426-.56-1.428-1.122-2.57-1.122-3.997 0-.285-.561-.856-.561-.856.561-.857.561-2.284.842-2.855.56-.857 1.683-1.713 1.683-2.57 1.122-2.854 3.086-5.138 3.647-7.993-5.33-.856-10.942-.571-16.272-2.57-1.122-.57-2.525-.856-3.648-1.712-.56-1.998-.28-2.57-.841-2.855Z",
      fill: "#003E74"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M103.545 131.841c1.7-4.26 4.534-6.815 4.817-11.642-9.067-5.11-19.834-1.988-26.635-13.913-1.7-2.556 0-14.482.85-15.902 1.984-4.259 5.95-4.259 9.634-1.42.284-.283 3.117.569 3.684.853 3.683-.568 7.65.851 11.617 1.703 5.1.568 9.35 2.556 14.167 1.988.284-.284.85-1.42.85-2.84-1.133-7.098-2.833-13.345-4.533-20.728-.85-1.703-.567-3.975-1.134-5.679-.283-4.259-3.116-10.79-.566-12.777.283-.284.85.851 1.133.568.85-.568 1.133-1.704 1.983-1.42 8.784 5.963 16.151 15.05 24.085 23.852 2.55 2.555 3.117-4.26 5.1-6.531.567-1.136 0-3.692.567-4.543 1.983-3.692 2.267-8.235 3.967-11.642 3.116-4.26 4.817-10.79 9.35-12.494 3.117-.852 6.517.284 9.35 3.407.567.284 1.984 0 2.834.852 3.117 2.84 5.667 6.53 9.067 9.938 1.134 1.42 1.7 3.975 1.134 5.111-.85 4.828-5.1 5.111-7.65 8.519-4.818 7.95-9.918 15.9-14.735 23.851-.566 1.136-1.983 3.692-.85 4.828 6.8 6.814 12.75 13.913 20.401 19.308 4.817 3.123 9.917 2.84 14.167 7.099 3.117 3.691 5.384 7.666 6.801 12.493-17.284 11.075-36.835-7.098-55.253-6.814-1.416.284-1.133 2.271-1.133 3.123.85 7.95 2.267 15.617 3.117 23.284.283 5.395 3.116 10.79 3.966 15.901.284 1.988 1.984 7.099-.566 6.815-2.834 0-6.8-.852-8.784-5.395-2.55-5.963-5.1-12.21-7.083-18.74-.284-1.988-1.134-3.692-.284-5.396.283-3.123-1.7-5.963-2.55-8.234-.567-1.136-1.7.567-2.55 1.135-2.55 3.408-5.1 6.531-7.367 10.507-4.25 5.962-9.067 9.654-14.734 12.21-4.25 1.703-10.484 2.555-13.318-3.976 1.417-.284 2.55-3.407 1.7-4.26-6.516-9.937 2.55-15.9 5.384-22.999Z",
      fill: "#7BAED4"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M293.694 243H278v-84.586h15.694v14.145C299.58 163.224 306.866 157 320.88 157H322v13.579h-1.121c-6.726 0-12.051 2.263-16.815 6.79-5.886 5.657-10.09 14.427-10.37 21.782V243ZM356.553 244C337.522 244 329 231.59 329 220.308c0-18.052 15.339-27.641 54.821-34.41v-3.667c0-9.308-5.68-14.103-16.759-14.103-14.77 0-19.883 9.308-21.303 12.128l-.284 1.129-14.487-6.206.568-1.128c6.25-11 20.168-18.051 35.222-18.051 16.475 0 32.95 7.898 32.95 25.667v41.461c0 8.461.852 12.974 1.988 17.487l.284 1.41h-16.475l-1.136-10.153C378.424 238.077 369.051 244 356.553 244Zm26.984-45.975c-26.132 4.513-38.914 11.847-38.914 22.283 0 6.769 7.1 11.564 13.35 11.564 7.953 0 18.463-5.36 25.564-12.975v-20.872ZM454.403 243h-19.24L408 158h16.128l21.22 66.806L466.57 158H481zM595.423 242h-15.846V129.768L595.423 123zM648 244c-22.8 0-38-17.6-38-44s15.2-44 38-44 38 17.6 38 44-15.2 44-38 44Zm0-76.077c-13.793 0-22.237 11.922-22.237 32.077 0 20.155 8.444 32.077 22.237 32.077 13.793 0 22.237-11.922 22.237-32.077 0-20.155-8.444-32.077-22.237-32.077ZM734.064 244C711.226 244 696 226.4 696 200s15.226-44 38.064-44c16.353 0 27.914 7.665 34.116 22.994l.564 1.135-14.943 4.542-.282-.852c-2.256-7.096-7.613-15.612-19.455-15.612-14.098 0-22.275 11.638-22.275 32.077 0 20.438 8.177 32.077 22.275 32.077 10.996 0 16.353-3.69 22.838-14.761l.564-.852L771 221.574l-.564 1.136c-9.868 15.329-20.019 21.29-36.372 21.29ZM798.284 243h-15.568v-85h15.568zM244.286 244c-12 0-20-2.547-21.429-14.43v-59.697H210V157.99h12.857v-23.2l16-6.79v29.99h20.572l-3.143 11.883h-17.143v57.717c0 2.263 1.143 4.527 8.857 4.527 4 0 7.143-.283 12.286-1.132l1.714-.283-3.143 11.883h-.571c-4.572.849-8 1.415-14 1.415ZM884.477 274c-4.253 0-9.358-.564-11.343-.847l-1.134-.282 3.687-11.854h1.985c1.417.282 3.119.282 5.104.282 7.94 0 17.582-1.975 21.552-18.627l-30.627-84.39h15.03l.284.565 22.403 60.399L931.268 158H948l-30.91 91.163C909.15 270.895 893.267 274 884.476 274ZM849.286 244c-12 0-20-2.54-21.429-14.394V169.77H815v-11.854h12.857v-23.143l16-6.774v29.917h20.572l-3.143 11.854h-17.143v57.577c0 2.258 1.143 4.516 8.857 4.516 4 0 7.143-.283 12.286-1.13l1.714-.281-3.143 11.853h-.571c-4.572 1.13-8 1.694-14 1.694ZM529.39 244c-10.734 0-20.337-3.69-27.68-10.503C493.237 225.548 489 213.909 489 200c0-26.4 15.252-44 38.13-44 9.603 0 18.641 3.123 24.855 9.084 7.06 6.813 11.015 17.032 11.015 29.523v8.8h-57.9c.564 16.464 10.732 28.67 24.29 28.67 9.602 0 17.793-4.541 22.595-13.058l.565-1.135 10.168 9.935-.565.852C551.985 242.864 545.77 244 529.389 244Zm-24.008-52.8H546.9c-.283-14.477-7.626-23.277-19.49-23.277-12.709 0-20.617 8.516-22.03 23.277ZM798.284 145.284h-15.568v-15.568h15.568z",
      fill: "#003E74"
    })));
  },
  wC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "goodsam-logo-icon"), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(3)"
    }, /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 306,
      height: 312
    }), /*#__PURE__*/e.createElement("path", {
      stroke: "#3E1016",
      strokeLinecap: "square",
      strokeWidth: .2,
      d: "M237 103v113"
    })));
  },
  QC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1234 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "goodsam-logo"), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 1233.7,
      height: 312,
      fill: "none",
      fillRule: "evenodd"
    }));
  },
  HC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "rvezy-logo-icon"), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 312,
      height: 162.933,
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(0 75)"
    }));
  },
  zC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 704 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "rvezy-logo"), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 703.353,
      height: 312,
      fill: "none",
      fillRule: "evenodd"
    }));
  },
  MC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1231 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "wallabing-logo"), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 1230.472,
      height: 312,
      fill: "none",
      fillRule: "evenodd"
    }));
  },
  kC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "wallabing-logo-icon"), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 312,
      height: 311,
      fill: "none",
      fillRule: "evenodd"
    }));
  },
  NC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "outdoorsy-logo-icon"), /*#__PURE__*/e.createElement("path", {
      fill: "#0F0F0F",
      fillRule: "nonzero",
      d: "M299.874 104.633C270.594 44.303 208.591 15 156.577 15c-29.28 0-57.87 7.584-83.36 21.374-51.67 28.959-78.539 80.67-72.338 101.7 0 0 5.856 18.615 31.002 18.27 12.056-.344 16.534-8.273 17.223-15.168 2.756-34.474 30.657-74.12 69.582-91.357 21.012-9.653 45.125-9.653 70.96 2.413 21.356 9.998 38.58 27.235 48.225 48.954 8.611 16.892 13.09 37.577 13.09 62.398 0 26.89-5.512 48.954-15.846 65.846-10.334 16.548-26.18 24.822-45.814 24.822-18.256 0-32.38-8.619-43.747-25.511-11.712-16.893-17.223-36.888-17.223-64.812 0-26.89 5.511-51.022 16.534-67.57 4.823-7.929 11.712-14.134 19.29-18.96 3.79-1.724 4.823-6.206 3.79-9.998-1.379-2.758-4.134-4.482-6.89-4.482-63.726 0-95.072 54.47-95.072 101.01C65.983 267.352 139.009 297 189.3 297c70.271 0 122.63-62.399 122.63-133.76.689-20.685-3.79-40.335-12.057-58.607Z"
    }));
  },
  SC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1430 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("path", {
      fill: "#0F0F0F",
      fillRule: "nonzero",
      d: "m368.755 67.211-.239 95.813c-.238 4.528.477 8.818 1.907 13.108.953 2.622 2.383 4.767 4.529 6.674 2.383 1.43 4.528 2.621 7.15 3.336 1.43.477 2.383 1.669 2.383 3.337 0 3.337-2.86 8.104-8.342 13.347-5.482 5.482-12.632 8.104-21.45 8.104-7.389 0-13.347-2.384-18.114-6.674-4.767-4.528-7.627-10.963-8.58-17.399l-1.192-10.963c-4.767 11.202-11.678 20.497-20.259 26.217-8.103 5.482-17.16 8.58-26.932 8.819-11.44.238-20.974-3.099-27.647-10.249-6.912-7.15-10.249-17.637-10.249-31.699v-54.58c0-15.968-7.15-20.02-7.15-20.02-2.383-1.43-4.767-2.622-7.15-3.337-1.43-.476-2.622-1.906-2.622-3.813 0-3.813 2.86-8.342 8.342-13.824 5.72-5.482 13.347-8.342 21.45-8.103 8.82 0 15.97 2.621 21.451 8.103 5.482 5.482 8.104 12.87 8.104 22.404v62.683c0 8.104 1.43 14.062 4.29 17.637 2.621 3.337 6.673 5.482 10.963 5.244 6.912-.239 13.109-5.244 18.59-14.062 5.72-9.057 8.58-20.497 8.58-34.083v-66.02c13.586-1.43 27.886-1.43 42.187 0M476.96 88.424h-29.077v59.584c0 13.109 1.669 22.404 4.767 27.648 3.337 5.243 9.057 7.626 17.637 7.626 2.86 0 5.482-.238 8.103-.953 1.907-.477 4.052-.953 5.959-.953 1.43-.239 2.86.953 2.86 2.383v.477c0 5.482-4.29 11.44-12.632 17.637-8.342 6.197-18.352 9.533-30.03 9.533-26.218 0-39.565-16.207-39.565-48.62V88.423h-15.73c-1.43-6.197-1.43-12.632 0-18.59h15.73V35.511c14.3-1.668 28.6-1.43 42.901.239v33.367h29.077c1.43 6.674 1.43 12.87 0 19.306Zm161.117 94.62c2.384 1.43 4.767 2.622 7.15 3.337 1.43.476 2.384 1.668 2.622 3.337 0 4.29-3.098 9.056-9.057 14.061-5.72 4.767-13.108 7.389-20.973 7.389-8.342 0-14.777-2.622-20.02-7.389-5.244-5.243-8.343-12.631-8.82-21.688-4.051 8.58-10.01 15.968-17.636 21.45-7.627 5.244-16.923 7.627-25.98 7.627-16.206 0-29.553-6.912-39.087-20.259-10.01-13.347-14.777-30.507-14.777-51.243 0-19.782 5.244-36.942 15.492-51.48 10.249-14.54 23.834-21.69 40.28-21.69 19.066 0 33.843 8.819 41.947 25.264V2.145c14.062-2.86 28.6-2.86 42.663 0V162.07c-.715 17.876-.715 16.446 6.196 20.974Zm-57.2-14.062c5.48-8.58 8.103-18.59 8.103-30.269 0-11.917-2.622-22.642-7.627-31.222-5.244-8.58-11.917-13.109-20.497-13.109-8.104 0-14.3 4.052-19.544 11.917-5.244 8.104-7.627 18.352-8.104 31.222-.238 13.347 2.384 24.31 7.389 32.414 5.243 8.104 11.678 11.917 19.782 11.917 8.103 0 15.015-4.29 20.497-12.87Zm199.25-84.133c13.347 13.346 20.02 30.984 20.02 52.434 0 21.689-6.673 39.564-19.782 53.15-13.108 13.823-30.507 20.973-52.434 20.973-20.974 0-38.134-6.673-51.72-20.02-13.823-13.109-20.497-31.222-20.497-53.865 0-21.212 6.912-38.61 20.497-52.434 13.824-13.824 30.985-20.497 51.72-20.497 21.45 0 38.85 6.912 52.196 20.259Zm-29.316 88.423c5.244-8.818 7.627-20.497 7.627-35.274 0-14.3-2.621-25.979-7.388-35.512-5.244-9.534-12.632-14.062-22.642-14.062-9.057 0-16.684 4.528-21.928 13.347-5.481 8.818-8.341 20.497-8.341 34.797 0 15.254 2.86 27.17 8.58 35.99 5.72 9.056 13.108 13.823 21.927 13.823 9.534.238 16.922-4.052 22.165-13.109ZM940.052 84.85c13.347 13.346 20.02 30.984 20.02 52.434 0 21.689-6.673 39.564-19.781 53.15-13.109 13.585-30.508 20.973-52.435 20.973-20.974 0-38.134-6.673-51.72-20.02-13.823-13.109-20.496-31.222-20.496-53.865 0-21.212 6.911-38.61 20.497-52.434 13.823-13.824 30.984-20.497 51.72-20.497 21.688 0 38.848 6.912 52.195 20.259Zm-29.315 88.423c5.243-8.818 7.627-20.497 7.627-35.274 0-14.3-2.622-25.979-7.389-35.512-5.243-9.534-12.632-14.062-22.642-14.062-9.057 0-16.684 4.528-21.927 13.347-5.482 8.818-8.342 20.497-8.342 34.797 0 15.254 2.86 27.17 8.58 35.99 5.72 9.056 13.109 13.823 21.927 13.823 9.534.238 16.922-4.052 22.166-13.109Zm115.832 35.99v-57.44c.239-14.062 2.384-25.98 6.674-35.751 4.29-10.01 9.533-14.777 15.968-15.492 3.099-.238 6.197 1.192 8.104 3.813 1.668 2.86 2.86 6.197 2.622 9.772 0 3.337-.477 6.912-1.43 10.249l-1.43 5.958c0 3.337 3.336 4.767 10.248 4.767 8.342 0 15.73-3.337 21.927-10.487 6.197-6.912 10.01-15.969 9.772-25.502 0-10.01-2.86-18.352-8.58-24.549-5.72-6.197-13.109-9.534-22.88-9.057-9.772.238-18.83 4.052-25.503 10.964-7.388 7.15-13.108 18.352-16.207 30.269 0-4.767-.476-10.01-.953-12.632-.954-9.057-3.337-16.207-8.104-21.45-4.528-5.244-10.963-7.39-18.59-7.39-8.104-.238-15.73 2.622-21.45 8.104-5.72 5.482-8.58 9.772-8.58 13.347 0 1.43 1.191 2.86 2.621 3.337 4.052 1.43 7.388 4.052 10.01 7.15 1.907 2.86 3.099 8.58 3.099 16.207v95.336h42.662v.476Zm134.423-92.238c6.674 4.052 13.824 7.15 21.212 9.057 8.342 2.383 16.684 4.767 24.788 7.627 8.103 2.622 15.253 7.15 21.212 12.87 5.72 5.72 8.818 13.824 8.58 21.689 0 12.632-5.72 22.642-17.399 30.507-11.678 7.866-27.409 11.917-47.668 11.917-18.828 0-34.082-3.098-45.76-9.057-11.68-5.958-17.4-13.823-17.4-23.357-.238-5.72 1.907-11.202 6.197-14.777 4.529-3.813 10.25-5.72 16.208-5.482 4.29 0 8.58.954 12.393 2.622 4.29 1.669 6.197 3.099 6.197 4.529l-.238 2.383c-.239 1.43-.239 2.86-.239 4.528 0 4.767 1.907 9.534 5.482 12.632 3.813 3.337 9.534 4.767 17.16 4.767 7.15 0 12.87-1.668 16.922-5.243 3.814-2.86 5.959-7.389 5.959-12.394 0-4.767-2.86-8.818-8.58-11.917-6.674-3.337-13.824-5.958-20.974-8.103-8.342-2.384-16.207-4.767-24.549-7.627a52.097 52.097 0 0 1-20.974-13.824c-5.72-6.197-8.818-14.538-8.58-23.119 0-11.917 5.72-21.927 17.399-30.03 11.44-8.342 25.74-12.394 42.662-11.917 18.83 0 33.368 3.098 44.093 9.533 10.487 6.197 15.73 13.824 15.73 22.88 0 6.198-1.906 11.441-5.958 15.254-4.052 3.814-9.534 5.482-15.969 5.482-4.29 0-8.342-.953-12.393-2.621-4.052-1.669-6.197-3.337-6.197-4.767 0-.239 0-.954.238-1.192.238-.953.238-1.43.238-2.383v-2.86c0-4.529-1.43-9.057-4.528-12.632-3.098-3.337-8.103-5.244-14.539-5.244-5.243-.238-10.01 1.43-14.062 4.767-3.336 2.86-5.243 6.912-5.481 11.202 0 5.72 3.098 10.248 8.818 14.3Zm261.696 100.817c-5.72-3.098-14.777-3.098-18.352-3.336-5.244-.239-10.01-.239-14.777 0V67.21a158.038 158.038 0 0 0-42.424 0v66.02c0 13.824-2.86 25.264-8.58 34.083-5.72 9.057-11.918 13.823-18.591 14.062-4.29.238-8.342-1.669-10.964-5.244-2.86-3.813-4.29-9.533-4.29-17.637V96.527c0-9.533-2.621-16.922-8.103-22.404-5.482-5.481-12.632-8.103-21.45-8.103-8.104-.239-15.731 2.622-21.451 8.103-5.72 5.482-8.342 10.01-8.342 13.824 0 1.668.953 3.098 2.622 3.813 8.103.239 11.917 10.01 11.917 10.01 1.668 4.29 2.621 8.82 2.383 13.348v53.864c0 14.062 3.337 24.549 10.249 31.7 6.911 7.15 15.968 10.963 27.647 10.486 9.533-.238 18.829-3.098 26.932-8.342 8.342-5.482 15.73-14.3 20.259-25.264v44.57c-1.192.238-2.622.476-4.052 1.191-20.497 5.72-37.419 14.3-51.004 25.502-10.964 9.057-18.59 19.544-17.637 32.891 1.668 19.067 28.124 33.13 54.818 29.793 15.73-1.907 25.978-8.342 33.844-16.207 12.393-12.632 17.637-27.41 21.212-42.901 1.191-4.529 1.906-9.534 2.86-14.54 8.342 1.193 16.207 2.861 24.549 5.244 7.15 1.669 16.922 2.86 17.637-10.487 1.43-6.673-1.907-12.393-6.912-14.777Zm-116.548 62.445c-4.29-12.393 10.249-23.119 23.12-30.269 4.528-2.622 9.533-4.767 14.3-6.912 1.668-.953 2.86-1.191 2.86-1.191-4.052 57.2-33.844 56.01-40.28 38.372ZM207.876 78.89c-20.259-41.71-63.16-61.968-99.149-61.968-20.258 0-40.04 5.243-57.678 14.777C15.3 51.719-3.29 87.47 1 102.009c0 0 4.051 12.87 21.45 12.632 8.342-.238 11.44-5.72 11.917-10.487 1.906-23.834 21.212-51.243 48.144-63.16 14.539-6.673 31.222-6.673 49.098 1.669 14.777 6.911 26.694 18.828 33.367 33.844 5.959 11.678 9.057 25.979 9.057 43.139 0 18.59-3.813 33.844-10.963 45.523-7.15 11.44-18.114 17.16-31.7 17.16-12.631 0-22.403-5.958-30.269-17.637-8.103-11.679-11.916-25.502-11.916-44.808 0-18.59 3.813-35.274 11.44-46.714 3.337-5.482 8.103-9.772 13.347-13.109 2.622-1.191 3.337-4.29 2.622-6.911-.954-1.907-2.86-3.099-4.767-3.099-44.093 0-65.782 37.658-65.782 69.833 0 71.502 50.528 91.999 85.325 91.999 48.622 0 84.849-43.14 84.849-92.475.477-14.3-2.622-27.886-8.342-40.518Z"
    }));
  },
  VC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 312 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "rvngo-logo-icon"), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 760,
      height: 151,
      x: -447,
      y: 81,
      fill: "none",
      fillRule: "evenodd"
    }));
  },
  LC = function (t) {
    return /*#__PURE__*/e.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 1571 312",
      className: tC(iC.base, k({}, iC["height-".concat(t.presetHeight)], t.presetHeight), t.className),
      style: t.customHeight && "custom" === t.presetHeight ? {
        height: t.customHeight
      } : null
    }, /*#__PURE__*/e.createElement("title", null, "rvngo-logo"), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      transform: "translate(.333)"
    }, /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 1568.453,
      height: 312
    }), /*#__PURE__*/e.createElement("image", {
      xlinkHref: "data:image/png;base64,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",
      width: 1569.286,
      height: 312,
      x: .929
    })));
  },
  PC = function (e) {
    var n = e.channel,
      r = e.variation,
      o = e.presetHeight,
      i = e.customHeight,
      a = e.isGrayscale,
      c = e.className;
    return function () {
      var e = null;
      switch (n) {
        case "rvngo":
          e = "full" === r ? LC : VC;
          break;
        case "outdoorsy":
          e = "full" === r ? SC : NC;
          break;
        case "wallabing":
          e = "full" === r ? MC : kC;
          break;
        case "rvezy":
          e = "full" === r ? zC : HC;
          break;
        case "goodsam":
          e = "full" === r ? QC : wC;
          break;
        case "travelocity":
          e = "full" === r ? xC : BC;
          break;
        case "kayak":
          e = "full" === r ? IC : yC;
          break;
        case "agoda":
          e = "full" === r ? EC : bC;
          break;
        case "homeaway":
        case "vrbo":
          e = "full" === r ? vC : CC;
          break;
        case "rvshare":
          e = "full" === r ? AC : gC;
          break;
        case "google":
          e = "full" === r ? mC : hC;
          break;
        case "expedia":
          e = "full" === r ? pC : fC;
          break;
        case "booking":
          e = "full" === r ? dC : uC;
          break;
        case "airbnb":
          e = "full" === r ? aC : cC;
          break;
        default:
          e = "full" === r ? sC : lC;
      }
      return /*#__PURE__*/t.createElement(e, {
        className: tC(c, k({}, iC.isGrayscale, a)),
        presetHeight: o,
        customHeight: i
      });
    }();
  };
PC.propTypes = {
  channel: g.oneOf(["agoda", "airbnb", "booking", "homeaway", "direct", "expedia", "google", "rvshare", "vrbo", "kayak", "travelocity", "goodsam", "rvezy", "wallabing", "outdoorsy", "rvngo"]),
  variation: g.oneOf(["full", "icon"]),
  presetHeight: g.oneOf(["s", "m", "l", "xl", "xxl", "custom"]),
  customHeight: g.number,
  isGrayscale: g.bool,
  className: g.string
}, PC.defaultProps = {
  channel: "direct",
  variation: "full",
  presetHeight: "m"
};
var OC = {
    "is-block": "baseElement-module_is-block__24Wgj",
    "is-flex": "baseElement-module_is-flex__27P-_",
    "is-inline": "baseElement-module_is-inline__38lhE",
    "is-inline-block": "baseElement-module_is-inline-block__1EOVI",
    "is-inline-flex": "baseElement-module_is-inline-flex__2jOiG",
    "is-flex-direction-row": "baseElement-module_is-flex-direction-row__2fezM",
    "is-flex-direction-row-reverse": "baseElement-module_is-flex-direction-row-reverse__VwsES",
    "is-flex-direction-column": "baseElement-module_is-flex-direction-column__1pnBV",
    "is-flex-direction-column-reverse": "baseElement-module_is-flex-direction-column-reverse__3zAYn",
    "is-flex-wrap-nowrap": "baseElement-module_is-flex-wrap-nowrap__1qsop",
    "is-flex-wrap-wrap": "baseElement-module_is-flex-wrap-wrap__1tCCu",
    "is-flex-wrap-wrap-reverse": "baseElement-module_is-flex-wrap-wrap-reverse__2C7XM",
    "is-justify-content-flex-start": "baseElement-module_is-justify-content-flex-start__2dszS",
    "is-justify-content-flex-end": "baseElement-module_is-justify-content-flex-end__lKIAa",
    "is-justify-content-center": "baseElement-module_is-justify-content-center__AMxz_",
    "is-justify-content-space-between": "baseElement-module_is-justify-content-space-between__1KY6r",
    "is-justify-content-space-around": "baseElement-module_is-justify-content-space-around__iIsbY",
    "is-justify-content-space-evenly": "baseElement-module_is-justify-content-space-evenly__3LRFd",
    "is-justify-content-start": "baseElement-module_is-justify-content-start__2VvsD",
    "is-justify-content-end": "baseElement-module_is-justify-content-end__3CH61",
    "is-justify-content-left": "baseElement-module_is-justify-content-left__1Zpay",
    "is-justify-content-right": "baseElement-module_is-justify-content-right__2KWWa",
    "is-align-content-flex-start": "baseElement-module_is-align-content-flex-start__gf-u4",
    "is-align-content-flex-end": "baseElement-module_is-align-content-flex-end__3W1JX",
    "is-align-content-center": "baseElement-module_is-align-content-center__3z9MS",
    "is-align-content-space-between": "baseElement-module_is-align-content-space-between__1VfdJ",
    "is-align-content-space-around": "baseElement-module_is-align-content-space-around__Opkbc",
    "is-align-content-space-evenly": "baseElement-module_is-align-content-space-evenly__1SIcp",
    "is-align-content-stretch": "baseElement-module_is-align-content-stretch__J0ZFA",
    "is-align-content-start": "baseElement-module_is-align-content-start__3YSV6",
    "is-align-content-end": "baseElement-module_is-align-content-end__3odqv",
    "is-align-content-baseline": "baseElement-module_is-align-content-baseline__383Ec",
    "is-align-items-stretch": "baseElement-module_is-align-items-stretch__2j-N3",
    "is-align-items-flex-start": "baseElement-module_is-align-items-flex-start__1c7_5",
    "is-align-items-flex-end": "baseElement-module_is-align-items-flex-end__1VAcG",
    "is-align-items-center": "baseElement-module_is-align-items-center__dp0Ke",
    "is-align-items-baseline": "baseElement-module_is-align-items-baseline__3A_mZ",
    "is-align-items-start": "baseElement-module_is-align-items-start__3Zsha",
    "is-align-items-end": "baseElement-module_is-align-items-end__TEayk",
    "is-align-items-self-start": "baseElement-module_is-align-items-self-start__2WYnZ",
    "is-align-items-self-end": "baseElement-module_is-align-items-self-end__egJ0A",
    "is-align-self-auto": "baseElement-module_is-align-self-auto__Rj55b",
    "is-align-self-flex-start": "baseElement-module_is-align-self-flex-start__3YVqx",
    "is-align-self-flex-end": "baseElement-module_is-align-self-flex-end__IEKld",
    "is-align-self-center": "baseElement-module_is-align-self-center__3sIv4",
    "is-align-self-baseline": "baseElement-module_is-align-self-baseline__1wmsb",
    "is-align-self-stretch": "baseElement-module_is-align-self-stretch__2haBd",
    "is-flex-grow-0": "baseElement-module_is-flex-grow-0__1OjTh",
    "is-flex-grow-1": "baseElement-module_is-flex-grow-1__4QoEZ",
    "is-flex-grow-2": "baseElement-module_is-flex-grow-2__3ZXmL",
    "is-flex-grow-3": "baseElement-module_is-flex-grow-3__3H1VO",
    "is-flex-grow-4": "baseElement-module_is-flex-grow-4__3Fmot",
    "is-flex-grow-5": "baseElement-module_is-flex-grow-5__N7Rl1",
    "is-flex-shrink-0": "baseElement-module_is-flex-shrink-0__3AG0j",
    "is-flex-shrink-1": "baseElement-module_is-flex-shrink-1__2V4UV",
    "is-flex-shrink-2": "baseElement-module_is-flex-shrink-2__33clr",
    "is-flex-shrink-3": "baseElement-module_is-flex-shrink-3__1Uhn7",
    "is-flex-shrink-4": "baseElement-module_is-flex-shrink-4__x0Xw6",
    "is-flex-shrink-5": "baseElement-module_is-flex-shrink-5__2HIX2",
    setRelative: "baseElement-module_setRelative__T8yZ2"
  },
  TC = ["flexDirection", "flexWrap", "justifyContent", "alignItems", "flexGrow", "flexShrink", "display"],
  DC = ["renderAs", "children", "domRef", "className", "setPositionRelative"],
  RC = function (e) {
    var n = e.renderAs,
      r = e.children,
      o = e.domRef,
      i = e.className,
      a = e.setPositionRelative,
      c = n,
      s = function (e) {
        var t,
          n = e.flexDirection,
          r = e.flexWrap,
          o = e.justifyContent,
          i = e.alignItems,
          a = e.flexGrow,
          c = e.flexShrink,
          s = e.display,
          l = S(e, TC);
        return [tC((t = {}, k(t, OC["is-flex-direction-".concat(n)], n), k(t, OC["is-flex-wrap-".concat(r)], r), k(t, OC["is-justify-content-".concat(o)], o), k(t, OC["is-align-items-".concat(i)], i), k(t, OC["is-flex-grow-".concat(a)], a), k(t, OC["is-flex-shrink-".concat(c)], c), k(t, OC["is-".concat(s)], s), t)), l];
      }(S(e, DC)),
      l = V(s, 2),
      u = l[0],
      d = l[1];
    return /*#__PURE__*/t.createElement(c, N({
      ref: o,
      className: tC(i, k({}, OC.setRelative, a), u)
    }, d), r);
  };
RC.propTypes = {
  children: g.any,
  domRef: g.object,
  className: g.string,
  renderAs: g.string,
  alignItems: g.oneOf(["auto", "flex-start", "flex-end", "center", "baseline", "stretch"]),
  display: g.oneOf(["block", "flex", "inline", "inline-block", "inline-flex"]),
  flexDirection: g.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  flexWrap: g.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  flexGrow: g.oneOf(["0", 1, 2, 3, 4, 5]),
  flexShrink: g.oneOf(["0", 1, 2, 3, 4, 5]),
  justifyContent: g.oneOf(["flex-start", "flex-end", "center", "space-around", "space-between", "space-evenly", "start", "end", "left", "right"]),
  style: g.object,
  setPositionRelative: g.bool
}, RC.defaultProps = {
  renderAs: "div"
};
var GC = function (e) {
    var t = V(n(null), 2),
      o = t[0],
      i = t[1];
    return r(function () {
      function t(t) {
        e.current && !e.current.contains(t.target) ? i(!0) : i(!1);
      }
      return document.addEventListener("mousedown", t), function () {
        document.removeEventListener("mousedown", t);
      };
    }, [e]), {
      isOutsideClick: o
    };
  },
  FC = {
    callToAction: "callToActionButton-module_callToAction__w-e8X",
    "textAlign-left": "callToActionButton-module_textAlign-left__35HGH",
    "textAlign-center": "callToActionButton-module_textAlign-center__2Qret",
    "textAlign-right": "callToActionButton-module_textAlign-right__2o_W_",
    primary: "callToActionButton-module_primary__2L2rn",
    outline: "callToActionButton-module_outline__kG-3S",
    "outline-white-bg": "callToActionButton-module_outline-white-bg__DgGO8",
    ghost: "callToActionButton-module_ghost__3-Iul",
    dense: "callToActionButton-module_dense__1wRpn",
    custom: "callToActionButton-module_custom__1ZFKX",
    secondary: "callToActionButton-module_secondary__2g7bk",
    danger: "callToActionButton-module_danger__cvJS4",
    white: "callToActionButton-module_white__3GHQK",
    disabled: "callToActionButton-module_disabled__1Q4GD",
    fullWidth: "callToActionButton-module_fullWidth__2_WrM",
    large: "callToActionButton-module_large__x0KHj",
    dropdown: "callToActionButton-module_dropdown__1vsr7",
    callToAction_icon: "callToActionButton-module_callToAction_icon__FOfmN",
    after: "callToActionButton-module_after__2Vwxe",
    before: "callToActionButton-module_before__2aNLe",
    button: "callToActionButton-module_button__1qBSi"
  },
  jC = function (e) {
    var n,
      i,
      a = e.children,
      c = e.variation,
      s = e.onClick,
      l = e.onClickOutside,
      u = e.appearance,
      d = e.size,
      f = e.isDropdown,
      p = e.isDisabled,
      m = e.isFullWidth,
      h = e.prependIcon,
      A = e.appendIcon,
      g = e.id,
      v = e.className,
      C = e.textAlign,
      b = e.buttonType,
      E = e.title,
      y = e.role,
      I = e.customButtonColor,
      B = e.customTextColor,
      x = o(null),
      w = GC(x).isOutsideClick;
    return r(function () {
      l && l(w);
    }, [w]), r(function () {
      I && B && (document.documentElement.style.setProperty("--primary-cta-color", I), document.documentElement.style.setProperty("--primary-cta-text-color", B));
    }, [I, B]), /*#__PURE__*/t.createElement(RC, {
      id: g,
      domRef: x,
      title: E,
      role: y,
      renderAs: "button",
      onClick: s,
      disabled: p,
      type: b,
      className: tC(FC.callToAction, FC.button, (n = {}, k(n, FC.primary, "primary" === c), k(n, FC.secondary, "secondary" === c), k(n, FC.danger, "danger" === c), k(n, FC.white, "white" === c), k(n, FC.custom, I && B), k(n, FC.disabled, p), k(n, FC.outline, "outline" === u), k(n, FC["outline-white-bg"], "outline-white-bg" === u), k(n, FC.ghost, "ghost" === u), k(n, FC.fullWidth, m), k(n, FC.dense, "dense" === d), k(n, FC.large, "large" === d), k(n, FC.dropdown, f), k(n, FC["textAlign-".concat(C)], C), n), v)
    }, h && /*#__PURE__*/t.createElement("span", {
      className: tC(FC.callToAction_icon, FC.before)
    }, h), a, (A || f) && /*#__PURE__*/t.createElement("span", {
      className: tC(FC.callToAction_icon, FC.after, (i = {}, k(i, FC.dense, "dense" === d), k(i, FC.large, "large" === d), k(i, FC.secondary, "secondary" === c), k(i, FC.danger, "danger" === c), k(i, FC.outline, "outline" === u), k(i, FC["outline-white-bg"], "outline-white-bg" === u), k(i, FC.ghost, "ghost" === u), k(i, FC.disabled, p), k(i, FC["textAlign-".concat(C)], C), i))
    }, A || (f ? /*#__PURE__*/t.createElement(qv, {
      name: "chevronDown"
    }) : null)));
  };
jC.propTypes = {
  onClick: g.func.isRequired,
  children: g.oneOfType([g.string, g.node]).isRequired,
  variation: g.oneOf(["primary", "secondary", "danger", "white"]),
  appearance: g.oneOf(["filled", "outline", "outline-white-bg", "ghost"]),
  size: g.oneOf(["dense", "default", "large"]),
  prependIcon: g.node,
  appendIcon: g.node,
  isDisabled: g.bool,
  isFullWidth: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  id: g.string,
  buttonType: g.oneOf(["button", "submit"]),
  className: g.string,
  title: g.string,
  role: g.string,
  onClickOutside: g.func,
  isDropdown: g.bool,
  customButtonColor: g.string,
  customTextColor: g.string
}, jC.defaultProps = {
  variation: "primary",
  appearance: "filled",
  textAlign: "center",
  buttonType: "button"
};
var JC = "iconButton-module_iconButton__MZzv3",
  ZC = "iconButton-module_denseIcon__37ONs",
  WC = function (e) {
    return /*#__PURE__*/t.createElement(jC, N({}, e, {
      className: tC(JC, k({}, ZC, "dense" === e.size), e.className),
      appendIcon: null,
      prependIcon: null,
      isDropdown: null,
      icon: null,
      size: e.size
    }), e.children);
  };
WC.propTypes = {
  onClick: g.func.isRequired,
  children: g.node.isRequired,
  variation: g.oneOf(["primary", "secondary", "danger"]),
  appearance: g.oneOf(["filled", "outline", "outline-white-bg", "ghost"]),
  size: g.oneOf(["dense", "default"]),
  isDisabled: g.bool,
  isFullWidth: g.bool,
  id: g.string,
  className: g.string,
  onClickOutside: g.func,
  customButtonColor: g.string,
  customTextColor: g.string
}, WC.defaultProps = {
  variation: "primary",
  appearance: "filled",
  size: "default"
};
var XC = {
    avatar: "avatar-module_avatar__2wwMg",
    image: "avatar-module_image__2n4E5",
    initials: "avatar-module_initials__15M7K",
    "size-m": "avatar-module_size-m__1Ivjt",
    "size-l": "avatar-module_size-l__C0Wda",
    "size-xl": "avatar-module_size-xl__18LAD",
    "size-xxl": "avatar-module_size-xxl__2tOp6"
  },
  UC = function (e) {
    var n = e.variation,
      r = e.initials,
      o = e.imageSrc,
      i = e.imageAlt,
      a = e.size;
    return "image" === n ? /*#__PURE__*/t.createElement("img", {
      className: tC(XC.avatar, XC.image, k({}, XC["size-".concat(a)], a)),
      src: o,
      alt: i
    }) : /*#__PURE__*/t.createElement("div", {
      className: tC(XC.avatar, XC.initials, k({}, XC["size-".concat(a)], a))
    }, r.length > 0 ? r.slice(0, 2) : null);
  };
UC.propTypes = {
  variation: g.oneOf(["image", "initials"]),
  initials: g.string,
  imageSrc: g.string,
  imageAlt: g.string,
  size: g.oneOf(["m", "l", "xl", "xxl"])
}, UC.defaultProps = {
  variation: "initials",
  initials: "AB",
  size: "m",
  imageAlt: ""
};
var KC = {
    overlay: "overlay-module_overlay__3gsL_",
    reveal: "overlay-module_reveal__36CW3",
    "position-fixed": "overlay-module_position-fixed__ibDqZ",
    "position-absolute": "overlay-module_position-absolute__3uHPM",
    "zIndex-navigation": "overlay-module_zIndex-navigation__1vT_K",
    "zIndex-modals": "overlay-module_zIndex-modals__2exb8",
    "zIndex-preloaders": "overlay-module_zIndex-preloaders__1dt2v",
    "zIndex-everything": "overlay-module_zIndex-everything__2l2cR",
    "color-transparent": "overlay-module_color-transparent__D5Oy_",
    "color-dark": "overlay-module_color-dark__2jZBX",
    "color-white": "overlay-module_color-white__1nlyN",
    "color-white-opaque": "overlay-module_color-white-opaque__3JkVK",
    activeCursor: "overlay-module_activeCursor__1GCsU"
  },
  YC = function (e) {
    var n,
      o = e.reveal,
      i = e.closeOnClick,
      a = e.color,
      c = e.position,
      s = e.top,
      l = e.right,
      u = e.bottom,
      d = e.left,
      f = e.zIndex,
      p = e.freezeBody,
      m = {};
    return s && (m = z(z({}, m), {}, {
      top: s
    })), l && (m = z(z({}, m), {}, {
      right: l
    })), u && (m = z(z({}, m), {}, {
      bottom: u
    })), d && (m = z(z({}, m), {}, {
      left: d
    })), r(function () {
      var e = document.querySelector("body"),
        t = document.body.style.top;
      e.style.top = o && p ? "-".concat(window.scrollY, "px") : "", e.style.overflow = o && p ? "hidden" : "", e.style.position = o && p ? "fixed" : "", e.style.width = o && p ? "100%" : "", !o && p && window.scrollTo(0, -1 * Number.parseInt(t || "0"));
    }, [o, p]), /*#__PURE__*/t.createElement("div", {
      role: "button",
      tabIndex: 0,
      onKeyDown: function (e) {
        "Escape" === e.code && i();
      },
      onClick: i,
      className: tC(KC.overlay, (n = {}, k(n, KC.reveal, o), k(n, KC["color-".concat(a)], a), k(n, KC["position-".concat(c)], c), k(n, KC["zIndex-".concat(f)], f), k(n, KC.activeCursor, i), n)),
      style: m
    });
  };
YC.propTypes = {
  reveal: g.bool,
  color: g.oneOf(["transparent", "dark", "white", "white-opaque"]),
  position: g.oneOf(["absolute", "fixed"]),
  top: g.oneOfType([g.number, g.string]),
  right: g.oneOfType([g.number, g.string]),
  bottom: g.oneOfType([g.number, g.string]),
  left: g.oneOfType([g.number, g.string]),
  zIndex: g.oneOf(["navigation", "modals", "preloaders", "everything"]),
  closeOnClick: g.func,
  freezeBody: g.bool
}, YC.defaultProps = {
  color: "dark",
  position: "fixed",
  zIndex: "modals",
  freezeBody: !0
};
var qC = "panel-module_panel__3pPPg",
  _C = "panel-module_shadow__h93rP",
  $C = "panel-module_removeBorder__2j1TK",
  eb = {
    "padding-xxs": "Box-module_padding-xxs__DGHEK",
    "padding-xs": "Box-module_padding-xs__1trre",
    "padding-s": "Box-module_padding-s__3zCtm",
    "padding-m": "Box-module_padding-m__3SkTd",
    "padding-l": "Box-module_padding-l__22LSy",
    "padding-xl": "Box-module_padding-xl__2QCUL",
    "padding-xxl": "Box-module_padding-xxl__3ONgU",
    "padding-top-xxs": "Box-module_padding-top-xxs__1vhtf",
    "padding-top-xs": "Box-module_padding-top-xs__2Q11i",
    "padding-top-s": "Box-module_padding-top-s__RSE3y",
    "padding-top-m": "Box-module_padding-top-m__3DBQt",
    "padding-top-l": "Box-module_padding-top-l__1ACd2",
    "padding-top-xl": "Box-module_padding-top-xl__1DFQ7",
    "padding-top-xxl": "Box-module_padding-top-xxl__1WG5Z",
    "padding-right-xxs": "Box-module_padding-right-xxs__1gO4b",
    "padding-right-xs": "Box-module_padding-right-xs__3hI75",
    "padding-right-s": "Box-module_padding-right-s__2bkMj",
    "padding-right-m": "Box-module_padding-right-m__3seaL",
    "padding-right-l": "Box-module_padding-right-l__28mEw",
    "padding-right-xl": "Box-module_padding-right-xl__3InK1",
    "padding-right-xxl": "Box-module_padding-right-xxl__oF6OY",
    "padding-bottom-xxs": "Box-module_padding-bottom-xxs__1KFWd",
    "padding-bottom-xs": "Box-module_padding-bottom-xs__eOnYU",
    "padding-bottom-s": "Box-module_padding-bottom-s__1JlIf",
    "padding-bottom-m": "Box-module_padding-bottom-m__2FS6P",
    "padding-bottom-l": "Box-module_padding-bottom-l__1EhuA",
    "padding-bottom-xl": "Box-module_padding-bottom-xl__2yxX9",
    "padding-bottom-xxl": "Box-module_padding-bottom-xxl__3VGSy",
    "padding-left-xxs": "Box-module_padding-left-xxs__yiX4Y",
    "padding-left-xs": "Box-module_padding-left-xs__R7mm0",
    "padding-left-s": "Box-module_padding-left-s__2xoI2",
    "padding-left-m": "Box-module_padding-left-m__2wHtt",
    "padding-left-l": "Box-module_padding-left-l__1MzCJ",
    "padding-left-xl": "Box-module_padding-left-xl__3pI6Q",
    "padding-left-xxl": "Box-module_padding-left-xxl__MXrqx",
    "padding-vertical-xxs": "Box-module_padding-vertical-xxs__1SNyY",
    "padding-vertical-xs": "Box-module_padding-vertical-xs__28e7k",
    "padding-vertical-s": "Box-module_padding-vertical-s__3NHTj",
    "padding-vertical-m": "Box-module_padding-vertical-m__MLAfX",
    "padding-vertical-l": "Box-module_padding-vertical-l__B_byz",
    "padding-vertical-xl": "Box-module_padding-vertical-xl__lIHIO",
    "padding-vertical-xxl": "Box-module_padding-vertical-xxl__3x4rf",
    "padding-horizontal-xxs": "Box-module_padding-horizontal-xxs__5Fz0F",
    "padding-horizontal-xs": "Box-module_padding-horizontal-xs__PMUiH",
    "padding-horizontal-s": "Box-module_padding-horizontal-s__hSEKP",
    "padding-horizontal-m": "Box-module_padding-horizontal-m__1BDD8",
    "padding-horizontal-l": "Box-module_padding-horizontal-l__2DdnJ",
    "padding-horizontal-xl": "Box-module_padding-horizontal-xl__2VwHr",
    "padding-horizontal-xxl": "Box-module_padding-horizontal-xxl__2gecm",
    truncateWrapper: "Box-module_truncateWrapper__2N9xC"
  },
  tb = ["children", "display", "className", "renderAs", "padding", "flex", "flexBasis", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingVertical", "paddingHorizontal", "style", "setPositionRelative", "isTextTruncateWrapper"],
  nb = function (e) {
    var n,
      r = e.children,
      o = e.display,
      i = e.className,
      a = e.renderAs,
      c = e.padding,
      s = e.flex,
      l = e.flexBasis,
      u = e.paddingTop,
      d = e.paddingRight,
      f = e.paddingBottom,
      p = e.paddingLeft,
      m = e.paddingVertical,
      h = e.paddingHorizontal,
      A = e.style,
      g = e.setPositionRelative,
      v = e.isTextTruncateWrapper,
      C = S(e, tb),
      b = z({}, A);
    return l && (b = z(z({}, b), {}, {
      flexBasis: "".concat(l)
    })), s && (b = z(z({}, b), {}, {
      flex: "".concat(s)
    })), /*#__PURE__*/t.createElement(RC, N({
      renderAs: a,
      display: o,
      className: tC((n = {}, k(n, eb["padding-".concat(c)], c), k(n, eb["padding-top-".concat(u)], u), k(n, eb["padding-right-".concat(d)], d), k(n, eb["padding-bottom-".concat(f)], f), k(n, eb["padding-left-".concat(p)], p), k(n, eb["padding-vertical-".concat(m)], m), k(n, eb["padding-horizontal-".concat(h)], h), k(n, eb.truncateWrapper, v), n), i),
      setPositionRelative: g
    }, C, {
      style: b
    }), r);
  };
nb.propTypes = {
  children: g.any,
  renderAs: g.string,
  display: g.oneOf(["block", "inline", "inline-block"]),
  padding: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingTop: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingRight: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingBottom: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingLeft: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingVertical: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingHorizontal: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  flex: g.string,
  flexBasis: g.string,
  className: g.string,
  setPositionRelative: g.bool,
  isTextTruncateWrapper: g.bool
}, nb.defaultProps = {
  display: "block",
  renderAs: "div"
};
var rb = ["addShadow", "children", "className", "padding", "onClickOutside", "removeBorder"],
  ob = function (e) {
    var n,
      i = e.addShadow,
      a = e.children,
      c = e.className,
      s = e.padding,
      l = e.onClickOutside,
      u = e.removeBorder,
      d = S(e, rb),
      f = o(null),
      p = GC(f).isOutsideClick;
    return r(function () {
      p && l && l();
    }, [p]), /*#__PURE__*/t.createElement(nb, N({
      domRef: f,
      className: tC(qC, (n = {}, k(n, _C, i), k(n, $C, u), n), c),
      padding: s
    }, d), a);
  };
ob.propTypes = {
  addShadow: g.bool,
  children: g.any.isRequired,
  className: g.string,
  onClickOutside: g.func,
  removeBorder: g.bool
};
var ib = {
    progress: "ProgressBar-module_progress__2qLly",
    "track-color-blue": "ProgressBar-module_track-color-blue__27Dcj",
    "track-color-purple": "ProgressBar-module_track-color-purple__2Gitt",
    "track-color-green": "ProgressBar-module_track-color-green__1jJHd",
    "track-color-yellow": "ProgressBar-module_track-color-yellow__jC2Mc",
    "track-color-red": "ProgressBar-module_track-color-red__4zfn6",
    progressIndicator: "ProgressBar-module_progressIndicator__1fKqw",
    "indicator-color-blue": "ProgressBar-module_indicator-color-blue__1ZvsF",
    "indicator-color-purple": "ProgressBar-module_indicator-color-purple__3F6ix",
    "indicator-color-green": "ProgressBar-module_indicator-color-green__JfB-g",
    "indicator-color-yellow": "ProgressBar-module_indicator-color-yellow__1O1iE",
    "indicator-color-red": "ProgressBar-module_indicator-color-red__1Urq2"
  },
  ab = {
    "padding-xxs": "FlexBox-module_padding-xxs__1tEjz",
    "padding-xs": "FlexBox-module_padding-xs__Tgh7q",
    "padding-s": "FlexBox-module_padding-s__1YK7j",
    "padding-m": "FlexBox-module_padding-m__3PQ3A",
    "padding-l": "FlexBox-module_padding-l__Ddn7p",
    "padding-xl": "FlexBox-module_padding-xl__tWTdC",
    "padding-xxl": "FlexBox-module_padding-xxl__wua71",
    "padding-top-xxs": "FlexBox-module_padding-top-xxs__2jv9X",
    "padding-top-xs": "FlexBox-module_padding-top-xs__3ykXC",
    "padding-top-s": "FlexBox-module_padding-top-s__TCXOM",
    "padding-top-m": "FlexBox-module_padding-top-m__2wUIW",
    "padding-top-l": "FlexBox-module_padding-top-l__3OXzw",
    "padding-top-xl": "FlexBox-module_padding-top-xl__zvcxy",
    "padding-top-xxl": "FlexBox-module_padding-top-xxl__1hG6Q",
    "padding-right-xxs": "FlexBox-module_padding-right-xxs__2nr6O",
    "padding-right-xs": "FlexBox-module_padding-right-xs__2qO2s",
    "padding-right-s": "FlexBox-module_padding-right-s__2eB-R",
    "padding-right-m": "FlexBox-module_padding-right-m__1_zg3",
    "padding-right-l": "FlexBox-module_padding-right-l__1IM-6",
    "padding-right-xl": "FlexBox-module_padding-right-xl__1YqAK",
    "padding-right-xxl": "FlexBox-module_padding-right-xxl__1sscX",
    "padding-bottom-xxs": "FlexBox-module_padding-bottom-xxs__21oct",
    "padding-bottom-xs": "FlexBox-module_padding-bottom-xs__28oDQ",
    "padding-bottom-s": "FlexBox-module_padding-bottom-s__TQ1L7",
    "padding-bottom-m": "FlexBox-module_padding-bottom-m__1hqL6",
    "padding-bottom-l": "FlexBox-module_padding-bottom-l__2e9Sj",
    "padding-bottom-xl": "FlexBox-module_padding-bottom-xl__3Iy7I",
    "padding-bottom-xxl": "FlexBox-module_padding-bottom-xxl__1c8e2",
    "padding-left-xxs": "FlexBox-module_padding-left-xxs__SLvDz",
    "padding-left-xs": "FlexBox-module_padding-left-xs__9C6VM",
    "padding-left-s": "FlexBox-module_padding-left-s__1cCq4",
    "padding-left-m": "FlexBox-module_padding-left-m__3kvmi",
    "padding-left-l": "FlexBox-module_padding-left-l__16VXB",
    "padding-left-xl": "FlexBox-module_padding-left-xl__1bP-k",
    "padding-left-xxl": "FlexBox-module_padding-left-xxl__eVSYY",
    "padding-vertical-xxs": "FlexBox-module_padding-vertical-xxs__1HRZH",
    "padding-vertical-xs": "FlexBox-module_padding-vertical-xs__3x7S6",
    "padding-vertical-s": "FlexBox-module_padding-vertical-s__2yMQm",
    "padding-vertical-m": "FlexBox-module_padding-vertical-m__1_eDF",
    "padding-vertical-l": "FlexBox-module_padding-vertical-l__3Be4E",
    "padding-vertical-xl": "FlexBox-module_padding-vertical-xl__VlH-s",
    "padding-vertical-xxl": "FlexBox-module_padding-vertical-xxl__1uxMI",
    "padding-horizontal-xxs": "FlexBox-module_padding-horizontal-xxs__2JWZZ",
    "padding-horizontal-xs": "FlexBox-module_padding-horizontal-xs__24qmh",
    "padding-horizontal-s": "FlexBox-module_padding-horizontal-s__36Fbo",
    "padding-horizontal-m": "FlexBox-module_padding-horizontal-m__1by1_",
    "padding-horizontal-l": "FlexBox-module_padding-horizontal-l__2U3sd",
    "padding-horizontal-xl": "FlexBox-module_padding-horizontal-xl__2bB1_",
    "padding-horizontal-xxl": "FlexBox-module_padding-horizontal-xxl__3qzh_",
    "gap-xxs": "FlexBox-module_gap-xxs__3sC05",
    "gap-xs": "FlexBox-module_gap-xs__1atrl",
    "gap-s": "FlexBox-module_gap-s__4QgHs",
    "gap-m": "FlexBox-module_gap-m__mgYgU",
    "gap-l": "FlexBox-module_gap-l__23o1w",
    "gap-xl": "FlexBox-module_gap-xl__2jL3K",
    "gap-xxl": "FlexBox-module_gap-xxl__314VO",
    minWidth: "FlexBox-module_minWidth__2SQ9E"
  },
  cb = ["children", "className", "renderAs", "isInlineFlex", "flexGrow", "flexShrink", "flexWrap", "flexBasis", "flex", "justifyContent", "alignItems", "flexDirection", "gap", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingVertical", "paddingHorizontal", "setPositionRelative", "isTextTruncateWrapper", "style"],
  sb = function (e) {
    var n,
      r = e.children,
      o = e.className,
      i = e.renderAs,
      a = e.isInlineFlex,
      c = e.flexGrow,
      s = e.flexShrink,
      l = e.flexWrap,
      u = e.flexBasis,
      d = e.flex,
      f = e.justifyContent,
      p = e.alignItems,
      m = e.flexDirection,
      h = e.gap,
      A = e.padding,
      g = e.paddingTop,
      v = e.paddingRight,
      C = e.paddingBottom,
      b = e.paddingLeft,
      E = e.paddingVertical,
      y = e.paddingHorizontal,
      I = e.setPositionRelative,
      B = e.isTextTruncateWrapper,
      x = e.style,
      w = S(e, cb),
      Q = z({}, x);
    return u && (Q = z(z({}, Q), {}, {
      flexBasis: "".concat(u)
    })), d && (Q = z(z({}, Q), {}, {
      flex: "".concat(d)
    })), /*#__PURE__*/t.createElement(RC, N({
      renderAs: i,
      className: tC((n = {}, k(n, ab["gap-".concat(h)], h), k(n, ab["padding-".concat(A)], A), k(n, ab["padding-top-".concat(g)], g), k(n, ab["padding-right-".concat(v)], v), k(n, ab["padding-bottom-".concat(C)], C), k(n, ab["padding-left-".concat(b)], b), k(n, ab["padding-vertical-".concat(E)], E), k(n, ab["padding-horizontal-".concat(y)], y), k(n, ab.minWidth, B), n), o),
      display: a ? "inline-flex" : "flex",
      flexGrow: c,
      flexWrap: l,
      flexShrink: s,
      justifyContent: f,
      alignItems: p,
      flexDirection: m,
      setPositionRelative: I
    }, w, {
      style: Q
    }), r);
  };
sb.propTypes = {
  justifyContent: g.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"]),
  alignItems: g.oneOf(["flex-start", "flex-end", "center", "baseline", "stretch"]),
  flexDirection: g.oneOf(["row", "row-reverse", "column", "column-reverse"]),
  flexWrap: g.oneOf(["nowrap", "wrap", "wrap-reverse"]),
  flexGrow: g.oneOf(["0", 1, 2, 3, 4, 5]),
  flexShrink: g.oneOf(["0", 1, 2, 3, 4, 5]),
  flex: g.string,
  flexBasis: g.string,
  gap: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  isInlineFlex: g.bool,
  padding: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingTop: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingRight: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingBottom: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingLeft: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingVertical: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingHorizontal: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  renderAs: g.string,
  children: g.any,
  className: g.string,
  setPositionRelative: g.bool,
  isTextTruncateWrapper: g.bool
}, sb.defaultProps = {
  isInlineFlex: !1,
  justifyContent: "flex-start",
  alignItems: "stretch",
  flexDirection: "row",
  flexWrap: "nowrap"
};
var lb = function (e) {
  var n = e.progress,
    r = e.color;
  return /*#__PURE__*/t.createElement(sb, {
    flexGrow: 1,
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/t.createElement(nb, {
    className: tC(ib.progress, k({}, ib["track-color-".concat(r)], r))
  }, /*#__PURE__*/t.createElement(nb, {
    className: tC(ib.progressIndicator, k({}, ib["indicator-color-".concat(r)], r)),
    style: {
      width: "".concat(n, "%")
    }
  })));
};
lb.propTypes = {
  progress: g.number,
  color: g.oneOf(["blue", "purple", "green", "yellow", "red"])
}, lb.defaultProps = {
  color: "purple"
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var ub = function (e, t) {
  return ub = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) t.hasOwnProperty(n) && (e[n] = t[n]);
  }, ub(e, t);
};
function db(e) {
  var t = e.className,
    n = e.counterClockwise,
    r = e.dashRatio,
    o = e.pathRadius,
    a = e.strokeWidth,
    c = e.style;
  return /*#__PURE__*/i("path", {
    className: t,
    style: Object.assign({}, c, pb({
      pathRadius: o,
      dashRatio: r,
      counterClockwise: n
    })),
    d: fb({
      pathRadius: o,
      counterClockwise: n
    }),
    strokeWidth: a,
    fillOpacity: 0
  });
}
function fb(e) {
  var t = e.pathRadius,
    n = e.counterClockwise ? 1 : 0;
  return "\n      M 50,50\n      m 0,-" + t + "\n      a " + t + "," + t + " " + n + " 1 1 0," + 2 * t + "\n      a " + t + "," + t + " " + n + " 1 1 0,-" + 2 * t + "\n    ";
}
function pb(e) {
  var t = e.counterClockwise,
    n = e.dashRatio,
    r = e.pathRadius,
    o = 2 * Math.PI * r,
    i = (1 - n) * o;
  return {
    strokeDasharray: o + "px " + o + "px",
    strokeDashoffset: (t ? -i : i) + "px"
  };
}
var mb = function (e) {
  function t() {
    return null !== e && e.apply(this, arguments) || this;
  }
  return function (e, t) {
    function n() {
      this.constructor = e;
    }
    ub(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
  }(t, e), t.prototype.getBackgroundPadding = function () {
    return this.props.background ? this.props.backgroundPadding : 0;
  }, t.prototype.getPathRadius = function () {
    return 50 - this.props.strokeWidth / 2 - this.getBackgroundPadding();
  }, t.prototype.getPathRatio = function () {
    var e = this.props,
      t = e.value,
      n = e.minValue,
      r = e.maxValue;
    return (Math.min(Math.max(t, n), r) - n) / (r - n);
  }, t.prototype.render = function () {
    var e = this.props,
      t = e.circleRatio,
      n = e.className,
      r = e.classes,
      o = e.counterClockwise,
      a = e.styles,
      c = e.strokeWidth,
      s = e.text,
      l = this.getPathRadius(),
      u = this.getPathRatio();
    return /*#__PURE__*/i("svg", {
      className: r.root + " " + n,
      style: a.root,
      viewBox: "0 0 100 100",
      "data-test-id": "CircularProgressbar"
    }, this.props.background ? /*#__PURE__*/i("circle", {
      className: r.background,
      style: a.background,
      cx: 50,
      cy: 50,
      r: 50
    }) : null, /*#__PURE__*/i(db, {
      className: r.trail,
      counterClockwise: o,
      dashRatio: t,
      pathRadius: l,
      strokeWidth: c,
      style: a.trail
    }), /*#__PURE__*/i(db, {
      className: r.path,
      counterClockwise: o,
      dashRatio: u * t,
      pathRadius: l,
      strokeWidth: c,
      style: a.path
    }), s ? /*#__PURE__*/i("text", {
      className: r.text,
      style: a.text,
      x: 50,
      y: 50
    }, s) : null);
  }, t.defaultProps = {
    background: !1,
    backgroundPadding: 0,
    circleRatio: 1,
    classes: {
      root: "CircularProgressbar",
      trail: "CircularProgressbar-trail",
      path: "CircularProgressbar-path",
      text: "CircularProgressbar-text",
      background: "CircularProgressbar-background"
    },
    counterClockwise: !1,
    className: "",
    maxValue: 100,
    minValue: 0,
    strokeWidth: 8,
    styles: {
      root: {},
      trail: {},
      path: {},
      text: {},
      background: {}
    },
    text: ""
  }, t;
}(a);
function hb(e) {
  var t = e.rotation,
    n = e.strokeLinecap,
    r = e.textColor,
    o = e.textSize,
    i = e.pathColor,
    a = e.pathTransition,
    c = e.pathTransitionDuration,
    s = e.trailColor,
    l = e.backgroundColor,
    u = null == t ? void 0 : "rotate(" + t + "turn)",
    d = null == t ? void 0 : "center center";
  return {
    root: {},
    path: Ab({
      stroke: i,
      strokeLinecap: n,
      transform: u,
      transformOrigin: d,
      transition: a,
      transitionDuration: null == c ? void 0 : c + "s"
    }),
    trail: Ab({
      stroke: s,
      strokeLinecap: n,
      transform: u,
      transformOrigin: d
    }),
    text: Ab({
      fill: r,
      fontSize: o
    }),
    background: Ab({
      fill: l
    })
  };
}
function Ab(e) {
  return Object.keys(e).forEach(function (t) {
    null == e[t] && delete e[t];
  }), e;
}
var gb = {
    progressCircle: "ProgressCircle-module_progressCircle__DWQpp",
    "size-l": "ProgressCircle-module_size-l__2oqfx",
    "size-xl": "ProgressCircle-module_size-xl__1_LOO",
    "size-xxl": "ProgressCircle-module_size-xxl__1ZELY"
  },
  vb = function (e) {
    var n = e.setSize,
      r = e.customSize,
      o = e.customTextSize,
      i = e.percentageValue,
      a = e.label;
    return /*#__PURE__*/t.createElement(nb, {
      className: tC(gb.progressCircle, k({}, gb["size-".concat(n)], n && !r)),
      style: r ? {
        width: r
      } : null
    }, /*#__PURE__*/t.createElement(mb, {
      value: i,
      text: a,
      styles: hb({
        strokeLinecap: "butt",
        textSize: o
      })
    }));
  };
vb.propTypes = {
  percentageValue: g.number,
  label: g.string,
  setSize: g.oneOf(["l", "xl", "xxl"]),
  customSize: g.oneOfType([g.number, g.string]),
  customTextSize: g.oneOfType([g.number, g.string])
}, vb.defaultProps = {
  percentageValue: 0,
  label: "0%",
  customTextSize: "25px"
};
var Cb = {
    tableContainer: "Table-module_tableContainer__1hlPi",
    addScrollShadow: "Table-module_addScrollShadow__2IlaP",
    table: "Table-module_table__fr8_o",
    isFullWidth: "Table-module_isFullWidth__eyaar",
    isNarrow: "Table-module_isNarrow__12jbC",
    th: "Table-module_th__keWr2",
    td: "Table-module_td__1t9AT",
    thContent: "Table-module_thContent__1ZBTP",
    tdContent: "Table-module_tdContent__1QQX1",
    "valign-row-top": "Table-module_valign-row-top__2cCHP",
    "valign-row-middle": "Table-module_valign-row-middle__11Gmt",
    "valign-row-bottom": "Table-module_valign-row-bottom__1tooL",
    "align-row-left": "Table-module_align-row-left__3ADq6",
    "align-row-center": "Table-module_align-row-center__DrBwE",
    "align-row-right": "Table-module_align-row-right__2uFBC",
    "valign-column-top": "Table-module_valign-column-top__1zCX_",
    "valign-column-middle": "Table-module_valign-column-middle__3enUw",
    "valign-column-bottom": "Table-module_valign-column-bottom__2Jcgp",
    "align-column-left": "Table-module_align-column-left__1b732",
    "align-column-center": "Table-module_align-column-center__g1Pvr",
    "align-column-right": "Table-module_align-column-right__12aB5"
  },
  bb = function (e) {
    var n,
      r = e.vAlign,
      o = e.align,
      i = e.children,
      a = e.width,
      c = e.colspan,
      s = e.rowspan,
      l = e.flexDirection,
      u = e.className,
      d = e.id,
      f = e.contentGap,
      p = e.contentJustifyContent,
      m = e.contentAlignItems;
    return /*#__PURE__*/t.createElement(RC, {
      renderAs: "td",
      className: tC(Cb.td, u),
      style: a && {
        width: a
      },
      colSpan: c,
      rowSpan: s,
      id: d
    }, /*#__PURE__*/t.createElement(sb, {
      className: tC(Cb.tdContent, (n = {}, k(n, Cb["valign-".concat(l, "-").concat(r)], r), k(n, Cb["align-".concat(l, "-").concat(o)], o), n)),
      flexDirection: l,
      gap: f,
      justifyContent: p,
      alignItems: m
    }, i));
  };
bb.propTypes = {
  vAlign: g.oneOf(["top", "middle", "bottom"]),
  align: g.oneOf(["left", "center", "right"]),
  width: g.oneOfType([g.number, g.string]),
  colspan: g.oneOfType([g.number, g.string]),
  rowspan: g.oneOfType([g.number, g.string]),
  children: g.any,
  flexDirection: g.oneOf(["row", "column"]),
  className: g.string,
  id: g.string,
  contentGap: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  contentJustifyContent: g.oneOf(["flex-start", "flex-end", "center", "space-between", "space-around", "space-evenly"]),
  contentAlignItems: g.oneOf(["flex-start", "flex-end", "center", "baseline", "stretch"])
}, bb.defaultProps = {
  vAlign: "middle",
  align: "left",
  flexDirection: "row"
}, bb.displayName = "Table.Cell";
var Eb = function (e) {
  var n,
    r = e.vAlign,
    o = e.align,
    i = e.children,
    a = e.width,
    c = e.colspan,
    s = e.rowspan,
    l = e.flexDirection;
  return /*#__PURE__*/t.createElement(RC, {
    renderAs: "th",
    className: Cb.th,
    style: a && {
      width: a
    },
    colSpan: c,
    rowSpan: s
  }, /*#__PURE__*/t.createElement(sb, {
    className: tC(Cb.thContent, (n = {}, k(n, Cb["valign-".concat(l, "-").concat(r)], r), k(n, Cb["align-".concat(l, "-").concat(o)], o), n)),
    flexDirection: l
  }, i));
};
Eb.propTypes = {
  vAlign: g.oneOf(["top", "middle", "bottom"]),
  align: g.oneOf(["left", "center", "right"]),
  width: g.oneOfType([g.number, g.string]),
  colspan: g.oneOfType([g.number, g.string]),
  rowspan: g.oneOfType([g.number, g.string]),
  children: g.any,
  flexDirection: g.oneOf(["row", "column"])
}, Eb.defaultProps = {
  vAlign: "middle",
  hAlign: "left",
  flexDirection: "row"
}, Eb.displayName = "Table.Header";
var yb = function (e) {
  var o,
    i = e.isScrollable,
    a = e.isNarrow,
    c = e.isFullWidth,
    s = e.children,
    l = V(n(!1), 2),
    u = l[0],
    d = l[1];
  r(function () {
    var e = function (e, t) {
      var n,
        r = arguments,
        o = this;
      return function () {
        clearTimeout(n), n = setTimeout(function () {
          n = null, Reflect.apply(e, o, r);
        }, t);
      };
    }(function () {
      var e = document.querySelector("#tableScrollContainer"),
        t = e.scrollWidth > e.clientWidth;
      d(t);
    }, 50);
    return window.addEventListener("resize", e), e(), function () {
      window.removeEventListener("resize", e);
    };
  }, []);
  var f = /*#__PURE__*/t.createElement(RC, {
    renderAs: "table",
    className: tC(Cb.table, (o = {}, k(o, Cb.isNarrow, a), k(o, Cb.isFullWidth, c), o))
  }, s);
  return i ? /*#__PURE__*/t.createElement(nb, {
    setPositionRelative: !0,
    className: u ? Cb.addScrollShadow : ""
  }, /*#__PURE__*/t.createElement(nb, {
    id: "tableScrollContainer",
    className: Cb.tableContainer
  }, f)) : f;
};
yb.propTypes = {
  children: g.any,
  isScrollable: g.bool,
  isNarrow: g.bool,
  isFullWidth: g.bool
}, yb.defaultProps = {
  isScrollable: !0,
  isFullWidth: !0
}, yb.Cell = bb, yb.Header = Eb;
var Ib = {
    iconBadge: "IconBadge-module_iconBadge__2bzBb",
    "color-gray": "IconBadge-module_color-gray__1hcAF",
    "color-blue": "IconBadge-module_color-blue__178Sm",
    "color-purple": "IconBadge-module_color-purple__2l8Qw",
    "color-green": "IconBadge-module_color-green__3o2uw",
    "color-yellow": "IconBadge-module_color-yellow__1_xhl",
    "color-red": "IconBadge-module_color-red__1CKRZ",
    "size-s": "IconBadge-module_size-s__3CNbE",
    "size-m": "IconBadge-module_size-m__27ajz",
    "size-l": "IconBadge-module_size-l__1tFOp"
  },
  Bb = function (e) {
    var n,
      r = e.iconProps,
      o = e.color,
      i = e.size;
    return /*#__PURE__*/t.createElement(sb, {
      justifyContent: "center",
      alignItems: "center",
      className: tC(Ib.iconBadge, (n = {}, k(n, Ib["color-".concat(o)], o), k(n, Ib["size-".concat(i)], i), n))
    }, /*#__PURE__*/t.createElement(qv, r));
  };
Bb.propTypes = {
  iconProps: g.object.isRequired,
  color: g.oneOf(["gray", "blue", "purple", "green", "yellow", "red"]),
  size: g.oneOf(["s", "m", "l"])
}, Bb.defaultProps = {
  color: "gray",
  size: "m"
};
var xb = "divider-module_divider__2KckZ",
  wb = {
    spacer: "Spacer-module_spacer__157am",
    horizontal: "Spacer-module_horizontal__1Ss9P",
    xxs: "Spacer-module_xxs__1SWNu",
    xs: "Spacer-module_xs__3nq2h",
    s: "Spacer-module_s__ODsIN",
    m: "Spacer-module_m__17rQj",
    l: "Spacer-module_l__2VjR3",
    xl: "Spacer-module_xl__apdp7",
    xxl: "Spacer-module_xxl__23HAl",
    vertical: "Spacer-module_vertical__vI7JP"
  },
  Qb = function (e) {
    var n,
      r = e.size,
      o = e.direction;
    return /*#__PURE__*/t.createElement(RC, {
      className: tC(wb.spacer, (n = {}, k(n, wb["".concat(o)], o), k(n, wb["".concat(r)], r), n))
    });
  };
Qb.propTypes = {
  direction: g.oneOf(["horizontal", "vertical"]),
  size: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"])
}, Qb.defaultProps = {
  size: "s",
  direction: "vertical"
};
var Hb = function (e) {
  var n = e.padding,
    r = e.paddingTop,
    o = e.paddingBottom;
  return /*#__PURE__*/t.createElement(t.Fragment, null, (n || r) && /*#__PURE__*/t.createElement(Qb, {
    size: n || r || null
  }), /*#__PURE__*/t.createElement(nb, {
    className: xb
  }), (n || o) && /*#__PURE__*/t.createElement(Qb, {
    size: n || o || null
  }));
};
Hb.propTypes = {
  padding: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingTop: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"]),
  paddingBottom: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"])
};
var zb = "TextBody-module_body__2Dz2Q",
  Mb = {
    wrapper: "textWrapper-module_wrapper__35qy4",
    "align-left": "textWrapper-module_align-left__2rC0r",
    "align-center": "textWrapper-module_align-center__2RtVp",
    "align-right": "textWrapper-module_align-right__2qtnp",
    "transform-capitalize": "textWrapper-module_transform-capitalize__3frFo",
    "transform-lowercase": "textWrapper-module_transform-lowercase__26l4H",
    "transform-uppercase": "textWrapper-module_transform-uppercase__21GXo",
    "transform-none": "textWrapper-module_transform-none__2Wizd",
    truncate: "textWrapper-module_truncate__1AuEs",
    whiteText: "textWrapper-module_whiteText__2dQrK",
    "color-white": "textWrapper-module_color-white__3gxuA",
    "color-gray": "textWrapper-module_color-gray__wnnpv",
    "color-dark-gray": "textWrapper-module_color-dark-gray__iCXdL",
    "color-light-gray": "textWrapper-module_color-light-gray__2W-rR",
    "color-disabled": "textWrapper-module_color-disabled__1vFBu",
    "weight-semibold": "textWrapper-module_weight-semibold__3oc4V",
    "weight-bold": "textWrapper-module_weight-bold__3Hovq",
    "weight-monospace": "textWrapper-module_weight-monospace__sO_7s",
    "vertical-align-baseline": "textWrapper-module_vertical-align-baseline__2_nq2",
    "vertical-align-sub": "textWrapper-module_vertical-align-sub__17cQC",
    "vertical-align-super": "textWrapper-module_vertical-align-super__3FJ8Y",
    "vertical-align-text-top": "textWrapper-module_vertical-align-text-top__2eY9D",
    "vertical-align-text-bottom": "textWrapper-module_vertical-align-text-bottom__2ht7o",
    "vertical-align-middle": "textWrapper-module_vertical-align-middle__PoIdv",
    "vertical-align-top": "textWrapper-module_vertical-align-top__3yKf5",
    "vertical-align-bottom": "textWrapper-module_vertical-align-bottom__1VmUB"
  },
  kb = ["children", "className", "isFullWidth", "textAlign", "textTransform", "truncate", "whiteText", "textColor", "weight", "verticalAlign"],
  Nb = function (e) {
    var n,
      r = e.children,
      o = e.className,
      i = e.isFullWidth,
      a = e.textAlign,
      c = e.textTransform,
      s = e.truncate,
      l = e.whiteText,
      u = e.textColor,
      d = e.weight,
      f = e.verticalAlign,
      p = S(e, kb);
    return /*#__PURE__*/t.createElement(nb, N({
      display: i ? "block" : "inline-block",
      className: tC(Mb.wrapper, (n = {}, k(n, Mb["align-".concat(a)], a), k(n, Mb["transform-".concat(c)], c), k(n, Mb.truncate, s), k(n, Mb.whiteText, l), k(n, Mb["color-".concat(u)], u), k(n, Mb["weight-".concat(d)], d), k(n, Mb["vertical-align-".concat(f)], f), n), o)
    }, p), r);
  };
Nb.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string
}, Nb.defaultProps = {
  textAlign: "left",
  textTransform: "none",
  weight: "regular"
};
var Sb = ["children", "className"],
  Vb = function (e) {
    var n = e.children,
      r = e.className,
      o = S(e, Sb);
    return /*#__PURE__*/t.createElement(Nb, N({
      className: tC(zb, r)
    }, o), n);
  };
Vb.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
};
var Lb = function () {
    var e = V(n({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: window.innerWidth < 768,
        isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
        isTabletOrGreater: window.innerWidth >= 768,
        isTouch: window.innerWidth < 1024,
        isDesktop: window.innerWidth >= 1024,
        isLargeDesktop: window.innerWidth >= 1280,
        isWidescreen: window.innerWidth >= 1366,
        isHD: window.innerWidth >= 1440,
        isSuperHD: window.innerWidth >= 1680
      }), 2),
      t = e[0],
      o = e[1];
    return r(function () {
      function e() {
        o({
          width: window.innerWidth,
          height: window.innerHeight,
          isMobile: window.innerWidth < 768,
          isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
          isTabletOrGreater: window.innerWidth >= 768,
          isTouch: window.innerWidth < 1024,
          isDesktop: window.innerWidth >= 1024,
          isLargeDesktop: window.innerWidth >= 1280,
          isWidescreen: window.innerWidth >= 1366,
          isHD: window.innerWidth >= 1440,
          isSuperHD: window.innerWidth >= 1680
        });
      }
      return window.addEventListener("resize", e), e(), function () {
        return window.removeEventListener("resize", e);
      };
    }, []), t;
  },
  Pb = "TextDense-module_dense__1sofy",
  Ob = ["children", "className"],
  Tb = function (e) {
    var n = e.children,
      r = e.className,
      o = S(e, Ob);
    return /*#__PURE__*/t.createElement(Nb, N({
      className: tC(Pb, r)
    }, o), n);
  };
Tb.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
};
var Db = function (e) {
  var n = e.label,
    r = e.value,
    o = e.description,
    i = e.removeBottomBorder,
    a = e.padding,
    c = e.collapseOnMobile,
    s = e.labelIsRegularWeight,
    l = e.labelClassName,
    u = e.valueClassName,
    d = Lb().isMobile;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
    alignItems: d && c ? "flex-start" : "center",
    flexDirection: d && c ? "column" : "row",
    paddingVertical: a
  }, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(Vb, {
    weight: s ? "regular" : "semibold",
    isFullWidth: !0,
    textColor: "light-gray",
    className: l
  }, n), o && /*#__PURE__*/t.createElement(Tb, null, o)), d && c && /*#__PURE__*/t.createElement(Qb, {
    size: "xxs"
  }), /*#__PURE__*/t.createElement(sb, {
    flex: "1",
    justifyContent: "flex-end"
  }, /*#__PURE__*/t.createElement(Vb, {
    className: u
  }, r))), !i && /*#__PURE__*/t.createElement(Hb, null));
};
Db.propTypes = {
  label: g.oneOfType([g.string, g.node]),
  labelIsRegularWeight: g.bool,
  value: g.oneOfType([g.string, g.node]),
  description: g.string,
  removeBottomBorder: g.bool,
  padding: g.oneOf(["xxs", "xs", "s", "m"]),
  collapseOnMobile: g.bool,
  labelClassName: g.string,
  valueClassName: g.string
}, Db.defaultProps = {
  label: "Label",
  value: "Value",
  padding: "s",
  collapseOnMobile: !0
};
var Rb = "inputCheckbox-module_wrapper__1JDqd",
  Gb = "inputCheckbox-module_customCheckbox__3tna3",
  Fb = "inputCheckbox-module_isChecked__CBq44",
  jb = "inputCheckbox-module_custom__1JR24",
  Jb = "inputCheckbox-module_hiddenCheckbox__lRHpW",
  Zb = "inputCheckbox-module_label__3DUFR",
  Wb = "inputCheckbox-module_check__IeJb0",
  Xb = function (e) {
    var o,
      i,
      a = e.children,
      c = e.className,
      s = e.checked,
      l = e.removeBottomSpacer,
      u = e.onChange,
      d = e.value,
      f = e.customColor,
      p = V(n(s || !1), 2),
      m = p[0],
      h = p[1];
    return r(function () {
      h(s);
    }, [s]), r(function () {
      f && document.documentElement.style.setProperty("--checkbox-color", f);
    }, [f]), /*#__PURE__*/t.createElement(sb, {
      renderAs: "label",
      className: tC(Rb, k({}, jb, f), c),
      paddingBottom: l ? null : "xs",
      alignItems: "center",
      gap: "xs"
    }, /*#__PURE__*/t.createElement("input", {
      type: "checkbox",
      className: Jb,
      value: d,
      onChange: function () {
        h(!m), u && u(d);
      }
    }), /*#__PURE__*/t.createElement(nb, {
      className: tC(Gb, (o = {}, k(o, Fb, m), k(o, jb, f), o))
    }, /*#__PURE__*/t.createElement("span", {
      className: tC(Wb, (i = {}, k(i, Fb, m), k(i, jb, f), i))
    }, /*#__PURE__*/t.createElement(qv, {
      name: "check"
    }))), a && /*#__PURE__*/t.createElement(nb, {
      flex: "1",
      paddingLeft: "xs",
      className: tC(Zb, k({}, Fb, m))
    }, a));
  };
Xb.propTypes = {
  onChange: g.func,
  removeBottomSpacer: g.bool,
  children: g.string,
  value: g.string,
  className: g.string,
  checked: g.bool,
  customColor: g.string
};
var Ub = {
    inputWrapper: "inputWrapper-module_inputWrapper__IvJfu",
    isActive: "inputWrapper-module_isActive__11aoD",
    custom: "inputWrapper-module_custom__1lruH",
    isDisabled: "inputWrapper-module_isDisabled__1bLTv",
    isError: "inputWrapper-module_isError__2mMue",
    description: "inputWrapper-module_description__1FlrZ",
    adornment: "inputWrapper-module_adornment__3CWBu",
    prefix: "inputWrapper-module_prefix__2y0JX",
    suffix: "inputWrapper-module_suffix__3_ViN",
    inlineEditButtons: "inputWrapper-module_inlineEditButtons__1dLF8",
    "width-pct-quarter": "inputWrapper-module_width-pct-quarter__1uDTS",
    "width-pct-half": "inputWrapper-module_width-pct-half__21xyX",
    "width-pct-three-quarter": "inputWrapper-module_width-pct-three-quarter__3SUxc",
    "width-auto": "inputWrapper-module_width-auto__2qBHT",
    "width-xs": "inputWrapper-module_width-xs__1YjfF",
    "width-s": "inputWrapper-module_width-s__1mZH4",
    "width-m": "inputWrapper-module_width-m__2PzSp",
    "width-l": "inputWrapper-module_width-l__3Q6q6",
    "width-xl": "inputWrapper-module_width-xl__3twOb"
  },
  Kb = {
    pill: "pill-module_pill__2WznZ",
    "color-gray": "pill-module_color-gray__UvKso",
    "color-blue": "pill-module_color-blue__12jMf",
    "color-purple": "pill-module_color-purple__2OMvQ",
    "color-green": "pill-module_color-green__1PtiY",
    "color-yellow": "pill-module_color-yellow__3f1Iw",
    "color-red": "pill-module_color-red__2Bgeh",
    dense: "pill-module_dense__2Riwr",
    closeButton: "pill-module_closeButton__RubRM"
  },
  Yb = function (e) {
    var n,
      r = e.children,
      o = e.color,
      i = e.removeOnClick,
      a = e.isDense;
    return /*#__PURE__*/t.createElement(nb, {
      display: "inline-block",
      className: tC(Kb.pill, (n = {}, k(n, Kb["color-".concat(o)], o), k(n, Kb.dense, a), n)),
      paddingHorizontal: i ? null : "xs",
      paddingLeft: i ? "xs" : null
    }, r, i && /*#__PURE__*/t.createElement("button", {
      className: tC(Kb.closeButton),
      onClick: function () {
        return i();
      }
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    })));
  };
Yb.propTypes = {
  children: g.string.isRequired,
  color: g.oneOf(["gray", "blue", "purple", "green", "yellow", "red"]),
  removeOnClick: g.func,
  isDense: g.bool
}, Yb.defaultProps = {
  color: "gray"
};
var qb = function (e) {
  var n,
    o = e.isActive,
    i = e.removeBottomSpacer,
    a = e.children,
    c = e.isDisabled,
    s = e.className,
    l = e.description,
    u = e.addPrefix,
    d = e.addSuffix,
    f = e.isError,
    p = e.inputWidth,
    m = e.characterCount,
    h = e.characterCountTotal,
    A = e.useCharacterCount,
    g = e.inlineEditOnSubmit,
    v = e.inlineEditSubmitIsDisabled,
    C = e.inlineEditOnCancel,
    b = e.customColor;
  return r(function () {
    b && document.documentElement.style.setProperty("--input-wrapper-focus-color", b);
  }, [b]), /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
    className: tC(Ub.inputWrapper, (n = {}, k(n, Ub.isActive, o), k(n, Ub.isDisabled, c), k(n, Ub.isError, f), k(n, Ub["width-".concat(p)], p), k(n, Ub.custom, b), n), s),
    isInlineFlex: "inline-flex" === p
  }, u && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    className: tC(Ub.adornment, Ub.prefix),
    flexShrink: "0"
  }, /*#__PURE__*/t.createElement("span", null, u)), a, d && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    className: tC(Ub.adornment, Ub.suffix),
    flexShrink: "0"
  }, /*#__PURE__*/t.createElement("div", null, d)), g && /*#__PURE__*/t.createElement(sb, {
    className: Ub.inlineEditButtons,
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(ob, {
    addShadow: !0,
    removeBorder: !0
  }, /*#__PURE__*/t.createElement(WC, {
    onClick: g,
    size: "dense",
    variation: "secondary",
    isDisabled: v
  }, /*#__PURE__*/t.createElement(qv, {
    name: "check"
  }))), /*#__PURE__*/t.createElement(ob, {
    addShadow: !0,
    removeBorder: !0
  }, /*#__PURE__*/t.createElement(WC, {
    onClick: C,
    size: "dense",
    variation: "secondary",
    appearance: "ghost"
  }, /*#__PURE__*/t.createElement(qv, {
    name: "times"
  }))))), (A || l) && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    justifyContent: "space-between",
    className: Ub["width-".concat(p)],
    isInlineFlex: "inline-flex" === p
  }, /*#__PURE__*/t.createElement(nb, {
    className: tC(Ub.description, k({}, Ub.isError, f))
  }, l || " "), m >= 0 && /*#__PURE__*/t.createElement(nb, null, h ? /*#__PURE__*/t.createElement(Yb, {
    isDense: !0
  }, "".concat(m, " / ").concat(h)) : /*#__PURE__*/t.createElement(Yb, {
    color: "blue"
  }, "".concat(m, " chars.")))), !i && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Qb, {
    size: "xs"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xxs"
  })));
};
qb.propTypes = {
  isActive: g.bool,
  removeBottomSpacer: g.bool,
  isDisabled: g.bool,
  addPrefix: g.string,
  addSuffix: g.string,
  className: g.string,
  description: g.string,
  isError: g.bool,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl", "inline-flex"]),
  characterCount: g.number,
  characterCountTotal: g.number,
  useCharacterCount: g.bool,
  inlineEditOnSubmit: g.func,
  inlineEditOnCancel: g.func,
  inlineEditSubmitIsDisabled: g.bool,
  customColor: g.string
}, qb.defaultProps = {
  inputWidth: "xl"
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _b = function () {
  return _b = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, _b.apply(this, arguments);
};
function $b(e, t, n) {
  if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || t);
}
var eE = function (e) {
    return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
  },
  tE = {
    k: 1e3,
    m: 1e6,
    b: 1e9
  },
  nE = function (e) {
    var t = e.value,
      n = e.groupSeparator,
      r = void 0 === n ? "," : n,
      o = e.decimalSeparator,
      i = void 0 === o ? "." : o,
      a = e.allowDecimals,
      c = void 0 === a || a,
      s = e.decimalsLimit,
      l = void 0 === s ? 2 : s,
      u = e.allowNegativeValue,
      d = void 0 === u || u,
      f = e.disableAbbreviations,
      p = void 0 !== f && f,
      m = e.prefix,
      h = void 0 === m ? "" : m,
      A = e.transformRawValue,
      g = (void 0 === A ? function (e) {
        return e;
      } : A)(t);
    if ("-" === g) return g;
    var v = p ? [] : ["k", "m", "b"],
      C = new RegExp("((^|\\D)-\\d)|(-" + eE(h) + ")").test(g),
      b = RegExp("(\\d+)-?" + eE(h)).exec(t) || [],
      E = b[0],
      y = b[1],
      I = function (e, t) {
        void 0 === t && (t = ",");
        var n = new RegExp(eE(t), "g");
        return e.replace(n, "");
      }(h ? E ? g.replace(E, "").concat(y) : g.replace(h, "") : g, r),
      B = function (e, t) {
        var n = eE(t.join("")),
          r = new RegExp("[^\\d" + n + "]", "gi");
        return e.replace(r, "");
      }(I, $b([r, i], v)),
      x = B;
    if (!p) {
      if (v.some(function (e) {
        return e === B.toLowerCase();
      })) return "";
      var w = function (e, t) {
        void 0 === t && (t = ".");
        var n = new RegExp("(\\d+(" + eE(t) + "\\d*)?)([kmb])$", "i"),
          r = e.match(n);
        if (r) {
          var o = r[1],
            i = r[3],
            a = tE[i.toLowerCase()];
          return Number(o.replace(t, ".")) * a;
        }
      }(B, i);
      w && (x = String(w));
    }
    var Q = C && d ? "-" : "";
    if (i && x.includes(i)) {
      var H = B.split(i),
        z = H[0],
        M = H[1],
        k = l && M ? M.slice(0, l) : M;
      return "" + Q + z + (c ? "" + i + k : "");
    }
    return "" + Q + x;
  },
  rE = function (e, t) {
    var n = t.groupSeparator,
      r = void 0 === n ? "," : n,
      o = t.decimalSeparator,
      i = void 0 === o ? "." : o,
      a = new RegExp("\\d([^" + eE(r) + eE(i) + "0-9]+)"),
      c = e.match(a);
    return c ? c[1] : void 0;
  },
  oE = function (e) {
    var t = e.value,
      n = e.decimalSeparator,
      r = e.intlConfig,
      o = e.decimalScale,
      i = e.prefix,
      a = void 0 === i ? "" : i,
      c = e.suffix,
      s = void 0 === c ? "" : c;
    if ("" === t || void 0 === t) return "";
    if ("-" === t) return "-";
    var l = new RegExp("^\\d?-" + (a ? eE(a) + "?" : "") + "\\d").test(t),
      u = "." !== n ? iE(t, n, l) : t,
      d = (r ? new Intl.NumberFormat(r.locale, r.currency ? {
        style: "currency",
        currency: r.currency,
        minimumFractionDigits: o || 0,
        maximumFractionDigits: 20
      } : void 0) : new Intl.NumberFormat(void 0, {
        minimumFractionDigits: o || 0,
        maximumFractionDigits: 20
      })).formatToParts(Number(u)),
      f = aE(d, e),
      p = rE(f, _b({}, e)),
      m = t.slice(-1) === n ? n : "",
      h = (u.match(RegExp("\\d+\\.(\\d+)")) || [])[1];
    return void 0 === o && h && n && (f = f.includes(n) ? f.replace(RegExp("(\\d+)(" + eE(n) + ")(\\d+)", "g"), "$1$2" + h) : p && !s ? f.replace(p, "" + n + h + p) : "" + f + n + h), s && m ? "" + f + m + s : p && m ? f.replace(p, "" + m + p) : p && s ? f.replace(p, "" + m + s) : [f, m, s].join("");
  },
  iE = function (e, t, n) {
    var r = e;
    return t && "." !== t && (r = r.replace(RegExp(eE(t), "g"), "."), n && "-" === t && (r = "-" + r.slice(1))), r;
  },
  aE = function (e, t) {
    var n = t.prefix,
      r = t.groupSeparator,
      o = t.decimalSeparator,
      i = t.decimalScale,
      a = t.disableGroupSeparators,
      c = void 0 !== a && a;
    return e.reduce(function (e, t, a) {
      var s = t.type,
        l = t.value;
      return 0 === a && n ? "minusSign" === s ? [l, n] : "currency" === s ? $b($b([], e), [n]) : [n, l] : "currency" === s ? n ? e : $b($b([], e), [l]) : "group" === s ? c ? e : $b($b([], e), [void 0 !== r ? r : l]) : "decimal" === s ? void 0 !== i && 0 === i ? e : $b($b([], e), [void 0 !== o ? o : l]) : $b($b([], e), "fraction" === s ? [void 0 !== i ? l.slice(0, i) : l] : [l]);
    }, [""]).join("");
  },
  cE = {
    currencySymbol: "",
    groupSeparator: "",
    decimalSeparator: "",
    prefix: "",
    suffix: ""
  },
  sE = function (e) {
    return RegExp(/\d/, "gi").test(e);
  },
  lE = /*#__PURE__*/c(function (e, i) {
    var a = e.allowDecimals,
      c = void 0 === a || a,
      l = e.allowNegativeValue,
      u = void 0 === l || l,
      d = e.id,
      f = e.name,
      p = e.className,
      m = e.customInput,
      h = e.decimalsLimit,
      A = e.defaultValue,
      g = e.disabled,
      v = void 0 !== g && g,
      C = e.maxLength,
      b = e.value,
      E = e.onValueChange,
      y = e.fixedDecimalLength,
      I = e.placeholder,
      B = e.decimalScale,
      x = e.prefix,
      w = e.suffix,
      Q = e.intlConfig,
      H = e.step,
      z = e.min,
      M = e.max,
      k = e.disableGroupSeparators,
      N = void 0 !== k && k,
      S = e.disableAbbreviations,
      V = void 0 !== S && S,
      L = e.decimalSeparator,
      P = e.groupSeparator,
      O = e.onChange,
      T = e.onFocus,
      D = e.onBlur,
      R = e.onKeyDown,
      G = e.onKeyUp,
      F = e.transformRawValue,
      j = function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
          var o = 0;
          for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
        }
        return n;
      }(e, ["allowDecimals", "allowNegativeValue", "id", "name", "className", "customInput", "decimalsLimit", "defaultValue", "disabled", "maxLength", "value", "onValueChange", "fixedDecimalLength", "placeholder", "decimalScale", "prefix", "suffix", "intlConfig", "step", "min", "max", "disableGroupSeparators", "disableAbbreviations", "decimalSeparator", "groupSeparator", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "transformRawValue"]);
    if (L && sE(L)) throw new Error("decimalSeparator cannot be a number");
    if (P && sE(P)) throw new Error("groupSeparator cannot be a number");
    var J = s(function () {
        return function (e) {
          var t = e || {},
            n = t.locale,
            r = t.currency;
          return (n ? new Intl.NumberFormat(n, r ? {
            currency: r,
            style: "currency"
          } : void 0) : new Intl.NumberFormat()).formatToParts(1000.1).reduce(function (e, t, n) {
            return "currency" === t.type ? _b(_b({}, e), 0 === n ? {
              currencySymbol: t.value,
              prefix: t.value
            } : {
              currencySymbol: t.value,
              suffix: t.value
            }) : "group" === t.type ? _b(_b({}, e), {
              groupSeparator: t.value
            }) : "decimal" === t.type ? _b(_b({}, e), {
              decimalSeparator: t.value
            }) : e;
          }, cE);
        }(Q);
      }, [Q]),
      Z = L || J.decimalSeparator || "",
      W = P || J.groupSeparator || "";
    if (Z && W && Z === W && !1 === N) throw new Error("decimalSeparator cannot be the same as groupSeparator");
    var X = {
        decimalSeparator: Z,
        groupSeparator: W,
        disableGroupSeparators: N,
        intlConfig: Q,
        prefix: x || J.prefix,
        suffix: w
      },
      U = {
        decimalSeparator: Z,
        groupSeparator: W,
        allowDecimals: c,
        decimalsLimit: h || y || 2,
        allowNegativeValue: u,
        disableAbbreviations: V,
        prefix: x || J.prefix,
        transformRawValue: F
      },
      K = null != A ? oE(_b(_b({}, X), {
        decimalScale: B,
        value: String(A)
      })) : null != b ? oE(_b(_b({}, X), {
        decimalScale: B,
        value: String(b)
      })) : "",
      Y = n(K),
      q = Y[0],
      _ = Y[1],
      $ = n(!1),
      ee = $[0],
      te = $[1],
      ne = n(0),
      re = ne[0],
      oe = ne[1],
      ie = n(0),
      ae = ie[0],
      ce = ie[1],
      se = n(null),
      le = se[0],
      ue = se[1],
      de = i || o(null),
      fe = function (e, t) {
        te(!0);
        var n = function (e) {
            var t = e.selectionStart,
              n = e.value,
              r = e.lastKeyStroke,
              o = e.stateValue,
              i = e.groupSeparator,
              a = t,
              c = n;
            if (o && a) {
              var s = n.split("");
              return "Backspace" === r && o[a] === i && (s.splice(a - 1, 1), a -= 1), "Delete" === r && o[a] === i && (s.splice(a, 1), a += 1), {
                modifiedValue: c = s.join(""),
                cursorPosition: a
              };
            }
            return {
              modifiedValue: c,
              cursorPosition: t
            };
          }({
            selectionStart: t,
            value: e,
            lastKeyStroke: le,
            stateValue: q,
            groupSeparator: W
          }),
          r = n.modifiedValue,
          o = n.cursorPosition,
          i = nE(_b({
            value: r
          }, U));
        if (!(C && i.replace(/-/g, "").length > C)) {
          if ("" === i || "-" === i || i === Z) return E && E(void 0, f, {
            float: null,
            formatted: "",
            value: ""
          }), void _(i);
          var a = parseFloat(i.replace(Z, ".")),
            c = oE(_b({
              value: i
            }, X));
          if (null != o) {
            var s = o + (c.length - e.length);
            s = s <= 0 ? x ? x.length : 0 : s, oe(s), ce(ae + 1);
          }
          if (_(c), E) E(i, f, {
            float: a,
            formatted: c,
            value: i
          });
        }
      };
    r(function () {
      ee && "-" !== q && de && "object" == typeof de && de.current && de.current.setSelectionRange(re, re);
    }, [q, re, de, ee, ae]);
    var pe = _b({
      type: "text",
      inputMode: "decimal",
      id: d,
      name: f,
      className: p,
      onChange: function (e) {
        var t = e.target,
          n = t.value,
          r = t.selectionStart;
        fe(n, r), O && O(e);
      },
      onBlur: function (e) {
        var t = e.target.value,
          n = nE(_b({
            value: t
          }, U));
        if ("-" === n || !n) return _(""), void (D && D(e));
        var r = function (e, t, n) {
            if (n && e.length > 1) {
              if (e.includes(t)) {
                var r = e.split(t),
                  o = r[0];
                if ((i = r[1]).length > n) return "" + o + t + i.slice(0, n);
              }
              var i,
                a = e.length > n ? new RegExp("(\\d+)(\\d{" + n + "})") : new RegExp("(\\d)(\\d+)"),
                c = e.match(a);
              if (c) return "" + (o = c[1]) + t + c[2];
            }
            return e;
          }(n, Z, y),
          o = function (e, t, n) {
            if (void 0 === t && (t = "."), void 0 === n || "" === e || void 0 === e) return e;
            if (!e.match(/\d/g)) return "";
            var r = e.split(t),
              o = r[0],
              i = r[1];
            if (0 === n) return o;
            var a = i || "";
            if (a.length < n) for (; a.length < n;) a += "0";else a = a.slice(0, n);
            return "" + o + t + a;
          }(r, Z, void 0 !== B ? B : y),
          i = parseFloat(o.replace(Z, ".")),
          a = oE(_b(_b({}, X), {
            value: o
          }));
        E && E(o, f, {
          float: i,
          formatted: a,
          value: o
        }), _(a), D && D(e);
      },
      onFocus: function (e) {
        return T && T(e), q ? q.length : 0;
      },
      onKeyDown: function (e) {
        var t = e.key;
        if (ue(t), H && ("ArrowUp" === t || "ArrowDown" === t)) {
          e.preventDefault(), oe(q.length);
          var n = parseFloat(null != b ? String(b).replace(Z, ".") : nE(_b({
              value: q
            }, U))) || 0,
            r = "ArrowUp" === t ? n + H : n - H;
          if (void 0 !== z && r < z) return;
          if (void 0 !== M && r > M) return;
          var o = String(H).includes(".") ? Number(String(H).split(".")[1].length) : void 0;
          fe(String(o ? r.toFixed(o) : r).replace(".", Z));
        }
        R && R(e);
      },
      onKeyUp: function (e) {
        var t = e.key,
          n = e.currentTarget.selectionStart;
        if ("ArrowUp" !== t && "ArrowDown" !== t && "-" !== q) {
          var r = rE(q, {
            groupSeparator: W,
            decimalSeparator: Z
          });
          if (r && n && n > q.length - r.length && de && "object" == typeof de && de.current) {
            var o = q.length - r.length;
            de.current.setSelectionRange(o, o);
          }
        }
        G && G(e);
      },
      placeholder: I,
      disabled: v,
      value: null == b || "-" === q || Z && q === Z ? q : oE(_b(_b({}, X), {
        decimalScale: ee ? void 0 : B,
        value: String(b)
      })),
      ref: de
    }, j);
    if (m) {
      var me = m;
      return /*#__PURE__*/t.createElement(me, _b({}, pe));
    }
    return /*#__PURE__*/t.createElement("input", _b({}, pe));
  });
lE.displayName = "CurrencyInput";
var uE = "InputCurrency-module_isDense__3FZv5",
  dE = "InputCurrency-module_inputText__input__1O2Kb",
  fE = "InputCurrency-module_isDisabled__azTH3",
  pE = ["onValueChange", "placeholder", "decimalsLimit", "disableGroupSeparators", "decimalSeparator", "groupSeparator", "currencyPrefix", "isDense", "isDisabled", "removeBottomSpacer", "value", "onFocus", "onBlur", "isError", "addSuffix", "description", "wrapperClassName", "inputWidth", "fixedDecimalLength"],
  mE = function (e) {
    var r,
      o = e.onValueChange,
      i = e.placeholder,
      a = e.decimalsLimit,
      c = e.disableGroupSeparators,
      s = e.decimalSeparator,
      l = e.groupSeparator,
      u = e.currencyPrefix,
      d = e.isDense,
      f = e.isDisabled,
      p = e.removeBottomSpacer,
      m = e.value,
      h = e.onFocus,
      A = e.onBlur,
      g = e.isError,
      v = e.addSuffix,
      C = e.description,
      b = e.wrapperClassName,
      E = e.inputWidth,
      y = e.fixedDecimalLength,
      I = S(e, pE),
      B = V(n(!1), 2),
      x = B[0],
      w = B[1],
      Q = I.inlineEditOnSubmit || null,
      H = I.inlineEditOnCancel || null,
      z = I.inlineEditSubmitIsDisabled || !1;
    return delete I.inlineEditOnSubmit, delete I.inlineEditOnCancel, delete I.inlineEditSubmitIsDisabled, /*#__PURE__*/t.createElement(qb, {
      isActive: x,
      isDisabled: f,
      removeBottomSpacer: p,
      description: C,
      isError: g,
      addSuffix: v,
      className: b,
      inputWidth: E,
      inlineEditOnSubmit: Q,
      inlineEditOnCancel: H,
      inlineEditSubmitIsDisabled: z,
      customColor: I.customColor
    }, /*#__PURE__*/t.createElement(nb, {
      flex: "1"
    }, /*#__PURE__*/t.createElement(lE, N({
      className: tC(dE, (r = {}, k(r, uE, d), k(r, fE, f), r)),
      onValueChange: o,
      onFocus: function () {
        w(!0), h && h();
      },
      onBlur: function () {
        w(!1), A && A();
      },
      placeholder: i,
      decimalsLimit: a,
      disableGroupSeparators: c,
      decimalSeparator: s,
      groupSeparator: l,
      prefix: u,
      value: m,
      fixedDecimalLength: y
    }, I))));
  };
mE.propTypes = {
  value: g.oneOfType([g.number, g.string]),
  onValueChange: g.func.isRequired,
  decimalsLimit: g.number,
  disableGroupSeparators: g.bool,
  decimalSeparator: g.string,
  groupSeparator: g.string,
  isDense: g.bool,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  onFocus: g.func,
  onBlur: g.func,
  isError: g.bool,
  currencyPrefix: g.string,
  description: g.string,
  wrapperClassName: g.string,
  placeholder: g.string,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"]),
  fixedDecimalLength: g.number
}, mE.defaultProps = {
  decimalsLimit: 2,
  decimalSeparator: ".",
  groupSeparator: ",",
  currencyPrefix: "$"
};
var hE = ["startDateId", "endDateId", "onDatesChange", "onFocusChange", "isDense", "focusedInput", "removeBottomSpacer", "isDisabled", "isError", "description", "addPrefix", "addSuffix", "inputWidth", "isOutsideRange", "showClearDates"],
  AE = function (e) {
    var o = e.startDateId,
      i = e.endDateId,
      a = e.onDatesChange,
      c = e.onFocusChange,
      s = e.isDense,
      l = e.focusedInput,
      u = e.removeBottomSpacer,
      d = e.isDisabled,
      f = e.isError,
      p = e.description,
      m = e.addPrefix,
      h = e.addSuffix,
      A = e.inputWidth,
      g = e.isOutsideRange,
      v = e.showClearDates,
      b = S(e, hE),
      E = V(n(!1), 2),
      y = E[0],
      I = E[1];
    return r(function () {
      I(!!l);
    }, [l]), /*#__PURE__*/t.createElement(qb, {
      isActive: y,
      className: tC(k({}, "ds-date-range-dense", s)),
      removeBottomSpacer: u,
      isDisabled: d,
      description: p,
      isError: f,
      addPrefix: m,
      addSuffix: h,
      inputWidth: A,
      customColor: b.customColor
    }, /*#__PURE__*/t.createElement(nb, {
      flex: "1"
    }, /*#__PURE__*/t.createElement(C, N({
      startDateId: o,
      endDateId: i,
      onDatesChange: a,
      onFocusChange: c,
      customArrowIcon: /*#__PURE__*/t.createElement(qv, {
        name: "longArrowRight",
        iconStyle: "regular"
      }),
      customCloseIcon: /*#__PURE__*/t.createElement(qv, {
        name: "times"
      }),
      customInputIcon: /*#__PURE__*/t.createElement(qv, {
        name: "calendarAlt"
      }),
      focusedInput: l,
      disabled: d,
      isOutsideRange: g,
      showCLearDates: v
    }, b))));
  };
AE.propTypes = {
  onDatesChange: g.func.isRequired,
  onFocusChange: g.func.isRequired,
  addPrefix: g.string,
  addSuffix: g.string,
  description: g.string,
  startDateId: g.string,
  endDateId: g.string,
  focusedInput: g.any,
  isDense: g.bool,
  removeBottomSpacer: g.bool,
  isDisabled: g.bool,
  isError: g.bool,
  inputWidth: g.oneOf(["pct-half", "pct-three-quarter", "auto", "m", "l", "xl"]),
  isOutsideRange: g.func,
  showClearDates: g.bool
}, AE.defaultProps = {
  startDateId: "default_range_picker_start_id",
  endDateId: "default_range_picker_end_id",
  isOutsideRange: function () {
    return !1;
  }
};
var gE = "inputIncrementer-module_isDense__1a-u3",
  vE = "inputIncrementer-module_inputText__input__1O8Qw",
  CE = "inputIncrementer-module_incrementField__1xBNA",
  bE = "inputIncrementer-module_isReadOnly__TxBxZ",
  EE = "inputIncrementer-module_incrementButton__3vnEN",
  yE = "inputIncrementer-module_incrementButton__left__3yMfn",
  IE = "inputIncrementer-module_incrementButton__right__1aMZ5",
  BE = ["inputFocused", "isDense", "removeBottomSpacer", "isDisabled", "onBlur", "onFocus", "min", "max", "step", "onIncrement", "onDecrement", "isError", "description", "value", "onChange", "inputWidth", "inputIsReadOnly"],
  xE = function (e) {
    var o,
      i = e.inputFocused,
      a = e.isDense,
      c = e.removeBottomSpacer,
      s = e.isDisabled,
      l = e.onBlur,
      u = e.onFocus,
      d = e.min,
      f = e.max,
      p = e.step,
      m = e.onIncrement,
      h = e.onDecrement,
      A = e.isError,
      g = e.description,
      v = e.value,
      C = e.onChange,
      b = e.inputWidth,
      E = e.inputIsReadOnly,
      y = S(e, BE),
      I = V(n(!1), 2),
      B = I[0],
      x = I[1],
      w = V(n(v || 0), 2),
      Q = w[0],
      H = w[1],
      z = V(n(Number.parseFloat(d)), 2),
      M = z[0],
      L = z[1],
      P = V(n(Number.parseFloat(f)), 2),
      O = P[0],
      T = P[1];
    return r(function () {
      H(v);
    }, [v]), r(function () {
      L(Number.parseFloat(d)), T(Number.parseFloat(f));
    }, [d, f]), /*#__PURE__*/t.createElement(qb, {
      removeBottomSpacer: c,
      isActive: i || B,
      isDisabled: s,
      description: g,
      isError: A,
      inputWidth: b,
      customColor: y.customColor
    }, /*#__PURE__*/t.createElement("div", {
      className: yE
    }, /*#__PURE__*/t.createElement(WC, {
      variation: "secondary",
      appearance: "ghost",
      className: tC(EE, k({}, gE, a)),
      isDisabled: s,
      onClick: function () {
        var e = Number.parseFloat(Q) - p;
        e < M && (e = M), H(e), C(e), h && h(e);
      }
    }, /*#__PURE__*/t.createElement(qv, {
      name: "minus"
    }))), /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1
    }, /*#__PURE__*/t.createElement(RC, N({
      renderAs: "input",
      type: "number",
      inputMode: "numeric",
      value: Q,
      onBlur: function () {
        x(!1), l && l();
      },
      onFocus: function () {
        x(!0), u && u();
      },
      disabled: s,
      min: d,
      max: f,
      step: p,
      className: tC(vE, CE, (o = {}, k(o, gE, a), k(o, bE, E), o)),
      onChange: function (e) {
        var t = Number(e.target.value);
        t < M && (t = M), t > O && (t = O), C(t);
      },
      readOnly: E
    }, y))), /*#__PURE__*/t.createElement("div", {
      className: IE
    }, /*#__PURE__*/t.createElement(WC, {
      variation: "secondary",
      appearance: "ghost",
      className: tC(EE, k({}, gE, a)),
      isDisabled: s,
      onClick: function () {
        var e = Number.parseFloat(Q) + p;
        e > O && (e = O), H(e), C(e), m && m(e);
      }
    }, /*#__PURE__*/t.createElement(qv, {
      name: "plus"
    }))));
  };
xE.propTypes = {
  onChange: g.func.isRequired,
  value: g.oneOfType([g.number, g.string]).isRequired,
  onIncrement: g.func,
  onDecrement: g.func,
  step: g.number,
  min: g.number,
  max: g.number,
  inputFocused: g.bool,
  onFocus: g.func,
  onBlur: g.func,
  placeholder: g.string,
  isDense: g.bool,
  removeBottomSpacer: g.bool,
  isDisabled: g.bool,
  isError: g.bool,
  description: g.string,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "s", "m", "l", "xl"]),
  inputIsReadOnly: g.bool
}, xE.defaultProps = {
  step: 1,
  inputIsReadOnly: !1
};
var wE = "InputNumber-module_inputText__icon__QYGU1",
  QE = "InputNumber-module_isDense__3WMbs",
  HE = "InputNumber-module_inputText__input__1WtAG",
  zE = "InputNumber-module_hasIconLeft__11frf",
  ME = "InputNumber-module_hasIconRight__lBrzJ",
  kE = "InputNumber-module_isDisabled__2L0qh",
  NE = ["prependIcon", "appendIcon", "inputFocused", "isDense", "className", "removeBottomSpacer", "isDisabled", "onBlur", "onFocus", "min", "max", "step", "isError", "description", "addPrefix", "addSuffix", "wrapperClassName", "inputWidth", "useCharacterCount", "characterCount", "characterCountTotal"],
  SE = function (e) {
    var r,
      i = e.prependIcon,
      a = e.appendIcon,
      c = e.inputFocused,
      s = e.isDense,
      l = e.className,
      u = e.removeBottomSpacer,
      d = e.isDisabled,
      f = e.onBlur,
      p = e.onFocus,
      m = e.min,
      h = e.max,
      A = e.step,
      g = e.isError,
      v = e.description,
      C = e.addPrefix,
      b = e.addSuffix,
      E = e.wrapperClassName,
      y = e.inputWidth,
      I = e.useCharacterCount,
      B = e.characterCount,
      x = e.characterCountTotal,
      w = S(e, NE),
      Q = V(n(!1), 2),
      H = Q[0],
      z = Q[1],
      M = o(null),
      L = w.inlineEditOnSubmit || null,
      P = w.inlineEditOnCancel || null,
      O = w.inlineEditSubmitIsDisabled || !1;
    return delete w.inlineEditOnSubmit, delete w.inlineEditOnCancel, delete w.inlineEditSubmitIsDisabled, /*#__PURE__*/t.createElement(qb, {
      removeBottomSpacer: u,
      isActive: c || H,
      isDisabled: d,
      description: v,
      isError: g,
      addPrefix: C,
      addSuffix: b,
      className: E,
      inputWidth: y,
      inlineEditOnSubmit: L,
      inlineEditOnCancel: P,
      inlineEditSubmitIsDisabled: O,
      customColor: w.customColor,
      useCharacterCount: I,
      characterCount: B,
      characterCountTotal: x
    }, i && /*#__PURE__*/t.createElement(nb, {
      className: tC(wE, k({}, QE, s)),
      onClick: function () {
        M.current.focus();
      }
    }, /*#__PURE__*/t.createElement("span", null, i)), /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1
    }, /*#__PURE__*/t.createElement(RC, N({
      renderAs: "input",
      type: "number",
      inputMode: "numeric",
      domRef: M,
      className: tC(HE, (r = {}, k(r, QE, s), k(r, zE, i), k(r, ME, a), k(r, kE, d), r), l),
      onBlur: function (e) {
        z(!1), f && f(e);
      },
      onFocus: function (e) {
        z(!0), p && p(e);
      },
      disabled: d,
      min: m,
      max: h,
      step: A
    }, w))), a && /*#__PURE__*/t.createElement(nb, {
      className: tC(wE, k({}, QE, s)),
      onClick: function () {
        M.current.focus();
      }
    }, /*#__PURE__*/t.createElement("span", null, a)));
  };
SE.propTypes = {
  onChange: g.func.isRequired,
  value: g.string,
  prependIcon: g.oneOfType([g.node, g.string]),
  appendIcon: g.oneOfType([g.node, g.string]),
  min: g.number,
  max: g.number,
  step: g.oneOfType([g.number, g.string]),
  inputFocused: g.bool,
  isDense: g.bool,
  removeBottomSpacer: g.bool,
  isDisabled: g.bool,
  onFocus: g.func,
  onBlur: g.func,
  isError: g.bool,
  addPrefix: g.string,
  addSuffix: g.string,
  description: g.string,
  placeholder: g.string,
  className: g.string,
  wrapperClassName: g.string,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"]),
  characterCount: g.number,
  characterCountTotal: g.number,
  useCharacterCount: g.bool
};
var VE = {
  version: 4,
  country_calling_codes: {
    1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"],
    7: ["RU", "KZ"],
    20: ["EG"],
    27: ["ZA"],
    30: ["GR"],
    31: ["NL"],
    32: ["BE"],
    33: ["FR"],
    34: ["ES"],
    36: ["HU"],
    39: ["IT", "VA"],
    40: ["RO"],
    41: ["CH"],
    43: ["AT"],
    44: ["GB", "GG", "IM", "JE"],
    45: ["DK"],
    46: ["SE"],
    47: ["NO", "SJ"],
    48: ["PL"],
    49: ["DE"],
    51: ["PE"],
    52: ["MX"],
    53: ["CU"],
    54: ["AR"],
    55: ["BR"],
    56: ["CL"],
    57: ["CO"],
    58: ["VE"],
    60: ["MY"],
    61: ["AU", "CC", "CX"],
    62: ["ID"],
    63: ["PH"],
    64: ["NZ"],
    65: ["SG"],
    66: ["TH"],
    81: ["JP"],
    82: ["KR"],
    84: ["VN"],
    86: ["CN"],
    90: ["TR"],
    91: ["IN"],
    92: ["PK"],
    93: ["AF"],
    94: ["LK"],
    95: ["MM"],
    98: ["IR"],
    211: ["SS"],
    212: ["MA", "EH"],
    213: ["DZ"],
    216: ["TN"],
    218: ["LY"],
    220: ["GM"],
    221: ["SN"],
    222: ["MR"],
    223: ["ML"],
    224: ["GN"],
    225: ["CI"],
    226: ["BF"],
    227: ["NE"],
    228: ["TG"],
    229: ["BJ"],
    230: ["MU"],
    231: ["LR"],
    232: ["SL"],
    233: ["GH"],
    234: ["NG"],
    235: ["TD"],
    236: ["CF"],
    237: ["CM"],
    238: ["CV"],
    239: ["ST"],
    240: ["GQ"],
    241: ["GA"],
    242: ["CG"],
    243: ["CD"],
    244: ["AO"],
    245: ["GW"],
    246: ["IO"],
    247: ["AC"],
    248: ["SC"],
    249: ["SD"],
    250: ["RW"],
    251: ["ET"],
    252: ["SO"],
    253: ["DJ"],
    254: ["KE"],
    255: ["TZ"],
    256: ["UG"],
    257: ["BI"],
    258: ["MZ"],
    260: ["ZM"],
    261: ["MG"],
    262: ["RE", "YT"],
    263: ["ZW"],
    264: ["NA"],
    265: ["MW"],
    266: ["LS"],
    267: ["BW"],
    268: ["SZ"],
    269: ["KM"],
    290: ["SH", "TA"],
    291: ["ER"],
    297: ["AW"],
    298: ["FO"],
    299: ["GL"],
    350: ["GI"],
    351: ["PT"],
    352: ["LU"],
    353: ["IE"],
    354: ["IS"],
    355: ["AL"],
    356: ["MT"],
    357: ["CY"],
    358: ["FI", "AX"],
    359: ["BG"],
    370: ["LT"],
    371: ["LV"],
    372: ["EE"],
    373: ["MD"],
    374: ["AM"],
    375: ["BY"],
    376: ["AD"],
    377: ["MC"],
    378: ["SM"],
    380: ["UA"],
    381: ["RS"],
    382: ["ME"],
    383: ["XK"],
    385: ["HR"],
    386: ["SI"],
    387: ["BA"],
    389: ["MK"],
    420: ["CZ"],
    421: ["SK"],
    423: ["LI"],
    500: ["FK"],
    501: ["BZ"],
    502: ["GT"],
    503: ["SV"],
    504: ["HN"],
    505: ["NI"],
    506: ["CR"],
    507: ["PA"],
    508: ["PM"],
    509: ["HT"],
    590: ["GP", "BL", "MF"],
    591: ["BO"],
    592: ["GY"],
    593: ["EC"],
    594: ["GF"],
    595: ["PY"],
    596: ["MQ"],
    597: ["SR"],
    598: ["UY"],
    599: ["CW", "BQ"],
    670: ["TL"],
    672: ["NF"],
    673: ["BN"],
    674: ["NR"],
    675: ["PG"],
    676: ["TO"],
    677: ["SB"],
    678: ["VU"],
    679: ["FJ"],
    680: ["PW"],
    681: ["WF"],
    682: ["CK"],
    683: ["NU"],
    685: ["WS"],
    686: ["KI"],
    687: ["NC"],
    688: ["TV"],
    689: ["PF"],
    690: ["TK"],
    691: ["FM"],
    692: ["MH"],
    850: ["KP"],
    852: ["HK"],
    853: ["MO"],
    855: ["KH"],
    856: ["LA"],
    880: ["BD"],
    886: ["TW"],
    960: ["MV"],
    961: ["LB"],
    962: ["JO"],
    963: ["SY"],
    964: ["IQ"],
    965: ["KW"],
    966: ["SA"],
    967: ["YE"],
    968: ["OM"],
    970: ["PS"],
    971: ["AE"],
    972: ["IL"],
    973: ["BH"],
    974: ["QA"],
    975: ["BT"],
    976: ["MN"],
    977: ["NP"],
    992: ["TJ"],
    993: ["TM"],
    994: ["AZ"],
    995: ["GE"],
    996: ["KG"],
    998: ["UZ"]
  },
  countries: {
    AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]],
    AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]],
    AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"],
    AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"],
    AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([457]\\d{6})$", "268$1", 0, "268"],
    AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2457]\\d{6})$", "264$1", 0, "264"],
    AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"],
    AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"],
    AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]],
    AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"],
    AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "1|([267]\\d{6})$", "684$1", 0, "684"],
    AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"],
    AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "0|(183[12])", 0, 0, 0, [["(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]],
    AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"],
    AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"],
    BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"],
    BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "246$1", 0, "246"],
    BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:28|4[14]|5)|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"],
    BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"],
    BF: ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]],
    BG: ["359", "00", "[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[047]"]]]],
    BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]],
    BJ: ["229", "00", "[25689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[25689]"]]]],
    BL: ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]],
    BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "441$1", 0, "441"],
    BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]],
    BO: ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"],
    BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"],
    BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"],
    BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([3-8]\\d{6})$", "242$1", 0, "242"],
    BT: ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]],
    BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-79]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]],
    BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"],
    BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]],
    CA: ["1", "011", "(?:[2-8]\\d|90)\\d{8}", [10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|6[578])|4(?:03|1[68]|3[178]|50|74)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47|72)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"], 0, 0, 0, ["600[2-9]\\d{6}"]]],
    CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    CD: ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
    CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]],
    CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]],
    CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"],
    CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]],
    CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]],
    CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-3]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]],
    CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]],
    CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "(?:10|2[0-57-9])(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "0|(1(?:[12]\\d|79)\\d\\d)", 0, 0, 0, 0, "00"],
    CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:(?:1\\d|[36])\\d{3}|9101)\\d{6}|[124-8]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1 $2", ["[146][2-9]|[2578]"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["[39]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"],
    CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"],
    CU: ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["5"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"],
    CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]],
    CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"],
    CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "0|([59]\\d{7})$", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:83[0-38]|93[0-6])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[06-9]|7[02-9]|8[0-24-9]|9[0-27-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"],
    CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]],
    CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]],
    DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:1\\d|2[02-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[05]\\d|[23]1|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[0568]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"],
    DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]],
    DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]],
    DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "767$1", 0, "767"],
    DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"],
    DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"],
    EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"],
    EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
    EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[189]"], "0$1"]], "0"],
    EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"],
    ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"],
    ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]],
    ET: ["251", "00", "(?:11|[2-59]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-59]"], "0$1"]], "0"],
    FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d)(\\d{4,9})", "$1 $2", ["[2568][1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[12]00|[368]|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[1245]|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"],
    FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    FK: ["500", "00", "[2-7]\\d{4}", [5]],
    FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]],
    FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"],
    FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"],
    GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[47]\\d{6}|76\\d{6})", "$1"],
    GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0359])|(?:5[0-26-9]|[78][0-49])\\d\\d|6(?:[0-4]\\d\\d|50[0-24-69]))|2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d\\d|1(?:[0-7]\\d\\d|8(?:[02]\\d|1[0-278])))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"],
    GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "473$1", 0, "473"],
    GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"],
    GF: ["594", "00", "(?:[56]94|80\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "0|([25-9]\\d{5})$", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]],
    GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"],
    GI: ["350", "00", "(?:[25]\\d\\d|606)\\d{5}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]],
    GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]],
    GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]],
    GP: ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]],
    GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]],
    GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]],
    GT: ["502", "00", "(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
    GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "1|([3-9]\\d{6})$", "671$1", 0, "671"],
    GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]],
    GY: ["592", "001", "(?:862\\d|9008)\\d{3}|(?:[2-46]\\d|77)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46-9]"]]]],
    HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]],
    HR: ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    HT: ["509", "00", "[2-489]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-489]"]]]],
    HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"],
    ID: ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"],
    IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"],
    IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([25-8]\\d{5})$", "1624$1", 0, "74576|(?:16|7[56])24"],
    IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"],
    IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]],
    IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"],
    IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    IT: ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|55\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[38]"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[1-9]\\d{8}|3[2-9]\\d{7}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]],
    JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "0|([0-24-8]\\d{5})$", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-2]|2[356]|34|4[01347]|5[49]|6[0-369]|77|81|9[139])\\d{6}"], ["56\\d{8}"]]],
    JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"],
    JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    JP: ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9]|636)|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9]|636[457-9])|9(?:496|802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[27-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9])|5(?:2|3[045]|4[0-369]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|49|51|6(?:[0-24]|36|5[0-3589]|72|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:49|55|83)[29]|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|7[015-9]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17|3[015-9]))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3[045]|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9(?:[019]|4[1-3]|6(?:[0-47-9]|5[01346-9])))|3(?:[29]|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[23]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|72|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|829(?:2|66)|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0"],
    KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"],
    KG: ["996", "00", "8\\d{9}|(?:[235-8]\\d|99)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"],
    KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]],
    KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "869$1", 0, "869"],
    KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"],
    KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"],
    KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]],
    KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "345$1", 0, "345"],
    KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"],
    LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"],
    LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"],
    LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "1|([2-8]\\d{6})$", "758$1", 0, "758"],
    LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "0|(1001)"],
    LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"],
    LR: ["231", "00", "(?:2|33|5\\d|77|88)\\d{7}|[4-6]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[4-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3578]"], "0$1"]], "0"],
    LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]],
    LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"],
    LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],
    LV: ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]],
    LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"],
    MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{5})(\\d{4})", "$1-$2", ["5(?:29|38)", "5(?:29|38)[89]", "5(?:29|38)[89]0"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|892", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|892"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:29(?:[189][05]|2[29]|3[01])|38[89][05])\\d{4}|5(?:2(?:[0-25-7]\\d|3[1-578]|4[02-46-8]|8[0235-7]|90)|3(?:[0-47]\\d|5[02-9]|6[02-8]|80|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[01]\\d|6[1267]|7[0-57]))\\d{6}"], ["80\\d{7}"], ["89\\d{7}"], 0, 0, 0, 0, ["592(?:4[0-2]|93)\\d{4}"]]],
    MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"],
    MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"],
    ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"],
    MF: ["590", "00", "(?:590|(?:69|80)\\d|976)\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["976[01]\\d{5}"]]],
    MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "0|([24-9]\\d{6})$", "20$1"],
    MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"],
    MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"],
    ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]],
    MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"],
    MN: ["976", "001", "[12]\\d{7,9}|[57-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[57-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"],
    MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]],
    MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "670$1", 0, "670"],
    MQ: ["596", "00", "(?:69|80)\\d{7}|(?:59|97)6\\d{6}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]],
    MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "1|([34]\\d{6})$", "664$1", 0, "664"],
    MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]],
    MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:5|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["5"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"],
    MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[3467]|9[13-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    MW: ["265", "00", "(?:[19]\\d|[23]1|77|88)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"],
    MX: ["52", "0[09]", "1(?:(?:44|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[017]\\d|[235][1-9]|4[0-35-9]|6[0-46-9]|8[1-79]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"],
    MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9])|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1[36-8]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"],
    MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]],
    NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    NC: ["687", "00", "[2-57-9]\\d{5}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[2-57-9]"]]]],
    NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[04]"]]]],
    NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"],
    NG: ["234", "009", "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"],
    NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]],
    NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|[89]\\d{6,9}|1\\d{4,5}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-57-9]"], "0$1"]], "0"],
    NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[489]|59"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-7]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"],
    NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-579]|6[2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"],
    NR: ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]],
    NU: ["683", "00", "(?:[47]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]],
    NZ: ["64", "0(?:0|161)", "[29]\\d{7,9}|50\\d{5}(?:\\d{2,3})?|6[0-35-9]\\d{6}|7\\d{7,8}|8\\d{4,9}|(?:11\\d|[34])\\d{7}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-579]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|[89]0", "50(?:[0367]|88)|[89]0"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[59]|80"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7|86"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"],
    OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]],
    PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]],
    PE: ["51", "19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, 0, " Anexo "],
    PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
    PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"],
    PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"],
    PL: ["48", "00", "6\\d{5}(?:\\d{2})?|8\\d{9}|[1-9]\\d{6}(?:\\d{2})?", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]],
    PM: ["508", "00", "(?:[45]|80\\d\\d)\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"],
    PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"],
    PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]],
    PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]],
    PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-6])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"],
    QA: ["974", "00", "[2-7]\\d{7}|800\\d{4}(?:\\d{2})?|2\\d{6}", [7, 8, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["2[126]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]"]]]],
    RE: ["262", "00", "9769\\d{5}|(?:26|[68]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, "26[23]|69|[89]"],
    RO: ["40", "00", "(?:[2378]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[237-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "],
    RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"],
    RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-6]2|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-6]2|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"],
    RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]]], "0"],
    SA: ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"],
    SB: ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],
    SC: ["248", "010|0[0-2]", "8000\\d{3}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
    SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"],
    SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-4]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]],
    SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"],
    SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"],
    SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|[57]9)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"],
    SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"],
    SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"],
    SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"],
    SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]],
    SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["24|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3478]|64|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6(?:0[5-7]|[1-35-9])|9[2-9]"]]], "0"],
    SR: ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]],
    SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"],
    ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]],
    SV: ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]],
    SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|(5\\d{6})$", "721$1", 0, "721"],
    SY: ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"],
    SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]],
    TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"],
    TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "1|([2-479]\\d{6})$", "649$1", 0, "649"],
    TD: ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"],
    TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]],
    TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"],
    TJ: ["992", "810", "(?:00|[1-57-9]\\d)\\d{7}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[34]7|91[78]"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"],
    TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]],
    TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]],
    TM: ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
    TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]],
    TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]],
    TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|616)", "5(?:[0-59]|6161)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"],
    TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-46-8]\\d{6})$", "868$1", 0, "868"],
    TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
    TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"],
    TZ: ["255", "00[056]", "(?:[26-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"],
    UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["4[45][0-5]|5(?:0|6[37])|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]", "4[45][0-5]|5(?:0|6(?:3[14-7]|7))|6(?:[12][018]|[36-8])|7|89|9[1-9]|(?:48|57)[0137-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["[3-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"],
    UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"],
    US: ["1", "011", "[2-9]\\d{9}", [10], [["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["5(?:05(?:[2-57-9]\\d\\d|6(?:[0-35-9]\\d|44))|82(?:2(?:0[0-3]|[268]2)|3(?:0[02]|33)|4(?:00|4[24]|65|82)|5(?:00|29|83)|6(?:00|66|82)|777|8(?:00|88)|9(?:00|9[89])))\\d{4}|(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[01356]|3[0-24679]|4[167]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[39]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[0-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[0179]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-289]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01579]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"]]],
    UY: ["598", "0(?:0|1[3-9]\\d)", "4\\d{9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["405|8|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["4"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "],
    UZ: ["998", "810", "(?:33|55|[679]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[35-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"],
    VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"],
    VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "1|([2-7]\\d{6})$", "784$1", 0, "784"],
    VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"],
    VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "1|([2-578]\\d{6})$", "284$1", 0, "284"],
    VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "1|([2-9]\\d{6})$", "340$1", 0, "340"],
    VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[69]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[3578]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"],
    VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]],
    WF: ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]],
    WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]],
    XK: ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"],
    YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7[24-68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"],
    YT: ["262", "00", "80\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, "269|63"],
    ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"],
    ZM: ["260", "00", "(?:63|80)0\\d{6}|(?:21|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"],
    ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"]
  },
  nonGeographic: {
    800: ["800", 0, "(?:005|[1-9]\\d\\d)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:005|[1-9]\\d\\d)\\d{5}"]]],
    808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]],
    870: ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],
    878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]],
    881: ["881", 0, "[0-36-9]\\d{8}", [9], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-36-9]"]]], 0, 0, 0, 0, 0, 0, [0, ["[0-36-9]\\d{8}"]]],
    882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|285\\d{9}|(?:[19]\\d|49)\\d{6}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["4"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[19]"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["34[57]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-3]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|3(?:2|47|7\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:(?:285\\d\\d|3(?:45|[69]\\d{3}))\\d|9[89])\\d{6}"]]],
    883: ["883", 0, "(?:210|370\\d\\d)\\d{7}|51\\d{7}(?:\\d{3})?", [9, 10, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["2"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[35]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:210|(?:370[1-9]|51[013]0)\\d)\\d{7}|5100\\d{5}"]]],
    888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]],
    979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]]
  }
};
function LE(e, t) {
  var n = 0,
    r = t.split(""),
    o = Array.isArray(r),
    i = 0;
  for (r = o ? r : r[Symbol.iterator]();;) {
    var a;
    if (o) {
      if (i >= r.length) break;
      a = r[i++];
    } else {
      if ((i = r.next()).done) break;
      a = i.value;
    }
    a === e && n++;
  }
  return n;
}
function PE(e, t) {
  for (var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "x", r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : " ", o = e.length, i = LE("(", e), a = LE(")", e), c = i - a; c > 0 && o < t.length;) e += t[o].replace(n, r), ")" === t[o] && c--, o++;
  return e;
}
function OE(e, t, n) {
  "string" == typeof n && (n = function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x",
      n = arguments.length > 2 ? arguments[2] : void 0;
    if (!e) return function (e) {
      return {
        text: e
      };
    };
    var r = LE(t, e);
    return function (o) {
      if (!o) return {
        text: "",
        template: e
      };
      var i = 0,
        a = "",
        c = e.split(""),
        s = Array.isArray(c),
        l = 0;
      for (c = s ? c : c[Symbol.iterator]();;) {
        var u;
        if (s) {
          if (l >= c.length) break;
          u = c[l++];
        } else {
          if ((l = c.next()).done) break;
          u = l.value;
        }
        var d = u;
        if (d === t) {
          if (a += o[i], ++i === o.length && o.length < r) break;
        } else a += d;
      }
      return n && (a = PE(a, e)), {
        text: a,
        template: e
      };
    };
  }(n));
  var r = n(e) || {},
    o = r.text,
    i = r.template;
  if (void 0 === o && (o = e), i) if (void 0 === t) t = o.length;else {
    for (var a = 0, c = !1, s = -1; a < o.length && a < i.length;) {
      if (o[a] !== i[a]) {
        if (0 === t) {
          c = !0, t = a;
          break;
        }
        s = a, t--;
      }
      a++;
    }
    c || (t = s + 1);
  }
  return {
    text: o,
    caret: t
  };
}
var TE = 8,
  DE = 46;
function RE(e, t) {
  void 0 !== t && (!function () {
    if ("undefined" != typeof navigator) return GE.test(navigator.userAgent);
  }() ? e.setSelectionRange(t, t) : setTimeout(function () {
    return e.setSelectionRange(t, t);
  }, 0));
}
var GE = /Android/i;
function FE(e, t, n, r, o) {
  var i = function (e) {
    switch (e.keyCode) {
      case TE:
        return "Backspace";
      case DE:
        return "Delete";
    }
  }(e);
  switch (i) {
    case "Delete":
    case "Backspace":
      e.preventDefault();
      var a = function (e) {
        if (e.selectionStart !== e.selectionEnd) return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      }(t);
      return a ? (function (e, t) {
        var n = e.value;
        n = n.slice(0, t.start) + n.slice(t.end), e.value = n, RE(e, t.start);
      }(t, a), jE(t, n, r, void 0, o)) : jE(t, n, r, i, o);
  }
}
function jE(e, t, n, r, o) {
  var i = function (e, t, n) {
      for (var r = "", o = 0, i = 0; i < e.length;) {
        var a = n(e[i], r);
        void 0 !== a && (r += a, void 0 !== t && (t === i ? o = r.length - 1 : t > i && (o = r.length))), i++;
      }
      return void 0 === t && (o = r.length), {
        value: r,
        caret: o
      };
    }(e.value, e.selectionStart, t),
    a = i.value,
    c = i.caret;
  if (r) {
    var s = function (e, t, n) {
      switch (n) {
        case "Backspace":
          t > 0 && (e = e.slice(0, t - 1) + e.slice(t), t--);
          break;
        case "Delete":
          e = e.slice(0, t) + e.slice(t + 1);
      }
      return {
        value: e,
        caret: t
      };
    }(a, c, r);
    a = s.value, c = s.caret;
  }
  var l = OE(a, c, n),
    u = l.text;
  c = l.caret, e.value = u, RE(e, c), o(a);
}
function JE() {
  return JE = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, JE.apply(this, arguments);
}
function ZE(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function WE(e, n) {
  var r = e.value,
    i = e.parse,
    a = e.format,
    c = e.inputComponent,
    s = e.onChange,
    u = e.onKeyDown,
    d = ZE(e, ["value", "parse", "format", "inputComponent", "onChange", "onKeyDown"]),
    f = o(),
    p = l(function (e) {
      f.current = e, n && ("function" == typeof n ? n(e) : n.current = e);
    }, [n]),
    m = l(function (e) {
      jE(f.current, i, a, void 0, s);
    }, [f, i, a, s]),
    h = l(function (e) {
      return u && u(e), FE(e, f.current, i, a, s);
    }, [f, i, a, s, u]);
  return /*#__PURE__*/t.createElement(c, JE({}, d, {
    ref: p,
    value: a(UE(r) ? "" : r).text,
    onKeyDown: h,
    onChange: m
  }));
}
(WE = /*#__PURE__*/t.forwardRef(WE)).propTypes = {
  parse: g.func.isRequired,
  format: g.func.isRequired,
  inputComponent: g.elementType.isRequired,
  type: g.string.isRequired,
  value: g.string,
  onChange: g.func.isRequired,
  onKeyDown: g.func,
  onCut: g.func,
  onPaste: g.func
}, WE.defaultProps = {
  inputComponent: "input",
  type: "text"
};
var XE = WE;
function UE(e) {
  return null == e;
}
var KE = function e(t) {
  !function (e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }(this, e), this.name = this.constructor.name, this.message = t, this.stack = new Error(t).stack;
};
(KE.prototype = Object.create(Error.prototype)).constructor = KE;
var YE = "".concat("-‐-―−ー－").concat("／/").concat("．.").concat("  ­​⁠　").concat("()（）［］\\[\\]").concat("~⁓∼～");
function qE(e, t) {
  e = e.split("-"), t = t.split("-");
  for (var n = e[0].split("."), r = t[0].split("."), o = 0; o < 3; o++) {
    var i = Number(n[o]),
      a = Number(r[o]);
    if (i > a) return 1;
    if (a > i) return -1;
    if (!isNaN(i) && isNaN(a)) return 1;
    if (isNaN(i) && !isNaN(a)) return -1;
  }
  return e[1] && t[1] ? e[1] > t[1] ? 1 : e[1] < t[1] ? -1 : 0 : !e[1] && t[1] ? 1 : e[1] && !t[1] ? -1 : 0;
}
function _E(e) {
  return _E = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, _E(e);
}
function $E(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ey(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function ty(e, t, n) {
  return t && ey(e.prototype, t), n && ey(e, n), e;
}
var ny = /^\d+$/,
  ry = function () {
    function e(t) {
      $E(this, e), function (e) {
        if (!e) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
        if (!ly(e) || !ly(e.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(ly(e) ? "an object of shape: { " + Object.keys(e).join(", ") + " }" : "a " + uy(e) + ": " + e, "."));
      }(t), this.metadata = t, py.call(this, t);
    }
    return ty(e, [{
      key: "getCountries",
      value: function () {
        return Object.keys(this.metadata.countries).filter(function (e) {
          return "001" !== e;
        });
      }
    }, {
      key: "getCountryMetadata",
      value: function (e) {
        return this.metadata.countries[e];
      }
    }, {
      key: "nonGeographic",
      value: function () {
        if (!(this.v1 || this.v2 || this.v3)) return this.metadata.nonGeographic || this.metadata.nonGeographical;
      }
    }, {
      key: "hasCountry",
      value: function (e) {
        return void 0 !== this.getCountryMetadata(e);
      }
    }, {
      key: "hasCallingCode",
      value: function (e) {
        if (this.getCountryCodesForCallingCode(e)) return !0;
        if (this.nonGeographic()) {
          if (this.nonGeographic()[e]) return !0;
        } else {
          var t = this.countryCallingCodes()[e];
          if (t && 1 === t.length && "001" === t[0]) return !0;
        }
      }
    }, {
      key: "isNonGeographicCallingCode",
      value: function (e) {
        return this.nonGeographic() ? !!this.nonGeographic()[e] : !this.getCountryCodesForCallingCode(e);
      }
    }, {
      key: "country",
      value: function (e) {
        return this.selectNumberingPlan(e);
      }
    }, {
      key: "selectNumberingPlan",
      value: function (e, t) {
        if (e && ny.test(e) && (t = e, e = null), e && "001" !== e) {
          if (!this.hasCountry(e)) throw new Error("Unknown country: ".concat(e));
          this.numberingPlan = new oy(this.getCountryMetadata(e), this);
        } else if (t) {
          if (!this.hasCallingCode(t)) throw new Error("Unknown calling code: ".concat(t));
          this.numberingPlan = new oy(this.getNumberingPlanMetadata(t), this);
        } else this.numberingPlan = void 0;
        return this;
      }
    }, {
      key: "getCountryCodesForCallingCode",
      value: function (e) {
        var t = this.countryCallingCodes()[e];
        if (t) {
          if (1 === t.length && 3 === t[0].length) return;
          return t;
        }
      }
    }, {
      key: "getCountryCodeForCallingCode",
      value: function (e) {
        var t = this.getCountryCodesForCallingCode(e);
        if (t) return t[0];
      }
    }, {
      key: "getNumberingPlanMetadata",
      value: function (e) {
        var t = this.getCountryCodeForCallingCode(e);
        if (t) return this.getCountryMetadata(t);
        if (this.nonGeographic()) {
          var n = this.nonGeographic()[e];
          if (n) return n;
        } else {
          var r = this.countryCallingCodes()[e];
          if (r && 1 === r.length && "001" === r[0]) return this.metadata.countries["001"];
        }
      }
    }, {
      key: "countryCallingCode",
      value: function () {
        return this.numberingPlan.callingCode();
      }
    }, {
      key: "IDDPrefix",
      value: function () {
        return this.numberingPlan.IDDPrefix();
      }
    }, {
      key: "defaultIDDPrefix",
      value: function () {
        return this.numberingPlan.defaultIDDPrefix();
      }
    }, {
      key: "nationalNumberPattern",
      value: function () {
        return this.numberingPlan.nationalNumberPattern();
      }
    }, {
      key: "possibleLengths",
      value: function () {
        return this.numberingPlan.possibleLengths();
      }
    }, {
      key: "formats",
      value: function () {
        return this.numberingPlan.formats();
      }
    }, {
      key: "nationalPrefixForParsing",
      value: function () {
        return this.numberingPlan.nationalPrefixForParsing();
      }
    }, {
      key: "nationalPrefixTransformRule",
      value: function () {
        return this.numberingPlan.nationalPrefixTransformRule();
      }
    }, {
      key: "leadingDigits",
      value: function () {
        return this.numberingPlan.leadingDigits();
      }
    }, {
      key: "hasTypes",
      value: function () {
        return this.numberingPlan.hasTypes();
      }
    }, {
      key: "type",
      value: function (e) {
        return this.numberingPlan.type(e);
      }
    }, {
      key: "ext",
      value: function () {
        return this.numberingPlan.ext();
      }
    }, {
      key: "countryCallingCodes",
      value: function () {
        return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
      }
    }, {
      key: "chooseCountryByCountryCallingCode",
      value: function (e) {
        return this.selectNumberingPlan(e);
      }
    }, {
      key: "hasSelectedNumberingPlan",
      value: function () {
        return void 0 !== this.numberingPlan;
      }
    }]), e;
  }(),
  oy = function () {
    function e(t, n) {
      $E(this, e), this.globalMetadataObject = n, this.metadata = t, py.call(this, n.metadata);
    }
    return ty(e, [{
      key: "callingCode",
      value: function () {
        return this.metadata[0];
      }
    }, {
      key: "getDefaultCountryMetadataForRegion",
      value: function () {
        return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
      }
    }, {
      key: "IDDPrefix",
      value: function () {
        if (!this.v1 && !this.v2) return this.metadata[1];
      }
    }, {
      key: "defaultIDDPrefix",
      value: function () {
        if (!this.v1 && !this.v2) return this.metadata[12];
      }
    }, {
      key: "nationalNumberPattern",
      value: function () {
        return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
      }
    }, {
      key: "possibleLengths",
      value: function () {
        if (!this.v1) return this.metadata[this.v2 ? 2 : 3];
      }
    }, {
      key: "_getFormats",
      value: function (e) {
        return e[this.v1 ? 2 : this.v2 ? 3 : 4];
      }
    }, {
      key: "formats",
      value: function () {
        var e = this,
          t = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
        return t.map(function (t) {
          return new iy(t, e);
        });
      }
    }, {
      key: "nationalPrefix",
      value: function () {
        return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
      }
    }, {
      key: "_getNationalPrefixFormattingRule",
      value: function (e) {
        return e[this.v1 ? 4 : this.v2 ? 5 : 6];
      }
    }, {
      key: "nationalPrefixFormattingRule",
      value: function () {
        return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
      }
    }, {
      key: "_nationalPrefixForParsing",
      value: function () {
        return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
      }
    }, {
      key: "nationalPrefixForParsing",
      value: function () {
        return this._nationalPrefixForParsing() || this.nationalPrefix();
      }
    }, {
      key: "nationalPrefixTransformRule",
      value: function () {
        return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
      }
    }, {
      key: "_getNationalPrefixIsOptionalWhenFormatting",
      value: function () {
        return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
      }
    }, {
      key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
      value: function () {
        return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
      }
    }, {
      key: "leadingDigits",
      value: function () {
        return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
      }
    }, {
      key: "types",
      value: function () {
        return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
      }
    }, {
      key: "hasTypes",
      value: function () {
        return (!this.types() || 0 !== this.types().length) && !!this.types();
      }
    }, {
      key: "type",
      value: function (e) {
        if (this.hasTypes() && sy(this.types(), e)) return new cy(sy(this.types(), e), this);
      }
    }, {
      key: "ext",
      value: function () {
        return this.v1 || this.v2 ? " ext. " : this.metadata[13] || " ext. ";
      }
    }]), e;
  }(),
  iy = function () {
    function e(t, n) {
      $E(this, e), this._format = t, this.metadata = n;
    }
    return ty(e, [{
      key: "pattern",
      value: function () {
        return this._format[0];
      }
    }, {
      key: "format",
      value: function () {
        return this._format[1];
      }
    }, {
      key: "leadingDigitsPatterns",
      value: function () {
        return this._format[2] || [];
      }
    }, {
      key: "nationalPrefixFormattingRule",
      value: function () {
        return this._format[3] || this.metadata.nationalPrefixFormattingRule();
      }
    }, {
      key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
      value: function () {
        return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
      }
    }, {
      key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
      value: function () {
        return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
      }
    }, {
      key: "usesNationalPrefix",
      value: function () {
        return !(!this.nationalPrefixFormattingRule() || ay.test(this.nationalPrefixFormattingRule()));
      }
    }, {
      key: "internationalFormat",
      value: function () {
        return this._format[5] || this.format();
      }
    }]), e;
  }(),
  ay = /^\(?\$1\)?$/,
  cy = function () {
    function e(t, n) {
      $E(this, e), this.type = t, this.metadata = n;
    }
    return ty(e, [{
      key: "pattern",
      value: function () {
        return this.metadata.v1 ? this.type : this.type[0];
      }
    }, {
      key: "possibleLengths",
      value: function () {
        if (!this.metadata.v1) return this.type[1] || this.metadata.possibleLengths();
      }
    }]), e;
  }();
function sy(e, t) {
  switch (t) {
    case "FIXED_LINE":
      return e[0];
    case "MOBILE":
      return e[1];
    case "TOLL_FREE":
      return e[2];
    case "PREMIUM_RATE":
      return e[3];
    case "PERSONAL_NUMBER":
      return e[4];
    case "VOICEMAIL":
      return e[5];
    case "UAN":
      return e[6];
    case "PAGER":
      return e[7];
    case "VOIP":
      return e[8];
    case "SHARED_COST":
      return e[9];
  }
}
var ly = function (e) {
    return "object" === _E(e);
  },
  uy = function (e) {
    return _E(e);
  };
function dy(e, t) {
  if ((t = new ry(t)).hasCountry(e)) return t.country(e).countryCallingCode();
  throw new Error("Unknown country: ".concat(e));
}
function fy(e, t) {
  return void 0 !== t.countries[e];
}
function py(e) {
  var t = e.version;
  "number" == typeof t ? (this.v1 = 1 === t, this.v2 = 2 === t, this.v3 = 3 === t, this.v4 = 4 === t) : t ? -1 === qE(t, "1.2.0") ? this.v2 = !0 : -1 === qE(t, "1.7.35") ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
var my = function (e) {
  return "([".concat("0-9０-９٠-٩۰-۹", "]{1,").concat(e, "})");
};
function hy(e) {
  var t = "#?";
  return ";ext=" + my("20") + "|" + ("[  \\t,]*(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)[:\\.．]?[  \\t,-]*" + my("20") + t) + "|" + ("[  \\t,]*(?:[xｘ#＃~～]|int|ｉｎｔ)[:\\.．]?[  \\t,-]*" + my("9") + t) + "|" + ("[- ]+" + my("6") + "#") + "|" + ("[  \\t]*(?:,{2}|;)[:\\.．]?[  \\t,-]*" + my("15") + t) + "|" + ("[  \\t]*(?:,)+[:\\.．]?[  \\t,-]*" + my("9") + t);
}
var Ay = "[+＋]{0,1}(?:[" + YE + "]*[0-9０-９٠-٩۰-۹]){3,}[" + YE + "0-9０-９٠-٩۰-۹]*",
  gy = new RegExp("^[+＋]{0,1}(?:[" + YE + "]*[0-9０-９٠-٩۰-۹]){1,2}$", "i"),
  vy = Ay + "(?:" + hy() + ")?",
  Cy = new RegExp("^[0-9０-９٠-٩۰-۹]{2}$|^" + vy + "$", "i");
function by(e) {
  return e.length >= 2 && Cy.test(e);
}
var Ey = new RegExp("(?:" + hy() + ")$", "i");
var yy = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  "１": "1",
  "２": "2",
  "３": "3",
  "４": "4",
  "５": "5",
  "６": "6",
  "７": "7",
  "８": "8",
  "９": "9",
  "٠": "0",
  "١": "1",
  "٢": "2",
  "٣": "3",
  "٤": "4",
  "٥": "5",
  "٦": "6",
  "٧": "7",
  "٨": "8",
  "٩": "9",
  "۰": "0",
  "۱": "1",
  "۲": "2",
  "۳": "3",
  "۴": "4",
  "۵": "5",
  "۶": "6",
  "۷": "7",
  "۸": "8",
  "۹": "9"
};
function Iy(e) {
  return yy[e];
}
function By(e) {
  var t = "",
    n = e.split(""),
    r = Array.isArray(n),
    o = 0;
  for (n = r ? n : n[Symbol.iterator]();;) {
    var i;
    if (r) {
      if (o >= n.length) break;
      i = n[o++];
    } else {
      if ((o = n.next()).done) break;
      i = o.value;
    }
    var a = Iy(i);
    a && (t += a);
  }
  return t;
}
function xy(e) {
  var t = "",
    n = e.split(""),
    r = Array.isArray(n),
    o = 0;
  for (n = r ? n : n[Symbol.iterator]();;) {
    var i;
    if (r) {
      if (o >= n.length) break;
      i = n[o++];
    } else {
      if ((o = n.next()).done) break;
      i = o.value;
    }
    t += wy(i, t) || "";
  }
  return t;
}
function wy(e, t) {
  if ("+" === e) {
    if (t) return;
    return "+";
  }
  return Iy(e);
}
function Qy(e, t) {
  return Hy(e, void 0, t);
}
function Hy(e, t, n) {
  var r = n.type(t),
    o = r && r.possibleLengths() || n.possibleLengths();
  if (!o) return "IS_POSSIBLE";
  if ("FIXED_LINE_OR_MOBILE" === t) {
    if (!n.type("FIXED_LINE")) return Hy(e, "MOBILE", n);
    var i = n.type("MOBILE");
    i && (o = function (e, t) {
      var n = e.slice(),
        r = t,
        o = Array.isArray(r),
        i = 0;
      for (r = o ? r : r[Symbol.iterator]();;) {
        var a;
        if (o) {
          if (i >= r.length) break;
          a = r[i++];
        } else {
          if ((i = r.next()).done) break;
          a = i.value;
        }
        var c = a;
        e.indexOf(c) < 0 && n.push(c);
      }
      return n.sort(function (e, t) {
        return e - t;
      });
    }(o, i.possibleLengths()));
  } else if (t && !r) return "INVALID_LENGTH";
  var a = e.length,
    c = o[0];
  return c === a ? "IS_POSSIBLE" : c > a ? "TOO_SHORT" : o[o.length - 1] < a ? "TOO_LONG" : o.indexOf(a, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function zy(e, t) {
  return "IS_POSSIBLE" === Qy(e, t);
}
function My(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = [],
      r = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function ky(e, t) {
  return e = e || "", new RegExp("^(?:" + t + ")$").test(e);
}
var Ny = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function Sy(e, t, n) {
  if (t = t || {}, e.country) {
    (n = new ry(n)).selectNumberingPlan(e.country, e.countryCallingCode);
    var r = t.v2 ? e.nationalNumber : e.phone;
    if (ky(r, n.nationalNumberPattern())) {
      if (Vy(r, "FIXED_LINE", n)) return n.type("MOBILE") && "" === n.type("MOBILE").pattern() ? "FIXED_LINE_OR_MOBILE" : n.type("MOBILE") ? Vy(r, "MOBILE", n) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE" : "FIXED_LINE_OR_MOBILE";
      for (var o = 0, i = Ny; o < i.length; o++) {
        var a = i[o];
        if (Vy(r, a, n)) return a;
      }
    }
  }
}
function Vy(e, t, n) {
  return !(!(t = n.type(t)) || !t.pattern()) && !(t.possibleLengths() && t.possibleLengths().indexOf(e.length) < 0) && ky(e, t.pattern());
}
function Ly(e) {
  return e.replace(new RegExp("[".concat(YE, "]+"), "g"), " ").trim();
}
var Py = /(\$\d)/;
function Oy(e, t, n) {
  var r = n.useInternationalFormat,
    o = n.withNationalPrefix;
  n.carrierCode, n.metadata;
  var i = e.replace(new RegExp(t.pattern()), r ? t.internationalFormat() : o && t.nationalPrefixFormattingRule() ? t.format().replace(Py, t.nationalPrefixFormattingRule()) : t.format());
  return r ? Ly(i) : i;
}
var Ty = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function Dy(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var Ry = {
  formatExtension: function (e, t, n) {
    return "".concat(e).concat(n.ext()).concat(t);
  }
};
function Gy(e, t, n, r) {
  if (n = n ? function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        Dy(e, t, n[t]);
      });
    }
    return e;
  }({}, Ry, n) : Ry, r = new ry(r), e.country && "001" !== e.country) {
    if (!r.hasCountry(e.country)) throw new Error("Unknown country: ".concat(e.country));
    r.country(e.country);
  } else {
    if (!e.countryCallingCode) return e.phone || "";
    r.selectNumberingPlan(e.countryCallingCode);
  }
  var o,
    i = r.countryCallingCode(),
    a = n.v2 ? e.nationalNumber : e.phone;
  switch (t) {
    case "NATIONAL":
      return a ? jy(o = Fy(a, e.carrierCode, "NATIONAL", r, n), e.ext, r, n.formatExtension) : "";
    case "INTERNATIONAL":
      return a ? (o = Fy(a, null, "INTERNATIONAL", r, n), jy(o = "+".concat(i, " ").concat(o), e.ext, r, n.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(a);
    case "RFC3966":
      return function (e) {
        var t = e.number,
          n = e.ext;
        if (!t) return "";
        if ("+" !== t[0]) throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
        return "tel:".concat(t).concat(n ? ";ext=" + n : "");
      }({
        number: "+".concat(i).concat(a),
        ext: e.ext
      });
    case "IDD":
      if (!n.fromCountry) return;
      var c = function (e, t, n, r, o) {
        if (dy(r, o.metadata) === n) {
          var i = Fy(e, t, "NATIONAL", o);
          return "1" === n ? n + " " + i : i;
        }
        var a = function (e, t, n) {
          var r = new ry(n);
          return r.selectNumberingPlan(e, t), r.defaultIDDPrefix() ? r.defaultIDDPrefix() : Ty.test(r.IDDPrefix()) ? r.IDDPrefix() : void 0;
        }(r, void 0, o.metadata);
        if (a) return "".concat(a, " ").concat(n, " ").concat(Fy(e, null, "INTERNATIONAL", o));
      }(a, e.carrierCode, i, n.fromCountry, r);
      return jy(c, e.ext, r, n.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(t, '"'));
  }
}
function Fy(e, t, n, r, o) {
  var i = function (e, t) {
    var n = e,
      r = Array.isArray(n),
      o = 0;
    for (n = r ? n : n[Symbol.iterator]();;) {
      var i;
      if (r) {
        if (o >= n.length) break;
        i = n[o++];
      } else {
        if ((o = n.next()).done) break;
        i = o.value;
      }
      var a = i;
      if (a.leadingDigitsPatterns().length > 0) {
        var c = a.leadingDigitsPatterns()[a.leadingDigitsPatterns().length - 1];
        if (0 !== t.search(c)) continue;
      }
      if (ky(t, a.pattern())) return a;
    }
  }(r.formats(), e);
  return i ? Oy(e, i, {
    useInternationalFormat: "INTERNATIONAL" === n,
    withNationalPrefix: !i.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !o || !1 !== o.nationalPrefix,
    carrierCode: t,
    metadata: r
  }) : e;
}
function jy(e, t, n, r) {
  return t ? r(e, t, n) : e;
}
function Jy(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Zy(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
var Wy = function () {
    function e(t, n, r) {
      if (function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), !t) throw new TypeError("`country` or `countryCallingCode` not passed");
      if (!n) throw new TypeError("`nationalNumber` not passed");
      if (!r) throw new TypeError("`metadata` not passed");
      var o = new ry(r);
      Xy(t) && (this.country = t, o.country(t), t = o.countryCallingCode()), this.countryCallingCode = t, this.nationalNumber = n, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.metadata = r;
    }
    var t, n, r;
    return t = e, n = [{
      key: "setExt",
      value: function (e) {
        this.ext = e;
      }
    }, {
      key: "isPossible",
      value: function () {
        return function (e, t, n) {
          if (void 0 === t && (t = {}), n = new ry(n), t.v2) {
            if (!e.countryCallingCode) throw new Error("Invalid phone number object passed");
            n.selectNumberingPlan(e.countryCallingCode);
          } else {
            if (!e.phone) return !1;
            if (e.country) {
              if (!n.hasCountry(e.country)) throw new Error("Unknown country: ".concat(e.country));
              n.country(e.country);
            } else {
              if (!e.countryCallingCode) throw new Error("Invalid phone number object passed");
              n.selectNumberingPlan(e.countryCallingCode);
            }
          }
          if (n.possibleLengths()) return zy(e.phone || e.nationalNumber, n);
          if (e.countryCallingCode && n.isNonGeographicCallingCode(e.countryCallingCode)) return !0;
          throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
        }(this, {
          v2: !0
        }, this.metadata);
      }
    }, {
      key: "isValid",
      value: function () {
        return function (e, t, n) {
          return t = t || {}, n = new ry(n), !!e.country && (n.selectNumberingPlan(e.country, e.countryCallingCode), n.hasTypes() ? void 0 !== Sy(e, t, n.metadata) : ky(t.v2 ? e.nationalNumber : e.phone, n.nationalNumberPattern()));
        }(this, {
          v2: !0
        }, this.metadata);
      }
    }, {
      key: "isNonGeographic",
      value: function () {
        return new ry(this.metadata).isNonGeographicCallingCode(this.countryCallingCode);
      }
    }, {
      key: "isEqual",
      value: function (e) {
        return this.number === e.number && this.ext === e.ext;
      }
    }, {
      key: "getType",
      value: function () {
        return Sy(this, {
          v2: !0
        }, this.metadata);
      }
    }, {
      key: "format",
      value: function (e, t) {
        return Gy(this, e, t ? function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
              r = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
              return Object.getOwnPropertyDescriptor(n, e).enumerable;
            }))), r.forEach(function (t) {
              Jy(e, t, n[t]);
            });
          }
          return e;
        }({}, t, {
          v2: !0
        }) : {
          v2: !0
        }, this.metadata);
      }
    }, {
      key: "formatNational",
      value: function (e) {
        return this.format("NATIONAL", e);
      }
    }, {
      key: "formatInternational",
      value: function (e) {
        return this.format("INTERNATIONAL", e);
      }
    }, {
      key: "getURI",
      value: function (e) {
        return this.format("RFC3966", e);
      }
    }], n && Zy(t.prototype, n), r && Zy(t, r), e;
  }(),
  Xy = function (e) {
    return /^[A-Z]{2}$/.test(e);
  },
  Uy = new RegExp("([0-9０-９٠-٩۰-۹])");
function Ky(e, t, n, r) {
  if (t) {
    var o = new ry(r);
    o.selectNumberingPlan(t, n);
    var i = new RegExp(o.IDDPrefix());
    if (0 === e.search(i)) {
      var a = (e = e.slice(e.match(i)[0].length)).match(Uy);
      if (!(a && null != a[1] && a[1].length > 0 && "0" === a[1])) return e;
    }
  }
}
function Yy(e, t) {
  if (e && t.numberingPlan.nationalPrefixForParsing()) {
    var n = new RegExp("^(?:" + t.numberingPlan.nationalPrefixForParsing() + ")"),
      r = n.exec(e);
    if (r) {
      var o,
        i,
        a,
        c = r.length - 1,
        s = c > 0 && r[c];
      if (t.nationalPrefixTransformRule() && s) o = e.replace(n, t.nationalPrefixTransformRule()), c > 1 && (i = r[1]);else {
        var l = r[0];
        o = e.slice(l.length), s && (i = r[1]);
      }
      if (s) {
        var u = e.indexOf(r[1]);
        e.slice(0, u) === t.numberingPlan.nationalPrefix() && (a = t.numberingPlan.nationalPrefix());
      } else a = r[0];
      return {
        nationalNumber: o,
        nationalPrefix: a,
        carrierCode: i
      };
    }
  }
  return {
    nationalNumber: e
  };
}
function qy(e, t) {
  var n = Yy(e, t),
    r = n.nationalNumber,
    o = n.carrierCode;
  if (!function (e, t, n) {
    if (ky(e, n.nationalNumberPattern()) && !ky(t, n.nationalNumberPattern())) return !1;
    return !0;
  }(e, r, t)) return {
    nationalNumber: e
  };
  if (e.length !== r.length + (o ? o.length : 0) && t.possibleLengths()) switch (Qy(r, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return {
        nationalNumber: e
      };
  }
  return {
    nationalNumber: r,
    carrierCode: o
  };
}
function _y(e, t, n, r) {
  var o = t ? dy(t, r) : n;
  if (0 === e.indexOf(o)) {
    (r = new ry(r)).selectNumberingPlan(t, n);
    var i = e.slice(o.length),
      a = qy(i, r).nationalNumber,
      c = qy(e, r).nationalNumber;
    if (!ky(c, r.nationalNumberPattern()) && ky(a, r.nationalNumberPattern()) || "TOO_LONG" === Qy(c, r)) return {
      countryCallingCode: o,
      number: i
    };
  }
  return {
    number: e
  };
}
function $y(e, t, n, r) {
  if (!e) return {};
  if ("+" !== e[0]) {
    var o = Ky(e, t, n, r);
    if (!o || o === e) {
      if (t || n) {
        var i = _y(e, t, n, r),
          a = i.countryCallingCode,
          c = i.number;
        if (a) return {
          countryCallingCode: a,
          number: c
        };
      }
      return {
        number: e
      };
    }
    e = "+" + o;
  }
  if ("0" === e[1]) return {};
  r = new ry(r);
  for (var s = 2; s - 1 <= 3 && s <= e.length;) {
    var l = e.slice(1, s);
    if (r.hasCallingCode(l)) return r.selectNumberingPlan(l), {
      countryCallingCode: l,
      number: e.slice(s)
    };
    s++;
  }
  return {};
}
function eI(e, t, n) {
  var r = n.getCountryCodesForCallingCode(e);
  if (r) return 1 === r.length ? r[0] : function (e, t, n) {
    n = new ry(n);
    var r = e,
      o = Array.isArray(r),
      i = 0;
    for (r = o ? r : r[Symbol.iterator]();;) {
      var a;
      if (o) {
        if (i >= r.length) break;
        a = r[i++];
      } else {
        if ((i = r.next()).done) break;
        a = i.value;
      }
      var c = a;
      if (n.country(c), n.leadingDigits()) {
        if (t && 0 === t.search(n.leadingDigits())) return c;
      } else if (Sy({
        phone: t,
        country: c
      }, void 0, n.metadata)) return c;
    }
  }(r, t, n.metadata);
}
var tI = new RegExp("[+＋0-9０-９٠-٩۰-۹]"),
  nI = new RegExp("[^0-9０-９٠-٩۰-۹#]+$");
function rI(e, t, n) {
  if (t = t || {}, n = new ry(n), t.defaultCountry && !n.hasCountry(t.defaultCountry)) {
    if (t.v2) throw new KE("INVALID_COUNTRY");
    throw new Error("Unknown country: ".concat(t.defaultCountry));
  }
  var r = function (e, t, n) {
      if (e && 0 === e.indexOf("tel:")) return function (e) {
        var t,
          n,
          r = (e = e.replace(/^tel:/, "tel=")).split(";"),
          o = Array.isArray(r),
          i = 0;
        for (r = o ? r : r[Symbol.iterator]();;) {
          var a;
          if (o) {
            if (i >= r.length) break;
            a = r[i++];
          } else {
            if ((i = r.next()).done) break;
            a = i.value;
          }
          var c = My(a.split("="), 2),
            s = c[0],
            l = c[1];
          switch (s) {
            case "tel":
              t = l;
              break;
            case "ext":
              n = l;
              break;
            case "phone-context":
              "+" === l[0] && (t = l + t);
          }
        }
        if (!by(t)) return {};
        var u = {
          number: t
        };
        return n && (u.ext = n), u;
      }(e);
      var r = function (e, t, n) {
        if (!e) return;
        if (e.length > 250) {
          if (n) throw new KE("TOO_LONG");
          return;
        }
        if (!1 === t) return e;
        var r = e.search(tI);
        if (r < 0) return;
        return e.slice(r).replace(nI, "");
      }(e, n, t);
      if (!r) return {};
      if (!by(r)) return function (e) {
        return gy.test(e);
      }(r) ? {
        error: "TOO_SHORT"
      } : {};
      var o = function (e) {
        var t = e.search(Ey);
        if (t < 0) return {};
        for (var n = e.slice(0, t), r = e.match(Ey), o = 1; o < r.length;) {
          if (r[o]) return {
            number: n,
            ext: r[o]
          };
          o++;
        }
      }(r);
      if (o.ext) return o;
      return {
        number: r
      };
    }(e, t.v2, t.extract),
    o = r.number,
    i = r.ext,
    a = r.error;
  if (!o) {
    if (t.v2) {
      if ("TOO_SHORT" === a) throw new KE("TOO_SHORT");
      throw new KE("NOT_A_NUMBER");
    }
    return {};
  }
  var c = function (e, t, n, r) {
      var o,
        i = $y(xy(e), t, n, r.metadata),
        a = i.countryCallingCode,
        c = i.number;
      if (a) r.selectNumberingPlan(a);else {
        if (!c || !t && !n) return {};
        r.selectNumberingPlan(t, n), t && (o = t), a = n || dy(t, r.metadata);
      }
      if (!c) return {
        countryCallingCode: a
      };
      var s = qy(xy(c), r),
        l = s.nationalNumber,
        u = s.carrierCode,
        d = eI(a, l, r);
      d && (o = d, "001" === d || r.country(o));
      return {
        country: o,
        countryCallingCode: a,
        nationalNumber: l,
        carrierCode: u
      };
    }(o, t.defaultCountry, t.defaultCallingCode, n),
    s = c.country,
    l = c.nationalNumber,
    u = c.countryCallingCode,
    d = c.carrierCode;
  if (!n.hasSelectedNumberingPlan()) {
    if (t.v2) throw new KE("INVALID_COUNTRY");
    return {};
  }
  if (!l || l.length < 2) {
    if (t.v2) throw new KE("TOO_SHORT");
    return {};
  }
  if (l.length > 17) {
    if (t.v2) throw new KE("TOO_LONG");
    return {};
  }
  if (t.v2) {
    var f = new Wy(u, l, n.metadata);
    return s && (f.country = s), d && (f.carrierCode = d), i && (f.ext = i), f;
  }
  var p = !!(t.extended ? n.hasSelectedNumberingPlan() : s) && ky(l, n.nationalNumberPattern());
  return t.extended ? {
    country: s,
    countryCallingCode: u,
    carrierCode: d,
    valid: p,
    possible: !!p || !(!0 !== t.extended || !n.possibleLengths() || !zy(l, n)),
    phone: l,
    ext: i
  } : p ? function (e, t, n) {
    var r = {
      country: e,
      phone: t
    };
    n && (r.ext = n);
    return r;
  }(s, l, i) : {};
}
function oI(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function iI(e, t, n) {
  return rI(e, function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        oI(e, t, n[t]);
      });
    }
    return e;
  }({}, t, {
    v2: !0
  }), n);
}
function aI(e) {
  return aI = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, aI(e);
}
function cI(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function sI(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = [],
      r = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function lI(e) {
  var t,
    n,
    r,
    o = sI(Array.prototype.slice.call(e), 4),
    i = o[0],
    a = o[1],
    c = o[2],
    s = o[3];
  if ("string" != typeof i) throw new TypeError("A text for parsing must be a string.");
  if (t = i, a && "string" != typeof a) {
    if (!uI(a)) throw new Error("Invalid second argument: ".concat(a));
    c ? (n = a, r = c) : r = a;
  } else s ? (n = c, r = s) : (n = void 0, r = c), a && (n = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        cI(e, t, n[t]);
      });
    }
    return e;
  }({
    defaultCountry: a
  }, n));
  return {
    text: t,
    options: n,
    metadata: r
  };
}
var uI = function (e) {
  return "object" === aI(e);
};
function dI(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function fI(e, t, n) {
  t && t.defaultCountry && !fy(t.defaultCountry, n) && (t = function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {},
        r = Object.keys(n);
      "function" == typeof Object.getOwnPropertySymbols && (r = r.concat(Object.getOwnPropertySymbols(n).filter(function (e) {
        return Object.getOwnPropertyDescriptor(n, e).enumerable;
      }))), r.forEach(function (t) {
        dI(e, t, n[t]);
      });
    }
    return e;
  }({}, t, {
    defaultCountry: void 0
  }));
  try {
    return iI(e, t, n);
  } catch (e) {
    if (!(e instanceof KE)) throw e;
  }
}
function pI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
var mI = function () {
    function e(t) {
      var n,
        r,
        o,
        i = this,
        a = t.onCountryChange,
        c = t.onCallingCodeChange;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), o = function (e) {
        for (var t = 0, n = Object.keys(e); t < n.length; t++) {
          var r = n[t];
          i[r] = e[r];
        }
      }, (r = "update") in (n = this) ? Object.defineProperty(n, r, {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : n[r] = o, this.onCountryChange = a, this.onCallingCodeChange = c;
    }
    var t, n, r;
    return t = e, n = [{
      key: "reset",
      value: function (e, t) {
        this.international = !1, this.IDDPrefix = void 0, this.missingPlus = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(e, t);
      }
    }, {
      key: "resetNationalSignificantNumber",
      value: function () {
        this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberMatchesInput = !0, this.nationalPrefix = void 0, this.carrierCode = void 0, this.complexPrefixBeforeNationalSignificantNumber = void 0;
      }
    }, {
      key: "initCountryAndCallingCode",
      value: function (e, t) {
        this.setCountry(e), this.setCallingCode(t);
      }
    }, {
      key: "setCountry",
      value: function (e) {
        this.country = e, this.onCountryChange(e);
      }
    }, {
      key: "setCallingCode",
      value: function (e) {
        return this.callingCode = e, this.onCallingCodeChange(this.country, e);
      }
    }, {
      key: "startInternationalNumber",
      value: function () {
        this.international = !0, this.initCountryAndCallingCode();
      }
    }, {
      key: "appendDigits",
      value: function (e) {
        this.digits += e;
      }
    }, {
      key: "appendNationalSignificantNumberDigits",
      value: function (e) {
        this.nationalSignificantNumber += e;
      }
    }, {
      key: "getNationalDigits",
      value: function () {
        return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
      }
    }, {
      key: "getDigitsWithoutInternationalPrefix",
      value: function () {
        return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
      }
    }], n && pI(t.prototype, n), r && pI(t, r), e;
  }(),
  hI = new RegExp("x");
function AI(e, t) {
  if (t < 1) return "";
  for (var n = ""; t > 1;) 1 & t && (n += e), t >>= 1, e += e;
  return n + e;
}
function gI(e, t) {
  return ")" === e[t] && t++, function (e) {
    var t = [],
      n = 0;
    for (; n < e.length;) "(" === e[n] ? t.push(n) : ")" === e[n] && t.pop(), n++;
    var r = 0,
      o = "";
    t.push(e.length);
    for (var i = 0, a = t; i < a.length; i++) {
      var c = a[i];
      o += e.slice(r, c), r = c + 1;
    }
    return o;
  }(e.slice(0, t));
}
function vI(e, t, n) {
  var r = n.metadata,
    o = n.shouldTryNationalPrefixFormattingRule,
    i = n.getSeparatorAfterNationalPrefix;
  if (new RegExp("^(?:".concat(t.pattern(), ")$")).test(e.nationalSignificantNumber)) return function (e, t, n) {
    var r = n.metadata,
      o = n.shouldTryNationalPrefixFormattingRule,
      i = n.getSeparatorAfterNationalPrefix;
    if (e.nationalSignificantNumber, e.international, e.nationalPrefix, e.carrierCode, o(t)) {
      var a = CI(e, t, {
        useNationalPrefixFormattingRule: !0,
        getSeparatorAfterNationalPrefix: i,
        metadata: r
      });
      if (a) return a;
    }
    return CI(e, t, {
      useNationalPrefixFormattingRule: !1,
      getSeparatorAfterNationalPrefix: i,
      metadata: r
    });
  }(e, t, {
    metadata: r,
    shouldTryNationalPrefixFormattingRule: o,
    getSeparatorAfterNationalPrefix: i
  });
}
function CI(e, t, n) {
  var r = n.metadata,
    o = n.useNationalPrefixFormattingRule,
    i = n.getSeparatorAfterNationalPrefix,
    a = Oy(e.nationalSignificantNumber, t, {
      carrierCode: e.carrierCode,
      useInternationalFormat: e.international,
      withNationalPrefix: o,
      metadata: r
    });
  if (o || (e.nationalPrefix ? a = e.nationalPrefix + i(t) + a : e.complexPrefixBeforeNationalSignificantNumber && (a = e.complexPrefixBeforeNationalSignificantNumber + " " + a)), function (e, t) {
    return By(e) === t.getNationalDigits();
  }(a, e)) return a;
}
function bI(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function EI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function yI(e, t, n) {
  return t && EI(e.prototype, t), n && EI(e, n), e;
}
var II = function () {
  function e(t) {
    bI(this, e), this.matchTree = new wI().parse(t);
  }
  return yI(e, [{
    key: "match",
    value: function (e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = t.allowOverflow;
      if (!e) throw new Error("String is required");
      var r = BI(e.split(""), this.matchTree, !0);
      if (r && r.match && delete r.matchedChars, !r || !r.overflow || n) return r;
    }
  }]), e;
}();
function BI(e, t, n) {
  if ("string" == typeof t) {
    if (n && e.length > t.length) return {
      overflow: !0
    };
    var r = e.join("");
    return 0 === t.indexOf(r) ? e.length === t.length ? {
      match: !0,
      matchedChars: e
    } : {
      partialMatch: !0
    } : 0 === r.indexOf(t) ? {
      match: !0,
      matchedChars: e.slice(0, t.length)
    } : void 0;
  }
  if (Array.isArray(t)) {
    for (var o = e.slice(), i = 0; i < t.length;) {
      var a = BI(o, t[i], n && i === t.length - 1);
      if (!a || a.overflow) return a;
      if (!a.match) {
        if (a.partialMatch) return {
          partialMatch: !0
        };
        throw new Error("Unsupported match result:\n".concat(JSON.stringify(a, null, 2)));
      }
      if (0 === (o = o.slice(a.matchedChars.length)).length) return i === t.length - 1 ? {
        match: !0,
        matchedChars: e
      } : {
        partialMatch: !0
      };
      i++;
    }
    return n ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: e.slice(0, e.length - o.length)
    };
  }
  switch (t.op) {
    case "|":
      var c,
        s = t.args,
        l = Array.isArray(s),
        u = 0;
      for (s = l ? s : s[Symbol.iterator]();;) {
        var d;
        if (l) {
          if (u >= s.length) break;
          d = s[u++];
        } else {
          if ((u = s.next()).done) break;
          d = u.value;
        }
        var f = BI(e, d, n);
        if (f) {
          if (f.overflow) return f;
          if (f.match) return {
            match: !0,
            matchedChars: f.matchedChars
          };
          f.partialMatch && (c = !0);
        }
      }
      return c ? {
        partialMatch: !0
      } : void 0;
    case "[]":
      var p = t.args,
        m = Array.isArray(p),
        h = 0;
      for (p = m ? p : p[Symbol.iterator]();;) {
        var A;
        if (m) {
          if (h >= p.length) break;
          A = p[h++];
        } else {
          if ((h = p.next()).done) break;
          A = h.value;
        }
        var g = A;
        if (e[0] === g) return 1 === e.length ? {
          match: !0,
          matchedChars: e
        } : n ? {
          overflow: !0
        } : {
          match: !0,
          matchedChars: [g]
        };
      }
      return;
    default:
      throw new Error("Unsupported instruction tree: ".concat(t));
  }
}
var xI = new RegExp("(\\||\\(\\?\\:|\\)|\\[|\\])"),
  wI = function () {
    function e() {
      bI(this, e);
    }
    return yI(e, [{
      key: "parse",
      value: function (e) {
        if (this.context = [{
          or: !0,
          instructions: []
        }], this.parsePattern(e), 1 !== this.context.length) throw new Error("Non-finalized contexts left when pattern parse ended");
        var t = this.context[0],
          n = t.branches,
          r = t.instructions;
        if (n) return [{
          op: "|",
          args: n.concat([r])
        }];
        if (0 === r.length) throw new Error("Pattern is required");
        return r;
      }
    }, {
      key: "startContext",
      value: function (e) {
        this.context.push(e);
      }
    }, {
      key: "endContext",
      value: function () {
        this.context.pop();
      }
    }, {
      key: "getContext",
      value: function () {
        return this.context[this.context.length - 1];
      }
    }, {
      key: "parsePattern",
      value: function (e) {
        if (!e) throw new Error("Empty pattern passed");
        var t = e.match(xI);
        if (t) {
          var n = t[1],
            r = e.slice(0, t.index),
            o = e.slice(t.index + n.length);
          switch (n) {
            case "(?:":
              r && this.parsePattern(r), this.startContext({
                or: !0,
                instructions: [],
                branches: []
              });
              break;
            case ")":
              if (!this.getContext().or) throw new Error('")" operator must be preceded by "(?:" operator');
              if (r && this.parsePattern(r), 0 === this.getContext().instructions.length) throw new Error('No instructions found after "|" operator in an "or" group');
              var i = this.getContext().branches;
              i.push(this.getContext().instructions), this.endContext(), this.getContext().instructions.push({
                op: "|",
                args: i
              });
              break;
            case "|":
              if (!this.getContext().or) throw new Error('"|" operator can only be used inside "or" groups');
              if (r && this.parsePattern(r), !this.getContext().branches) {
                if (1 !== this.context.length) throw new Error('"branches" not found in an "or" group context');
                this.getContext().branches = [];
              }
              this.getContext().branches.push(this.getContext().instructions), this.getContext().instructions = [];
              break;
            case "[":
              r && this.parsePattern(r), this.startContext({
                oneOfSet: !0
              });
              break;
            case "]":
              if (!this.getContext().oneOfSet) throw new Error('"]" operator must be preceded by "[" operator');
              this.endContext(), this.getContext().instructions.push({
                op: "[]",
                args: QI(r)
              });
              break;
            default:
              throw new Error("Unknown operator: ".concat(n));
          }
          o && this.parsePattern(o);
        } else this.getContext().instructions = this.getContext().instructions.concat(e.split(""));
      }
    }]), e;
  }();
function QI(e) {
  for (var t = [], n = 0; n < e.length;) {
    if ("-" === e[n]) {
      if (0 === n || n === e.length - 1) throw new Error("Couldn't parse a one-of set pattern: ".concat(e));
      for (var r = e[n - 1].charCodeAt(0) + 1, o = e[n + 1].charCodeAt(0) - 1, i = r; i <= o;) t.push(String.fromCharCode(i)), i++;
    } else t.push(e[n]);
    n++;
  }
  return t;
}
function HI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function zI(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var MI = AI("9", 15),
  kI = /[- ]/,
  NI = new RegExp("^[" + YE + "]*(\\$\\d[" + YE + "]*)+$"),
  SI = function () {
    function e(t) {
      var n = this;
      t.state;
      var r = t.metadata;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), zI(this, "getSeparatorAfterNationalPrefix", function (e) {
        return n.isNANP || e && e.nationalPrefixFormattingRule() && kI.test(e.nationalPrefixFormattingRule()) ? " " : "";
      }), zI(this, "shouldTryNationalPrefixFormattingRule", function (e, t) {
        var n = t.international,
          r = t.nationalPrefix;
        if (e.nationalPrefixFormattingRule()) {
          var o = e.usesNationalPrefix();
          if (o && r || !o && !n) return !0;
        }
      }), this.metadata = r, this.resetFormat();
    }
    var t, n, r;
    return t = e, n = [{
      key: "resetFormat",
      value: function () {
        this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
      }
    }, {
      key: "reset",
      value: function (e, t) {
        this.resetFormat(), e ? (this.isNANP = "1" === e.callingCode(), this.matchingFormats = e.formats(), t.nationalSignificantNumber && this.narrowDownMatchingFormats(t)) : (this.isNANP = void 0, this.matchingFormats = []);
      }
    }, {
      key: "format",
      value: function (e, t) {
        var n = this;
        if (function (e, t) {
          return "IS_POSSIBLE" === Qy(e, t);
        }(t.nationalSignificantNumber, this.metadata)) {
          var r = this.matchingFormats,
            o = Array.isArray(r),
            i = 0;
          for (r = o ? r : r[Symbol.iterator]();;) {
            var a;
            if (o) {
              if (i >= r.length) break;
              a = r[i++];
            } else {
              if ((i = r.next()).done) break;
              a = i.value;
            }
            var c = a,
              s = vI(t, c, {
                metadata: this.metadata,
                shouldTryNationalPrefixFormattingRule: function (e) {
                  return n.shouldTryNationalPrefixFormattingRule(e, {
                    international: t.international,
                    nationalPrefix: t.nationalPrefix
                  });
                },
                getSeparatorAfterNationalPrefix: this.getSeparatorAfterNationalPrefix
              });
            if (s) return this.resetFormat(), this.chosenFormat = c, this.setNationalNumberTemplate(s.replace(/\d/g, "x"), t), this.populatedNationalNumberTemplate = s, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf("x"), s;
          }
        }
        return this.formatNationalNumberWithNextDigits(e, t);
      }
    }, {
      key: "formatNationalNumberWithNextDigits",
      value: function (e, t) {
        var n = this.chosenFormat,
          r = this.chooseFormat(t);
        if (r) return r === n ? this.formatNextNationalNumberDigits(e) : this.formatNextNationalNumberDigits(t.getNationalDigits());
      }
    }, {
      key: "narrowDownMatchingFormats",
      value: function (e) {
        var t = this,
          n = e.nationalSignificantNumber,
          r = e.nationalPrefix,
          o = e.international,
          i = n,
          a = i.length - 3;
        a < 0 && (a = 0), this.matchingFormats = this.matchingFormats.filter(function (e) {
          return t.formatSuits(e, o, r) && t.formatMatches(e, i, a);
        }), this.chosenFormat && -1 === this.matchingFormats.indexOf(this.chosenFormat) && this.resetFormat();
      }
    }, {
      key: "formatSuits",
      value: function (e, t, n) {
        return !(n && !e.usesNationalPrefix() && !e.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !t && !n && e.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
      }
    }, {
      key: "formatMatches",
      value: function (e, t, n) {
        var r = e.leadingDigitsPatterns().length;
        if (0 === r) return !0;
        n = Math.min(n, r - 1);
        var o = e.leadingDigitsPatterns()[n];
        if (t.length < 3) try {
          return void 0 !== new II(o).match(t, {
            allowOverflow: !0
          });
        } catch (e) {
          return console.error(e), !0;
        }
        return new RegExp("^(".concat(o, ")")).test(t);
      }
    }, {
      key: "getFormatFormat",
      value: function (e, t) {
        return t ? e.internationalFormat() : e.format();
      }
    }, {
      key: "chooseFormat",
      value: function (e) {
        var t = this,
          n = function () {
            if (o) {
              if (i >= r.length) return "break";
              a = r[i++];
            } else {
              if ((i = r.next()).done) return "break";
              a = i.value;
            }
            var n = a;
            return t.chosenFormat === n ? "break" : NI.test(t.getFormatFormat(n, e.international)) ? t.createTemplateForFormat(n, e) ? (t.chosenFormat = n, "break") : (t.matchingFormats = t.matchingFormats.filter(function (e) {
              return e !== n;
            }), "continue") : "continue";
          },
          r = this.matchingFormats.slice(),
          o = Array.isArray(r),
          i = 0;
        e: for (r = o ? r : r[Symbol.iterator]();;) {
          var a;
          switch (n()) {
            case "break":
              break e;
            case "continue":
              continue;
          }
        }
        return this.chosenFormat || this.resetFormat(), this.chosenFormat;
      }
    }, {
      key: "createTemplateForFormat",
      value: function (e, t) {
        if (!(e.pattern().indexOf("|") >= 0)) {
          var n = this.getTemplateForFormat(e, t);
          return n ? (this.setNationalNumberTemplate(n, t), !0) : void 0;
        }
      }
    }, {
      key: "getInternationalPrefixBeforeCountryCallingCode",
      value: function (e, t) {
        var n = e.IDDPrefix,
          r = e.missingPlus;
        return n ? t && !1 === t.spacing ? n : n + " " : r ? "" : "+";
      }
    }, {
      key: "getTemplate",
      value: function (e) {
        if (this.template) {
          for (var t = -1, n = 0, r = e.international ? this.getInternationalPrefixBeforeCountryCallingCode(e, {
              spacing: !1
            }) : ""; n < r.length + e.getDigitsWithoutInternationalPrefix().length;) t = this.template.indexOf("x", t + 1), n++;
          return gI(this.template, t + 1);
        }
      }
    }, {
      key: "setNationalNumberTemplate",
      value: function (e, t) {
        this.nationalNumberTemplate = e, this.populatedNationalNumberTemplate = e, this.populatedNationalNumberTemplatePosition = -1, t.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(t).replace(/[\d\+]/g, "x") + AI("x", t.callingCode.length) + " " + e : this.template = e;
      }
    }, {
      key: "getTemplateForFormat",
      value: function (e, t) {
        var n = t.nationalSignificantNumber,
          r = t.international,
          o = t.nationalPrefix,
          i = t.complexPrefixBeforeNationalSignificantNumber,
          a = e.pattern();
        a = a.replace(/\[([^\[\]])*\]/g, "\\d").replace(/\d(?=[^,}][^,}])/g, "\\d");
        var c = MI.match(a)[0];
        if (!(n.length > c.length)) {
          var s = new RegExp("^" + a + "$"),
            l = n.replace(/\d/g, "9");
          s.test(l) && (c = l);
          var u,
            d = this.getFormatFormat(e, r);
          if (this.shouldTryNationalPrefixFormattingRule(e, {
            international: r,
            nationalPrefix: o
          })) {
            var f = d.replace(Py, e.nationalPrefixFormattingRule());
            if (By(e.nationalPrefixFormattingRule()) === (o || "") + By("$1") && (d = f, u = !0, o)) for (var p = o.length; p > 0;) d = d.replace(/\d/, "x"), p--;
          }
          var m = c.replace(new RegExp(a), d).replace(new RegExp("9", "g"), "x");
          return u || (i ? m = AI("x", i.length) + " " + m : o && (m = AI("x", o.length) + this.getSeparatorAfterNationalPrefix(e) + m)), r && (m = Ly(m)), m;
        }
      }
    }, {
      key: "formatNextNationalNumberDigits",
      value: function (e) {
        var t = function (e, t, n) {
          var r = n.split(""),
            o = Array.isArray(r),
            i = 0;
          for (r = o ? r : r[Symbol.iterator]();;) {
            var a;
            if (o) {
              if (i >= r.length) break;
              a = r[i++];
            } else {
              if ((i = r.next()).done) break;
              a = i.value;
            }
            var c = a;
            if (e.slice(t + 1).search(hI) < 0) return;
            t = e.search(hI), e = e.replace(hI, c);
          }
          return [e, t];
        }(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, e);
        if (t) return this.populatedNationalNumberTemplate = t[0], this.populatedNationalNumberTemplatePosition = t[1], gI(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
        this.resetFormat();
      }
    }], n && HI(t.prototype, n), r && HI(t, r), e;
  }();
function VI(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = [],
      r = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function LI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
var PI = new RegExp("^" + ("[" + YE + "0-9０-９٠-٩۰-۹]+") + "$", "i"),
  OI = "(?:[+＋][" + YE + "0-9０-９٠-٩۰-۹]*|[" + YE + "0-9０-９٠-٩۰-۹]+)",
  TI = new RegExp("[^" + YE + "0-9０-９٠-٩۰-۹]+.*$"),
  DI = /[^\d\[\]]/,
  RI = function () {
    function e(t) {
      var n = t.defaultCountry,
        r = t.defaultCallingCode,
        o = t.metadata,
        i = t.onNationalSignificantNumberChange;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, e), this.defaultCountry = n, this.defaultCallingCode = r, this.metadata = o, this.onNationalSignificantNumberChange = i;
    }
    var t, n, r;
    return t = e, n = [{
      key: "input",
      value: function (e, t) {
        var n,
          r = function (e) {
            var t = VI(function (e) {
                var t = function (e) {
                  var t,
                    n = e.search(OI);
                  if (!(n < 0)) return "+" === (e = e.slice(n))[0] && (t = !0, e = e.slice("+".length)), e = e.replace(TI, ""), t && (e = "+" + e), e;
                }(e) || "";
                return "+" === t[0] ? [t.slice("+".length), !0] : [t];
              }(e), 2),
              n = t[0],
              r = t[1];
            return PI.test(n) || (n = ""), [n, r];
          }(e),
          o = VI(r, 2),
          i = o[0],
          a = o[1],
          c = By(i);
        return a && (t.digits || (t.startInternationalNumber(), c || (n = !0))), c && this.inputDigits(c, t), {
          digits: c,
          justLeadingPlus: n
        };
      }
    }, {
      key: "inputDigits",
      value: function (e, t) {
        var n = t.digits,
          r = n.length < 3 && n.length + e.length >= 3;
        if (t.appendDigits(e), r && this.extractIddPrefix(t), this.isWaitingForCountryCallingCode(t)) {
          if (!this.extractCountryCallingCode(t)) return;
        } else t.appendNationalSignificantNumberDigits(e);
        t.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(t.getNationalDigits(), t.update);
      }
    }, {
      key: "isWaitingForCountryCallingCode",
      value: function (e) {
        var t = e.international,
          n = e.callingCode;
        return t && !n;
      }
    }, {
      key: "extractCountryCallingCode",
      value: function (e) {
        var t = $y("+" + e.getDigitsWithoutInternationalPrefix(), this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
          n = t.countryCallingCode,
          r = t.number;
        if (n) return e.setCallingCode(n), e.update({
          nationalSignificantNumber: r
        }), !0;
      }
    }, {
      key: "reset",
      value: function (e) {
        if (e) {
          this.hasSelectedNumberingPlan = !0;
          var t = e._nationalPrefixForParsing();
          this.couldPossiblyExtractAnotherNationalSignificantNumber = t && DI.test(t);
        } else this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
      }
    }, {
      key: "extractNationalSignificantNumber",
      value: function (e, t) {
        if (this.hasSelectedNumberingPlan) {
          var n = Yy(e, this.metadata),
            r = n.nationalPrefix,
            o = n.nationalNumber,
            i = n.carrierCode;
          if (o !== e) return this.onExtractedNationalNumber(r, i, o, e, t), !0;
        }
      }
    }, {
      key: "extractAnotherNationalSignificantNumber",
      value: function (e, t, n) {
        if (!this.hasExtractedNationalSignificantNumber) return this.extractNationalSignificantNumber(e, n);
        if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
          var r = Yy(e, this.metadata),
            o = r.nationalPrefix,
            i = r.nationalNumber,
            a = r.carrierCode;
          if (i !== t) return this.onExtractedNationalNumber(o, a, i, e, n), !0;
        }
      }
    }, {
      key: "onExtractedNationalNumber",
      value: function (e, t, n, r, o) {
        var i,
          a,
          c = r.lastIndexOf(n);
        if (c >= 0 && c === r.length - n.length) {
          a = !0;
          var s = r.slice(0, c);
          s !== e && (i = s);
        }
        o({
          nationalPrefix: e,
          carrierCode: t,
          nationalSignificantNumber: n,
          nationalSignificantNumberMatchesInput: a,
          complexPrefixBeforeNationalSignificantNumber: i
        }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
      }
    }, {
      key: "reExtractNationalSignificantNumber",
      value: function (e) {
        return !!this.extractAnotherNationalSignificantNumber(e.getNationalDigits(), e.nationalSignificantNumber, e.update) || (this.extractIddPrefix(e) || this.fixMissingPlus(e) ? (this.extractCallingCodeAndNationalSignificantNumber(e), !0) : void 0);
      }
    }, {
      key: "extractIddPrefix",
      value: function (e) {
        var t = e.international,
          n = e.IDDPrefix,
          r = e.digits;
        if (e.nationalSignificantNumber, !t && !n) {
          var o = Ky(r, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
          return void 0 !== o && o !== r ? (e.update({
            IDDPrefix: r.slice(0, r.length - o.length)
          }), this.startInternationalNumber(e), !0) : void 0;
        }
      }
    }, {
      key: "fixMissingPlus",
      value: function (e) {
        if (!e.international) {
          var t = _y(e.digits, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata),
            n = t.countryCallingCode;
          if (t.number, n) return e.update({
            missingPlus: !0
          }), this.startInternationalNumber(e), !0;
        }
      }
    }, {
      key: "startInternationalNumber",
      value: function (e) {
        e.startInternationalNumber(), e.nationalSignificantNumber && (e.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
      }
    }, {
      key: "extractCallingCodeAndNationalSignificantNumber",
      value: function (e) {
        this.extractCountryCallingCode(e) && this.extractNationalSignificantNumber(e.getNationalDigits(), e.update);
      }
    }], n && LI(t.prototype, n), r && LI(t, r), e;
  }();
function GI(e) {
  return GI = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, GI(e);
}
function FI(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = [],
      r = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function jI(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
var JI = function () {
  function e(t, n) {
    !function (e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }(this, e), this.metadata = new ry(n);
    var r = FI(this.getCountryAndCallingCode(t), 2),
      o = r[0],
      i = r[1];
    this.defaultCountry = o, this.defaultCallingCode = i, this.reset();
  }
  var t, n, r;
  return t = e, n = [{
    key: "getCountryAndCallingCode",
    value: function (e) {
      var t, n;
      return e && ("object" === GI(e) ? (t = e.defaultCountry, n = e.defaultCallingCode) : t = e), t && !this.metadata.hasCountry(t) && (t = void 0), [t, n];
    }
  }, {
    key: "input",
    value: function (e) {
      var t = this.parser.input(e, this.state),
        n = t.digits;
      if (t.justLeadingPlus) this.formattedOutput = "+";else if (n) {
        var r;
        if (this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state), this.metadata.hasSelectedNumberingPlan() && (r = this.formatter.format(n, this.state)), void 0 === r && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var o = this.state.getNationalDigits();
          o && (r = this.formatter.format(o, this.state));
        }
        this.formattedOutput = r ? this.getFullNumber(r) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function () {
      var e = this;
      return this.state = new mI({
        onCountryChange: function (t) {
          e.country = t;
        },
        onCallingCodeChange: function (t, n) {
          e.metadata.selectNumberingPlan(t, n), e.formatter.reset(e.metadata.numberingPlan, e.state), e.parser.reset(e.metadata.numberingPlan);
        }
      }), this.formatter = new SI({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new RI({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function () {
          e.determineTheCountryIfNeeded(), e.formatter.reset(e.metadata.numberingPlan, e.state);
        }
      }), this.state.reset(this.defaultCountry, this.defaultCallingCode), this.formattedOutput = "", this;
    }
  }, {
    key: "isInternational",
    value: function () {
      return this.state.international;
    }
  }, {
    key: "getCallingCode",
    value: function () {
      return this.state.callingCode;
    }
  }, {
    key: "getCountryCallingCode",
    value: function () {
      return this.getCallingCode();
    }
  }, {
    key: "getCountry",
    value: function () {
      var e = this.state,
        t = e.digits,
        n = e.country;
      if (t) return n;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function () {
      this.state.country && !this.isCountryCallingCodeAmbiguous() || this.determineTheCountry();
    }
  }, {
    key: "getFullNumber",
    value: function (e) {
      var t = this;
      if (this.isInternational()) {
        var n = function (e) {
            return t.formatter.getInternationalPrefixBeforeCountryCallingCode(t.state, {
              spacing: !!e
            }) + e;
          },
          r = this.state.callingCode;
        return n(r ? e ? "".concat(r, " ").concat(e) : r : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return e;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function () {
      var e = this.state,
        t = e.nationalSignificantNumber,
        n = e.complexPrefixBeforeNationalSignificantNumber,
        r = e.nationalPrefix,
        o = t,
        i = n || r;
      return i && (o = i + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function () {
      var e = this.state.nationalSignificantNumberMatchesInput;
      return this.getFullNumber(e ? this.getNonFormattedNationalNumberWithPrefix() : this.state.getNationalDigits());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function () {
      var e = this.getNonFormattedNumber();
      if (e) return e.replace(/[\+\d]/g, "x");
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function () {
      var e = this.state.callingCode,
        t = this.metadata.getCountryCodesForCallingCode(e);
      return t && t.length > 1;
    }
  }, {
    key: "determineTheCountry",
    value: function () {
      this.state.setCountry(eI(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, this.state.nationalSignificantNumber, this.metadata));
    }
  }, {
    key: "getNumber",
    value: function () {
      var e = this.state,
        t = e.nationalSignificantNumber,
        n = e.carrierCode;
      if (this.isInternational()) {
        if (!this.state.callingCode) return;
      } else if (!this.state.country && !this.defaultCallingCode) return;
      if (t) {
        var r = this.getCountry(),
          o = this.getCountryCallingCode() || this.defaultCallingCode,
          i = new Wy(r || o, t, this.metadata.metadata);
        return n && (i.carrierCode = n), i;
      }
    }
  }, {
    key: "isPossible",
    value: function () {
      var e = this.getNumber();
      return !!e && e.isPossible();
    }
  }, {
    key: "isValid",
    value: function () {
      var e = this.getNumber();
      return !!e && e.isValid();
    }
  }, {
    key: "getNationalNumber",
    value: function () {
      return this.state.nationalSignificantNumber;
    }
  }, {
    key: "getChars",
    value: function () {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
  }, {
    key: "getTemplate",
    value: function () {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }], n && jI(t.prototype, n), r && jI(t, r), e;
}();
function ZI(e) {
  return new ry(e).getCountries();
}
function WI(e) {
  var t = e.country,
    n = e.international,
    r = e.withCountryCallingCode,
    o = e.metadata;
  return t && n && !r ? "+".concat(dy(t, o)) : "";
}
function XI(e, t) {
  return t && " " === (e = e.slice(t.length))[0] && (e = e.slice(1)), e;
}
function UI() {
  return UI = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, UI.apply(this, arguments);
}
function KI(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var YI = function (e) {
  function n(e, n) {
    var r = e.country,
      o = e.international,
      i = e.withCountryCallingCode,
      a = e.metadata,
      c = KI(e, ["country", "international", "withCountryCallingCode", "metadata"]),
      s = l(function (e) {
        var t = new JI(r, a),
          n = WI({
            country: r,
            international: o,
            withCountryCallingCode: i,
            metadata: a
          }),
          c = t.input(n + e),
          s = t.getTemplate();
        return n && (c = XI(c, n), s && (s = XI(s, n))), {
          text: c,
          template: s
        };
      }, [r, a]);
    return /*#__PURE__*/t.createElement(XE, UI({}, c, {
      ref: n,
      parse: wy,
      format: s
    }));
  }
  return (n = /*#__PURE__*/t.forwardRef(n)).propTypes = {
    value: g.string.isRequired,
    onChange: g.func.isRequired,
    country: g.string,
    international: g.bool,
    withCountryCallingCode: g.bool,
    metadata: g.object.isRequired
  }, n.defaultProps = {
    metadata: e
  }, n;
}();
function qI() {
  return qI = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qI.apply(this, arguments);
}
function _I(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
var $I = function (e) {
  function n(e, n) {
    var r = e.value,
      o = e.onChange,
      i = e.country,
      a = e.international,
      c = e.withCountryCallingCode,
      s = e.metadata,
      u = e.inputComponent,
      d = _I(e, ["value", "onChange", "country", "international", "withCountryCallingCode", "metadata", "inputComponent"]),
      f = WI({
        country: i,
        international: a,
        withCountryCallingCode: c,
        metadata: s
      }),
      p = l(function (e) {
        var t = xy(e.target.value);
        t === r && 0 === eB(f, t, i, s).indexOf(e.target.value) && (t = t.slice(0, -1));
        o(t);
      }, [f, r, o, i, s]);
    return /*#__PURE__*/t.createElement(u, qI({}, d, {
      ref: n,
      value: eB(f, r, i, s),
      onChange: p
    }));
  }
  return (n = /*#__PURE__*/t.forwardRef(n)).propTypes = {
    value: g.string.isRequired,
    onChange: g.func.isRequired,
    country: g.string,
    international: g.bool,
    withCountryCallingCode: g.bool,
    metadata: g.object.isRequired,
    inputComponent: g.elementType.isRequired
  }, n.defaultProps = {
    metadata: e,
    inputComponent: "input"
  }, n;
}();
function eB(e, t, n, r) {
  return XI(function (e, t, n) {
    return n || (n = t, t = void 0), new JI(t, n).input(e);
  }(e + t, n, r), e);
}
function tB(e) {
  return String.fromCodePoint(127397 + e.toUpperCase().charCodeAt(0));
}
function nB() {
  return nB = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nB.apply(this, arguments);
}
function rB(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function oB(e) {
  var n = e.value,
    r = e.onChange,
    o = e.options,
    i = rB(e, ["value", "onChange", "options"]),
    a = l(function (e) {
      var t = e.target.value;
      r("ZZ" === t ? void 0 : t);
    }, [r]);
  return s(function () {
    return cB(o, n);
  }, [o, n]), /*#__PURE__*/t.createElement("select", nB({}, i, {
    value: n || "ZZ",
    onChange: a
  }), o.map(function (e) {
    var n = e.value,
      r = e.label,
      o = e.divider;
    return /*#__PURE__*/t.createElement("option", {
      key: o ? "|" : n || "ZZ",
      value: o ? "|" : n || "ZZ",
      disabled: !!o,
      style: o ? iB : void 0
    }, r);
  }));
}
oB.propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  options: g.arrayOf(g.shape({
    value: g.string,
    label: g.string,
    divider: g.bool
  })).isRequired
};
var iB = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function aB(e) {
  var n = e.value,
    r = e.options,
    o = e.className,
    i = e.iconComponent;
  e.getIconAspectRatio;
  var a = e.arrowComponent,
    c = e.unicodeFlags,
    l = rB(e, ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"]),
    u = s(function () {
      return cB(r, n);
    }, [r, n]);
  return /*#__PURE__*/t.createElement("div", {
    className: "PhoneInputCountry"
  }, /*#__PURE__*/t.createElement(oB, nB({}, l, {
    value: n,
    options: r,
    className: tC("PhoneInputCountrySelect", o)
  })), c && n && /*#__PURE__*/t.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, function (e) {
    return tB(e[0]) + tB(e[1]);
  }(n)), !(c && n) && /*#__PURE__*/t.createElement(i, {
    country: n,
    label: u && u.label,
    aspectRatio: c ? 1 : void 0
  }), /*#__PURE__*/t.createElement(a, null));
}
function cB(e, t) {
  var n = e,
    r = Array.isArray(n),
    o = 0;
  for (n = r ? n : n[Symbol.iterator]();;) {
    var i;
    if (r) {
      if (o >= n.length) break;
      i = n[o++];
    } else {
      if ((o = n.next()).done) break;
      i = o.value;
    }
    var a = i;
    if (!a.divider && a.value === t) return a;
  }
}
function sB() {
  return sB = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, sB.apply(this, arguments);
}
function lB(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function uB(e) {
  var n = e.country,
    r = e.countryName,
    o = e.flags,
    i = e.flagUrl,
    a = lB(e, ["country", "countryName", "flags", "flagUrl"]);
  return o && o[n] ? o[n]({
    title: r
  }) : /*#__PURE__*/t.createElement("img", sB({}, a, {
    alt: r,
    role: r ? void 0 : "presentation",
    src: i.replace("{XX}", n).replace("{xx}", n.toLowerCase())
  }));
}
function dB() {
  return dB = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, dB.apply(this, arguments);
}
function fB(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function pB(e) {
  var n = e.aspectRatio,
    r = fB(e, ["aspectRatio"]);
  return 1 === n ? /*#__PURE__*/t.createElement(hB, r) : /*#__PURE__*/t.createElement(mB, r);
}
function mB(e) {
  var n = e.title,
    r = fB(e, ["title"]);
  return /*#__PURE__*/t.createElement("svg", dB({}, r, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /*#__PURE__*/t.createElement("title", null, n), /*#__PURE__*/t.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/t.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /*#__PURE__*/t.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /*#__PURE__*/t.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /*#__PURE__*/t.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /*#__PURE__*/t.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /*#__PURE__*/t.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /*#__PURE__*/t.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
function hB(e) {
  var n = e.title,
    r = fB(e, ["title"]);
  return /*#__PURE__*/t.createElement("svg", dB({}, r, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /*#__PURE__*/t.createElement("title", null, n), /*#__PURE__*/t.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /*#__PURE__*/t.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /*#__PURE__*/t.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /*#__PURE__*/t.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /*#__PURE__*/t.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /*#__PURE__*/t.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /*#__PURE__*/t.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /*#__PURE__*/t.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
function AB(e, t) {
  return !!fy(e, t) || (console.error("Country not found: ".concat(e)), !1);
}
function gB(e, t) {
  return e && (e = e.filter(function (e) {
    return AB(e, t);
  }), 0 === e.length && (e = void 0)), e;
}
function vB(e) {
  var n = e.flags,
    r = e.flagUrl,
    o = e.flagComponent,
    i = e.internationalIcon;
  function a(e) {
    var a = e.country,
      c = e.label,
      s = e.aspectRatio,
      l = i === pB ? s : void 0;
    return /*#__PURE__*/t.createElement("div", {
      className: tC("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": 1 === l,
        "PhoneInputCountryIcon--border": a
      })
    }, a ? /*#__PURE__*/t.createElement(o, {
      country: a,
      countryName: c,
      flags: n,
      flagUrl: r,
      className: "PhoneInputCountryIconImg"
    }) : /*#__PURE__*/t.createElement(i, {
      title: c,
      aspectRatio: l,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return a.propTypes = {
    country: g.string,
    label: g.string.isRequired,
    aspectRatio: g.number
  }, a;
}
aB.propTypes = {
  iconComponent: g.elementType,
  arrowComponent: g.elementType.isRequired,
  unicodeFlags: g.bool
}, aB.defaultProps = {
  arrowComponent: function () {
    return /*#__PURE__*/t.createElement("div", {
      className: "PhoneInputCountrySelectArrow"
    });
  }
}, uB.propTypes = {
  country: g.string.isRequired,
  countryName: g.string.isRequired,
  flags: g.objectOf(g.elementType),
  flagUrl: g.string.isRequired
}, pB.propTypes = {
  title: g.string.isRequired,
  aspectRatio: g.number
}, mB.propTypes = {
  title: g.string.isRequired
}, hB.propTypes = {
  title: g.string.isRequired
}, vB({
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: uB,
  internationalIcon: pB
});
var CB = g.shape({
    country_calling_codes: g.object.isRequired,
    countries: g.object.isRequired
  }),
  bB = g.objectOf(g.string),
  EB = /^\d+$/;
function yB(e, t) {
  var n = "+" + dy(e, t);
  return (t = new ry(t)).selectNumberingPlan(e), t.numberingPlan.leadingDigits() && EB.test(t.numberingPlan.leadingDigits()) && (n += t.numberingPlan.leadingDigits()), n;
}
function IB(e, t) {
  return function () {
    var e = lI(arguments),
      t = e.text,
      n = e.options,
      r = e.metadata;
    return fI(t, n, r);
  }(e || "", t);
}
function BB(e, t) {
  var n = t.prevCountry,
    r = t.newCountry,
    o = t.metadata,
    i = t.useNationalFormat;
  if (!e) return i ? "" : yB(r, o);
  if (r) {
    if ("+" === e[0]) {
      if (i) return 0 === e.indexOf("+" + dy(r, o)) ? function (e, t, n) {
        if (t) {
          var r = "+" + dy(t, n);
          if (e.length < r.length) {
            if (0 === r.indexOf(e)) return "";
          } else if (0 === e.indexOf(r)) return e.slice(r.length);
        }
        for (var o = 0, i = Object.keys(n.country_calling_codes); o < i.length; o++) {
          var a = i[o];
          if (e.indexOf(a) === "+".length) return e.slice("+".length + a.length);
        }
        return "";
      }(e, r, o) : "";
      if (n) {
        var a = yB(r, o);
        return 0 === e.indexOf(a) ? e : a;
      }
      var c = yB(r, o);
      return 0 === e.indexOf(c) ? e : c;
    }
  } else if ("+" !== e[0]) return xB(e, n, o) || "";
  return e;
}
function xB(e, t, n) {
  if (e) {
    if ("+" === e[0]) {
      if ("+" === e) return;
      return e;
    }
    if (t) {
      var r = MB(e, t, n);
      return r ? "+".concat(dy(t, n)).concat(r) : void 0;
    }
  }
}
function wB(e, t, n) {
  var r = MB(e, t, n);
  if (r) {
    var o = r.length - function (e, t) {
      return (t = new ry(t)).selectNumberingPlan(e), t.numberingPlan.possibleLengths()[t.numberingPlan.possibleLengths().length - 1];
    }(t, n);
    if (o > 0) return e.slice(0, e.length - o);
  }
  return e;
}
function QB(e, t) {
  var n = t.country,
    r = t.countries,
    o = t.required,
    i = t.metadata;
  if ("+" === e) return n;
  var a = function (e, t) {
    var n = new JI(null, t);
    return n.input(e), n.getCountry();
  }(e, i);
  return a && (!r || r.indexOf(a) >= 0) ? a : !n || o || kB(e, n, i) ? n : void 0;
}
function HB(e, t, n) {
  if (0 === e.indexOf(yB(t, n))) {
    var r = new JI(t, n);
    r.input(e);
    var o = r.getNumber();
    return o ? o.formatNational().replace(/\D/g, "") : "";
  }
  return e.replace(/\D/g, "");
}
function zB(e, t, n) {
  return String.prototype.localeCompare ? e.localeCompare(t, n) : e < t ? -1 : e > t ? 1 : 0;
}
function MB(e, t, n) {
  var r = new JI(t, n);
  r.input(e);
  var o = r.getNumber();
  return o && o.nationalNumber;
}
function kB(e, t, n) {
  for (var r = yB(t, n), o = 0; o < e.length && o < r.length;) {
    if (e[o] !== r[o]) return !1;
    o++;
  }
  return !0;
}
function NB(e) {
  var t = e.value,
    n = e.phoneNumber,
    r = e.defaultCountry,
    o = e.international,
    i = e.useNationalFormat,
    a = e.metadata;
  return (!1 === o || i) && n && n.country ? function (e) {
    return e.formatNational().replace(/\D/g, "");
  }(n) : !t && o && r ? yB(r, a) : t;
}
function SB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function VB(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? SB(Object(n), !0).forEach(function (t) {
      LB(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : SB(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function LB(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function PB(e) {
  return PB = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, PB(e);
}
function OB(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function TB() {
  return TB = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, TB.apply(this, arguments);
}
function DB(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function RB(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function GB(e) {
  return GB = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, GB(e);
}
function FB(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function jB(e, t) {
  return jB = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  }, jB(e, t);
}
function JB(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var ZB = function (e) {
    function n(e) {
      var r;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, n), r = function (e, t) {
        return !t || "object" !== PB(t) && "function" != typeof t ? FB(e) : t;
      }(this, GB(n).call(this, e)), JB(FB(r), "inputRef", /*#__PURE__*/t.createRef()), JB(FB(r), "setInputRef", function (e) {
        r.inputRef.current = e;
        var t = r.props.inputRef;
        t && ("function" == typeof t ? t(e) : t.current = e);
      }), JB(FB(r), "isCountrySupportedWithError", function (e) {
        return AB(e, r.props.metadata);
      }), JB(FB(r), "onCountryChange", function (e) {
        var t = r.props,
          n = t.international,
          o = t.metadata,
          i = t.onChange,
          a = t.focusInputOnCountrySelection,
          c = r.state,
          s = BB(c.phoneDigits, {
            prevCountry: c.country,
            newCountry: e,
            metadata: o,
            useNationalFormat: !n
          }),
          l = xB(s, e, o);
        a && r.inputRef.current.focus(), r.setState({
          country: e,
          hasUserSelectedACountry: !0,
          phoneDigits: s,
          value: l
        }, function () {
          i(l);
        });
      }), JB(FB(r), "onChange", function (e) {
        var t = r.props,
          n = t.defaultCountry,
          o = t.onChange,
          i = t.addInternationalOption,
          a = t.international,
          c = t.limitMaxLength,
          s = t.countryCallingCodeEditable,
          l = t.metadata,
          u = r.state,
          d = u.countries,
          f = function (e, t) {
            var n,
              r = t.prevPhoneDigits,
              o = t.country,
              i = t.defaultCountry,
              a = t.countryRequired,
              c = t.getAnyCountry,
              s = t.countries,
              l = t.international,
              u = t.limitMaxLength,
              d = t.countryCallingCodeEditable,
              f = t.metadata;
            if (l && !1 === d) {
              var p,
                m = yB(o, f);
              if (0 !== e.indexOf(m)) return e && "+" !== e[0] ? p = e = m + e : e = m, {
                phoneDigits: e,
                value: p,
                country: o
              };
            }
            return !1 === l && o && e && "+" === e[0] && (e = HB(e, o, f)), e && o && u && (e = wB(e, o, f)), !e || "+" === e[0] || o && !l || (e = "+" + e), !e && r && "+" === r[0] && (o = l ? void 0 : i), "+" === e && r && "+" === r[0] && r.length > "+".length && (o = void 0), e && (n = "+" === e[0] ? "+" === e || o && 0 === yB(o, f).indexOf(e) ? void 0 : e : xB(e, o, f)), n && (o = QB(n, {
              country: o,
              countries: s,
              metadata: f
            }), !1 === l && o && e && "+" === e[0] && (n = xB(e = HB(e, o, f), o, f))), !o && a && (o = i || c()), {
              phoneDigits: e,
              country: o,
              value: n
            };
          }(e, {
            prevPhoneDigits: u.phoneDigits,
            country: u.country,
            countryRequired: !i,
            defaultCountry: n,
            getAnyCountry: function () {
              return r.getFirstSupportedCountry({
                countries: d
              });
            },
            countries: d,
            international: a,
            limitMaxLength: c,
            countryCallingCodeEditable: s,
            metadata: l
          }),
          p = f.phoneDigits,
          m = f.country,
          h = f.value,
          A = {
            phoneDigits: p,
            value: h,
            country: m
          };
        !1 === s && (h || p !== r.state.phoneDigits || (A.forceRerender = {})), r.setState(A, function () {
          return o(h);
        });
      }), JB(FB(r), "_onFocus", function () {
        return r.setState({
          isFocused: !0
        });
      }), JB(FB(r), "_onBlur", function () {
        return r.setState({
          isFocused: !1
        });
      }), JB(FB(r), "onFocus", function (e) {
        r._onFocus();
        var t = r.props.onFocus;
        t && t(e);
      }), JB(FB(r), "onBlur", function (e) {
        var t = r.props.onBlur;
        r._onBlur(), t && t(e);
      }), JB(FB(r), "onCountryFocus", function (e) {
        r._onFocus();
        var t = r.props.countrySelectProps;
        if (t) {
          var n = t.onFocus;
          n && n(e);
        }
      }), JB(FB(r), "onCountryBlur", function (e) {
        r._onBlur();
        var t = r.props.countrySelectProps;
        if (t) {
          var n = t.onBlur;
          n && n(e);
        }
      });
      var o = r.props,
        i = o.value;
      o.labels;
      var a = o.international,
        c = o.addInternationalOption,
        s = o.displayInitialValueAsLocalNumber,
        l = o.initialValueFormat,
        u = o.metadata,
        d = r.props,
        f = d.defaultCountry,
        p = d.countries;
      f && (r.isCountrySupportedWithError(f) || (f = void 0)), p = gB(p, u);
      var m = IB(i, u);
      r.CountryIcon = vB(r.props);
      var h = function (e) {
        var t,
          n = e.value,
          r = e.phoneNumber,
          o = e.defaultCountry,
          i = e.getAnyCountry,
          a = e.countries,
          c = e.required,
          s = e.metadata;
        return r && r.country ? t = r.country : o && (n && !kB(n, o, s) || (t = o)), a && a.indexOf(t) < 0 && (t = void 0), !t && c && a && a.length > 0 && (t = i()), t;
      }({
        value: i,
        phoneNumber: m,
        defaultCountry: f,
        required: !c,
        countries: p || ZI(u),
        getAnyCountry: function () {
          return r.getFirstSupportedCountry({
            countries: p
          });
        },
        metadata: u
      });
      return r.state = {
        props: r.props,
        country: h,
        countries: p,
        phoneDigits: NB({
          value: i,
          phoneNumber: m,
          defaultCountry: f,
          international: a,
          useNationalFormat: s || "national" === l,
          metadata: u
        }),
        value: i
      }, r;
    }
    var r, o, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && jB(e, t);
    }(n, t.PureComponent), r = n, o = [{
      key: "componentDidMount",
      value: function () {
        var e = this.props.onCountryChange,
          t = this.props.defaultCountry,
          n = this.state.country;
        e && (t && (this.isCountrySupportedWithError(t) || (t = void 0)), n !== t && e(n));
      }
    }, {
      key: "componentDidUpdate",
      value: function (e, t) {
        var n = this.props.onCountryChange,
          r = this.state.country;
        n && r !== t.country && n(r);
      }
    }, {
      key: "getCountrySelectOptions",
      value: function (e) {
        var t,
          n,
          r = e.countries,
          o = this.props,
          i = o.international,
          a = o.countryCallingCodeEditable,
          c = o.countryOptionsOrder,
          s = o.addInternationalOption,
          l = o.labels,
          u = o.locales,
          d = o.metadata;
        return t = function () {
          return function (e, t) {
            if (!t) return e;
            var n = [],
              r = [],
              o = n,
              i = t,
              a = Array.isArray(i),
              c = 0;
            for (i = a ? i : i[Symbol.iterator]();;) {
              var s;
              if (a) {
                if (c >= i.length) break;
                s = i[c++];
              } else {
                if ((c = i.next()).done) break;
                s = c.value;
              }
              var l = s;
              "|" === l ? o.push({
                divider: !0
              }) : "..." === l || "…" === l ? o = r : function () {
                var t = void 0;
                t = "🌐" === l ? void 0 : l;
                var n = e.indexOf(e.filter(function (e) {
                    return e.value === t;
                  })[0]),
                  r = e[n];
                e.splice(n, 1), o.push(r);
              }();
            }
            return n.concat(e).concat(r);
          }(function (e) {
            var t = e.countries,
              n = e.countryNames,
              r = e.addInternationalOption,
              o = e.compareStringsLocales,
              i = e.compareStrings;
            i || (i = zB);
            var a = t.map(function (e) {
              return {
                value: e,
                label: n[e] || e
              };
            });
            return a.sort(function (e, t) {
              return i(e.label, t.label, o);
            }), r && a.unshift({
              label: n.ZZ
            }), a;
          }({
            countries: r || ZI(d),
            countryNames: l,
            addInternationalOption: (!i || !1 !== a) && s,
            compareStringsLocales: u
          }), function (e, t) {
            if (e && (e = e.filter(function (e) {
              switch (e) {
                case "🌐":
                case "|":
                case "...":
                case "…":
                  return !0;
                default:
                  return AB(e, t);
              }
            })).length > 0) return e;
          }(c, d));
        }, n = [r, c, s, l, d], UB && function (e, t) {
          if (e.length !== t.length) return !1;
          for (var n = 0; n < e.length;) {
            if (e[n] !== t[n]) return !1;
            n++;
          }
          return !0;
        }(n, UB) || (XB = t(), UB = n), XB;
      }
    }, {
      key: "getFirstSupportedCountry",
      value: function (e) {
        var t = e.countries;
        return this.getCountrySelectOptions({
          countries: t
        })[0].value;
      }
    }, {
      key: "render",
      value: function () {
        var e = this.props,
          n = e.name,
          r = e.disabled,
          o = e.autoComplete,
          i = e.style,
          a = e.className;
        e.inputRef;
        var c = e.inputComponent,
          s = e.numberInputProps,
          l = e.smartCaret,
          u = e.countrySelectComponent,
          d = e.countrySelectProps,
          f = e.containerComponent;
        e.defaultCountry, e.countries, e.countryOptionsOrder;
        var p = e.labels;
        e.flags, e.flagComponent, e.flagUrl, e.addInternationalOption, e.internationalIcon, e.displayInitialValueAsLocalNumber, e.initialValueFormat, e.onCountryChange, e.limitMaxLength, e.countryCallingCodeEditable, e.focusInputOnCountrySelection, e.reset;
        var m = e.metadata;
        e.international, e.locales;
        var h = DB(e, ["name", "disabled", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"]),
          A = this.state,
          g = A.country,
          v = A.countries,
          C = A.phoneDigits,
          b = A.isFocused,
          E = l ? YI : $I,
          y = this.getCountrySelectOptions({
            countries: v
          });
        return /*#__PURE__*/t.createElement(f, {
          style: i,
          className: tC(a, "PhoneInput", {
            "PhoneInput--focus": b
          })
        }, /*#__PURE__*/t.createElement(u, TB({
          name: n ? "".concat(n, "Country") : void 0,
          "aria-label": p.country
        }, d, {
          value: g,
          options: y,
          onChange: this.onCountryChange,
          onFocus: this.onCountryFocus,
          onBlur: this.onCountryBlur,
          disabled: r || d && d.disabled,
          iconComponent: this.CountryIcon
        })), /*#__PURE__*/t.createElement(E, TB({
          ref: this.setInputRef,
          type: "tel",
          autoComplete: o
        }, s, h, {
          name: n,
          metadata: m,
          country: g,
          value: C || "",
          onChange: this.onChange,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          disabled: r,
          inputComponent: c,
          className: tC("PhoneInputInput", s && s.className, h.className)
        })));
      }
    }], i = [{
      key: "getDerivedStateFromProps",
      value: function (e, t) {
        return function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? OB(Object(n), !0).forEach(function (t) {
              JB(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : OB(Object(n)).forEach(function (t) {
              Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
          }
          return e;
        }({
          props: e
        }, function (e, t, n) {
          var r = e.metadata,
            o = e.countries,
            i = e.defaultCountry,
            a = e.value,
            c = e.reset,
            s = e.international,
            l = e.displayInitialValueAsLocalNumber,
            u = e.initialValueFormat,
            d = t.defaultCountry,
            f = t.value,
            p = t.reset;
          n.country;
          var m = n.value,
            h = n.hasUserSelectedACountry,
            A = function (e) {
              return NB(VB({}, e, {
                international: s,
                useNationalFormat: l || "national" === u,
                metadata: r
              }));
            };
          if (c !== p) return {
            phoneDigits: A({
              value: void 0,
              defaultCountry: i
            }),
            value: void 0,
            country: i,
            hasUserSelectedACountry: void 0
          };
          if (i !== d) {
            var g = !i || AB(i, r),
              v = !m || s && m === A({
                value: void 0,
                defaultCountry: d
              });
            if (!h && g && !a && v) return {
              country: i,
              phoneDigits: A({
                value: void 0,
                defaultCountry: i
              }),
              value: void 0
            };
          }
          if (a !== f && a !== m) {
            var C, b, E;
            if (a) {
              C = IB(a, r);
              var y = gB(o, r);
              C && C.country ? (!y || y.indexOf(C.country) >= 0) && (b = C.country) : b = QB(a, {
                country: void 0,
                countries: y,
                metadata: r
              });
            }
            return a || (E = {
              hasUserSelectedACountry: void 0
            }), VB({}, E, {
              phoneDigits: A({
                phoneNumber: C,
                value: a,
                defaultCountry: i
              }),
              value: a,
              country: a ? b : i
            });
          }
        }(e, t.props, t));
      }
    }], o && RB(r.prototype, o), i && RB(r, i), n;
  }(),
  WB = /*#__PURE__*/t.forwardRef(function (e, n) {
    return /*#__PURE__*/t.createElement(ZB, TB({}, e, {
      inputRef: n
    }));
  });
WB.propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  onFocus: g.func,
  onBlur: g.func,
  disabled: g.bool,
  autoComplete: g.string.isRequired,
  initialValueFormat: g.oneOf(["national"]),
  displayInitialValueAsLocalNumber: g.bool,
  defaultCountry: g.string,
  countries: g.arrayOf(g.string),
  labels: bB.isRequired,
  locales: g.oneOfType([g.string, g.arrayOf(g.string)]),
  flagUrl: g.string.isRequired,
  flags: g.objectOf(g.elementType),
  flagComponent: g.elementType.isRequired,
  addInternationalOption: g.bool.isRequired,
  internationalIcon: g.elementType.isRequired,
  countryOptionsOrder: g.arrayOf(g.string),
  style: g.object,
  className: g.string,
  countrySelectComponent: g.elementType.isRequired,
  countrySelectProps: g.object,
  inputComponent: g.elementType.isRequired,
  containerComponent: g.elementType.isRequired,
  numberInputProps: g.object,
  smartCaret: g.bool.isRequired,
  international: g.bool,
  limitMaxLength: g.bool.isRequired,
  countryCallingCodeEditable: g.bool.isRequired,
  metadata: CB.isRequired,
  onCountryChange: g.func,
  focusInputOnCountrySelection: g.bool.isRequired
}, WB.defaultProps = {
  autoComplete: "tel",
  countrySelectComponent: aB,
  flagComponent: uB,
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  internationalIcon: pB,
  inputComponent: "input",
  containerComponent: "div",
  reset: g.any,
  smartCaret: !0,
  addInternationalOption: !0,
  limitMaxLength: !1,
  countryCallingCodeEditable: !0,
  focusInputOnCountrySelection: !0
};
var XB,
  UB,
  KB = WB;
var YB = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Burma",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
function qB() {
  return qB = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, qB.apply(this, arguments);
}
function _B(e) {
  var n = /*#__PURE__*/t.forwardRef(function (e, n) {
    return /*#__PURE__*/t.createElement(KB, qB({
      ref: n
    }, e));
  });
  return n.propTypes = {
    metadata: CB.isRequired,
    labels: bB.isRequired
  }, n.defaultProps = {
    metadata: e,
    labels: YB
  }, n;
}
_B();
var $B = _B(VE);
function ex(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if (!(Symbol.iterator in Object(e)) && "[object Arguments]" !== Object.prototype.toString.call(e)) return;
    var n = [],
      r = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function tx(e) {
  var t = this,
    i = e.value,
    a = e.onChange,
    c = e.country,
    s = e.defaultCountry,
    u = e.international,
    d = e.withCountryCallingCode,
    f = e.useNationalFormatForDefaultCountryValue,
    p = e.metadata,
    m = o(),
    h = function (e, t, n) {
      console.error("[react-phone-number-input] Expected phone number ".concat(e, " to correspond to country ").concat(t, " but ").concat(n ? "in reality it corresponds to country " + n : "it doesn't", ".")), m.current = !0;
    },
    A = function (e) {
      return function (e, t, n, r, o, i, a, c) {
        if (t && n && r) {
          var s = yB(t, a);
          return e ? (0 !== e.indexOf(s) && c(e, t), e) : s;
        }
        if (!e) return "";
        if (!t && !o) return e;
        var l = new JI(void 0, a);
        l.input(e);
        var u = l.getNumber();
        return u ? t ? (u.country && u.country !== t ? c(e, t, u.country) : u.countryCallingCode !== dy(t, a) && c(e, t), n ? u.nationalNumber : By(u.formatNational())) : u.countryCallingCode && u.countryCallingCode === dy(o, a) && i ? By(u.formatNational()) : e : "";
      }(i, c, u, d, s, f, p, function () {
        e && e.onCountryMismatch && e.onCountryMismatch();
        for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
        h.apply(t, r);
      });
    },
    g = ex(n(c), 2),
    v = g[0],
    C = g[1],
    b = ex(n(s), 2),
    E = b[0],
    y = b[1],
    I = ex(n(A()), 2),
    B = I[0],
    x = I[1],
    w = ex(n(i), 2),
    Q = w[0],
    H = w[1],
    z = ex(n(), 2);
  z[0];
  var M = z[1],
    k = l(function () {
      return M({});
    }, [M]);
  function N(e) {
    var t = new JI(c || s, p);
    t.input(c && u && !d ? "+".concat(dy(c, p)).concat(e) : e);
    var n = t.getNumber();
    if (n) return n.number;
  }
  r(function () {
    i !== Q && (H(i), x(A()));
  }, [i]), r(function () {
    if (c !== v) {
      var e;
      C(c);
      var t = A({
        onCountryMismatch: function () {
          e = !0;
        }
      });
      x(t), e && H(N(t));
    }
  }, [c]), r(function () {
    s !== E && (y(s), x(A()));
  }, [s]), r(function () {
    Q !== i && a(Q);
  }, [Q]);
  var S = l(function (e) {
    var t;
    if (c) {
      if (u && d) {
        var n = yB(c, p);
        if (0 !== e.indexOf(n)) if (e && "+" !== e[0]) e = n + e;else if (!m.current) return x(n), H(void 0), k();
      } else e && "+" === e[0] && (e = e.slice(1));
    } else s || e && "+" !== e[0] && (e = "+" + e);
    e && (t = N(e)), x(e), H(t);
  }, [c, u, d, s, p, x, H, k, m]);
  return [B, S];
}
function nx() {
  return nx = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, nx.apply(this, arguments);
}
function rx(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    if (!(Symbol.iterator in Object(e)) && "[object Arguments]" !== Object.prototype.toString.call(e)) return;
    var n = [],
      r = !0,
      o = !1,
      i = void 0;
    try {
      for (var a, c = e[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0);
    } catch (e) {
      o = !0, i = e;
    } finally {
      try {
        r || null == c.return || c.return();
      } finally {
        if (o) throw i;
      }
    }
    return n;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}
function ox(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function ix(e, n) {
  var r = e.Component,
    o = e.country,
    i = e.defaultCountry,
    a = e.useNationalFormatForDefaultCountryValue,
    c = e.value,
    s = e.onChange,
    l = e.metadata,
    u = e.international,
    d = e.withCountryCallingCode,
    f = ox(e, ["Component", "country", "defaultCountry", "useNationalFormatForDefaultCountryValue", "value", "onChange", "metadata", "international", "withCountryCallingCode"]),
    p = rx(tx({
      value: c,
      onChange: s,
      country: o,
      defaultCountry: i,
      international: u,
      withCountryCallingCode: d,
      useNationalFormatForDefaultCountryValue: a,
      metadata: l
    }), 2),
    m = p[0],
    h = p[1];
  return /*#__PURE__*/t.createElement(r, nx({}, f, {
    ref: n,
    metadata: l,
    international: u,
    withCountryCallingCode: d,
    country: o || i,
    value: m,
    onChange: h
  }));
}
(ix = /*#__PURE__*/t.forwardRef(ix)).propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  country: g.string,
  defaultCountry: g.string,
  international: g.bool,
  withCountryCallingCode: g.bool,
  Component: g.elementType.isRequired,
  useNationalFormatForDefaultCountryValue: g.bool.isRequired,
  metadata: g.object.isRequired
}, ix.defaultProps = {
  useNationalFormatForDefaultCountryValue: !0
};
var ax = ix;
function cx() {
  return cx = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cx.apply(this, arguments);
}
function sx(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function lx(e) {
  function n(e, n) {
    var r = e.smartCaret,
      o = sx(e, ["smartCaret"]);
    return /*#__PURE__*/t.createElement(ax, cx({}, o, {
      ref: n,
      Component: r ? YI : $I
    }));
  }
  return (n = /*#__PURE__*/t.forwardRef(n)).propTypes = {
    type: g.string,
    autoComplete: g.string,
    smartCaret: g.bool.isRequired,
    metadata: g.object.isRequired
  }, n.defaultProps = {
    type: "tel",
    autoComplete: "tel",
    smartCaret: !0,
    metadata: e
  }, n;
}
lx();
var ux = lx(VE),
  dx = "inputPhoneNumber-module_chevron__3ZdIm",
  fx = ["isDense", "country", "defaultCountry", "isDisabled", "withCountrySelector", "onFocus", "onBlur", "value", "onChange", "removeBottomSpacer", "isError", "description", "inputWidth"],
  px = function (e) {
    var r = e.isDense,
      o = e.country,
      i = e.defaultCountry,
      a = e.isDisabled,
      c = e.withCountrySelector,
      s = e.onFocus,
      l = e.onBlur,
      u = e.value,
      d = e.onChange,
      f = e.removeBottomSpacer,
      p = e.isError,
      m = e.description,
      h = e.inputWidth,
      A = S(e, fx),
      g = V(n(!1), 2),
      v = g[0],
      C = g[1],
      b = c ? $B : ux,
      E = A.inlineEditOnSubmit || null,
      y = A.inlineEditOnCancel || null,
      I = A.inlineEditSubmitIsDisabled || !1;
    return delete A.inlineEditOnSubmit, delete A.inlineEditOnCancel, delete A.inlineEditSubmitIsDisabled, /*#__PURE__*/t.createElement(qb, {
      isActive: v,
      isDisabled: a,
      removeBottomSpacer: f,
      description: m,
      isError: p,
      inputWidth: h,
      inlineEditOnSubmit: E,
      inlineEditOnCancel: y,
      inlineEditSubmitIsDisabled: I,
      customColor: A.customColor
    }, /*#__PURE__*/t.createElement("div", {
      className: dx
    }, /*#__PURE__*/t.createElement(qv, {
      name: "chevronDown"
    })), /*#__PURE__*/t.createElement(b, N({
      value: u,
      onChange: d,
      country: o,
      disabled: a,
      defaultCountry: i,
      onFocus: function (e) {
        C(!0), s && s(e);
      },
      onBlur: function (e) {
        C(!1), l && l(e);
      },
      className: r ? "ds-phone-input-dense" : ""
    }, A)));
  };
function mx() {
  return mx = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, mx.apply(this, arguments);
}
px.propTypes = {
  onChange: g.func.isRequired,
  value: g.string,
  withCountrySelector: g.bool,
  country: g.string,
  defaultCountry: g.string,
  onFocus: g.func,
  onBlur: g.func,
  isDense: g.bool,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  description: g.string,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"])
}, px.defaultProps = {
  withCountrySelector: !0,
  defaultCountry: "US"
};
var hx = function () {
    function e(e) {
      var t = this;
      this._insertTag = function (e) {
        var n;
        n = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e);
      }, this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
    }
    var t = e.prototype;
    return t.hydrate = function (e) {
      e.forEach(this._insertTag);
    }, t.insert = function (e) {
      this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
        var t = document.createElement("style");
        return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
      }(this));
      var t = this.tags[this.tags.length - 1];
      if ("production" !== process.env.NODE_ENV) {
        var n = 64 === e.charCodeAt(0) && 105 === e.charCodeAt(1);
        n && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n;
      }
      if (this.isSpeedy) {
        var r = function (e) {
          if (e.sheet) return e.sheet;
          for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
        }(t);
        try {
          r.insertRule(e, r.cssRules.length);
        } catch (t) {
          "production" === process.env.NODE_ENV || /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(e) || console.error('There was a problem inserting the following rule: "' + e + '"', t);
        }
      } else t.appendChild(document.createTextNode(e));
      this.ctr++;
    }, t.flush = function () {
      this.tags.forEach(function (e) {
        return e.parentNode && e.parentNode.removeChild(e);
      }), this.tags = [], this.ctr = 0, "production" !== process.env.NODE_ENV && (this._alreadyInsertedOrderInsensitiveRule = !1);
    }, e;
  }(),
  Ax = "-ms-",
  gx = "-moz-",
  vx = "-webkit-",
  Cx = Math.abs,
  bx = String.fromCharCode,
  Ex = Object.assign;
function yx(e) {
  return e.trim();
}
function Ix(e, t, n) {
  return e.replace(t, n);
}
function Bx(e, t) {
  return e.indexOf(t);
}
function xx(e, t) {
  return 0 | e.charCodeAt(t);
}
function wx(e, t, n) {
  return e.slice(t, n);
}
function Qx(e) {
  return e.length;
}
function Hx(e) {
  return e.length;
}
function zx(e, t) {
  return t.push(e), e;
}
var Mx = 1,
  kx = 1,
  Nx = 0,
  Sx = 0,
  Vx = 0,
  Lx = "";
function Px(e, t, n, r, o, i, a) {
  return {
    value: e,
    root: t,
    parent: n,
    type: r,
    props: o,
    children: i,
    line: Mx,
    column: kx,
    length: a,
    return: ""
  };
}
function Ox(e, t) {
  return Ex(Px("", null, null, "", null, null, 0), e, {
    length: -e.length
  }, t);
}
function Tx() {
  return Vx = Sx > 0 ? xx(Lx, --Sx) : 0, kx--, 10 === Vx && (kx = 1, Mx--), Vx;
}
function Dx() {
  return Vx = Sx < Nx ? xx(Lx, Sx++) : 0, kx++, 10 === Vx && (kx = 1, Mx++), Vx;
}
function Rx() {
  return xx(Lx, Sx);
}
function Gx() {
  return Sx;
}
function Fx(e, t) {
  return wx(Lx, e, t);
}
function jx(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Jx(e) {
  return Mx = kx = 1, Nx = Qx(Lx = e), Sx = 0, [];
}
function Zx(e) {
  return Lx = "", e;
}
function Wx(e) {
  return yx(Fx(Sx - 1, Kx(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
}
function Xx(e) {
  for (; (Vx = Rx()) && Vx < 33;) Dx();
  return jx(e) > 2 || jx(Vx) > 3 ? "" : " ";
}
function Ux(e, t) {
  for (; --t && Dx() && !(Vx < 48 || Vx > 102 || Vx > 57 && Vx < 65 || Vx > 70 && Vx < 97););
  return Fx(e, Gx() + (t < 6 && 32 == Rx() && 32 == Dx()));
}
function Kx(e) {
  for (; Dx();) switch (Vx) {
    case e:
      return Sx;
    case 34:
    case 39:
      34 !== e && 39 !== e && Kx(Vx);
      break;
    case 40:
      41 === e && Kx(e);
      break;
    case 92:
      Dx();
  }
  return Sx;
}
function Yx(e, t) {
  for (; Dx() && e + Vx !== 57 && (e + Vx !== 84 || 47 !== Rx()););
  return "/*" + Fx(t, Sx - 1) + "*" + bx(47 === e ? e : Dx());
}
function qx(e) {
  for (; !jx(Rx());) Dx();
  return Fx(e, Sx);
}
function _x(e) {
  return Zx($x("", null, null, null, [""], e = Jx(e), 0, [0], e));
}
function $x(e, t, n, r, o, i, a, c, s) {
  for (var l = 0, u = 0, d = a, f = 0, p = 0, m = 0, h = 1, A = 1, g = 1, v = 0, C = "", b = o, E = i, y = r, I = C; A;) switch (m = v, v = Dx()) {
    case 40:
      if (108 != m && 58 == I.charCodeAt(d - 1)) {
        -1 != Bx(I += Ix(Wx(v), "&", "&\f"), "&\f") && (g = -1);
        break;
      }
    case 34:
    case 39:
    case 91:
      I += Wx(v);
      break;
    case 9:
    case 10:
    case 13:
    case 32:
      I += Xx(m);
      break;
    case 92:
      I += Ux(Gx() - 1, 7);
      continue;
    case 47:
      switch (Rx()) {
        case 42:
        case 47:
          zx(tw(Yx(Dx(), Gx()), t, n), s);
          break;
        default:
          I += "/";
      }
      break;
    case 123 * h:
      c[l++] = Qx(I) * g;
    case 125 * h:
    case 59:
    case 0:
      switch (v) {
        case 0:
        case 125:
          A = 0;
        case 59 + u:
          p > 0 && Qx(I) - d && zx(p > 32 ? nw(I + ";", r, n, d - 1) : nw(Ix(I, " ", "") + ";", r, n, d - 2), s);
          break;
        case 59:
          I += ";";
        default:
          if (zx(y = ew(I, t, n, l, u, o, c, C, b = [], E = [], d), i), 123 === v) if (0 === u) $x(I, t, y, y, b, i, d, c, E);else switch (f) {
            case 100:
            case 109:
            case 115:
              $x(e, y, y, r && zx(ew(e, y, y, 0, 0, o, c, C, o, b = [], d), E), o, E, d, c, r ? b : E);
              break;
            default:
              $x(I, y, y, y, [""], E, 0, c, E);
          }
      }
      l = u = p = 0, h = g = 1, C = I = "", d = a;
      break;
    case 58:
      d = 1 + Qx(I), p = m;
    default:
      if (h < 1) if (123 == v) --h;else if (125 == v && 0 == h++ && 125 == Tx()) continue;
      switch (I += bx(v), v * h) {
        case 38:
          g = u > 0 ? 1 : (I += "\f", -1);
          break;
        case 44:
          c[l++] = (Qx(I) - 1) * g, g = 1;
          break;
        case 64:
          45 === Rx() && (I += Wx(Dx())), f = Rx(), u = d = Qx(C = I += qx(Gx())), v++;
          break;
        case 45:
          45 === m && 2 == Qx(I) && (h = 0);
      }
  }
  return i;
}
function ew(e, t, n, r, o, i, a, c, s, l, u) {
  for (var d = o - 1, f = 0 === o ? i : [""], p = Hx(f), m = 0, h = 0, A = 0; m < r; ++m) for (var g = 0, v = wx(e, d + 1, d = Cx(h = a[m])), C = e; g < p; ++g) (C = yx(h > 0 ? f[g] + " " + v : Ix(v, /&\f/g, f[g]))) && (s[A++] = C);
  return Px(e, t, n, 0 === o ? "rule" : c, s, l, u);
}
function tw(e, t, n) {
  return Px(e, t, n, "comm", bx(Vx), wx(e, 2, -2), 0);
}
function nw(e, t, n, r) {
  return Px(e, t, n, "decl", wx(e, 0, r), wx(e, r + 1, -1), r);
}
function rw(e, t) {
  switch (function (e, t) {
    return (((t << 2 ^ xx(e, 0)) << 2 ^ xx(e, 1)) << 2 ^ xx(e, 2)) << 2 ^ xx(e, 3);
  }(e, t)) {
    case 5103:
      return vx + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return vx + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return vx + e + gx + e + Ax + e + e;
    case 6828:
    case 4268:
      return vx + e + Ax + e + e;
    case 6165:
      return vx + e + Ax + "flex-" + e + e;
    case 5187:
      return vx + e + Ix(e, /(\w+).+(:[^]+)/, "-webkit-box-$1$2-ms-flex-$1$2") + e;
    case 5443:
      return vx + e + Ax + "flex-item-" + Ix(e, /flex-|-self/, "") + e;
    case 4675:
      return vx + e + Ax + "flex-line-pack" + Ix(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return vx + e + Ax + Ix(e, "shrink", "negative") + e;
    case 5292:
      return vx + e + Ax + Ix(e, "basis", "preferred-size") + e;
    case 6060:
      return vx + "box-" + Ix(e, "-grow", "") + vx + e + Ax + Ix(e, "grow", "positive") + e;
    case 4554:
      return vx + Ix(e, /([^-])(transform)/g, "$1-webkit-$2") + e;
    case 6187:
      return Ix(Ix(Ix(e, /(zoom-|grab)/, vx + "$1"), /(image-set)/, vx + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ix(e, /(image-set\([^]*)/, vx + "$1$`$1");
    case 4968:
      return Ix(Ix(e, /(.+:)(flex-)?(.*)/, "-webkit-box-pack:$3-ms-flex-pack:$3"), /s.+-b[^;]+/, "justify") + vx + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ix(e, /(.+)-inline(.+)/, vx + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Qx(e) - 1 - t > 6) switch (xx(e, t + 1)) {
        case 109:
          if (45 !== xx(e, t + 4)) break;
        case 102:
          return Ix(e, /(.+:)(.+)-([^]+)/, "$1-webkit-$2-$3$1" + gx + (108 == xx(e, t + 3) ? "$3" : "$2-$3")) + e;
        case 115:
          return ~Bx(e, "stretch") ? rw(Ix(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (115 !== xx(e, t + 1)) break;
    case 6444:
      switch (xx(e, Qx(e) - 3 - (~Bx(e, "!important") && 10))) {
        case 107:
          return Ix(e, ":", ":" + vx) + e;
        case 101:
          return Ix(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + vx + (45 === xx(e, 14) ? "inline-" : "") + "box$3$1" + vx + "$2$3$1" + Ax + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (xx(e, t + 11)) {
        case 114:
          return vx + e + Ax + Ix(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return vx + e + Ax + Ix(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return vx + e + Ax + Ix(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return vx + e + Ax + e + e;
  }
  return e;
}
function ow(e, t) {
  for (var n = "", r = Hx(e), o = 0; o < r; o++) n += t(e[o], o, e, t) || "";
  return n;
}
function iw(e, t, n, r) {
  switch (e.type) {
    case "@import":
    case "decl":
      return e.return = e.return || e.value;
    case "comm":
      return "";
    case "@keyframes":
      return e.return = e.value + "{" + ow(e.children, r) + "}";
    case "rule":
      e.value = e.props.join(",");
  }
  return Qx(n = ow(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function aw(e) {
  var t = Hx(e);
  return function (n, r, o, i) {
    for (var a = "", c = 0; c < t; c++) a += e[c](n, r, o, i) || "";
    return a;
  };
}
var cw = function (e, t, n) {
    for (var r = 0, o = 0; r = o, o = Rx(), 38 === r && 12 === o && (t[n] = 1), !jx(o);) Dx();
    return Fx(e, Sx);
  },
  sw = function (e, t) {
    return Zx(function (e, t) {
      var n = -1,
        r = 44;
      do {
        switch (jx(r)) {
          case 0:
            38 === r && 12 === Rx() && (t[n] = 1), e[n] += cw(Sx - 1, t, n);
            break;
          case 2:
            e[n] += Wx(r);
            break;
          case 4:
            if (44 === r) {
              e[++n] = 58 === Rx() ? "&\f" : "", t[n] = e[n].length;
              break;
            }
          default:
            e[n] += bx(r);
        }
      } while (r = Dx());
      return e;
    }(Jx(e), t));
  },
  lw = new WeakMap(),
  uw = function (e) {
    if ("rule" === e.type && e.parent && !(e.length < 1)) {
      for (var t = e.value, n = e.parent, r = e.column === n.column && e.line === n.line; "rule" !== n.type;) if (!(n = n.parent)) return;
      if ((1 !== e.props.length || 58 === t.charCodeAt(0) || lw.get(n)) && !r) {
        lw.set(e, !0);
        for (var o = [], i = sw(t, o), a = n.props, c = 0, s = 0; c < i.length; c++) for (var l = 0; l < a.length; l++, s++) e.props[s] = o[c] ? i[c].replace(/&\f/g, a[l]) : a[l] + " " + i[c];
      }
    }
  },
  dw = function (e) {
    if ("decl" === e.type) {
      var t = e.value;
      108 === t.charCodeAt(0) && 98 === t.charCodeAt(2) && (e.return = "", e.value = "");
    }
  },
  fw = function (e) {
    return 105 === e.type.charCodeAt(1) && 64 === e.type.charCodeAt(0);
  },
  pw = function (e) {
    e.type = "", e.value = "", e.return = "", e.children = "", e.props = "";
  },
  mw = function (e, t, n) {
    fw(e) && (e.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), pw(e)) : function (e, t) {
      for (var n = e - 1; n >= 0; n--) if (!fw(t[n])) return !0;
      return !1;
    }(t, n) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), pw(e)));
  },
  hw = "undefined" != typeof document,
  Aw = hw ? void 0 : function (e) {
    var t = new WeakMap();
    return function (n) {
      if (t.has(n)) return t.get(n);
      var r = e(n);
      return t.set(n, r), r;
    };
  }(function () {
    return function (e) {
      var t = Object.create(null);
      return function (n) {
        return void 0 === t[n] && (t[n] = e(n)), t[n];
      };
    }(function () {
      var e = {};
      return function (t) {
        return e[t];
      };
    });
  }),
  gw = [function (e, t, n, r) {
    if (e.length > -1 && !e.return) switch (e.type) {
      case "decl":
        e.return = rw(e.value, e.length);
        break;
      case "@keyframes":
        return ow([Ox(e, {
          value: Ix(e.value, "@", "@" + vx)
        })], r);
      case "rule":
        if (e.length) return function (e, t) {
          return e.map(t).join("");
        }(e.props, function (t) {
          switch (function (e, t) {
            return (e = t.exec(e)) ? e[0] : e;
          }(t, /(::plac\w+|:read-\w+)/)) {
            case ":read-only":
            case ":read-write":
              return ow([Ox(e, {
                props: [Ix(t, /:(read-\w+)/, ":-moz-$1")]
              })], r);
            case "::placeholder":
              return ow([Ox(e, {
                props: [Ix(t, /:(plac\w+)/, ":-webkit-input-$1")]
              }), Ox(e, {
                props: [Ix(t, /:(plac\w+)/, ":-moz-$1")]
              }), Ox(e, {
                props: [Ix(t, /:(plac\w+)/, Ax + "input-$1")]
              })], r);
          }
          return "";
        });
    }
  }],
  vw = function (e) {
    var t = e.key;
    if ("production" !== process.env.NODE_ENV && !t) throw new Error("You have to configure `key` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.\nIf multiple caches share the same key they might \"fight\" for each other's style elements.");
    if (hw && "css" === t) {
      var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
      Array.prototype.forEach.call(n, function (e) {
        -1 !== e.getAttribute("data-emotion").indexOf(" ") && (document.head.appendChild(e), e.setAttribute("data-s", ""));
      });
    }
    var r = e.stylisPlugins || gw;
    if ("production" !== process.env.NODE_ENV && /[^a-z-]/.test(t)) throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + t + '" was passed');
    var o,
      i,
      a = {},
      c = [];
    hw && (o = e.container || document.head, Array.prototype.forEach.call(document.querySelectorAll('style[data-emotion^="' + t + ' "]'), function (e) {
      for (var t = e.getAttribute("data-emotion").split(" "), n = 1; n < t.length; n++) a[t[n]] = !0;
      c.push(e);
    }));
    var s,
      l = [uw, dw];
    if ("production" !== process.env.NODE_ENV && l.push(function (e) {
      return function (t, n, r) {
        if ("rule" === t.type) {
          var o,
            i = t.value.match(/(:first|:nth|:nth-last)-child/g);
          if (i && !0 !== e.compat) {
            var a = n > 0 ? r[n - 1] : null;
            if (a && function (e) {
              return !!e && "comm" === e.type && e.children.indexOf("emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason") > -1;
            }((o = a.children).length ? o[o.length - 1] : null)) return;
            i.forEach(function (e) {
              console.error('The pseudo class "' + e + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + e.split("-child")[0] + '-of-type".');
            });
          }
        }
      };
    }({
      get compat() {
        return g.compat;
      }
    }), mw), hw) {
      var u,
        d = [iw, "production" !== process.env.NODE_ENV ? function (e) {
          e.root || (e.return ? u.insert(e.return) : e.value && "comm" !== e.type && u.insert(e.value + "{}"));
        } : (s = function (e) {
          u.insert(e);
        }, function (e) {
          e.root || (e = e.return) && s(e);
        })],
        f = aw(l.concat(r, d));
      i = function (e, t, n, r) {
        u = n, "production" !== process.env.NODE_ENV && void 0 !== t.map && (u = {
          insert: function (e) {
            n.insert(e + t.map);
          }
        }), function (e) {
          ow(_x(e), f);
        }(e ? e + "{" + t.styles + "}" : t.styles), r && (g.inserted[t.name] = !0);
      };
    } else {
      var p = [iw],
        m = aw(l.concat(r, p)),
        h = Aw(r)(t),
        A = function (e, t) {
          var n = t.name;
          return void 0 === h[n] && (h[n] = function (e) {
            return ow(_x(e), m);
          }(e ? e + "{" + t.styles + "}" : t.styles)), h[n];
        };
      i = function (e, t, n, r) {
        var o = t.name,
          i = A(e, t);
        return void 0 === g.compat ? (r && (g.inserted[o] = !0), "development" === process.env.NODE_ENV && void 0 !== t.map ? i + t.map : i) : r ? void (g.inserted[o] = i) : i;
      };
    }
    var g = {
      key: t,
      sheet: new hx({
        key: t,
        container: o,
        nonce: e.nonce,
        speedy: e.speedy,
        prepend: e.prepend,
        insertionPoint: e.insertionPoint
      }),
      nonce: e.nonce,
      inserted: a,
      registered: {},
      insert: i
    };
    return g.sheet.hydrate(c), g;
  },
  Cw = {
    exports: {}
  },
  bw = {},
  Ew = "function" == typeof Symbol && Symbol.for,
  yw = Ew ? Symbol.for("react.element") : 60103,
  Iw = Ew ? Symbol.for("react.portal") : 60106,
  Bw = Ew ? Symbol.for("react.fragment") : 60107,
  xw = Ew ? Symbol.for("react.strict_mode") : 60108,
  ww = Ew ? Symbol.for("react.profiler") : 60114,
  Qw = Ew ? Symbol.for("react.provider") : 60109,
  Hw = Ew ? Symbol.for("react.context") : 60110,
  zw = Ew ? Symbol.for("react.async_mode") : 60111,
  Mw = Ew ? Symbol.for("react.concurrent_mode") : 60111,
  kw = Ew ? Symbol.for("react.forward_ref") : 60112,
  Nw = Ew ? Symbol.for("react.suspense") : 60113,
  Sw = Ew ? Symbol.for("react.suspense_list") : 60120,
  Vw = Ew ? Symbol.for("react.memo") : 60115,
  Lw = Ew ? Symbol.for("react.lazy") : 60116,
  Pw = Ew ? Symbol.for("react.block") : 60121,
  Ow = Ew ? Symbol.for("react.fundamental") : 60117,
  Tw = Ew ? Symbol.for("react.responder") : 60118,
  Dw = Ew ? Symbol.for("react.scope") : 60119;
function Rw(e) {
  if ("object" == typeof e && null !== e) {
    var t = e.$$typeof;
    switch (t) {
      case yw:
        switch (e = e.type) {
          case zw:
          case Mw:
          case Bw:
          case ww:
          case xw:
          case Nw:
            return e;
          default:
            switch (e = e && e.$$typeof) {
              case Hw:
              case kw:
              case Lw:
              case Vw:
              case Qw:
                return e;
              default:
                return t;
            }
        }
      case Iw:
        return t;
    }
  }
}
function Gw(e) {
  return Rw(e) === Mw;
}
bw.AsyncMode = zw, bw.ConcurrentMode = Mw, bw.ContextConsumer = Hw, bw.ContextProvider = Qw, bw.Element = yw, bw.ForwardRef = kw, bw.Fragment = Bw, bw.Lazy = Lw, bw.Memo = Vw, bw.Portal = Iw, bw.Profiler = ww, bw.StrictMode = xw, bw.Suspense = Nw, bw.isAsyncMode = function (e) {
  return Gw(e) || Rw(e) === zw;
}, bw.isConcurrentMode = Gw, bw.isContextConsumer = function (e) {
  return Rw(e) === Hw;
}, bw.isContextProvider = function (e) {
  return Rw(e) === Qw;
}, bw.isElement = function (e) {
  return "object" == typeof e && null !== e && e.$$typeof === yw;
}, bw.isForwardRef = function (e) {
  return Rw(e) === kw;
}, bw.isFragment = function (e) {
  return Rw(e) === Bw;
}, bw.isLazy = function (e) {
  return Rw(e) === Lw;
}, bw.isMemo = function (e) {
  return Rw(e) === Vw;
}, bw.isPortal = function (e) {
  return Rw(e) === Iw;
}, bw.isProfiler = function (e) {
  return Rw(e) === ww;
}, bw.isStrictMode = function (e) {
  return Rw(e) === xw;
}, bw.isSuspense = function (e) {
  return Rw(e) === Nw;
}, bw.isValidElementType = function (e) {
  return "string" == typeof e || "function" == typeof e || e === Bw || e === Mw || e === ww || e === xw || e === Nw || e === Sw || "object" == typeof e && null !== e && (e.$$typeof === Lw || e.$$typeof === Vw || e.$$typeof === Qw || e.$$typeof === Hw || e.$$typeof === kw || e.$$typeof === Ow || e.$$typeof === Tw || e.$$typeof === Dw || e.$$typeof === Pw);
}, bw.typeOf = Rw;
var Fw = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"production" !== process.env.NODE_ENV && function () {
  var e = "function" == typeof Symbol && Symbol.for,
    t = e ? Symbol.for("react.element") : 60103,
    n = e ? Symbol.for("react.portal") : 60106,
    r = e ? Symbol.for("react.fragment") : 60107,
    o = e ? Symbol.for("react.strict_mode") : 60108,
    i = e ? Symbol.for("react.profiler") : 60114,
    a = e ? Symbol.for("react.provider") : 60109,
    c = e ? Symbol.for("react.context") : 60110,
    s = e ? Symbol.for("react.async_mode") : 60111,
    l = e ? Symbol.for("react.concurrent_mode") : 60111,
    u = e ? Symbol.for("react.forward_ref") : 60112,
    d = e ? Symbol.for("react.suspense") : 60113,
    f = e ? Symbol.for("react.suspense_list") : 60120,
    p = e ? Symbol.for("react.memo") : 60115,
    m = e ? Symbol.for("react.lazy") : 60116,
    h = e ? Symbol.for("react.block") : 60121,
    A = e ? Symbol.for("react.fundamental") : 60117,
    g = e ? Symbol.for("react.responder") : 60118,
    v = e ? Symbol.for("react.scope") : 60119;
  function C(e) {
    if ("object" == typeof e && null !== e) {
      var f = e.$$typeof;
      switch (f) {
        case t:
          var h = e.type;
          switch (h) {
            case s:
            case l:
            case r:
            case i:
            case o:
            case d:
              return h;
            default:
              var A = h && h.$$typeof;
              switch (A) {
                case c:
                case u:
                case m:
                case p:
                case a:
                  return A;
                default:
                  return f;
              }
          }
        case n:
          return f;
      }
    }
  }
  var b = s,
    E = l,
    y = c,
    I = a,
    B = t,
    x = u,
    w = r,
    Q = m,
    H = p,
    z = n,
    M = i,
    k = o,
    N = d,
    S = !1;
  function V(e) {
    return C(e) === l;
  }
  Fw.AsyncMode = b, Fw.ConcurrentMode = E, Fw.ContextConsumer = y, Fw.ContextProvider = I, Fw.Element = B, Fw.ForwardRef = x, Fw.Fragment = w, Fw.Lazy = Q, Fw.Memo = H, Fw.Portal = z, Fw.Profiler = M, Fw.StrictMode = k, Fw.Suspense = N, Fw.isAsyncMode = function (e) {
    return S || (S = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), V(e) || C(e) === s;
  }, Fw.isConcurrentMode = V, Fw.isContextConsumer = function (e) {
    return C(e) === c;
  }, Fw.isContextProvider = function (e) {
    return C(e) === a;
  }, Fw.isElement = function (e) {
    return "object" == typeof e && null !== e && e.$$typeof === t;
  }, Fw.isForwardRef = function (e) {
    return C(e) === u;
  }, Fw.isFragment = function (e) {
    return C(e) === r;
  }, Fw.isLazy = function (e) {
    return C(e) === m;
  }, Fw.isMemo = function (e) {
    return C(e) === p;
  }, Fw.isPortal = function (e) {
    return C(e) === n;
  }, Fw.isProfiler = function (e) {
    return C(e) === i;
  }, Fw.isStrictMode = function (e) {
    return C(e) === o;
  }, Fw.isSuspense = function (e) {
    return C(e) === d;
  }, Fw.isValidElementType = function (e) {
    return "string" == typeof e || "function" == typeof e || e === r || e === l || e === i || e === o || e === d || e === f || "object" == typeof e && null !== e && (e.$$typeof === m || e.$$typeof === p || e.$$typeof === a || e.$$typeof === c || e.$$typeof === u || e.$$typeof === A || e.$$typeof === g || e.$$typeof === v || e.$$typeof === h);
  }, Fw.typeOf = C;
}(), "production" === process.env.NODE_ENV ? Cw.exports = bw : Cw.exports = Fw;
var jw = Cw.exports,
  Jw = {};
Jw[jw.ForwardRef] = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Jw[jw.Memo] = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
};
var Zw = "undefined" != typeof document;
function Ww(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function (n) {
    void 0 !== e[n] ? t.push(e[n] + ";") : r += n + " ";
  }), r;
}
var Xw = function (e, t, n) {
  var r = e.key + "-" + t.name;
  if ((!1 === n || !1 === Zw && void 0 !== e.compat) && void 0 === e.registered[r] && (e.registered[r] = t.styles), void 0 === e.inserted[t.name]) {
    var o = "",
      i = t;
    do {
      var a = e.insert(t === i ? "." + r : "", i, e.sheet, !0);
      Zw || void 0 === a || (o += a), i = i.next;
    } while (void 0 !== i);
    if (!Zw && 0 !== o.length) return o;
  }
};
var Uw = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function Kw(e) {
  var t = Object.create(null);
  return function (n) {
    return void 0 === t[n] && (t[n] = e(n)), t[n];
  };
}
var Yw = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences",
  qw = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).",
  _w = /[A-Z]|^ms/g,
  $w = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
  eQ = function (e) {
    return 45 === e.charCodeAt(1);
  },
  tQ = function (e) {
    return null != e && "boolean" != typeof e;
  },
  nQ = Kw(function (e) {
    return eQ(e) ? e : e.replace(_w, "-$&").toLowerCase();
  }),
  rQ = function (e, t) {
    switch (e) {
      case "animation":
      case "animationName":
        if ("string" == typeof t) return t.replace($w, function (e, t, n) {
          return fQ = {
            name: t,
            styles: n,
            next: fQ
          }, t;
        });
    }
    return 1 === Uw[e] || eQ(e) || "number" != typeof t || 0 === t ? t : t + "px";
  };
if ("production" !== process.env.NODE_ENV) {
  var oQ = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/,
    iQ = ["normal", "none", "initial", "inherit", "unset"],
    aQ = rQ,
    cQ = /^-ms-/,
    sQ = /-(.)/g,
    lQ = {};
  rQ = function (e, t) {
    if ("content" === e && ("string" != typeof t || -1 === iQ.indexOf(t) && !oQ.test(t) && (t.charAt(0) !== t.charAt(t.length - 1) || '"' !== t.charAt(0) && "'" !== t.charAt(0)))) throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + t + "\"'`");
    var n = aQ(e, t);
    return "" === n || eQ(e) || -1 === e.indexOf("-") || void 0 !== lQ[e] || (lQ[e] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + e.replace(cQ, "ms-").replace(sQ, function (e, t) {
      return t.toUpperCase();
    }) + "?")), n;
  };
}
function uQ(e, t, n) {
  if (null == n) return "";
  if (void 0 !== n.__emotion_styles) {
    if ("production" !== process.env.NODE_ENV && "NO_COMPONENT_SELECTOR" === n.toString()) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object":
      if (1 === n.anim) return fQ = {
        name: n.name,
        styles: n.styles,
        next: fQ
      }, n.name;
      if (void 0 !== n.styles) {
        var r = n.next;
        if (void 0 !== r) for (; void 0 !== r;) fQ = {
          name: r.name,
          styles: r.styles,
          next: fQ
        }, r = r.next;
        var o = n.styles + ";";
        return "production" !== process.env.NODE_ENV && void 0 !== n.map && (o += n.map), o;
      }
      return function (e, t, n) {
        var r = "";
        if (Array.isArray(n)) for (var o = 0; o < n.length; o++) r += uQ(e, t, n[o]) + ";";else for (var i in n) {
          var a = n[i];
          if ("object" != typeof a) null != t && void 0 !== t[a] ? r += i + "{" + t[a] + "}" : tQ(a) && (r += nQ(i) + ":" + rQ(i, a) + ";");else {
            if ("NO_COMPONENT_SELECTOR" === i && "production" !== process.env.NODE_ENV) throw new Error("Component selectors can only be used in conjunction with @emotion/babel-plugin.");
            if (!Array.isArray(a) || "string" != typeof a[0] || null != t && void 0 !== t[a[0]]) {
              var c = uQ(e, t, a);
              switch (i) {
                case "animation":
                case "animationName":
                  r += nQ(i) + ":" + c + ";";
                  break;
                default:
                  "production" !== process.env.NODE_ENV && "undefined" === i && console.error(qw), r += i + "{" + c + "}";
              }
            } else for (var s = 0; s < a.length; s++) tQ(a[s]) && (r += nQ(i) + ":" + rQ(i, a[s]) + ";");
          }
        }
        return r;
      }(e, t, n);
    case "function":
      if (void 0 !== e) {
        var i = fQ,
          a = n(e);
        return fQ = i, uQ(e, t, a);
      }
      "production" !== process.env.NODE_ENV && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    case "string":
      if ("production" !== process.env.NODE_ENV) {
        var c = [],
          s = n.replace($w, function (e, t, n) {
            var r = "animation" + c.length;
            return c.push("const " + r + " = keyframes`" + n.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + r + "}";
          });
        c.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(c, ["`" + s + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\ncss`" + s + "`");
      }
  }
  if (null == t) return n;
  var l = t[n];
  return void 0 !== l ? l : n;
}
var dQ,
  fQ,
  pQ = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
"production" !== process.env.NODE_ENV && (dQ = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var mQ = function (e, t, n) {
    if (1 === e.length && "object" == typeof e[0] && null !== e[0] && void 0 !== e[0].styles) return e[0];
    var r = !0,
      o = "";
    fQ = void 0;
    var i,
      a = e[0];
    null == a || void 0 === a.raw ? (r = !1, o += uQ(n, t, a)) : ("production" !== process.env.NODE_ENV && void 0 === a[0] && console.error(Yw), o += a[0]);
    for (var c = 1; c < e.length; c++) o += uQ(n, t, e[c]), r && ("production" !== process.env.NODE_ENV && void 0 === a[c] && console.error(Yw), o += a[c]);
    "production" !== process.env.NODE_ENV && (o = o.replace(dQ, function (e) {
      return i = e, "";
    })), pQ.lastIndex = 0;
    for (var s, l = ""; null !== (s = pQ.exec(o));) l += "-" + s[1];
    var u = function (e) {
      for (var t, n = 0, r = 0, o = e.length; o >= 4; ++r, o -= 4) t = 1540483477 * (65535 & (t = 255 & e.charCodeAt(r) | (255 & e.charCodeAt(++r)) << 8 | (255 & e.charCodeAt(++r)) << 16 | (255 & e.charCodeAt(++r)) << 24)) + (59797 * (t >>> 16) << 16), n = 1540483477 * (65535 & (t ^= t >>> 24)) + (59797 * (t >>> 16) << 16) ^ 1540483477 * (65535 & n) + (59797 * (n >>> 16) << 16);
      switch (o) {
        case 3:
          n ^= (255 & e.charCodeAt(r + 2)) << 16;
        case 2:
          n ^= (255 & e.charCodeAt(r + 1)) << 8;
        case 1:
          n = 1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) + (59797 * (n >>> 16) << 16);
      }
      return (((n = 1540483477 * (65535 & (n ^= n >>> 13)) + (59797 * (n >>> 16) << 16)) ^ n >>> 15) >>> 0).toString(36);
    }(o) + l;
    return "production" !== process.env.NODE_ENV ? {
      name: u,
      styles: o,
      map: i,
      next: fQ,
      toString: function () {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
      }
    } : {
      name: u,
      styles: o,
      next: fQ
    };
  },
  hQ = "undefined" != typeof document,
  AQ = {}.hasOwnProperty,
  gQ = /*#__PURE__*/d("undefined" != typeof HTMLElement ? vw({
    key: "css"
  }) : null);
"production" !== process.env.NODE_ENV && (gQ.displayName = "EmotionCacheContext"), gQ.Provider;
var vQ = function (e) {
  return /*#__PURE__*/c(function (t, n) {
    var r = u(gQ);
    return e(t, r, n);
  });
};
hQ || (vQ = function (e) {
  return function (t) {
    var n = u(gQ);
    return null === n ? (n = vw({
      key: "css"
    }), /*#__PURE__*/i(gQ.Provider, {
      value: n
    }, e(t, n))) : e(t, n);
  };
});
var CQ = /*#__PURE__*/d({});
"production" !== process.env.NODE_ENV && (CQ.displayName = "EmotionThemeContext");
var bQ = function (e) {
    var t = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(e);
    if (t) {
      var n = t[1].split(".");
      return n[n.length - 1];
    }
    if (t = /^([A-Za-z0-9$.]+)@/.exec(e)) return t[1];
  },
  EQ = new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]),
  yQ = function (e) {
    return e.replace(/\$/g, "-");
  },
  IQ = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__",
  BQ = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__",
  xQ = function (e, t) {
    if ("production" !== process.env.NODE_ENV && "string" == typeof t.css && -1 !== t.css.indexOf(":")) throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + t.css + "`");
    var n = {};
    for (var r in t) AQ.call(t, r) && (n[r] = t[r]);
    if (n[IQ] = e, "production" !== process.env.NODE_ENV && t.css && ("object" != typeof t.css || "string" != typeof t.css.name || -1 === t.css.name.indexOf("-"))) {
      var o = function (e) {
        if (e) for (var t = e.split("\n"), n = 0; n < t.length; n++) {
          var r = bQ(t[n]);
          if (r) {
            if (EQ.has(r)) break;
            if (/^[A-Z]/.test(r)) return yQ(r);
          }
        }
      }(new Error().stack);
      o && (n[BQ] = o);
    }
    return n;
  },
  wQ = function () {
    return null;
  },
  QQ = vQ(function (e, t, n) {
    var r = e.css;
    "string" == typeof r && void 0 !== t.registered[r] && (r = t.registered[r]);
    var o = e[IQ],
      a = [r],
      c = "";
    "string" == typeof e.className ? c = Ww(t.registered, a, e.className) : null != e.className && (c = e.className + " ");
    var s = mQ(a, void 0, u(CQ));
    if ("production" !== process.env.NODE_ENV && -1 === s.name.indexOf("-")) {
      var l = e[BQ];
      l && (s = mQ([s, "label:" + l + ";"]));
    }
    var d = Xw(t, s, "string" == typeof o);
    c += t.key + "-" + s.name;
    var p = {};
    for (var m in e) !AQ.call(e, m) || "css" === m || m === IQ || "production" !== process.env.NODE_ENV && m === BQ || (p[m] = e[m]);
    p.ref = n, p.className = c;
    var h = /*#__PURE__*/i(o, p),
      A = /*#__PURE__*/i(wQ, null);
    if (!hQ && void 0 !== d) {
      for (var g, v = s.name, C = s.next; void 0 !== C;) v += " " + C.name, C = C.next;
      A = /*#__PURE__*/i("style", ((g = {})["data-emotion"] = t.key + " " + v, g.dangerouslySetInnerHTML = {
        __html: d
      }, g.nonce = t.sheet.nonce, g));
    }
    return /*#__PURE__*/i(f, null, A, h);
  });
"production" !== process.env.NODE_ENV && (QQ.displayName = "EmotionCssPropInternal");
var HQ = function () {
    function e(e) {
      var t = this;
      this._insertTag = function (e) {
        var n;
        n = 0 === t.tags.length ? t.insertionPoint ? t.insertionPoint.nextSibling : t.prepend ? t.container.firstChild : t.before : t.tags[t.tags.length - 1].nextSibling, t.container.insertBefore(e, n), t.tags.push(e);
      }, this.isSpeedy = void 0 === e.speedy ? "production" === process.env.NODE_ENV : e.speedy, this.tags = [], this.ctr = 0, this.nonce = e.nonce, this.key = e.key, this.container = e.container, this.prepend = e.prepend, this.insertionPoint = e.insertionPoint, this.before = null;
    }
    var t = e.prototype;
    return t.hydrate = function (e) {
      e.forEach(this._insertTag);
    }, t.insert = function (e) {
      this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 && this._insertTag(function (e) {
        var t = document.createElement("style");
        return t.setAttribute("data-emotion", e.key), void 0 !== e.nonce && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
      }(this));
      var t = this.tags[this.tags.length - 1];
      if ("production" !== process.env.NODE_ENV) {
        var n = 64 === e.charCodeAt(0) && 105 === e.charCodeAt(1);
        n && this._alreadyInsertedOrderInsensitiveRule && console.error("You're attempting to insert the following rule:\n" + e + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !n;
      }
      if (this.isSpeedy) {
        var r = function (e) {
          if (e.sheet) return e.sheet;
          for (var t = 0; t < document.styleSheets.length; t++) if (document.styleSheets[t].ownerNode === e) return document.styleSheets[t];
        }(t);
        try {
          r.insertRule(e, r.cssRules.length);
        } catch (t) {
          "production" === process.env.NODE_ENV || /:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear){/.test(e) || console.error('There was a problem inserting the following rule: "' + e + '"', t);
        }
      } else t.appendChild(document.createTextNode(e));
      this.ctr++;
    }, t.flush = function () {
      this.tags.forEach(function (e) {
        return e.parentNode && e.parentNode.removeChild(e);
      }), this.tags = [], this.ctr = 0, "production" !== process.env.NODE_ENV && (this._alreadyInsertedOrderInsensitiveRule = !1);
    }, e;
  }(),
  zQ = function (e, t) {
    var n = arguments;
    if (null == t || !AQ.call(t, "css")) return i.apply(void 0, n);
    var r = n.length,
      o = new Array(r);
    o[0] = QQ, o[1] = xQ(e, t);
    for (var a = 2; a < r; a++) o[a] = n[a];
    return i.apply(null, o);
  },
  MQ = !1,
  kQ = vQ(function (e, t) {
    "production" === process.env.NODE_ENV || MQ || !e.className && !e.css || (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), MQ = !0);
    var n = e.styles,
      r = mQ([n], void 0, u(CQ));
    if (!hQ) {
      for (var a, c = r.name, s = r.styles, l = r.next; void 0 !== l;) c += " " + l.name, s += l.styles, l = l.next;
      var d = !0 === t.compat,
        f = t.insert("", {
          name: c,
          styles: s
        }, t.sheet, d);
      return d ? null : /*#__PURE__*/i("style", ((a = {})["data-emotion"] = t.key + "-global " + c, a.dangerouslySetInnerHTML = {
        __html: f
      }, a.nonce = t.sheet.nonce, a));
    }
    var m = o();
    return p(function () {
      var e = t.key + "-global",
        n = new HQ({
          key: e,
          nonce: t.sheet.nonce,
          container: t.sheet.container,
          speedy: t.sheet.isSpeedy
        }),
        o = !1,
        i = document.querySelector('style[data-emotion="' + e + " " + r.name + '"]');
      return t.sheet.tags.length && (n.before = t.sheet.tags[0]), null !== i && (o = !0, i.setAttribute("data-emotion", e), n.hydrate([i])), m.current = [n, o], function () {
        n.flush();
      };
    }, [t]), p(function () {
      var e = m.current,
        n = e[0];
      if (e[1]) e[1] = !1;else {
        if (void 0 !== r.next && Xw(t, r.next, !0), n.tags.length) {
          var o = n.tags[n.tags.length - 1].nextElementSibling;
          n.before = o, n.flush();
        }
        t.insert("", r, n, !1);
      }
    }, [t, r.name]), null;
  });
function NQ() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return mQ(t);
}
"production" !== process.env.NODE_ENV && (kQ.displayName = "EmotionGlobal");
var SQ = function e(t) {
  for (var n = t.length, r = 0, o = ""; r < n; r++) {
    var i = t[r];
    if (null != i) {
      var a = void 0;
      switch (typeof i) {
        case "boolean":
          break;
        case "object":
          if (Array.isArray(i)) a = e(i);else for (var c in "production" !== process.env.NODE_ENV && void 0 !== i.styles && void 0 !== i.name && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), a = "", i) i[c] && c && (a && (a += " "), a += c);
          break;
        default:
          a = i;
      }
      a && (o && (o += " "), o += a);
    }
  }
  return o;
};
function VQ(e, t, n) {
  var r = [],
    o = Ww(e, r, n);
  return r.length < 2 ? n : o + t(r);
}
var LQ = function () {
    return null;
  },
  PQ = vQ(function (e, t) {
    var n = "",
      r = "",
      o = !1,
      a = function () {
        if (o && "production" !== process.env.NODE_ENV) throw new Error("css can only be used during render");
        for (var e = arguments.length, i = new Array(e), a = 0; a < e; a++) i[a] = arguments[a];
        var c = mQ(i, t.registered);
        if (hQ) Xw(t, c, !1);else {
          var s = Xw(t, c, !1);
          void 0 !== s && (n += s);
        }
        return hQ || (r += " " + c.name), t.key + "-" + c.name;
      },
      c = {
        css: a,
        cx: function () {
          if (o && "production" !== process.env.NODE_ENV) throw new Error("cx can only be used during render");
          for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
          return VQ(t.registered, a, SQ(n));
        },
        theme: u(CQ)
      },
      s = e.children(c);
    o = !0;
    var l,
      d = /*#__PURE__*/i(LQ, null);
    hQ || 0 === n.length || (d = /*#__PURE__*/i("style", ((l = {})["data-emotion"] = t.key + " " + r.substring(1), l.dangerouslySetInnerHTML = {
      __html: n
    }, l.nonce = t.sheet.nonce, l)));
    return /*#__PURE__*/i(f, null, d, s);
  });
if ("production" !== process.env.NODE_ENV && (PQ.displayName = "EmotionClassNames"), "production" !== process.env.NODE_ENV) {
  var OQ = "undefined" != typeof document,
    TQ = "undefined" != typeof jest;
  if (OQ && !TQ) {
    var DQ = "undefined" != typeof globalThis ? globalThis : OQ ? window : global,
      RQ = "__EMOTION_REACT_" + "11.7.1".split(".")[0] + "__";
    DQ[RQ] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), DQ[RQ] = !0;
  }
}
function GQ(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = {},
    i = Object.keys(e);
  for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}
function FQ(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = GQ(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function jQ(e) {
  return jQ = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jQ(e);
}
function JQ(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function ZQ(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function WQ(e, t, n) {
  return t && ZQ(e.prototype, t), n && ZQ(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function XQ(e, t) {
  return XQ = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  }, XQ(e, t);
}
function UQ(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  Object.defineProperty(e, "prototype", {
    value: Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }),
    writable: !1
  }), t && XQ(e, t);
}
function KQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function YQ(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function qQ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function _Q(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? qQ(Object(n), !0).forEach(function (t) {
      YQ(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : qQ(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function $Q(e) {
  return $Q = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, $Q(e);
}
function eH(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? function (e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }(e) : t;
}
function tH(e) {
  var t = function () {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }();
  return function () {
    var n,
      r = $Q(e);
    if (t) {
      var o = $Q(this).constructor;
      n = Reflect.construct(r, arguments, o);
    } else n = r.apply(this, arguments);
    return eH(this, n);
  };
}
var nH = ["className", "clearValue", "cx", "getStyles", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"],
  rH = function () {};
function oH(e, t) {
  return t ? "-" === t[0] ? e + t : e + "__" + t : e;
}
function iH(e, t, n) {
  var r = [n];
  if (t && e) for (var o in t) t.hasOwnProperty(o) && t[o] && r.push("".concat(oH(e, o)));
  return r.filter(function (e) {
    return e;
  }).map(function (e) {
    return String(e).trim();
  }).join(" ");
}
var aH = function (e) {
    return t = e, Array.isArray(t) ? e.filter(Boolean) : "object" === jQ(e) && null !== e ? [e] : [];
    var t;
  },
  cH = function (e) {
    return e.className, e.clearValue, e.cx, e.getStyles, e.getValue, e.hasValue, e.isMulti, e.isRtl, e.options, e.selectOption, e.selectProps, e.setValue, e.theme, _Q({}, FQ(e, nH));
  };
function sH(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function lH(e) {
  return sH(e) ? window.pageYOffset : e.scrollTop;
}
function uH(e, t) {
  sH(e) ? window.scrollTo(0, t) : e.scrollTop = t;
}
function dH(e, t, n, r) {
  return n * ((e = e / r - 1) * e * e + 1) + t;
}
function fH(e, t) {
  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 200,
    r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : rH,
    o = lH(e),
    i = t - o,
    a = 10,
    c = 0;
  function s() {
    var t = dH(c += a, o, i, n);
    uH(e, t), c < n ? window.requestAnimationFrame(s) : r(e);
  }
  s();
}
function pH() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch (e) {
    return !1;
  }
}
var mH = !1,
  hH = {
    get passive() {
      return mH = !0;
    }
  },
  AH = "undefined" != typeof window ? window : {};
AH.addEventListener && AH.removeEventListener && (AH.addEventListener("p", rH, hH), AH.removeEventListener("p", rH, !1));
var gH = mH;
function vH(e) {
  return null != e;
}
function CH(e, t, n) {
  return e ? t : n;
}
function bH(e) {
  var t = e.maxHeight,
    n = e.menuEl,
    r = e.minHeight,
    o = e.placement,
    i = e.shouldScroll,
    a = e.isFixedPosition,
    c = e.theme.spacing,
    s = function (e) {
      var t = getComputedStyle(e),
        n = "absolute" === t.position,
        r = /(auto|scroll)/;
      if ("fixed" === t.position) return document.documentElement;
      for (var o = e; o = o.parentElement;) if (t = getComputedStyle(o), (!n || "static" !== t.position) && r.test(t.overflow + t.overflowY + t.overflowX)) return o;
      return document.documentElement;
    }(n),
    l = {
      placement: "bottom",
      maxHeight: t
    };
  if (!n || !n.offsetParent) return l;
  var u = s.getBoundingClientRect().height,
    d = n.getBoundingClientRect(),
    f = d.bottom,
    p = d.height,
    m = d.top,
    h = n.offsetParent.getBoundingClientRect().top,
    A = window.innerHeight,
    g = lH(s),
    v = parseInt(getComputedStyle(n).marginBottom, 10),
    C = parseInt(getComputedStyle(n).marginTop, 10),
    b = h - C,
    E = A - m,
    y = b + g,
    I = u - g - m,
    B = f - A + g + v,
    x = g + m - C,
    w = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (E >= p) return {
        placement: "bottom",
        maxHeight: t
      };
      if (I >= p && !a) return i && fH(s, B, w), {
        placement: "bottom",
        maxHeight: t
      };
      if (!a && I >= r || a && E >= r) return i && fH(s, B, w), {
        placement: "bottom",
        maxHeight: a ? E - v : I - v
      };
      if ("auto" === o || a) {
        var Q = t,
          H = a ? b : y;
        return H >= r && (Q = Math.min(H - v - c.controlHeight, t)), {
          placement: "top",
          maxHeight: Q
        };
      }
      if ("bottom" === o) return i && uH(s, B), {
        placement: "bottom",
        maxHeight: t
      };
      break;
    case "top":
      if (b >= p) return {
        placement: "top",
        maxHeight: t
      };
      if (y >= p && !a) return i && fH(s, x, w), {
        placement: "top",
        maxHeight: t
      };
      if (!a && y >= r || a && b >= r) {
        var z = t;
        return (!a && y >= r || a && b >= r) && (z = a ? b - C : y - C), i && fH(s, x, w), {
          placement: "top",
          maxHeight: z
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return l;
}
var EH = function (e) {
    return "auto" === e ? "bottom" : e;
  },
  yH = /*#__PURE__*/d({
    getPortalPlacement: null
  }),
  IH = function (e) {
    UQ(n, a);
    var t = tH(n);
    function n() {
      var e;
      JQ(this, n);
      for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];
      return (e = t.call.apply(t, [this].concat(o))).state = {
        maxHeight: e.props.maxMenuHeight,
        placement: null
      }, e.context = void 0, e.getPlacement = function (t) {
        var n = e.props,
          r = n.minMenuHeight,
          o = n.maxMenuHeight,
          i = n.menuPlacement,
          a = n.menuPosition,
          c = n.menuShouldScrollIntoView,
          s = n.theme;
        if (t) {
          var l = "fixed" === a,
            u = bH({
              maxHeight: o,
              menuEl: t,
              minHeight: r,
              placement: i,
              shouldScroll: c && !l,
              isFixedPosition: l,
              theme: s
            }),
            d = e.context.getPortalPlacement;
          d && d(u), e.setState(u);
        }
      }, e.getUpdatedProps = function () {
        var t = e.props.menuPlacement,
          n = e.state.placement || EH(t);
        return _Q(_Q({}, e.props), {}, {
          placement: n,
          maxHeight: e.state.maxHeight
        });
      }, e;
    }
    return WQ(n, [{
      key: "render",
      value: function () {
        return (0, this.props.children)({
          ref: this.getPlacement,
          placerProps: this.getUpdatedProps()
        });
      }
    }]), n;
  }();
IH.contextType = yH;
var BH = function (e) {
    var t = e.theme,
      n = t.spacing.baseUnit;
    return {
      color: t.colors.neutral40,
      padding: "".concat(2 * n, "px ").concat(3 * n, "px"),
      textAlign: "center"
    };
  },
  xH = BH,
  wH = BH,
  QH = function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerProps;
    return zQ("div", mx({
      css: o("noOptionsMessage", e),
      className: r({
        "menu-notice": !0,
        "menu-notice--no-options": !0
      }, n)
    }, i), t);
  };
QH.defaultProps = {
  children: "No options"
};
var HH = function (e) {
  var t = e.children,
    n = e.className,
    r = e.cx,
    o = e.getStyles,
    i = e.innerProps;
  return zQ("div", mx({
    css: o("loadingMessage", e),
    className: r({
      "menu-notice": !0,
      "menu-notice--loading": !0
    }, n)
  }, i), t);
};
HH.defaultProps = {
  children: "Loading..."
};
var zH,
  MH = function (e) {
    UQ(n, a);
    var t = tH(n);
    function n() {
      var e;
      JQ(this, n);
      for (var r = arguments.length, o = new Array(r), i = 0; i < r; i++) o[i] = arguments[i];
      return (e = t.call.apply(t, [this].concat(o))).state = {
        placement: null
      }, e.getPortalPlacement = function (t) {
        var n = t.placement;
        n !== EH(e.props.menuPlacement) && e.setState({
          placement: n
        });
      }, e;
    }
    return WQ(n, [{
      key: "render",
      value: function () {
        var e = this.props,
          t = e.appendTo,
          n = e.children,
          r = e.className,
          o = e.controlElement,
          i = e.cx,
          a = e.innerProps,
          c = e.menuPlacement,
          s = e.menuPosition,
          l = e.getStyles,
          u = "fixed" === s;
        if (!t && !u || !o) return null;
        var d = this.state.placement || EH(c),
          f = function (e) {
            var t = e.getBoundingClientRect();
            return {
              bottom: t.bottom,
              height: t.height,
              left: t.left,
              right: t.right,
              top: t.top,
              width: t.width
            };
          }(o),
          p = u ? 0 : window.pageYOffset,
          m = f[d] + p,
          h = zQ("div", mx({
            css: l("menuPortal", {
              offset: m,
              position: s,
              rect: f
            }),
            className: i({
              "menu-portal": !0
            }, r)
          }, a), n);
        return zQ(yH.Provider, {
          value: {
            getPortalPlacement: this.getPortalPlacement
          }
        }, t ? /*#__PURE__*/B(h, t) : h);
      }
    }]), n;
  }(),
  kH = ["size"];
var NH,
  SH,
  VH = "production" === process.env.NODE_ENV ? {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
  } : {
    name: "tj5bde-Svg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGljYXRvcnMudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXdCSSIsImZpbGUiOiJpbmRpY2F0b3JzLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVhY3ROb2RlIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4LCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmltcG9ydCB7XG4gIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lLFxuICBDU1NPYmplY3RXaXRoTGFiZWwsXG4gIEdyb3VwQmFzZSxcbn0gZnJvbSAnLi4vdHlwZXMnO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgSWNvbnNcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5jb25zdCBTdmcgPSAoe1xuICBzaXplLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzdmcnXSAmIHsgc2l6ZTogbnVtYmVyIH0pID0+IChcbiAgPHN2Z1xuICAgIGhlaWdodD17c2l6ZX1cbiAgICB3aWR0aD17c2l6ZX1cbiAgICB2aWV3Qm94PVwiMCAwIDIwIDIwXCJcbiAgICBhcmlhLWhpZGRlbj1cInRydWVcIlxuICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICBjc3M9e3tcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgZmlsbDogJ2N1cnJlbnRDb2xvcicsXG4gICAgICBsaW5lSGVpZ2h0OiAxLFxuICAgICAgc3Ryb2tlOiAnY3VycmVudENvbG9yJyxcbiAgICAgIHN0cm9rZVdpZHRoOiAwLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IHR5cGUgQ3Jvc3NJY29uUHJvcHMgPSBKU1guSW50cmluc2ljRWxlbWVudHNbJ3N2ZyddICYgeyBzaXplPzogbnVtYmVyIH07XG5leHBvcnQgY29uc3QgQ3Jvc3NJY29uID0gKHByb3BzOiBDcm9zc0ljb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNMTQuMzQ4IDE0Ljg0OWMtMC40NjkgMC40NjktMS4yMjkgMC40NjktMS42OTcgMGwtMi42NTEtMy4wMzAtMi42NTEgMy4wMjljLTAuNDY5IDAuNDY5LTEuMjI5IDAuNDY5LTEuNjk3IDAtMC40NjktMC40NjktMC40NjktMS4yMjkgMC0xLjY5N2wyLjc1OC0zLjE1LTIuNzU5LTMuMTUyYy0wLjQ2OS0wLjQ2OS0wLjQ2OS0xLjIyOCAwLTEuNjk3czEuMjI4LTAuNDY5IDEuNjk3IDBsMi42NTIgMy4wMzEgMi42NTEtMy4wMzFjMC40NjktMC40NjkgMS4yMjgtMC40NjkgMS42OTcgMHMwLjQ2OSAxLjIyOSAwIDEuNjk3bC0yLjc1OCAzLjE1MiAyLjc1OCAzLjE1YzAuNDY5IDAuNDY5IDAuNDY5IDEuMjI5IDAgMS42OTh6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuZXhwb3J0IHR5cGUgRG93bkNoZXZyb25Qcm9wcyA9IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snc3ZnJ10gJiB7IHNpemU/OiBudW1iZXIgfTtcbmV4cG9ydCBjb25zdCBEb3duQ2hldnJvbiA9IChwcm9wczogRG93bkNoZXZyb25Qcm9wcykgPT4gKFxuICA8U3ZnIHNpemU9ezIwfSB7Li4ucHJvcHN9PlxuICAgIDxwYXRoIGQ9XCJNNC41MTYgNy41NDhjMC40MzYtMC40NDYgMS4wNDMtMC40ODEgMS41NzYgMGwzLjkwOCAzLjc0NyAzLjkwOC0zLjc0N2MwLjUzMy0wLjQ4MSAxLjE0MS0wLjQ0NiAxLjU3NCAwIDAuNDM2IDAuNDQ1IDAuNDA4IDEuMTk3IDAgMS42MTUtMC40MDYgMC40MTgtNC42OTUgNC41MDItNC42OTUgNC41MDItMC4yMTcgMC4yMjMtMC41MDIgMC4zMzUtMC43ODcgMC4zMzVzLTAuNTctMC4xMTItMC43ODktMC4zMzVjMCAwLTQuMjg3LTQuMDg0LTQuNjk1LTQuNTAycy0wLjQzNi0xLjE3IDAtMS42MTV6XCIgLz5cbiAgPC9Tdmc+XG4pO1xuXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cbi8vIERyb3Bkb3duICYgQ2xlYXIgQnV0dG9uc1xuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG5cbmV4cG9ydCBpbnRlcmZhY2UgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxcbiAgT3B0aW9uID0gdW5rbm93bixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4gPSBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+ID0gR3JvdXBCYXNlPE9wdGlvbj5cbj4gZXh0ZW5kcyBDb21tb25Qcm9wc0FuZENsYXNzTmFtZTxPcHRpb24sIElzTXVsdGksIEdyb3VwPiB7XG4gIC8qKiBUaGUgY2hpbGRyZW4gdG8gYmUgcmVuZGVyZWQgaW5zaWRlIHRoZSBpbmRpY2F0b3IuICovXG4gIGNoaWxkcmVuPzogUmVhY3ROb2RlO1xuICAvKiogUHJvcHMgdGhhdCB3aWxsIGJlIHBhc3NlZCBvbiB0byB0aGUgY2hpbGRyZW4uICovXG4gIGlubmVyUHJvcHM6IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snZGl2J107XG4gIC8qKiBUaGUgZm9jdXNlZCBzdGF0ZSBvZiB0aGUgc2VsZWN0LiAqL1xuICBpc0ZvY3VzZWQ6IGJvb2xlYW47XG4gIGlzRGlzYWJsZWQ6IGJvb2xlYW47XG59XG5cbmNvbnN0IGJhc2VDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oe1xuICBpc0ZvY3VzZWQsXG4gIHRoZW1lOiB7XG4gICAgc3BhY2luZzogeyBiYXNlVW5pdCB9LFxuICAgIGNvbG9ycyxcbiAgfSxcbn06XG4gIHwgRHJvcGRvd25JbmRpY2F0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPlxuICB8IENsZWFySW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdpbmRpY2F0b3JDb250YWluZXInLFxuICBjb2xvcjogaXNGb2N1c2VkID8gY29sb3JzLm5ldXRyYWw2MCA6IGNvbG9ycy5uZXV0cmFsMjAsXG4gIGRpc3BsYXk6ICdmbGV4JyxcbiAgcGFkZGluZzogYmFzZVVuaXQgKiAyLFxuICB0cmFuc2l0aW9uOiAnY29sb3IgMTUwbXMnLFxuXG4gICc6aG92ZXInOiB7XG4gICAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsODAgOiBjb2xvcnMubmV1dHJhbDQwLFxuICB9LFxufSk7XG5cbmV4cG9ydCBjb25zdCBkcm9wZG93bkluZGljYXRvckNTUyA9IGJhc2VDU1M7XG5leHBvcnQgY29uc3QgRHJvcGRvd25JbmRpY2F0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHByb3BzOiBEcm9wZG93bkluZGljYXRvclByb3BzPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+XG4pID0+IHtcbiAgY29uc3QgeyBjaGlsZHJlbiwgY2xhc3NOYW1lLCBjeCwgZ2V0U3R5bGVzLCBpbm5lclByb3BzIH0gPSBwcm9wcztcbiAgcmV0dXJuIChcbiAgICA8ZGl2XG4gICAgICBjc3M9e2dldFN0eWxlcygnZHJvcGRvd25JbmRpY2F0b3InLCBwcm9wcyl9XG4gICAgICBjbGFzc05hbWU9e2N4KFxuICAgICAgICB7XG4gICAgICAgICAgaW5kaWNhdG9yOiB0cnVlLFxuICAgICAgICAgICdkcm9wZG93bi1pbmRpY2F0b3InOiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICBjbGFzc05hbWVcbiAgICAgICl9XG4gICAgICB7Li4uaW5uZXJQcm9wc31cbiAgICA+XG4gICAgICB7Y2hpbGRyZW4gfHwgPERvd25DaGV2cm9uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuZXhwb3J0IGludGVyZmFjZSBDbGVhckluZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFRoZSBjaGlsZHJlbiB0byBiZSByZW5kZXJlZCBpbnNpZGUgdGhlIGluZGljYXRvci4gKi9cbiAgY2hpbGRyZW4/OiBSZWFjdE5vZGU7XG4gIC8qKiBQcm9wcyB0aGF0IHdpbGwgYmUgcGFzc2VkIG9uIHRvIHRoZSBjaGlsZHJlbi4gKi9cbiAgaW5uZXJQcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydkaXYnXTtcbiAgLyoqIFRoZSBmb2N1c2VkIHN0YXRlIG9mIHRoZSBzZWxlY3QuICovXG4gIGlzRm9jdXNlZDogYm9vbGVhbjtcbn1cblxuZXhwb3J0IGNvbnN0IGNsZWFySW5kaWNhdG9yQ1NTID0gYmFzZUNTUztcbmV4cG9ydCBjb25zdCBDbGVhckluZGljYXRvciA9IDxcbiAgT3B0aW9uLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbixcbiAgR3JvdXAgZXh0ZW5kcyBHcm91cEJhc2U8T3B0aW9uPlxuPihcbiAgcHJvcHM6IENsZWFySW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNoaWxkcmVuLCBjbGFzc05hbWUsIGN4LCBnZXRTdHlsZXMsIGlubmVyUHJvcHMgfSA9IHByb3BzO1xuICByZXR1cm4gKFxuICAgIDxkaXZcbiAgICAgIGNzcz17Z2V0U3R5bGVzKCdjbGVhckluZGljYXRvcicsIHByb3BzKX1cbiAgICAgIGNsYXNzTmFtZT17Y3goXG4gICAgICAgIHtcbiAgICAgICAgICBpbmRpY2F0b3I6IHRydWUsXG4gICAgICAgICAgJ2NsZWFyLWluZGljYXRvcic6IHRydWUsXG4gICAgICAgIH0sXG4gICAgICAgIGNsYXNzTmFtZVxuICAgICAgKX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIHtjaGlsZHJlbiB8fCA8Q3Jvc3NJY29uIC8+fVxuICAgIDwvZGl2PlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBTZXBhcmF0b3Jcbi8vID09PT09PT09PT09PT09PT09PT09PT09PT09PT09PVxuXG5leHBvcnQgaW50ZXJmYWNlIEluZGljYXRvclNlcGFyYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgaXNEaXNhYmxlZDogYm9vbGVhbjtcbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpbm5lclByb3BzPzogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ107XG59XG5cbmV4cG9ydCBjb25zdCBpbmRpY2F0b3JTZXBhcmF0b3JDU1MgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oe1xuICBpc0Rpc2FibGVkLFxuICB0aGVtZToge1xuICAgIHNwYWNpbmc6IHsgYmFzZVVuaXQgfSxcbiAgICBjb2xvcnMsXG4gIH0sXG59OiBJbmRpY2F0b3JTZXBhcmF0b3JQcm9wczxPcHRpb24sIElzTXVsdGksIEdyb3VwPik6IENTU09iamVjdFdpdGhMYWJlbCA9PiAoe1xuICBsYWJlbDogJ2luZGljYXRvclNlcGFyYXRvcicsXG4gIGFsaWduU2VsZjogJ3N0cmV0Y2gnLFxuICBiYWNrZ3JvdW5kQ29sb3I6IGlzRGlzYWJsZWQgPyBjb2xvcnMubmV1dHJhbDEwIDogY29sb3JzLm5ldXRyYWwyMCxcbiAgbWFyZ2luQm90dG9tOiBiYXNlVW5pdCAqIDIsXG4gIG1hcmdpblRvcDogYmFzZVVuaXQgKiAyLFxuICB3aWR0aDogMSxcbn0pO1xuXG5leHBvcnQgY29uc3QgSW5kaWNhdG9yU2VwYXJhdG9yID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KFxuICBwcm9wczogSW5kaWNhdG9yU2VwYXJhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY3gsIGdldFN0eWxlcywgaW5uZXJQcm9wcyB9ID0gcHJvcHM7XG4gIHJldHVybiAoXG4gICAgPHNwYW5cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2luZGljYXRvclNlcGFyYXRvcicsIHByb3BzKX1cbiAgICAgIGNsYXNzTmFtZT17Y3goeyAnaW5kaWNhdG9yLXNlcGFyYXRvcic6IHRydWUgfSwgY2xhc3NOYW1lKX1cbiAgICAvPlxuICApO1xufTtcblxuLy8gPT09PT09PT09PT09PT09PT09PT09PT09PT09PT09XG4vLyBMb2FkaW5nXG4vLyA9PT09PT09PT09PT09PT09PT09PT09PT09PT09PT1cblxuY29uc3QgbG9hZGluZ0RvdEFuaW1hdGlvbnMgPSBrZXlmcmFtZXNgXG4gIDAlLCA4MCUsIDEwMCUgeyBvcGFjaXR5OiAwOyB9XG4gIDQwJSB7IG9wYWNpdHk6IDE7IH1cbmA7XG5cbmV4cG9ydCBjb25zdCBsb2FkaW5nSW5kaWNhdG9yQ1NTID0gPFxuICBPcHRpb24sXG4gIElzTXVsdGkgZXh0ZW5kcyBib29sZWFuLFxuICBHcm91cCBleHRlbmRzIEdyb3VwQmFzZTxPcHRpb24+XG4+KHtcbiAgaXNGb2N1c2VkLFxuICBzaXplLFxuICB0aGVtZToge1xuICAgIGNvbG9ycyxcbiAgICBzcGFjaW5nOiB7IGJhc2VVbml0IH0sXG4gIH0sXG59OiBMb2FkaW5nSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD4pOiBDU1NPYmplY3RXaXRoTGFiZWwgPT4gKHtcbiAgbGFiZWw6ICdsb2FkaW5nSW5kaWNhdG9yJyxcbiAgY29sb3I6IGlzRm9jdXNlZCA/IGNvbG9ycy5uZXV0cmFsNjAgOiBjb2xvcnMubmV1dHJhbDIwLFxuICBkaXNwbGF5OiAnZmxleCcsXG4gIHBhZGRpbmc6IGJhc2VVbml0ICogMixcbiAgdHJhbnNpdGlvbjogJ2NvbG9yIDE1MG1zJyxcbiAgYWxpZ25TZWxmOiAnY2VudGVyJyxcbiAgZm9udFNpemU6IHNpemUsXG4gIGxpbmVIZWlnaHQ6IDEsXG4gIG1hcmdpblJpZ2h0OiBzaXplLFxuICB0ZXh0QWxpZ246ICdjZW50ZXInLFxuICB2ZXJ0aWNhbEFsaWduOiAnbWlkZGxlJyxcbn0pO1xuXG5pbnRlcmZhY2UgTG9hZGluZ0RvdFByb3BzIHtcbiAgZGVsYXk6IG51bWJlcjtcbiAgb2Zmc2V0OiBib29sZWFuO1xufVxuY29uc3QgTG9hZGluZ0RvdCA9ICh7IGRlbGF5LCBvZmZzZXQgfTogTG9hZGluZ0RvdFByb3BzKSA9PiAoXG4gIDxzcGFuXG4gICAgY3NzPXt7XG4gICAgICBhbmltYXRpb246IGAke2xvYWRpbmdEb3RBbmltYXRpb25zfSAxcyBlYXNlLWluLW91dCAke2RlbGF5fW1zIGluZmluaXRlO2AsXG4gICAgICBiYWNrZ3JvdW5kQ29sb3I6ICdjdXJyZW50Q29sb3InLFxuICAgICAgYm9yZGVyUmFkaXVzOiAnMWVtJyxcbiAgICAgIGRpc3BsYXk6ICdpbmxpbmUtYmxvY2snLFxuICAgICAgbWFyZ2luTGVmdDogb2Zmc2V0ID8gJzFlbScgOiB1bmRlZmluZWQsXG4gICAgICBoZWlnaHQ6ICcxZW0nLFxuICAgICAgdmVydGljYWxBbGlnbjogJ3RvcCcsXG4gICAgICB3aWR0aDogJzFlbScsXG4gICAgfX1cbiAgLz5cbik7XG5cbmV4cG9ydCBpbnRlcmZhY2UgTG9hZGluZ0luZGljYXRvclByb3BzPFxuICBPcHRpb24gPSB1bmtub3duLFxuICBJc011bHRpIGV4dGVuZHMgYm9vbGVhbiA9IGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj4gPSBHcm91cEJhc2U8T3B0aW9uPlxuPiBleHRlbmRzIENvbW1vblByb3BzQW5kQ2xhc3NOYW1lPE9wdGlvbiwgSXNNdWx0aSwgR3JvdXA+IHtcbiAgLyoqIFByb3BzIHRoYXQgd2lsbCBiZSBwYXNzZWQgb24gdG8gdGhlIGNoaWxkcmVuLiAqL1xuICBpbm5lclByb3BzOiBKU1guSW50cmluc2ljRWxlbWVudHNbJ2RpdiddO1xuICAvKiogVGhlIGZvY3VzZWQgc3RhdGUgb2YgdGhlIHNlbGVjdC4gKi9cbiAgaXNGb2N1c2VkOiBib29sZWFuO1xuICBpc0Rpc2FibGVkOiBib29sZWFuO1xuICAvKiogU2V0IHNpemUgb2YgdGhlIGNvbnRhaW5lci4gKi9cbiAgc2l6ZTogbnVtYmVyO1xufVxuZXhwb3J0IGNvbnN0IExvYWRpbmdJbmRpY2F0b3IgPSA8XG4gIE9wdGlvbixcbiAgSXNNdWx0aSBleHRlbmRzIGJvb2xlYW4sXG4gIEdyb3VwIGV4dGVuZHMgR3JvdXBCYXNlPE9wdGlvbj5cbj4oXG4gIHByb3BzOiBMb2FkaW5nSW5kaWNhdG9yUHJvcHM8T3B0aW9uLCBJc011bHRpLCBHcm91cD5cbikgPT4ge1xuICBjb25zdCB7IGNsYXNzTmFtZSwgY3gsIGdldFN0eWxlcywgaW5uZXJQcm9wcywgaXNSdGwgfSA9IHByb3BzO1xuXG4gIHJldHVybiAoXG4gICAgPGRpdlxuICAgICAgY3NzPXtnZXRTdHlsZXMoJ2xvYWRpbmdJbmRpY2F0b3InLCBwcm9wcyl9XG4gICAgICBjbGFzc05hbWU9e2N4KFxuICAgICAgICB7XG4gICAgICAgICAgaW5kaWNhdG9yOiB0cnVlLFxuICAgICAgICAgICdsb2FkaW5nLWluZGljYXRvcic6IHRydWUsXG4gICAgICAgIH0sXG4gICAgICAgIGNsYXNzTmFtZVxuICAgICAgKX1cbiAgICAgIHsuLi5pbm5lclByb3BzfVxuICAgID5cbiAgICAgIDxMb2FkaW5nRG90IGRlbGF5PXswfSBvZmZzZXQ9e2lzUnRsfSAvPlxuICAgICAgPExvYWRpbmdEb3QgZGVsYXk9ezE2MH0gb2Zmc2V0IC8+XG4gICAgICA8TG9hZGluZ0RvdCBkZWxheT17MzIwfSBvZmZzZXQ9eyFpc1J0bH0gLz5cbiAgICA8L2Rpdj5cbiAgKTtcbn07XG5Mb2FkaW5nSW5kaWNhdG9yLmRlZmF1bHRQcm9wcyA9IHsgc2l6ZTogNCB9O1xuIl19 */",
    toString: function () {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  },
  LH = function (e) {
    var t = e.size,
      n = FQ(e, kH);
    return zQ("svg", mx({
      height: t,
      width: t,
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false",
      css: VH
    }, n));
  },
  PH = function (e) {
    return zQ(LH, mx({
      size: 20
    }, e), zQ("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
  },
  OH = function (e) {
    return zQ(LH, mx({
      size: 20
    }, e), zQ("path", {
      d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
  },
  TH = function (e) {
    var t = e.isFocused,
      n = e.theme,
      r = n.spacing.baseUnit,
      o = n.colors;
    return {
      label: "indicatorContainer",
      color: t ? o.neutral60 : o.neutral20,
      display: "flex",
      padding: 2 * r,
      transition: "color 150ms",
      ":hover": {
        color: t ? o.neutral80 : o.neutral40
      }
    };
  },
  DH = TH,
  RH = TH,
  GH = function () {
    var e = NQ.apply(void 0, arguments),
      t = "animation-" + e.name;
    return {
      name: t,
      styles: "@keyframes " + t + "{" + e.styles + "}",
      anim: 1,
      toString: function () {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  }(zH || (NH = ["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"], SH || (SH = NH.slice(0)), zH = Object.freeze(Object.defineProperties(NH, {
    raw: {
      value: Object.freeze(SH)
    }
  })))),
  FH = function (e) {
    var t = e.delay,
      n = e.offset;
    return zQ("span", {
      css: NQ({
        animation: "".concat(GH, " 1s ease-in-out ").concat(t, "ms infinite;"),
        backgroundColor: "currentColor",
        borderRadius: "1em",
        display: "inline-block",
        marginLeft: n ? "1em" : void 0,
        height: "1em",
        verticalAlign: "top",
        width: "1em"
      }, "production" === process.env.NODE_ENV ? "" : ";label:LoadingDot;", "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
  },
  jH = function (e) {
    var t = e.className,
      n = e.cx,
      r = e.getStyles,
      o = e.innerProps,
      i = e.isRtl;
    return zQ("div", mx({
      css: r("loadingIndicator", e),
      className: n({
        indicator: !0,
        "loading-indicator": !0
      }, t)
    }, o), zQ(FH, {
      delay: 0,
      offset: i
    }), zQ(FH, {
      delay: 160,
      offset: !0
    }), zQ(FH, {
      delay: 320,
      offset: !i
    }));
  };
jH.defaultProps = {
  size: 4
};
var JH = ["data"],
  ZH = ["innerRef", "isDisabled", "isHidden", "inputClassName"],
  WH = {
    gridArea: "1 / 2",
    font: "inherit",
    minWidth: "2px",
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
  },
  XH = {
    flex: "1 1 auto",
    display: "inline-grid",
    gridArea: "1 / 1 / 2 / 3",
    gridTemplateColumns: "0 min-content",
    "&:after": _Q({
      content: 'attr(data-value) " "',
      visibility: "hidden",
      whiteSpace: "pre"
    }, WH)
  },
  UH = function (e) {
    return _Q({
      label: "input",
      color: "inherit",
      background: 0,
      opacity: e ? 0 : 1,
      width: "100%"
    }, WH);
  },
  KH = function (e) {
    var t = e.children,
      n = e.innerProps;
    return zQ("div", n, t);
  };
var YH = {
  ClearIndicator: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerProps;
    return zQ("div", mx({
      css: o("clearIndicator", e),
      className: r({
        indicator: !0,
        "clear-indicator": !0
      }, n)
    }, i), t || zQ(PH, null));
  },
  Control: function (e) {
    var t = e.children,
      n = e.cx,
      r = e.getStyles,
      o = e.className,
      i = e.isDisabled,
      a = e.isFocused,
      c = e.innerRef,
      s = e.innerProps,
      l = e.menuIsOpen;
    return zQ("div", mx({
      ref: c,
      css: r("control", e),
      className: n({
        control: !0,
        "control--is-disabled": i,
        "control--is-focused": a,
        "control--menu-is-open": l
      }, o)
    }, s), t);
  },
  DropdownIndicator: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerProps;
    return zQ("div", mx({
      css: o("dropdownIndicator", e),
      className: r({
        indicator: !0,
        "dropdown-indicator": !0
      }, n)
    }, i), t || zQ(OH, null));
  },
  DownChevron: OH,
  CrossIcon: PH,
  Group: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.Heading,
      a = e.headingProps,
      c = e.innerProps,
      s = e.label,
      l = e.theme,
      u = e.selectProps;
    return zQ("div", mx({
      css: o("group", e),
      className: r({
        group: !0
      }, n)
    }, c), zQ(i, mx({}, a, {
      selectProps: u,
      theme: l,
      getStyles: o,
      cx: r
    }), s), zQ("div", null, t));
  },
  GroupHeading: function (e) {
    var t = e.getStyles,
      n = e.cx,
      r = e.className,
      o = cH(e);
    o.data;
    var i = FQ(o, JH);
    return zQ("div", mx({
      css: t("groupHeading", e),
      className: n({
        "group-heading": !0
      }, r)
    }, i));
  },
  IndicatorsContainer: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.innerProps,
      i = e.getStyles;
    return zQ("div", mx({
      css: i("indicatorsContainer", e),
      className: r({
        indicators: !0
      }, n)
    }, o), t);
  },
  IndicatorSeparator: function (e) {
    var t = e.className,
      n = e.cx,
      r = e.getStyles,
      o = e.innerProps;
    return zQ("span", mx({}, o, {
      css: r("indicatorSeparator", e),
      className: n({
        "indicator-separator": !0
      }, t)
    }));
  },
  Input: function (e) {
    var t = e.className,
      n = e.cx,
      r = e.getStyles,
      o = e.value,
      i = cH(e),
      a = i.innerRef,
      c = i.isDisabled,
      s = i.isHidden,
      l = i.inputClassName,
      u = FQ(i, ZH);
    return zQ("div", {
      className: n({
        "input-container": !0
      }, t),
      css: r("input", e),
      "data-value": o || ""
    }, zQ("input", mx({
      className: n({
        input: !0
      }, l),
      ref: a,
      style: UH(s),
      disabled: c
    }, u)));
  },
  LoadingIndicator: jH,
  Menu: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerRef,
      a = e.innerProps;
    return zQ("div", mx({
      css: o("menu", e),
      className: r({
        menu: !0
      }, n),
      ref: i
    }, a), t);
  },
  MenuList: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerProps,
      a = e.innerRef,
      c = e.isMulti;
    return zQ("div", mx({
      css: o("menuList", e),
      className: r({
        "menu-list": !0,
        "menu-list--is-multi": c
      }, n),
      ref: a
    }, i), t);
  },
  MenuPortal: MH,
  LoadingMessage: HH,
  NoOptionsMessage: QH,
  MultiValue: function (e) {
    var t = e.children,
      n = e.className,
      r = e.components,
      o = e.cx,
      i = e.data,
      a = e.getStyles,
      c = e.innerProps,
      s = e.isDisabled,
      l = e.removeProps,
      u = e.selectProps,
      d = r.Container,
      f = r.Label,
      p = r.Remove;
    return zQ(PQ, null, function (r) {
      var m = r.css,
        h = r.cx;
      return zQ(d, {
        data: i,
        innerProps: _Q({
          className: h(m(a("multiValue", e)), o({
            "multi-value": !0,
            "multi-value--is-disabled": s
          }, n))
        }, c),
        selectProps: u
      }, zQ(f, {
        data: i,
        innerProps: {
          className: h(m(a("multiValueLabel", e)), o({
            "multi-value__label": !0
          }, n))
        },
        selectProps: u
      }, t), zQ(p, {
        data: i,
        innerProps: _Q({
          className: h(m(a("multiValueRemove", e)), o({
            "multi-value__remove": !0
          }, n)),
          "aria-label": "Remove ".concat(t || "option")
        }, l),
        selectProps: u
      }));
    });
  },
  MultiValueContainer: KH,
  MultiValueLabel: KH,
  MultiValueRemove: function (e) {
    var t = e.children,
      n = e.innerProps;
    return zQ("div", mx({
      role: "button"
    }, n), t || zQ(PH, {
      size: 14
    }));
  },
  Option: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.isDisabled,
      a = e.isFocused,
      c = e.isSelected,
      s = e.innerRef,
      l = e.innerProps;
    return zQ("div", mx({
      css: o("option", e),
      className: r({
        option: !0,
        "option--is-disabled": i,
        "option--is-focused": a,
        "option--is-selected": c
      }, n),
      ref: s,
      "aria-disabled": i
    }, l), t);
  },
  Placeholder: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerProps;
    return zQ("div", mx({
      css: o("placeholder", e),
      className: r({
        placeholder: !0
      }, n)
    }, i), t);
  },
  SelectContainer: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.innerProps,
      a = e.isDisabled,
      c = e.isRtl;
    return zQ("div", mx({
      css: o("container", e),
      className: r({
        "--is-disabled": a,
        "--is-rtl": c
      }, n)
    }, i), t);
  },
  SingleValue: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.getStyles,
      i = e.isDisabled,
      a = e.innerProps;
    return zQ("div", mx({
      css: o("singleValue", e),
      className: r({
        "single-value": !0,
        "single-value--is-disabled": i
      }, n)
    }, a), t);
  },
  ValueContainer: function (e) {
    var t = e.children,
      n = e.className,
      r = e.cx,
      o = e.innerProps,
      i = e.isMulti,
      a = e.getStyles,
      c = e.hasValue;
    return zQ("div", mx({
      css: a("valueContainer", e),
      className: r({
        "value-container": !0,
        "value-container--is-multi": i,
        "value-container--has-value": c
      }, n)
    }, o), t);
  }
};
function qH(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function _H(e, t) {
  if (e) {
    if ("string" == typeof e) return qH(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? qH(e, t) : void 0;
  }
}
function $H(e) {
  return function (e) {
    if (Array.isArray(e)) return qH(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || _H(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
var ez = Number.isNaN || function (e) {
  return "number" == typeof e && e != e;
};
function tz(e, t) {
  return e === t || !(!ez(e) || !ez(t));
}
function nz(e, t) {
  if (e.length !== t.length) return !1;
  for (var n = 0; n < e.length; n++) if (!tz(e[n], t[n])) return !1;
  return !0;
}
for (var rz = "production" === process.env.NODE_ENV ? {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
  } : {
    name: "1f43avz-a11yText-A11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
    toString: function () {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  }, oz = function (e) {
    return zQ("span", mx({
      css: rz
    }, e));
  }, iz = {
    guidance: function (e) {
      var t = e.isSearchable,
        n = e.isMulti,
        r = e.isDisabled,
        o = e.tabSelectsValue;
      switch (e.context) {
        case "menu":
          return "Use Up and Down to choose options".concat(r ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
        case "input":
          return "".concat(e["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "");
        case "value":
          return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
        default:
          return "";
      }
    },
    onChange: function (e) {
      var t = e.action,
        n = e.label,
        r = void 0 === n ? "" : n,
        o = e.labels,
        i = e.isDisabled;
      switch (t) {
        case "deselect-option":
        case "pop-value":
        case "remove-value":
          return "option ".concat(r, ", deselected.");
        case "clear":
          return "All selected options have been cleared.";
        case "initial-input-focus":
          return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
        case "select-option":
          return "option ".concat(r, i ? " is disabled. Select another option." : ", selected.");
        default:
          return "";
      }
    },
    onFocus: function (e) {
      var t = e.context,
        n = e.focused,
        r = e.options,
        o = e.label,
        i = void 0 === o ? "" : o,
        a = e.selectValue,
        c = e.isDisabled,
        s = e.isSelected,
        l = function (e, t) {
          return e && e.length ? "".concat(e.indexOf(t) + 1, " of ").concat(e.length) : "";
        };
      if ("value" === t && a) return "value ".concat(i, " focused, ").concat(l(a, n), ".");
      if ("menu" === t) {
        var u = c ? " disabled" : "",
          d = "".concat(s ? "selected" : "focused").concat(u);
        return "option ".concat(i, " ").concat(d, ", ").concat(l(r, n), ".");
      }
      return "";
    },
    onFilter: function (e) {
      var t = e.inputValue,
        n = e.resultsMessage;
      return "".concat(n).concat(t ? " for search term " + t : "", ".");
    }
  }, az = function (e) {
    var n = e.ariaSelection,
      r = e.focusedOption,
      o = e.focusedValue,
      i = e.focusableOptions,
      a = e.isFocused,
      c = e.selectValue,
      l = e.selectProps,
      u = e.id,
      d = l.ariaLiveMessages,
      f = l.getOptionLabel,
      p = l.inputValue,
      m = l.isMulti,
      h = l.isOptionDisabled,
      A = l.isSearchable,
      g = l.menuIsOpen,
      v = l.options,
      C = l.screenReaderStatus,
      b = l.tabSelectsValue,
      E = l["aria-label"],
      y = l["aria-live"],
      I = s(function () {
        return _Q(_Q({}, iz), d || {});
      }, [d]),
      B = s(function () {
        var e,
          t = "";
        if (n && I.onChange) {
          var r = n.option,
            o = n.options,
            i = n.removedValue,
            a = n.removedValues,
            s = n.value,
            l = i || r || (e = s, Array.isArray(e) ? null : e),
            u = l ? f(l) : "",
            d = o || a || void 0,
            p = d ? d.map(f) : [],
            m = _Q({
              isDisabled: l && h(l, c),
              label: u,
              labels: p
            }, n);
          t = I.onChange(m);
        }
        return t;
      }, [n, I, h, c, f]),
      x = s(function () {
        var e = "",
          t = r || o,
          n = !!(r && c && c.includes(r));
        if (t && I.onFocus) {
          var i = {
            focused: t,
            label: f(t),
            isDisabled: h(t, c),
            isSelected: n,
            options: v,
            context: t === r ? "menu" : "value",
            selectValue: c
          };
          e = I.onFocus(i);
        }
        return e;
      }, [r, o, f, h, I, v, c]),
      w = s(function () {
        var e = "";
        if (g && v.length && I.onFilter) {
          var t = C({
            count: i.length
          });
          e = I.onFilter({
            inputValue: p,
            resultsMessage: t
          });
        }
        return e;
      }, [i, p, g, I, v, C]),
      Q = s(function () {
        var e = "";
        if (I.guidance) {
          var t = o ? "value" : g ? "menu" : "input";
          e = I.guidance({
            "aria-label": E,
            context: t,
            isDisabled: r && h(r, c),
            isMulti: m,
            isSearchable: A,
            tabSelectsValue: b
          });
        }
        return e;
      }, [E, r, o, m, h, A, g, I, c, b]),
      H = "".concat(x, " ").concat(w, " ").concat(Q),
      z = zQ(t.Fragment, null, zQ("span", {
        id: "aria-selection"
      }, B), zQ("span", {
        id: "aria-context"
      }, H)),
      M = "initial-input-focus" === (null == n ? void 0 : n.action);
    return zQ(t.Fragment, null, zQ(oz, {
      id: u
    }, M && z), zQ(oz, {
      "aria-live": y,
      "aria-atomic": "false",
      "aria-relevant": "additions text"
    }, a && !M && z));
  }, cz = [{
    base: "A",
    letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
  }, {
    base: "AA",
    letters: "Ꜳ"
  }, {
    base: "AE",
    letters: "ÆǼǢ"
  }, {
    base: "AO",
    letters: "Ꜵ"
  }, {
    base: "AU",
    letters: "Ꜷ"
  }, {
    base: "AV",
    letters: "ꜸꜺ"
  }, {
    base: "AY",
    letters: "Ꜽ"
  }, {
    base: "B",
    letters: "BⒷＢḂḄḆɃƂƁ"
  }, {
    base: "C",
    letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
  }, {
    base: "D",
    letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
  }, {
    base: "DZ",
    letters: "ǱǄ"
  }, {
    base: "Dz",
    letters: "ǲǅ"
  }, {
    base: "E",
    letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
  }, {
    base: "F",
    letters: "FⒻＦḞƑꝻ"
  }, {
    base: "G",
    letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
  }, {
    base: "H",
    letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
  }, {
    base: "I",
    letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
  }, {
    base: "J",
    letters: "JⒿＪĴɈ"
  }, {
    base: "K",
    letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
  }, {
    base: "L",
    letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
  }, {
    base: "LJ",
    letters: "Ǉ"
  }, {
    base: "Lj",
    letters: "ǈ"
  }, {
    base: "M",
    letters: "MⓂＭḾṀṂⱮƜ"
  }, {
    base: "N",
    letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
  }, {
    base: "NJ",
    letters: "Ǌ"
  }, {
    base: "Nj",
    letters: "ǋ"
  }, {
    base: "O",
    letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
  }, {
    base: "OI",
    letters: "Ƣ"
  }, {
    base: "OO",
    letters: "Ꝏ"
  }, {
    base: "OU",
    letters: "Ȣ"
  }, {
    base: "P",
    letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
  }, {
    base: "Q",
    letters: "QⓆＱꝖꝘɊ"
  }, {
    base: "R",
    letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
  }, {
    base: "S",
    letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
  }, {
    base: "T",
    letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
  }, {
    base: "TZ",
    letters: "Ꜩ"
  }, {
    base: "U",
    letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
  }, {
    base: "V",
    letters: "VⓋＶṼṾƲꝞɅ"
  }, {
    base: "VY",
    letters: "Ꝡ"
  }, {
    base: "W",
    letters: "WⓌＷẀẂŴẆẄẈⱲ"
  }, {
    base: "X",
    letters: "XⓍＸẊẌ"
  }, {
    base: "Y",
    letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
  }, {
    base: "Z",
    letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
  }, {
    base: "a",
    letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
  }, {
    base: "aa",
    letters: "ꜳ"
  }, {
    base: "ae",
    letters: "æǽǣ"
  }, {
    base: "ao",
    letters: "ꜵ"
  }, {
    base: "au",
    letters: "ꜷ"
  }, {
    base: "av",
    letters: "ꜹꜻ"
  }, {
    base: "ay",
    letters: "ꜽ"
  }, {
    base: "b",
    letters: "bⓑｂḃḅḇƀƃɓ"
  }, {
    base: "c",
    letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
  }, {
    base: "d",
    letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
  }, {
    base: "dz",
    letters: "ǳǆ"
  }, {
    base: "e",
    letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
  }, {
    base: "f",
    letters: "fⓕｆḟƒꝼ"
  }, {
    base: "g",
    letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
  }, {
    base: "h",
    letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
  }, {
    base: "hv",
    letters: "ƕ"
  }, {
    base: "i",
    letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
  }, {
    base: "j",
    letters: "jⓙｊĵǰɉ"
  }, {
    base: "k",
    letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
  }, {
    base: "l",
    letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
  }, {
    base: "lj",
    letters: "ǉ"
  }, {
    base: "m",
    letters: "mⓜｍḿṁṃɱɯ"
  }, {
    base: "n",
    letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
  }, {
    base: "nj",
    letters: "ǌ"
  }, {
    base: "o",
    letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
  }, {
    base: "oi",
    letters: "ƣ"
  }, {
    base: "ou",
    letters: "ȣ"
  }, {
    base: "oo",
    letters: "ꝏ"
  }, {
    base: "p",
    letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
  }, {
    base: "q",
    letters: "qⓠｑɋꝗꝙ"
  }, {
    base: "r",
    letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
  }, {
    base: "s",
    letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
  }, {
    base: "t",
    letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
  }, {
    base: "tz",
    letters: "ꜩ"
  }, {
    base: "u",
    letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
  }, {
    base: "v",
    letters: "vⓥｖṽṿʋꝟʌ"
  }, {
    base: "vy",
    letters: "ꝡ"
  }, {
    base: "w",
    letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
  }, {
    base: "x",
    letters: "xⓧｘẋẍ"
  }, {
    base: "y",
    letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
  }, {
    base: "z",
    letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
  }], sz = new RegExp("[" + cz.map(function (e) {
    return e.letters;
  }).join("") + "]", "g"), lz = {}, uz = 0; uz < cz.length; uz++) for (var dz = cz[uz], fz = 0; fz < dz.letters.length; fz++) lz[dz.letters[fz]] = dz.base;
var pz = function (e) {
    return e.replace(sz, function (e) {
      return lz[e];
    });
  },
  mz = function (e, t) {
    var n;
    void 0 === t && (t = nz);
    var r,
      o = [],
      i = !1;
    return function () {
      for (var a = [], c = 0; c < arguments.length; c++) a[c] = arguments[c];
      return i && n === this && t(a, o) || (r = e.apply(this, a), i = !0, n = this, o = a), r;
    };
  }(pz),
  hz = function (e) {
    return e.replace(/^\s+|\s+$/g, "");
  },
  Az = function (e) {
    return "".concat(e.label, " ").concat(e.value);
  },
  gz = ["innerRef"];
function vz(e) {
  var t = e.innerRef,
    n = FQ(e, gz);
  return zQ("input", mx({
    ref: t
  }, n, {
    css: NQ({
      label: "dummyInput",
      background: 0,
      border: 0,
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      width: 1,
      color: "transparent",
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, "production" === process.env.NODE_ENV ? "" : ";label:DummyInput;", "production" === process.env.NODE_ENV ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNNIiwiZmlsZSI6IkR1bW15SW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4ucHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var Cz = ["boxSizing", "height", "overflow", "paddingRight", "position"],
  bz = {
    boxSizing: "border-box",
    overflow: "hidden",
    position: "relative",
    height: "100%"
  };
function Ez(e) {
  e.preventDefault();
}
function yz(e) {
  e.stopPropagation();
}
function Iz() {
  var e = this.scrollTop,
    t = this.scrollHeight,
    n = e + this.offsetHeight;
  0 === e ? this.scrollTop = 1 : n === t && (this.scrollTop = e - 1);
}
function Bz() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var xz = !("undefined" == typeof window || !window.document || !window.document.createElement),
  wz = 0,
  Qz = {
    capture: !1,
    passive: !1
  };
var Hz = function () {
    return document.activeElement && document.activeElement.blur();
  },
  zz = "production" === process.env.NODE_ENV ? {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
  } : {
    name: "bp8cua-ScrollManager",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: function () {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  };
function Mz(e) {
  var n = e.children,
    i = e.lockEnabled,
    a = e.captureEnabled,
    c = function (e) {
      var t = e.isEnabled,
        n = e.onBottomArrive,
        i = e.onBottomLeave,
        a = e.onTopArrive,
        c = e.onTopLeave,
        s = o(!1),
        u = o(!1),
        d = o(0),
        f = o(null),
        p = l(function (e, t) {
          if (null !== f.current) {
            var r = f.current,
              o = r.scrollTop,
              l = r.scrollHeight,
              d = r.clientHeight,
              p = f.current,
              m = t > 0,
              h = l - d - o,
              A = !1;
            h > t && s.current && (i && i(e), s.current = !1), m && u.current && (c && c(e), u.current = !1), m && t > h ? (n && !s.current && n(e), p.scrollTop = l, A = !0, s.current = !0) : !m && -t > o && (a && !u.current && a(e), p.scrollTop = 0, A = !0, u.current = !0), A && function (e) {
              e.preventDefault(), e.stopPropagation();
            }(e);
          }
        }, [n, i, a, c]),
        m = l(function (e) {
          p(e, e.deltaY);
        }, [p]),
        h = l(function (e) {
          d.current = e.changedTouches[0].clientY;
        }, []),
        A = l(function (e) {
          var t = d.current - e.changedTouches[0].clientY;
          p(e, t);
        }, [p]),
        g = l(function (e) {
          if (e) {
            var t = !!gH && {
              passive: !1
            };
            e.addEventListener("wheel", m, t), e.addEventListener("touchstart", h, t), e.addEventListener("touchmove", A, t);
          }
        }, [A, h, m]),
        v = l(function (e) {
          e && (e.removeEventListener("wheel", m, !1), e.removeEventListener("touchstart", h, !1), e.removeEventListener("touchmove", A, !1));
        }, [A, h, m]);
      return r(function () {
        if (t) {
          var e = f.current;
          return g(e), function () {
            v(e);
          };
        }
      }, [t, g, v]), function (e) {
        f.current = e;
      };
    }({
      isEnabled: void 0 === a || a,
      onBottomArrive: e.onBottomArrive,
      onBottomLeave: e.onBottomLeave,
      onTopArrive: e.onTopArrive,
      onTopLeave: e.onTopLeave
    }),
    s = function (e) {
      var t = e.isEnabled,
        n = e.accountForScrollbars,
        i = void 0 === n || n,
        a = o({}),
        c = o(null),
        s = l(function (e) {
          if (xz) {
            var t = document.body,
              n = t && t.style;
            if (i && Cz.forEach(function (e) {
              var t = n && n[e];
              a.current[e] = t;
            }), i && wz < 1) {
              var r = parseInt(a.current.paddingRight, 10) || 0,
                o = document.body ? document.body.clientWidth : 0,
                c = window.innerWidth - o + r || 0;
              Object.keys(bz).forEach(function (e) {
                var t = bz[e];
                n && (n[e] = t);
              }), n && (n.paddingRight = "".concat(c, "px"));
            }
            t && Bz() && (t.addEventListener("touchmove", Ez, Qz), e && (e.addEventListener("touchstart", Iz, Qz), e.addEventListener("touchmove", yz, Qz))), wz += 1;
          }
        }, [i]),
        u = l(function (e) {
          if (xz) {
            var t = document.body,
              n = t && t.style;
            wz = Math.max(wz - 1, 0), i && wz < 1 && Cz.forEach(function (e) {
              var t = a.current[e];
              n && (n[e] = t);
            }), t && Bz() && (t.removeEventListener("touchmove", Ez, Qz), e && (e.removeEventListener("touchstart", Iz, Qz), e.removeEventListener("touchmove", yz, Qz)));
          }
        }, [i]);
      return r(function () {
        if (t) {
          var e = c.current;
          return s(e), function () {
            u(e);
          };
        }
      }, [t, s, u]), function (e) {
        c.current = e;
      };
    }({
      isEnabled: i
    });
  return zQ(t.Fragment, null, i && zQ("div", {
    onClick: Hz,
    css: zz
  }), n(function (e) {
    c(e), s(e);
  }));
}
var kz = function (e) {
    return e.label;
  },
  Nz = function (e) {
    return e.value;
  },
  Sz = {
    clearIndicator: RH,
    container: function (e) {
      var t = e.isDisabled;
      return {
        label: "container",
        direction: e.isRtl ? "rtl" : void 0,
        pointerEvents: t ? "none" : void 0,
        position: "relative"
      };
    },
    control: function (e) {
      var t = e.isDisabled,
        n = e.isFocused,
        r = e.theme,
        o = r.colors,
        i = r.borderRadius,
        a = r.spacing;
      return {
        label: "control",
        alignItems: "center",
        backgroundColor: t ? o.neutral5 : o.neutral0,
        borderColor: t ? o.neutral10 : n ? o.primary : o.neutral20,
        borderRadius: i,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: n ? "0 0 0 1px ".concat(o.primary) : void 0,
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: a.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms",
        "&:hover": {
          borderColor: n ? o.primary : o.neutral30
        }
      };
    },
    dropdownIndicator: DH,
    group: function (e) {
      var t = e.theme.spacing;
      return {
        paddingBottom: 2 * t.baseUnit,
        paddingTop: 2 * t.baseUnit
      };
    },
    groupHeading: function (e) {
      var t = e.theme.spacing;
      return {
        label: "group",
        color: "#999",
        cursor: "default",
        display: "block",
        fontSize: "75%",
        fontWeight: 500,
        marginBottom: "0.25em",
        paddingLeft: 3 * t.baseUnit,
        paddingRight: 3 * t.baseUnit,
        textTransform: "uppercase"
      };
    },
    indicatorsContainer: function () {
      return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
      };
    },
    indicatorSeparator: function (e) {
      var t = e.isDisabled,
        n = e.theme,
        r = n.spacing.baseUnit,
        o = n.colors;
      return {
        label: "indicatorSeparator",
        alignSelf: "stretch",
        backgroundColor: t ? o.neutral10 : o.neutral20,
        marginBottom: 2 * r,
        marginTop: 2 * r,
        width: 1
      };
    },
    input: function (e) {
      var t = e.isDisabled,
        n = e.value,
        r = e.theme,
        o = r.spacing,
        i = r.colors;
      return _Q({
        margin: o.baseUnit / 2,
        paddingBottom: o.baseUnit / 2,
        paddingTop: o.baseUnit / 2,
        visibility: t ? "hidden" : "visible",
        color: i.neutral80,
        transform: n ? "translateZ(0)" : ""
      }, XH);
    },
    loadingIndicator: function (e) {
      var t = e.isFocused,
        n = e.size,
        r = e.theme,
        o = r.colors,
        i = r.spacing.baseUnit;
      return {
        label: "loadingIndicator",
        color: t ? o.neutral60 : o.neutral20,
        display: "flex",
        padding: 2 * i,
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: n,
        lineHeight: 1,
        marginRight: n,
        textAlign: "center",
        verticalAlign: "middle"
      };
    },
    loadingMessage: wH,
    menu: function (e) {
      var t,
        n = e.placement,
        r = e.theme,
        o = r.borderRadius,
        i = r.spacing,
        a = r.colors;
      return KQ(t = {
        label: "menu"
      }, function (e) {
        return e ? {
          bottom: "top",
          top: "bottom"
        }[e] : "bottom";
      }(n), "100%"), KQ(t, "backgroundColor", a.neutral0), KQ(t, "borderRadius", o), KQ(t, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), KQ(t, "marginBottom", i.menuGutter), KQ(t, "marginTop", i.menuGutter), KQ(t, "position", "absolute"), KQ(t, "width", "100%"), KQ(t, "zIndex", 1), t;
    },
    menuList: function (e) {
      var t = e.maxHeight,
        n = e.theme.spacing.baseUnit;
      return {
        maxHeight: t,
        overflowY: "auto",
        paddingBottom: n,
        paddingTop: n,
        position: "relative",
        WebkitOverflowScrolling: "touch"
      };
    },
    menuPortal: function (e) {
      var t = e.rect,
        n = e.offset,
        r = e.position;
      return {
        left: t.left,
        position: r,
        top: n,
        width: t.width,
        zIndex: 1
      };
    },
    multiValue: function (e) {
      var t = e.theme,
        n = t.spacing,
        r = t.borderRadius;
      return {
        label: "multiValue",
        backgroundColor: t.colors.neutral10,
        borderRadius: r / 2,
        display: "flex",
        margin: n.baseUnit / 2,
        minWidth: 0
      };
    },
    multiValueLabel: function (e) {
      var t = e.theme,
        n = t.borderRadius,
        r = t.colors,
        o = e.cropWithEllipsis;
      return {
        borderRadius: n / 2,
        color: r.neutral80,
        fontSize: "85%",
        overflow: "hidden",
        padding: 3,
        paddingLeft: 6,
        textOverflow: o || void 0 === o ? "ellipsis" : void 0,
        whiteSpace: "nowrap"
      };
    },
    multiValueRemove: function (e) {
      var t = e.theme,
        n = t.spacing,
        r = t.borderRadius,
        o = t.colors;
      return {
        alignItems: "center",
        borderRadius: r / 2,
        backgroundColor: e.isFocused ? o.dangerLight : void 0,
        display: "flex",
        paddingLeft: n.baseUnit,
        paddingRight: n.baseUnit,
        ":hover": {
          backgroundColor: o.dangerLight,
          color: o.danger
        }
      };
    },
    noOptionsMessage: xH,
    option: function (e) {
      var t = e.isDisabled,
        n = e.isFocused,
        r = e.isSelected,
        o = e.theme,
        i = o.spacing,
        a = o.colors;
      return {
        label: "option",
        backgroundColor: r ? a.primary : n ? a.primary25 : "transparent",
        color: t ? a.neutral20 : r ? a.neutral0 : "inherit",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        padding: "".concat(2 * i.baseUnit, "px ").concat(3 * i.baseUnit, "px"),
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        ":active": {
          backgroundColor: t ? void 0 : r ? a.primary : a.primary50
        }
      };
    },
    placeholder: function (e) {
      var t = e.theme,
        n = t.spacing;
      return {
        label: "placeholder",
        color: t.colors.neutral50,
        gridArea: "1 / 1 / 2 / 3",
        marginLeft: n.baseUnit / 2,
        marginRight: n.baseUnit / 2
      };
    },
    singleValue: function (e) {
      var t = e.isDisabled,
        n = e.theme,
        r = n.spacing,
        o = n.colors;
      return {
        label: "singleValue",
        color: t ? o.neutral40 : o.neutral80,
        gridArea: "1 / 1 / 2 / 3",
        marginLeft: r.baseUnit / 2,
        marginRight: r.baseUnit / 2,
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      };
    },
    valueContainer: function (e) {
      var t = e.theme.spacing,
        n = e.isMulti,
        r = e.hasValue,
        o = e.selectProps.controlShouldRenderValue;
      return {
        alignItems: "center",
        display: n && r && o ? "flex" : "grid",
        flex: 1,
        flexWrap: "wrap",
        padding: "".concat(t.baseUnit / 2, "px ").concat(2 * t.baseUnit, "px"),
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
      };
    }
  },
  Vz = {
    borderRadius: 4,
    colors: {
      primary: "#2684FF",
      primary75: "#4C9AFF",
      primary50: "#B2D4FF",
      primary25: "#DEEBFF",
      danger: "#DE350B",
      dangerLight: "#FFBDAD",
      neutral0: "hsl(0, 0%, 100%)",
      neutral5: "hsl(0, 0%, 95%)",
      neutral10: "hsl(0, 0%, 90%)",
      neutral20: "hsl(0, 0%, 80%)",
      neutral30: "hsl(0, 0%, 70%)",
      neutral40: "hsl(0, 0%, 60%)",
      neutral50: "hsl(0, 0%, 50%)",
      neutral60: "hsl(0, 0%, 40%)",
      neutral70: "hsl(0, 0%, 30%)",
      neutral80: "hsl(0, 0%, 20%)",
      neutral90: "hsl(0, 0%, 10%)"
    },
    spacing: {
      baseUnit: 4,
      controlHeight: 38,
      menuGutter: 8
    }
  },
  Lz = {
    "aria-live": "polite",
    backspaceRemovesValue: !0,
    blurInputOnSelect: pH(),
    captureMenuScroll: !pH(),
    closeMenuOnSelect: !0,
    closeMenuOnScroll: !1,
    components: {},
    controlShouldRenderValue: !0,
    escapeClearsValue: !1,
    filterOption: function (e) {
      return function (t, n) {
        if (t.data.__isNew__) return !0;
        var r = _Q({
            ignoreCase: !0,
            ignoreAccents: !0,
            stringify: Az,
            trim: !0,
            matchFrom: "any"
          }, e),
          o = r.ignoreCase,
          i = r.ignoreAccents,
          a = r.stringify,
          c = r.trim,
          s = r.matchFrom,
          l = c ? hz(n) : n,
          u = c ? hz(a(t)) : a(t);
        return o && (l = l.toLowerCase(), u = u.toLowerCase()), i && (l = mz(l), u = pz(u)), "start" === s ? u.substr(0, l.length) === l : u.indexOf(l) > -1;
      };
    }(),
    formatGroupLabel: function (e) {
      return e.label;
    },
    getOptionLabel: kz,
    getOptionValue: Nz,
    isDisabled: !1,
    isLoading: !1,
    isMulti: !1,
    isRtl: !1,
    isSearchable: !0,
    isOptionDisabled: function (e) {
      return !!e.isDisabled;
    },
    loadingMessage: function () {
      return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: !1,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: !1,
    menuShouldScrollIntoView: !function () {
      try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      } catch (e) {
        return !1;
      }
    }(),
    noOptionsMessage: function () {
      return "No options";
    },
    openMenuOnFocus: !1,
    openMenuOnClick: !0,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function (e) {
      var t = e.count;
      return "".concat(t, " result").concat(1 !== t ? "s" : "", " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: !0
  };
function Pz(e, t, n, r) {
  return {
    type: "option",
    data: t,
    isDisabled: Fz(e, t, n),
    isSelected: jz(e, t, n),
    label: Rz(e, t),
    value: Gz(e, t),
    index: r
  };
}
function Oz(e, t) {
  return e.options.map(function (n, r) {
    if ("options" in n) {
      var o = n.options.map(function (n, r) {
        return Pz(e, n, t, r);
      }).filter(function (t) {
        return Dz(e, t);
      });
      return o.length > 0 ? {
        type: "group",
        data: n,
        options: o,
        index: r
      } : void 0;
    }
    var i = Pz(e, n, t, r);
    return Dz(e, i) ? i : void 0;
  }).filter(vH);
}
function Tz(e) {
  return e.reduce(function (e, t) {
    return "group" === t.type ? e.push.apply(e, $H(t.options.map(function (e) {
      return e.data;
    }))) : e.push(t.data), e;
  }, []);
}
function Dz(e, t) {
  var n = e.inputValue,
    r = void 0 === n ? "" : n,
    o = t.data,
    i = t.isSelected,
    a = t.label,
    c = t.value;
  return (!Zz(e) || !i) && Jz(e, {
    label: a,
    value: c,
    data: o
  }, r);
}
var Rz = function (e, t) {
    return e.getOptionLabel(t);
  },
  Gz = function (e, t) {
    return e.getOptionValue(t);
  };
function Fz(e, t, n) {
  return "function" == typeof e.isOptionDisabled && e.isOptionDisabled(t, n);
}
function jz(e, t, n) {
  if (n.indexOf(t) > -1) return !0;
  if ("function" == typeof e.isOptionSelected) return e.isOptionSelected(t, n);
  var r = Gz(e, t);
  return n.some(function (t) {
    return Gz(e, t) === r;
  });
}
function Jz(e, t, n) {
  return !e.filterOption || e.filterOption(t, n);
}
var Zz = function (e) {
    var t = e.hideSelectedOptions,
      n = e.isMulti;
    return void 0 === t ? n : t;
  },
  Wz = 1,
  Xz = function (e) {
    UQ(r, a);
    var n = tH(r);
    function r(e) {
      var t;
      return JQ(this, r), (t = n.call(this, e)).state = {
        ariaSelection: null,
        focusedOption: null,
        focusedValue: null,
        inputIsHidden: !1,
        isFocused: !1,
        selectValue: [],
        clearFocusValueOnUpdate: !1,
        prevWasFocused: !1,
        inputIsHiddenAfterUpdate: void 0,
        prevProps: void 0
      }, t.blockOptionHover = !1, t.isComposing = !1, t.commonProps = void 0, t.initialTouchX = 0, t.initialTouchY = 0, t.instancePrefix = "", t.openAfterFocus = !1, t.scrollToFocusedOptionOnUpdate = !1, t.userIsDragging = void 0, t.controlRef = null, t.getControlRef = function (e) {
        t.controlRef = e;
      }, t.focusedOptionRef = null, t.getFocusedOptionRef = function (e) {
        t.focusedOptionRef = e;
      }, t.menuListRef = null, t.getMenuListRef = function (e) {
        t.menuListRef = e;
      }, t.inputRef = null, t.getInputRef = function (e) {
        t.inputRef = e;
      }, t.focus = t.focusInput, t.blur = t.blurInput, t.onChange = function (e, n) {
        var r = t.props,
          o = r.onChange,
          i = r.name;
        n.name = i, t.ariaOnChange(e, n), o(e, n);
      }, t.setValue = function (e, n, r) {
        var o = t.props,
          i = o.closeMenuOnSelect,
          a = o.isMulti,
          c = o.inputValue;
        t.onInputChange("", {
          action: "set-value",
          prevInputValue: c
        }), i && (t.setState({
          inputIsHiddenAfterUpdate: !a
        }), t.onMenuClose()), t.setState({
          clearFocusValueOnUpdate: !0
        }), t.onChange(e, {
          action: n,
          option: r
        });
      }, t.selectOption = function (e) {
        var n = t.props,
          r = n.blurInputOnSelect,
          o = n.isMulti,
          i = n.name,
          a = t.state.selectValue,
          c = o && t.isOptionSelected(e, a),
          s = t.isOptionDisabled(e, a);
        if (c) {
          var l = t.getOptionValue(e);
          t.setValue(a.filter(function (e) {
            return t.getOptionValue(e) !== l;
          }), "deselect-option", e);
        } else {
          if (s) return void t.ariaOnChange(e, {
            action: "select-option",
            option: e,
            name: i
          });
          o ? t.setValue([].concat($H(a), [e]), "select-option", e) : t.setValue(e, "select-option");
        }
        r && t.blurInput();
      }, t.removeValue = function (e) {
        var n = t.props.isMulti,
          r = t.state.selectValue,
          o = t.getOptionValue(e),
          i = r.filter(function (e) {
            return t.getOptionValue(e) !== o;
          }),
          a = CH(n, i, i[0] || null);
        t.onChange(a, {
          action: "remove-value",
          removedValue: e
        }), t.focusInput();
      }, t.clearValue = function () {
        var e = t.state.selectValue;
        t.onChange(CH(t.props.isMulti, [], null), {
          action: "clear",
          removedValues: e
        });
      }, t.popValue = function () {
        var e = t.props.isMulti,
          n = t.state.selectValue,
          r = n[n.length - 1],
          o = n.slice(0, n.length - 1),
          i = CH(e, o, o[0] || null);
        t.onChange(i, {
          action: "pop-value",
          removedValue: r
        });
      }, t.getValue = function () {
        return t.state.selectValue;
      }, t.cx = function () {
        for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++) n[r] = arguments[r];
        return iH.apply(void 0, [t.props.classNamePrefix].concat(n));
      }, t.getOptionLabel = function (e) {
        return Rz(t.props, e);
      }, t.getOptionValue = function (e) {
        return Gz(t.props, e);
      }, t.getStyles = function (e, n) {
        var r = Sz[e](n);
        r.boxSizing = "border-box";
        var o = t.props.styles[e];
        return o ? o(r, n) : r;
      }, t.getElementId = function (e) {
        return "".concat(t.instancePrefix, "-").concat(e);
      }, t.getComponents = function () {
        return e = t.props, _Q(_Q({}, YH), e.components);
        var e;
      }, t.buildCategorizedOptions = function () {
        return Oz(t.props, t.state.selectValue);
      }, t.getCategorizedOptions = function () {
        return t.props.menuIsOpen ? t.buildCategorizedOptions() : [];
      }, t.buildFocusableOptions = function () {
        return Tz(t.buildCategorizedOptions());
      }, t.getFocusableOptions = function () {
        return t.props.menuIsOpen ? t.buildFocusableOptions() : [];
      }, t.ariaOnChange = function (e, n) {
        t.setState({
          ariaSelection: _Q({
            value: e
          }, n)
        });
      }, t.onMenuMouseDown = function (e) {
        0 === e.button && (e.stopPropagation(), e.preventDefault(), t.focusInput());
      }, t.onMenuMouseMove = function (e) {
        t.blockOptionHover = !1;
      }, t.onControlMouseDown = function (e) {
        var n = t.props.openMenuOnClick;
        t.state.isFocused ? t.props.menuIsOpen ? "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && t.onMenuClose() : n && t.openMenu("first") : (n && (t.openAfterFocus = !0), t.focusInput()), "INPUT" !== e.target.tagName && "TEXTAREA" !== e.target.tagName && e.preventDefault();
      }, t.onDropdownIndicatorMouseDown = function (e) {
        if (!(e && "mousedown" === e.type && 0 !== e.button || t.props.isDisabled)) {
          var n = t.props,
            r = n.isMulti,
            o = n.menuIsOpen;
          t.focusInput(), o ? (t.setState({
            inputIsHiddenAfterUpdate: !r
          }), t.onMenuClose()) : t.openMenu("first"), e.preventDefault(), e.stopPropagation();
        }
      }, t.onClearIndicatorMouseDown = function (e) {
        e && "mousedown" === e.type && 0 !== e.button || (t.clearValue(), e.preventDefault(), e.stopPropagation(), t.openAfterFocus = !1, "touchend" === e.type ? t.focusInput() : setTimeout(function () {
          return t.focusInput();
        }));
      }, t.onScroll = function (e) {
        "boolean" == typeof t.props.closeMenuOnScroll ? e.target instanceof HTMLElement && sH(e.target) && t.props.onMenuClose() : "function" == typeof t.props.closeMenuOnScroll && t.props.closeMenuOnScroll(e) && t.props.onMenuClose();
      }, t.onCompositionStart = function () {
        t.isComposing = !0;
      }, t.onCompositionEnd = function () {
        t.isComposing = !1;
      }, t.onTouchStart = function (e) {
        var n = e.touches,
          r = n && n.item(0);
        r && (t.initialTouchX = r.clientX, t.initialTouchY = r.clientY, t.userIsDragging = !1);
      }, t.onTouchMove = function (e) {
        var n = e.touches,
          r = n && n.item(0);
        if (r) {
          var o = Math.abs(r.clientX - t.initialTouchX),
            i = Math.abs(r.clientY - t.initialTouchY);
          t.userIsDragging = o > 5 || i > 5;
        }
      }, t.onTouchEnd = function (e) {
        t.userIsDragging || (t.controlRef && !t.controlRef.contains(e.target) && t.menuListRef && !t.menuListRef.contains(e.target) && t.blurInput(), t.initialTouchX = 0, t.initialTouchY = 0);
      }, t.onControlTouchEnd = function (e) {
        t.userIsDragging || t.onControlMouseDown(e);
      }, t.onClearIndicatorTouchEnd = function (e) {
        t.userIsDragging || t.onClearIndicatorMouseDown(e);
      }, t.onDropdownIndicatorTouchEnd = function (e) {
        t.userIsDragging || t.onDropdownIndicatorMouseDown(e);
      }, t.handleInputChange = function (e) {
        var n = t.props.inputValue,
          r = e.currentTarget.value;
        t.setState({
          inputIsHiddenAfterUpdate: !1
        }), t.onInputChange(r, {
          action: "input-change",
          prevInputValue: n
        }), t.props.menuIsOpen || t.onMenuOpen();
      }, t.onInputFocus = function (e) {
        t.props.onFocus && t.props.onFocus(e), t.setState({
          inputIsHiddenAfterUpdate: !1,
          isFocused: !0
        }), (t.openAfterFocus || t.props.openMenuOnFocus) && t.openMenu("first"), t.openAfterFocus = !1;
      }, t.onInputBlur = function (e) {
        var n = t.props.inputValue;
        t.menuListRef && t.menuListRef.contains(document.activeElement) ? t.inputRef.focus() : (t.props.onBlur && t.props.onBlur(e), t.onInputChange("", {
          action: "input-blur",
          prevInputValue: n
        }), t.onMenuClose(), t.setState({
          focusedValue: null,
          isFocused: !1
        }));
      }, t.onOptionHover = function (e) {
        t.blockOptionHover || t.state.focusedOption === e || t.setState({
          focusedOption: e
        });
      }, t.shouldHideSelectedOptions = function () {
        return Zz(t.props);
      }, t.onKeyDown = function (e) {
        var n = t.props,
          r = n.isMulti,
          o = n.backspaceRemovesValue,
          i = n.escapeClearsValue,
          a = n.inputValue,
          c = n.isClearable,
          s = n.isDisabled,
          l = n.menuIsOpen,
          u = n.onKeyDown,
          d = n.tabSelectsValue,
          f = n.openMenuOnFocus,
          p = t.state,
          m = p.focusedOption,
          h = p.focusedValue,
          A = p.selectValue;
        if (!(s || "function" == typeof u && (u(e), e.defaultPrevented))) {
          switch (t.blockOptionHover = !0, e.key) {
            case "ArrowLeft":
              if (!r || a) return;
              t.focusValue("previous");
              break;
            case "ArrowRight":
              if (!r || a) return;
              t.focusValue("next");
              break;
            case "Delete":
            case "Backspace":
              if (a) return;
              if (h) t.removeValue(h);else {
                if (!o) return;
                r ? t.popValue() : c && t.clearValue();
              }
              break;
            case "Tab":
              if (t.isComposing) return;
              if (e.shiftKey || !l || !d || !m || f && t.isOptionSelected(m, A)) return;
              t.selectOption(m);
              break;
            case "Enter":
              if (229 === e.keyCode) break;
              if (l) {
                if (!m) return;
                if (t.isComposing) return;
                t.selectOption(m);
                break;
              }
              return;
            case "Escape":
              l ? (t.setState({
                inputIsHiddenAfterUpdate: !1
              }), t.onInputChange("", {
                action: "menu-close",
                prevInputValue: a
              }), t.onMenuClose()) : c && i && t.clearValue();
              break;
            case " ":
              if (a) return;
              if (!l) {
                t.openMenu("first");
                break;
              }
              if (!m) return;
              t.selectOption(m);
              break;
            case "ArrowUp":
              l ? t.focusOption("up") : t.openMenu("last");
              break;
            case "ArrowDown":
              l ? t.focusOption("down") : t.openMenu("first");
              break;
            case "PageUp":
              if (!l) return;
              t.focusOption("pageup");
              break;
            case "PageDown":
              if (!l) return;
              t.focusOption("pagedown");
              break;
            case "Home":
              if (!l) return;
              t.focusOption("first");
              break;
            case "End":
              if (!l) return;
              t.focusOption("last");
              break;
            default:
              return;
          }
          e.preventDefault();
        }
      }, t.instancePrefix = "react-select-" + (t.props.instanceId || ++Wz), t.state.selectValue = aH(e.value), t;
    }
    return WQ(r, [{
      key: "componentDidMount",
      value: function () {
        this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput();
      }
    }, {
      key: "componentDidUpdate",
      value: function (e) {
        var t,
          n,
          r,
          o,
          i,
          a = this.props,
          c = a.isDisabled,
          s = a.menuIsOpen,
          l = this.state.isFocused;
        (l && !c && e.isDisabled || l && s && !e.menuIsOpen) && this.focusInput(), l && c && !e.isDisabled && this.setState({
          isFocused: !1
        }, this.onMenuClose), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (t = this.menuListRef, n = this.focusedOptionRef, r = t.getBoundingClientRect(), o = n.getBoundingClientRect(), i = n.offsetHeight / 3, o.bottom + i > r.bottom ? uH(t, Math.min(n.offsetTop + n.clientHeight - t.offsetHeight + i, t.scrollHeight)) : o.top - i < r.top && uH(t, Math.max(n.offsetTop - i, 0)), this.scrollToFocusedOptionOnUpdate = !1);
      }
    }, {
      key: "componentWillUnmount",
      value: function () {
        this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
      }
    }, {
      key: "onMenuOpen",
      value: function () {
        this.props.onMenuOpen();
      }
    }, {
      key: "onMenuClose",
      value: function () {
        this.onInputChange("", {
          action: "menu-close",
          prevInputValue: this.props.inputValue
        }), this.props.onMenuClose();
      }
    }, {
      key: "onInputChange",
      value: function (e, t) {
        this.props.onInputChange(e, t);
      }
    }, {
      key: "focusInput",
      value: function () {
        this.inputRef && this.inputRef.focus();
      }
    }, {
      key: "blurInput",
      value: function () {
        this.inputRef && this.inputRef.blur();
      }
    }, {
      key: "openMenu",
      value: function (e) {
        var t = this,
          n = this.state,
          r = n.selectValue,
          o = n.isFocused,
          i = this.buildFocusableOptions(),
          a = "first" === e ? 0 : i.length - 1;
        if (!this.props.isMulti) {
          var c = i.indexOf(r[0]);
          c > -1 && (a = c);
        }
        this.scrollToFocusedOptionOnUpdate = !(o && this.menuListRef), this.setState({
          inputIsHiddenAfterUpdate: !1,
          focusedValue: null,
          focusedOption: i[a]
        }, function () {
          return t.onMenuOpen();
        });
      }
    }, {
      key: "focusValue",
      value: function (e) {
        var t = this.state,
          n = t.selectValue,
          r = t.focusedValue;
        if (this.props.isMulti) {
          this.setState({
            focusedOption: null
          });
          var o = n.indexOf(r);
          r || (o = -1);
          var i = n.length - 1,
            a = -1;
          if (n.length) {
            switch (e) {
              case "previous":
                a = 0 === o ? 0 : -1 === o ? i : o - 1;
                break;
              case "next":
                o > -1 && o < i && (a = o + 1);
            }
            this.setState({
              inputIsHidden: -1 !== a,
              focusedValue: n[a]
            });
          }
        }
      }
    }, {
      key: "focusOption",
      value: function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "first",
          t = this.props.pageSize,
          n = this.state.focusedOption,
          r = this.getFocusableOptions();
        if (r.length) {
          var o = 0,
            i = r.indexOf(n);
          n || (i = -1), "up" === e ? o = i > 0 ? i - 1 : r.length - 1 : "down" === e ? o = (i + 1) % r.length : "pageup" === e ? (o = i - t) < 0 && (o = 0) : "pagedown" === e ? (o = i + t) > r.length - 1 && (o = r.length - 1) : "last" === e && (o = r.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
            focusedOption: r[o],
            focusedValue: null
          });
        }
      }
    }, {
      key: "getTheme",
      value: function () {
        return this.props.theme ? "function" == typeof this.props.theme ? this.props.theme(Vz) : _Q(_Q({}, Vz), this.props.theme) : Vz;
      }
    }, {
      key: "getCommonProps",
      value: function () {
        var e = this.clearValue,
          t = this.cx,
          n = this.getStyles,
          r = this.getValue,
          o = this.selectOption,
          i = this.setValue,
          a = this.props,
          c = a.isMulti,
          s = a.isRtl,
          l = a.options;
        return {
          clearValue: e,
          cx: t,
          getStyles: n,
          getValue: r,
          hasValue: this.hasValue(),
          isMulti: c,
          isRtl: s,
          options: l,
          selectOption: o,
          selectProps: a,
          setValue: i,
          theme: this.getTheme()
        };
      }
    }, {
      key: "hasValue",
      value: function () {
        return this.state.selectValue.length > 0;
      }
    }, {
      key: "hasOptions",
      value: function () {
        return !!this.getFocusableOptions().length;
      }
    }, {
      key: "isClearable",
      value: function () {
        var e = this.props,
          t = e.isClearable,
          n = e.isMulti;
        return void 0 === t ? n : t;
      }
    }, {
      key: "isOptionDisabled",
      value: function (e, t) {
        return Fz(this.props, e, t);
      }
    }, {
      key: "isOptionSelected",
      value: function (e, t) {
        return jz(this.props, e, t);
      }
    }, {
      key: "filterOption",
      value: function (e, t) {
        return Jz(this.props, e, t);
      }
    }, {
      key: "formatOptionLabel",
      value: function (e, t) {
        if ("function" == typeof this.props.formatOptionLabel) {
          var n = this.props.inputValue,
            r = this.state.selectValue;
          return this.props.formatOptionLabel(e, {
            context: t,
            inputValue: n,
            selectValue: r
          });
        }
        return this.getOptionLabel(e);
      }
    }, {
      key: "formatGroupLabel",
      value: function (e) {
        return this.props.formatGroupLabel(e);
      }
    }, {
      key: "startListeningComposition",
      value: function () {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    }, {
      key: "stopListeningComposition",
      value: function () {
        document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
      }
    }, {
      key: "startListeningToTouch",
      value: function () {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    }, {
      key: "stopListeningToTouch",
      value: function () {
        document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
      }
    }, {
      key: "renderInput",
      value: function () {
        var e = this.props,
          n = e.isDisabled,
          r = e.isSearchable,
          o = e.inputId,
          i = e.inputValue,
          a = e.tabIndex,
          c = e.form,
          s = e.menuIsOpen,
          l = this.getComponents().Input,
          u = this.state,
          d = u.inputIsHidden,
          f = u.ariaSelection,
          p = this.commonProps,
          m = o || this.getElementId("input"),
          h = _Q(_Q({
            "aria-autocomplete": "list",
            "aria-expanded": s,
            "aria-haspopup": !0,
            "aria-controls": this.getElementId("listbox"),
            "aria-owns": this.getElementId("listbox"),
            "aria-errormessage": this.props["aria-errormessage"],
            "aria-invalid": this.props["aria-invalid"],
            "aria-label": this.props["aria-label"],
            "aria-labelledby": this.props["aria-labelledby"],
            role: "combobox"
          }, !r && {
            "aria-readonly": !0
          }), this.hasValue() ? "initial-input-focus" === (null == f ? void 0 : f.action) && {
            "aria-describedby": this.getElementId("live-region")
          } : {
            "aria-describedby": this.getElementId("placeholder")
          });
        return r ? /*#__PURE__*/t.createElement(l, mx({}, p, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: m,
          innerRef: this.getInputRef,
          isDisabled: n,
          isHidden: d,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: a,
          form: c,
          type: "text",
          value: i
        }, h)) : /*#__PURE__*/t.createElement(vz, mx({
          id: m,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: rH,
          onFocus: this.onInputFocus,
          disabled: n,
          tabIndex: a,
          inputMode: "none",
          form: c,
          value: ""
        }, h));
      }
    }, {
      key: "renderPlaceholderOrValue",
      value: function () {
        var e = this,
          n = this.getComponents(),
          r = n.MultiValue,
          o = n.MultiValueContainer,
          i = n.MultiValueLabel,
          a = n.MultiValueRemove,
          c = n.SingleValue,
          s = n.Placeholder,
          l = this.commonProps,
          u = this.props,
          d = u.controlShouldRenderValue,
          f = u.isDisabled,
          p = u.isMulti,
          m = u.inputValue,
          h = u.placeholder,
          A = this.state,
          g = A.selectValue,
          v = A.focusedValue,
          C = A.isFocused;
        if (!this.hasValue() || !d) return m ? null : /*#__PURE__*/t.createElement(s, mx({}, l, {
          key: "placeholder",
          isDisabled: f,
          isFocused: C,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), h);
        if (p) return g.map(function (n, c) {
          var s = n === v,
            u = "".concat(e.getOptionLabel(n), "-").concat(e.getOptionValue(n));
          return /*#__PURE__*/t.createElement(r, mx({}, l, {
            components: {
              Container: o,
              Label: i,
              Remove: a
            },
            isFocused: s,
            isDisabled: f,
            key: u,
            index: c,
            removeProps: {
              onClick: function () {
                return e.removeValue(n);
              },
              onTouchEnd: function () {
                return e.removeValue(n);
              },
              onMouseDown: function (e) {
                e.preventDefault(), e.stopPropagation();
              }
            },
            data: n
          }), e.formatOptionLabel(n, "value"));
        });
        if (m) return null;
        var b = g[0];
        return /*#__PURE__*/t.createElement(c, mx({}, l, {
          data: b,
          isDisabled: f
        }), this.formatOptionLabel(b, "value"));
      }
    }, {
      key: "renderClearIndicator",
      value: function () {
        var e = this.getComponents().ClearIndicator,
          n = this.commonProps,
          r = this.props,
          o = r.isDisabled,
          i = r.isLoading,
          a = this.state.isFocused;
        if (!this.isClearable() || !e || o || !this.hasValue() || i) return null;
        var c = {
          onMouseDown: this.onClearIndicatorMouseDown,
          onTouchEnd: this.onClearIndicatorTouchEnd,
          "aria-hidden": "true"
        };
        return /*#__PURE__*/t.createElement(e, mx({}, n, {
          innerProps: c,
          isFocused: a
        }));
      }
    }, {
      key: "renderLoadingIndicator",
      value: function () {
        var e = this.getComponents().LoadingIndicator,
          n = this.commonProps,
          r = this.props,
          o = r.isDisabled,
          i = r.isLoading,
          a = this.state.isFocused;
        if (!e || !i) return null;
        return /*#__PURE__*/t.createElement(e, mx({}, n, {
          innerProps: {
            "aria-hidden": "true"
          },
          isDisabled: o,
          isFocused: a
        }));
      }
    }, {
      key: "renderIndicatorSeparator",
      value: function () {
        var e = this.getComponents(),
          n = e.DropdownIndicator,
          r = e.IndicatorSeparator;
        if (!n || !r) return null;
        var o = this.commonProps,
          i = this.props.isDisabled,
          a = this.state.isFocused;
        return /*#__PURE__*/t.createElement(r, mx({}, o, {
          isDisabled: i,
          isFocused: a
        }));
      }
    }, {
      key: "renderDropdownIndicator",
      value: function () {
        var e = this.getComponents().DropdownIndicator;
        if (!e) return null;
        var n = this.commonProps,
          r = this.props.isDisabled,
          o = this.state.isFocused,
          i = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            "aria-hidden": "true"
          };
        return /*#__PURE__*/t.createElement(e, mx({}, n, {
          innerProps: i,
          isDisabled: r,
          isFocused: o
        }));
      }
    }, {
      key: "renderMenu",
      value: function () {
        var e = this,
          n = this.getComponents(),
          r = n.Group,
          o = n.GroupHeading,
          i = n.Menu,
          a = n.MenuList,
          c = n.MenuPortal,
          s = n.LoadingMessage,
          l = n.NoOptionsMessage,
          u = n.Option,
          d = this.commonProps,
          f = this.state.focusedOption,
          p = this.props,
          m = p.captureMenuScroll,
          h = p.inputValue,
          A = p.isLoading,
          g = p.loadingMessage,
          v = p.minMenuHeight,
          C = p.maxMenuHeight,
          b = p.menuIsOpen,
          E = p.menuPlacement,
          y = p.menuPosition,
          I = p.menuPortalTarget,
          B = p.menuShouldBlockScroll,
          x = p.menuShouldScrollIntoView,
          w = p.noOptionsMessage,
          Q = p.onMenuScrollToTop,
          H = p.onMenuScrollToBottom;
        if (!b) return null;
        var z,
          M = function (n, r) {
            var o = n.type,
              i = n.data,
              a = n.isDisabled,
              c = n.isSelected,
              s = n.label,
              l = n.value,
              p = f === i,
              m = a ? void 0 : function () {
                return e.onOptionHover(i);
              },
              h = a ? void 0 : function () {
                return e.selectOption(i);
              },
              A = "".concat(e.getElementId("option"), "-").concat(r),
              g = {
                id: A,
                onClick: h,
                onMouseMove: m,
                onMouseOver: m,
                tabIndex: -1
              };
            return /*#__PURE__*/t.createElement(u, mx({}, d, {
              innerProps: g,
              data: i,
              isDisabled: a,
              isSelected: c,
              key: A,
              label: s,
              type: o,
              value: l,
              isFocused: p,
              innerRef: p ? e.getFocusedOptionRef : void 0
            }), e.formatOptionLabel(n.data, "menu"));
          };
        if (this.hasOptions()) z = this.getCategorizedOptions().map(function (n) {
          if ("group" === n.type) {
            var i = n.data,
              a = n.options,
              c = n.index,
              s = "".concat(e.getElementId("group"), "-").concat(c),
              l = "".concat(s, "-heading");
            return /*#__PURE__*/t.createElement(r, mx({}, d, {
              key: s,
              data: i,
              options: a,
              Heading: o,
              headingProps: {
                id: l,
                data: n.data
              },
              label: e.formatGroupLabel(n.data)
            }), n.options.map(function (e) {
              return M(e, "".concat(c, "-").concat(e.index));
            }));
          }
          if ("option" === n.type) return M(n, "".concat(n.index));
        });else if (A) {
          var k = g({
            inputValue: h
          });
          if (null === k) return null;
          z = /*#__PURE__*/t.createElement(s, d, k);
        } else {
          var N = w({
            inputValue: h
          });
          if (null === N) return null;
          z = /*#__PURE__*/t.createElement(l, d, N);
        }
        var S = {
            minMenuHeight: v,
            maxMenuHeight: C,
            menuPlacement: E,
            menuPosition: y,
            menuShouldScrollIntoView: x
          },
          V = /*#__PURE__*/t.createElement(IH, mx({}, d, S), function (n) {
            var r = n.ref,
              o = n.placerProps,
              c = o.placement,
              s = o.maxHeight;
            return /*#__PURE__*/t.createElement(i, mx({}, d, S, {
              innerRef: r,
              innerProps: {
                onMouseDown: e.onMenuMouseDown,
                onMouseMove: e.onMenuMouseMove,
                id: e.getElementId("listbox")
              },
              isLoading: A,
              placement: c
            }), /*#__PURE__*/t.createElement(Mz, {
              captureEnabled: m,
              onTopArrive: Q,
              onBottomArrive: H,
              lockEnabled: B
            }, function (n) {
              return /*#__PURE__*/t.createElement(a, mx({}, d, {
                innerRef: function (t) {
                  e.getMenuListRef(t), n(t);
                },
                isLoading: A,
                maxHeight: s,
                focusedOption: f
              }), z);
            }));
          });
        return I || "fixed" === y ? /*#__PURE__*/t.createElement(c, mx({}, d, {
          appendTo: I,
          controlElement: this.controlRef,
          menuPlacement: E,
          menuPosition: y
        }), V) : V;
      }
    }, {
      key: "renderFormField",
      value: function () {
        var e = this,
          n = this.props,
          r = n.delimiter,
          o = n.isDisabled,
          i = n.isMulti,
          a = n.name,
          c = this.state.selectValue;
        if (a && !o) {
          if (i) {
            if (r) {
              var s = c.map(function (t) {
                return e.getOptionValue(t);
              }).join(r);
              return /*#__PURE__*/t.createElement("input", {
                name: a,
                type: "hidden",
                value: s
              });
            }
            var l = c.length > 0 ? c.map(function (n, r) {
              return /*#__PURE__*/t.createElement("input", {
                key: "i-".concat(r),
                name: a,
                type: "hidden",
                value: e.getOptionValue(n)
              });
            }) : /*#__PURE__*/t.createElement("input", {
              name: a,
              type: "hidden"
            });
            return /*#__PURE__*/t.createElement("div", null, l);
          }
          var u = c[0] ? this.getOptionValue(c[0]) : "";
          return /*#__PURE__*/t.createElement("input", {
            name: a,
            type: "hidden",
            value: u
          });
        }
      }
    }, {
      key: "renderLiveRegion",
      value: function () {
        var e = this.commonProps,
          n = this.state,
          r = n.ariaSelection,
          o = n.focusedOption,
          i = n.focusedValue,
          a = n.isFocused,
          c = n.selectValue,
          s = this.getFocusableOptions();
        return /*#__PURE__*/t.createElement(az, mx({}, e, {
          id: this.getElementId("live-region"),
          ariaSelection: r,
          focusedOption: o,
          focusedValue: i,
          isFocused: a,
          selectValue: c,
          focusableOptions: s
        }));
      }
    }, {
      key: "render",
      value: function () {
        var e = this.getComponents(),
          n = e.Control,
          r = e.IndicatorsContainer,
          o = e.SelectContainer,
          i = e.ValueContainer,
          a = this.props,
          c = a.className,
          s = a.id,
          l = a.isDisabled,
          u = a.menuIsOpen,
          d = this.state.isFocused,
          f = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/t.createElement(o, mx({}, f, {
          className: c,
          innerProps: {
            id: s,
            onKeyDown: this.onKeyDown
          },
          isDisabled: l,
          isFocused: d
        }), this.renderLiveRegion(), /*#__PURE__*/t.createElement(n, mx({}, f, {
          innerRef: this.getControlRef,
          innerProps: {
            onMouseDown: this.onControlMouseDown,
            onTouchEnd: this.onControlTouchEnd
          },
          isDisabled: l,
          isFocused: d,
          menuIsOpen: u
        }), /*#__PURE__*/t.createElement(i, mx({}, f, {
          isDisabled: l
        }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/t.createElement(r, mx({}, f, {
          isDisabled: l
        }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function (e, t) {
        var n = t.prevProps,
          r = t.clearFocusValueOnUpdate,
          o = t.inputIsHiddenAfterUpdate,
          i = t.ariaSelection,
          a = t.isFocused,
          c = t.prevWasFocused,
          s = e.options,
          l = e.value,
          u = e.menuIsOpen,
          d = e.inputValue,
          f = e.isMulti,
          p = aH(l),
          m = {};
        if (n && (l !== n.value || s !== n.options || u !== n.menuIsOpen || d !== n.inputValue)) {
          var h = u ? function (e, t) {
              return Tz(Oz(e, t));
            }(e, p) : [],
            A = r ? function (e, t) {
              var n = e.focusedValue,
                r = e.selectValue.indexOf(n);
              if (r > -1) {
                if (t.indexOf(n) > -1) return n;
                if (r < t.length) return t[r];
              }
              return null;
            }(t, p) : null,
            g = function (e, t) {
              var n = e.focusedOption;
              return n && t.indexOf(n) > -1 ? n : t[0];
            }(t, h);
          m = {
            selectValue: p,
            focusedOption: g,
            focusedValue: A,
            clearFocusValueOnUpdate: !1
          };
        }
        var v = null != o && e !== n ? {
            inputIsHidden: o,
            inputIsHiddenAfterUpdate: void 0
          } : {},
          C = i,
          b = a && c;
        return a && !b && (C = {
          value: CH(f, p, p[0] || null),
          options: p,
          action: "initial-input-focus"
        }, b = !c), "initial-input-focus" === (null == i ? void 0 : i.action) && (C = null), _Q(_Q(_Q({}, m), v), {}, {
          prevProps: e,
          ariaSelection: C,
          prevWasFocused: b
        });
      }
    }]), r;
  }();
function Uz(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        o,
        i = [],
        a = !0,
        c = !1;
      try {
        for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
      } catch (e) {
        c = !0, o = e;
      } finally {
        try {
          a || null == n.return || n.return();
        } finally {
          if (c) throw o;
        }
      }
      return i;
    }
  }(e, t) || _H(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
Xz.defaultProps = Lz;
var Kz = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Yz(e) {
  var t = e.defaultInputValue,
    r = void 0 === t ? "" : t,
    o = e.defaultMenuIsOpen,
    i = void 0 !== o && o,
    a = e.defaultValue,
    c = void 0 === a ? null : a,
    s = e.inputValue,
    u = e.menuIsOpen,
    d = e.onChange,
    f = e.onInputChange,
    p = e.onMenuClose,
    m = e.onMenuOpen,
    h = e.value,
    A = FQ(e, Kz),
    g = Uz(n(void 0 !== s ? s : r), 2),
    v = g[0],
    C = g[1],
    b = Uz(n(void 0 !== u ? u : i), 2),
    E = b[0],
    y = b[1],
    I = Uz(n(void 0 !== h ? h : c), 2),
    B = I[0],
    x = I[1],
    w = l(function (e, t) {
      "function" == typeof d && d(e, t), x(e);
    }, [d]),
    Q = l(function (e, t) {
      var n;
      "function" == typeof f && (n = f(e, t)), C(void 0 !== n ? n : e);
    }, [f]),
    H = l(function () {
      "function" == typeof m && m(), y(!0);
    }, [m]),
    z = l(function () {
      "function" == typeof p && p(), y(!1);
    }, [p]),
    M = void 0 !== s ? s : v,
    k = void 0 !== u ? u : E,
    N = void 0 !== h ? h : B;
  return _Q(_Q({}, A), {}, {
    inputValue: M,
    menuIsOpen: k,
    onChange: w,
    onInputChange: Q,
    onMenuClose: z,
    onMenuOpen: H,
    value: N
  });
}
var qz = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"],
  _z = function () {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
      t = arguments.length > 1 ? arguments[1] : void 0,
      n = arguments.length > 2 ? arguments[2] : void 0,
      r = String(e).toLowerCase(),
      o = String(n.getOptionValue(t)).toLowerCase(),
      i = String(n.getOptionLabel(t)).toLowerCase();
    return o === r || i === r;
  },
  $z = {
    formatCreateLabel: function (e) {
      return 'Create "'.concat(e, '"');
    },
    isValidNewOption: function (e, t, n, r) {
      return !(!e || t.some(function (t) {
        return _z(e, t, r);
      }) || n.some(function (t) {
        return _z(e, t, r);
      }));
    },
    getNewOptionData: function (e, t) {
      return {
        label: t,
        value: e,
        __isNew__: !0
      };
    }
  };
var eM = /*#__PURE__*/t.forwardRef(function (e, n) {
    var r = function (e) {
      var t = e.allowCreateWhileLoading,
        n = void 0 !== t && t,
        r = e.createOptionPosition,
        o = void 0 === r ? "last" : r,
        i = e.formatCreateLabel,
        a = void 0 === i ? $z.formatCreateLabel : i,
        c = e.isValidNewOption,
        u = void 0 === c ? $z.isValidNewOption : c,
        d = e.getNewOptionData,
        f = void 0 === d ? $z.getNewOptionData : d,
        p = e.onCreateOption,
        m = e.options,
        h = void 0 === m ? [] : m,
        A = e.onChange,
        g = FQ(e, qz),
        v = g.getOptionValue,
        C = void 0 === v ? Nz : v,
        b = g.getOptionLabel,
        E = void 0 === b ? kz : b,
        y = g.inputValue,
        I = g.isLoading,
        B = g.isMulti,
        x = g.value,
        w = g.name,
        Q = s(function () {
          return u(y, aH(x), h, {
            getOptionValue: C,
            getOptionLabel: E
          }) ? f(y, a(y)) : void 0;
        }, [a, f, E, C, y, u, h, x]),
        H = s(function () {
          return !n && I || !Q ? h : "first" === o ? [Q].concat($H(h)) : [].concat($H(h), [Q]);
        }, [n, o, I, Q, h]),
        z = l(function (e, t) {
          if ("select-option" !== t.action) return A(e, t);
          var n = Array.isArray(e) ? e : [e];
          if (n[n.length - 1] !== Q) A(e, t);else if (p) p(y);else {
            var r = f(y, y),
              o = {
                action: "create-option",
                name: w,
                option: r
              };
            A(CH(B, [].concat($H(aH(x)), [r]), r), o);
          }
        }, [f, y, B, w, Q, p, A, x]);
      return _Q(_Q({}, g), {}, {
        options: H,
        onChange: z
      });
    }(Yz(e));
    return /*#__PURE__*/t.createElement(Xz, mx({
      ref: n
    }, r));
  }),
  tM = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
var nM = /*#__PURE__*/t.forwardRef(function (e, i) {
    var a = function (e) {
        var t = e.defaultOptions,
          i = void 0 !== t && t,
          a = e.cacheOptions,
          c = void 0 !== a && a,
          s = e.loadOptions;
        e.options;
        var u = e.isLoading,
          d = void 0 !== u && u,
          f = e.onInputChange,
          p = e.filterOption,
          m = void 0 === p ? null : p,
          h = FQ(e, tM),
          A = h.inputValue,
          g = o(void 0),
          v = o(!1),
          C = Uz(n(Array.isArray(i) ? i : void 0), 2),
          b = C[0],
          E = C[1],
          y = Uz(n(void 0 !== A ? A : ""), 2),
          I = y[0],
          B = y[1],
          x = Uz(n(!0 === i), 2),
          w = x[0],
          Q = x[1],
          H = Uz(n(void 0), 2),
          z = H[0],
          M = H[1],
          k = Uz(n([]), 2),
          N = k[0],
          S = k[1],
          V = Uz(n(!1), 2),
          L = V[0],
          P = V[1],
          O = Uz(n({}), 2),
          T = O[0],
          D = O[1],
          R = Uz(n(void 0), 2),
          G = R[0],
          F = R[1],
          j = Uz(n(void 0), 2),
          J = j[0],
          Z = j[1];
        c !== J && (D({}), Z(c)), i !== G && (E(Array.isArray(i) ? i : void 0), F(i)), r(function () {
          return v.current = !0, function () {
            v.current = !1;
          };
        }, []);
        var W = l(function (e, t) {
          if (!s) return t();
          var n = s(e, t);
          n && "function" == typeof n.then && n.then(t, function () {
            return t();
          });
        }, [s]);
        r(function () {
          !0 === i && W(I, function (e) {
            v.current && (E(e || []), Q(!!g.current));
          });
        }, []);
        var X = l(function (e, t) {
            var n = function (e, t, n) {
              if (n) {
                var r = n(e, t);
                if ("string" == typeof r) return r;
              }
              return e;
            }(e, t, f);
            if (!n) return g.current = void 0, B(""), M(""), S([]), Q(!1), void P(!1);
            if (c && T[n]) B(n), M(n), S(T[n]), Q(!1), P(!1);else {
              var r = g.current = {};
              B(n), Q(!0), P(!z), W(n, function (e) {
                v && r === g.current && (g.current = void 0, Q(!1), M(n), S(e || []), P(!1), D(e ? _Q(_Q({}, T), {}, KQ({}, n, e)) : T));
              });
            }
          }, [c, W, z, T, f]),
          U = L ? [] : I && z ? N : b || [];
        return _Q(_Q({}, h), {}, {
          options: U,
          isLoading: w || d,
          onInputChange: X,
          filterOption: m
        });
      }(e),
      c = Yz(a);
    return /*#__PURE__*/t.createElement(Xz, mx({
      ref: i
    }, c));
  }),
  rM = function (e, t) {
    return z(z({}, t), {}, {
      color: "#505775",
      paddingTop: e ? "6px" : "8px",
      paddingBottom: e ? "6px" : "8px"
    });
  },
  oM = function (e, t) {
    return {
      container: function (e) {
        return z(z({}, e), {}, {
          width: "100%",
          fontWeight: "400",
          fontSize: "14px",
          letterSpacing: "0.015em"
        });
      },
      control: function (e) {
        return z(z({}, e), {}, {
          border: "none",
          minHeight: "28px",
          borderColor: "transparent",
          boxShadow: "none",
          "&:hover": {
            borderColor: "transparent",
            boxShadow: "none"
          }
        });
      },
      option: function (e, t) {
        return z(z({}, e), {}, {
          transition: "all 0.25s",
          backgroundColor: t.isSelected ? "#067bc2" : t.isFocused ? "#cde5f3" : "transparent",
          "&:hover": {
            backgroundColor: t.isSelected ? "#067bc2" : "#cde5f3"
          }
        });
      },
      multiValue: function (t) {
        return z(z({}, t), {}, {
          borderRadius: "4px",
          backgroundColor: "#dcdde3",
          marginTop: e ? "0" : "2px",
          marginBottom: e ? "0" : "2px"
        });
      },
      multiValueLabel: function (t) {
        return z(z({}, t), {}, {
          fontSize: e ? "0.8em" : "14px",
          lineHeight: "20px",
          paddingLeft: "8px",
          paddingRight: "4px",
          paddingTop: e ? "1px" : "3px",
          paddingBottom: e ? "1px" : "3px",
          color: "#2d3142"
        });
      },
      multiValueRemove: function (e) {
        return z(z({}, e), {}, {
          cursor: "pointer",
          fontSize: "0.8em",
          paddingRight: "6px",
          "&:hover": {
            backgroundColor: "#c6c7cc",
            color: "#2d3142"
          }
        });
      },
      input: function (t) {
        return z(z({}, t), {}, {
          marginTop: e ? "0" : "2px",
          marginBottom: e ? "0" : "2px"
        });
      },
      singleValue: function (n) {
        return z(z({}, n), {}, {
          color: "#2d3142",
          lineHeight: e ? "28px" : t ? "normal" : "32px"
        });
      },
      placeholder: function (n) {
        return z(z({}, n), {}, {
          lineHeight: e ? "28px" : t ? "normal" : "32px"
        });
      },
      dropdownIndicator: function (t) {
        return rM(e, t);
      },
      clearIndicator: function (t) {
        return rM(e, t);
      },
      valueContainer: function (t) {
        return z(z({}, t), {}, {
          paddingTop: e ? "0" : "2px",
          paddingBottom: e ? "0" : "2px",
          paddingLeft: "6px"
        });
      }
    };
  },
  iM = ["removeBottomSpacer", "inputFocused", "isDense", "isDisabled", "options", "isMulti", "isSearchable", "isClearable", "isError", "description", "removeInputWrapper", "removeIndicatorSeparator", "inputWidth", "componentType"],
  aM = function (e) {
    return /*#__PURE__*/t.createElement(y.DropdownIndicator, e, /*#__PURE__*/t.createElement(qv, {
      name: "chevronDown"
    }));
  },
  cM = function (e) {
    return /*#__PURE__*/t.createElement(y.ClearIndicator, e, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    }));
  },
  sM = function (e) {
    return /*#__PURE__*/t.createElement(y.MultiValueRemove, e, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    }));
  },
  lM = function (e) {
    var n = e.removeBottomSpacer,
      r = e.inputFocused,
      o = e.isDense,
      i = e.isDisabled,
      a = e.options,
      c = e.isMulti,
      s = e.isSearchable,
      l = e.isClearable,
      u = e.isError,
      d = e.description,
      f = e.removeInputWrapper,
      p = e.removeIndicatorSeparator,
      m = e.inputWidth,
      h = e.componentType,
      A = S(e, iM),
      g = p ? {
        DropdownIndicator: aM,
        ClearIndicator: cM,
        MultiValueRemove: sM,
        IndicatorSeparator: function () {
          return null;
        }
      } : {
        DropdownIndicator: aM,
        ClearIndicator: cM,
        MultiValueRemove: sM
      },
      v = /*#__PURE__*/t.createElement(sb, {
        flexGrow: 1
      }, /*#__PURE__*/t.createElement(E, N({
        className: o ? "react-select-is-dense" : "",
        styles: oM(o, s),
        options: a,
        isDisabled: i,
        isMulti: c,
        isSearchable: s,
        isClearable: l,
        components: g
      }, A))),
      C = /*#__PURE__*/t.createElement(sb, {
        flexGrow: 1
      }, /*#__PURE__*/t.createElement(nM, N({
        className: o ? "react-select-is-dense" : "",
        styles: oM(o, s),
        options: a,
        isDisabled: i,
        isMulti: c,
        isSearchable: s,
        isClearable: l,
        components: g
      }, A))),
      b = /*#__PURE__*/t.createElement(sb, {
        flexGrow: 1
      }, /*#__PURE__*/t.createElement(eM, N({
        className: o ? "react-select-is-dense" : "",
        styles: oM(o, s),
        options: a,
        isDisabled: i,
        isMulti: c,
        isSearchable: s,
        isClearable: l,
        components: g
      }, A))),
      y = function () {
        switch (h) {
          case "async":
            return C;
          case "createable":
            return b;
          default:
            return v;
        }
      };
    return f ? y() : /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(qb, {
      removeBottomSpacer: n,
      isActive: r,
      isDisabled: i,
      description: d,
      isError: u,
      inputWidth: m,
      customColor: A.customColor
    }, y()));
  };
lM.propTypes = {
  onChange: g.func,
  isDisabled: g.bool,
  options: g.array.isRequired,
  description: g.string,
  isMulti: g.bool,
  isSearchable: g.bool,
  isClearable: g.bool,
  inputFocused: g.bool,
  isDense: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  removeInputWrapper: g.bool,
  removeIndicatorSeparator: g.bool,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"]),
  componentType: g.oneOf(["default", "async", "createable"])
}, lM.defaultProps = {
  componentType: "default"
};
var uM = "inputText-module_inputText__icon__2EepJ",
  dM = "inputText-module_isDense__1-Zup",
  fM = "inputText-module_inputText__input__1lYn_",
  pM = "inputText-module_hasIconLeft__3Zhvh",
  mM = "inputText-module_hasIconRight__1SuNy",
  hM = "inputText-module_isDisabled__3izar",
  AM = "inputText-module_clearButton__31BIb",
  gM = ["prependIcon", "appendIcon", "inputFocused", "isDense", "className", "removeBottomSpacer", "isDisabled", "onBlur", "onFocus", "isError", "description", "addSuffix", "addPrefix", "wrapperClassName", "onClear", "removeInputWrapper", "inputWidth", "useCharacterCount", "characterCount", "characterCountTotal"],
  vM = function (e) {
    var r,
      i = e.prependIcon,
      a = e.appendIcon,
      c = e.inputFocused,
      s = e.isDense,
      l = e.className,
      u = e.removeBottomSpacer,
      d = e.isDisabled,
      f = e.onBlur,
      p = e.onFocus,
      m = e.isError,
      h = e.description,
      A = e.addSuffix,
      g = e.addPrefix,
      v = e.wrapperClassName,
      C = e.onClear,
      b = e.removeInputWrapper,
      E = e.inputWidth,
      y = e.useCharacterCount,
      I = e.characterCount,
      B = e.characterCountTotal,
      x = S(e, gM),
      w = V(n(!1), 2),
      Q = w[0],
      H = w[1],
      z = o(null),
      M = x.inlineEditOnSubmit || null,
      L = x.inlineEditOnCancel || null,
      P = x.inlineEditSubmitIsDisabled || !1;
    delete x.inlineEditOnSubmit, delete x.inlineEditOnCancel, delete x.inlineEditSubmitIsDisabled;
    var O = /*#__PURE__*/t.createElement(t.Fragment, null, i && /*#__PURE__*/t.createElement(nb, {
      className: tC(uM, k({}, dM, s)),
      onClick: function () {
        z.current.focus();
      }
    }, /*#__PURE__*/t.createElement("span", null, i)), /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1
    }, /*#__PURE__*/t.createElement(RC, N({
      renderAs: "input",
      type: "text",
      domRef: z,
      className: tC(fM, (r = {}, k(r, dM, s), k(r, pM, i), k(r, mM, a), k(r, hM, d), r), l),
      disabled: d,
      onBlur: function (e) {
        H(!1), f && f(e);
      },
      onFocus: function (e) {
        H(!0), p && p(e);
      }
    }, x))), a && /*#__PURE__*/t.createElement(nb, {
      className: tC(uM, k({}, dM, s)),
      onClick: function () {
        z.current.focus();
      }
    }, /*#__PURE__*/t.createElement("span", null, a)), C && "" !== x.value && /*#__PURE__*/t.createElement(RC, {
      renderAs: "button",
      onClick: C,
      className: tC(AM, k({}, dM, s))
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    })));
    return b ? O : /*#__PURE__*/t.createElement(qb, {
      removeBottomSpacer: u,
      isActive: c || Q,
      isDisabled: d,
      description: h,
      isError: m,
      addPrefix: g,
      addSuffix: A,
      className: v,
      inputWidth: E,
      inlineEditOnSubmit: M,
      inlineEditOnCancel: L,
      inlineEditSubmitIsDisabled: P,
      useCharacterCount: y,
      characterCount: I,
      characterCountTotal: B,
      customColor: x.customColor
    }, O);
  };
vM.propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  prependIcon: g.oneOfType([g.node, g.string]),
  appendIcon: g.oneOfType([g.node, g.string]),
  onFocus: g.func,
  onBlur: g.func,
  inputFocused: g.bool,
  isDense: g.bool,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  addPrefix: g.string,
  addSuffix: g.string,
  description: g.string,
  onClear: g.func,
  placeholder: g.string,
  className: g.string,
  wrapperClassName: g.string,
  removeInputWrapper: g.bool,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"]),
  characterCount: g.number,
  characterCountTotal: g.number,
  useCharacterCount: g.bool
};
var CM = "InputTextarea-module_isDisabled__TYLA7",
  bM = "InputTextarea-module_textarea__3srYQ",
  EM = function () {
    return EM = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, EM.apply(this, arguments);
  };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function yM(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
var IM,
  BM,
  xM,
  wM = Object.keys,
  QM = function (e, t) {
    if (t) {
      var n = "hidden",
        r = window.getComputedStyle(t).maxHeight;
      if ("none" !== r) parseFloat(r) < t.scrollHeight && (n = "");
      t.style.height = "0", t.style.overflowY = n, t.style.height = "".concat(function (e, t) {
        var n = window.getComputedStyle(t),
          r = n.borderBottomWidth,
          o = n.borderTopWidth,
          i = n.fontSize,
          a = n.lineHeight,
          c = n.paddingBottom,
          s = n.paddingTop,
          l = "normal" === a ? 1.2 * parseFloat(i) : parseFloat(a),
          u = 0 === e ? 0 : l * e + parseFloat(r) + parseFloat(o) + parseFloat(c) + parseFloat(s),
          d = t.scrollHeight + parseFloat(r) + parseFloat(o);
        return Math.max(u, d);
      }(e, t), "px");
    }
  },
  HM = function (e) {
    var t = o(e),
      n = o(0);
    return function (e, t) {
      if (e === t) return !0;
      if (!(e instanceof Object && t instanceof Object)) return !1;
      for (var n = wM(e), r = n.length, o = 0; o < r; o++) if (!(n[o] in t)) return !1;
      for (o = 0; o < r; o++) if (e[n[o]] !== t[n[o]]) return !1;
      return r === wM(t).length;
    }(e, t.current) || (t.current = e, n.current += 1), s(function () {
      return t.current;
    }, [n.current]);
  },
  zM = (IM = function (e) {
    var n = e.forwardedRef,
      r = yM(e, ["forwardedRef"]),
      i = "function" == typeof n,
      a = HM(r.style),
      c = o(),
      s = i || !n ? c : n,
      u = r.rows ? parseInt("" + r.rows, 10) : 0,
      d = r.onChange,
      f = r.onInput,
      m = yM(r, ["onChange", "onInput"]);
    p(function () {
      QM(u, s.current);
    }, [r.className, r.value, s, u, a]), p(function () {
      if (window.ResizeObserver) {
        var e = new ResizeObserver(function () {
          QM(u, s.current);
        });
        return e.observe(s.current), function () {
          e.disconnect();
        };
      }
    }, [s, u]);
    var h = l(function (e) {
        d && d(e), f && f(e), QM(u, s.current);
      }, [d, f, s, u]),
      A = l(function (e) {
        s.current = e, i && n(e);
      }, [n, i, s]);
    return /*#__PURE__*/t.createElement("textarea", EM({}, m, {
      onInput: h,
      ref: A,
      rows: u
    }));
  }, BM = function (e, n) {
    return /*#__PURE__*/t.createElement(IM, EM({}, e, {
      forwardedRef: n
    }));
  }, xM = IM.displayName || IM.name, BM.displayName = "withForwardedRef(" + xM + ")", /*#__PURE__*/c(BM)),
  MM = ["inputFocused", "className", "removeBottomSpacer", "isDisabled", "onBlur", "onFocus", "isError", "description", "rows", "inputWidth", "useCharacterCount", "characterCount", "characterCountTotal"],
  kM = function (e) {
    var r = e.inputFocused,
      o = e.className,
      i = e.removeBottomSpacer,
      a = e.isDisabled,
      c = e.onBlur,
      s = e.onFocus,
      l = e.isError,
      u = e.description,
      d = e.rows,
      f = e.inputWidth,
      p = e.useCharacterCount,
      m = e.characterCount,
      h = e.characterCountTotal,
      A = S(e, MM),
      g = V(n(!1), 2),
      v = g[0],
      C = g[1];
    return /*#__PURE__*/t.createElement(qb, {
      removeBottomSpacer: i,
      isActive: r || v,
      isDisabled: a,
      description: u,
      isError: l,
      inputWidth: f,
      useCharacterCount: p,
      characterCount: m,
      characterCountTotal: h,
      customColor: A.customColor
    }, /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1
    }, /*#__PURE__*/t.createElement(zM, N({
      className: tC(bM, k({}, CM, a), o),
      onBlur: function (e) {
        C(!1), c && c(e);
      },
      onFocus: function (e) {
        C(!0), s && s(e);
      },
      rows: d
    }, A))));
  };
kM.propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  rows: g.number,
  inputFocused: g.bool,
  onFocus: g.func,
  onBlur: g.func,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  description: g.string,
  placeholder: g.string,
  className: g.string,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"]),
  characterCount: g.number,
  characterCountTotal: g.number,
  useCharacterCount: g.bool
}, kM.defaultProps = {
  rows: 3
};
var NM = {
    wrapper: "InputRadioButton-module_wrapper__3cDGA",
    customRadioButton: "InputRadioButton-module_customRadioButton__3qC-h",
    isChecked: "InputRadioButton-module_isChecked__22sVL",
    custom: "InputRadioButton-module_custom__3AJJY",
    hiddenRadioButton: "InputRadioButton-module_hiddenRadioButton__RliTJ",
    label: "InputRadioButton-module_label__3izAq"
  },
  SM = ["groupName", "removeBottomSpacer", "children", "value", "onClick", "checked", "className", "customColor"],
  VM = function (e) {
    var o,
      i,
      a = e.groupName,
      c = e.removeBottomSpacer,
      s = e.children,
      l = e.value,
      u = e.onClick,
      d = e.checked,
      f = e.className,
      p = e.customColor,
      m = S(e, SM),
      h = V(n(d || !1), 2),
      A = h[0],
      g = h[1];
    return r(function () {
      void 0 !== d && g(d);
    }, [d]), r(function () {
      p && document.documentElement.style.setProperty("--radio-button-color", p);
    }, [p]), /*#__PURE__*/t.createElement(sb, {
      renderAs: "label",
      className: tC(NM.wrapper, k({}, NM.custom, p), f),
      paddingBottom: c ? null : "xs",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement("input", N({}, m, {
      type: "radio",
      className: NM.hiddenRadioButton,
      onClick: function (e) {
        u(e);
      },
      value: l,
      name: a
    })), /*#__PURE__*/t.createElement(nb, {
      className: tC(NM.customRadioButton, (o = {}, k(o, NM.isChecked, A), k(o, NM.custom, p), o))
    }, /*#__PURE__*/t.createElement("span", {
      className: tC(NM.circle, (i = {}, k(i, NM.isChecked, A), k(i, NM.custom, p), i))
    })), s && /*#__PURE__*/t.createElement(nb, {
      paddingLeft: "xs",
      className: tC(NM.label, k({}, NM.isChecked, A))
    }, s));
  };
VM.propTypes = {
  onClick: g.func.isRequired,
  groupName: g.string,
  removeBottomSpacer: g.bool,
  value: g.string,
  checked: g.bool,
  children: g.oneOfType([g.string, g.node]),
  className: g.string,
  customColor: g.string
};
var LM = {
    exports: {}
  },
  PM = {};
Object.defineProperty(PM, "__esModule", {
  value: !0
});
var OM = t;
function TM() {
  return TM = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, TM.apply(this, arguments);
}
var DM = OM.createElement("svg", {
    viewBox: "-2 -5 14 20",
    height: "100%",
    width: "100%",
    style: {
      position: "absolute",
      top: 0
    }
  }, OM.createElement("path", {
    d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
    fill: "#fff",
    fillRule: "evenodd"
  })),
  RM = OM.createElement("svg", {
    height: "100%",
    width: "100%",
    viewBox: "-2 -5 17 21",
    style: {
      position: "absolute",
      top: 0
    }
  }, OM.createElement("path", {
    d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
    fill: "#fff",
    fillRule: "evenodd"
  }));
function GM(e) {
  if (7 === e.length) return e;
  for (var t = "#", n = 1; n < 4; n += 1) t += e[n] + e[n];
  return t;
}
function FM(e, t, n, r, o) {
  return function (e, t, n, r, o) {
    var i = (e - n) / (t - n);
    if (0 === i) return r;
    if (1 === i) return o;
    for (var a = "#", c = 1; c < 6; c += 2) {
      var s = parseInt(r.substr(c, 2), 16),
        l = parseInt(o.substr(c, 2), 16),
        u = Math.round((1 - i) * s + i * l).toString(16);
      1 === u.length && (u = "0" + u), a += u;
    }
    return a;
  }(e, t, n, GM(r), GM(o));
}
var jM = function (e) {
  function t(t) {
    e.call(this, t);
    var n = t.height,
      r = t.width,
      o = t.checked;
    this.t = t.handleDiameter || n - 2, this.i = Math.max(r - n, r - (n + this.t) / 2), this.o = Math.max(0, (n - this.t) / 2), this.state = {
      h: o ? this.i : this.o
    }, this.l = 0, this.u = 0, this.p = this.p.bind(this), this.v = this.v.bind(this), this.g = this.g.bind(this), this.k = this.k.bind(this), this.M = this.M.bind(this), this.m = this.m.bind(this), this.T = this.T.bind(this), this.$ = this.$.bind(this), this.C = this.C.bind(this), this.O = this.O.bind(this), this.D = this.D.bind(this), this.S = this.S.bind(this);
  }
  return e && (t.__proto__ = e), (t.prototype = Object.create(e && e.prototype)).constructor = t, t.prototype.componentDidMount = function () {
    this.W = !0;
  }, t.prototype.componentDidUpdate = function (e) {
    e.checked !== this.props.checked && this.setState({
      h: this.props.checked ? this.i : this.o
    });
  }, t.prototype.componentWillUnmount = function () {
    this.W = !1;
  }, t.prototype.I = function (e) {
    this.H.focus(), this.setState({
      j: e,
      R: !0,
      B: Date.now()
    });
  }, t.prototype.L = function (e) {
    var t = this.state,
      n = t.j,
      r = t.h,
      o = (this.props.checked ? this.i : this.o) + e - n;
    t.N || e === n || this.setState({
      N: !0
    });
    var i = Math.min(this.i, Math.max(this.o, o));
    i !== r && this.setState({
      h: i
    });
  }, t.prototype.U = function (e) {
    var t = this.state,
      n = t.h,
      r = t.N,
      o = t.B,
      i = this.props.checked,
      a = (this.i + this.o) / 2;
    this.setState({
      h: this.props.checked ? this.i : this.o
    });
    var c = Date.now() - o;
    (!r || c < 250 || i && n <= a || !i && n >= a) && this.A(e), this.W && this.setState({
      N: !1,
      R: !1
    }), this.l = Date.now();
  }, t.prototype.p = function (e) {
    e.preventDefault(), "number" == typeof e.button && 0 !== e.button || (this.I(e.clientX), window.addEventListener("mousemove", this.v), window.addEventListener("mouseup", this.g));
  }, t.prototype.v = function (e) {
    e.preventDefault(), this.L(e.clientX);
  }, t.prototype.g = function (e) {
    this.U(e), window.removeEventListener("mousemove", this.v), window.removeEventListener("mouseup", this.g);
  }, t.prototype.k = function (e) {
    this.X = null, this.I(e.touches[0].clientX);
  }, t.prototype.M = function (e) {
    this.L(e.touches[0].clientX);
  }, t.prototype.m = function (e) {
    e.preventDefault(), this.U(e);
  }, t.prototype.$ = function (e) {
    Date.now() - this.l > 50 && (this.A(e), Date.now() - this.u > 50 && this.W && this.setState({
      R: !1
    }));
  }, t.prototype.C = function () {
    this.u = Date.now();
  }, t.prototype.O = function () {
    this.setState({
      R: !0
    });
  }, t.prototype.D = function () {
    this.setState({
      R: !1
    });
  }, t.prototype.S = function (e) {
    this.H = e;
  }, t.prototype.T = function (e) {
    e.preventDefault(), this.H.focus(), this.A(e), this.W && this.setState({
      R: !1
    });
  }, t.prototype.A = function (e) {
    var t = this.props;
    (0, t.onChange)(!t.checked, e, t.id);
  }, t.prototype.render = function () {
    var e = this.props,
      t = e.checked,
      n = e.disabled,
      r = e.className,
      o = e.offColor,
      i = e.onColor,
      a = e.offHandleColor,
      c = e.onHandleColor,
      s = e.checkedIcon,
      l = e.uncheckedIcon,
      u = e.checkedHandleIcon,
      d = e.uncheckedHandleIcon,
      f = e.boxShadow,
      p = e.activeBoxShadow,
      m = e.height,
      h = e.width,
      A = e.borderRadius,
      g = function (e, t) {
        var n = {};
        for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && -1 === t.indexOf(r) && (n[r] = e[r]);
        return n;
      }(e, ["checked", "disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "checkedHandleIcon", "uncheckedHandleIcon", "boxShadow", "activeBoxShadow", "height", "width", "borderRadius", "handleDiameter"]),
      v = this.state,
      C = v.h,
      b = v.N,
      E = v.R,
      y = {
        position: "relative",
        display: "inline-block",
        textAlign: "left",
        opacity: n ? .5 : 1,
        direction: "ltr",
        borderRadius: m / 2,
        WebkitTransition: "opacity 0.25s",
        MozTransition: "opacity 0.25s",
        transition: "opacity 0.25s",
        touchAction: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
        userSelect: "none"
      },
      I = {
        height: m,
        width: h,
        margin: Math.max(0, (this.t - m) / 2),
        position: "relative",
        background: FM(C, this.i, this.o, o, i),
        borderRadius: "number" == typeof A ? A : m / 2,
        cursor: n ? "default" : "pointer",
        WebkitTransition: b ? null : "background 0.25s",
        MozTransition: b ? null : "background 0.25s",
        transition: b ? null : "background 0.25s"
      },
      B = {
        height: m,
        width: Math.min(1.5 * m, h - (this.t + m) / 2 + 1),
        position: "relative",
        opacity: (C - this.o) / (this.i - this.o),
        pointerEvents: "none",
        WebkitTransition: b ? null : "opacity 0.25s",
        MozTransition: b ? null : "opacity 0.25s",
        transition: b ? null : "opacity 0.25s"
      },
      x = {
        height: m,
        width: Math.min(1.5 * m, h - (this.t + m) / 2 + 1),
        position: "absolute",
        opacity: 1 - (C - this.o) / (this.i - this.o),
        right: 0,
        top: 0,
        pointerEvents: "none",
        WebkitTransition: b ? null : "opacity 0.25s",
        MozTransition: b ? null : "opacity 0.25s",
        transition: b ? null : "opacity 0.25s"
      },
      w = {
        height: this.t,
        width: this.t,
        background: FM(C, this.i, this.o, a, c),
        display: "inline-block",
        cursor: n ? "default" : "pointer",
        borderRadius: "number" == typeof A ? A - 1 : "50%",
        position: "absolute",
        transform: "translateX(" + C + "px)",
        top: Math.max(0, (m - this.t) / 2),
        outline: 0,
        boxShadow: E ? p : f,
        border: 0,
        WebkitTransition: b ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
        MozTransition: b ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
        transition: b ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
      },
      Q = {
        height: this.t,
        width: this.t,
        opacity: Math.max(2 * (1 - (C - this.o) / (this.i - this.o) - .5), 0),
        position: "absolute",
        left: 0,
        top: 0,
        pointerEvents: "none",
        WebkitTransition: b ? null : "opacity 0.25s",
        MozTransition: b ? null : "opacity 0.25s",
        transition: b ? null : "opacity 0.25s"
      },
      H = {
        height: this.t,
        width: this.t,
        opacity: Math.max(2 * ((C - this.o) / (this.i - this.o) - .5), 0),
        position: "absolute",
        left: 0,
        top: 0,
        pointerEvents: "none",
        WebkitTransition: b ? null : "opacity 0.25s",
        MozTransition: b ? null : "opacity 0.25s",
        transition: b ? null : "opacity 0.25s"
      };
    return OM.createElement("div", {
      className: r,
      style: y
    }, OM.createElement("div", {
      className: "react-switch-bg",
      style: I,
      onClick: n ? null : this.T,
      onMouseDown: function (e) {
        return e.preventDefault();
      }
    }, s && OM.createElement("div", {
      style: B
    }, s), l && OM.createElement("div", {
      style: x
    }, l)), OM.createElement("div", {
      className: "react-switch-handle",
      style: w,
      onClick: function (e) {
        return e.preventDefault();
      },
      onMouseDown: n ? null : this.p,
      onTouchStart: n ? null : this.k,
      onTouchMove: n ? null : this.M,
      onTouchEnd: n ? null : this.m,
      onTouchCancel: n ? null : this.D
    }, d && OM.createElement("div", {
      style: Q
    }, d), u && OM.createElement("div", {
      style: H
    }, u)), OM.createElement("input", TM({}, {
      type: "checkbox",
      role: "switch",
      "aria-checked": t,
      checked: t,
      disabled: n,
      style: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: 1,
        margin: -1,
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        width: 1
      }
    }, g, {
      ref: this.S,
      onFocus: this.O,
      onBlur: this.D,
      onKeyUp: this.C,
      onChange: this.$
    })));
  }, t;
}(OM.Component);
jM.defaultProps = {
  disabled: !1,
  offColor: "#888",
  onColor: "#080",
  offHandleColor: "#fff",
  onHandleColor: "#fff",
  uncheckedIcon: DM,
  checkedIcon: RM,
  boxShadow: null,
  activeBoxShadow: "0 0 2px 3px #3bf",
  height: 28,
  width: 56
}, PM.default = jM;
var JM = {};
!function (e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var n = t,
    r = g;
  function o() {
    return o = Object.assign ? Object.assign.bind() : function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];
        for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
      }
      return e;
    }, o.apply(this, arguments);
  }
  var i = n.createElement("svg", {
      viewBox: "-2 -5 14 20",
      height: "100%",
      width: "100%",
      style: {
        position: "absolute",
        top: 0
      }
    }, n.createElement("path", {
      d: "M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",
      fill: "#fff",
      fillRule: "evenodd"
    })),
    a = n.createElement("svg", {
      height: "100%",
      width: "100%",
      viewBox: "-2 -5 17 21",
      style: {
        position: "absolute",
        top: 0
      }
    }, n.createElement("path", {
      d: "M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",
      fill: "#fff",
      fillRule: "evenodd"
    }));
  function c(e) {
    if (7 === e.length) return e;
    for (var t = "#", n = 1; n < 4; n += 1) t += e[n] + e[n];
    return t;
  }
  function s(e, t, n, r, o) {
    return function (e, t, n, r, o) {
      var i = (e - n) / (t - n);
      if (0 === i) return r;
      if (1 === i) return o;
      for (var a = "#", c = 1; c < 6; c += 2) {
        var s = parseInt(r.substr(c, 2), 16),
          l = parseInt(o.substr(c, 2), 16),
          u = Math.round((1 - i) * s + i * l).toString(16);
        1 === u.length && (u = "0" + u), a += u;
      }
      return a;
    }(e, t, n, c(r), c(o));
  }
  var l = function (e, t, n) {
    var r = e[t];
    return "string" != typeof r || "#" !== r[0] || 4 !== r.length && 7 !== r.length ? new Error("Invalid prop '" + t + "' supplied to '" + n + "'. '" + t + "' has to be either a 3-digit or 6-digit hex-color string. Valid examples: '#abc', '#123456'") : null;
  };
  var u = function (e) {
    function t(t) {
      e.call(this, t);
      var n = t.height,
        r = t.width,
        o = t.handleDiameter,
        i = t.checked;
      this.$handleDiameter = o || n - 2, this.$checkedPos = Math.max(r - n, r - (n + this.$handleDiameter) / 2), this.$uncheckedPos = Math.max(0, (n - this.$handleDiameter) / 2), this.state = {
        $pos: i ? this.$checkedPos : this.$uncheckedPos
      }, this.$lastDragAt = 0, this.$lastKeyUpAt = 0, this.$onMouseDown = this.$onMouseDown.bind(this), this.$onMouseMove = this.$onMouseMove.bind(this), this.$onMouseUp = this.$onMouseUp.bind(this), this.$onTouchStart = this.$onTouchStart.bind(this), this.$onTouchMove = this.$onTouchMove.bind(this), this.$onTouchEnd = this.$onTouchEnd.bind(this), this.$onClick = this.$onClick.bind(this), this.$onInputChange = this.$onInputChange.bind(this), this.$onKeyUp = this.$onKeyUp.bind(this), this.$setHasOutline = this.$setHasOutline.bind(this), this.$unsetHasOutline = this.$unsetHasOutline.bind(this), this.$getInputRef = this.$getInputRef.bind(this);
    }
    return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.componentDidMount = function () {
      this.$isMounted = !0;
    }, t.prototype.componentDidUpdate = function (e) {
      if (e.checked !== this.props.checked) {
        var t = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
        this.setState({
          $pos: t
        });
      }
    }, t.prototype.componentWillUnmount = function () {
      this.$isMounted = !1;
    }, t.prototype.$onDragStart = function (e) {
      this.$inputRef.focus(), this.setState({
        $startX: e,
        $hasOutline: !0,
        $dragStartingTime: Date.now()
      });
    }, t.prototype.$onDrag = function (e) {
      var t = this.state,
        n = t.$startX,
        r = t.$isDragging,
        o = t.$pos,
        i = (this.props.checked ? this.$checkedPos : this.$uncheckedPos) + e - n;
      r || e === n || this.setState({
        $isDragging: !0
      });
      var a = Math.min(this.$checkedPos, Math.max(this.$uncheckedPos, i));
      a !== o && this.setState({
        $pos: a
      });
    }, t.prototype.$onDragStop = function (e) {
      var t = this.state,
        n = t.$pos,
        r = t.$isDragging,
        o = t.$dragStartingTime,
        i = this.props.checked,
        a = (this.$checkedPos + this.$uncheckedPos) / 2,
        c = this.props.checked ? this.$checkedPos : this.$uncheckedPos;
      this.setState({
        $pos: c
      });
      var s = Date.now() - o;
      (!r || s < 250 || i && n <= a || !i && n >= a) && this.$onChange(e), this.$isMounted && this.setState({
        $isDragging: !1,
        $hasOutline: !1
      }), this.$lastDragAt = Date.now();
    }, t.prototype.$onMouseDown = function (e) {
      e.preventDefault(), "number" == typeof e.button && 0 !== e.button || (this.$onDragStart(e.clientX), window.addEventListener("mousemove", this.$onMouseMove), window.addEventListener("mouseup", this.$onMouseUp));
    }, t.prototype.$onMouseMove = function (e) {
      e.preventDefault(), this.$onDrag(e.clientX);
    }, t.prototype.$onMouseUp = function (e) {
      this.$onDragStop(e), window.removeEventListener("mousemove", this.$onMouseMove), window.removeEventListener("mouseup", this.$onMouseUp);
    }, t.prototype.$onTouchStart = function (e) {
      this.$checkedStateFromDragging = null, this.$onDragStart(e.touches[0].clientX);
    }, t.prototype.$onTouchMove = function (e) {
      this.$onDrag(e.touches[0].clientX);
    }, t.prototype.$onTouchEnd = function (e) {
      e.preventDefault(), this.$onDragStop(e);
    }, t.prototype.$onInputChange = function (e) {
      Date.now() - this.$lastDragAt > 50 && (this.$onChange(e), Date.now() - this.$lastKeyUpAt > 50 && this.$isMounted && this.setState({
        $hasOutline: !1
      }));
    }, t.prototype.$onKeyUp = function () {
      this.$lastKeyUpAt = Date.now();
    }, t.prototype.$setHasOutline = function () {
      this.setState({
        $hasOutline: !0
      });
    }, t.prototype.$unsetHasOutline = function () {
      this.setState({
        $hasOutline: !1
      });
    }, t.prototype.$getInputRef = function (e) {
      this.$inputRef = e;
    }, t.prototype.$onClick = function (e) {
      e.preventDefault(), this.$inputRef.focus(), this.$onChange(e), this.$isMounted && this.setState({
        $hasOutline: !1
      });
    }, t.prototype.$onChange = function (e) {
      var t = this.props,
        n = t.checked;
      (0, t.onChange)(!n, e, t.id);
    }, t.prototype.render = function () {
      var e = this.props,
        t = e.checked,
        r = e.disabled,
        i = e.className,
        a = e.offColor,
        c = e.onColor,
        l = e.offHandleColor,
        u = e.onHandleColor,
        d = e.checkedIcon,
        f = e.uncheckedIcon,
        p = e.checkedHandleIcon,
        m = e.uncheckedHandleIcon,
        h = e.boxShadow,
        A = e.activeBoxShadow,
        g = e.height,
        v = e.width,
        C = e.borderRadius;
      e.handleDiameter;
      var b = function (e, t) {
          var n = {};
          for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && -1 === t.indexOf(r) && (n[r] = e[r]);
          return n;
        }(e, ["checked", "disabled", "className", "offColor", "onColor", "offHandleColor", "onHandleColor", "checkedIcon", "uncheckedIcon", "checkedHandleIcon", "uncheckedHandleIcon", "boxShadow", "activeBoxShadow", "height", "width", "borderRadius", "handleDiameter"]),
        E = b,
        y = this.state,
        I = y.$pos,
        B = y.$isDragging,
        x = y.$hasOutline,
        w = {
          position: "relative",
          display: "inline-block",
          textAlign: "left",
          opacity: r ? .5 : 1,
          direction: "ltr",
          borderRadius: g / 2,
          WebkitTransition: "opacity 0.25s",
          MozTransition: "opacity 0.25s",
          transition: "opacity 0.25s",
          touchAction: "none",
          WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
          userSelect: "none"
        },
        Q = {
          height: g,
          width: v,
          margin: Math.max(0, (this.$handleDiameter - g) / 2),
          position: "relative",
          background: s(I, this.$checkedPos, this.$uncheckedPos, a, c),
          borderRadius: "number" == typeof C ? C : g / 2,
          cursor: r ? "default" : "pointer",
          WebkitTransition: B ? null : "background 0.25s",
          MozTransition: B ? null : "background 0.25s",
          transition: B ? null : "background 0.25s"
        },
        H = {
          height: g,
          width: Math.min(1.5 * g, v - (this.$handleDiameter + g) / 2 + 1),
          position: "relative",
          opacity: (I - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
          pointerEvents: "none",
          WebkitTransition: B ? null : "opacity 0.25s",
          MozTransition: B ? null : "opacity 0.25s",
          transition: B ? null : "opacity 0.25s"
        },
        z = {
          height: g,
          width: Math.min(1.5 * g, v - (this.$handleDiameter + g) / 2 + 1),
          position: "absolute",
          opacity: 1 - (I - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos),
          right: 0,
          top: 0,
          pointerEvents: "none",
          WebkitTransition: B ? null : "opacity 0.25s",
          MozTransition: B ? null : "opacity 0.25s",
          transition: B ? null : "opacity 0.25s"
        },
        M = {
          height: this.$handleDiameter,
          width: this.$handleDiameter,
          background: s(I, this.$checkedPos, this.$uncheckedPos, l, u),
          display: "inline-block",
          cursor: r ? "default" : "pointer",
          borderRadius: "number" == typeof C ? C - 1 : "50%",
          position: "absolute",
          transform: "translateX(" + I + "px)",
          top: Math.max(0, (g - this.$handleDiameter) / 2),
          outline: 0,
          boxShadow: x ? A : h,
          border: 0,
          WebkitTransition: B ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
          MozTransition: B ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s",
          transition: B ? null : "background-color 0.25s, transform 0.25s, box-shadow 0.15s"
        },
        k = {
          height: this.$handleDiameter,
          width: this.$handleDiameter,
          opacity: Math.max(2 * (1 - (I - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - .5), 0),
          position: "absolute",
          left: 0,
          top: 0,
          pointerEvents: "none",
          WebkitTransition: B ? null : "opacity 0.25s",
          MozTransition: B ? null : "opacity 0.25s",
          transition: B ? null : "opacity 0.25s"
        },
        N = {
          height: this.$handleDiameter,
          width: this.$handleDiameter,
          opacity: Math.max(2 * ((I - this.$uncheckedPos) / (this.$checkedPos - this.$uncheckedPos) - .5), 0),
          position: "absolute",
          left: 0,
          top: 0,
          pointerEvents: "none",
          WebkitTransition: B ? null : "opacity 0.25s",
          MozTransition: B ? null : "opacity 0.25s",
          transition: B ? null : "opacity 0.25s"
        };
      return n.createElement("div", {
        className: i,
        style: w
      }, n.createElement("div", {
        className: "react-switch-bg",
        style: Q,
        onClick: r ? null : this.$onClick,
        onMouseDown: function (e) {
          return e.preventDefault();
        }
      }, d && n.createElement("div", {
        style: H
      }, d), f && n.createElement("div", {
        style: z
      }, f)), n.createElement("div", {
        className: "react-switch-handle",
        style: M,
        onClick: function (e) {
          return e.preventDefault();
        },
        onMouseDown: r ? null : this.$onMouseDown,
        onTouchStart: r ? null : this.$onTouchStart,
        onTouchMove: r ? null : this.$onTouchMove,
        onTouchEnd: r ? null : this.$onTouchEnd,
        onTouchCancel: r ? null : this.$unsetHasOutline
      }, m && n.createElement("div", {
        style: k
      }, m), p && n.createElement("div", {
        style: N
      }, p)), n.createElement("input", o({}, {
        type: "checkbox",
        role: "switch",
        "aria-checked": t,
        checked: t,
        disabled: r,
        style: {
          border: 0,
          clip: "rect(0 0 0 0)",
          height: 1,
          margin: -1,
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: 1
        }
      }, E, {
        ref: this.$getInputRef,
        onFocus: this.$setHasOutline,
        onBlur: this.$unsetHasOutline,
        onKeyUp: this.$onKeyUp,
        onChange: this.$onInputChange
      })));
    }, t;
  }(n.Component);
  u.propTypes = {
    checked: r.bool.isRequired,
    onChange: r.func.isRequired,
    disabled: r.bool,
    offColor: l,
    onColor: l,
    offHandleColor: l,
    onHandleColor: l,
    handleDiameter: r.number,
    uncheckedIcon: r.oneOfType([r.bool, r.element]),
    checkedIcon: r.oneOfType([r.bool, r.element]),
    boxShadow: r.string,
    borderRadius: r.number,
    activeBoxShadow: r.string,
    uncheckedHandleIcon: r.element,
    checkedHandleIcon: r.element,
    height: r.number,
    width: r.number,
    id: r.string,
    className: r.string
  }, u.defaultProps = {
    disabled: !1,
    offColor: "#888",
    onColor: "#080",
    offHandleColor: "#fff",
    onHandleColor: "#fff",
    uncheckedIcon: i,
    checkedIcon: a,
    boxShadow: null,
    activeBoxShadow: "0 0 2px 3px #3bf",
    height: 28,
    width: 56
  }, e.default = u;
}(JM), "production" === process.env.NODE_ENV ? LM.exports = PM : LM.exports = JM;
var ZM = LM.exports,
  WM = "label-module_label__3yBia",
  XM = "label-module_icon__25HyM",
  UM = "label-module_required__3WYyJ",
  KM = ["children", "prependIcon", "appendIcon", "markRequiredField", "className"],
  YM = function (e) {
    var n = e.children,
      r = e.prependIcon,
      o = e.appendIcon,
      i = e.markRequiredField,
      a = e.className,
      c = S(e, KM);
    return /*#__PURE__*/t.createElement(RC, N({
      className: tC(WM, a),
      display: "block",
      renderAs: "label"
    }, c), r && /*#__PURE__*/t.createElement(RC, {
      renderAs: "span",
      className: XM
    }, r), n, o && /*#__PURE__*/t.createElement(RC, {
      renderAs: "span",
      className: XM
    }, o), i && /*#__PURE__*/t.createElement(RC, {
      renderAs: "span",
      className: UM
    }, "*"));
  };
YM.propTypes = {
  children: g.any.isRequired,
  prependIcon: g.node,
  appendIcon: g.node,
  markRequiredField: g.bool,
  htmlFor: g.string,
  className: g.string
};
var qM = "InputSwitch-module_hasLabel__3en7W",
  _M = "InputSwitch-module_labelBox__JJ615",
  $M = "InputSwitch-module_label__2_GjT",
  ek = ZM.default ? ZM.default : ZM,
  tk = function (e) {
    var o = e.onChange,
      i = e.isDisabled,
      a = e.id,
      c = e.isChecked,
      s = e.removeBottomSpacer,
      l = e.label,
      u = e.labelPosition,
      d = V(n(c || !1), 2),
      f = d[0],
      p = d[1],
      m = V(n(!1), 2),
      h = m[0],
      A = m[1];
    return r(function () {
      void 0 !== c && p(c);
    }, [c]), /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
      justifyContent: "space-between",
      alignItems: "center",
      className: tC(k({}, qM, l)),
      onMouseEnter: function () {
        return A(!0);
      },
      onMouseLeave: function () {
        return A(!1);
      }
    }, l && "left" === u && /*#__PURE__*/t.createElement(nb, {
      flex: "1",
      paddingRight: "xs",
      onClick: function () {
        p(!f), o && o();
      },
      className: _M
    }, /*#__PURE__*/t.createElement(YM, {
      className: $M
    }, l)), /*#__PURE__*/t.createElement(ek, {
      checked: f,
      onChange: function () {
        p(!f), o && o();
      },
      disabled: i,
      uncheckedIcon: !1,
      checkedIcon: !1,
      id: a,
      onColor: h ? "#3895ce" : "#6ab0da",
      offColor: h ? "#a7acc3" : "#B8BDCF",
      handleDiameter: 16,
      height: 28,
      width: 52,
      className: "ds-react-switch"
    }), l && "right" === u && /*#__PURE__*/t.createElement(nb, {
      flex: "1",
      paddingLeft: "xs",
      onClick: function () {
        p(!f), o && o();
      },
      className: _M
    }, /*#__PURE__*/t.createElement(YM, {
      className: $M
    }, l))), !s && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Qb, {
      size: "xs"
    }), /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    })));
  };
tk.propTypes = {
  isChecked: g.bool,
  onChange: g.func.isRequired,
  isDisabled: g.bool,
  id: g.string,
  removeBottomSpacer: g.bool,
  label: g.string,
  labelPosition: g.oneOf(["right", "left"])
}, tk.defaultProps = {
  isDisabled: !1,
  labelPosition: "left"
};
var nk = {
    formGroupHeader: "FormGroupHeader-module_formGroupHeader__3FoTw",
    removeTopMargin: "FormGroupHeader-module_removeTopMargin__1dtoc",
    "extend-s": "FormGroupHeader-module_extend-s__29HKm",
    "extend-m": "FormGroupHeader-module_extend-m__2Ah-R",
    removeTopBorder: "FormGroupHeader-module_removeTopBorder__1pkqM"
  },
  rk = function (e) {
    var n,
      r = e.horizontalPadding,
      o = e.title,
      i = e.removeTopMargin,
      a = e.extendHorizontalMargin,
      c = e.removeTopBorder;
    return /*#__PURE__*/t.createElement(nb, {
      paddingHorizontal: "none" !== r ? r : null,
      paddingTop: "xs",
      paddingBottom: "xs",
      className: tC(nk.formGroupHeader, (n = {}, k(n, nk.removeTopMargin, i), k(n, nk["extend-".concat(a)], a), k(n, nk.removeTopBorder, c), n))
    }, /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      style: {
        minWidth: 0
      }
    }, /*#__PURE__*/t.createElement(Tb, {
      truncate: !0,
      textTransform: "uppercase"
    }, o)));
  };
rk.propTypes = {
  title: g.string,
  horizontalPadding: g.oneOf(["none", "s", "m"]),
  removeTopMargin: g.bool,
  extendHorizontalMargin: g.oneOf(["s", "m"]),
  removeTopBorder: g.bool
}, rk.defaultProps = {
  horizontalPadding: "s"
};
var ok = "InputButtonSelect-module_wrapperBg__3Tn4x",
  ik = "InputButtonSelect-module_inputButtonGroup__1WiLI",
  ak = "InputButtonSelect-module_isDense__YYIhb",
  ck = "InputButtonSelect-module_button__2Zrgb",
  sk = "InputButtonSelect-module_isActive__mJsxx",
  lk = "InputButtonSelect-module_isIcon__1S1IR",
  uk = function (e) {
    var n,
      r = e.variation,
      o = e.children,
      i = e.onClick,
      a = e.isActive,
      c = e.width;
    return /*#__PURE__*/t.createElement(sb, {
      renderAs: "button",
      justifyContent: "center",
      alignItems: "center",
      className: tC(ck, (n = {}, k(n, lk, "icon-button" === r), k(n, sk, a), n)),
      onClick: function () {
        i && i();
      },
      flex: "auto" === c ? "1" : "none"
    }, o);
  };
uk.propTypes = {
  variation: g.oneOf(["call-to-action", "icon-button"]),
  children: g.oneOfType([g.string, g.node]),
  onClick: g.func,
  isActive: g.bool,
  width: g.oneOf(["auto", "inline-flex"])
}, uk.defaultProps = {
  variation: "call-to-action",
  width: "inline-flex"
};
var dk = function (e) {
  var n = e.removeBottomSpacer,
    r = e.isDisabled,
    o = e.description,
    i = e.wrapperClassName,
    a = e.inputWidth,
    c = e.isError,
    s = e.isDense,
    l = e.children;
  return /*#__PURE__*/t.createElement(qb, {
    removeBottomSpacer: n,
    isDisabled: r,
    description: o,
    className: tC(ok, i),
    inputWidth: a,
    isError: c
  }, /*#__PURE__*/t.createElement(sb, {
    className: tC(ik, k({}, ak, s)),
    alignItems: "center",
    gap: "xxs",
    flex: "auto" === a ? "1" : "0"
  }, t.Children.map(l, function (e) {
    return /*#__PURE__*/t.cloneElement(e, {
      width: a
    });
  })));
};
dk.propTypes = {
  children: g.any,
  isDense: g.bool,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  description: g.string,
  wrapperClassName: g.string,
  inputWidth: g.oneOf(["auto", "inline-flex"])
}, dk.defaultProps = {
  inputWidth: "inline-flex"
}, dk.Button = uk;
var fk = ["onDateChange", "onFocusChange", "addPrefix", "addSuffix", "description", "dateId", "focusedInput", "isDense", "removeBottomSpacer", "isDisabled", "isError", "inputWidth", "isFocused", "numberOfMonths"],
  pk = function (e) {
    var o = e.onDateChange,
      i = e.onFocusChange,
      a = e.addPrefix,
      c = e.addSuffix,
      s = e.description,
      l = e.dateId,
      u = e.focusedInput,
      d = e.isDense,
      f = e.removeBottomSpacer,
      p = e.isDisabled,
      m = e.isError,
      h = e.inputWidth,
      A = e.isFocused,
      g = e.numberOfMonths,
      v = S(e, fk),
      C = V(n(!1), 2),
      E = C[0],
      y = C[1];
    return r(function () {
      y(!!u);
    }, [u]), /*#__PURE__*/t.createElement(qb, {
      isActive: E,
      className: tC(k({}, "ds-date-dense", d)),
      removeBottomSpacer: f,
      isDisabled: p,
      description: s,
      isError: m,
      addPrefix: a,
      addSuffix: c,
      inputWidth: h,
      customColor: v.customColor
    }, /*#__PURE__*/t.createElement(b, N({
      onDateChange: o,
      onFocusChange: i,
      dateId: l,
      focused: A,
      disabled: p,
      customInputIcon: /*#__PURE__*/t.createElement(qv, {
        name: "calendarAlt"
      }),
      customCloseIcon: /*#__PURE__*/t.createElement(qv, {
        name: "times"
      }),
      numberOfMonths: g
    }, v)));
  };
pk.propTypes = {
  onDateChange: g.func.isRequired,
  isFocused: g.bool,
  onFocusChange: g.func.isRequired,
  addPrefix: g.string,
  addSuffix: g.string,
  description: g.string,
  dateId: g.string,
  focusedInput: g.any,
  isDense: g.bool,
  removeBottomSpacer: g.bool,
  isDisabled: g.bool,
  isError: g.bool,
  inputWidth: g.oneOf(["pct-half", "pct-three-quarter", "auto", "m", "l", "xl"]),
  isOutsideRange: g.func,
  numberOfMonths: g.number
}, pk.defaultProps = {
  dateId: "date_id",
  isOutsideRange: function () {
    return !1;
  },
  numberOfMonths: 1
};
var mk = "InputTime-module_inputText__icon__A9jZZ",
  hk = "InputTime-module_isDense__2Muad",
  Ak = "InputTime-module_inputText__input__3jg8_",
  gk = "InputTime-module_hasIconLeft__2SaUf",
  vk = "InputTime-module_hasIconRight__25KCj",
  Ck = "InputTime-module_isDisabled__2mDJM",
  bk = "InputTime-module_clearButton__gVODk",
  Ek = ["prependIcon", "appendIcon", "inputFocused", "isDense", "className", "removeBottomSpacer", "isDisabled", "onBlur", "onFocus", "isError", "description", "addSuffix", "addPrefix", "wrapperClassName", "onClear", "removeInputWrapper", "inputWidth"],
  yk = function (e) {
    var r,
      i = e.prependIcon,
      a = e.appendIcon,
      c = e.inputFocused,
      s = e.isDense,
      l = e.className,
      u = e.removeBottomSpacer,
      d = e.isDisabled,
      f = e.onBlur,
      p = e.onFocus,
      m = e.isError,
      h = e.description,
      A = e.addSuffix,
      g = e.addPrefix,
      v = e.wrapperClassName,
      C = e.onClear,
      b = e.removeInputWrapper,
      E = e.inputWidth,
      y = S(e, Ek),
      I = V(n(!1), 2),
      B = I[0],
      x = I[1],
      w = o(null),
      Q = /*#__PURE__*/t.createElement(t.Fragment, null, i && /*#__PURE__*/t.createElement(nb, {
        className: tC(mk, k({}, hk, s)),
        onClick: function () {
          w.current.focus();
        }
      }, /*#__PURE__*/t.createElement("span", null, i)), /*#__PURE__*/t.createElement(sb, {
        flexGrow: 1
      }, /*#__PURE__*/t.createElement(RC, N({
        renderAs: "input",
        domRef: w,
        className: tC(Ak, (r = {}, k(r, hk, s), k(r, gk, i), k(r, vk, a), k(r, Ck, d), r), l),
        disabled: d,
        onBlur: function () {
          x(!1), f && f();
        },
        onFocus: function () {
          x(!0), p && p();
        }
      }, y, {
        type: "time"
      }))), a && /*#__PURE__*/t.createElement(nb, {
        className: tC(mk, k({}, hk, s)),
        onClick: function () {
          w.current.focus();
        }
      }, /*#__PURE__*/t.createElement("span", null, a)), C && "" !== y.value && /*#__PURE__*/t.createElement(RC, {
        renderAs: "button",
        onClick: C,
        className: tC(bk, k({}, hk, s))
      }, /*#__PURE__*/t.createElement(qv, {
        name: "times"
      })));
    return b ? Q : /*#__PURE__*/t.createElement(qb, {
      removeBottomSpacer: u,
      isActive: c || B,
      isDisabled: d,
      description: h,
      isError: m,
      addPrefix: g,
      addSuffix: A,
      className: v,
      inputWidth: E,
      customColor: y.customColor
    }, Q);
  };
function Ik(e) {
  this.content = e;
}
function Bk(e, t, n) {
  for (let r = 0;; r++) {
    if (r == e.childCount || r == t.childCount) return e.childCount == t.childCount ? null : n;
    let o = e.child(r),
      i = t.child(r);
    if (o != i) {
      if (!o.sameMarkup(i)) return n;
      if (o.isText && o.text != i.text) {
        for (let e = 0; o.text[e] == i.text[e]; e++) n++;
        return n;
      }
      if (o.content.size || i.content.size) {
        let e = Bk(o.content, i.content, n + 1);
        if (null != e) return e;
      }
      n += o.nodeSize;
    } else n += o.nodeSize;
  }
}
function xk(e, t, n, r) {
  for (let o = e.childCount, i = t.childCount;;) {
    if (0 == o || 0 == i) return o == i ? null : {
      a: n,
      b: r
    };
    let a = e.child(--o),
      c = t.child(--i),
      s = a.nodeSize;
    if (a != c) {
      if (!a.sameMarkup(c)) return {
        a: n,
        b: r
      };
      if (a.isText && a.text != c.text) {
        let e = 0,
          t = Math.min(a.text.length, c.text.length);
        for (; e < t && a.text[a.text.length - e - 1] == c.text[c.text.length - e - 1];) e++, n--, r--;
        return {
          a: n,
          b: r
        };
      }
      if (a.content.size || c.content.size) {
        let e = xk(a.content, c.content, n - 1, r - 1);
        if (e) return e;
      }
      n -= s, r -= s;
    } else n -= s, r -= s;
  }
}
yk.propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  prependIcon: g.oneOfType([g.node, g.string]),
  appendIcon: g.oneOfType([g.node, g.string]),
  onFocus: g.func,
  onBlur: g.func,
  inputFocused: g.bool,
  isDense: g.bool,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  addPrefix: g.string,
  addSuffix: g.string,
  description: g.string,
  onClear: g.func,
  placeholder: g.string,
  className: g.string,
  wrapperClassName: g.string,
  removeInputWrapper: g.bool,
  inputWidth: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"])
}, Ik.prototype = {
  constructor: Ik,
  find: function (e) {
    for (var t = 0; t < this.content.length; t += 2) if (this.content[t] === e) return t;
    return -1;
  },
  get: function (e) {
    var t = this.find(e);
    return -1 == t ? void 0 : this.content[t + 1];
  },
  update: function (e, t, n) {
    var r = n && n != e ? this.remove(n) : this,
      o = r.find(e),
      i = r.content.slice();
    return -1 == o ? i.push(n || e, t) : (i[o + 1] = t, n && (i[o] = n)), new Ik(i);
  },
  remove: function (e) {
    var t = this.find(e);
    if (-1 == t) return this;
    var n = this.content.slice();
    return n.splice(t, 2), new Ik(n);
  },
  addToStart: function (e, t) {
    return new Ik([e, t].concat(this.remove(e).content));
  },
  addToEnd: function (e, t) {
    var n = this.remove(e).content.slice();
    return n.push(e, t), new Ik(n);
  },
  addBefore: function (e, t, n) {
    var r = this.remove(t),
      o = r.content.slice(),
      i = r.find(e);
    return o.splice(-1 == i ? o.length : i, 0, t, n), new Ik(o);
  },
  forEach: function (e) {
    for (var t = 0; t < this.content.length; t += 2) e(this.content[t], this.content[t + 1]);
  },
  prepend: function (e) {
    return (e = Ik.from(e)).size ? new Ik(e.content.concat(this.subtract(e).content)) : this;
  },
  append: function (e) {
    return (e = Ik.from(e)).size ? new Ik(this.subtract(e).content.concat(e.content)) : this;
  },
  subtract: function (e) {
    var t = this;
    e = Ik.from(e);
    for (var n = 0; n < e.content.length; n += 2) t = t.remove(e.content[n]);
    return t;
  },
  toObject: function () {
    var e = {};
    return this.forEach(function (t, n) {
      e[t] = n;
    }), e;
  },
  get size() {
    return this.content.length >> 1;
  }
}, Ik.from = function (e) {
  if (e instanceof Ik) return e;
  var t = [];
  if (e) for (var n in e) t.push(n, e[n]);
  return new Ik(t);
};
class wk {
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, null == t) for (let t = 0; t < e.length; t++) this.size += e[t].nodeSize;
  }
  nodesBetween(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let o = arguments.length > 4 ? arguments[4] : undefined;
    for (let i = 0, a = 0; a < t; i++) {
      let c = this.content[i],
        s = a + c.nodeSize;
      if (s > e && !1 !== n(c, r + a, o || null, i) && c.content.size) {
        let o = a + 1;
        c.nodesBetween(Math.max(0, e - o), Math.min(c.content.size, t - o), n, r + o);
      }
      a = s;
    }
  }
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  textBetween(e, t, n, r) {
    let o = "",
      i = !0;
    return this.nodesBetween(e, t, (a, c) => {
      let s = a.isText ? a.text.slice(Math.max(e, c) - c, t - c) : a.isLeaf ? r ? "function" == typeof r ? r(a) : r : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && s || a.isTextblock) && n && (i ? i = !1 : o += n), o += s;
    }, 0), o;
  }
  append(e) {
    if (!e.size) return this;
    if (!this.size) return e;
    let t = this.lastChild,
      n = e.firstChild,
      r = this.content.slice(),
      o = 0;
    for (t.isText && t.sameMarkup(n) && (r[r.length - 1] = t.withText(t.text + n.text), o = 1); o < e.content.length; o++) r.push(e.content[o]);
    return new wk(r, this.size + e.size);
  }
  cut(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.size;
    if (0 == e && t == this.size) return this;
    let n = [],
      r = 0;
    if (t > e) for (let o = 0, i = 0; i < t; o++) {
      let a = this.content[o],
        c = i + a.nodeSize;
      c > e && ((i < e || c > t) && (a = a.isText ? a.cut(Math.max(0, e - i), Math.min(a.text.length, t - i)) : a.cut(Math.max(0, e - i - 1), Math.min(a.content.size, t - i - 1))), n.push(a), r += a.nodeSize), i = c;
    }
    return new wk(n, r);
  }
  cutByIndex(e, t) {
    return e == t ? wk.empty : 0 == e && t == this.content.length ? this : new wk(this.content.slice(e, t));
  }
  replaceChild(e, t) {
    let n = this.content[e];
    if (n == t) return this;
    let r = this.content.slice(),
      o = this.size + t.nodeSize - n.nodeSize;
    return r[e] = t, new wk(r, o);
  }
  addToStart(e) {
    return new wk([e].concat(this.content), this.size + e.nodeSize);
  }
  addToEnd(e) {
    return new wk(this.content.concat(e), this.size + e.nodeSize);
  }
  eq(e) {
    if (this.content.length != e.content.length) return !1;
    for (let t = 0; t < this.content.length; t++) if (!this.content[t].eq(e.content[t])) return !1;
    return !0;
  }
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  get childCount() {
    return this.content.length;
  }
  child(e) {
    let t = this.content[e];
    if (!t) throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  maybeChild(e) {
    return this.content[e] || null;
  }
  forEach(e) {
    for (let t = 0, n = 0; t < this.content.length; t++) {
      let r = this.content[t];
      e(r, n, t), n += r.nodeSize;
    }
  }
  findDiffStart(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Bk(this, e, t);
  }
  findDiffEnd(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.size;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.size;
    return xk(this, e, t, n);
  }
  findIndex(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    if (0 == e) return Hk(0, e);
    if (e == this.size) return Hk(this.content.length, e);
    if (e > this.size || e < 0) throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let n = 0, r = 0;; n++) {
      let o = r + this.child(n).nodeSize;
      if (o >= e) return o == e || t > 0 ? Hk(n + 1, o) : Hk(n, r);
      r = o;
    }
  }
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  toStringInner() {
    return this.content.join(", ");
  }
  toJSON() {
    return this.content.length ? this.content.map(e => e.toJSON()) : null;
  }
  static fromJSON(e, t) {
    if (!t) return wk.empty;
    if (!Array.isArray(t)) throw new RangeError("Invalid input for Fragment.fromJSON");
    return new wk(t.map(e.nodeFromJSON));
  }
  static fromArray(e) {
    if (!e.length) return wk.empty;
    let t,
      n = 0;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      n += o.nodeSize, r && o.isText && e[r - 1].sameMarkup(o) ? (t || (t = e.slice(0, r)), t[t.length - 1] = o.withText(t[t.length - 1].text + o.text)) : t && t.push(o);
    }
    return new wk(t || e, n);
  }
  static from(e) {
    if (!e) return wk.empty;
    if (e instanceof wk) return e;
    if (Array.isArray(e)) return this.fromArray(e);
    if (e.attrs) return new wk([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
wk.empty = new wk([], 0);
const Qk = {
  index: 0,
  offset: 0
};
function Hk(e, t) {
  return Qk.index = e, Qk.offset = t, Qk;
}
function zk(e, t) {
  if (e === t) return !0;
  if (!e || "object" != typeof e || !t || "object" != typeof t) return !1;
  let n = Array.isArray(e);
  if (Array.isArray(t) != n) return !1;
  if (n) {
    if (e.length != t.length) return !1;
    for (let n = 0; n < e.length; n++) if (!zk(e[n], t[n])) return !1;
  } else {
    for (let n in e) if (!(n in t) || !zk(e[n], t[n])) return !1;
    for (let n in t) if (!(n in e)) return !1;
  }
  return !0;
}
class Mk {
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  addToSet(e) {
    let t,
      n = !1;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      if (this.eq(o)) return e;
      if (this.type.excludes(o.type)) t || (t = e.slice(0, r));else {
        if (o.type.excludes(this.type)) return e;
        !n && o.type.rank > this.type.rank && (t || (t = e.slice(0, r)), t.push(this), n = !0), t && t.push(o);
      }
    }
    return t || (t = e.slice()), n || t.push(this), t;
  }
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++) if (this.eq(e[t])) return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  isInSet(e) {
    for (let t = 0; t < e.length; t++) if (this.eq(e[t])) return !0;
    return !1;
  }
  eq(e) {
    return this == e || this.type == e.type && zk(this.attrs, e.attrs);
  }
  toJSON() {
    let e = {
      type: this.type.name
    };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  static fromJSON(e, t) {
    if (!t) throw new RangeError("Invalid input for Mark.fromJSON");
    let n = e.marks[t.type];
    if (!n) throw new RangeError(`There is no mark type ${t.type} in this schema`);
    return n.create(t.attrs);
  }
  static sameSet(e, t) {
    if (e == t) return !0;
    if (e.length != t.length) return !1;
    for (let n = 0; n < e.length; n++) if (!e[n].eq(t[n])) return !1;
    return !0;
  }
  static setFrom(e) {
    if (!e || Array.isArray(e) && 0 == e.length) return Mk.none;
    if (e instanceof Mk) return [e];
    let t = e.slice();
    return t.sort((e, t) => e.type.rank - t.type.rank), t;
  }
}
Mk.none = [];
class kk extends Error {}
class Nk {
  constructor(e, t, n) {
    this.content = e, this.openStart = t, this.openEnd = n;
  }
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  insertAt(e, t) {
    let n = Vk(this.content, e + this.openStart, t);
    return n && new Nk(n, this.openStart, this.openEnd);
  }
  removeBetween(e, t) {
    return new Nk(Sk(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  toJSON() {
    if (!this.content.size) return null;
    let e = {
      content: this.content.toJSON()
    };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  static fromJSON(e, t) {
    if (!t) return Nk.empty;
    let n = t.openStart || 0,
      r = t.openEnd || 0;
    if ("number" != typeof n || "number" != typeof r) throw new RangeError("Invalid input for Slice.fromJSON");
    return new Nk(wk.fromJSON(e, t.content), n, r);
  }
  static maxOpen(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    let n = 0,
      r = 0;
    for (let r = e.firstChild; r && !r.isLeaf && (t || !r.type.spec.isolating); r = r.firstChild) n++;
    for (let n = e.lastChild; n && !n.isLeaf && (t || !n.type.spec.isolating); n = n.lastChild) r++;
    return new Nk(e, n, r);
  }
}
function Sk(e, t, n) {
  let _e$findIndex = e.findIndex(t),
    r = _e$findIndex.index,
    o = _e$findIndex.offset,
    i = e.maybeChild(r),
    _e$findIndex2 = e.findIndex(n),
    a = _e$findIndex2.index,
    c = _e$findIndex2.offset;
  if (o == t || i.isText) {
    if (c != n && !e.child(a).isText) throw new RangeError("Removing non-flat range");
    return e.cut(0, t).append(e.cut(n));
  }
  if (r != a) throw new RangeError("Removing non-flat range");
  return e.replaceChild(r, i.copy(Sk(i.content, t - o - 1, n - o - 1)));
}
function Vk(e, t, n, r) {
  let _e$findIndex3 = e.findIndex(t),
    o = _e$findIndex3.index,
    i = _e$findIndex3.offset,
    a = e.maybeChild(o);
  if (i == t || a.isText) return r && !r.canReplace(o, o, n) ? null : e.cut(0, t).append(n).append(e.cut(t));
  let c = Vk(a.content, t - i - 1, n);
  return c && e.replaceChild(o, a.copy(c));
}
function Lk(e, t, n) {
  if (n.openStart > e.depth) throw new kk("Inserted content deeper than insertion position");
  if (e.depth - n.openStart != t.depth - n.openEnd) throw new kk("Inconsistent open depths");
  return Pk(e, t, n, 0);
}
function Pk(e, t, n, r) {
  let o = e.index(r),
    i = e.node(r);
  if (o == t.index(r) && r < e.depth - n.openStart) {
    let a = Pk(e, t, n, r + 1);
    return i.copy(i.content.replaceChild(o, a));
  }
  if (n.content.size) {
    if (n.openStart || n.openEnd || e.depth != r || t.depth != r) {
      let _ref = function (e, t) {
          let n = t.depth - e.openStart,
            r = t.node(n).copy(e.content);
          for (let e = n - 1; e >= 0; e--) r = t.node(e).copy(wk.from(r));
          return {
            start: r.resolveNoCache(e.openStart + n),
            end: r.resolveNoCache(r.content.size - e.openEnd - n)
          };
        }(n, e),
        o = _ref.start,
        a = _ref.end;
      return Gk(i, Fk(e, o, a, t, r));
    }
    {
      let r = e.parent,
        o = r.content;
      return Gk(r, o.cut(0, e.parentOffset).append(n.content).append(o.cut(t.parentOffset)));
    }
  }
  return Gk(i, jk(e, t, r));
}
function Ok(e, t) {
  if (!t.type.compatibleContent(e.type)) throw new kk("Cannot join " + t.type.name + " onto " + e.type.name);
}
function Tk(e, t, n) {
  let r = e.node(n);
  return Ok(r, t.node(n)), r;
}
function Dk(e, t) {
  let n = t.length - 1;
  n >= 0 && e.isText && e.sameMarkup(t[n]) ? t[n] = e.withText(t[n].text + e.text) : t.push(e);
}
function Rk(e, t, n, r) {
  let o = (t || e).node(n),
    i = 0,
    a = t ? t.index(n) : o.childCount;
  e && (i = e.index(n), e.depth > n ? i++ : e.textOffset && (Dk(e.nodeAfter, r), i++));
  for (let e = i; e < a; e++) Dk(o.child(e), r);
  t && t.depth == n && t.textOffset && Dk(t.nodeBefore, r);
}
function Gk(e, t) {
  return e.type.checkContent(t), e.copy(t);
}
function Fk(e, t, n, r, o) {
  let i = e.depth > o && Tk(e, t, o + 1),
    a = r.depth > o && Tk(n, r, o + 1),
    c = [];
  return Rk(null, e, o, c), i && a && t.index(o) == n.index(o) ? (Ok(i, a), Dk(Gk(i, Fk(e, t, n, r, o + 1)), c)) : (i && Dk(Gk(i, jk(e, t, o + 1)), c), Rk(t, n, o, c), a && Dk(Gk(a, jk(n, r, o + 1)), c)), Rk(r, null, o, c), new wk(c);
}
function jk(e, t, n) {
  let r = [];
  if (Rk(null, e, n, r), e.depth > n) {
    Dk(Gk(Tk(e, t, n + 1), jk(e, t, n + 1)), r);
  }
  return Rk(t, null, n, r), new wk(r);
}
Nk.empty = new Nk(wk.empty, 0, 0);
class Jk {
  constructor(e, t, n) {
    this.pos = e, this.path = t, this.parentOffset = n, this.depth = t.length / 3 - 1;
  }
  resolveDepth(e) {
    return null == e ? this.depth : e < 0 ? this.depth + e : e;
  }
  get parent() {
    return this.node(this.depth);
  }
  get doc() {
    return this.node(0);
  }
  node(e) {
    return this.path[3 * this.resolveDepth(e)];
  }
  index(e) {
    return this.path[3 * this.resolveDepth(e) + 1];
  }
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e != this.depth || this.textOffset ? 1 : 0);
  }
  start(e) {
    return 0 == (e = this.resolveDepth(e)) ? 0 : this.path[3 * e - 1] + 1;
  }
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  before(e) {
    if (!(e = this.resolveDepth(e))) throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[3 * e - 1];
  }
  after(e) {
    if (!(e = this.resolveDepth(e))) throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[3 * e - 1] + this.path[3 * e].nodeSize;
  }
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  get nodeAfter() {
    let e = this.parent,
      t = this.index(this.depth);
    if (t == e.childCount) return null;
    let n = this.pos - this.path[this.path.length - 1],
      r = e.child(t);
    return n ? e.child(t).cut(n) : r;
  }
  get nodeBefore() {
    let e = this.index(this.depth),
      t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : 0 == e ? null : this.parent.child(e - 1);
  }
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let n = this.path[3 * t],
      r = 0 == t ? 0 : this.path[3 * t - 1] + 1;
    for (let t = 0; t < e; t++) r += n.child(t).nodeSize;
    return r;
  }
  marks() {
    let e = this.parent,
      t = this.index();
    if (0 == e.content.size) return Mk.none;
    if (this.textOffset) return e.child(t).marks;
    let n = e.maybeChild(t - 1),
      r = e.maybeChild(t);
    if (!n) {
      let e = n;
      n = r, r = e;
    }
    let o = n.marks;
    for (var i = 0; i < o.length; i++) !1 !== o[i].type.spec.inclusive || r && o[i].isInSet(r.marks) || (o = o[i--].removeFromSet(o));
    return o;
  }
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline) return null;
    let n = t.marks,
      r = e.parent.maybeChild(e.index());
    for (var o = 0; o < n.length; o++) !1 !== n[o].type.spec.inclusive || r && n[o].isInSet(r.marks) || (n = n[o--].removeFromSet(n));
    return n;
  }
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--) if (this.start(t) <= e && this.end(t) >= e) return t;
    return 0;
  }
  blockRange() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this;
    let t = arguments.length > 1 ? arguments[1] : undefined;
    if (e.pos < this.pos) return e.blockRange(this);
    for (let n = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); n >= 0; n--) if (e.pos <= this.end(n) && (!t || t(this.node(n)))) return new Uk(this, e, n);
    return null;
  }
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++) e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size)) throw new RangeError("Position " + t + " out of range");
    let n = [],
      r = 0,
      o = t;
    for (let t = e;;) {
      let _t$content$findIndex = t.content.findIndex(o),
        e = _t$content$findIndex.index,
        i = _t$content$findIndex.offset,
        a = o - i;
      if (n.push(t, e, r + i), !a) break;
      if (t = t.child(e), t.isText) break;
      o = a - 1, r += i + 1;
    }
    return new Jk(t, n, o);
  }
  static resolveCached(e, t) {
    for (let n = 0; n < Zk.length; n++) {
      let r = Zk[n];
      if (r.pos == t && r.doc == e) return r;
    }
    let n = Zk[Wk] = Jk.resolve(e, t);
    return Wk = (Wk + 1) % Xk, n;
  }
}
let Zk = [],
  Wk = 0,
  Xk = 12;
class Uk {
  constructor(e, t, n) {
    this.$from = e, this.$to = t, this.depth = n;
  }
  get start() {
    return this.$from.before(this.depth + 1);
  }
  get end() {
    return this.$to.after(this.depth + 1);
  }
  get parent() {
    return this.$from.node(this.depth);
  }
  get startIndex() {
    return this.$from.index(this.depth);
  }
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const Kk = Object.create(null);
class Yk {
  constructor(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Mk.none;
    this.type = e, this.attrs = t, this.marks = r, this.content = n || wk.empty;
  }
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  get childCount() {
    return this.content.childCount;
  }
  child(e) {
    return this.content.child(e);
  }
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  forEach(e) {
    this.content.forEach(e);
  }
  nodesBetween(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    this.content.nodesBetween(e, t, n, r, this);
  }
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  textBetween(e, t, n, r) {
    return this.content.textBetween(e, t, n, r);
  }
  get firstChild() {
    return this.content.firstChild;
  }
  get lastChild() {
    return this.content.lastChild;
  }
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  hasMarkup(e, t, n) {
    return this.type == e && zk(this.attrs, t || e.defaultAttrs || Kk) && Mk.sameSet(this.marks, n || Mk.none);
  }
  copy() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return e == this.content ? this : new Yk(this.type, this.attrs, e, this.marks);
  }
  mark(e) {
    return e == this.marks ? this : new Yk(this.type, this.attrs, this.content, e);
  }
  cut(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.content.size;
    return 0 == e && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  slice(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.content.size;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    if (e == t) return Nk.empty;
    let r = this.resolve(e),
      o = this.resolve(t),
      i = n ? 0 : r.sharedDepth(t),
      a = r.start(i),
      c = r.node(i).content.cut(r.pos - a, o.pos - a);
    return new Nk(c, r.depth - i, o.depth - i);
  }
  replace(e, t, n) {
    return Lk(this.resolve(e), this.resolve(t), n);
  }
  nodeAt(e) {
    for (let t = this;;) {
      let _t$content$findIndex2 = t.content.findIndex(e),
        n = _t$content$findIndex2.index,
        r = _t$content$findIndex2.offset;
      if (t = t.maybeChild(n), !t) return null;
      if (r == e || t.isText) return t;
      e -= r + 1;
    }
  }
  childAfter(e) {
    let _this$content$findInd = this.content.findIndex(e),
      t = _this$content$findInd.index,
      n = _this$content$findInd.offset;
    return {
      node: this.content.maybeChild(t),
      index: t,
      offset: n
    };
  }
  childBefore(e) {
    if (0 == e) return {
      node: null,
      index: 0,
      offset: 0
    };
    let _this$content$findInd2 = this.content.findIndex(e),
      t = _this$content$findInd2.index,
      n = _this$content$findInd2.offset;
    if (n < e) return {
      node: this.content.child(t),
      index: t,
      offset: n
    };
    let r = this.content.child(t - 1);
    return {
      node: r,
      index: t - 1,
      offset: n - r.nodeSize
    };
  }
  resolve(e) {
    return Jk.resolveCached(this, e);
  }
  resolveNoCache(e) {
    return Jk.resolve(this, e);
  }
  rangeHasMark(e, t, n) {
    let r = !1;
    return t > e && this.nodesBetween(e, t, e => (n.isInSet(e.marks) && (r = !0), !r)), r;
  }
  get isBlock() {
    return this.type.isBlock;
  }
  get isTextblock() {
    return this.type.isTextblock;
  }
  get inlineContent() {
    return this.type.inlineContent;
  }
  get isInline() {
    return this.type.isInline;
  }
  get isText() {
    return this.type.isText;
  }
  get isLeaf() {
    return this.type.isLeaf;
  }
  get isAtom() {
    return this.type.isAtom;
  }
  toString() {
    if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), _k(this.marks, e);
  }
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t) throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  canReplace(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : wk.empty;
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let o = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : n.childCount;
    let i = this.contentMatchAt(e).matchFragment(n, r, o),
      a = i && i.matchFragment(this.content, t);
    if (!a || !a.validEnd) return !1;
    for (let e = r; e < o; e++) if (!this.type.allowsMarks(n.child(e).marks)) return !1;
    return !0;
  }
  canReplaceWith(e, t, n, r) {
    if (r && !this.type.allowsMarks(r)) return !1;
    let o = this.contentMatchAt(e).matchType(n),
      i = o && o.matchFragment(this.content, t);
    return !!i && i.validEnd;
  }
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  check() {
    this.type.checkContent(this.content);
    let e = Mk.none;
    for (let t = 0; t < this.marks.length; t++) e = this.marks[t].addToSet(e);
    if (!Mk.sameSet(e, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map(e => e.type.name)}`);
    this.content.forEach(e => e.check());
  }
  toJSON() {
    let e = {
      type: this.type.name
    };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map(e => e.toJSON())), e;
  }
  static fromJSON(e, t) {
    if (!t) throw new RangeError("Invalid input for Node.fromJSON");
    let n = null;
    if (t.marks) {
      if (!Array.isArray(t.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
      n = t.marks.map(e.markFromJSON);
    }
    if ("text" == t.type) {
      if ("string" != typeof t.text) throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, n);
    }
    let r = wk.fromJSON(e, t.content);
    return e.nodeType(t.type).create(t.attrs, r, n);
  }
}
Yk.prototype.text = void 0;
class qk extends Yk {
  constructor(e, t, n, r) {
    if (super(e, t, null, r), !n) throw new RangeError("Empty text nodes are not allowed");
    this.text = n;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : _k(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new qk(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new qk(this.type, this.attrs, e, this.marks);
  }
  cut() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.text.length;
    return 0 == e && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function _k(e, t) {
  for (let n = e.length - 1; n >= 0; n--) t = e[n].type.name + "(" + t + ")";
  return t;
}
class $k {
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  static parse(e, t) {
    let n = new eN(e, t);
    if (null == n.next) return $k.empty;
    let r = tN(n);
    n.next && n.err("Unexpected trailing text");
    let o = function (e) {
      let t = Object.create(null);
      return n(cN(e, 0));
      function n(r) {
        let o = [];
        r.forEach(t => {
          e[t].forEach(_ref2 => {
            let t = _ref2.term,
              n = _ref2.to;
            if (!t) return;
            let r;
            for (let e = 0; e < o.length; e++) o[e][0] == t && (r = o[e][1]);
            cN(e, n).forEach(e => {
              r || o.push([t, r = []]), -1 == r.indexOf(e) && r.push(e);
            });
          });
        });
        let i = t[r.join(",")] = new $k(r.indexOf(e.length - 1) > -1);
        for (let e = 0; e < o.length; e++) {
          let r = o[e][1].sort(aN);
          i.next.push({
            type: o[e][0],
            next: t[r.join(",")] || n(r)
          });
        }
        return i;
      }
    }(function (e) {
      let t = [[]];
      return o(i(e, 0), n()), t;
      function n() {
        return t.push([]) - 1;
      }
      function r(e, n, r) {
        let o = {
          term: r,
          to: n
        };
        return t[e].push(o), o;
      }
      function o(e, t) {
        e.forEach(e => e.to = t);
      }
      function i(e, t) {
        if ("choice" == e.type) return e.exprs.reduce((e, n) => e.concat(i(n, t)), []);
        if ("seq" != e.type) {
          if ("star" == e.type) {
            let a = n();
            return r(t, a), o(i(e.expr, a), a), [r(a)];
          }
          if ("plus" == e.type) {
            let a = n();
            return o(i(e.expr, t), a), o(i(e.expr, a), a), [r(a)];
          }
          if ("opt" == e.type) return [r(t)].concat(i(e.expr, t));
          if ("range" == e.type) {
            let a = t;
            for (let t = 0; t < e.min; t++) {
              let t = n();
              o(i(e.expr, a), t), a = t;
            }
            if (-1 == e.max) o(i(e.expr, a), a);else for (let t = e.min; t < e.max; t++) {
              let t = n();
              r(a, t), o(i(e.expr, a), t), a = t;
            }
            return [r(a)];
          }
          if ("name" == e.type) return [r(t, void 0, e.value)];
          throw new Error("Unknown expr type");
        }
        for (let r = 0;; r++) {
          let a = i(e.exprs[r], t);
          if (r == e.exprs.length - 1) return a;
          o(a, t = n());
        }
      }
    }(r));
    return function (e, t) {
      for (let n = 0, r = [e]; n < r.length; n++) {
        let e = r[n],
          o = !e.validEnd,
          i = [];
        for (let t = 0; t < e.next.length; t++) {
          let _e$next$t = e.next[t],
            n = _e$next$t.type,
            a = _e$next$t.next;
          i.push(n.name), !o || n.isText || n.hasRequiredAttrs() || (o = !1), -1 == r.indexOf(a) && r.push(a);
        }
        o && t.err("Only non-generatable nodes (" + i.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
      }
    }(o, n), o;
  }
  matchType(e) {
    for (let t = 0; t < this.next.length; t++) if (this.next[t].type == e) return this.next[t].next;
    return null;
  }
  matchFragment(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.childCount;
    let r = this;
    for (let o = t; r && o < n; o++) r = r.matchType(e.child(o).type);
    return r;
  }
  get inlineContent() {
    return 0 != this.next.length && this.next[0].type.isInline;
  }
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let t = this.next[e].type;
      if (!t.isText && !t.hasRequiredAttrs()) return t;
    }
    return null;
  }
  compatible(e) {
    for (let t = 0; t < this.next.length; t++) for (let n = 0; n < e.next.length; n++) if (this.next[t].type == e.next[n].type) return !0;
    return !1;
  }
  fillBefore(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let r = [this];
    return function o(i, a) {
      let c = i.matchFragment(e, n);
      if (c && (!t || c.validEnd)) return wk.from(a.map(e => e.createAndFill()));
      for (let e = 0; e < i.next.length; e++) {
        let _i$next$e = i.next[e],
          t = _i$next$e.type,
          n = _i$next$e.next;
        if (!t.isText && !t.hasRequiredAttrs() && -1 == r.indexOf(n)) {
          r.push(n);
          let e = o(n, a.concat(t));
          if (e) return e;
        }
      }
      return null;
    }(this, []);
  }
  findWrapping(e) {
    for (let t = 0; t < this.wrapCache.length; t += 2) if (this.wrapCache[t] == e) return this.wrapCache[t + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  computeWrapping(e) {
    let t = Object.create(null),
      n = [{
        match: this,
        type: null,
        via: null
      }];
    for (; n.length;) {
      let r = n.shift(),
        o = r.match;
      if (o.matchType(e)) {
        let e = [];
        for (let t = r; t.type; t = t.via) e.push(t.type);
        return e.reverse();
      }
      for (let e = 0; e < o.next.length; e++) {
        let _o$next$e = o.next[e],
          i = _o$next$e.type,
          a = _o$next$e.next;
        i.isLeaf || i.hasRequiredAttrs() || i.name in t || r.type && !a.validEnd || (n.push({
          match: i.contentMatch,
          type: i,
          via: r
        }), t[i.name] = !0);
      }
    }
    return null;
  }
  get edgeCount() {
    return this.next.length;
  }
  edge(e) {
    if (e >= this.next.length) throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  toString() {
    let e = [];
    return function t(n) {
      e.push(n);
      for (let r = 0; r < n.next.length; r++) -1 == e.indexOf(n.next[r].next) && t(n.next[r].next);
    }(this), e.map((t, n) => {
      let r = n + (t.validEnd ? "*" : " ") + " ";
      for (let n = 0; n < t.next.length; n++) r += (n ? ", " : "") + t.next[n].type.name + "->" + e.indexOf(t.next[n].next);
      return r;
    }).join("\n");
  }
}
$k.empty = new $k(!0);
class eN {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), "" == this.tokens[this.tokens.length - 1] && this.tokens.pop(), "" == this.tokens[0] && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function tN(e) {
  let t = [];
  do {
    t.push(nN(e));
  } while (e.eat("|"));
  return 1 == t.length ? t[0] : {
    type: "choice",
    exprs: t
  };
}
function nN(e) {
  let t = [];
  do {
    t.push(rN(e));
  } while (e.next && ")" != e.next && "|" != e.next);
  return 1 == t.length ? t[0] : {
    type: "seq",
    exprs: t
  };
}
function rN(e) {
  let t = function (e) {
    if (e.eat("(")) {
      let t = tN(e);
      return e.eat(")") || e.err("Missing closing paren"), t;
    }
    if (!/\W/.test(e.next)) {
      let t = function (e, t) {
        let n = e.nodeTypes,
          r = n[t];
        if (r) return [r];
        let o = [];
        for (let e in n) {
          let r = n[e];
          r.groups.indexOf(t) > -1 && o.push(r);
        }
        0 == o.length && e.err("No node type or group '" + t + "' found");
        return o;
      }(e, e.next).map(t => (null == e.inline ? e.inline = t.isInline : e.inline != t.isInline && e.err("Mixing inline and block content"), {
        type: "name",
        value: t
      }));
      return e.pos++, 1 == t.length ? t[0] : {
        type: "choice",
        exprs: t
      };
    }
    e.err("Unexpected token '" + e.next + "'");
  }(e);
  for (;;) if (e.eat("+")) t = {
    type: "plus",
    expr: t
  };else if (e.eat("*")) t = {
    type: "star",
    expr: t
  };else if (e.eat("?")) t = {
    type: "opt",
    expr: t
  };else {
    if (!e.eat("{")) break;
    t = iN(e, t);
  }
  return t;
}
function oN(e) {
  /\D/.test(e.next) && e.err("Expected number, got '" + e.next + "'");
  let t = Number(e.next);
  return e.pos++, t;
}
function iN(e, t) {
  let n = oN(e),
    r = n;
  return e.eat(",") && (r = "}" != e.next ? oN(e) : -1), e.eat("}") || e.err("Unclosed braced range"), {
    type: "range",
    min: n,
    max: r,
    expr: t
  };
}
function aN(e, t) {
  return t - e;
}
function cN(e, t) {
  let n = [];
  return function t(r) {
    let o = e[r];
    if (1 == o.length && !o[0].term) return t(o[0].to);
    n.push(r);
    for (let e = 0; e < o.length; e++) {
      let _o$e = o[e],
        r = _o$e.term,
        i = _o$e.to;
      r || -1 != n.indexOf(i) || t(i);
    }
  }(t), n.sort(aN);
}
function sN(e) {
  let t = Object.create(null);
  for (let n in e) {
    let r = e[n];
    if (!r.hasDefault) return null;
    t[n] = r.default;
  }
  return t;
}
function lN(e, t) {
  let n = Object.create(null);
  for (let r in e) {
    let o = t && t[r];
    if (void 0 === o) {
      let t = e[r];
      if (!t.hasDefault) throw new RangeError("No value supplied for attribute " + r);
      o = t.default;
    }
    n[r] = o;
  }
  return n;
}
function uN(e) {
  let t = Object.create(null);
  if (e) for (let n in e) t[n] = new fN(e[n]);
  return t;
}
class dN {
  constructor(e, t, n) {
    this.name = e, this.schema = t, this.spec = n, this.markSet = null, this.groups = n.group ? n.group.split(" ") : [], this.attrs = uN(n.attrs), this.defaultAttrs = sN(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(n.inline || "text" == e), this.isText = "text" == e;
  }
  get isInline() {
    return !this.isBlock;
  }
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  get isLeaf() {
    return this.contentMatch == $k.empty;
  }
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  hasRequiredAttrs() {
    for (let e in this.attrs) if (this.attrs[e].isRequired) return !0;
    return !1;
  }
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : lN(this.attrs, e);
  }
  create() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let t = arguments.length > 1 ? arguments[1] : undefined;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    if (this.isText) throw new Error("NodeType.create can't construct text nodes");
    return new Yk(this, this.computeAttrs(e), wk.from(t), Mk.setFrom(n));
  }
  createChecked() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let t = arguments.length > 1 ? arguments[1] : undefined;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    return t = wk.from(t), this.checkContent(t), new Yk(this, this.computeAttrs(e), t, Mk.setFrom(n));
  }
  createAndFill() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let t = arguments.length > 1 ? arguments[1] : undefined;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    if (e = this.computeAttrs(e), (t = wk.from(t)).size) {
      let e = this.contentMatch.fillBefore(t);
      if (!e) return null;
      t = e.append(t);
    }
    let r = this.contentMatch.matchFragment(t),
      o = r && r.fillBefore(wk.empty, !0);
    return o ? new Yk(this, e, t.append(o), Mk.setFrom(n)) : null;
  }
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd) return !1;
    for (let t = 0; t < e.childCount; t++) if (!this.allowsMarks(e.child(t).marks)) return !1;
    return !0;
  }
  checkContent(e) {
    if (!this.validContent(e)) throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  allowsMarkType(e) {
    return null == this.markSet || this.markSet.indexOf(e) > -1;
  }
  allowsMarks(e) {
    if (null == this.markSet) return !0;
    for (let t = 0; t < e.length; t++) if (!this.allowsMarkType(e[t].type)) return !1;
    return !0;
  }
  allowedMarks(e) {
    if (null == this.markSet) return e;
    let t;
    for (let n = 0; n < e.length; n++) this.allowsMarkType(e[n].type) ? t && t.push(e[n]) : t || (t = e.slice(0, n));
    return t ? t.length ? t : Mk.none : e;
  }
  static compile(e, t) {
    let n = Object.create(null);
    e.forEach((e, r) => n[e] = new dN(e, t, r));
    let r = t.spec.topNode || "doc";
    if (!n[r]) throw new RangeError("Schema is missing its top node type ('" + r + "')");
    if (!n.text) throw new RangeError("Every schema needs a 'text' type");
    for (let e in n.text.attrs) throw new RangeError("The text node type should not have attributes");
    return n;
  }
}
class fN {
  constructor(e) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(e, "default"), this.default = e.default;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class pN {
  constructor(e, t, n, r) {
    this.name = e, this.rank = t, this.schema = n, this.spec = r, this.attrs = uN(r.attrs), this.excluded = null;
    let o = sN(this.attrs);
    this.instance = o ? new Mk(this, o) : null;
  }
  create() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return !e && this.instance ? this.instance : new Mk(this, lN(this.attrs, e));
  }
  static compile(e, t) {
    let n = Object.create(null),
      r = 0;
    return e.forEach((e, o) => n[e] = new pN(e, r++, t, o)), n;
  }
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++) e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  isInSet(e) {
    for (let t = 0; t < e.length; t++) if (e[t].type == this) return e[t];
  }
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class mN {
  constructor(e) {
    this.cached = Object.create(null);
    let t = this.spec = {};
    for (let n in e) t[n] = e[n];
    t.nodes = Ik.from(e.nodes), t.marks = Ik.from(e.marks || {}), this.nodes = dN.compile(this.spec.nodes, this), this.marks = pN.compile(this.spec.marks, this);
    let n = Object.create(null);
    for (let e in this.nodes) {
      if (e in this.marks) throw new RangeError(e + " can not be both a node and a mark");
      let t = this.nodes[e],
        r = t.spec.content || "",
        o = t.spec.marks;
      t.contentMatch = n[r] || (n[r] = $k.parse(r, this.nodes)), t.inlineContent = t.contentMatch.inlineContent, t.markSet = "_" == o ? null : o ? hN(this, o.split(" ")) : "" != o && t.inlineContent ? null : [];
    }
    for (let e in this.marks) {
      let t = this.marks[e],
        n = t.spec.excludes;
      t.excluded = null == n ? [t] : "" == n ? [] : hN(this, n.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = Object.create(null);
  }
  node(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    let r = arguments.length > 3 ? arguments[3] : undefined;
    if ("string" == typeof e) e = this.nodeType(e);else {
      if (!(e instanceof dN)) throw new RangeError("Invalid node type: " + e);
      if (e.schema != this) throw new RangeError("Node type from different schema used (" + e.name + ")");
    }
    return e.createChecked(t, n, r);
  }
  text(e, t) {
    let n = this.nodes.text;
    return new qk(n, n.defaultAttrs, e, Mk.setFrom(t));
  }
  mark(e, t) {
    return "string" == typeof e && (e = this.marks[e]), e.create(t);
  }
  nodeFromJSON(e) {
    return Yk.fromJSON(this, e);
  }
  markFromJSON(e) {
    return Mk.fromJSON(this, e);
  }
  nodeType(e) {
    let t = this.nodes[e];
    if (!t) throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function hN(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) {
    let o = t[r],
      i = e.marks[o],
      a = i;
    if (i) n.push(i);else for (let t in e.marks) {
      let r = e.marks[t];
      ("_" == o || r.spec.group && r.spec.group.split(" ").indexOf(o) > -1) && n.push(a = r);
    }
    if (!a) throw new SyntaxError("Unknown mark type: '" + t[r] + "'");
  }
  return n;
}
class AN {
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [], t.forEach(e => {
      e.tag ? this.tags.push(e) : e.style && this.styles.push(e);
    }), this.normalizeLists = !this.tags.some(t => {
      if (!/^(ul|ol)\b/.test(t.tag) || !t.node) return !1;
      let n = e.nodes[t.node];
      return n.contentMatch.matchType(n);
    });
  }
  parse(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let n = new yN(this, t, !1);
    return n.addAll(e, t.from, t.to), n.finish();
  }
  parseSlice(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let n = new yN(this, t, !0);
    return n.addAll(e, t.from, t.to), Nk.maxOpen(n.finish());
  }
  matchTag(e, t, n) {
    for (let r = n ? this.tags.indexOf(n) + 1 : 0; r < this.tags.length; r++) {
      let n = this.tags[r];
      if (IN(e, n.tag) && (void 0 === n.namespace || e.namespaceURI == n.namespace) && (!n.context || t.matchesContext(n.context))) {
        if (n.getAttrs) {
          let t = n.getAttrs(e);
          if (!1 === t) continue;
          n.attrs = t || void 0;
        }
        return n;
      }
    }
  }
  matchStyle(e, t, n, r) {
    for (let o = r ? this.styles.indexOf(r) + 1 : 0; o < this.styles.length; o++) {
      let r = this.styles[o],
        i = r.style;
      if (!(0 != i.indexOf(e) || r.context && !n.matchesContext(r.context) || i.length > e.length && (61 != i.charCodeAt(e.length) || i.slice(e.length + 1) != t))) {
        if (r.getAttrs) {
          let e = r.getAttrs(t);
          if (!1 === e) continue;
          r.attrs = e || void 0;
        }
        return r;
      }
    }
  }
  static schemaRules(e) {
    let t = [];
    function n(e) {
      let n = null == e.priority ? 50 : e.priority,
        r = 0;
      for (; r < t.length; r++) {
        let e = t[r];
        if ((null == e.priority ? 50 : e.priority) < n) break;
      }
      t.splice(r, 0, e);
    }
    for (let t in e.marks) {
      let r = e.marks[t].spec.parseDOM;
      r && r.forEach(e => {
        n(e = BN(e)), e.mark || e.ignore || e.clearMark || (e.mark = t);
      });
    }
    for (let t in e.nodes) {
      let r = e.nodes[t].spec.parseDOM;
      r && r.forEach(e => {
        n(e = BN(e)), e.node || e.ignore || e.mark || (e.node = t);
      });
    }
    return t;
  }
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new AN(e, AN.schemaRules(e)));
  }
}
const gN = {
    address: !0,
    article: !0,
    aside: !0,
    blockquote: !0,
    canvas: !0,
    dd: !0,
    div: !0,
    dl: !0,
    fieldset: !0,
    figcaption: !0,
    figure: !0,
    footer: !0,
    form: !0,
    h1: !0,
    h2: !0,
    h3: !0,
    h4: !0,
    h5: !0,
    h6: !0,
    header: !0,
    hgroup: !0,
    hr: !0,
    li: !0,
    noscript: !0,
    ol: !0,
    output: !0,
    p: !0,
    pre: !0,
    section: !0,
    table: !0,
    tfoot: !0,
    ul: !0
  },
  vN = {
    head: !0,
    noscript: !0,
    object: !0,
    script: !0,
    style: !0,
    title: !0
  },
  CN = {
    ol: !0,
    ul: !0
  };
function bN(e, t, n) {
  return null != t ? (t ? 1 : 0) | ("full" === t ? 2 : 0) : e && "pre" == e.whitespace ? 3 : -5 & n;
}
class EN {
  constructor(e, t, n, r, o, i, a) {
    this.type = e, this.attrs = t, this.marks = n, this.pendingMarks = r, this.solid = o, this.options = a, this.content = [], this.activeMarks = Mk.none, this.stashMarks = [], this.match = i || (4 & a ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type) return [];
      let t = this.type.contentMatch.fillBefore(wk.from(e));
      if (!t) {
        let t,
          n = this.type.contentMatch;
        return (t = n.findWrapping(e.type)) ? (this.match = n, t) : null;
      }
      this.match = this.type.contentMatch.matchFragment(t);
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(1 & this.options)) {
      let e,
        t = this.content[this.content.length - 1];
      if (t && t.isText && (e = /[ \t\r\n\u000c]+$/.exec(t.text))) {
        let n = t;
        t.text.length == e[0].length ? this.content.pop() : this.content[this.content.length - 1] = n.withText(n.text.slice(0, n.text.length - e[0].length));
      }
    }
    let t = wk.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(wk.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  popFromStashMark(e) {
    for (let t = this.stashMarks.length - 1; t >= 0; t--) if (e.eq(this.stashMarks[t])) return this.stashMarks.splice(t, 1)[0];
  }
  applyPending(e) {
    for (let t = 0, n = this.pendingMarks; t < n.length; t++) {
      let r = n[t];
      (this.type ? this.type.allowsMarkType(r.type) : xN(r.type, e)) && !r.isInSet(this.activeMarks) && (this.activeMarks = r.addToSet(this.activeMarks), this.pendingMarks = r.removeFromSet(this.pendingMarks));
    }
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !gN.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class yN {
  constructor(e, t, n) {
    this.parser = e, this.options = t, this.isOpen = n, this.open = 0;
    let r,
      o = t.topNode,
      i = bN(null, t.preserveWhitespace, 0) | (n ? 4 : 0);
    r = o ? new EN(o.type, o.attrs, Mk.none, Mk.none, !0, t.topMatch || o.type.contentMatch, i) : new EN(n ? null : e.schema.topNodeType, null, Mk.none, Mk.none, !0, null, i), this.nodes = [r], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  addDOM(e) {
    3 == e.nodeType ? this.addTextNode(e) : 1 == e.nodeType && this.addElement(e);
  }
  withStyleRules(e, t) {
    let n = e.getAttribute("style");
    if (!n) return t();
    let r = this.readStyles(function (e) {
      let t,
        n = /\s*([\w-]+)\s*:\s*([^;]+)/g,
        r = [];
      for (; t = n.exec(e);) r.push(t[1], t[2].trim());
      return r;
    }(n));
    if (!r) return;
    let _r2 = _slicedToArray(r, 2),
      o = _r2[0],
      i = _r2[1],
      a = this.top;
    for (let e = 0; e < i.length; e++) this.removePendingMark(i[e], a);
    for (let e = 0; e < o.length; e++) this.addPendingMark(o[e]);
    t();
    for (let e = 0; e < o.length; e++) this.removePendingMark(o[e], a);
    for (let e = 0; e < i.length; e++) this.addPendingMark(i[e]);
  }
  addTextNode(e) {
    let t = e.nodeValue,
      n = this.top;
    if (2 & n.options || n.inlineContext(e) || /[^ \t\r\n\u000c]/.test(t)) {
      if (1 & n.options) t = 2 & n.options ? t.replace(/\r\n?/g, "\n") : t.replace(/\r?\n|\r/g, " ");else if (t = t.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(t) && this.open == this.nodes.length - 1) {
        let r = n.content[n.content.length - 1],
          o = e.previousSibling;
        (!r || o && "BR" == o.nodeName || r.isText && /[ \t\r\n\u000c]$/.test(r.text)) && (t = t.slice(1));
      }
      t && this.insertNode(this.parser.schema.text(t)), this.findInText(e);
    } else this.findInside(e);
  }
  addElement(e, t) {
    let n,
      r = e.nodeName.toLowerCase();
    CN.hasOwnProperty(r) && this.parser.normalizeLists && function (e) {
      for (let t = e.firstChild, n = null; t; t = t.nextSibling) {
        let e = 1 == t.nodeType ? t.nodeName.toLowerCase() : null;
        e && CN.hasOwnProperty(e) && n ? (n.appendChild(t), t = n) : "li" == e ? n = t : e && (n = null);
      }
    }(e);
    let o = this.options.ruleFromNode && this.options.ruleFromNode(e) || (n = this.parser.matchTag(e, this, t));
    if (o ? o.ignore : vN.hasOwnProperty(r)) this.findInside(e), this.ignoreFallback(e);else if (!o || o.skip || o.closeParent) {
      o && o.closeParent ? this.open = Math.max(0, this.open - 1) : o && o.skip.nodeType && (e = o.skip);
      let t,
        n = this.top,
        i = this.needsBlock;
      if (gN.hasOwnProperty(r)) n.content.length && n.content[0].isInline && this.open && (this.open--, n = this.top), t = !0, n.type || (this.needsBlock = !0);else if (!e.firstChild) return void this.leafFallback(e);
      o && o.skip ? this.addAll(e) : this.withStyleRules(e, () => this.addAll(e)), t && this.sync(n), this.needsBlock = i;
    } else this.withStyleRules(e, () => {
      this.addElementByRule(e, o, !1 === o.consuming ? n : void 0);
    });
  }
  leafFallback(e) {
    "BR" == e.nodeName && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode("\n"));
  }
  ignoreFallback(e) {
    "BR" != e.nodeName || this.top.type && this.top.type.inlineContent || this.findPlace(this.parser.schema.text("-"));
  }
  readStyles(e) {
    let t = Mk.none,
      n = Mk.none;
    for (let r = 0; r < e.length; r += 2) for (let o;;) {
      let i = this.parser.matchStyle(e[r], e[r + 1], this, o);
      if (!i) break;
      if (i.ignore) return null;
      if (i.clearMark ? this.top.pendingMarks.concat(this.top.activeMarks).forEach(e => {
        i.clearMark(e) && (n = e.addToSet(n));
      }) : t = this.parser.schema.marks[i.mark].create(i.attrs).addToSet(t), !1 !== i.consuming) break;
      o = i;
    }
    return [t, n];
  }
  addElementByRule(e, t, n) {
    let r, o, i;
    if (t.node) o = this.parser.schema.nodes[t.node], o.isLeaf ? this.insertNode(o.create(t.attrs)) || this.leafFallback(e) : r = this.enter(o, t.attrs || null, t.preserveWhitespace);else {
      i = this.parser.schema.marks[t.mark].create(t.attrs), this.addPendingMark(i);
    }
    let a = this.top;
    if (o && o.isLeaf) this.findInside(e);else if (n) this.addElement(e, n);else if (t.getContent) this.findInside(e), t.getContent(e, this.parser.schema).forEach(e => this.insertNode(e));else {
      let n = e;
      "string" == typeof t.contentElement ? n = e.querySelector(t.contentElement) : "function" == typeof t.contentElement ? n = t.contentElement(e) : t.contentElement && (n = t.contentElement), this.findAround(e, n, !0), this.addAll(n);
    }
    r && this.sync(a) && this.open--, i && this.removePendingMark(i, a);
  }
  addAll(e, t, n) {
    let r = t || 0;
    for (let o = t ? e.childNodes[t] : e.firstChild, i = null == n ? null : e.childNodes[n]; o != i; o = o.nextSibling, ++r) this.findAtPoint(e, r), this.addDOM(o);
    this.findAtPoint(e, r);
  }
  findPlace(e) {
    let t, n;
    for (let r = this.open; r >= 0; r--) {
      let o = this.nodes[r],
        i = o.findWrapping(e);
      if (i && (!t || t.length > i.length) && (t = i, n = o, !i.length)) break;
      if (o.solid) break;
    }
    if (!t) return !1;
    this.sync(n);
    for (let e = 0; e < t.length; e++) this.enterInner(t[e], null, !1);
    return !0;
  }
  insertNode(e) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let e = this.textblockFromContext();
      e && this.enterInner(e);
    }
    if (this.findPlace(e)) {
      this.closeExtra();
      let t = this.top;
      t.applyPending(e.type), t.match && (t.match = t.match.matchType(e.type));
      let n = t.activeMarks;
      for (let r = 0; r < e.marks.length; r++) t.type && !t.type.allowsMarkType(e.marks[r].type) || (n = e.marks[r].addToSet(n));
      return t.content.push(e.mark(n)), !0;
    }
    return !1;
  }
  enter(e, t, n) {
    let r = this.findPlace(e.create(t));
    return r && this.enterInner(e, t, !0, n), r;
  }
  enterInner(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    let r = arguments.length > 3 ? arguments[3] : undefined;
    this.closeExtra();
    let o = this.top;
    o.applyPending(e), o.match = o.match && o.match.matchType(e);
    let i = bN(e, r, o.options);
    4 & o.options && 0 == o.content.length && (i |= 4), this.nodes.push(new EN(e, t, o.activeMarks, o.pendingMarks, n, null, i)), this.open++;
  }
  closeExtra() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--) this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(this.isOpen || this.options.topOpen);
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) if (this.nodes[t] == e) return this.open = t, !0;
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let n = this.nodes[t].content;
      for (let t = n.length - 1; t >= 0; t--) e += n[t].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find) for (let n = 0; n < this.find.length; n++) this.find[n].node == e && this.find[n].offset == t && (this.find[n].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find) for (let t = 0; t < this.find.length; t++) null == this.find[t].pos && 1 == e.nodeType && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, n) {
    if (e != t && this.find) for (let r = 0; r < this.find.length; r++) if (null == this.find[r].pos && 1 == e.nodeType && e.contains(this.find[r].node)) {
      t.compareDocumentPosition(this.find[r].node) & (n ? 2 : 4) && (this.find[r].pos = this.currentPos);
    }
  }
  findInText(e) {
    if (this.find) for (let t = 0; t < this.find.length; t++) this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  matchesContext(e) {
    if (e.indexOf("|") > -1) return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"),
      n = this.options.context,
      r = !(this.isOpen || n && n.parent.type != this.nodes[0].type),
      o = -(n ? n.depth + 1 : 0) + (r ? 0 : 1),
      i = (e, a) => {
        for (; e >= 0; e--) {
          let c = t[e];
          if ("" == c) {
            if (e == t.length - 1 || 0 == e) continue;
            for (; a >= o; a--) if (i(e - 1, a)) return !0;
            return !1;
          }
          {
            let e = a > 0 || 0 == a && r ? this.nodes[a].type : n && a >= o ? n.node(a - o).type : null;
            if (!e || e.name != c && -1 == e.groups.indexOf(c)) return !1;
            a--;
          }
        }
        return !0;
      };
    return i(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e) for (let t = e.depth; t >= 0; t--) {
      let n = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
      if (n && n.isTextblock && n.defaultAttrs) return n;
    }
    for (let e in this.parser.schema.nodes) {
      let t = this.parser.schema.nodes[e];
      if (t.isTextblock && t.defaultAttrs) return t;
    }
  }
  addPendingMark(e) {
    let t = function (e, t) {
      for (let n = 0; n < t.length; n++) if (e.eq(t[n])) return t[n];
    }(e, this.top.pendingMarks);
    t && this.top.stashMarks.push(t), this.top.pendingMarks = e.addToSet(this.top.pendingMarks);
  }
  removePendingMark(e, t) {
    for (let n = this.open; n >= 0; n--) {
      let r = this.nodes[n];
      if (r.pendingMarks.lastIndexOf(e) > -1) r.pendingMarks = e.removeFromSet(r.pendingMarks);else {
        r.activeMarks = e.removeFromSet(r.activeMarks);
        let t = r.popFromStashMark(e);
        t && r.type && r.type.allowsMarkType(t.type) && (r.activeMarks = t.addToSet(r.activeMarks));
      }
      if (r == t) break;
    }
  }
}
function IN(e, t) {
  return (e.matches || e.msMatchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector).call(e, t);
}
function BN(e) {
  let t = {};
  for (let n in e) t[n] = e[n];
  return t;
}
function xN(e, t) {
  let n = t.schema.nodes;
  for (let r in n) {
    let o = n[r];
    if (!o.allowsMarkType(e)) continue;
    let i = [],
      a = e => {
        i.push(e);
        for (let n = 0; n < e.edgeCount; n++) {
          let _e$edge = e.edge(n),
            r = _e$edge.type,
            o = _e$edge.next;
          if (r == t) return !0;
          if (i.indexOf(o) < 0 && a(o)) return !0;
        }
      };
    if (a(o.contentMatch)) return !0;
  }
}
class wN {
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  serializeFragment(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let n = arguments.length > 2 ? arguments[2] : undefined;
    n || (n = HN(t).createDocumentFragment());
    let r = n,
      o = [];
    return e.forEach(e => {
      if (o.length || e.marks.length) {
        let n = 0,
          i = 0;
        for (; n < o.length && i < e.marks.length;) {
          let t = e.marks[i];
          if (this.marks[t.type.name]) {
            if (!t.eq(o[n][0]) || !1 === t.type.spec.spanning) break;
            n++, i++;
          } else i++;
        }
        for (; n < o.length;) r = o.pop()[1];
        for (; i < e.marks.length;) {
          let n = e.marks[i++],
            a = this.serializeMark(n, e.isInline, t);
          a && (o.push([n, r]), r.appendChild(a.dom), r = a.contentDOM || a.dom);
        }
      }
      r.appendChild(this.serializeNodeInner(e, t));
    }), n;
  }
  serializeNodeInner(e, t) {
    let _wN$renderSpec = wN.renderSpec(HN(t), this.nodes[e.type.name](e)),
      n = _wN$renderSpec.dom,
      r = _wN$renderSpec.contentDOM;
    if (r) {
      if (e.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, r);
    }
    return n;
  }
  serializeNode(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let n = this.serializeNodeInner(e, t);
    for (let r = e.marks.length - 1; r >= 0; r--) {
      let o = this.serializeMark(e.marks[r], e.isInline, t);
      o && ((o.contentDOM || o.dom).appendChild(n), n = o.dom);
    }
    return n;
  }
  serializeMark(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let r = this.marks[e.type.name];
    return r && wN.renderSpec(HN(n), r(e, t));
  }
  static renderSpec(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    if ("string" == typeof t) return {
      dom: e.createTextNode(t)
    };
    if (null != t.nodeType) return {
      dom: t
    };
    if (t.dom && null != t.dom.nodeType) return t;
    let r,
      o = t[0],
      i = o.indexOf(" ");
    i > 0 && (n = o.slice(0, i), o = o.slice(i + 1));
    let a = n ? e.createElementNS(n, o) : e.createElement(o),
      c = t[1],
      s = 1;
    if (c && "object" == typeof c && null == c.nodeType && !Array.isArray(c)) {
      s = 2;
      for (let e in c) if (null != c[e]) {
        let t = e.indexOf(" ");
        t > 0 ? a.setAttributeNS(e.slice(0, t), e.slice(t + 1), c[e]) : a.setAttribute(e, c[e]);
      }
    }
    for (let o = s; o < t.length; o++) {
      let i = t[o];
      if (0 === i) {
        if (o < t.length - 1 || o > s) throw new RangeError("Content hole must be the only child of its parent node");
        return {
          dom: a,
          contentDOM: a
        };
      }
      {
        let _wN$renderSpec2 = wN.renderSpec(e, i, n),
          t = _wN$renderSpec2.dom,
          o = _wN$renderSpec2.contentDOM;
        if (a.appendChild(t), o) {
          if (r) throw new RangeError("Multiple content holes");
          r = o;
        }
      }
    }
    return {
      dom: a,
      contentDOM: r
    };
  }
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new wN(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  static nodesFromSchema(e) {
    let t = QN(e.nodes);
    return t.text || (t.text = e => e.text), t;
  }
  static marksFromSchema(e) {
    return QN(e.marks);
  }
}
function QN(e) {
  let t = {};
  for (let n in e) {
    let r = e[n].spec.toDOM;
    r && (t[n] = r);
  }
  return t;
}
function HN(e) {
  return e.document || window.document;
}
const zN = Math.pow(2, 16);
function MN(e, t) {
  return e + t * zN;
}
function kN(e) {
  return 65535 & e;
}
class NN {
  constructor(e, t, n) {
    this.pos = e, this.delInfo = t, this.recover = n;
  }
  get deleted() {
    return (8 & this.delInfo) > 0;
  }
  get deletedBefore() {
    return (5 & this.delInfo) > 0;
  }
  get deletedAfter() {
    return (6 & this.delInfo) > 0;
  }
  get deletedAcross() {
    return (4 & this.delInfo) > 0;
  }
}
class SN {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    if (this.ranges = e, this.inverted = t, !e.length && SN.empty) return SN.empty;
  }
  recover(e) {
    let t = 0,
      n = kN(e);
    if (!this.inverted) for (let e = 0; e < n; e++) t += this.ranges[3 * e + 2] - this.ranges[3 * e + 1];
    return this.ranges[3 * n] + t + function (e) {
      return (e - (65535 & e)) / zN;
    }(e);
  }
  mapResult(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return this._map(e, t, !1);
  }
  map(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return this._map(e, t, !0);
  }
  _map(e, t, n) {
    let r = 0,
      o = this.inverted ? 2 : 1,
      i = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let c = this.ranges[a] - (this.inverted ? r : 0);
      if (c > e) break;
      let s = this.ranges[a + o],
        l = this.ranges[a + i],
        u = c + s;
      if (e <= u) {
        let o = c + r + ((s ? e == c ? -1 : e == u ? 1 : t : t) < 0 ? 0 : l);
        if (n) return o;
        let i = e == (t < 0 ? c : u) ? null : MN(a / 3, e - c),
          d = e == c ? 2 : e == u ? 1 : 4;
        return (t < 0 ? e != c : e != u) && (d |= 8), new NN(o, d, i);
      }
      r += l - s;
    }
    return n ? e + r : new NN(e + r, 0, null);
  }
  touches(e, t) {
    let n = 0,
      r = kN(t),
      o = this.inverted ? 2 : 1,
      i = this.inverted ? 1 : 2;
    for (let t = 0; t < this.ranges.length; t += 3) {
      let a = this.ranges[t] - (this.inverted ? n : 0);
      if (a > e) break;
      let c = this.ranges[t + o];
      if (e <= a + c && t == 3 * r) return !0;
      n += this.ranges[t + i] - c;
    }
    return !1;
  }
  forEach(e) {
    let t = this.inverted ? 2 : 1,
      n = this.inverted ? 1 : 2;
    for (let r = 0, o = 0; r < this.ranges.length; r += 3) {
      let i = this.ranges[r],
        a = i - (this.inverted ? o : 0),
        c = i + (this.inverted ? 0 : o),
        s = this.ranges[r + t],
        l = this.ranges[r + n];
      e(a, a + s, c, c + l), o += l - s;
    }
  }
  invert() {
    return new SN(this.ranges, !this.inverted);
  }
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  static offset(e) {
    return 0 == e ? SN.empty : new SN(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
SN.empty = new SN([]);
class VN {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let t = arguments.length > 1 ? arguments[1] : undefined;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e.length;
    this.maps = e, this.mirror = t, this.from = n, this.to = r;
  }
  slice() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.maps.length;
    return new VN(this.maps, this.mirror, e, t);
  }
  copy() {
    return new VN(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
  }
  appendMap(e, t) {
    this.to = this.maps.push(e), null != t && this.setMirror(this.maps.length - 1, t);
  }
  appendMapping(e) {
    for (let t = 0, n = this.maps.length; t < e.maps.length; t++) {
      let r = e.getMirror(t);
      this.appendMap(e.maps[t], null != r && r < t ? n + r : void 0);
    }
  }
  getMirror(e) {
    if (this.mirror) for (let t = 0; t < this.mirror.length; t++) if (this.mirror[t] == e) return this.mirror[t + (t % 2 ? -1 : 1)];
  }
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, n = this.maps.length + e.maps.length; t >= 0; t--) {
      let r = e.getMirror(t);
      this.appendMap(e.maps[t].invert(), null != r && r > t ? n - r - 1 : void 0);
    }
  }
  invert() {
    let e = new VN();
    return e.appendMappingInverted(this), e;
  }
  map(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    if (this.mirror) return this._map(e, t, !0);
    for (let n = this.from; n < this.to; n++) e = this.maps[n].map(e, t);
    return e;
  }
  mapResult(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return this._map(e, t, !1);
  }
  _map(e, t, n) {
    let r = 0;
    for (let n = this.from; n < this.to; n++) {
      let o = this.maps[n].mapResult(e, t);
      if (null != o.recover) {
        let t = this.getMirror(n);
        if (null != t && t > n && t < this.to) {
          n = t, e = this.maps[t].recover(o.recover);
          continue;
        }
      }
      r |= o.delInfo, e = o.pos;
    }
    return n ? e : new NN(e, r, null);
  }
}
const LN = Object.create(null);
class PN {
  getMap() {
    return SN.empty;
  }
  merge(e) {
    return null;
  }
  static fromJSON(e, t) {
    if (!t || !t.stepType) throw new RangeError("Invalid input for Step.fromJSON");
    let n = LN[t.stepType];
    if (!n) throw new RangeError(`No step type ${t.stepType} defined`);
    return n.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in LN) throw new RangeError("Duplicate use of step JSON ID " + e);
    return LN[e] = t, t.prototype.jsonID = e, t;
  }
}
class ON {
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  static ok(e) {
    return new ON(e, null);
  }
  static fail(e) {
    return new ON(null, e);
  }
  static fromReplace(e, t, n, r) {
    try {
      return ON.ok(e.replace(t, n, r));
    } catch (e) {
      if (e instanceof kk) return ON.fail(e.message);
      throw e;
    }
  }
}
function TN(e, t, n) {
  let r = [];
  for (let o = 0; o < e.childCount; o++) {
    let i = e.child(o);
    i.content.size && (i = i.copy(TN(i.content, t, i))), i.isInline && (i = t(i, n, o)), r.push(i);
  }
  return wk.fromArray(r);
}
class DN extends PN {
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to),
      n = e.resolve(this.from),
      r = n.node(n.sharedDepth(this.to)),
      o = new Nk(TN(t.content, (e, t) => e.isAtom && t.type.allowsMarkType(this.mark.type) ? e.mark(this.mark.addToSet(e.marks)) : e, r), t.openStart, t.openEnd);
    return ON.fromReplace(e, this.from, this.to, o);
  }
  invert() {
    return new RN(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1),
      n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new DN(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof DN && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new DN(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.from || "number" != typeof t.to) throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new DN(t.from, t.to, e.markFromJSON(t.mark));
  }
}
PN.jsonID("addMark", DN);
class RN extends PN {
  constructor(e, t, n) {
    super(), this.from = e, this.to = t, this.mark = n;
  }
  apply(e) {
    let t = e.slice(this.from, this.to),
      n = new Nk(TN(t.content, e => e.mark(this.mark.removeFromSet(e.marks)), e), t.openStart, t.openEnd);
    return ON.fromReplace(e, this.from, this.to, n);
  }
  invert() {
    return new DN(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1),
      n = e.mapResult(this.to, -1);
    return t.deleted && n.deleted || t.pos >= n.pos ? null : new RN(t.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof RN && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new RN(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.from || "number" != typeof t.to) throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new RN(t.from, t.to, e.markFromJSON(t.mark));
  }
}
PN.jsonID("removeMark", RN);
class GN extends PN {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t) return ON.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return ON.fromReplace(e, this.pos, this.pos + 1, new Nk(wk.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let e = this.mark.addToSet(t.marks);
      if (e.length == t.marks.length) {
        for (let n = 0; n < t.marks.length; n++) if (!t.marks[n].isInSet(e)) return new GN(this.pos, t.marks[n]);
        return new GN(this.pos, this.mark);
      }
    }
    return new FN(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new GN(t.pos, this.mark);
  }
  toJSON() {
    return {
      stepType: "addNodeMark",
      pos: this.pos,
      mark: this.mark.toJSON()
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.pos) throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new GN(t.pos, e.markFromJSON(t.mark));
  }
}
PN.jsonID("addNodeMark", GN);
class FN extends PN {
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t) return ON.fail("No node at mark step's position");
    let n = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return ON.fromReplace(e, this.pos, this.pos + 1, new Nk(wk.from(n), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return t && this.mark.isInSet(t.marks) ? new GN(this.pos, this.mark) : this;
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new FN(t.pos, this.mark);
  }
  toJSON() {
    return {
      stepType: "removeNodeMark",
      pos: this.pos,
      mark: this.mark.toJSON()
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.pos) throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new FN(t.pos, e.markFromJSON(t.mark));
  }
}
PN.jsonID("removeNodeMark", FN);
class jN extends PN {
  constructor(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
    super(), this.from = e, this.to = t, this.slice = n, this.structure = r;
  }
  apply(e) {
    return this.structure && ZN(e, this.from, this.to) ? ON.fail("Structure replace would overwrite content") : ON.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new SN([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new jN(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1),
      n = e.mapResult(this.to, -1);
    return t.deletedAcross && n.deletedAcross ? null : new jN(t.pos, Math.max(t.pos, n.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof jN) || e.structure || this.structure) return null;
    if (this.from + this.slice.size != e.from || this.slice.openEnd || e.slice.openStart) {
      if (e.to != this.from || this.slice.openStart || e.slice.openEnd) return null;
      {
        let t = this.slice.size + e.slice.size == 0 ? Nk.empty : new Nk(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
        return new jN(e.from, this.to, t, this.structure);
      }
    }
    {
      let t = this.slice.size + e.slice.size == 0 ? Nk.empty : new Nk(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new jN(this.from, this.to + (e.to - e.from), t, this.structure);
    }
  }
  toJSON() {
    let e = {
      stepType: "replace",
      from: this.from,
      to: this.to
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.from || "number" != typeof t.to) throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new jN(t.from, t.to, Nk.fromJSON(e, t.slice), !!t.structure);
  }
}
PN.jsonID("replace", jN);
class JN extends PN {
  constructor(e, t, n, r, o, i) {
    let a = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
    super(), this.from = e, this.to = t, this.gapFrom = n, this.gapTo = r, this.slice = o, this.insert = i, this.structure = a;
  }
  apply(e) {
    if (this.structure && (ZN(e, this.from, this.gapFrom) || ZN(e, this.gapTo, this.to))) return ON.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd) return ON.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, t.content);
    return n ? ON.fromReplace(e, this.from, this.to, n) : ON.fail("Content does not fit in gap");
  }
  getMap() {
    return new SN([this.from, this.gapFrom - this.from, this.insert, this.gapTo, this.to - this.gapTo, this.slice.size - this.insert]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new JN(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1),
      n = e.mapResult(this.to, -1),
      r = e.map(this.gapFrom, -1),
      o = e.map(this.gapTo, 1);
    return t.deletedAcross && n.deletedAcross || r < t.pos || o > n.pos ? null : new JN(t.pos, n.pos, r, o, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.from || "number" != typeof t.to || "number" != typeof t.gapFrom || "number" != typeof t.gapTo || "number" != typeof t.insert) throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new JN(t.from, t.to, t.gapFrom, t.gapTo, Nk.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
function ZN(e, t, n) {
  let r = e.resolve(t),
    o = n - t,
    i = r.depth;
  for (; o > 0 && i > 0 && r.indexAfter(i) == r.node(i).childCount;) i--, o--;
  if (o > 0) {
    let e = r.node(i).maybeChild(r.indexAfter(i));
    for (; o > 0;) {
      if (!e || e.isLeaf) return !0;
      e = e.firstChild, o--;
    }
  }
  return !1;
}
function WN(e, t, n) {
  return (0 == t || e.canReplace(t, e.childCount)) && (n == e.childCount || e.canReplace(0, n));
}
function XN(e) {
  let t = e.parent.content.cutByIndex(e.startIndex, e.endIndex);
  for (let n = e.depth;; --n) {
    let r = e.$from.node(n),
      o = e.$from.index(n),
      i = e.$to.indexAfter(n);
    if (n < e.depth && r.canReplace(o, i, t)) return n;
    if (0 == n || r.type.spec.isolating || !WN(r, o, i)) break;
  }
  return null;
}
function UN(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : e;
  let o = function (e, t) {
      let n = e.parent,
        r = e.startIndex,
        o = e.endIndex,
        i = n.contentMatchAt(r).findWrapping(t);
      if (!i) return null;
      let a = i.length ? i[0] : t;
      return n.canReplaceWith(r, o, a) ? i : null;
    }(e, t),
    i = o && function (e, t) {
      let n = e.parent,
        r = e.startIndex,
        o = e.endIndex,
        i = n.child(r),
        a = t.contentMatch.findWrapping(i.type);
      if (!a) return null;
      let c = (a.length ? a[a.length - 1] : t).contentMatch;
      for (let e = r; c && e < o; e++) c = c.matchType(n.child(e).type);
      return c && c.validEnd ? a : null;
    }(r, t);
  return i ? o.map(KN).concat({
    type: t,
    attrs: n
  }).concat(i.map(KN)) : null;
}
function KN(e) {
  return {
    type: e,
    attrs: null
  };
}
function YN(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  let r = arguments.length > 3 ? arguments[3] : undefined;
  let o = e.resolve(t),
    i = o.depth - n,
    a = r && r[r.length - 1] || o.parent;
  if (i < 0 || o.parent.type.spec.isolating || !o.parent.canReplace(o.index(), o.parent.childCount) || !a.type.validContent(o.parent.content.cutByIndex(o.index(), o.parent.childCount))) return !1;
  for (let e = o.depth - 1, t = n - 2; e > i; e--, t--) {
    let n = o.node(e),
      i = o.index(e);
    if (n.type.spec.isolating) return !1;
    let a = n.content.cutByIndex(i, n.childCount),
      c = r && r[t + 1];
    c && (a = a.replaceChild(0, c.type.create(c.attrs)));
    let s = r && r[t] || n;
    if (!n.canReplace(i + 1, n.childCount) || !s.type.validContent(a)) return !1;
  }
  let c = o.indexAfter(i),
    s = r && r[0];
  return o.node(i).canReplaceWith(c, c, s ? s.type : o.node(i + 1).type);
}
function qN(e, t) {
  let n = e.resolve(t),
    r = n.index();
  return _N(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(r, r + 1);
}
function _N(e, t) {
  return !(!e || !t || e.isLeaf || !e.canAppend(t));
}
function $N(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  let r = e.resolve(t);
  for (let e = r.depth;; e--) {
    let o,
      i,
      a = r.index(e);
    if (e == r.depth ? (o = r.nodeBefore, i = r.nodeAfter) : n > 0 ? (o = r.node(e + 1), a++, i = r.node(e).maybeChild(a)) : (o = r.node(e).maybeChild(a - 1), i = r.node(e + 1)), o && !o.isTextblock && _N(o, i) && r.node(e).canReplace(a, a + 1)) return t;
    if (0 == e) break;
    t = n < 0 ? r.before(e) : r.after(e);
  }
}
function eS(e, t, n) {
  let r = e.resolve(t);
  if (!n.content.size) return t;
  let o = n.content;
  for (let e = 0; e < n.openStart; e++) o = o.firstChild.content;
  for (let e = 1; e <= (0 == n.openStart && n.size ? 2 : 1); e++) for (let t = r.depth; t >= 0; t--) {
    let n = t == r.depth ? 0 : r.pos <= (r.start(t + 1) + r.end(t + 1)) / 2 ? -1 : 1,
      i = r.index(t) + (n > 0 ? 1 : 0),
      a = r.node(t),
      c = !1;
    if (1 == e) c = a.canReplace(i, i, o);else {
      let e = a.contentMatchAt(i).findWrapping(o.firstChild.type);
      c = e && a.canReplaceWith(i, i, e[0]);
    }
    if (c) return 0 == n ? r.pos : n < 0 ? r.before(t + 1) : r.after(t + 1);
  }
  return null;
}
function tS(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
  let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Nk.empty;
  if (t == n && !r.size) return null;
  let o = e.resolve(t),
    i = e.resolve(n);
  return nS(o, i, r) ? new jN(t, n, r) : new rS(o, i, r).fit();
}
function nS(e, t, n) {
  return !n.openStart && !n.openEnd && e.start() == t.start() && e.parent.canReplace(e.index(), t.index(), n.content);
}
PN.jsonID("replaceAround", JN);
class rS {
  constructor(e, t, n) {
    this.$from = e, this.$to = t, this.unplaced = n, this.frontier = [], this.placed = wk.empty;
    for (let t = 0; t <= e.depth; t++) {
      let n = e.node(t);
      this.frontier.push({
        type: n.type,
        match: n.contentMatchAt(e.indexAfter(t))
      });
    }
    for (let t = e.depth; t > 0; t--) this.placed = wk.from(e.node(t).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size;) {
      let e = this.findFittable();
      e ? this.placeNodes(e) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(),
      t = this.placed.size - this.depth - this.$from.depth,
      n = this.$from,
      r = this.close(e < 0 ? this.$to : n.doc.resolve(e));
    if (!r) return null;
    let o = this.placed,
      i = n.depth,
      a = r.depth;
    for (; i && a && 1 == o.childCount;) o = o.firstChild.content, i--, a--;
    let c = new Nk(o, i, a);
    return e > -1 ? new JN(n.pos, e, this.$to.pos, this.$to.end(), c, t) : c.size || n.pos != this.$to.pos ? new jN(n.pos, r.pos, c) : null;
  }
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, n = 0, r = this.unplaced.openEnd; n < e; n++) {
      let o = t.firstChild;
      if (t.childCount > 1 && (r = 0), o.type.spec.isolating && r <= n) {
        e = n;
        break;
      }
      t = o.content;
    }
    for (let t = 1; t <= 2; t++) for (let n = 1 == t ? e : this.unplaced.openStart; n >= 0; n--) {
      let e,
        r = null;
      n ? (r = aS(this.unplaced.content, n - 1).firstChild, e = r.content) : e = this.unplaced.content;
      let o = e.firstChild;
      for (let e = this.depth; e >= 0; e--) {
        let i,
          _this$frontier$e = this.frontier[e],
          a = _this$frontier$e.type,
          c = _this$frontier$e.match,
          s = null;
        if (1 == t && (o ? c.matchType(o.type) || (s = c.fillBefore(wk.from(o), !1)) : r && a.compatibleContent(r.type))) return {
          sliceDepth: n,
          frontierDepth: e,
          parent: r,
          inject: s
        };
        if (2 == t && o && (i = c.findWrapping(o.type))) return {
          sliceDepth: n,
          frontierDepth: e,
          parent: r,
          wrap: i
        };
        if (r && c.matchType(r.type)) break;
      }
    }
  }
  openMore() {
    let _this$unplaced = this.unplaced,
      e = _this$unplaced.content,
      t = _this$unplaced.openStart,
      n = _this$unplaced.openEnd,
      r = aS(e, t);
    return !(!r.childCount || r.firstChild.isLeaf) && (this.unplaced = new Nk(e, t + 1, Math.max(n, r.size + t >= e.size - n ? t + 1 : 0)), !0);
  }
  dropNode() {
    let _this$unplaced2 = this.unplaced,
      e = _this$unplaced2.content,
      t = _this$unplaced2.openStart,
      n = _this$unplaced2.openEnd,
      r = aS(e, t);
    if (r.childCount <= 1 && t > 0) {
      let o = e.size - t <= t + r.size;
      this.unplaced = new Nk(oS(e, t - 1, 1), t - 1, o ? t - 1 : n);
    } else this.unplaced = new Nk(oS(e, t, 1), t, n);
  }
  placeNodes(_ref3) {
    let e = _ref3.sliceDepth,
      t = _ref3.frontierDepth,
      n = _ref3.parent,
      r = _ref3.inject,
      o = _ref3.wrap;
    for (; this.depth > t;) this.closeFrontierNode();
    if (o) for (let e = 0; e < o.length; e++) this.openFrontierNode(o[e]);
    let i = this.unplaced,
      a = n ? n.content : i.content,
      c = i.openStart - e,
      s = 0,
      l = [],
      _this$frontier$t = this.frontier[t],
      u = _this$frontier$t.match,
      d = _this$frontier$t.type;
    if (r) {
      for (let e = 0; e < r.childCount; e++) l.push(r.child(e));
      u = u.matchFragment(r);
    }
    let f = a.size + e - (i.content.size - i.openEnd);
    for (; s < a.childCount;) {
      let e = a.child(s),
        t = u.matchType(e.type);
      if (!t) break;
      s++, (s > 1 || 0 == c || e.content.size) && (u = t, l.push(cS(e.mark(d.allowedMarks(e.marks)), 1 == s ? c : 0, s == a.childCount ? f : -1)));
    }
    let p = s == a.childCount;
    p || (f = -1), this.placed = iS(this.placed, t, wk.from(l)), this.frontier[t].match = u, p && f < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let e = 0, t = a; e < f; e++) {
      let e = t.lastChild;
      this.frontier.push({
        type: e.type,
        match: e.contentMatchAt(e.childCount)
      }), t = e.content;
    }
    this.unplaced = p ? 0 == e ? Nk.empty : new Nk(oS(i.content, e - 1, 1), e - 1, f < 0 ? i.openEnd : e - 1) : new Nk(oS(i.content, e, s), i.openStart, i.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock) return -1;
    let e,
      t = this.frontier[this.depth];
    if (!t.type.isTextblock || !sS(this.$to, this.$to.depth, t.type, t.match, !1) || this.$to.depth == this.depth && (e = this.findCloseLevel(this.$to)) && e.depth == this.depth) return -1;
    let n = this.$to.depth,
      r = this.$to.after(n);
    for (; n > 1 && r == this.$to.end(--n);) ++r;
    return r;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let _this$frontier$t2 = this.frontier[t],
        n = _this$frontier$t2.match,
        r = _this$frontier$t2.type,
        o = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)),
        i = sS(e, t, r, n, o);
      if (i) {
        for (let n = t - 1; n >= 0; n--) {
          let _this$frontier$n = this.frontier[n],
            t = _this$frontier$n.match,
            r = _this$frontier$n.type,
            o = sS(e, n, r, t, !0);
          if (!o || o.childCount) continue e;
        }
        return {
          depth: t,
          fit: i,
          move: o ? e.doc.resolve(e.after(t + 1)) : e
        };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t) return null;
    for (; this.depth > t.depth;) this.closeFrontierNode();
    t.fit.childCount && (this.placed = iS(this.placed, t.depth, t.fit)), e = t.move;
    for (let n = t.depth + 1; n <= e.depth; n++) {
      let t = e.node(n),
        r = t.type.contentMatch.fillBefore(t.content, !0, e.index(n));
      this.openFrontierNode(t.type, t.attrs, r);
    }
    return e;
  }
  openFrontierNode(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(e), this.placed = iS(this.placed, this.depth, wk.from(e.create(t, n))), this.frontier.push({
      type: e,
      match: e.contentMatch
    });
  }
  closeFrontierNode() {
    let e = this.frontier.pop().match.fillBefore(wk.empty, !0);
    e.childCount && (this.placed = iS(this.placed, this.frontier.length, e));
  }
}
function oS(e, t, n) {
  return 0 == t ? e.cutByIndex(n, e.childCount) : e.replaceChild(0, e.firstChild.copy(oS(e.firstChild.content, t - 1, n)));
}
function iS(e, t, n) {
  return 0 == t ? e.append(n) : e.replaceChild(e.childCount - 1, e.lastChild.copy(iS(e.lastChild.content, t - 1, n)));
}
function aS(e, t) {
  for (let n = 0; n < t; n++) e = e.firstChild.content;
  return e;
}
function cS(e, t, n) {
  if (t <= 0) return e;
  let r = e.content;
  return t > 1 && (r = r.replaceChild(0, cS(r.firstChild, t - 1, 1 == r.childCount ? n - 1 : 0))), t > 0 && (r = e.type.contentMatch.fillBefore(r).append(r), n <= 0 && (r = r.append(e.type.contentMatch.matchFragment(r).fillBefore(wk.empty, !0)))), e.copy(r);
}
function sS(e, t, n, r, o) {
  let i = e.node(t),
    a = o ? e.indexAfter(t) : e.index(t);
  if (a == i.childCount && !n.compatibleContent(i.type)) return null;
  let c = r.fillBefore(i.content, !0, a);
  return c && !function (e, t, n) {
    for (let r = n; r < t.childCount; r++) if (!e.allowsMarks(t.child(r).marks)) return !0;
    return !1;
  }(n, i.content, a) ? c : null;
}
function lS(e, t, n, r, o) {
  if (t < n) {
    let o = e.firstChild;
    e = e.replaceChild(0, o.copy(lS(o.content, t + 1, n, r, o)));
  }
  if (t > r) {
    let t = o.contentMatchAt(0),
      n = t.fillBefore(e).append(e);
    e = n.append(t.matchFragment(n).fillBefore(wk.empty, !0));
  }
  return e;
}
function uS(e, t) {
  let n = [];
  for (let r = Math.min(e.depth, t.depth); r >= 0; r--) {
    let o = e.start(r);
    if (o < e.pos - (e.depth - r) || t.end(r) > t.pos + (t.depth - r) || e.node(r).type.spec.isolating || t.node(r).type.spec.isolating) break;
    (o == t.start(r) || r == e.depth && r == t.depth && e.parent.inlineContent && t.parent.inlineContent && r && t.start(r - 1) == o - 1) && n.push(r);
  }
  return n;
}
class dS extends PN {
  constructor(e, t, n) {
    super(), this.pos = e, this.attr = t, this.value = n;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t) return ON.fail("No node at attribute step's position");
    let n = Object.create(null);
    for (let e in t.attrs) n[e] = t.attrs[e];
    n[this.attr] = this.value;
    let r = t.type.create(n, null, t.marks);
    return ON.fromReplace(e, this.pos, this.pos + 1, new Nk(wk.from(r), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return SN.empty;
  }
  invert(e) {
    return new dS(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new dS(t.pos, this.attr, this.value);
  }
  toJSON() {
    return {
      stepType: "attr",
      pos: this.pos,
      attr: this.attr,
      value: this.value
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.pos || "string" != typeof t.attr) throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new dS(t.pos, t.attr, t.value);
  }
}
PN.jsonID("attr", dS);
class fS extends PN {
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = Object.create(null);
    for (let n in e.attrs) t[n] = e.attrs[n];
    t[this.attr] = this.value;
    let n = e.type.create(t, e.content, e.marks);
    return ON.ok(n);
  }
  getMap() {
    return SN.empty;
  }
  invert(e) {
    return new fS(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return {
      stepType: "docAttr",
      attr: this.attr,
      value: this.value
    };
  }
  static fromJSON(e, t) {
    if ("string" != typeof t.attr) throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new fS(t.attr, t.value);
  }
}
PN.jsonID("docAttr", fS);
let pS = class extends Error {};
pS = function e(t) {
  let n = Error.call(this, t);
  return n.__proto__ = e.prototype, n;
}, (pS.prototype = Object.create(Error.prototype)).constructor = pS, pS.prototype.name = "TransformError";
class mS {
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new VN();
  }
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed) throw new pS(t.failed);
    return this;
  }
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  get docChanged() {
    return this.steps.length > 0;
  }
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  replace(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Nk.empty;
    let r = tS(this.doc, e, t, n);
    return r && this.step(r), this;
  }
  replaceWith(e, t, n) {
    return this.replace(e, t, new Nk(wk.from(n), 0, 0));
  }
  delete(e, t) {
    return this.replace(e, t, Nk.empty);
  }
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  replaceRange(e, t, n) {
    return function (e, t, n, r) {
      if (!r.size) return e.deleteRange(t, n);
      let o = e.doc.resolve(t),
        i = e.doc.resolve(n);
      if (nS(o, i, r)) return e.step(new jN(t, n, r));
      let a = uS(o, e.doc.resolve(n));
      0 == a[a.length - 1] && a.pop();
      let c = -(o.depth + 1);
      a.unshift(c);
      for (let e = o.depth, t = o.pos - 1; e > 0; e--, t--) {
        let n = o.node(e).type.spec;
        if (n.defining || n.definingAsContext || n.isolating) break;
        a.indexOf(e) > -1 ? c = e : o.before(e) == t && a.splice(1, 0, -e);
      }
      let s = a.indexOf(c),
        l = [],
        u = r.openStart;
      for (let e = r.content, t = 0;; t++) {
        let n = e.firstChild;
        if (l.push(n), t == r.openStart) break;
        e = n.content;
      }
      for (let e = u - 1; e >= 0; e--) {
        let t = l[e],
          n = (d = t.type).spec.defining || d.spec.definingForContent;
        if (n && !t.sameMarkup(o.node(Math.abs(c) - 1))) u = e;else if (n || !t.type.isTextblock) break;
      }
      var d;
      for (let t = r.openStart; t >= 0; t--) {
        let c = (t + u + 1) % (r.openStart + 1),
          d = l[c];
        if (d) for (let t = 0; t < a.length; t++) {
          let l = a[(t + s) % a.length],
            u = !0;
          l < 0 && (u = !1, l = -l);
          let f = o.node(l - 1),
            p = o.index(l - 1);
          if (f.canReplaceWith(p, p, d.type, d.marks)) return e.replace(o.before(l), u ? i.after(l) : n, new Nk(lS(r.content, 0, r.openStart, c), c, r.openEnd));
        }
      }
      let f = e.steps.length;
      for (let c = a.length - 1; c >= 0 && (e.replace(t, n, r), !(e.steps.length > f)); c--) {
        let e = a[c];
        e < 0 || (t = o.before(e), n = i.after(e));
      }
    }(this, e, t, n), this;
  }
  replaceRangeWith(e, t, n) {
    return function (e, t, n, r) {
      if (!r.isInline && t == n && e.doc.resolve(t).parent.content.size) {
        let o = function (e, t, n) {
          let r = e.resolve(t);
          if (r.parent.canReplaceWith(r.index(), r.index(), n)) return t;
          if (0 == r.parentOffset) for (let e = r.depth - 1; e >= 0; e--) {
            let t = r.index(e);
            if (r.node(e).canReplaceWith(t, t, n)) return r.before(e + 1);
            if (t > 0) return null;
          }
          if (r.parentOffset == r.parent.content.size) for (let e = r.depth - 1; e >= 0; e--) {
            let t = r.indexAfter(e);
            if (r.node(e).canReplaceWith(t, t, n)) return r.after(e + 1);
            if (t < r.node(e).childCount) return null;
          }
          return null;
        }(e.doc, t, r.type);
        null != o && (t = n = o);
      }
      e.replaceRange(t, n, new Nk(wk.from(r), 0, 0));
    }(this, e, t, n), this;
  }
  deleteRange(e, t) {
    return function (e, t, n) {
      let r = e.doc.resolve(t),
        o = e.doc.resolve(n),
        i = uS(r, o);
      for (let t = 0; t < i.length; t++) {
        let n = i[t],
          a = t == i.length - 1;
        if (a && 0 == n || r.node(n).type.contentMatch.validEnd) return e.delete(r.start(n), o.end(n));
        if (n > 0 && (a || r.node(n - 1).canReplace(r.index(n - 1), o.indexAfter(n - 1)))) return e.delete(r.before(n), o.after(n));
      }
      for (let i = 1; i <= r.depth && i <= o.depth; i++) if (t - r.start(i) == r.depth - i && n > r.end(i) && o.end(i) - n != o.depth - i) return e.delete(r.before(i), n);
      e.delete(t, n);
    }(this, e, t), this;
  }
  lift(e, t) {
    return function (e, t, n) {
      let r = t.$from,
        o = t.$to,
        i = t.depth,
        a = r.before(i + 1),
        c = o.after(i + 1),
        s = a,
        l = c,
        u = wk.empty,
        d = 0;
      for (let e = i, t = !1; e > n; e--) t || r.index(e) > 0 ? (t = !0, u = wk.from(r.node(e).copy(u)), d++) : s--;
      let f = wk.empty,
        p = 0;
      for (let e = i, t = !1; e > n; e--) t || o.after(e + 1) < o.end(e) ? (t = !0, f = wk.from(o.node(e).copy(f)), p++) : l++;
      e.step(new JN(s, l, a, c, new Nk(u.append(f), d, p), u.size - d, !0));
    }(this, e, t), this;
  }
  join(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return function (e, t, n) {
      let r = new jN(t - n, t + n, Nk.empty, !0);
      e.step(r);
    }(this, e, t), this;
  }
  wrap(e, t) {
    return function (e, t, n) {
      let r = wk.empty;
      for (let e = n.length - 1; e >= 0; e--) {
        if (r.size) {
          let t = n[e].type.contentMatch.matchFragment(r);
          if (!t || !t.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        r = wk.from(n[e].type.create(n[e].attrs, r));
      }
      let o = t.start,
        i = t.end;
      e.step(new JN(o, i, o, i, new Nk(r, 0, 0), n.length, !0));
    }(this, e, t), this;
  }
  setBlockType(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    return function (e, t, n, r, o) {
      if (!r.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
      let i = e.steps.length;
      e.doc.nodesBetween(t, n, (t, n) => {
        if (t.isTextblock && !t.hasMarkup(r, o) && function (e, t, n) {
          let r = e.resolve(t),
            o = r.index();
          return r.parent.canReplaceWith(o, o + 1, n);
        }(e.doc, e.mapping.slice(i).map(n), r)) {
          e.clearIncompatible(e.mapping.slice(i).map(n, 1), r);
          let a = e.mapping.slice(i),
            c = a.map(n, 1),
            s = a.map(n + t.nodeSize, 1);
          return e.step(new JN(c, s, c + 1, s - 1, new Nk(wk.from(r.create(o, null, t.marks)), 0, 0), 1, !0)), !1;
        }
      });
    }(this, e, t, n, r), this;
  }
  setNodeMarkup(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let r = arguments.length > 3 ? arguments[3] : undefined;
    return function (e, t, n, r, o) {
      let i = e.doc.nodeAt(t);
      if (!i) throw new RangeError("No node at given position");
      n || (n = i.type);
      let a = n.create(r, null, o || i.marks);
      if (i.isLeaf) return e.replaceWith(t, t + i.nodeSize, a);
      if (!n.validContent(i.content)) throw new RangeError("Invalid content for node type " + n.name);
      e.step(new JN(t, t + i.nodeSize, t + 1, t + i.nodeSize - 1, new Nk(wk.from(a), 0, 0), 1, !0));
    }(this, e, t, n, r), this;
  }
  setNodeAttribute(e, t, n) {
    return this.step(new dS(e, t, n)), this;
  }
  setDocAttribute(e, t) {
    return this.step(new fS(e, t)), this;
  }
  addNodeMark(e, t) {
    return this.step(new GN(e, t)), this;
  }
  removeNodeMark(e, t) {
    if (!(t instanceof Mk)) {
      let n = this.doc.nodeAt(e);
      if (!n) throw new RangeError("No node at position " + e);
      if (t = t.isInSet(n.marks), !t) return this;
    }
    return this.step(new FN(e, t)), this;
  }
  split(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    let n = arguments.length > 2 ? arguments[2] : undefined;
    return function (e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      let r = arguments.length > 3 ? arguments[3] : undefined;
      let o = e.doc.resolve(t),
        i = wk.empty,
        a = wk.empty;
      for (let e = o.depth, t = o.depth - n, c = n - 1; e > t; e--, c--) {
        i = wk.from(o.node(e).copy(i));
        let t = r && r[c];
        a = wk.from(t ? t.type.create(t.attrs, a) : o.node(e).copy(a));
      }
      e.step(new jN(t, t, new Nk(i.append(a), n, n), !0));
    }(this, e, t, n), this;
  }
  addMark(e, t, n) {
    return function (e, t, n, r) {
      let o,
        i,
        a = [],
        c = [];
      e.doc.nodesBetween(t, n, (e, s, l) => {
        if (!e.isInline) return;
        let u = e.marks;
        if (!r.isInSet(u) && l.type.allowsMarkType(r.type)) {
          let l = Math.max(s, t),
            d = Math.min(s + e.nodeSize, n),
            f = r.addToSet(u);
          for (let e = 0; e < u.length; e++) u[e].isInSet(f) || (o && o.to == l && o.mark.eq(u[e]) ? o.to = d : a.push(o = new RN(l, d, u[e])));
          i && i.to == l ? i.to = d : c.push(i = new DN(l, d, r));
        }
      }), a.forEach(t => e.step(t)), c.forEach(t => e.step(t));
    }(this, e, t, n), this;
  }
  removeMark(e, t, n) {
    return function (e, t, n, r) {
      let o = [],
        i = 0;
      e.doc.nodesBetween(t, n, (e, a) => {
        if (!e.isInline) return;
        i++;
        let c = null;
        if (r instanceof pN) {
          let t,
            n = e.marks;
          for (; t = r.isInSet(n);) (c || (c = [])).push(t), n = t.removeFromSet(n);
        } else r ? r.isInSet(e.marks) && (c = [r]) : c = e.marks;
        if (c && c.length) {
          let r = Math.min(a + e.nodeSize, n);
          for (let e = 0; e < c.length; e++) {
            let n,
              s = c[e];
            for (let e = 0; e < o.length; e++) {
              let t = o[e];
              t.step == i - 1 && s.eq(o[e].style) && (n = t);
            }
            n ? (n.to = r, n.step = i) : o.push({
              style: s,
              from: Math.max(a, t),
              to: r,
              step: i
            });
          }
        }
      }), o.forEach(t => e.step(new RN(t.from, t.to, t.style)));
    }(this, e, t, n), this;
  }
  clearIncompatible(e, t, n) {
    return function (e, t, n) {
      let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : n.contentMatch;
      let o = e.doc.nodeAt(t),
        i = [],
        a = t + 1;
      for (let t = 0; t < o.childCount; t++) {
        let c = o.child(t),
          s = a + c.nodeSize,
          l = r.matchType(c.type);
        if (l) {
          r = l;
          for (let t = 0; t < c.marks.length; t++) n.allowsMarkType(c.marks[t].type) || e.step(new RN(a, s, c.marks[t]));
          if (c.isText && !n.spec.code) {
            let e,
              t,
              r = /\r?\n|\r/g;
            for (; e = r.exec(c.text);) t || (t = new Nk(wk.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), i.push(new jN(a + e.index, a + e.index + e[0].length, t));
          }
        } else i.push(new jN(a, s, Nk.empty));
        a = s;
      }
      if (!r.validEnd) {
        let t = r.fillBefore(wk.empty, !0);
        e.replace(a, a, new Nk(t, 0, 0));
      }
      for (let t = i.length - 1; t >= 0; t--) e.step(i[t]);
    }(this, e, t, n), this;
  }
}
const hS = Object.create(null);
class AS {
  constructor(e, t, n) {
    this.$anchor = e, this.$head = t, this.ranges = n || [new gS(e.min(t), e.max(t))];
  }
  get anchor() {
    return this.$anchor.pos;
  }
  get head() {
    return this.$head.pos;
  }
  get from() {
    return this.$from.pos;
  }
  get to() {
    return this.$to.pos;
  }
  get $from() {
    return this.ranges[0].$from;
  }
  get $to() {
    return this.ranges[0].$to;
  }
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++) if (e[t].$from.pos != e[t].$to.pos) return !1;
    return !0;
  }
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  replace(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Nk.empty;
    let n = t.content.lastChild,
      r = null;
    for (let e = 0; e < t.openEnd; e++) r = n, n = n.lastChild;
    let o = e.steps.length,
      i = this.ranges;
    for (let a = 0; a < i.length; a++) {
      let _i$a = i[a],
        c = _i$a.$from,
        s = _i$a.$to,
        l = e.mapping.slice(o);
      e.replaceRange(l.map(c.pos), l.map(s.pos), a ? Nk.empty : t), 0 == a && QS(e, o, (n ? n.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  replaceWith(e, t) {
    let n = e.steps.length,
      r = this.ranges;
    for (let o = 0; o < r.length; o++) {
      let _r$o = r[o],
        i = _r$o.$from,
        a = _r$o.$to,
        c = e.mapping.slice(n),
        s = c.map(i.pos),
        l = c.map(a.pos);
      o ? e.deleteRange(s, l) : (e.replaceRangeWith(s, l, t), QS(e, n, t.isInline ? -1 : 1));
    }
  }
  static findFrom(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    let r = e.parent.inlineContent ? new bS(e) : wS(e.node(0), e.parent, e.pos, e.index(), t, n);
    if (r) return r;
    for (let r = e.depth - 1; r >= 0; r--) {
      let o = t < 0 ? wS(e.node(0), e.node(r), e.before(r + 1), e.index(r), t, n) : wS(e.node(0), e.node(r), e.after(r + 1), e.index(r) + 1, t, n);
      if (o) return o;
    }
    return null;
  }
  static near(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return this.findFrom(e, t) || this.findFrom(e, -t) || new BS(e.node(0));
  }
  static atStart(e) {
    return wS(e, e, 0, 0, 1) || new BS(e);
  }
  static atEnd(e) {
    return wS(e, e, e.content.size, e.childCount, -1) || new BS(e);
  }
  static fromJSON(e, t) {
    if (!t || !t.type) throw new RangeError("Invalid input for Selection.fromJSON");
    let n = hS[t.type];
    if (!n) throw new RangeError(`No selection type ${t.type} defined`);
    return n.fromJSON(e, t);
  }
  static jsonID(e, t) {
    if (e in hS) throw new RangeError("Duplicate use of selection JSON ID " + e);
    return hS[e] = t, t.prototype.jsonID = e, t;
  }
  getBookmark() {
    return bS.between(this.$anchor, this.$head).getBookmark();
  }
}
AS.prototype.visible = !0;
class gS {
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}
let vS = !1;
function CS(e) {
  vS || e.parent.inlineContent || (vS = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + e.parent.type.name + ")"));
}
class bS extends AS {
  constructor(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
    CS(e), CS(t), super(e, t);
  }
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let n = e.resolve(t.map(this.head));
    if (!n.parent.inlineContent) return AS.near(n);
    let r = e.resolve(t.map(this.anchor));
    return new bS(r.parent.inlineContent ? r : n, n);
  }
  replace(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Nk.empty;
    if (super.replace(e, t), t == Nk.empty) {
      let t = this.$from.marksAcross(this.$to);
      t && e.ensureMarks(t);
    }
  }
  eq(e) {
    return e instanceof bS && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new ES(this.anchor, this.head);
  }
  toJSON() {
    return {
      type: "text",
      anchor: this.anchor,
      head: this.head
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.anchor || "number" != typeof t.head) throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new bS(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
    let r = e.resolve(t);
    return new this(r, n == t ? r : e.resolve(n));
  }
  static between(e, t, n) {
    let r = e.pos - t.pos;
    if (n && !r || (n = r >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let e = AS.findFrom(t, n, !0) || AS.findFrom(t, -n, !0);
      if (!e) return AS.near(t, n);
      t = e.$head;
    }
    return e.parent.inlineContent || (0 == r || (e = (AS.findFrom(e, -n, !0) || AS.findFrom(e, n, !0)).$anchor).pos < t.pos != r < 0) && (e = t), new bS(e, t);
  }
}
AS.jsonID("text", bS);
class ES {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new ES(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return bS.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class yS extends AS {
  constructor(e) {
    let t = e.nodeAfter,
      n = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, n), this.node = t;
  }
  map(e, t) {
    let _t$mapResult = t.mapResult(this.anchor),
      n = _t$mapResult.deleted,
      r = _t$mapResult.pos,
      o = e.resolve(r);
    return n ? AS.near(o) : new yS(o);
  }
  content() {
    return new Nk(wk.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof yS && e.anchor == this.anchor;
  }
  toJSON() {
    return {
      type: "node",
      anchor: this.anchor
    };
  }
  getBookmark() {
    return new IS(this.anchor);
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.anchor) throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new yS(e.resolve(t.anchor));
  }
  static create(e, t) {
    return new yS(e.resolve(t));
  }
  static isSelectable(e) {
    return !e.isText && !1 !== e.type.spec.selectable;
  }
}
yS.prototype.visible = !1, AS.jsonID("node", yS);
class IS {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let _e$mapResult = e.mapResult(this.anchor),
      t = _e$mapResult.deleted,
      n = _e$mapResult.pos;
    return t ? new ES(n, n) : new IS(n);
  }
  resolve(e) {
    let t = e.resolve(this.anchor),
      n = t.nodeAfter;
    return n && yS.isSelectable(n) ? new yS(t) : AS.near(t);
  }
}
class BS extends AS {
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Nk.empty;
    if (t == Nk.empty) {
      e.delete(0, e.doc.content.size);
      let t = AS.atStart(e.doc);
      t.eq(e.selection) || e.setSelection(t);
    } else super.replace(e, t);
  }
  toJSON() {
    return {
      type: "all"
    };
  }
  static fromJSON(e) {
    return new BS(e);
  }
  map(e) {
    return new BS(e);
  }
  eq(e) {
    return e instanceof BS;
  }
  getBookmark() {
    return xS;
  }
}
AS.jsonID("all", BS);
const xS = {
  map() {
    return this;
  },
  resolve: e => new BS(e)
};
function wS(e, t, n, r, o) {
  let i = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : !1;
  if (t.inlineContent) return bS.create(e, n);
  for (let a = r - (o > 0 ? 0 : 1); o > 0 ? a < t.childCount : a >= 0; a += o) {
    let r = t.child(a);
    if (r.isAtom) {
      if (!i && yS.isSelectable(r)) return yS.create(e, n - (o < 0 ? r.nodeSize : 0));
    } else {
      let t = wS(e, r, n + o, o < 0 ? r.childCount : 0, o, i);
      if (t) return t;
    }
    n += r.nodeSize * o;
  }
  return null;
}
function QS(e, t, n) {
  let r = e.steps.length - 1;
  if (r < t) return;
  let o,
    i = e.steps[r];
  (i instanceof jN || i instanceof JN) && (e.mapping.maps[r].forEach((e, t, n, r) => {
    null == o && (o = r);
  }), e.setSelection(AS.near(e.doc.resolve(o), n)));
}
class HS extends mS {
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  setSelection(e) {
    if (e.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = -3 & (1 | this.updated), this.storedMarks = null, this;
  }
  get selectionSet() {
    return (1 & this.updated) > 0;
  }
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= 2, this;
  }
  ensureMarks(e) {
    return Mk.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  get storedMarksSet() {
    return (2 & this.updated) > 0;
  }
  addStep(e, t) {
    super.addStep(e, t), this.updated = -3 & this.updated, this.storedMarks = null;
  }
  setTime(e) {
    return this.time = e, this;
  }
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  replaceSelectionWith(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    let n = this.selection;
    return t && (e = e.mark(this.storedMarks || (n.empty ? n.$from.marks() : n.$from.marksAcross(n.$to) || Mk.none))), n.replaceWith(this, e), this;
  }
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  insertText(e, t, n) {
    let r = this.doc.type.schema;
    if (null == t) return e ? this.replaceSelectionWith(r.text(e), !0) : this.deleteSelection();
    {
      if (null == n && (n = t), n = null == n ? t : n, !e) return this.deleteRange(t, n);
      let o = this.storedMarks;
      if (!o) {
        let e = this.doc.resolve(t);
        o = n == t ? e.marks() : e.marksAcross(this.doc.resolve(n));
      }
      return this.replaceRangeWith(t, n, r.text(e, o)), this.selection.empty || this.setSelection(AS.near(this.selection.$to)), this;
    }
  }
  setMeta(e, t) {
    return this.meta["string" == typeof e ? e : e.key] = t, this;
  }
  getMeta(e) {
    return this.meta["string" == typeof e ? e : e.key];
  }
  get isGeneric() {
    for (let e in this.meta) return !1;
    return !0;
  }
  scrollIntoView() {
    return this.updated |= 4, this;
  }
  get scrolledIntoView() {
    return (4 & this.updated) > 0;
  }
}
function zS(e, t) {
  return t && e ? e.bind(t) : e;
}
class MS {
  constructor(e, t, n) {
    this.name = e, this.init = zS(t.init, n), this.apply = zS(t.apply, n);
  }
}
const kS = [new MS("doc", {
  init: e => e.doc || e.schema.topNodeType.createAndFill(),
  apply: e => e.doc
}), new MS("selection", {
  init: (e, t) => e.selection || AS.atStart(t.doc),
  apply: e => e.selection
}), new MS("storedMarks", {
  init: e => e.storedMarks || null,
  apply: (e, t, n, r) => r.selection.$cursor ? e.storedMarks : null
}), new MS("scrollToSelection", {
  init: () => 0,
  apply: (e, t) => e.scrolledIntoView ? t + 1 : t
})];
class NS {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = Object.create(null), this.fields = kS.slice(), t && t.forEach(e => {
      if (this.pluginsByKey[e.key]) throw new RangeError("Adding different instances of a keyed plugin (" + e.key + ")");
      this.plugins.push(e), this.pluginsByKey[e.key] = e, e.spec.state && this.fields.push(new MS(e.key, e.spec.state, e));
    });
  }
}
class SS {
  constructor(e) {
    this.config = e;
  }
  get schema() {
    return this.config.schema;
  }
  get plugins() {
    return this.config.plugins;
  }
  apply(e) {
    return this.applyTransaction(e).state;
  }
  filterTransaction(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    for (let n = 0; n < this.config.plugins.length; n++) if (n != t) {
      let t = this.config.plugins[n];
      if (t.spec.filterTransaction && !t.spec.filterTransaction.call(t, e, this)) return !1;
    }
    return !0;
  }
  applyTransaction(e) {
    if (!this.filterTransaction(e)) return {
      state: this,
      transactions: []
    };
    let t = [e],
      n = this.applyInner(e),
      r = null;
    for (;;) {
      let o = !1;
      for (let i = 0; i < this.config.plugins.length; i++) {
        let a = this.config.plugins[i];
        if (a.spec.appendTransaction) {
          let c = r ? r[i].n : 0,
            s = r ? r[i].state : this,
            l = c < t.length && a.spec.appendTransaction.call(a, c ? t.slice(c) : t, s, n);
          if (l && n.filterTransaction(l, i)) {
            if (l.setMeta("appendedTransaction", e), !r) {
              r = [];
              for (let e = 0; e < this.config.plugins.length; e++) r.push(e < i ? {
                state: n,
                n: t.length
              } : {
                state: this,
                n: 0
              });
            }
            t.push(l), n = n.applyInner(l), o = !0;
          }
          r && (r[i] = {
            state: n,
            n: t.length
          });
        }
      }
      if (!o) return {
        state: n,
        transactions: t
      };
    }
  }
  applyInner(e) {
    if (!e.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
    let t = new SS(this.config),
      n = this.config.fields;
    for (let r = 0; r < n.length; r++) {
      let o = n[r];
      t[o.name] = o.apply(e, this[o.name], this, t);
    }
    return t;
  }
  get tr() {
    return new HS(this);
  }
  static create(e) {
    let t = new NS(e.doc ? e.doc.type.schema : e.schema, e.plugins),
      n = new SS(t);
    for (let r = 0; r < t.fields.length; r++) n[t.fields[r].name] = t.fields[r].init(e, n);
    return n;
  }
  reconfigure(e) {
    let t = new NS(this.schema, e.plugins),
      n = t.fields,
      r = new SS(t);
    for (let t = 0; t < n.length; t++) {
      let o = n[t].name;
      r[o] = this.hasOwnProperty(o) ? this[o] : n[t].init(e, r);
    }
    return r;
  }
  toJSON(e) {
    let t = {
      doc: this.doc.toJSON(),
      selection: this.selection.toJSON()
    };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map(e => e.toJSON())), e && "object" == typeof e) for (let n in e) {
      if ("doc" == n || "selection" == n) throw new RangeError("The JSON fields `doc` and `selection` are reserved");
      let r = e[n],
        o = r.spec.state;
      o && o.toJSON && (t[n] = o.toJSON.call(r, this[r.key]));
    }
    return t;
  }
  static fromJSON(e, t, n) {
    if (!t) throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema) throw new RangeError("Required config field 'schema' missing");
    let r = new NS(e.schema, e.plugins),
      o = new SS(r);
    return r.fields.forEach(r => {
      if ("doc" == r.name) o.doc = Yk.fromJSON(e.schema, t.doc);else if ("selection" == r.name) o.selection = AS.fromJSON(o.doc, t.selection);else if ("storedMarks" == r.name) t.storedMarks && (o.storedMarks = t.storedMarks.map(e.schema.markFromJSON));else {
        if (n) for (let i in n) {
          let a = n[i],
            c = a.spec.state;
          if (a.key == r.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(t, i)) return void (o[r.name] = c.fromJSON.call(a, e, t[i], o));
        }
        o[r.name] = r.init(e, o);
      }
    }), o;
  }
}
function VS(e, t, n) {
  for (let r in e) {
    let o = e[r];
    o instanceof Function ? o = o.bind(t) : "handleDOMEvents" == r && (o = VS(o, t, {})), n[r] = o;
  }
  return n;
}
class LS {
  constructor(e) {
    this.spec = e, this.props = {}, e.props && VS(e.props, this, this.props), this.key = e.key ? e.key.key : OS("plugin");
  }
  getState(e) {
    return e[this.key];
  }
}
const PS = Object.create(null);
function OS(e) {
  return e in PS ? e + "$" + ++PS[e] : (PS[e] = 0, e + "$");
}
class TS {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "key";
    this.key = OS(e);
  }
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  getState(e) {
    return e[this.key];
  }
}
const DS = function (e) {
    for (var t = 0;; t++) if (!(e = e.previousSibling)) return t;
  },
  RS = function (e) {
    let t = e.assignedSlot || e.parentNode;
    return t && 11 == t.nodeType ? t.host : t;
  };
let GS = null;
const FS = function (e, t, n) {
    let r = GS || (GS = document.createRange());
    return r.setEnd(e, null == n ? e.nodeValue.length : n), r.setStart(e, t || 0), r;
  },
  jS = function (e, t, n, r) {
    return n && (ZS(e, t, n, r, -1) || ZS(e, t, n, r, 1));
  },
  JS = /^(img|br|input|textarea|hr)$/i;
function ZS(e, t, n, r, o) {
  for (;;) {
    if (e == n && t == r) return !0;
    if (t == (o < 0 ? 0 : WS(e))) {
      let n = e.parentNode;
      if (!n || 1 != n.nodeType || XS(e) || JS.test(e.nodeName) || "false" == e.contentEditable) return !1;
      t = DS(e) + (o < 0 ? 0 : 1), e = n;
    } else {
      if (1 != e.nodeType) return !1;
      if ("false" == (e = e.childNodes[t + (o < 0 ? -1 : 0)]).contentEditable) return !1;
      t = o < 0 ? WS(e) : 0;
    }
  }
}
function WS(e) {
  return 3 == e.nodeType ? e.nodeValue.length : e.childNodes.length;
}
function XS(e) {
  let t;
  for (let n = e; n && !(t = n.pmViewDesc); n = n.parentNode);
  return t && t.node && t.node.isBlock && (t.dom == e || t.contentDOM == e);
}
const US = function (e) {
  return e.focusNode && jS(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset);
};
function KS(e, t) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = e, n.key = n.code = t, n;
}
const YS = "undefined" != typeof navigator ? navigator : null,
  qS = "undefined" != typeof document ? document : null,
  _S = YS && YS.userAgent || "",
  $S = /Edge\/(\d+)/.exec(_S),
  eV = /MSIE \d/.exec(_S),
  tV = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(_S),
  nV = !!(eV || tV || $S),
  rV = eV ? document.documentMode : tV ? +tV[1] : $S ? +$S[1] : 0,
  oV = !nV && /gecko\/(\d+)/i.test(_S);
oV && (/Firefox\/(\d+)/.exec(_S) || [0, 0])[1];
const iV = !nV && /Chrome\/(\d+)/.exec(_S),
  aV = !!iV,
  cV = iV ? +iV[1] : 0,
  sV = !nV && !!YS && /Apple Computer/.test(YS.vendor),
  lV = sV && (/Mobile\/\w+/.test(_S) || !!YS && YS.maxTouchPoints > 2),
  uV = lV || !!YS && /Mac/.test(YS.platform),
  dV = !!YS && /Win/.test(YS.platform),
  fV = /Android \d/.test(_S),
  pV = !!qS && "webkitFontSmoothing" in qS.documentElement.style,
  mV = pV ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function hV(e) {
  return {
    left: 0,
    right: e.documentElement.clientWidth,
    top: 0,
    bottom: e.documentElement.clientHeight
  };
}
function AV(e, t) {
  return "number" == typeof e ? e : e[t];
}
function gV(e) {
  let t = e.getBoundingClientRect(),
    n = t.width / e.offsetWidth || 1,
    r = t.height / e.offsetHeight || 1;
  return {
    left: t.left,
    right: t.left + e.clientWidth * n,
    top: t.top,
    bottom: t.top + e.clientHeight * r
  };
}
function vV(e, t, n) {
  let r = e.someProp("scrollThreshold") || 0,
    o = e.someProp("scrollMargin") || 5,
    i = e.dom.ownerDocument;
  for (let a = n || e.dom; a; a = RS(a)) {
    if (1 != a.nodeType) continue;
    let e = a,
      n = e == i.body,
      c = n ? hV(i) : gV(e),
      s = 0,
      l = 0;
    if (t.top < c.top + AV(r, "top") ? l = -(c.top - t.top + AV(o, "top")) : t.bottom > c.bottom - AV(r, "bottom") && (l = t.bottom - t.top > c.bottom - c.top ? t.top + AV(o, "top") - c.top : t.bottom - c.bottom + AV(o, "bottom")), t.left < c.left + AV(r, "left") ? s = -(c.left - t.left + AV(o, "left")) : t.right > c.right - AV(r, "right") && (s = t.right - c.right + AV(o, "right")), s || l) if (n) i.defaultView.scrollBy(s, l);else {
      let n = e.scrollLeft,
        r = e.scrollTop;
      l && (e.scrollTop += l), s && (e.scrollLeft += s);
      let o = e.scrollLeft - n,
        i = e.scrollTop - r;
      t = {
        left: t.left - o,
        top: t.top - i,
        right: t.right - o,
        bottom: t.bottom - i
      };
    }
    if (n || /^(fixed|sticky)$/.test(getComputedStyle(a).position)) break;
  }
}
function CV(e) {
  let t = [],
    n = e.ownerDocument;
  for (let r = e; r && (t.push({
    dom: r,
    top: r.scrollTop,
    left: r.scrollLeft
  }), e != n); r = RS(r));
  return t;
}
function bV(e, t) {
  for (let n = 0; n < e.length; n++) {
    let _e$n = e[n],
      r = _e$n.dom,
      o = _e$n.top,
      i = _e$n.left;
    r.scrollTop != o + t && (r.scrollTop = o + t), r.scrollLeft != i && (r.scrollLeft = i);
  }
}
let EV = null;
function yV(e, t) {
  let n,
    r,
    o,
    i,
    a = 2e8,
    c = 0,
    s = t.top,
    l = t.top;
  for (let u = e.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let e;
    if (1 == u.nodeType) e = u.getClientRects();else {
      if (3 != u.nodeType) continue;
      e = FS(u).getClientRects();
    }
    for (let f = 0; f < e.length; f++) {
      let p = e[f];
      if (p.top <= s && p.bottom >= l) {
        s = Math.max(p.bottom, s), l = Math.min(p.top, l);
        let e = p.left > t.left ? p.left - t.left : p.right < t.left ? t.left - p.right : 0;
        if (e < a) {
          n = u, a = e, r = e && 3 == n.nodeType ? {
            left: p.right < t.left ? p.right : p.left,
            top: t.top
          } : t, 1 == u.nodeType && e && (c = d + (t.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > t.top && !o && p.left <= t.left && p.right >= t.left && (o = u, i = {
        left: Math.max(p.left, Math.min(p.right, t.left)),
        top: p.top
      });
      !n && (t.left >= p.right && t.top >= p.top || t.left >= p.left && t.top >= p.bottom) && (c = d + 1);
    }
  }
  return !n && o && (n = o, r = i, a = 0), n && 3 == n.nodeType ? function (e, t) {
    let n = e.nodeValue.length,
      r = document.createRange();
    for (let o = 0; o < n; o++) {
      r.setEnd(e, o + 1), r.setStart(e, o);
      let n = QV(r, 1);
      if (n.top != n.bottom && IV(t, n)) return {
        node: e,
        offset: o + (t.left >= (n.left + n.right) / 2 ? 1 : 0)
      };
    }
    return {
      node: e,
      offset: 0
    };
  }(n, r) : !n || a && 1 == n.nodeType ? {
    node: e,
    offset: c
  } : yV(n, r);
}
function IV(e, t) {
  return e.left >= t.left - 1 && e.left <= t.right + 1 && e.top >= t.top - 1 && e.top <= t.bottom + 1;
}
function BV(e, t, n) {
  let r = e.childNodes.length;
  if (r && n.top < n.bottom) for (let o = Math.max(0, Math.min(r - 1, Math.floor(r * (t.top - n.top) / (n.bottom - n.top)) - 2)), i = o;;) {
    let n = e.childNodes[i];
    if (1 == n.nodeType) {
      let e = n.getClientRects();
      for (let r = 0; r < e.length; r++) {
        let o = e[r];
        if (IV(t, o)) return BV(n, t, o);
      }
    }
    if ((i = (i + 1) % r) == o) break;
  }
  return e;
}
function xV(e, t) {
  var _i2;
  let n,
    r = e.dom.ownerDocument,
    o = 0,
    i = function (e, t, n) {
      if (e.caretPositionFromPoint) try {
        let r = e.caretPositionFromPoint(t, n);
        if (r) return {
          node: r.offsetNode,
          offset: r.offset
        };
      } catch (e) {}
      if (e.caretRangeFromPoint) {
        let r = e.caretRangeFromPoint(t, n);
        if (r) return {
          node: r.startContainer,
          offset: r.startOffset
        };
      }
    }(r, t.left, t.top);
  i && (_i2 = i, n = _i2.node, o = _i2.offset, _i2);
  let a,
    c = (e.root.elementFromPoint ? e.root : r).elementFromPoint(t.left, t.top);
  if (!c || !e.dom.contains(1 != c.nodeType ? c.parentNode : c)) {
    let n = e.dom.getBoundingClientRect();
    if (!IV(t, n)) return null;
    if (c = BV(e.dom, t, n), !c) return null;
  }
  if (sV) for (let e = c; n && e; e = RS(e)) e.draggable && (n = void 0);
  if (c = function (e, t) {
    let n = e.parentNode;
    return n && /^li$/i.test(n.nodeName) && t.left < e.getBoundingClientRect().left ? n : e;
  }(c, t), n) {
    if (oV && 1 == n.nodeType && (o = Math.min(o, n.childNodes.length), o < n.childNodes.length)) {
      let e,
        r = n.childNodes[o];
      "IMG" == r.nodeName && (e = r.getBoundingClientRect()).right <= t.left && e.bottom > t.top && o++;
    }
    let r;
    pV && o && 1 == n.nodeType && 1 == (r = n.childNodes[o - 1]).nodeType && "false" == r.contentEditable && r.getBoundingClientRect().top >= t.top && o--, n == e.dom && o == n.childNodes.length - 1 && 1 == n.lastChild.nodeType && t.top > n.lastChild.getBoundingClientRect().bottom ? a = e.state.doc.content.size : 0 != o && 1 == n.nodeType && "BR" == n.childNodes[o - 1].nodeName || (a = function (e, t, n, r) {
      let o = -1;
      for (let n = t, i = !1; n != e.dom;) {
        let t = e.docView.nearestDesc(n, !0);
        if (!t) return null;
        if (1 == t.dom.nodeType && (t.node.isBlock && t.parent && !i || !t.contentDOM)) {
          let e = t.dom.getBoundingClientRect();
          if (t.node.isBlock && t.parent && !i && (i = !0, e.left > r.left || e.top > r.top ? o = t.posBefore : (e.right < r.left || e.bottom < r.top) && (o = t.posAfter)), !t.contentDOM && o < 0 && !t.node.isText) return (t.node.isBlock ? r.top < (e.top + e.bottom) / 2 : r.left < (e.left + e.right) / 2) ? t.posBefore : t.posAfter;
        }
        n = t.dom.parentNode;
      }
      return o > -1 ? o : e.docView.posFromDOM(t, n, -1);
    }(e, n, o, t));
  }
  null == a && (a = function (e, t, n) {
    let _yV = yV(t, n),
      r = _yV.node,
      o = _yV.offset,
      i = -1;
    if (1 == r.nodeType && !r.firstChild) {
      let e = r.getBoundingClientRect();
      i = e.left != e.right && n.left > (e.left + e.right) / 2 ? 1 : -1;
    }
    return e.docView.posFromDOM(r, o, i);
  }(e, c, t));
  let s = e.docView.nearestDesc(c, !0);
  return {
    pos: a,
    inside: s ? s.posAtStart - s.border : -1
  };
}
function wV(e) {
  return e.top < e.bottom || e.left < e.right;
}
function QV(e, t) {
  let n = e.getClientRects();
  if (n.length) {
    let e = n[t < 0 ? 0 : n.length - 1];
    if (wV(e)) return e;
  }
  return Array.prototype.find.call(n, wV) || e.getBoundingClientRect();
}
const HV = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function zV(e, t, n) {
  let _e$docView$domFromPos = e.docView.domFromPos(t, n < 0 ? -1 : 1),
    r = _e$docView$domFromPos.node,
    o = _e$docView$domFromPos.offset,
    i = _e$docView$domFromPos.atom,
    a = pV || oV;
  if (3 == r.nodeType) {
    if (!a || !HV.test(r.nodeValue) && (n < 0 ? o : o != r.nodeValue.length)) {
      let e = o,
        t = o,
        i = n < 0 ? 1 : -1;
      return n < 0 && !o ? (t++, i = -1) : n >= 0 && o == r.nodeValue.length ? (e--, i = 1) : n < 0 ? e-- : t++, MV(QV(FS(r, e, t), i), i < 0);
    }
    {
      let e = QV(FS(r, o, o), n);
      if (oV && o && /\s/.test(r.nodeValue[o - 1]) && o < r.nodeValue.length) {
        let t = QV(FS(r, o - 1, o - 1), -1);
        if (t.top == e.top) {
          let n = QV(FS(r, o, o + 1), -1);
          if (n.top != e.top) return MV(n, n.left < t.left);
        }
      }
      return e;
    }
  }
  if (!e.state.doc.resolve(t - (i || 0)).parent.inlineContent) {
    if (null == i && o && (n < 0 || o == WS(r))) {
      let e = r.childNodes[o - 1];
      if (1 == e.nodeType) return kV(e.getBoundingClientRect(), !1);
    }
    if (null == i && o < WS(r)) {
      let e = r.childNodes[o];
      if (1 == e.nodeType) return kV(e.getBoundingClientRect(), !0);
    }
    return kV(r.getBoundingClientRect(), n >= 0);
  }
  if (null == i && o && (n < 0 || o == WS(r))) {
    let e = r.childNodes[o - 1],
      t = 3 == e.nodeType ? FS(e, WS(e) - (a ? 0 : 1)) : 1 != e.nodeType || "BR" == e.nodeName && e.nextSibling ? null : e;
    if (t) return MV(QV(t, 1), !1);
  }
  if (null == i && o < WS(r)) {
    let e = r.childNodes[o];
    for (; e.pmViewDesc && e.pmViewDesc.ignoreForCoords;) e = e.nextSibling;
    let t = e ? 3 == e.nodeType ? FS(e, 0, a ? 0 : 1) : 1 == e.nodeType ? e : null : null;
    if (t) return MV(QV(t, -1), !0);
  }
  return MV(QV(3 == r.nodeType ? FS(r) : r, -n), n >= 0);
}
function MV(e, t) {
  if (0 == e.width) return e;
  let n = t ? e.left : e.right;
  return {
    top: e.top,
    bottom: e.bottom,
    left: n,
    right: n
  };
}
function kV(e, t) {
  if (0 == e.height) return e;
  let n = t ? e.top : e.bottom;
  return {
    top: n,
    bottom: n,
    left: e.left,
    right: e.right
  };
}
function NV(e, t, n) {
  let r = e.state,
    o = e.root.activeElement;
  r != t && e.updateState(t), o != e.dom && e.focus();
  try {
    return n();
  } finally {
    r != t && e.updateState(r), o != e.dom && o && o.focus();
  }
}
const SV = /[\u0590-\u08ac]/;
let VV = null,
  LV = null,
  PV = !1;
function OV(e, t, n) {
  return VV == t && LV == n ? PV : (VV = t, LV = n, PV = "up" == n || "down" == n ? function (e, t, n) {
    let r = t.selection,
      o = "up" == n ? r.$from : r.$to;
    return NV(e, t, () => {
      let _e$docView$domFromPos2 = e.docView.domFromPos(o.pos, "up" == n ? -1 : 1),
        t = _e$docView$domFromPos2.node;
      for (;;) {
        let n = e.docView.nearestDesc(t, !0);
        if (!n) break;
        if (n.node.isBlock) {
          t = n.contentDOM || n.dom;
          break;
        }
        t = n.dom.parentNode;
      }
      let r = zV(e, o.pos, 1);
      for (let e = t.firstChild; e; e = e.nextSibling) {
        let t;
        if (1 == e.nodeType) t = e.getClientRects();else {
          if (3 != e.nodeType) continue;
          t = FS(e, 0, e.nodeValue.length).getClientRects();
        }
        for (let e = 0; e < t.length; e++) {
          let o = t[e];
          if (o.bottom > o.top + 1 && ("up" == n ? r.top - o.top > 2 * (o.bottom - r.top) : o.bottom - r.bottom > 2 * (r.bottom - o.top))) return !1;
        }
      }
      return !0;
    });
  }(e, t, n) : function (e, t, n) {
    let r = t.selection.$head;
    if (!r.parent.isTextblock) return !1;
    let o = r.parentOffset,
      i = !o,
      a = o == r.parent.content.size,
      c = e.domSelection();
    return SV.test(r.parent.textContent) && c.modify ? NV(e, t, () => {
      let _e$domSelectionRange = e.domSelectionRange(),
        t = _e$domSelectionRange.focusNode,
        o = _e$domSelectionRange.focusOffset,
        i = _e$domSelectionRange.anchorNode,
        a = _e$domSelectionRange.anchorOffset,
        s = c.caretBidiLevel;
      c.modify("move", n, "character");
      let l = r.depth ? e.docView.domAfterPos(r.before()) : e.dom,
        _e$domSelectionRange2 = e.domSelectionRange(),
        u = _e$domSelectionRange2.focusNode,
        d = _e$domSelectionRange2.focusOffset,
        f = u && !l.contains(1 == u.nodeType ? u : u.parentNode) || t == u && o == d;
      try {
        c.collapse(i, a), t && (t != i || o != a) && c.extend && c.extend(t, o);
      } catch (e) {}
      return null != s && (c.caretBidiLevel = s), f;
    }) : "left" == n || "backward" == n ? i : a;
  }(e, t, n));
}
class TV {
  constructor(e, t, n, r) {
    this.parent = e, this.children = t, this.dom = n, this.contentDOM = r, this.dirty = 0, n.pmViewDesc = this;
  }
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, n) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  parseRule() {
    return null;
  }
  stopEvent(e) {
    return !1;
  }
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++) e += this.children[t].size;
    return e;
  }
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++) this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, n = this.posAtStart;; t++) {
      let r = this.children[t];
      if (r == e) return n;
      n += r.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, n) {
    if (this.contentDOM && this.contentDOM.contains(1 == e.nodeType ? e : e.parentNode)) {
      if (n < 0) {
        let n, r;
        if (e == this.contentDOM) n = e.childNodes[t - 1];else {
          for (; e.parentNode != this.contentDOM;) e = e.parentNode;
          n = e.previousSibling;
        }
        for (; n && (!(r = n.pmViewDesc) || r.parent != this);) n = n.previousSibling;
        return n ? this.posBeforeChild(r) + r.size : this.posAtStart;
      }
      {
        let n, r;
        if (e == this.contentDOM) n = e.childNodes[t];else {
          for (; e.parentNode != this.contentDOM;) e = e.parentNode;
          n = e.nextSibling;
        }
        for (; n && (!(r = n.pmViewDesc) || r.parent != this);) n = n.nextSibling;
        return n ? this.posBeforeChild(r) : this.posAtEnd;
      }
    }
    let r;
    if (e == this.dom && this.contentDOM) r = t > DS(this.contentDOM);else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) r = 2 & e.compareDocumentPosition(this.contentDOM);else if (this.dom.firstChild) {
      if (0 == t) for (let t = e;; t = t.parentNode) {
        if (t == this.dom) {
          r = !1;
          break;
        }
        if (t.previousSibling) break;
      }
      if (null == r && t == e.childNodes.length) for (let t = e;; t = t.parentNode) {
        if (t == this.dom) {
          r = !0;
          break;
        }
        if (t.nextSibling) break;
      }
    }
    return (null == r ? n > 0 : r) ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    for (let n = !0, r = e; r; r = r.parentNode) {
      let o,
        i = this.getDesc(r);
      if (i && (!t || i.node)) {
        if (!n || !(o = i.nodeDOM) || (1 == o.nodeType ? o.contains(1 == e.nodeType ? e : e.parentNode) : o == e)) return i;
        n = !1;
      }
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let e = t; e; e = e.parent) if (e == this) return t;
  }
  posFromDOM(e, t, n) {
    for (let r = e; r; r = r.parentNode) {
      let o = this.getDesc(r);
      if (o) return o.localPosFromDOM(e, t, n);
    }
    return -1;
  }
  descAt(e) {
    for (let t = 0, n = 0; t < this.children.length; t++) {
      let r = this.children[t],
        o = n + r.size;
      if (n == e && o != n) {
        for (; !r.border && r.children.length;) r = r.children[0];
        return r;
      }
      if (e < o) return r.descAt(e - n - r.border);
      n = o;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM) return {
      node: this.dom,
      offset: 0,
      atom: e + 1
    };
    let n,
      r = 0,
      o = 0;
    for (let t = 0; r < this.children.length; r++) {
      let n = this.children[r],
        i = t + n.size;
      if (i > e || n instanceof ZV) {
        o = e - t;
        break;
      }
      t = i;
    }
    if (o) return this.children[r].domFromPos(o - this.children[r].border, t);
    for (; r && !(n = this.children[r - 1]).size && n instanceof DV && n.side >= 0; r--);
    if (t <= 0) {
      let e,
        n = !0;
      for (; e = r ? this.children[r - 1] : null, e && e.dom.parentNode != this.contentDOM; r--, n = !1);
      return e && t && n && !e.border && !e.domAtom ? e.domFromPos(e.size, t) : {
        node: this.contentDOM,
        offset: e ? DS(e.dom) + 1 : 0
      };
    }
    {
      let e,
        n = !0;
      for (; e = r < this.children.length ? this.children[r] : null, e && e.dom.parentNode != this.contentDOM; r++, n = !1);
      return e && n && !e.border && !e.domAtom ? e.domFromPos(0, t) : {
        node: this.contentDOM,
        offset: e ? DS(e.dom) : this.contentDOM.childNodes.length
      };
    }
  }
  parseRange(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    if (0 == this.children.length) return {
      node: this.contentDOM,
      from: e,
      to: t,
      fromOffset: 0,
      toOffset: this.contentDOM.childNodes.length
    };
    let r = -1,
      o = -1;
    for (let i = n, a = 0;; a++) {
      let n = this.children[a],
        c = i + n.size;
      if (-1 == r && e <= c) {
        let o = i + n.border;
        if (e >= o && t <= c - n.border && n.node && n.contentDOM && this.contentDOM.contains(n.contentDOM)) return n.parseRange(e, t, o);
        e = i;
        for (let t = a; t > 0; t--) {
          let n = this.children[t - 1];
          if (n.size && n.dom.parentNode == this.contentDOM && !n.emptyChildAt(1)) {
            r = DS(n.dom) + 1;
            break;
          }
          e -= n.size;
        }
        -1 == r && (r = 0);
      }
      if (r > -1 && (c > t || a == this.children.length - 1)) {
        t = c;
        for (let e = a + 1; e < this.children.length; e++) {
          let n = this.children[e];
          if (n.size && n.dom.parentNode == this.contentDOM && !n.emptyChildAt(-1)) {
            o = DS(n.dom);
            break;
          }
          t += n.size;
        }
        -1 == o && (o = this.contentDOM.childNodes.length);
        break;
      }
      i = c;
    }
    return {
      node: this.contentDOM,
      from: e,
      to: t,
      fromOffset: r,
      toOffset: o
    };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length) return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return 0 == t.size || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let _this$domFromPos = this.domFromPos(e, 0),
      t = _this$domFromPos.node,
      n = _this$domFromPos.offset;
    if (1 != t.nodeType || n == t.childNodes.length) throw new RangeError("No node after pos " + e);
    return t.childNodes[n];
  }
  setSelection(e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
    let o = Math.min(e, t),
      i = Math.max(e, t);
    for (let a = 0, c = 0; a < this.children.length; a++) {
      let s = this.children[a],
        l = c + s.size;
      if (o > c && i < l) return s.setSelection(e - c - s.border, t - c - s.border, n, r);
      c = l;
    }
    let a = this.domFromPos(e, e ? -1 : 1),
      c = t == e ? a : this.domFromPos(t, t ? -1 : 1),
      s = n.getSelection(),
      l = !1;
    if ((oV || sV) && e == t) {
      let _a2 = a,
        e = _a2.node,
        t = _a2.offset;
      if (3 == e.nodeType) {
        if (l = !(!t || "\n" != e.nodeValue[t - 1]), l && t == e.nodeValue.length) for (let t, n = e; n; n = n.parentNode) {
          if (t = n.nextSibling) {
            "BR" == t.nodeName && (a = c = {
              node: t.parentNode,
              offset: DS(t) + 1
            });
            break;
          }
          let e = n.pmViewDesc;
          if (e && e.node && e.node.isBlock) break;
        }
      } else {
        let n = e.childNodes[t - 1];
        l = n && ("BR" == n.nodeName || "false" == n.contentEditable);
      }
    }
    if (oV && s.focusNode && s.focusNode != c.node && 1 == s.focusNode.nodeType) {
      let e = s.focusNode.childNodes[s.focusOffset];
      e && "false" == e.contentEditable && (r = !0);
    }
    if (!(r || l && sV) && jS(a.node, a.offset, s.anchorNode, s.anchorOffset) && jS(c.node, c.offset, s.focusNode, s.focusOffset)) return;
    let u = !1;
    if ((s.extend || e == t) && !l) {
      s.collapse(a.node, a.offset);
      try {
        e != t && s.extend(c.node, c.offset), u = !0;
      } catch (e) {}
    }
    if (!u) {
      if (e > t) {
        let e = a;
        a = c, c = e;
      }
      let n = document.createRange();
      n.setEnd(c.node, c.offset), n.setStart(a.node, a.offset), s.removeAllRanges(), s.addRange(n);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && "selection" != e.type;
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  markDirty(e, t) {
    for (let n = 0, r = 0; r < this.children.length; r++) {
      let o = this.children[r],
        i = n + o.size;
      if (n == i ? e <= i && t >= n : e < i && t > n) {
        let r = n + o.border,
          a = i - o.border;
        if (e >= r && t <= a) return this.dirty = e == n || t == i ? 2 : 1, void (e != r || t != a || !o.contentLost && o.dom.parentNode == this.contentDOM ? o.markDirty(e - r, t - r) : o.dirty = 3);
        o.dirty = o.dom != o.contentDOM || o.dom.parentNode != this.contentDOM || o.children.length ? 3 : 2;
      }
      n = i;
    }
    this.dirty = 2;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let n = 1 == e ? 2 : 1;
      t.dirty < n && (t.dirty = n);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
}
class DV extends TV {
  constructor(e, t, n, r) {
    let o,
      i = t.type.toDOM;
    if ("function" == typeof i && (i = i(n, () => o ? o.parent ? o.parent.posBeforeChild(o) : void 0 : r)), !t.type.spec.raw) {
      if (1 != i.nodeType) {
        let e = document.createElement("span");
        e.appendChild(i), i = e;
      }
      i.contentEditable = "false", i.classList.add("ProseMirror-widget");
    }
    super(e, [], i, null), this.widget = t, this.widget = t, o = this;
  }
  matchesWidget(e) {
    return 0 == this.dirty && e.type.eq(this.widget.type);
  }
  parseRule() {
    return {
      ignore: !0
    };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return !!t && t(e);
  }
  ignoreMutation(e) {
    return "selection" != e.type || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class RV extends TV {
  constructor(e, t, n, r) {
    super(e, [], t, null), this.textDOM = n, this.text = r;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return {
      node: this.textDOM,
      offset: e
    };
  }
  ignoreMutation(e) {
    return "characterData" === e.type && e.target.nodeValue == e.oldValue;
  }
}
class GV extends TV {
  constructor(e, t, n, r) {
    super(e, [], n, r), this.mark = t;
  }
  static create(e, t, n, r) {
    let o = r.nodeViews[t.type.name],
      i = o && o(t, r, n);
    return i && i.dom || (i = wN.renderSpec(document, t.type.spec.toDOM(t, n))), new GV(e, t, i.dom, i.contentDOM || i.dom);
  }
  parseRule() {
    return 3 & this.dirty || this.mark.type.spec.reparseInView ? null : {
      mark: this.mark.type.name,
      attrs: this.mark.attrs,
      contentElement: this.contentDOM
    };
  }
  matchesMark(e) {
    return 3 != this.dirty && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), 0 != this.dirty) {
      let e = this.parent;
      for (; !e.node;) e = e.parent;
      e.dirty < this.dirty && (e.dirty = this.dirty), this.dirty = 0;
    }
  }
  slice(e, t, n) {
    let r = GV.create(this.parent, this.mark, !0, n),
      o = this.children,
      i = this.size;
    t < i && (o = oL(o, t, i, n)), e > 0 && (o = oL(o, 0, e, n));
    for (let e = 0; e < o.length; e++) o[e].parent = r;
    return r.children = o, r;
  }
}
class FV extends TV {
  constructor(e, t, n, r, o, i, a, c, s) {
    super(e, [], o, i), this.node = t, this.outerDeco = n, this.innerDeco = r, this.nodeDOM = a;
  }
  static create(e, t, n, r, o, i) {
    var _wN$renderSpec3;
    let a,
      c = o.nodeViews[t.type.name],
      s = c && c(t, o, () => a ? a.parent ? a.parent.posBeforeChild(a) : void 0 : i, n, r),
      l = s && s.dom,
      u = s && s.contentDOM;
    if (t.isText) {
      if (l) {
        if (3 != l.nodeType) throw new RangeError("Text must be rendered as a DOM text node");
      } else l = document.createTextNode(t.text);
    } else l || (_wN$renderSpec3 = wN.renderSpec(document, t.type.spec.toDOM(t)), l = _wN$renderSpec3.dom, u = _wN$renderSpec3.contentDOM, _wN$renderSpec3);
    u || t.isText || "BR" == l.nodeName || (l.hasAttribute("contenteditable") || (l.contentEditable = "false"), t.type.spec.draggable && (l.draggable = !0));
    let d = l;
    return l = $V(l, n, t), s ? a = new WV(e, t, n, r, l, u || null, d, s, o, i + 1) : t.isText ? new JV(e, t, n, r, l, d, o) : new FV(e, t, n, r, l, u || null, d, o, i + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView) return null;
    let e = {
      node: this.node.type.name,
      attrs: this.node.attrs
    };
    if ("pre" == this.node.type.whitespace && (e.preserveWhitespace = "full"), this.contentDOM) {
      if (this.contentLost) {
        for (let t = this.children.length - 1; t >= 0; t--) {
          let n = this.children[t];
          if (this.dom.contains(n.dom.parentNode)) {
            e.contentElement = n.dom.parentNode;
            break;
          }
        }
        e.contentElement || (e.getContent = () => wk.empty);
      } else e.contentElement = this.contentDOM;
    } else e.getContent = () => this.node.content;
    return e;
  }
  matchesNode(e, t, n) {
    return 0 == this.dirty && e.eq(this.node) && eL(t, this.outerDeco) && n.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  updateChildren(e, t) {
    let n = this.node.inlineContent,
      r = t,
      o = e.composing ? this.localCompositionInfo(e, t) : null,
      i = o && o.pos > -1 ? o : null,
      a = o && o.pos < 0,
      c = new nL(this, i && i.node, e);
    !function (e, t, n, r) {
      let o = t.locals(e),
        i = 0;
      if (0 == o.length) {
        for (let n = 0; n < e.childCount; n++) {
          let a = e.child(n);
          r(a, o, t.forChild(i, a), n), i += a.nodeSize;
        }
        return;
      }
      let a = 0,
        c = [],
        s = null;
      for (let l = 0;;) {
        let u, d, f, p;
        for (; a < o.length && o[a].to == i;) {
          let e = o[a++];
          e.widget && (u ? (d || (d = [u])).push(e) : u = e);
        }
        if (u) if (d) {
          d.sort(rL);
          for (let e = 0; e < d.length; e++) n(d[e], l, !!s);
        } else n(u, l, !!s);
        if (s) p = -1, f = s, s = null;else {
          if (!(l < e.childCount)) break;
          p = l, f = e.child(l++);
        }
        for (let e = 0; e < c.length; e++) c[e].to <= i && c.splice(e--, 1);
        for (; a < o.length && o[a].from <= i && o[a].to > i;) c.push(o[a++]);
        let m = i + f.nodeSize;
        if (f.isText) {
          let e = m;
          a < o.length && o[a].from < e && (e = o[a].from);
          for (let t = 0; t < c.length; t++) c[t].to < e && (e = c[t].to);
          e < m && (s = f.cut(e - i), f = f.cut(0, e - i), m = e, p = -1);
        } else for (; a < o.length && o[a].to < m;) a++;
        let h = f.isInline && !f.isLeaf ? c.filter(e => !e.inline) : c.slice();
        r(f, h, t.forChild(i, f), p), i = m;
      }
    }(this.node, this.innerDeco, (t, o, i) => {
      t.spec.marks ? c.syncToMarks(t.spec.marks, n, e) : t.type.side >= 0 && !i && c.syncToMarks(o == this.node.childCount ? Mk.none : this.node.child(o).marks, n, e), c.placeWidget(t, e, r);
    }, (t, i, s, l) => {
      let u;
      c.syncToMarks(t.marks, n, e), c.findNodeMatch(t, i, s, l) || a && e.state.selection.from > r && e.state.selection.to < r + t.nodeSize && (u = c.findIndexWithChild(o.node)) > -1 && c.updateNodeAt(t, i, s, u, e) || c.updateNextNode(t, i, s, e, l, r) || c.addNode(t, i, s, e, r), r += t.nodeSize;
    }), c.syncToMarks([], n, e), this.node.isTextblock && c.addTextblockHacks(), c.destroyRest(), (c.changed || 2 == this.dirty) && (i && this.protectLocalComposition(e, i), XV(this.contentDOM, this.children, e), lV && function (e) {
      if ("UL" == e.nodeName || "OL" == e.nodeName) {
        let t = e.style.cssText;
        e.style.cssText = t + "; list-style: square !important", window.getComputedStyle(e).listStyle, e.style.cssText = t;
      }
    }(this.dom));
  }
  localCompositionInfo(e, t) {
    let _e$state$selection = e.state.selection,
      n = _e$state$selection.from,
      r = _e$state$selection.to;
    if (!(e.state.selection instanceof bS) || n < t || r > t + this.node.content.size) return null;
    let o = e.domSelectionRange(),
      i = function (e, t) {
        for (;;) {
          if (3 == e.nodeType) return e;
          if (1 == e.nodeType && t > 0) {
            if (e.childNodes.length > t && 3 == e.childNodes[t].nodeType) return e.childNodes[t];
            t = WS(e = e.childNodes[t - 1]);
          } else {
            if (!(1 == e.nodeType && t < e.childNodes.length)) return null;
            e = e.childNodes[t], t = 0;
          }
        }
      }(o.focusNode, o.focusOffset);
    if (!i || !this.dom.contains(i.parentNode)) return null;
    if (this.node.inlineContent) {
      let e = i.nodeValue,
        o = function (e, t, n, r) {
          for (let o = 0, i = 0; o < e.childCount && i <= r;) {
            let a = e.child(o++),
              c = i;
            if (i += a.nodeSize, !a.isText) continue;
            let s = a.text;
            for (; o < e.childCount;) {
              let t = e.child(o++);
              if (i += t.nodeSize, !t.isText) break;
              s += t.text;
            }
            if (i >= n) {
              if (i >= r && s.slice(r - t.length - c, r - c) == t) return r - t.length;
              let e = c < r ? s.lastIndexOf(t, r - c - 1) : -1;
              if (e >= 0 && e + t.length + c >= n) return c + e;
              if (n == r && s.length >= r + t.length - c && s.slice(r - c, r - c + t.length) == t) return r;
            }
          }
          return -1;
        }(this.node.content, e, n - t, r - t);
      return o < 0 ? null : {
        node: i,
        pos: o,
        text: e
      };
    }
    return {
      node: i,
      pos: -1,
      text: ""
    };
  }
  protectLocalComposition(e, _ref4) {
    let t = _ref4.node,
      n = _ref4.pos,
      r = _ref4.text;
    if (this.getDesc(t)) return;
    let o = t;
    for (; o.parentNode != this.contentDOM; o = o.parentNode) {
      for (; o.previousSibling;) o.parentNode.removeChild(o.previousSibling);
      for (; o.nextSibling;) o.parentNode.removeChild(o.nextSibling);
      o.pmViewDesc && (o.pmViewDesc = void 0);
    }
    let i = new RV(this, o, t, r);
    e.input.compositionNodes.push(i), this.children = oL(this.children, n, n + r.length, e, i);
  }
  update(e, t, n, r) {
    return !(3 == this.dirty || !e.sameMarkup(this.node)) && (this.updateInner(e, t, n, r), !0);
  }
  updateInner(e, t, n, r) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = n, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = 0;
  }
  updateOuterDeco(e) {
    if (eL(e, this.outerDeco)) return;
    let t = 1 != this.nodeDOM.nodeType,
      n = this.dom;
    this.dom = qV(this.dom, this.nodeDOM, YV(this.outerDeco, this.node, t), YV(e, this.node, t)), this.dom != n && (n.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  selectNode() {
    1 == this.nodeDOM.nodeType && this.nodeDOM.classList.add("ProseMirror-selectednode"), !this.contentDOM && this.node.type.spec.draggable || (this.dom.draggable = !0);
  }
  deselectNode() {
    1 == this.nodeDOM.nodeType && this.nodeDOM.classList.remove("ProseMirror-selectednode"), !this.contentDOM && this.node.type.spec.draggable || this.dom.removeAttribute("draggable");
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function jV(e, t, n, r, o) {
  $V(r, t, e);
  let i = new FV(void 0, e, t, n, r, r, r, o, 0);
  return i.contentDOM && i.updateChildren(o, 0), i;
}
class JV extends FV {
  constructor(e, t, n, r, o, i, a) {
    super(e, t, n, r, o, null, i, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco;) e = e.parentNode;
    return {
      skip: e || !0
    };
  }
  update(e, t, n, r) {
    return !(3 == this.dirty || 0 != this.dirty && !this.inParent() || !e.sameMarkup(this.node)) && (this.updateOuterDeco(t), 0 == this.dirty && e.text == this.node.text || e.text == this.nodeDOM.nodeValue || (this.nodeDOM.nodeValue = e.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = e, this.dirty = 0, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode) if (t == e) return !0;
    return !1;
  }
  domFromPos(e) {
    return {
      node: this.nodeDOM,
      offset: e
    };
  }
  localPosFromDOM(e, t, n) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, n);
  }
  ignoreMutation(e) {
    return "characterData" != e.type && "selection" != e.type;
  }
  slice(e, t, n) {
    let r = this.node.cut(e, t),
      o = document.createTextNode(r.text);
    return new JV(this.parent, r, this.outerDeco, this.innerDeco, o, o, n);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom == this.nodeDOM || 0 != e && t != this.nodeDOM.nodeValue.length || (this.dirty = 3);
  }
  get domAtom() {
    return !1;
  }
}
class ZV extends TV {
  parseRule() {
    return {
      ignore: !0
    };
  }
  matchesHack(e) {
    return 0 == this.dirty && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return "IMG" == this.dom.nodeName;
  }
}
class WV extends FV {
  constructor(e, t, n, r, o, i, a, c, s, l) {
    super(e, t, n, r, o, i, a, s, l), this.spec = c;
  }
  update(e, t, n, r) {
    if (3 == this.dirty) return !1;
    if (this.spec.update) {
      let o = this.spec.update(e, t, n);
      return o && this.updateInner(e, t, n, r), o;
    }
    return !(!this.contentDOM && !e.isLeaf) && super.update(e, t, n, r);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, n, r) {
    this.spec.setSelection ? this.spec.setSelection(e, t, n) : super.setSelection(e, t, n, r);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return !!this.spec.stopEvent && this.spec.stopEvent(e);
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function XV(e, t, n) {
  let r = e.firstChild,
    o = !1;
  for (let i = 0; i < t.length; i++) {
    let a = t[i],
      c = a.dom;
    if (c.parentNode == e) {
      for (; c != r;) r = tL(r), o = !0;
      r = r.nextSibling;
    } else o = !0, e.insertBefore(c, r);
    if (a instanceof GV) {
      let t = r ? r.previousSibling : e.lastChild;
      XV(a.contentDOM, a.children, n), r = t ? t.nextSibling : e.firstChild;
    }
  }
  for (; r;) r = tL(r), o = !0;
  o && n.trackWrites == e && (n.trackWrites = null);
}
const UV = function (e) {
  e && (this.nodeName = e);
};
UV.prototype = Object.create(null);
const KV = [new UV()];
function YV(e, t, n) {
  if (0 == e.length) return KV;
  let r = n ? KV[0] : new UV(),
    o = [r];
  for (let i = 0; i < e.length; i++) {
    let a = e[i].type.attrs;
    if (a) {
      a.nodeName && o.push(r = new UV(a.nodeName));
      for (let e in a) {
        let i = a[e];
        null != i && (n && 1 == o.length && o.push(r = new UV(t.isInline ? "span" : "div")), "class" == e ? r.class = (r.class ? r.class + " " : "") + i : "style" == e ? r.style = (r.style ? r.style + ";" : "") + i : "nodeName" != e && (r[e] = i));
      }
    }
  }
  return o;
}
function qV(e, t, n, r) {
  if (n == KV && r == KV) return t;
  let o = t;
  for (let t = 0; t < r.length; t++) {
    let i = r[t],
      a = n[t];
    if (t) {
      let t;
      a && a.nodeName == i.nodeName && o != e && (t = o.parentNode) && t.nodeName.toLowerCase() == i.nodeName || (t = document.createElement(i.nodeName), t.pmIsDeco = !0, t.appendChild(o), a = KV[0]), o = t;
    }
    _V(o, a || KV[0], i);
  }
  return o;
}
function _V(e, t, n) {
  for (let r in t) "class" == r || "style" == r || "nodeName" == r || r in n || e.removeAttribute(r);
  for (let r in n) "class" != r && "style" != r && "nodeName" != r && n[r] != t[r] && e.setAttribute(r, n[r]);
  if (t.class != n.class) {
    let r = t.class ? t.class.split(" ").filter(Boolean) : [],
      o = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let t = 0; t < r.length; t++) -1 == o.indexOf(r[t]) && e.classList.remove(r[t]);
    for (let t = 0; t < o.length; t++) -1 == r.indexOf(o[t]) && e.classList.add(o[t]);
    0 == e.classList.length && e.removeAttribute("class");
  }
  if (t.style != n.style) {
    if (t.style) {
      let n,
        r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g;
      for (; n = r.exec(t.style);) e.style.removeProperty(n[1]);
    }
    n.style && (e.style.cssText += n.style);
  }
}
function $V(e, t, n) {
  return qV(e, e, KV, YV(t, n, 1 != e.nodeType));
}
function eL(e, t) {
  if (e.length != t.length) return !1;
  for (let n = 0; n < e.length; n++) if (!e[n].type.eq(t[n].type)) return !1;
  return !0;
}
function tL(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class nL {
  constructor(e, t, n) {
    this.lock = t, this.view = n, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = function (e, t) {
      let n = t,
        r = n.children.length,
        o = e.childCount,
        i = new Map(),
        a = [];
      e: for (; o > 0;) {
        let c;
        for (;;) if (r) {
          let e = n.children[r - 1];
          if (!(e instanceof GV)) {
            c = e, r--;
            break;
          }
          n = e, r = e.children.length;
        } else {
          if (n == t) break e;
          r = n.parent.children.indexOf(n), n = n.parent;
        }
        let s = c.node;
        if (s) {
          if (s != e.child(o - 1)) break;
          --o, i.set(c, o), a.push(c);
        }
      }
      return {
        index: o,
        matched: i,
        matches: a.reverse()
      };
    }(e.node.content, e);
  }
  destroyBetween(e, t) {
    if (e != t) {
      for (let n = e; n < t; n++) this.top.children[n].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  syncToMarks(e, t, n) {
    let r = 0,
      o = this.stack.length >> 1,
      i = Math.min(o, e.length);
    for (; r < i && (r == o - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && !1 !== e[r].type.spec.spanning;) r++;
    for (; r < o;) this.destroyRest(), this.top.dirty = 0, this.index = this.stack.pop(), this.top = this.stack.pop(), o--;
    for (; o < e.length;) {
      this.stack.push(this.top, this.index + 1);
      let r = -1;
      for (let t = this.index; t < Math.min(this.index + 3, this.top.children.length); t++) {
        let n = this.top.children[t];
        if (n.matchesMark(e[o]) && !this.isLocked(n.dom)) {
          r = t;
          break;
        }
      }
      if (r > -1) r > this.index && (this.changed = !0, this.destroyBetween(this.index, r)), this.top = this.top.children[this.index];else {
        let r = GV.create(this.top, e[o], t, n);
        this.top.children.splice(this.index, 0, r), this.top = r, this.changed = !0;
      }
      this.index = 0, o++;
    }
  }
  findNodeMatch(e, t, n, r) {
    let o,
      i = -1;
    if (r >= this.preMatch.index && (o = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, n)) i = this.top.children.indexOf(o, this.index);else for (let r = this.index, o = Math.min(this.top.children.length, r + 5); r < o; r++) {
      let o = this.top.children[r];
      if (o.matchesNode(e, t, n) && !this.preMatch.matched.has(o)) {
        i = r;
        break;
      }
    }
    return !(i < 0) && (this.destroyBetween(this.index, i), this.index++, !0);
  }
  updateNodeAt(e, t, n, r, o) {
    let i = this.top.children[r];
    return 3 == i.dirty && i.dom == i.contentDOM && (i.dirty = 2), !!i.update(e, t, n, o) && (this.destroyBetween(this.index, r), this.index++, !0);
  }
  findIndexWithChild(e) {
    for (;;) {
      let t = e.parentNode;
      if (!t) return -1;
      if (t == this.top.contentDOM) {
        let t = e.pmViewDesc;
        if (t) for (let e = this.index; e < this.top.children.length; e++) if (this.top.children[e] == t) return e;
        return -1;
      }
      e = t;
    }
  }
  updateNextNode(e, t, n, r, o, i) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let c = this.top.children[a];
      if (c instanceof FV) {
        let s = this.preMatch.matched.get(c);
        if (null != s && s != o) return !1;
        let l,
          u = c.dom,
          d = this.isLocked(u) && !(e.isText && c.node && c.node.isText && c.nodeDOM.nodeValue == e.text && 3 != c.dirty && eL(t, c.outerDeco));
        if (!d && c.update(e, t, n, r)) return this.destroyBetween(this.index, a), c.dom != u && (this.changed = !0), this.index++, !0;
        if (!d && (l = this.recreateWrapper(c, e, t, n, r, i))) return this.top.children[this.index] = l, l.contentDOM && (l.dirty = 2, l.updateChildren(r, i + 1), l.dirty = 0), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  recreateWrapper(e, t, n, r, o, i) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content)) return null;
    let a = FV.create(this.top, t, n, r, o, i);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let e of a.children) e.parent = a;
    }
    return e.destroy(), a;
  }
  addNode(e, t, n, r, o) {
    let i = FV.create(this.top, e, t, n, r, o);
    i.contentDOM && i.updateChildren(r, o + 1), this.top.children.splice(this.index++, 0, i), this.changed = !0;
  }
  placeWidget(e, t, n) {
    let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (!r || !r.matchesWidget(e) || e != r.widget && r.widget.type.toDOM.parentNode) {
      let r = new DV(this.top, e, t, n);
      this.top.children.splice(this.index++, 0, r), this.changed = !0;
    } else this.index++;
  }
  addTextblockHacks() {
    let e = this.top.children[this.index - 1],
      t = this.top;
    for (; e instanceof GV;) t = e, e = t.children[t.children.length - 1];
    (!e || !(e instanceof JV) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((sV || aV) && e && "false" == e.dom.contentEditable && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e)) this.index++;else {
      let n = document.createElement(e);
      "IMG" == e && (n.className = "ProseMirror-separator", n.alt = ""), "BR" == e && (n.className = "ProseMirror-trailingBreak");
      let r = new ZV(this.top, [], n, null);
      t != this.top ? t.children.push(r) : t.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || 1 == e.nodeType && e.contains(this.lock.parentNode));
  }
}
function rL(e, t) {
  return e.type.side - t.type.side;
}
function oL(e, t, n, r, o) {
  let i = [];
  for (let a = 0, c = 0; a < e.length; a++) {
    let s = e[a],
      l = c,
      u = c += s.size;
    l >= n || u <= t ? i.push(s) : (l < t && i.push(s.slice(0, t - l, r)), o && (i.push(o), o = void 0), u > n && i.push(s.slice(n - l, s.size, r)));
  }
  return i;
}
function iL(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let n = e.domSelectionRange(),
    r = e.state.doc;
  if (!n.focusNode) return null;
  let o = e.docView.nearestDesc(n.focusNode),
    i = o && 0 == o.size,
    a = e.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (a < 0) return null;
  let c,
    s,
    l = r.resolve(a);
  if (US(n)) {
    for (c = l; o && !o.node;) o = o.parent;
    let e = o.node;
    if (o && e.isAtom && yS.isSelectable(e) && o.parent && (!e.isInline || !function (e, t, n) {
      for (let r = 0 == t, o = t == WS(e); r || o;) {
        if (e == n) return !0;
        let t = DS(e);
        if (!(e = e.parentNode)) return !1;
        r = r && 0 == t, o = o && t == WS(e);
      }
    }(n.focusNode, n.focusOffset, o.dom))) {
      let e = o.posBefore;
      s = new yS(a == e ? l : r.resolve(e));
    }
  } else {
    let t = e.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (t < 0) return null;
    c = r.resolve(t);
  }
  if (!s) {
    s = mL(e, c, l, "pointer" == t || e.state.selection.head < l.pos && !i ? 1 : -1);
  }
  return s;
}
function aL(e) {
  return e.editable ? e.hasFocus() : AL(e) && document.activeElement && document.activeElement.contains(e.dom);
}
function cL(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  let n = e.state.selection;
  if (fL(e, n), aL(e)) {
    if (!t && e.input.mouseDown && e.input.mouseDown.allowDefault && aV) {
      let t = e.domSelectionRange(),
        n = e.domObserver.currentSelection;
      if (t.anchorNode && n.anchorNode && jS(t.anchorNode, t.anchorOffset, n.anchorNode, n.anchorOffset)) return e.input.mouseDown.delayedSelectionSync = !0, void e.domObserver.setCurSelection();
    }
    if (e.domObserver.disconnectSelection(), e.cursorWrapper) !function (e) {
      let t = e.domSelection(),
        n = document.createRange(),
        r = e.cursorWrapper.dom,
        o = "IMG" == r.nodeName;
      o ? n.setEnd(r.parentNode, DS(r) + 1) : n.setEnd(r, 0);
      n.collapse(!1), t.removeAllRanges(), t.addRange(n), !o && !e.state.selection.visible && nV && rV <= 11 && (r.disabled = !0, r.disabled = !1);
    }(e);else {
      let r,
        o,
        i = n.anchor,
        a = n.head;
      !sL || n instanceof bS || (n.$from.parent.inlineContent || (r = lL(e, n.from)), n.empty || n.$from.parent.inlineContent || (o = lL(e, n.to))), e.docView.setSelection(i, a, e.root, t), sL && (r && dL(r), o && dL(o)), n.visible ? e.dom.classList.remove("ProseMirror-hideselection") : (e.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && function (e) {
        let t = e.dom.ownerDocument;
        t.removeEventListener("selectionchange", e.input.hideSelectionGuard);
        let n = e.domSelectionRange(),
          r = n.anchorNode,
          o = n.anchorOffset;
        t.addEventListener("selectionchange", e.input.hideSelectionGuard = () => {
          n.anchorNode == r && n.anchorOffset == o || (t.removeEventListener("selectionchange", e.input.hideSelectionGuard), setTimeout(() => {
            aL(e) && !e.state.selection.visible || e.dom.classList.remove("ProseMirror-hideselection");
          }, 20));
        });
      }(e));
    }
    e.domObserver.setCurSelection(), e.domObserver.connectSelection();
  }
}
const sL = sV || aV && cV < 63;
function lL(e, t) {
  let _e$docView$domFromPos3 = e.docView.domFromPos(t, 0),
    n = _e$docView$domFromPos3.node,
    r = _e$docView$domFromPos3.offset,
    o = r < n.childNodes.length ? n.childNodes[r] : null,
    i = r ? n.childNodes[r - 1] : null;
  if (sV && o && "false" == o.contentEditable) return uL(o);
  if (!(o && "false" != o.contentEditable || i && "false" != i.contentEditable)) {
    if (o) return uL(o);
    if (i) return uL(i);
  }
}
function uL(e) {
  return e.contentEditable = "true", sV && e.draggable && (e.draggable = !1, e.wasDraggable = !0), e;
}
function dL(e) {
  e.contentEditable = "false", e.wasDraggable && (e.draggable = !0, e.wasDraggable = null);
}
function fL(e, t) {
  if (t instanceof yS) {
    let n = e.docView.descAt(t.from);
    n != e.lastSelectedViewDesc && (pL(e), n && n.selectNode(), e.lastSelectedViewDesc = n);
  } else pL(e);
}
function pL(e) {
  e.lastSelectedViewDesc && (e.lastSelectedViewDesc.parent && e.lastSelectedViewDesc.deselectNode(), e.lastSelectedViewDesc = void 0);
}
function mL(e, t, n, r) {
  return e.someProp("createSelectionBetween", r => r(e, t, n)) || bS.between(t, n, r);
}
function hL(e) {
  return !(e.editable && !e.hasFocus()) && AL(e);
}
function AL(e) {
  let t = e.domSelectionRange();
  if (!t.anchorNode) return !1;
  try {
    return e.dom.contains(3 == t.anchorNode.nodeType ? t.anchorNode.parentNode : t.anchorNode) && (e.editable || e.dom.contains(3 == t.focusNode.nodeType ? t.focusNode.parentNode : t.focusNode));
  } catch (e) {
    return !1;
  }
}
function gL(e, t) {
  let _e$selection = e.selection,
    n = _e$selection.$anchor,
    r = _e$selection.$head,
    o = t > 0 ? n.max(r) : n.min(r),
    i = o.parent.inlineContent ? o.depth ? e.doc.resolve(t > 0 ? o.after() : o.before()) : null : o;
  return i && AS.findFrom(i, t);
}
function vL(e, t) {
  return e.dispatch(e.state.tr.setSelection(t).scrollIntoView()), !0;
}
function CL(e, t, n) {
  let r = e.state.selection;
  if (!(r instanceof bS)) {
    if (r instanceof yS && r.node.isInline) return vL(e, new bS(t > 0 ? r.$to : r.$from));
    {
      let n = gL(e.state, t);
      return !!n && vL(e, n);
    }
  }
  if (n.indexOf("s") > -1) {
    let n = r.$head,
      o = n.textOffset ? null : t < 0 ? n.nodeBefore : n.nodeAfter;
    if (!o || o.isText || !o.isLeaf) return !1;
    let i = e.state.doc.resolve(n.pos + o.nodeSize * (t < 0 ? -1 : 1));
    return vL(e, new bS(r.$anchor, i));
  }
  if (!r.empty) return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward")) {
    let n = gL(e.state, t);
    return !!(n && n instanceof yS) && vL(e, n);
  }
  if (!(uV && n.indexOf("m") > -1)) {
    let n,
      o = r.$head,
      i = o.textOffset ? null : t < 0 ? o.nodeBefore : o.nodeAfter;
    if (!i || i.isText) return !1;
    let a = t < 0 ? o.pos - i.nodeSize : o.pos;
    return !!(i.isAtom || (n = e.docView.descAt(a)) && !n.contentDOM) && (yS.isSelectable(i) ? vL(e, new yS(t < 0 ? e.state.doc.resolve(o.pos - i.nodeSize) : o)) : !!pV && vL(e, new bS(e.state.doc.resolve(t < 0 ? a : a + i.nodeSize))));
  }
}
function bL(e) {
  return 3 == e.nodeType ? e.nodeValue.length : e.childNodes.length;
}
function EL(e, t) {
  let n = e.pmViewDesc;
  return n && 0 == n.size && (t < 0 || e.nextSibling || "BR" != e.nodeName);
}
function yL(e, t) {
  return t < 0 ? function (e) {
    let t = e.domSelectionRange(),
      n = t.focusNode,
      r = t.focusOffset;
    if (!n) return;
    let o,
      i,
      a = !1;
    oV && 1 == n.nodeType && r < bL(n) && EL(n.childNodes[r], -1) && (a = !0);
    for (;;) if (r > 0) {
      if (1 != n.nodeType) break;
      {
        let e = n.childNodes[r - 1];
        if (EL(e, -1)) o = n, i = --r;else {
          if (3 != e.nodeType) break;
          n = e, r = n.nodeValue.length;
        }
      }
    } else {
      if (IL(n)) break;
      {
        let t = n.previousSibling;
        for (; t && EL(t, -1);) o = n.parentNode, i = DS(t), t = t.previousSibling;
        if (t) n = t, r = bL(n);else {
          if (n = n.parentNode, n == e.dom) break;
          r = 0;
        }
      }
    }
    a ? BL(e, n, r) : o && BL(e, o, i);
  }(e) : function (e) {
    let t = e.domSelectionRange(),
      n = t.focusNode,
      r = t.focusOffset;
    if (!n) return;
    let o,
      i,
      a = bL(n);
    for (;;) if (r < a) {
      if (1 != n.nodeType) break;
      if (!EL(n.childNodes[r], 1)) break;
      o = n, i = ++r;
    } else {
      if (IL(n)) break;
      {
        let t = n.nextSibling;
        for (; t && EL(t, 1);) o = t.parentNode, i = DS(t) + 1, t = t.nextSibling;
        if (t) n = t, r = 0, a = bL(n);else {
          if (n = n.parentNode, n == e.dom) break;
          r = a = 0;
        }
      }
    }
    o && BL(e, o, i);
  }(e);
}
function IL(e) {
  let t = e.pmViewDesc;
  return t && t.node && t.node.isBlock;
}
function BL(e, t, n) {
  if (3 != t.nodeType) {
    let e, r;
    (r = function (e, t) {
      for (; e && t == e.childNodes.length && !XS(e);) t = DS(e) + 1, e = e.parentNode;
      for (; e && t < e.childNodes.length;) {
        let n = e.childNodes[t];
        if (3 == n.nodeType) return n;
        if (1 == n.nodeType && "false" == n.contentEditable) break;
        e = n, t = 0;
      }
    }(t, n)) ? (t = r, n = 0) : (e = function (e, t) {
      for (; e && !t && !XS(e);) t = DS(e), e = e.parentNode;
      for (; e && t;) {
        let n = e.childNodes[t - 1];
        if (3 == n.nodeType) return n;
        if (1 == n.nodeType && "false" == n.contentEditable) break;
        e = n, t = e.childNodes.length;
      }
    }(t, n)) && (t = e, n = e.nodeValue.length);
  }
  let r = e.domSelection();
  if (US(r)) {
    let e = document.createRange();
    e.setEnd(t, n), e.setStart(t, n), r.removeAllRanges(), r.addRange(e);
  } else r.extend && r.extend(t, n);
  e.domObserver.setCurSelection();
  let o = e.state;
  setTimeout(() => {
    e.state == o && cL(e);
  }, 50);
}
function xL(e, t) {
  let n = e.state.doc.resolve(t);
  if (!aV && !dV && n.parent.inlineContent) {
    let r = e.coordsAtPos(t);
    if (t > n.start()) {
      let n = e.coordsAtPos(t - 1),
        o = (n.top + n.bottom) / 2;
      if (o > r.top && o < r.bottom && Math.abs(n.left - r.left) > 1) return n.left < r.left ? "ltr" : "rtl";
    }
    if (t < n.end()) {
      let n = e.coordsAtPos(t + 1),
        o = (n.top + n.bottom) / 2;
      if (o > r.top && o < r.bottom && Math.abs(n.left - r.left) > 1) return n.left > r.left ? "ltr" : "rtl";
    }
  }
  return "rtl" == getComputedStyle(e.dom).direction ? "rtl" : "ltr";
}
function wL(e, t, n) {
  let r = e.state.selection;
  if (r instanceof bS && !r.empty || n.indexOf("s") > -1) return !1;
  if (uV && n.indexOf("m") > -1) return !1;
  let o = r.$from,
    i = r.$to;
  if (!o.parent.inlineContent || e.endOfTextblock(t < 0 ? "up" : "down")) {
    let n = gL(e.state, t);
    if (n && n instanceof yS) return vL(e, n);
  }
  if (!o.parent.inlineContent) {
    let n = t < 0 ? o : i,
      a = r instanceof BS ? AS.near(n, t) : AS.findFrom(n, t);
    return !!a && vL(e, a);
  }
  return !1;
}
function QL(e, t) {
  if (!(e.state.selection instanceof bS)) return !0;
  let _e$state$selection2 = e.state.selection,
    n = _e$state$selection2.$head,
    r = _e$state$selection2.$anchor,
    o = _e$state$selection2.empty;
  if (!n.sameParent(r)) return !0;
  if (!o) return !1;
  if (e.endOfTextblock(t > 0 ? "forward" : "backward")) return !0;
  let i = !n.textOffset && (t < 0 ? n.nodeBefore : n.nodeAfter);
  if (i && !i.isText) {
    let r = e.state.tr;
    return t < 0 ? r.delete(n.pos - i.nodeSize, n.pos) : r.delete(n.pos, n.pos + i.nodeSize), e.dispatch(r), !0;
  }
  return !1;
}
function HL(e, t, n) {
  e.domObserver.stop(), t.contentEditable = n, e.domObserver.start();
}
function zL(e, t) {
  let n = t.keyCode,
    r = function (e) {
      let t = "";
      return e.ctrlKey && (t += "c"), e.metaKey && (t += "m"), e.altKey && (t += "a"), e.shiftKey && (t += "s"), t;
    }(t);
  if (8 == n || uV && 72 == n && "c" == r) return QL(e, -1) || yL(e, -1);
  if (46 == n && !t.shiftKey || uV && 68 == n && "c" == r) return QL(e, 1) || yL(e, 1);
  if (13 == n || 27 == n) return !0;
  if (37 == n || uV && 66 == n && "c" == r) {
    let t = 37 == n ? "ltr" == xL(e, e.state.selection.from) ? -1 : 1 : -1;
    return CL(e, t, r) || yL(e, t);
  }
  if (39 == n || uV && 70 == n && "c" == r) {
    let t = 39 == n ? "ltr" == xL(e, e.state.selection.from) ? 1 : -1 : 1;
    return CL(e, t, r) || yL(e, t);
  }
  return 38 == n || uV && 80 == n && "c" == r ? wL(e, -1, r) || yL(e, -1) : 40 == n || uV && 78 == n && "c" == r ? function (e) {
    if (!sV || e.state.selection.$head.parentOffset > 0) return !1;
    let _e$domSelectionRange3 = e.domSelectionRange(),
      t = _e$domSelectionRange3.focusNode,
      n = _e$domSelectionRange3.focusOffset;
    if (t && 1 == t.nodeType && 0 == n && t.firstChild && "false" == t.firstChild.contentEditable) {
      let n = t.firstChild;
      HL(e, n, "true"), setTimeout(() => HL(e, n, "false"), 20);
    }
    return !1;
  }(e) || wL(e, 1, r) || yL(e, 1) : r == (uV ? "m" : "c") && (66 == n || 73 == n || 89 == n || 90 == n);
}
function ML(e, t) {
  e.someProp("transformCopied", n => {
    t = n(t, e);
  });
  let n = [],
    _t2 = t,
    r = _t2.content,
    o = _t2.openStart,
    i = _t2.openEnd;
  for (; o > 1 && i > 1 && 1 == r.childCount && 1 == r.firstChild.childCount;) {
    o--, i--;
    let e = r.firstChild;
    n.push(e.type.name, e.attrs != e.type.defaultAttrs ? e.attrs : null), r = e.content;
  }
  let a = e.someProp("clipboardSerializer") || wN.fromSchema(e.state.schema),
    c = RL(),
    s = c.createElement("div");
  s.appendChild(a.serializeFragment(r, {
    document: c
  }));
  let l,
    u = s.firstChild,
    d = 0;
  for (; u && 1 == u.nodeType && (l = TL[u.nodeName.toLowerCase()]);) {
    for (let e = l.length - 1; e >= 0; e--) {
      let t = c.createElement(l[e]);
      for (; s.firstChild;) t.appendChild(s.firstChild);
      s.appendChild(t), d++;
    }
    u = s.firstChild;
  }
  u && 1 == u.nodeType && u.setAttribute("data-pm-slice", `${o} ${i}${d ? ` -${d}` : ""} ${JSON.stringify(n)}`);
  let f = e.someProp("clipboardTextSerializer", n => n(t, e)) || t.content.textBetween(0, t.content.size, "\n\n");
  return {
    dom: s,
    text: f
  };
}
function kL(e, t, n, r, o) {
  let i,
    a,
    c = o.parent.type.spec.code;
  if (!n && !t) return null;
  let s = t && (r || c || !n);
  if (s) {
    if (e.someProp("transformPastedText", n => {
      t = n(t, c || r, e);
    }), c) return t ? new Nk(wk.from(e.state.schema.text(t.replace(/\r\n?/g, "\n"))), 0, 0) : Nk.empty;
    let n = e.someProp("clipboardTextParser", n => n(t, o, r, e));
    if (n) a = n;else {
      let n = o.marks(),
        r = e.state.schema,
        a = wN.fromSchema(r);
      i = document.createElement("div"), t.split(/(?:\r\n?|\n)+/).forEach(e => {
        let t = i.appendChild(document.createElement("p"));
        e && t.appendChild(a.serializeNode(r.text(e, n)));
      });
    }
  } else e.someProp("transformPastedHTML", t => {
    n = t(n, e);
  }), i = function (e) {
    let t = /^(\s*<meta [^>]*>)*/.exec(e);
    t && (e = e.slice(t[0].length));
    let n,
      r = RL().createElement("div"),
      o = /<([a-z][^>\s]+)/i.exec(e);
    (n = o && TL[o[1].toLowerCase()]) && (e = n.map(e => "<" + e + ">").join("") + e + n.map(e => "</" + e + ">").reverse().join(""));
    if (r.innerHTML = e, n) for (let e = 0; e < n.length; e++) r = r.querySelector(n[e]) || r;
    return r;
  }(n), pV && function (e) {
    let t = e.querySelectorAll(aV ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for (let n = 0; n < t.length; n++) {
      let r = t[n];
      1 == r.childNodes.length && " " == r.textContent && r.parentNode && r.parentNode.replaceChild(e.ownerDocument.createTextNode(" "), r);
    }
  }(i);
  let l = i && i.querySelector("[data-pm-slice]"),
    u = l && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(l.getAttribute("data-pm-slice") || "");
  if (u && u[3]) for (let e = +u[3]; e > 0; e--) {
    let e = i.firstChild;
    for (; e && 1 != e.nodeType;) e = e.nextSibling;
    if (!e) break;
    i = e;
  }
  if (!a) {
    let t = e.someProp("clipboardParser") || e.someProp("domParser") || AN.fromSchema(e.state.schema);
    a = t.parseSlice(i, {
      preserveWhitespace: !(!s && !u),
      context: o,
      ruleFromNode: e => "BR" != e.nodeName || e.nextSibling || !e.parentNode || NL.test(e.parentNode.nodeName) ? null : {
        ignore: !0
      }
    });
  }
  if (u) a = function (e, t) {
    if (!e.size) return e;
    let n,
      r = e.content.firstChild.type.schema;
    try {
      n = JSON.parse(t);
    } catch (t) {
      return e;
    }
    let o = e.content,
      i = e.openStart,
      a = e.openEnd;
    for (let e = n.length - 2; e >= 0; e -= 2) {
      let t = r.nodes[n[e]];
      if (!t || t.hasRequiredAttrs()) break;
      o = wk.from(t.create(n[e + 1], o)), i++, a++;
    }
    return new Nk(o, i, a);
  }(OL(a, +u[1], +u[2]), u[4]);else if (a = Nk.maxOpen(function (e, t) {
    if (e.childCount < 2) return e;
    for (let n = t.depth; n >= 0; n--) {
      let r,
        o = t.node(n).contentMatchAt(t.index(n)),
        i = [];
      if (e.forEach(e => {
        if (!i) return;
        let t,
          n = o.findWrapping(e.type);
        if (!n) return i = null;
        if (t = i.length && r.length && VL(n, r, e, i[i.length - 1], 0)) i[i.length - 1] = t;else {
          i.length && (i[i.length - 1] = LL(i[i.length - 1], r.length));
          let t = SL(e, n);
          i.push(t), o = o.matchType(t.type), r = n;
        }
      }), i) return wk.from(i);
    }
    return e;
  }(a.content, o), !0), a.openStart || a.openEnd) {
    let e = 0,
      t = 0;
    for (let t = a.content.firstChild; e < a.openStart && !t.type.spec.isolating; e++, t = t.firstChild);
    for (let e = a.content.lastChild; t < a.openEnd && !e.type.spec.isolating; t++, e = e.lastChild);
    a = OL(a, e, t);
  }
  return e.someProp("transformPasted", t => {
    a = t(a, e);
  }), a;
}
const NL = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function SL(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  for (let r = t.length - 1; r >= n; r--) e = t[r].create(null, wk.from(e));
  return e;
}
function VL(e, t, n, r, o) {
  if (o < e.length && o < t.length && e[o] == t[o]) {
    let i = VL(e, t, n, r.lastChild, o + 1);
    if (i) return r.copy(r.content.replaceChild(r.childCount - 1, i));
    if (r.contentMatchAt(r.childCount).matchType(o == e.length - 1 ? n.type : e[o + 1])) return r.copy(r.content.append(wk.from(SL(n, e, o + 1))));
  }
}
function LL(e, t) {
  if (0 == t) return e;
  let n = e.content.replaceChild(e.childCount - 1, LL(e.lastChild, t - 1)),
    r = e.contentMatchAt(e.childCount).fillBefore(wk.empty, !0);
  return e.copy(n.append(r));
}
function PL(e, t, n, r, o, i) {
  let a = t < 0 ? e.firstChild : e.lastChild,
    c = a.content;
  return e.childCount > 1 && (i = 0), o < r - 1 && (c = PL(c, t, n, r, o + 1, i)), o >= n && (c = t < 0 ? a.contentMatchAt(0).fillBefore(c, i <= o).append(c) : c.append(a.contentMatchAt(a.childCount).fillBefore(wk.empty, !0))), e.replaceChild(t < 0 ? 0 : e.childCount - 1, a.copy(c));
}
function OL(e, t, n) {
  return t < e.openStart && (e = new Nk(PL(e.content, -1, t, e.openStart, 0, e.openEnd), t, e.openEnd)), n < e.openEnd && (e = new Nk(PL(e.content, 1, n, e.openEnd, 0, 0), e.openStart, n)), e;
}
const TL = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let DL = null;
function RL() {
  return DL || (DL = document.implementation.createHTMLDocument("title"));
}
const GL = {},
  FL = {},
  jL = {
    touchstart: !0,
    touchmove: !0
  };
class JL {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = {
      time: 0,
      x: 0,
      y: 0,
      type: ""
    }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastAndroidDelete = 0, this.composing = !1, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = Object.create(null), this.hideSelectionGuard = null;
  }
}
function ZL(e, t) {
  e.input.lastSelectionOrigin = t, e.input.lastSelectionTime = Date.now();
}
function WL(e) {
  e.someProp("handleDOMEvents", t => {
    for (let n in t) e.input.eventHandlers[n] || e.dom.addEventListener(n, e.input.eventHandlers[n] = t => XL(e, t));
  });
}
function XL(e, t) {
  return e.someProp("handleDOMEvents", n => {
    let r = n[t.type];
    return !!r && (r(e, t) || t.defaultPrevented);
  });
}
function UL(e, t) {
  if (!t.bubbles) return !0;
  if (t.defaultPrevented) return !1;
  for (let n = t.target; n != e.dom; n = n.parentNode) if (!n || 11 == n.nodeType || n.pmViewDesc && n.pmViewDesc.stopEvent(t)) return !1;
  return !0;
}
function KL(e) {
  return {
    left: e.clientX,
    top: e.clientY
  };
}
function YL(e, t, n, r, o) {
  if (-1 == r) return !1;
  let i = e.state.doc.resolve(r);
  for (let r = i.depth + 1; r > 0; r--) if (e.someProp(t, t => r > i.depth ? t(e, n, i.nodeAfter, i.before(r), o, !0) : t(e, n, i.node(r), i.before(r), o, !1))) return !0;
  return !1;
}
function qL(e, t, n) {
  e.focused || e.focus();
  let r = e.state.tr.setSelection(t);
  "pointer" == n && r.setMeta("pointer", !0), e.dispatch(r);
}
function _L(e, t, n, r, o) {
  return YL(e, "handleClickOn", t, n, r) || e.someProp("handleClick", n => n(e, t, r)) || (o ? function (e, t) {
    if (-1 == t) return !1;
    let n,
      r,
      o = e.state.selection;
    o instanceof yS && (n = o.node);
    let i = e.state.doc.resolve(t);
    for (let e = i.depth + 1; e > 0; e--) {
      let t = e > i.depth ? i.nodeAfter : i.node(e);
      if (yS.isSelectable(t)) {
        r = n && o.$from.depth > 0 && e >= o.$from.depth && i.before(o.$from.depth + 1) == o.$from.pos ? i.before(o.$from.depth) : i.before(e);
        break;
      }
    }
    return null != r && (qL(e, yS.create(e.state.doc, r), "pointer"), !0);
  }(e, n) : function (e, t) {
    if (-1 == t) return !1;
    let n = e.state.doc.resolve(t),
      r = n.nodeAfter;
    return !!(r && r.isAtom && yS.isSelectable(r)) && (qL(e, new yS(n), "pointer"), !0);
  }(e, n));
}
function $L(e, t, n, r) {
  return YL(e, "handleDoubleClickOn", t, n, r) || e.someProp("handleDoubleClick", n => n(e, t, r));
}
function eP(e, t, n, r) {
  return YL(e, "handleTripleClickOn", t, n, r) || e.someProp("handleTripleClick", n => n(e, t, r)) || function (e, t, n) {
    if (0 != n.button) return !1;
    let r = e.state.doc;
    if (-1 == t) return !!r.inlineContent && (qL(e, bS.create(r, 0, r.content.size), "pointer"), !0);
    let o = r.resolve(t);
    for (let t = o.depth + 1; t > 0; t--) {
      let n = t > o.depth ? o.nodeAfter : o.node(t),
        i = o.before(t);
      if (n.inlineContent) qL(e, bS.create(r, i + 1, i + 1 + n.content.size), "pointer");else {
        if (!yS.isSelectable(n)) continue;
        qL(e, yS.create(r, i), "pointer");
      }
      return !0;
    }
  }(e, n, r);
}
function tP(e) {
  return sP(e);
}
FL.keydown = (e, t) => {
  let n = t;
  if (e.input.shiftKey = 16 == n.keyCode || n.shiftKey, !oP(e, n) && (e.input.lastKeyCode = n.keyCode, e.input.lastKeyCodeTime = Date.now(), !fV || !aV || 13 != n.keyCode)) if (229 != n.keyCode && e.domObserver.forceFlush(), !lV || 13 != n.keyCode || n.ctrlKey || n.altKey || n.metaKey) e.someProp("handleKeyDown", t => t(e, n)) || zL(e, n) ? n.preventDefault() : ZL(e, "key");else {
    let t = Date.now();
    e.input.lastIOSEnter = t, e.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
      e.input.lastIOSEnter == t && (e.someProp("handleKeyDown", t => t(e, KS(13, "Enter"))), e.input.lastIOSEnter = 0);
    }, 200);
  }
}, FL.keyup = (e, t) => {
  16 == t.keyCode && (e.input.shiftKey = !1);
}, FL.keypress = (e, t) => {
  let n = t;
  if (oP(e, n) || !n.charCode || n.ctrlKey && !n.altKey || uV && n.metaKey) return;
  if (e.someProp("handleKeyPress", t => t(e, n))) return void n.preventDefault();
  let r = e.state.selection;
  if (!(r instanceof bS && r.$from.sameParent(r.$to))) {
    let t = String.fromCharCode(n.charCode);
    /[\r\n]/.test(t) || e.someProp("handleTextInput", n => n(e, r.$from.pos, r.$to.pos, t)) || e.dispatch(e.state.tr.insertText(t).scrollIntoView()), n.preventDefault();
  }
};
const nP = uV ? "metaKey" : "ctrlKey";
GL.mousedown = (e, t) => {
  let n = t;
  e.input.shiftKey = n.shiftKey;
  let r = tP(e),
    o = Date.now(),
    i = "singleClick";
  o - e.input.lastClick.time < 500 && function (e, t) {
    let n = t.x - e.clientX,
      r = t.y - e.clientY;
    return n * n + r * r < 100;
  }(n, e.input.lastClick) && !n[nP] && ("singleClick" == e.input.lastClick.type ? i = "doubleClick" : "doubleClick" == e.input.lastClick.type && (i = "tripleClick")), e.input.lastClick = {
    time: o,
    x: n.clientX,
    y: n.clientY,
    type: i
  };
  let a = e.posAtCoords(KL(n));
  a && ("singleClick" == i ? (e.input.mouseDown && e.input.mouseDown.done(), e.input.mouseDown = new rP(e, a, n, !!r)) : ("doubleClick" == i ? $L : eP)(e, a.pos, a.inside, n) ? n.preventDefault() : ZL(e, "pointer"));
};
class rP {
  constructor(e, t, n, r) {
    let o, i;
    if (this.view = e, this.pos = t, this.event = n, this.flushed = r, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!n[nP], this.allowDefault = n.shiftKey, t.inside > -1) o = e.state.doc.nodeAt(t.inside), i = t.inside;else {
      let n = e.state.doc.resolve(t.pos);
      o = n.parent, i = n.depth ? n.before() : 0;
    }
    const a = r ? null : n.target,
      c = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = c ? c.dom : null;
    let s = e.state.selection;
    (0 == n.button && o.type.spec.draggable && !1 !== o.type.spec.selectable || s instanceof yS && s.from <= i && s.to > i) && (this.mightDrag = {
      node: o,
      pos: i,
      addAttr: !(!this.target || this.target.draggable),
      setUneditable: !(!this.target || !oV || this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ZL(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => cL(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target)) return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(KL(e))), this.updateAllowDefault(e), this.allowDefault || !t ? ZL(this.view, "pointer") : _L(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : 0 == e.button && (this.flushed || sV && this.mightDrag && !this.mightDrag.node.isAtom || aV && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (qL(this.view, AS.near(this.view.state.doc.resolve(t.pos)), "pointer"), e.preventDefault()) : ZL(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ZL(this.view, "pointer"), 0 == e.buttons && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
function oP(e, t) {
  return !!e.composing || !!(sV && Math.abs(t.timeStamp - e.input.compositionEndedAt) < 500) && (e.input.compositionEndedAt = -2e8, !0);
}
GL.touchstart = e => {
  e.input.lastTouch = Date.now(), tP(e), ZL(e, "pointer");
}, GL.touchmove = e => {
  e.input.lastTouch = Date.now(), ZL(e, "pointer");
}, GL.contextmenu = e => tP(e);
const iP = fV ? 5e3 : -1;
function aP(e, t) {
  clearTimeout(e.input.composingTimeout), t > -1 && (e.input.composingTimeout = setTimeout(() => sP(e), t));
}
function cP(e) {
  for (e.composing && (e.input.composing = !1, e.input.compositionEndedAt = function () {
    let e = document.createEvent("Event");
    return e.initEvent("event", !0, !0), e.timeStamp;
  }()); e.input.compositionNodes.length > 0;) e.input.compositionNodes.pop().markParentsDirty();
}
function sP(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  if (!(fV && e.domObserver.flushingSoon >= 0)) {
    if (e.domObserver.forceFlush(), cP(e), t || e.docView && e.docView.dirty) {
      let t = iL(e);
      return t && !t.eq(e.state.selection) ? e.dispatch(e.state.tr.setSelection(t)) : e.updateState(e.state), !0;
    }
    return !1;
  }
}
FL.compositionstart = FL.compositionupdate = e => {
  if (!e.composing) {
    e.domObserver.flush();
    let t = e.state,
      n = t.selection.$from;
    if (t.selection.empty && (t.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some(e => !1 === e.type.spec.inclusive))) e.markCursor = e.state.storedMarks || n.marks(), sP(e, !0), e.markCursor = null;else if (sP(e), oV && t.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let t = e.domSelectionRange();
      for (let n = t.focusNode, r = t.focusOffset; n && 1 == n.nodeType && 0 != r;) {
        let t = r < 0 ? n.lastChild : n.childNodes[r - 1];
        if (!t) break;
        if (3 == t.nodeType) {
          e.domSelection().collapse(t, t.nodeValue.length);
          break;
        }
        n = t, r = -1;
      }
    }
    e.input.composing = !0;
  }
  aP(e, iP);
}, FL.compositionend = (e, t) => {
  e.composing && (e.input.composing = !1, e.input.compositionEndedAt = t.timeStamp, e.input.compositionPendingChanges = e.domObserver.pendingRecords().length ? e.input.compositionID : 0, e.input.compositionPendingChanges && Promise.resolve().then(() => e.domObserver.flush()), e.input.compositionID++, aP(e, 20));
};
const lP = nV && rV < 15 || lV && mV < 604;
function uP(e, t, n, r, o) {
  let i = kL(e, t, n, r, e.state.selection.$from);
  if (e.someProp("handlePaste", t => t(e, o, i || Nk.empty))) return !0;
  if (!i) return !1;
  let a = function (e) {
      return 0 == e.openStart && 0 == e.openEnd && 1 == e.content.childCount ? e.content.firstChild : null;
    }(i),
    c = a ? e.state.tr.replaceSelectionWith(a, r) : e.state.tr.replaceSelection(i);
  return e.dispatch(c.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function dP(e) {
  let t = e.getData("text/plain") || e.getData("Text");
  if (t) return t;
  let n = e.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
GL.copy = FL.cut = (e, t) => {
  let n = t,
    r = e.state.selection,
    o = "cut" == n.type;
  if (r.empty) return;
  let i = lP ? null : n.clipboardData,
    a = r.content(),
    _ML = ML(e, a),
    c = _ML.dom,
    s = _ML.text;
  i ? (n.preventDefault(), i.clearData(), i.setData("text/html", c.innerHTML), i.setData("text/plain", s)) : function (e, t) {
    if (!e.dom.parentNode) return;
    let n = e.dom.parentNode.appendChild(document.createElement("div"));
    n.appendChild(t), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let r = getSelection(),
      o = document.createRange();
    o.selectNodeContents(t), e.dom.blur(), r.removeAllRanges(), r.addRange(o), setTimeout(() => {
      n.parentNode && n.parentNode.removeChild(n), e.focus();
    }, 50);
  }(e, c), o && e.dispatch(e.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
}, FL.paste = (e, t) => {
  let n = t;
  if (e.composing && !fV) return;
  let r = lP ? null : n.clipboardData,
    o = e.input.shiftKey && 45 != e.input.lastKeyCode;
  r && uP(e, dP(r), r.getData("text/html"), o, n) ? n.preventDefault() : function (e, t) {
    if (!e.dom.parentNode) return;
    let n = e.input.shiftKey || e.state.selection.$from.parent.type.spec.code,
      r = e.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
    n || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
    let o = e.input.shiftKey && 45 != e.input.lastKeyCode;
    setTimeout(() => {
      e.focus(), r.parentNode && r.parentNode.removeChild(r), n ? uP(e, r.value, null, o, t) : uP(e, r.textContent, r.innerHTML, o, t);
    }, 50);
  }(e, n);
};
class fP {
  constructor(e, t, n) {
    this.slice = e, this.move = t, this.node = n;
  }
}
const pP = uV ? "altKey" : "ctrlKey";
GL.dragstart = (e, t) => {
  let n = t,
    r = e.input.mouseDown;
  if (r && r.done(), !n.dataTransfer) return;
  let o,
    i = e.state.selection,
    a = i.empty ? null : e.posAtCoords(KL(n));
  if (a && a.pos >= i.from && a.pos <= (i instanceof yS ? i.to - 1 : i.to)) ;else if (r && r.mightDrag) o = yS.create(e.state.doc, r.mightDrag.pos);else if (n.target && 1 == n.target.nodeType) {
    let t = e.docView.nearestDesc(n.target, !0);
    t && t.node.type.spec.draggable && t != e.docView && (o = yS.create(e.state.doc, t.posBefore));
  }
  let c = (o || e.state.selection).content(),
    _ML2 = ML(e, c),
    s = _ML2.dom,
    l = _ML2.text;
  n.dataTransfer.clearData(), n.dataTransfer.setData(lP ? "Text" : "text/html", s.innerHTML), n.dataTransfer.effectAllowed = "copyMove", lP || n.dataTransfer.setData("text/plain", l), e.dragging = new fP(c, !n[pP], o);
}, GL.dragend = e => {
  let t = e.dragging;
  window.setTimeout(() => {
    e.dragging == t && (e.dragging = null);
  }, 50);
}, FL.dragover = FL.dragenter = (e, t) => t.preventDefault(), FL.drop = (e, t) => {
  let n = t,
    r = e.dragging;
  if (e.dragging = null, !n.dataTransfer) return;
  let o = e.posAtCoords(KL(n));
  if (!o) return;
  let i = e.state.doc.resolve(o.pos),
    a = r && r.slice;
  a ? e.someProp("transformPasted", t => {
    a = t(a, e);
  }) : a = kL(e, dP(n.dataTransfer), lP ? null : n.dataTransfer.getData("text/html"), !1, i);
  let c = !(!r || n[pP]);
  if (e.someProp("handleDrop", t => t(e, n, a || Nk.empty, c))) return void n.preventDefault();
  if (!a) return;
  n.preventDefault();
  let s = a ? eS(e.state.doc, i.pos, a) : i.pos;
  null == s && (s = i.pos);
  let l = e.state.tr;
  if (c) {
    let e = r.node;
    e ? e.replace(l) : l.deleteSelection();
  }
  let u = l.mapping.map(s),
    d = 0 == a.openStart && 0 == a.openEnd && 1 == a.content.childCount,
    f = l.doc;
  if (d ? l.replaceRangeWith(u, u, a.content.firstChild) : l.replaceRange(u, u, a), l.doc.eq(f)) return;
  let p = l.doc.resolve(u);
  if (d && yS.isSelectable(a.content.firstChild) && p.nodeAfter && p.nodeAfter.sameMarkup(a.content.firstChild)) l.setSelection(new yS(p));else {
    let t = l.mapping.map(s);
    l.mapping.maps[l.mapping.maps.length - 1].forEach((e, n, r, o) => t = o), l.setSelection(mL(e, p, l.doc.resolve(t)));
  }
  e.focus(), e.dispatch(l.setMeta("uiEvent", "drop"));
}, GL.focus = e => {
  e.input.lastFocus = Date.now(), e.focused || (e.domObserver.stop(), e.dom.classList.add("ProseMirror-focused"), e.domObserver.start(), e.focused = !0, setTimeout(() => {
    e.docView && e.hasFocus() && !e.domObserver.currentSelection.eq(e.domSelectionRange()) && cL(e);
  }, 20));
}, GL.blur = (e, t) => {
  let n = t;
  e.focused && (e.domObserver.stop(), e.dom.classList.remove("ProseMirror-focused"), e.domObserver.start(), n.relatedTarget && e.dom.contains(n.relatedTarget) && e.domObserver.currentSelection.clear(), e.focused = !1);
}, GL.beforeinput = (e, t) => {
  if (aV && fV && "deleteContentBackward" == t.inputType) {
    e.domObserver.flushSoon();
    let t = e.input.domChangeCount;
    setTimeout(() => {
      if (e.input.domChangeCount != t) return;
      if (e.dom.blur(), e.focus(), e.someProp("handleKeyDown", t => t(e, KS(8, "Backspace")))) return;
      let n = e.state.selection.$cursor;
      n && n.pos > 0 && e.dispatch(e.state.tr.delete(n.pos - 1, n.pos).scrollIntoView());
    }, 50);
  }
};
for (let e in FL) GL[e] = FL[e];
function mP(e, t) {
  if (e == t) return !0;
  for (let n in e) if (e[n] !== t[n]) return !1;
  for (let n in t) if (!(n in e)) return !1;
  return !0;
}
class hP {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || bP, this.side = this.spec.side || 0;
  }
  map(e, t, n, r) {
    let _e$mapResult2 = e.mapResult(t.from + r, this.side < 0 ? -1 : 1),
      o = _e$mapResult2.pos,
      i = _e$mapResult2.deleted;
    return i ? null : new vP(o - n, o - n, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof hP && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && mP(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class AP {
  constructor(e, t) {
    this.attrs = e, this.spec = t || bP;
  }
  map(e, t, n, r) {
    let o = e.map(t.from + r, this.spec.inclusiveStart ? -1 : 1) - n,
      i = e.map(t.to + r, this.spec.inclusiveEnd ? 1 : -1) - n;
    return o >= i ? null : new vP(o, i, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof AP && mP(this.attrs, e.attrs) && mP(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof AP;
  }
  destroy() {}
}
class gP {
  constructor(e, t) {
    this.attrs = e, this.spec = t || bP;
  }
  map(e, t, n, r) {
    let o = e.mapResult(t.from + r, 1);
    if (o.deleted) return null;
    let i = e.mapResult(t.to + r, -1);
    return i.deleted || i.pos <= o.pos ? null : new vP(o.pos - n, i.pos - n, this);
  }
  valid(e, t) {
    let n,
      _e$content$findIndex = e.content.findIndex(t.from),
      r = _e$content$findIndex.index,
      o = _e$content$findIndex.offset;
    return o == t.from && !(n = e.child(r)).isText && o + n.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof gP && mP(this.attrs, e.attrs) && mP(this.spec, e.spec);
  }
  destroy() {}
}
class vP {
  constructor(e, t, n) {
    this.from = e, this.to = t, this.type = n;
  }
  copy(e, t) {
    return new vP(e, t, this.type);
  }
  eq(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  map(e, t, n) {
    return this.type.map(e, this, t, n);
  }
  static widget(e, t, n) {
    return new vP(e, e, new hP(t, n));
  }
  static inline(e, t, n, r) {
    return new vP(e, t, new AP(n, r));
  }
  static node(e, t, n, r) {
    return new vP(e, t, new gP(n, r));
  }
  get spec() {
    return this.type.spec;
  }
  get inline() {
    return this.type instanceof AP;
  }
  get widget() {
    return this.type instanceof hP;
  }
}
const CP = [],
  bP = {};
class EP {
  constructor(e, t) {
    this.local = e.length ? e : CP, this.children = t.length ? t : CP;
  }
  static create(e, t) {
    return t.length ? QP(t, e, 0, bP) : yP;
  }
  find(e, t, n) {
    let r = [];
    return this.findInner(null == e ? 0 : e, null == t ? 1e9 : t, r, 0, n), r;
  }
  findInner(e, t, n, r, o) {
    for (let i = 0; i < this.local.length; i++) {
      let a = this.local[i];
      a.from <= t && a.to >= e && (!o || o(a.spec)) && n.push(a.copy(a.from + r, a.to + r));
    }
    for (let i = 0; i < this.children.length; i += 3) if (this.children[i] < t && this.children[i + 1] > e) {
      let a = this.children[i] + 1;
      this.children[i + 2].findInner(e - a, t - a, n, r + a, o);
    }
  }
  map(e, t, n) {
    return this == yP || 0 == e.maps.length ? this : this.mapInner(e, t, 0, 0, n || bP);
  }
  mapInner(e, t, n, r, o) {
    let i;
    for (let a = 0; a < this.local.length; a++) {
      let c = this.local[a].map(e, n, r);
      c && c.type.valid(t, c) ? (i || (i = [])).push(c) : o.onRemove && o.onRemove(this.local[a].spec);
    }
    return this.children.length ? function (e, t, n, r, o, i, a) {
      let c = e.slice();
      for (let e = 0, t = i; e < n.maps.length; e++) {
        let r = 0;
        n.maps[e].forEach((e, n, o, i) => {
          let a = i - o - (n - e);
          for (let o = 0; o < c.length; o += 3) {
            let i = c[o + 1];
            if (i < 0 || e > i + t - r) continue;
            let s = c[o] + t - r;
            n >= s ? c[o + 1] = e <= s ? -2 : -1 : e >= t && a && (c[o] += a, c[o + 1] += a);
          }
          r += a;
        }), t = n.maps[e].map(t, -1);
      }
      let s = !1;
      for (let t = 0; t < c.length; t += 3) if (c[t + 1] < 0) {
        if (-2 == c[t + 1]) {
          s = !0, c[t + 1] = -1;
          continue;
        }
        let l = n.map(e[t] + i),
          u = l - o;
        if (u < 0 || u >= r.content.size) {
          s = !0;
          continue;
        }
        let d = n.map(e[t + 1] + i, -1) - o,
          _r$content$findIndex = r.content.findIndex(u),
          f = _r$content$findIndex.index,
          p = _r$content$findIndex.offset,
          m = r.maybeChild(f);
        if (m && p == u && p + m.nodeSize == d) {
          let r = c[t + 2].mapInner(n, m, l + 1, e[t] + i + 1, a);
          r != yP ? (c[t] = u, c[t + 1] = d, c[t + 2] = r) : (c[t + 1] = -2, s = !0);
        } else s = !0;
      }
      if (s) {
        let s = function (e, t, n, r, o, i, a) {
            function c(e, t) {
              for (let i = 0; i < e.local.length; i++) {
                let c = e.local[i].map(r, o, t);
                c ? n.push(c) : a.onRemove && a.onRemove(e.local[i].spec);
              }
              for (let n = 0; n < e.children.length; n += 3) c(e.children[n + 2], e.children[n] + t + 1);
            }
            for (let n = 0; n < e.length; n += 3) -1 == e[n + 1] && c(e[n + 2], t[n] + i + 1);
            return n;
          }(c, e, t, n, o, i, a),
          l = QP(s, r, 0, a);
        t = l.local;
        for (let e = 0; e < c.length; e += 3) c[e + 1] < 0 && (c.splice(e, 3), e -= 3);
        for (let e = 0, t = 0; e < l.children.length; e += 3) {
          let n = l.children[e];
          for (; t < c.length && c[t] < n;) t += 3;
          c.splice(t, 0, l.children[e], l.children[e + 1], l.children[e + 2]);
        }
      }
      return new EP(t.sort(HP), c);
    }(this.children, i || [], e, t, n, r, o) : i ? new EP(i.sort(HP), CP) : yP;
  }
  add(e, t) {
    return t.length ? this == yP ? EP.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, n) {
    let r,
      o = 0;
    e.forEach((e, i) => {
      let a,
        c = i + n;
      if (a = xP(t, e, c)) {
        for (r || (r = this.children.slice()); o < r.length && r[o] < i;) o += 3;
        r[o] == i ? r[o + 2] = r[o + 2].addInner(e, a, c + 1) : r.splice(o, 0, i, i + e.nodeSize, QP(a, e, c + 1, bP)), o += 3;
      }
    });
    let i = BP(o ? wP(t) : t, -n);
    for (let t = 0; t < i.length; t++) i[t].type.valid(e, i[t]) || i.splice(t--, 1);
    return new EP(i.length ? this.local.concat(i).sort(HP) : this.local, r || this.children);
  }
  remove(e) {
    return 0 == e.length || this == yP ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let n = this.children,
      r = this.local;
    for (let r = 0; r < n.length; r += 3) {
      let o,
        i = n[r] + t,
        a = n[r + 1] + t;
      for (let t, n = 0; n < e.length; n++) (t = e[n]) && t.from > i && t.to < a && (e[n] = null, (o || (o = [])).push(t));
      if (!o) continue;
      n == this.children && (n = this.children.slice());
      let c = n[r + 2].removeInner(o, i + 1);
      c != yP ? n[r + 2] = c : (n.splice(r, 3), r -= 3);
    }
    if (r.length) for (let n, o = 0; o < e.length; o++) if (n = e[o]) for (let e = 0; e < r.length; e++) r[e].eq(n, t) && (r == this.local && (r = this.local.slice()), r.splice(e--, 1));
    return n == this.children && r == this.local ? this : r.length || n.length ? new EP(r, n) : yP;
  }
  forChild(e, t) {
    if (this == yP) return this;
    if (t.isLeaf) return EP.empty;
    let n, r;
    for (let t = 0; t < this.children.length; t += 3) if (this.children[t] >= e) {
      this.children[t] == e && (n = this.children[t + 2]);
      break;
    }
    let o = e + 1,
      i = o + t.content.size;
    for (let e = 0; e < this.local.length; e++) {
      let t = this.local[e];
      if (t.from < i && t.to > o && t.type instanceof AP) {
        let e = Math.max(o, t.from) - o,
          n = Math.min(i, t.to) - o;
        e < n && (r || (r = [])).push(t.copy(e, n));
      }
    }
    if (r) {
      let e = new EP(r.sort(HP), CP);
      return n ? new IP([e, n]) : e;
    }
    return n || yP;
  }
  eq(e) {
    if (this == e) return !0;
    if (!(e instanceof EP) || this.local.length != e.local.length || this.children.length != e.children.length) return !1;
    for (let t = 0; t < this.local.length; t++) if (!this.local[t].eq(e.local[t])) return !1;
    for (let t = 0; t < this.children.length; t += 3) if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2])) return !1;
    return !0;
  }
  locals(e) {
    return zP(this.localsInner(e));
  }
  localsInner(e) {
    if (this == yP) return CP;
    if (e.inlineContent || !this.local.some(AP.is)) return this.local;
    let t = [];
    for (let e = 0; e < this.local.length; e++) this.local[e].type instanceof AP || t.push(this.local[e]);
    return t;
  }
}
EP.empty = new EP([], []), EP.removeOverlap = zP;
const yP = EP.empty;
class IP {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const n = this.members.map(n => n.map(e, t, bP));
    return IP.from(n);
  }
  forChild(e, t) {
    if (t.isLeaf) return EP.empty;
    let n = [];
    for (let r = 0; r < this.members.length; r++) {
      let o = this.members[r].forChild(e, t);
      o != yP && (o instanceof IP ? n = n.concat(o.members) : n.push(o));
    }
    return IP.from(n);
  }
  eq(e) {
    if (!(e instanceof IP) || e.members.length != this.members.length) return !1;
    for (let t = 0; t < this.members.length; t++) if (!this.members[t].eq(e.members[t])) return !1;
    return !0;
  }
  locals(e) {
    let t,
      n = !0;
    for (let r = 0; r < this.members.length; r++) {
      let o = this.members[r].localsInner(e);
      if (o.length) if (t) {
        n && (t = t.slice(), n = !1);
        for (let e = 0; e < o.length; e++) t.push(o[e]);
      } else t = o;
    }
    return t ? zP(n ? t : t.sort(HP)) : CP;
  }
  static from(e) {
    switch (e.length) {
      case 0:
        return yP;
      case 1:
        return e[0];
      default:
        return new IP(e.every(e => e instanceof EP) ? e : e.reduce((e, t) => e.concat(t instanceof EP ? t : t.members), []));
    }
  }
}
function BP(e, t) {
  if (!t || !e.length) return e;
  let n = [];
  for (let r = 0; r < e.length; r++) {
    let o = e[r];
    n.push(new vP(o.from + t, o.to + t, o.type));
  }
  return n;
}
function xP(e, t, n) {
  if (t.isLeaf) return null;
  let r = n + t.nodeSize,
    o = null;
  for (let t, i = 0; i < e.length; i++) (t = e[i]) && t.from > n && t.to < r && ((o || (o = [])).push(t), e[i] = null);
  return o;
}
function wP(e) {
  let t = [];
  for (let n = 0; n < e.length; n++) null != e[n] && t.push(e[n]);
  return t;
}
function QP(e, t, n, r) {
  let o = [],
    i = !1;
  t.forEach((t, a) => {
    let c = xP(e, t, a + n);
    if (c) {
      i = !0;
      let e = QP(c, t, n + a + 1, r);
      e != yP && o.push(a, a + t.nodeSize, e);
    }
  });
  let a = BP(i ? wP(e) : e, -n).sort(HP);
  for (let e = 0; e < a.length; e++) a[e].type.valid(t, a[e]) || (r.onRemove && r.onRemove(a[e].spec), a.splice(e--, 1));
  return a.length || o.length ? new EP(a, o) : yP;
}
function HP(e, t) {
  return e.from - t.from || e.to - t.to;
}
function zP(e) {
  let t = e;
  for (let n = 0; n < t.length - 1; n++) {
    let r = t[n];
    if (r.from != r.to) for (let o = n + 1; o < t.length; o++) {
      let i = t[o];
      if (i.from != r.from) {
        i.from < r.to && (t == e && (t = e.slice()), t[n] = r.copy(r.from, i.from), MP(t, o, r.copy(i.from, r.to)));
        break;
      }
      i.to != r.to && (t == e && (t = e.slice()), t[o] = i.copy(i.from, r.to), MP(t, o + 1, i.copy(r.to, i.to)));
    }
  }
  return t;
}
function MP(e, t, n) {
  for (; t < e.length && HP(n, e[t]) > 0;) t++;
  e.splice(t, 0, n);
}
function kP(e) {
  let t = [];
  return e.someProp("decorations", n => {
    let r = n(e.state);
    r && r != yP && t.push(r);
  }), e.cursorWrapper && t.push(EP.create(e.state.doc, [e.cursorWrapper.deco])), IP.from(t);
}
const NP = {
    childList: !0,
    characterData: !0,
    characterDataOldValue: !0,
    attributes: !0,
    attributeOldValue: !0,
    subtree: !0
  },
  SP = nV && rV <= 11;
class VP {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class LP {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new VP(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.observer = window.MutationObserver && new window.MutationObserver(e => {
      for (let t = 0; t < e.length; t++) this.queue.push(e[t]);
      nV && rV <= 11 && e.some(e => "childList" == e.type && e.removedNodes.length || "characterData" == e.type && e.oldValue.length > e.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), SP && (this.onCharData = e => {
      this.queue.push({
        target: e.target,
        type: "characterData",
        oldValue: e.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, NP)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++) this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (hL(this.view)) {
      if (this.suppressingSelectionUpdates) return cL(this.view);
      if (nV && rV <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && jS(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset)) return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode) return !0;
    let t,
      n = new Set();
    for (let t = e.focusNode; t; t = RS(t)) n.add(t);
    for (let r = e.anchorNode; r; r = RS(r)) if (n.has(r)) {
      t = r;
      break;
    }
    let r = t && this.view.docView.nearestDesc(t);
    return r && r.ignoreMutation({
      type: "selection",
      target: 3 == t.nodeType ? t.parentNode : t
    }) ? (this.setCurSelection(), !0) : void 0;
  }
  pendingRecords() {
    if (this.observer) for (let e of this.observer.takeRecords()) this.queue.push(e);
    return this.queue;
  }
  flush() {
    let e = this.view;
    if (!e.docView || this.flushingSoon > -1) return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let n = e.domSelectionRange(),
      r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && hL(e) && !this.ignoreSelectionChange(n),
      o = -1,
      i = -1,
      a = !1,
      c = [];
    if (e.editable) for (let e = 0; e < t.length; e++) {
      let n = this.registerMutation(t[e], c);
      n && (o = o < 0 ? n.from : Math.min(n.from, o), i = i < 0 ? n.to : Math.max(n.to, i), n.typeOver && (a = !0));
    }
    if (oV && c.length > 1) {
      let e = c.filter(e => "BR" == e.nodeName);
      if (2 == e.length) {
        let t = e[0],
          n = e[1];
        t.parentNode && t.parentNode.parentNode == n.parentNode ? n.remove() : t.remove();
      }
    }
    let s = null;
    o < 0 && r && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && US(n) && (s = iL(e)) && s.eq(AS.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, cL(e), this.currentSelection.set(n), e.scrollToSelection()) : (o > -1 || r) && (o > -1 && (e.docView.markDirty(o, i), function (e) {
      if (PP.has(e)) return;
      if (PP.set(e, null), -1 !== ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(e.dom).whiteSpace)) {
        if (e.requiresGeckoHackNode = oV, OP) return;
        console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), OP = !0;
      }
    }(e)), this.handleDOMChange(o, i, a, c), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(n) || cL(e), this.currentSelection.set(n));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1) return null;
    let n = this.view.docView.nearestDesc(e.target);
    if ("attributes" == e.type && (n == this.view.docView || "contenteditable" == e.attributeName || "style" == e.attributeName && !e.oldValue && !e.target.getAttribute("style"))) return null;
    if (!n || n.ignoreMutation(e)) return null;
    if ("childList" == e.type) {
      for (let n = 0; n < e.addedNodes.length; n++) t.push(e.addedNodes[n]);
      if (n.contentDOM && n.contentDOM != n.dom && !n.contentDOM.contains(e.target)) return {
        from: n.posBefore,
        to: n.posAfter
      };
      let r = e.previousSibling,
        o = e.nextSibling;
      if (nV && rV <= 11 && e.addedNodes.length) for (let t = 0; t < e.addedNodes.length; t++) {
        let _e$addedNodes$t = e.addedNodes[t],
          n = _e$addedNodes$t.previousSibling,
          i = _e$addedNodes$t.nextSibling;
        (!n || Array.prototype.indexOf.call(e.addedNodes, n) < 0) && (r = n), (!i || Array.prototype.indexOf.call(e.addedNodes, i) < 0) && (o = i);
      }
      let i = r && r.parentNode == e.target ? DS(r) + 1 : 0,
        a = n.localPosFromDOM(e.target, i, -1),
        c = o && o.parentNode == e.target ? DS(o) : e.target.childNodes.length;
      return {
        from: a,
        to: n.localPosFromDOM(e.target, c, 1)
      };
    }
    return "attributes" == e.type ? {
      from: n.posAtStart - n.border,
      to: n.posAtEnd + n.border
    } : {
      from: n.posAtStart,
      to: n.posAtEnd,
      typeOver: e.target.nodeValue == e.oldValue
    };
  }
}
let PP = new WeakMap(),
  OP = !1;
function TP(e) {
  let t = e.pmViewDesc;
  if (t) return t.parseRule();
  if ("BR" == e.nodeName && e.parentNode) {
    if (sV && /^(ul|ol)$/i.test(e.parentNode.nodeName)) {
      let e = document.createElement("div");
      return e.appendChild(document.createElement("li")), {
        skip: e
      };
    }
    if (e.parentNode.lastChild == e || sV && /^(tr|table)$/i.test(e.parentNode.nodeName)) return {
      ignore: !0
    };
  } else if ("IMG" == e.nodeName && e.getAttribute("mark-placeholder")) return {
    ignore: !0
  };
  return null;
}
const DP = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function RP(e, t, n, r, o) {
  let i = e.input.compositionPendingChanges || (e.composing ? e.input.compositionID : 0);
  if (e.input.compositionPendingChanges = 0, t < 0) {
    let t = e.input.lastSelectionTime > Date.now() - 50 ? e.input.lastSelectionOrigin : null,
      n = iL(e, t);
    if (n && !e.state.selection.eq(n)) {
      if (aV && fV && 13 === e.input.lastKeyCode && Date.now() - 100 < e.input.lastKeyCodeTime && e.someProp("handleKeyDown", t => t(e, KS(13, "Enter")))) return;
      let r = e.state.tr.setSelection(n);
      "pointer" == t ? r.setMeta("pointer", !0) : "key" == t && r.scrollIntoView(), i && r.setMeta("composition", i), e.dispatch(r);
    }
    return;
  }
  let a = e.state.doc.resolve(t),
    c = a.sharedDepth(n);
  t = a.before(c + 1), n = e.state.doc.resolve(n).after(c + 1);
  let s,
    l,
    u = e.state.selection,
    d = function (e, t, n) {
      let r,
        _e$docView$parseRange = e.docView.parseRange(t, n),
        o = _e$docView$parseRange.node,
        i = _e$docView$parseRange.fromOffset,
        a = _e$docView$parseRange.toOffset,
        c = _e$docView$parseRange.from,
        s = _e$docView$parseRange.to,
        l = e.domSelectionRange(),
        u = l.anchorNode;
      if (u && e.dom.contains(1 == u.nodeType ? u : u.parentNode) && (r = [{
        node: u,
        offset: l.anchorOffset
      }], US(l) || r.push({
        node: l.focusNode,
        offset: l.focusOffset
      })), aV && 8 === e.input.lastKeyCode) for (let e = a; e > i; e--) {
        let t = o.childNodes[e - 1],
          n = t.pmViewDesc;
        if ("BR" == t.nodeName && !n) {
          a = e;
          break;
        }
        if (!n || n.size) break;
      }
      let d = e.state.doc,
        f = e.someProp("domParser") || AN.fromSchema(e.state.schema),
        p = d.resolve(c),
        m = null,
        h = f.parse(o, {
          topNode: p.parent,
          topMatch: p.parent.contentMatchAt(p.index()),
          topOpen: !0,
          from: i,
          to: a,
          preserveWhitespace: "pre" != p.parent.type.whitespace || "full",
          findPositions: r,
          ruleFromNode: TP,
          context: p
        });
      if (r && null != r[0].pos) {
        let e = r[0].pos,
          t = r[1] && r[1].pos;
        null == t && (t = e), m = {
          anchor: e + c,
          head: t + c
        };
      }
      return {
        doc: h,
        sel: m,
        from: c,
        to: s
      };
    }(e, t, n),
    f = e.state.doc,
    p = f.slice(d.from, d.to);
  8 === e.input.lastKeyCode && Date.now() - 100 < e.input.lastKeyCodeTime ? (s = e.state.selection.to, l = "end") : (s = e.state.selection.from, l = "start"), e.input.lastKeyCode = null;
  let m = function (e, t, n, r, o) {
    let i = e.findDiffStart(t, n);
    if (null == i) return null;
    let _e$findDiffEnd = e.findDiffEnd(t, n + e.size, n + t.size),
      a = _e$findDiffEnd.a,
      c = _e$findDiffEnd.b;
    if ("end" == o) {
      r -= a + Math.max(0, i - Math.min(a, c)) - i;
    }
    if (a < i && e.size < t.size) {
      let e = r <= i && r >= a ? i - r : 0;
      i -= e, i && i < t.size && jP(t.textBetween(i - 1, i + 1)) && (i += e ? 1 : -1), c = i + (c - a), a = i;
    } else if (c < i) {
      let t = r <= i && r >= c ? i - r : 0;
      i -= t, i && i < e.size && jP(e.textBetween(i - 1, i + 1)) && (i += t ? 1 : -1), a = i + (a - c), c = i;
    }
    return {
      start: i,
      endA: a,
      endB: c
    };
  }(p.content, d.doc.content, d.from, s, l);
  if ((lV && e.input.lastIOSEnter > Date.now() - 225 || fV) && o.some(e => 1 == e.nodeType && !DP.test(e.nodeName)) && (!m || m.endA >= m.endB) && e.someProp("handleKeyDown", t => t(e, KS(13, "Enter")))) return void (e.input.lastIOSEnter = 0);
  if (!m) {
    if (!(r && u instanceof bS && !u.empty && u.$head.sameParent(u.$anchor)) || e.composing || d.sel && d.sel.anchor != d.sel.head) {
      if (d.sel) {
        let t = GP(e, e.state.doc, d.sel);
        if (t && !t.eq(e.state.selection)) {
          let n = e.state.tr.setSelection(t);
          i && n.setMeta("composition", i), e.dispatch(n);
        }
      }
      return;
    }
    m = {
      start: u.from,
      endA: u.to,
      endB: u.to
    };
  }
  if (aV && e.cursorWrapper && d.sel && d.sel.anchor == e.cursorWrapper.deco.from && d.sel.head == d.sel.anchor) {
    let e = m.endB - m.start;
    d.sel = {
      anchor: d.sel.anchor + e,
      head: d.sel.anchor + e
    };
  }
  e.input.domChangeCount++, e.state.selection.from < e.state.selection.to && m.start == m.endB && e.state.selection instanceof bS && (m.start > e.state.selection.from && m.start <= e.state.selection.from + 2 && e.state.selection.from >= d.from ? m.start = e.state.selection.from : m.endA < e.state.selection.to && m.endA >= e.state.selection.to - 2 && e.state.selection.to <= d.to && (m.endB += e.state.selection.to - m.endA, m.endA = e.state.selection.to)), nV && rV <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > d.from && "  " == d.doc.textBetween(m.start - d.from - 1, m.start - d.from + 1) && (m.start--, m.endA--, m.endB--);
  let h,
    A = d.doc.resolveNoCache(m.start - d.from),
    g = d.doc.resolveNoCache(m.endB - d.from),
    v = f.resolve(m.start),
    C = A.sameParent(g) && A.parent.inlineContent && v.end() >= m.endA;
  if ((lV && e.input.lastIOSEnter > Date.now() - 225 && (!C || o.some(e => "DIV" == e.nodeName || "P" == e.nodeName)) || !C && A.pos < d.doc.content.size && !A.sameParent(g) && (h = AS.findFrom(d.doc.resolve(A.pos + 1), 1, !0)) && h.head == g.pos) && e.someProp("handleKeyDown", t => t(e, KS(13, "Enter")))) return void (e.input.lastIOSEnter = 0);
  if (e.state.selection.anchor > m.start && function (e, t, n, r, o) {
    if (!r.parent.isTextblock || n - t <= o.pos - r.pos || FP(r, !0, !1) < o.pos) return !1;
    let i = e.resolve(t);
    if (i.parentOffset < i.parent.content.size || !i.parent.isTextblock) return !1;
    let a = e.resolve(FP(i, !0, !0));
    return !(!a.parent.isTextblock || a.pos > n || FP(a, !0, !1) < n) && r.parent.content.cut(r.parentOffset).eq(a.parent.content);
  }(f, m.start, m.endA, A, g) && e.someProp("handleKeyDown", t => t(e, KS(8, "Backspace")))) return void (fV && aV && e.domObserver.suppressSelectionUpdates());
  aV && fV && m.endB == m.start && (e.input.lastAndroidDelete = Date.now()), fV && !C && A.start() != g.start() && 0 == g.parentOffset && A.depth == g.depth && d.sel && d.sel.anchor == d.sel.head && d.sel.head == m.endA && (m.endB -= 2, g = d.doc.resolveNoCache(m.endB - d.from), setTimeout(() => {
    e.someProp("handleKeyDown", function (t) {
      return t(e, KS(13, "Enter"));
    });
  }, 20));
  let b,
    E,
    y,
    I = m.start,
    B = m.endA;
  if (C) if (A.pos == g.pos) nV && rV <= 11 && 0 == A.parentOffset && (e.domObserver.suppressSelectionUpdates(), setTimeout(() => cL(e), 20)), b = e.state.tr.delete(I, B), E = f.resolve(m.start).marksAcross(f.resolve(m.endA));else if (m.endA == m.endB && (y = function (e, t) {
    let n,
      r,
      o,
      i = e.firstChild.marks,
      a = t.firstChild.marks,
      c = i,
      s = a;
    for (let e = 0; e < a.length; e++) c = a[e].removeFromSet(c);
    for (let e = 0; e < i.length; e++) s = i[e].removeFromSet(s);
    if (1 == c.length && 0 == s.length) r = c[0], n = "add", o = e => e.mark(r.addToSet(e.marks));else {
      if (0 != c.length || 1 != s.length) return null;
      r = s[0], n = "remove", o = e => e.mark(r.removeFromSet(e.marks));
    }
    let l = [];
    for (let e = 0; e < t.childCount; e++) l.push(o(t.child(e)));
    if (wk.from(l).eq(e)) return {
      mark: r,
      type: n
    };
  }(A.parent.content.cut(A.parentOffset, g.parentOffset), v.parent.content.cut(v.parentOffset, m.endA - v.start())))) b = e.state.tr, "add" == y.type ? b.addMark(I, B, y.mark) : b.removeMark(I, B, y.mark);else if (A.parent.child(A.index()).isText && A.index() == g.index() - (g.textOffset ? 0 : 1)) {
    let t = A.parent.textBetween(A.parentOffset, g.parentOffset);
    if (e.someProp("handleTextInput", n => n(e, I, B, t))) return;
    b = e.state.tr.insertText(t, I, B);
  }
  if (b || (b = e.state.tr.replace(I, B, d.doc.slice(m.start - d.from, m.endB - d.from))), d.sel) {
    let t = GP(e, b.doc, d.sel);
    t && !(aV && fV && e.composing && t.empty && (m.start != m.endB || e.input.lastAndroidDelete < Date.now() - 100) && (t.head == I || t.head == b.mapping.map(B) - 1) || nV && t.empty && t.head == I) && b.setSelection(t);
  }
  E && b.ensureMarks(E), i && b.setMeta("composition", i), e.dispatch(b.scrollIntoView());
}
function GP(e, t, n) {
  return Math.max(n.anchor, n.head) > t.content.size ? null : mL(e, t.resolve(n.anchor), t.resolve(n.head));
}
function FP(e, t, n) {
  let r = e.depth,
    o = t ? e.end() : e.pos;
  for (; r > 0 && (t || e.indexAfter(r) == e.node(r).childCount);) r--, o++, t = !1;
  if (n) {
    let t = e.node(r).maybeChild(e.indexAfter(r));
    for (; t && !t.isLeaf;) t = t.firstChild, o++;
  }
  return o;
}
function jP(e) {
  if (2 != e.length) return !1;
  let t = e.charCodeAt(0),
    n = e.charCodeAt(1);
  return t >= 56320 && t <= 57343 && n >= 55296 && n <= 56319;
}
class JP {
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new JL(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(KP), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : "function" == typeof e ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = XP(this), WP(this), this.nodeViews = UP(this), this.docView = jV(this.state.doc, ZP(this), kP(this), this.dom, this), this.domObserver = new LP(this, (e, t, n, r) => RP(this, e, t, n, r)), this.domObserver.start(), function (e) {
      for (let t in GL) {
        let n = GL[t];
        e.dom.addEventListener(t, e.input.eventHandlers[t] = t => {
          !UL(e, t) || XL(e, t) || !e.editable && t.type in FL || n(e, t);
        }, jL[t] ? {
          passive: !0
        } : void 0);
      }
      sV && e.dom.addEventListener("input", () => null), WL(e);
    }(this), this.updatePluginViews();
  }
  get composing() {
    return this.input.composing;
  }
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e) this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && WL(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(KP), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  setProps(e) {
    let t = {};
    for (let e in this._props) t[e] = this._props[e];
    t.state = this.state;
    for (let n in e) t[n] = e[n];
    this.update(t);
  }
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var n;
    let r = this.state,
      o = !1,
      i = !1;
    e.storedMarks && this.composing && (cP(this), i = !0), this.state = e;
    let a = r.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let e = UP(this);
      (function (e, t) {
        let n = 0,
          r = 0;
        for (let r in e) {
          if (e[r] != t[r]) return !0;
          n++;
        }
        for (let e in t) r++;
        return n != r;
      })(e, this.nodeViews) && (this.nodeViews = e, o = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && WL(this), this.editable = XP(this), WP(this);
    let c = kP(this),
      s = ZP(this),
      l = r.plugins == e.plugins || r.doc.eq(e.doc) ? e.scrollToSelection > r.scrollToSelection ? "to selection" : "preserve" : "reset",
      u = o || !this.docView.matchesNode(e.doc, s, c);
    !u && e.selection.eq(r.selection) || (i = !0);
    let d = "preserve" == l && i && null == this.dom.style.overflowAnchor && function (e) {
      let t,
        n,
        r = e.dom.getBoundingClientRect(),
        o = Math.max(0, r.top);
      for (let i = (r.left + r.right) / 2, a = o + 1; a < Math.min(innerHeight, r.bottom); a += 5) {
        let r = e.root.elementFromPoint(i, a);
        if (!r || r == e.dom || !e.dom.contains(r)) continue;
        let c = r.getBoundingClientRect();
        if (c.top >= o - 20) {
          t = r, n = c.top;
          break;
        }
      }
      return {
        refDOM: t,
        refTop: n,
        stack: CV(e.dom)
      };
    }(this);
    if (i) {
      this.domObserver.stop();
      let t = u && (nV || aV) && !this.composing && !r.selection.empty && !e.selection.empty && function (e, t) {
        let n = Math.min(e.$anchor.sharedDepth(e.head), t.$anchor.sharedDepth(t.head));
        return e.$anchor.start(n) != t.$anchor.start(n);
      }(r.selection, e.selection);
      if (u) {
        let n = aV ? this.trackWrites = this.domSelectionRange().focusNode : null;
        !o && this.docView.update(e.doc, s, c, this) || (this.docView.updateOuterDeco([]), this.docView.destroy(), this.docView = jV(e.doc, s, c, this.dom, this)), n && !this.trackWrites && (t = !0);
      }
      t || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && function (e) {
        let t = e.docView.domFromPos(e.state.selection.anchor, 0),
          n = e.domSelectionRange();
        return jS(t.node, t.offset, n.anchorNode, n.anchorOffset);
      }(this)) ? cL(this, t) : (fL(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(r), (null === (n = this.dragging) || void 0 === n ? void 0 : n.node) && !r.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, r), "reset" == l ? this.dom.scrollTop = 0 : "to selection" == l ? this.scrollToSelection() : d && function (_ref5) {
      let e = _ref5.refDOM,
        t = _ref5.refTop,
        n = _ref5.stack;
      let r = e ? e.getBoundingClientRect().top : 0;
      bV(n, 0 == r ? 0 : r - t);
    }(d);
  }
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (this.someProp("handleScrollToSelection", e => e(this))) ;else if (this.state.selection instanceof yS) {
      let t = this.docView.domAfterPos(this.state.selection.from);
      1 == t.nodeType && vV(this, t.getBoundingClientRect(), e);
    } else vV(this, this.coordsAtPos(this.state.selection.head, 1), e);
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop();) e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (e && e.plugins == this.state.plugins && this.directPlugins == this.prevDirectPlugins) for (let t = 0; t < this.pluginViews.length; t++) {
      let n = this.pluginViews[t];
      n.update && n.update(this, e);
    } else {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let e = 0; e < this.directPlugins.length; e++) {
        let t = this.directPlugins[e];
        t.spec.view && this.pluginViews.push(t.spec.view(this));
      }
      for (let e = 0; e < this.state.plugins.length; e++) {
        let t = this.state.plugins[e];
        t.spec.view && this.pluginViews.push(t.spec.view(this));
      }
    }
  }
  updateDraggedNode(e, t) {
    let n = e.node,
      r = -1;
    if (this.state.doc.nodeAt(n.from) == n.node) r = n.from;else {
      let e = n.from + (this.state.doc.content.size - t.doc.content.size);
      (e > 0 && this.state.doc.nodeAt(e)) == n.node && (r = e);
    }
    this.dragging = new fP(e.slice, e.move, r < 0 ? void 0 : yS.create(this.state.doc, r));
  }
  someProp(e, t) {
    let n,
      r = this._props && this._props[e];
    if (null != r && (n = t ? t(r) : r)) return n;
    for (let r = 0; r < this.directPlugins.length; r++) {
      let o = this.directPlugins[r].props[e];
      if (null != o && (n = t ? t(o) : o)) return n;
    }
    let o = this.state.plugins;
    if (o) for (let r = 0; r < o.length; r++) {
      let i = o[r].props[e];
      if (null != i && (n = t ? t(i) : i)) return n;
    }
  }
  hasFocus() {
    if (nV) {
      let e = this.root.activeElement;
      if (e == this.dom) return !0;
      if (!e || !this.dom.contains(e)) return !1;
      for (; e && this.dom != e && this.dom.contains(e);) {
        if ("false" == e.contentEditable) return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  focus() {
    this.domObserver.stop(), this.editable && function (e) {
      if (e.setActive) return e.setActive();
      if (EV) return e.focus(EV);
      let t = CV(e);
      e.focus(null == EV ? {
        get preventScroll() {
          return EV = {
            preventScroll: !0
          }, !0;
        }
      } : void 0), EV || (EV = !1, bV(t, 0));
    }(this.dom), cL(this), this.domObserver.start();
  }
  get root() {
    let e = this._root;
    if (null == e) for (let e = this.dom.parentNode; e; e = e.parentNode) if (9 == e.nodeType || 11 == e.nodeType && e.host) return e.getSelection || (Object.getPrototypeOf(e).getSelection = () => e.ownerDocument.getSelection()), this._root = e;
    return e || document;
  }
  updateRoot() {
    this._root = null;
  }
  posAtCoords(e) {
    return xV(this, e);
  }
  coordsAtPos(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return zV(this, e, t);
  }
  domAtPos(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return this.docView.domFromPos(e, t);
  }
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  posAtDOM(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
    let r = this.docView.posFromDOM(e, t, n);
    if (null == r) throw new RangeError("DOM position not inside the editor");
    return r;
  }
  endOfTextblock(e, t) {
    return OV(this, t || this.state, e);
  }
  pasteHTML(e, t) {
    return uP(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  pasteText(e, t) {
    return uP(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  destroy() {
    this.docView && (!function (e) {
      e.domObserver.stop();
      for (let t in e.input.eventHandlers) e.dom.removeEventListener(t, e.input.eventHandlers[t]);
      clearTimeout(e.input.composingTimeout), clearTimeout(e.input.lastIOSEnterFallbackTimeout);
    }(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], kP(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null);
  }
  get isDestroyed() {
    return null == this.docView;
  }
  dispatchEvent(e) {
    return function (e, t) {
      XL(e, t) || !GL[t.type] || !e.editable && t.type in FL || GL[t.type](e, t);
    }(this, e);
  }
  dispatch(e) {
    let t = this._props.dispatchTransaction;
    t ? t.call(this, e) : this.updateState(this.state.apply(e));
  }
  domSelectionRange() {
    return sV && 11 === this.root.nodeType && function (e) {
      let t = e.activeElement;
      for (; t && t.shadowRoot;) t = t.shadowRoot.activeElement;
      return t;
    }(this.dom.ownerDocument) == this.dom ? function (e) {
      var _ref6;
      let t;
      function n(e) {
        e.preventDefault(), e.stopImmediatePropagation(), t = e.getTargetRanges()[0];
      }
      e.dom.addEventListener("beforeinput", n, !0), document.execCommand("indent"), e.dom.removeEventListener("beforeinput", n, !0);
      let r = t.startContainer,
        o = t.startOffset,
        i = t.endContainer,
        a = t.endOffset,
        c = e.domAtPos(e.state.selection.anchor);
      return jS(c.node, c.offset, i, a) && (_ref6 = [i, a, r, o], r = _ref6[0], o = _ref6[1], i = _ref6[2], a = _ref6[3], _ref6), {
        anchorNode: r,
        anchorOffset: o,
        focusNode: i,
        focusOffset: a
      };
    }(this) : this.domSelection();
  }
  domSelection() {
    return this.root.getSelection();
  }
}
function ZP(e) {
  let t = Object.create(null);
  return t.class = "ProseMirror", t.contenteditable = String(e.editable), e.someProp("attributes", n => {
    if ("function" == typeof n && (n = n(e.state)), n) for (let e in n) "class" == e ? t.class += " " + n[e] : "style" == e ? t.style = (t.style ? t.style + ";" : "") + n[e] : t[e] || "contenteditable" == e || "nodeName" == e || (t[e] = String(n[e]));
  }), t.translate || (t.translate = "no"), [vP.node(0, e.state.doc.content.size, t)];
}
function WP(e) {
  if (e.markCursor) {
    let t = document.createElement("img");
    t.className = "ProseMirror-separator", t.setAttribute("mark-placeholder", "true"), t.setAttribute("alt", ""), e.cursorWrapper = {
      dom: t,
      deco: vP.widget(e.state.selection.head, t, {
        raw: !0,
        marks: e.markCursor
      })
    };
  } else e.cursorWrapper = null;
}
function XP(e) {
  return !e.someProp("editable", t => !1 === t(e.state));
}
function UP(e) {
  let t = Object.create(null);
  function n(e) {
    for (let n in e) Object.prototype.hasOwnProperty.call(t, n) || (t[n] = e[n]);
  }
  return e.someProp("nodeViews", n), e.someProp("markViews", n), t;
}
function KP(e) {
  if (e.spec.state || e.spec.filterTransaction || e.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}
for (var YP = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
  }, qP = {
    48: ")",
    49: "!",
    50: "@",
    51: "#",
    52: "$",
    53: "%",
    54: "^",
    55: "&",
    56: "*",
    57: "(",
    59: ":",
    61: "+",
    173: "_",
    186: ":",
    187: "+",
    188: "<",
    189: "_",
    190: ">",
    191: "?",
    192: "~",
    219: "{",
    220: "|",
    221: "}",
    222: '"'
  }, _P = "undefined" != typeof navigator && /Mac/.test(navigator.platform), $P = "undefined" != typeof navigator && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent), eO = 0; eO < 10; eO++) YP[48 + eO] = YP[96 + eO] = String(eO);
for (eO = 1; eO <= 24; eO++) YP[eO + 111] = "F" + eO;
for (eO = 65; eO <= 90; eO++) YP[eO] = String.fromCharCode(eO + 32), qP[eO] = String.fromCharCode(eO);
for (var tO in YP) qP.hasOwnProperty(tO) || (qP[tO] = YP[tO]);
const nO = "undefined" != typeof navigator && /Mac|iP(hone|[oa]d)/.test(navigator.platform);
function rO(e) {
  let t,
    n,
    r,
    o,
    i = e.split(/-(?!$)/),
    a = i[i.length - 1];
  "Space" == a && (a = " ");
  for (let e = 0; e < i.length - 1; e++) {
    let a = i[e];
    if (/^(cmd|meta|m)$/i.test(a)) o = !0;else if (/^a(lt)?$/i.test(a)) t = !0;else if (/^(c|ctrl|control)$/i.test(a)) n = !0;else if (/^s(hift)?$/i.test(a)) r = !0;else {
      if (!/^mod$/i.test(a)) throw new Error("Unrecognized modifier name: " + a);
      nO ? o = !0 : n = !0;
    }
  }
  return t && (a = "Alt-" + a), n && (a = "Ctrl-" + a), o && (a = "Meta-" + a), r && (a = "Shift-" + a), a;
}
function oO(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n && t.shiftKey && (e = "Shift-" + e), e;
}
function iO(e) {
  let t = function (e) {
    let t = Object.create(null);
    for (let n in e) t[rO(n)] = e[n];
    return t;
  }(e);
  return function (e, n) {
    let r,
      o = function (e) {
        var t = !(_P && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || $P && e.shiftKey && e.key && 1 == e.key.length || "Unidentified" == e.key) && e.key || (e.shiftKey ? qP : YP)[e.keyCode] || e.key || "Unidentified";
        return "Esc" == t && (t = "Escape"), "Del" == t && (t = "Delete"), "Left" == t && (t = "ArrowLeft"), "Up" == t && (t = "ArrowUp"), "Right" == t && (t = "ArrowRight"), "Down" == t && (t = "ArrowDown"), t;
      }(n),
      i = t[oO(o, n)];
    if (i && i(e.state, e.dispatch, e)) return !0;
    if (1 == o.length && " " != o) {
      if (n.shiftKey) {
        let r = t[oO(o, n, !1)];
        if (r && r(e.state, e.dispatch, e)) return !0;
      }
      if ((n.shiftKey || n.altKey || n.metaKey || o.charCodeAt(0) > 127) && (r = YP[n.keyCode]) && r != o) {
        let o = t[oO(r, n)];
        if (o && o(e.state, e.dispatch, e)) return !0;
      }
    }
    return !1;
  };
}
const aO = (e, t) => !e.selection.empty && (t && t(e.tr.deleteSelection().scrollIntoView()), !0);
const cO = (e, t, n) => {
  let r = function (e, t) {
    let n = e.selection.$cursor;
    return !n || (t ? !t.endOfTextblock("backward", e) : n.parentOffset > 0) ? null : n;
  }(e, n);
  if (!r) return !1;
  let o = uO(r);
  if (!o) {
    let n = r.blockRange(),
      o = n && XN(n);
    return null != o && (t && t(e.tr.lift(n, o).scrollIntoView()), !0);
  }
  let i = o.nodeBefore;
  if (!i.type.spec.isolating && EO(e, o, t)) return !0;
  if (0 == r.parent.content.size && (sO(i, "end") || yS.isSelectable(i))) {
    let n = tS(e.doc, r.before(), r.after(), Nk.empty);
    if (n && n.slice.size < n.to - n.from) {
      if (t) {
        let r = e.tr.step(n);
        r.setSelection(sO(i, "end") ? AS.findFrom(r.doc.resolve(r.mapping.map(o.pos, -1)), -1) : yS.create(r.doc, o.pos - i.nodeSize)), t(r.scrollIntoView());
      }
      return !0;
    }
  }
  return !(!i.isAtom || o.depth != r.depth - 1) && (t && t(e.tr.delete(o.pos - i.nodeSize, o.pos).scrollIntoView()), !0);
};
function sO(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
  for (let r = e; r; r = "start" == t ? r.firstChild : r.lastChild) {
    if (r.isTextblock) return !0;
    if (n && 1 != r.childCount) return !1;
  }
  return !1;
}
const lO = (e, t, n) => {
  let _e$selection2 = e.selection,
    r = _e$selection2.$head,
    o = _e$selection2.empty,
    i = r;
  if (!o) return !1;
  if (r.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", e) : r.parentOffset > 0) return !1;
    i = uO(r);
  }
  let a = i && i.nodeBefore;
  return !(!a || !yS.isSelectable(a)) && (t && t(e.tr.setSelection(yS.create(e.doc, i.pos - a.nodeSize)).scrollIntoView()), !0);
};
function uO(e) {
  if (!e.parent.type.spec.isolating) for (let t = e.depth - 1; t >= 0; t--) {
    if (e.index(t) > 0) return e.doc.resolve(e.before(t + 1));
    if (e.node(t).type.spec.isolating) break;
  }
  return null;
}
const dO = (e, t, n) => {
    let r = function (e, t) {
      let n = e.selection.$cursor;
      return !n || (t ? !t.endOfTextblock("forward", e) : n.parentOffset < n.parent.content.size) ? null : n;
    }(e, n);
    if (!r) return !1;
    let o = pO(r);
    if (!o) return !1;
    let i = o.nodeAfter;
    if (EO(e, o, t)) return !0;
    if (0 == r.parent.content.size && (sO(i, "start") || yS.isSelectable(i))) {
      let n = tS(e.doc, r.before(), r.after(), Nk.empty);
      if (n && n.slice.size < n.to - n.from) {
        if (t) {
          let r = e.tr.step(n);
          r.setSelection(sO(i, "start") ? AS.findFrom(r.doc.resolve(r.mapping.map(o.pos)), 1) : yS.create(r.doc, r.mapping.map(o.pos))), t(r.scrollIntoView());
        }
        return !0;
      }
    }
    return !(!i.isAtom || o.depth != r.depth - 1) && (t && t(e.tr.delete(o.pos, o.pos + i.nodeSize).scrollIntoView()), !0);
  },
  fO = (e, t, n) => {
    let _e$selection3 = e.selection,
      r = _e$selection3.$head,
      o = _e$selection3.empty,
      i = r;
    if (!o) return !1;
    if (r.parent.isTextblock) {
      if (n ? !n.endOfTextblock("forward", e) : r.parentOffset < r.parent.content.size) return !1;
      i = pO(r);
    }
    let a = i && i.nodeAfter;
    return !(!a || !yS.isSelectable(a)) && (t && t(e.tr.setSelection(yS.create(e.doc, i.pos)).scrollIntoView()), !0);
  };
function pO(e) {
  if (!e.parent.type.spec.isolating) for (let t = e.depth - 1; t >= 0; t--) {
    let n = e.node(t);
    if (e.index(t) + 1 < n.childCount) return e.doc.resolve(e.after(t + 1));
    if (n.type.spec.isolating) break;
  }
  return null;
}
const mO = (e, t) => {
  let _e$selection4 = e.selection,
    n = _e$selection4.$head,
    r = _e$selection4.$anchor;
  return !(!n.parent.type.spec.code || !n.sameParent(r)) && (t && t(e.tr.insertText("\n").scrollIntoView()), !0);
};
function hO(e) {
  for (let t = 0; t < e.edgeCount; t++) {
    let _e$edge2 = e.edge(t),
      n = _e$edge2.type;
    if (n.isTextblock && !n.hasRequiredAttrs()) return n;
  }
  return null;
}
const AO = (e, t) => {
    let _e$selection5 = e.selection,
      n = _e$selection5.$head,
      r = _e$selection5.$anchor;
    if (!n.parent.type.spec.code || !n.sameParent(r)) return !1;
    let o = n.node(-1),
      i = n.indexAfter(-1),
      a = hO(o.contentMatchAt(i));
    if (!a || !o.canReplaceWith(i, i, a)) return !1;
    if (t) {
      let r = n.after(),
        o = e.tr.replaceWith(r, r, a.createAndFill());
      o.setSelection(AS.near(o.doc.resolve(r), 1)), t(o.scrollIntoView());
    }
    return !0;
  },
  gO = (e, t) => {
    let n = e.selection,
      r = n.$from,
      o = n.$to;
    if (n instanceof BS || r.parent.inlineContent || o.parent.inlineContent) return !1;
    let i = hO(o.parent.contentMatchAt(o.indexAfter()));
    if (!i || !i.isTextblock) return !1;
    if (t) {
      let n = (!r.parentOffset && o.index() < o.parent.childCount ? r : o).pos,
        a = e.tr.insert(n, i.createAndFill());
      a.setSelection(bS.create(a.doc, n + 1)), t(a.scrollIntoView());
    }
    return !0;
  },
  vO = (e, t) => {
    let n = e.selection.$cursor;
    if (!n || n.parent.content.size) return !1;
    if (n.depth > 1 && n.after() != n.end(-1)) {
      let r = n.before();
      if (YN(e.doc, r)) return t && t(e.tr.split(r).scrollIntoView()), !0;
    }
    let r = n.blockRange(),
      o = r && XN(r);
    return null != o && (t && t(e.tr.lift(r, o).scrollIntoView()), !0);
  };
const CO = (e, t) => {
  let _e$selection6 = e.selection,
    n = _e$selection6.$from,
    r = _e$selection6.$to;
  if (e.selection instanceof yS && e.selection.node.isBlock) return !(!n.parentOffset || !YN(e.doc, n.pos) || (t && t(e.tr.split(n.pos).scrollIntoView()), 0));
  if (!n.parent.isBlock) return !1;
  if (t) {
    let o = r.parentOffset == r.parent.content.size,
      i = e.tr;
    (e.selection instanceof bS || e.selection instanceof BS) && i.deleteSelection();
    let a = 0 == n.depth ? null : hO(n.node(-1).contentMatchAt(n.indexAfter(-1))),
      c = bO && bO(r.parent, o),
      s = c ? [c] : o && a ? [{
        type: a
      }] : void 0,
      l = YN(i.doc, i.mapping.map(n.pos), 1, s);
    if (s || l || !YN(i.doc, i.mapping.map(n.pos), 1, a ? [{
      type: a
    }] : void 0) || (a && (s = [{
      type: a
    }]), l = !0), l && (i.split(i.mapping.map(n.pos), 1, s), !o && !n.parentOffset && n.parent.type != a)) {
      let e = i.mapping.map(n.before()),
        t = i.doc.resolve(e);
      a && n.node(-1).canReplaceWith(t.index(), t.index() + 1, a) && i.setNodeMarkup(i.mapping.map(n.before()), a);
    }
    t(i.scrollIntoView());
  }
  return !0;
};
var bO;
function EO(e, t, n) {
  let r,
    o,
    i = t.nodeBefore,
    a = t.nodeAfter;
  if (i.type.spec.isolating || a.type.spec.isolating) return !1;
  if (function (e, t, n) {
    let r = t.nodeBefore,
      o = t.nodeAfter,
      i = t.index();
    return !(!(r && o && r.type.compatibleContent(o.type)) || (!r.content.size && t.parent.canReplace(i - 1, i) ? (n && n(e.tr.delete(t.pos - r.nodeSize, t.pos).scrollIntoView()), 0) : !t.parent.canReplace(i, i + 1) || !o.isTextblock && !qN(e.doc, t.pos) || (n && n(e.tr.clearIncompatible(t.pos, r.type, r.contentMatchAt(r.childCount)).join(t.pos).scrollIntoView()), 0)));
  }(e, t, n)) return !0;
  let c = t.parent.canReplace(t.index(), t.index() + 1);
  if (c && (r = (o = i.contentMatchAt(i.childCount)).findWrapping(a.type)) && o.matchType(r[0] || a.type).validEnd) {
    if (n) {
      let o = t.pos + a.nodeSize,
        c = wk.empty;
      for (let e = r.length - 1; e >= 0; e--) c = wk.from(r[e].create(null, c));
      c = wk.from(i.copy(c));
      let s = e.tr.step(new JN(t.pos - 1, o, t.pos, o, new Nk(c, 1, 0), r.length, !0)),
        l = o + 2 * r.length;
      qN(s.doc, l) && s.join(l), n(s.scrollIntoView());
    }
    return !0;
  }
  let s = AS.findFrom(t, 1),
    l = s && s.$from.blockRange(s.$to),
    u = l && XN(l);
  if (null != u && u >= t.depth) return n && n(e.tr.lift(l, u).scrollIntoView()), !0;
  if (c && sO(a, "start", !0) && sO(i, "end")) {
    let r = i,
      o = [];
    for (; o.push(r), !r.isTextblock;) r = r.lastChild;
    let c = a,
      s = 1;
    for (; !c.isTextblock; c = c.firstChild) s++;
    if (r.canReplace(r.childCount, r.childCount, c.content)) {
      if (n) {
        let r = wk.empty;
        for (let e = o.length - 1; e >= 0; e--) r = wk.from(o[e].copy(r));
        n(e.tr.step(new JN(t.pos - o.length, t.pos + a.nodeSize, t.pos + s, t.pos + a.nodeSize - s, new Nk(r, o.length, 0), 0, !0)).scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function yO(e) {
  return function (t, n) {
    let r = t.selection,
      o = e < 0 ? r.$from : r.$to,
      i = o.depth;
    for (; o.node(i).isInline;) {
      if (!i) return !1;
      i--;
    }
    return !!o.node(i).isTextblock && (n && n(t.tr.setSelection(bS.create(t.doc, e < 0 ? o.start(i) : o.end(i)))), !0);
  };
}
const IO = yO(-1),
  BO = yO(1);
function xO(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (n, r) {
    let o = !1;
    for (let r = 0; r < n.selection.ranges.length && !o; r++) {
      let _n$selection$ranges$r = n.selection.ranges[r],
        i = _n$selection$ranges$r.$from.pos,
        a = _n$selection$ranges$r.$to.pos;
      n.doc.nodesBetween(i, a, (r, i) => {
        if (o) return !1;
        if (r.isTextblock && !r.hasMarkup(e, t)) if (r.type == e) o = !0;else {
          let t = n.doc.resolve(i),
            r = t.index();
          o = t.parent.canReplaceWith(r, r + 1, e);
        }
      });
    }
    if (!o) return !1;
    if (r) {
      let o = n.tr;
      for (let r = 0; r < n.selection.ranges.length; r++) {
        let _n$selection$ranges$r2 = n.selection.ranges[r],
          i = _n$selection$ranges$r2.$from.pos,
          a = _n$selection$ranges$r2.$to.pos;
        o.setBlockType(i, a, e, t);
      }
      r(o.scrollIntoView());
    }
    return !0;
  };
}
function wO() {
  for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
    e[_key] = arguments[_key];
  }
  return function (t, n, r) {
    for (let o = 0; o < e.length; o++) if (e[o](t, n, r)) return !0;
    return !1;
  };
}
let QO = wO(aO, cO, lO),
  HO = wO(aO, dO, fO);
const zO = {
    Enter: wO(mO, gO, vO, CO),
    "Mod-Enter": AO,
    Backspace: QO,
    "Mod-Backspace": QO,
    "Shift-Backspace": QO,
    Delete: HO,
    "Mod-Delete": HO,
    "Mod-a": (e, t) => (t && t(e.tr.setSelection(new BS(e.doc))), !0)
  },
  MO = {
    "Ctrl-h": zO.Backspace,
    "Alt-Backspace": zO["Mod-Backspace"],
    "Ctrl-d": zO.Delete,
    "Ctrl-Alt-Backspace": zO["Mod-Delete"],
    "Alt-Delete": zO["Mod-Delete"],
    "Alt-d": zO["Mod-Delete"],
    "Ctrl-a": IO,
    "Ctrl-e": BO
  };
for (let e in zO) MO[e] = zO[e];
function kO(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function (n, r) {
    let _n$selection = n.selection,
      o = _n$selection.$from,
      i = _n$selection.$to,
      a = o.blockRange(i),
      c = !1,
      s = a;
    if (!a) return !1;
    if (a.depth >= 2 && o.node(a.depth - 1).type.compatibleContent(e) && 0 == a.startIndex) {
      if (0 == o.index(a.depth - 1)) return !1;
      let e = n.doc.resolve(a.start - 2);
      s = new Uk(e, e, a.depth), a.endIndex < a.parent.childCount && (a = new Uk(o, n.doc.resolve(i.end(a.depth)), a.depth)), c = !0;
    }
    let l = UN(s, e, t, a);
    return !!l && (r && r(function (e, t, n, r, o) {
      let i = wk.empty;
      for (let e = n.length - 1; e >= 0; e--) i = wk.from(n[e].type.create(n[e].attrs, i));
      e.step(new JN(t.start - (r ? 2 : 0), t.end, t.start, t.end, new Nk(i, 0, 0), n.length, !0));
      let a = 0;
      for (let e = 0; e < n.length; e++) n[e].type == o && (a = e + 1);
      let c = n.length - a,
        s = t.start + n.length - (r ? 2 : 0),
        l = t.parent;
      for (let n = t.startIndex, r = t.endIndex, o = !0; n < r; n++, o = !1) !o && YN(e.doc, s, c) && (e.split(s, c), s += 2 * c), s += l.child(n).nodeSize;
      return e;
    }(n.tr, a, l, c, e).scrollIntoView()), !0);
  };
}
function NO(e) {
  return function (t, n) {
    let _t$selection = t.selection,
      r = _t$selection.$from,
      o = _t$selection.$to,
      i = r.blockRange(o, t => t.childCount > 0 && t.firstChild.type == e);
    return !!i && (!n || (r.node(i.depth - 1).type == e ? function (e, t, n, r) {
      let o = e.tr,
        i = r.end,
        a = r.$to.end(r.depth);
      i < a && (o.step(new JN(i - 1, a, i, a, new Nk(wk.from(n.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new Uk(o.doc.resolve(r.$from.pos), o.doc.resolve(a), r.depth));
      const c = XN(r);
      if (null == c) return !1;
      o.lift(r, c);
      let s = o.mapping.map(i, -1) - 1;
      qN(o.doc, s) && o.join(s);
      return t(o.scrollIntoView()), !0;
    }(t, n, e, i) : function (e, t, n) {
      let r = e.tr,
        o = n.parent;
      for (let e = n.end, t = n.endIndex - 1, i = n.startIndex; t > i; t--) e -= o.child(t).nodeSize, r.delete(e - 1, e + 1);
      let i = r.doc.resolve(n.start),
        a = i.nodeAfter;
      if (r.mapping.map(n.end) != n.start + i.nodeAfter.nodeSize) return !1;
      let c = 0 == n.startIndex,
        s = n.endIndex == o.childCount,
        l = i.node(-1),
        u = i.index(-1);
      if (!l.canReplace(u + (c ? 0 : 1), u + 1, a.content.append(s ? wk.empty : wk.from(o)))) return !1;
      let d = i.pos,
        f = d + a.nodeSize;
      return r.step(new JN(d - (c ? 1 : 0), f + (s ? 1 : 0), d + 1, f - 1, new Nk((c ? wk.empty : wk.from(o.copy(wk.empty))).append(s ? wk.empty : wk.from(o.copy(wk.empty))), c ? 0 : 1, s ? 0 : 1), c ? 0 : 1)), t(r.scrollIntoView()), !0;
    }(t, n, i)));
  };
}
function SO(e) {
  const t = e.state,
    n = e.transaction;
  let r = n.selection,
    o = n.doc,
    i = n.storedMarks;
  return _objectSpread(_objectSpread({}, t), {}, {
    apply: t.apply.bind(t),
    applyTransaction: t.applyTransaction.bind(t),
    filterTransaction: t.filterTransaction,
    plugins: t.plugins,
    schema: t.schema,
    reconfigure: t.reconfigure.bind(t),
    toJSON: t.toJSON.bind(t),
    get storedMarks() {
      return i;
    },
    get selection() {
      return r;
    },
    get doc() {
      return o;
    },
    get tr() {
      return r = n.selection, o = n.doc, i = n.storedMarks, n;
    }
  });
}
"undefined" != typeof navigator ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : "undefined" != typeof os && os.platform && os.platform();
class VO {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    var _this = this;
    const e = this.rawCommands,
      t = this.editor,
      n = this.state,
      r = t.view,
      o = n.tr,
      i = this.buildProps(o);
    return Object.fromEntries(Object.entries(e).map(_ref7 => {
      let _ref8 = _slicedToArray(_ref7, 2),
        e = _ref8[0],
        t = _ref8[1];
      return [e, function () {
        const n = t(...arguments)(i);
        return o.getMeta("preventDispatch") || _this.hasCustomState || r.dispatch(o), n;
      }];
    }));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e) {
    var _this2 = this;
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    const n = this.rawCommands,
      r = this.editor,
      o = this.state,
      i = r.view,
      a = [],
      c = !!e,
      s = e || o.tr,
      l = _objectSpread(_objectSpread({}, Object.fromEntries(Object.entries(n).map(_ref9 => {
        let _ref10 = _slicedToArray(_ref9, 2),
          e = _ref10[0],
          n = _ref10[1];
        return [e, function () {
          const r = _this2.buildProps(s, t),
            o = n(...arguments)(r);
          return a.push(o), l;
        }];
      }))), {}, {
        run: () => (c || !t || s.getMeta("preventDispatch") || this.hasCustomState || i.dispatch(s), a.every(e => !0 === e))
      });
    return l;
  }
  createCan(e) {
    const t = this.rawCommands,
      n = this.state,
      r = e || n.tr,
      o = this.buildProps(r, false),
      i = Object.fromEntries(Object.entries(t).map(_ref11 => {
        let _ref12 = _slicedToArray(_ref11, 2),
          e = _ref12[0],
          t = _ref12[1];
        return [e, function () {
          return t(...arguments)(_objectSpread(_objectSpread({}, o), {}, {
            dispatch: void 0
          }));
        }];
      }));
    return _objectSpread(_objectSpread({}, i), {}, {
      chain: () => this.createChain(r, false)
    });
  }
  buildProps(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    const n = this.rawCommands,
      r = this.editor,
      o = this.state,
      i = r.view;
    o.storedMarks && e.setStoredMarks(o.storedMarks);
    const a = {
      tr: e,
      editor: r,
      view: i,
      state: SO({
        state: o,
        transaction: e
      }),
      dispatch: t ? () => {} : void 0,
      chain: () => this.createChain(e),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(n).map(_ref13 => {
          let _ref14 = _slicedToArray(_ref13, 2),
            e = _ref14[0],
            t = _ref14[1];
          return [e, function () {
            return t(...arguments)(a);
          }];
        }));
      }
    };
    return a;
  }
}
function LO(e, t, n) {
  if (void 0 === e.config[t] && e.parent) return LO(e.parent, t, n);
  if ("function" == typeof e.config[t]) {
    return e.config[t].bind(_objectSpread(_objectSpread({}, n), {}, {
      parent: e.parent ? LO(e.parent, t, n) : null
    }));
  }
  return e.config[t];
}
function PO(e) {
  return {
    baseExtensions: e.filter(e => "extension" === e.type),
    nodeExtensions: e.filter(e => "node" === e.type),
    markExtensions: e.filter(e => "mark" === e.type)
  };
}
function OO(e) {
  const t = [],
    _PO = PO(e),
    n = _PO.nodeExtensions,
    r = _PO.markExtensions,
    o = [...n, ...r],
    i = {
      default: null,
      rendered: !0,
      renderHTML: null,
      parseHTML: null,
      keepOnSplit: !0,
      isRequired: !1
    };
  return e.forEach(e => {
    const n = LO(e, "addGlobalAttributes", {
      name: e.name,
      options: e.options,
      storage: e.storage
    });
    if (!n) return;
    n().forEach(e => {
      e.types.forEach(n => {
        Object.entries(e.attributes).forEach(_ref15 => {
          let _ref16 = _slicedToArray(_ref15, 2),
            e = _ref16[0],
            r = _ref16[1];
          t.push({
            type: n,
            name: e,
            attribute: _objectSpread(_objectSpread({}, i), r)
          });
        });
      });
    });
  }), o.forEach(e => {
    const n = {
        name: e.name,
        options: e.options,
        storage: e.storage
      },
      r = LO(e, "addAttributes", n);
    if (!r) return;
    const o = r();
    Object.entries(o).forEach(_ref17 => {
      let _ref18 = _slicedToArray(_ref17, 2),
        n = _ref18[0],
        r = _ref18[1];
      const o = _objectSpread(_objectSpread({}, i), r);
      "function" == typeof (null == o ? void 0 : o.default) && (o.default = o.default()), (null == o ? void 0 : o.isRequired) && void 0 === (null == o ? void 0 : o.default) && delete o.default, t.push({
        type: e.name,
        name: n,
        attribute: o
      });
    });
  }), t;
}
function TO(e, t) {
  if ("string" == typeof e) {
    if (!t.nodes[e]) throw Error(`There is no node type named '${e}'. Maybe you forgot to add the extension?`);
    return t.nodes[e];
  }
  return e;
}
function DO() {
  for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    e[_key2] = arguments[_key2];
  }
  return e.filter(e => !!e).reduce((e, t) => {
    const n = _objectSpread({}, e);
    return Object.entries(t).forEach(_ref19 => {
      let _ref20 = _slicedToArray(_ref19, 2),
        e = _ref20[0],
        t = _ref20[1];
      n[e] ? n[e] = "class" === e ? [n[e], t].join(" ") : "style" === e ? [n[e], t].join("; ") : t : n[e] = t;
    }), n;
  }, {});
}
function RO(e, t) {
  return t.filter(e => e.attribute.rendered).map(t => t.attribute.renderHTML ? t.attribute.renderHTML(e.attrs) || {} : {
    [t.name]: e.attrs[t.name]
  }).reduce((e, t) => DO(e, t), {});
}
function GO(e) {
  return "function" == typeof e;
}
function FO(e, t) {
  for (var _len3 = arguments.length, n = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    n[_key3 - 2] = arguments[_key3];
  }
  return GO(e) ? t ? e.bind(t)(...n) : e(...n) : e;
}
function jO(e, t) {
  return e.style ? e : _objectSpread(_objectSpread({}, e), {}, {
    getAttrs: n => {
      const r = e.getAttrs ? e.getAttrs(n) : e.attrs;
      if (!1 === r) return !1;
      const o = t.reduce((e, t) => {
        const r = t.attribute.parseHTML ? t.attribute.parseHTML(n) : function (e) {
          return "string" != typeof e ? e : e.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(e) : "true" === e || "false" !== e && e;
        }(n.getAttribute(t.name));
        return null == r ? e : _objectSpread(_objectSpread({}, e), {}, {
          [t.name]: r
        });
      }, {});
      return _objectSpread(_objectSpread({}, r), o);
    }
  });
}
function JO(e) {
  return Object.fromEntries(Object.entries(e).filter(_ref21 => {
    let _ref22 = _slicedToArray(_ref21, 2),
      e = _ref22[0],
      t = _ref22[1];
    return ("attrs" !== e || !function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return 0 === Object.keys(e).length && e.constructor === Object;
    }(t)) && null != t;
  }));
}
function ZO(e, t) {
  return t.nodes[e] || t.marks[e] || null;
}
function WO(e, t) {
  return Array.isArray(t) ? t.some(t => ("string" == typeof t ? t : t.name) === e.name) : t;
}
function XO(e) {
  return "[object RegExp]" === Object.prototype.toString.call(e);
}
class UO {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
function KO(e) {
  var t;
  const n = e.editor,
    r = e.from,
    o = e.to,
    i = e.text,
    a = e.rules,
    c = e.plugin,
    s = n.view;
  if (s.composing) return !1;
  const l = s.state.doc.resolve(r);
  if (l.parent.type.spec.code || (null === (t = l.nodeBefore || l.nodeAfter) || void 0 === t ? void 0 : t.marks.find(e => e.type.spec.code))) return !1;
  let u = !1;
  const d = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    let n = "";
    const r = e.parentOffset;
    return e.parent.nodesBetween(Math.max(0, r - t), r, (e, t, o, i) => {
      var a, c;
      const s = (null === (c = (a = e.type.spec).toText) || void 0 === c ? void 0 : c.call(a, {
        node: e,
        pos: t,
        parent: o,
        index: i
      })) || e.textContent || "%leaf%";
      n += s.slice(0, Math.max(0, r - t));
    }), n;
  }(l) + i;
  return a.forEach(e => {
    if (u) return;
    const t = ((e, t) => {
      if (XO(t)) return t.exec(e);
      const n = t(e);
      if (!n) return null;
      const r = [n.text];
      return r.index = n.index, r.input = e, r.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(n.replaceWith)), r;
    })(d, e.find);
    if (!t) return;
    const a = s.state.tr,
      l = SO({
        state: s.state,
        transaction: a
      }),
      f = {
        from: r - (t[0].length - i.length),
        to: o
      },
      _VO = new VO({
        editor: n,
        state: l
      }),
      p = _VO.commands,
      m = _VO.chain,
      h = _VO.can;
    null !== e.handler({
      state: l,
      range: f,
      match: t,
      commands: p,
      chain: m,
      can: h
    }) && a.steps.length && (a.setMeta(c, {
      transform: a,
      from: r,
      to: o,
      text: i
    }), s.dispatch(a), u = !0);
  }), u;
}
function YO(e) {
  const t = e.editor,
    n = e.rules,
    r = new LS({
      state: {
        init: () => null,
        apply(e, t) {
          const n = e.getMeta(r);
          return n || (e.selectionSet || e.docChanged ? null : t);
        }
      },
      props: {
        handleTextInput: (e, o, i, a) => KO({
          editor: t,
          from: o,
          to: i,
          text: a,
          rules: n,
          plugin: r
        }),
        handleDOMEvents: {
          compositionend: e => (setTimeout(() => {
            const o = e.state.selection.$cursor;
            o && KO({
              editor: t,
              from: o.pos,
              to: o.pos,
              text: "",
              rules: n,
              plugin: r
            });
          }), !1)
        },
        handleKeyDown(e, o) {
          if ("Enter" !== o.key) return !1;
          const i = e.state.selection.$cursor;
          return !!i && KO({
            editor: t,
            from: i.pos,
            to: i.pos,
            text: "\n",
            rules: n,
            plugin: r
          });
        }
      },
      isInputRules: !0
    });
  return r;
}
class qO {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
function _O(e) {
  const t = e.editor,
    n = e.state,
    r = e.from,
    o = e.to,
    i = e.rule,
    _VO2 = new VO({
      editor: t,
      state: n
    }),
    a = _VO2.commands,
    c = _VO2.chain,
    s = _VO2.can,
    l = [];
  n.doc.nodesBetween(r, o, (e, t) => {
    if (!e.isTextblock || e.type.spec.code) return;
    const u = Math.max(r, t),
      d = Math.min(o, t + e.content.size),
      f = ((e, t) => {
        if (XO(t)) return [...e.matchAll(t)];
        const n = t(e);
        return n ? n.map(t => {
          const n = [t.text];
          return n.index = t.index, n.input = e, n.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), n.push(t.replaceWith)), n;
        }) : [];
      })(e.textBetween(u - t, d - t, void 0, "￼"), i.find);
    f.forEach(e => {
      if (void 0 === e.index) return;
      const t = u + e.index + 1,
        r = t + e[0].length,
        o = {
          from: n.tr.mapping.map(t),
          to: n.tr.mapping.map(r)
        },
        d = i.handler({
          state: n,
          range: o,
          match: e,
          commands: a,
          chain: c,
          can: s
        });
      l.push(d);
    });
  });
  return l.every(e => null !== e);
}
function $O(e) {
  const t = e.editor,
    n = e.rules;
  let r = null,
    o = !1,
    i = !1;
  const a = n.map(e => new LS({
    view(e) {
      const t = t => {
        var n;
        r = (null === (n = e.dom.parentElement) || void 0 === n ? void 0 : n.contains(t.target)) ? e.dom.parentElement : null;
      };
      return window.addEventListener("dragstart", t), {
        destroy() {
          window.removeEventListener("dragstart", t);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: e => (i = r === e.dom.parentElement, !1),
        paste: (e, t) => {
          var n;
          const r = null === (n = t.clipboardData) || void 0 === n ? void 0 : n.getData("text/html");
          return o = !!(null == r ? void 0 : r.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (n, r, a) => {
      const c = n[0],
        s = "paste" === c.getMeta("uiEvent") && !o,
        l = "drop" === c.getMeta("uiEvent") && !i;
      if (!s && !l) return;
      const u = r.doc.content.findDiffStart(a.doc.content),
        d = r.doc.content.findDiffEnd(a.doc.content);
      if ("number" != typeof u || !d || u === d.b) return;
      const f = a.tr,
        p = SO({
          state: a,
          transaction: f
        });
      return _O({
        editor: t,
        state: p,
        from: Math.max(u - 1, 0),
        to: d.b - 1,
        rule: e
      }) && f.steps.length ? f : void 0;
    }
  }));
  return a;
}
class eT {
  constructor(e, t) {
    this.splittableMarks = [], this.editor = t, this.extensions = eT.resolve(e), this.schema = function (e, t) {
      var n;
      const r = OO(e),
        _PO2 = PO(e),
        o = _PO2.nodeExtensions,
        i = _PO2.markExtensions,
        a = null === (n = o.find(e => LO(e, "topNode"))) || void 0 === n ? void 0 : n.name,
        c = Object.fromEntries(o.map(n => {
          const o = r.filter(e => e.type === n.name),
            i = {
              name: n.name,
              options: n.options,
              storage: n.storage,
              editor: t
            },
            a = e.reduce((e, t) => {
              const r = LO(t, "extendNodeSchema", i);
              return _objectSpread(_objectSpread({}, e), r ? r(n) : {});
            }, {}),
            c = JO(_objectSpread(_objectSpread({}, a), {}, {
              content: FO(LO(n, "content", i)),
              marks: FO(LO(n, "marks", i)),
              group: FO(LO(n, "group", i)),
              inline: FO(LO(n, "inline", i)),
              atom: FO(LO(n, "atom", i)),
              selectable: FO(LO(n, "selectable", i)),
              draggable: FO(LO(n, "draggable", i)),
              code: FO(LO(n, "code", i)),
              defining: FO(LO(n, "defining", i)),
              isolating: FO(LO(n, "isolating", i)),
              attrs: Object.fromEntries(o.map(e => {
                var t;
                return [e.name, {
                  default: null === (t = null == e ? void 0 : e.attribute) || void 0 === t ? void 0 : t.default
                }];
              }))
            })),
            s = FO(LO(n, "parseHTML", i));
          s && (c.parseDOM = s.map(e => jO(e, o)));
          const l = LO(n, "renderHTML", i);
          l && (c.toDOM = e => l({
            node: e,
            HTMLAttributes: RO(e, o)
          }));
          const u = LO(n, "renderText", i);
          return u && (c.toText = u), [n.name, c];
        })),
        s = Object.fromEntries(i.map(n => {
          const o = r.filter(e => e.type === n.name),
            i = {
              name: n.name,
              options: n.options,
              storage: n.storage,
              editor: t
            },
            a = e.reduce((e, t) => {
              const r = LO(t, "extendMarkSchema", i);
              return _objectSpread(_objectSpread({}, e), r ? r(n) : {});
            }, {}),
            c = JO(_objectSpread(_objectSpread({}, a), {}, {
              inclusive: FO(LO(n, "inclusive", i)),
              excludes: FO(LO(n, "excludes", i)),
              group: FO(LO(n, "group", i)),
              spanning: FO(LO(n, "spanning", i)),
              code: FO(LO(n, "code", i)),
              attrs: Object.fromEntries(o.map(e => {
                var t;
                return [e.name, {
                  default: null === (t = null == e ? void 0 : e.attribute) || void 0 === t ? void 0 : t.default
                }];
              }))
            })),
            s = FO(LO(n, "parseHTML", i));
          s && (c.parseDOM = s.map(e => jO(e, o)));
          const l = LO(n, "renderHTML", i);
          return l && (c.toDOM = e => l({
            mark: e,
            HTMLAttributes: RO(e, o)
          })), [n.name, c];
        }));
      return new mN({
        topNode: a,
        nodes: c,
        marks: s
      });
    }(this.extensions, t), this.extensions.forEach(e => {
      var t;
      this.editor.extensionStorage[e.name] = e.storage;
      const n = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: ZO(e.name, this.schema)
      };
      if ("mark" === e.type) {
        (null === (t = FO(LO(e, "keepOnSplit", n))) || void 0 === t || t) && this.splittableMarks.push(e.name);
      }
      const r = LO(e, "onBeforeCreate", n);
      r && this.editor.on("beforeCreate", r);
      const o = LO(e, "onCreate", n);
      o && this.editor.on("create", o);
      const i = LO(e, "onUpdate", n);
      i && this.editor.on("update", i);
      const a = LO(e, "onSelectionUpdate", n);
      a && this.editor.on("selectionUpdate", a);
      const c = LO(e, "onTransaction", n);
      c && this.editor.on("transaction", c);
      const s = LO(e, "onFocus", n);
      s && this.editor.on("focus", s);
      const l = LO(e, "onBlur", n);
      l && this.editor.on("blur", l);
      const u = LO(e, "onDestroy", n);
      u && this.editor.on("destroy", u);
    });
  }
  static resolve(e) {
    const t = eT.sort(eT.flatten(e)),
      n = function (e) {
        const t = e.filter((t, n) => e.indexOf(t) !== n);
        return [...new Set(t)];
      }(t.map(e => e.name));
    return n.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${n.map(e => `'${e}'`).join(", ")}]. This can lead to issues.`), t;
  }
  static flatten(e) {
    return e.map(e => {
      const t = LO(e, "addExtensions", {
        name: e.name,
        options: e.options,
        storage: e.storage
      });
      return t ? [e, ...this.flatten(t())] : e;
    }).flat(10);
  }
  static sort(e) {
    return e.sort((e, t) => {
      const n = LO(e, "priority") || 100,
        r = LO(t, "priority") || 100;
      return n > r ? -1 : n < r ? 1 : 0;
    });
  }
  get commands() {
    return this.extensions.reduce((e, t) => {
      const n = LO(t, "addCommands", {
        name: t.name,
        options: t.options,
        storage: t.storage,
        editor: this.editor,
        type: ZO(t.name, this.schema)
      });
      return n ? _objectSpread(_objectSpread({}, e), n()) : e;
    }, {});
  }
  get plugins() {
    const e = this.editor,
      t = eT.sort([...this.extensions].reverse()),
      n = [],
      r = [],
      o = t.map(t => {
        const o = {
            name: t.name,
            options: t.options,
            storage: t.storage,
            editor: e,
            type: ZO(t.name, this.schema)
          },
          i = [],
          a = LO(t, "addKeyboardShortcuts", o);
        let c = {};
        if ("mark" === t.type && t.config.exitable && (c.ArrowRight = () => ZT.handleExit({
          editor: e,
          mark: t
        })), a) {
          const t = Object.fromEntries(Object.entries(a()).map(_ref23 => {
            let _ref24 = _slicedToArray(_ref23, 2),
              t = _ref24[0],
              n = _ref24[1];
            return [t, () => n({
              editor: e
            })];
          }));
          c = _objectSpread(_objectSpread({}, c), t);
        }
        const s = new LS({
          props: {
            handleKeyDown: iO(c)
          }
        });
        i.push(s);
        const l = LO(t, "addInputRules", o);
        WO(t, e.options.enableInputRules) && l && n.push(...l());
        const u = LO(t, "addPasteRules", o);
        WO(t, e.options.enablePasteRules) && u && r.push(...u());
        const d = LO(t, "addProseMirrorPlugins", o);
        if (d) {
          const e = d();
          i.push(...e);
        }
        return i;
      }).flat();
    return [YO({
      editor: e,
      rules: n
    }), ...$O({
      editor: e,
      rules: r
    }), ...o];
  }
  get attributes() {
    return OO(this.extensions);
  }
  get nodeViews() {
    const e = this.editor,
      _PO3 = PO(this.extensions),
      t = _PO3.nodeExtensions;
    return Object.fromEntries(t.filter(e => !!LO(e, "addNodeView")).map(t => {
      const n = this.attributes.filter(e => e.type === t.name),
        r = {
          name: t.name,
          options: t.options,
          storage: t.storage,
          editor: e,
          type: TO(t.name, this.schema)
        },
        o = LO(t, "addNodeView", r);
      if (!o) return [];
      return [t.name, (r, i, a, c) => {
        const s = RO(r, n);
        return o()({
          editor: e,
          node: r,
          getPos: a,
          decorations: c,
          HTMLAttributes: s,
          extension: t
        });
      }];
    }));
  }
}
function tT(e) {
  return "Object" === function (e) {
    return Object.prototype.toString.call(e).slice(8, -1);
  }(e) && e.constructor === Object && Object.getPrototypeOf(e) === Object.prototype;
}
function nT(e, t) {
  const n = _objectSpread({}, e);
  return tT(e) && tT(t) && Object.keys(t).forEach(r => {
    tT(t[r]) ? r in e ? n[r] = nT(e[r], t[r]) : Object.assign(n, {
      [r]: t[r]
    }) : Object.assign(n, {
      [r]: t[r]
    });
  }), n;
}
class rT {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = _objectSpread(_objectSpread({}, this.config), e), this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = FO(LO(this, "addOptions", {
      name: this.name
    }))), this.storage = FO(LO(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new rT(e);
  }
  configure() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const t = this.extend();
    return t.options = nT(this.options, e), t.storage = FO(LO(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const t = new rT(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = FO(LO(t, "addOptions", {
      name: t.name
    })), t.storage = FO(LO(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function oT(e, t, n) {
  const r = t.from,
    o = t.to,
    _ref25 = n || {},
    _ref25$blockSeparator = _ref25.blockSeparator,
    i = _ref25$blockSeparator === void 0 ? "\n\n" : _ref25$blockSeparator,
    _ref25$textSerializer = _ref25.textSerializers,
    a = _ref25$textSerializer === void 0 ? {} : _ref25$textSerializer;
  let c = "",
    s = !0;
  return e.nodesBetween(r, o, (e, n, l, u) => {
    var d;
    const f = null == a ? void 0 : a[e.type.name];
    f ? (e.isBlock && !s && (c += i, s = !0), l && (c += f({
      node: e,
      pos: n,
      parent: l,
      index: u,
      range: t
    }))) : e.isText ? (c += null === (d = null == e ? void 0 : e.text) || void 0 === d ? void 0 : d.slice(Math.max(r, n) - n, o - n), s = !1) : e.isBlock && !s && (c += i, s = !0);
  }), c;
}
function iT(e) {
  return Object.fromEntries(Object.entries(e.nodes).filter(_ref26 => {
    let _ref27 = _slicedToArray(_ref26, 2),
      e = _ref27[1];
    return e.spec.toText;
  }).map(_ref28 => {
    let _ref29 = _slicedToArray(_ref28, 2),
      e = _ref29[0],
      t = _ref29[1];
    return [e, t.spec.toText];
  }));
}
const aT = rT.create({
  name: "clipboardTextSerializer",
  addProseMirrorPlugins() {
    return [new LS({
      key: new TS("clipboardTextSerializer"),
      props: {
        clipboardTextSerializer: () => {
          const e = this.editor,
            t = e.state,
            n = e.schema,
            r = t.doc,
            o = t.selection,
            i = o.ranges,
            a = Math.min(...i.map(e => e.$from.pos)),
            c = Math.max(...i.map(e => e.$to.pos));
          return oT(r, {
            from: a,
            to: c
          }, {
            textSerializers: iT(n)
          });
        }
      }
    })];
  }
});
function cT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    strict: !0
  };
  const r = Object.keys(t);
  return !r.length || r.every(r => n.strict ? t[r] === e[r] : XO(t[r]) ? t[r].test(e[r]) : t[r] === e[r]);
}
function sT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return e.find(e => e.type === t && cT(e.attrs, n));
}
function lT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return !!sT(e, t, n);
}
function uT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!e || !t) return;
  let r = e.parent.childAfter(e.parentOffset);
  if (e.parentOffset === r.offset && 0 !== r.offset && (r = e.parent.childBefore(e.parentOffset)), !r.node) return;
  const o = sT([...r.node.marks], t, n);
  if (!o) return;
  let i = r.index,
    a = e.start() + r.offset,
    c = i + 1,
    s = a + r.node.nodeSize;
  for (sT([...r.node.marks], t, n); i > 0 && o.isInSet(e.parent.child(i - 1).marks);) i -= 1, a -= e.parent.child(i).nodeSize;
  for (; c < e.parent.childCount && lT([...e.parent.child(c).marks], t, n);) s += e.parent.child(c).nodeSize, c += 1;
  return {
    from: a,
    to: s
  };
}
function dT(e, t) {
  if ("string" == typeof e) {
    if (!t.marks[e]) throw Error(`There is no mark type named '${e}'. Maybe you forgot to add the extension?`);
    return t.marks[e];
  }
  return e;
}
function fT(e) {
  return e instanceof bS;
}
function pT() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  return Math.min(Math.max(e, t), n);
}
function mT(e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!t) return null;
  const n = AS.atStart(e),
    r = AS.atEnd(e);
  if ("start" === t || !0 === t) return n;
  if ("end" === t) return r;
  const o = n.from,
    i = r.to;
  return "all" === t ? bS.create(e, pT(0, o, i), pT(e.content.size, o, i)) : bS.create(e, pT(t, o, i), pT(t, o, i));
}
function hT() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function AT(e) {
  const t = `<body>${e}</body>`;
  return new window.DOMParser().parseFromString(t, "text/html").body;
}
function gT(e, t, n) {
  if (n = _objectSpread({
    slice: !0,
    parseOptions: {}
  }, n), "object" == typeof e && null !== e) try {
    return Array.isArray(e) && e.length > 0 ? wk.fromArray(e.map(e => t.nodeFromJSON(e))) : t.nodeFromJSON(e);
  } catch (r) {
    return console.warn("[tiptap warn]: Invalid content.", "Passed value:", e, "Error:", r), gT("", t, n);
  }
  if ("string" == typeof e) {
    const r = AN.fromSchema(t);
    return n.slice ? r.parseSlice(AT(e), n.parseOptions).content : r.parse(AT(e), n.parseOptions);
  }
  return gT("", t, n);
}
function vT() {
  return "undefined" != typeof navigator && /Mac/.test(navigator.platform);
}
function CT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _e$selection7 = e.selection,
    r = _e$selection7.from,
    o = _e$selection7.to,
    i = _e$selection7.empty,
    a = t ? TO(t, e.schema) : null,
    c = [];
  e.doc.nodesBetween(r, o, (e, t) => {
    if (e.isText) return;
    const n = Math.max(r, t),
      i = Math.min(o, t + e.nodeSize);
    c.push({
      node: e,
      from: n,
      to: i
    });
  });
  const s = o - r,
    l = c.filter(e => !a || a.name === e.node.type.name).filter(e => cT(e.node.attrs, n, {
      strict: !1
    }));
  if (i) return !!l.length;
  return l.reduce((e, t) => e + t.to - t.from, 0) >= s;
}
function bT(e, t) {
  return t.nodes[e] ? "node" : t.marks[e] ? "mark" : null;
}
function ET(e, t) {
  const n = "string" == typeof t ? [t] : t;
  return Object.keys(e).reduce((t, r) => (n.includes(r) || (t[r] = e[r]), t), {});
}
function yT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return gT(e, t, {
    slice: !1,
    parseOptions: n
  });
}
function IT(e) {
  return t => function (e, t) {
    for (let n = e.depth; n > 0; n -= 1) {
      const r = e.node(n);
      if (t(r)) return {
        pos: n > 0 ? e.before(n) : 0,
        start: e.start(n),
        depth: n,
        node: r
      };
    }
  }(t.$from, e);
}
function BT(e, t) {
  const n = dT(t, e.schema),
    _e$selection8 = e.selection,
    r = _e$selection8.from,
    o = _e$selection8.to,
    i = _e$selection8.empty,
    a = [];
  i ? (e.storedMarks && a.push(...e.storedMarks), a.push(...e.selection.$head.marks())) : e.doc.nodesBetween(r, o, e => {
    a.push(...e.marks);
  });
  const c = a.find(e => e.type.name === n.name);
  return c ? _objectSpread({}, c.attrs) : {};
}
function xT(e, t) {
  const n = bT("string" == typeof t ? t : t.name, e.schema);
  return "node" === n ? function (e, t) {
    const n = TO(t, e.schema),
      _e$selection9 = e.selection,
      r = _e$selection9.from,
      o = _e$selection9.to,
      i = [];
    e.doc.nodesBetween(r, o, e => {
      i.push(e);
    });
    const a = i.reverse().find(e => e.type.name === n.name);
    return a ? _objectSpread({}, a.attrs) : {};
  }(e, t) : "mark" === n ? BT(e, t) : {};
}
function wT(e) {
  const t = function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : JSON.stringify;
    const n = {};
    return e.filter(e => {
      const r = t(e);
      return !Object.prototype.hasOwnProperty.call(n, r) && (n[r] = !0);
    });
  }(e);
  return 1 === t.length ? t : t.filter((e, n) => {
    const r = t.filter((e, t) => t !== n);
    return !r.some(t => e.oldRange.from >= t.oldRange.from && e.oldRange.to <= t.oldRange.to && e.newRange.from >= t.newRange.from && e.newRange.to <= t.newRange.to);
  });
}
function QT(e, t, n) {
  const r = [];
  return e === t ? n.resolve(e).marks().forEach(t => {
    const o = uT(n.resolve(e - 1), t.type);
    o && r.push(_objectSpread({
      mark: t
    }, o));
  }) : n.nodesBetween(e, t, (e, t) => {
    r.push(...e.marks.map(n => ({
      from: t,
      to: t + e.nodeSize,
      mark: n
    })));
  }), r;
}
function HT(e, t, n) {
  return Object.fromEntries(Object.entries(n).filter(_ref30 => {
    let _ref31 = _slicedToArray(_ref30, 1),
      n = _ref31[0];
    const r = e.find(e => e.type === t && e.name === n);
    return !!r && r.attribute.keepOnSplit;
  }));
}
function zT(e, t) {
  let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const _e$selection10 = e.selection,
    r = _e$selection10.empty,
    o = _e$selection10.ranges,
    i = t ? dT(t, e.schema) : null;
  if (r) return !!(e.storedMarks || e.selection.$from.marks()).filter(e => !i || i.name === e.type.name).find(e => cT(e.attrs, n, {
    strict: !1
  }));
  let a = 0;
  const c = [];
  if (o.forEach(_ref32 => {
    let t = _ref32.$from,
      n = _ref32.$to;
    const r = t.pos,
      o = n.pos;
    e.doc.nodesBetween(r, o, (e, t) => {
      if (!e.isText && !e.marks.length) return;
      const n = Math.max(r, t),
        i = Math.min(o, t + e.nodeSize);
      a += i - n, c.push(...e.marks.map(e => ({
        mark: e,
        from: n,
        to: i
      })));
    });
  }), 0 === a) return !1;
  const s = c.filter(e => !i || i.name === e.mark.type.name).filter(e => cT(e.mark.attrs, n, {
      strict: !1
    })).reduce((e, t) => e + t.to - t.from, 0),
    l = c.filter(e => !i || e.mark.type !== i && e.mark.type.excludes(i)).reduce((e, t) => e + t.to - t.from, 0);
  return (s > 0 ? s + l : s) >= a;
}
function MT(e, t) {
  const _PO4 = PO(t),
    n = _PO4.nodeExtensions,
    r = n.find(t => t.name === e);
  if (!r) return !1;
  const o = FO(LO(r, "group", {
    name: r.name,
    options: r.options,
    storage: r.storage
  }));
  return "string" == typeof o && o.split(" ").includes("list");
}
function kT(e, t) {
  const n = e.storedMarks || e.selection.$to.parentOffset && e.selection.$from.marks();
  if (n) {
    const r = n.filter(e => null == t ? void 0 : t.includes(e.type.name));
    e.tr.ensureMarks(r);
  }
}
const NT = (e, t) => {
    const n = IT(e => e.type === t)(e.selection);
    if (!n) return !0;
    const r = e.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
    if (void 0 === r) return !0;
    const o = e.doc.nodeAt(r);
    return n.node.type !== (null == o ? void 0 : o.type) || !qN(e.doc, n.pos) || (e.join(n.pos), !0);
  },
  ST = (e, t) => {
    const n = IT(e => e.type === t)(e.selection);
    if (!n) return !0;
    const r = e.doc.resolve(n.start).after(n.depth);
    if (void 0 === r) return !0;
    const o = e.doc.nodeAt(r);
    return n.node.type !== (null == o ? void 0 : o.type) || !qN(e.doc, r) || (e.join(r), !0);
  };
var VT = Object.freeze({
  __proto__: null,
  blur: () => _ref33 => {
    let e = _ref33.editor,
      t = _ref33.view;
    return requestAnimationFrame(() => {
      var n;
      e.isDestroyed || (t.dom.blur(), null === (n = null === window || void 0 === window ? void 0 : window.getSelection()) || void 0 === n || n.removeAllRanges());
    }), !0;
  },
  clearContent: function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
    return _ref34 => {
      let t = _ref34.commands;
      return t.setContent("", e);
    };
  },
  clearNodes: () => _ref35 => {
    let e = _ref35.state,
      t = _ref35.tr,
      n = _ref35.dispatch;
    const r = t.selection,
      o = r.ranges;
    return !n || (o.forEach(_ref36 => {
      let n = _ref36.$from,
        r = _ref36.$to;
      e.doc.nodesBetween(n.pos, r.pos, (e, n) => {
        if (e.type.isText) return;
        const r = t.doc,
          o = t.mapping,
          i = r.resolve(o.map(n)),
          a = r.resolve(o.map(n + e.nodeSize)),
          c = i.blockRange(a);
        if (!c) return;
        const s = XN(c);
        if (e.type.isTextblock) {
          const _i$parent$contentMatc = i.parent.contentMatchAt(i.index()),
            e = _i$parent$contentMatc.defaultType;
          t.setNodeMarkup(c.start, e);
        }
        (s || 0 === s) && t.lift(c, s);
      });
    }), !0);
  },
  command: e => t => e(t),
  createParagraphNear: () => _ref37 => {
    let e = _ref37.state,
      t = _ref37.dispatch;
    return gO(e, t);
  },
  deleteCurrentNode: () => _ref38 => {
    let e = _ref38.tr,
      t = _ref38.dispatch;
    const n = e.selection,
      r = n.$anchor.node();
    if (r.content.size > 0) return !1;
    const o = e.selection.$anchor;
    for (let n = o.depth; n > 0; n -= 1) {
      if (o.node(n).type === r.type) {
        if (t) {
          const t = o.before(n),
            r = o.after(n);
          e.delete(t, r).scrollIntoView();
        }
        return !0;
      }
    }
    return !1;
  },
  deleteNode: e => _ref39 => {
    let t = _ref39.tr,
      n = _ref39.state,
      r = _ref39.dispatch;
    const o = TO(e, n.schema),
      i = t.selection.$anchor;
    for (let e = i.depth; e > 0; e -= 1) {
      if (i.node(e).type === o) {
        if (r) {
          const n = i.before(e),
            r = i.after(e);
          t.delete(n, r).scrollIntoView();
        }
        return !0;
      }
    }
    return !1;
  },
  deleteRange: e => _ref40 => {
    let t = _ref40.tr,
      n = _ref40.dispatch;
    const r = e.from,
      o = e.to;
    return n && t.delete(r, o), !0;
  },
  deleteSelection: () => _ref41 => {
    let e = _ref41.state,
      t = _ref41.dispatch;
    return aO(e, t);
  },
  enter: () => _ref42 => {
    let e = _ref42.commands;
    return e.keyboardShortcut("Enter");
  },
  exitCode: () => _ref43 => {
    let e = _ref43.state,
      t = _ref43.dispatch;
    return AO(e, t);
  },
  extendMarkRange: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref44 => {
      let n = _ref44.tr,
        r = _ref44.state,
        o = _ref44.dispatch;
      const i = dT(e, r.schema),
        a = n.doc,
        c = n.selection,
        s = c.$from,
        l = c.from,
        u = c.to;
      if (o) {
        const e = uT(s, i, t);
        if (e && e.from <= l && e.to >= u) {
          const t = bS.create(a, e.from, e.to);
          n.setSelection(t);
        }
      }
      return !0;
    };
  },
  first: e => t => {
    const n = "function" == typeof e ? e(t) : e;
    for (let e = 0; e < n.length; e += 1) if (n[e](t)) return !0;
    return !1;
  },
  focus: function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref45 => {
      let n = _ref45.editor,
        r = _ref45.view,
        o = _ref45.tr,
        i = _ref45.dispatch;
      t = _objectSpread({
        scrollIntoView: !0
      }, t);
      const a = () => {
        hT() && r.dom.focus(), requestAnimationFrame(() => {
          n.isDestroyed || (r.focus(), (null == t ? void 0 : t.scrollIntoView) && n.commands.scrollIntoView());
        });
      };
      if (r.hasFocus() && null === e || !1 === e) return !0;
      if (i && null === e && !fT(n.state.selection)) return a(), !0;
      const c = mT(o.doc, e) || n.state.selection,
        s = n.state.selection.eq(c);
      return i && (s || o.setSelection(c), s && o.storedMarks && o.setStoredMarks(o.storedMarks), a()), !0;
    };
  },
  forEach: (e, t) => n => e.every((e, r) => t(e, _objectSpread(_objectSpread({}, n), {}, {
    index: r
  }))),
  insertContent: (e, t) => _ref46 => {
    let n = _ref46.tr,
      r = _ref46.commands;
    return r.insertContentAt({
      from: n.selection.from,
      to: n.selection.to
    }, e, t);
  },
  insertContentAt: (e, t, n) => _ref47 => {
    let r = _ref47.tr,
      o = _ref47.dispatch,
      i = _ref47.editor;
    if (o) {
      n = _objectSpread({
        parseOptions: {},
        updateSelection: !0
      }, n);
      const o = gT(t, i.schema, {
        parseOptions: _objectSpread({
          preserveWhitespace: "full"
        }, n.parseOptions)
      });
      if ("<>" === o.toString()) return !0;
      let _ref48 = "number" == typeof e ? {
          from: e,
          to: e
        } : e,
        a = _ref48.from,
        c = _ref48.to,
        s = !0,
        l = !0;
      if ((o.toString().startsWith("<") ? o : [o]).forEach(e => {
        e.check(), s = !!s && e.isText && 0 === e.marks.length, l = !!l && e.isBlock;
      }), a === c && l) {
        const _r$doc$resolve = r.doc.resolve(a),
          e = _r$doc$resolve.parent;
        e.isTextblock && !e.type.spec.code && !e.childCount && (a -= 1, c += 1);
      }
      s ? Array.isArray(t) ? r.insertText(t.map(e => e.text || "").join(""), a, c) : "object" == typeof t && t && t.text ? r.insertText(t.text, a, c) : r.insertText(t, a, c) : r.replaceWith(a, c, o), n.updateSelection && function (e, t, n) {
        const r = e.steps.length - 1;
        if (r < t) return;
        const o = e.steps[r];
        if (!(o instanceof jN || o instanceof JN)) return;
        const i = e.mapping.maps[r];
        let a = 0;
        i.forEach((e, t, n, r) => {
          0 === a && (a = r);
        }), e.setSelection(AS.near(e.doc.resolve(a), n));
      }(r, r.steps.length - 1, -1);
    }
    return !0;
  },
  joinUp: () => _ref49 => {
    let e = _ref49.state,
      t = _ref49.dispatch;
    return ((e, t) => {
      let n,
        r = e.selection,
        o = r instanceof yS;
      if (o) {
        if (r.node.isTextblock || !qN(e.doc, r.from)) return !1;
        n = r.from;
      } else if (n = $N(e.doc, r.from, -1), null == n) return !1;
      if (t) {
        let r = e.tr.join(n);
        o && r.setSelection(yS.create(r.doc, n - e.doc.resolve(n).nodeBefore.nodeSize)), t(r.scrollIntoView());
      }
      return !0;
    })(e, t);
  },
  joinDown: () => _ref50 => {
    let e = _ref50.state,
      t = _ref50.dispatch;
    return ((e, t) => {
      let n,
        r = e.selection;
      if (r instanceof yS) {
        if (r.node.isTextblock || !qN(e.doc, r.to)) return !1;
        n = r.to;
      } else if (n = $N(e.doc, r.to, 1), null == n) return !1;
      return t && t(e.tr.join(n).scrollIntoView()), !0;
    })(e, t);
  },
  joinBackward: () => _ref51 => {
    let e = _ref51.state,
      t = _ref51.dispatch;
    return cO(e, t);
  },
  joinForward: () => _ref52 => {
    let e = _ref52.state,
      t = _ref52.dispatch;
    return dO(e, t);
  },
  keyboardShortcut: e => _ref53 => {
    let t = _ref53.editor,
      n = _ref53.view,
      r = _ref53.tr,
      o = _ref53.dispatch;
    const i = function (e) {
        const t = e.split(/-(?!$)/);
        let n,
          r,
          o,
          i,
          a = t[t.length - 1];
        "Space" === a && (a = " ");
        for (let e = 0; e < t.length - 1; e += 1) {
          const a = t[e];
          if (/^(cmd|meta|m)$/i.test(a)) i = !0;else if (/^a(lt)?$/i.test(a)) n = !0;else if (/^(c|ctrl|control)$/i.test(a)) r = !0;else if (/^s(hift)?$/i.test(a)) o = !0;else {
            if (!/^mod$/i.test(a)) throw new Error(`Unrecognized modifier name: ${a}`);
            hT() || vT() ? i = !0 : r = !0;
          }
        }
        return n && (a = `Alt-${a}`), r && (a = `Ctrl-${a}`), i && (a = `Meta-${a}`), o && (a = `Shift-${a}`), a;
      }(e).split(/-(?!$)/),
      a = i.find(e => !["Alt", "Ctrl", "Meta", "Shift"].includes(e)),
      c = new KeyboardEvent("keydown", {
        key: "Space" === a ? " " : a,
        altKey: i.includes("Alt"),
        ctrlKey: i.includes("Ctrl"),
        metaKey: i.includes("Meta"),
        shiftKey: i.includes("Shift"),
        bubbles: !0,
        cancelable: !0
      }),
      s = t.captureTransaction(() => {
        n.someProp("handleKeyDown", e => e(n, c));
      });
    return null == s || s.steps.forEach(e => {
      const t = e.map(r.mapping);
      t && o && r.maybeStep(t);
    }), !0;
  },
  lift: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref54 => {
      let n = _ref54.state,
        r = _ref54.dispatch;
      return !!CT(n, TO(e, n.schema), t) && ((e, t) => {
        let _e$selection11 = e.selection,
          n = _e$selection11.$from,
          r = _e$selection11.$to,
          o = n.blockRange(r),
          i = o && XN(o);
        return null != i && (t && t(e.tr.lift(o, i).scrollIntoView()), !0);
      })(n, r);
    };
  },
  liftEmptyBlock: () => _ref55 => {
    let e = _ref55.state,
      t = _ref55.dispatch;
    return vO(e, t);
  },
  liftListItem: e => _ref56 => {
    let t = _ref56.state,
      n = _ref56.dispatch;
    return NO(TO(e, t.schema))(t, n);
  },
  newlineInCode: () => _ref57 => {
    let e = _ref57.state,
      t = _ref57.dispatch;
    return mO(e, t);
  },
  resetAttributes: (e, t) => _ref58 => {
    let n = _ref58.tr,
      r = _ref58.state,
      o = _ref58.dispatch;
    let i = null,
      a = null;
    const c = bT("string" == typeof e ? e : e.name, r.schema);
    return !!c && ("node" === c && (i = TO(e, r.schema)), "mark" === c && (a = dT(e, r.schema)), o && n.selection.ranges.forEach(e => {
      r.doc.nodesBetween(e.$from.pos, e.$to.pos, (e, r) => {
        i && i === e.type && n.setNodeMarkup(r, void 0, ET(e.attrs, t)), a && e.marks.length && e.marks.forEach(o => {
          a === o.type && n.addMark(r, r + e.nodeSize, a.create(ET(o.attrs, t)));
        });
      });
    }), !0);
  },
  scrollIntoView: () => _ref59 => {
    let e = _ref59.tr,
      t = _ref59.dispatch;
    return t && e.scrollIntoView(), !0;
  },
  selectAll: () => _ref60 => {
    let e = _ref60.tr,
      t = _ref60.commands;
    return t.setTextSelection({
      from: 0,
      to: e.doc.content.size
    });
  },
  selectNodeBackward: () => _ref61 => {
    let e = _ref61.state,
      t = _ref61.dispatch;
    return lO(e, t);
  },
  selectNodeForward: () => _ref62 => {
    let e = _ref62.state,
      t = _ref62.dispatch;
    return fO(e, t);
  },
  selectParentNode: () => _ref63 => {
    let e = _ref63.state,
      t = _ref63.dispatch;
    return ((e, t) => {
      let n,
        _e$selection12 = e.selection,
        r = _e$selection12.$from,
        o = _e$selection12.to,
        i = r.sharedDepth(o);
      return 0 != i && (n = r.before(i), t && t(e.tr.setSelection(yS.create(e.doc, n))), !0);
    })(e, t);
  },
  selectTextblockEnd: () => _ref64 => {
    let e = _ref64.state,
      t = _ref64.dispatch;
    return BO(e, t);
  },
  selectTextblockStart: () => _ref65 => {
    let e = _ref65.state,
      t = _ref65.dispatch;
    return IO(e, t);
  },
  setContent: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _ref66 => {
      let r = _ref66.tr,
        o = _ref66.editor,
        i = _ref66.dispatch;
      const a = r.doc,
        c = yT(e, o.schema, n);
      return i && r.replaceWith(0, a.content.size, c).setMeta("preventUpdate", !t), !0;
    };
  },
  setMark: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref67 => {
      let n = _ref67.tr,
        r = _ref67.state,
        o = _ref67.dispatch;
      const i = n.selection,
        a = i.empty,
        c = i.ranges,
        s = dT(e, r.schema);
      if (o) if (a) {
        const e = BT(r, s);
        n.addStoredMark(s.create(_objectSpread(_objectSpread({}, e), t)));
      } else c.forEach(e => {
        const o = e.$from.pos,
          i = e.$to.pos;
        r.doc.nodesBetween(o, i, (e, r) => {
          const a = Math.max(r, o),
            c = Math.min(r + e.nodeSize, i);
          e.marks.find(e => e.type === s) ? e.marks.forEach(e => {
            s === e.type && n.addMark(a, c, s.create(_objectSpread(_objectSpread({}, e.attrs), t)));
          }) : n.addMark(a, c, s.create(t));
        });
      });
      return function (e, t, n) {
        var r;
        const o = t.selection;
        let i = null;
        if (fT(o) && (i = o.$cursor), i) {
          const t = null !== (r = e.storedMarks) && void 0 !== r ? r : i.marks();
          return !!n.isInSet(t) || !t.some(e => e.type.excludes(n));
        }
        const a = o.ranges;
        return a.some(_ref68 => {
          let t = _ref68.$from,
            r = _ref68.$to;
          let o = 0 === t.depth && e.doc.inlineContent && e.doc.type.allowsMarkType(n);
          return e.doc.nodesBetween(t.pos, r.pos, (e, t, r) => {
            if (o) return !1;
            if (e.isInline) {
              const t = !r || r.type.allowsMarkType(n),
                i = !!n.isInSet(e.marks) || !e.marks.some(e => e.type.excludes(n));
              o = t && i;
            }
            return !o;
          }), o;
        });
      }(r, n, s);
    };
  },
  setMeta: (e, t) => _ref69 => {
    let n = _ref69.tr;
    return n.setMeta(e, t), !0;
  },
  setNode: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref70 => {
      let n = _ref70.state,
        r = _ref70.dispatch,
        o = _ref70.chain;
      const i = TO(e, n.schema);
      return i.isTextblock ? o().command(_ref71 => {
        let e = _ref71.commands;
        return !!xO(i, t)(n) || e.clearNodes();
      }).command(_ref72 => {
        let e = _ref72.state;
        return xO(i, t)(e, r);
      }).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
    };
  },
  setNodeSelection: e => _ref73 => {
    let t = _ref73.tr,
      n = _ref73.dispatch;
    if (n) {
      const n = t.doc,
        r = pT(e, 0, n.content.size),
        o = yS.create(n, r);
      t.setSelection(o);
    }
    return !0;
  },
  setTextSelection: e => _ref74 => {
    let t = _ref74.tr,
      n = _ref74.dispatch;
    if (n) {
      const n = t.doc,
        _ref75 = "number" == typeof e ? {
          from: e,
          to: e
        } : e,
        r = _ref75.from,
        o = _ref75.to,
        i = bS.atStart(n).from,
        a = bS.atEnd(n).to,
        c = pT(r, i, a),
        s = pT(o, i, a),
        l = bS.create(n, c, s);
      t.setSelection(l);
    }
    return !0;
  },
  sinkListItem: e => _ref76 => {
    let t = _ref76.state,
      n = _ref76.dispatch;
    const r = TO(e, t.schema);
    return (o = r, function (e, t) {
      let _e$selection13 = e.selection,
        n = _e$selection13.$from,
        r = _e$selection13.$to,
        i = n.blockRange(r, e => e.childCount > 0 && e.firstChild.type == o);
      if (!i) return !1;
      let a = i.startIndex;
      if (0 == a) return !1;
      let c = i.parent,
        s = c.child(a - 1);
      if (s.type != o) return !1;
      if (t) {
        let n = s.lastChild && s.lastChild.type == c.type,
          r = wk.from(n ? o.create() : null),
          a = new Nk(wk.from(o.create(null, wk.from(c.type.create(null, r)))), n ? 3 : 1, 0),
          l = i.start,
          u = i.end;
        t(e.tr.step(new JN(l - (n ? 3 : 1), u, l, u, a, 1, !0)).scrollIntoView());
      }
      return !0;
    })(t, n);
    var o;
  },
  splitBlock: function () {
    let _ref77 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref77$keepMarks = _ref77.keepMarks,
      e = _ref77$keepMarks === void 0 ? !0 : _ref77$keepMarks;
    return _ref78 => {
      let t = _ref78.tr,
        n = _ref78.state,
        r = _ref78.dispatch,
        o = _ref78.editor;
      const i = t.selection,
        a = t.doc,
        c = i.$from,
        s = i.$to,
        l = HT(o.extensionManager.attributes, c.node().type.name, c.node().attrs);
      if (i instanceof yS && i.node.isBlock) return !(!c.parentOffset || !YN(a, c.pos)) && (r && (e && kT(n, o.extensionManager.splittableMarks), t.split(c.pos).scrollIntoView()), !0);
      if (!c.parent.isBlock) return !1;
      if (r) {
        const r = s.parentOffset === s.parent.content.size;
        i instanceof bS && t.deleteSelection();
        const a = 0 === c.depth ? void 0 : function (e) {
          for (let t = 0; t < e.edgeCount; t += 1) {
            const _e$edge3 = e.edge(t),
              n = _e$edge3.type;
            if (n.isTextblock && !n.hasRequiredAttrs()) return n;
          }
          return null;
        }(c.node(-1).contentMatchAt(c.indexAfter(-1)));
        let u = r && a ? [{
            type: a,
            attrs: l
          }] : void 0,
          d = YN(t.doc, t.mapping.map(c.pos), 1, u);
        if (u || d || !YN(t.doc, t.mapping.map(c.pos), 1, a ? [{
          type: a
        }] : void 0) || (d = !0, u = a ? [{
          type: a,
          attrs: l
        }] : void 0), d && (t.split(t.mapping.map(c.pos), 1, u), a && !r && !c.parentOffset && c.parent.type !== a)) {
          const e = t.mapping.map(c.before()),
            n = t.doc.resolve(e);
          c.node(-1).canReplaceWith(n.index(), n.index() + 1, a) && t.setNodeMarkup(t.mapping.map(c.before()), a);
        }
        e && kT(n, o.extensionManager.splittableMarks), t.scrollIntoView();
      }
      return !0;
    };
  },
  splitListItem: e => _ref79 => {
    let t = _ref79.tr,
      n = _ref79.state,
      r = _ref79.dispatch,
      o = _ref79.editor;
    var i;
    const a = TO(e, n.schema),
      _n$selection2 = n.selection,
      c = _n$selection2.$from,
      s = _n$selection2.$to,
      l = n.selection.node;
    if (l && l.isBlock || c.depth < 2 || !c.sameParent(s)) return !1;
    const u = c.node(-1);
    if (u.type !== a) return !1;
    const d = o.extensionManager.attributes;
    if (0 === c.parent.content.size && c.node(-1).childCount === c.indexAfter(-1)) {
      if (2 === c.depth || c.node(-3).type !== a || c.index(-2) !== c.node(-2).childCount - 1) return !1;
      if (r) {
        let e = wk.empty;
        const n = c.index(-1) ? 1 : c.index(-2) ? 2 : 3;
        for (let t = c.depth - n; t >= c.depth - 3; t -= 1) e = wk.from(c.node(t).copy(e));
        const r = c.indexAfter(-1) < c.node(-2).childCount ? 1 : c.indexAfter(-2) < c.node(-3).childCount ? 2 : 3,
          o = HT(d, c.node().type.name, c.node().attrs),
          s = (null === (i = a.contentMatch.defaultType) || void 0 === i ? void 0 : i.createAndFill(o)) || void 0;
        e = e.append(wk.from(a.createAndFill(null, s) || void 0));
        const l = c.before(c.depth - (n - 1));
        t.replace(l, c.after(-r), new Nk(e, 4 - n, 0));
        let u = -1;
        t.doc.nodesBetween(l, t.doc.content.size, (e, t) => {
          if (u > -1) return !1;
          e.isTextblock && 0 === e.content.size && (u = t + 1);
        }), u > -1 && t.setSelection(bS.near(t.doc.resolve(u))), t.scrollIntoView();
      }
      return !0;
    }
    const f = s.pos === c.end() ? u.contentMatchAt(0).defaultType : null,
      p = HT(d, u.type.name, u.attrs),
      m = HT(d, c.node().type.name, c.node().attrs);
    t.delete(c.pos, s.pos);
    const h = f ? [{
      type: a,
      attrs: p
    }, {
      type: f,
      attrs: m
    }] : [{
      type: a,
      attrs: p
    }];
    if (!YN(t.doc, c.pos, 2)) return !1;
    if (r) {
      const e = n.selection,
        i = n.storedMarks,
        a = o.extensionManager.splittableMarks,
        s = i || e.$to.parentOffset && e.$from.marks();
      if (t.split(c.pos, 2, h).scrollIntoView(), !s || !r) return !0;
      const l = s.filter(e => a.includes(e.type.name));
      t.ensureMarks(l);
    }
    return !0;
  },
  toggleList: function (e, t, n) {
    let r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return _ref80 => {
      let o = _ref80.editor,
        i = _ref80.tr,
        a = _ref80.state,
        c = _ref80.dispatch,
        s = _ref80.chain,
        l = _ref80.commands,
        u = _ref80.can;
      const _o$extensionManager = o.extensionManager,
        d = _o$extensionManager.extensions,
        f = _o$extensionManager.splittableMarks,
        p = TO(e, a.schema),
        m = TO(t, a.schema),
        h = a.selection,
        A = a.storedMarks,
        g = h.$from,
        v = h.$to,
        C = g.blockRange(v),
        b = A || h.$to.parentOffset && h.$from.marks();
      if (!C) return !1;
      const E = IT(e => MT(e.type.name, d))(h);
      if (C.depth >= 1 && E && C.depth - E.depth <= 1) {
        if (E.node.type === p) return l.liftListItem(m);
        if (MT(E.node.type.name, d) && p.validContent(E.node.content) && c) return s().command(() => (i.setNodeMarkup(E.pos, p), !0)).command(() => NT(i, p)).command(() => ST(i, p)).run();
      }
      return n && b && c ? s().command(() => {
        const e = u().wrapInList(p, r),
          t = b.filter(e => f.includes(e.type.name));
        return i.ensureMarks(t), !!e || l.clearNodes();
      }).wrapInList(p, r).command(() => NT(i, p)).command(() => ST(i, p)).run() : s().command(() => !!u().wrapInList(p, r) || l.clearNodes()).wrapInList(p, r).command(() => NT(i, p)).command(() => ST(i, p)).run();
    };
  },
  toggleMark: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _ref81 => {
      let r = _ref81.state,
        o = _ref81.commands;
      const _n$extendEmptyMarkRan = n.extendEmptyMarkRange,
        i = _n$extendEmptyMarkRan === void 0 ? !1 : _n$extendEmptyMarkRan,
        a = dT(e, r.schema);
      return zT(r, a, t) ? o.unsetMark(a, {
        extendEmptyMarkRange: i
      }) : o.setMark(a, t);
    };
  },
  toggleNode: function (e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return _ref82 => {
      let r = _ref82.state,
        o = _ref82.commands;
      const i = TO(e, r.schema),
        a = TO(t, r.schema);
      return CT(r, i, n) ? o.setNode(a) : o.setNode(i, n);
    };
  },
  toggleWrap: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref83 => {
      let n = _ref83.state,
        r = _ref83.commands;
      const o = TO(e, n.schema);
      return CT(n, o, t) ? r.lift(o) : r.wrapIn(o, t);
    };
  },
  undoInputRule: () => _ref84 => {
    let e = _ref84.state,
      t = _ref84.dispatch;
    const n = e.plugins;
    for (let r = 0; r < n.length; r += 1) {
      const o = n[r];
      let i;
      if (o.spec.isInputRules && (i = o.getState(e))) {
        if (t) {
          const t = e.tr,
            n = i.transform;
          for (let e = n.steps.length - 1; e >= 0; e -= 1) t.step(n.steps[e].invert(n.docs[e]));
          if (i.text) {
            const n = t.doc.resolve(i.from).marks();
            t.replaceWith(i.from, i.to, e.schema.text(i.text, n));
          } else t.delete(i.from, i.to);
        }
        return !0;
      }
    }
    return !1;
  },
  unsetAllMarks: () => _ref85 => {
    let e = _ref85.tr,
      t = _ref85.dispatch;
    const n = e.selection,
      r = n.empty,
      o = n.ranges;
    return r || t && o.forEach(t => {
      e.removeMark(t.$from.pos, t.$to.pos);
    }), !0;
  },
  unsetMark: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref86 => {
      let n = _ref86.tr,
        r = _ref86.state,
        o = _ref86.dispatch;
      var i;
      const _t$extendEmptyMarkRan = t.extendEmptyMarkRange,
        a = _t$extendEmptyMarkRan === void 0 ? !1 : _t$extendEmptyMarkRan,
        c = n.selection,
        s = dT(e, r.schema),
        l = c.$from,
        u = c.empty,
        d = c.ranges;
      if (!o) return !0;
      if (u && a) {
        let e = c.from,
          t = c.to;
        const r = null === (i = l.marks().find(e => e.type === s)) || void 0 === i ? void 0 : i.attrs,
          o = uT(l, s, r);
        o && (e = o.from, t = o.to), n.removeMark(e, t, s);
      } else d.forEach(e => {
        n.removeMark(e.$from.pos, e.$to.pos, s);
      });
      return n.removeStoredMark(s), !0;
    };
  },
  updateAttributes: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref87 => {
      let n = _ref87.tr,
        r = _ref87.state,
        o = _ref87.dispatch;
      let i = null,
        a = null;
      const c = bT("string" == typeof e ? e : e.name, r.schema);
      return !!c && ("node" === c && (i = TO(e, r.schema)), "mark" === c && (a = dT(e, r.schema)), o && n.selection.ranges.forEach(e => {
        const o = e.$from.pos,
          c = e.$to.pos;
        r.doc.nodesBetween(o, c, (e, r) => {
          i && i === e.type && n.setNodeMarkup(r, void 0, _objectSpread(_objectSpread({}, e.attrs), t)), a && e.marks.length && e.marks.forEach(i => {
            if (a === i.type) {
              const s = Math.max(r, o),
                l = Math.min(r + e.nodeSize, c);
              n.addMark(s, l, a.create(_objectSpread(_objectSpread({}, i.attrs), t)));
            }
          });
        });
      }), !0);
    };
  },
  wrapIn: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref88 => {
      let n = _ref88.state,
        r = _ref88.dispatch;
      return function (e) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return function (n, r) {
          let _n$selection3 = n.selection,
            o = _n$selection3.$from,
            i = _n$selection3.$to,
            a = o.blockRange(i),
            c = a && UN(a, e, t);
          return !!c && (r && r(n.tr.wrap(a, c).scrollIntoView()), !0);
        };
      }(TO(e, n.schema), t)(n, r);
    };
  },
  wrapInList: function (e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _ref89 => {
      let n = _ref89.state,
        r = _ref89.dispatch;
      return kO(TO(e, n.schema), t)(n, r);
    };
  }
});
const LT = rT.create({
    name: "commands",
    addCommands: () => _objectSpread({}, VT)
  }),
  PT = rT.create({
    name: "editable",
    addProseMirrorPlugins() {
      return [new LS({
        key: new TS("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })];
    }
  }),
  OT = rT.create({
    name: "focusEvents",
    addProseMirrorPlugins() {
      const e = this.editor;
      return [new LS({
        key: new TS("focusEvents"),
        props: {
          handleDOMEvents: {
            focus: (t, n) => {
              e.isFocused = !0;
              const r = e.state.tr.setMeta("focus", {
                event: n
              }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            },
            blur: (t, n) => {
              e.isFocused = !1;
              const r = e.state.tr.setMeta("blur", {
                event: n
              }).setMeta("addToHistory", !1);
              return t.dispatch(r), !1;
            }
          }
        }
      })];
    }
  }),
  TT = rT.create({
    name: "keymap",
    addKeyboardShortcuts() {
      const e = () => this.editor.commands.first(_ref90 => {
          let e = _ref90.commands;
          return [() => e.undoInputRule(), () => e.command(_ref91 => {
            let t = _ref91.tr;
            const n = t.selection,
              r = t.doc,
              o = n.empty,
              i = n.$anchor,
              a = i.pos,
              c = i.parent,
              s = AS.atStart(r).from === a;
            return !(!(o && s && c.type.isTextblock) || c.textContent.length) && e.clearNodes();
          }), () => e.deleteSelection(), () => e.joinBackward(), () => e.selectNodeBackward()];
        }),
        t = () => this.editor.commands.first(_ref92 => {
          let e = _ref92.commands;
          return [() => e.deleteSelection(), () => e.deleteCurrentNode(), () => e.joinForward(), () => e.selectNodeForward()];
        }),
        n = {
          Enter: () => this.editor.commands.first(_ref93 => {
            let e = _ref93.commands;
            return [() => e.newlineInCode(), () => e.createParagraphNear(), () => e.liftEmptyBlock(), () => e.splitBlock()];
          }),
          "Mod-Enter": () => this.editor.commands.exitCode(),
          Backspace: e,
          "Mod-Backspace": e,
          "Shift-Backspace": e,
          Delete: t,
          "Mod-Delete": t,
          "Mod-a": () => this.editor.commands.selectAll()
        },
        r = _objectSpread({}, n),
        o = _objectSpread(_objectSpread({}, n), {}, {
          "Ctrl-h": e,
          "Alt-Backspace": e,
          "Ctrl-d": t,
          "Ctrl-Alt-Backspace": t,
          "Alt-Delete": t,
          "Alt-d": t,
          "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
          "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
        });
      return hT() || vT() ? o : r;
    },
    addProseMirrorPlugins() {
      return [new LS({
        key: new TS("clearDocument"),
        appendTransaction: (e, t, n) => {
          if (!(e.some(e => e.docChanged) && !t.doc.eq(n.doc))) return;
          const _t$selection2 = t.selection,
            r = _t$selection2.empty,
            o = _t$selection2.from,
            i = _t$selection2.to,
            a = AS.atStart(t.doc).from,
            c = AS.atEnd(t.doc).to;
          if (r || !(o === a && i === c)) return;
          if (!(0 === n.doc.textBetween(0, n.doc.content.size, " ", " ").length)) return;
          const s = n.tr,
            l = SO({
              state: n,
              transaction: s
            }),
            _VO3 = new VO({
              editor: this.editor,
              state: l
            }),
            u = _VO3.commands;
          return u.clearNodes(), s.steps.length ? s : void 0;
        }
      })];
    }
  }),
  DT = rT.create({
    name: "tabindex",
    addProseMirrorPlugins() {
      return [new LS({
        key: new TS("tabindex"),
        props: {
          attributes: this.editor.isEditable ? {
            tabindex: "0"
          } : {}
        }
      })];
    }
  });
var RT = Object.freeze({
  __proto__: null,
  ClipboardTextSerializer: aT,
  Commands: LT,
  Editable: PT,
  FocusEvents: OT,
  Keymap: TT,
  Tabindex: DT
});
function GT(e) {
  return new UO({
    find: e.find,
    handler: _ref94 => {
      let t = _ref94.state,
        n = _ref94.range,
        r = _ref94.match;
      const o = FO(e.getAttributes, void 0, r);
      if (!1 === o || null === o) return null;
      const i = t.tr,
        a = r[r.length - 1],
        c = r[0];
      let s = n.to;
      if (a) {
        const r = c.search(/\S/),
          l = n.from + c.indexOf(a),
          u = l + a.length;
        if (QT(n.from, n.to, t.doc).filter(t => t.mark.type.excluded.find(n => n === e.type && n !== t.mark.type)).filter(e => e.to > l).length) return null;
        u < n.to && i.delete(u, n.to), l > n.from && i.delete(n.from + r, l), s = n.from + r + a.length, i.addMark(n.from + r, s, e.type.create(o || {})), i.removeStoredMark(e.type);
      }
    }
  });
}
function FT(e) {
  return new UO({
    find: e.find,
    handler: _ref95 => {
      let t = _ref95.state,
        n = _ref95.range,
        r = _ref95.match;
      const o = FO(e.getAttributes, void 0, r) || {},
        i = t.tr,
        a = n.from;
      let c = n.to;
      if (r[1]) {
        let t = a + r[0].lastIndexOf(r[1]);
        t > c ? t = c : c = t + r[1].length;
        const n = r[0][r[0].length - 1];
        i.insertText(n, a + r[0].length - 1), i.replaceWith(t, c, e.type.create(o));
      } else r[0] && i.replaceWith(a, c, e.type.create(o));
    }
  });
}
function jT(e) {
  return new UO({
    find: e.find,
    handler: _ref96 => {
      let t = _ref96.state,
        n = _ref96.range,
        r = _ref96.match;
      const o = t.doc.resolve(n.from),
        i = FO(e.getAttributes, void 0, r) || {};
      if (!o.node(-1).canReplaceWith(o.index(-1), o.indexAfter(-1), e.type)) return null;
      t.tr.delete(n.from, n.to).setBlockType(n.from, n.from, e.type, i);
    }
  });
}
function JT(e) {
  return new UO({
    find: e.find,
    handler: _ref97 => {
      let t = _ref97.state,
        n = _ref97.range,
        r = _ref97.match,
        o = _ref97.chain;
      const i = FO(e.getAttributes, void 0, r) || {},
        a = t.tr.delete(n.from, n.to),
        c = a.doc.resolve(n.from).blockRange(),
        s = c && UN(c, e.type, i);
      if (!s) return null;
      if (a.wrap(c, s), e.keepMarks && e.editor) {
        const n = t.selection,
          r = t.storedMarks,
          o = e.editor.extensionManager.splittableMarks,
          i = r || n.$to.parentOffset && n.$from.marks();
        if (i) {
          const e = i.filter(e => o.includes(e.type.name));
          a.ensureMarks(e);
        }
      }
      if (e.keepAttributes) {
        const t = "bulletList" === e.type.name || "orderedList" === e.type.name ? "listItem" : "taskList";
        o().updateAttributes(t, i).run();
      }
      const l = a.doc.resolve(n.from - 1).nodeBefore;
      l && l.type === e.type && qN(a.doc, n.from - 1) && (!e.joinPredicate || e.joinPredicate(r, l)) && a.join(n.from - 1);
    }
  });
}
class ZT {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = _objectSpread(_objectSpread({}, this.config), e), this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = FO(LO(this, "addOptions", {
      name: this.name
    }))), this.storage = FO(LO(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new ZT(e);
  }
  configure() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const t = this.extend();
    return t.options = nT(this.options, e), t.storage = FO(LO(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const t = new ZT(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = FO(LO(t, "addOptions", {
      name: t.name
    })), t.storage = FO(LO(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  static handleExit(_ref98) {
    let e = _ref98.editor,
      t = _ref98.mark;
    const n = e.state.tr,
      r = e.state.selection.$from;
    if (r.pos === r.end()) {
      const o = r.marks(),
        i = !!o.find(e => (null == e ? void 0 : e.type.name) === t.name);
      if (!i) return !1;
      const a = o.find(e => (null == e ? void 0 : e.type.name) === t.name);
      return a && n.removeStoredMark(a), n.insertText(" ", r.pos), e.view.dispatch(n), !0;
    }
    return !1;
  }
}
class WT {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = _objectSpread(_objectSpread({}, this.config), e), this.name = this.config.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = FO(LO(this, "addOptions", {
      name: this.name
    }))), this.storage = FO(LO(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new WT(e);
  }
  configure() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const t = this.extend();
    return t.options = nT(this.options, e), t.storage = FO(LO(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
  extend() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const t = new WT(e);
    return t.parent = this, this.child = t, t.name = e.name ? e.name : t.parent.name, e.defaultOptions && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${t.name}".`), t.options = FO(LO(t, "addOptions", {
      name: t.name
    })), t.storage = FO(LO(t, "addStorage", {
      name: t.name,
      options: t.options
    })), t;
  }
}
function XT(e) {
  return new qO({
    find: e.find,
    handler: _ref99 => {
      let t = _ref99.state,
        n = _ref99.range,
        r = _ref99.match;
      const o = FO(e.getAttributes, void 0, r);
      if (!1 === o || null === o) return null;
      const i = t.tr,
        a = r[r.length - 1],
        c = r[0];
      let s = n.to;
      if (a) {
        const r = c.search(/\S/),
          l = n.from + c.indexOf(a),
          u = l + a.length;
        if (QT(n.from, n.to, t.doc).filter(t => t.mark.type.excluded.find(n => n === e.type && n !== t.mark.type)).filter(e => e.to > l).length) return null;
        u < n.to && i.delete(u, n.to), l > n.from && i.delete(n.from + r, l), s = n.from + r + a.length, i.addMark(n.from + r, s, e.type.create(o || {})), i.removeStoredMark(e.type);
      }
    }
  });
}
var UT = "top",
  KT = "bottom",
  YT = "right",
  qT = "left",
  _T = [UT, KT, YT, qT],
  $T = _T.reduce(function (e, t) {
    return e.concat([t + "-start", t + "-end"]);
  }, []),
  eD = [].concat(_T, ["auto"]).reduce(function (e, t) {
    return e.concat([t, t + "-start", t + "-end"]);
  }, []),
  tD = ["beforeRead", "read", "afterRead", "beforeMain", "main", "afterMain", "beforeWrite", "write", "afterWrite"];
function nD(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function rD(e) {
  if (null == e) return window;
  if ("[object Window]" !== e.toString()) {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function oD(e) {
  return e instanceof rD(e).Element || e instanceof Element;
}
function iD(e) {
  return e instanceof rD(e).HTMLElement || e instanceof HTMLElement;
}
function aD(e) {
  return "undefined" != typeof ShadowRoot && (e instanceof rD(e).ShadowRoot || e instanceof ShadowRoot);
}
var cD = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: function (e) {
    var t = e.state;
    Object.keys(t.elements).forEach(function (e) {
      var n = t.styles[e] || {},
        r = t.attributes[e] || {},
        o = t.elements[e];
      iD(o) && nD(o) && (Object.assign(o.style, n), Object.keys(r).forEach(function (e) {
        var t = r[e];
        !1 === t ? o.removeAttribute(e) : o.setAttribute(e, !0 === t ? "" : t);
      }));
    });
  },
  effect: function (e) {
    var t = e.state,
      n = {
        popper: {
          position: t.options.strategy,
          left: "0",
          top: "0",
          margin: "0"
        },
        arrow: {
          position: "absolute"
        },
        reference: {}
      };
    return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function () {
      Object.keys(t.elements).forEach(function (e) {
        var r = t.elements[e],
          o = t.attributes[e] || {},
          i = Object.keys(t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]).reduce(function (e, t) {
            return e[t] = "", e;
          }, {});
        iD(r) && nD(r) && (Object.assign(r.style, i), Object.keys(o).forEach(function (e) {
          r.removeAttribute(e);
        }));
      });
    };
  },
  requires: ["computeStyles"]
};
function sD(e) {
  return e.split("-")[0];
}
var lD = Math.max,
  uD = Math.min,
  dD = Math.round;
function fD(e, t) {
  void 0 === t && (t = !1);
  var n = e.getBoundingClientRect(),
    r = 1,
    o = 1;
  if (iD(e) && t) {
    var i = e.offsetHeight,
      a = e.offsetWidth;
    a > 0 && (r = dD(n.width) / a || 1), i > 0 && (o = dD(n.height) / i || 1);
  }
  return {
    width: n.width / r,
    height: n.height / o,
    top: n.top / o,
    right: n.right / r,
    bottom: n.bottom / o,
    left: n.left / r,
    x: n.left / r,
    y: n.top / o
  };
}
function pD(e) {
  var t = fD(e),
    n = e.offsetWidth,
    r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function mD(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t)) return !0;
  if (n && aD(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r)) return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function hD(e) {
  return rD(e).getComputedStyle(e);
}
function AD(e) {
  return ["table", "td", "th"].indexOf(nD(e)) >= 0;
}
function gD(e) {
  return ((oD(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function vD(e) {
  return "html" === nD(e) ? e : e.assignedSlot || e.parentNode || (aD(e) ? e.host : null) || gD(e);
}
function CD(e) {
  return iD(e) && "fixed" !== hD(e).position ? e.offsetParent : null;
}
function bD(e) {
  for (var t = rD(e), n = CD(e); n && AD(n) && "static" === hD(n).position;) n = CD(n);
  return n && ("html" === nD(n) || "body" === nD(n) && "static" === hD(n).position) ? t : n || function (e) {
    var t = -1 !== navigator.userAgent.toLowerCase().indexOf("firefox");
    if (-1 !== navigator.userAgent.indexOf("Trident") && iD(e) && "fixed" === hD(e).position) return null;
    var n = vD(e);
    for (aD(n) && (n = n.host); iD(n) && ["html", "body"].indexOf(nD(n)) < 0;) {
      var r = hD(n);
      if ("none" !== r.transform || "none" !== r.perspective || "paint" === r.contain || -1 !== ["transform", "perspective"].indexOf(r.willChange) || t && "filter" === r.willChange || t && r.filter && "none" !== r.filter) return n;
      n = n.parentNode;
    }
    return null;
  }(e) || t;
}
function ED(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function yD(e, t, n) {
  return lD(e, uD(t, n));
}
function ID(e) {
  return Object.assign({}, {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, e);
}
function BD(e, t) {
  return t.reduce(function (t, n) {
    return t[n] = e, t;
  }, {});
}
var xD = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: function (e) {
    var t,
      n = e.state,
      r = e.name,
      o = e.options,
      i = n.elements.arrow,
      a = n.modifiersData.popperOffsets,
      c = sD(n.placement),
      s = ED(c),
      l = [qT, YT].indexOf(c) >= 0 ? "height" : "width";
    if (i && a) {
      var u = function (e, t) {
          return ID("number" != typeof (e = "function" == typeof e ? e(Object.assign({}, t.rects, {
            placement: t.placement
          })) : e) ? e : BD(e, _T));
        }(o.padding, n),
        d = pD(i),
        f = "y" === s ? UT : qT,
        p = "y" === s ? KT : YT,
        m = n.rects.reference[l] + n.rects.reference[s] - a[s] - n.rects.popper[l],
        h = a[s] - n.rects.reference[s],
        A = bD(i),
        g = A ? "y" === s ? A.clientHeight || 0 : A.clientWidth || 0 : 0,
        v = m / 2 - h / 2,
        C = u[f],
        b = g - d[l] - u[p],
        E = g / 2 - d[l] / 2 + v,
        y = yD(C, E, b),
        I = s;
      n.modifiersData[r] = ((t = {})[I] = y, t.centerOffset = y - E, t);
    }
  },
  effect: function (e) {
    var t = e.state,
      n = e.options.element,
      r = void 0 === n ? "[data-popper-arrow]" : n;
    null != r && ("string" != typeof r || (r = t.elements.popper.querySelector(r))) && ("production" !== process.env.NODE_ENV && (iD(r) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), mD(t.elements.popper, r) ? t.elements.arrow = r : "production" !== process.env.NODE_ENV && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" ")));
  },
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function wD(e) {
  return e.split("-")[1];
}
var QD = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function HD(e) {
  var t,
    n = e.popper,
    r = e.popperRect,
    o = e.placement,
    i = e.variation,
    a = e.offsets,
    c = e.position,
    s = e.gpuAcceleration,
    l = e.adaptive,
    u = e.roundOffsets,
    d = e.isFixed,
    f = a.x,
    p = void 0 === f ? 0 : f,
    m = a.y,
    h = void 0 === m ? 0 : m,
    A = "function" == typeof u ? u({
      x: p,
      y: h
    }) : {
      x: p,
      y: h
    };
  p = A.x, h = A.y;
  var g = a.hasOwnProperty("x"),
    v = a.hasOwnProperty("y"),
    C = qT,
    b = UT,
    E = window;
  if (l) {
    var y = bD(n),
      I = "clientHeight",
      B = "clientWidth";
    if (y === rD(n) && "static" !== hD(y = gD(n)).position && "absolute" === c && (I = "scrollHeight", B = "scrollWidth"), y = y, o === UT || (o === qT || o === YT) && "end" === i) b = KT, h -= (d && y === E && E.visualViewport ? E.visualViewport.height : y[I]) - r.height, h *= s ? 1 : -1;
    if (o === qT || (o === UT || o === KT) && "end" === i) C = YT, p -= (d && y === E && E.visualViewport ? E.visualViewport.width : y[B]) - r.width, p *= s ? 1 : -1;
  }
  var x,
    w = Object.assign({
      position: c
    }, l && QD),
    Q = !0 === u ? function (e) {
      var t = e.x,
        n = e.y,
        r = window.devicePixelRatio || 1;
      return {
        x: dD(t * r) / r || 0,
        y: dD(n * r) / r || 0
      };
    }({
      x: p,
      y: h
    }) : {
      x: p,
      y: h
    };
  return p = Q.x, h = Q.y, s ? Object.assign({}, w, ((x = {})[b] = v ? "0" : "", x[C] = g ? "0" : "", x.transform = (E.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + h + "px)" : "translate3d(" + p + "px, " + h + "px, 0)", x)) : Object.assign({}, w, ((t = {})[b] = v ? h + "px" : "", t[C] = g ? p + "px" : "", t.transform = "", t));
}
var zD = {
    name: "computeStyles",
    enabled: !0,
    phase: "beforeWrite",
    fn: function (e) {
      var t = e.state,
        n = e.options,
        r = n.gpuAcceleration,
        o = void 0 === r || r,
        i = n.adaptive,
        a = void 0 === i || i,
        c = n.roundOffsets,
        s = void 0 === c || c;
      if ("production" !== process.env.NODE_ENV) {
        var l = hD(t.elements.popper).transitionProperty || "";
        a && ["transform", "top", "right", "bottom", "left"].some(function (e) {
          return l.indexOf(e) >= 0;
        }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', "\n\n", 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", "\n\n", "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
      }
      var u = {
        placement: sD(t.placement),
        variation: wD(t.placement),
        popper: t.elements.popper,
        popperRect: t.rects.popper,
        gpuAcceleration: o,
        isFixed: "fixed" === t.options.strategy
      };
      null != t.modifiersData.popperOffsets && (t.styles.popper = Object.assign({}, t.styles.popper, HD(Object.assign({}, u, {
        offsets: t.modifiersData.popperOffsets,
        position: t.options.strategy,
        adaptive: a,
        roundOffsets: s
      })))), null != t.modifiersData.arrow && (t.styles.arrow = Object.assign({}, t.styles.arrow, HD(Object.assign({}, u, {
        offsets: t.modifiersData.arrow,
        position: "absolute",
        adaptive: !1,
        roundOffsets: s
      })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
        "data-popper-placement": t.placement
      });
    },
    data: {}
  },
  MD = {
    passive: !0
  };
var kD = {
    name: "eventListeners",
    enabled: !0,
    phase: "write",
    fn: function () {},
    effect: function (e) {
      var t = e.state,
        n = e.instance,
        r = e.options,
        o = r.scroll,
        i = void 0 === o || o,
        a = r.resize,
        c = void 0 === a || a,
        s = rD(t.elements.popper),
        l = [].concat(t.scrollParents.reference, t.scrollParents.popper);
      return i && l.forEach(function (e) {
        e.addEventListener("scroll", n.update, MD);
      }), c && s.addEventListener("resize", n.update, MD), function () {
        i && l.forEach(function (e) {
          e.removeEventListener("scroll", n.update, MD);
        }), c && s.removeEventListener("resize", n.update, MD);
      };
    },
    data: {}
  },
  ND = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  };
function SD(e) {
  return e.replace(/left|right|bottom|top/g, function (e) {
    return ND[e];
  });
}
var VD = {
  start: "end",
  end: "start"
};
function LD(e) {
  return e.replace(/start|end/g, function (e) {
    return VD[e];
  });
}
function PD(e) {
  var t = rD(e);
  return {
    scrollLeft: t.pageXOffset,
    scrollTop: t.pageYOffset
  };
}
function OD(e) {
  return fD(gD(e)).left + PD(e).scrollLeft;
}
function TD(e) {
  var t = hD(e),
    n = t.overflow,
    r = t.overflowX,
    o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function DD(e) {
  return ["html", "body", "#document"].indexOf(nD(e)) >= 0 ? e.ownerDocument.body : iD(e) && TD(e) ? e : DD(vD(e));
}
function RD(e, t) {
  var n;
  void 0 === t && (t = []);
  var r = DD(e),
    o = r === (null == (n = e.ownerDocument) ? void 0 : n.body),
    i = rD(r),
    a = o ? [i].concat(i.visualViewport || [], TD(r) ? r : []) : r,
    c = t.concat(a);
  return o ? c : c.concat(RD(vD(a)));
}
function GD(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function FD(e, t) {
  return "viewport" === t ? GD(function (e) {
    var t = rD(e),
      n = gD(e),
      r = t.visualViewport,
      o = n.clientWidth,
      i = n.clientHeight,
      a = 0,
      c = 0;
    return r && (o = r.width, i = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (a = r.offsetLeft, c = r.offsetTop)), {
      width: o,
      height: i,
      x: a + OD(e),
      y: c
    };
  }(e)) : oD(t) ? function (e) {
    var t = fD(e);
    return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
  }(t) : GD(function (e) {
    var t,
      n = gD(e),
      r = PD(e),
      o = null == (t = e.ownerDocument) ? void 0 : t.body,
      i = lD(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0),
      a = lD(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0),
      c = -r.scrollLeft + OD(e),
      s = -r.scrollTop;
    return "rtl" === hD(o || n).direction && (c += lD(n.clientWidth, o ? o.clientWidth : 0) - i), {
      width: i,
      height: a,
      x: c,
      y: s
    };
  }(gD(e)));
}
function jD(e, t, n) {
  var r = "clippingParents" === t ? function (e) {
      var t = RD(vD(e)),
        n = ["absolute", "fixed"].indexOf(hD(e).position) >= 0 && iD(e) ? bD(e) : e;
      return oD(n) ? t.filter(function (e) {
        return oD(e) && mD(e, n) && "body" !== nD(e);
      }) : [];
    }(e) : [].concat(t),
    o = [].concat(r, [n]),
    i = o[0],
    a = o.reduce(function (t, n) {
      var r = FD(e, n);
      return t.top = lD(r.top, t.top), t.right = uD(r.right, t.right), t.bottom = uD(r.bottom, t.bottom), t.left = lD(r.left, t.left), t;
    }, FD(e, i));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function JD(e) {
  var t,
    n = e.reference,
    r = e.element,
    o = e.placement,
    i = o ? sD(o) : null,
    a = o ? wD(o) : null,
    c = n.x + n.width / 2 - r.width / 2,
    s = n.y + n.height / 2 - r.height / 2;
  switch (i) {
    case UT:
      t = {
        x: c,
        y: n.y - r.height
      };
      break;
    case KT:
      t = {
        x: c,
        y: n.y + n.height
      };
      break;
    case YT:
      t = {
        x: n.x + n.width,
        y: s
      };
      break;
    case qT:
      t = {
        x: n.x - r.width,
        y: s
      };
      break;
    default:
      t = {
        x: n.x,
        y: n.y
      };
  }
  var l = i ? ED(i) : null;
  if (null != l) {
    var u = "y" === l ? "height" : "width";
    switch (a) {
      case "start":
        t[l] = t[l] - (n[u] / 2 - r[u] / 2);
        break;
      case "end":
        t[l] = t[l] + (n[u] / 2 - r[u] / 2);
    }
  }
  return t;
}
function ZD(e, t) {
  void 0 === t && (t = {});
  var n = t,
    r = n.placement,
    o = void 0 === r ? e.placement : r,
    i = n.boundary,
    a = void 0 === i ? "clippingParents" : i,
    c = n.rootBoundary,
    s = void 0 === c ? "viewport" : c,
    l = n.elementContext,
    u = void 0 === l ? "popper" : l,
    d = n.altBoundary,
    f = void 0 !== d && d,
    p = n.padding,
    m = void 0 === p ? 0 : p,
    h = ID("number" != typeof m ? m : BD(m, _T)),
    A = "popper" === u ? "reference" : "popper",
    g = e.rects.popper,
    v = e.elements[f ? A : u],
    C = jD(oD(v) ? v : v.contextElement || gD(e.elements.popper), a, s),
    b = fD(e.elements.reference),
    E = JD({
      reference: b,
      element: g,
      strategy: "absolute",
      placement: o
    }),
    y = GD(Object.assign({}, g, E)),
    I = "popper" === u ? y : b,
    B = {
      top: C.top - I.top + h.top,
      bottom: I.bottom - C.bottom + h.bottom,
      left: C.left - I.left + h.left,
      right: I.right - C.right + h.right
    },
    x = e.modifiersData.offset;
  if ("popper" === u && x) {
    var w = x[o];
    Object.keys(B).forEach(function (e) {
      var t = [YT, KT].indexOf(e) >= 0 ? 1 : -1,
        n = [UT, KT].indexOf(e) >= 0 ? "y" : "x";
      B[e] += w[n] * t;
    });
  }
  return B;
}
function WD(e, t) {
  void 0 === t && (t = {});
  var n = t,
    r = n.placement,
    o = n.boundary,
    i = n.rootBoundary,
    a = n.padding,
    c = n.flipVariations,
    s = n.allowedAutoPlacements,
    l = void 0 === s ? eD : s,
    u = wD(r),
    d = u ? c ? $T : $T.filter(function (e) {
      return wD(e) === u;
    }) : _T,
    f = d.filter(function (e) {
      return l.indexOf(e) >= 0;
    });
  0 === f.length && (f = d, "production" !== process.env.NODE_ENV && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var p = f.reduce(function (t, n) {
    return t[n] = ZD(e, {
      placement: n,
      boundary: o,
      rootBoundary: i,
      padding: a
    })[sD(n)], t;
  }, {});
  return Object.keys(p).sort(function (e, t) {
    return p[e] - p[t];
  });
}
var XD = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: function (e) {
    var t = e.state,
      n = e.options,
      r = e.name;
    if (!t.modifiersData[r]._skip) {
      for (var o = n.mainAxis, i = void 0 === o || o, a = n.altAxis, c = void 0 === a || a, s = n.fallbackPlacements, l = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.flipVariations, m = void 0 === p || p, h = n.allowedAutoPlacements, A = t.options.placement, g = sD(A), v = s || (g === A || !m ? [SD(A)] : function (e) {
          if ("auto" === sD(e)) return [];
          var t = SD(e);
          return [LD(e), t, LD(t)];
        }(A)), C = [A].concat(v).reduce(function (e, n) {
          return e.concat("auto" === sD(n) ? WD(t, {
            placement: n,
            boundary: u,
            rootBoundary: d,
            padding: l,
            flipVariations: m,
            allowedAutoPlacements: h
          }) : n);
        }, []), b = t.rects.reference, E = t.rects.popper, y = new Map(), I = !0, B = C[0], x = 0; x < C.length; x++) {
        var w = C[x],
          Q = sD(w),
          H = "start" === wD(w),
          z = [UT, KT].indexOf(Q) >= 0,
          M = z ? "width" : "height",
          k = ZD(t, {
            placement: w,
            boundary: u,
            rootBoundary: d,
            altBoundary: f,
            padding: l
          }),
          N = z ? H ? YT : qT : H ? KT : UT;
        b[M] > E[M] && (N = SD(N));
        var S = SD(N),
          V = [];
        if (i && V.push(k[Q] <= 0), c && V.push(k[N] <= 0, k[S] <= 0), V.every(function (e) {
          return e;
        })) {
          B = w, I = !1;
          break;
        }
        y.set(w, V);
      }
      if (I) for (var L = function (e) {
          var t = C.find(function (t) {
            var n = y.get(t);
            if (n) return n.slice(0, e).every(function (e) {
              return e;
            });
          });
          if (t) return B = t, "break";
        }, P = m ? 3 : 1; P > 0; P--) {
        if ("break" === L(P)) break;
      }
      t.placement !== B && (t.modifiersData[r]._skip = !0, t.placement = B, t.reset = !0);
    }
  },
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function UD(e, t, n) {
  return void 0 === n && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function KD(e) {
  return [UT, YT, KT, qT].some(function (t) {
    return e[t] >= 0;
  });
}
var YD = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: function (e) {
    var t = e.state,
      n = e.name,
      r = t.rects.reference,
      o = t.rects.popper,
      i = t.modifiersData.preventOverflow,
      a = ZD(t, {
        elementContext: "reference"
      }),
      c = ZD(t, {
        altBoundary: !0
      }),
      s = UD(a, r),
      l = UD(c, o, i),
      u = KD(s),
      d = KD(l);
    t.modifiersData[n] = {
      referenceClippingOffsets: s,
      popperEscapeOffsets: l,
      isReferenceHidden: u,
      hasPopperEscaped: d
    }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
      "data-popper-reference-hidden": u,
      "data-popper-escaped": d
    });
  }
};
var qD = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: function (e) {
    var t = e.state,
      n = e.options,
      r = e.name,
      o = n.offset,
      i = void 0 === o ? [0, 0] : o,
      a = eD.reduce(function (e, n) {
        return e[n] = function (e, t, n) {
          var r = sD(e),
            o = [qT, UT].indexOf(r) >= 0 ? -1 : 1,
            i = "function" == typeof n ? n(Object.assign({}, t, {
              placement: e
            })) : n,
            a = i[0],
            c = i[1];
          return a = a || 0, c = (c || 0) * o, [qT, YT].indexOf(r) >= 0 ? {
            x: c,
            y: a
          } : {
            x: a,
            y: c
          };
        }(n, t.rects, i), e;
      }, {}),
      c = a[t.placement],
      s = c.x,
      l = c.y;
    null != t.modifiersData.popperOffsets && (t.modifiersData.popperOffsets.x += s, t.modifiersData.popperOffsets.y += l), t.modifiersData[r] = a;
  }
};
var _D = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: function (e) {
    var t = e.state,
      n = e.name;
    t.modifiersData[n] = JD({
      reference: t.rects.reference,
      element: t.rects.popper,
      strategy: "absolute",
      placement: t.placement
    });
  },
  data: {}
};
var $D = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: function (e) {
    var t = e.state,
      n = e.options,
      r = e.name,
      o = n.mainAxis,
      i = void 0 === o || o,
      a = n.altAxis,
      c = void 0 !== a && a,
      s = n.boundary,
      l = n.rootBoundary,
      u = n.altBoundary,
      d = n.padding,
      f = n.tether,
      p = void 0 === f || f,
      m = n.tetherOffset,
      h = void 0 === m ? 0 : m,
      A = ZD(t, {
        boundary: s,
        rootBoundary: l,
        padding: d,
        altBoundary: u
      }),
      g = sD(t.placement),
      v = wD(t.placement),
      C = !v,
      b = ED(g),
      E = "x" === b ? "y" : "x",
      y = t.modifiersData.popperOffsets,
      I = t.rects.reference,
      B = t.rects.popper,
      x = "function" == typeof h ? h(Object.assign({}, t.rects, {
        placement: t.placement
      })) : h,
      w = "number" == typeof x ? {
        mainAxis: x,
        altAxis: x
      } : Object.assign({
        mainAxis: 0,
        altAxis: 0
      }, x),
      Q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null,
      H = {
        x: 0,
        y: 0
      };
    if (y) {
      if (i) {
        var z,
          M = "y" === b ? UT : qT,
          k = "y" === b ? KT : YT,
          N = "y" === b ? "height" : "width",
          S = y[b],
          V = S + A[M],
          L = S - A[k],
          P = p ? -B[N] / 2 : 0,
          O = "start" === v ? I[N] : B[N],
          T = "start" === v ? -B[N] : -I[N],
          D = t.elements.arrow,
          R = p && D ? pD(D) : {
            width: 0,
            height: 0
          },
          G = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          F = G[M],
          j = G[k],
          J = yD(0, I[N], R[N]),
          Z = C ? I[N] / 2 - P - J - F - w.mainAxis : O - J - F - w.mainAxis,
          W = C ? -I[N] / 2 + P + J + j + w.mainAxis : T + J + j + w.mainAxis,
          X = t.elements.arrow && bD(t.elements.arrow),
          U = X ? "y" === b ? X.clientTop || 0 : X.clientLeft || 0 : 0,
          K = null != (z = null == Q ? void 0 : Q[b]) ? z : 0,
          Y = S + W - K,
          q = yD(p ? uD(V, S + Z - K - U) : V, S, p ? lD(L, Y) : L);
        y[b] = q, H[b] = q - S;
      }
      if (c) {
        var _,
          $ = "x" === b ? UT : qT,
          ee = "x" === b ? KT : YT,
          te = y[E],
          ne = "y" === E ? "height" : "width",
          re = te + A[$],
          oe = te - A[ee],
          ie = -1 !== [UT, qT].indexOf(g),
          ae = null != (_ = null == Q ? void 0 : Q[E]) ? _ : 0,
          ce = ie ? re : te - I[ne] - B[ne] - ae + w.altAxis,
          se = ie ? te + I[ne] + B[ne] - ae - w.altAxis : oe,
          le = p && ie ? function (e, t, n) {
            var r = yD(e, t, n);
            return r > n ? n : r;
          }(ce, te, se) : yD(p ? ce : re, te, p ? se : oe);
        y[E] = le, H[E] = le - te;
      }
      t.modifiersData[r] = H;
    }
  },
  requiresIfExists: ["offset"]
};
function eR(e, t, n) {
  void 0 === n && (n = !1);
  var r = iD(t),
    o = iD(t) && function (e) {
      var t = e.getBoundingClientRect(),
        n = dD(t.width) / e.offsetWidth || 1,
        r = dD(t.height) / e.offsetHeight || 1;
      return 1 !== n || 1 !== r;
    }(t),
    i = gD(t),
    a = fD(e, o),
    c = {
      scrollLeft: 0,
      scrollTop: 0
    },
    s = {
      x: 0,
      y: 0
    };
  return (r || !r && !n) && (("body" !== nD(t) || TD(i)) && (c = function (e) {
    return e !== rD(e) && iD(e) ? {
      scrollLeft: (t = e).scrollLeft,
      scrollTop: t.scrollTop
    } : PD(e);
    var t;
  }(t)), iD(t) ? ((s = fD(t, !0)).x += t.clientLeft, s.y += t.clientTop) : i && (s.x = OD(i))), {
    x: a.left + c.scrollLeft - s.x,
    y: a.top + c.scrollTop - s.y,
    width: a.width,
    height: a.height
  };
}
function tR(e) {
  var t = new Map(),
    n = new Set(),
    r = [];
  function o(e) {
    n.add(e.name), [].concat(e.requires || [], e.requiresIfExists || []).forEach(function (e) {
      if (!n.has(e)) {
        var r = t.get(e);
        r && o(r);
      }
    }), r.push(e);
  }
  return e.forEach(function (e) {
    t.set(e.name, e);
  }), e.forEach(function (e) {
    n.has(e.name) || o(e);
  }), r;
}
function nR(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return [].concat(n).reduce(function (e, t) {
    return e.replace(/%s/, t);
  }, e);
}
var rR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s',
  oR = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
var iR = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.",
  aR = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
  };
function cR() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return !t.some(function (e) {
    return !(e && "function" == typeof e.getBoundingClientRect);
  });
}
function sR(e) {
  void 0 === e && (e = {});
  var t = e,
    n = t.defaultModifiers,
    r = void 0 === n ? [] : n,
    o = t.defaultOptions,
    i = void 0 === o ? aR : o;
  return function (e, t, n) {
    void 0 === n && (n = i);
    var o,
      a,
      c = {
        placement: "bottom",
        orderedModifiers: [],
        options: Object.assign({}, aR, i),
        modifiersData: {},
        elements: {
          reference: e,
          popper: t
        },
        attributes: {},
        styles: {}
      },
      s = [],
      l = !1,
      u = {
        state: c,
        setOptions: function (n) {
          var o = "function" == typeof n ? n(c.options) : n;
          d(), c.options = Object.assign({}, i, c.options, o), c.scrollParents = {
            reference: oD(e) ? RD(e) : e.contextElement ? RD(e.contextElement) : [],
            popper: RD(t)
          };
          var a,
            l,
            f,
            p = function (e) {
              var t = tR(e);
              return tD.reduce(function (e, n) {
                return e.concat(t.filter(function (e) {
                  return e.phase === n;
                }));
              }, []);
            }(function (e) {
              var t = e.reduce(function (e, t) {
                var n = e[t.name];
                return e[t.name] = n ? Object.assign({}, n, t, {
                  options: Object.assign({}, n.options, t.options),
                  data: Object.assign({}, n.data, t.data)
                }) : t, e;
              }, {});
              return Object.keys(t).map(function (e) {
                return t[e];
              });
            }([].concat(r, c.options.modifiers)));
          if (c.orderedModifiers = p.filter(function (e) {
            return e.enabled;
          }), "production" !== process.env.NODE_ENV) {
            var m = (a = [].concat(p, c.options.modifiers), l = function (e) {
              return e.name;
            }, f = new Set(), a.filter(function (e) {
              var t = l(e);
              if (!f.has(t)) return f.add(t), !0;
            }));
            if (function (e) {
              e.forEach(function (t) {
                [].concat(Object.keys(t), oR).filter(function (e, t, n) {
                  return n.indexOf(e) === t;
                }).forEach(function (n) {
                  switch (n) {
                    case "name":
                      "string" != typeof t.name && console.error(nR(rR, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
                      break;
                    case "enabled":
                      "boolean" != typeof t.enabled && console.error(nR(rR, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
                      break;
                    case "phase":
                      tD.indexOf(t.phase) < 0 && console.error(nR(rR, t.name, '"phase"', "either " + tD.join(", "), '"' + String(t.phase) + '"'));
                      break;
                    case "fn":
                      "function" != typeof t.fn && console.error(nR(rR, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
                      break;
                    case "effect":
                      null != t.effect && "function" != typeof t.effect && console.error(nR(rR, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
                      break;
                    case "requires":
                      null == t.requires || Array.isArray(t.requires) || console.error(nR(rR, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
                      break;
                    case "requiresIfExists":
                      Array.isArray(t.requiresIfExists) || console.error(nR(rR, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
                      break;
                    case "options":
                    case "data":
                      break;
                    default:
                      console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + oR.map(function (e) {
                        return '"' + e + '"';
                      }).join(", ") + '; but "' + n + '" was provided.');
                  }
                  t.requires && t.requires.forEach(function (n) {
                    null == e.find(function (e) {
                      return e.name === n;
                    }) && console.error(nR('Popper: modifier "%s" requires "%s", but "%s" modifier is not available', String(t.name), n, n));
                  });
                });
              });
            }(m), "auto" === sD(c.options.placement)) {
              var h = c.orderedModifiers.find(function (e) {
                return "flip" === e.name;
              });
              h || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
            }
            var A = hD(t);
            [A.marginTop, A.marginRight, A.marginBottom, A.marginLeft].some(function (e) {
              return parseFloat(e);
            }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
          }
          return c.orderedModifiers.forEach(function (e) {
            var t = e.name,
              n = e.options,
              r = void 0 === n ? {} : n,
              o = e.effect;
            if ("function" == typeof o) {
              var i = o({
                  state: c,
                  name: t,
                  instance: u,
                  options: r
                }),
                a = function () {};
              s.push(i || a);
            }
          }), u.update();
        },
        forceUpdate: function () {
          if (!l) {
            var e = c.elements,
              t = e.reference,
              n = e.popper;
            if (cR(t, n)) {
              c.rects = {
                reference: eR(t, bD(n), "fixed" === c.options.strategy),
                popper: pD(n)
              }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function (e) {
                return c.modifiersData[e.name] = Object.assign({}, e.data);
              });
              for (var r = 0, o = 0; o < c.orderedModifiers.length; o++) {
                if ("production" !== process.env.NODE_ENV && (r += 1) > 100) {
                  console.error("Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.");
                  break;
                }
                if (!0 !== c.reset) {
                  var i = c.orderedModifiers[o],
                    a = i.fn,
                    s = i.options,
                    d = void 0 === s ? {} : s,
                    f = i.name;
                  "function" == typeof a && (c = a({
                    state: c,
                    options: d,
                    name: f,
                    instance: u
                  }) || c);
                } else c.reset = !1, o = -1;
              }
            } else "production" !== process.env.NODE_ENV && console.error(iR);
          }
        },
        update: (o = function () {
          return new Promise(function (e) {
            u.forceUpdate(), e(c);
          });
        }, function () {
          return a || (a = new Promise(function (e) {
            Promise.resolve().then(function () {
              a = void 0, e(o());
            });
          })), a;
        }),
        destroy: function () {
          d(), l = !0;
        }
      };
    if (!cR(e, t)) return "production" !== process.env.NODE_ENV && console.error(iR), u;
    function d() {
      s.forEach(function (e) {
        return e();
      }), s = [];
    }
    return u.setOptions(n).then(function (e) {
      !l && n.onFirstUpdate && n.onFirstUpdate(e);
    }), u;
  };
}
var lR = sR({
    defaultModifiers: [kD, _D, zD, cD, qD, XD, $D, xD, YD]
  }),
  uR = {
    passive: !0,
    capture: !0
  },
  dR = function () {
    return document.body;
  };
function fR(e, t, n) {
  if (Array.isArray(e)) {
    var r = e[t];
    return null == r ? Array.isArray(n) ? n[t] : n : r;
  }
  return e;
}
function pR(e, t) {
  var n = {}.toString.call(e);
  return 0 === n.indexOf("[object") && n.indexOf(t + "]") > -1;
}
function mR(e, t) {
  return "function" == typeof e ? e.apply(void 0, t) : e;
}
function hR(e, t) {
  return 0 === t ? e : function (r) {
    clearTimeout(n), n = setTimeout(function () {
      e(r);
    }, t);
  };
  var n;
}
function AR(e) {
  return [].concat(e);
}
function gR(e, t) {
  -1 === e.indexOf(t) && e.push(t);
}
function vR(e) {
  return e.split("-")[0];
}
function CR(e) {
  return [].slice.call(e);
}
function bR(e) {
  return Object.keys(e).reduce(function (t, n) {
    return void 0 !== e[n] && (t[n] = e[n]), t;
  }, {});
}
function ER() {
  return document.createElement("div");
}
function yR(e) {
  return ["Element", "Fragment"].some(function (t) {
    return pR(e, t);
  });
}
function IR(e) {
  return pR(e, "MouseEvent");
}
function BR(e) {
  return yR(e) ? [e] : function (e) {
    return pR(e, "NodeList");
  }(e) ? CR(e) : Array.isArray(e) ? e : CR(document.querySelectorAll(e));
}
function xR(e, t) {
  e.forEach(function (e) {
    e && (e.style.transitionDuration = t + "ms");
  });
}
function wR(e, t) {
  e.forEach(function (e) {
    e && e.setAttribute("data-state", t);
  });
}
function QR(e, t, n) {
  var r = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function (t) {
    e[r](t, n);
  });
}
function HR(e, t) {
  for (var n = t; n;) {
    var r;
    if (e.contains(n)) return !0;
    n = null == n.getRootNode || null == (r = n.getRootNode()) ? void 0 : r.host;
  }
  return !1;
}
var zR = {
    isTouch: !1
  },
  MR = 0;
function kR() {
  zR.isTouch || (zR.isTouch = !0, window.performance && document.addEventListener("mousemove", NR));
}
function NR() {
  var e = performance.now();
  e - MR < 20 && (zR.isTouch = !1, document.removeEventListener("mousemove", NR)), MR = e;
}
function SR() {
  var e,
    t = document.activeElement;
  if ((e = t) && e._tippy && e._tippy.reference === e) {
    var n = t._tippy;
    t.blur && !n.state.isVisible && t.blur();
  }
}
var VR,
  LR = !!("undefined" != typeof window && "undefined" != typeof document) && !!window.msCrypto;
function PR(e) {
  return [e + "() was called on a" + ("destroy" === e ? "n already-" : " ") + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function OR(e) {
  return e.replace(/[ \t]{2,}/g, " ").replace(/^[ \t]*/gm, "").trim();
}
function TR(e) {
  return OR("\n  %ctippy.js\n\n  %c" + OR(e) + "\n\n  %c👷‍ This is a development-only message. It will be removed in production.\n  ");
}
function DR(e) {
  return [TR(e), "color: #00C584; font-size: 1.3em; font-weight: bold;", "line-height: 1.5", "color: #a6a095;"];
}
function RR(e, t) {
  var n;
  e && !VR.has(t) && (VR.add(t), (n = console).warn.apply(n, DR(t)));
}
function GR(e, t) {
  var n;
  e && !VR.has(t) && (VR.add(t), (n = console).error.apply(n, DR(t)));
}
"production" !== process.env.NODE_ENV && (VR = new Set());
var FR = {
    animateFill: !1,
    followCursor: !1,
    inlinePositioning: !1,
    sticky: !1
  },
  jR = Object.assign({
    appendTo: dR,
    aria: {
      content: "auto",
      expanded: "auto"
    },
    delay: 0,
    duration: [300, 250],
    getReferenceClientRect: null,
    hideOnClick: !0,
    ignoreAttributes: !1,
    interactive: !1,
    interactiveBorder: 2,
    interactiveDebounce: 0,
    moveTransition: "",
    offset: [0, 10],
    onAfterUpdate: function () {},
    onBeforeUpdate: function () {},
    onCreate: function () {},
    onDestroy: function () {},
    onHidden: function () {},
    onHide: function () {},
    onMount: function () {},
    onShow: function () {},
    onShown: function () {},
    onTrigger: function () {},
    onUntrigger: function () {},
    onClickOutside: function () {},
    placement: "top",
    plugins: [],
    popperOptions: {},
    render: null,
    showOnCreate: !1,
    touch: !0,
    trigger: "mouseenter focus",
    triggerTarget: null
  }, FR, {
    allowHTML: !1,
    animation: "fade",
    arrow: !0,
    content: "",
    inertia: !1,
    maxWidth: 350,
    role: "tooltip",
    theme: "",
    zIndex: 9999
  }),
  JR = Object.keys(jR);
function ZR(e) {
  var t = (e.plugins || []).reduce(function (t, n) {
    var r,
      o = n.name,
      i = n.defaultValue;
    o && (t[o] = void 0 !== e[o] ? e[o] : null != (r = jR[o]) ? r : i);
    return t;
  }, {});
  return Object.assign({}, e, t);
}
function WR(e, t) {
  var n = Object.assign({}, t, {
    content: mR(t.content, [e])
  }, t.ignoreAttributes ? {} : function (e, t) {
    return (t ? Object.keys(ZR(Object.assign({}, jR, {
      plugins: t
    }))) : JR).reduce(function (t, n) {
      var r = (e.getAttribute("data-tippy-" + n) || "").trim();
      if (!r) return t;
      if ("content" === n) t[n] = r;else try {
        t[n] = JSON.parse(r);
      } catch (e) {
        t[n] = r;
      }
      return t;
    }, {});
  }(e, t.plugins));
  return n.aria = Object.assign({}, jR.aria, n.aria), n.aria = {
    expanded: "auto" === n.aria.expanded ? t.interactive : n.aria.expanded,
    content: "auto" === n.aria.content ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function XR(e, t) {
  void 0 === e && (e = {}), void 0 === t && (t = []), Object.keys(e).forEach(function (e) {
    var n,
      r,
      o = function (e, t) {
        var n = Object.assign({}, e);
        return t.forEach(function (e) {
          delete n[e];
        }), n;
      }(jR, Object.keys(FR)),
      i = (n = o, r = e, !{}.hasOwnProperty.call(n, r));
    i && (i = 0 === t.filter(function (t) {
      return t.name === e;
    }).length), RR(i, ["`" + e + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", "\n\n", "All props: https://atomiks.github.io/tippyjs/v6/all-props/\n", "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
function UR(e, t) {
  e.innerHTML = t;
}
function KR(e) {
  var t = ER();
  return !0 === e ? t.className = "tippy-arrow" : (t.className = "tippy-svg-arrow", yR(e) ? t.appendChild(e) : UR(t, e)), t;
}
function YR(e, t) {
  yR(t.content) ? (UR(e, ""), e.appendChild(t.content)) : "function" != typeof t.content && (t.allowHTML ? UR(e, t.content) : e.textContent = t.content);
}
function qR(e) {
  var t = e.firstElementChild,
    n = CR(t.children);
  return {
    box: t,
    content: n.find(function (e) {
      return e.classList.contains("tippy-content");
    }),
    arrow: n.find(function (e) {
      return e.classList.contains("tippy-arrow") || e.classList.contains("tippy-svg-arrow");
    }),
    backdrop: n.find(function (e) {
      return e.classList.contains("tippy-backdrop");
    })
  };
}
function _R(e) {
  var t = ER(),
    n = ER();
  n.className = "tippy-box", n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = ER();
  function o(n, r) {
    var o = qR(t),
      i = o.box,
      a = o.content,
      c = o.arrow;
    r.theme ? i.setAttribute("data-theme", r.theme) : i.removeAttribute("data-theme"), "string" == typeof r.animation ? i.setAttribute("data-animation", r.animation) : i.removeAttribute("data-animation"), r.inertia ? i.setAttribute("data-inertia", "") : i.removeAttribute("data-inertia"), i.style.maxWidth = "number" == typeof r.maxWidth ? r.maxWidth + "px" : r.maxWidth, r.role ? i.setAttribute("role", r.role) : i.removeAttribute("role"), n.content === r.content && n.allowHTML === r.allowHTML || YR(a, e.props), r.arrow ? c ? n.arrow !== r.arrow && (i.removeChild(c), i.appendChild(KR(r.arrow))) : i.appendChild(KR(r.arrow)) : c && i.removeChild(c);
  }
  return r.className = "tippy-content", r.setAttribute("data-state", "hidden"), YR(r, e.props), t.appendChild(n), n.appendChild(r), o(e.props, e.props), {
    popper: t,
    onUpdate: o
  };
}
_R.$$tippy = !0;
var $R = 1,
  eG = [],
  tG = [];
function nG(e, t) {
  var n,
    r,
    o,
    i,
    a,
    c,
    s,
    l,
    u = WR(e, Object.assign({}, jR, ZR(bR(t)))),
    d = !1,
    f = !1,
    p = !1,
    m = !1,
    h = [],
    A = hR(X, u.interactiveDebounce),
    g = $R++,
    v = (l = u.plugins).filter(function (e, t) {
      return l.indexOf(e) === t;
    }),
    C = {
      id: g,
      reference: e,
      popper: ER(),
      popperInstance: null,
      props: u,
      state: {
        isEnabled: !0,
        isVisible: !1,
        isDestroyed: !1,
        isMounted: !1,
        isShown: !1
      },
      plugins: v,
      clearDelayTimeouts: function () {
        clearTimeout(n), clearTimeout(r), cancelAnimationFrame(o);
      },
      setProps: function (t) {
        "production" !== process.env.NODE_ENV && RR(C.state.isDestroyed, PR("setProps"));
        if (C.state.isDestroyed) return;
        S("onBeforeUpdate", [C, t]), Z();
        var n = C.props,
          r = WR(e, Object.assign({}, n, bR(t), {
            ignoreAttributes: !0
          }));
        C.props = r, J(), n.interactiveDebounce !== r.interactiveDebounce && (P(), A = hR(X, r.interactiveDebounce));
        n.triggerTarget && !r.triggerTarget ? AR(n.triggerTarget).forEach(function (e) {
          e.removeAttribute("aria-expanded");
        }) : r.triggerTarget && e.removeAttribute("aria-expanded");
        L(), N(), y && y(n, r);
        C.popperInstance && (q(), $().forEach(function (e) {
          requestAnimationFrame(e._tippy.popperInstance.forceUpdate);
        }));
        S("onAfterUpdate", [C, t]);
      },
      setContent: function (e) {
        C.setProps({
          content: e
        });
      },
      show: function () {
        "production" !== process.env.NODE_ENV && RR(C.state.isDestroyed, PR("show"));
        var e = C.state.isVisible,
          t = C.state.isDestroyed,
          n = !C.state.isEnabled,
          r = zR.isTouch && !C.props.touch,
          o = fR(C.props.duration, 0, jR.duration);
        if (e || t || n || r) return;
        if (H().hasAttribute("disabled")) return;
        if (S("onShow", [C], !1), !1 === C.props.onShow(C)) return;
        C.state.isVisible = !0, Q() && (E.style.visibility = "visible");
        N(), R(), C.state.isMounted || (E.style.transition = "none");
        if (Q()) {
          var i = M(),
            a = i.box,
            s = i.content;
          xR([a, s], 0);
        }
        c = function () {
          var e;
          if (C.state.isVisible && !m) {
            if (m = !0, E.offsetHeight, E.style.transition = C.props.moveTransition, Q() && C.props.animation) {
              var t = M(),
                n = t.box,
                r = t.content;
              xR([n, r], o), wR([n, r], "visible");
            }
            V(), L(), gR(tG, C), null == (e = C.popperInstance) || e.forceUpdate(), S("onMount", [C]), C.props.animation && Q() && function (e, t) {
              F(e, t);
            }(o, function () {
              C.state.isShown = !0, S("onShown", [C]);
            });
          }
        }, function () {
          var e,
            t = C.props.appendTo,
            n = H();
          e = C.props.interactive && t === dR || "parent" === t ? n.parentNode : mR(t, [n]);
          e.contains(E) || e.appendChild(E);
          C.state.isMounted = !0, q(), "production" !== process.env.NODE_ENV && RR(C.props.interactive && t === jR.appendTo && n.nextElementSibling !== E, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", "\n\n", "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", "\n\n", "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", "\n\n", "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
        }();
      },
      hide: function () {
        "production" !== process.env.NODE_ENV && RR(C.state.isDestroyed, PR("hide"));
        var e = !C.state.isVisible,
          t = C.state.isDestroyed,
          n = !C.state.isEnabled,
          r = fR(C.props.duration, 1, jR.duration);
        if (e || t || n) return;
        if (S("onHide", [C], !1), !1 === C.props.onHide(C)) return;
        C.state.isVisible = !1, C.state.isShown = !1, m = !1, d = !1, Q() && (E.style.visibility = "hidden");
        if (P(), G(), N(!0), Q()) {
          var o = M(),
            i = o.box,
            a = o.content;
          C.props.animation && (xR([i, a], r), wR([i, a], "hidden"));
        }
        V(), L(), C.props.animation ? Q() && function (e, t) {
          F(e, function () {
            !C.state.isVisible && E.parentNode && E.parentNode.contains(E) && t();
          });
        }(r, C.unmount) : C.unmount();
      },
      hideWithInteractivity: function (e) {
        "production" !== process.env.NODE_ENV && RR(C.state.isDestroyed, PR("hideWithInteractivity"));
        z().addEventListener("mousemove", A), gR(eG, A), A(e);
      },
      enable: function () {
        C.state.isEnabled = !0;
      },
      disable: function () {
        C.hide(), C.state.isEnabled = !1;
      },
      unmount: function () {
        "production" !== process.env.NODE_ENV && RR(C.state.isDestroyed, PR("unmount"));
        C.state.isVisible && C.hide();
        if (!C.state.isMounted) return;
        _(), $().forEach(function (e) {
          e._tippy.unmount();
        }), E.parentNode && E.parentNode.removeChild(E);
        tG = tG.filter(function (e) {
          return e !== C;
        }), C.state.isMounted = !1, S("onHidden", [C]);
      },
      destroy: function () {
        "production" !== process.env.NODE_ENV && RR(C.state.isDestroyed, PR("destroy"));
        if (C.state.isDestroyed) return;
        C.clearDelayTimeouts(), C.unmount(), Z(), delete e._tippy, C.state.isDestroyed = !0, S("onDestroy", [C]);
      }
    };
  if (!u.render) return "production" !== process.env.NODE_ENV && GR(!0, "render() function has not been supplied."), C;
  var b = u.render(C),
    E = b.popper,
    y = b.onUpdate;
  E.setAttribute("data-tippy-root", ""), E.id = "tippy-" + C.id, C.popper = E, e._tippy = C, E._tippy = C;
  var I = v.map(function (e) {
      return e.fn(C);
    }),
    B = e.hasAttribute("aria-expanded");
  return J(), L(), N(), S("onCreate", [C]), u.showOnCreate && ee(), E.addEventListener("mouseenter", function () {
    C.props.interactive && C.state.isVisible && C.clearDelayTimeouts();
  }), E.addEventListener("mouseleave", function () {
    C.props.interactive && C.props.trigger.indexOf("mouseenter") >= 0 && z().addEventListener("mousemove", A);
  }), C;
  function x() {
    var e = C.props.touch;
    return Array.isArray(e) ? e : [e, 0];
  }
  function w() {
    return "hold" === x()[0];
  }
  function Q() {
    var e;
    return !(null == (e = C.props.render) || !e.$$tippy);
  }
  function H() {
    return s || e;
  }
  function z() {
    var e,
      t,
      n = H().parentNode;
    return n ? null != (t = AR(n)[0]) && null != (e = t.ownerDocument) && e.body ? t.ownerDocument : document : document;
  }
  function M() {
    return qR(E);
  }
  function k(e) {
    return C.state.isMounted && !C.state.isVisible || zR.isTouch || i && "focus" === i.type ? 0 : fR(C.props.delay, e ? 0 : 1, jR.delay);
  }
  function N(e) {
    void 0 === e && (e = !1), E.style.pointerEvents = C.props.interactive && !e ? "" : "none", E.style.zIndex = "" + C.props.zIndex;
  }
  function S(e, t, n) {
    var r;
    (void 0 === n && (n = !0), I.forEach(function (n) {
      n[e] && n[e].apply(n, t);
    }), n) && (r = C.props)[e].apply(r, t);
  }
  function V() {
    var t = C.props.aria;
    if (t.content) {
      var n = "aria-" + t.content,
        r = E.id;
      AR(C.props.triggerTarget || e).forEach(function (e) {
        var t = e.getAttribute(n);
        if (C.state.isVisible) e.setAttribute(n, t ? t + " " + r : r);else {
          var o = t && t.replace(r, "").trim();
          o ? e.setAttribute(n, o) : e.removeAttribute(n);
        }
      });
    }
  }
  function L() {
    !B && C.props.aria.expanded && AR(C.props.triggerTarget || e).forEach(function (e) {
      C.props.interactive ? e.setAttribute("aria-expanded", C.state.isVisible && e === H() ? "true" : "false") : e.removeAttribute("aria-expanded");
    });
  }
  function P() {
    z().removeEventListener("mousemove", A), eG = eG.filter(function (e) {
      return e !== A;
    });
  }
  function O(t) {
    if (!zR.isTouch || !p && "mousedown" !== t.type) {
      var n = t.composedPath && t.composedPath()[0] || t.target;
      if (!C.props.interactive || !HR(E, n)) {
        if (AR(C.props.triggerTarget || e).some(function (e) {
          return HR(e, n);
        })) {
          if (zR.isTouch) return;
          if (C.state.isVisible && C.props.trigger.indexOf("click") >= 0) return;
        } else S("onClickOutside", [C, t]);
        !0 === C.props.hideOnClick && (C.clearDelayTimeouts(), C.hide(), f = !0, setTimeout(function () {
          f = !1;
        }), C.state.isMounted || G());
      }
    }
  }
  function T() {
    p = !0;
  }
  function D() {
    p = !1;
  }
  function R() {
    var e = z();
    e.addEventListener("mousedown", O, !0), e.addEventListener("touchend", O, uR), e.addEventListener("touchstart", D, uR), e.addEventListener("touchmove", T, uR);
  }
  function G() {
    var e = z();
    e.removeEventListener("mousedown", O, !0), e.removeEventListener("touchend", O, uR), e.removeEventListener("touchstart", D, uR), e.removeEventListener("touchmove", T, uR);
  }
  function F(e, t) {
    var n = M().box;
    function r(e) {
      e.target === n && (QR(n, "remove", r), t());
    }
    if (0 === e) return t();
    QR(n, "remove", a), QR(n, "add", r), a = r;
  }
  function j(t, n, r) {
    void 0 === r && (r = !1), AR(C.props.triggerTarget || e).forEach(function (e) {
      e.addEventListener(t, n, r), h.push({
        node: e,
        eventType: t,
        handler: n,
        options: r
      });
    });
  }
  function J() {
    var e;
    w() && (j("touchstart", W, {
      passive: !0
    }), j("touchend", U, {
      passive: !0
    })), (e = C.props.trigger, e.split(/\s+/).filter(Boolean)).forEach(function (e) {
      if ("manual" !== e) switch (j(e, W), e) {
        case "mouseenter":
          j("mouseleave", U);
          break;
        case "focus":
          j(LR ? "focusout" : "blur", K);
          break;
        case "focusin":
          j("focusout", K);
      }
    });
  }
  function Z() {
    h.forEach(function (e) {
      var t = e.node,
        n = e.eventType,
        r = e.handler,
        o = e.options;
      t.removeEventListener(n, r, o);
    }), h = [];
  }
  function W(e) {
    var t,
      n = !1;
    if (C.state.isEnabled && !Y(e) && !f) {
      var r = "focus" === (null == (t = i) ? void 0 : t.type);
      i = e, s = e.currentTarget, L(), !C.state.isVisible && IR(e) && eG.forEach(function (t) {
        return t(e);
      }), "click" === e.type && (C.props.trigger.indexOf("mouseenter") < 0 || d) && !1 !== C.props.hideOnClick && C.state.isVisible ? n = !0 : ee(e), "click" === e.type && (d = !n), n && !r && te(e);
    }
  }
  function X(e) {
    var t = e.target,
      n = H().contains(t) || E.contains(t);
    if ("mousemove" !== e.type || !n) {
      var r = $().concat(E).map(function (e) {
        var t,
          n = null == (t = e._tippy.popperInstance) ? void 0 : t.state;
        return n ? {
          popperRect: e.getBoundingClientRect(),
          popperState: n,
          props: u
        } : null;
      }).filter(Boolean);
      (function (e, t) {
        var n = t.clientX,
          r = t.clientY;
        return e.every(function (e) {
          var t = e.popperRect,
            o = e.popperState,
            i = e.props.interactiveBorder,
            a = vR(o.placement),
            c = o.modifiersData.offset;
          if (!c) return !0;
          var s = "bottom" === a ? c.top.y : 0,
            l = "top" === a ? c.bottom.y : 0,
            u = "right" === a ? c.left.x : 0,
            d = "left" === a ? c.right.x : 0,
            f = t.top - r + s > i,
            p = r - t.bottom - l > i,
            m = t.left - n + u > i,
            h = n - t.right - d > i;
          return f || p || m || h;
        });
      })(r, e) && (P(), te(e));
    }
  }
  function U(e) {
    Y(e) || C.props.trigger.indexOf("click") >= 0 && d || (C.props.interactive ? C.hideWithInteractivity(e) : te(e));
  }
  function K(e) {
    C.props.trigger.indexOf("focusin") < 0 && e.target !== H() || C.props.interactive && e.relatedTarget && E.contains(e.relatedTarget) || te(e);
  }
  function Y(e) {
    return !!zR.isTouch && w() !== e.type.indexOf("touch") >= 0;
  }
  function q() {
    _();
    var t = C.props,
      n = t.popperOptions,
      r = t.placement,
      o = t.offset,
      i = t.getReferenceClientRect,
      a = t.moveTransition,
      s = Q() ? qR(E).arrow : null,
      l = i ? {
        getBoundingClientRect: i,
        contextElement: i.contextElement || H()
      } : e,
      u = {
        name: "$$tippy",
        enabled: !0,
        phase: "beforeWrite",
        requires: ["computeStyles"],
        fn: function (e) {
          var t = e.state;
          if (Q()) {
            var n = M().box;
            ["placement", "reference-hidden", "escaped"].forEach(function (e) {
              "placement" === e ? n.setAttribute("data-placement", t.placement) : t.attributes.popper["data-popper-" + e] ? n.setAttribute("data-" + e, "") : n.removeAttribute("data-" + e);
            }), t.attributes.popper = {};
          }
        }
      },
      d = [{
        name: "offset",
        options: {
          offset: o
        }
      }, {
        name: "preventOverflow",
        options: {
          padding: {
            top: 2,
            bottom: 2,
            left: 5,
            right: 5
          }
        }
      }, {
        name: "flip",
        options: {
          padding: 5
        }
      }, {
        name: "computeStyles",
        options: {
          adaptive: !a
        }
      }, u];
    Q() && s && d.push({
      name: "arrow",
      options: {
        element: s,
        padding: 3
      }
    }), d.push.apply(d, (null == n ? void 0 : n.modifiers) || []), C.popperInstance = lR(l, E, Object.assign({}, n, {
      placement: r,
      onFirstUpdate: c,
      modifiers: d
    }));
  }
  function _() {
    C.popperInstance && (C.popperInstance.destroy(), C.popperInstance = null);
  }
  function $() {
    return CR(E.querySelectorAll("[data-tippy-root]"));
  }
  function ee(e) {
    C.clearDelayTimeouts(), e && S("onTrigger", [C, e]), R();
    var t = k(!0),
      r = x(),
      o = r[0],
      i = r[1];
    zR.isTouch && "hold" === o && i && (t = i), t ? n = setTimeout(function () {
      C.show();
    }, t) : C.show();
  }
  function te(e) {
    if (C.clearDelayTimeouts(), S("onUntrigger", [C, e]), C.state.isVisible) {
      if (!(C.props.trigger.indexOf("mouseenter") >= 0 && C.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(e.type) >= 0 && d)) {
        var t = k(!1);
        t ? r = setTimeout(function () {
          C.state.isVisible && C.hide();
        }, t) : o = requestAnimationFrame(function () {
          C.hide();
        });
      }
    } else G();
  }
}
function rG(e, t) {
  void 0 === t && (t = {});
  var n = jR.plugins.concat(t.plugins || []);
  "production" !== process.env.NODE_ENV && (!function (e) {
    var t = !e,
      n = "[object Object]" === Object.prototype.toString.call(e) && !e.addEventListener;
    GR(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), GR(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
  }(e), XR(t, n)), document.addEventListener("touchstart", kR, uR), window.addEventListener("blur", SR);
  var r = Object.assign({}, t, {
      plugins: n
    }),
    o = BR(e);
  if ("production" !== process.env.NODE_ENV) {
    var i = yR(r.content),
      a = o.length > 1;
    RR(i && a, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", "\n\n", "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", "\n\n", "1) content: element.innerHTML\n", "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var c = o.reduce(function (e, t) {
    var n = t && nG(t, r);
    return n && e.push(n), e;
  }, []);
  return yR(e) ? c[0] : c;
}
rG.defaultProps = jR, rG.setDefaultProps = function (e) {
  "production" !== process.env.NODE_ENV && XR(e, []), Object.keys(e).forEach(function (t) {
    jR[t] = e[t];
  });
}, rG.currentInput = zR, Object.assign({}, cD, {
  effect: function (e) {
    var t = e.state,
      n = {
        popper: {
          position: t.options.strategy,
          left: "0",
          top: "0",
          margin: "0"
        },
        arrow: {
          position: "absolute"
        },
        reference: {}
      };
    Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow);
  }
});
var oG = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function (e) {
    var t,
      n = e.reference;
    var r = -1,
      o = !1,
      i = [],
      a = {
        name: "tippyInlinePositioning",
        enabled: !0,
        phase: "afterWrite",
        fn: function (o) {
          var a = o.state;
          e.props.inlinePositioning && (-1 !== i.indexOf(a.placement) && (i = []), t !== a.placement && -1 === i.indexOf(a.placement) && (i.push(a.placement), e.setProps({
            getReferenceClientRect: function () {
              return function (e) {
                return function (e, t, n, r) {
                  if (n.length < 2 || null === e) return t;
                  if (2 === n.length && r >= 0 && n[0].left > n[1].right) return n[r] || t;
                  switch (e) {
                    case "top":
                    case "bottom":
                      var o = n[0],
                        i = n[n.length - 1],
                        a = "top" === e,
                        c = o.top,
                        s = i.bottom,
                        l = a ? o.left : i.left,
                        u = a ? o.right : i.right;
                      return {
                        top: c,
                        bottom: s,
                        left: l,
                        right: u,
                        width: u - l,
                        height: s - c
                      };
                    case "left":
                    case "right":
                      var d = Math.min.apply(Math, n.map(function (e) {
                          return e.left;
                        })),
                        f = Math.max.apply(Math, n.map(function (e) {
                          return e.right;
                        })),
                        p = n.filter(function (t) {
                          return "left" === e ? t.left === d : t.right === f;
                        }),
                        m = p[0].top,
                        h = p[p.length - 1].bottom;
                      return {
                        top: m,
                        bottom: h,
                        left: d,
                        right: f,
                        width: f - d,
                        height: h - m
                      };
                    default:
                      return t;
                  }
                }(vR(e), n.getBoundingClientRect(), CR(n.getClientRects()), r);
              }(a.placement);
            }
          })), t = a.placement);
        }
      };
    function c() {
      var t;
      o || (t = function (e, t) {
        var n;
        return {
          popperOptions: Object.assign({}, e.popperOptions, {
            modifiers: [].concat(((null == (n = e.popperOptions) ? void 0 : n.modifiers) || []).filter(function (e) {
              return e.name !== t.name;
            }), [t])
          })
        };
      }(e.props, a), o = !0, e.setProps(t), o = !1);
    }
    return {
      onCreate: c,
      onAfterUpdate: c,
      onTrigger: function (t, n) {
        if (IR(n)) {
          var o = CR(e.reference.getClientRects()),
            i = o.find(function (e) {
              return e.left - 2 <= n.clientX && e.right + 2 >= n.clientX && e.top - 2 <= n.clientY && e.bottom + 2 >= n.clientY;
            }),
            a = o.indexOf(i);
          r = a > -1 ? a : r;
        }
      },
      onHidden: function () {
        r = -1;
      }
    };
  }
};
rG.setDefaultProps({
  render: _R
});
const iG = function () {
    for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      e[_key4] = arguments[_key4];
    }
    return t => {
      e.forEach(e => {
        "function" == typeof e ? e(t) : e && (e.current = t);
      });
    };
  },
  aG = _ref100 => {
    let e = _ref100.renderers;
    return /*#__PURE__*/t.createElement(t.Fragment, null, Object.entries(e).map(_ref101 => {
      let _ref102 = _slicedToArray(_ref101, 2),
        e = _ref102[0],
        t = _ref102[1];
      return /*#__PURE__*/I.createPortal(t.reactElement, t.element, e);
    }));
  };
class cG extends t.Component {
  constructor(e) {
    super(e), this.editorContentRef = /*#__PURE__*/t.createRef(), this.initialized = !1, this.state = {
      renderers: {}
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && e.options.element) {
      if (e.contentComponent) return;
      const t = this.editorContentRef.current;
      t.append(...e.options.element.childNodes), e.setOptions({
        element: t
      }), e.contentComponent = this, e.createNodeViews(), this.initialized = !0;
    }
  }
  maybeFlushSync(e) {
    this.initialized ? x(e) : e();
  }
  setRenderer(e, t) {
    this.maybeFlushSync(() => {
      this.setState(_ref103 => {
        let n = _ref103.renderers;
        return {
          renderers: _objectSpread(_objectSpread({}, n), {}, {
            [e]: t
          })
        };
      });
    });
  }
  removeRenderer(e) {
    this.maybeFlushSync(() => {
      this.setState(_ref104 => {
        let t = _ref104.renderers;
        const n = _objectSpread({}, t);
        return delete n[e], {
          renderers: n
        };
      });
    });
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e) return;
    if (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), e.contentComponent = null, !e.options.element.firstChild) return;
    const t = document.createElement("div");
    t.append(...e.options.element.childNodes), e.setOptions({
      element: t
    });
  }
  render() {
    const _this$props = this.props,
      e = _this$props.editor,
      n = _this$props.innerRef,
      r = _objectWithoutProperties(_this$props, _excluded);
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement("div", _objectSpread({
      ref: iG(n, this.editorContentRef)
    }, r)), /*#__PURE__*/t.createElement(aG, {
      renderers: this.state.renderers
    }));
  }
}
const sG = /*#__PURE__*/c((e, n) => {
    const r = t.useMemo(() => Math.floor(4294967295 * Math.random()).toString(), [e.editor]);
    return /*#__PURE__*/t.createElement(cG, _objectSpread({
      key: r,
      innerRef: n
    }, e));
  }),
  lG = /*#__PURE__*/t.memo(sG);
class uG extends class extends class {
  constructor() {
    this.callbacks = {};
  }
  on(e, t) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(t), this;
  }
  emit(e) {
    for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      t[_key5 - 1] = arguments[_key5];
    }
    const n = this.callbacks[e];
    return n && n.forEach(e => e.apply(this, t)), this;
  }
  off(e, t) {
    const n = this.callbacks[e];
    return n && (t ? this.callbacks[e] = n.filter(e => e !== t) : delete this.callbacks[e]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
} {
  constructor() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super(), this.isFocused = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", {
      editor: this
    }), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", {
        editor: this
      }));
    }, 0);
  }
  get storage() {
    return this.extensionStorage;
  }
  get commands() {
    return this.commandManager.commands;
  }
  chain() {
    return this.commandManager.chain();
  }
  can() {
    return this.commandManager.can();
  }
  injectCSS() {
    this.options.injectCSS && document && (this.css = function (e, t) {
      const n = document.querySelector("style[data-tiptap-style]");
      if (null !== n) return n;
      const r = document.createElement("style");
      return t && r.setAttribute("nonce", t), r.setAttribute("data-tiptap-style", ""), r.innerHTML = e, document.getElementsByTagName("head")[0].appendChild(r), r;
    }('.ProseMirror {\n  position: relative;\n}\n\n.ProseMirror {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  white-space: break-spaces;\n  -webkit-font-variant-ligatures: none;\n  font-variant-ligatures: none;\n  font-feature-settings: "liga" 0; /* the above doesn\'t seem to work in Edge */\n}\n\n.ProseMirror [contenteditable="false"] {\n  white-space: normal;\n}\n\n.ProseMirror [contenteditable="false"] [contenteditable="true"] {\n  white-space: pre-wrap;\n}\n\n.ProseMirror pre {\n  white-space: pre-wrap;\n}\n\nimg.ProseMirror-separator {\n  display: inline !important;\n  border: none !important;\n  margin: 0 !important;\n  width: 1px !important;\n  height: 1px !important;\n}\n\n.ProseMirror-gapcursor {\n  display: none;\n  pointer-events: none;\n  position: absolute;\n  margin: 0;\n}\n\n.ProseMirror-gapcursor:after {\n  content: "";\n  display: block;\n  position: absolute;\n  top: -2px;\n  width: 20px;\n  border-top: 1px solid black;\n  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;\n}\n\n@keyframes ProseMirror-cursor-blink {\n  to {\n    visibility: hidden;\n  }\n}\n\n.ProseMirror-hideselection *::selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection *::-moz-selection {\n  background: transparent;\n}\n\n.ProseMirror-hideselection * {\n  caret-color: transparent;\n}\n\n.ProseMirror-focused .ProseMirror-gapcursor {\n  display: block;\n}\n\n.tippy-box[data-animation=fade][data-state=hidden] {\n  opacity: 0\n}', this.options.injectNonce));
  }
  setOptions() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.options = _objectSpread(_objectSpread({}, this.options), e), this.view && this.state && !this.isDestroyed && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  setEditable(e) {
    let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
    this.setOptions({
      editable: e
    }), t && this.emit("update", {
      editor: this,
      transaction: this.state.tr
    });
  }
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  get state() {
    return this.view.state;
  }
  registerPlugin(e, t) {
    const n = GO(t) ? t(e, [...this.state.plugins]) : [...this.state.plugins, e],
      r = this.state.reconfigure({
        plugins: n
      });
    this.view.updateState(r);
  }
  unregisterPlugin(e) {
    if (this.isDestroyed) return;
    const t = "string" == typeof e ? `${e}$` : e.key,
      n = this.state.reconfigure({
        plugins: this.state.plugins.filter(e => !e.key.startsWith(t))
      });
    this.view.updateState(n);
  }
  createExtensionManager() {
    const e = [...(this.options.enableCoreExtensions ? Object.values(RT) : []), ...this.options.extensions].filter(e => ["extension", "node", "mark"].includes(null == e ? void 0 : e.type));
    this.extensionManager = new eT(e, this);
  }
  createCommandManager() {
    this.commandManager = new VO({
      editor: this
    });
  }
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  createView() {
    const e = yT(this.options.content, this.schema, this.options.parseOptions),
      t = mT(e, this.options.autofocus);
    this.view = new JP(this.options.element, _objectSpread(_objectSpread({}, this.options.editorProps), {}, {
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: SS.create({
        doc: e,
        selection: t || void 0
      })
    }));
    const n = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(n), this.createNodeViews();
    this.view.dom.editor = this;
  }
  createNodeViews() {
    this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const t = this.capturedTransaction;
    return this.capturedTransaction = null, t;
  }
  dispatchTransaction(e) {
    if (this.view.isDestroyed) return;
    if (this.isCapturingTransaction) return this.capturedTransaction ? void e.steps.forEach(e => {
      var t;
      return null === (t = this.capturedTransaction) || void 0 === t ? void 0 : t.step(e);
    }) : void (this.capturedTransaction = e);
    const t = this.state.apply(e),
      n = !this.state.selection.eq(t.selection);
    this.view.updateState(t), this.emit("transaction", {
      editor: this,
      transaction: e
    }), n && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const r = e.getMeta("focus"),
      o = e.getMeta("blur");
    r && this.emit("focus", {
      editor: this,
      event: r.event,
      transaction: e
    }), o && this.emit("blur", {
      editor: this,
      event: o.event,
      transaction: e
    }), e.docChanged && !e.getMeta("preventUpdate") && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  getAttributes(e) {
    return xT(this.state, e);
  }
  isActive(e, t) {
    const n = "string" == typeof e ? e : null,
      r = "string" == typeof e ? t : e;
    return function (e, t) {
      let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!t) return CT(e, null, n) || zT(e, null, n);
      const r = bT(t, e.schema);
      return "node" === r ? CT(e, t, n) : "mark" === r && zT(e, t, n);
    }(this.state, n, r);
  }
  getJSON() {
    return this.state.doc.toJSON();
  }
  getHTML() {
    return function (e, t) {
      const n = wN.fromSchema(t).serializeFragment(e),
        r = document.implementation.createHTMLDocument().createElement("div");
      return r.appendChild(n), r.innerHTML;
    }(this.state.doc.content, this.schema);
  }
  getText(e) {
    const _ref105 = e || {},
      _ref105$blockSeparato = _ref105.blockSeparator,
      t = _ref105$blockSeparato === void 0 ? "\n\n" : _ref105$blockSeparato,
      _ref105$textSerialize = _ref105.textSerializers,
      n = _ref105$textSerialize === void 0 ? {} : _ref105$textSerialize;
    return function (e, t) {
      return oT(e, {
        from: 0,
        to: e.content.size
      }, t);
    }(this.state.doc, {
      blockSeparator: t,
      textSerializers: _objectSpread(_objectSpread({}, iT(this.schema)), n)
    });
  }
  get isEmpty() {
    return function (e) {
      var t;
      const n = null === (t = e.type.createAndFill()) || void 0 === t ? void 0 : t.toJSON(),
        r = e.toJSON();
      return JSON.stringify(n) === JSON.stringify(r);
    }(this.state.doc);
  }
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  destroy() {
    this.emit("destroy"), this.view && this.view.destroy(), this.removeAllListeners();
  }
  get isDestroyed() {
    var e;
    return !(null === (e = this.view) || void 0 === e ? void 0 : e.docView);
  }
} {
  constructor() {
    super(...arguments), this.contentComponent = null;
  }
}
const dG = function () {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  const _n2 = n(null),
    _n3 = _slicedToArray(_n2, 2),
    i = _n3[0],
    a = _n3[1],
    c = function () {
      const _n4 = n(0),
        _n5 = _slicedToArray(_n4, 2),
        e = _n5[1];
      return () => e(e => e + 1);
    }(),
    s = e.onBeforeCreate,
    l = e.onBlur,
    u = e.onCreate,
    d = e.onDestroy,
    f = e.onFocus,
    p = e.onSelectionUpdate,
    m = e.onTransaction,
    h = e.onUpdate,
    A = o(s),
    g = o(l),
    v = o(u),
    C = o(d),
    b = o(f),
    E = o(p),
    y = o(m),
    I = o(h);
  return r(() => {
    i && (s && (i.off("beforeCreate", A.current), i.on("beforeCreate", s), A.current = s), l && (i.off("blur", g.current), i.on("blur", l), g.current = l), u && (i.off("create", v.current), i.on("create", u), v.current = u), d && (i.off("destroy", C.current), i.on("destroy", d), C.current = d), f && (i.off("focus", b.current), i.on("focus", f), b.current = f), p && (i.off("selectionUpdate", E.current), i.on("selectionUpdate", p), E.current = p), m && (i.off("transaction", y.current), i.on("transaction", m), y.current = m), h && (i.off("update", I.current), i.on("update", h), I.current = h));
  }, [s, l, u, d, f, p, m, h, i]), r(() => {
    let t = !0;
    const n = new uG(e);
    return a(n), n.on("transaction", () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          t && c();
        });
      });
    }), () => {
      t = !1;
    };
  }, t), r(() => () => {
    null == i || i.destroy();
  }, [i]), i;
};
/*#__PURE__*/d({
  editor: null
}).Consumer;
const fG = /*#__PURE__*/d({
  onDragStart: void 0
});
/*#__PURE__*/t.forwardRef((e, n) => {
  const _u2 = u(fG),
    r = _u2.onDragStart,
    o = e.as || "div";
  return /*#__PURE__*/t.createElement(o, _objectSpread(_objectSpread({}, e), {}, {
    ref: n,
    "data-node-view-wrapper": "",
    onDragStart: r,
    style: _objectSpread({
      whiteSpace: "normal"
    }, e.style)
  }));
});
const pG = WT.create({
    name: "listItem",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    content: "paragraph block*",
    defining: !0,
    parseHTML: () => [{
      tag: "li"
    }],
    renderHTML(_ref106) {
      let e = _ref106.HTMLAttributes;
      return ["li", DO(this.options.HTMLAttributes, e), 0];
    },
    addKeyboardShortcuts() {
      return {
        Enter: () => this.editor.commands.splitListItem(this.name),
        Tab: () => this.editor.commands.sinkListItem(this.name),
        "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
      };
    }
  }),
  mG = ZT.create({
    name: "textStyle",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "span",
      getAttrs: e => !!e.hasAttribute("style") && {}
    }],
    renderHTML(_ref107) {
      let e = _ref107.HTMLAttributes;
      return ["span", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        removeEmptyTextStyle: () => _ref108 => {
          let e = _ref108.state,
            t = _ref108.commands;
          const n = BT(e, this.type);
          return !!Object.entries(n).some(_ref109 => {
            let _ref110 = _slicedToArray(_ref109, 2),
              e = _ref110[1];
            return !!e;
          }) || t.unsetMark(this.name);
        }
      };
    }
  }),
  hG = rT.create({
    name: "characterCount",
    addOptions: () => ({
      limit: null,
      mode: "textSize"
    }),
    addStorage: () => ({
      characters: () => 0,
      words: () => 0
    }),
    onBeforeCreate() {
      this.storage.characters = e => {
        const t = (null == e ? void 0 : e.node) || this.editor.state.doc;
        if ("textSize" === ((null == e ? void 0 : e.mode) || this.options.mode)) {
          return t.textBetween(0, t.content.size, void 0, " ").length;
        }
        return t.nodeSize;
      }, this.storage.words = e => {
        const t = (null == e ? void 0 : e.node) || this.editor.state.doc;
        return t.textBetween(0, t.content.size, " ", " ").split(" ").filter(e => "" !== e).length;
      };
    },
    addProseMirrorPlugins() {
      return [new LS({
        key: new TS("characterCount"),
        filterTransaction: (e, t) => {
          const n = this.options.limit;
          if (!e.docChanged || 0 === n || null == n) return !0;
          const r = this.storage.characters({
              node: t.doc
            }),
            o = this.storage.characters({
              node: e.doc
            });
          if (o <= n) return !0;
          if (r > n && o > n && o <= r) return !0;
          if (r > n && o > n && o > r) return !1;
          if (!e.getMeta("paste")) return !1;
          const i = e.selection.$head.pos,
            a = i - (o - n),
            c = i;
          e.deleteRange(a, c);
          return !(this.storage.characters({
            node: e.doc
          }) > n);
        }
      })];
    }
  }),
  AG = WT.create({
    name: "doc",
    topNode: !0,
    content: "block+"
  }),
  gG = WT.create({
    name: "paragraph",
    priority: 1e3,
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    group: "block",
    content: "inline*",
    parseHTML: () => [{
      tag: "p"
    }],
    renderHTML(_ref111) {
      let e = _ref111.HTMLAttributes;
      return ["p", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setParagraph: () => _ref112 => {
          let e = _ref112.commands;
          return e.setNode(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Alt-0": () => this.editor.commands.setParagraph()
      };
    }
  }),
  vG = WT.create({
    name: "text",
    group: "inline"
  }),
  CG = rT.create({
    name: "placeholder",
    addOptions: () => ({
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    }),
    addProseMirrorPlugins() {
      return [new LS({
        key: new TS("placeholder"),
        props: {
          decorations: _ref113 => {
            let e = _ref113.doc,
              t = _ref113.selection;
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable,
              r = t.anchor,
              o = [];
            if (!n) return null;
            const i = e.type.createAndFill(),
              a = (null == i ? void 0 : i.sameMarkup(e)) && null === i.content.findDiffStart(e.content);
            return e.descendants((e, t) => {
              const n = r >= t && r <= t + e.nodeSize,
                i = !e.isLeaf && !e.childCount;
              if ((n || !this.options.showOnlyCurrent) && i) {
                const r = [this.options.emptyNodeClass];
                a && r.push(this.options.emptyEditorClass);
                const i = vP.node(t, t + e.nodeSize, {
                  class: r.join(" "),
                  "data-placeholder": "function" == typeof this.options.placeholder ? this.options.placeholder({
                    editor: this.editor,
                    node: e,
                    pos: t,
                    hasAnchor: n
                  }) : this.options.placeholder
                });
                o.push(i);
              }
              return this.options.includeChildren;
            }), EP.create(e, o);
          }
        }
      })];
    }
  }),
  bG = ZT.create({
    name: "underline",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "u"
    }, {
      style: "text-decoration",
      consuming: !1,
      getAttrs: e => !!e.includes("underline") && {}
    }],
    renderHTML(_ref114) {
      let e = _ref114.HTMLAttributes;
      return ["u", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setUnderline: () => _ref115 => {
          let e = _ref115.commands;
          return e.setMark(this.name);
        },
        toggleUnderline: () => _ref116 => {
          let e = _ref116.commands;
          return e.toggleMark(this.name);
        },
        unsetUnderline: () => _ref117 => {
          let e = _ref117.commands;
          return e.unsetMark(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-u": () => this.editor.commands.toggleUnderline(),
        "Mod-U": () => this.editor.commands.toggleUnderline()
      };
    }
  }),
  EG = (e, t) => {
    for (const n in t) e[n] = t[n];
    return e;
  };
function yG(e, t) {
  return e in t || (t[e] = []), t[e];
}
function IG(e, t, n) {
  t.numeric && (t.asciinumeric = !0, t.alphanumeric = !0), t.ascii && (t.asciinumeric = !0, t.alpha = !0), t.asciinumeric && (t.alphanumeric = !0), t.alpha && (t.alphanumeric = !0), t.alphanumeric && (t.domain = !0), t.emoji && (t.domain = !0);
  for (const r in t) {
    const t = yG(r, n);
    t.indexOf(e) < 0 && t.push(e);
  }
}
function BG(e) {
  void 0 === e && (e = null), this.j = {}, this.jr = [], this.jd = null, this.t = e;
}
BG.groups = {}, BG.prototype = {
  accepts() {
    return !!this.t;
  },
  go(e) {
    const t = this,
      n = t.j[e];
    if (n) return n;
    for (let n = 0; n < t.jr.length; n++) {
      const r = t.jr[n][0],
        o = t.jr[n][1];
      if (o && r.test(e)) return o;
    }
    return t.jd;
  },
  has(e, t) {
    return void 0 === t && (t = !1), t ? e in this.j : !!this.go(e);
  },
  ta(e, t, n, r) {
    for (let o = 0; o < e.length; o++) this.tt(e[o], t, n, r);
  },
  tr(e, t, n, r) {
    let o;
    return r = r || BG.groups, t && t.j ? o = t : (o = new BG(t), n && r && IG(t, n, r)), this.jr.push([e, o]), o;
  },
  ts(e, t, n, r) {
    let o = this;
    const i = e.length;
    if (!i) return o;
    for (let t = 0; t < i - 1; t++) o = o.tt(e[t]);
    return o.tt(e[i - 1], t, n, r);
  },
  tt(e, t, n, r) {
    r = r || BG.groups;
    const o = this;
    if (t && t.j) return o.j[e] = t, t;
    const i = t;
    let a,
      c = o.go(e);
    if (c ? (a = new BG(), EG(a.j, c.j), a.jr.push.apply(a.jr, c.jr), a.jd = c.jd, a.t = c.t) : a = new BG(), i) {
      if (r) if (a.t && "string" == typeof a.t) {
        const e = EG(function (e, t) {
          const n = {};
          for (const r in t) t[r].indexOf(e) >= 0 && (n[r] = !0);
          return n;
        }(a.t, r), n);
        IG(i, e, r);
      } else n && IG(i, n, r);
      a.t = i;
    }
    return o.j[e] = a, a;
  }
};
const xG = (e, t, n, r, o) => e.ta(t, n, r, o),
  wG = (e, t, n, r, o) => e.tr(t, n, r, o),
  QG = (e, t, n, r, o) => e.ts(t, n, r, o),
  HG = (e, t, n, r, o) => e.tt(t, n, r, o),
  zG = "WORD",
  MG = "AT",
  kG = "COLON",
  NG = "DOT",
  SG = "HYPHEN",
  VG = "SLASH";
var LG = Object.freeze({
  __proto__: null,
  WORD: zG,
  UWORD: "UWORD",
  LOCALHOST: "LOCALHOST",
  TLD: "TLD",
  UTLD: "UTLD",
  SCHEME: "SCHEME",
  SLASH_SCHEME: "SLASH_SCHEME",
  NUM: "NUM",
  WS: "WS",
  NL: "NL",
  OPENBRACE: "OPENBRACE",
  OPENBRACKET: "OPENBRACKET",
  OPENANGLEBRACKET: "OPENANGLEBRACKET",
  OPENPAREN: "OPENPAREN",
  CLOSEBRACE: "CLOSEBRACE",
  CLOSEBRACKET: "CLOSEBRACKET",
  CLOSEANGLEBRACKET: "CLOSEANGLEBRACKET",
  CLOSEPAREN: "CLOSEPAREN",
  AMPERSAND: "AMPERSAND",
  APOSTROPHE: "APOSTROPHE",
  ASTERISK: "ASTERISK",
  AT: MG,
  BACKSLASH: "BACKSLASH",
  BACKTICK: "BACKTICK",
  CARET: "CARET",
  COLON: kG,
  COMMA: "COMMA",
  DOLLAR: "DOLLAR",
  DOT: NG,
  EQUALS: "EQUALS",
  EXCLAMATION: "EXCLAMATION",
  HYPHEN: SG,
  PERCENT: "PERCENT",
  PIPE: "PIPE",
  PLUS: "PLUS",
  POUND: "POUND",
  QUERY: "QUERY",
  QUOTE: "QUOTE",
  SEMI: "SEMI",
  SLASH: VG,
  TILDE: "TILDE",
  UNDERSCORE: "UNDERSCORE",
  EMOJI: "EMOJI",
  SYM: "SYM"
});
const PG = /[a-z]/,
  OG = /\p{L}/u,
  TG = /\p{Emoji}/u,
  DG = /\d/,
  RG = /\s/;
let GG = null,
  FG = null;
function jG(e, t, n, r, o) {
  let i;
  const a = t.length;
  for (let n = 0; n < a - 1; n++) {
    const a = t[n];
    e.j[a] ? i = e.j[a] : (i = new BG(r), i.jr = o.slice(), e.j[a] = i), e = i;
  }
  return i = new BG(n), i.jr = o.slice(), e.j[t[a - 1]] = i, i;
}
function JG(e) {
  const t = [],
    n = [];
  let r = 0;
  for (; r < e.length;) {
    let o = 0;
    for (; "0123456789".indexOf(e[r + o]) >= 0;) o++;
    if (o > 0) {
      t.push(n.join(""));
      for (let t = parseInt(e.substring(r, r + o), 10); t > 0; t--) n.pop();
      r += o;
    } else n.push(e[r]), r++;
  }
  return t;
}
const ZG = {
  defaultProtocol: "http",
  events: null,
  format: XG,
  formatHref: XG,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function WG(e, t) {
  void 0 === t && (t = null);
  let n = EG({}, ZG);
  e && (n = EG(n, e instanceof WG ? e.o : e));
  const r = n.ignoreTags,
    o = [];
  for (let e = 0; e < r.length; e++) o.push(r[e].toUpperCase());
  this.o = n, t && (this.defaultRender = t), this.ignoreTags = o;
}
function XG(e) {
  return e;
}
function UG(e, t) {
  this.t = "token", this.v = e, this.tk = t;
}
function KG(e, t) {
  class n extends UG {
    constructor(t, n) {
      super(t, n), this.t = e;
    }
  }
  for (const e in t) n.prototype[e] = t[e];
  return n.t = e, n;
}
WG.prototype = {
  o: ZG,
  ignoreTags: [],
  defaultRender: e => e,
  check(e) {
    return this.get("validate", e.toString(), e);
  },
  get(e, t, n) {
    const r = null != t;
    let o = this.o[e];
    return o ? ("object" == typeof o ? (o = n.t in o ? o[n.t] : ZG[e], "function" == typeof o && r && (o = o(t, n))) : "function" == typeof o && r && (o = o(t, n.t, n)), o) : o;
  },
  getObj(e, t, n) {
    let r = this.o[e];
    return "function" == typeof r && null != t && (r = r(t, n.t, n)), r;
  },
  render(e) {
    const t = e.render(this);
    return (this.get("render", null, e) || this.defaultRender)(t, e.t, e);
  }
}, UG.prototype = {
  isLink: !1,
  toString() {
    return this.v;
  },
  toHref(e) {
    return this.toString();
  },
  toFormattedString(e) {
    const t = this.toString(),
      n = e.get("truncate", t, this),
      r = e.get("format", t, this);
    return n && r.length > n ? r.substring(0, n) + "…" : r;
  },
  toFormattedHref(e) {
    return e.get("formatHref", this.toHref(e.get("defaultProtocol")), this);
  },
  startIndex() {
    return this.tk[0].s;
  },
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  toObject(e) {
    return void 0 === e && (e = ZG.defaultProtocol), {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  toFormattedObject(e) {
    return {
      type: this.t,
      value: this.toFormattedString(e),
      isLink: this.isLink,
      href: this.toFormattedHref(e),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  validate(e) {
    return e.get("validate", this.toString(), this);
  },
  render(e) {
    const t = this,
      n = this.toHref(e.get("defaultProtocol")),
      r = e.get("formatHref", n, this),
      o = e.get("tagName", n, t),
      i = this.toFormattedString(e),
      a = {},
      c = e.get("className", n, t),
      s = e.get("target", n, t),
      l = e.get("rel", n, t),
      u = e.getObj("attributes", n, t),
      d = e.getObj("events", n, t);
    return a.href = r, c && (a.class = c), s && (a.target = s), l && (a.rel = l), u && EG(a, u), {
      tagName: o,
      attributes: a,
      content: i,
      eventListeners: d
    };
  }
};
const YG = KG("email", {
    isLink: !0,
    toHref() {
      return "mailto:" + this.toString();
    }
  }),
  qG = KG("text"),
  _G = KG("nl"),
  $G = KG("url", {
    isLink: !0,
    toHref(e) {
      return void 0 === e && (e = ZG.defaultProtocol), this.hasProtocol() ? this.v : `${e}://${this.v}`;
    },
    hasProtocol() {
      const e = this.tk;
      return e.length >= 2 && "LOCALHOST" !== e[0].t && e[1].t === kG;
    }
  }),
  eF = e => new BG(e);
function tF(e, t, n) {
  const r = n[0].s,
    o = n[n.length - 1].e;
  return new e(t.slice(r, o), n);
}
const nF = "undefined" != typeof console && console && console.warn || (() => {}),
  rF = {
    scanner: null,
    parser: null,
    tokenQueue: [],
    pluginQueue: [],
    customSchemes: [],
    initialized: !1
  };
function oF(e, t) {
  if (void 0 === t && (t = !1), rF.initialized && nF(`linkifyjs: already initialized - will not register custom scheme "${e}" until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(e)) throw new Error('linkifyjs: incorrect scheme format.\n 1. Must only contain digits, lowercase ASCII letters or "-"\n 2. Cannot start or end with "-"\n 3. "-" cannot repeat');
  rF.customSchemes.push([e, t]);
}
function iF() {
  rF.scanner = function (e) {
    void 0 === e && (e = []);
    const t = {};
    BG.groups = t;
    const n = new BG();
    null == GG && (GG = JG("aaa1rp3barth4b0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0faromeo7ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4vianca6w0s2x0a2z0ure5ba0by2idu3namex3narepublic11d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re2s2c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y0eats7k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0cast4mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking0channel11l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dabur3d1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t0isalat7u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0at2delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d0network8tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntdoor4ier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0ardian6cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5gtv3iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0eles2s3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1nder2le4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster5ia3d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4de2k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0cys3drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7serati6ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic3tual5v1w1x1y1z2na0b1goya4me2tura4vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rthwesternmutual14on4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9dnavy5lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3ssagens7y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cher3ks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0a1b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp2w2ell3ia1ksha5oes2p0ping5uji3w0time7i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ffany5ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0channel7ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lkswagen7vo3te1ing3o2yage5u0elos6wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4finity6ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2")), null == FG && (FG = JG("ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5تصالات6رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2")), HG(n, "'", "APOSTROPHE"), HG(n, "{", "OPENBRACE"), HG(n, "[", "OPENBRACKET"), HG(n, "<", "OPENANGLEBRACKET"), HG(n, "(", "OPENPAREN"), HG(n, "}", "CLOSEBRACE"), HG(n, "]", "CLOSEBRACKET"), HG(n, ">", "CLOSEANGLEBRACKET"), HG(n, ")", "CLOSEPAREN"), HG(n, "&", "AMPERSAND"), HG(n, "*", "ASTERISK"), HG(n, "@", MG), HG(n, "`", "BACKTICK"), HG(n, "^", "CARET"), HG(n, ":", kG), HG(n, ",", "COMMA"), HG(n, "$", "DOLLAR"), HG(n, ".", NG), HG(n, "=", "EQUALS"), HG(n, "!", "EXCLAMATION"), HG(n, "-", SG), HG(n, "%", "PERCENT"), HG(n, "|", "PIPE"), HG(n, "+", "PLUS"), HG(n, "#", "POUND"), HG(n, "?", "QUERY"), HG(n, '"', "QUOTE"), HG(n, "/", VG), HG(n, ";", "SEMI"), HG(n, "~", "TILDE"), HG(n, "_", "UNDERSCORE"), HG(n, "\\", "BACKSLASH");
    const r = wG(n, DG, "NUM", {
      numeric: !0
    });
    wG(r, DG, r);
    const o = wG(n, PG, zG, {
      ascii: !0
    });
    wG(o, PG, o);
    const i = wG(n, OG, "UWORD", {
      alpha: !0
    });
    wG(i, PG), wG(i, OG, i);
    const a = wG(n, RG, "WS", {
      whitespace: !0
    });
    HG(n, "\n", "NL", {
      whitespace: !0
    }), HG(a, "\n"), wG(a, RG, a);
    const c = wG(n, TG, "EMOJI", {
      emoji: !0
    });
    wG(c, TG, c), HG(c, "️", c);
    const s = HG(c, "‍");
    wG(s, TG, c);
    const l = [[PG, o]],
      u = [[PG, null], [OG, i]];
    for (let e = 0; e < GG.length; e++) jG(n, GG[e], "TLD", zG, l);
    for (let e = 0; e < FG.length; e++) jG(n, FG[e], "UTLD", "UWORD", u);
    IG("TLD", {
      tld: !0,
      ascii: !0
    }, t), IG("UTLD", {
      utld: !0,
      alpha: !0
    }, t), jG(n, "file", "SCHEME", zG, l), jG(n, "mailto", "SCHEME", zG, l), jG(n, "http", "SLASH_SCHEME", zG, l), jG(n, "https", "SLASH_SCHEME", zG, l), jG(n, "ftp", "SLASH_SCHEME", zG, l), jG(n, "ftps", "SLASH_SCHEME", zG, l), IG("SCHEME", {
      scheme: !0,
      ascii: !0
    }, t), IG("SLASH_SCHEME", {
      slashscheme: !0,
      ascii: !0
    }, t), e = e.sort((e, t) => e[0] > t[0] ? 1 : -1);
    for (let t = 0; t < e.length; t++) {
      const r = e[t][0],
        o = e[t][1] ? {
          scheme: !0
        } : {
          slashscheme: !0
        };
      r.indexOf("-") >= 0 ? o.domain = !0 : PG.test(r) ? DG.test(r) ? o.asciinumeric = !0 : o.ascii = !0 : o.numeric = !0, QG(n, r, r, o);
    }
    return QG(n, "localhost", "LOCALHOST", {
      ascii: !0
    }), n.jd = new BG("SYM"), {
      start: n,
      tokens: EG({
        groups: t
      }, LG)
    };
  }(rF.customSchemes);
  for (let e = 0; e < rF.tokenQueue.length; e++) rF.tokenQueue[e][1]({
    scanner: rF.scanner
  });
  rF.parser = function (e) {
    let t = e.groups;
    const n = t.domain.concat(["AMPERSAND", "ASTERISK", MG, "BACKSLASH", "BACKTICK", "CARET", "DOLLAR", "EQUALS", SG, "NUM", "PERCENT", "PIPE", "PLUS", "POUND", VG, "SYM", "TILDE", "UNDERSCORE"]),
      r = ["APOSTROPHE", "CLOSEANGLEBRACKET", "CLOSEBRACE", "CLOSEBRACKET", "CLOSEPAREN", kG, "COMMA", NG, "EXCLAMATION", "OPENANGLEBRACKET", "OPENBRACE", "OPENBRACKET", "OPENPAREN", "QUERY", "QUOTE", "SEMI"],
      o = ["AMPERSAND", "APOSTROPHE", "ASTERISK", "BACKSLASH", "BACKTICK", "CARET", "CLOSEBRACE", "DOLLAR", "EQUALS", SG, "OPENBRACE", "PERCENT", "PIPE", "PLUS", "POUND", "QUERY", VG, "SYM", "TILDE", "UNDERSCORE"],
      i = eF(),
      a = HG(i, "TILDE");
    xG(a, o, a), xG(a, t.domain, a);
    const c = eF(),
      s = eF(),
      l = eF();
    xG(i, t.domain, c), xG(i, t.scheme, s), xG(i, t.slashscheme, l), xG(c, o, a), xG(c, t.domain, c);
    const u = HG(c, MG);
    HG(a, MG, u), HG(s, MG, u), HG(l, MG, u);
    const d = HG(a, NG);
    xG(d, o, a), xG(d, t.domain, a);
    const f = eF();
    xG(u, t.domain, f), xG(f, t.domain, f);
    const p = HG(f, NG);
    xG(p, t.domain, f);
    const m = eF(YG);
    xG(p, t.tld, m), xG(p, t.utld, m), HG(u, "LOCALHOST", m);
    const h = HG(f, SG);
    xG(h, t.domain, f), xG(m, t.domain, f), HG(m, NG, p), HG(m, SG, h);
    const A = HG(m, kG);
    xG(A, t.numeric, YG);
    const g = HG(c, SG),
      v = HG(c, NG);
    xG(g, t.domain, c), xG(v, o, a), xG(v, t.domain, c);
    const C = eF($G);
    xG(v, t.tld, C), xG(v, t.utld, C), xG(C, t.domain, c), xG(C, o, a), HG(C, NG, v), HG(C, SG, g), HG(C, MG, u);
    const b = HG(C, kG),
      E = eF($G);
    xG(b, t.numeric, E);
    const y = eF($G),
      I = eF();
    xG(y, n, y), xG(y, r, I), xG(I, n, y), xG(I, r, I), HG(C, VG, y), HG(E, VG, y);
    const B = HG(s, kG),
      x = HG(l, kG),
      w = HG(x, VG),
      Q = HG(w, VG);
    xG(s, t.domain, c), HG(s, NG, v), HG(s, SG, g), xG(l, t.domain, c), HG(l, NG, v), HG(l, SG, g), xG(B, t.domain, y), HG(B, VG, y), xG(Q, t.domain, y), xG(Q, n, y), HG(Q, VG, y);
    const H = HG(y, "OPENBRACE"),
      z = HG(y, "OPENBRACKET"),
      M = HG(y, "OPENANGLEBRACKET"),
      k = HG(y, "OPENPAREN");
    HG(I, "OPENBRACE", H), HG(I, "OPENBRACKET", z), HG(I, "OPENANGLEBRACKET", M), HG(I, "OPENPAREN", k), HG(H, "CLOSEBRACE", y), HG(z, "CLOSEBRACKET", y), HG(M, "CLOSEANGLEBRACKET", y), HG(k, "CLOSEPAREN", y), HG(H, "CLOSEBRACE", y);
    const N = eF($G),
      S = eF($G),
      V = eF($G),
      L = eF($G);
    xG(H, n, N), xG(z, n, S), xG(M, n, V), xG(k, n, L);
    const P = eF(),
      O = eF(),
      T = eF(),
      D = eF();
    return xG(H, r), xG(z, r), xG(M, r), xG(k, r), xG(N, n, N), xG(S, n, S), xG(V, n, V), xG(L, n, L), xG(N, r, N), xG(S, r, S), xG(V, r, V), xG(L, r, L), xG(P, n, P), xG(O, n, S), xG(T, n, V), xG(D, n, L), xG(P, r, P), xG(O, r, O), xG(T, r, T), xG(D, r, D), HG(S, "CLOSEBRACKET", y), HG(V, "CLOSEANGLEBRACKET", y), HG(L, "CLOSEPAREN", y), HG(N, "CLOSEBRACE", y), HG(O, "CLOSEBRACKET", y), HG(T, "CLOSEANGLEBRACKET", y), HG(D, "CLOSEPAREN", y), HG(P, "CLOSEPAREN", y), HG(i, "LOCALHOST", C), HG(i, "NL", _G), {
      start: i,
      tokens: LG
    };
  }(rF.scanner.tokens);
  for (let e = 0; e < rF.pluginQueue.length; e++) rF.pluginQueue[e][1]({
    scanner: rF.scanner,
    parser: rF.parser
  });
  rF.initialized = !0;
}
function aF(e) {
  return rF.initialized || iF(), function (e, t, n) {
    let r = n.length,
      o = 0,
      i = [],
      a = [];
    for (; o < r;) {
      let c = e,
        s = null,
        l = null,
        u = 0,
        d = null,
        f = -1;
      for (; o < r && !(s = c.go(n[o].t));) a.push(n[o++]);
      for (; o < r && (l = s || c.go(n[o].t));) s = null, c = l, c.accepts() ? (f = 0, d = c) : f >= 0 && f++, o++, u++;
      if (f < 0) o -= u, o < r && (a.push(n[o]), o++);else {
        a.length > 0 && (i.push(tF(qG, t, a)), a = []), o -= f, u -= f;
        const e = d.t,
          r = n.slice(o - u, o);
        i.push(tF(e, t, r));
      }
    }
    return a.length > 0 && i.push(tF(qG, t, a)), i;
  }(rF.parser.start, e, function (e, t) {
    const n = function (e) {
        const t = [],
          n = e.length;
        let r = 0;
        for (; r < n;) {
          let o,
            i = e.charCodeAt(r),
            a = i < 55296 || i > 56319 || r + 1 === n || (o = e.charCodeAt(r + 1)) < 56320 || o > 57343 ? e[r] : e.slice(r, r + 2);
          t.push(a), r += a.length;
        }
        return t;
      }(t.replace(/[A-Z]/g, e => e.toLowerCase())),
      r = n.length,
      o = [];
    let i = 0,
      a = 0;
    for (; a < r;) {
      let c = e,
        s = null,
        l = 0,
        u = null,
        d = -1,
        f = -1;
      for (; a < r && (s = c.go(n[a]));) c = s, c.accepts() ? (d = 0, f = 0, u = c) : d >= 0 && (d += n[a].length, f++), l += n[a].length, i += n[a].length, a++;
      i -= d, a -= f, l -= d, o.push({
        t: u.t,
        v: t.slice(i - l, i),
        s: i - l,
        e: i
      });
    }
    return o;
  }(rF.scanner.start, e));
}
function cF(e, t, n) {
  if (void 0 === t && (t = null), void 0 === n && (n = null), t && "object" == typeof t) {
    if (n) throw Error(`linkifyjs: Invalid link type ${t}; must be a string`);
    n = t, t = null;
  }
  const r = new WG(n),
    o = aF(e),
    i = [];
  for (let e = 0; e < o.length; e++) {
    const n = o[e];
    !n.isLink || t && n.t !== t || i.push(n.toFormattedObject(r));
  }
  return i;
}
function sF(e, t) {
  void 0 === t && (t = null);
  const n = aF(e);
  return 1 === n.length && n[0].isLink && (!t || n[0].t === t);
}
function lF(e) {
  return new LS({
    key: new TS("autolink"),
    appendTransaction: (t, n, r) => {
      const o = t.some(e => e.docChanged) && !n.doc.eq(r.doc),
        i = t.some(e => e.getMeta("preventAutolink"));
      if (!o || i) return;
      const a = r.tr,
        c = function (e, t) {
          const n = new mS(e);
          return t.forEach(e => {
            e.steps.forEach(e => {
              n.step(e);
            });
          }), n;
        }(n.doc, [...t]),
        s = c.mapping,
        l = function (e) {
          const t = e.mapping,
            n = e.steps,
            r = [];
          return t.maps.forEach((e, o) => {
            const i = [];
            if (e.ranges.length) e.forEach((e, t) => {
              i.push({
                from: e,
                to: t
              });
            });else {
              const _n$o = n[o],
                e = _n$o.from,
                t = _n$o.to;
              if (void 0 === e || void 0 === t) return;
              i.push({
                from: e,
                to: t
              });
            }
            i.forEach(_ref118 => {
              let e = _ref118.from,
                n = _ref118.to;
              const i = t.slice(o).map(e, -1),
                a = t.slice(o).map(n),
                c = t.invert().map(i, -1),
                s = t.invert().map(a);
              r.push({
                oldRange: {
                  from: c,
                  to: s
                },
                newRange: {
                  from: i,
                  to: a
                }
              });
            });
          }), wT(r);
        }(c);
      return l.forEach(_ref119 => {
        let t = _ref119.oldRange,
          o = _ref119.newRange;
        QT(t.from, t.to, n.doc).filter(t => t.mark.type === e.type).forEach(t => {
          const o = QT(s.map(t.from), s.map(t.to), r.doc).filter(t => t.mark.type === e.type);
          if (!o.length) return;
          const i = o[0],
            c = n.doc.textBetween(t.from, t.to, void 0, " "),
            l = r.doc.textBetween(i.from, i.to, void 0, " "),
            u = sF(c),
            d = sF(l);
          u && !d && a.removeMark(i.from, i.to, e.type);
        });
        const i = function (e, t, n) {
          const r = [];
          return e.nodesBetween(t.from, t.to, (e, t) => {
            n(e) && r.push({
              node: e,
              pos: t
            });
          }), r;
        }(r.doc, o, e => e.isTextblock);
        let c, l;
        if (i.length > 1 ? (c = i[0], l = r.doc.textBetween(c.pos, c.pos + c.node.nodeSize, void 0, " ")) : i.length && r.doc.textBetween(o.from, o.to, " ", " ").endsWith(" ") && (c = i[0], l = r.doc.textBetween(c.pos, o.to, void 0, " ")), c && l) {
          const t = l.split(" ").filter(e => "" !== e);
          if (t.length <= 0) return !1;
          const n = t[t.length - 1],
            r = c.pos + l.lastIndexOf(n);
          if (!n) return !1;
          cF(n).filter(e => e.isLink).filter(t => !e.validate || e.validate(t.value)).map(e => _objectSpread(_objectSpread({}, e), {}, {
            from: r + e.start + 1,
            to: r + e.end + 1
          })).forEach(t => {
            a.addMark(t.from, t.to, e.type.create({
              href: t.href
            }));
          });
        }
      }), a.steps.length ? a : void 0;
    }
  });
}
const uF = ZT.create({
    name: "link",
    priority: 1e3,
    keepOnSplit: !1,
    onCreate() {
      this.options.protocols.forEach(e => {
        "string" != typeof e ? oF(e.scheme, e.optionalSlashes) : oF(e);
      });
    },
    onDestroy() {
      BG.groups = {}, rF.scanner = null, rF.parser = null, rF.tokenQueue = [], rF.pluginQueue = [], rF.customSchemes = [], rF.initialized = !1;
    },
    inclusive() {
      return this.options.autolink;
    },
    addOptions: () => ({
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      validate: void 0
    }),
    addAttributes() {
      return {
        href: {
          default: null
        },
        target: {
          default: this.options.HTMLAttributes.target
        },
        class: {
          default: this.options.HTMLAttributes.class
        }
      };
    },
    parseHTML: () => [{
      tag: 'a[href]:not([href *= "javascript:" i])'
    }],
    renderHTML(_ref120) {
      let e = _ref120.HTMLAttributes;
      return ["a", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setLink: e => _ref121 => {
          let t = _ref121.chain;
          return t().setMark(this.name, e).setMeta("preventAutolink", !0).run();
        },
        toggleLink: e => _ref122 => {
          let t = _ref122.chain;
          return t().toggleMark(this.name, e, {
            extendEmptyMarkRange: !0
          }).setMeta("preventAutolink", !0).run();
        },
        unsetLink: () => _ref123 => {
          let e = _ref123.chain;
          return e().unsetMark(this.name, {
            extendEmptyMarkRange: !0
          }).setMeta("preventAutolink", !0).run();
        }
      };
    },
    addPasteRules() {
      return [XT({
        find: e => cF(e).filter(e => !this.options.validate || this.options.validate(e.value)).filter(e => e.isLink).map(e => ({
          text: e.value,
          index: e.start,
          data: e
        })),
        type: this.type,
        getAttributes: e => {
          var t;
          return {
            href: null === (t = e.data) || void 0 === t ? void 0 : t.href
          };
        }
      })];
    },
    addProseMirrorPlugins() {
      const e = [];
      return this.options.autolink && e.push(lF({
        type: this.type,
        validate: this.options.validate
      })), this.options.openOnClick && e.push(function (e) {
        return new LS({
          key: new TS("handleClickLink"),
          props: {
            handleClick: (t, n, r) => {
              var o, i, a;
              if (0 !== r.button) return !1;
              const c = xT(t.state, e.type.name),
                s = null === (o = r.target) || void 0 === o ? void 0 : o.closest("a"),
                l = null !== (i = null == s ? void 0 : s.href) && void 0 !== i ? i : c.href,
                u = null !== (a = null == s ? void 0 : s.target) && void 0 !== a ? a : c.target;
              return !(!s || !l || (window.open(l, u), 0));
            }
          }
        });
      }({
        type: this.type
      })), this.options.linkOnPaste && e.push(function (e) {
        return new LS({
          key: new TS("handlePasteLink"),
          props: {
            handlePaste: (t, n, r) => {
              const o = t.state,
                i = o.selection,
                a = i.empty;
              if (a) return !1;
              let c = "";
              r.content.forEach(e => {
                c += e.textContent;
              });
              const s = cF(c).find(e => e.isLink && e.value === c);
              return !(!c || !s || (e.editor.commands.setMark(e.type, {
                href: s.href
              }), 0));
            }
          }
        });
      }({
        editor: this.editor,
        type: this.type
      })), e;
    }
  }),
  dF = rT.create({
    name: "textAlign",
    addOptions: () => ({
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: "left"
    }),
    addGlobalAttributes() {
      return [{
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: e => e.style.textAlign || this.options.defaultAlignment,
            renderHTML: e => e.textAlign === this.options.defaultAlignment ? {} : {
              style: `text-align: ${e.textAlign}`
            }
          }
        }
      }];
    },
    addCommands() {
      return {
        setTextAlign: e => _ref124 => {
          let t = _ref124.commands;
          return !!this.options.alignments.includes(e) && this.options.types.every(n => t.updateAttributes(n, {
            textAlign: e
          }));
        },
        unsetTextAlign: () => _ref125 => {
          let e = _ref125.commands;
          return this.options.types.every(t => e.resetAttributes(t, "textAlign"));
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
        "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
        "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
        "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
      };
    }
  }),
  fF = /^\s*>\s$/,
  pF = WT.create({
    name: "blockquote",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    content: "block+",
    group: "block",
    defining: !0,
    parseHTML: () => [{
      tag: "blockquote"
    }],
    renderHTML(_ref126) {
      let e = _ref126.HTMLAttributes;
      return ["blockquote", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setBlockquote: () => _ref127 => {
          let e = _ref127.commands;
          return e.wrapIn(this.name);
        },
        toggleBlockquote: () => _ref128 => {
          let e = _ref128.commands;
          return e.toggleWrap(this.name);
        },
        unsetBlockquote: () => _ref129 => {
          let e = _ref129.commands;
          return e.lift(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
      };
    },
    addInputRules() {
      return [JT({
        find: fF,
        type: this.type
      })];
    }
  }),
  mF = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))$/,
  hF = /(?:^|\s)((?:\*\*)((?:[^*]+))(?:\*\*))/g,
  AF = /(?:^|\s)((?:__)((?:[^__]+))(?:__))$/,
  gF = /(?:^|\s)((?:__)((?:[^__]+))(?:__))/g,
  vF = ZT.create({
    name: "bold",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "strong"
    }, {
      tag: "b",
      getAttrs: e => "normal" !== e.style.fontWeight && null
    }, {
      style: "font-weight",
      getAttrs: e => /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null
    }],
    renderHTML(_ref130) {
      let e = _ref130.HTMLAttributes;
      return ["strong", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setBold: () => _ref131 => {
          let e = _ref131.commands;
          return e.setMark(this.name);
        },
        toggleBold: () => _ref132 => {
          let e = _ref132.commands;
          return e.toggleMark(this.name);
        },
        unsetBold: () => _ref133 => {
          let e = _ref133.commands;
          return e.unsetMark(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-b": () => this.editor.commands.toggleBold(),
        "Mod-B": () => this.editor.commands.toggleBold()
      };
    },
    addInputRules() {
      return [GT({
        find: mF,
        type: this.type
      }), GT({
        find: AF,
        type: this.type
      })];
    },
    addPasteRules() {
      return [XT({
        find: hF,
        type: this.type
      }), XT({
        find: gF,
        type: this.type
      })];
    }
  }),
  CF = WT.create({
    name: "listItem",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    content: "paragraph block*",
    defining: !0,
    parseHTML: () => [{
      tag: "li"
    }],
    renderHTML(_ref134) {
      let e = _ref134.HTMLAttributes;
      return ["li", DO(this.options.HTMLAttributes, e), 0];
    },
    addKeyboardShortcuts() {
      return {
        Enter: () => this.editor.commands.splitListItem(this.name),
        Tab: () => this.editor.commands.sinkListItem(this.name),
        "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
      };
    }
  }),
  bF = ZT.create({
    name: "textStyle",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "span",
      getAttrs: e => !!e.hasAttribute("style") && {}
    }],
    renderHTML(_ref135) {
      let e = _ref135.HTMLAttributes;
      return ["span", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        removeEmptyTextStyle: () => _ref136 => {
          let e = _ref136.state,
            t = _ref136.commands;
          const n = BT(e, this.type);
          return !!Object.entries(n).some(_ref137 => {
            let _ref138 = _slicedToArray(_ref137, 2),
              e = _ref138[1];
            return !!e;
          }) || t.unsetMark(this.name);
        }
      };
    }
  }),
  EF = /^\s*([-+*])\s$/,
  yF = WT.create({
    name: "bulletList",
    addOptions: () => ({
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    }),
    group: "block list",
    content() {
      return `${this.options.itemTypeName}+`;
    },
    parseHTML: () => [{
      tag: "ul"
    }],
    renderHTML(_ref139) {
      let e = _ref139.HTMLAttributes;
      return ["ul", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        toggleBulletList: () => _ref140 => {
          let e = _ref140.commands,
            t = _ref140.chain;
          return this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(CF.name, this.editor.getAttributes(bF.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
      };
    },
    addInputRules() {
      let e = JT({
        find: EF,
        type: this.type
      });
      return (this.options.keepMarks || this.options.keepAttributes) && (e = JT({
        find: EF,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: () => this.editor.getAttributes(bF.name),
        editor: this.editor
      })), [e];
    }
  }),
  IF = /(?:^|\s)((?:`)((?:[^`]+))(?:`))$/,
  BF = /(?:^|\s)((?:`)((?:[^`]+))(?:`))/g,
  xF = ZT.create({
    name: "code",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    excludes: "_",
    code: !0,
    exitable: !0,
    parseHTML: () => [{
      tag: "code"
    }],
    renderHTML(_ref141) {
      let e = _ref141.HTMLAttributes;
      return ["code", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setCode: () => _ref142 => {
          let e = _ref142.commands;
          return e.setMark(this.name);
        },
        toggleCode: () => _ref143 => {
          let e = _ref143.commands;
          return e.toggleMark(this.name);
        },
        unsetCode: () => _ref144 => {
          let e = _ref144.commands;
          return e.unsetMark(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-e": () => this.editor.commands.toggleCode()
      };
    },
    addInputRules() {
      return [GT({
        find: IF,
        type: this.type
      })];
    },
    addPasteRules() {
      return [XT({
        find: BF,
        type: this.type
      })];
    }
  }),
  wF = /^```([a-z]+)?[\s\n]$/,
  QF = /^~~~([a-z]+)?[\s\n]$/,
  HF = WT.create({
    name: "codeBlock",
    addOptions: () => ({
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      HTMLAttributes: {}
    }),
    content: "text*",
    marks: "",
    group: "block",
    code: !0,
    defining: !0,
    addAttributes() {
      return {
        language: {
          default: null,
          parseHTML: e => {
            var t;
            const n = this.options.languageClassPrefix,
              r = [...((null === (t = e.firstElementChild) || void 0 === t ? void 0 : t.classList) || [])].filter(e => e.startsWith(n)).map(e => e.replace(n, ""))[0];
            return r || null;
          },
          rendered: !1
        }
      };
    },
    parseHTML: () => [{
      tag: "pre",
      preserveWhitespace: "full"
    }],
    renderHTML(_ref145) {
      let e = _ref145.node,
        t = _ref145.HTMLAttributes;
      return ["pre", DO(this.options.HTMLAttributes, t), ["code", {
        class: e.attrs.language ? this.options.languageClassPrefix + e.attrs.language : null
      }, 0]];
    },
    addCommands() {
      return {
        setCodeBlock: e => _ref146 => {
          let t = _ref146.commands;
          return t.setNode(this.name, e);
        },
        toggleCodeBlock: e => _ref147 => {
          let t = _ref147.commands;
          return t.toggleNode(this.name, "paragraph", e);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
        Backspace: () => {
          const _this$editor$state$se = this.editor.state.selection,
            e = _this$editor$state$se.empty,
            t = _this$editor$state$se.$anchor,
            n = 1 === t.pos;
          return !(!e || t.parent.type.name !== this.name) && !(!n && t.parent.textContent.length) && this.editor.commands.clearNodes();
        },
        Enter: _ref148 => {
          let e = _ref148.editor;
          if (!this.options.exitOnTripleEnter) return !1;
          const t = e.state,
            n = t.selection,
            r = n.$from,
            o = n.empty;
          if (!o || r.parent.type !== this.type) return !1;
          const i = r.parentOffset === r.parent.nodeSize - 2,
            a = r.parent.textContent.endsWith("\n\n");
          return !(!i || !a) && e.chain().command(_ref149 => {
            let e = _ref149.tr;
            return e.delete(r.pos - 2, r.pos), !0;
          }).exitCode().run();
        },
        ArrowDown: _ref150 => {
          let e = _ref150.editor;
          if (!this.options.exitOnArrowDown) return !1;
          const t = e.state,
            n = t.selection,
            r = t.doc,
            o = n.$from,
            i = n.empty;
          if (!i || o.parent.type !== this.type) return !1;
          if (!(o.parentOffset === o.parent.nodeSize - 2)) return !1;
          const a = o.after();
          if (void 0 === a) return !1;
          return !r.nodeAt(a) && e.commands.exitCode();
        }
      };
    },
    addInputRules() {
      return [jT({
        find: wF,
        type: this.type,
        getAttributes: e => ({
          language: e[1]
        })
      }), jT({
        find: QF,
        type: this.type,
        getAttributes: e => ({
          language: e[1]
        })
      })];
    },
    addProseMirrorPlugins() {
      return [new LS({
        key: new TS("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (e, t) => {
            if (!t.clipboardData) return !1;
            if (this.editor.isActive(this.type.name)) return !1;
            const n = t.clipboardData.getData("text/plain"),
              r = t.clipboardData.getData("vscode-editor-data"),
              o = r ? JSON.parse(r) : void 0,
              i = null == o ? void 0 : o.mode;
            if (!n || !i) return !1;
            const a = e.state.tr;
            return a.replaceSelectionWith(this.type.create({
              language: i
            })), a.setSelection(bS.near(a.doc.resolve(Math.max(0, a.selection.from - 2)))), a.insertText(n.replace(/\r\n?/g, "\n")), a.setMeta("paste", !0), e.dispatch(a), !0;
          }
        }
      })];
    }
  });
function zF() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return new LS({
    view: t => new MF(t, e)
  });
}
class MF {
  constructor(e, t) {
    var n;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = null !== (n = t.width) && void 0 !== n ? n : 1, this.color = !1 === t.color ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map(t => {
      let n = e => {
        this[t](e);
      };
      return e.dom.addEventListener(t, n), {
        name: t,
        handler: n
      };
    });
  }
  destroy() {
    this.handlers.forEach(_ref151 => {
      let e = _ref151.name,
        t = _ref151.handler;
      return this.editorView.dom.removeEventListener(e, t);
    });
  }
  update(e, t) {
    null != this.cursorPos && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, null == e ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e,
      t = this.editorView.state.doc.resolve(this.cursorPos),
      n = !t.parent.inlineContent;
    if (n) {
      let n = t.nodeBefore,
        r = t.nodeAfter;
      if (n || r) {
        let t = this.editorView.nodeDOM(this.cursorPos - (n ? n.nodeSize : 0));
        if (t) {
          let o = t.getBoundingClientRect(),
            i = n ? o.bottom : o.top;
          n && r && (i = (i + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), e = {
            left: o.left,
            right: o.right,
            top: i - this.width / 2,
            bottom: i + this.width / 2
          };
        }
      }
    }
    if (!e) {
      let t = this.editorView.coordsAtPos(this.cursorPos);
      e = {
        left: t.left - this.width / 2,
        right: t.left + this.width / 2,
        top: t.top,
        bottom: t.bottom
      };
    }
    let r,
      o,
      i = this.editorView.dom.offsetParent;
    if (this.element || (this.element = i.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n), !i || i == document.body && "static" == getComputedStyle(i).position) r = -pageXOffset, o = -pageYOffset;else {
      let e = i.getBoundingClientRect();
      r = e.left - i.scrollLeft, o = e.top - i.scrollTop;
    }
    this.element.style.left = e.left - r + "px", this.element.style.top = e.top - o + "px", this.element.style.width = e.right - e.left + "px", this.element.style.height = e.bottom - e.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable) return;
    let t = this.editorView.posAtCoords({
        left: e.clientX,
        top: e.clientY
      }),
      n = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside),
      r = n && n.type.spec.disableDropCursor,
      o = "function" == typeof r ? r(this.editorView, t, e) : r;
    if (t && !o) {
      let e = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let t = eS(this.editorView.state.doc, e, this.editorView.dragging.slice);
        null != t && (e = t);
      }
      this.setCursor(e), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    e.target != this.editorView.dom && this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
const kF = rT.create({
  name: "dropCursor",
  addOptions: () => ({
    color: "currentColor",
    width: 1,
    class: void 0
  }),
  addProseMirrorPlugins() {
    return [zF(this.options)];
  }
});
class NF extends AS {
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let n = e.resolve(t.map(this.head));
    return NF.valid(n) ? new NF(n) : AS.near(n);
  }
  content() {
    return Nk.empty;
  }
  eq(e) {
    return e instanceof NF && e.head == this.head;
  }
  toJSON() {
    return {
      type: "gapcursor",
      pos: this.head
    };
  }
  static fromJSON(e, t) {
    if ("number" != typeof t.pos) throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new NF(e.resolve(t.pos));
  }
  getBookmark() {
    return new SF(this.anchor);
  }
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !function (e) {
      for (let t = e.depth; t >= 0; t--) {
        let n = e.index(t),
          r = e.node(t);
        if (0 != n) for (let e = r.child(n - 1);; e = e.lastChild) {
          if (0 == e.childCount && !e.inlineContent || e.isAtom || e.type.spec.isolating) return !0;
          if (e.inlineContent) return !1;
        } else if (r.type.spec.isolating) return !0;
      }
      return !0;
    }(e) || !function (e) {
      for (let t = e.depth; t >= 0; t--) {
        let n = e.indexAfter(t),
          r = e.node(t);
        if (n != r.childCount) for (let e = r.child(n);; e = e.firstChild) {
          if (0 == e.childCount && !e.inlineContent || e.isAtom || e.type.spec.isolating) return !0;
          if (e.inlineContent) return !1;
        } else if (r.type.spec.isolating) return !0;
      }
      return !0;
    }(e)) return !1;
    let n = t.type.spec.allowGapCursor;
    if (null != n) return n;
    let r = t.contentMatchAt(e.index()).defaultType;
    return r && r.isTextblock;
  }
  static findGapCursorFrom(e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
    e: for (;;) {
      if (!n && NF.valid(e)) return e;
      let r = e.pos,
        o = null;
      for (let n = e.depth;; n--) {
        let i = e.node(n);
        if (t > 0 ? e.indexAfter(n) < i.childCount : e.index(n) > 0) {
          o = i.child(t > 0 ? e.indexAfter(n) : e.index(n) - 1);
          break;
        }
        if (0 == n) return null;
        r += t;
        let a = e.doc.resolve(r);
        if (NF.valid(a)) return a;
      }
      for (;;) {
        let i = t > 0 ? o.firstChild : o.lastChild;
        if (!i) {
          if (o.isAtom && !o.isText && !yS.isSelectable(o)) {
            e = e.doc.resolve(r + o.nodeSize * t), n = !1;
            continue e;
          }
          break;
        }
        o = i, r += t;
        let a = e.doc.resolve(r);
        if (NF.valid(a)) return a;
      }
      return null;
    }
  }
}
NF.prototype.visible = !1, NF.findFrom = NF.findGapCursorFrom, AS.jsonID("gapcursor", NF);
class SF {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new SF(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return NF.valid(t) ? new NF(t) : AS.near(t);
  }
}
const VF = iO({
  ArrowLeft: LF("horiz", -1),
  ArrowRight: LF("horiz", 1),
  ArrowUp: LF("vert", -1),
  ArrowDown: LF("vert", 1)
});
function LF(e, t) {
  const n = "vert" == e ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
  return function (e, r, o) {
    let i = e.selection,
      a = t > 0 ? i.$to : i.$from,
      c = i.empty;
    if (i instanceof bS) {
      if (!o.endOfTextblock(n) || 0 == a.depth) return !1;
      c = !1, a = e.doc.resolve(t > 0 ? a.after() : a.before());
    }
    let s = NF.findGapCursorFrom(a, t, c);
    return !!s && (r && r(e.tr.setSelection(new NF(s))), !0);
  };
}
function PF(e, t, n) {
  if (!e || !e.editable) return !1;
  let r = e.state.doc.resolve(t);
  if (!NF.valid(r)) return !1;
  let o = e.posAtCoords({
    left: n.clientX,
    top: n.clientY
  });
  return !(o && o.inside > -1 && yS.isSelectable(e.state.doc.nodeAt(o.inside))) && (e.dispatch(e.state.tr.setSelection(new NF(r))), !0);
}
function OF(e, t) {
  if ("insertCompositionText" != t.inputType || !(e.state.selection instanceof NF)) return !1;
  let n = e.state.selection.$from,
    r = n.parent.contentMatchAt(n.index()).findWrapping(e.state.schema.nodes.text);
  if (!r) return !1;
  let o = wk.empty;
  for (let e = r.length - 1; e >= 0; e--) o = wk.from(r[e].createAndFill(null, o));
  let i = e.state.tr.replace(n.pos, n.pos, new Nk(o, 0, 0));
  return i.setSelection(bS.near(i.doc.resolve(n.pos + 1))), e.dispatch(i), !1;
}
function TF(e) {
  if (!(e.selection instanceof NF)) return null;
  let t = document.createElement("div");
  return t.className = "ProseMirror-gapcursor", EP.create(e.doc, [vP.widget(e.selection.head, t, {
    key: "gapcursor"
  })]);
}
const DF = rT.create({
    name: "gapCursor",
    addProseMirrorPlugins: () => [new LS({
      props: {
        decorations: TF,
        createSelectionBetween: (e, t, n) => t.pos == n.pos && NF.valid(n) ? new NF(n) : null,
        handleClick: PF,
        handleKeyDown: VF,
        handleDOMEvents: {
          beforeinput: OF
        }
      }
    })],
    extendNodeSchema(e) {
      var t;
      return {
        allowGapCursor: null !== (t = FO(LO(e, "allowGapCursor", {
          name: e.name,
          options: e.options,
          storage: e.storage
        }))) && void 0 !== t ? t : null
      };
    }
  }),
  RF = WT.create({
    name: "hardBreak",
    addOptions: () => ({
      keepMarks: !0,
      HTMLAttributes: {}
    }),
    inline: !0,
    group: "inline",
    selectable: !1,
    parseHTML: () => [{
      tag: "br"
    }],
    renderHTML(_ref152) {
      let e = _ref152.HTMLAttributes;
      return ["br", DO(this.options.HTMLAttributes, e)];
    },
    renderText: () => "\n",
    addCommands() {
      return {
        setHardBreak: () => _ref153 => {
          let e = _ref153.commands,
            t = _ref153.chain,
            n = _ref153.state,
            r = _ref153.editor;
          return e.first([() => e.exitCode(), () => e.command(() => {
            const e = n.selection,
              o = n.storedMarks;
            if (e.$from.parent.type.spec.isolating) return !1;
            const i = this.options.keepMarks,
              a = r.extensionManager.splittableMarks,
              c = o || e.$to.parentOffset && e.$from.marks();
            return t().insertContent({
              type: this.name
            }).command(_ref154 => {
              let e = _ref154.tr,
                t = _ref154.dispatch;
              if (t && c && i) {
                const t = c.filter(e => a.includes(e.type.name));
                e.ensureMarks(t);
              }
              return !0;
            }).run();
          })]);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Enter": () => this.editor.commands.setHardBreak(),
        "Shift-Enter": () => this.editor.commands.setHardBreak()
      };
    }
  }),
  GF = WT.create({
    name: "heading",
    addOptions: () => ({
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    }),
    content: "inline*",
    group: "block",
    defining: !0,
    addAttributes: () => ({
      level: {
        default: 1,
        rendered: !1
      }
    }),
    parseHTML() {
      return this.options.levels.map(e => ({
        tag: `h${e}`,
        attrs: {
          level: e
        }
      }));
    },
    renderHTML(_ref155) {
      let e = _ref155.node,
        t = _ref155.HTMLAttributes;
      return [`h${this.options.levels.includes(e.attrs.level) ? e.attrs.level : this.options.levels[0]}`, DO(this.options.HTMLAttributes, t), 0];
    },
    addCommands() {
      return {
        setHeading: e => _ref156 => {
          let t = _ref156.commands;
          return !!this.options.levels.includes(e.level) && t.setNode(this.name, e);
        },
        toggleHeading: e => _ref157 => {
          let t = _ref157.commands;
          return !!this.options.levels.includes(e.level) && t.toggleNode(this.name, "paragraph", e);
        }
      };
    },
    addKeyboardShortcuts() {
      return this.options.levels.reduce((e, t) => _objectSpread(_objectSpread({}, e), {}, {
        [`Mod-Alt-${t}`]: () => this.editor.commands.toggleHeading({
          level: t
        })
      }), {});
    },
    addInputRules() {
      return this.options.levels.map(e => jT({
        find: new RegExp(`^(#{1,${e}})\\s$`),
        type: this.type,
        getAttributes: {
          level: e
        }
      }));
    }
  });
var FF = function () {};
FF.prototype.append = function (e) {
  return e.length ? (e = FF.from(e), !this.length && e || e.length < 200 && this.leafAppend(e) || this.length < 200 && e.leafPrepend(this) || this.appendInner(e)) : this;
}, FF.prototype.prepend = function (e) {
  return e.length ? FF.from(e).append(this) : this;
}, FF.prototype.appendInner = function (e) {
  return new JF(this, e);
}, FF.prototype.slice = function (e, t) {
  return void 0 === e && (e = 0), void 0 === t && (t = this.length), e >= t ? FF.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
}, FF.prototype.get = function (e) {
  if (!(e < 0 || e >= this.length)) return this.getInner(e);
}, FF.prototype.forEach = function (e, t, n) {
  void 0 === t && (t = 0), void 0 === n && (n = this.length), t <= n ? this.forEachInner(e, t, n, 0) : this.forEachInvertedInner(e, t, n, 0);
}, FF.prototype.map = function (e, t, n) {
  void 0 === t && (t = 0), void 0 === n && (n = this.length);
  var r = [];
  return this.forEach(function (t, n) {
    return r.push(e(t, n));
  }, t, n), r;
}, FF.from = function (e) {
  return e instanceof FF ? e : e && e.length ? new jF(e) : FF.empty;
};
var jF = function (e) {
  function t(t) {
    e.call(this), this.values = t;
  }
  e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t;
  var n = {
    length: {
      configurable: !0
    },
    depth: {
      configurable: !0
    }
  };
  return t.prototype.flatten = function () {
    return this.values;
  }, t.prototype.sliceInner = function (e, n) {
    return 0 == e && n == this.length ? this : new t(this.values.slice(e, n));
  }, t.prototype.getInner = function (e) {
    return this.values[e];
  }, t.prototype.forEachInner = function (e, t, n, r) {
    for (var o = t; o < n; o++) if (!1 === e(this.values[o], r + o)) return !1;
  }, t.prototype.forEachInvertedInner = function (e, t, n, r) {
    for (var o = t - 1; o >= n; o--) if (!1 === e(this.values[o], r + o)) return !1;
  }, t.prototype.leafAppend = function (e) {
    if (this.length + e.length <= 200) return new t(this.values.concat(e.flatten()));
  }, t.prototype.leafPrepend = function (e) {
    if (this.length + e.length <= 200) return new t(e.flatten().concat(this.values));
  }, n.length.get = function () {
    return this.values.length;
  }, n.depth.get = function () {
    return 0;
  }, Object.defineProperties(t.prototype, n), t;
}(FF);
FF.empty = new jF([]);
var JF = function (e) {
  function t(t, n) {
    e.call(this), this.left = t, this.right = n, this.length = t.length + n.length, this.depth = Math.max(t.depth, n.depth) + 1;
  }
  return e && (t.__proto__ = e), t.prototype = Object.create(e && e.prototype), t.prototype.constructor = t, t.prototype.flatten = function () {
    return this.left.flatten().concat(this.right.flatten());
  }, t.prototype.getInner = function (e) {
    return e < this.left.length ? this.left.get(e) : this.right.get(e - this.left.length);
  }, t.prototype.forEachInner = function (e, t, n, r) {
    var o = this.left.length;
    return !(t < o && !1 === this.left.forEachInner(e, t, Math.min(n, o), r)) && !(n > o && !1 === this.right.forEachInner(e, Math.max(t - o, 0), Math.min(this.length, n) - o, r + o)) && void 0;
  }, t.prototype.forEachInvertedInner = function (e, t, n, r) {
    var o = this.left.length;
    return !(t > o && !1 === this.right.forEachInvertedInner(e, t - o, Math.max(n, o) - o, r + o)) && !(n < o && !1 === this.left.forEachInvertedInner(e, Math.min(t, o), n, r)) && void 0;
  }, t.prototype.sliceInner = function (e, t) {
    if (0 == e && t == this.length) return this;
    var n = this.left.length;
    return t <= n ? this.left.slice(e, t) : e >= n ? this.right.slice(e - n, t - n) : this.left.slice(e, n).append(this.right.slice(0, t - n));
  }, t.prototype.leafAppend = function (e) {
    var n = this.right.leafAppend(e);
    if (n) return new t(this.left, n);
  }, t.prototype.leafPrepend = function (e) {
    var n = this.left.leafPrepend(e);
    if (n) return new t(n, this.right);
  }, t.prototype.appendInner = function (e) {
    return this.left.depth >= Math.max(this.right.depth, e.depth) + 1 ? new t(this.left, new t(this.right, e)) : new t(this, e);
  }, t;
}(FF);
class ZF {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  popEvent(e, t) {
    if (0 == this.eventCount) return null;
    let n,
      r,
      o = this.items.length;
    for (;; o--) {
      if (this.items.get(o - 1).selection) {
        --o;
        break;
      }
    }
    t && (n = this.remapping(o, this.items.length), r = n.maps.length);
    let i,
      a,
      c = e.tr,
      s = [],
      l = [];
    return this.items.forEach((e, t) => {
      if (!e.step) return n || (n = this.remapping(o, t + 1), r = n.maps.length), r--, void l.push(e);
      if (n) {
        l.push(new WF(e.map));
        let t,
          o = e.step.map(n.slice(r));
        o && c.maybeStep(o).doc && (t = c.mapping.maps[c.mapping.maps.length - 1], s.push(new WF(t, void 0, void 0, s.length + l.length))), r--, t && n.appendMap(t, r);
      } else c.maybeStep(e.step);
      return e.selection ? (i = n ? e.selection.map(n.slice(r)) : e.selection, a = new ZF(this.items.slice(0, o).append(l.reverse().concat(s)), this.eventCount - 1), !1) : void 0;
    }, this.items.length, 0), {
      remaining: a,
      transform: c,
      selection: i
    };
  }
  addTransform(e, t, n, r) {
    let o = [],
      i = this.eventCount,
      a = this.items,
      c = !r && a.length ? a.get(a.length - 1) : null;
    for (let n = 0; n < e.steps.length; n++) {
      let s,
        l = e.steps[n].invert(e.docs[n]),
        u = new WF(e.mapping.maps[n], l, t);
      (s = c && c.merge(u)) && (u = s, n ? o.pop() : a = a.slice(0, a.length - 1)), o.push(u), t && (i++, t = void 0), r || (c = u);
    }
    let s = i - n.depth;
    return s > UF && (a = function (e, t) {
      let n;
      return e.forEach((e, r) => {
        if (e.selection && 0 == t--) return n = r, !1;
      }), e.slice(n);
    }(a, s), i -= s), new ZF(a.append(o), i);
  }
  remapping(e, t) {
    let n = new VN();
    return this.items.forEach((t, r) => {
      let o = null != t.mirrorOffset && r - t.mirrorOffset >= e ? n.maps.length - t.mirrorOffset : void 0;
      n.appendMap(t.map, o);
    }, e, t), n;
  }
  addMaps(e) {
    return 0 == this.eventCount ? this : new ZF(this.items.append(e.map(e => new WF(e))), this.eventCount);
  }
  rebased(e, t) {
    if (!this.eventCount) return this;
    let n = [],
      r = Math.max(0, this.items.length - t),
      o = e.mapping,
      i = e.steps.length,
      a = this.eventCount;
    this.items.forEach(e => {
      e.selection && a--;
    }, r);
    let c = t;
    this.items.forEach(t => {
      let r = o.getMirror(--c);
      if (null == r) return;
      i = Math.min(i, r);
      let s = o.maps[r];
      if (t.step) {
        let i = e.steps[r].invert(e.docs[r]),
          l = t.selection && t.selection.map(o.slice(c + 1, r));
        l && a++, n.push(new WF(s, i, l));
      } else n.push(new WF(s));
    }, r);
    let s = [];
    for (let e = t; e < i; e++) s.push(new WF(o.maps[e]));
    let l = this.items.slice(0, r).append(s).append(n),
      u = new ZF(l, a);
    return u.emptyItemCount() > 500 && (u = u.compress(this.items.length - n.length)), u;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach(t => {
      t.step || e++;
    }), e;
  }
  compress() {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.items.length;
    let t = this.remapping(0, e),
      n = t.maps.length,
      r = [],
      o = 0;
    return this.items.forEach((i, a) => {
      if (a >= e) r.push(i), i.selection && o++;else if (i.step) {
        let e = i.step.map(t.slice(n)),
          a = e && e.getMap();
        if (n--, a && t.appendMap(a, n), e) {
          let c = i.selection && i.selection.map(t.slice(n));
          c && o++;
          let s,
            l = new WF(a.invert(), e, c),
            u = r.length - 1;
          (s = r.length && r[u].merge(l)) ? r[u] = s : r.push(l);
        }
      } else i.map && n--;
    }, this.items.length, 0), new ZF(FF.from(r.reverse()), o);
  }
}
ZF.empty = new ZF(FF.empty, 0);
class WF {
  constructor(e, t, n, r) {
    this.map = e, this.step = t, this.selection = n, this.mirrorOffset = r;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t) return new WF(t.getMap().invert(), t, this.selection);
    }
  }
}
class XF {
  constructor(e, t, n, r, o) {
    this.done = e, this.undone = t, this.prevRanges = n, this.prevTime = r, this.prevComposition = o;
  }
}
const UF = 20;
function KF(e) {
  let t = [];
  return e.forEach((e, n, r, o) => t.push(r, o)), t;
}
function YF(e, t) {
  if (!e) return null;
  let n = [];
  for (let r = 0; r < e.length; r += 2) {
    let o = t.map(e[r], 1),
      i = t.map(e[r + 1], -1);
    o <= i && n.push(o, i);
  }
  return n;
}
function qF(e, t, n, r) {
  let o = ej(t),
    i = tj.get(t).spec.config,
    a = (r ? e.undone : e.done).popEvent(t, o);
  if (!a) return;
  let c = a.selection.resolve(a.transform.doc),
    s = (r ? e.done : e.undone).addTransform(a.transform, t.selection.getBookmark(), i, o),
    l = new XF(r ? s : a.remaining, r ? a.remaining : s, null, 0, -1);
  n(a.transform.setSelection(c).setMeta(tj, {
    redo: r,
    historyState: l
  }).scrollIntoView());
}
let _F = !1,
  $F = null;
function ej(e) {
  let t = e.plugins;
  if ($F != t) {
    _F = !1, $F = t;
    for (let e = 0; e < t.length; e++) if (t[e].spec.historyPreserveItems) {
      _F = !0;
      break;
    }
  }
  return _F;
}
const tj = new TS("history"),
  nj = new TS("closeHistory");
function rj() {
  let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return e = {
    depth: e.depth || 100,
    newGroupDelay: e.newGroupDelay || 500
  }, new LS({
    key: tj,
    state: {
      init: () => new XF(ZF.empty, ZF.empty, null, 0, -1),
      apply: (t, n, r) => function (e, t, n, r) {
        let o,
          i = n.getMeta(tj);
        if (i) return i.historyState;
        n.getMeta(nj) && (e = new XF(e.done, e.undone, null, 0, -1));
        let a = n.getMeta("appendedTransaction");
        if (0 == n.steps.length) return e;
        if (a && a.getMeta(tj)) return a.getMeta(tj).redo ? new XF(e.done.addTransform(n, void 0, r, ej(t)), e.undone, KF(n.mapping.maps[n.steps.length - 1]), e.prevTime, e.prevComposition) : new XF(e.done, e.undone.addTransform(n, void 0, r, ej(t)), null, e.prevTime, e.prevComposition);
        if (!1 === n.getMeta("addToHistory") || a && !1 === a.getMeta("addToHistory")) return (o = n.getMeta("rebased")) ? new XF(e.done.rebased(n, o), e.undone.rebased(n, o), YF(e.prevRanges, n.mapping), e.prevTime, e.prevComposition) : new XF(e.done.addMaps(n.mapping.maps), e.undone.addMaps(n.mapping.maps), YF(e.prevRanges, n.mapping), e.prevTime, e.prevComposition);
        {
          let o = n.getMeta("composition"),
            i = 0 == e.prevTime || !a && e.prevComposition != o && (e.prevTime < (n.time || 0) - r.newGroupDelay || !function (e, t) {
              if (!t) return !1;
              if (!e.docChanged) return !0;
              let n = !1;
              return e.mapping.maps[0].forEach((e, r) => {
                for (let o = 0; o < t.length; o += 2) e <= t[o + 1] && r >= t[o] && (n = !0);
              }), n;
            }(n, e.prevRanges)),
            c = a ? YF(e.prevRanges, n.mapping) : KF(n.mapping.maps[n.steps.length - 1]);
          return new XF(e.done.addTransform(n, i ? t.selection.getBookmark() : void 0, r, ej(t)), ZF.empty, c, n.time, null == o ? e.prevComposition : o);
        }
      }(n, r, t, e)
    },
    config: e,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let n = t.inputType,
            r = "historyUndo" == n ? oj : "historyRedo" == n ? ij : null;
          return !!r && (t.preventDefault(), r(e.state, e.dispatch));
        }
      }
    }
  });
}
const oj = (e, t) => {
    let n = tj.getState(e);
    return !(!n || 0 == n.done.eventCount) && (t && qF(n, e, t, !1), !0);
  },
  ij = (e, t) => {
    let n = tj.getState(e);
    return !(!n || 0 == n.undone.eventCount) && (t && qF(n, e, t, !0), !0);
  },
  aj = rT.create({
    name: "history",
    addOptions: () => ({
      depth: 100,
      newGroupDelay: 500
    }),
    addCommands: () => ({
      undo: () => _ref158 => {
        let e = _ref158.state,
          t = _ref158.dispatch;
        return oj(e, t);
      },
      redo: () => _ref159 => {
        let e = _ref159.state,
          t = _ref159.dispatch;
        return ij(e, t);
      }
    }),
    addProseMirrorPlugins() {
      return [rj(this.options)];
    },
    addKeyboardShortcuts() {
      return {
        "Mod-z": () => this.editor.commands.undo(),
        "Mod-y": () => this.editor.commands.redo(),
        "Shift-Mod-z": () => this.editor.commands.redo(),
        "Mod-я": () => this.editor.commands.undo(),
        "Shift-Mod-я": () => this.editor.commands.redo()
      };
    }
  }),
  cj = WT.create({
    name: "horizontalRule",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    group: "block",
    parseHTML: () => [{
      tag: "hr"
    }],
    renderHTML(_ref160) {
      let e = _ref160.HTMLAttributes;
      return ["hr", DO(this.options.HTMLAttributes, e)];
    },
    addCommands() {
      return {
        setHorizontalRule: () => _ref161 => {
          let e = _ref161.chain;
          return e().insertContent({
            type: this.name
          }).command(_ref162 => {
            let e = _ref162.tr,
              t = _ref162.dispatch;
            var n;
            if (t) {
              const t = e.selection.$to,
                r = t.end();
              if (t.nodeAfter) e.setSelection(bS.create(e.doc, t.pos));else {
                const o = null === (n = t.parent.type.contentMatch.defaultType) || void 0 === n ? void 0 : n.create();
                o && (e.insert(r, o), e.setSelection(bS.create(e.doc, r)));
              }
              e.scrollIntoView();
            }
            return !0;
          }).run();
        }
      };
    },
    addInputRules() {
      return [FT({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })];
    }
  }),
  sj = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))$/,
  lj = /(?:^|\s)((?:\*)((?:[^*]+))(?:\*))/g,
  uj = /(?:^|\s)((?:_)((?:[^_]+))(?:_))$/,
  dj = /(?:^|\s)((?:_)((?:[^_]+))(?:_))/g,
  fj = ZT.create({
    name: "italic",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "em"
    }, {
      tag: "i",
      getAttrs: e => "normal" !== e.style.fontStyle && null
    }, {
      style: "font-style=italic"
    }],
    renderHTML(_ref163) {
      let e = _ref163.HTMLAttributes;
      return ["em", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setItalic: () => _ref164 => {
          let e = _ref164.commands;
          return e.setMark(this.name);
        },
        toggleItalic: () => _ref165 => {
          let e = _ref165.commands;
          return e.toggleMark(this.name);
        },
        unsetItalic: () => _ref166 => {
          let e = _ref166.commands;
          return e.unsetMark(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-i": () => this.editor.commands.toggleItalic(),
        "Mod-I": () => this.editor.commands.toggleItalic()
      };
    },
    addInputRules() {
      return [GT({
        find: sj,
        type: this.type
      }), GT({
        find: uj,
        type: this.type
      })];
    },
    addPasteRules() {
      return [XT({
        find: lj,
        type: this.type
      }), XT({
        find: dj,
        type: this.type
      })];
    }
  }),
  pj = WT.create({
    name: "listItem",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    content: "paragraph block*",
    defining: !0,
    parseHTML: () => [{
      tag: "li"
    }],
    renderHTML(_ref167) {
      let e = _ref167.HTMLAttributes;
      return ["li", DO(this.options.HTMLAttributes, e), 0];
    },
    addKeyboardShortcuts() {
      return {
        Enter: () => this.editor.commands.splitListItem(this.name),
        Tab: () => this.editor.commands.sinkListItem(this.name),
        "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
      };
    }
  }),
  mj = ZT.create({
    name: "textStyle",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "span",
      getAttrs: e => !!e.hasAttribute("style") && {}
    }],
    renderHTML(_ref168) {
      let e = _ref168.HTMLAttributes;
      return ["span", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        removeEmptyTextStyle: () => _ref169 => {
          let e = _ref169.state,
            t = _ref169.commands;
          const n = BT(e, this.type);
          return !!Object.entries(n).some(_ref170 => {
            let _ref171 = _slicedToArray(_ref170, 2),
              e = _ref171[1];
            return !!e;
          }) || t.unsetMark(this.name);
        }
      };
    }
  }),
  hj = /^(\d+)\.\s$/,
  Aj = WT.create({
    name: "orderedList",
    addOptions: () => ({
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    }),
    group: "block list",
    content() {
      return `${this.options.itemTypeName}+`;
    },
    addAttributes: () => ({
      start: {
        default: 1,
        parseHTML: e => e.hasAttribute("start") ? parseInt(e.getAttribute("start") || "", 10) : 1
      }
    }),
    parseHTML: () => [{
      tag: "ol"
    }],
    renderHTML(_ref172) {
      let e = _ref172.HTMLAttributes;
      const t = e.start,
        n = _objectWithoutProperties(e, _excluded2);
      return 1 === t ? ["ol", DO(this.options.HTMLAttributes, n), 0] : ["ol", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        toggleOrderedList: () => _ref173 => {
          let e = _ref173.commands,
            t = _ref173.chain;
          return this.options.keepAttributes ? t().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(pj.name, this.editor.getAttributes(mj.name)).run() : e.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
      };
    },
    addInputRules() {
      let e = JT({
        find: hj,
        type: this.type,
        getAttributes: e => ({
          start: +e[1]
        }),
        joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
      });
      return (this.options.keepMarks || this.options.keepAttributes) && (e = JT({
        find: hj,
        type: this.type,
        keepMarks: this.options.keepMarks,
        keepAttributes: this.options.keepAttributes,
        getAttributes: e => _objectSpread({
          start: +e[1]
        }, this.editor.getAttributes(mj.name)),
        joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
        editor: this.editor
      })), [e];
    }
  }),
  gj = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))$/,
  vj = /(?:^|\s)((?:~~)((?:[^~]+))(?:~~))/g,
  Cj = ZT.create({
    name: "strike",
    addOptions: () => ({
      HTMLAttributes: {}
    }),
    parseHTML: () => [{
      tag: "s"
    }, {
      tag: "del"
    }, {
      tag: "strike"
    }, {
      style: "text-decoration",
      consuming: !1,
      getAttrs: e => !!e.includes("line-through") && {}
    }],
    renderHTML(_ref174) {
      let e = _ref174.HTMLAttributes;
      return ["s", DO(this.options.HTMLAttributes, e), 0];
    },
    addCommands() {
      return {
        setStrike: () => _ref175 => {
          let e = _ref175.commands;
          return e.setMark(this.name);
        },
        toggleStrike: () => _ref176 => {
          let e = _ref176.commands;
          return e.toggleMark(this.name);
        },
        unsetStrike: () => _ref177 => {
          let e = _ref177.commands;
          return e.unsetMark(this.name);
        }
      };
    },
    addKeyboardShortcuts() {
      return {
        "Mod-Shift-x": () => this.editor.commands.toggleStrike()
      };
    },
    addInputRules() {
      return [GT({
        find: gj,
        type: this.type
      })];
    },
    addPasteRules() {
      return [XT({
        find: vj,
        type: this.type
      })];
    }
  }),
  bj = rT.create({
    name: "starterKit",
    addExtensions() {
      var e, t, n, r, o, i, a, c, s, l, u, d, f, p, m, h, A, g;
      const v = [];
      return !1 !== this.options.blockquote && v.push(pF.configure(null === (e = this.options) || void 0 === e ? void 0 : e.blockquote)), !1 !== this.options.bold && v.push(vF.configure(null === (t = this.options) || void 0 === t ? void 0 : t.bold)), !1 !== this.options.bulletList && v.push(yF.configure(null === (n = this.options) || void 0 === n ? void 0 : n.bulletList)), !1 !== this.options.code && v.push(xF.configure(null === (r = this.options) || void 0 === r ? void 0 : r.code)), !1 !== this.options.codeBlock && v.push(HF.configure(null === (o = this.options) || void 0 === o ? void 0 : o.codeBlock)), !1 !== this.options.document && v.push(AG.configure(null === (i = this.options) || void 0 === i ? void 0 : i.document)), !1 !== this.options.dropcursor && v.push(kF.configure(null === (a = this.options) || void 0 === a ? void 0 : a.dropcursor)), !1 !== this.options.gapcursor && v.push(DF.configure(null === (c = this.options) || void 0 === c ? void 0 : c.gapcursor)), !1 !== this.options.hardBreak && v.push(RF.configure(null === (s = this.options) || void 0 === s ? void 0 : s.hardBreak)), !1 !== this.options.heading && v.push(GF.configure(null === (l = this.options) || void 0 === l ? void 0 : l.heading)), !1 !== this.options.history && v.push(aj.configure(null === (u = this.options) || void 0 === u ? void 0 : u.history)), !1 !== this.options.horizontalRule && v.push(cj.configure(null === (d = this.options) || void 0 === d ? void 0 : d.horizontalRule)), !1 !== this.options.italic && v.push(fj.configure(null === (f = this.options) || void 0 === f ? void 0 : f.italic)), !1 !== this.options.listItem && v.push(pG.configure(null === (p = this.options) || void 0 === p ? void 0 : p.listItem)), !1 !== this.options.orderedList && v.push(Aj.configure(null === (m = this.options) || void 0 === m ? void 0 : m.orderedList)), !1 !== this.options.paragraph && v.push(gG.configure(null === (h = this.options) || void 0 === h ? void 0 : h.paragraph)), !1 !== this.options.strike && v.push(Cj.configure(null === (A = this.options) || void 0 === A ? void 0 : A.strike)), !1 !== this.options.text && v.push(vG.configure(null === (g = this.options) || void 0 === g ? void 0 : g.text)), v;
    }
  });
var Ej = {
    menuBar: "InputRichTextarea-module_menuBar__1S1aC",
    menuButton: "InputRichTextarea-module_menuButton__30oVK",
    isActive: "InputRichTextarea-module_isActive__1-KCW",
    isDisabled: "InputRichTextarea-module_isDisabled__1CC2a",
    divider: "InputRichTextarea-module_divider__12N_m",
    wrapper: "InputRichTextarea-module_wrapper__J5xEa",
    addScroll: "InputRichTextarea-module_addScroll__ijkB2",
    "height-s": "InputRichTextarea-module_height-s__Wdehx",
    "height-m": "InputRichTextarea-module_height-m__1nJ87",
    "height-l": "InputRichTextarea-module_height-l__1vqs5",
    "min-height-s": "InputRichTextarea-module_min-height-s__b2Cjr",
    "min-height-xs": "InputRichTextarea-module_min-height-xs__2GhXr",
    "min-height-none": "InputRichTextarea-module_min-height-none__1jkX-"
  },
  yj = {
    "ds-tooltip-theme-dark": "Tooltip-module_ds-tooltip-theme-dark__2qDAR",
    "ds-tooltip-theme-light": "Tooltip-module_ds-tooltip-theme-light__6Klra",
    "ds-tooltip-theme-gray": "Tooltip-module_ds-tooltip-theme-gray__2eZsx"
  };
function Ij(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = {},
    i = Object.keys(e);
  for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
  return o;
}
var Bj = "undefined" != typeof window && "undefined" != typeof document;
function xj(e, t) {
  e && ("function" == typeof e && e(t), {}.hasOwnProperty.call(e, "current") && (e.current = t));
}
function wj() {
  return Bj && document.createElement("div");
}
function Qj(e, t) {
  if (e === t) return !0;
  if ("object" == typeof e && null != e && "object" == typeof t && null != t) {
    if (Object.keys(e).length !== Object.keys(t).length) return !1;
    for (var n in e) {
      if (!t.hasOwnProperty(n)) return !1;
      if (!Qj(e[n], t[n])) return !1;
    }
    return !0;
  }
  return !1;
}
function Hj(e) {
  var t = [];
  return e.forEach(function (e) {
    t.find(function (t) {
      return Qj(e, t);
    }) || t.push(e);
  }), t;
}
var zj = Bj ? p : r;
function Mj(e, t, n) {
  n.split(/\s+/).forEach(function (n) {
    n && e.classList[t](n);
  });
}
var kj = {
  name: "className",
  defaultValue: "",
  fn: function (e) {
    var t = e.popper.firstElementChild,
      n = function () {
        var t;
        return !!(null == (t = e.props.render) ? void 0 : t.$$tippy);
      };
    function r() {
      !e.props.className || n() ? Mj(t, "add", e.props.className) : "production" !== process.env.NODE_ENV && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
    }
    return {
      onCreate: r,
      onBeforeUpdate: function () {
        n() && Mj(t, "remove", e.props.className);
      },
      onAfterUpdate: r
    };
  }
};
function Nj(e) {
  return function (r) {
    var i = r.children,
      a = r.content,
      c = r.visible,
      s = r.singleton,
      l = r.render,
      u = r.reference,
      d = r.disabled,
      f = void 0 !== d && d,
      p = r.ignoreAttributes,
      h = void 0 === p || p;
    r.__source, r.__self;
    var A,
      g,
      v = Ij(r, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]),
      C = void 0 !== c,
      b = void 0 !== s,
      E = n(!1),
      y = E[0],
      I = E[1],
      x = n({}),
      w = x[0],
      Q = x[1],
      H = n(),
      z = H[0],
      M = H[1],
      k = (A = function () {
        return {
          container: wj(),
          renders: 1
        };
      }, (g = o()).current || (g.current = "function" == typeof A ? A() : A), g.current),
      N = Object.assign({
        ignoreAttributes: h
      }, v, {
        content: k.container
      });
    C && ("production" !== process.env.NODE_ENV && ["trigger", "hideOnClick", "showOnCreate"].forEach(function (e) {
      void 0 !== N[e] && console.warn(["@tippyjs/react: Cannot specify `" + e + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), N.trigger = "manual", N.hideOnClick = !1), b && (f = !0);
    var S = N,
      V = N.plugins || [];
    l && (S = Object.assign({}, N, {
      plugins: b && null != s.data ? [].concat(V, [{
        fn: function () {
          return {
            onTrigger: function (e, t) {
              var n = s.data.children.find(function (e) {
                return e.instance.reference === t.currentTarget;
              });
              e.state.$$activeSingletonInstance = n.instance, M(n.content);
            }
          };
        }
      }]) : V,
      render: function () {
        return {
          popper: k.container
        };
      }
    }));
    var L = [u].concat(i ? [i.type] : []);
    return zj(function () {
      var t = u;
      u && u.hasOwnProperty("current") && (t = u.current);
      var n = e(t || k.ref || wj(), Object.assign({}, S, {
        plugins: [kj].concat(N.plugins || [])
      }));
      return k.instance = n, f && n.disable(), c && n.show(), b && s.hook({
        instance: n,
        content: a,
        props: S,
        setSingletonContent: M
      }), I(!0), function () {
        n.destroy(), null == s || s.cleanup(n);
      };
    }, L), zj(function () {
      var e;
      if (1 !== k.renders) {
        var t,
          n,
          r,
          o,
          i = k.instance;
        i.setProps((t = i.props, n = S, Object.assign({}, n, {
          popperOptions: Object.assign({}, t.popperOptions, n.popperOptions, {
            modifiers: Hj([].concat((null == (r = t.popperOptions) ? void 0 : r.modifiers) || [], (null == (o = n.popperOptions) ? void 0 : o.modifiers) || []))
          })
        }))), null == (e = i.popperInstance) || e.forceUpdate(), f ? i.disable() : i.enable(), C && (c ? i.show() : i.hide()), b && s.hook({
          instance: i,
          content: a,
          props: S,
          setSingletonContent: M
        });
      } else k.renders++;
    }), zj(function () {
      var e;
      if (l) {
        var t = k.instance;
        t.setProps({
          popperOptions: Object.assign({}, t.props.popperOptions, {
            modifiers: [].concat(((null == (e = t.props.popperOptions) ? void 0 : e.modifiers) || []).filter(function (e) {
              return "$$tippyReact" !== e.name;
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function (e) {
                var t,
                  n = e.state,
                  r = null == (t = n.modifiersData) ? void 0 : t.hide;
                w.placement === n.placement && w.referenceHidden === (null == r ? void 0 : r.isReferenceHidden) && w.escaped === (null == r ? void 0 : r.hasPopperEscaped) || Q({
                  placement: n.placement,
                  referenceHidden: null == r ? void 0 : r.isReferenceHidden,
                  escaped: null == r ? void 0 : r.hasPopperEscaped
                }), n.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [w.placement, w.referenceHidden, w.escaped].concat(L)), /*#__PURE__*/t.createElement(t.Fragment, null, i ? /*#__PURE__*/m(i, {
      ref: function (e) {
        k.ref = e, xj(i.ref, e);
      }
    }) : null, y && /*#__PURE__*/B(l ? l(function (e) {
      var t = {
        "data-placement": e.placement
      };
      return e.referenceHidden && (t["data-reference-hidden"] = ""), e.escaped && (t["data-escaped"] = ""), t;
    }(w), z, k.instance) : a, k.container));
  };
}
var Sj = function (e, n) {
    return /*#__PURE__*/c(function (r, o) {
      var i = r.children,
        a = Ij(r, ["children"]);
      return /*#__PURE__*/t.createElement(e, Object.assign({}, n, a), i ? /*#__PURE__*/m(i, {
        ref: function (e) {
          xj(o, e), xj(i.ref, e);
        }
      }) : null);
    });
  },
  Vj = Sj(Nj(rG)),
  Lj = /*#__PURE__*/c(function (e, n) {
    return /*#__PURE__*/t.createElement("div", {
      className: e.wrapperClassName,
      ref: n
    }, e.children);
  });
Lj.displayName = "ChildrenWrapper";
var Pj = function (e) {
  var n = e.theme,
    r = e.children,
    o = e.tipContent,
    i = e.trigger,
    a = e.parseHtml,
    c = e.hasInlineChild,
    s = e.isInteractive,
    l = e.placement,
    u = e.wrapperClassName,
    d = [oG];
  return /*#__PURE__*/t.createElement(Vj, {
    className: tC(k({}, yj["ds-tooltip-theme-".concat(n)], n)),
    content: o,
    trigger: "hover" === i ? "mouseenter focus" : i,
    allowHTML: a,
    inlinePositioning: c,
    plugins: d,
    interactive: s,
    placement: l,
    touch: !1,
    zIndex: 100,
    offset: [0, 16]
  }, /*#__PURE__*/t.createElement(Lj, {
    wrapperClassName: u
  }, r));
};
Pj.propTypes = {
  children: g.any,
  tipContent: g.oneOfType([g.string, g.element, g.func]),
  trigger: g.oneOf(["hover", "click"]),
  parseHtml: g.bool,
  hasInlineChild: g.bool,
  isInteractive: g.bool,
  placement: g.oneOf(["top", "top-start", "top-end", "right", "right-start", "right-end", "left", "left-start", "left-end", "bottom", "bottom-start", "bottom-end", "auto", "auto-start", "auto-end"]),
  theme: g.oneOf(["light", "gray", "dark"]),
  wrapperClassName: g.string
}, Pj.defaultProps = {
  theme: "dark",
  trigger: "hover",
  parseHtml: !1,
  hasInlineChild: !1,
  isInteractive: !1,
  placement: "top"
};
var Oj = function (e) {
  var n = e.onClick,
    r = e.disabled,
    o = e.iconName,
    i = e.tooltip,
    a = e.isActive,
    c = function () {
      var e;
      return /*#__PURE__*/t.createElement(RC, {
        renderAs: "button",
        type: "button",
        onClick: n,
        disabled: r,
        className: tC(Ej.menuButton, (e = {}, k(e, Ej.isActive, a), k(e, Ej.isDisabled, r), e))
      }, /*#__PURE__*/t.createElement(qv, {
        name: o
      }));
    };
  return i ? /*#__PURE__*/t.createElement(Pj, {
    theme: "dark",
    tipContent: i
  }, c()) : c();
};
Oj.propTypes = {
  onClick: g.func,
  disabled: g.bool,
  iconName: g.string,
  isActive: g.bool,
  tooltip: g.string
};
var Tj = function (e) {
  var n = e.editor,
    r = e.addContentFormatting,
    o = e.addHeaders,
    i = e.addParagraphStyling,
    a = e.addLists,
    c = l(function () {
      var e = n.getAttributes("link").href,
        t = window.prompt("URL", e);
      null !== t && ("" !== t ? n.chain().focus().extendMarkRange("link").toggleLink({
        href: t
      }).run() : n.chain().focus().extendMarkRange("link").unsetLink().run());
    }, [n]);
  return n ? /*#__PURE__*/t.createElement(sb, {
    className: Ej.menuBar,
    padding: "xxs",
    justifyContent: "space-between"
  }, /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleBold().run();
    },
    disabled: !n.can().chain().focus().toggleBold().run(),
    isActive: n.isActive("bold"),
    iconName: "bold",
    tooltip: "Bold"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleItalic().run();
    },
    disabled: !n.can().chain().focus().toggleItalic().run(),
    isActive: n.isActive("italic"),
    iconName: "italic",
    tooltip: "Italic"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleStrike().run();
    },
    disabled: !n.can().chain().focus().toggleStrike().run(),
    isActive: n.isActive("strike"),
    iconName: "strikethrough",
    tooltip: "Strike-through"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleUnderline().run();
    },
    isActive: n.isActive("underline"),
    iconName: "underline",
    tooltip: "Underline"
  })), /*#__PURE__*/t.createElement(nb, {
    className: Ej.divider
  }), /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setParagraph().run();
    },
    isActive: n.isActive("paragraph"),
    iconName: "paragraph",
    tooltip: "Paragraph"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setHardBreak().run();
    },
    iconName: "turnDownLeft",
    tooltip: "New Line"
  })), i && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setTextAlign("left").run();
    },
    isActive: n.isActive({
      textAlign: "left"
    }),
    iconName: "alignLeft",
    tooltip: "Align Left"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setTextAlign("center").run();
    },
    isActive: n.isActive({
      textAlign: "center"
    }),
    iconName: "alignCenter",
    tooltip: "Align Center"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setTextAlign("right").run();
    },
    isActive: n.isActive({
      textAlign: "right"
    }),
    iconName: "alignRight",
    tooltip: "Align Right"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setTextAlign("justify").run();
    },
    isActive: n.isActive({
      textAlign: "justify"
    }),
    iconName: "alignJustify",
    tooltip: "Align Justify"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().unsetTextAlign().run();
    },
    iconName: "alignSlash",
    tooltip: "Clear Align"
  })), a && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
    className: Ej.divider
  }), /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleBulletList().run();
    },
    isActive: n.isActive("bulletList"),
    iconName: "list",
    tooltip: "Bullet List"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleOrderedList().run();
    },
    isActive: n.isActive("orderedList"),
    iconName: "listOl",
    tooltip: "Number List"
  }))), o && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
    className: Ej.divider
  }), /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleHeading({
        level: 1
      }).run();
    },
    isActive: n.isActive("heading", {
      level: 1
    }),
    iconName: "h1",
    tooltip: "H1"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleHeading({
        level: 2
      }).run();
    },
    isActive: n.isActive("heading", {
      level: 2
    }),
    iconName: "h2",
    tooltip: "H2"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleHeading({
        level: 3
      }).run();
    },
    isActive: n.isActive("heading", {
      level: 3
    }),
    iconName: "h3",
    tooltip: "H3"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleHeading({
        level: 4
      }).run();
    },
    isActive: n.isActive("heading", {
      level: 4
    }),
    iconName: "h4",
    tooltip: "H4"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleHeading({
        level: 5
      }).run();
    },
    isActive: n.isActive("heading", {
      level: 5
    }),
    iconName: "h5",
    tooltip: "H5"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleHeading({
        level: 6
      }).run();
    },
    isActive: n.isActive("heading", {
      level: 6
    }),
    iconName: "h6",
    tooltip: "H6"
  }))), r && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
    className: Ej.divider
  }), /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(Oj, {
    onClick: c,
    isActive: n.isActive("link"),
    iconName: "link",
    tooltip: "Link"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().toggleBlockquote().run();
    },
    isActive: n.isActive("blockquote"),
    iconName: "blockquote",
    tooltip: "Block Quote"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().setHorizontalRule().run();
    },
    iconName: "horizontalRule",
    tooltip: "Divider"
  })))), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().unsetAllMarks().run();
    },
    iconName: "textSlash",
    tooltip: "Clear Text Styles"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().clearNodes().run();
    },
    iconName: "times",
    tooltip: "Clear Content Styles"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().undo().run();
    },
    disabled: !n.can().chain().focus().undo().run(),
    iconName: "rotateLeft",
    tooltip: "Undo"
  }), /*#__PURE__*/t.createElement(Oj, {
    onClick: function () {
      return n.chain().focus().redo().run();
    },
    disabled: !n.can().chain().focus().redo().run(),
    iconName: "rotateRight",
    tooltip: "Redo"
  })))) : null;
};
Tj.propTypes = {
  editor: g.any.isRequired,
  addHeaders: g.bool,
  addContentFormatting: g.bool,
  addParagraphStyling: g.bool,
  addLists: g.bool
};
var Dj = function (e) {
  var o = e.inputFocused,
    i = e.removeBottomSpacer,
    a = e.isDisabled,
    c = e.onBlur,
    s = e.onFocus,
    l = e.isError,
    u = e.description,
    d = e.value,
    f = e.onChange,
    p = e.maxLength,
    m = e.placeholder,
    h = e.showMenuBar,
    A = e.addContentFormatting,
    g = e.addHeaders,
    v = e.addParagraphStyling,
    C = e.addLists,
    b = e.maxHeight,
    E = e.customMaxHeight,
    y = e.removeInputWrapper,
    I = e.minHeight,
    B = e.useCharacterCount,
    x = e.customColor,
    w = V(n(!1), 2),
    Q = w[0],
    H = w[1],
    z = V(n(0), 2),
    M = z[0],
    N = z[1],
    S = dG({
      editorProps: {
        attributes: {
          class: tC("ds-rich-text")
        }
      },
      extensions: [AG, gG, vG, hG.configure({
        limit: p
      }), CG.configure({
        placeholder: m
      }), pG, mG, uF.configure({
        openOnClick: !1
      }), bG, dF.configure({
        types: ["heading", "paragraph"]
      }), bj.configure({
        bulletList: {
          keepMarks: !0,
          keepAttributes: !1
        },
        orderedList: {
          keepMarks: !0,
          keepAttributes: !1
        }
      })],
      content: d,
      onFocus: function () {
        H(!0), s && s();
      },
      onBlur: function () {
        H(!1), c && c();
      },
      onUpdate: function (e) {
        var t = e.editor;
        f(t.getHTML(), t.getText(), t.storage.characterCount.characters(), t.storage.characterCount.words()), N(t.storage.characterCount.characters());
      },
      onCreate: function (e) {
        var t = e.editor;
        N(t.storage.characterCount.characters());
      }
    }),
    L = function () {
      var e;
      return /*#__PURE__*/t.createElement(nb, {
        padding: "xs",
        className: tC(Ej.wrapper, (e = {}, k(e, Ej["height-".concat(b)], b), k(e, Ej["min-height-".concat(I)], I), k(e, Ej.addScroll, b), e)),
        style: E ? {
          maxHeight: E
        } : null
      }, /*#__PURE__*/t.createElement(lG, {
        editor: S
      }));
    };
  return r(function () {
    "" === d && S && S.commands.clearContent();
  }, [d]), S ? /*#__PURE__*/t.createElement(nb, {
    style: {
      width: "100%"
    }
  }, h && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Tj, {
    editor: S,
    addContentFormatting: A,
    addHeaders: g,
    addParagraphStyling: v,
    addLists: C
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xs"
  })), y ? L() : /*#__PURE__*/t.createElement(qb, {
    removeBottomSpacer: i,
    isActive: o || Q,
    isDisabled: a,
    description: u,
    isError: l,
    inputWidth: "auto",
    characterCount: M,
    characterCountTotal: p,
    useCharacterCount: B,
    customColor: x
  }, L())) : null;
};
function Rj(e) {
  return Rj = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rj(e);
}
function Gj(e) {
  var t = function (e, t) {
    if ("object" !== Rj(e) || null === e) return e;
    var n = e[Symbol.toPrimitive];
    if (void 0 !== n) {
      var r = n.call(e, t || "default");
      if ("object" !== Rj(r)) return r;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === t ? String : Number)(e);
  }(e, "string");
  return "symbol" === Rj(t) ? t : String(t);
}
function Fj(e, t, n) {
  return (t = Gj(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function jj(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Jj(e, t) {
  if (e) {
    if ("string" == typeof e) return jj(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? jj(e, t) : void 0;
  }
}
function Zj(e) {
  return function (e) {
    if (Array.isArray(e)) return jj(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || Jj(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Wj(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        o,
        i,
        a,
        c = [],
        s = !0,
        l = !1;
      try {
        if (i = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          s = !1;
        } else for (; !(s = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); s = !0);
      } catch (e) {
        l = !0, o = e;
      } finally {
        try {
          if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
        } finally {
          if (l) throw o;
        }
      }
      return c;
    }
  }(e, t) || Jj(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function Xj(e) {
  return Xj = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xj(e);
}
Dj.propTypes = {
  value: g.string,
  onChange: g.func.isRequired,
  inputFocused: g.bool,
  onFocus: g.func,
  onBlur: g.func,
  isDisabled: g.bool,
  removeBottomSpacer: g.bool,
  isError: g.bool,
  description: g.string,
  placeholder: g.string,
  showMenuBar: g.bool,
  addHeaders: g.bool,
  addContentFormatting: g.bool,
  addParagraphStyling: g.bool,
  addLists: g.bool,
  minHeight: g.oneOf(["s", "xs", "none"]),
  maxHeight: g.oneOf(["s", "m", "l", "custom"]),
  customMaxHeight: g.oneOfType([g.string, g.number]),
  maxLength: g.number,
  removeInputWrapper: g.bool,
  useCharacterCount: g.bool,
  customColor: g.string
}, Dj.defaultProps = {
  showMenuBar: !0,
  addHeaders: !1,
  addContentFormatting: !1,
  addParagraphStyling: !1,
  addLists: !1,
  minHeight: "s"
};
var Uj = {},
  Kj = [];
function Yj(e, t) {
  if ("production" !== process.env.NODE_ENV && !e && void 0 !== console) {
    var n = Kj.reduce(function (e, t) {
      return t(null != e ? e : "", "warning");
    }, t);
    n && console.error("Warning: ".concat(n));
  }
}
function qj(e, t) {
  if ("production" !== process.env.NODE_ENV && !e && void 0 !== console) {
    var n = Kj.reduce(function (e, t) {
      return t(null != e ? e : "", "note");
    }, t);
    n && console.warn("Note: ".concat(n));
  }
}
function _j(e, t, n) {
  t || Uj[n] || (e(!1, n), Uj[n] = !0);
}
function $j(e, t) {
  _j(Yj, e, t);
}
function eJ(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function tJ(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null != n) {
      var r,
        o,
        i,
        a,
        c = [],
        s = !0,
        l = !1;
      try {
        if (i = (n = n.call(e)).next, 0 === t) {
          if (Object(n) !== n) return;
          s = !1;
        } else for (; !(s = (r = i.call(n)).done) && (c.push(r.value), c.length !== t); s = !0);
      } catch (e) {
        l = !0, o = e;
      } finally {
        try {
          if (!s && null != n.return && (a = n.return(), Object(a) !== a)) return;
        } finally {
          if (l) throw o;
        }
      }
      return c;
    }
  }(e, t) || function (e, t) {
    if (e) {
      if ("string" == typeof e) return eJ(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? eJ(e, t) : void 0;
    }
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function nJ(t) {
  var n = e.useRef();
  n.current = t;
  var r = e.useCallback(function () {
    for (var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++) r[o] = arguments[o];
    return null === (e = n.current) || void 0 === e ? void 0 : e.call.apply(e, [n].concat(r));
  }, []);
  return r;
}
$j.preMessage = function (e) {
  Kj.push(e);
}, $j.resetWarned = function () {
  Uj = {};
}, $j.noteOnce = function (e, t) {
  _j(qj, e, t);
};
var rJ = "test" !== process.env.NODE_ENV && "undefined" != typeof window && window.document && window.document.createElement ? e.useLayoutEffect : e.useEffect,
  oJ = function (t, n) {
    !function (t, n) {
      var r = e.useRef(!0);
      rJ(function () {
        return t(r.current);
      }, n), rJ(function () {
        return r.current = !1, function () {
          r.current = !0;
        };
      }, []);
    }(function (e) {
      if (!e) return t();
    }, n);
  };
function iJ(t) {
  var n = e.useRef(!1),
    r = tJ(e.useState(t), 2),
    o = r[0],
    i = r[1];
  return e.useEffect(function () {
    return n.current = !1, function () {
      n.current = !0;
    };
  }, []), [o, function (e, t) {
    t && n.current || i(e);
  }];
}
function aJ(e) {
  return void 0 !== e;
}
function cJ() {
  return cJ = Object.assign ? Object.assign.bind() : function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, cJ.apply(this, arguments);
}
function sJ(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
  }
  return o;
}
function lJ(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function uJ(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? lJ(Object(n), !0).forEach(function (t) {
      Fj(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : lJ(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
var dJ = {
    MAC_ENTER: 3,
    BACKSPACE: 8,
    TAB: 9,
    NUM_CENTER: 12,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    PAUSE: 19,
    CAPS_LOCK: 20,
    ESC: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    PRINT_SCREEN: 44,
    INSERT: 45,
    DELETE: 46,
    ZERO: 48,
    ONE: 49,
    TWO: 50,
    THREE: 51,
    FOUR: 52,
    FIVE: 53,
    SIX: 54,
    SEVEN: 55,
    EIGHT: 56,
    NINE: 57,
    QUESTION_MARK: 63,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    META: 91,
    WIN_KEY_RIGHT: 92,
    CONTEXT_MENU: 93,
    NUM_ZERO: 96,
    NUM_ONE: 97,
    NUM_TWO: 98,
    NUM_THREE: 99,
    NUM_FOUR: 100,
    NUM_FIVE: 101,
    NUM_SIX: 102,
    NUM_SEVEN: 103,
    NUM_EIGHT: 104,
    NUM_NINE: 105,
    NUM_MULTIPLY: 106,
    NUM_PLUS: 107,
    NUM_MINUS: 109,
    NUM_PERIOD: 110,
    NUM_DIVISION: 111,
    F1: 112,
    F2: 113,
    F3: 114,
    F4: 115,
    F5: 116,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120,
    F10: 121,
    F11: 122,
    F12: 123,
    NUMLOCK: 144,
    SEMICOLON: 186,
    DASH: 189,
    EQUALS: 187,
    COMMA: 188,
    PERIOD: 190,
    SLASH: 191,
    APOSTROPHE: 192,
    SINGLE_QUOTE: 222,
    OPEN_SQUARE_BRACKET: 219,
    BACKSLASH: 220,
    CLOSE_SQUARE_BRACKET: 221,
    WIN_KEY: 224,
    MAC_FF_META: 224,
    WIN_IME: 229,
    isTextModifyingKeyEvent: function (e) {
      var t = e.keyCode;
      if (e.altKey && !e.ctrlKey || e.metaKey || t >= dJ.F1 && t <= dJ.F12) return !1;
      switch (t) {
        case dJ.ALT:
        case dJ.CAPS_LOCK:
        case dJ.CONTEXT_MENU:
        case dJ.CTRL:
        case dJ.DOWN:
        case dJ.END:
        case dJ.ESC:
        case dJ.HOME:
        case dJ.INSERT:
        case dJ.LEFT:
        case dJ.MAC_FF_META:
        case dJ.META:
        case dJ.NUMLOCK:
        case dJ.NUM_CENTER:
        case dJ.PAGE_DOWN:
        case dJ.PAGE_UP:
        case dJ.PAUSE:
        case dJ.PRINT_SCREEN:
        case dJ.RIGHT:
        case dJ.SHIFT:
        case dJ.UP:
        case dJ.WIN_KEY:
        case dJ.WIN_KEY_RIGHT:
          return !1;
        default:
          return !0;
      }
    },
    isCharacterKey: function (e) {
      if (e >= dJ.ZERO && e <= dJ.NINE) return !0;
      if (e >= dJ.NUM_ZERO && e <= dJ.NUM_MULTIPLY) return !0;
      if (e >= dJ.A && e <= dJ.Z) return !0;
      if (-1 !== window.navigator.userAgent.indexOf("WebKit") && 0 === e) return !0;
      switch (e) {
        case dJ.SPACE:
        case dJ.QUESTION_MARK:
        case dJ.NUM_PLUS:
        case dJ.NUM_MINUS:
        case dJ.NUM_PERIOD:
        case dJ.NUM_DIVISION:
        case dJ.SEMICOLON:
        case dJ.DASH:
        case dJ.EQUALS:
        case dJ.COMMA:
        case dJ.PERIOD:
        case dJ.SLASH:
        case dJ.APOSTROPHE:
        case dJ.SINGLE_QUOTE:
        case dJ.OPEN_SQUARE_BRACKET:
        case dJ.BACKSLASH:
        case dJ.CLOSE_SQUARE_BRACKET:
          return !0;
        default:
          return !1;
      }
    }
  },
  fJ = /*#__PURE__*/e.createContext({
    min: 0,
    max: 0,
    direction: "ltr",
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: !0
  });
function pJ(e, t, n) {
  return (e - t) / (n - t);
}
function mJ(e, t, n, r) {
  var o = pJ(t, n, r),
    i = {};
  switch (e) {
    case "rtl":
      i.right = "".concat(100 * o, "%"), i.transform = "translateX(50%)";
      break;
    case "btt":
      i.bottom = "".concat(100 * o, "%"), i.transform = "translateY(50%)";
      break;
    case "ttb":
      i.top = "".concat(100 * o, "%"), i.transform = "translateY(-50%)";
      break;
    default:
      i.left = "".concat(100 * o, "%"), i.transform = "translateX(-50%)";
  }
  return i;
}
function hJ(e, t) {
  return Array.isArray(e) ? e[t] : e;
}
var AJ = ["prefixCls", "value", "valueIndex", "onStartMove", "style", "render", "dragging", "onOffsetChange"],
  gJ = /*#__PURE__*/e.forwardRef(function (t, n) {
    var r,
      o,
      i = t.prefixCls,
      a = t.value,
      c = t.valueIndex,
      s = t.onStartMove,
      l = t.style,
      u = t.render,
      d = t.dragging,
      f = t.onOffsetChange,
      p = sJ(t, AJ),
      m = e.useContext(fJ),
      h = m.min,
      A = m.max,
      g = m.direction,
      v = m.disabled,
      C = m.keyboard,
      b = m.range,
      E = m.tabIndex,
      y = m.ariaLabelForHandle,
      I = m.ariaLabelledByForHandle,
      B = m.ariaValueTextFormatterForHandle,
      x = "".concat(i, "-handle"),
      w = function (e) {
        v || s(e, c);
      },
      Q = mJ(g, a, h, A),
      H = /*#__PURE__*/e.createElement("div", cJ({
        ref: n,
        className: tC(x, (r = {}, Fj(r, "".concat(x, "-").concat(c + 1), b), Fj(r, "".concat(x, "-dragging"), d), r)),
        style: uJ(uJ({}, Q), l),
        onMouseDown: w,
        onTouchStart: w,
        onKeyDown: function (e) {
          if (!v && C) {
            var t = null;
            switch (e.which || e.keyCode) {
              case dJ.LEFT:
                t = "ltr" === g || "btt" === g ? -1 : 1;
                break;
              case dJ.RIGHT:
                t = "ltr" === g || "btt" === g ? 1 : -1;
                break;
              case dJ.UP:
                t = "ttb" !== g ? 1 : -1;
                break;
              case dJ.DOWN:
                t = "ttb" !== g ? -1 : 1;
                break;
              case dJ.HOME:
                t = "min";
                break;
              case dJ.END:
                t = "max";
                break;
              case dJ.PAGE_UP:
                t = 2;
                break;
              case dJ.PAGE_DOWN:
                t = -2;
            }
            null !== t && (e.preventDefault(), f(t, c));
          }
        },
        tabIndex: v ? null : hJ(E, c),
        role: "slider",
        "aria-valuemin": h,
        "aria-valuemax": A,
        "aria-valuenow": a,
        "aria-disabled": v,
        "aria-label": hJ(y, c),
        "aria-labelledby": hJ(I, c),
        "aria-valuetext": null === (o = hJ(B, c)) || void 0 === o ? void 0 : o(a),
        "aria-orientation": "ltr" === g || "rtl" === g ? "horizontal" : "vertical"
      }, p));
    return u && (H = u(H, {
      index: c,
      prefixCls: i,
      value: a,
      dragging: d
    })), H;
  });
"production" !== process.env.NODE_ENV && (gJ.displayName = "Handle");
var vJ = ["prefixCls", "style", "onStartMove", "onOffsetChange", "values", "handleRender", "draggingIndex"],
  CJ = /*#__PURE__*/e.forwardRef(function (t, n) {
    var r = t.prefixCls,
      o = t.style,
      i = t.onStartMove,
      a = t.onOffsetChange,
      c = t.values,
      s = t.handleRender,
      l = t.draggingIndex,
      u = sJ(t, vJ),
      d = e.useRef({});
    return e.useImperativeHandle(n, function () {
      return {
        focus: function (e) {
          var t;
          null === (t = d.current[e]) || void 0 === t || t.focus();
        }
      };
    }), /*#__PURE__*/e.createElement(e.Fragment, null, c.map(function (t, n) {
      return /*#__PURE__*/e.createElement(gJ, cJ({
        ref: function (e) {
          e ? d.current[n] = e : delete d.current[n];
        },
        dragging: l === n,
        prefixCls: r,
        style: hJ(o, n),
        key: n,
        value: t,
        valueIndex: n,
        onStartMove: i,
        onOffsetChange: a,
        render: s
      }, u));
    }));
  });
function bJ(e) {
  var t = "touches" in e ? e.touches[0] : e;
  return {
    pageX: t.pageX,
    pageY: t.pageY
  };
}
function EJ(t) {
  var n,
    r = t.prefixCls,
    o = t.style,
    i = t.start,
    a = t.end,
    c = t.index,
    s = t.onStartMove,
    l = e.useContext(fJ),
    u = l.direction,
    d = l.min,
    f = l.max,
    p = l.disabled,
    m = l.range,
    h = "".concat(r, "-track"),
    A = pJ(i, d, f),
    g = pJ(a, d, f),
    v = function (e) {
      !p && s && s(e, -1);
    },
    C = {};
  switch (u) {
    case "rtl":
      C.right = "".concat(100 * A, "%"), C.width = "".concat(100 * g - 100 * A, "%");
      break;
    case "btt":
      C.bottom = "".concat(100 * A, "%"), C.height = "".concat(100 * g - 100 * A, "%");
      break;
    case "ttb":
      C.top = "".concat(100 * A, "%"), C.height = "".concat(100 * g - 100 * A, "%");
      break;
    default:
      C.left = "".concat(100 * A, "%"), C.width = "".concat(100 * g - 100 * A, "%");
  }
  return /*#__PURE__*/e.createElement("div", {
    className: tC(h, (n = {}, Fj(n, "".concat(h, "-").concat(c + 1), m), Fj(n, "".concat(r, "-track-draggable"), s), n)),
    style: uJ(uJ({}, C), o),
    onMouseDown: v,
    onTouchStart: v
  });
}
function yJ(t) {
  var n = t.prefixCls,
    r = t.style,
    o = t.values,
    i = t.startPoint,
    a = t.onStartMove,
    c = e.useContext(fJ),
    s = c.included,
    l = c.range,
    u = c.min,
    d = e.useMemo(function () {
      if (!l) {
        if (0 === o.length) return [];
        var e = null != i ? i : u,
          t = o[0];
        return [{
          start: Math.min(e, t),
          end: Math.max(e, t)
        }];
      }
      for (var n = [], r = 0; r < o.length - 1; r += 1) n.push({
        start: o[r],
        end: o[r + 1]
      });
      return n;
    }, [o, l, i, u]);
  return s ? d.map(function (t, o) {
    var i = t.start,
      c = t.end;
    return /*#__PURE__*/e.createElement(EJ, {
      index: o,
      prefixCls: n,
      style: hJ(r, o),
      start: i,
      end: c,
      key: o,
      onStartMove: a
    });
  }) : null;
}
function IJ(t) {
  var n = t.prefixCls,
    r = t.style,
    o = t.children,
    i = t.value,
    a = t.onClick,
    c = e.useContext(fJ),
    s = c.min,
    l = c.max,
    u = c.direction,
    d = c.includedStart,
    f = c.includedEnd,
    p = c.included,
    m = "".concat(n, "-text"),
    h = mJ(u, i, s, l);
  return /*#__PURE__*/e.createElement("span", {
    className: tC(m, Fj({}, "".concat(m, "-active"), p && d <= i && i <= f)),
    style: uJ(uJ({}, h), r),
    onMouseDown: function (e) {
      e.stopPropagation();
    },
    onClick: function () {
      a(i);
    }
  }, o);
}
function BJ(t) {
  var n = t.prefixCls,
    r = t.marks,
    o = t.onClick,
    i = "".concat(n, "-mark");
  return r.length ? /*#__PURE__*/e.createElement("div", {
    className: i
  }, r.map(function (t) {
    var n = t.value,
      r = t.style,
      a = t.label;
    return /*#__PURE__*/e.createElement(IJ, {
      key: n,
      prefixCls: i,
      style: r,
      value: n,
      onClick: o
    }, a);
  })) : null;
}
function xJ(t) {
  var n = t.prefixCls,
    r = t.value,
    o = t.style,
    i = t.activeStyle,
    a = e.useContext(fJ),
    c = a.min,
    s = a.max,
    l = a.direction,
    u = a.included,
    d = a.includedStart,
    f = a.includedEnd,
    p = "".concat(n, "-dot"),
    m = u && d <= r && r <= f,
    h = uJ(uJ({}, mJ(l, r, c, s)), "function" == typeof o ? o(r) : o);
  return m && (h = uJ(uJ({}, h), "function" == typeof i ? i(r) : i)), /*#__PURE__*/e.createElement("span", {
    className: tC(p, Fj({}, "".concat(p, "-active"), m)),
    style: h
  });
}
function wJ(t) {
  var n = t.prefixCls,
    r = t.marks,
    o = t.dots,
    i = t.style,
    a = t.activeStyle,
    c = e.useContext(fJ),
    s = c.min,
    l = c.max,
    u = c.step,
    d = e.useMemo(function () {
      var e = new Set();
      if (r.forEach(function (t) {
        e.add(t.value);
      }), o && null !== u) for (var t = s; t <= l;) e.add(t), t += u;
      return Array.from(e);
    }, [s, l, u, o, r]);
  return /*#__PURE__*/e.createElement("div", {
    className: "".concat(n, "-step")
  }, d.map(function (t) {
    return /*#__PURE__*/e.createElement(xJ, {
      prefixCls: n,
      key: t,
      value: t,
      style: i,
      activeStyle: a
    });
  }));
}
"production" !== process.env.NODE_ENV && (CJ.displayName = "Handles");
var QJ = /*#__PURE__*/e.forwardRef(function (t, n) {
  var r,
    o = t.prefixCls,
    i = void 0 === o ? "rc-slider" : o,
    a = t.className,
    c = t.style,
    s = t.disabled,
    l = void 0 !== s && s,
    u = t.keyboard,
    d = void 0 === u || u,
    f = t.autoFocus,
    p = t.onFocus,
    m = t.onBlur,
    h = t.min,
    A = void 0 === h ? 0 : h,
    g = t.max,
    v = void 0 === g ? 100 : g,
    C = t.step,
    b = void 0 === C ? 1 : C,
    E = t.value,
    y = t.defaultValue,
    I = t.range,
    B = t.count,
    x = t.onChange,
    w = t.onBeforeChange,
    Q = t.onAfterChange,
    H = t.allowCross,
    z = void 0 === H || H,
    M = t.pushable,
    k = void 0 !== M && M,
    N = t.draggableTrack,
    S = t.reverse,
    V = t.vertical,
    L = t.included,
    P = void 0 === L || L,
    O = t.startPoint,
    T = t.trackStyle,
    D = t.handleStyle,
    R = t.railStyle,
    G = t.dotStyle,
    F = t.activeDotStyle,
    j = t.marks,
    J = t.dots,
    Z = t.handleRender,
    W = t.tabIndex,
    X = void 0 === W ? 0 : W,
    U = t.ariaLabelForHandle,
    K = t.ariaLabelledByForHandle,
    Y = t.ariaValueTextFormatterForHandle,
    q = e.useRef(),
    _ = e.useRef(),
    $ = e.useMemo(function () {
      return V ? S ? "ttb" : "btt" : S ? "rtl" : "ltr";
    }, [S, V]),
    ee = e.useMemo(function () {
      return isFinite(A) ? A : 0;
    }, [A]),
    te = e.useMemo(function () {
      return isFinite(v) ? v : 100;
    }, [v]),
    ne = e.useMemo(function () {
      return null !== b && b <= 0 ? 1 : b;
    }, [b]),
    re = e.useMemo(function () {
      return "boolean" == typeof k ? !!k && ne : k >= 0 && k;
    }, [k, ne]),
    oe = e.useMemo(function () {
      return Object.keys(j || {}).map(function (t) {
        var n = j[t],
          r = {
            value: Number(t)
          };
        return n && "object" === Rj(n) && ! /*#__PURE__*/e.isValidElement(n) && ("label" in n || "style" in n) ? (r.style = n.style, r.label = n.label) : r.label = n, r;
      }).filter(function (e) {
        var t = e.label;
        return t || "number" == typeof t;
      }).sort(function (e, t) {
        return e.value - t.value;
      });
    }, [j]),
    ie = function (t, n, r, o, i, a) {
      var c = e.useCallback(function (e) {
          var r = isFinite(e) ? e : t;
          return r = Math.min(n, e), Math.max(t, r);
        }, [t, n]),
        s = e.useCallback(function (e) {
          if (null !== r) {
            var o = t + Math.round((c(e) - t) / r) * r,
              i = function (e) {
                return (String(e).split(".")[1] || "").length;
              },
              a = Math.max(i(r), i(n), i(t)),
              s = Number(o.toFixed(a));
            return t <= s && s <= n ? s : null;
          }
          return null;
        }, [r, t, n, c]),
        l = e.useCallback(function (e) {
          var i = c(e),
            a = o.map(function (e) {
              return e.value;
            });
          null !== r && a.push(s(e)), a.push(t, n);
          var l = a[0],
            u = n - t;
          return a.forEach(function (e) {
            var t = Math.abs(i - e);
            t <= u && (l = e, u = t);
          }), l;
        }, [t, n, o, r, c, s]),
        u = function e(i, a, c) {
          var l = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unit";
          if ("number" == typeof a) {
            var u,
              d = i[c],
              f = d + a,
              p = [];
            o.forEach(function (e) {
              p.push(e.value);
            }), p.push(t, n), p.push(s(d));
            var m = a > 0 ? 1 : -1;
            "unit" === l ? p.push(s(d + m * r)) : p.push(s(f)), p = p.filter(function (e) {
              return null !== e;
            }).filter(function (e) {
              return a < 0 ? e <= d : e >= d;
            }), "unit" === l && (p = p.filter(function (e) {
              return e !== d;
            }));
            var h = "unit" === l ? d : f;
            u = p[0];
            var A = Math.abs(u - h);
            if (p.forEach(function (e) {
              var t = Math.abs(e - h);
              t < A && (u = e, A = t);
            }), void 0 === u) return a < 0 ? t : n;
            if ("dist" === l) return u;
            if (Math.abs(a) > 1) {
              var g = Zj(i);
              return g[c] = u, e(g, a - m, c, l);
            }
            return u;
          }
          return "min" === a ? t : "max" === a ? n : void 0;
        },
        d = function (e, t, n) {
          var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unit",
            o = e[n],
            i = u(e, t, n, r);
          return {
            value: i,
            changed: i !== o
          };
        },
        f = function (e) {
          return null === a && 0 === e || "number" == typeof a && e < a;
        };
      return [l, function (e, t, n) {
        var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unit",
          o = e.map(l),
          c = o[n],
          s = u(o, t, n, r);
        if (o[n] = s, !1 === i) {
          var p = a || 0;
          n > 0 && o[n - 1] !== c && (o[n] = Math.max(o[n], o[n - 1] + p)), n < o.length - 1 && o[n + 1] !== c && (o[n] = Math.min(o[n], o[n + 1] - p));
        } else if ("number" == typeof a || null === a) {
          for (var m = n + 1; m < o.length; m += 1) for (var h = !0; f(o[m] - o[m - 1]) && h;) {
            var A = d(o, 1, m);
            o[m] = A.value, h = A.changed;
          }
          for (var g = n; g > 0; g -= 1) for (var v = !0; f(o[g] - o[g - 1]) && v;) {
            var C = d(o, -1, g - 1);
            o[g - 1] = C.value, v = C.changed;
          }
          for (var b = o.length - 1; b > 0; b -= 1) for (var E = !0; f(o[b] - o[b - 1]) && E;) {
            var y = d(o, -1, b - 1);
            o[b - 1] = y.value, E = y.changed;
          }
          for (var I = 0; I < o.length - 1; I += 1) for (var B = !0; f(o[I + 1] - o[I]) && B;) {
            var x = d(o, 1, I + 1);
            o[I + 1] = x.value, B = x.changed;
          }
        }
        return {
          value: o[n],
          values: o
        };
      }];
    }(ee, te, ne, oe, z, re),
    ae = Wj(ie, 2),
    ce = ae[0],
    se = ae[1],
    le = function (e, t) {
      var n = t || {},
        r = n.defaultValue,
        o = n.value,
        i = n.onChange,
        a = n.postState,
        c = tJ(iJ(function () {
          return aJ(o) ? o : aJ(r) ? "function" == typeof r ? r() : r : "function" == typeof e ? e() : e;
        }), 2),
        s = c[0],
        l = c[1],
        u = void 0 !== o ? o : s,
        d = a ? a(u) : u,
        f = nJ(i),
        p = tJ(iJ([u]), 2),
        m = p[0],
        h = p[1];
      return oJ(function () {
        var e = m[0];
        s !== e && f(s, e);
      }, [m]), oJ(function () {
        aJ(o) || l(o);
      }, [o]), [d, nJ(function (e, t) {
        l(e, t), h([u], t);
      })];
    }(y, {
      value: E
    }),
    ue = Wj(le, 2),
    de = ue[0],
    fe = ue[1],
    pe = e.useMemo(function () {
      var e = null == de ? [] : Array.isArray(de) ? de : [de],
        t = Wj(e, 1)[0],
        n = null === de ? [] : [void 0 === t ? ee : t];
      if (I) {
        if (n = Zj(e), B || void 0 === de) {
          var r = B >= 0 ? B + 1 : 2;
          for (n = n.slice(0, r); n.length < r;) {
            var o;
            n.push(null !== (o = n[n.length - 1]) && void 0 !== o ? o : ee);
          }
        }
        n.sort(function (e, t) {
          return e - t;
        });
      }
      return n.forEach(function (e, t) {
        n[t] = ce(e);
      }), n;
    }, [de, I, ee, B, ce]),
    me = e.useRef(pe);
  me.current = pe;
  var he = function (e) {
      return I ? e : e[0];
    },
    Ae = function (e) {
      var t = Zj(e).sort(function (e, t) {
        return e - t;
      });
      x && !function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          r = new Set();
        function o(e, t) {
          var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1,
            a = r.has(e);
          if ($j(!a, "Warning: There may be circular references"), a) return !1;
          if (e === t) return !0;
          if (n && i > 1) return !1;
          r.add(e);
          var c = i + 1;
          if (Array.isArray(e)) {
            if (!Array.isArray(t) || e.length !== t.length) return !1;
            for (var s = 0; s < e.length; s++) if (!o(e[s], t[s], c)) return !1;
            return !0;
          }
          if (e && t && "object" === Xj(e) && "object" === Xj(t)) {
            var l = Object.keys(e);
            return l.length === Object.keys(t).length && l.every(function (n) {
              return o(e[n], t[n], c);
            });
          }
          return !1;
        }
        return o(e, t);
      }(t, me.current, !0) && x(he(t)), fe(t);
    },
    ge = function (e) {
      if (!l) {
        var t = 0,
          n = te - ee;
        pe.forEach(function (r, o) {
          var i = Math.abs(e - r);
          i <= n && (n = i, t = o);
        });
        var r = Zj(pe);
        r[t] = e, I && !pe.length && void 0 === B && r.push(e), null == w || w(he(r)), Ae(r), null == Q || Q(he(r));
      }
    },
    ve = Wj(e.useState(null), 2),
    Ce = ve[0],
    be = ve[1];
  e.useEffect(function () {
    if (null !== Ce) {
      var e = pe.indexOf(Ce);
      e >= 0 && q.current.focus(e);
    }
    be(null);
  }, [Ce]);
  var Ee = e.useMemo(function () {
      return N && null === ne ? ("production" !== process.env.NODE_ENV && $j(!1, "`draggableTrack` is not supported when `step` is `null`."), !1) : N;
    }, [N, ne]),
    ye = function (t, n, r, o, i, a, c, s, l) {
      var u = Wj(e.useState(null), 2),
        d = u[0],
        f = u[1],
        p = Wj(e.useState(-1), 2),
        m = p[0],
        h = p[1],
        A = Wj(e.useState(r), 2),
        g = A[0],
        v = A[1],
        C = Wj(e.useState(r), 2),
        b = C[0],
        E = C[1],
        y = e.useRef(null),
        I = e.useRef(null);
      e.useEffect(function () {
        -1 === m && v(r);
      }, [r, m]), e.useEffect(function () {
        return function () {
          document.removeEventListener("mousemove", y.current), document.removeEventListener("mouseup", I.current), document.removeEventListener("touchmove", y.current), document.removeEventListener("touchend", I.current);
        };
      }, []);
      var B = function (e, t) {
          g.some(function (t, n) {
            return t !== e[n];
          }) && (void 0 !== t && f(t), v(e), c(e));
        },
        x = function (e, t) {
          if (-1 === e) {
            var n = b[0],
              r = b[b.length - 1],
              c = o - n,
              s = i - r,
              u = t * (i - o);
            u = Math.max(u, c), u = Math.min(u, s);
            var d = a(n + u);
            u = d - n;
            var f = b.map(function (e) {
              return e + u;
            });
            B(f);
          } else {
            var p = (i - o) * t,
              m = Zj(g);
            m[e] = b[e];
            var h = l(m, p, e, "dist");
            B(h.values, h.value);
          }
        },
        w = e.useRef(x);
      w.current = x;
      var Q = e.useMemo(function () {
        var e = Zj(r).sort(function (e, t) {
            return e - t;
          }),
          t = Zj(g).sort(function (e, t) {
            return e - t;
          });
        return e.every(function (e, n) {
          return e === t[n];
        }) ? g : r;
      }, [r, g]);
      return [m, d, Q, function (e, o) {
        e.stopPropagation();
        var i = r[o];
        h(o), f(i), E(r);
        var a = bJ(e),
          c = a.pageX,
          l = a.pageY,
          u = function (e) {
            e.preventDefault();
            var r,
              i = bJ(e),
              a = i.pageX,
              s = i.pageY,
              u = a - c,
              d = s - l,
              f = t.current.getBoundingClientRect(),
              p = f.width,
              m = f.height;
            switch (n) {
              case "btt":
                r = -d / m;
                break;
              case "ttb":
                r = d / m;
                break;
              case "rtl":
                r = -u / p;
                break;
              default:
                r = u / p;
            }
            w.current(o, r);
          },
          d = function e(t) {
            t.preventDefault(), document.removeEventListener("mouseup", e), document.removeEventListener("mousemove", u), document.removeEventListener("touchend", e), document.removeEventListener("touchmove", u), y.current = null, I.current = null, h(-1), s();
          };
        document.addEventListener("mouseup", d), document.addEventListener("mousemove", u), document.addEventListener("touchend", d), document.addEventListener("touchmove", u), y.current = u, I.current = d;
      }];
    }(_, $, pe, ee, te, ce, Ae, function () {
      null == Q || Q(he(me.current));
    }, se),
    Ie = Wj(ye, 4),
    Be = Ie[0],
    xe = Ie[1],
    we = Ie[2],
    Qe = Ie[3],
    He = function (e, t) {
      Qe(e, t), null == w || w(he(me.current));
    },
    ze = -1 !== Be;
  e.useEffect(function () {
    if (!ze) {
      var e = pe.lastIndexOf(xe);
      q.current.focus(e);
    }
  }, [ze]);
  var Me = e.useMemo(function () {
      return Zj(we).sort(function (e, t) {
        return e - t;
      });
    }, [we]),
    ke = Wj(e.useMemo(function () {
      return I ? [Me[0], Me[Me.length - 1]] : [ee, Me[0]];
    }, [Me, I, ee]), 2),
    Ne = ke[0],
    Se = ke[1];
  e.useImperativeHandle(n, function () {
    return {
      focus: function () {
        q.current.focus(0);
      },
      blur: function () {
        var e = document.activeElement;
        _.current.contains(e) && (null == e || e.blur());
      }
    };
  }), e.useEffect(function () {
    f && q.current.focus(0);
  }, []);
  var Ve = e.useMemo(function () {
    return {
      min: ee,
      max: te,
      direction: $,
      disabled: l,
      keyboard: d,
      step: ne,
      included: P,
      includedStart: Ne,
      includedEnd: Se,
      range: I,
      tabIndex: X,
      ariaLabelForHandle: U,
      ariaLabelledByForHandle: K,
      ariaValueTextFormatterForHandle: Y
    };
  }, [ee, te, $, l, d, ne, P, Ne, Se, I, X, U, K, Y]);
  return /*#__PURE__*/e.createElement(fJ.Provider, {
    value: Ve
  }, /*#__PURE__*/e.createElement("div", {
    ref: _,
    className: tC(i, a, (r = {}, Fj(r, "".concat(i, "-disabled"), l), Fj(r, "".concat(i, "-vertical"), V), Fj(r, "".concat(i, "-horizontal"), !V), Fj(r, "".concat(i, "-with-marks"), oe.length), r)),
    style: c,
    onMouseDown: function (e) {
      e.preventDefault();
      var t,
        n = _.current.getBoundingClientRect(),
        r = n.width,
        o = n.height,
        i = n.left,
        a = n.top,
        c = n.bottom,
        s = n.right,
        l = e.clientX,
        u = e.clientY;
      switch ($) {
        case "btt":
          t = (c - u) / o;
          break;
        case "ttb":
          t = (u - a) / o;
          break;
        case "rtl":
          t = (s - l) / r;
          break;
        default:
          t = (l - i) / r;
      }
      ge(ce(ee + t * (te - ee)));
    }
  }, /*#__PURE__*/e.createElement("div", {
    className: "".concat(i, "-rail"),
    style: R
  }), /*#__PURE__*/e.createElement(yJ, {
    prefixCls: i,
    style: T,
    values: Me,
    startPoint: O,
    onStartMove: Ee ? He : null
  }), /*#__PURE__*/e.createElement(wJ, {
    prefixCls: i,
    marks: oe,
    dots: J,
    style: G,
    activeStyle: F
  }), /*#__PURE__*/e.createElement(CJ, {
    ref: q,
    prefixCls: i,
    style: D,
    values: we,
    draggingIndex: Be,
    onStartMove: He,
    onOffsetChange: function (e, t) {
      if (!l) {
        var n = se(pe, e, t);
        null == w || w(he(pe)), Ae(n.values), null == Q || Q(he(n.values)), be(n.value);
      }
    },
    onFocus: p,
    onBlur: m,
    handleRender: Z
  }), /*#__PURE__*/e.createElement(BJ, {
    prefixCls: i,
    marks: oe,
    onClick: ge
  })));
});
"production" !== process.env.NODE_ENV && (QJ.displayName = "Slider");
var HJ = "TextCaption-module_caption__2veyi",
  zJ = ["children", "className"],
  MJ = function (e) {
    var n = e.children,
      r = e.className,
      o = S(e, zJ);
    return /*#__PURE__*/t.createElement(Nb, N({
      className: tC(HJ, r)
    }, o), n);
  };
MJ.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
}, MJ.defaultProps = {
  weight: "semibold"
};
var kJ = function (e) {
  var o = e.isRange,
    i = e.showRangeMinMax,
    a = e.min,
    c = e.max,
    s = e.minDisplay,
    l = e.maxDisplay,
    u = e.minLabel,
    d = e.maxLabel,
    f = e.count,
    p = e.value,
    m = e.onChange,
    h = e.customColor,
    A = e.removeBottomSpacer,
    g = V(n(o ? 0 : [a, c]), 2),
    v = g[0],
    C = g[1];
  return r(function () {
    p && C(p);
  }, [p]), r(function () {
    h && document.documentElement.style.setProperty("--range-slider-color", h);
  }, [h]), /*#__PURE__*/t.createElement(nb, {
    className: "ds-rc-slider"
  }, o && i && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
    justifyContent: "space-between"
  }, /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column"
  }, /*#__PURE__*/t.createElement(MJ, {
    textColor: "disabled",
    textTransform: "uppercase"
  }, u), /*#__PURE__*/t.createElement(Tb, {
    textColor: "dark-gray",
    weight: "semibold"
  }, s || (v ? v[0] : ""))), /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    alignItems: "flex-end"
  }, /*#__PURE__*/t.createElement(MJ, {
    textColor: "disabled",
    textTransform: "uppercase"
  }, d), /*#__PURE__*/t.createElement(Tb, {
    textColor: "dark-gray",
    weight: "semibold"
  }, l || (v ? v[1] : "")))), /*#__PURE__*/t.createElement(Qb, {
    size: "xs"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xxs"
  })), /*#__PURE__*/t.createElement(QJ, {
    allowCross: !1,
    range: o,
    min: a,
    max: c,
    count: f,
    value: v,
    onChange: function (e) {
      C(e), m(e);
    }
  }), !A && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Qb, {
    size: "xs"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xxs"
  })));
};
kJ.propTypes = {
  isRange: g.bool,
  showRangeMinMax: g.bool,
  min: g.number,
  max: g.number,
  minDisplay: g.oneOfType([g.string, g.number]),
  maxDisplay: g.oneOfType([g.string, g.number]),
  minLabel: g.string,
  maxLabel: g.string,
  count: g.number,
  value: g.oneOfType([g.number, g.array]),
  onChange: g.func,
  customColor: g.string,
  removeBottomSpacer: g.bool
}, kJ.defaultProps = {
  min: 0,
  max: 100,
  minLabel: "Min",
  maxLabel: "Max",
  count: 1
};
var NJ = "container-module_container__1qLQp",
  SJ = "container-module_isContractedWls__DVvJ6",
  VJ = "container-module_isNarrow__2-Kc4",
  LJ = "container-module_isExtended__jyL90",
  PJ = "container-module_isExtendedWls__2QUVd",
  OJ = "container-module_isFluid__1SAZr",
  TJ = "container-module_isFluidWls__33WbB",
  DJ = "container-module_isFullWidth__1mEWx",
  RJ = function (e) {
    var n,
      r = e.children,
      o = e.variation,
      i = e.className,
      a = e.id;
    return /*#__PURE__*/t.createElement(RC, {
      id: a,
      className: tC(NJ, (n = {}, k(n, LJ, "extended" === o), k(n, PJ, "extended-wls" === o), k(n, SJ, "contracted-wls" === o), k(n, VJ, "narrow" === o), k(n, OJ, "fluid" === o), k(n, TJ, "fluid-wls" === o), k(n, DJ, "full-width" === o), n), i)
    }, r);
  };
RJ.propTypes = {
  variation: g.oneOf(["default", "narrow", "contracted-wls", "extended", "extended-wls", "fluid", "fluid-wls", "full-width"]),
  children: g.any,
  id: g.string,
  className: g.string
}, RJ.defaultProps = {
  variation: "default"
};
var GJ = function (e) {
  var n = e.hideOn,
    r = e.hideStartingFrom,
    o = e.showStartingFrom,
    i = e.children,
    a = Lb(),
    c = a.isMobile,
    s = a.isTouch,
    l = a.width;
  if (n) switch (n) {
    case "mobile":
      return c ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
    case "touch":
      return s ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
  }
  if (r) switch (r) {
    case "tablet":
      return l >= 768 ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
    case "large-tablet":
      return l >= 960 ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
    case "desktop":
      return l >= 1024 ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
    case "large-desktop":
      return l >= 1280 ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
    case "widescreen":
      return l >= 1366 ? null : /*#__PURE__*/t.createElement(t.Fragment, null, i);
  }
  if (o) switch (o) {
    case "tablet":
      return l >= 768 ? /*#__PURE__*/t.createElement(t.Fragment, null, i) : null;
    case "large-tablet":
      return l >= 960 ? /*#__PURE__*/t.createElement(t.Fragment, null, i) : null;
    case "desktop":
      return l >= 1024 ? /*#__PURE__*/t.createElement(t.Fragment, null, i) : null;
    case "large-desktop":
      return l >= 1280 ? /*#__PURE__*/t.createElement(t.Fragment, null, i) : null;
    case "widescreen":
      return l >= 1366 ? /*#__PURE__*/t.createElement(t.Fragment, null, i) : null;
  }
  return /*#__PURE__*/t.createElement(t.Fragment, null, i);
};
GJ.propTypes = {
  hideStartingFrom: g.oneOf(["tablet", "large-tablet", "desktop", "large-desktop", "widescreen"]),
  hideOn: g.oneOf(["mobile", "touch"]),
  showStartingFrom: g.oneOf(["tablet", "large-tablet", "desktop", "large-desktop", "widescreen"]),
  children: g.any
};
var FJ = {
    flexBoxGridWrapper: "FlexBoxGrid-module_flexBoxGridWrapper__3ccYL",
    "gap-size-s": "FlexBoxGrid-module_gap-size-s__3PUD6",
    "gap-size-m": "FlexBoxGrid-module_gap-size-m__2T5lt",
    "gap-size-l": "FlexBoxGrid-module_gap-size-l__1ADon",
    flexBoxGridCell: "FlexBoxGrid-module_flexBoxGridCell__1wB0Q",
    "columns-5": "FlexBoxGrid-module_columns-5__3eVc_",
    "columns-4": "FlexBoxGrid-module_columns-4__1ztDr",
    "columns-3": "FlexBoxGrid-module_columns-3__1UTZj",
    "columns-2": "FlexBoxGrid-module_columns-2__29goa",
    "columns-1": "FlexBoxGrid-module_columns-1__1fStw",
    keepColumnsOnTouch: "FlexBoxGrid-module_keepColumnsOnTouch__7HM7J",
    "margin-bottom-s": "FlexBoxGrid-module_margin-bottom-s__3mX8v",
    "margin-bottom-m": "FlexBoxGrid-module_margin-bottom-m__2pCdC",
    "margin-bottom-l": "FlexBoxGrid-module_margin-bottom-l__1-m7c",
    flexBoxGridContent: "FlexBoxGrid-module_flexBoxGridContent__2Matj",
    "padding-s": "FlexBoxGrid-module_padding-s__3cpWN",
    "padding-m": "FlexBoxGrid-module_padding-m__14h3w",
    "padding-l": "FlexBoxGrid-module_padding-l__DYAMm"
  },
  jJ = function (e) {
    var n,
      r = e.gap,
      o = e.children,
      i = e.columns,
      a = e.keepColumnsOnTouch;
    return /*#__PURE__*/t.createElement(sb, {
      className: tC(FJ.flexBoxGridCell, (n = {}, k(n, FJ["columns-".concat(i)], i), k(n, FJ["margin-bottom-".concat(r)], r), k(n, FJ.keepColumnsOnTouch, a), n))
    }, /*#__PURE__*/t.createElement(nb, {
      className: tC(FJ.flexBoxGridContent, k({}, FJ["padding-".concat(r)], r))
    }, o));
  };
jJ.propTypes = {
  gap: g.oneOf(["s", "m", "l"]),
  columns: g.oneOf([1, 2, 3, 4, 5]),
  keepColumnsOnTouch: g.bool
}, jJ.defaultProps = {
  gap: "s",
  columns: 4
}, jJ.displayName = "FlexBoxGrid.Cell";
var JJ = function (e) {
  var n = e.children,
    r = e.gap,
    o = e.columns,
    i = e.keepColumnsOnTouch;
  return /*#__PURE__*/t.createElement(sb, {
    className: tC(FJ.flexBoxGridWrapper, k({}, FJ["gap-size-".concat(r)], r)),
    flexWrap: "wrap"
  }, t.Children.map(n, function (e) {
    return /*#__PURE__*/t.createElement(jJ, {
      gap: r,
      columns: o,
      keepColumnsOnTouch: i
    }, /*#__PURE__*/t.cloneElement(e));
  }));
};
JJ.propTypes = {
  gap: g.oneOf(["s", "m", "l"]),
  columns: g.oneOf([1, 2, 3, 4, 5]),
  keepColumnsOnTouch: g.bool
}, JJ.defaultProps = {
  gap: "s",
  columns: 4
};
var ZJ = {
    "aspect-ratio-square": "AspectRatioBox-module_aspect-ratio-square__agKb2",
    "aspect-ratio-widescreen": "AspectRatioBox-module_aspect-ratio-widescreen__3DWuZ",
    "aspect-ratio-fullscreen": "AspectRatioBox-module_aspect-ratio-fullscreen__1Tvhl",
    "aspect-ratio-panorama": "AspectRatioBox-module_aspect-ratio-panorama__3i1Wz",
    "aspect-ratio-poster": "AspectRatioBox-module_aspect-ratio-poster__3EDz5"
  },
  WJ = ["baseComponent", "aspectRatio", "children", "width"],
  XJ = function (e) {
    var n = e.baseComponent,
      r = e.aspectRatio,
      o = e.children,
      i = e.width,
      a = S(e, WJ),
      c = {};
    return i && (c = z(z({}, c), {}, {
      width: i
    })), a.style && (c = z(z({}, c), a.style)), "flex-box" === n ? /*#__PURE__*/t.createElement(sb, N({}, a, {
      className: tC(ZJ["aspect-ratio-".concat(r)], a.className),
      style: c
    }), o) : /*#__PURE__*/t.createElement(nb, N({}, a, {
      className: tC(ZJ["aspect-ratio-".concat(r)], a.className),
      style: i ? z({
        width: i
      }, a.style) : null
    }), o);
  };
XJ.propTypes = {
  baseComponent: g.oneOf(["box", "flex-box"]),
  aspectRatio: g.oneOf(["square", "widescreen", "fullscreen", "panorama", "poster"]),
  children: g.any,
  width: g.oneOfType([g.string, g.number])
}, XJ.defaultProps = {
  aspectRatio: "square",
  baseComponent: "box"
};
var UJ = {
    callToAction: "callToActionLink-module_callToAction__28kpU",
    "textAlign-left": "callToActionLink-module_textAlign-left__14XMt",
    "textAlign-center": "callToActionLink-module_textAlign-center__1ydB_",
    "textAlign-right": "callToActionLink-module_textAlign-right__1EHao",
    primary: "callToActionLink-module_primary__BuGBa",
    outline: "callToActionLink-module_outline__1GCo5",
    "outline-white-bg": "callToActionLink-module_outline-white-bg__17RNz",
    ghost: "callToActionLink-module_ghost__1HM9I",
    dense: "callToActionLink-module_dense__1b-CD",
    custom: "callToActionLink-module_custom__OOWYC",
    secondary: "callToActionLink-module_secondary__3Pc3p",
    danger: "callToActionLink-module_danger__2jaWG",
    white: "callToActionLink-module_white__1HOLv",
    disabled: "callToActionLink-module_disabled__2_WZd",
    fullWidth: "callToActionLink-module_fullWidth__2wAfZ",
    large: "callToActionLink-module_large__1MpxH",
    dropdown: "callToActionLink-module_dropdown__3mUwq",
    callToAction_icon: "callToActionLink-module_callToAction_icon__1nBND",
    after: "callToActionLink-module_after__QvEQp",
    before: "callToActionLink-module_before__3vpp4",
    linkStyle: "callToActionLink-module_linkStyle__2qYXT",
    adjustText: "callToActionLink-module_adjustText__1Ydj8"
  },
  KJ = function (e) {
    var n,
      o,
      i = e.type,
      a = e.children,
      c = e.onClick,
      s = e.size,
      l = e.href,
      u = e.appearance,
      d = e.prependIcon,
      f = e.appendIcon,
      p = e.openNewTab,
      m = e.id,
      h = e.reactRouterIsActive,
      A = e.variation,
      g = e.isFullWidth,
      v = e.textAlign,
      C = e.title,
      b = e.className,
      E = e.customButtonColor,
      y = e.customTextColor,
      I = function () {
        return /*#__PURE__*/t.createElement(t.Fragment, null, d && /*#__PURE__*/t.createElement("span", {
          className: tC(UJ.callToAction_icon, UJ.before)
        }, d), a, f && /*#__PURE__*/t.createElement("span", {
          className: tC(UJ.callToAction_icon, UJ.after)
        }, f));
      };
    return r(function () {
      E && y && (document.documentElement.style.setProperty("--primary-cta-color", E), document.documentElement.style.setProperty("--primary-cta-text-color", y));
    }, [E, y]), "router-link" === i ? /*#__PURE__*/t.createElement(w, {
      id: m,
      to: l,
      className: tC(UJ.callToAction, UJ.linkStyle, UJ["".concat(A)], (o = {}, k(o, UJ.custom, E && y), k(o, UJ.dense, "dense" === s), k(o, UJ.large, "large" === s), k(o, UJ.adjustText, "large" === s), k(o, UJ.ghost, "ghost" === u), k(o, UJ.outline, "outline" === u), k(o, UJ.fullWidth, g), k(o, UJ["textAlign-".concat(v)], v), o), b),
      onClick: c || null,
      isActive: h || null,
      title: C
    }, I()) : /*#__PURE__*/t.createElement(RC, {
      id: m,
      renderAs: "a",
      className: tC(UJ.callToAction, UJ["".concat(A)], (n = {}, k(n, UJ.custom, E && y), k(n, UJ.dense, "dense" === s), k(n, UJ.large, "large" === s), k(n, UJ.adjustText, "large" === s), k(n, UJ.ghost, "ghost" === u), k(n, UJ.outline, "outline" === u), k(n, UJ.fullWidth, g), k(n, UJ["textAlign-".concat(v)], v), n), UJ.linkStyle),
      href: l,
      target: p ? "_blank" : void 0,
      rel: p ? "noreferrer nofollow" : void 0,
      title: C
    }, I());
  };
KJ.propTypes = {
  href: g.string.isRequired,
  reactRouterIsActive: g.func,
  children: g.string,
  variation: g.oneOf(["primary", "secondary"]),
  appearance: g.oneOf(["filled", "outline", "ghost"]),
  type: g.oneOf(["link", "router-link"]),
  size: g.oneOf(["dense", "default", "large"]),
  openNewTab: g.bool,
  isFullWidth: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  prependIcon: g.node,
  appendIcon: g.node,
  title: g.string,
  id: g.string,
  className: g.string,
  customButtonColor: g.string,
  customTextColor: g.string
}, KJ.defaultProps = {
  type: "router-link",
  variation: "primary",
  textAlign: "center",
  size: "default"
};
var YJ = {
    listItemLink: "listItemLink-module_listItemLink__4bLKj",
    addBorder: "listItemLink-module_addBorder__1u6P1",
    isDanger: "listItemLink-module_isDanger__jFMKU",
    "size-auto": "listItemLink-module_size-auto__3X2NS",
    "size-m": "listItemLink-module_size-m__3EbUK",
    isActive: "listItemLink-module_isActive__hZnaX",
    isButton: "listItemLink-module_isButton__2zzuK",
    isLink: "listItemLink-module_isLink__3rV2G",
    removeBorderRadius: "listItemLink-module_removeBorderRadius__222IN",
    removeBottomMargin: "listItemLink-module_removeBottomMargin__24ASb",
    flex: "listItemLink-module_flex__3g14P",
    label: "listItemLink-module_label__35Bg1",
    labelAdjust: "listItemLink-module_labelAdjust__zKsq8",
    labelAdjustButton: "listItemLink-module_labelAdjustButton__1fxCT",
    description: "listItemLink-module_description__xfSQM",
    icon: "listItemLink-module_icon__1YXUW",
    "icon-color-blue": "listItemLink-module_icon-color-blue__3uCsr",
    "icon-color-purple": "listItemLink-module_icon-color-purple__1KlGH",
    "icon-color-green": "listItemLink-module_icon-color-green__3v_38",
    "icon-color-yellow": "listItemLink-module_icon-color-yellow__1vhLn",
    "icon-color-red": "listItemLink-module_icon-color-red__aZMeJ",
    imageWrapper: "listItemLink-module_imageWrapper__g_Tsj"
  },
  qJ = function (e) {
    var n,
      r,
      o,
      i,
      a = e.label,
      c = e.description,
      s = e.ornament,
      l = e.icon,
      u = e.iconPresetColor,
      d = e.iconCustomColor,
      f = e.removeBorderRadius,
      p = e.removeBottomMargin,
      m = e.onClick,
      h = e.href,
      A = e.openNewTab,
      g = e.type,
      v = e.isActive,
      C = e.id,
      b = e.minHeight,
      E = e.isDanger,
      y = e.addBorder,
      I = e.imageSrc,
      B = /*#__PURE__*/t.createElement(t.Fragment, null, I && /*#__PURE__*/t.createElement(nb, {
        setPositionRelative: !0,
        className: YJ.imageWrapper
      }, /*#__PURE__*/t.createElement("img", {
        src: I,
        alt: ""
      })), /*#__PURE__*/t.createElement(sb, {
        className: YJ.flex,
        renderAs: "span",
        flex: "1",
        flexDirection: "column",
        justifyContent: "center",
        paddingRight: (s || l) && "s"
      }, /*#__PURE__*/t.createElement(nb, {
        renderAs: "span"
      }, /*#__PURE__*/t.createElement(Vb, {
        truncate: !0,
        className: tC(YJ.label, (n = {}, k(n, YJ.labelAdjust, c && "button" !== g), k(n, YJ.labelAdjustButton, c && "button" === g), n))
      }, a)), c && /*#__PURE__*/t.createElement(nb, {
        renderAs: "span"
      }, /*#__PURE__*/t.createElement(MJ, {
        truncate: !0,
        className: YJ.description
      }, c))), (s || l) && /*#__PURE__*/t.createElement(sb, {
        className: YJ.flex,
        renderAs: "span",
        alignItems: "center"
      }, s && /*#__PURE__*/t.createElement(nb, {
        renderAs: "span",
        display: "inline-block",
        paddingRight: l && "s"
      }, s), l && /*#__PURE__*/t.createElement(nb, {
        renderAs: "span",
        display: "inline-block",
        style: d ? {
          color: d
        } : null,
        className: tC(YJ.icon, k({}, YJ["icon-color-".concat(u)], u && !d))
      }, l)));
    return "button" === g ? /*#__PURE__*/t.createElement("button", {
      id: C,
      onClick: function () {
        m(a);
      },
      type: "button",
      className: tC(YJ.listItemLink, YJ.isButton, (o = {}, k(o, YJ.removeBorderRadius, f), k(o, YJ.removeBottomMargin, p), k(o, YJ.isActive, v), k(o, YJ["size-".concat(b)], b), k(o, YJ.isDanger, E), k(o, YJ.addBorder, y), o))
    }, B) : "router-link" === g ? /*#__PURE__*/t.createElement(w, {
      id: C,
      to: h,
      className: tC(YJ.listItemLink, (i = {}, k(i, YJ.removeBorderRadius, f), k(i, YJ.removeBottomMargin, p), k(i, YJ.isActive, v), k(i, YJ["size-".concat(b)], b), k(i, YJ.isDanger, E), k(i, YJ.addBorder, y), i)),
      onClick: m ? function () {
        m(a);
      } : null
    }, B) : /*#__PURE__*/t.createElement("a", {
      id: C,
      href: h,
      target: A ? "_blank" : void 0,
      rel: A ? "noreferrer nofollow" : void 0,
      className: tC(YJ.listItemLink, YJ.isLink, (r = {}, k(r, YJ.removeBorderRadius, f), k(r, YJ.removeBottomMargin, p), k(r, YJ.isActive, v), k(r, YJ["size-".concat(b)], b), k(r, YJ.isDanger, E), k(r, YJ.addBorder, y), r))
    }, B);
  };
qJ.propTypes = {
  label: g.string,
  description: g.string,
  ornament: g.node,
  icon: g.node,
  iconPresetColor: g.oneOf(["blue", "purple", "green", "yellow", "red"]),
  iconCustomColor: g.string,
  removeBorderRadius: g.bool,
  removeBottomMargin: g.bool,
  type: g.oneOf(["link", "router-link", "button"]),
  href: g.string,
  openNewTab: g.bool,
  onClick: g.func,
  id: g.string,
  isActive: g.bool,
  minHeight: g.oneOf(["auto", "m"]),
  isDanger: g.bool,
  addBorder: g.bool,
  imageSrc: g.string
}, qJ.defaultProps = {
  type: "router-link",
  minHeight: "auto"
};
var _J = "tab-module_tab__31rNR",
  $J = "tab-module_is-button__isXIJ",
  eZ = "tab-module_is-active__2QMhz",
  tZ = "tab-module_isFullWidth__BUzX4",
  nZ = "tab-module_icon__XK3Dt",
  rZ = "tab-module_minimalist__vFr7G",
  oZ = "tab-module_label__s7bzk",
  iZ = "tab-module_hasIcon__1c3VD",
  aZ = function () {
    return aZ = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, aZ.apply(this, arguments);
  };
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var cZ = "",
  sZ = null,
  lZ = null,
  uZ = null;
function dZ() {
  cZ = "", null !== sZ && sZ.disconnect(), null !== lZ && (window.clearTimeout(lZ), lZ = null);
}
function fZ(e) {
  return ["BUTTON", "INPUT", "SELECT", "TEXTAREA"].includes(e.tagName) && !e.hasAttribute("disabled") || ["A", "AREA"].includes(e.tagName) && e.hasAttribute("href");
}
function pZ() {
  var e = null;
  if ("#" === cZ) e = document.body;else {
    var t = cZ.replace("#", "");
    null === (e = document.getElementById(t)) && "#top" === cZ && (e = document.body);
  }
  if (null !== e) {
    uZ(e);
    var n = e.getAttribute("tabindex");
    return null !== n || fZ(e) || e.setAttribute("tabindex", -1), e.focus({
      preventScroll: !0
    }), null !== n || fZ(e) || (e.blur(), e.removeAttribute("tabindex")), dZ(), !0;
  }
  return !1;
}
function mZ(e) {
  return /*#__PURE__*/t.forwardRef(function (n, r) {
    var o = "";
    "string" == typeof n.to && n.to.includes("#") ? o = "#" + n.to.split("#").slice(1).join("#") : "object" == typeof n.to && "string" == typeof n.to.hash && (o = n.to.hash);
    var i = {};
    e === w && (i.isActive = function (e, t) {
      return e && e.isExact && t.hash === o;
    });
    var a = function (e, t) {
      var n = {};
      for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
      if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var o = 0;
        for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
      }
      return n;
    }(n, ["scroll", "smooth", "timeout", "elementId"]);
    return /*#__PURE__*/t.createElement(e, aZ({}, i, a, {
      onClick: function (e) {
        var t;
        dZ(), cZ = n.elementId ? "#" + n.elementId : o, n.onClick && n.onClick(e), "" === cZ || e.defaultPrevented || 0 !== e.button || n.target && "_self" !== n.target || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey || (uZ = n.scroll || function (e) {
          return n.smooth ? e.scrollIntoView({
            behavior: "smooth"
          }) : e.scrollIntoView();
        }, t = n.timeout, window.setTimeout(function () {
          !1 === pZ() && (null === sZ && (sZ = new MutationObserver(pZ)), sZ.observe(document, {
            attributes: !0,
            childList: !0,
            subtree: !0
          }), lZ = window.setTimeout(function () {
            dZ();
          }, t || 1e4));
        }, 0));
      },
      ref: r
    }), n.children);
  });
}
var hZ = mZ(Q),
  AZ = mZ(w);
if ("production" !== process.env.NODE_ENV) {
  hZ.displayName = "HashLink", AZ.displayName = "NavHashLink";
  var gZ = {
    onClick: g.func,
    children: g.node,
    scroll: g.func,
    timeout: g.number,
    elementId: g.string,
    to: g.oneOfType([g.string, g.object])
  };
  hZ.propTypes = gZ, AZ.propTypes = gZ;
}
var vZ = function (e) {
  var n,
    i,
    a,
    c,
    s = e.children,
    l = e.type,
    u = e.isActive,
    d = e.href,
    f = e.openNewTab,
    p = e.onClick,
    m = e.onClickOutside,
    h = e.id,
    A = e.reactRouterIsActive,
    g = e.isFullWidth,
    v = e.icon,
    C = e.minimalist,
    b = o(null),
    E = GC(b).isOutsideClick;
  return r(function () {
    m && m(E);
  }, [E]), "button" === l ? /*#__PURE__*/t.createElement(RC, {
    renderAs: "button",
    domRef: b,
    id: h,
    className: tC(_J, $J, (i = {}, k(i, eZ, u), k(i, tZ, g), k(i, rZ, C), i)),
    onClick: p,
    type: "button"
  }, v && /*#__PURE__*/t.createElement(RC, {
    renderAs: "span",
    className: nZ
  }, v), /*#__PURE__*/t.createElement("span", {
    className: tC(oZ, k({}, iZ, v))
  }, s)) : "router-hash-link" === l ? /*#__PURE__*/t.createElement(hZ, {
    id: h,
    to: d,
    onClick: p || null,
    className: tC(_J, (a = {}, k(a, tZ, g), k(a, rZ, C), a)),
    activeClassName: eZ,
    isActive: A || null
  }, v && /*#__PURE__*/t.createElement(RC, {
    renderAs: "span",
    className: nZ
  }, v), /*#__PURE__*/t.createElement("span", {
    className: tC(oZ, k({}, iZ, v))
  }, s)) : "router-link" === l ? /*#__PURE__*/t.createElement(w, {
    id: h,
    to: d,
    onClick: p || null,
    className: tC(_J, (c = {}, k(c, tZ, g), k(c, rZ, C), c)),
    activeClassName: eZ,
    isActive: A || null
  }, v && /*#__PURE__*/t.createElement(RC, {
    renderAs: "span",
    className: nZ
  }, v), /*#__PURE__*/t.createElement("span", {
    className: tC(oZ, k({}, iZ, v))
  }, s)) : /*#__PURE__*/t.createElement("a", {
    id: h,
    className: tC(_J, (n = {}, k(n, eZ, u), k(n, tZ, g), k(n, rZ, C), n)),
    href: d,
    target: f ? "_blank" : void 0,
    rel: f ? "noreferrer nofollow" : void 0
  }, v && /*#__PURE__*/t.createElement(RC, {
    renderAs: "span",
    className: nZ
  }, v), /*#__PURE__*/t.createElement("span", {
    className: tC(oZ, k({}, iZ, v))
  }, s));
};
vZ.propTypes = {
  type: g.oneOf(["link", "router-link", "button", "router-hash-link"]),
  href: g.string,
  onClick: g.func,
  onClickOutside: g.func,
  openNewTab: g.bool,
  isActive: g.bool,
  id: g.string,
  reactRouterIsActive: g.func,
  isFullWidth: g.bool,
  icon: g.node,
  children: g.any,
  minimalist: g.bool
}, vZ.defaultProps = {
  renderAs: "button"
};
var CZ = "NavIconLink-module_navLink__S7m7o",
  bZ = "NavIconLink-module_isButton__39hBB",
  EZ = "NavIconLink-module_narrow__3PtD-",
  yZ = "NavIconLink-module_brand__20IMp",
  IZ = function (e) {
    var n,
      r,
      o,
      i = e.children,
      a = e.isBrand,
      c = e.isNarrow,
      s = e.href,
      l = e.className,
      u = e.type,
      d = e.onClick,
      f = e.id,
      p = e.reactRouterIsActive,
      m = e.openNewTab;
    return "button" === u ? /*#__PURE__*/t.createElement("button", {
      id: f,
      type: "button",
      className: tC(CZ, bZ, l, (r = {}, k(r, yZ, a), k(r, EZ, c), r)),
      onClick: d
    }, i) : "router-link" === u ? /*#__PURE__*/t.createElement(w, {
      id: f,
      to: s,
      onClick: d || null,
      className: tC(CZ, l, (o = {}, k(o, yZ, a), k(o, EZ, c), o)),
      isActive: p || null
    }, i) : /*#__PURE__*/t.createElement("a", {
      id: f,
      href: s,
      className: tC(CZ, l, (n = {}, k(n, yZ, a), k(n, EZ, c), n)),
      target: m ? "_blank" : void 0,
      rel: m ? "noreferrer nofollow" : void 0
    }, i);
  };
IZ.propTypes = {
  type: g.oneOf(["link", "router-link", "button"]),
  href: g.string,
  children: g.any,
  isNarrow: g.bool,
  isBrand: g.bool,
  openNewTab: g.bool,
  onClick: g.func,
  reactRouterIsActive: g.func,
  id: g.string,
  className: g.string
};
var BZ = {
    callToAction: "IconLink-module_callToAction__wWCQl",
    "textAlign-left": "IconLink-module_textAlign-left__3l2hM",
    "textAlign-center": "IconLink-module_textAlign-center__C2MaK",
    "textAlign-right": "IconLink-module_textAlign-right__2_kyN",
    primary: "IconLink-module_primary__2M6JU",
    outline: "IconLink-module_outline__2MMO8",
    "outline-white-bg": "IconLink-module_outline-white-bg__2W4i1",
    ghost: "IconLink-module_ghost__1t3UP",
    dense: "IconLink-module_dense__3r-8I",
    custom: "IconLink-module_custom__GKASZ",
    secondary: "IconLink-module_secondary__1HX6n",
    danger: "IconLink-module_danger__JVSjs",
    white: "IconLink-module_white__1yzHY",
    disabled: "IconLink-module_disabled__3Ey8u",
    fullWidth: "IconLink-module_fullWidth__3x2SX",
    large: "IconLink-module_large__HwBNM",
    dropdown: "IconLink-module_dropdown__F6NtU",
    callToAction_icon: "IconLink-module_callToAction_icon__A-FQa",
    after: "IconLink-module_after__2_Mp4",
    before: "IconLink-module_before__2-Q5w",
    iconLink: "IconLink-module_iconLink__2r0nU",
    denseIcon: "IconLink-module_denseIcon__11u8b",
    largeIcon: "IconLink-module_largeIcon__xUS3R"
  },
  xZ = function (e) {
    var n,
      o,
      i = e.type,
      a = e.children,
      c = e.onClick,
      s = e.size,
      l = e.href,
      u = e.appearance,
      d = e.openNewTab,
      f = e.id,
      p = e.reactRouterIsActive,
      m = e.variation,
      h = e.isFullWidth,
      A = e.textAlign,
      g = e.title,
      v = e.customButtonColor,
      C = e.customTextColor;
    return r(function () {
      v && C && (document.documentElement.style.setProperty("--primary-cta-color", v), document.documentElement.style.setProperty("--primary-cta-text-color", C));
    }, [v, C]), "router-link" === i ? /*#__PURE__*/t.createElement(w, {
      id: f,
      to: l,
      className: tC(BZ.callToAction, BZ.iconLink, BZ["".concat(m)], (o = {}, k(o, BZ.custom, v && C), k(o, BZ.denseIcon, "dense" === s), k(o, BZ.largeIcon, "large" === s), k(o, BZ.ghost, "ghost" === u), k(o, BZ.outline, "outline" === u), k(o, BZ.fullWidth, h), k(o, BZ["textAlign-".concat(A)], A), o)),
      onClick: c || null,
      isActive: p || null,
      title: g
    }, a) : /*#__PURE__*/t.createElement(RC, {
      id: f,
      renderAs: "a",
      className: tC(BZ.callToAction, BZ.iconLink, BZ["".concat(m)], (n = {}, k(n, BZ.custom, v && C), k(n, BZ.denseIcon, "dense" === s), k(n, BZ.largeIcon, "large" === s), k(n, BZ.ghost, "ghost" === u), k(n, BZ.outline, "outline" === u), k(n, BZ.fullWidth, h), k(n, BZ["textAlign-".concat(A)], A), n)),
      href: l,
      target: d ? "_blank" : void 0,
      rel: d ? "noreferrer nofollow" : void 0,
      title: g
    }, a);
  };
xZ.propTypes = {
  href: g.string.isRequired,
  reactRouterIsActive: g.func,
  children: g.node,
  variation: g.oneOf(["primary", "secondary", "danger"]),
  appearance: g.oneOf(["filled", "outline", "ghost"]),
  type: g.oneOf(["link", "router-link"]),
  size: g.oneOf(["dense", "default", "large"]),
  openNewTab: g.bool,
  isFullWidth: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  title: g.string,
  id: g.string,
  customButtonColor: g.string,
  customTextColor: g.string
}, xZ.defaultProps = {
  type: "router-link",
  variation: "primary",
  textAlign: "center",
  size: "default"
};
var wZ = {
    badgeWrapper: "badge-module_badgeWrapper__3VbYi",
    badge: "badge-module_badge__7Fqqr",
    inline: "badge-module_inline__31VmL",
    "color-gray": "badge-module_color-gray__1hS5d",
    "color-blue": "badge-module_color-blue__3EBIW",
    "color-green": "badge-module_color-green__2sEgx",
    "color-purple": "badge-module_color-purple__kMt8s",
    "color-yellow": "badge-module_color-yellow__2TRsm",
    "color-red": "badge-module_color-red__2p6wE",
    "size-xs": "badge-module_size-xs__ZESR7",
    "size-s": "badge-module_size-s__sgx5J",
    "position-top": "badge-module_position-top__3dPi0",
    "position-top-right": "badge-module_position-top-right__27P58",
    "position-right": "badge-module_position-right__1Kg-A",
    "position-bottom-right": "badge-module_position-bottom-right__2Uu5Y",
    "position-bottom": "badge-module_position-bottom__wtPF7",
    "position-bottom-left": "badge-module_position-bottom-left__DCdum",
    "position-left": "badge-module_position-left__13PBs",
    "position-top-left": "badge-module_position-top-left__kJD_5",
    "position-center": "badge-module_position-center__3oRJq",
    hasContent: "badge-module_hasContent__i_1w1"
  },
  QZ = function (e) {
    var n,
      r,
      o = e.children,
      i = e.color,
      a = e.position,
      c = e.badgeContent,
      s = e.size;
    return e.isInline ? /*#__PURE__*/t.createElement("span", {
      className: tC(wZ.badge, wZ.inline, (n = {}, k(n, wZ["color-".concat(i)], i), k(n, wZ["size-".concat(s)], s), k(n, wZ.hasContent, c), n))
    }, c) : /*#__PURE__*/t.createElement("div", {
      className: wZ.badgeWrapper
    }, o, /*#__PURE__*/t.createElement("span", {
      className: tC(wZ.badge, (r = {}, k(r, wZ["position-".concat(a)], a), k(r, wZ["color-".concat(i)], i), k(r, wZ["size-".concat(s)], s), k(r, wZ.hasContent, c), r))
    }, c));
  };
QZ.propTypes = {
  children: g.any,
  color: g.oneOf(["gray", "blue", "purple", "green", "yellow", "red"]),
  position: g.oneOf(["top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", "center"]),
  size: g.oneOf(["xs", "s"]),
  badgeContent: g.oneOfType([g.string, g.number]),
  isInline: g.bool
}, QZ.defaultProps = {
  color: "gray",
  position: "top-right",
  padding: "xs",
  size: "xs",
  isInline: !1
};
var HZ = {
    infoPanel: "InfoPanel-module_infoPanel__IoDBQ",
    isInline: "InfoPanel-module_isInline__2yNDO",
    hasDismissButton: "InfoPanel-module_hasDismissButton__3_64s",
    "color-blue": "InfoPanel-module_color-blue__1WK01",
    "color-purple": "InfoPanel-module_color-purple__2mVje",
    "color-green": "InfoPanel-module_color-green__jE8Ge",
    "color-yellow": "InfoPanel-module_color-yellow__OFJiF",
    "color-red": "InfoPanel-module_color-red__3vQZf",
    icon: "InfoPanel-module_icon__3L4Jn",
    "color-gray": "InfoPanel-module_color-gray__mlFTI",
    buttonWrapper: "InfoPanel-module_buttonWrapper__1Urwe",
    "headline-color-gray": "InfoPanel-module_headline-color-gray__3nnjc",
    "headline-color-blue": "InfoPanel-module_headline-color-blue__NBodR",
    "headline-color-purple": "InfoPanel-module_headline-color-purple__2q_TY",
    "headline-color-green": "InfoPanel-module_headline-color-green__Z0SAe",
    "headline-color-yellow": "InfoPanel-module_headline-color-yellow__13dZ7",
    "headline-color-red": "InfoPanel-module_headline-color-red__xNn-5"
  },
  zZ = function (e) {
    var r,
      o = e.icon,
      i = e.color,
      a = e.isInline,
      c = e.headline,
      s = e.description,
      l = e.customPanelContent,
      u = e.isDismissible,
      d = e.onDismiss,
      f = e.addShadow,
      p = e.actionLabel,
      m = e.actionOnClick,
      h = e.actionHref,
      A = e.actionHrefType,
      g = e.actionHrefNewTab,
      v = e.actionAppearance,
      C = V(n(!1), 2),
      b = C[0],
      E = C[1];
    return !b && /*#__PURE__*/t.createElement(ob, {
      className: tC(HZ.infoPanel, (r = {}, k(r, HZ.isInline, a), k(r, HZ.hasDismissButton, u), k(r, HZ["color-".concat(i)], i), r)),
      addShadow: f
    }, /*#__PURE__*/t.createElement(sb, {
      gap: "s"
    }, o && /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(sb, {
      justifyContent: "center",
      alignItems: "center",
      className: tC(HZ.icon, k({}, HZ["color-".concat(i)], i))
    }, o)), /*#__PURE__*/t.createElement(nb, {
      flex: "1"
    }, c && /*#__PURE__*/t.createElement(nb, {
      paddingTop: "xxs"
    }, /*#__PURE__*/t.createElement(Vb, {
      weight: "semibold",
      className: tC(k({}, HZ["headline-color-".concat(i)], i))
    }, c)), s && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    }), /*#__PURE__*/t.createElement(nb, {
      paddingTop: c ? null : "xxs"
    }, /*#__PURE__*/t.createElement(Tb, null, s))), l, (m || h) && /*#__PURE__*/t.createElement(sb, {
      paddingTop: "s",
      paddingBottom: "xxs"
    }, m && /*#__PURE__*/t.createElement(jC, {
      onClick: m,
      appearance: v,
      variation: "secondary",
      size: "dense"
    }, p), h && /*#__PURE__*/t.createElement(KJ, {
      href: h,
      appearance: v,
      variation: "secondary",
      size: "dense",
      type: A,
      openNewTab: g
    }, p))), u && /*#__PURE__*/t.createElement(nb, {
      className: HZ.buttonWrapper
    }, /*#__PURE__*/t.createElement(WC, {
      onClick: function () {
        d && d(), E(!0);
      },
      size: "dense",
      variation: "secondary",
      appearance: "ghost"
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    })))));
  };
zZ.propTypes = {
  icon: g.node,
  color: g.oneOf(["gray", "blue", "purple", "green", "yellow", "red"]),
  isInline: g.bool,
  headline: g.string,
  description: g.string,
  customPanelContent: g.node,
  isDismissible: g.bool,
  onDismiss: g.func,
  addShadow: g.bool,
  actionLabel: g.string,
  actionOnClick: g.func,
  actionHref: g.string,
  actionHrefType: g.oneOf(["link", "router-link"]),
  actionHrefNewTab: g.bool,
  actionAppearance: g.oneOf(["outline", "ghost"])
}, zZ.defaultProps = {
  color: "blue",
  isInline: !1,
  actionLabel: "Action",
  actionAppearance: "outline"
};
let MZ,
  kZ,
  NZ,
  SZ = {
    data: ""
  },
  VZ = e => "object" == typeof window ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), {
    innerHTML: " ",
    id: "_goober"
  })).firstChild : e || SZ,
  LZ = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,
  PZ = /\/\*[^]*?\*\/|  +/g,
  OZ = /\n+/g,
  TZ = (e, t) => {
    let n = "",
      r = "",
      o = "";
    for (let i in e) {
      let a = e[i];
      "@" == i[0] ? "i" == i[1] ? n = i + " " + a + ";" : r += "f" == i[1] ? TZ(a, i) : i + "{" + TZ(a, "k" == i[1] ? "" : t) + "}" : "object" == typeof a ? r += TZ(a, t ? t.replace(/([^,])+/g, e => i.replace(/(^:.*)|([^,])+/g, t => /&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : i) : null != a && (i = /^--/.test(i) ? i : i.replace(/[A-Z]/g, "-$&").toLowerCase(), o += TZ.p ? TZ.p(i, a) : i + ":" + a + ";");
    }
    return n + (t && o ? t + "{" + o + "}" : o) + r;
  },
  DZ = {},
  RZ = e => {
    if ("object" == typeof e) {
      let t = "";
      for (let n in e) t += n + RZ(e[n]);
      return t;
    }
    return e;
  },
  GZ = (e, t, n, r, o) => {
    let i = RZ(e),
      a = DZ[i] || (DZ[i] = (e => {
        let t = 0,
          n = 11;
        for (; t < e.length;) n = 101 * n + e.charCodeAt(t++) >>> 0;
        return "go" + n;
      })(i));
    if (!DZ[a]) {
      let t = i !== e ? e : (e => {
        let t,
          n,
          r = [{}];
        for (; t = LZ.exec(e.replace(PZ, ""));) t[4] ? r.shift() : t[3] ? (n = t[3].replace(OZ, " ").trim(), r.unshift(r[0][n] = r[0][n] || {})) : r[0][t[1]] = t[2].replace(OZ, " ").trim();
        return r[0];
      })(e);
      DZ[a] = TZ(o ? {
        ["@keyframes " + a]: t
      } : t, n ? "" : "." + a);
    }
    return ((e, t, n) => {
      -1 == t.data.indexOf(e) && (t.data = n ? e + t.data : t.data + e);
    })(DZ[a], t, r), a;
  },
  FZ = (e, t, n) => e.reduce((e, r, o) => {
    let i = t[o];
    if (i && i.call) {
      let e = i(n),
        t = e && e.props && e.props.className || /^go/.test(e) && e;
      i = t ? "." + t : e && "object" == typeof e ? e.props ? "" : TZ(e, "") : !1 === e ? "" : e;
    }
    return e + r + (null == i ? "" : i);
  }, "");
function jZ(e) {
  let t = this || {},
    n = e.call ? e(t.p) : e;
  return GZ(n.unshift ? n.raw ? FZ(n, [].slice.call(arguments, 1), t.p) : n.reduce((e, n) => Object.assign(e, n && n.call ? n(t.p) : n), {}) : n, VZ(t.target), t.g, t.o, t.k);
}
jZ.bind({
  g: 1
});
let JZ = jZ.bind({
  k: 1
});
function ZZ(e, t) {
  let n = this || {};
  return function () {
    let r = arguments;
    function o(i, a) {
      let c = Object.assign({}, i),
        s = c.className || o.className;
      n.p = Object.assign({
        theme: kZ && kZ()
      }, c), n.o = / *go\d+/.test(s), c.className = jZ.apply(n, r) + (s ? " " + s : ""), t && (c.ref = a);
      let l = e;
      return e[0] && (l = c.as || e, delete c.as), NZ && l[0] && NZ(c), MZ(l, c);
    }
    return t ? t(o) : o;
  };
}
var WZ = (e, t) => (e => "function" == typeof e)(e) ? e(t) : e,
  XZ = (() => {
    let e = 0;
    return () => (++e).toString();
  })(),
  UZ = (() => {
    let e;
    return () => {
      if (void 0 === e && typeof window < "u") {
        let t = matchMedia("(prefers-reduced-motion: reduce)");
        e = !t || t.matches;
      }
      return e;
    };
  })(),
  KZ = new Map(),
  YZ = e => {
    if (KZ.has(e)) return;
    let t = setTimeout(() => {
      KZ.delete(e), eW({
        type: 4,
        toastId: e
      });
    }, 1e3);
    KZ.set(e, t);
  },
  qZ = (e, t) => {
    switch (t.type) {
      case 0:
        return _objectSpread(_objectSpread({}, e), {}, {
          toasts: [t.toast, ...e.toasts].slice(0, 20)
        });
      case 1:
        return t.toast.id && (e => {
          let t = KZ.get(e);
          t && clearTimeout(t);
        })(t.toast.id), _objectSpread(_objectSpread({}, e), {}, {
          toasts: e.toasts.map(e => e.id === t.toast.id ? _objectSpread(_objectSpread({}, e), t.toast) : e)
        });
      case 2:
        let n = t.toast;
        return e.toasts.find(e => e.id === n.id) ? qZ(e, {
          type: 1,
          toast: n
        }) : qZ(e, {
          type: 0,
          toast: n
        });
      case 3:
        let r = t.toastId;
        return r ? YZ(r) : e.toasts.forEach(e => {
          YZ(e.id);
        }), _objectSpread(_objectSpread({}, e), {}, {
          toasts: e.toasts.map(e => e.id === r || void 0 === r ? _objectSpread(_objectSpread({}, e), {}, {
            visible: !1
          }) : e)
        });
      case 4:
        return void 0 === t.toastId ? _objectSpread(_objectSpread({}, e), {}, {
          toasts: []
        }) : _objectSpread(_objectSpread({}, e), {}, {
          toasts: e.toasts.filter(e => e.id !== t.toastId)
        });
      case 5:
        return _objectSpread(_objectSpread({}, e), {}, {
          pausedAt: t.time
        });
      case 6:
        let o = t.time - (e.pausedAt || 0);
        return _objectSpread(_objectSpread({}, e), {}, {
          pausedAt: void 0,
          toasts: e.toasts.map(e => _objectSpread(_objectSpread({}, e), {}, {
            pauseDuration: e.pauseDuration + o
          }))
        });
    }
  },
  _Z = [],
  $Z = {
    toasts: [],
    pausedAt: void 0
  },
  eW = e => {
    $Z = qZ($Z, e), _Z.forEach(e => {
      e($Z);
    });
  },
  tW = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
  },
  nW = e => (t, n) => {
    let r = function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "blank";
      let n = arguments.length > 2 ? arguments[2] : undefined;
      return _objectSpread(_objectSpread({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
          role: "status",
          "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0
      }, n), {}, {
        id: (null == n ? void 0 : n.id) || XZ()
      });
    }(t, e, n);
    return eW({
      type: 2,
      toast: r
    }), r.id;
  },
  rW = (e, t) => nW("blank")(e, t);
rW.error = nW("error"), rW.success = nW("success"), rW.loading = nW("loading"), rW.custom = nW("custom"), rW.dismiss = e => {
  eW({
    type: 3,
    toastId: e
  });
}, rW.remove = e => eW({
  type: 4,
  toastId: e
}), rW.promise = (e, t, n) => {
  let r = rW.loading(t.loading, _objectSpread(_objectSpread({}, n), null == n ? void 0 : n.loading));
  return e.then(e => (rW.success(WZ(t.success, e), _objectSpread(_objectSpread({
    id: r
  }, n), null == n ? void 0 : n.success)), e)).catch(e => {
    rW.error(WZ(t.error, e), _objectSpread(_objectSpread({
      id: r
    }, n), null == n ? void 0 : n.error));
  }), e;
};
var oW = e => {
    let _ref178 = function () {
        let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let _n6 = n($Z),
          _n7 = _slicedToArray(_n6, 2),
          t = _n7[0],
          o = _n7[1];
        r(() => (_Z.push(o), () => {
          let e = _Z.indexOf(o);
          e > -1 && _Z.splice(e, 1);
        }), [t]);
        let i = t.toasts.map(t => {
          var n, r;
          return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, e), e[t.type]), t), {}, {
            duration: t.duration || (null == (n = e[t.type]) ? void 0 : n.duration) || (null == e ? void 0 : e.duration) || tW[t.type],
            style: _objectSpread(_objectSpread(_objectSpread({}, e.style), null == (r = e[t.type]) ? void 0 : r.style), t.style)
          });
        });
        return _objectSpread(_objectSpread({}, t), {}, {
          toasts: i
        });
      }(e),
      t = _ref178.toasts,
      o = _ref178.pausedAt;
    r(() => {
      if (o) return;
      let e = Date.now(),
        n = t.map(t => {
          if (t.duration === 1 / 0) return;
          let n = (t.duration || 0) + t.pauseDuration - (e - t.createdAt);
          if (!(n < 0)) return setTimeout(() => rW.dismiss(t.id), n);
          t.visible && rW.dismiss(t.id);
        });
      return () => {
        n.forEach(e => e && clearTimeout(e));
      };
    }, [t, o]);
    let i = s(() => ({
      startPause: () => {
        eW({
          type: 5,
          time: Date.now()
        });
      },
      endPause: () => {
        o && eW({
          type: 6,
          time: Date.now()
        });
      },
      updateHeight: (e, t) => eW({
        type: 1,
        toast: {
          id: e,
          height: t
        }
      }),
      calculateOffset: (e, n) => {
        let _ref179 = n || {},
          _ref179$reverseOrder = _ref179.reverseOrder,
          r = _ref179$reverseOrder === void 0 ? !1 : _ref179$reverseOrder,
          _ref179$gutter = _ref179.gutter,
          o = _ref179$gutter === void 0 ? 8 : _ref179$gutter,
          i = _ref179.defaultPosition,
          a = t.filter(t => (t.position || i) === (e.position || i) && t.height),
          c = a.findIndex(t => t.id === e.id),
          s = a.filter((e, t) => t < c && e.visible).length;
        return a.filter(e => e.visible).slice(...(r ? [s + 1] : [0, s])).reduce((e, t) => e + (t.height || 0) + o, 0);
      }
    }), [t, o]);
    return {
      toasts: t,
      handlers: i
    };
  },
  iW = JZ`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`,
  aW = JZ`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`,
  cW = JZ`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`,
  sW = ZZ("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${iW} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${aW} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${e => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${cW} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`,
  lW = JZ`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`,
  uW = ZZ("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${e => e.secondary || "#e0e0e0"};
  border-right-color: ${e => e.primary || "#616161"};
  animation: ${lW} 1s linear infinite;
`,
  dW = JZ`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`,
  fW = JZ`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`,
  pW = ZZ("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${e => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${dW} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${fW} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${e => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`,
  mW = ZZ("div")`
  position: absolute;
`,
  hW = ZZ("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`,
  AW = JZ`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`,
  gW = ZZ("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${AW} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`,
  vW = _ref180 => {
    let t = _ref180.toast;
    let n = t.icon,
      r = t.type,
      o = t.iconTheme;
    return void 0 !== n ? "string" == typeof n ? /*#__PURE__*/e.createElement(gW, null, n) : n : "blank" === r ? null : /*#__PURE__*/e.createElement(hW, null, /*#__PURE__*/e.createElement(uW, _objectSpread({}, o)), "loading" !== r && /*#__PURE__*/e.createElement(mW, null, "error" === r ? /*#__PURE__*/e.createElement(sW, _objectSpread({}, o)) : /*#__PURE__*/e.createElement(pW, _objectSpread({}, o))));
  },
  CW = e => `\n0% {transform: translate3d(0,${-200 * e}%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n`,
  bW = e => `\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0,${-150 * e}%,-1px) scale(.6); opacity:0;}\n`,
  EW = ZZ("div", e.forwardRef)`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`,
  yW = ZZ("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`,
  IW = /*#__PURE__*/e.memo(_ref181 => {
    let t = _ref181.toast,
      n = _ref181.position,
      r = _ref181.style,
      o = _ref181.children;
    let i = null != t && t.height ? ((e, t) => {
        let n = e.includes("top") ? 1 : -1,
          _ref182 = UZ() ? ["0%{opacity:0;} 100%{opacity:1;}", "0%{opacity:1;} 100%{opacity:0;}"] : [CW(n), bW(n)],
          _ref183 = _slicedToArray(_ref182, 2),
          r = _ref183[0],
          o = _ref183[1];
        return {
          animation: t ? `${JZ(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${JZ(o)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
        };
      })(t.position || n || "top-center", t.visible) : {
        opacity: 0
      },
      a = /*#__PURE__*/e.createElement(vW, {
        toast: t
      }),
      c = /*#__PURE__*/e.createElement(yW, _objectSpread({}, t.ariaProps), WZ(t.message, t));
    return /*#__PURE__*/e.createElement(EW, {
      className: t.className,
      style: _objectSpread(_objectSpread(_objectSpread({}, i), r), t.style)
    }, "function" == typeof o ? o({
      icon: a,
      message: c
    }) : /*#__PURE__*/e.createElement(e.Fragment, null, a, c));
  });
!function (e, t, n, r) {
  TZ.p = t, MZ = e, kZ = n, NZ = r;
}(e.createElement);
var BW = jZ`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`,
  xW = _ref184 => {
    let t = _ref184.reverseOrder,
      _ref184$position = _ref184.position,
      n = _ref184$position === void 0 ? "top-center" : _ref184$position,
      r = _ref184.toastOptions,
      o = _ref184.gutter,
      i = _ref184.children,
      a = _ref184.containerStyle,
      c = _ref184.containerClassName;
    let _oW = oW(r),
      s = _oW.toasts,
      l = _oW.handlers;
    return /*#__PURE__*/e.createElement("div", {
      style: _objectSpread({
        position: "fixed",
        zIndex: 9999,
        top: 16,
        left: 16,
        right: 16,
        bottom: 16,
        pointerEvents: "none"
      }, a),
      className: c,
      onMouseEnter: l.startPause,
      onMouseLeave: l.endPause
    }, s.map(r => {
      let a = r.position || n,
        c = ((e, t) => {
          let n = e.includes("top"),
            r = n ? {
              top: 0
            } : {
              bottom: 0
            },
            o = e.includes("center") ? {
              justifyContent: "center"
            } : e.includes("right") ? {
              justifyContent: "flex-end"
            } : {};
          return _objectSpread(_objectSpread({
            left: 0,
            right: 0,
            display: "flex",
            position: "absolute",
            transition: UZ() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
            transform: `translateY(${t * (n ? 1 : -1)}px)`
          }, r), o);
        })(a, l.calculateOffset(r, {
          reverseOrder: t,
          gutter: o,
          defaultPosition: n
        })),
        s = r.height ? void 0 : (e => t => {
          t && setTimeout(() => {
            let n = t.getBoundingClientRect();
            e(n);
          });
        })(e => {
          l.updateHeight(r.id, e.height);
        });
      return /*#__PURE__*/e.createElement("div", {
        ref: s,
        className: r.visible ? BW : "",
        key: r.id,
        style: c
      }, "custom" === r.type ? WZ(r.message, r) : i ? i(r) : /*#__PURE__*/e.createElement(IW, {
        toast: r,
        position: a
      }));
    }));
  },
  wW = rW,
  QW = /*#__PURE__*/t.forwardRef(function (e, n) {
    var r = Lb().isMobile;
    return h(n, function () {
      return {
        toast: function (e, n, o, i) {
          var a = Date.now();
          wW.custom( /*#__PURE__*/t.createElement(nb, {
            style: {
              minWidth: 300,
              maxWidth: r ? 320 : 420
            }
          }, /*#__PURE__*/t.createElement(zZ, N({
            icon: /*#__PURE__*/t.createElement(qv, {
              name: "infoCircle"
            }),
            headline: e,
            description: n,
            color: "blue",
            addShadow: !0,
            onDismiss: function () {
              wW.dismiss(a);
            },
            isDismissible: !0
          }, o))), {
            id: a,
            duration: i || 5e3
          });
        },
        toastError: function (e, n, o, i) {
          var a = Date.now();
          wW.custom( /*#__PURE__*/t.createElement(nb, {
            style: {
              minWidth: 300,
              maxWidth: r ? 320 : 420
            }
          }, /*#__PURE__*/t.createElement(zZ, N({
            icon: /*#__PURE__*/t.createElement(qv, {
              name: "times"
            }),
            headline: e,
            description: n,
            color: "red",
            addShadow: !0,
            onDismiss: function () {
              wW.dismiss(a);
            },
            isDismissible: !0
          }, o))), {
            id: a,
            duration: i || 5e3
          });
        },
        toastSuccess: function (e, n, o, i) {
          var a = Date.now();
          wW.custom( /*#__PURE__*/t.createElement(nb, {
            style: {
              minWidth: 300,
              maxWidth: r ? 320 : 420
            }
          }, /*#__PURE__*/t.createElement(zZ, N({
            icon: /*#__PURE__*/t.createElement(qv, {
              name: "circleCheck"
            }),
            headline: e,
            description: n,
            color: "green",
            addShadow: !0,
            onDismiss: function () {
              wW.dismiss(a);
            },
            isDismissible: !0
          }, o))), {
            id: a,
            duration: i || 5e3
          });
        },
        toastWarn: function (e, n, o, i) {
          var a = Date.now();
          wW.custom( /*#__PURE__*/t.createElement(nb, {
            style: {
              minWidth: 300,
              maxWidth: r ? 320 : 420
            }
          }, /*#__PURE__*/t.createElement(zZ, N({
            icon: /*#__PURE__*/t.createElement(qv, {
              name: "exclamationTriangle"
            }),
            headline: e,
            description: n,
            color: "yellow",
            addShadow: !0,
            onDismiss: function () {
              wW.dismiss(a);
            },
            isDismissible: !0
          }, o))), {
            id: a,
            duration: i || 5e3
          });
        }
      };
    }), /*#__PURE__*/t.createElement(xW, {
      position: r ? "bottom-center" : "top-right",
      toastOptions: {
        style: {
          color: "#505775",
          animation: {
            enter: "enter 200ms ease-out forwards",
            leave: "leave 200ms ease-in forwards"
          }
        }
      }
    });
  });
QW.displayName = "Toast";
var HW = "TextMicro-module_micro__2WOhb",
  zW = ["children", "className"],
  MW = function (e) {
    var n = e.children,
      r = e.className,
      o = S(e, zW);
    return /*#__PURE__*/t.createElement(Nb, N({
      className: tC(HW, r)
    }, o), n);
  };
MW.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
}, MW.defaultProps = {
  weight: "semibold"
};
var kW = "textH1-module_headline__gGe7O",
  NW = ["children", "className"],
  SW = function (e) {
    var n = e.children,
      r = e.className,
      o = S(e, NW);
    return /*#__PURE__*/t.createElement(Nb, N({
      className: tC(kW, r),
      textColor: "dark-gray"
    }, o), n);
  };
SW.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
}, SW.defaultProps = {
  weight: "semibold"
};
var VW = "textH2-module_subHeadline__2cfal",
  LW = ["children", "className"],
  PW = function (e) {
    var n = e.children,
      r = e.className,
      o = S(e, LW);
    return /*#__PURE__*/t.createElement(Nb, N({
      className: tC(VW, r),
      textColor: "dark-gray"
    }, o), n);
  };
PW.propTypes = {
  children: g.any.isRequired,
  isFullWidth: g.bool,
  truncate: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  textTransform: g.oneOf(["capitalize", "uppercase", "lowercase", "none"]),
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  weight: g.oneOf(["regular", "semibold", "bold", "monospace"]),
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
}, PW.defaultProps = {
  weight: "semibold"
};
var OW = "textTitle-module_title__8OC5i",
  TW = function (e) {
    var n = e.children,
      r = e.textAlign,
      o = e.className,
      i = e.isFullWidth,
      a = e.textColor,
      c = e.truncate;
    return /*#__PURE__*/t.createElement(Nb, {
      className: tC(OW, o),
      textAlign: r,
      display: i ? "block" : "inline-block",
      textColor: a,
      truncate: c
    }, n);
  };
TW.propTypes = {
  isFullWidth: g.bool,
  textAlign: g.oneOf(["left", "center", "right"]),
  truncate: g.bool,
  textColor: g.oneOf(["white", "gray", "dark-gray", "light-gray", "disabled"]),
  children: g.any,
  className: g.string,
  verticalAlign: g.oneOf(["baseline", "sub", "super", "text-top", "text-bottom", "middle", "top", "bottom"])
}, TW.defaultProps = {
  textAlign: "left",
  textColor: "dark-gray"
};
var DW = "BottomSheet-module_bottomSheet__WBj3V",
  RW = "BottomSheet-module_formWidth__2GEdT";
process.env.NODE_ENV;
var GW = FW() ? p : r;
"production" !== process.env.NODE_ENV && ("undefined" != typeof process ? process : {
  env: {
    NODE_ENV: "development"
  }
}).env;
function FW() {
  return !("undefined" == typeof window || !window.document || !window.document.createElement);
}
process.env.NODE_ENV, process.env.NODE_ENV, process.env.NODE_ENV;
var jW = function (e) {
  var t,
    r = e.children,
    a = e.type,
    c = void 0 === a ? "reach-portal" : a,
    s = o(null),
    u = o(null),
    d = (t = n(Object.create(null))[1], l(function () {
      t(Object.create(null));
    }, []));
  return GW(function () {
    if (s.current) {
      var e = s.current.ownerDocument;
      return u.current = null == e ? void 0 : e.createElement(c), e.body.appendChild(u.current), d(), function () {
        u.current && u.current.ownerDocument && u.current.ownerDocument.body.removeChild(u.current);
      };
    }
  }, [c, d]), u.current ? /*#__PURE__*/B(r, u.current) : /*#__PURE__*/i("span", {
    ref: s
  });
};
"production" !== process.env.NODE_ENV && (jW.displayName = "Portal");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var JW,
  ZW,
  WW = function () {
    return WW = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, WW.apply(this, arguments);
  };
function XW(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
function UW(e) {
  var t = "function" == typeof Symbol && Symbol.iterator,
    n = t && e[t],
    r = 0;
  if (n) return n.call(e);
  if (e && "number" == typeof e.length) return {
    next: function () {
      return e && r >= e.length && (e = void 0), {
        value: e && e[r++],
        done: !e
      };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function KW(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
    o,
    i = n.call(e),
    a = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
}
function YW(e, t, n) {
  if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
!function (e) {
  e.Start = "xstate.start", e.Stop = "xstate.stop", e.Raise = "xstate.raise", e.Send = "xstate.send", e.Cancel = "xstate.cancel", e.NullEvent = "", e.Assign = "xstate.assign", e.After = "xstate.after", e.DoneState = "done.state", e.DoneInvoke = "done.invoke", e.Log = "xstate.log", e.Init = "xstate.init", e.Invoke = "xstate.invoke", e.ErrorExecution = "error.execution", e.ErrorCommunication = "error.communication", e.ErrorPlatform = "error.platform", e.ErrorCustom = "xstate.error", e.Update = "xstate.update", e.Pure = "xstate.pure", e.Choose = "xstate.choose";
}(JW || (JW = {})), function (e) {
  e.Parent = "#_parent", e.Internal = "#_internal";
}(ZW || (ZW = {}));
var qW = JW.Start,
  _W = JW.Stop,
  $W = JW.Raise,
  eX = JW.Send,
  tX = JW.Cancel,
  nX = JW.NullEvent,
  rX = JW.Assign;
JW.After, JW.DoneState;
var oX = JW.Log,
  iX = JW.Init,
  aX = JW.Invoke;
JW.ErrorExecution;
var cX,
  sX = JW.ErrorPlatform,
  lX = JW.ErrorCustom,
  uX = JW.Update,
  dX = JW.Choose,
  fX = JW.Pure,
  pX = {},
  mX = "production" === process.env.NODE_ENV;
function hX(e, t, n) {
  void 0 === n && (n = ".");
  var r = vX(e, n),
    o = vX(t, n);
  return VX(o) ? !!VX(r) && o === r : VX(r) ? r in o : Object.keys(r).every(function (e) {
    return e in o && hX(r[e], o[e]);
  });
}
function AX(e) {
  try {
    return VX(e) || "number" == typeof e ? "".concat(e) : e.type;
  } catch (e) {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function gX(e, t) {
  try {
    return NX(e) ? e : e.toString().split(t);
  } catch (t) {
    throw new Error("'".concat(e, "' is not a valid state path."));
  }
}
function vX(e, t) {
  return "object" == typeof (n = e) && "value" in n && "context" in n && "event" in n && "_event" in n ? e.value : NX(e) ? CX(e) : "string" != typeof e ? e : CX(gX(e, t));
  var n;
}
function CX(e) {
  if (1 === e.length) return e[0];
  for (var t = {}, n = t, r = 0; r < e.length - 1; r++) r === e.length - 2 ? n[e[r]] = e[r + 1] : (n[e[r]] = {}, n = n[e[r]]);
  return t;
}
function bX(e, t) {
  for (var n = {}, r = Object.keys(e), o = 0; o < r.length; o++) {
    var i = r[o];
    n[i] = t(e[i], i, e, o);
  }
  return n;
}
function EX(e, t, n) {
  var r,
    o,
    i = {};
  try {
    for (var a = UW(Object.keys(e)), c = a.next(); !c.done; c = a.next()) {
      var s = c.value,
        l = e[s];
      n(l) && (i[s] = t(l, s, e));
    }
  } catch (e) {
    r = {
      error: e
    };
  } finally {
    try {
      c && !c.done && (o = a.return) && o.call(a);
    } finally {
      if (r) throw r.error;
    }
  }
  return i;
}
var yX = function (e) {
  return function (t) {
    var n,
      r,
      o = t;
    try {
      for (var i = UW(e), a = i.next(); !a.done; a = i.next()) {
        o = o[a.value];
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        a && !a.done && (r = i.return) && r.call(i);
      } finally {
        if (n) throw n.error;
      }
    }
    return o;
  };
};
function IX(e) {
  return e ? VX(e) ? [[e]] : BX(Object.keys(e).map(function (t) {
    var n = e[t];
    return "string" == typeof n || n && Object.keys(n).length ? IX(e[t]).map(function (e) {
      return [t].concat(e);
    }) : [[t]];
  })) : [[]];
}
function BX(e) {
  var t;
  return (t = []).concat.apply(t, YW([], KW(e), !1));
}
function xX(e) {
  return NX(e) ? e : [e];
}
function wX(e) {
  return void 0 === e ? [] : xX(e);
}
function QX(e, t, n) {
  var r, o;
  if (SX(e)) return e(t, n.data);
  var i = {};
  try {
    for (var a = UW(Object.keys(e)), c = a.next(); !c.done; c = a.next()) {
      var s = c.value,
        l = e[s];
      SX(l) ? i[s] = l(t, n.data) : i[s] = l;
    }
  } catch (e) {
    r = {
      error: e
    };
  } finally {
    try {
      c && !c.done && (o = a.return) && o.call(a);
    } finally {
      if (r) throw r.error;
    }
  }
  return i;
}
function HX(e) {
  return e instanceof Promise || !(null === e || !SX(e) && "object" != typeof e || !SX(e.then));
}
function zX(e, t) {
  return bX(e.states, function (e, n) {
    if (e) {
      var r = (VX(t) ? void 0 : t[n]) || (e ? e.current : void 0);
      if (r) return {
        current: r,
        states: zX(e, r)
      };
    }
  });
}
function MX(e, t, n, r) {
  mX || kX(!!e, "Attempting to update undefined context");
  var o = e ? n.reduce(function (e, n) {
    var o,
      i,
      a = n.assignment,
      c = {
        state: r,
        action: n,
        _event: t
      },
      s = {};
    if (SX(a)) s = a(e, t.data, c);else try {
      for (var l = UW(Object.keys(a)), u = l.next(); !u.done; u = l.next()) {
        var d = u.value,
          f = a[d];
        s[d] = SX(f) ? f(e, t.data, c) : f;
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        u && !u.done && (i = l.return) && i.call(l);
      } finally {
        if (o) throw o.error;
      }
    }
    return Object.assign({}, e, s);
  }, e) : e;
  return o;
}
var kX = function () {};
function NX(e) {
  return Array.isArray(e);
}
function SX(e) {
  return "function" == typeof e;
}
function VX(e) {
  return "string" == typeof e;
}
function LX(e, t) {
  if (e) return VX(e) ? {
    type: "xstate.guard",
    name: e,
    predicate: t ? t[e] : void 0
  } : SX(e) ? {
    type: "xstate.guard",
    name: e.name,
    predicate: e
  } : e;
}
mX || (kX = function (e, t) {
  var n = e instanceof Error ? e : void 0;
  if ((n || !e) && void 0 !== console) {
    var r = ["Warning: ".concat(t)];
    n && r.push(n), console.warn.apply(console, r);
  }
});
var PX = function () {
  return "function" == typeof Symbol && Symbol.observable || "@@observable";
}();
function OX(e) {
  return !!e && "__xstatenode" in e;
}
function TX(e, t) {
  return VX(e) || "number" == typeof e ? WW({
    type: e
  }, t) : e;
}
function DX(e, t) {
  if (!VX(e) && "$$type" in e && "scxml" === e.$$type) return e;
  var n = TX(e);
  return WW({
    name: n.type,
    data: n,
    $$type: "scxml",
    type: "external"
  }, t);
}
function RX(e, t) {
  return xX(t).map(function (t) {
    return void 0 === t || "string" == typeof t || OX(t) ? {
      target: t,
      event: e
    } : WW(WW({}, t), {
      event: e
    });
  });
}
function GX(e, t, n, r, o) {
  var i = e.options.guards,
    a = {
      state: o,
      cond: t,
      _event: r
    };
  if ("xstate.guard" === t.type) return ((null == i ? void 0 : i[t.name]) || t.predicate)(n, r.data, a);
  var c = null == i ? void 0 : i[t.type];
  if (!c) throw new Error("Guard '".concat(t.type, "' is not implemented on machine '").concat(e.id, "'."));
  return c(n, r.data, a);
}
function FX(e) {
  return "string" == typeof e ? {
    type: e
  } : e;
}
function jX(e, t, n) {
  var r = function () {},
    o = "object" == typeof e,
    i = o ? e : null;
  return {
    next: ((o ? e.next : e) || r).bind(i),
    error: ((o ? e.error : t) || r).bind(i),
    complete: ((o ? e.complete : n) || r).bind(i)
  };
}
function JX(e, t) {
  return "".concat(e, ":invocation[").concat(t, "]");
}
function ZX(e) {
  return (e.type === $W || e.type === eX && e.to === ZW.Internal) && "number" != typeof e.delay;
}
(cX = {})[PX] = function () {
  return this;
}, cX[Symbol.observable] = function () {
  return this;
};
var WX = DX({
  type: iX
});
function XX(e, t) {
  return t && t[e] || void 0;
}
function UX(e, t) {
  var n;
  if (VX(e) || "number" == typeof e) n = SX(r = XX(e, t)) ? {
    type: e,
    exec: r
  } : r || {
    type: e,
    exec: void 0
  };else if (SX(e)) n = {
    type: e.name || e.toString(),
    exec: e
  };else {
    var r;
    if (SX(r = XX(e.type, t))) n = WW(WW({}, e), {
      exec: r
    });else if (r) {
      var o = r.type || e.type;
      n = WW(WW(WW({}, r), e), {
        type: o
      });
    } else n = e;
  }
  return n;
}
var KX = function (e, t) {
  return e ? (NX(e) ? e : [e]).map(function (e) {
    return UX(e, t);
  }) : [];
};
function YX(e) {
  var t = UX(e);
  return WW(WW({
    id: VX(e) ? e : t.id
  }, t), {
    type: t.type
  });
}
function qX(e, t) {
  var n = "".concat(JW.DoneState, ".").concat(e),
    r = {
      type: n,
      data: t,
      toString: function () {
        return n;
      }
    };
  return r;
}
function _X(e, t) {
  var n = "".concat(JW.DoneInvoke, ".").concat(e),
    r = {
      type: n,
      data: t,
      toString: function () {
        return n;
      }
    };
  return r;
}
function $X(e, t) {
  var n = "".concat(JW.ErrorPlatform, ".").concat(e),
    r = {
      type: n,
      data: t,
      toString: function () {
        return n;
      }
    };
  return r;
}
function eU(e, t, n, r, o, i, a) {
  void 0 === a && (a = !1);
  var c = a ? [] : function (e) {
      var t,
        n,
        r = [];
      try {
        for (var o = UW(e), i = o.next(); !i.done; i = o.next()) for (var a = i.value, c = 0; c < a.actions.length;) a.actions[c].type !== rX ? c++ : (r.push(a.actions[c]), a.actions.splice(c, 1));
      } catch (e) {
        t = {
          error: e
        };
      } finally {
        try {
          i && !i.done && (n = o.return) && n.call(o);
        } finally {
          if (t) throw t.error;
        }
      }
      return r;
    }(o),
    s = c.length ? MX(n, r, c, t) : n,
    l = a ? [n] : void 0,
    u = [];
  function d(o, c) {
    var d;
    switch (c.type) {
      case $W:
        var f = function (e, t, n, r) {
          var o,
            i = {
              _event: n
            },
            a = DX(SX(e.event) ? e.event(t, n.data, i) : e.event);
          if (VX(e.delay)) {
            var c = r && r[e.delay];
            o = SX(c) ? c(t, n.data, i) : c;
          } else o = SX(e.delay) ? e.delay(t, n.data, i) : e.delay;
          return WW(WW({}, e), {
            type: $W,
            _event: a,
            delay: o
          });
        }(c, s, r, e.options.delays);
        return i && "number" == typeof f.delay && i(f, s, r), f;
      case eX:
        var p = function (e, t, n, r) {
          var o,
            i = {
              _event: n
            },
            a = DX(SX(e.event) ? e.event(t, n.data, i) : e.event);
          if (VX(e.delay)) {
            var c = r && r[e.delay];
            o = SX(c) ? c(t, n.data, i) : c;
          } else o = SX(e.delay) ? e.delay(t, n.data, i) : e.delay;
          var s = SX(e.to) ? e.to(t, n.data, i) : e.to;
          return WW(WW({}, e), {
            to: s,
            _event: a,
            event: a.data,
            delay: o
          });
        }(c, s, r, e.options.delays);
        if (!mX) {
          var m = c.delay;
          kX(!VX(m) || "number" == typeof p.delay, "No delay reference for delay expression '".concat(m, "' was found on machine '").concat(e.id, "'"));
        }
        return i && p.to !== ZW.Internal && ("entry" === o ? u.push(p) : i(p, s, r)), p;
      case oX:
        var h = function (e, t, n) {
          return WW(WW({}, e), {
            value: VX(e.expr) ? e.expr : e.expr(t, n.data, {
              _event: n
            })
          });
        }(c, s, r);
        return null == i || i(h, s, r), h;
      case dX:
        if (!(C = null === (d = c.conds.find(function (n) {
          var o = LX(n.cond, e.options.guards);
          return !o || GX(e, o, s, r, i ? void 0 : t);
        })) || void 0 === d ? void 0 : d.actions)) return [];
        var A = KW(eU(e, t, s, r, [{
            type: o,
            actions: KX(wX(C), e.options.actions)
          }], i, a), 2),
          g = A[0],
          v = A[1];
        return s = v, null == l || l.push(s), g;
      case fX:
        var C;
        if (!(C = c.get(s, r.data))) return [];
        var b = KW(eU(e, t, s, r, [{
            type: o,
            actions: KX(wX(C), e.options.actions)
          }], i, a), 2),
          E = b[0],
          y = b[1];
        return s = y, null == l || l.push(s), E;
      case _W:
        h = function (e, t, n) {
          var r = SX(e.activity) ? e.activity(t, n.data) : e.activity,
            o = "string" == typeof r ? {
              id: r
            } : r;
          return {
            type: JW.Stop,
            activity: o
          };
        }(c, s, r);
        return null == i || i(h, n, r), h;
      case rX:
        s = MX(s, r, [c], i ? void 0 : t), null == l || l.push(s);
        break;
      default:
        var I = UX(c, e.options.actions),
          B = I.exec;
        if (i) i(I, s, r);else if (B && l) {
          var x = l.length - 1,
            w = WW(WW({}, I), {
              exec: function (e) {
                for (var t = [], n = 1; n < arguments.length; n++) t[n - 1] = arguments[n];
                B.apply(void 0, YW([l[x]], KW(t), !1));
              }
            });
          I = w;
        }
        return I;
    }
  }
  var f = BX(o.map(function (e) {
    var t,
      n,
      o = [];
    try {
      for (var a = UW(e.actions), c = a.next(); !c.done; c = a.next()) {
        var l = c.value,
          f = d(e.type, l);
        f && (o = o.concat(f));
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        c && !c.done && (n = a.return) && n.call(a);
      } finally {
        if (t) throw t.error;
      }
    }
    return u.forEach(function (e) {
      i(e, s, r);
    }), u.length = 0, o;
  }));
  return [f, s];
}
var tU = function (e, t) {
  return t(e);
};
function nU(e) {
  var t;
  return (t = {
    id: e,
    send: function () {},
    subscribe: function () {
      return {
        unsubscribe: function () {}
      };
    },
    getSnapshot: function () {},
    toJSON: function () {
      return {
        id: e
      };
    }
  })[PX] = function () {
    return this;
  }, t;
}
function rU(e, t, n) {
  var r = nU(t);
  if (r.deferred = !0, OX(e)) {
    var o = r.state = tU(void 0, function () {
      return (n ? e.withContext(n) : e).initialState;
    });
    r.getSnapshot = function () {
      return o;
    };
  }
  return r;
}
var oU = function (e) {
  return "atomic" === e.type || "final" === e.type;
};
function iU(e) {
  return Object.keys(e.states).map(function (t) {
    return e.states[t];
  });
}
function aU(e) {
  return iU(e).filter(function (e) {
    return "history" !== e.type;
  });
}
function cU(e) {
  var t = [e];
  return oU(e) ? t : t.concat(BX(aU(e).map(cU)));
}
function sU(e, t) {
  var n,
    r,
    o,
    i,
    a,
    c,
    s,
    l,
    u = uU(new Set(e)),
    d = new Set(t);
  try {
    for (var f = UW(d), p = f.next(); !p.done; p = f.next()) for (var m = (I = p.value).parent; m && !d.has(m);) d.add(m), m = m.parent;
  } catch (e) {
    n = {
      error: e
    };
  } finally {
    try {
      p && !p.done && (r = f.return) && r.call(f);
    } finally {
      if (n) throw n.error;
    }
  }
  var h = uU(d);
  try {
    for (var A = UW(d), g = A.next(); !g.done; g = A.next()) {
      if ("compound" !== (I = g.value).type || h.get(I) && h.get(I).length) {
        if ("parallel" === I.type) try {
          for (var v = (a = void 0, UW(aU(I))), C = v.next(); !C.done; C = v.next()) {
            var b = C.value;
            d.has(b) || (d.add(b), u.get(b) ? u.get(b).forEach(function (e) {
              return d.add(e);
            }) : b.initialStateNodes.forEach(function (e) {
              return d.add(e);
            }));
          }
        } catch (e) {
          a = {
            error: e
          };
        } finally {
          try {
            C && !C.done && (c = v.return) && c.call(v);
          } finally {
            if (a) throw a.error;
          }
        }
      } else u.get(I) ? u.get(I).forEach(function (e) {
        return d.add(e);
      }) : I.initialStateNodes.forEach(function (e) {
        return d.add(e);
      });
    }
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      g && !g.done && (i = A.return) && i.call(A);
    } finally {
      if (o) throw o.error;
    }
  }
  try {
    for (var E = UW(d), y = E.next(); !y.done; y = E.next()) {
      var I;
      for (m = (I = y.value).parent; m && !d.has(m);) d.add(m), m = m.parent;
    }
  } catch (e) {
    s = {
      error: e
    };
  } finally {
    try {
      y && !y.done && (l = E.return) && l.call(E);
    } finally {
      if (s) throw s.error;
    }
  }
  return d;
}
function lU(e, t) {
  var n = t.get(e);
  if (!n) return {};
  if ("compound" === e.type) {
    var r = n[0];
    if (!r) return {};
    if (oU(r)) return r.key;
  }
  var o = {};
  return n.forEach(function (e) {
    o[e.key] = lU(e, t);
  }), o;
}
function uU(e) {
  var t,
    n,
    r = new Map();
  try {
    for (var o = UW(e), i = o.next(); !i.done; i = o.next()) {
      var a = i.value;
      r.has(a) || r.set(a, []), a.parent && (r.has(a.parent) || r.set(a.parent, []), r.get(a.parent).push(a));
    }
  } catch (e) {
    t = {
      error: e
    };
  } finally {
    try {
      i && !i.done && (n = o.return) && n.call(o);
    } finally {
      if (t) throw t.error;
    }
  }
  return r;
}
function dU(e, t) {
  return lU(e, uU(sU([e], t)));
}
function fU(e, t) {
  return Array.isArray(e) ? e.some(function (e) {
    return e === t;
  }) : e instanceof Set && e.has(t);
}
function pU(e, t) {
  return "compound" === t.type ? aU(t).some(function (t) {
    return "final" === t.type && fU(e, t);
  }) : "parallel" === t.type && aU(t).every(function (t) {
    return pU(e, t);
  });
}
function mU(e) {
  return new Set(BX(e.map(function (e) {
    return e.tags;
  })));
}
function hU(e, t) {
  if (e === t) return !0;
  if (void 0 === e || void 0 === t) return !1;
  if (VX(e) || VX(t)) return e === t;
  var n = Object.keys(e),
    r = Object.keys(t);
  return n.length === r.length && n.every(function (n) {
    return hU(e[n], t[n]);
  });
}
var AU = function () {
    function e(e) {
      var t,
        n,
        r = this;
      this.actions = [], this.activities = pX, this.meta = {}, this.events = [], this.value = e.value, this.context = e.context, this._event = e._event, this._sessionid = e._sessionid, this.event = this._event.data, this.historyValue = e.historyValue, this.history = e.history, this.actions = e.actions || [], this.activities = e.activities || pX, this.meta = (void 0 === (n = e.configuration) && (n = []), n.reduce(function (e, t) {
        return void 0 !== t.meta && (e[t.id] = t.meta), e;
      }, {})), this.events = e.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = e.configuration, this.transitions = e.transitions, this.children = e.children, this.done = !!e.done, this.tags = null !== (t = Array.isArray(e.tags) ? new Set(e.tags) : e.tags) && void 0 !== t ? t : new Set(), this.machine = e.machine, Object.defineProperty(this, "nextEvents", {
        get: function () {
          return function (e) {
            return YW([], KW(new Set(BX(YW([], KW(e.map(function (e) {
              return e.ownEvents;
            })), !1)))), !1);
          }(r.configuration);
        }
      });
    }
    return e.from = function (t, n) {
      return t instanceof e ? t.context !== n ? new e({
        value: t.value,
        context: n,
        _event: t._event,
        _sessionid: null,
        historyValue: t.historyValue,
        history: t.history,
        actions: [],
        activities: t.activities,
        meta: {},
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      }) : t : new e({
        value: t,
        context: n,
        _event: WX,
        _sessionid: null,
        historyValue: void 0,
        history: void 0,
        actions: [],
        activities: void 0,
        meta: void 0,
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      });
    }, e.create = function (t) {
      return new e(t);
    }, e.inert = function (t, n) {
      if (t instanceof e) {
        if (!t.actions.length) return t;
        var r = WX;
        return new e({
          value: t.value,
          context: n,
          _event: r,
          _sessionid: null,
          historyValue: t.historyValue,
          history: t.history,
          activities: t.activities,
          configuration: t.configuration,
          transitions: [],
          children: {}
        });
      }
      return e.from(t, n);
    }, e.prototype.toStrings = function (e, t) {
      var n = this;
      if (void 0 === e && (e = this.value), void 0 === t && (t = "."), VX(e)) return [e];
      var r = Object.keys(e);
      return r.concat.apply(r, YW([], KW(r.map(function (r) {
        return n.toStrings(e[r], t).map(function (e) {
          return r + t + e;
        });
      })), !1));
    }, e.prototype.toJSON = function () {
      var e = this;
      e.configuration, e.transitions;
      var t = e.tags;
      e.machine;
      var n = XW(e, ["configuration", "transitions", "tags", "machine"]);
      return WW(WW({}, n), {
        tags: Array.from(t)
      });
    }, e.prototype.matches = function (e) {
      return hX(e, this.value);
    }, e.prototype.hasTag = function (e) {
      return this.tags.has(e);
    }, e.prototype.can = function (e) {
      var t;
      mX && kX(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
      var n = null === (t = this.machine) || void 0 === t ? void 0 : t.getTransitionData(this, e);
      return !!(null == n ? void 0 : n.transitions.length) && n.transitions.some(function (e) {
        return void 0 !== e.target || e.actions.length;
      });
    }, e;
  }(),
  gU = {
    deferEvents: !1
  },
  vU = function () {
    function e(e) {
      this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = WW(WW({}, gU), e);
    }
    return e.prototype.initialize = function (e) {
      if (this.initialized = !0, e) {
        if (!this.options.deferEvents) return void this.schedule(e);
        this.process(e);
      }
      this.flushEvents();
    }, e.prototype.schedule = function (e) {
      if (this.initialized && !this.processingEvent) {
        if (0 !== this.queue.length) throw new Error("Event queue should be empty when it is not processing events");
        this.process(e), this.flushEvents();
      } else this.queue.push(e);
    }, e.prototype.clear = function () {
      this.queue = [];
    }, e.prototype.flushEvents = function () {
      for (var e = this.queue.shift(); e;) this.process(e), e = this.queue.shift();
    }, e.prototype.process = function (e) {
      this.processingEvent = !0;
      try {
        e();
      } catch (e) {
        throw this.clear(), e;
      } finally {
        this.processingEvent = !1;
      }
    }, e;
  }(),
  CU = new Map(),
  bU = 0,
  EU = function () {
    return "x:".concat(bU++);
  },
  yU = function (e, t) {
    return CU.set(e, t), e;
  },
  IU = function (e) {
    return CU.get(e);
  },
  BU = function (e) {
    CU.delete(e);
  };
function xU() {
  return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : void (mX || console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues"));
}
function wU(e) {
  if (xU()) {
    var t = function () {
      var e = xU();
      if (e && "__xstate__" in e) return e.__xstate__;
    }();
    t && t.register(e);
  }
}
function QU(e, t) {
  void 0 === t && (t = {});
  var n = e.initialState,
    r = new Set(),
    o = [],
    i = !1,
    a = function (e) {
      var t;
      return WW(((t = {
        subscribe: function () {
          return {
            unsubscribe: function () {}
          };
        },
        id: "anonymous",
        getSnapshot: function () {}
      })[PX] = function () {
        return this;
      }, t), e);
    }({
      id: t.id,
      send: function (t) {
        o.push(t), function () {
          if (!i) {
            for (i = !0; o.length > 0;) {
              var t = o.shift();
              n = e.transition(n, t, c), r.forEach(function (e) {
                return e.next(n);
              });
            }
            i = !1;
          }
        }();
      },
      getSnapshot: function () {
        return n;
      },
      subscribe: function (e, t, o) {
        var i = jX(e, t, o);
        return r.add(i), i.next(n), {
          unsubscribe: function () {
            r.delete(i);
          }
        };
      }
    }),
    c = {
      parent: t.parent,
      self: a,
      id: t.id || "anonymous",
      observers: r
    };
  return n = e.start ? e.start(c) : n, a;
}
var HU,
  zU = {
    sync: !1,
    autoForward: !1
  };
!function (e) {
  e[e.NotStarted = 0] = "NotStarted", e[e.Running = 1] = "Running", e[e.Stopped = 2] = "Stopped";
}(HU || (HU = {}));
var MU = function () {
  function e(t, n) {
    void 0 === n && (n = e.defaultOptions);
    var r = this;
    this.machine = t, this.delayedEventsMap = {}, this.listeners = new Set(), this.contextListeners = new Set(), this.stopListeners = new Set(), this.doneListeners = new Set(), this.eventListeners = new Set(), this.sendListeners = new Set(), this.initialized = !1, this.status = HU.NotStarted, this.children = new Map(), this.forwardTo = new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function (e, t) {
      if (NX(e)) return r.batch(e), r.state;
      var n = DX(TX(e, t));
      if (r.status === HU.Stopped) return mX || kX(!1, 'Event "'.concat(n.name, '" was sent to stopped service "').concat(r.machine.id, '". This service has already reached its final state, and will not transition.\nEvent: ').concat(JSON.stringify(n.data))), r.state;
      if (r.status !== HU.Running && !r.options.deferEvents) throw new Error('Event "'.concat(n.name, '" was sent to uninitialized service "').concat(r.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: ').concat(JSON.stringify(n.data)));
      return r.scheduler.schedule(function () {
        r.forward(n);
        var e = r._nextState(n);
        r.update(e, n);
      }), r._state;
    }, this.sendTo = function (e, t, n) {
      var o,
        i = r.parent && (t === ZW.Parent || r.parent.id === t),
        a = i ? r.parent : VX(t) ? t === ZW.Internal ? r : r.children.get(t) || IU(t) : (o = t) && "function" == typeof o.send ? t : void 0;
      if (a) {
        if ("machine" in a) {
          if (r.status !== HU.Stopped || r.parent !== a || r.state.done) {
            var c = WW(WW({}, e), {
              name: e.name === lX ? "".concat($X(r.id)) : e.name,
              origin: r.sessionId
            });
            !n && r.machine.config.predictableActionArguments ? r._outgoingQueue.push([a, c]) : a.send(c);
          }
        } else !n && r.machine.config.predictableActionArguments ? r._outgoingQueue.push([a, e.data]) : a.send(e.data);
      } else {
        if (!i) throw new Error("Unable to send event to child '".concat(t, "' from service '").concat(r.id, "'."));
        mX || kX(!1, "Service '".concat(r.id, "' has no parent: unable to send event ").concat(e.type));
      }
    }, this._exec = function (e, t, n, o) {
      void 0 === o && (o = r.machine.options.actions);
      var i = e.exec || XX(e.type, o),
        a = SX(i) ? i : i ? i.exec : e.exec;
      if (a) try {
        return a(t, n.data, r.machine.config.predictableActionArguments ? {
          action: e,
          _event: n
        } : {
          action: e,
          state: r.state,
          _event: n
        });
      } catch (e) {
        throw r.parent && r.parent.send({
          type: "xstate.error",
          data: e
        }), e;
      }
      switch (e.type) {
        case $W:
          var c = e;
          r.defer(c);
          break;
        case eX:
          var s = e;
          if ("number" == typeof s.delay) return void r.defer(s);
          s.to ? r.sendTo(s._event, s.to, n === WX) : r.send(s._event);
          break;
        case tX:
          r.cancel(e.sendId);
          break;
        case qW:
          if (r.status !== HU.Running) return;
          var l = e.activity;
          if (!r.machine.config.predictableActionArguments && !r.state.activities[l.id || l.type]) break;
          if (l.type === JW.Invoke) {
            var u = FX(l.src),
              d = r.machine.options.services ? r.machine.options.services[u.type] : void 0,
              f = l.id,
              p = l.data;
            mX || kX(!("forward" in l), "`forward` property is deprecated (found in invocation of '".concat(l.src, "' in in machine '").concat(r.machine.id, "'). ") + "Please use `autoForward` instead.");
            var m = "autoForward" in l ? l.autoForward : !!l.forward;
            if (!d) return void (mX || kX(!1, "No service found for invocation '".concat(l.src, "' in machine '").concat(r.machine.id, "'.")));
            var h = p ? QX(p, t, n) : void 0;
            if ("string" == typeof d) return;
            var A = SX(d) ? d(t, n.data, {
              data: h,
              src: u,
              meta: l.meta
            }) : d;
            if (!A) return;
            var g = void 0;
            OX(A) && (A = h ? A.withContext(h) : A, g = {
              autoForward: m
            }), r.spawn(A, f, g);
          } else r.spawnActivity(l);
          break;
        case _W:
          r.stopChild(e.activity.id);
          break;
        case oX:
          var v = e,
            C = v.label,
            b = v.value;
          C ? r.logger(C, b) : r.logger(b);
          break;
        default:
          mX || kX(!1, "No implementation found for action type '".concat(e.type, "'"));
      }
    };
    var o = WW(WW({}, e.defaultOptions), n),
      i = o.clock,
      a = o.logger,
      c = o.parent,
      s = o.id,
      l = void 0 !== s ? s : t.id;
    this.id = l, this.logger = a, this.clock = i, this.parent = c, this.options = o, this.scheduler = new vU({
      deferEvents: this.options.deferEvents
    }), this.sessionId = EU();
  }
  return Object.defineProperty(e.prototype, "initialState", {
    get: function () {
      var e = this;
      return this._initialState ? this._initialState : tU(this, function () {
        return e._initialState = e.machine.initialState, e._initialState;
      });
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e.prototype, "state", {
    get: function () {
      return mX || kX(this.status !== HU.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first.")), this._state;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.execute = function (e, t) {
    var n, r;
    try {
      for (var o = UW(e.actions), i = o.next(); !i.done; i = o.next()) {
        var a = i.value;
        this.exec(a, e, t);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        i && !i.done && (r = o.return) && r.call(o);
      } finally {
        if (n) throw n.error;
      }
    }
  }, e.prototype.update = function (e, t) {
    var n,
      r,
      o,
      i,
      a,
      c,
      s,
      l,
      u = this;
    if (e._sessionid = this.sessionId, this._state = e, this.machine.config.predictableActionArguments && t !== WX || !this.options.execute) for (var d = void 0; d = this._outgoingQueue.shift();) d[0].send(d[1]);else this.execute(this.state);
    if (this.children.forEach(function (e) {
      u.state.children[e.id] = e;
    }), this.devTools && this.devTools.send(t.data, e), e.event) try {
      for (var f = UW(this.eventListeners), p = f.next(); !p.done; p = f.next()) {
        (0, p.value)(e.event);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        p && !p.done && (r = f.return) && r.call(f);
      } finally {
        if (n) throw n.error;
      }
    }
    try {
      for (var m = UW(this.listeners), h = m.next(); !h.done; h = m.next()) {
        (0, h.value)(e, e.event);
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        h && !h.done && (i = m.return) && i.call(m);
      } finally {
        if (o) throw o.error;
      }
    }
    try {
      for (var A = UW(this.contextListeners), g = A.next(); !g.done; g = A.next()) {
        (0, g.value)(this.state.context, this.state.history ? this.state.history.context : void 0);
      }
    } catch (e) {
      a = {
        error: e
      };
    } finally {
      try {
        g && !g.done && (c = A.return) && c.call(A);
      } finally {
        if (a) throw a.error;
      }
    }
    if (this.state.done) {
      var v = e.configuration.find(function (e) {
          return "final" === e.type && e.parent === u.machine;
        }),
        C = v && v.doneData ? QX(v.doneData, e.context, t) : void 0;
      this._doneEvent = _X(this.id, C);
      try {
        for (var b = UW(this.doneListeners), E = b.next(); !E.done; E = b.next()) {
          (0, E.value)(this._doneEvent);
        }
      } catch (e) {
        s = {
          error: e
        };
      } finally {
        try {
          E && !E.done && (l = b.return) && l.call(b);
        } finally {
          if (s) throw s.error;
        }
      }
      this._stop(), this._stopChildren(), BU(this.sessionId);
    }
  }, e.prototype.onTransition = function (e) {
    return this.listeners.add(e), this.status === HU.Running && e(this.state, this.state.event), this;
  }, e.prototype.subscribe = function (e, t, n) {
    var r = this,
      o = jX(e, t, n);
    this.listeners.add(o.next), this.status !== HU.NotStarted && o.next(this.state);
    var i = function () {
      r.doneListeners.delete(i), r.stopListeners.delete(i), o.complete();
    };
    return this.status === HU.Stopped ? o.complete() : (this.onDone(i), this.onStop(i)), {
      unsubscribe: function () {
        r.listeners.delete(o.next), r.doneListeners.delete(i), r.stopListeners.delete(i);
      }
    };
  }, e.prototype.onEvent = function (e) {
    return this.eventListeners.add(e), this;
  }, e.prototype.onSend = function (e) {
    return this.sendListeners.add(e), this;
  }, e.prototype.onChange = function (e) {
    return this.contextListeners.add(e), this;
  }, e.prototype.onStop = function (e) {
    return this.stopListeners.add(e), this;
  }, e.prototype.onDone = function (e) {
    return this.status === HU.Stopped && this._doneEvent ? e(this._doneEvent) : this.doneListeners.add(e), this;
  }, e.prototype.off = function (e) {
    return this.listeners.delete(e), this.eventListeners.delete(e), this.sendListeners.delete(e), this.stopListeners.delete(e), this.doneListeners.delete(e), this.contextListeners.delete(e), this;
  }, e.prototype.start = function (e) {
    var t = this;
    if (this.status === HU.Running) return this;
    this.machine._init(), yU(this.sessionId, this), this.initialized = !0, this.status = HU.Running;
    var n = void 0 === e ? this.initialState : tU(this, function () {
      return "object" == typeof (n = e) && null !== n && "value" in n && "_event" in n ? t.machine.resolveState(e) : t.machine.resolveState(AU.from(e, t.machine.context));
      var n;
    });
    return this.options.devTools && this.attachDev(), this.scheduler.initialize(function () {
      t.update(n, WX);
    }), this;
  }, e.prototype._stopChildren = function () {
    this.children.forEach(function (e) {
      SX(e.stop) && e.stop();
    }), this.children.clear();
  }, e.prototype._stop = function () {
    var e, t, n, r, o, i, a, c, s, l;
    try {
      for (var u = UW(this.listeners), d = u.next(); !d.done; d = u.next()) {
        var f = d.value;
        this.listeners.delete(f);
      }
    } catch (t) {
      e = {
        error: t
      };
    } finally {
      try {
        d && !d.done && (t = u.return) && t.call(u);
      } finally {
        if (e) throw e.error;
      }
    }
    try {
      for (var p = UW(this.stopListeners), m = p.next(); !m.done; m = p.next()) {
        (f = m.value)(), this.stopListeners.delete(f);
      }
    } catch (e) {
      n = {
        error: e
      };
    } finally {
      try {
        m && !m.done && (r = p.return) && r.call(p);
      } finally {
        if (n) throw n.error;
      }
    }
    try {
      for (var h = UW(this.contextListeners), A = h.next(); !A.done; A = h.next()) {
        f = A.value;
        this.contextListeners.delete(f);
      }
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        A && !A.done && (i = h.return) && i.call(h);
      } finally {
        if (o) throw o.error;
      }
    }
    try {
      for (var g = UW(this.doneListeners), v = g.next(); !v.done; v = g.next()) {
        f = v.value;
        this.doneListeners.delete(f);
      }
    } catch (e) {
      a = {
        error: e
      };
    } finally {
      try {
        v && !v.done && (c = g.return) && c.call(g);
      } finally {
        if (a) throw a.error;
      }
    }
    if (!this.initialized) return this;
    this.initialized = !1, this.status = HU.Stopped, this._initialState = void 0;
    try {
      for (var C = UW(Object.keys(this.delayedEventsMap)), b = C.next(); !b.done; b = C.next()) {
        var E = b.value;
        this.clock.clearTimeout(this.delayedEventsMap[E]);
      }
    } catch (e) {
      s = {
        error: e
      };
    } finally {
      try {
        b && !b.done && (l = C.return) && l.call(C);
      } finally {
        if (s) throw s.error;
      }
    }
    this.scheduler.clear(), this.scheduler = new vU({
      deferEvents: this.options.deferEvents
    });
  }, e.prototype.stop = function () {
    var e = this,
      t = this.scheduler;
    return this._stop(), t.schedule(function () {
      var t;
      if (!(null === (t = e._state) || void 0 === t ? void 0 : t.done)) {
        var n = DX({
            type: "xstate.stop"
          }),
          r = tU(e, function () {
            var t = BX(YW([], KW(e.state.configuration), !1).sort(function (e, t) {
                return t.order - e.order;
              }).map(function (t) {
                return KX(t.onExit, e.machine.options.actions);
              })),
              r = KW(eU(e.machine, e.state, e.state.context, n, [{
                type: "exit",
                actions: t
              }], e.machine.config.predictableActionArguments ? e._exec : void 0, e.machine.config.predictableActionArguments || e.machine.config.preserveActionOrder), 2),
              o = r[0],
              i = r[1],
              a = new AU({
                value: e.state.value,
                context: i,
                _event: n,
                _sessionid: e.sessionId,
                historyValue: void 0,
                history: e.state,
                actions: o.filter(function (e) {
                  return !ZX(e);
                }),
                activities: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {},
                done: e.state.done,
                tags: e.state.tags,
                machine: e.machine
              });
            return a.changed = !0, a;
          });
        e.update(r, n), e._stopChildren(), BU(e.sessionId);
      }
    }), this;
  }, e.prototype.batch = function (e) {
    var t = this;
    if (this.status === HU.NotStarted && this.options.deferEvents) mX || kX(!1, "".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '" and are deferred. Make sure .start() is called for this service.\nEvent: ').concat(JSON.stringify(event)));else if (this.status !== HU.Running) throw new Error("".concat(e.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.'));
    if (e.length) {
      var n = !!this.machine.config.predictableActionArguments && this._exec;
      this.scheduler.schedule(function () {
        var r,
          o,
          i = t.state,
          a = !1,
          c = [],
          s = function (e) {
            var r = DX(e);
            t.forward(r), i = tU(t, function () {
              return t.machine.transition(i, r, void 0, n || void 0);
            }), c.push.apply(c, YW([], KW(t.machine.config.predictableActionArguments ? i.actions : i.actions.map(function (e) {
              return function (e, t) {
                var n = e.exec;
                return WW(WW({}, e), {
                  exec: void 0 !== n ? function () {
                    return n(t.context, t.event, {
                      action: e,
                      state: t,
                      _event: t._event
                    });
                  } : void 0
                });
              }(e, i);
            })), !1)), a = a || !!i.changed;
          };
        try {
          for (var l = UW(e), u = l.next(); !u.done; u = l.next()) {
            s(u.value);
          }
        } catch (e) {
          r = {
            error: e
          };
        } finally {
          try {
            u && !u.done && (o = l.return) && o.call(l);
          } finally {
            if (r) throw r.error;
          }
        }
        i.changed = a, i.actions = c, t.update(i, DX(e[e.length - 1]));
      });
    }
  }, e.prototype.sender = function (e) {
    return this.send.bind(this, e);
  }, e.prototype._nextState = function (e, t) {
    var n = this;
    void 0 === t && (t = !!this.machine.config.predictableActionArguments && this._exec);
    var r = DX(e);
    if (0 === r.name.indexOf(sX) && !this.state.nextEvents.some(function (e) {
      return 0 === e.indexOf(sX);
    })) throw r.data.data;
    return tU(this, function () {
      return n.machine.transition(n.state, r, void 0, t || void 0);
    });
  }, e.prototype.nextState = function (e) {
    return this._nextState(e, !1);
  }, e.prototype.forward = function (e) {
    var t, n;
    try {
      for (var r = UW(this.forwardTo), o = r.next(); !o.done; o = r.next()) {
        var i = o.value,
          a = this.children.get(i);
        if (!a) throw new Error("Unable to forward event '".concat(e, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(i, "'."));
        a.send(e);
      }
    } catch (e) {
      t = {
        error: e
      };
    } finally {
      try {
        o && !o.done && (n = r.return) && n.call(r);
      } finally {
        if (t) throw t.error;
      }
    }
  }, e.prototype.defer = function (e) {
    var t = this,
      n = this.clock.setTimeout(function () {
        "to" in e && e.to ? t.sendTo(e._event, e.to, !0) : t.send(e._event);
      }, e.delay);
    e.id && (this.delayedEventsMap[e.id] = n);
  }, e.prototype.cancel = function (e) {
    this.clock.clearTimeout(this.delayedEventsMap[e]), delete this.delayedEventsMap[e];
  }, e.prototype.exec = function (e, t, n) {
    void 0 === n && (n = this.machine.options.actions), this._exec(e, t.context, t._event, n);
  }, e.prototype.removeChild = function (e) {
    var t;
    this.children.delete(e), this.forwardTo.delete(e), null === (t = this.state) || void 0 === t || delete t.children[e];
  }, e.prototype.stopChild = function (e) {
    var t = this.children.get(e);
    t && (this.removeChild(e), SX(t.stop) && t.stop());
  }, e.prototype.spawn = function (e, t, n) {
    if (this.status !== HU.Running) return rU(e, t);
    if (HX(e)) return this.spawnPromise(Promise.resolve(e), t);
    if (SX(e)) return this.spawnCallback(e, t);
    if (function (e) {
      try {
        return "function" == typeof e.send;
      } catch (e) {
        return !1;
      }
    }(o = e) && "id" in o) return this.spawnActor(e, t);
    if (function (e) {
      try {
        return "subscribe" in e && SX(e.subscribe);
      } catch (e) {
        return !1;
      }
    }(e)) return this.spawnObservable(e, t);
    if (OX(e)) return this.spawnMachine(e, WW(WW({}, n), {
      id: t
    }));
    if (null !== (r = e) && "object" == typeof r && "transition" in r && "function" == typeof r.transition) return this.spawnBehavior(e, t);
    throw new Error('Unable to spawn entity "'.concat(t, '" of type "').concat(typeof e, '".'));
    var r, o;
  }, e.prototype.spawnMachine = function (t, n) {
    var r = this;
    void 0 === n && (n = {});
    var o = new e(t, WW(WW({}, this.options), {
        parent: this,
        id: n.id || t.id
      })),
      i = WW(WW({}, zU), n);
    i.sync && o.onTransition(function (e) {
      r.send(uX, {
        state: e,
        id: o.id
      });
    });
    var a = o;
    return this.children.set(o.id, a), i.autoForward && this.forwardTo.add(o.id), o.onDone(function (e) {
      r.removeChild(o.id), r.send(DX(e, {
        origin: o.id
      }));
    }).start(), a;
  }, e.prototype.spawnBehavior = function (e, t) {
    var n = QU(e, {
      id: t,
      parent: this
    });
    return this.children.set(t, n), n;
  }, e.prototype.spawnPromise = function (e, t) {
    var n,
      r,
      o = this,
      i = !1;
    e.then(function (e) {
      i || (r = e, o.removeChild(t), o.send(DX(_X(t, e), {
        origin: t
      })));
    }, function (e) {
      if (!i) {
        o.removeChild(t);
        var n = $X(t, e);
        try {
          o.send(DX(n, {
            origin: t
          }));
        } catch (r) {
          !function (e, t, n) {
            if (!mX) {
              var r = e.stack ? " Stacktrace was '".concat(e.stack, "'") : "";
              if (e === t) console.error("Missing onError handler for invocation '".concat(n, "', error was '").concat(e, "'.").concat(r));else {
                var o = t.stack ? " Stacktrace was '".concat(t.stack, "'") : "";
                console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(n, "'. ") + "Original error: '".concat(e, "'. ").concat(r, " Current error is '").concat(t, "'.").concat(o));
              }
            }
          }(e, r, t), o.devTools && o.devTools.send(n, o.state), o.machine.strict && o.stop();
        }
      }
    });
    var a = (n = {
      id: t,
      send: function () {},
      subscribe: function (t, n, r) {
        var o = jX(t, n, r),
          i = !1;
        return e.then(function (e) {
          i || (o.next(e), i || o.complete());
        }, function (e) {
          i || o.error(e);
        }), {
          unsubscribe: function () {
            return i = !0;
          }
        };
      },
      stop: function () {
        i = !0;
      },
      toJSON: function () {
        return {
          id: t
        };
      },
      getSnapshot: function () {
        return r;
      }
    }, n[PX] = function () {
      return this;
    }, n);
    return this.children.set(t, a), a;
  }, e.prototype.spawnCallback = function (e, t) {
    var n,
      r,
      o,
      i = this,
      a = !1,
      c = new Set(),
      s = new Set();
    try {
      o = e(function (e) {
        r = e, s.forEach(function (t) {
          return t(e);
        }), a || i.send(DX(e, {
          origin: t
        }));
      }, function (e) {
        c.add(e);
      });
    } catch (e) {
      this.send($X(t, e));
    }
    if (HX(o)) return this.spawnPromise(o, t);
    var l = (n = {
      id: t,
      send: function (e) {
        return c.forEach(function (t) {
          return t(e);
        });
      },
      subscribe: function (e) {
        var t = jX(e);
        return s.add(t.next), {
          unsubscribe: function () {
            s.delete(t.next);
          }
        };
      },
      stop: function () {
        a = !0, SX(o) && o();
      },
      toJSON: function () {
        return {
          id: t
        };
      },
      getSnapshot: function () {
        return r;
      }
    }, n[PX] = function () {
      return this;
    }, n);
    return this.children.set(t, l), l;
  }, e.prototype.spawnObservable = function (e, t) {
    var n,
      r,
      o = this,
      i = e.subscribe(function (e) {
        r = e, o.send(DX(e, {
          origin: t
        }));
      }, function (e) {
        o.removeChild(t), o.send(DX($X(t, e), {
          origin: t
        }));
      }, function () {
        o.removeChild(t), o.send(DX(_X(t), {
          origin: t
        }));
      }),
      a = (n = {
        id: t,
        send: function () {},
        subscribe: function (t, n, r) {
          return e.subscribe(t, n, r);
        },
        stop: function () {
          return i.unsubscribe();
        },
        getSnapshot: function () {
          return r;
        },
        toJSON: function () {
          return {
            id: t
          };
        }
      }, n[PX] = function () {
        return this;
      }, n);
    return this.children.set(t, a), a;
  }, e.prototype.spawnActor = function (e, t) {
    return this.children.set(t, e), e;
  }, e.prototype.spawnActivity = function (e) {
    var t = this.machine.options && this.machine.options.activities ? this.machine.options.activities[e.type] : void 0;
    if (t) {
      var n = t(this.state.context, e);
      this.spawnEffect(e.id, n);
    } else mX || kX(!1, "No implementation found for activity '".concat(e.type, "'"));
  }, e.prototype.spawnEffect = function (e, t) {
    var n;
    this.children.set(e, ((n = {
      id: e,
      send: function () {},
      subscribe: function () {
        return {
          unsubscribe: function () {}
        };
      },
      stop: t || void 0,
      getSnapshot: function () {},
      toJSON: function () {
        return {
          id: e
        };
      }
    })[PX] = function () {
      return this;
    }, n));
  }, e.prototype.attachDev = function () {
    var e = xU();
    if (this.options.devTools && e) {
      if (e.__REDUX_DEVTOOLS_EXTENSION__) {
        var t = "object" == typeof this.options.devTools ? this.options.devTools : void 0;
        this.devTools = e.__REDUX_DEVTOOLS_EXTENSION__.connect(WW(WW({
          name: this.id,
          autoPause: !0,
          stateSanitizer: function (e) {
            return {
              value: e.value,
              context: e.context,
              actions: e.actions
            };
          }
        }, t), {
          features: WW({
            jump: !1,
            skip: !1
          }, t ? t.features : void 0)
        }), this.machine), this.devTools.init(this.state);
      }
      wU(this);
    }
  }, e.prototype.toJSON = function () {
    return {
      id: this.id
    };
  }, e.prototype[PX] = function () {
    return this;
  }, e.prototype.getSnapshot = function () {
    return this.status === HU.NotStarted ? this.initialState : this._state;
  }, e.defaultOptions = {
    execute: !0,
    deferEvents: !0,
    clock: {
      setTimeout: function (e, t) {
        return setTimeout(e, t);
      },
      clearTimeout: function (e) {
        return clearTimeout(e);
      }
    },
    logger: console.log.bind(console),
    devTools: !1
  }, e.interpret = kU, e;
}();
function kU(e, t) {
  return new MU(e, t);
}
function NU(e) {
  if ("string" == typeof e) {
    var t = {
      type: e,
      toString: function () {
        return e;
      }
    };
    return t;
  }
  return e;
}
function SU(e) {
  return WW(WW({
    type: aX
  }, e), {
    toJSON: function () {
      e.onDone, e.onError;
      var t = XW(e, ["onDone", "onError"]);
      return WW(WW({}, t), {
        type: aX,
        src: NU(e.src)
      });
    }
  });
}
var VU = {},
  LU = function (e) {
    return "#" === e[0];
  },
  PU = function () {
    function e(t, n, r, o) {
      void 0 === r && (r = "context" in t ? t.context : void 0);
      var i,
        a = this;
      this.config = t, this._context = r, this.order = -1, this.__xstatenode = !0, this.__cache = {
        events: void 0,
        relativeValue: new Map(),
        initialStateValue: void 0,
        initialState: void 0,
        on: void 0,
        transitions: void 0,
        candidates: {},
        delayedTransitions: void 0
      }, this.idMap = {}, this.tags = [], this.options = Object.assign({
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
      }, n), this.parent = null == o ? void 0 : o.parent, this.key = this.config.key || (null == o ? void 0 : o.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : "."), this.id = this.config.id || YW([this.machine.key], KW(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : null !== (i = this.config.schema) && void 0 !== i ? i : {}, this.description = this.config.description, mX || kX(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead.")), this.initial = this.config.initial, this.states = this.config.states ? bX(this.config.states, function (t, n) {
        var r,
          o = new e(t, {}, void 0, {
            parent: a,
            key: n
          });
        return Object.assign(a.idMap, WW(((r = {})[o.id] = o, r), o.idMap)), o;
      }) : VU;
      var c = 0;
      !function e(t) {
        var n, r;
        t.order = c++;
        try {
          for (var o = UW(iU(t)), i = o.next(); !i.done; i = o.next()) {
            e(i.value);
          }
        } catch (e) {
          n = {
            error: e
          };
        } finally {
          try {
            i && !i.done && (r = o.return) && r.call(o);
          } finally {
            if (n) throw n.error;
          }
        }
      }(this), this.history = !0 === this.config.history ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || !!this.config.on && (Array.isArray(this.config.on) ? this.config.on.some(function (e) {
        return "" === e.event;
      }) : "" in this.config.on), this.strict = !!this.config.strict, this.onEntry = wX(this.config.entry || this.config.onEntry).map(function (e) {
        return UX(e);
      }), this.onExit = wX(this.config.exit || this.config.onExit).map(function (e) {
        return UX(e);
      }), this.meta = this.config.meta, this.doneData = "final" === this.type ? this.config.data : void 0, this.invoke = wX(this.config.invoke).map(function (e, t) {
        var n, r;
        if (OX(e)) {
          var o = JX(a.id, t);
          return a.machine.options.services = WW(((n = {})[o] = e, n), a.machine.options.services), SU({
            src: o,
            id: o
          });
        }
        if (VX(e.src)) {
          o = e.id || JX(a.id, t);
          return SU(WW(WW({}, e), {
            id: o,
            src: e.src
          }));
        }
        if (OX(e.src) || SX(e.src)) {
          o = e.id || JX(a.id, t);
          return a.machine.options.services = WW(((r = {})[o] = e.src, r), a.machine.options.services), SU(WW(WW({
            id: o
          }, e), {
            src: o
          }));
        }
        var i = e.src;
        return SU(WW(WW({
          id: JX(a.id, t)
        }, e), {
          src: i
        }));
      }), this.activities = wX(this.config.activities).concat(this.invoke).map(function (e) {
        return YX(e);
      }), this.transition = this.transition.bind(this), this.tags = wX(this.config.tags);
    }
    return e.prototype._init = function () {
      this.__cache.transitions || cU(this).forEach(function (e) {
        return e.on;
      });
    }, e.prototype.withConfig = function (t, n) {
      var r = this.options,
        o = r.actions,
        i = r.activities,
        a = r.guards,
        c = r.services,
        s = r.delays;
      return new e(this.config, {
        actions: WW(WW({}, o), t.actions),
        activities: WW(WW({}, i), t.activities),
        guards: WW(WW({}, a), t.guards),
        services: WW(WW({}, c), t.services),
        delays: WW(WW({}, s), t.delays)
      }, null != n ? n : this.context);
    }, e.prototype.withContext = function (t) {
      return new e(this.config, this.options, t);
    }, Object.defineProperty(e.prototype, "context", {
      get: function () {
        return SX(this._context) ? this._context() : this._context;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "definition", {
      get: function () {
        return {
          id: this.id,
          key: this.key,
          version: this.version,
          context: this.context,
          type: this.type,
          initial: this.initial,
          history: this.history,
          states: bX(this.states, function (e) {
            return e.definition;
          }),
          on: this.on,
          transitions: this.transitions,
          entry: this.onEntry,
          exit: this.onExit,
          activities: this.activities || [],
          meta: this.meta,
          order: this.order || -1,
          data: this.doneData,
          invoke: this.invoke,
          description: this.description,
          tags: this.tags
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.toJSON = function () {
      return this.definition;
    }, Object.defineProperty(e.prototype, "on", {
      get: function () {
        if (this.__cache.on) return this.__cache.on;
        var e = this.transitions;
        return this.__cache.on = e.reduce(function (e, t) {
          return e[t.eventType] = e[t.eventType] || [], e[t.eventType].push(t), e;
        }, {});
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "after", {
      get: function () {
        return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "transitions", {
      get: function () {
        return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getCandidates = function (e) {
      if (this.__cache.candidates[e]) return this.__cache.candidates[e];
      var t = "" === e,
        n = this.transitions.filter(function (n) {
          var r = n.eventType === e;
          return t ? r : r || "*" === n.eventType;
        });
      return this.__cache.candidates[e] = n, n;
    }, e.prototype.getDelayedTransitions = function () {
      var e = this,
        t = this.config.after;
      if (!t) return [];
      var n = function (t, n) {
          var r = function (e, t) {
            var n = t ? "#".concat(t) : "";
            return "".concat(JW.After, "(").concat(e, ")").concat(n);
          }(SX(t) ? "".concat(e.id, ":delay[").concat(n, "]") : t, e.id);
          return e.onEntry.push(function (e, t) {
            return {
              to: t ? t.to : void 0,
              type: eX,
              event: SX(e) ? e : TX(e),
              delay: t ? t.delay : void 0,
              id: t && void 0 !== t.id ? t.id : SX(e) ? e.name : AX(e)
            };
          }(r, {
            delay: t
          })), e.onExit.push({
            type: tX,
            sendId: r
          }), r;
        },
        r = NX(t) ? t.map(function (e, t) {
          var r = n(e.delay, t);
          return WW(WW({}, e), {
            event: r
          });
        }) : BX(Object.keys(t).map(function (e, r) {
          var o = t[e],
            i = VX(o) ? {
              target: o
            } : o,
            a = isNaN(+e) ? e : +e,
            c = n(a, r);
          return wX(i).map(function (e) {
            return WW(WW({}, e), {
              event: c,
              delay: a
            });
          });
        }));
      return r.map(function (t) {
        var n = t.delay;
        return WW(WW({}, e.formatTransition(t)), {
          delay: n
        });
      });
    }, e.prototype.getStateNodes = function (e) {
      var t,
        n = this;
      if (!e) return [];
      var r = e instanceof AU ? e.value : vX(e, this.delimiter);
      if (VX(r)) {
        var o = this.getStateNode(r).initial;
        return void 0 !== o ? this.getStateNodes(((t = {})[r] = o, t)) : [this, this.states[r]];
      }
      var i = Object.keys(r),
        a = [this];
      return a.push.apply(a, YW([], KW(BX(i.map(function (e) {
        return n.getStateNode(e).getStateNodes(r[e]);
      }))), !1)), a;
    }, e.prototype.handles = function (e) {
      var t = AX(e);
      return this.events.includes(t);
    }, e.prototype.resolveState = function (e) {
      var t = e instanceof AU ? e : AU.create(e),
        n = Array.from(sU([], this.getStateNodes(t.value)));
      return new AU(WW(WW({}, t), {
        value: this.resolve(t.value),
        configuration: n,
        done: pU(n, this),
        tags: mU(n),
        machine: this.machine
      }));
    }, e.prototype.transitionLeafNode = function (e, t, n) {
      var r = this.getStateNode(e).next(t, n);
      return r && r.transitions.length ? r : this.next(t, n);
    }, e.prototype.transitionCompoundNode = function (e, t, n) {
      var r = Object.keys(e),
        o = this.getStateNode(r[0])._transition(e[r[0]], t, n);
      return o && o.transitions.length ? o : this.next(t, n);
    }, e.prototype.transitionParallelNode = function (e, t, n) {
      var r,
        o,
        i = {};
      try {
        for (var a = UW(Object.keys(e)), c = a.next(); !c.done; c = a.next()) {
          var s = c.value,
            l = e[s];
          if (l) {
            var u = this.getStateNode(s)._transition(l, t, n);
            u && (i[s] = u);
          }
        }
      } catch (e) {
        r = {
          error: e
        };
      } finally {
        try {
          c && !c.done && (o = a.return) && o.call(a);
        } finally {
          if (r) throw r.error;
        }
      }
      var d = Object.keys(i).map(function (e) {
          return i[e];
        }),
        f = BX(d.map(function (e) {
          return e.transitions;
        }));
      if (!d.some(function (e) {
        return e.transitions.length > 0;
      })) return this.next(t, n);
      var p = BX(Object.keys(i).map(function (e) {
        return i[e].configuration;
      }));
      return {
        transitions: f,
        exitSet: BX(d.map(function (e) {
          return e.exitSet;
        })),
        configuration: p,
        source: t,
        actions: BX(Object.keys(i).map(function (e) {
          return i[e].actions;
        }))
      };
    }, e.prototype._transition = function (e, t, n) {
      return VX(e) ? this.transitionLeafNode(e, t, n) : 1 === Object.keys(e).length ? this.transitionCompoundNode(e, t, n) : this.transitionParallelNode(e, t, n);
    }, e.prototype.getTransitionData = function (e, t) {
      return this._transition(e.value, e, DX(t));
    }, e.prototype.next = function (e, t) {
      var n,
        r,
        o,
        i = this,
        a = t.name,
        c = [],
        s = [];
      try {
        for (var l = UW(this.getCandidates(a)), u = l.next(); !u.done; u = l.next()) {
          var d = u.value,
            f = d.cond,
            p = d.in,
            m = e.context,
            h = !p || (VX(p) && LU(p) ? e.matches(vX(this.getStateNodeById(p).path, this.delimiter)) : hX(vX(p, this.delimiter), yX(this.path.slice(0, -2))(e.value))),
            A = !1;
          try {
            A = !f || GX(this.machine, f, m, t, e);
          } catch (e) {
            throw new Error("Unable to evaluate guard '".concat(f.name || f.type, "' in transition for event '").concat(a, "' in state node '").concat(this.id, "':\n").concat(e.message));
          }
          if (A && h) {
            void 0 !== d.target && (s = d.target), c.push.apply(c, YW([], KW(d.actions), !1)), o = d;
            break;
          }
        }
      } catch (e) {
        n = {
          error: e
        };
      } finally {
        try {
          u && !u.done && (r = l.return) && r.call(l);
        } finally {
          if (n) throw n.error;
        }
      }
      if (o) {
        if (!s.length) return {
          transitions: [o],
          exitSet: [],
          configuration: e.value ? [this] : [],
          source: e,
          actions: c
        };
        var g = BX(s.map(function (t) {
          return i.getRelativeStateNodes(t, e.historyValue);
        }));
        return {
          transitions: [o],
          exitSet: !!o.internal ? [] : BX(s.map(function (e) {
            return i.getPotentiallyReenteringNodes(e);
          })),
          configuration: g,
          source: e,
          actions: c
        };
      }
    }, e.prototype.getPotentiallyReenteringNodes = function (e) {
      if (this.order < e.order) return [this];
      for (var t = [], n = this, r = e; n && n !== r;) t.push(n), n = n.parent;
      return n !== r ? [] : (t.push(r), t);
    }, e.prototype.getActions = function (e, t, n, r, o, i, a) {
      var c,
        s,
        l,
        u,
        d = this,
        f = i ? sU([], this.getStateNodes(i.value)) : [],
        p = new Set();
      try {
        for (var m = UW(Array.from(e).sort(function (e, t) {
            return e.order - t.order;
          })), h = m.next(); !h.done; h = m.next()) {
          (!fU(f, v = h.value) || fU(n.exitSet, v) || v.parent && p.has(v.parent)) && p.add(v);
        }
      } catch (e) {
        c = {
          error: e
        };
      } finally {
        try {
          h && !h.done && (s = m.return) && s.call(m);
        } finally {
          if (c) throw c.error;
        }
      }
      try {
        for (var A = UW(f), g = A.next(); !g.done; g = A.next()) {
          var v;
          fU(e, v = g.value) && !fU(n.exitSet, v.parent) || n.exitSet.push(v);
        }
      } catch (e) {
        l = {
          error: e
        };
      } finally {
        try {
          g && !g.done && (u = A.return) && u.call(A);
        } finally {
          if (l) throw l.error;
        }
      }
      n.exitSet.sort(function (e, t) {
        return t.order - e.order;
      });
      var C = Array.from(p).sort(function (e, t) {
          return e.order - t.order;
        }),
        b = new Set(n.exitSet),
        E = BX(C.map(function (e) {
          var t = [];
          if ("final" !== e.type) return t;
          var i = e.parent;
          if (!i.parent) return t;
          t.push(qX(e.id, e.doneData), qX(i.id, e.doneData ? QX(e.doneData, r, o) : void 0));
          var a = i.parent;
          return "parallel" === a.type && aU(a).every(function (e) {
            return pU(n.configuration, e);
          }) && t.push(qX(a.id)), t;
        })),
        y = C.map(function (e) {
          var t = e.onEntry,
            n = e.activities.map(function (e) {
              return function (e) {
                var t = YX(e);
                return {
                  type: JW.Start,
                  activity: t,
                  exec: void 0
                };
              }(e);
            });
          return {
            type: "entry",
            actions: KX(a ? YW(YW([], KW(t), !1), KW(n), !1) : YW(YW([], KW(n), !1), KW(t), !1), d.machine.options.actions)
          };
        }).concat({
          type: "state_done",
          actions: E.map(function (e) {
            return function (e, t) {
              return {
                type: $W,
                event: "function" == typeof e ? e : TX(e),
                delay: t ? t.delay : void 0,
                id: null == t ? void 0 : t.id
              };
            }(e);
          })
        }),
        I = Array.from(b).map(function (e) {
          return {
            type: "exit",
            actions: KX(YW(YW([], KW(e.onExit), !1), KW(e.activities.map(function (e) {
              return function (e) {
                var t = SX(e) ? e : YX(e);
                return {
                  type: JW.Stop,
                  activity: t,
                  exec: void 0
                };
              }(e);
            })), !1), d.machine.options.actions)
          };
        }).concat({
          type: "transition",
          actions: KX(n.actions, this.machine.options.actions)
        }).concat(y);
      if (t) {
        var B = KX(BX(YW([], KW(e), !1).sort(function (e, t) {
          return t.order - e.order;
        }).map(function (e) {
          return e.onExit;
        })), this.machine.options.actions).filter(function (e) {
          return !ZX(e);
        });
        return I.concat({
          type: "stop",
          actions: B
        });
      }
      return I;
    }, e.prototype.transition = function (e, t, n, r) {
      void 0 === e && (e = this.initialState);
      var o,
        i,
        a = DX(t);
      if (e instanceof AU) o = void 0 === n ? e : this.resolveState(AU.from(e, n));else {
        var c = VX(e) ? this.resolve(CX(this.getResolvedPath(e))) : this.resolve(e),
          s = null != n ? n : this.machine.context;
        o = this.resolveState(AU.from(c, s));
      }
      if (!mX && "*" === a.name) throw new Error("An event cannot have the wildcard type ('".concat("*", "')"));
      if (this.strict && !this.events.includes(a.name) && (i = a.name, !/^(done|error)\./.test(i))) throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(a.name, "'"));
      var l = this._transition(o.value, o, a) || {
          transitions: [],
          configuration: [],
          exitSet: [],
          source: o,
          actions: []
        },
        u = sU([], this.getStateNodes(o.value)),
        d = l.configuration.length ? sU(u, l.configuration) : u;
      return l.configuration = YW([], KW(d), !1), this.resolveTransition(l, o, o.context, r, a);
    }, e.prototype.resolveRaisedTransition = function (e, t, n, r) {
      var o,
        i = e.actions;
      return (e = this.transition(e, t, void 0, r))._event = n, e.event = n.data, (o = e.actions).unshift.apply(o, YW([], KW(i), !1)), e;
    }, e.prototype.resolveTransition = function (e, t, n, r, o) {
      var i,
        a,
        c,
        s,
        l = this;
      void 0 === o && (o = WX);
      var u = e.configuration,
        d = !t || e.transitions.length > 0,
        f = d ? e.configuration : t ? t.configuration : [],
        p = pU(f, this),
        m = d ? dU(this.machine, u) : void 0,
        h = t ? t.historyValue ? t.historyValue : e.source ? this.machine.historyValue(t.value) : void 0 : void 0,
        A = this.getActions(new Set(f), p, e, n, o, t, r),
        g = t ? WW({}, t.activities) : {};
      try {
        for (var v = UW(A), C = v.next(); !C.done; C = v.next()) {
          var b = C.value;
          try {
            for (var E = (c = void 0, UW(b.actions)), y = E.next(); !y.done; y = E.next()) {
              var I = y.value;
              I.type === qW ? g[I.activity.id || I.activity.type] = I : I.type === _W && (g[I.activity.id || I.activity.type] = !1);
            }
          } catch (e) {
            c = {
              error: e
            };
          } finally {
            try {
              y && !y.done && (s = E.return) && s.call(E);
            } finally {
              if (c) throw c.error;
            }
          }
        }
      } catch (e) {
        i = {
          error: e
        };
      } finally {
        try {
          C && !C.done && (a = v.return) && a.call(v);
        } finally {
          if (i) throw i.error;
        }
      }
      var B,
        x,
        w = KW(eU(this, t, n, o, A, r, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2),
        Q = w[0],
        H = w[1],
        z = KW(function (e, t) {
          var n,
            r,
            o = KW([[], []], 2),
            i = o[0],
            a = o[1];
          try {
            for (var c = UW(e), s = c.next(); !s.done; s = c.next()) {
              var l = s.value;
              t(l) ? i.push(l) : a.push(l);
            }
          } catch (e) {
            n = {
              error: e
            };
          } finally {
            try {
              s && !s.done && (r = c.return) && r.call(c);
            } finally {
              if (n) throw n.error;
            }
          }
          return [i, a];
        }(Q, ZX), 2),
        M = z[0],
        k = z[1],
        N = Q.filter(function (e) {
          var t;
          return e.type === qW && (null === (t = e.activity) || void 0 === t ? void 0 : t.type) === aX;
        }),
        S = N.reduce(function (e, t) {
          return e[t.activity.id] = function (e, t, n, r) {
            var o,
              i = FX(e.src),
              a = null === (o = null == t ? void 0 : t.options.services) || void 0 === o ? void 0 : o[i.type],
              c = e.data ? QX(e.data, n, r) : void 0,
              s = a ? rU(a, e.id, c) : nU(e.id);
            return s.meta = e, s;
          }(t.activity, l.machine, H, o), e;
        }, t ? WW({}, t.children) : {}),
        V = new AU({
          value: m || t.value,
          context: H,
          _event: o,
          _sessionid: t ? t._sessionid : null,
          historyValue: m ? h ? (B = h, x = m, {
            current: x,
            states: zX(B, x)
          }) : void 0 : t ? t.historyValue : void 0,
          history: !m || e.source ? t : void 0,
          actions: m ? k : [],
          activities: m ? g : t ? t.activities : {},
          events: [],
          configuration: f,
          transitions: e.transitions,
          children: S,
          done: p,
          tags: mU(f),
          machine: this
        }),
        L = n !== H;
      V.changed = o.name === uX || L;
      var P = V.history;
      P && delete P.history;
      var O = !p && (this._transient || u.some(function (e) {
        return e._transient;
      }));
      if (!(d || O && "" !== o.name)) return V;
      var T = V;
      if (!p) for (O && (T = this.resolveRaisedTransition(T, {
        type: nX
      }, o, r)); M.length;) {
        var D = M.shift();
        T = this.resolveRaisedTransition(T, D._event, o, r);
      }
      var R = T.changed || (P ? !!T.actions.length || L || typeof P.value != typeof T.value || !hU(T.value, P.value) : void 0);
      return T.changed = R, T.history = P, T;
    }, e.prototype.getStateNode = function (e) {
      if (LU(e)) return this.machine.getStateNodeById(e);
      if (!this.states) throw new Error("Unable to retrieve child state '".concat(e, "' from '").concat(this.id, "'; no child states exist."));
      var t = this.states[e];
      if (!t) throw new Error("Child state '".concat(e, "' does not exist on '").concat(this.id, "'"));
      return t;
    }, e.prototype.getStateNodeById = function (e) {
      var t = LU(e) ? e.slice("#".length) : e;
      if (t === this.id) return this;
      var n = this.machine.idMap[t];
      if (!n) throw new Error("Child state node '#".concat(t, "' does not exist on machine '").concat(this.id, "'"));
      return n;
    }, e.prototype.getStateNodeByPath = function (e) {
      if ("string" == typeof e && LU(e)) try {
        return this.getStateNodeById(e.slice(1));
      } catch (e) {}
      for (var t = gX(e, this.delimiter).slice(), n = this; t.length;) {
        var r = t.shift();
        if (!r.length) break;
        n = n.getStateNode(r);
      }
      return n;
    }, e.prototype.resolve = function (e) {
      var t,
        n = this;
      if (!e) return this.initialStateValue || VU;
      switch (this.type) {
        case "parallel":
          return bX(this.initialStateValue, function (t, r) {
            return t ? n.getStateNode(r).resolve(e[r] || t) : VU;
          });
        case "compound":
          if (VX(e)) {
            var r = this.getStateNode(e);
            return "parallel" === r.type || "compound" === r.type ? ((t = {})[e] = r.initialStateValue, t) : e;
          }
          return Object.keys(e).length ? bX(e, function (e, t) {
            return e ? n.getStateNode(t).resolve(e) : VU;
          }) : this.initialStateValue || {};
        default:
          return e || VU;
      }
    }, e.prototype.getResolvedPath = function (e) {
      if (LU(e)) {
        var t = this.machine.idMap[e.slice("#".length)];
        if (!t) throw new Error("Unable to find state node '".concat(e, "'"));
        return t.path;
      }
      return gX(e, this.delimiter);
    }, Object.defineProperty(e.prototype, "initialStateValue", {
      get: function () {
        var e, t;
        if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
        if ("parallel" === this.type) t = EX(this.states, function (e) {
          return e.initialStateValue || VU;
        }, function (e) {
          return !("history" === e.type);
        });else if (void 0 !== this.initial) {
          if (!this.states[this.initial]) throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
          t = oU(this.states[this.initial]) ? this.initial : ((e = {})[this.initial] = this.states[this.initial].initialStateValue, e);
        } else t = {};
        return this.__cache.initialStateValue = t, this.__cache.initialStateValue;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getInitialState = function (e, t) {
      this._init();
      var n = this.getStateNodes(e);
      return this.resolveTransition({
        configuration: n,
        exitSet: [],
        transitions: [],
        source: void 0,
        actions: []
      }, void 0, null != t ? t : this.machine.context, void 0);
    }, Object.defineProperty(e.prototype, "initialState", {
      get: function () {
        var e = this.initialStateValue;
        if (!e) throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
        return this.getInitialState(e);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "target", {
      get: function () {
        var e;
        if ("history" === this.type) {
          var t = this.config;
          e = VX(t.target) && LU(t.target) ? CX(this.machine.getStateNodeById(t.target).path.slice(this.path.length - 1)) : t.target;
        }
        return e;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getRelativeStateNodes = function (e, t, n) {
      return void 0 === n && (n = !0), n ? "history" === e.type ? e.resolveHistory(t) : e.initialStateNodes : [e];
    }, Object.defineProperty(e.prototype, "initialStateNodes", {
      get: function () {
        var e = this;
        return oU(this) ? [this] : "compound" !== this.type || this.initial ? BX(IX(this.initialStateValue).map(function (t) {
          return e.getFromRelativePath(t);
        })) : (mX || kX(!1, "Compound state node '".concat(this.id, "' has no initial state.")), [this]);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getFromRelativePath = function (e) {
      if (!e.length) return [this];
      var t = KW(e),
        n = t[0],
        r = t.slice(1);
      if (!this.states) throw new Error("Cannot retrieve subPath '".concat(n, "' from node with no states"));
      var o = this.getStateNode(n);
      if ("history" === o.type) return o.resolveHistory();
      if (!this.states[n]) throw new Error("Child state '".concat(n, "' does not exist on '").concat(this.id, "'"));
      return this.states[n].getFromRelativePath(r);
    }, e.prototype.historyValue = function (e) {
      if (Object.keys(this.states).length) return {
        current: e || this.initialStateValue,
        states: EX(this.states, function (t, n) {
          if (!e) return t.historyValue();
          var r = VX(e) ? void 0 : e[n];
          return t.historyValue(r || t.initialStateValue);
        }, function (e) {
          return !e.history;
        })
      };
    }, e.prototype.resolveHistory = function (e) {
      var t = this;
      if ("history" !== this.type) return [this];
      var n = this.parent;
      if (!e) {
        var r = this.target;
        return r ? BX(IX(r).map(function (e) {
          return n.getFromRelativePath(e);
        })) : n.initialStateNodes;
      }
      var o,
        i,
        a = (o = n.path, i = "states", function (e) {
          var t,
            n,
            r = e;
          try {
            for (var a = UW(o), c = a.next(); !c.done; c = a.next()) {
              var s = c.value;
              r = r[i][s];
            }
          } catch (e) {
            t = {
              error: e
            };
          } finally {
            try {
              c && !c.done && (n = a.return) && n.call(a);
            } finally {
              if (t) throw t.error;
            }
          }
          return r;
        })(e).current;
      return VX(a) ? [n.getStateNode(a)] : BX(IX(a).map(function (e) {
        return "deep" === t.history ? n.getFromRelativePath(e) : [n.states[e[0]]];
      }));
    }, Object.defineProperty(e.prototype, "stateIds", {
      get: function () {
        var e = this,
          t = BX(Object.keys(this.states).map(function (t) {
            return e.states[t].stateIds;
          }));
        return [this.id].concat(t);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "events", {
      get: function () {
        var e, t, n, r;
        if (this.__cache.events) return this.__cache.events;
        var o = this.states,
          i = new Set(this.ownEvents);
        if (o) try {
          for (var a = UW(Object.keys(o)), c = a.next(); !c.done; c = a.next()) {
            var s = o[c.value];
            if (s.states) try {
              for (var l = (n = void 0, UW(s.events)), u = l.next(); !u.done; u = l.next()) {
                var d = u.value;
                i.add("".concat(d));
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                u && !u.done && (r = l.return) && r.call(l);
              } finally {
                if (n) throw n.error;
              }
            }
          }
        } catch (t) {
          e = {
            error: t
          };
        } finally {
          try {
            c && !c.done && (t = a.return) && t.call(a);
          } finally {
            if (e) throw e.error;
          }
        }
        return this.__cache.events = Array.from(i);
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "ownEvents", {
      get: function () {
        var e = new Set(this.transitions.filter(function (e) {
          return !(!e.target && !e.actions.length && e.internal);
        }).map(function (e) {
          return e.eventType;
        }));
        return Array.from(e);
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolveTarget = function (e) {
      var t = this;
      if (void 0 !== e) return e.map(function (e) {
        if (!VX(e)) return e;
        var n = e[0] === t.delimiter;
        if (n && !t.parent) return t.getStateNodeByPath(e.slice(1));
        var r = n ? t.key + e : e;
        if (!t.parent) return t.getStateNodeByPath(r);
        try {
          return t.parent.getStateNodeByPath(r);
        } catch (e) {
          throw new Error("Invalid transition definition for state node '".concat(t.id, "':\n").concat(e.message));
        }
      });
    }, e.prototype.formatTransition = function (e) {
      var t = this,
        n = function (e) {
          if (void 0 !== e && "" !== e) return wX(e);
        }(e.target),
        r = "internal" in e ? e.internal : !n || n.some(function (e) {
          return VX(e) && e[0] === t.delimiter;
        }),
        o = this.machine.options.guards,
        i = this.resolveTarget(n),
        a = WW(WW({}, e), {
          actions: KX(wX(e.actions)),
          cond: LX(e.cond, o),
          target: i,
          source: this,
          internal: r,
          eventType: e.event,
          toJSON: function () {
            return WW(WW({}, a), {
              target: a.target ? a.target.map(function (e) {
                return "#".concat(e.id);
              }) : void 0,
              source: "#".concat(t.id)
            });
          }
        });
      return a;
    }, e.prototype.formatTransitions = function () {
      var e,
        t,
        n,
        r = this;
      if (this.config.on) {
        if (Array.isArray(this.config.on)) n = this.config.on;else {
          var o = this.config.on,
            i = "*",
            a = o[i],
            c = void 0 === a ? [] : a,
            s = XW(o, ["*"]);
          n = BX(Object.keys(s).map(function (e) {
            mX || "" !== e || kX(!1, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(r.id, '".'));
            var t = RX(e, s[e]);
            return mX || function (e, t, n) {
              var r = n.slice(0, -1).some(function (e) {
                  return !("cond" in e) && !("in" in e) && (VX(e.target) || OX(e.target));
                }),
                o = "" === t ? "the transient event" : "event '".concat(t, "'");
              kX(!r, "One or more transitions for ".concat(o, " on state '").concat(e.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
            }(r, e, t), t;
          }).concat(RX("*", c)));
        }
      } else n = [];
      var l = this.config.always ? RX("", this.config.always) : [],
        u = this.config.onDone ? RX(String(qX(this.id)), this.config.onDone) : [];
      mX || kX(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
      var d = BX(this.invoke.map(function (e) {
          var t = [];
          return e.onDone && t.push.apply(t, YW([], KW(RX(String(_X(e.id)), e.onDone)), !1)), e.onError && t.push.apply(t, YW([], KW(RX(String($X(e.id)), e.onError)), !1)), t;
        })),
        f = this.after,
        p = BX(YW(YW(YW(YW([], KW(u), !1), KW(d), !1), KW(n), !1), KW(l), !1).map(function (e) {
          return wX(e).map(function (e) {
            return r.formatTransition(e);
          });
        }));
      try {
        for (var m = UW(f), h = m.next(); !h.done; h = m.next()) {
          var A = h.value;
          p.push(A);
        }
      } catch (t) {
        e = {
          error: t
        };
      } finally {
        try {
          h && !h.done && (t = m.return) && t.call(m);
        } finally {
          if (e) throw e.error;
        }
      }
      return p;
    }, e;
  }();
var OU,
  TU = function (e) {
    return {
      type: rX,
      assignment: e
    };
  };
!function (e) {
  e[e.Effect = 1] = "Effect", e[e.LayoutEffect = 2] = "LayoutEffect";
}(OU || (OU = {}));
var DU = "undefined" != typeof document ? p : r;
function RU(t) {
  var n = e.useRef();
  return n.current || (n.current = {
    v: t()
  }), n.current.v;
}
var GU = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r,
      o,
      i = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (n = i.return) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }
    return a;
  },
  FU = function (e) {
    var t = "function" == typeof Symbol && Symbol.iterator,
      n = t && e[t],
      r = 0;
    if (n) return n.call(e);
    if (e && "number" == typeof e.length) return {
      next: function () {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
    throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
  };
var jU = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r,
      o,
      i = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (n = i.return) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }
    return a;
  },
  JU = function (e, t, n) {
    if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
    return e.concat(r || Array.prototype.slice.call(t));
  };
function ZU(e, t) {
  (0, e.exec)(t.context, t._event.data, {
    action: e,
    state: t,
    _event: t._event
  })();
}
function WU(e) {
  var t = o([]),
    n = o([]);
  DU(function () {
    var r = e.subscribe(function (e) {
      var r, o;
      if (e.actions.length) {
        var i = e.actions.filter(function (e) {
            return "function" == typeof e.exec && "__effect" in e.exec;
          }),
          a = jU(function (e, t) {
            var n,
              r,
              o = GU([[], []], 2),
              i = o[0],
              a = o[1];
            try {
              for (var c = FU(e), s = c.next(); !s.done; s = c.next()) {
                var l = s.value;
                t(l) ? i.push(l) : a.push(l);
              }
            } catch (e) {
              n = {
                error: e
              };
            } finally {
              try {
                s && !s.done && (r = c.return) && r.call(c);
              } finally {
                if (n) throw n.error;
              }
            }
            return [i, a];
          }(i, function (e) {
            return e.exec.__effect === OU.Effect;
          }), 2),
          c = a[0],
          s = a[1];
        (r = t.current).push.apply(r, JU([], jU(c.map(function (t) {
          return [t, e];
        })), !1)), (o = n.current).push.apply(o, JU([], jU(s.map(function (t) {
          return [t, e];
        })), !1));
      }
    });
    return function () {
      r.unsubscribe();
    };
  }, []), DU(function () {
    for (; n.current.length;) {
      var e = jU(n.current.shift(), 2);
      ZU(e[0], e[1]);
    }
  }), r(function () {
    for (; t.current.length;) {
      var e = jU(t.current.shift(), 2);
      ZU(e[0], e[1]);
    }
  });
}
var XU = function () {
    return XU = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
      return e;
    }, XU.apply(this, arguments);
  },
  UU = function (e, t) {
    var n = {};
    for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;
      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
    }
    return n;
  },
  KU = function (e, t) {
    var n = "function" == typeof Symbol && e[Symbol.iterator];
    if (!n) return e;
    var r,
      o,
      i = n.call(e),
      a = [];
    try {
      for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
    } catch (e) {
      o = {
        error: e
      };
    } finally {
      try {
        r && !r.done && (n = i.return) && n.call(i);
      } finally {
        if (o) throw o.error;
      }
    }
    return a;
  };
var YU = function (e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
    o,
    i = n.call(e),
    a = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) a.push(r.value);
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return a;
};
function qU(e, t) {
  void 0 === t && (t = {});
  var r = l(function (e) {
      var t = void 0 === e.changed && Object.keys(e.children).length;
      (e.changed || t) && c(e);
    }, []),
    o = function (e, t, r) {
      void 0 === t && (t = {});
      var o = RU(function () {
        return "function" == typeof e ? e() : e;
      });
      if ("production" !== process.env.NODE_ENV && "function" != typeof e) {
        var i = KU(n(o), 1)[0];
        e !== i && console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
      }
      var a = t.context,
        c = t.guards,
        s = t.actions,
        l = t.activities,
        u = t.services,
        d = t.delays,
        f = t.state,
        p = UU(t, ["context", "guards", "actions", "activities", "services", "delays", "state"]),
        m = RU(function () {
          var e = {
            context: a,
            guards: c,
            actions: s,
            activities: l,
            services: u,
            delays: d
          };
          return kU(o.withConfig(e, function () {
            return XU(XU({}, o.context), a);
          }), XU({
            deferEvents: !0
          }, p));
        });
      return DU(function () {
        var e;
        return r && (e = m.subscribe(function (e, t, n) {
          if ("object" == typeof e) return e;
          var r = function () {};
          return {
            next: e,
            error: void 0 || r,
            complete: void 0 || r
          };
        }(r))), function () {
          null == e || e.unsubscribe();
        };
      }, [r]), DU(function () {
        return m.start(f ? AU.create(f) : void 0), function () {
          m.stop();
        };
      }, []), DU(function () {
        Object.assign(m.machine.options.actions, s), Object.assign(m.machine.options.guards, c), Object.assign(m.machine.options.activities, l), Object.assign(m.machine.options.services, u), Object.assign(m.machine.options.delays, d);
      }, [s, c, l, u, d]), WU(m), m;
    }(e, t, r),
    i = YU(n(function () {
      var e = o.machine.initialState;
      return t.state ? AU.create(t.state) : e;
    }), 2),
    a = i[0],
    c = i[1];
  return [a, o.send, o];
}
const _U = {
  arr: Array.isArray,
  obj: e => "[object Object]" === Object.prototype.toString.call(e),
  fun: e => "function" == typeof e,
  str: e => "string" == typeof e,
  num: e => "number" == typeof e,
  und: e => void 0 === e,
  nul: e => null === e,
  set: e => e instanceof Set,
  map: e => e instanceof Map,
  equ(e, t) {
    if (typeof e != typeof t) return !1;
    if (_U.str(e) || _U.num(e)) return e === t;
    if (_U.obj(e) && _U.obj(t) && Object.keys(e).length + Object.keys(t).length === 0) return !0;
    let n;
    for (n in e) if (!(n in t)) return !1;
    for (n in t) if (e[n] !== t[n]) return !1;
    return !_U.und(n) || e === t;
  }
};
function $U(e, t) {
  return _U.und(e) || _U.nul(e) ? t : e;
}
function eK(e) {
  return _U.und(e) ? [] : _U.arr(e) ? e : [e];
}
function tK(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
  return _U.fun(e) ? e(...n) : e;
}
function nK(e) {
  const t = function (e) {
    return e.to, e.from, e.config, e.onStart, e.onRest, e.onFrame, e.children, e.reset, e.reverse, e.force, e.immediate, e.delay, e.attach, e.destroyed, e.interpolateTo, e.ref, e.lazy, GQ(e, ["to", "from", "config", "onStart", "onRest", "onFrame", "children", "reset", "reverse", "force", "immediate", "delay", "attach", "destroyed", "interpolateTo", "ref", "lazy"]);
  }(e);
  if (_U.und(t)) return mx({
    to: t
  }, e);
  const n = Object.keys(e).reduce((n, r) => _U.und(t[r]) ? mx({}, n, {
    [r]: e[r]
  }) : n, {});
  return mx({
    to: t
  }, n);
}
class rK {
  constructor() {
    this.payload = void 0, this.children = [];
  }
  getAnimatedValue() {
    return this.getValue();
  }
  getPayload() {
    return this.payload || this;
  }
  attach() {}
  detach() {}
  getChildren() {
    return this.children;
  }
  addChild(e) {
    0 === this.children.length && this.attach(), this.children.push(e);
  }
  removeChild(e) {
    const t = this.children.indexOf(e);
    this.children.splice(t, 1), 0 === this.children.length && this.detach();
  }
}
class oK extends rK {
  constructor() {
    super(...arguments), this.payload = [], this.attach = () => this.payload.forEach(e => e instanceof rK && e.addChild(this)), this.detach = () => this.payload.forEach(e => e instanceof rK && e.removeChild(this));
  }
}
class iK extends rK {
  constructor() {
    super(...arguments), this.payload = {}, this.attach = () => Object.values(this.payload).forEach(e => e instanceof rK && e.addChild(this)), this.detach = () => Object.values(this.payload).forEach(e => e instanceof rK && e.removeChild(this));
  }
  getValue(e) {
    void 0 === e && (e = !1);
    const t = {};
    for (const n in this.payload) {
      const r = this.payload[n];
      (!e || r instanceof rK) && (t[n] = r instanceof rK ? r[e ? "getAnimatedValue" : "getValue"]() : r);
    }
    return t;
  }
  getAnimatedValue() {
    return this.getValue(!0);
  }
}
let aK, cK;
let sK,
  lK = e => "undefined" != typeof window ? window.requestAnimationFrame(e) : -1;
let uK,
  dK = () => Date.now();
class fK extends iK {
  constructor(e, t) {
    super(), this.update = void 0, this.payload = e.style ? mx({}, e, {
      style: uK(e.style)
    }) : e, this.update = t, this.attach();
  }
}
let pK = !1;
const mK = new Set(),
  hK = () => {
    if (!pK) return !1;
    let e = dK();
    for (let t of mK) {
      let n = !1;
      for (let r = 0; r < t.configs.length; r++) {
        let o,
          i,
          a = t.configs[r];
        for (let t = 0; t < a.animatedValues.length; t++) {
          let r = a.animatedValues[t];
          if (r.done) continue;
          let c = a.fromValues[t],
            s = a.toValues[t],
            l = r.lastPosition,
            u = s instanceof rK,
            d = Array.isArray(a.initialVelocity) ? a.initialVelocity[t] : a.initialVelocity;
          if (u && (s = s.getValue()), a.immediate) r.setValue(s), r.done = !0;else if ("string" != typeof c && "string" != typeof s) {
            if (void 0 !== a.duration) l = c + a.easing((e - r.startTime) / a.duration) * (s - c), o = e >= r.startTime + a.duration;else if (a.decay) l = c + d / (1 - .998) * (1 - Math.exp(-(1 - .998) * (e - r.startTime))), o = Math.abs(r.lastPosition - l) < .1, o && (s = l);else {
              i = void 0 !== r.lastTime ? r.lastTime : e, d = void 0 !== r.lastVelocity ? r.lastVelocity : a.initialVelocity, e > i + 64 && (i = e);
              let t = Math.floor(e - i);
              for (let e = 0; e < t; ++e) {
                d += 1 * ((-a.tension * (l - s) + -a.friction * d) / a.mass) / 1e3, l += 1 * d / 1e3;
              }
              let n = !(!a.clamp || 0 === a.tension) && (c < s ? l > s : l < s),
                u = Math.abs(d) <= a.precision,
                f = 0 === a.tension || Math.abs(s - l) <= a.precision;
              o = n || u && f, r.lastVelocity = d, r.lastTime = e;
            }
            u && !a.toValues[t].done && (o = !1), o ? (r.value !== s && (l = s), r.done = !0) : n = !0, r.setValue(l), r.lastPosition = l;
          } else r.setValue(s), r.done = !0;
        }
        t.props.onFrame && (t.values[a.name] = a.interpolation.getValue());
      }
      t.props.onFrame && t.props.onFrame(t.values), n || (mK.delete(t), t.stop(!0));
    }
    return mK.size ? lK(hK) : pK = !1, pK;
  };
function AK(e, t, n) {
  if ("function" == typeof e) return e;
  if (Array.isArray(e)) return AK({
    range: e,
    output: t,
    extrapolate: n
  });
  if (sK && "string" == typeof e.output[0]) return sK(e);
  const r = e,
    o = r.output,
    i = r.range || [0, 1],
    a = r.extrapolateLeft || r.extrapolate || "extend",
    c = r.extrapolateRight || r.extrapolate || "extend",
    s = r.easing || (e => e);
  return e => {
    const t = function (e, t) {
      for (var n = 1; n < t.length - 1 && !(t[n] >= e); ++n);
      return n - 1;
    }(e, i);
    return function (e, t, n, r, o, i, a, c, s) {
      let l = s ? s(e) : e;
      if (l < t) {
        if ("identity" === a) return l;
        "clamp" === a && (l = t);
      }
      if (l > n) {
        if ("identity" === c) return l;
        "clamp" === c && (l = n);
      }
      if (r === o) return r;
      if (t === n) return e <= t ? r : o;
      t === -1 / 0 ? l = -l : n === 1 / 0 ? l -= t : l = (l - t) / (n - t);
      l = i(l), r === -1 / 0 ? l = -l : o === 1 / 0 ? l += r : l = l * (o - r) + r;
      return l;
    }(e, i[t], i[t + 1], o[t], o[t + 1], s, a, c, r.map);
  };
}
class gK extends oK {
  constructor(e, t, n, r) {
    super(), this.calc = void 0, this.payload = e instanceof oK && !(e instanceof gK) ? e.getPayload() : Array.isArray(e) ? e : [e], this.calc = AK(t, n, r);
  }
  getValue() {
    return this.calc(...this.payload.map(e => e.getValue()));
  }
  updateConfig(e, t, n) {
    this.calc = AK(e, t, n);
  }
  interpolate(e, t, n) {
    return new gK(this, e, t, n);
  }
}
const vK = (e, t, n) => e && new gK(e, t, n);
function CK(e, t) {
  "update" in e ? t.add(e) : e.getChildren().forEach(e => CK(e, t));
}
class bK extends rK {
  constructor(e) {
    var t;
    super(), t = this, this.animatedStyles = new Set(), this.value = void 0, this.startPosition = void 0, this.lastPosition = void 0, this.lastVelocity = void 0, this.startTime = void 0, this.lastTime = void 0, this.done = !1, this.setValue = function (e, n) {
      void 0 === n && (n = !0), t.value = e, n && t.flush();
    }, this.value = e, this.startPosition = e, this.lastPosition = e;
  }
  flush() {
    0 === this.animatedStyles.size && CK(this, this.animatedStyles), this.animatedStyles.forEach(e => e.update());
  }
  clearStyles() {
    this.animatedStyles.clear();
  }
  getValue() {
    return this.value;
  }
  interpolate(e, t, n) {
    return new gK(this, e, t, n);
  }
}
class EK extends oK {
  constructor(e) {
    super(), this.payload = e.map(e => new bK(e));
  }
  setValue(e, t) {
    void 0 === t && (t = !0), Array.isArray(e) ? e.length === this.payload.length && e.forEach((e, n) => this.payload[n].setValue(e, t)) : this.payload.forEach(n => n.setValue(e, t));
  }
  getValue() {
    return this.payload.map(e => e.getValue());
  }
  interpolate(e, t) {
    return new gK(this, e, t);
  }
}
let yK = 0;
class IK {
  constructor() {
    this.id = void 0, this.idle = !0, this.hasChanged = !1, this.guid = 0, this.local = 0, this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.values = {}, this.configs = [], this.listeners = [], this.queue = [], this.localQueue = void 0, this.getValues = () => this.interpolations, this.id = yK++;
  }
  update(e) {
    if (!e) return this;
    const t = nK(e),
      n = t.delay,
      r = void 0 === n ? 0 : n,
      o = t.to,
      i = GQ(t, ["delay", "to"]);
    if (_U.arr(o) || _U.fun(o)) this.queue.push(mx({}, i, {
      delay: r,
      to: o
    }));else if (o) {
      let e = {};
      Object.entries(o).forEach(t => {
        let n = t[0];
        const o = mx({
            to: {
              [n]: t[1]
            },
            delay: tK(r, n)
          }, i),
          a = e[o.delay] && e[o.delay].to;
        e[o.delay] = mx({}, e[o.delay], o, {
          to: mx({}, a, o.to)
        });
      }), this.queue = Object.values(e);
    }
    return this.queue = this.queue.sort((e, t) => e.delay - t.delay), this.diff(i), this;
  }
  start(e) {
    if (this.queue.length) {
      this.idle = !1, this.localQueue && this.localQueue.forEach(e => {
        let t = e.from,
          n = void 0 === t ? {} : t,
          r = e.to,
          o = void 0 === r ? {} : r;
        _U.obj(n) && (this.merged = mx({}, n, this.merged)), _U.obj(o) && (this.merged = mx({}, this.merged, o));
      });
      const t = this.local = ++this.guid,
        n = this.localQueue = this.queue;
      this.queue = [], n.forEach((r, o) => {
        let i = r.delay,
          a = GQ(r, ["delay"]);
        const c = r => {
          o === n.length - 1 && t === this.guid && r && (this.idle = !0, this.props.onRest && this.props.onRest(this.merged)), e && e();
        };
        let s = _U.arr(a.to) || _U.fun(a.to);
        i ? setTimeout(() => {
          t === this.guid && (s ? this.runAsync(a, c) : this.diff(a).start(c));
        }, i) : s ? this.runAsync(a, c) : this.diff(a).start(c);
      });
    } else _U.fun(e) && this.listeners.push(e), this.props.onStart && this.props.onStart(), t = this, mK.has(t) || mK.add(t), pK || (pK = !0, lK(hK));
    var t;
    return this;
  }
  stop(e) {
    return this.listeners.forEach(t => t(e)), this.listeners = [], this;
  }
  pause(e) {
    var t;
    return this.stop(!0), e && (t = this, mK.has(t) && mK.delete(t)), this;
  }
  runAsync(e, t) {
    var n = this;
    e.delay;
    let r = GQ(e, ["delay"]);
    const o = this.local;
    let i = Promise.resolve(void 0);
    if (_U.arr(r.to)) for (let e = 0; e < r.to.length; e++) {
      const t = e,
        n = mx({}, r, nK(r.to[t]));
      _U.arr(n.config) && (n.config = n.config[t]), i = i.then(() => {
        if (o === this.guid) return new Promise(e => this.diff(n).start(e));
      });
    } else if (_U.fun(r.to)) {
      let e,
        t = 0;
      i = i.then(() => r.to(n => {
        const i = mx({}, r, nK(n));
        if (_U.arr(i.config) && (i.config = i.config[t]), t++, o === this.guid) return e = new Promise(e => this.diff(i).start(e));
      }, function (e) {
        return void 0 === e && (e = !0), n.stop(e);
      }).then(() => e));
    }
    i.then(t);
  }
  diff(e) {
    this.props = mx({}, this.props, e);
    let t = this.props,
      n = t.from,
      r = void 0 === n ? {} : n,
      o = t.to,
      i = void 0 === o ? {} : o,
      a = t.config,
      c = void 0 === a ? {} : a,
      s = t.reverse,
      l = t.attach,
      u = t.reset,
      d = t.immediate;
    if (s) {
      var f = [i, r];
      r = f[0], i = f[1];
    }
    this.merged = mx({}, r, this.merged, i), this.hasChanged = !1;
    let p = l && l(this);
    if (this.animations = Object.entries(this.merged).reduce((e, t) => {
      let n = t[0],
        o = t[1],
        i = e[n] || {};
      const a = _U.num(o),
        s = _U.str(o) && !o.startsWith("#") && !/\d/.test(o) && !cK[o],
        l = _U.arr(o),
        f = !a && !l && !s;
      let m = _U.und(r[n]) ? o : r[n],
        h = a || l || s ? o : 1,
        A = tK(c, n);
      p && (h = p.animations[n].parent);
      let g,
        v = i.parent,
        C = i.interpolation,
        b = eK(p ? h.getPayload() : h),
        E = o;
      f && (E = sK({
        range: [0, 1],
        output: [o, o]
      })(1));
      let y = C && C.getValue();
      const I = !_U.und(v) && i.animatedValues.some(e => !e.done),
        B = !_U.equ(E, y),
        x = !_U.equ(E, i.previous),
        w = !_U.equ(A, i.config);
      if (u || x && B || w) {
        if (a || s) v = C = i.parent || new bK(m);else if (l) v = C = i.parent || new EK(m);else if (f) {
          let e = i.interpolation && i.interpolation.calc(i.parent.value);
          e = void 0 === e || u ? m : e, i.parent ? (v = i.parent, v.setValue(0, !1)) : v = new bK(0);
          const t = {
            output: [e, o]
          };
          i.interpolation ? (C = i.interpolation, i.interpolation.updateConfig(t)) : C = v.interpolate(t);
        }
        return b = eK(p ? h.getPayload() : h), g = eK(v.getPayload()), u && !f && v.setValue(m, !1), this.hasChanged = !0, g.forEach(e => {
          e.startPosition = e.value, e.lastPosition = e.value, e.lastVelocity = I ? e.lastVelocity : void 0, e.lastTime = I ? e.lastTime : void 0, e.startTime = dK(), e.done = !1, e.animatedStyles.clear();
        }), tK(d, n) && v.setValue(f ? h : o, !1), mx({}, e, {
          [n]: mx({}, i, {
            name: n,
            parent: v,
            interpolation: C,
            animatedValues: g,
            toValues: b,
            previous: E,
            config: A,
            fromValues: eK(v.getValue()),
            immediate: tK(d, n),
            initialVelocity: $U(A.velocity, 0),
            clamp: $U(A.clamp, !1),
            precision: $U(A.precision, .01),
            tension: $U(A.tension, 170),
            friction: $U(A.friction, 26),
            mass: $U(A.mass, 1),
            duration: A.duration,
            easing: $U(A.easing, e => e),
            decay: A.decay
          })
        });
      }
      return B ? e : (f && (v.setValue(1, !1), C.updateConfig({
        output: [E, E]
      })), v.done = !0, this.hasChanged = !0, mx({}, e, {
        [n]: mx({}, e[n], {
          previous: E
        })
      }));
    }, this.animations), this.hasChanged) {
      this.configs = Object.values(this.animations), this.values = {}, this.interpolations = {};
      for (let e in this.animations) this.interpolations[e] = this.animations[e].interpolation, this.values[e] = this.animations[e].interpolation.getValue();
    }
    return this;
  }
  destroy() {
    this.stop(), this.props = {}, this.merged = {}, this.animations = {}, this.interpolations = {}, this.values = {}, this.configs = [], this.local = 0;
  }
}
const BK = e => {
  const t = _U.fun(e),
    n = ((e, t) => {
      const n = o(!1),
        i = o(),
        a = _U.fun(t),
        c = s(() => {
          let n;
          return i.current && (i.current.map(e => e.destroy()), i.current = void 0), [new Array(e).fill().map((e, r) => {
            const o = new IK(),
              i = a ? tK(t, r, o) : t[r];
            return 0 === r && (n = i.ref), o.update(i), n || o.start(), o;
          }), n];
        }, [e]),
        l = c[0],
        u = c[1];
      i.current = l, h(u, () => ({
        start: () => Promise.all(i.current.map(e => new Promise(t => e.start(t)))),
        stop: e => i.current.forEach(t => t.stop(e)),
        get controllers() {
          return i.current;
        }
      }));
      const d = s(() => e => i.current.map((t, n) => {
        t.update(a ? tK(e, n, t) : e[n]), u || t.start();
      }), [e]);
      r(() => {
        n.current ? a || d(t) : u || i.current.forEach(e => e.start());
      }), r(() => (n.current = !0, () => i.current.forEach(e => e.destroy())), []);
      const f = i.current.map(e => e.getValues());
      return a ? [f, d, e => i.current.forEach(t => t.pause(e))] : f;
    })(1, t ? e : [e]),
    i = n[0],
    a = n[1],
    c = n[2];
  return t ? [i[0], a, c] : i;
};
class xK extends iK {
  constructor(e) {
    void 0 === e && (e = {}), super(), !e.transform || e.transform instanceof rK || (e = aK.transform(e)), this.payload = e;
  }
}
const wK = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
  },
  QK = "[-+]?\\d*\\.?\\d+";
function HK() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return "\\(\\s*(" + t.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const zK = new RegExp("rgb" + HK(QK, QK, QK)),
  MK = new RegExp("rgba" + HK(QK, QK, QK, QK)),
  kK = new RegExp("hsl" + HK(QK, "[-+]?\\d*\\.?\\d+%", "[-+]?\\d*\\.?\\d+%")),
  NK = new RegExp("hsla" + HK(QK, "[-+]?\\d*\\.?\\d+%", "[-+]?\\d*\\.?\\d+%", QK)),
  SK = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  VK = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  LK = /^#([0-9a-fA-F]{6})$/,
  PK = /^#([0-9a-fA-F]{8})$/;
function OK(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + 6 * (t - e) * n : n < .5 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function TK(e, t, n) {
  const r = n < .5 ? n * (1 + t) : n + t - n * t,
    o = 2 * n - r,
    i = OK(o, r, e + 1 / 3),
    a = OK(o, r, e),
    c = OK(o, r, e - 1 / 3);
  return Math.round(255 * i) << 24 | Math.round(255 * a) << 16 | Math.round(255 * c) << 8;
}
function DK(e) {
  const t = parseInt(e, 10);
  return t < 0 ? 0 : t > 255 ? 255 : t;
}
function RK(e) {
  return (parseFloat(e) % 360 + 360) % 360 / 360;
}
function GK(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 1 ? 255 : Math.round(255 * t);
}
function FK(e) {
  const t = parseFloat(e);
  return t < 0 ? 0 : t > 100 ? 1 : t / 100;
}
function jK(e) {
  let t = function (e) {
    let t;
    return "number" == typeof e ? e >>> 0 === e && e >= 0 && e <= 4294967295 ? e : null : (t = LK.exec(e)) ? parseInt(t[1] + "ff", 16) >>> 0 : wK.hasOwnProperty(e) ? wK[e] : (t = zK.exec(e)) ? (DK(t[1]) << 24 | DK(t[2]) << 16 | DK(t[3]) << 8 | 255) >>> 0 : (t = MK.exec(e)) ? (DK(t[1]) << 24 | DK(t[2]) << 16 | DK(t[3]) << 8 | GK(t[4])) >>> 0 : (t = SK.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + "ff", 16) >>> 0 : (t = PK.exec(e)) ? parseInt(t[1], 16) >>> 0 : (t = VK.exec(e)) ? parseInt(t[1] + t[1] + t[2] + t[2] + t[3] + t[3] + t[4] + t[4], 16) >>> 0 : (t = kK.exec(e)) ? (255 | TK(RK(t[1]), FK(t[2]), FK(t[3]))) >>> 0 : (t = NK.exec(e)) ? (TK(RK(t[1]), FK(t[2]), FK(t[3])) | GK(t[4])) >>> 0 : null;
  }(e);
  return null === t ? e : (t = t || 0, `rgba(${(4278190080 & t) >>> 24}, ${(16711680 & t) >>> 16}, ${(65280 & t) >>> 8}, ${(255 & t) / 255})`);
}
const JK = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
  ZK = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi,
  WK = new RegExp(`(${Object.keys(wK).join("|")})`, "g");
let XK = {
  animationIterationCount: !0,
  borderImageOutset: !0,
  borderImageSlice: !0,
  borderImageWidth: !0,
  boxFlex: !0,
  boxFlexGroup: !0,
  boxOrdinalGroup: !0,
  columnCount: !0,
  columns: !0,
  flex: !0,
  flexGrow: !0,
  flexPositive: !0,
  flexShrink: !0,
  flexNegative: !0,
  flexOrder: !0,
  gridRow: !0,
  gridRowEnd: !0,
  gridRowSpan: !0,
  gridRowStart: !0,
  gridColumn: !0,
  gridColumnEnd: !0,
  gridColumnSpan: !0,
  gridColumnStart: !0,
  fontWeight: !0,
  lineClamp: !0,
  lineHeight: !0,
  opacity: !0,
  order: !0,
  orphans: !0,
  tabSize: !0,
  widows: !0,
  zIndex: !0,
  zoom: !0,
  fillOpacity: !0,
  floodOpacity: !0,
  stopOpacity: !0,
  strokeDasharray: !0,
  strokeDashoffset: !0,
  strokeMiterlimit: !0,
  strokeOpacity: !0,
  strokeWidth: !0
};
const UK = ["Webkit", "Ms", "Moz", "O"];
function KK(e, t, n) {
  return null == t || "boolean" == typeof t || "" === t ? "" : n || "number" != typeof t || 0 === t || XK.hasOwnProperty(e) && XK[e] ? ("" + t).trim() : t + "px";
}
XK = Object.keys(XK).reduce((e, t) => (UK.forEach(n => e[((e, t) => e + t.charAt(0).toUpperCase() + t.substring(1))(n, t)] = e[t]), e), XK);
const YK = {};
var qK, _K;
qK = e => new xK(e), uK = qK, _K = e => {
  const t = e.output.map(e => e.replace(ZK, jK)).map(e => e.replace(WK, jK)),
    n = t[0].match(JK).map(() => []);
  t.forEach(e => {
    e.match(JK).forEach((e, t) => n[t].push(+e));
  });
  const r = t[0].match(JK).map((t, r) => AK(mx({}, e, {
    output: n[r]
  })));
  return e => {
    let n = 0;
    return t[0].replace(JK, () => r[n++](e)).replace(/rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi, (e, t, n, r, o) => `rgba(${Math.round(t)}, ${Math.round(n)}, ${Math.round(r)}, ${o})`);
  };
}, sK = _K, cK = wK, function (e, t) {
  aK = {
    fn: e,
    transform: t
  };
}((e, t) => {
  if (!e.nodeType || void 0 === e.setAttribute) return !1;
  {
    const o = t.style,
      i = t.children,
      a = t.scrollTop,
      c = t.scrollLeft,
      s = GQ(t, ["style", "children", "scrollTop", "scrollLeft"]),
      l = "filter" === e.nodeName || e.parentNode && "filter" === e.parentNode.nodeName;
    void 0 !== a && (e.scrollTop = a), void 0 !== c && (e.scrollLeft = c), void 0 !== i && (e.textContent = i);
    for (let t in o) if (o.hasOwnProperty(t)) {
      var n = 0 === t.indexOf("--"),
        r = KK(t, o[t], n);
      "float" === t && (t = "cssFloat"), n ? e.style.setProperty(t, r) : e.style[t] = r;
    }
    for (let t in s) {
      const n = l ? t : YK[t] || (YK[t] = t.replace(/([A-Z])/g, e => "-" + e.toLowerCase()));
      void 0 !== e.getAttribute(n) && e.setAttribute(n, s[t]);
    }
  }
}, e => e);
const $K = (eY = e => {
  const i = /*#__PURE__*/c((i, a) => {
    const c = function () {
        const e = n(!1)[1],
          t = l(() => e(e => !e), []);
        return t;
      }(),
      s = o(!0),
      u = o(null),
      d = o(null),
      f = l(e => {
        const t = u.current;
        u.current = new fK(e, () => {
          let e = !1;
          d.current && (e = aK.fn(d.current, u.current.getAnimatedValue())), d.current && !1 !== e || c();
        }), t && t.detach();
      }, []);
    r(() => () => {
      s.current = !1, u.current && u.current.detach();
    }, []), h(a, () => (e => e.current)(d)), f(i);
    const p = u.current.getValue();
    p.scrollTop, p.scrollLeft;
    const m = GQ(p, ["scrollTop", "scrollLeft"]),
      A = (g = e, !_U.fun(g) || g.prototype instanceof t.Component ? e => d.current = function (e, t) {
        return t && (_U.fun(t) ? t(e) : _U.obj(t) && (t.current = e)), e;
      }(e, a) : void 0);
    var g;
    return /*#__PURE__*/t.createElement(e, mx({}, m, {
      ref: A
    }));
  });
  return i;
}, void 0 === (tY = !1) && (tY = !0), e => (_U.arr(e) ? e : Object.keys(e)).reduce((e, t) => {
  const n = tY ? t[0].toLowerCase() + t.substring(1) : t;
  return e[n] = eY(n), e;
}, eY));
var eY, tY;
const nY = $K(["a", "abbr", "address", "area", "article", "aside", "audio", "b", "base", "bdi", "bdo", "big", "blockquote", "body", "br", "button", "canvas", "caption", "cite", "code", "col", "colgroup", "data", "datalist", "dd", "del", "details", "dfn", "dialog", "div", "dl", "dt", "em", "embed", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "iframe", "img", "input", "ins", "kbd", "keygen", "label", "legend", "li", "link", "main", "map", "mark", "menu", "menuitem", "meta", "meter", "nav", "noscript", "object", "ol", "optgroup", "option", "output", "p", "param", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "script", "section", "select", "small", "source", "span", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "textarea", "tfoot", "th", "thead", "time", "title", "tr", "track", "u", "ul", "var", "video", "wbr", "circle", "clipPath", "defs", "ellipse", "foreignObject", "g", "image", "line", "linearGradient", "mask", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "stop", "svg", "text", "tspan"]);
function rY(e, t) {
  return e.map(function (e, n) {
    return e + t[n];
  });
}
function oY(e, t) {
  return e.map(function (e, n) {
    return e - t[n];
  });
}
function iY(e) {
  return Math.hypot.apply(Math, e);
}
function aY(e) {
  return Math.sign ? Math.sign(e) : Number(e > 0) - Number(e < 0) || +e;
}
function cY(e, t, n) {
  return 0 === t || Math.abs(t) === 1 / 0 ? function (e, t) {
    return Math.pow(e, 5 * t);
  }(e, n) : e * t * n / (t + n * e);
}
function sY(e, t, n, r) {
  return void 0 === r && (r = .15), 0 === r ? function (e, t, n) {
    return Math.max(t, Math.min(e, n));
  }(e, t, n) : e < t ? -cY(t - e, n - t, r) + t : e > n ? +cY(e - n, n - t, r) + n : e;
}
function lY(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function uY() {
  return uY = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, uY.apply(this, arguments);
}
function dY(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e.__proto__ = t;
}
function fY(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pY(e, t) {
  (null == t || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function mY(e, t) {
  var n;
  if ("undefined" == typeof Symbol || null == e[Symbol.iterator]) {
    if (Array.isArray(e) || (n = function (e, t) {
      if (e) {
        if ("string" == typeof e) return pY(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? pY(e, t) : void 0;
      }
    }(e)) || t && e && "number" == typeof e.length) {
      n && (e = n);
      var r = 0;
      return function () {
        return r >= e.length ? {
          done: !0
        } : {
          done: !1,
          value: e[r++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  return (n = e[Symbol.iterator]()).next.bind(n);
}
function hY() {}
function AY() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
  return 0 === t.length ? hY : 1 === t.length ? t[0] : function () {
    for (var e, n, r = mY(t); !(n = r()).done;) {
      var o = n.value;
      e = o.apply(this, arguments) || e;
    }
    return e;
  };
}
function gY(e, t) {
  if (void 0 === e) {
    if (void 0 === t) throw new Error("Must define fallback value if undefined is expected");
    e = t;
  }
  return Array.isArray(e) ? e : [e, e];
}
function vY(e) {
  if ("function" == typeof e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
    return e.apply(void 0, n);
  }
  return e;
}
function CY(e, t) {
  void 0 === e && (e = {});
  for (var n = {}, r = 0, o = Object.entries(t); r < o.length; r++) {
    var i = o[r],
      a = i[0],
      c = i[1];
    switch (typeof c) {
      case "function":
        n[a] = c.call(n, e[a], a, e);
        break;
      case "object":
        n[a] = CY(e[a], c);
        break;
      case "boolean":
        c && (n[a] = e[a]);
    }
  }
  return n;
}
var bY = uY({}, {
    threshold: function (e) {
      return void 0 === e && (e = 0), gY(e);
    },
    rubberband: function (e) {
      switch (void 0 === e && (e = 0), e) {
        case !0:
          return gY(.15);
        case !1:
          return gY(0);
        default:
          return gY(e);
      }
    },
    enabled: function (e) {
      return void 0 === e && (e = !0), e;
    },
    triggerAllEvents: function (e) {
      return void 0 === e && (e = !1), e;
    },
    initial: function (e) {
      return void 0 === e && (e = 0), "function" == typeof e ? e : gY(e);
    }
  }, {
    axis: !0,
    lockDirection: function (e) {
      return void 0 === e && (e = !1), e;
    },
    bounds: function (e) {
      if (void 0 === e && (e = {}), "function" == typeof e) return function (t) {
        return bY.bounds(e(t));
      };
      var t = e,
        n = t.left,
        r = void 0 === n ? -1 / 0 : n,
        o = t.right,
        i = void 0 === o ? 1 / 0 : o,
        a = t.top,
        c = void 0 === a ? -1 / 0 : a,
        s = t.bottom;
      return [[r, i], [c, void 0 === s ? 1 / 0 : s]];
    }
  }),
  EY = "undefined" != typeof window && window.document && window.document.createElement,
  yY = {
    enabled: function (e) {
      return void 0 === e && (e = !0), e;
    },
    domTarget: !0,
    window: function (e) {
      function t(t) {
        return e.apply(this, arguments);
      }
      return t.toString = function () {
        return e.toString();
      }, t;
    }(function (e) {
      return void 0 === e && (e = EY ? window : void 0), e;
    }),
    eventOptions: function (e) {
      var t = void 0 === e ? {} : e,
        n = t.passive,
        r = void 0 === n || n,
        o = t.capture;
      return {
        passive: r,
        capture: void 0 !== o && o
      };
    }
  },
  IY = uY({}, bY, {
    threshold: function (e, t, n) {
      var r = n.filterTaps,
        o = void 0 !== r && r,
        i = n.lockDirection,
        a = void 0 !== i && i,
        c = n.axis,
        s = gY(e, o ? 3 : a || (void 0 === c ? void 0 : c) ? 1 : 0);
      return this.filterTaps = o || s[0] + s[1] > 0, s;
    },
    swipeVelocity: function (e) {
      return void 0 === e && (e = .5), gY(e);
    },
    swipeDistance: function (e) {
      return void 0 === e && (e = 60), gY(e);
    },
    delay: function (e) {
      switch (void 0 === e && (e = 0), e) {
        case !0:
          return 180;
        case !1:
          return 0;
        default:
          return e;
      }
    }
  });
function BY(e) {
  var t = e.domTarget,
    n = e.eventOptions,
    r = e.window,
    o = e.enabled,
    i = function (e, t) {
      if (null == e) return {};
      var n,
        r,
        o = {},
        i = Object.keys(e);
      for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      return o;
    }(e, ["domTarget", "eventOptions", "window", "enabled"]),
    a = function (e) {
      return void 0 === e && (e = {}), CY(e, yY);
    }({
      domTarget: t,
      eventOptions: n,
      window: r,
      enabled: o
    });
  return a.drag = function (e) {
    return void 0 === e && (e = {}), CY(e, IY);
  }(i), a;
}
function xY(e) {
  return uY({
    _active: !1,
    _blocked: !1,
    _intentional: [!1, !1],
    _movement: [0, 0],
    _initial: [0, 0],
    _bounds: [[-1 / 0, 1 / 0], [-1 / 0, 1 / 0]],
    _lastEventType: void 0,
    event: void 0,
    intentional: !1,
    values: [0, 0],
    velocities: [0, 0],
    delta: [0, 0],
    movement: [0, 0],
    offset: [0, 0],
    lastOffset: [0, 0],
    direction: [0, 0],
    initial: [0, 0],
    previous: [0, 0],
    first: !1,
    last: !1,
    active: !1,
    timeStamp: 0,
    startTime: 0,
    elapsedTime: 0,
    cancel: hY,
    canceled: !1,
    memo: void 0,
    args: void 0
  }, e);
}
function wY() {
  return {
    shared: {
      hovering: !1,
      scrolling: !1,
      wheeling: !1,
      dragging: !1,
      moving: !1,
      pinching: !1,
      touches: 0,
      buttons: 0,
      down: !1,
      shiftKey: !1,
      altKey: !1,
      metaKey: !1,
      ctrlKey: !1
    },
    drag: xY({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0,
      _isTap: !0,
      _delayedEvent: !1,
      _pointerId: void 0,
      tap: !1,
      swipe: [0, 0]
    }),
    pinch: xY({
      da: [0, 0],
      vdva: [0, 0],
      origin: void 0,
      turns: 0
    }),
    wheel: xY({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0
    }),
    move: xY({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0
    }),
    scroll: xY({
      axis: void 0,
      xy: [0, 0],
      vxvy: [0, 0],
      velocity: 0,
      distance: 0
    })
  };
}
var QY = new Map(),
  HY = function () {
    function e(e, t) {
      var n = this;
      void 0 === t && (t = []), this.controller = e, this.args = t, this.debounced = !0, this.setTimeout = function (e, t) {
        var r;
        void 0 === t && (t = 140), clearTimeout(n.controller.timeouts[n.stateKey]);
        for (var o = arguments.length, i = new Array(o > 2 ? o - 2 : 0), a = 2; a < o; a++) i[a - 2] = arguments[a];
        n.controller.timeouts[n.stateKey] = (r = window).setTimeout.apply(r, [e, t].concat(i));
      }, this.clearTimeout = function () {
        clearTimeout(n.controller.timeouts[n.stateKey]);
      }, this.fireGestureHandler = function (e) {
        if (void 0 === e && (e = !1), n.state._blocked) return n.debounced || (n.state._active = !1, n.clean()), null;
        if (!e && !n.state.intentional && !n.config.triggerAllEvents) return null;
        if (n.state.intentional) {
          var t = n.state.active,
            r = n.state._active;
          n.state.active = r, n.state.first = r && !t, n.state.last = t && !r, n.controller.state.shared[n.ingKey] = r;
        }
        var o = uY({}, n.controller.state.shared, n.state, n.mapStateValues(n.state)),
          i = n.handler(o);
        return n.state.memo = void 0 !== i ? i : n.state.memo, n.state._active || n.clean(), o;
      };
    }
    var t,
      n,
      r,
      o = e.prototype;
    return o.updateSharedState = function (e) {
      Object.assign(this.controller.state.shared, e);
    }, o.updateGestureState = function (e) {
      Object.assign(this.state, e);
    }, o.checkIntentionality = function (e, t) {
      return {
        _intentional: e,
        _blocked: !1
      };
    }, o.getMovement = function (e) {
      var t = this.config,
        n = t.initial,
        r = t.bounds,
        o = t.rubberband,
        i = t.threshold,
        a = this.state,
        c = a._bounds,
        s = a._initial,
        l = a._active,
        u = a._intentional,
        d = a.lastOffset,
        f = a.movement,
        p = this.getInternalMovement(e, this.state),
        m = !1 === u[0] ? zY(p[0], i[0]) : u[0],
        h = !1 === u[1] ? zY(p[1], i[1]) : u[1],
        A = this.checkIntentionality([m, h], p);
      if (A._blocked) return uY({}, A, {
        _movement: p,
        delta: [0, 0]
      });
      var g,
        v,
        C,
        b,
        E = A._intentional,
        y = p;
      (!1 !== E[0] && !1 === u[0] && (v = vY(n, this.state), g = vY(r, this.state), s[0] = v[0], c[0] = g[0]), !1 !== E[1] && !1 === u[1]) && (v = null != (C = v) ? C : vY(n, this.state), g = null != (b = g) ? b : vY(r, this.state), s[1] = v[1], c[1] = g[1]);
      var I = [!1 !== E[0] ? p[0] - E[0] : s[0], !1 !== E[1] ? p[1] - E[1] : s[1]],
        B = rY(I, d),
        x = l ? o : [0, 0];
      return I = MY(c, rY(I, s), x), uY({}, A, {
        intentional: !1 !== E[0] || !1 !== E[1],
        _initial: s,
        _movement: y,
        movement: I,
        values: e,
        offset: MY(c, B, x),
        delta: oY(I, f)
      });
    }, o.clean = function () {
      this.clearTimeout();
    }, t = e, (n = [{
      key: "config",
      get: function () {
        return this.controller.config[this.stateKey];
      }
    }, {
      key: "enabled",
      get: function () {
        return this.controller.config.enabled && this.config.enabled;
      }
    }, {
      key: "state",
      get: function () {
        return this.controller.state[this.stateKey];
      }
    }, {
      key: "handler",
      get: function () {
        return this.controller.handlers[this.stateKey];
      }
    }]) && lY(t.prototype, n), r && lY(t, r), e;
  }();
function zY(e, t) {
  return Math.abs(e) >= t && aY(e) * t;
}
function MY(e, t, n) {
  var r = t[0],
    o = t[1],
    i = n[0],
    a = n[1],
    c = e[0],
    s = c[0],
    l = c[1],
    u = e[1],
    d = u[0],
    f = u[1];
  return [sY(r, s, l, i), sY(o, d, f, a)];
}
function kY(e, t, n) {
  var r = e.state,
    o = e.args,
    i = t.timeStamp,
    a = t.type,
    c = r.values;
  return {
    _lastEventType: a,
    event: t,
    timeStamp: i,
    elapsedTime: n ? 0 : i - r.startTime,
    args: o,
    previous: c
  };
}
function NY(e, t) {
  return function (n) {
    for (var r = arguments.length, o = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) o[i - 1] = arguments[i];
    return e.call.apply(e, [this, uY({}, t, {
      event: n
    })].concat(o));
  };
}
var SY = function (e) {
  var t = this;
  this.classes = e, this.bind = function () {
    for (var e = {}, n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
    for (var i, a = mY(t.classes); !(i = a()).done;) {
      var c = i.value;
      new c(t, r).addBindings(e);
    }
    for (var s = 0, l = Object.entries(t.nativeRefs); s < l.length; s++) {
      var u = l[s],
        d = u[0],
        f = u[1];
      RY(e, d, NY(f, uY({}, t.state.shared, {
        args: r
      })));
    }
    return t.config.domTarget ? PY(t, e) : OY(t, e);
  }, this.effect = function () {
    return t.config.domTarget && t.bind(), t.clean;
  }, this.clean = function () {
    var e = DY(t.config),
      n = t.config.eventOptions;
    e && FY(e, TY(t.domListeners), n), Object.values(t.timeouts).forEach(clearTimeout), function (e) {
      var t = e.config,
        n = t.window,
        r = t.eventOptions,
        o = e.windowListeners;
      if (!n) return;
      for (var i in o) {
        FY(n, o[i], r);
      }
      e.windowListeners = {};
    }(t);
  }, this.state = wY(), this.timeouts = {}, this.domListeners = [], this.windowListeners = {};
};
function VY(e, t) {
  var n = e.config,
    r = e.windowListeners;
  n.window && (FY(n.window, r[t], n.eventOptions), delete r[t]);
}
function LY(e, t, n) {
  var r = e.config,
    o = e.windowListeners;
  void 0 === n && (n = []), r.window && (FY(r.window, o[t], r.eventOptions), GY(r.window, o[t] = n, r.eventOptions));
}
function PY(e, t) {
  var n = e.config,
    r = e.domListeners,
    o = DY(n);
  if (!o) throw new Error("domTarget must be defined");
  var i = n.eventOptions;
  FY(o, TY(r), i);
  for (var a = 0, c = Object.entries(t); a < c.length; a++) {
    var s = c[a],
      l = s[0],
      u = s[1],
      d = l.slice(2).toLowerCase();
    r.push([d, AY.apply(void 0, u)]);
  }
  GY(o, r, i);
}
function OY(e, t) {
  for (var n = {}, r = e.config.eventOptions.capture ? "Capture" : "", o = 0, i = Object.entries(t); o < i.length; o++) {
    var a = i[o],
      c = a[0],
      s = a[1],
      l = Array.isArray(s) ? s : [s];
    n[c + r] = AY.apply(void 0, l);
  }
  return n;
}
function TY(e) {
  return void 0 === e && (e = []), e.splice(0, e.length);
}
function DY(e) {
  var t = e.domTarget;
  return t && "current" in t ? t.current : t;
}
function RY(e, t, n) {
  e[t] || (e[t] = []), e[t].push(n);
}
function GY(e, t, n) {
  void 0 === t && (t = []), void 0 === n && (n = {});
  for (var r, o = mY(t); !(r = o()).done;) {
    var i = r.value,
      a = i[0],
      c = i[1];
    e.addEventListener(a, c, n);
  }
}
function FY(e, t, n) {
  void 0 === t && (t = []), void 0 === n && (n = {});
  for (var r, o = mY(t); !(r = o()).done;) {
    var i = r.value,
      a = i[0],
      c = i[1];
    e.removeEventListener(a, c, n);
  }
}
function jY(e, n, r) {
  void 0 === r && (r = {});
  var o = function (e) {
      var t = new Set();
      e.drag && t.add(QY.get("drag"));
      e.wheel && t.add(QY.get("wheel"));
      e.scroll && t.add(QY.get("scroll"));
      e.move && t.add(QY.get("move"));
      e.pinch && t.add(QY.get("pinch"));
      e.hover && t.add(QY.get("hover"));
      return t;
    }(e),
    i = t.useMemo(function () {
      return new SY(o);
    }, []);
  return i.config = n, i.handlers = e, i.nativeRefs = r, t.useEffect(i.effect, []), i.config.domTarget ? JY : i.bind;
}
function JY() {
  "development" === process.env.NODE_ENV && console.warn("Deprecation notice: When the `domTarget` option is specified, you don't need to write `useEffect(bind, [bind])` anymore: event binding is now made handled internally to this lib.\n\nNext version won't return anything when `domTarget` is provided, therefore your code will break if you try to call `useEffect`.");
}
var ZY = function (e) {
  function t() {
    return e.apply(this, arguments) || this;
  }
  dY(t, e);
  var n = t.prototype;
  return n.getInternalMovement = function (e, t) {
    return oY(e, t.initial);
  }, n.checkIntentionality = function (e, t) {
    if (!1 === e[0] && !1 === e[1]) return {
      _intentional: e,
      axis: this.state.axis
    };
    var n = t.map(Math.abs),
      r = n[0],
      o = n[1],
      i = this.state.axis || (r > o ? "x" : r < o ? "y" : void 0);
    return this.config.axis || this.config.lockDirection ? i ? this.config.axis && i !== this.config.axis ? {
      _intentional: e,
      _blocked: !0,
      axis: i
    } : (e["x" === i ? 1 : 0] = !1, {
      _intentional: e,
      _blocked: !1,
      axis: i
    }) : {
      _intentional: [!1, !1],
      _blocked: !1,
      axis: i
    } : {
      _intentional: e,
      _blocked: !1,
      axis: i
    };
  }, n.getKinematics = function (e, t) {
    var n = this.getMovement(e);
    if (!n._blocked) {
      var r = t.timeStamp - this.state.timeStamp;
      Object.assign(n, function (e, t, n) {
        var r = iY(t),
          o = 0 === r ? 0 : 1 / r,
          i = 0 === n ? 0 : 1 / n,
          a = i * r,
          c = t.map(function (e) {
            return i * e;
          }),
          s = t.map(function (e) {
            return o * e;
          });
        return {
          velocities: c,
          velocity: a,
          distance: iY(e),
          direction: s
        };
      }(n.movement, n.delta, r));
    }
    return n;
  }, n.mapStateValues = function (e) {
    return {
      xy: e.values,
      vxvy: e.velocities
    };
  }, t;
}(HY);
function WY(e) {
  if ("touches" in e) {
    var t = e.targetTouches,
      n = e.changedTouches;
    return t.length > 0 ? t : n;
  }
  return null;
}
function XY(e) {
  var t = "buttons" in e ? e.buttons : 0,
    n = WY(e),
    r = n && n.length || 0;
  return {
    touches: r,
    down: r > 0 || t > 0,
    buttons: t,
    shiftKey: e.shiftKey,
    altKey: e.altKey,
    metaKey: e.metaKey,
    ctrlKey: e.ctrlKey
  };
}
function UY(e) {
  var t = WY(e),
    n = t ? t[0] : e;
  return [n.clientX, n.clientY];
}
var KY = function (e) {
  function t() {
    var t;
    return (t = e.apply(this, arguments) || this).ingKey = "dragging", t.stateKey = "drag", t.onDragStart = function (e) {
      t.enabled && !t.state._active && (LY(t.controller, t.stateKey, [["pointermove", t.onDragChange], ["pointerup", t.onDragEnd], ["pointercancel", t.onDragEnd]]), t.updateGestureState({
        _pointerId: e.pointerId
      }), t.config.delay > 0 ? (t.state._delayedEvent = !0, "persist" in e && "function" == typeof e.persist && e.persist(), t.setTimeout(t.startDrag.bind(fY(t)), t.config.delay, e)) : t.startDrag(e));
    }, t.onDragChange = function (e) {
      if (!t.state.canceled && e.pointerId === t.state._pointerId) if (t.state._active) {
        var n = XY(e);
        if (n.down) {
          t.updateSharedState(n);
          var r = UY(e),
            o = t.getKinematics(r, e),
            i = kY(fY(t), e),
            a = t.state._isTap,
            c = iY(o._movement);
          a && c >= 3 && (a = !1), t.updateGestureState(uY({}, i, o, {
            _isTap: a
          })), t.fireGestureHandler();
        } else t.onDragEnd(e);
      } else t.state._delayedEvent && (t.clearTimeout(), t.startDrag(e));
    }, t.onDragEnd = function (e) {
      if (e.pointerId === t.state._pointerId) {
        t.state._active = !1, t.updateSharedState({
          down: !1,
          buttons: 0,
          touches: 0
        });
        var n = t.state._isTap,
          r = t.state.velocities,
          o = r[0],
          i = r[1],
          a = t.state.movement,
          c = a[0],
          s = a[1],
          l = t.state._intentional,
          u = l[0],
          d = l[1],
          f = t.config.swipeVelocity,
          p = f[0],
          m = f[1],
          h = t.config.swipeDistance,
          A = h[0],
          g = h[1],
          v = uY({}, kY(fY(t), e), t.getMovement(t.state.values)),
          C = [0, 0];
        v.elapsedTime < 220 && (!1 !== u && Math.abs(o) > p && Math.abs(c) > A && (C[0] = aY(o)), !1 !== d && Math.abs(i) > m && Math.abs(s) > g && (C[1] = aY(i))), t.updateGestureState(uY({}, v, {
          tap: n,
          swipe: C
        })), t.fireGestureHandler(!0 === n);
      }
    }, t.clean = function () {
      e.prototype.clean.call(fY(t)), t.state._delayedEvent = !1, VY(t.controller, t.stateKey);
    }, t.onCancel = function () {
      t.state.canceled || (t.updateGestureState({
        canceled: !0
      }), t.state._active = !1, t.updateSharedState({
        down: !1,
        buttons: 0,
        touches: 0
      }), requestAnimationFrame(function () {
        return t.fireGestureHandler();
      }));
    }, t.onClick = function (e) {
      t.state._isTap || e.stopPropagation();
    }, t;
  }
  dY(t, e);
  var n = t.prototype;
  return n.startDrag = function (e) {
    var t = UY(e);
    this.updateSharedState(XY(e)), this.updateGestureState(uY({}, function (e, t, n) {
      var r = e.state.offset,
        o = n.timeStamp;
      return uY({}, wY()[e.stateKey], {
        _active: !0,
        values: t,
        initial: t,
        offset: r,
        lastOffset: r,
        startTime: o
      });
    }(this, t, e), kY(this, e, !0), {
      _pointerId: e.pointerId,
      cancel: this.onCancel
    })), this.updateGestureState(this.getMovement(t)), this.fireGestureHandler();
  }, n.addBindings = function (e) {
    (RY(e, "onPointerDown", this.onDragStart), this.config.filterTaps) && RY(e, this.controller.config.eventOptions.capture ? "onClick" : "onClickCapture", this.onClick);
  }, t;
}(ZY);
function YY(e, t) {
  if (e === t) return !0;
  if (e && t && "object" == typeof e && "object" == typeof t) {
    if (e.constructor !== t.constructor) return !1;
    var n, r, o, i;
    if (Array.isArray(e)) {
      if ((n = e.length) !== t.length) return !1;
      for (r = n; 0 != r--;) if (!YY(e[r], t[r])) return !1;
      return !0;
    }
    if ("function" == typeof Map && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(r = i.next()).done;) if (!t.has(r.value[0])) return !1;
      for (i = e.entries(); !(r = i.next()).done;) if (!YY(r.value[1], t.get(r.value[0]))) return !1;
      return !0;
    }
    if ("function" == typeof Set && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size) return !1;
      for (i = e.entries(); !(r = i.next()).done;) if (!t.has(r.value[0])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if ((n = (o = Object.keys(e)).length) !== Object.keys(t).length) return !1;
    for (r = n; 0 != r--;) if (!Object.prototype.hasOwnProperty.call(t, o[r])) return !1;
    if ("undefined" != typeof Element && e instanceof Element) return !1;
    for (r = n; 0 != r--;) if (!("_owner" === o[r] && e.$$typeof || YY(e[o[r]], t[o[r]]))) return !1;
    return !0;
  }
  return e != e && t != t;
}
function qY(e, t) {
  try {
    return YY(e, t);
  } catch (e) {
    if ((e.message || "").match(/stack|recursion/i)) return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw e;
  }
}
function _Y(e, t) {
  void 0 === t && (t = {}), QY.set("drag", KY);
  var n = o();
  return n.current || (n.current = function (e, t) {
    var n,
      r,
      o = [],
      i = !1;
    return function () {
      for (var a = arguments.length, c = new Array(a), s = 0; s < a; s++) c[s] = arguments[s];
      return i && n === this && t(c, o) || (r = e.apply(this, c), i = !0, n = this, o = c), r;
    };
  }(BY, qY)), jY({
    drag: e
  }, n.current(t));
}
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var $Y = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"],
  eq = $Y.join(","),
  tq = "undefined" == typeof Element,
  nq = tq ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector,
  rq = !tq && Element.prototype.getRootNode ? function (e) {
    return e.getRootNode();
  } : function (e) {
    return e.ownerDocument;
  },
  oq = function (e, t, n) {
    var r = Array.prototype.slice.apply(e.querySelectorAll(eq));
    return t && nq.call(e, eq) && r.unshift(e), r = r.filter(n);
  },
  iq = function e(t, n, r) {
    for (var o = [], i = Array.from(t); i.length;) {
      var a = i.shift();
      if ("SLOT" === a.tagName) {
        var c = a.assignedElements(),
          s = e(c.length ? c : a.children, !0, r);
        r.flatten ? o.push.apply(o, s) : o.push({
          scope: a,
          candidates: s
        });
      } else {
        nq.call(a, eq) && r.filter(a) && (n || !t.includes(a)) && o.push(a);
        var l = a.shadowRoot || "function" == typeof r.getShadowRoot && r.getShadowRoot(a),
          u = !r.shadowRootFilter || r.shadowRootFilter(a);
        if (l && u) {
          var d = e(!0 === l ? a.children : l.children, !0, r);
          r.flatten ? o.push.apply(o, d) : o.push({
            scope: a,
            candidates: d
          });
        } else i.unshift.apply(i, a.children);
      }
    }
    return o;
  },
  aq = function (e, t) {
    return e.tabIndex < 0 && (t || /^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || e.isContentEditable) && isNaN(parseInt(e.getAttribute("tabindex"), 10)) ? 0 : e.tabIndex;
  },
  cq = function (e, t) {
    return e.tabIndex === t.tabIndex ? e.documentOrder - t.documentOrder : e.tabIndex - t.tabIndex;
  },
  sq = function (e) {
    return "INPUT" === e.tagName;
  },
  lq = function (e) {
    return function (e) {
      return sq(e) && "radio" === e.type;
    }(e) && !function (e) {
      if (!e.name) return !0;
      var t,
        n = e.form || rq(e),
        r = function (e) {
          return n.querySelectorAll('input[type="radio"][name="' + e + '"]');
        };
      if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape) t = r(window.CSS.escape(e.name));else try {
        t = r(e.name);
      } catch (e) {
        return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", e.message), !1;
      }
      var o = function (e, t) {
        for (var n = 0; n < e.length; n++) if (e[n].checked && e[n].form === t) return e[n];
      }(t, e.form);
      return !o || o === e;
    }(e);
  },
  uq = function (e) {
    var t = e.getBoundingClientRect(),
      n = t.width,
      r = t.height;
    return 0 === n && 0 === r;
  },
  dq = function (e, t) {
    return !(t.disabled || function (e) {
      return sq(e) && "hidden" === e.type;
    }(t) || function (e, t) {
      var n = t.displayCheck,
        r = t.getShadowRoot;
      if ("hidden" === getComputedStyle(e).visibility) return !0;
      var o = nq.call(e, "details>summary:first-of-type") ? e.parentElement : e;
      if (nq.call(o, "details:not([open]) *")) return !0;
      var i = rq(e).host,
        a = (null == i ? void 0 : i.ownerDocument.contains(i)) || e.ownerDocument.contains(e);
      if (n && "full" !== n) {
        if ("non-zero-area" === n) return uq(e);
      } else {
        if ("function" == typeof r) {
          for (var c = e; e;) {
            var s = e.parentElement,
              l = rq(e);
            if (s && !s.shadowRoot && !0 === r(s)) return uq(e);
            e = e.assignedSlot ? e.assignedSlot : s || l === e.ownerDocument ? s : l.host;
          }
          e = c;
        }
        if (a) return !e.getClientRects().length;
      }
      return !1;
    }(t, e) || function (e) {
      return "DETAILS" === e.tagName && Array.prototype.slice.apply(e.children).some(function (e) {
        return "SUMMARY" === e.tagName;
      });
    }(t) || function (e) {
      if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName)) for (var t = e.parentElement; t;) {
        if ("FIELDSET" === t.tagName && t.disabled) {
          for (var n = 0; n < t.children.length; n++) {
            var r = t.children.item(n);
            if ("LEGEND" === r.tagName) return !!nq.call(t, "fieldset[disabled] *") || !r.contains(e);
          }
          return !0;
        }
        t = t.parentElement;
      }
      return !1;
    }(t));
  },
  fq = function (e, t) {
    return !(lq(t) || aq(t) < 0 || !dq(e, t));
  },
  pq = function (e) {
    var t = parseInt(e.getAttribute("tabindex"), 10);
    return !!(isNaN(t) || t >= 0);
  },
  mq = function e(t) {
    var n = [],
      r = [];
    return t.forEach(function (t, o) {
      var i = !!t.scope,
        a = i ? t.scope : t,
        c = aq(a, i),
        s = i ? e(t.candidates) : a;
      0 === c ? i ? n.push.apply(n, s) : n.push(a) : r.push({
        documentOrder: o,
        tabIndex: c,
        item: t,
        isScope: i,
        content: s
      });
    }), r.sort(cq).reduce(function (e, t) {
      return t.isScope ? e.push.apply(e, t.content) : e.push(t.content), e;
    }, []).concat(n);
  },
  hq = function (e, t) {
    var n;
    return n = (t = t || {}).getShadowRoot ? iq([e], t.includeContainer, {
      filter: fq.bind(null, t),
      flatten: !1,
      getShadowRoot: t.getShadowRoot,
      shadowRootFilter: pq
    }) : oq(e, t.includeContainer, fq.bind(null, t)), mq(n);
  },
  Aq = function (e, t) {
    if (t = t || {}, !e) throw new Error("No node provided");
    return !1 !== nq.call(e, eq) && fq(t, e);
  },
  gq = $Y.concat("iframe").join(","),
  vq = function (e, t) {
    if (t = t || {}, !e) throw new Error("No node provided");
    return !1 !== nq.call(e, gq) && dq(t, e);
  };
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function Cq(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bq(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = null != arguments[t] ? arguments[t] : {};
    t % 2 ? Cq(Object(n), !0).forEach(function (t) {
      Eq(e, t, n[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Cq(Object(n)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
    });
  }
  return e;
}
function Eq(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var yq,
  Iq = (yq = [], {
    activateTrap: function (e) {
      if (yq.length > 0) {
        var t = yq[yq.length - 1];
        t !== e && t.pause();
      }
      var n = yq.indexOf(e);
      -1 === n || yq.splice(n, 1), yq.push(e);
    },
    deactivateTrap: function (e) {
      var t = yq.indexOf(e);
      -1 !== t && yq.splice(t, 1), yq.length > 0 && yq[yq.length - 1].unpause();
    }
  }),
  Bq = function (e) {
    return setTimeout(e, 0);
  },
  xq = function (e, t) {
    var n = -1;
    return e.every(function (e, r) {
      return !t(e) || (n = r, !1);
    }), n;
  },
  wq = function (e) {
    for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++) n[r - 1] = arguments[r];
    return "function" == typeof e ? e.apply(void 0, n) : e;
  },
  Qq = function (e) {
    return e.target.shadowRoot && "function" == typeof e.composedPath ? e.composedPath()[0] : e.target;
  },
  Hq = function (e, t) {
    var n,
      r = (null == t ? void 0 : t.document) || document,
      o = bq({
        returnFocusOnDeactivate: !0,
        escapeDeactivates: !0,
        delayInitialFocus: !0
      }, t),
      i = {
        containers: [],
        containerGroups: [],
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: !1,
        paused: !1,
        delayInitialFocusTimer: void 0
      },
      a = function (e, t, n) {
        return e && void 0 !== e[t] ? e[t] : o[n || t];
      },
      c = function (e) {
        return i.containerGroups.findIndex(function (t) {
          var n = t.container,
            r = t.tabbableNodes;
          return n.contains(e) || r.find(function (t) {
            return t === e;
          });
        });
      },
      s = function (e) {
        var t = o[e];
        if ("function" == typeof t) {
          for (var n = arguments.length, i = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++) i[a - 1] = arguments[a];
          t = t.apply(void 0, i);
        }
        if (!0 === t && (t = void 0), !t) {
          if (void 0 === t || !1 === t) return t;
          throw new Error("`".concat(e, "` was specified but was not a node, or did not return a node"));
        }
        var c = t;
        if ("string" == typeof t && !(c = r.querySelector(t))) throw new Error("`".concat(e, "` as selector refers to no known node"));
        return c;
      },
      l = function () {
        var e = s("initialFocus");
        if (!1 === e) return !1;
        if (void 0 === e) if (c(r.activeElement) >= 0) e = r.activeElement;else {
          var t = i.tabbableGroups[0];
          e = t && t.firstTabbableNode || s("fallbackFocus");
        }
        if (!e) throw new Error("Your focus-trap needs to have at least one focusable element");
        return e;
      },
      u = function () {
        if (i.containerGroups = i.containers.map(function (e) {
          var t = hq(e, o.tabbableOptions),
            n = function (e, t) {
              return (t = t || {}).getShadowRoot ? iq([e], t.includeContainer, {
                filter: dq.bind(null, t),
                flatten: !0,
                getShadowRoot: t.getShadowRoot
              }) : oq(e, t.includeContainer, dq.bind(null, t));
            }(e, o.tabbableOptions);
          return {
            container: e,
            tabbableNodes: t,
            focusableNodes: n,
            firstTabbableNode: t.length > 0 ? t[0] : null,
            lastTabbableNode: t.length > 0 ? t[t.length - 1] : null,
            nextTabbableNode: function (e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                r = n.findIndex(function (t) {
                  return t === e;
                });
              if (!(r < 0)) return t ? n.slice(r + 1).find(function (e) {
                return Aq(e, o.tabbableOptions);
              }) : n.slice(0, r).reverse().find(function (e) {
                return Aq(e, o.tabbableOptions);
              });
            }
          };
        }), i.tabbableGroups = i.containerGroups.filter(function (e) {
          return e.tabbableNodes.length > 0;
        }), i.tabbableGroups.length <= 0 && !s("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
      },
      d = function e(t) {
        !1 !== t && t !== r.activeElement && (t && t.focus ? (t.focus({
          preventScroll: !!o.preventScroll
        }), i.mostRecentlyFocusedNode = t, function (e) {
          return e.tagName && "input" === e.tagName.toLowerCase() && "function" == typeof e.select;
        }(t) && t.select()) : e(l()));
      },
      f = function (e) {
        var t = s("setReturnFocus", e);
        return t || !1 !== t && e;
      },
      p = function (e) {
        var t = Qq(e);
        c(t) >= 0 || (wq(o.clickOutsideDeactivates, e) ? n.deactivate({
          returnFocus: o.returnFocusOnDeactivate && !vq(t, o.tabbableOptions)
        }) : wq(o.allowOutsideClick, e) || e.preventDefault());
      },
      m = function (e) {
        var t = Qq(e),
          n = c(t) >= 0;
        n || t instanceof Document ? n && (i.mostRecentlyFocusedNode = t) : (e.stopImmediatePropagation(), d(i.mostRecentlyFocusedNode || l()));
      },
      h = function (e) {
        if (function (e) {
          return "Escape" === e.key || "Esc" === e.key || 27 === e.keyCode;
        }(e) && !1 !== wq(o.escapeDeactivates, e)) return e.preventDefault(), void n.deactivate();
        (function (e) {
          return "Tab" === e.key || 9 === e.keyCode;
        })(e) && function (e) {
          var t = Qq(e);
          u();
          var n = null;
          if (i.tabbableGroups.length > 0) {
            var r = c(t),
              a = r >= 0 ? i.containerGroups[r] : void 0;
            if (r < 0) n = e.shiftKey ? i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : i.tabbableGroups[0].firstTabbableNode;else if (e.shiftKey) {
              var l = xq(i.tabbableGroups, function (e) {
                var n = e.firstTabbableNode;
                return t === n;
              });
              if (l < 0 && (a.container === t || vq(t, o.tabbableOptions) && !Aq(t, o.tabbableOptions) && !a.nextTabbableNode(t, !1)) && (l = r), l >= 0) {
                var f = 0 === l ? i.tabbableGroups.length - 1 : l - 1;
                n = i.tabbableGroups[f].lastTabbableNode;
              }
            } else {
              var p = xq(i.tabbableGroups, function (e) {
                var n = e.lastTabbableNode;
                return t === n;
              });
              if (p < 0 && (a.container === t || vq(t, o.tabbableOptions) && !Aq(t, o.tabbableOptions) && !a.nextTabbableNode(t)) && (p = r), p >= 0) {
                var m = p === i.tabbableGroups.length - 1 ? 0 : p + 1;
                n = i.tabbableGroups[m].firstTabbableNode;
              }
            }
          } else n = s("fallbackFocus");
          n && (e.preventDefault(), d(n));
        }(e);
      },
      A = function (e) {
        var t = Qq(e);
        c(t) >= 0 || wq(o.clickOutsideDeactivates, e) || wq(o.allowOutsideClick, e) || (e.preventDefault(), e.stopImmediatePropagation());
      },
      g = function () {
        if (i.active) return Iq.activateTrap(n), i.delayInitialFocusTimer = o.delayInitialFocus ? Bq(function () {
          d(l());
        }) : d(l()), r.addEventListener("focusin", m, !0), r.addEventListener("mousedown", p, {
          capture: !0,
          passive: !1
        }), r.addEventListener("touchstart", p, {
          capture: !0,
          passive: !1
        }), r.addEventListener("click", A, {
          capture: !0,
          passive: !1
        }), r.addEventListener("keydown", h, {
          capture: !0,
          passive: !1
        }), n;
      },
      v = function () {
        if (i.active) return r.removeEventListener("focusin", m, !0), r.removeEventListener("mousedown", p, !0), r.removeEventListener("touchstart", p, !0), r.removeEventListener("click", A, !0), r.removeEventListener("keydown", h, !0), n;
      };
    return n = {
      get active() {
        return i.active;
      },
      get paused() {
        return i.paused;
      },
      activate: function (e) {
        if (i.active) return this;
        var t = a(e, "onActivate"),
          n = a(e, "onPostActivate"),
          o = a(e, "checkCanFocusTrap");
        o || u(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = r.activeElement, t && t();
        var c = function () {
          o && u(), g(), n && n();
        };
        return o ? (o(i.containers.concat()).then(c, c), this) : (c(), this);
      },
      deactivate: function (e) {
        if (!i.active) return this;
        var t = bq({
          onDeactivate: o.onDeactivate,
          onPostDeactivate: o.onPostDeactivate,
          checkCanReturnFocus: o.checkCanReturnFocus
        }, e);
        clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, v(), i.active = !1, i.paused = !1, Iq.deactivateTrap(n);
        var r = a(t, "onDeactivate"),
          c = a(t, "onPostDeactivate"),
          s = a(t, "checkCanReturnFocus"),
          l = a(t, "returnFocus", "returnFocusOnDeactivate");
        r && r();
        var u = function () {
          Bq(function () {
            l && d(f(i.nodeFocusedBeforeActivation)), c && c();
          });
        };
        return l && s ? (s(f(i.nodeFocusedBeforeActivation)).then(u, u), this) : (u(), this);
      },
      pause: function () {
        return i.paused || !i.active || (i.paused = !0, v()), this;
      },
      unpause: function () {
        return i.paused && i.active ? (i.paused = !1, u(), g(), this) : this;
      },
      updateContainerElements: function (e) {
        var t = [].concat(e).filter(Boolean);
        return i.containers = t.map(function (e) {
          return "string" == typeof e ? r.querySelector(e) : e;
        }), i.active && u(), this;
      }
    }, n.updateContainerElements(e), n;
  };
var zq = !1;
if ("undefined" != typeof window) {
  var Mq = {
    get passive() {
      zq = !0;
    }
  };
  window.addEventListener("testPassive", null, Mq), window.removeEventListener("testPassive", null, Mq);
}
var kq,
  Nq = "undefined" != typeof window && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || "MacIntel" === window.navigator.platform && window.navigator.maxTouchPoints > 1),
  Sq = [],
  Vq = !1,
  Lq = -1,
  Pq = void 0,
  Oq = void 0,
  Tq = function (e) {
    return Sq.some(function (t) {
      return !(!t.options.allowTouchMove || !t.options.allowTouchMove(e));
    });
  },
  Dq = function (e) {
    var t = e || window.event;
    return !!Tq(t.target) || t.touches.length > 1 || (t.preventDefault && t.preventDefault(), !1);
  },
  Rq = function (e, t) {
    if (e) {
      if (!Sq.some(function (t) {
        return t.targetElement === e;
      })) {
        var n = {
          targetElement: e,
          options: t || {}
        };
        Sq = [].concat(function (e) {
          if (Array.isArray(e)) {
            for (var t = 0, n = Array(e.length); t < e.length; t++) n[t] = e[t];
            return n;
          }
          return Array.from(e);
        }(Sq), [n]), Nq ? (e.ontouchstart = function (e) {
          1 === e.targetTouches.length && (Lq = e.targetTouches[0].clientY);
        }, e.ontouchmove = function (t) {
          1 === t.targetTouches.length && function (e, t) {
            var n = e.targetTouches[0].clientY - Lq;
            !Tq(e.target) && (t && 0 === t.scrollTop && n > 0 || function (e) {
              return !!e && e.scrollHeight - e.scrollTop <= e.clientHeight;
            }(t) && n < 0 ? Dq(e) : e.stopPropagation());
          }(t, e);
        }, Vq || (document.addEventListener("touchmove", Dq, zq ? {
          passive: !1
        } : void 0), Vq = !0)) : function (e) {
          if (void 0 === Oq) {
            var t = !!e && !0 === e.reserveScrollBarGap,
              n = window.innerWidth - document.documentElement.clientWidth;
            t && n > 0 && (Oq = document.body.style.paddingRight, document.body.style.paddingRight = n + "px");
          }
          void 0 === Pq && (Pq = document.body.style.overflow, document.body.style.overflow = "hidden");
        }(t);
      }
    } else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
  },
  Gq = function (e) {
    e ? (Sq = Sq.filter(function (t) {
      return t.targetElement !== e;
    }), Nq ? (e.ontouchstart = null, e.ontouchmove = null, Vq && 0 === Sq.length && (document.removeEventListener("touchmove", Dq, zq ? {
      passive: !1
    } : void 0), Vq = !1)) : Sq.length || (void 0 !== Oq && (document.body.style.paddingRight = Oq, Oq = void 0), void 0 !== Pq && (document.body.style.overflow = Pq, Pq = void 0))) : console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
  },
  Fq = [],
  jq = "ResizeObserver loop completed with undelivered notifications.";
!function (e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
}(kq || (kq = {}));
var Jq,
  Zq = function (e) {
    return Object.freeze(e);
  },
  Wq = function (e, t) {
    this.inlineSize = e, this.blockSize = t, Zq(this);
  },
  Xq = function () {
    function e(e, t, n, r) {
      return this.x = e, this.y = t, this.width = n, this.height = r, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Zq(this);
    }
    return e.prototype.toJSON = function () {
      var e = this;
      return {
        x: e.x,
        y: e.y,
        top: e.top,
        right: e.right,
        bottom: e.bottom,
        left: e.left,
        width: e.width,
        height: e.height
      };
    }, e.fromRect = function (t) {
      return new e(t.x, t.y, t.width, t.height);
    }, e;
  }(),
  Uq = function (e) {
    return e instanceof SVGElement && "getBBox" in e;
  },
  Kq = function (e) {
    if (Uq(e)) {
      var t = e.getBBox(),
        n = t.width,
        r = t.height;
      return !n && !r;
    }
    var o = e,
      i = o.offsetWidth,
      a = o.offsetHeight;
    return !(i || a || e.getClientRects().length);
  },
  Yq = function (e) {
    var t;
    if (e instanceof Element) return !0;
    var n = null === (t = null == e ? void 0 : e.ownerDocument) || void 0 === t ? void 0 : t.defaultView;
    return !!(n && e instanceof n.Element);
  },
  qq = "undefined" != typeof window ? window : {},
  _q = new WeakMap(),
  $q = /auto|scroll/,
  e_ = /^tb|vertical/,
  t_ = /msie|trident/i.test(qq.navigator && qq.navigator.userAgent),
  n_ = function (e) {
    return parseFloat(e || "0");
  },
  r_ = function (e, t, n) {
    return void 0 === e && (e = 0), void 0 === t && (t = 0), void 0 === n && (n = !1), new Wq((n ? t : e) || 0, (n ? e : t) || 0);
  },
  o_ = Zq({
    devicePixelContentBoxSize: r_(),
    borderBoxSize: r_(),
    contentBoxSize: r_(),
    contentRect: new Xq(0, 0, 0, 0)
  }),
  i_ = function (e, t) {
    if (void 0 === t && (t = !1), _q.has(e) && !t) return _q.get(e);
    if (Kq(e)) return _q.set(e, o_), o_;
    var n = getComputedStyle(e),
      r = Uq(e) && e.ownerSVGElement && e.getBBox(),
      o = !t_ && "border-box" === n.boxSizing,
      i = e_.test(n.writingMode || ""),
      a = !r && $q.test(n.overflowY || ""),
      c = !r && $q.test(n.overflowX || ""),
      s = r ? 0 : n_(n.paddingTop),
      l = r ? 0 : n_(n.paddingRight),
      u = r ? 0 : n_(n.paddingBottom),
      d = r ? 0 : n_(n.paddingLeft),
      f = r ? 0 : n_(n.borderTopWidth),
      p = r ? 0 : n_(n.borderRightWidth),
      m = r ? 0 : n_(n.borderBottomWidth),
      h = d + l,
      A = s + u,
      g = (r ? 0 : n_(n.borderLeftWidth)) + p,
      v = f + m,
      C = c ? e.offsetHeight - v - e.clientHeight : 0,
      b = a ? e.offsetWidth - g - e.clientWidth : 0,
      E = o ? h + g : 0,
      y = o ? A + v : 0,
      I = r ? r.width : n_(n.width) - E - b,
      B = r ? r.height : n_(n.height) - y - C,
      x = I + h + b + g,
      w = B + A + C + v,
      Q = Zq({
        devicePixelContentBoxSize: r_(Math.round(I * devicePixelRatio), Math.round(B * devicePixelRatio), i),
        borderBoxSize: r_(x, w, i),
        contentBoxSize: r_(I, B, i),
        contentRect: new Xq(d, s, I, B)
      });
    return _q.set(e, Q), Q;
  },
  a_ = function (e, t, n) {
    var r = i_(e, n),
      o = r.borderBoxSize,
      i = r.contentBoxSize,
      a = r.devicePixelContentBoxSize;
    switch (t) {
      case kq.DEVICE_PIXEL_CONTENT_BOX:
        return a;
      case kq.BORDER_BOX:
        return o;
      default:
        return i;
    }
  },
  c_ = function (e) {
    var t = i_(e);
    this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = Zq([t.borderBoxSize]), this.contentBoxSize = Zq([t.contentBoxSize]), this.devicePixelContentBoxSize = Zq([t.devicePixelContentBoxSize]);
  },
  s_ = function (e) {
    if (Kq(e)) return 1 / 0;
    for (var t = 0, n = e.parentNode; n;) t += 1, n = n.parentNode;
    return t;
  },
  l_ = function () {
    var e = 1 / 0,
      t = [];
    Fq.forEach(function (n) {
      if (0 !== n.activeTargets.length) {
        var r = [];
        n.activeTargets.forEach(function (t) {
          var n = new c_(t.target),
            o = s_(t.target);
          r.push(n), t.lastReportedSize = a_(t.target, t.observedBox), o < e && (e = o);
        }), t.push(function () {
          n.callback.call(n.observer, r, n.observer);
        }), n.activeTargets.splice(0, n.activeTargets.length);
      }
    });
    for (var n = 0, r = t; n < r.length; n++) {
      (0, r[n])();
    }
    return e;
  },
  u_ = function (e) {
    Fq.forEach(function (t) {
      t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function (n) {
        n.isActive() && (s_(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
      });
    });
  },
  d_ = function () {
    var e = 0;
    for (u_(e); Fq.some(function (e) {
      return e.activeTargets.length > 0;
    });) e = l_(), u_(e);
    return Fq.some(function (e) {
      return e.skippedTargets.length > 0;
    }) && function () {
      var e;
      "function" == typeof ErrorEvent ? e = new ErrorEvent("error", {
        message: jq
      }) : ((e = document.createEvent("Event")).initEvent("error", !1, !1), e.message = jq), window.dispatchEvent(e);
    }(), e > 0;
  },
  f_ = [],
  p_ = function (e) {
    if (!Jq) {
      var t = 0,
        n = document.createTextNode("");
      new MutationObserver(function () {
        return f_.splice(0).forEach(function (e) {
          return e();
        });
      }).observe(n, {
        characterData: !0
      }), Jq = function () {
        n.textContent = "".concat(t ? t-- : t++);
      };
    }
    f_.push(e), Jq();
  },
  m_ = 0,
  h_ = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
  },
  A_ = ["resize", "load", "transitionend", "animationend", "animationstart", "animationiteration", "keyup", "keydown", "mouseup", "mousedown", "mouseover", "mouseout", "blur", "focus"],
  g_ = function (e) {
    return void 0 === e && (e = 0), Date.now() + e;
  },
  v_ = !1,
  C_ = function () {
    function e() {
      var e = this;
      this.stopped = !0, this.listener = function () {
        return e.schedule();
      };
    }
    return e.prototype.run = function (e) {
      var t = this;
      if (void 0 === e && (e = 250), !v_) {
        v_ = !0;
        var n = g_(e);
        !function (e) {
          p_(function () {
            requestAnimationFrame(e);
          });
        }(function () {
          var r = !1;
          try {
            r = d_();
          } finally {
            if (v_ = !1, e = n - g_(), !m_) return;
            r ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
          }
        });
      }
    }, e.prototype.schedule = function () {
      this.stop(), this.run();
    }, e.prototype.observe = function () {
      var e = this,
        t = function () {
          return e.observer && e.observer.observe(document.body, h_);
        };
      document.body ? t() : qq.addEventListener("DOMContentLoaded", t);
    }, e.prototype.start = function () {
      var e = this;
      this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), A_.forEach(function (t) {
        return qq.addEventListener(t, e.listener, !0);
      }));
    }, e.prototype.stop = function () {
      var e = this;
      this.stopped || (this.observer && this.observer.disconnect(), A_.forEach(function (t) {
        return qq.removeEventListener(t, e.listener, !0);
      }), this.stopped = !0);
    }, e;
  }(),
  b_ = new C_(),
  E_ = function (e) {
    !m_ && e > 0 && b_.start(), !(m_ += e) && b_.stop();
  },
  y_ = function () {
    function e(e, t) {
      this.target = e, this.observedBox = t || kq.CONTENT_BOX, this.lastReportedSize = {
        inlineSize: 0,
        blockSize: 0
      };
    }
    return e.prototype.isActive = function () {
      var e = a_(this.target, this.observedBox, !0);
      return function (e) {
        return !Uq(e) && !function (e) {
          switch (e.tagName) {
            case "INPUT":
              if ("image" !== e.type) break;
            case "VIDEO":
            case "AUDIO":
            case "EMBED":
            case "OBJECT":
            case "CANVAS":
            case "IFRAME":
            case "IMG":
              return !0;
          }
          return !1;
        }(e) && "inline" === getComputedStyle(e).display;
      }(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
    }, e;
  }(),
  I_ = function (e, t) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
  },
  B_ = new WeakMap(),
  x_ = function (e, t) {
    for (var n = 0; n < e.length; n += 1) if (e[n].target === t) return n;
    return -1;
  },
  w_ = function () {
    function e() {}
    return e.connect = function (e, t) {
      var n = new I_(e, t);
      B_.set(e, n);
    }, e.observe = function (e, t, n) {
      var r = B_.get(e),
        o = 0 === r.observationTargets.length;
      x_(r.observationTargets, t) < 0 && (o && Fq.push(r), r.observationTargets.push(new y_(t, n && n.box)), E_(1), b_.schedule());
    }, e.unobserve = function (e, t) {
      var n = B_.get(e),
        r = x_(n.observationTargets, t),
        o = 1 === n.observationTargets.length;
      r >= 0 && (o && Fq.splice(Fq.indexOf(n), 1), n.observationTargets.splice(r, 1), E_(-1));
    }, e.disconnect = function (e) {
      var t = this,
        n = B_.get(e);
      n.observationTargets.slice().forEach(function (n) {
        return t.unobserve(e, n.target);
      }), n.activeTargets.splice(0, n.activeTargets.length);
    }, e;
  }(),
  Q_ = function () {
    function e(e) {
      if (0 === arguments.length) throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
      if ("function" != typeof e) throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
      w_.connect(this, e);
    }
    return e.prototype.observe = function (e, t) {
      if (0 === arguments.length) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
      if (!Yq(e)) throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
      w_.observe(this, e, t);
    }, e.prototype.unobserve = function (e) {
      if (0 === arguments.length) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
      if (!Yq(e)) throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
      w_.unobserve(this, e);
    }, e.prototype.disconnect = function () {
      w_.disconnect(this);
    }, e.toString = function () {
      return "function ResizeObserver () { [polyfill code] }";
    }, e;
  }();
function H_() {
  return H_ = Object.assign || function (e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, H_.apply(this, arguments);
}
function z_(e, t) {
  if (null == e) return {};
  var n,
    r,
    o = {},
    i = Object.keys(e);
  for (r = 0; r < i.length; r++) t.indexOf(n = i[r]) >= 0 || (o[n] = e[n]);
  return o;
}
var M_ = "undefined" != typeof window ? p : r;
function k_(e, t, n) {
  return t = (t = +t) == t ? t : 0, n = (n = +n) == n ? n : 0, (e = +e) == e && (e = (e = e <= n ? e : n) >= t ? e : t), e;
}
function N_(e) {
  var t = Math.round(e);
  if (Number.isNaN(e)) throw new TypeError("Found a NaN! Check your snapPoints / defaultSnap / snapTo ");
  return t;
}
var S_ = {
  box: "border-box"
};
function V_(e, t) {
  var r = t.label,
    o = t.enabled,
    i = t.resizeSourceRef,
    a = n(0),
    c = a[0],
    s = a[1];
  A(r + ": " + c);
  var u = l(function (e) {
    s(e[0].borderBoxSize[0].blockSize), i.current = "element";
  }, [i]);
  return M_(function () {
    if (e.current && o) {
      var t = new Q_(u);
      return t.observe(e.current, S_), function () {
        t.disconnect();
      };
    }
  }, [e, u, o]), o ? c : 0;
}
function L_(e) {
  return void 0 === e && (e = 1e3), new Promise(function (t) {
    return setTimeout(t, e);
  });
}
var P_ = {
    DRAG: {
      target: "#overlay.dragging",
      actions: "onOpenEnd"
    }
  },
  O_ = {
    RESIZE: {
      target: "#overlay.resizing",
      actions: "onOpenEnd"
    }
  },
  T_ = function (e, t, n) {
    return void 0 === n && (n = e.context), new PU(e, t, n);
  }({
    id: "overlay",
    initial: "closed",
    context: {
      initialState: "CLOSED"
    },
    states: {
      closed: {
        on: {
          OPEN: "opening",
          CLOSE: void 0
        }
      },
      opening: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onOpenStart",
              onDone: "transition"
            }
          },
          transition: {
            always: [{
              target: "immediately",
              cond: "initiallyOpen"
            }, {
              target: "smoothly",
              cond: "initiallyClosed"
            }]
          },
          immediately: {
            initial: "open",
            states: {
              open: {
                invoke: {
                  src: "openImmediately",
                  onDone: "activating"
                }
              },
              activating: {
                invoke: {
                  src: "activate",
                  onDone: "#overlay.opening.end"
                },
                on: H_({}, P_, O_)
              }
            }
          },
          smoothly: {
            initial: "visuallyHidden",
            states: {
              visuallyHidden: {
                invoke: {
                  src: "renderVisuallyHidden",
                  onDone: "activating"
                }
              },
              activating: {
                invoke: {
                  src: "activate",
                  onDone: "open"
                }
              },
              open: {
                invoke: {
                  src: "openSmoothly",
                  onDone: "#overlay.opening.end"
                },
                on: H_({}, P_, O_)
              }
            }
          },
          end: {
            invoke: {
              src: "onOpenEnd",
              onDone: "done"
            },
            on: {
              CLOSE: "#overlay.closing",
              DRAG: "#overlay.dragging"
            }
          },
          done: {
            type: "final"
          }
        },
        on: H_({}, {
          CLOSE: {
            target: "#overlay.closing",
            actions: "onOpenCancel"
          }
        }),
        onDone: "open"
      },
      open: {
        on: {
          DRAG: "#overlay.dragging",
          SNAP: "snapping",
          RESIZE: "resizing"
        }
      },
      dragging: {
        on: {
          SNAP: "snapping"
        }
      },
      snapping: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onSnapStart",
              onDone: "snappingSmoothly"
            },
            entry: [TU({
              y: function (e, t) {
                return t.payload.y;
              },
              velocity: function (e, t) {
                return t.payload.velocity;
              },
              snapSource: function (e, t) {
                var n = t.payload.source;
                return void 0 === n ? "custom" : n;
              }
            })]
          },
          snappingSmoothly: {
            invoke: {
              src: "snapSmoothly",
              onDone: "end"
            }
          },
          end: {
            invoke: {
              src: "onSnapEnd",
              onDone: "done"
            },
            on: {
              RESIZE: "#overlay.resizing",
              SNAP: "#overlay.snapping",
              CLOSE: "#overlay.closing",
              DRAG: "#overlay.dragging"
            }
          },
          done: {
            type: "final"
          }
        },
        on: {
          SNAP: {
            target: "snapping",
            actions: "onSnapEnd"
          },
          RESIZE: {
            target: "#overlay.resizing",
            actions: "onSnapCancel"
          },
          DRAG: {
            target: "#overlay.dragging",
            actions: "onSnapCancel"
          },
          CLOSE: {
            target: "#overlay.closing",
            actions: "onSnapCancel"
          }
        },
        onDone: "open"
      },
      resizing: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onResizeStart",
              onDone: "resizingSmoothly"
            }
          },
          resizingSmoothly: {
            invoke: {
              src: "resizeSmoothly",
              onDone: "end"
            }
          },
          end: {
            invoke: {
              src: "onResizeEnd",
              onDone: "done"
            },
            on: {
              SNAP: "#overlay.snapping",
              CLOSE: "#overlay.closing",
              DRAG: "#overlay.dragging"
            }
          },
          done: {
            type: "final"
          }
        },
        on: {
          RESIZE: {
            target: "resizing",
            actions: "onResizeEnd"
          },
          SNAP: {
            target: "snapping",
            actions: "onResizeCancel"
          },
          DRAG: {
            target: "#overlay.dragging",
            actions: "onResizeCancel"
          },
          CLOSE: {
            target: "#overlay.closing",
            actions: "onResizeCancel"
          }
        },
        onDone: "open"
      },
      closing: {
        initial: "start",
        states: {
          start: {
            invoke: {
              src: "onCloseStart",
              onDone: "deactivating"
            },
            on: {
              OPEN: {
                target: "#overlay.open",
                actions: "onCloseCancel"
              }
            }
          },
          deactivating: {
            invoke: {
              src: "deactivate",
              onDone: "closingSmoothly"
            }
          },
          closingSmoothly: {
            invoke: {
              src: "closeSmoothly",
              onDone: "end"
            }
          },
          end: {
            invoke: {
              src: "onCloseEnd",
              onDone: "done"
            },
            on: {
              OPEN: {
                target: "#overlay.opening",
                actions: "onCloseCancel"
              }
            }
          },
          done: {
            type: "final"
          }
        },
        on: {
          CLOSE: void 0,
          OPEN: {
            target: "#overlay.opening",
            actions: "onCloseCancel"
          }
        },
        onDone: "closed"
      }
    },
    on: {
      CLOSE: "closing"
    }
  }, {
    actions: {
      onOpenCancel: function (e, t) {},
      onSnapCancel: function (e, t) {},
      onResizeCancel: function (e, t) {},
      onCloseCancel: function (e, t) {},
      onOpenEnd: function (e, t) {},
      onSnapEnd: function (e, t) {},
      onRezizeEnd: function (e, t) {}
    },
    services: {
      onSnapStart: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onOpenStart: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onCloseStart: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onResizeStart: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onSnapEnd: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onOpenEnd: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onCloseEnd: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      onResizeEnd: function () {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      renderVisuallyHidden: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      activate: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      deactivate: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      openSmoothly: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      openImmediately: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      snapSmoothly: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      resizeSmoothly: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      },
      closeSmoothly: function (e, t) {
        try {
          return Promise.resolve(L_()).then(function () {});
        } catch (e) {
          return Promise.reject(e);
        }
      }
    },
    guards: {
      initiallyClosed: function (e) {
        return "CLOSED" === e.initialState;
      },
      initiallyOpen: function (e) {
        return "OPEN" === e.initialState;
      }
    }
  }),
  D_ = ["children", "sibling", "className", "footer", "header", "open", "initialState", "lastSnapRef", "initialFocusRef", "onDismiss", "maxHeight", "defaultSnap", "snapPoints", "blocking", "scrollLocking", "style", "onSpringStart", "onSpringCancel", "onSpringEnd", "reserveScrollBarGap", "expandOnContentDrag"],
  R_ = ["velocity"],
  G_ = ["onRest", "config"],
  F_ = {
    tension: 170,
    friction: 26
  },
  j_ = F_.tension,
  J_ = F_.friction,
  Z_ = /*#__PURE__*/t.forwardRef(function (e, i) {
    var a = e.children,
      c = e.sibling,
      u = e.className,
      d = e.footer,
      f = e.header,
      p = e.open,
      m = e.initialState,
      g = e.lastSnapRef,
      v = e.initialFocusRef,
      C = e.onDismiss,
      b = e.maxHeight,
      E = e.defaultSnap,
      y = void 0 === E ? X_ : E,
      I = e.snapPoints,
      B = void 0 === I ? U_ : I,
      x = e.blocking,
      w = void 0 === x || x,
      Q = e.scrollLocking,
      H = void 0 === Q || Q,
      z = e.style,
      M = e.onSpringStart,
      k = e.onSpringCancel,
      N = e.onSpringEnd,
      S = e.reserveScrollBarGap,
      V = void 0 === S ? w : S,
      L = e.expandOnContentDrag,
      P = void 0 !== L && L,
      O = z_(e, D_),
      T = function () {
        var e = n(!1),
          t = e[0],
          o = e[1],
          i = n({}),
          a = i[0],
          c = i[1],
          s = l(function (e) {
            return c(function (t) {
              var n;
              return H_({}, t, ((n = {})[e] = !1, n));
            }), function () {
              c(function (t) {
                var n;
                return H_({}, t, ((n = {})[e] = !0, n));
              });
            };
          }, []);
        return r(function () {
          var e = Object.values(a);
          0 !== e.length && e.every(Boolean) && o(!0);
        }, [a]), {
          ready: t,
          registerReady: s
        };
      }(),
      D = T.ready,
      R = T.registerReady,
      G = o(!1),
      F = o(M),
      j = o(k),
      J = o(N);
    r(function () {
      F.current = M, j.current = k, J.current = N;
    }, [k, M, N]);
    var Z,
      W,
      X = BK(function () {
        return {
          y: 0,
          ready: 0,
          maxHeight: 0,
          minSnap: 0,
          maxSnap: 0
        };
      }),
      U = X[0],
      K = X[1],
      Y = o(null),
      q = o(null),
      _ = o(null),
      $ = o(null),
      ee = o(null),
      te = o(null),
      ne = o(0),
      re = o(),
      oe = o(!1),
      ie = (Z = s(function () {
        return "undefined" != typeof window ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
      }, []), W = o(null == Z ? void 0 : Z.matches), A(W.current ? "reduce" : "no-preference"), r(function () {
        var e = function (e) {
          W.current = e.matches;
        };
        return null == Z || Z.addListener(e), function () {
          return null == Z ? void 0 : Z.removeListener(e);
        };
      }, [Z]), W),
      ae = function (e) {
        var t = e.targetRef,
          n = e.enabled,
          i = e.reserveScrollBarGap,
          a = o({
            activate: function () {
              throw new TypeError("Tried to activate scroll lock too early");
            },
            deactivate: function () {}
          });
        return A(n ? "Enabled" : "Disabled"), r(function () {
          if (!n) return a.current.deactivate(), void (a.current = {
            activate: function () {},
            deactivate: function () {}
          });
          var e = t.current,
            r = !1;
          a.current = {
            activate: function () {
              r || (r = !0, Rq(e, {
                allowTouchMove: function (e) {
                  return e.closest("[data-body-scroll-lock-ignore]");
                },
                reserveScrollBarGap: i
              }));
            },
            deactivate: function () {
              r && (r = !1, Gq(e));
            }
          };
        }, [n, t, i]), a;
      }({
        targetRef: q,
        enabled: D && H,
        reserveScrollBarGap: V
      }),
      ce = function (e) {
        var t = e.targetRef,
          n = e.enabled,
          i = o({
            activate: function () {
              throw new TypeError("Tried to activate aria hider too early");
            },
            deactivate: function () {}
          });
        return A(n ? "Enabled" : "Disabled"), r(function () {
          if (!n) return i.current.deactivate(), void (i.current = {
            activate: function () {},
            deactivate: function () {}
          });
          var e = t.current,
            r = !1,
            o = [],
            a = [];
          i.current = {
            activate: function () {
              if (!r) {
                r = !0;
                var t = e.parentNode;
                document.querySelectorAll("body > *").forEach(function (e) {
                  if (e !== t) {
                    var n = e.getAttribute("aria-hidden");
                    null !== n && "false" !== n || (o.push(n), a.push(e), e.setAttribute("aria-hidden", "true"));
                  }
                });
              }
            },
            deactivate: function () {
              r && (r = !1, a.forEach(function (e, t) {
                var n = o[t];
                null === n ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n);
              }), o = [], a = []);
            }
          };
        }, [t, n]), i;
      }({
        targetRef: Y,
        enabled: D && w
      }),
      se = function (e) {
        var t = e.targetRef,
          n = e.fallbackRef,
          i = e.initialFocusRef,
          a = e.enabled,
          c = o({
            activate: function () {
              throw new TypeError("Tried to activate focus trap too early");
            },
            deactivate: function () {}
          });
        return A(a ? "Enabled" : "Disabled"), r(function () {
          if (!a) return c.current.deactivate(), void (c.current = {
            activate: function () {},
            deactivate: function () {}
          });
          var e = n.current,
            r = Hq(t.current, {
              onActivate: void 0,
              initialFocus: i ? function () {
                return (null == i ? void 0 : i.current) || e;
              } : void 0,
              fallbackFocus: e,
              escapeDeactivates: !1,
              clickOutsideDeactivates: !1
            }),
            o = !1;
          c.current = {
            activate: function () {
              try {
                return o ? Promise.resolve() : (o = !0, Promise.resolve(r.activate()).then(function () {
                  return Promise.resolve(new Promise(function (e) {
                    return setTimeout(function () {
                      return e(void 0);
                    }, 0);
                  })).then(function () {});
                }));
              } catch (e) {
                return Promise.reject(e);
              }
            },
            deactivate: function () {
              o && (o = !1, r.deactivate());
            }
          };
        }, [a, n, i, t]), c;
      }({
        targetRef: Y,
        fallbackRef: te,
        initialFocusRef: v || void 0,
        enabled: D && w && !1 !== v
      }),
      le = function (e) {
        var t = e.getSnapPoints,
          i = e.heightRef,
          a = e.lastSnapRef,
          c = e.ready,
          l = function (e) {
            var t = e.contentRef,
              i = e.controlledMaxHeight,
              a = e.footerEnabled,
              c = e.footerRef,
              l = e.headerEnabled,
              u = e.headerRef,
              d = e.registerReady,
              f = e.resizeSourceRef,
              p = s(function () {
                return d("contentHeight");
              }, [d]),
              m = function (e, t, i) {
                var a = s(function () {
                    return t("maxHeight");
                  }, [t]),
                  c = n(function () {
                    return N_(e) || "undefined" != typeof window ? window.innerHeight : 0;
                  }),
                  l = c[0],
                  u = c[1],
                  d = l > 0,
                  f = o(0);
                return A(e ? "controlled" : "auto"), r(function () {
                  d && a();
                }, [d, a]), M_(function () {
                  if (e) return u(N_(e)), void (i.current = "maxheightprop");
                  var t = function () {
                    f.current || (f.current = requestAnimationFrame(function () {
                      u(window.innerHeight), i.current = "window", f.current = 0;
                    }));
                  };
                  return window.addEventListener("resize", t), u(window.innerHeight), i.current = "window", a(), function () {
                    window.removeEventListener("resize", t), cancelAnimationFrame(f.current);
                  };
                }, [e, a, i]), l;
              }(i, d, f),
              h = V_(u, {
                label: "headerHeight",
                enabled: l,
                resizeSourceRef: f
              }),
              g = V_(t, {
                label: "contentHeight",
                enabled: !0,
                resizeSourceRef: f
              }),
              v = V_(c, {
                label: "footerHeight",
                enabled: a,
                resizeSourceRef: f
              }),
              C = Math.min(m - h - v, g) + h + v;
            A("minHeight: " + C);
            var b = g > 0;
            return r(function () {
              b && p();
            }, [b, p]), {
              maxHeight: m,
              minHeight: C,
              headerHeight: h,
              footerHeight: v
            };
          }({
            contentRef: e.contentRef,
            controlledMaxHeight: e.controlledMaxHeight,
            footerEnabled: e.footerEnabled,
            footerRef: e.footerRef,
            headerEnabled: e.headerEnabled,
            headerRef: e.headerRef,
            registerReady: e.registerReady,
            resizeSourceRef: e.resizeSourceRef
          }),
          u = l.maxHeight,
          d = l.minHeight,
          f = l.headerHeight,
          p = l.footerHeight,
          m = function (e, t) {
            var n = [].concat(e).map(N_).reduce(function (e, n) {
                return e.add(k_(n, 0, t)), e;
              }, new Set()),
              r = Array.from(n),
              o = Math.min.apply(Math, r);
            if (Number.isNaN(o)) throw new TypeError("minSnap is NaN");
            var i = Math.max.apply(Math, r);
            if (Number.isNaN(i)) throw new TypeError("maxSnap is NaN");
            return {
              snapPoints: r,
              minSnap: o,
              maxSnap: i
            };
          }(c ? t({
            height: i.current,
            footerHeight: p,
            headerHeight: f,
            minHeight: d,
            maxHeight: u
          }) : [0], u),
          h = m.snapPoints,
          g = m.minSnap,
          v = m.maxSnap;
        return A("minSnap: " + g + ", maxSnap:" + v), {
          minSnap: g,
          maxSnap: v,
          findSnap: function (e) {
            var t = N_("function" == typeof e ? e({
              footerHeight: p,
              headerHeight: f,
              height: i.current,
              minHeight: d,
              maxHeight: u,
              snapPoints: h,
              lastSnap: a.current
            }) : e);
            return h.reduce(function (e, n) {
              return Math.abs(n - t) < Math.abs(e - t) ? n : e;
            }, g);
          },
          maxHeight: u
        };
      }({
        contentRef: _,
        controlledMaxHeight: b,
        footerEnabled: !!d,
        footerRef: ee,
        getSnapPoints: B,
        headerEnabled: !1 !== f,
        headerRef: $,
        heightRef: ne,
        lastSnapRef: g,
        ready: D,
        registerReady: R,
        resizeSourceRef: re
      }),
      ue = le.minSnap,
      de = le.maxSnap,
      fe = le.maxHeight,
      pe = le.findSnap,
      me = o(fe),
      he = o(ue),
      Ae = o(de),
      ge = o(pe),
      ve = o(0);
    M_(function () {
      me.current = fe, Ae.current = de, he.current = ue, ge.current = pe, ve.current = pe(y);
    }, [pe, y, fe, de, ue]);
    var Ce = l(function (e) {
        var t = e.onRest,
          n = e.config,
          r = (n = void 0 === n ? {} : n).velocity,
          o = void 0 === r ? 1 : r,
          i = z_(n, R_),
          a = z_(e, G_);
        return new Promise(function (e) {
          return K(H_({}, a, {
            config: H_({
              velocity: o
            }, i, {
              mass: 1,
              tension: j_,
              friction: Math.max(J_, J_ + (J_ - J_ * o))
            }),
            onRest: function () {
              var n = [].slice.call(arguments);
              e.apply(void 0, n), null == t || t.apply(void 0, n);
            }
          }));
        });
      }, [K]),
      be = qU(T_, {
        devTools: !1,
        actions: {
          onOpenCancel: l(function () {
            return null == j.current ? void 0 : j.current({
              type: "OPEN"
            });
          }, []),
          onSnapCancel: l(function (e) {
            return null == j.current ? void 0 : j.current({
              type: "SNAP",
              source: e.snapSource
            });
          }, []),
          onCloseCancel: l(function () {
            return null == j.current ? void 0 : j.current({
              type: "CLOSE"
            });
          }, []),
          onResizeCancel: l(function () {
            return null == j.current ? void 0 : j.current({
              type: "RESIZE",
              source: re.current
            });
          }, []),
          onOpenEnd: l(function () {
            return null == J.current ? void 0 : J.current({
              type: "OPEN"
            });
          }, []),
          onSnapEnd: l(function (e, t) {
            return null == J.current ? void 0 : J.current({
              type: "SNAP",
              source: e.snapSource
            });
          }, []),
          onResizeEnd: l(function () {
            return null == J.current ? void 0 : J.current({
              type: "RESIZE",
              source: re.current
            });
          }, [])
        },
        context: {
          initialState: m
        },
        services: {
          onSnapStart: l(function (e, t) {
            try {
              return Promise.resolve(null == F.current ? void 0 : F.current({
                type: "SNAP",
                source: t.payload.source || "custom"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onOpenStart: l(function () {
            try {
              return Promise.resolve(null == F.current ? void 0 : F.current({
                type: "OPEN"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onCloseStart: l(function () {
            try {
              return Promise.resolve(null == F.current ? void 0 : F.current({
                type: "CLOSE"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onResizeStart: l(function () {
            try {
              return Promise.resolve(null == F.current ? void 0 : F.current({
                type: "RESIZE",
                source: re.current
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onSnapEnd: l(function (e, t) {
            try {
              return Promise.resolve(null == J.current ? void 0 : J.current({
                type: "SNAP",
                source: e.snapSource
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onOpenEnd: l(function () {
            try {
              return Promise.resolve(null == J.current ? void 0 : J.current({
                type: "OPEN"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onCloseEnd: l(function () {
            try {
              return Promise.resolve(null == J.current ? void 0 : J.current({
                type: "CLOSE"
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          onResizeEnd: l(function () {
            try {
              return Promise.resolve(null == J.current ? void 0 : J.current({
                type: "RESIZE",
                source: re.current
              }));
            } catch (e) {
              return Promise.reject(e);
            }
          }, []),
          renderVisuallyHidden: l(function (e, t) {
            try {
              return Promise.resolve(Ce({
                y: ve.current,
                ready: 0,
                maxHeight: me.current,
                maxSnap: Ae.current,
                minSnap: ve.current,
                immediate: !0
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [Ce]),
          activate: l(function (e, t) {
            try {
              return G.current = !0, Promise.resolve(Promise.all([ae.current.activate(), se.current.activate(), ce.current.activate()])).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [ce, se, ae]),
          deactivate: l(function () {
            try {
              return ae.current.deactivate(), se.current.deactivate(), ce.current.deactivate(), G.current = !1, Promise.resolve();
            } catch (e) {
              return Promise.reject(e);
            }
          }, [ce, se, ae]),
          openImmediately: l(function () {
            try {
              return ne.current = ve.current, Promise.resolve(Ce({
                y: ve.current,
                ready: 1,
                maxHeight: me.current,
                maxSnap: Ae.current,
                minSnap: ve.current,
                immediate: !0
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [Ce]),
          openSmoothly: l(function () {
            try {
              return Promise.resolve(Ce({
                y: 0,
                ready: 1,
                maxHeight: me.current,
                maxSnap: Ae.current,
                minSnap: ve.current,
                immediate: !0
              })).then(function () {
                return ne.current = ve.current, Promise.resolve(Ce({
                  y: ve.current,
                  ready: 1,
                  maxHeight: me.current,
                  maxSnap: Ae.current,
                  minSnap: ve.current,
                  immediate: ie.current
                })).then(function () {});
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }, [Ce, ie]),
          snapSmoothly: l(function (e, t) {
            try {
              var n = ge.current(e.y);
              return ne.current = n, g.current = n, Promise.resolve(Ce({
                y: n,
                ready: 1,
                maxHeight: me.current,
                maxSnap: Ae.current,
                minSnap: he.current,
                immediate: ie.current,
                config: {
                  velocity: e.velocity
                }
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [Ce, g, ie]),
          resizeSmoothly: l(function () {
            try {
              var e = ge.current(ne.current);
              return ne.current = e, g.current = e, Promise.resolve(Ce({
                y: e,
                ready: 1,
                maxHeight: me.current,
                maxSnap: Ae.current,
                minSnap: he.current,
                immediate: "element" !== re.current || ie.current
              })).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          }, [Ce, g, ie]),
          closeSmoothly: l(function (e, t) {
            try {
              return Ce({
                minSnap: ne.current,
                immediate: !0
              }), ne.current = 0, Promise.resolve(Ce({
                y: 0,
                maxHeight: me.current,
                maxSnap: Ae.current,
                immediate: ie.current
              })).then(function () {
                return Promise.resolve(Ce({
                  ready: 0,
                  immediate: !0
                })).then(function () {});
              });
            } catch (e) {
              return Promise.reject(e);
            }
          }, [Ce, ie])
        }
      }),
      Ee = be[0],
      ye = be[1];
    r(function () {
      D && ye(p ? "OPEN" : "CLOSE");
    }, [p, ye, D]), M_(function () {
      (fe || de || ue) && ye("RESIZE");
    }, [fe, de, ue, ye]), r(function () {
      return function () {
        ae.current.deactivate(), se.current.deactivate(), ce.current.deactivate();
      };
    }, [ce, se, ae]), h(i, function () {
      return {
        snapTo: function (e, t) {
          var n = void 0 === t ? {} : t,
            r = n.velocity,
            o = void 0 === r ? 1 : r,
            i = n.source,
            a = void 0 === i ? "custom" : i;
          ye("SNAP", {
            payload: {
              y: ge.current(e),
              velocity: o,
              source: a
            }
          });
        },
        get height() {
          return ne.current;
        }
      };
    }, [ye]), r(function () {
      var e = q.current,
        t = function (e) {
          oe.current && e.preventDefault();
        },
        n = function (t) {
          e.scrollTop < 0 && (requestAnimationFrame(function () {
            e.style.overflow = "hidden", e.scrollTop = 0, e.style.removeProperty("overflow");
          }), t.preventDefault());
        };
      return P && (e.addEventListener("scroll", t), e.addEventListener("touchmove", t), e.addEventListener("touchstart", n)), function () {
        e.removeEventListener("scroll", t), e.removeEventListener("touchmove", t), e.removeEventListener("touchstart", n);
      };
    }, [P, q]);
    var Ie = _Y(function (e) {
      var t = e.args,
        n = (t = void 0 === t ? [] : t)[0],
        r = (n = void 0 === n ? {} : n).closeOnTap,
        o = void 0 !== r && r,
        i = n.isContentDragging,
        a = void 0 !== i && i,
        c = e.cancel,
        s = e.direction[1],
        l = e.down,
        u = e.first,
        d = e.last,
        f = e.memo,
        p = void 0 === f ? U.y.getValue() : f,
        m = e.tap,
        h = e.velocity,
        A = -1 * e.movement[1];
      if (!G.current) return c(), p;
      if (C && o && m) return c(), setTimeout(function () {
        return C();
      }, 0), p;
      if (m) return p;
      var g = p + A,
        v = A * h,
        b = Math.max(he.current, Math.min(Ae.current, g + 2 * v));
      if (!l && C && s > 0 && g + v < he.current / 2) return c(), C(), p;
      var E = l ? C || he.current !== Ae.current ? sY(g, C ? 0 : he.current, Ae.current, .55) : g < he.current ? sY(g, he.current, 2 * Ae.current, .55) : sY(g, he.current / 2, Ae.current, .55) : b;
      return P && a ? (E >= Ae.current && (E = Ae.current), p === Ae.current && q.current.scrollTop > 0 && (E = Ae.current), oe.current = E < Ae.current) : oe.current = !1, u && ye("DRAG"), d ? (ye("SNAP", {
        payload: {
          y: E,
          velocity: h > .05 ? h : 1,
          source: "dragging"
        }
      }), p) : (K({
        y: E,
        ready: 1,
        maxHeight: me.current,
        maxSnap: Ae.current,
        minSnap: he.current,
        immediate: !0,
        config: {
          velocity: h
        }
      }), p);
    }, {
      filterTaps: !0
    });
    if (Number.isNaN(Ae.current)) throw new TypeError("maxSnapRef is NaN!!");
    if (Number.isNaN(he.current)) throw new TypeError("minSnapRef is NaN!!");
    var Be = function (e) {
      var t,
        n = e.spring,
        r = vK([n.y, n.maxHeight], function (e, t) {
          return Math.round(k_(t - e, 0, 16)) + "px";
        }),
        o = vK([n.y, n.minSnap, n.maxSnap], function (e, t, n) {
          return k_(e, t, n) + "px";
        }),
        i = vK([n.y, n.minSnap, n.maxSnap], function (e, t, n) {
          return e < t ? t - e + "px" : e > n ? n - e + "px" : "0px";
        }),
        a = vK([n.y, n.maxSnap], function (e, t) {
          return e >= t ? Math.ceil(e - t) : 0;
        }),
        c = vK([n.y, n.minSnap], function (e, t) {
          if (!t) return 0;
          var n = Math.max(t / 2 - 45, 0);
          return k_((e - n) * (1 / (Math.min(t / 2 + 45, t) - n) + 0), 0, 1);
        }),
        s = vK([n.y, n.minSnap], function (e, t) {
          return t ? k_(e / t, 0, 1) : 0;
        });
      return (t = {})["--rsbs-content-opacity"] = c, t["--rsbs-backdrop-opacity"] = s, t["--rsbs-antigap-scale-y"] = a, t["--rsbs-overlay-translate-y"] = i, t["--rsbs-overlay-rounded"] = r, t["--rsbs-overlay-h"] = o, t;
    }({
      spring: U
    });
    return /*#__PURE__*/t.createElement(nY.div, H_({}, O, {
      "data-rsbs-root": !0,
      "data-rsbs-state": W_.find(Ee.matches),
      "data-rsbs-is-blocking": w,
      "data-rsbs-is-dismissable": !!C,
      "data-rsbs-has-header": !!f,
      "data-rsbs-has-footer": !!d,
      className: u,
      ref: Y,
      style: H_({}, Be, z, {
        opacity: U.ready
      })
    }), c, w && /*#__PURE__*/t.createElement("div", H_({
      key: "backdrop",
      "data-rsbs-backdrop": !0
    }, Ie({
      closeOnTap: !0
    }))), /*#__PURE__*/t.createElement("div", {
      key: "overlay",
      "aria-modal": "true",
      role: "dialog",
      "data-rsbs-overlay": !0,
      tabIndex: -1,
      ref: te,
      onKeyDown: function (e) {
        "Escape" === e.key && (e.stopPropagation(), C && C());
      }
    }, !1 !== f && /*#__PURE__*/t.createElement("div", H_({
      key: "header",
      "data-rsbs-header": !0,
      ref: $
    }, Ie()), f), /*#__PURE__*/t.createElement("div", H_({
      key: "scroll",
      "data-rsbs-scroll": !0,
      ref: q
    }, P ? Ie({
      isContentDragging: !0
    }) : {}), /*#__PURE__*/t.createElement("div", {
      "data-rsbs-content": !0,
      ref: _
    }, a)), d && /*#__PURE__*/t.createElement("div", H_({
      key: "footer",
      ref: ee,
      "data-rsbs-footer": !0
    }, Ie()), d)));
  }),
  W_ = ["closed", "opening", "open", "closing", "dragging", "snapping", "resizing"];
function X_(e) {
  var t = e.lastSnap;
  return null != t ? t : Math.min.apply(Math, e.snapPoints);
}
function U_(e) {
  return e.minHeight;
}
var K_ = ["onSpringStart", "onSpringEnd", "skipInitialTransition"],
  Y_ = /*#__PURE__*/c(function (e, r) {
    var i = e.onSpringStart,
      a = e.onSpringEnd,
      c = e.skipInitialTransition,
      s = z_(e, K_),
      u = n(!1),
      d = u[0],
      f = u[1],
      p = o(),
      m = o(null),
      h = o(c && s.open ? "OPEN" : "CLOSED");
    M_(function () {
      if (s.open) return cancelAnimationFrame(p.current), f(!0), function () {
        h.current = "CLOSED";
      };
    }, [s.open]);
    var A = l(function (e) {
        return Promise.resolve(null == i ? void 0 : i(e)).then(function () {
          "OPEN" === e.type && cancelAnimationFrame(p.current);
        });
      }, [i]),
      g = l(function (e) {
        return Promise.resolve(null == a ? void 0 : a(e)).then(function () {
          "CLOSE" === e.type && (p.current = requestAnimationFrame(function () {
            return f(!1);
          }));
        });
      }, [a]);
    return d ? /*#__PURE__*/t.createElement(jW, {
      "data-rsbs-portal": !0
    }, /*#__PURE__*/t.createElement(Z_, H_({}, s, {
      lastSnapRef: m,
      ref: r,
      initialState: h.current,
      onSpringStart: A,
      onSpringEnd: g
    }))) : null;
  }),
  q_ = ["reveal", "onDismiss", "children", "size"],
  __ = function (e) {
    var n = e.reveal,
      r = e.onDismiss,
      o = e.children,
      i = e.size,
      a = S(e, q_);
    return /*#__PURE__*/t.createElement(Y_, N({}, a, {
      className: tC(DW, k({}, RW, "form" === i)),
      open: n,
      onDismiss: r
    }), o);
  };
__.propTypes = {
  reveal: g.bool,
  onDismiss: g.func,
  header: g.node,
  footer: g.node,
  snapPoints: g.func,
  children: g.any,
  size: g.oneOf(["auto", "form"])
}, __.defaultProps = {
  size: "auto"
};
var $_ = {
    "columns-size-1": "checkboxGrid-module_columns-size-1__tYDK4",
    "columns-size-2": "checkboxGrid-module_columns-size-2__1ypkn",
    "columns-size-3": "checkboxGrid-module_columns-size-3__X2bzL",
    "columns-size-4": "checkboxGrid-module_columns-size-4__3QfRH",
    "columns-size-5": "checkboxGrid-module_columns-size-5__3kHrB"
  },
  e$ = function (e) {
    var n = e.checkboxes,
      r = e.numberOfColumns,
      o = e.removeBottomSpacer,
      i = e.customColor;
    return /*#__PURE__*/t.createElement(sb, {
      flexWrap: "wrap"
    }, n && n.map(function (e, n) {
      return /*#__PURE__*/t.createElement(Xb, {
        key: n,
        onChange: e.onChange,
        className: $_["columns-size-".concat(r)],
        removeBottomSpacer: o,
        value: e.value,
        checked: e.checked,
        customColor: e.customColor || i || null
      }, e.label);
    }));
  };
e$.propTypes = {
  checkboxes: g.array.isRequired,
  numberOfColumns: g.oneOf([1, 2, 3, 4, 5]),
  removeBottomSpacer: g.bool,
  customColor: g.string
}, e$.defaultProps = {
  numberOfColumns: 1
};
var t$ = "dialog-module_dialog__Rlb6a",
  n$ = "dialog-module_reveal__1RABv",
  r$ = "dialog-module_description__3EwCt",
  o$ = "dialog-module_header__B2nqB",
  i$ = function (e) {
    var n = e.reveal,
      r = e.title,
      o = e.description,
      i = e.confirmLabel,
      a = e.confirmOnClick,
      c = e.cancelLabel,
      s = e.cancelOnClick,
      l = e.closeOnClick,
      u = e.isDanger;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(YC, {
      reveal: n,
      closeOnClick: l
    }), /*#__PURE__*/t.createElement(ob, {
      className: tC(t$, k({}, n$, n)),
      addShadow: !0
    }, /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      paddingLeft: "s",
      paddingRight: "xs",
      paddingTop: "xs",
      className: o$
    }, /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1,
      paddingRight: "xs"
    }, r ? /*#__PURE__*/t.createElement(Vb, {
      weight: "semibold",
      truncate: !0
    }, r) : " "), /*#__PURE__*/t.createElement(WC, {
      onClick: l,
      size: "dense",
      appearance: "ghost",
      variation: "secondary"
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    }))), /*#__PURE__*/t.createElement(nb, {
      paddingHorizontal: "s",
      paddingTop: "xs",
      paddingBottom: "s",
      className: r$
    }, o), /*#__PURE__*/t.createElement(sb, {
      justifyContent: "flex-end",
      gap: "xs",
      paddingTop: "xxs",
      paddingBottom: "xs",
      paddingHorizontal: "xs"
    }, /*#__PURE__*/t.createElement(jC, {
      onClick: s,
      variation: "secondary",
      appearance: "ghost",
      size: "dense"
    }, c), /*#__PURE__*/t.createElement(jC, {
      onClick: a,
      size: "dense",
      variation: u ? "danger" : "primary"
    }, i))));
  };
i$.propTypes = {
  description: g.string.isRequired,
  confirmOnClick: g.func.isRequired,
  cancelOnClick: g.func.isRequired,
  reveal: g.bool,
  title: g.string,
  confirmLabel: g.string,
  cancelLabel: g.string,
  closeOnClick: g.func,
  isDanger: g.bool
}, i$.defaultProps = {
  cancelLabel: "Cancel",
  confirmLabel: "Confirm"
};
var a$ = "dropdown-module_dropdown__cdu2p",
  c$ = "dropdown-module_panelIsHover__2R4jd",
  s$ = {
    dropdownPanel: "panel-module_dropdownPanel__2jTCX",
    noPadding: "panel-module_noPadding__28Tue",
    "width-auto": "panel-module_width-auto__3PJnG",
    "width-s": "panel-module_width-s__1-FXQ",
    "width-m": "panel-module_width-m__2m7pr",
    "width-l": "panel-module_width-l__1XDeI",
    "align-bottomLeft": "panel-module_align-bottomLeft__24Cca",
    "align-bottomRight": "panel-module_align-bottomRight__1p99c",
    "align-bottomCenter": "panel-module_align-bottomCenter__2f0pk",
    "align-topLeft": "panel-module_align-topLeft__18Q4t",
    "align-topRight": "panel-module_align-topRight__2Xa2k",
    forceMinWidth: "panel-module_forceMinWidth__3UtK2",
    truncateText: "panel-module_truncateText__2Rzc2"
  },
  l$ = function (e) {
    var n,
      i = e.align,
      a = e.onClickOutside,
      c = e.children,
      s = e.className,
      l = e.panelWidthVariation,
      u = e.removePanelPadding,
      d = o(null),
      f = GC(d).isOutsideClick;
    return r(function () {
      f && a();
    }, [f]), /*#__PURE__*/t.createElement("div", {
      className: tC(s$.dropdownPanel, s, (n = {}, k(n, s$["align-".concat(i)], i), k(n, s$["width-".concat(l)], l), k(n, s$.noPadding, u), n)),
      ref: d
    }, c);
  };
l$.Link = qJ, l$.propTypes = {
  onClickOutside: g.func,
  align: g.oneOf(["bottomLeft", "bottomRight", "bottomCenter", "topRight", "topLeft"]),
  children: g.any,
  className: g.string,
  panelWidthVariation: g.oneOf(["auto", "s", "m", "l"]),
  forceMinWidth: g.bool,
  removePanelPadding: g.bool
}, l$.defaultProps = {
  align: "bottomLeft",
  panelWidthVariation: "auto",
  removePanelPadding: !1
};
var u$ = function (e) {
  var o = e.controlType,
    i = e.alignPanel,
    a = e.controlLabel,
    c = e.controlProps,
    s = e.panelContent,
    l = e.panelWidthVariation,
    u = e.closeMobileOverlay,
    d = e.forceDropdownIcon,
    f = e.removePanelPadding,
    p = e.onPanelClose,
    m = V(n(!1), 2),
    h = m[0],
    A = m[1],
    g = V(n(!1), 2),
    v = g[0],
    C = g[1],
    b = V(n(a), 2),
    E = b[0],
    y = b[1],
    I = V(n(!1), 2),
    B = I[0],
    x = I[1],
    w = V(n(!1), 2),
    Q = w[0],
    H = w[1];
  r(function () {
    ["nav-link", "nav-icon-link"].includes(o) && x(!0);
  }, [o]), r(function () {
    y(a);
  }, [a]), r(function () {
    !h && Q && p && p();
  }, [h]), r(function () {
    H(!0);
  }, []);
  var z = function () {
    return Array.isArray(s) ? s.map(function (e, n) {
      return e.addDivider ? /*#__PURE__*/t.createElement(Hb, {
        paddingBottom: "xs",
        paddingTop: "xxs"
      }) : /*#__PURE__*/t.createElement(l$.Link, {
        key: n,
        label: e.label,
        type: e.type,
        href: e.href,
        id: e.id,
        openNewTab: e.openNewTab,
        emphasize: e.emphasize,
        addPadding: e.addPadding,
        onClick: function () {
          e.onClick && e.onClick(), u && u(), A(!1);
        },
        isDanger: e.isDanger,
        ornament: e.ornament,
        icon: e.icon,
        iconPresetColor: e.icon,
        iconCustomColor: e.iconCustomColor,
        removeBorderRadius: e.removeBorderRadius
      });
    }) : s;
  };
  return /*#__PURE__*/t.createElement(RC, {
    className: tC(a$)
  }, "icon-button" === o ? /*#__PURE__*/t.createElement(WC, N({}, c, {
    onClick: function () {
      A(!h);
    },
    onClickOutside: function (e) {
      C(e);
    }
  }), E) : /*#__PURE__*/t.createElement(jC, N({}, c, {
    onClick: function () {
      A(!h);
    },
    onClickOutside: function (e) {
      C(e);
    },
    isDropdown: d
  }), E), B ? /*#__PURE__*/t.createElement(l$, {
    align: i,
    onClickOutside: function () {
      v && A(!1);
    },
    className: c$,
    panelWidthVariation: l,
    removePanelPadding: f
  }, Array.isArray(s) ? z() : s) : /*#__PURE__*/t.createElement(t.Fragment, null, h && /*#__PURE__*/t.createElement(l$, {
    align: i,
    onClickOutside: function () {
      v && A(!1);
    },
    panelWidthVariation: l,
    removePanelPadding: f
  }, Array.isArray(s) ? z() : s)));
};
u$.propTypes = {
  panelContent: g.oneOfType([g.array, g.node]).isRequired,
  controlType: g.oneOf(["call-to-action-button", "icon-button"]),
  controlProps: g.object,
  controlLabel: g.oneOfType([g.string, g.node]),
  alignPanel: g.oneOf(["bottomLeft", "bottomRight", "bottomCenter", "topRight", "topLeft"]),
  panelWidthVariation: g.oneOf(["auto", "s", "m", "l"]),
  closeMobileOverlay: g.func,
  forceDropdownIcon: g.bool,
  removePanelPadding: g.bool,
  onPanelClose: g.func
}, u$.defaultProps = {
  alignPanel: "bottomLeft",
  controlType: "call-to-action-button",
  controlLabel: "Select...",
  forceDropdownIcon: !0,
  removePanelPadding: !1
};
var d$ = "FormField-module_horizontalWrapper__36Fjc",
  f$ = function (e) {
    var n = e.labelText,
      r = e.inputType,
      o = e.inputProps,
      i = e.labelHtmlFor,
      a = e.labelAppendIcon,
      c = e.labelPrependIcon,
      s = e.labelMarkRequiredField,
      l = e.labelPosition,
      u = function () {
        return /*#__PURE__*/t.createElement(YM, {
          htmlFor: i,
          appendIcon: a,
          prependIcon: c,
          markRequiredField: s
        }, n);
      },
      d = function () {
        switch (r) {
          case "switch":
            return /*#__PURE__*/t.createElement(tk, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "currency":
            return /*#__PURE__*/t.createElement(mE, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "date-range":
            return /*#__PURE__*/t.createElement(AE, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              startDateId: i || (null == o ? void 0 : o.id)
            }));
          case "date":
            return /*#__PURE__*/t.createElement(pk, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              dateId: i || (null == o ? void 0 : o.id)
            }));
          case "incrementer":
            return /*#__PURE__*/t.createElement(xE, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "number":
            return /*#__PURE__*/t.createElement(SE, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "phone":
            return /*#__PURE__*/t.createElement(px, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "select":
            return /*#__PURE__*/t.createElement(lM, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "textarea":
            return /*#__PURE__*/t.createElement(kM, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          case "time":
            return /*#__PURE__*/t.createElement(yk, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
          default:
            return /*#__PURE__*/t.createElement(vM, N({}, o, {
              removeBottomSpacer: "top" !== l || (null == o ? void 0 : o.removeBottomSpacer),
              id: i || (null == o ? void 0 : o.id)
            }));
        }
      };
    return "top" === l ? /*#__PURE__*/t.createElement(t.Fragment, null, u(), d()) : /*#__PURE__*/t.createElement(sb, {
      gap: "s",
      flexDirection: "left" === l ? "row" : "row-reverse",
      alignItems: "center",
      className: d$
    }, /*#__PURE__*/t.createElement(nb, null, u()), /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      flex: "1"
    }, d()));
  };
f$.propTypes = {
  labelText: g.string,
  labelAppendIcon: g.node,
  labelPrependIcon: g.node,
  labelMarkRequiredField: g.bool,
  labelPosition: g.oneOf(["top", "left", "right"]),
  inputType: g.oneOf(["currency", "date-range", "incrementer", "number", "phone", "select", "text", "textarea", "switch", "date", "time"]),
  inputProps: g.object,
  labelHtmlFor: g.string
}, f$.defaultProps = {
  inputType: "text",
  labelPosition: "top"
};
var p$ = function (e) {
  var n = e.formFields,
    r = e.breakpoint,
    o = e.gap,
    i = Lb(),
    a = i.isTabletOrGreater,
    c = i.isDesktop,
    s = "tablet" === r ? a : c;
  return /*#__PURE__*/t.createElement(sb, {
    gap: s && "".concat(o),
    flexDirection: s ? "row" : "column"
  }, n && n.map(function (e, n) {
    var r = null != e && e.gridRowCellWidth ? null == e ? void 0 : e.gridRowCellWidth : null;
    return /*#__PURE__*/t.createElement(nb, {
      key: "form-field-grid-row-".concat(n),
      flex: r ? void 0 : "1",
      style: r && {
        width: r
      }
    }, "object" === M(e.component) && e.component.inputProps ? /*#__PURE__*/t.createElement(f$, e.component) : /*#__PURE__*/t.createElement(t.Fragment, null, e.component ? e.component : e));
  }));
};
p$.propTypes = {
  formFields: g.array,
  breakpoint: g.oneOf(["tablet", "desktop"]),
  gap: g.oneOf(["xxs", "xs", "s", "m", "l", "xl", "xxl"])
}, p$.defaultProps = {
  breakpoint: "tablet",
  gap: "s"
};
var m$ = "InputButtonGroup-module_adjustInputWrapper__3Gniw",
  h$ = "InputButtonGroup-module_adjustButton__1-EXj",
  A$ = function (e) {
    var n = e.isDense,
      r = e.inputType,
      o = e.inputProps,
      i = e.buttonType,
      a = e.buttonProps,
      c = e.buttonLabel,
      s = e.buttonIcon,
      l = e.removeBottomSpacer,
      u = e.inputDescription;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, null, function () {
      switch (r) {
        case "currency":
          return /*#__PURE__*/t.createElement(mE, N({}, o, {
            wrapperClassName: m$,
            isDense: n,
            description: "",
            removeBottomSpacer: !0
          }));
        case "number":
          return /*#__PURE__*/t.createElement(SE, N({}, o, {
            wrapperClassName: m$,
            isDense: n,
            description: "",
            removeBottomSpacer: !0
          }));
        default:
          return /*#__PURE__*/t.createElement(vM, N({}, o, {
            wrapperClassName: m$,
            isDense: n,
            description: "",
            removeBottomSpacer: !0
          }));
      }
    }(), /*#__PURE__*/t.createElement(sb, null, "icon-button" === i ? /*#__PURE__*/t.createElement(WC, N({
      className: h$,
      size: n ? "dense" : void 0
    }, a), s) : /*#__PURE__*/t.createElement(jC, N({
      className: h$,
      size: n ? "dense" : void 0
    }, a), c))), u && /*#__PURE__*/t.createElement(nb, {
      className: tC(Ub.description, k({}, Ub.isError, o.isError))
    }, u), !l && /*#__PURE__*/t.createElement(Qb, {
      size: "xs"
    }));
  };
A$.propTypes = {
  isDense: g.bool,
  inputType: g.oneOf(["text", "number", "currency"]),
  buttonType: g.oneOf(["call-to-action", "icon-button"]),
  inputProps: g.object,
  buttonProps: g.object,
  buttonLabel: g.string,
  buttonIcon: g.node,
  removeBottomSpacer: g.bool,
  inputDescription: g.string
}, A$.defaultProps = {
  buttonLabel: "Label",
  buttonIcon: /*#__PURE__*/t.createElement(qv, {
    name: "plus"
  }),
  buttonType: "call-to-action"
};
var g$ = {
    modal: "Modal-module_modal__3Xz-_",
    reveal: "Modal-module_reveal__3xLOV",
    "size-auto": "Modal-module_size-auto__30vsP",
    "size-s": "Modal-module_size-s__JSbkQ",
    "size-m": "Modal-module_size-m__5fYKZ",
    "size-l": "Modal-module_size-l__1bFt8",
    "size-xl": "Modal-module_size-xl__2XPbd",
    "size-cover": "Modal-module_size-cover__3P8Oi",
    "size-form": "Modal-module_size-form__3RKiL",
    fullHeight: "Modal-module_fullHeight__3RTDG",
    header: "Modal-module_header__3I3C_",
    minimal: "Modal-module_minimal__3XwOM",
    lightButton: "Modal-module_lightButton__2jgql",
    content: "Modal-module_content__1pGu_",
    contentBox: "Modal-module_contentBox__1I_uV",
    isScrollable: "Modal-module_isScrollable__2FSQ0",
    headlessCloseButton: "Modal-module_headlessCloseButton__1SO58",
    headerIcon: "Modal-module_headerIcon__2m42k"
  },
  v$ = function (e) {
    var r = e.contentIsScrollable,
      i = e.headlessCloseOnClick,
      a = e.children,
      c = o(),
      s = V(n(0), 2),
      l = s[0],
      u = s[1];
    return /*#__PURE__*/t.createElement(nb, {
      className: g$.content
    }, i && /*#__PURE__*/t.createElement(nb, {
      className: g$.headlessCloseButton
    }, /*#__PURE__*/t.createElement(WC, {
      onClick: i,
      variation: "secondary",
      appearance: "ghost",
      size: "dense"
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    }))), /*#__PURE__*/t.createElement(nb, {
      className: tC(g$.contentBox, k({}, g$.isScrollable, r)),
      domRef: c,
      onScroll: function () {
        var e = c.current.scrollTop;
        u(e);
      },
      style: r ? null : {
        marginTop: "-".concat(l, "px")
      }
    }, a));
  };
v$.propTypes = {
  contentIsScrollable: g.bool,
  headlessCloseOnClick: g.func
}, v$.defaultProps = {
  contentIsScrollable: !1
};
var C$ = {
    footer: "CallToActionBar-module_footer__1dm68",
    "height-m": "CallToActionBar-module_height-m__1_dTD",
    "height-s": "CallToActionBar-module_height-s__G1hhm",
    "height-xs": "CallToActionBar-module_height-xs__QJBRx",
    addBorder: "CallToActionBar-module_addBorder__29LjT",
    icon: "CallToActionBar-module_icon__2NpAZ"
  },
  b$ = function (e) {
    var n,
      r = e.primaryProps,
      o = e.secondaryProps,
      i = e.alignButtons,
      a = e.addBorder,
      c = e.horizontalPadding,
      s = e.verticalHeight,
      l = e.showSpinner,
      u = function (e, n) {
        return "button" === e.actionType ? /*#__PURE__*/t.createElement(jC, {
          onClick: e.action,
          variation: n,
          appearance: "primary" === n ? "filled" : "ghost",
          isDisabled: e.isDisabled,
          isFullWidth: e.isFullWidth,
          className: e.className,
          customTextColor: "primary" === n && e.customTextColor ? e.customTextColor : null,
          customButtonColor: "primary" === n && e.customButtonColor ? e.customButtonColor : null
        }, e.label) : /*#__PURE__*/t.createElement(KJ, {
          href: e.action,
          variation: n,
          appearance: "primary" === n ? "filled" : "ghost",
          isDisabled: e.isDisabled,
          type: e.linkType ? e.linkType : "router-link",
          isFullWidth: e.isFullWidth,
          className: e.className
        }, e.label);
      };
    return /*#__PURE__*/t.createElement(sb, {
      justifyContent: "flex-start",
      className: tC(C$.footer, (n = {}, k(n, C$.addBorder, a), k(n, C$["height-".concat(s)], s), n)),
      alignItems: "center",
      paddingHorizontal: c,
      flexDirection: "right" === i ? "row-reverse" : "row",
      gap: "xs",
      flexShrink: "0"
    }, r && r.action && u(r, "primary"), l && /*#__PURE__*/t.createElement(nb, {
      className: C$.icon
    }, /*#__PURE__*/t.createElement(qv, {
      name: "spinner",
      spin: !0
    })), o && o.action && u(o, "secondary"));
  };
b$.propTypes = {
  primaryProps: g.object,
  secondaryProps: g.object,
  alignButtons: g.oneOf(["left", "right"]),
  addBorder: g.bool,
  horizontalPadding: g.oneOf(["s", "m", "null"]),
  verticalHeight: g.oneOf(["xs", "s", "m", "null"]),
  showSpinner: g.bool
}, b$.defaultProps = {
  alignButtons: "left",
  addBorder: !0,
  horizontalPadding: "s",
  verticalHeight: "xs"
};
var E$ = function (e) {
  var n = e.primaryOnClick,
    r = e.primaryLabel,
    o = e.secondaryOnClick,
    i = e.secondaryLabel,
    a = e.alignButtons,
    c = e.primaryIsDisabled,
    s = e.secondaryIsDisabled,
    l = e.primaryCustomTextColor,
    u = e.primaryCustomButtonColor;
  return /*#__PURE__*/t.createElement(b$, {
    alignButtons: a,
    primaryProps: {
      actionType: "button",
      action: n,
      label: r,
      isDisabled: c,
      customButtonColor: u,
      customTextColor: l
    },
    secondaryProps: {
      actionType: "button",
      action: o,
      label: i,
      isDisabled: s
    }
  });
};
E$.propTypes = {
  primaryOnClick: g.func,
  primaryLabel: g.string,
  secondaryOnClick: g.func,
  secondaryLabel: g.string,
  alignButtons: g.oneOf(["left", "right"]),
  primaryIsDisabled: g.bool,
  secondaryIsDisabled: g.bool,
  primaryCustomButtonColor: g.string,
  primaryCustomTextColor: g.string
}, E$.defaultProps = {
  alignButtons: "left",
  primaryLabel: "Primary",
  secondaryLabel: "Secondary",
  primaryIsDisabled: !1,
  secondaryIsDisabled: !1
};
var y$ = function (e) {
  var n,
    r = e.reveal,
    o = e.title,
    i = e.closeOnClick,
    a = e.size,
    c = e.fullHeight,
    s = e.noHeader,
    l = e.children,
    u = e.variation,
    d = e.headerIcon;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(YC, {
    reveal: r,
    closeOnClick: i
  }), /*#__PURE__*/t.createElement(ob, {
    className: tC(g$.modal, (n = {}, k(n, g$.reveal, r), k(n, g$["size-".concat(a)], a), k(n, g$.fullHeight, c && "cover" !== a), n)),
    addShadow: !0
  }, !s && /*#__PURE__*/t.createElement(sb, {
    className: tC(g$.header, k({}, g$.minimal, "minimal" === u)),
    alignItems: "center",
    paddingLeft: "s",
    paddingRight: "xs"
  }, /*#__PURE__*/t.createElement(sb, {
    flexGrow: 1,
    gap: "s",
    alignItems: "center"
  }, d && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    className: g$.headerIcon
  }, d), /*#__PURE__*/t.createElement(Vb, {
    weight: "semibold",
    textColor: "minimal" === u ? "dark-gray" : "white",
    truncate: !0
  }, o || " ")), /*#__PURE__*/t.createElement(Qb, {
    size: "xs",
    direction: "horizontal"
  }), i && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center"
  }, /*#__PURE__*/t.createElement(WC, {
    onClick: i,
    variation: "secondary",
    appearance: "ghost",
    className: "default" === u ? g$.lightButton : null
  }, /*#__PURE__*/t.createElement(qv, {
    name: "times"
  })))), l));
};
y$.propTypes = {
  reveal: g.bool,
  title: g.string,
  closeOnClick: g.func,
  size: g.oneOf(["auto", "s", "m", "l", "xl", "cover", "form"]),
  fullHeight: g.bool,
  noHeader: g.bool,
  headerIcon: g.node,
  variation: g.oneOf(["default", "minimal"]),
  children: function (e, n) {
    var r = e[n],
      o = null;
    return t.Children.forEach(r, function (e) {
      e.type !== y$.Footer && e.type !== y$.Content && (o = new Error("'".concat(e.type, "' - Children of Modal should only be either <Modal.Content> or <Modal.Footer>")));
    }), o;
  }
}, y$.defaultProps = {
  size: "m",
  overlayClosesModal: !0,
  variation: "default"
}, y$.Content = v$, y$.Footer = E$;
var I$ = "navBar-module_navBar__1Cs14",
  B$ = function (e) {
    var n = e.children;
    return /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      className: I$
    }, n);
  };
B$.propTypes = {
  children: g.any
};
var x$ = "tabBar-module_tab-bar__2llSY",
  w$ = "tabBar-module_minimalist__2ll0R",
  Q$ = "tabBar-module_addScrollShadow__3mKoE",
  H$ = "tabBar-module_tab-bar-wrapper__1OZoT",
  z$ = function (e) {
    var n = e.minimalist,
      r = e.children;
    return /*#__PURE__*/t.createElement(sb, null, t.Children.map(r, function (e) {
      return /*#__PURE__*/t.cloneElement(e, {
        minimalist: n
      });
    }));
  };
z$.propTypes = {
  children: g.any,
  minimalist: g.bool
}, z$.defaultProps = {};
var M$ = function (e) {
  var o = e.id,
    i = e.children,
    a = e.justifyTabs,
    c = e.className,
    s = e.containerVariation,
    l = e.minimalist,
    u = V(n(!1), 2),
    d = u[0],
    f = u[1];
  return r(function () {
    var e = function (e, t) {
      var n,
        r = arguments,
        o = this;
      return function () {
        clearTimeout(n), n = setTimeout(function () {
          n = null, Reflect.apply(e, o, r);
        }, t);
      };
    }(function () {
      var e = document.querySelector(".tab-bar-scroll"),
        t = e.scrollWidth > e.clientWidth;
      f(t);
    }, 50);
    return window.addEventListener("resize", e), e(), function () {
      window.removeEventListener("resize", e);
    };
  }, []), /*#__PURE__*/t.createElement(nb, {
    setPositionRelative: !0,
    className: tC(k({}, Q$, d))
  }, /*#__PURE__*/t.createElement(RJ, {
    id: o,
    variation: s,
    className: tC(x$, "tab-bar-scroll", k({}, w$, l), c)
  }, /*#__PURE__*/t.createElement(sb, {
    className: H$,
    justifyContent: a,
    gap: l ? "xxs" : null
  }, i)));
};
M$.Tab = vZ, M$.TabGroup = z$, M$.propTypes = {
  children: g.any,
  justifyTabs: g.oneOf(["flex-start", "flex-end", "center", "space-between"]),
  containerVariation: g.oneOf(["extended", "fluid", "full-width"]),
  className: g.string,
  minimalist: g.bool,
  id: g.string
}, M$.defaultProps = {
  justifyTabs: "flex-start",
  containerVariation: "fluid"
};
var k$ = {
    "columns-size-1": "RadioButtonGrid-module_columns-size-1__2wx1u",
    "columns-size-2": "RadioButtonGrid-module_columns-size-2__2Wvq9",
    "columns-size-3": "RadioButtonGrid-module_columns-size-3__giKp9",
    "columns-size-4": "RadioButtonGrid-module_columns-size-4__22khF",
    "columns-size-5": "RadioButtonGrid-module_columns-size-5__2iRuC"
  },
  N$ = function (e) {
    var n = e.radioButtons,
      r = e.numberOfColumns,
      o = e.removeBottomSpacer,
      i = e.customColor;
    return /*#__PURE__*/t.createElement(sb, {
      flexWrap: "wrap",
      setPositionRelative: !0
    }, n && n.map(function (e, n) {
      return /*#__PURE__*/t.createElement(VM, {
        key: "radio-grid-".concat(n),
        onClick: function (t) {
          e.onClick(t);
        },
        className: k$["columns-size-".concat(r)],
        checked: null == e ? void 0 : e.checked,
        removeBottomSpacer: o,
        customColor: e.customColor || i || null
      }, e.label);
    }));
  };
N$.propTypes = {
  radioButtons: g.array.isRequired,
  numberOfColumns: g.oneOf(["1", "2", "3", "4", "5"]),
  removeBottomSpacer: g.bool,
  customColor: g.string
}, N$.defaultProps = {};
var S$ = "SideTabBar-module_sideTabBar__1u_zZ",
  V$ = "SideTabBar-module_sideTabBar__indicatorTrack__2OKla",
  L$ = "SideTabBar-module_sideTabBar__indicator__3CUKl",
  P$ = "SideTab-module_sideTab__3v5N_",
  O$ = "SideTab-module_isActive__3TrFL",
  T$ = "SideTab-module_isButton__1m_L7",
  D$ = function (e) {
    var n = e.children,
      i = e.linkType,
      a = e.href,
      c = e.onClick,
      s = e.openInNewTab,
      l = e.isActive,
      u = e.setIndicatorPosition,
      d = e.id,
      f = e.className,
      p = e.hashLinkScrollsSmooth,
      m = o(null);
    return r(function () {
      l && u && u(m.current.offsetTop);
    }, [l]), "button" === i ? /*#__PURE__*/t.createElement(RC, {
      domRef: m,
      renderAs: "li"
    }, /*#__PURE__*/t.createElement(RC, {
      id: d,
      renderAs: "button",
      type: "button",
      className: tC(P$, T$, f, k({}, O$, l)),
      onClick: c
    }, n)) : "router-hash-link" === i ? /*#__PURE__*/t.createElement(RC, {
      domRef: m,
      renderAs: "li"
    }, /*#__PURE__*/t.createElement(hZ, {
      id: d,
      to: a,
      onClick: c || null,
      className: tC(P$, k({}, O$, l), f),
      smooth: p
    }, n)) : "link" === i ? /*#__PURE__*/t.createElement(RC, {
      domRef: m,
      renderAs: "li"
    }, /*#__PURE__*/t.createElement(RC, {
      renderAs: "a",
      id: d,
      href: a,
      className: tC(P$, f, k({}, O$, l)),
      target: s ? "_blank" : void 0,
      rel: s ? "noreferrer nofollow" : void 0
    }, n)) : /*#__PURE__*/t.createElement(RC, {
      domRef: m,
      renderAs: "li"
    }, /*#__PURE__*/t.createElement(w, {
      id: d,
      to: a,
      onClick: c || null,
      className: tC(P$, f, k({}, O$, l))
    }, n));
  };
D$.propTypes = {
  children: g.any,
  linkType: g.oneOf(["link", "router-link", "button", "router-hash-link"]),
  href: g.string,
  onClick: g.func,
  openInNewTab: g.bool,
  isActive: g.bool,
  setIndicatorPosition: g.func,
  id: g.string,
  className: g.string,
  hashLinkScrollsSmooth: g.bool
}, D$.defaultProps = {
  linkType: "router-link"
};
var R$ = function (e) {
  var n = e.children,
    r = e.indicatorPosition,
    o = e.className;
  return /*#__PURE__*/t.createElement(nb, {
    renderAs: "ul",
    className: tC(S$, o)
  }, /*#__PURE__*/t.createElement(nb, {
    className: V$
  }, /*#__PURE__*/t.createElement(nb, {
    className: L$,
    style: {
      top: r
    }
  })), n);
};
R$.propTypes = {
  children: g.any,
  indicatorPosition: g.number,
  className: g.string
}, R$.defaultProps = {}, R$.Tab = D$;
var G$ = {
    pageHeader: "PageHeader-module_pageHeader__27Tvn",
    "height-m": "PageHeader-module_height-m__1rJn3",
    "height-l": "PageHeader-module_height-l__1Anob",
    pageTitle: "PageHeader-module_pageTitle__2V9DF",
    breadcrumbs: "PageHeader-module_breadcrumbs__2WP57",
    icon: "PageHeader-module_icon__2Sg7F",
    headerLeft: "PageHeader-module_headerLeft__2yvap"
  },
  F$ = function (e) {
    var n = e.breadcrumbs,
      r = e.children,
      o = e.backLinkHref,
      i = e.backLinkType,
      a = Lb().isMobile;
    return /*#__PURE__*/t.createElement(sb, {
      flex: "1",
      flexDirection: "column",
      className: G$.headerLeft
    }, n && /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      gap: "s",
      className: G$.breadcrumbs
    }, a ? /*#__PURE__*/t.createElement(MJ, null, n[n.length - 1].label) : /*#__PURE__*/t.createElement(t.Fragment, null, n.map(function (e, r) {
      return r === n.length - 1 ? /*#__PURE__*/t.createElement(MJ, {
        key: "breadcrumb-".concat(r),
        weight: "bold"
      }, e.label) : /*#__PURE__*/t.createElement(t.Fragment, {
        key: "breadcrumb-".concat(r)
      }, /*#__PURE__*/t.createElement(w, {
        to: e.href
      }, /*#__PURE__*/t.createElement(MJ, {
        weight: "regular"
      }, e.label)), /*#__PURE__*/t.createElement(MJ, {
        className: G$.icon
      }, /*#__PURE__*/t.createElement(qv, {
        name: "chevronRight"
      })));
    }))), /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      gap: "xs"
    }, o && /*#__PURE__*/t.createElement(xZ, {
      href: o,
      appearance: "ghost",
      type: i
    }, /*#__PURE__*/t.createElement(qv, {
      name: "arrowLeft"
    })), /*#__PURE__*/t.createElement(TW, {
      truncate: !0,
      className: G$.pageTitle
    }, r)));
  };
F$.propTypes = {
  breadcrumbs: g.array,
  children: g.any,
  backLinkType: g.oneOf(["link", "router-link"]),
  backLinkHref: g.string
}, F$.defaultProps = {
  backLinkType: "router-link"
};
var j$ = function (e) {
  var n = e.children;
  return /*#__PURE__*/t.createElement(sb, {
    gap: "xs"
  }, n);
};
j$.propTypes = {
  children: g.any
};
var J$ = function (e) {
  var n = e.containerVariation,
    r = e.height,
    o = e.children;
  return /*#__PURE__*/t.createElement(RJ, {
    variation: n
  }, /*#__PURE__*/t.createElement(sb, {
    gap: "m",
    alignItems: "center",
    className: tC(G$.pageHeader, k({}, G$["height-".concat(r)], r))
  }, o));
};
J$.propTypes = {
  containerVariation: g.oneOf(["extended", "fluid", "full-width"]),
  height: g.oneOf(["m", "l"]),
  children: g.any
}, J$.defaultProps = {
  containerVariation: "extended",
  height: "m"
}, J$.Left = F$, J$.Right = j$;
var Z$ = "SearchBar-module_separator__2XCNQ",
  W$ = function (e) {
    var o = e.removeBottomSpacer,
      i = e.description,
      a = e.inputTextProps,
      c = e.inputSelectProps,
      s = e.isDisabled,
      l = e.isDense,
      u = e.isError,
      d = e.selectWidth,
      f = e.width,
      p = e.containerClassName,
      m = e.onIsActive,
      h = e.isSubtle,
      A = V(n(!1), 2),
      g = A[0],
      v = A[1];
    return r(function () {
      m && m(g);
    }, [g]), /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(qb, {
      isActive: g,
      removeBottomSpacer: o,
      description: i,
      isDisabled: s,
      isError: u,
      inputWidth: f,
      className: p
    }, c && /*#__PURE__*/t.createElement(nb, {
      style: d && {
        width: d
      }
    }, /*#__PURE__*/t.createElement(lM, N({}, c, {
      removeInputWrapper: !0,
      onMenuClose: function () {
        v(!1), c.onMenuClose && c.onMenuClose();
      },
      onMenuOpen: function () {
        v(!0), c.onMenuOpen && c.onMenuOpen();
      },
      isDisabled: s,
      isDense: l,
      removeIndicatorSeparator: !0
    }))), /*#__PURE__*/t.createElement(sb, {
      flex: "1",
      className: c && Z$
    }, /*#__PURE__*/t.createElement(vM, N({}, a, {
      removeInputWrapper: !0,
      onBlur: function () {
        v(!1), a.onBlur && a.onBlur();
      },
      onFocus: function () {
        v(!0), a.onFocus && a.onFocus();
      },
      isDisabled: s,
      isDense: l,
      prependIcon: h ? /*#__PURE__*/t.createElement(nb, {
        style: {
          color: "#A0A2AF"
        }
      }, /*#__PURE__*/t.createElement(qv, {
        name: "search"
      })) : /*#__PURE__*/t.createElement(qv, {
        name: "search"
      })
    })))));
  };
W$.propTypes = {
  containerClassName: g.string,
  isDisabled: g.bool,
  inputSelectProps: g.object,
  inputTextProps: g.object,
  removeBottomSpacer: g.bool,
  description: g.string,
  isDense: g.bool,
  isError: g.bool,
  selectWidth: g.oneOfType([g.number, g.string]),
  width: g.oneOf(["pct-quarter", "pct-half", "pct-three-quarter", "auto", "xs", "s", "m", "l", "xl"]),
  onIsActive: g.func
};
var X$ = "SlideoutPanel-module_panel__1QdFq",
  U$ = "SlideoutPanel-module_navWidth__3sC51",
  K$ = "SlideoutPanel-module_reveal__2kWOy",
  Y$ = "SlideoutPanel-module_header__2Hd7s",
  q$ = "SlideoutPanel-module_minimal__3F8sI",
  _$ = "SlideoutPanel-module_removeHeader__RRRVR",
  $$ = "SlideoutPanel-module_navPadding__1tyYu",
  e1 = "SlideoutPanel-module_closeButton__1_a0U",
  t1 = "SlideoutPanel-module_contentWrapper__CmsLs",
  n1 = "SlideoutPanel-module_contentTopShadow__1NCjo",
  r1 = "SlideoutPanel-module_contentBottomShadow__2GWzR",
  o1 = "SlideoutPanel-module_adjustForFooter__12tcl",
  i1 = "SlideoutPanel-module_content__1RCg3",
  a1 = "SlideoutPanel-module_removeSidePadding__3RBpm",
  c1 = "SlideoutPanel-module_removeTopPadding__5DAdj",
  s1 = "SlideoutPanel-module_removePadding__P-akY",
  l1 = "SlideoutPanel-module_scrollContent__2WQ_T",
  u1 = "SlideoutPanel-module_headerIcon__1_Au_",
  d1 = function (t, n) {
    var r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
      o = e.useState(),
      i = V(o, 2),
      a = i[0],
      c = i[1];
    return e.useLayoutEffect(function () {
      var e = t.current,
        o = function () {
          var t = r ? e.scrollWidth > e.clientWidth : e.scrollHeight > e.clientHeight;
          c(t), n && n(t);
        };
      e && ("ResizeObserver" in window && new ResizeObserver(o).observe(e), o());
    }, [n, t]), a;
  },
  f1 = function (e) {
    var i,
      a,
      c,
      s,
      l = e.reveal,
      u = e.children,
      d = e.primaryActionProps,
      f = e.secondaryActionProps,
      p = e.closeButtonOnClick,
      m = e.removeContentSidePadding,
      h = e.removeContentTopPadding,
      A = e.removeContentPadding,
      g = e.contentIsScrollable,
      v = e.closeOnClickOutside,
      C = e.title,
      b = e.mobileModalSize,
      E = e.variation,
      y = e.headerIcon,
      I = e.modalOnMobile,
      B = e.removeHeaderBorder,
      x = Lb(),
      w = x.isMobile,
      Q = x.height,
      H = o(),
      z = d1(H),
      M = V(n(!1), 2),
      N = M[0],
      S = M[1],
      L = V(n(!1), 2),
      P = L[0],
      O = L[1],
      T = V(n(!0), 2),
      D = T[0],
      R = T[1];
    return r(function () {
      D && z && (O(!0), R(!1));
    }, [z]), w && I ? /*#__PURE__*/t.createElement(y$, {
      reveal: l,
      closeOnClick: p,
      title: C,
      size: b,
      variation: E
    }, /*#__PURE__*/t.createElement(y$.Content, {
      contentIsScrollable: g
    }, /*#__PURE__*/t.createElement(nb, {
      className: tC(i1, (s = {}, k(s, a1, m), k(s, c1, h), k(s, s1, A), k(s, l1, g), s))
    }, u)), (d || f) && /*#__PURE__*/t.createElement(y$.Footer, {
      primaryLabel: d.label,
      primaryOnClick: d.action,
      primaryIsDisabled: d.isDisabled,
      primaryCustomButtonColor: d.customButtonColor,
      primaryCustomTextColor: d.customTextColor,
      secondaryLabel: f.label,
      secondaryOnClick: f.action,
      secondaryIsDisabled: f.isDisabled
    })) : /*#__PURE__*/t.createElement(t.Fragment, null, v && /*#__PURE__*/t.createElement(YC, {
      reveal: l,
      color: "transparent",
      zIndex: "navigation",
      position: "fixed",
      closeOnClick: p
    }), /*#__PURE__*/t.createElement(nb, {
      className: tC(X$, (i = {}, k(i, K$, l), k(i, U$, "side-navigation" === E), i)),
      style: {
        height: Q
      }
    }, /*#__PURE__*/t.createElement(sb, {
      className: t1,
      flexDirection: "column"
    }, N && /*#__PURE__*/t.createElement(nb, {
      className: n1
    }), P && /*#__PURE__*/t.createElement(nb, {
      className: tC(r1, k({}, o1, d || f))
    }), /*#__PURE__*/t.createElement(sb, {
      paddingVertical: "xxs",
      alignItems: "center",
      className: tC(Y$, (a = {}, k(a, q$, "minimal" === E || "side-navigation" === E), k(a, $$, "side-navigation" === E), k(a, _$, B), a)),
      gap: "xs"
    }, y && /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      className: u1
    }, y), /*#__PURE__*/t.createElement(sb, {
      flex: "1",
      alignItems: "center",
      style: {
        minWidth: 0
      }
    }, C ? /*#__PURE__*/t.createElement(PW, {
      textColor: "minimal" === E || "side-navigation" === E ? "dark-gray" : "white",
      truncate: !0
    }, C) : " "), /*#__PURE__*/t.createElement(WC, {
      onClick: p,
      variation: "secondary",
      appearance: "ghost",
      className: "default" === E ? e1 : null
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    }))), /*#__PURE__*/t.createElement("div", {
      className: tC(i1, (c = {}, k(c, a1, m), k(c, c1, h), k(c, s1, A), k(c, l1, g), c)),
      ref: H,
      onScroll: function () {
        var e = H.current,
          t = e.scrollHeight,
          n = e.scrollTop,
          r = e.clientHeight;
        z && n > 0 && !N ? S(!0) : z && 0 === n && N && S(!1), z && n + r === t ? P && O(!1) : P || O(!0);
      }
    }, u), (d || f) && /*#__PURE__*/t.createElement(b$, {
      primaryProps: d,
      secondaryProps: f,
      horizontalPadding: "m"
    }))));
  };
f1.propTypes = {
  reveal: g.bool,
  children: g.any,
  closeButtonOnClick: g.func,
  primaryActionProps: g.object,
  secondaryActionProps: g.object,
  removeContentSidePadding: g.bool,
  removeContentTopPadding: g.bool,
  removeContentPadding: g.bool,
  contentIsScrollable: g.bool,
  closeOnClickOutside: g.bool,
  title: g.string,
  modalOnMobile: g.bool,
  mobileModalSize: g.oneOf(["auto", "s", "m", "l", "xl", "cover", "form"]),
  variation: g.oneOf(["default", "minimal", "side-navigation"]),
  headerIcon: g.node,
  removeHeaderBorder: g.bool
}, f1.defaultProps = {
  contentIsScrollable: !0,
  closeOnClickOutside: !0,
  mobileModalSize: "cover",
  variation: "default",
  modalOnMobile: !0
};
var p1 = {
    icon: "StandByOverlay-module_icon__3jy4Q",
    "preset-color-blue": "StandByOverlay-module_preset-color-blue__3gFyS",
    "preset-color-purple": "StandByOverlay-module_preset-color-purple__1IjgI",
    "preset-color-green": "StandByOverlay-module_preset-color-green__2NocN",
    "preset-color-yellow": "StandByOverlay-module_preset-color-yellow__w4rUd",
    "preset-color-red": "StandByOverlay-module_preset-color-red__2s_w4",
    content: "StandByOverlay-module_content__2wwAy",
    reveal: "StandByOverlay-module_reveal__1hrYn",
    "position-fixed": "StandByOverlay-module_position-fixed__xE8lz",
    "position-absolute": "StandByOverlay-module_position-absolute__2F4df",
    "zIndex-navigation": "StandByOverlay-module_zIndex-navigation__1-Scy",
    "zIndex-modals": "StandByOverlay-module_zIndex-modals__3O1NX",
    "zIndex-preloaders": "StandByOverlay-module_zIndex-preloaders__1J4jV",
    "zIndex-everything": "StandByOverlay-module_zIndex-everything__2iYyq",
    innerContent: "StandByOverlay-module_innerContent__3rxaX",
    actionWrapper: "StandByOverlay-module_actionWrapper__3ckyd"
  },
  m1 = function (e) {
    var n,
      r = e.reveal,
      o = e.position,
      i = e.top,
      a = e.right,
      c = e.bottom,
      s = e.left,
      l = e.zIndex,
      u = e.icon,
      d = e.iconPresetColor,
      f = e.iconCustomColor,
      p = e.headline,
      m = e.description,
      h = e.actionLabel,
      A = e.actionOnClick,
      g = e.actionHref,
      v = e.actionIcon,
      C = e.closeOnClick,
      b = e.freezeBody,
      E = {};
    return i && (E = z(z({}, E), {}, {
      top: i
    })), a && (E = z(z({}, E), {}, {
      right: a
    })), c && (E = z(z({}, E), {}, {
      bottom: c
    })), s && (E = z(z({}, E), {}, {
      left: s
    })), /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(YC, {
      color: "white",
      reveal: r,
      position: o,
      top: i,
      right: a,
      bottom: c,
      left: s,
      zIndex: l,
      closeOnClick: C,
      freezeBody: b
    }), /*#__PURE__*/t.createElement(sb, {
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      className: tC(p1.content, (n = {}, k(n, p1.reveal, r), k(n, p1["position-".concat(o)], o), k(n, p1["zIndex-".concat(l)], l), n)),
      style: E
    }, /*#__PURE__*/t.createElement(nb, {
      className: tC(p1.innerContent, k({}, p1.reveal, r))
    }, /*#__PURE__*/t.createElement(nb, {
      style: f ? {
        color: f
      } : {},
      className: tC(p1.icon, k({}, p1["preset-color-".concat(d)], d))
    }, u || /*#__PURE__*/t.createElement(qv, {
      name: "spinner",
      spin: !0
    })), p && /*#__PURE__*/t.createElement(nb, {
      paddingTop: "xxs"
    }, /*#__PURE__*/t.createElement(PW, {
      isFullWidth: !0,
      textAlign: "center"
    }, p)), m && /*#__PURE__*/t.createElement(nb, {
      paddingTop: "xxs"
    }, /*#__PURE__*/t.createElement(Vb, {
      isFullWidth: !0,
      textAlign: "center"
    }, m)), g || A && /*#__PURE__*/t.createElement(nb, {
      paddingTop: "m",
      className: p1.actionWrapper
    }, g && /*#__PURE__*/t.createElement(KJ, {
      href: g,
      appearance: "outline",
      variation: "secondary",
      prependIcon: v || null
    }, h), A && /*#__PURE__*/t.createElement(jC, {
      onClick: A,
      appearance: "outline",
      variation: "secondary",
      prependIcon: v || null
    }, h)))));
  };
m1.propTypes = {
  reveal: g.bool,
  color: g.oneOf(["white", "white-opaque"]),
  position: g.oneOf(["absolute", "fixed"]),
  top: g.oneOfType([g.number, g.string]),
  right: g.oneOfType([g.number, g.string]),
  bottom: g.oneOfType([g.number, g.string]),
  left: g.oneOfType([g.number, g.string]),
  zIndex: g.oneOf(["navigation", "modals", "preloaders", "everything"]),
  icon: g.node,
  iconPresetColor: g.oneOf(["blue", "purple", "green", "yellow", "red"]),
  iconCustomColor: g.string,
  headline: g.string,
  description: g.string,
  actionLabel: g.string,
  actionOnClick: g.func,
  actionHref: g.string,
  actionIcon: g.node,
  closeOnClick: g.func,
  freezeBody: g.bool
}, m1.defaultProps = {
  iconPresetColor: "purple",
  zIndex: "modals",
  position: "fixed",
  color: "white",
  actionLabel: "Action",
  freezeBody: !0
};
var h1 = function (e) {
  var r = e.children,
    o = e.triggerLabel,
    i = e.triggerType,
    a = e.triggerProps,
    c = e.primaryActionProps,
    s = e.switchToBottomSheetAt,
    l = e.dropdownWidth,
    u = e.dropdownAlignment,
    d = e.showSpinner,
    f = e.onPopoverClose,
    p = e.hideActionBar,
    m = e.mobileBottomSheetProps,
    h = Lb(),
    A = h.isMobile,
    g = h.isTouch,
    v = V(n(!1), 2),
    C = v[0],
    b = v[1],
    E = "mobile" === s ? A : g,
    y = z(z({
      label: "Update",
      actionType: "button"
    }, c), {}, {
      action: function () {
        null != c && c.action && c.action();
      },
      isFullWidth: E
    });
  return E ? /*#__PURE__*/t.createElement(t.Fragment, null, "call-to-action-button" === i ? /*#__PURE__*/t.createElement(jC, N({}, a, {
    onClick: function () {
      return b(!0);
    }
  }), o) : /*#__PURE__*/t.createElement(WC, N({}, a, {
    onClick: function () {
      return b(!0);
    }
  }), o), /*#__PURE__*/t.createElement(__, N({
    reveal: C,
    onDismiss: function () {
      b(!1), f && f();
    },
    footer: p ? null : /*#__PURE__*/t.createElement(b$, {
      primaryProps: y,
      verticalHeight: "null",
      horizontalPadding: "null",
      addBorder: !1,
      showSpinner: d
    })
  }, m), /*#__PURE__*/t.createElement(nb, {
    padding: "s"
  }, r))) : /*#__PURE__*/t.createElement(u$, {
    controlLabel: o,
    controlType: i,
    controlProps: a,
    panelWidthVariation: l,
    panelContent: /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
      padding: "s"
    }, r), !p && /*#__PURE__*/t.createElement(b$, {
      primaryProps: y,
      verticalHeight: "s",
      showSpinner: d
    })),
    alignPanel: u,
    forceDropdownIcon: !1,
    removePanelPadding: !0,
    onPanelClose: f
  });
};
h1.propTypes = {
  children: g.any,
  triggerLabel: g.oneOfType([g.node, g.string]),
  triggerType: g.oneOf(["call-to-action-button", "icon-button"]),
  triggerProps: g.object,
  primaryActionProps: g.object,
  showSpinner: g.bool,
  switchToBottomSheetAt: g.oneOf(["mobile", "tablet"]),
  dropdownWidth: g.oneOf(["auto", "s", "m"]),
  dropdownAlignment: g.oneOf(["bottomLeft", "bottomRight", "bottomCenter", "topRight", "topLeft"]),
  onPopoverClose: g.func,
  hideActionBar: g.bool,
  mobileBottomSheetProps: g.shape({
    snapPoints: g.func
  })
}, h1.defaultProps = {
  switchToBottomSheetAt: "mobile",
  dropdownWidth: "m",
  triggerType: "call-to-action-button",
  triggerLabel: "Popover Form",
  dropdownAlignment: "bottomCenter",
  hideActionBar: !1,
  mobileBottomSheetProps: {}
};
var A1 = "EditableLineItem-module_spinner__QHYvD",
  g1 = function (e) {
    var r = e.label,
      o = e.displayValue,
      i = e.inputType,
      a = e.inputProps,
      c = e.customDisplayView,
      s = e.customEditView,
      l = e.primaryActionLabel,
      u = e.primaryActionType,
      d = e.primaryActionEventProps,
      f = e.primaryActionClassname,
      p = e.editDescription,
      m = e.secondaryActionIconName,
      h = e.secondaryActionTooltip,
      A = e.secondaryActionType,
      g = e.secondaryActionEvent,
      v = e.saveAction,
      C = e.saveIsDisabled,
      b = e.saveActionClassname,
      E = e.editInfoPanelProps,
      y = e.showSpinner,
      I = e.fullWidthEditView,
      B = V(n(!1), 2),
      x = B[0],
      w = B[1];
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
      alignItems: "flex-start",
      paddingVertical: "m",
      gap: "s",
      setPositionRelative: !0
    }, x ? /*#__PURE__*/t.createElement(nb, {
      flex: "1"
    }, /*#__PURE__*/t.createElement(ob, null, /*#__PURE__*/t.createElement(sb, {
      paddingHorizontal: "s",
      alignItems: "center",
      paddingTop: "s",
      gap: "s"
    }, /*#__PURE__*/t.createElement(nb, {
      flex: "1"
    }, /*#__PURE__*/t.createElement(Vb, {
      weight: "semibold",
      textColor: "dark-gray"
    }, r)), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(WC, {
      onClick: function () {
        return w(!1);
      },
      variation: "secondary",
      appearance: "ghost",
      size: "dense"
    }, /*#__PURE__*/t.createElement(qv, {
      name: "times"
    })))), /*#__PURE__*/t.createElement(nb, {
      paddingHorizontal: "s",
      paddingTop: "s",
      paddingBottom: "xs"
    }, /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    }), E && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(zZ, E), /*#__PURE__*/t.createElement(Qb, null)), /*#__PURE__*/t.createElement(nb, {
      style: I ? null : {
        maxWidth: 500
      }
    }, p && /*#__PURE__*/t.createElement(t.Fragment, null, "string" == typeof p || p instanceof String ? /*#__PURE__*/t.createElement(Vb, null, p) : p, /*#__PURE__*/t.createElement(Qb, {
      size: "xs"
    })), s || /*#__PURE__*/t.createElement(t.Fragment, null, a && function () {
      switch (i) {
        case "radio-buttons":
          return /*#__PURE__*/t.createElement(N$, N({}, a, {
            numberOfColumns: "1"
          }));
        case "currency":
          return /*#__PURE__*/t.createElement(mE, a);
        case "date-range":
          return /*#__PURE__*/t.createElement(AE, a);
        case "date":
          return /*#__PURE__*/t.createElement(pk, a);
        case "incrementer":
          return /*#__PURE__*/t.createElement(xE, a);
        case "phone":
          return /*#__PURE__*/t.createElement(px, a);
        case "richTextarea":
          return /*#__PURE__*/t.createElement(Dj, a);
        case "textarea":
          return /*#__PURE__*/t.createElement(kM, a);
        case "select":
          return /*#__PURE__*/t.createElement(lM, a);
        case "time":
          return /*#__PURE__*/t.createElement(yk, a);
        case "number":
          return /*#__PURE__*/t.createElement(SE, a);
        default:
          return /*#__PURE__*/t.createElement(vM, a);
      }
    }()))), /*#__PURE__*/t.createElement(b$, {
      horizontalPadding: "s",
      primaryProps: {
        action: function () {
          v && v(), w(!1);
        },
        label: "Save",
        actionType: "button",
        isDisabled: C,
        className: b
      },
      secondaryProps: {
        action: function () {
          return w(!1);
        },
        label: "Cancel",
        actionType: "button"
      }
    }))) : /*#__PURE__*/t.createElement(t.Fragment, null, y && /*#__PURE__*/t.createElement(sb, {
      className: A1
    }, /*#__PURE__*/t.createElement(qv, {
      name: "spinner",
      spin: !0
    })), /*#__PURE__*/t.createElement(nb, {
      flex: "1",
      isTextTruncateWrapper: !0
    }, r && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Vb, {
      weight: "semibold",
      textColor: "dark-gray",
      truncate: !0,
      verticalAlign: "middle"
    }, r), /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    })), c || /*#__PURE__*/t.createElement(t.Fragment, null, o && /*#__PURE__*/t.createElement(nb, {
      style: {
        marginTop: -4
      }
    }, o))), /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      gap: "xs"
    }, A && m && function () {
      var e = h ? Pj : t.Fragment;
      switch (A) {
        case "router-link":
          return /*#__PURE__*/t.createElement(e, {
            tipContent: h
          }, /*#__PURE__*/t.createElement(xZ, {
            href: g,
            variation: "secondary",
            appearance: "ghost",
            size: "dense",
            type: "router-link"
          }, /*#__PURE__*/t.createElement(qv, {
            name: m
          })));
        case "link":
          return /*#__PURE__*/t.createElement(e, {
            tipContent: h
          }, /*#__PURE__*/t.createElement(xZ, {
            href: g,
            variation: "secondary",
            appearance: "ghost",
            size: "dense",
            type: "link",
            openNewTab: !0
          }, /*#__PURE__*/t.createElement(qv, {
            name: m
          })));
        default:
          return /*#__PURE__*/t.createElement(e, {
            tipContent: h
          }, /*#__PURE__*/t.createElement(WC, {
            onClick: function () {
              g && g();
            },
            variation: "secondary",
            appearance: "ghost",
            size: "dense"
          }, /*#__PURE__*/t.createElement(qv, {
            name: m
          })));
      }
    }(), "none" !== u && /*#__PURE__*/t.createElement(nb, null, function () {
      switch (u) {
        case "switch":
          return /*#__PURE__*/t.createElement(tk, {
            onChange: d.action,
            removeBottomSpacer: !0,
            isChecked: d.switchIsChecked,
            isDisabled: d.switchIsDisabled
          });
        case "router-link":
          return /*#__PURE__*/t.createElement(KJ, {
            href: d.action,
            variation: "secondary",
            appearance: "outline",
            size: "dense",
            type: "router-link",
            className: f
          }, l);
        case "link":
          return /*#__PURE__*/t.createElement(KJ, {
            href: d.action,
            variation: "secondary",
            appearance: "outline",
            size: "dense",
            type: "link",
            openNewTab: !0,
            className: f
          }, l);
        default:
          return /*#__PURE__*/t.createElement(jC, {
            onClick: function () {
              d && null != d && d.action ? d.action() : w(!0);
            },
            variation: "secondary",
            appearance: "outline",
            size: "dense",
            isDisabled: y,
            className: f
          }, l);
      }
    }())))), /*#__PURE__*/t.createElement(Hb, null));
  };
g1.propTypes = {
  label: g.string,
  displayValue: g.string,
  editDescription: g.oneOfType([g.string, g.node]),
  editInfoPanelProps: g.object,
  showSpinner: g.bool,
  inputType: g.oneOf(["currency", "date-range", "incrementer", "number", "phone", "select", "text", "textarea", "switch", "date", "time", "richTextarea", "radio-buttons"]),
  inputProps: g.object,
  customDisplayView: g.node,
  customEditView: g.node,
  saveAction: g.func,
  saveActionClassname: g.string,
  saveIsDisabled: g.bool,
  primaryActionLabel: g.string,
  primaryActionType: g.oneOf(["link", "router-link", "button", "switch", "none"]),
  primaryActionEventProps: g.shape({
    action: g.oneOfType([g.string, g.func]),
    switchIsChecked: g.bool,
    switchIsDisabled: g.bool
  }),
  primaryActionClassname: g.string,
  secondaryActionIconName: g.string,
  secondaryActionTooltip: g.string,
  secondaryActionType: g.oneOf(["router-link", "link", "button"]),
  secondaryActionEvent: g.oneOfType([g.string, g.func]),
  fullWidthEditView: g.bool
}, g1.defaultProps = {
  primaryActionLabel: "Edit",
  primaryActionType: "button"
};
var v1 = function (e) {
  var r = e.inputProps,
    o = e.inputType,
    i = e.inlineEditOnSubmit,
    a = e.inlineEditOnCancel,
    c = e.displayValue,
    s = e.removeBottomSpacer,
    l = e.isDense,
    u = e.inlineEditSubmitIsDisabled,
    d = V(n(!1), 2),
    f = d[0],
    p = d[1];
  return f ? function () {
    switch (o) {
      case "currency":
        return /*#__PURE__*/t.createElement(mE, N({}, r, {
          inlineEditOnSubmit: function () {
            i && i(), p(!1);
          },
          inlineEditOnCancel: function () {
            a && a(), p(!1);
          },
          removeBottomSpacer: s,
          isDense: l,
          inlineEditSubmitIsDisabled: u
        }));
      case "phone":
        return /*#__PURE__*/t.createElement(px, N({}, r, {
          inlineEditOnSubmit: function () {
            i && i(), p(!1);
          },
          inlineEditOnCancel: function () {
            a && a(), p(!1);
          },
          removeBottomSpacer: s,
          isDense: l,
          inlineEditSubmitIsDisabled: u
        }));
      case "number":
        return /*#__PURE__*/t.createElement(SE, N({}, r, {
          inlineEditOnSubmit: function () {
            i && i(), p(!1);
          },
          inlineEditOnCancel: function () {
            a && a(), p(!1);
          },
          removeBottomSpacer: s,
          isDense: l,
          inlineEditSubmitIsDisabled: u
        }));
      default:
        return /*#__PURE__*/t.createElement(vM, N({}, r, {
          inlineEditOnSubmit: function () {
            i && i(), p(!1);
          },
          inlineEditOnCancel: function () {
            a && a(), p(!1);
          },
          removeBottomSpacer: s,
          isDense: l,
          inlineEditSubmitIsDisabled: u
        }));
    }
  }() : /*#__PURE__*/t.createElement(jC, {
    onClick: function () {
      return p(!0);
    },
    appearance: "ghost",
    variation: "secondary",
    size: l ? "dense" : "default"
  }, c);
};
v1.propTypes = {
  inputProps: g.object,
  inputType: g.oneOf(["currency", "number", "phone", "text"]),
  inlineEditOnSubmit: g.func,
  inlineEditOnCancel: g.func,
  displayValue: g.oneOfType([g.string, g.number]),
  removeBottomSpacer: g.bool,
  isDense: g.bool,
  inlineEditSubmitIsDisabled: g.bool
}, v1.defaultProps = {
  inputType: "text"
};
var C1 = "FileUploadTray-module_fileUploadTray__1IwOU",
  b1 = "FileUploadTray-module_wrapper__bVdO5",
  E1 = "FileUploadTray-module_scrollWrapper__1ir5k",
  y1 = "FileUploadTray-module_addShadow__oNB3M",
  I1 = {
    filePreview: "FilePreview-module_filePreview__mPein",
    "aspect-ratio-square": "FilePreview-module_aspect-ratio-square__HHZL4",
    "size-s": "FilePreview-module_size-s__OalLp",
    "size-m": "FilePreview-module_size-m__2CRbt",
    "size-l": "FilePreview-module_size-l__bDGg1",
    "aspect-ratio-block": "FilePreview-module_aspect-ratio-block__3GjAv",
    "aspect-ratio-wide": "FilePreview-module_aspect-ratio-wide__1_SsY",
    isImage: "FilePreview-module_isImage__3sWg1",
    filePreview__panel: "FilePreview-module_filePreview__panel__DmECP",
    filePreview__closeButton: "FilePreview-module_filePreview__closeButton__r8toA",
    filePreview__icon: "FilePreview-module_filePreview__icon__1zLGV",
    filePreview__name: "FilePreview-module_filePreview__name__pgCEP"
  },
  B1 = function (e) {
    var n = e.fileType,
      r = e.onRemoveFile,
      o = e.fileImageSrc,
      i = e.size,
      a = e.fileName,
      c = e.aspectRatio,
      s = function () {
        switch (n) {
          case "pdf":
            return "filePdf";
          case "excel":
            return "fileExcel";
          case "word":
            return "fileWord";
          case "csv":
            return "fileCsv";
          case "video":
            return "fileVideo";
          case "doc":
            return "fileDoc";
          default:
            return "file";
        }
      },
      l = function () {
        var e;
        return /*#__PURE__*/t.createElement(ob, {
          className: I1.filePreview__panel
        }, /*#__PURE__*/t.createElement(sb, {
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          paddingHorizontal: "xs",
          className: tC(I1.filePreview, (e = {}, k(e, I1["file-type-".concat(n)], n), k(e, I1.isImage, "image" === n), k(e, I1["size-".concat(i)], i), k(e, I1["aspect-ratio-".concat(c)], c), e)),
          setPositionRelative: !0,
          style: "image" === n ? {
            backgroundImage: "url(".concat(o, ")")
          } : null
        }, r && /*#__PURE__*/t.createElement(nb, {
          className: I1.filePreview__closeButton
        }, /*#__PURE__*/t.createElement(WC, {
          onClick: r,
          variation: "secondary",
          size: "dense"
        }, /*#__PURE__*/t.createElement(qv, {
          name: "trashAlt"
        }))), "image" !== n && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
          className: I1.filePreview__icon
        }, /*#__PURE__*/t.createElement(qv, {
          name: s(),
          iconStyle: "regular"
        })), a && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Qb, {
          size: "l" === i ? "xs" : "xxs"
        }), /*#__PURE__*/t.createElement(nb, {
          isTextTruncateWrapper: !0,
          className: I1.filePreview__name
        }, /*#__PURE__*/t.createElement(MJ, {
          textAlign: "center",
          isFullWidth: !0,
          truncate: !0
        }, a))))));
      };
    return a ? /*#__PURE__*/t.createElement(Pj, {
      tipContent: a
    }, l()) : l();
  };
B1.propTypes = {
  fileType: g.oneOf(["image", "doc", "file", "pdf", "excel", "word", "csv", "video"]),
  fileName: g.string,
  fileImageSrc: g.string,
  onRemoveFile: g.func,
  aspectRatio: g.oneOf(["square", "wide", "block"]),
  size: g.oneOf(["s", "m", "l"])
}, B1.defaultProps = {
  fileType: "file",
  aspectRatio: "square"
};
var x1 = function (e) {
  var i = e.layout,
    a = e.files,
    c = e.previewSize,
    s = e.previewAspectRatio,
    l = o(),
    u = d1(l, null, !0),
    d = V(n(!1), 2),
    f = d[0],
    p = d[1],
    m = V(n(!0), 2),
    h = m[0],
    A = m[1];
  r(function () {
    h && u && (p(!0), A(!1));
  }, [u]);
  var g = function () {
    return a.map(function (e, n) {
      return /*#__PURE__*/t.createElement(B1, N({
        key: "file-preview-".concat(n)
      }, e, {
        size: c,
        aspectRatio: s
      }));
    });
  };
  return "grid" === i ? /*#__PURE__*/t.createElement(sb, {
    flexWrap: "wrap",
    gap: "xs",
    className: b1,
    padding: "s"
  }, a.length > 0 && g()) : /*#__PURE__*/t.createElement(nb, {
    id: "fileUploadTrayScrollContainer",
    setPositionRelative: !0,
    className: tC(b1, k({}, y1, f)),
    paddingHorizontal: "s"
  }, /*#__PURE__*/t.createElement("div", {
    className: E1,
    ref: l
  }, /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    className: C1,
    gap: "xs"
  }, a.length > 0 && g())));
};
x1.propTypes = {
  layout: g.oneOf(["grid", "horizontal"]),
  previewSize: g.oneOf(["s", "m", "l"]),
  previewAspectRatio: g.oneOf(["square", "wide", "block"]),
  files: g.arrayOf(g.shape({
    fileType: g.oneOf(["image", "doc", "file", "pdf", "excel", "word", "csv", "video"]),
    fileName: g.string,
    fileImageSrc: g.string,
    onRemoveFile: g.func
  }))
}, x1.defaultProps = {
  layout: "horizontal",
  previewSize: "s",
  previewAspectRatio: "square",
  files: []
}, x1.FIlePreview = B1;
var w1 = "PageStateMessage-module_pageState__1WraJ",
  Q1 = "PageStateMessage-module_pageState__icon__3lRJS",
  H1 = function (e) {
    var n = e.iconProps,
      r = e.headline,
      o = e.description,
      i = e.ctaProps,
      a = e.ctaLabel,
      c = e.ctaType,
      s = Lb().isMobile;
    return /*#__PURE__*/t.createElement(sb, {
      className: w1,
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      paddingVertical: s ? "m" : "l",
      paddingHorizontal: "s"
    }, /*#__PURE__*/t.createElement(nb, {
      className: Q1,
      paddingBottom: "xs"
    }, /*#__PURE__*/t.createElement(qv, n)), /*#__PURE__*/t.createElement(GJ, {
      showStartingFrom: "tablet"
    }, /*#__PURE__*/t.createElement(SW, {
      textAlign: "center",
      textColor: "dark-gray"
    }, r)), /*#__PURE__*/t.createElement(GJ, {
      hideStartingFrom: "tablet"
    }, /*#__PURE__*/t.createElement(PW, {
      textAlign: "center",
      textColor: "dark-gray"
    }, r)), /*#__PURE__*/t.createElement(Vb, {
      textAlign: "center"
    }, o), i && /*#__PURE__*/t.createElement(nb, {
      paddingTop: "m"
    }, "button" === c ? /*#__PURE__*/t.createElement(jC, i, a) : /*#__PURE__*/t.createElement(KJ, i, a)));
  };
H1.propTypes = {
  iconProps: g.object,
  headline: g.string,
  description: g.string,
  ctaProps: g.object,
  ctaLabel: g.string,
  ctaType: g.oneOf(["link", "button"])
}, H1.defaultProps = {};
var z1 = {
    wrapper: "globalSearch-module_wrapper__2slsV",
    content: "globalSearch-module_content__Z23Z8",
    globalSearch: "globalSearch-module_globalSearch__1T8mv",
    isActive: "globalSearch-module_isActive__4-q6f",
    globalSearch__icon: "globalSearch-module_globalSearch__icon__1mITE",
    globalSearch__control_wrapper: "globalSearch-module_globalSearch__control_wrapper__1Dufj",
    globalSearch__control_input: "globalSearch-module_globalSearch__control_input__2lnQk",
    globalSearchPanel: "globalSearch-module_globalSearchPanel__3-QtK",
    globalSearchPanel__footer: "globalSearch-module_globalSearchPanel__footer__2ryhH",
    globalSearchPanel__icon: "globalSearch-module_globalSearchPanel__icon__pXVgV",
    globalSearchPanel__text: "globalSearch-module_globalSearchPanel__text__1ABNP",
    globalSearchItem__section: "globalSearch-module_globalSearchItem__section__2tEcz",
    globalSearchItem__icon: "globalSearch-module_globalSearchItem__icon__25p80",
    globalSearchItem__content: "globalSearch-module_globalSearchItem__content__1XBkF",
    globalSearchItem__infoTitle: "globalSearch-module_globalSearchItem__infoTitle__1doH7",
    globalSearchItem__infoParagraph: "globalSearch-module_globalSearchItem__infoParagraph__19-uc",
    globalSearchItem__link: "globalSearch-module_globalSearchItem__link__1bwfN",
    globalSearchItem__result_term: "globalSearch-module_globalSearchItem__result_term__vBi-i",
    globalSearchItem__result_term_tag: "globalSearch-module_globalSearchItem__result_term_tag__gNWkl",
    globalSearchItem__result_location: "globalSearch-module_globalSearchItem__result_location__1Zx2C",
    globalSearchItem__result: "globalSearch-module_globalSearchItem__result__4ZyeV",
    dense: "globalSearch-module_dense__2wxJS",
    globalSearchItem__result_term_highlight: "globalSearch-module_globalSearchItem__result_term_highlight__2aHXz"
  },
  M1 = function () {
    return /*#__PURE__*/t.createElement(sb, {
      className: z1.globalSearchItem
    }, /*#__PURE__*/t.createElement(nb, {
      className: z1.globalSearchItem__icon
    }, /*#__PURE__*/t.createElement(qv, {
      name: "infoCircle"
    })), /*#__PURE__*/t.createElement(nb, {
      className: z1.globalSearchItem__content
    }, /*#__PURE__*/t.createElement("div", {
      className: z1.globalSearchItem__infoTitle
    }, "Global Search"), /*#__PURE__*/t.createElement("div", {
      className: z1.globalSearchItem__infoParagraph
    }, "You can search for Properties, Reservations, Messages, and anything else you need to find on Direct. If we can’t match what you’re looking for directly, we’ll do our best to offer suggestions and hints to help you find what youre looking for.")));
  },
  k1 = "resultItem-module_resultItem__OLpti",
  N1 = "resultItem-module_resultItem__icon__1W08p",
  S1 = "resultItem-module_resultItem__result_text__1FafU",
  V1 = "resultItem-module_resultItem__result_location__1JBMi",
  L1 = "resultItem-module_resultItem__content__3Z3QI",
  P1 = "resultItem-module_resultItem__content_image__1bY8-",
  O1 = "resultItem-module_resultItem__result__5NNNA",
  T1 = "resultItem-module_resultItem__result_highlight__1z3eQ",
  D1 = function (e) {
    var n,
      r = e.result,
      o = e.searchInput;
    return /*#__PURE__*/t.createElement("a", {
      href: r.href,
      className: k1
    }, /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: N1
    }, /*#__PURE__*/t.createElement(qv, {
      name: "chevronRight"
    })), /*#__PURE__*/t.createElement(sb, {
      renderAs: "span",
      alignItems: "center",
      className: L1
    }, r.image && /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: P1
    }, /*#__PURE__*/t.createElement("img", {
      src: r.image,
      alt: r.result
    })), /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: O1
    }, /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: S1,
      dangerouslySetInnerHTML: (n = r.result, {
        __html: n.replace(new RegExp("(" + o + ")", "ig"), '<span class="' + T1 + '">$1</span>')
      })
    }), /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: V1
    }, r.location))));
  },
  R1 = function (e) {
    var n = e.recentTerms;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
      className: z1.globalSearchItem__section
    }, "Recent Searches"), n.map(function (e, n) {
      return /*#__PURE__*/t.createElement(D1, {
        key: n,
        result: e
      });
    }));
  },
  G1 = "suggestionItem-module_suggestionItem__F1hPU",
  F1 = "suggestionItem-module_suggestionItem__icon__24SDs",
  j1 = "suggestionItem-module_suggestionItem__content_term__3OGFw",
  J1 = "suggestionItem-module_suggestionItem__content_location__WYBCB",
  Z1 = "suggestionItem-module_suggestionItem__content__3G5dN",
  W1 = function (e) {
    var n = e.searchInput,
      r = e.location;
    return /*#__PURE__*/t.createElement("a", {
      href: "/",
      className: G1
    }, /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: F1
    }, /*#__PURE__*/t.createElement(qv, {
      name: "search"
    })), /*#__PURE__*/t.createElement(sb, {
      renderAs: "span",
      flexGrow: 1,
      alignItems: "center",
      className: "".concat(Z1)
    }, /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: j1
    }, "'".concat(n, "' "), r && /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      display: "inline",
      className: J1
    }, "in ", r))));
  },
  X1 = function (e) {
    var n = e.results,
      r = e.searchInput;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(W1, {
      searchInput: r
    }), /*#__PURE__*/t.createElement(W1, {
      searchInput: r,
      location: "Properties"
    }), n.map(function (e, n) {
      return /*#__PURE__*/t.createElement(D1, {
        key: n,
        result: e,
        searchInput: r
      });
    }));
  },
  U1 = function (e) {
    var r = e.resultList,
      o = e.globalSearchOnChange,
      i = V(n(""), 2),
      a = i[0],
      c = i[1],
      s = V(n(!1), 2),
      l = s[0],
      u = s[1];
    return /*#__PURE__*/t.createElement(nb, {
      className: z1.wrapper
    }, /*#__PURE__*/t.createElement(nb, {
      className: z1.content
    }, /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    }), /*#__PURE__*/t.createElement(vM, {
      isDense: !0,
      prependIcon: /*#__PURE__*/t.createElement(qv, {
        name: "search"
      }),
      inputFocused: l,
      id: "searchInput",
      type: "text",
      value: a,
      placeholder: "Search Direct for Reservations, Properties, Guests, etc.",
      onChange: function (e) {
        c(e.target.value), o(e.target.value);
      },
      onFocus: function () {
        return u(!0);
      },
      onBlur: function () {
        return u(!1);
      },
      autoComplete: "off"
    }), l && /*#__PURE__*/t.createElement(sb, {
      flexDirection: "column",
      className: z1.globalSearchPanel
    }, "" === a ? r.recentTerms.length > 0 ? /*#__PURE__*/t.createElement(R1, {
      recentTerms: r.recentTerms
    }) : /*#__PURE__*/t.createElement(M1, null) : /*#__PURE__*/t.createElement(X1, {
      results: r.results,
      searchInput: a
    }), /*#__PURE__*/t.createElement("a", {
      href: "/",
      className: z1.globalSearchPanel__footer
    }, /*#__PURE__*/t.createElement(sb, {
      renderAs: "span",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: z1.globalSearchPanel__icon
    }, /*#__PURE__*/t.createElement(qv, {
      name: "questionCircle"
    })), /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      className: z1.globalSearchPanel__text
    }, "Help Center"))))));
  },
  K1 = "InboxChatBubble-module_chatBubbleWrapper__1D4E7",
  Y1 = "InboxChatBubble-module_chatBubble__2OqL1",
  q1 = "InboxChatBubble-module_guestBubble__1XBhX",
  _1 = "InboxChatBubble-module_messageTime__1ZLOJ",
  $1 = "InboxChatBubble-module_message__1FZDz",
  e2 = "InboxChatBubble-module_typing__2Ryra",
  t2 = "InboxChatBubble-module_spinner__E7KSS",
  n2 = "InboxChatBubble-module_warning__1Twza",
  r2 = "InboxChatBubble-module_attachmentRail__yN3JL",
  o2 = {
    attachment: "InboxAttachmentPreview-module_attachment__1roT4",
    closeButton: "InboxAttachmentPreview-module_closeButton__1Aa8E",
    "size-m": "InboxAttachmentPreview-module_size-m__1PyPE",
    "size-l": "InboxAttachmentPreview-module_size-l__1uGRw",
    isImage: "InboxAttachmentPreview-module_isImage__6Tuis",
    icon: "InboxAttachmentPreview-module_icon__3oKVi",
    filename: "InboxAttachmentPreview-module_filename__2uqfS"
  },
  i2 = function (e) {
    var n,
      r = e.imageSrc,
      o = e.removeAttachment,
      i = e.icon,
      a = e.filename,
      c = e.size;
    return /*#__PURE__*/t.createElement(sb, {
      flexDirection: "column",
      className: tC(o2.attachment, (n = {}, k(n, o2.isImage, r), k(n, o2["size-".concat(c)], c), n)),
      style: r ? {
        backgroundImage: "url(".concat(r, ")")
      } : null
    }, o && /*#__PURE__*/t.createElement("div", {
      className: o2.closeButton
    }, /*#__PURE__*/t.createElement(WC, {
      size: "dense",
      variation: "secondary",
      onClick: o
    }, /*#__PURE__*/t.createElement(qv, {
      name: "trashAlt"
    }))), !r && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1,
      justifyContent: "center",
      alignItems: "center",
      className: tC(o2.icon, k({}, o2["size-".concat(c)], c))
    }, i), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement("div", {
      className: tC(o2.filename, k({}, o2["size-".concat(c)], c))
    }, a))));
  };
i2.propTypes = {
  imageSrc: g.string,
  removeAttachment: g.func,
  icon: g.node,
  filename: g.string,
  size: g.oneOf(["m", "l"])
}, i2.defaultProps = {
  size: "m"
};
var a2 = function (e) {
  var n = e.isGuest,
    r = e.userIsTyping,
    o = e.showWarning,
    i = e.messageIsSending,
    a = e.attachments,
    c = e.message,
    s = e.senderName,
    l = e.messageTime,
    u = e.avatarInitials,
    d = e.avatarImageSrc;
  return /*#__PURE__*/t.createElement(sb, {
    alignItems: "flex-end",
    flexDirection: n ? "row-reverse" : "row",
    justifyContent: "flex-end"
  }, /*#__PURE__*/t.createElement(sb, {
    className: K1,
    flexDirection: "column"
  }, /*#__PURE__*/t.createElement(MJ, {
    className: _1,
    paddingBottom: "xxs"
  }, l), /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    justifyContent: "flex-end",
    className: tC(Y1, k({}, q1, n))
  }, r ? /*#__PURE__*/t.createElement("div", {
    className: e2
  }, /*#__PURE__*/t.createElement(qv, {
    name: "ellipsisH"
  })) : i ? /*#__PURE__*/t.createElement("div", {
    className: t2
  }, /*#__PURE__*/t.createElement(qv, {
    name: "spinner",
    spin: !0
  })) : o ? /*#__PURE__*/t.createElement("div", {
    className: n2
  }, /*#__PURE__*/t.createElement(qv, {
    name: "exclamationTriangle"
  })) : /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Tb, {
    weight: "bold",
    paddingBottom: "xxs"
  }, s), /*#__PURE__*/t.createElement(Tb, {
    className: $1
  }, c), a && a.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Qb, {
    size: "xs"
  }), /*#__PURE__*/t.createElement(sb, {
    className: r2,
    gap: "xs"
  }, a.map(function (e, n) {
    return /*#__PURE__*/t.createElement(i2, {
      key: n,
      imageSrc: e.imageSrc,
      removeAttachment: e.removeAttachment,
      icon: e.icon,
      filename: e.filename
    });
  })))))), /*#__PURE__*/t.createElement(sb, {
    style: {
      flexShrink: 0
    }
  }, /*#__PURE__*/t.createElement(Qb, {
    size: "s",
    direction: "horizontal"
  })), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(UC, {
    size: "l",
    initials: u,
    imageSrc: d,
    variation: d ? "image" : "initials"
  })));
};
a2.propTypes = {
  senderName: g.string,
  message: g.oneOfType([g.string, g.node]),
  attachments: g.array,
  messageTime: g.string,
  avatarInitials: g.string,
  avatarImageSrc: g.string,
  messageIsSending: g.bool,
  userIsTyping: g.bool,
  isGuest: g.bool,
  showWarning: g.bool
}, a2.defaultProps = {
  senderName: "Name",
  message: "This is a message."
};
var c2 = "InboxConversationItem-module_container__3n4Zk",
  s2 = "InboxConversationItem-module_wrapper__2bA3M",
  l2 = "InboxConversationItem-module_isSelected__1djWR",
  u2 = "InboxConversationItem-module_isSelectedCheckbox__2Ex2v",
  d2 = "InboxConversationItem-module_itemWrapper__2CSWw",
  f2 = "InboxConversationItem-module_unread__2LWoB",
  p2 = "InboxConversationItem-module_sourceWrapper__1TF36",
  m2 = "InboxConversationItem-module_checkboxWrapper__24_SU",
  h2 = "InboxConversationItem-module_reveal__2_kz_",
  A2 = "InboxConversationItem-module_checkbox__26wE-",
  g2 = "InboxConversationItem-module_inboxTag__20WeM",
  v2 = "InboxConversationItem-module_archived__1iho9",
  C2 = "InboxConversationItem-module_important__3fKKz",
  b2 = "InboxConversationItem-module_needsReply__rmfHb",
  E2 = "InboxConversationItem-module_isUnread__140uj",
  y2 = "InboxConversationItem-module_guestName__VE7KV",
  I2 = function (e) {
    var n = e.status;
    return function () {
      switch (n) {
        case "cancelled":
          return /*#__PURE__*/t.createElement(Yb, null, "Cancelled");
        case "declined":
          return /*#__PURE__*/t.createElement(Yb, null, "Declined");
        case "post-trip":
          return /*#__PURE__*/t.createElement(Yb, {
            color: "purple"
          }, "Post-Trip");
        case "on-trip":
          return /*#__PURE__*/t.createElement(Yb, {
            color: "green"
          }, "On Trip");
        case "pre-trip":
          return /*#__PURE__*/t.createElement(Yb, {
            color: "green"
          }, "Pre-Trip");
        case "request":
          return /*#__PURE__*/t.createElement(Yb, {
            color: "blue"
          }, "Request");
        case "inquiry":
          return /*#__PURE__*/t.createElement(Yb, {
            color: "blue"
          }, "Inquiry");
        default:
          return /*#__PURE__*/t.createElement(t.Fragment, null);
      }
    }();
  };
I2.propTypes = {
  status: g.oneOf(["inquiry", "request", "pre-trip", "on-trip", "post-trip", "declined", "cancelled"])
};
var B2 = function (e) {
  var n,
    r = e.lastUpdated,
    o = e.guestName,
    i = e.status,
    a = e.propertyName,
    c = e.source,
    s = e.datesBooked,
    l = e.isUnread,
    u = e.avatarInitials,
    d = e.avatarImgSrc,
    f = e.onClick,
    p = e.showCheckbox,
    m = e.checkboxSelected,
    h = e.onCheckboxSelect,
    A = e.isSelected,
    g = e.inboxTags,
    v = e.needsReply;
  return /*#__PURE__*/t.createElement(nb, {
    className: c2
  }, /*#__PURE__*/t.createElement(sb, {
    className: tC(m2, k({}, h2, p))
  }, /*#__PURE__*/t.createElement(sb, {
    justifyContent: "center",
    alignItems: "center",
    className: tC(A2, k({}, l2, m))
  }, /*#__PURE__*/t.createElement(Xb, {
    onChange: h,
    removeBottomSpacer: !0,
    checked: m
  }))), /*#__PURE__*/t.createElement("button", {
    className: tC(s2, (n = {}, k(n, l2, A), k(n, u2, m), n)),
    onClick: f
  }, /*#__PURE__*/t.createElement(sb, {
    paddingHorizontal: "s",
    justifyContent: "center",
    flexDirection: "column",
    className: tC(d2, k({}, f2, l))
  }, /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(UC, {
    variation: d ? "image" : "initials",
    size: "l",
    initials: u,
    imageSrc: d
  })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(Qb, {
    size: "xs",
    direction: "horizontal"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xxs",
    direction: "horizontal"
  })), /*#__PURE__*/t.createElement(sb, {
    flexGrow: 1
  }, /*#__PURE__*/t.createElement(sb, {
    flexGrow: 1,
    flexDirection: "column"
  }, /*#__PURE__*/t.createElement(MJ, {
    weight: l ? "bold" : "semibold"
  }, /*#__PURE__*/t.createElement(qv, {
    name: "clock",
    iconStyle: "regular"
  }), " ", r), /*#__PURE__*/t.createElement(Vb, {
    className: y2,
    weight: l ? "bold" : "semibold",
    truncate: !0
  }, o)), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(Qb, {
    size: "xs",
    direction: "horizontal"
  })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(I2, {
    status: i
  })), g && g.includes("archive") && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    justifyContent: "center",
    className: tC(g2, v2)
  }, /*#__PURE__*/t.createElement(qv, {
    name: "archive"
  })), g && g.includes("imp") && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    justifyContent: "center",
    className: tC(g2, C2)
  }, /*#__PURE__*/t.createElement(qv, {
    name: "star"
  })), v && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    justifyContent: "center",
    className: tC(b2, k({}, E2, l))
  }, /*#__PURE__*/t.createElement(qv, {
    name: "messageDots"
  })))), /*#__PURE__*/t.createElement(Qb, {
    size: "xs"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xxs"
  }), /*#__PURE__*/t.createElement(sb, {
    alignItems: "center"
  }, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(nb, {
    className: p2
  }, /*#__PURE__*/t.createElement(PC, {
    channel: c,
    isGrayscale: !l,
    presetHeight: "m",
    variation: "icon"
  }))), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(Qb, {
    size: "xs",
    direction: "horizontal"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "xxs",
    direction: "horizontal"
  })), /*#__PURE__*/t.createElement(sb, {
    flexGrow: 1
  }, /*#__PURE__*/t.createElement(MJ, {
    truncate: !0,
    weight: l ? "bold" : "semibold"
  }, "".concat(s).concat(a && " • ".concat(a))))))));
};
B2.propTypes = {
  avatarInitials: g.string,
  avatarImgSrc: g.string,
  lastUpdated: g.string,
  status: g.oneOf(["inquiry", "request", "pre-trip", "on-trip", "post-trip", "declined", "cancelled"]),
  guestName: g.string,
  source: g.oneOf(["agoda", "airbnb", "booking", "homeaway", "direct", "expedia", "google", "rvshare", "vrbo", "kayak", "travelocity"]),
  datesBooked: g.string,
  propertyName: g.string,
  isUnread: g.bool,
  onClick: g.func,
  showCheckbox: g.bool,
  onCheckboxSelect: g.func,
  checkboxSelected: g.bool,
  inboxTags: g.array,
  needsReply: g.bool,
  isSelected: g.bool
}, B2.defaultProps = {
  isUnread: !0,
  avatarVariation: "initials"
};
var x2 = "InboxConversationItemEmpty-module_container__3O8DG",
  w2 = "InboxConversationItemEmpty-module_wrapper__2X8LU",
  Q2 = "InboxConversationItemEmpty-module_noPointer__2NWPh",
  H2 = "InboxConversationItemEmpty-module_itemWrapper__2G5ZY",
  z2 = "InboxConversationItemEmpty-module_sourceWrapper__2TJq8",
  M2 = "InboxConversationItemEmpty-module_avatarEmpty__2WuDb",
  k2 = "InboxConversationItemEmpty-module_textEmpty__V_D6Q",
  N2 = "InboxConversationItemEmpty-module_caption__LbirN",
  S2 = "InboxConversationItemEmpty-module_body__2dd6x",
  V2 = "InboxConversationItemEmpty-module_pillEmpty__2Oi0d",
  L2 = "InboxConversationItemEmpty-module_sourceEmpty__10gHU",
  P2 = function () {
    return /*#__PURE__*/t.createElement(nb, {
      className: x2
    }, /*#__PURE__*/t.createElement(nb, {
      className: tC(w2, Q2)
    }, /*#__PURE__*/t.createElement(sb, {
      paddingHorizontal: "s",
      justifyContent: "center",
      flexDirection: "column",
      className: tC(H2)
    }, /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(nb, {
      className: M2
    })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(Qb, {
      size: "xs",
      direction: "horizontal"
    }), /*#__PURE__*/t.createElement(Qb, {
      size: "xxs",
      direction: "horizontal"
    })), /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1
    }, /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1,
      flexDirection: "column"
    }, /*#__PURE__*/t.createElement(nb, {
      className: tC(k2, N2),
      style: {
        width: 57
      }
    }), /*#__PURE__*/t.createElement(Qb, {
      size: "xs"
    }), /*#__PURE__*/t.createElement(nb, {
      className: tC(k2, S2),
      style: {
        width: 112
      }
    })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(Qb, {
      size: "xs",
      direction: "horizontal"
    })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(nb, {
      className: V2
    })))), /*#__PURE__*/t.createElement(Qb, {
      size: "xs"
    }), /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    }), /*#__PURE__*/t.createElement(sb, {
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(nb, {
      className: z2
    }, /*#__PURE__*/t.createElement(nb, {
      className: L2
    }))), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(Qb, {
      size: "xs",
      direction: "horizontal"
    }), /*#__PURE__*/t.createElement(Qb, {
      size: "xxs",
      direction: "horizontal"
    })), /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1
    }, " ", /*#__PURE__*/t.createElement(nb, {
      className: tC(k2, N2)
    }))))));
  },
  O2 = "InboxChatTextarea-module_wrapper__1sKFi",
  T2 = "InboxChatTextarea-module_pillRailWrapper__3T0cY",
  D2 = "InboxChatTextarea-module_pillRail__rp_QJ",
  R2 = "InboxChatTextarea-module_pillWrapper__CG9cE",
  G2 = function (e) {
    var r = e.onChange,
      o = e.quickReplies,
      i = e.isDisabled,
      a = e.isError,
      c = e.description,
      s = e.onBlur,
      l = e.onFocus,
      u = e.value,
      d = e.placeholder,
      f = e.attachments,
      p = V(n(!1), 2),
      m = p[0],
      h = p[1];
    return /*#__PURE__*/t.createElement(qb, {
      className: O2,
      isActive: m,
      isDisabled: i,
      description: c,
      isError: a,
      removeBottomSpacer: !0,
      inputWidth: "auto"
    }, o && o.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
      paddingHorizontal: "xs",
      paddingVertical: "xs",
      className: T2
    }, /*#__PURE__*/t.createElement(sb, {
      className: D2,
      alignItems: "center"
    }, o.map(function (e, n) {
      return /*#__PURE__*/t.createElement(sb, {
        key: n,
        className: R2
      }, /*#__PURE__*/t.createElement(Yb, {
        removeOnClick: e.onRemove
      }, e.label));
    }))), /*#__PURE__*/t.createElement(Hb, null)), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1,
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/t.createElement(Dj, {
      onChange: function (e, t) {
        return r(e, t);
      },
      onBlur: function () {
        h(!1), s && s();
      },
      onFocus: function () {
        h(!0), l && l();
      },
      value: u,
      placeholder: d,
      removeInputWrapper: !0,
      removeBottomSpacer: !0,
      showMenuBar: !1,
      minHeight: "none",
      maxHeight: "s"
    }))), f && f.length > 0 && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(Hb, null), /*#__PURE__*/t.createElement(sb, {
      paddingHorizontal: "xs",
      paddingVertical: "xs",
      className: T2
    }, /*#__PURE__*/t.createElement(sb, {
      className: D2,
      alignItems: "center",
      gap: "xs"
    }, f.map(function (e, n) {
      return /*#__PURE__*/t.createElement(i2, N({
        key: n
      }, e));
    })))));
  };
G2.propTypes = {
  onChange: g.func.isRequired,
  quickReplies: g.array,
  isError: g.bool,
  description: g.string,
  attachments: g.array,
  isDisabled: g.bool,
  onFocus: g.func,
  onBlur: g.func,
  value: g.string,
  placeholder: g.string
}, G2.defaultProps = {};
var F2 = {
    actionMessageWrapper: "InboxActionMessage-module_actionMessageWrapper__2xSmz",
    actionMessage: "InboxActionMessage-module_actionMessage__1PEgp",
    "status-neutral": "InboxActionMessage-module_status-neutral__1uB8w",
    "status-positive": "InboxActionMessage-module_status-positive__P25FC",
    "status-warning": "InboxActionMessage-module_status-warning__em18H",
    "status-negative": "InboxActionMessage-module_status-negative__3sIH9",
    "status-admin": "InboxActionMessage-module_status-admin__cq9V9",
    isGuest: "InboxActionMessage-module_isGuest__dBnzp",
    icon: "InboxActionMessage-module_icon__3pHGG",
    image: "InboxActionMessage-module_image__3_Hq6",
    message: "InboxActionMessage-module_message__3TI2W",
    buttonsWrapper: "InboxActionMessage-module_buttonsWrapper__19TCP",
    avatar: "InboxActionMessage-module_avatar__2sYtY",
    messageTitle: "InboxActionMessage-module_messageTitle__3vTE5",
    messageSubtitle: "InboxActionMessage-module_messageSubtitle__2wpoR"
  },
  j2 = {
    base: "Vrbo-module_base__3Bc4d",
    gray: "Vrbo-module_gray__REy5g",
    fullColor: "Vrbo-module_fullColor__1tDHF"
  },
  J2 = ["color", "className"],
  Z2 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, J2);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(j2.base, j2["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "vrbo"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero"
    }, /*#__PURE__*/e.createElement("path", {
      d: "m19.79 14.118.6-1.091-2.037-8.981c-.568-2.528.113-3.63 2.412-4.011V0H18.64c-.615.265-1.918 1.062-1.19 4.04l2.34 10.078Z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m18.693 16.654.512-1.11-2.302-11.466c-.432-2.225-.247-3.382.472-4.043V0h-1.243c-.38.832-.495 1.664-.058 3.865l2.62 12.789Zm-1.059 2.213.512-1.098-2.878-13.933C14.762 1.67 14.877.679 15.084 0h-1.1c-.01 1.172.136 2.34.438 3.47l3.212 15.397ZM12.977 0h-1.295v.035c.576.72.749 1.6 1.21 3.541L16.344 20h.777L13.668 3.523A30.817 30.817 0 0 1 12.978 0Zm-2.59 0H9v.035c1.266.514 1.888 1.5 2.389 3.807l3.413 16.152h.777L12.143 3.742C11.55.92 10.928.402 10.387 0Zm17.648 0c-1.634.98-2.607 2.791-4.645 7.282l.052.03c2.354-4.52 3.695-6.32 6.734-7.259V0h-2.14Zm-4.76 7.194.052.035c1.934-4.668 2.44-5.972 3.229-7.194V0H24.99v.047c.161 1.871-.449 3.594-1.715 7.147Z"
    })));
  };
Z2.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, Z2.defaultProps = {
  color: "fullColor"
};
var W2 = {
    base: "RVShare-module_base__1KLHA",
    gray: "RVShare-module_gray__30-VV",
    blackFill: "RVShare-module_blackFill__HWIFV",
    blueFill: "RVShare-module_blueFill__3OMpk",
    fullColor: "RVShare-module_fullColor__3teWh"
  },
  X2 = ["color", "className"],
  U2 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, X2);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(W2.base, W2["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "rvshare"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 0h5.687v8.782H0z"
    }), /*#__PURE__*/e.createElement("path", {
      id: "c",
      d: "M0 0h6.031v8.782H0z"
    })), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("g", {
      transform: "translate(0 6)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M1.409 3.934c.507-.02 1.011-.009 1.506-.07.433-.054.735-.334.893-.75.114-.3.12-.613.087-.928-.071-.67-.42-1.044-1.087-1.098-.457-.037-.92-.014-1.38-.017-.006 0-.012.006-.019.011v2.852ZM3.249 0c.164.025.33.04.491.076.877.193 1.41.77 1.537 1.661.074.518.056 1.03-.117 1.53-.21.602-.6 1.012-1.243 1.147-.016.003-.032.01-.062.018.137.03.261.048.38.082.505.145.774.506.898.996.091.355.097.717.106 1.08.011.485.022.97.043 1.455a.88.88 0 0 0 .349.686l.056.05h-.101c-.464 0-.928-.002-1.392.002-.075 0-.115-.026-.148-.088a1.58 1.58 0 0 1-.167-.675c-.03-.585-.041-1.17-.071-1.757a2.928 2.928 0 0 0-.083-.567c-.102-.402-.377-.624-.781-.686a3.188 3.188 0 0 0-.437-.03c-.363-.006-.726-.003-1.102-.003v3.798H0V.114L.003 0h3.246Z",
      className: W2.blackFill,
      mask: "url(#b)"
    })), /*#__PURE__*/e.createElement("g", {
      transform: "translate(5.803 6)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "d",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#c"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M6.031 0c-.051.22-.098.44-.153.66L4.292 6.956l-.441 1.753c-.005.02-.013.04-.022.066-.029.002-.06.005-.09.005-.53 0-1.06-.002-1.59.002-.084 0-.11-.028-.129-.105C1.432 6.164.841 3.653.25 1.14L.011.123C.002.083.004.04 0 0h1.466c.007.023.016.046.021.069l.302 1.422 1.058 4.982.111.519a.095.095 0 0 0 .038-.06l.299-1.335c.369-1.643.737-3.286 1.107-4.928.05-.224.108-.446.163-.67h1.466Z",
      className: W2.blackFill,
      mask: "url(#d)"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M20.013 8.865c.019-.031.039-.062.057-.094.257-.46.646-.717 1.17-.777.34-.038.675-.024 1.003.077.55.17.846.567.951 1.115.042.22.062.449.063.675.005 1.588.002 3.177.002 4.766 0 .145 0 .145-.149.145h-1.685c-.139 0-.139 0-.139-.144 0-1.464.001-2.927-.002-4.39 0-.1-.013-.202-.036-.3-.057-.238-.188-.41-.447-.451a.624.624 0 0 0-.62.24c-.165.208-.205.456-.206.71-.002 1.397-.001 2.794-.001 4.19 0 .145 0 .145-.14.145-.565 0-1.13-.002-1.696.002-.092 0-.127-.02-.127-.12.003-2.836.003-5.671 0-8.507 0-.098.031-.123.126-.122.572.004 1.144.004 1.717 0 .097-.001.123.028.122.123-.003.859-.002 1.718-.002 2.577v.13l.039.01M27.456 11.509c-.028.004-.039.003-.048.006-.3.128-.604.253-.903.386a.704.704 0 0 0-.41.474c-.073.265-.063.532.02.793.061.192.174.347.38.399.314.079.73-.065.864-.434.046-.128.07-.27.081-.405.016-.21.013-.418.016-.627.002-.195 0-.39 0-.592m2.023 3.263c-.602 0-1.199-.002-1.795 0-.069 0-.085-.038-.092-.088-.03-.206-.058-.413-.087-.62-.002-.015-.007-.03-.018-.071-.03.05-.05.08-.068.113-.277.478-.7.732-1.238.814a2.164 2.164 0 0 1-.87-.05c-.48-.122-.819-.418-.984-.885a2.875 2.875 0 0 1-.056-1.817c.168-.57.537-.946 1.11-1.11.421-.118.846-.223 1.27-.337.144-.038.288-.08.43-.128.215-.075.358-.216.364-.457.004-.146.011-.294-.012-.436a.511.511 0 0 0-.463-.433 1.238 1.238 0 0 0-.333.005c-.287.044-.444.23-.504.504a2.141 2.141 0 0 0-.043.31c-.004.059-.026.077-.083.077l-1.58-.001c-.046 0-.087-.001-.084-.063.026-.58.121-1.135.57-1.557.297-.278.661-.425 1.057-.49.7-.115 1.401-.126 2.094.054.702.18 1.115.674 1.186 1.398.016.159.025.32.025.48.002 1.198-.004 2.396.004 3.594.002.277.04.555.08.83.015.12.076.235.12.364M36.661 10.627c.02.005.03.01.04.01.443 0 .886 0 1.33.002.085 0 .086-.05.083-.11-.004-.104.001-.21-.016-.312-.035-.223-.066-.448-.127-.664a.484.484 0 0 0-.37-.35c-.36-.08-.725.04-.854.487-.088.305-.09.617-.086.937m3.267 1.896c.01 1.02-.405 2.052-1.696 2.33a4.057 4.057 0 0 1-1.74-.002c-.84-.185-1.36-.71-1.596-1.528a5.152 5.152 0 0 1-.187-1.246c-.013-.387-.028-.775-.017-1.162.013-.491.074-.977.241-1.446.284-.798.85-1.267 1.672-1.424.574-.11 1.15-.1 1.721.03.756.173 1.234.639 1.456 1.378.114.379.171.767.188 1.16.015.35.016.699.03 1.047.002.094-.029.117-.12.117-1.033-.003-2.066 0-3.098-.004-.106-.001-.142.027-.137.133.021.427-.009.858.102 1.278.02.07.045.139.075.205.113.244.315.349.572.347.263-.001.476-.11.566-.367.067-.192.112-.395.136-.597.03-.248.016-.25.266-.25h1.566M12.97 12.672c.252 0 .503.003.755-.002.084-.001.111.02.116.11.007.145.027.29.055.434.076.389.381.536.734.52.393-.017.62-.222.676-.608.04-.28-.073-.556-.383-.718-.23-.121-.482-.198-.723-.297-.38-.157-.766-.297-1.133-.478-.553-.274-.867-.725-.918-1.352-.032-.395-.017-.781.14-1.15.23-.542.668-.843 1.213-1.006.503-.151 1.02-.171 1.54-.133.408.03.802.108 1.162.307.48.265.75.676.816 1.218.018.145.015.292.024.438.003.064-.024.084-.087.084-.523-.001-1.046-.002-1.57 0-.067 0-.093-.02-.091-.09a1.41 1.41 0 0 0-.018-.26c-.058-.34-.213-.484-.559-.505a1.542 1.542 0 0 0-.351.03c-.473.084-.51.732-.27.965.141.137.31.226.491.288.365.125.736.234 1.1.362.392.138.753.332 1.029.657.247.293.37.639.4 1.014.037.439.003.87-.194 1.276-.271.557-.733.873-1.313 1.037-.46.13-.931.147-1.408.114-.383-.026-.76-.083-1.117-.236-.582-.25-.896-.701-.972-1.321-.023-.197-.017-.397-.028-.595-.005-.085.03-.106.11-.105.258.005.517.002.774.002M32.444 9.07c.017-.03.036-.061.052-.093.234-.461.568-.817 1.087-.94.21-.05.434-.043.652-.057.062-.004.11.02.11.104-.003.565-.001 1.13-.002 1.697 0 .013-.004.027-.007.048-.133-.01-.263-.016-.394-.027a1.878 1.878 0 0 0-.752.084c-.416.14-.676.475-.693.914-.015.4-.015.802-.016 1.204-.002.876-.001 1.753-.001 2.629 0 .139 0 .139-.136.139-.57 0-1.137-.002-1.706.002-.088 0-.121-.018-.121-.115.003-2.133.003-4.267 0-6.401 0-.095.03-.116.12-.115.555.004 1.11.004 1.664 0 .089-.001.113.027.11.113-.004.268 0 .536 0 .804l.033.01",
      className: W2.blueFill
    })));
  };
U2.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, U2.defaultProps = {
  color: "fullColor"
};
var K2 = {
    base: "Homeaway-module_base__tz83b",
    gray: "Homeaway-module_gray__3JUcz",
    blueFill: "Homeaway-module_blueFill__3Zsjg",
    fullColor: "Homeaway-module_fullColor__hJsdW"
  },
  Y2 = ["color", "className"],
  q2 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, Y2);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(K2.base, K2["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "homeaway"), /*#__PURE__*/e.createElement("defs", null, /*#__PURE__*/e.createElement("path", {
      id: "a",
      d: "M0 0h22.712v20H0z"
    })), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M18.464 12.074c-.475.61-1.157 1.02-1.937 1.06a2.026 2.026 0 0 1-.125.004c-.787 0-1.503-.381-2.023-.978-.52-.598-.858-1.415-.907-2.325a5.076 5.076 0 0 1-.006-.226c0-.886.281-1.7.755-2.31.475-.61 1.158-1.02 1.938-1.06.041-.002.084-.004.124-.004.787 0 1.504.382 2.023.979.522.596.858 1.414.907 2.325.004.076.007.15.007.225 0 .887-.28 1.7-.756 2.31ZM16.367 1.356l-4.62 5.77-.026 7.375 4.268-.491s.81-.13.863.623c.06.844-.701.839-.701.839l-4.43.588-.01 1.576 9.492 1.686-.008-12.196-4.828-5.77ZM25.265 8.475l-2.35.101-.017 2.95 2.373-.172zM22.908 12.369l-.01 2.885 2.373-.205-.017-2.846z",
      fill: "#FFF"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M15.063 9.762c-.06-1.168.544-2.151 1.35-2.209-.474.324-.785 1.18-.735 2.166.05.998.455 1.823.97 2.085v.012c-.815.043-1.524-.876-1.585-2.054m3.025-2.202c-.414-.495-.95-.78-1.518-.78-.03 0-.06 0-.09.002-.565.031-1.069.336-1.446.838-.374.502-.61 1.196-.61 1.964 0 .064.002.129.005.195.04.791.323 1.49.737 1.984.415.494.95.78 1.518.78.03 0 .06-.002.091-.004.564-.031 1.069-.337 1.446-.837.374-.502.61-1.196.61-1.964 0-.064-.002-.129-.006-.195-.039-.79-.322-1.49-.737-1.983M26.288 8.195v2.991l1.695-.119-.004-2.931zM26.288 15.254l1.695-.172v-2.879l-1.695.132z",
      fill: "#FFF"
    }), /*#__PURE__*/e.createElement("g", {
      transform: "translate(9)"
    }, /*#__PURE__*/e.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, /*#__PURE__*/e.createElement("use", {
      xlinkHref: "#a"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M17.4 11.177V8.268l1.838-.057.004 2.85-1.842.116Zm1.837 3.697-1.837.174v-2.933l1.837-.133v2.892Zm-4.977.478.008-3.005 2.22-.172.015 2.963-2.243.214ZM2.962 17.63l.01-1.582 4.4-.59s.757.005.696-.841c-.052-.757-.857-.625-.857-.625l-4.24.492.027-7.404 4.59-5.79 4.795 5.79.007 12.243-9.428-1.693Zm11.314-9.214 2.21-.103.005 2.924-2.23.174.015-2.995ZM16.342 0H6.136L.112 7.072h2.123V14.6l-1.618.21s-.78.144-.586.969c.163.517.787.493.787.493l1.417-.176v2.086L12.335 20l8.028-1.8-.014-11.116h2.363L16.342 0Z",
      className: K2.blueFill,
      mask: "url(#b)"
    })), /*#__PURE__*/e.createElement("path", {
      d: "M18.294 11.837c-.394.494-.922.793-1.513.823a1.677 1.677 0 0 1-.095.004c-.594 0-1.154-.281-1.59-.767-.432-.486-.727-1.173-.768-1.951a3.039 3.039 0 0 1-.007-.192c0-.755.247-1.438.639-1.93.393-.494.923-.794 1.512-.825l.095-.002c.594 0 1.155.28 1.59.767.433.485.728 1.173.769 1.95.004.066.006.129.006.192 0 .755-.246 1.438-.638 1.931m.3-4.436c-.522-.586-1.239-.96-2.027-.96-.04 0-.083 0-.125.002-.78.04-1.464.442-1.94 1.042-.475.6-.756 1.399-.756 2.27 0 .072.002.146.005.22.05.895.388 1.697.91 2.285.52.585 1.237.96 2.025.96.042 0 .083 0 .125-.003.781-.04 1.465-.443 1.94-1.042.477-.6.757-1.398.757-2.269 0-.073-.002-.147-.006-.222-.05-.895-.386-1.697-.909-2.283",
      className: K2.blueFill
    }), /*#__PURE__*/e.createElement("path", {
      d: "M15.423 9.696c-.053-1.02.278-1.903.784-2.238-.86.06-1.503 1.075-1.44 2.283.065 1.216.822 2.167 1.69 2.122v-.012c-.548-.271-.98-1.123-1.034-2.155",
      className: K2.blueFill
    })));
  };
q2.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, q2.defaultProps = {
  color: "fullColor"
};
var _2 = {
    base: "Expedia-module_base__PKm0a",
    gray: "Expedia-module_gray__iHy-3",
    fullColor: "Expedia-module_fullColor__3S6Ja"
  },
  $2 = ["color", "className"],
  e4 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, $2);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(_2.base, _2["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "expedia"), /*#__PURE__*/e.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, /*#__PURE__*/e.createElement("path", {
      d: "m21.708 7.689-.402-1.135-3.417-4.565.617-.158 5.886 5.082 3.46-.99c.402-.1.862-.13 1.22-.13A9.949 9.949 0 0 0 23.36.582c-5.197-1.852-10.911.861-12.778 6.073a10.084 10.084 0 0 0-.473 4.852l8.298-2.885 3.302-.933ZM29.446 6.698c-.302.2-.747.46-1.192.603l-3.474.99-2.326 7.437-.603.201.488-5.685-.272-1.177-3.245.919-8.6 2.024a10.027 10.027 0 0 0 6.447 7.408c5.197 1.852 10.925-.862 12.763-6.059.79-2.24.732-4.58.014-6.661",
      fill: "#15375F"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m22.067 9.067.272 1.177-.488 5.685.603-.2 2.312-7.438 3.474-.99c.445-.144.89-.402 1.192-.603-.115-.302-.23-.603-.374-.905-.359 0-.818.03-1.22.13l-3.46.99-5.886-5.096-.618.158 3.432 4.565.402 1.134-3.274.933-8.298 2.886.086.517L18.808 10l3.259-.933Z",
      fill: "#FFC717"
    })));
  };
e4.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, e4.defaultProps = {
  color: "fullColor"
};
var t4 = {
    base: "airbnb-module_base__1iLeo",
    gray: "airbnb-module_gray__3HikV",
    fullColor: "airbnb-module_fullColor__3TzVu"
  },
  n4 = ["color", "className"],
  r4 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, n4);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(t4.base, t4["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "airbnb"), /*#__PURE__*/e.createElement("path", {
      d: "M20.308 15.228c-1.127-1.413-1.79-2.653-2.009-3.713-1.006-3.928 5.028-3.928 4.02 0-.242 1.083-.905 2.322-2.008 3.713h-.003Zm6.168 3.27c-1.878.817-3.736-.486-5.326-2.253 4.638-5.807 2.058-8.929-.842-8.929-2.452 0-3.802 2.076-3.271 4.487.31 1.303 1.126 2.785 2.43 4.442-1.453 1.609-2.703 2.352-3.802 2.451-2.232.332-3.978-1.833-3.183-4.066.674-1.748 4.988-10.32 5.173-10.784.703-1.342 1.141-2.563 2.651-2.563 1.444 0 1.937 1.159 2.695 2.673 1.607 3.153 3.989 7.923 5.127 10.674.588 1.476-.061 3.182-1.652 3.868Zm2.098-6.077C22.82.175 22.502 0 20.308 0c-2.032 0-2.896 1.414-3.78 3.25-4.739 9.478-5.198 10.82-5.238 10.938C10.165 17.283 12.484 20 15.292 20c.969 0 2.706-.27 5.016-2.786 2.62 2.847 4.52 2.786 5.017 2.786 2.807.002 5.127-2.717 4-5.812.001-.174-.75-1.737-.75-1.767h-.001Z",
      fillRule: "nonzero"
    }));
  };
r4.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, r4.defaultProps = {
  color: "fullColor"
};
var o4 = {
    base: "BookingDotCom-module_base__2q5PB",
    gray: "BookingDotCom-module_gray__vLEeb",
    color: "BookingDotCom-module_color__zoofc"
  },
  i4 = ["color", "className"],
  a4 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, i4);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(o4.base, o4["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "bookingdotcom"), /*#__PURE__*/e.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/e.createElement("path", {
      d: "M30.45 3.84C30.45 1.72 28.73 0 26.61 0H13.84C11.722 0 10 1.72 10 3.84v12.32A3.843 3.843 0 0 0 13.84 20h12.77c2.119 0 3.84-1.721 3.84-3.84V3.84Z",
      fill: "#0C3B7C"
    }), /*#__PURE__*/e.createElement("path", {
      fill: "#0C3B7C",
      d: "M10 12.425h10.214V20H10.001z"
    }), /*#__PURE__*/e.createElement("path", {
      d: "m19.294 13.238-1.647-.001v-1.97c0-.42.163-.64.523-.69h1.124c.802 0 1.32.506 1.32 1.323 0 .84-.505 1.337-1.32 1.338Zm-1.647-5.312v-.518c0-.454.192-.67.613-.698h.843c.723 0 1.156.433 1.156 1.157 0 .551-.297 1.195-1.13 1.195h-1.482V7.926Zm3.75 1.966-.297-.168.26-.222c.302-.26.81-.845.81-1.854 0-1.545-1.2-2.542-3.054-2.542H16.76c-.55.02-.99.467-.996 1.02v8.768h3.395c2.061 0 3.392-1.122 3.392-2.86 0-.936-.43-1.736-1.153-2.142",
      fill: "#FFF"
    }), /*#__PURE__*/e.createElement("path", {
      d: "M23.434 13.683a1.209 1.209 0 1 1 2.416 0c0 .669-.543 1.212-1.21 1.212a1.21 1.21 0 0 1-1.206-1.212",
      fill: "#00BAFC"
    })));
  };
a4.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, a4.defaultProps = {
  color: "fullColor"
};
var c4 = {
    base: "Direct-module_base__24CyE",
    gray: "Direct-module_gray__2yvuY",
    fullColor: "Direct-module_fullColor__1hq_6"
  },
  s4 = ["color", "className"],
  l4 = function (t) {
    var n = t.color,
      r = t.className,
      o = S(t, s4);
    return /*#__PURE__*/e.createElement("svg", N({
      width: 40,
      height: 20,
      xmlns: "http://www.w3.org/2000/svg",
      className: tC(c4.base, c4["".concat(n)], r)
    }, o), /*#__PURE__*/e.createElement("title", null, "direct"), /*#__PURE__*/e.createElement("path", {
      d: "m17.172 9.993 1.245-1.248a.86.86 0 0 1 1.217 0l1.244 1.248-1.244 1.247a.86.86 0 0 1-1.217 0l-1.245-1.247Zm1.826 7.814-4.81-4.822 1.89-1.896 1.245 1.248c.939.942 2.466.941 3.404 0l2.34-2.344-2.34-2.344a2.406 2.406 0 0 0-3.404 0l-1.245 1.247-1.857-1.86 4.83-4.842 7.76 7.78-7.813 7.833ZM12.034 7.035l2.95 2.958L12 12.985 18.998 20 29 9.973 19.051 0l-7.017 7.035Z",
      fillRule: "nonzero"
    }));
  };
l4.propTypes = {
  color: g.oneOf(["fullColor", "gray"]),
  className: g.string
}, l4.defaultProps = {
  color: "fullColor"
};
var u4 = function (e) {
  var n = e.source,
    r = e.isGray,
    o = e.className;
  return function () {
    switch (n) {
      case "vrbo":
        return /*#__PURE__*/t.createElement(Z2, {
          color: r ? "gray" : "fullColor",
          className: o
        });
      case "rvshare":
        return /*#__PURE__*/t.createElement(U2, {
          color: r ? "gray" : "fullColor",
          className: o
        });
      case "homeaway":
        return /*#__PURE__*/t.createElement(q2, {
          color: r ? "gray" : "fullColor",
          className: o
        });
      case "expedia":
        return /*#__PURE__*/t.createElement(e4, {
          color: r ? "gray" : "fullColor",
          className: o
        });
      case "airbnb":
        return /*#__PURE__*/t.createElement(r4, {
          color: r ? "gray" : "fullColor",
          className: o
        });
      case "bookingdotcom":
        return /*#__PURE__*/t.createElement(a4, {
          color: r ? "gray" : "fullColor",
          className: o
        });
      default:
        return /*#__PURE__*/t.createElement(l4, {
          color: r ? "gray" : "fullColor",
          className: o
        });
    }
  }();
};
u4.propTypes = {
  source: g.oneOf(["airbnb", "vrbo", "direct", "rvshare", "expedia", "homeaway", "bookingdotcom"]),
  isGray: g.bool,
  className: g.string
};
var d4 = function (e) {
  var n,
    r = e.isGuest,
    o = e.status,
    i = e.headerIcon,
    a = e.headerTitle,
    c = e.messageDate,
    s = e.messageImageSrc,
    l = e.messageTitle,
    u = e.messageSubtitle,
    d = e.messageBody,
    f = e.footerActions,
    p = e.children;
  return /*#__PURE__*/t.createElement(sb, {
    alignItems: "flex-end",
    flexDirection: r ? "row-reverse" : "row",
    justifyContent: "flex-end"
  }, /*#__PURE__*/t.createElement(sb, {
    className: F2.actionMessageWrapper,
    flexDirection: "column"
  }, /*#__PURE__*/t.createElement(sb, {
    justifyContent: "space-between",
    alignItems: "center"
  }, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(MJ, {
    textTransform: "uppercase"
  }, "System Message")), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(MJ, null, c))), /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    justifyContent: "flex-end",
    className: tC(F2.actionMessage, (n = {}, k(n, F2.isGuest, r), k(n, F2["status-".concat(o)], o), n))
  }, a && /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    gap: "xs",
    paddingBottom: "xxs"
  }, i && /*#__PURE__*/t.createElement(nb, {
    className: tC(F2.icon, k({}, F2["status-".concat(o)], o))
  }, i), /*#__PURE__*/t.createElement(nb, {
    flex: "1"
  }, /*#__PURE__*/t.createElement(Vb, {
    weight: "semibold",
    textColor: "dark-gray"
  }, a))), s && /*#__PURE__*/t.createElement(nb, {
    className: F2.image
  }, /*#__PURE__*/t.createElement("img", {
    src: s,
    alt: ""
  })), l && /*#__PURE__*/t.createElement(sb, {
    className: F2.messageTitle
  }, /*#__PURE__*/t.createElement(PW, {
    truncate: !0
  }, l)), u && /*#__PURE__*/t.createElement(sb, {
    className: F2.messageSubtitle
  }, /*#__PURE__*/t.createElement(Vb, {
    weight: "semibold",
    truncate: !0
  }, u)), (l || u) && /*#__PURE__*/t.createElement(Qb, {
    size: "xxs"
  }), d && /*#__PURE__*/t.createElement(nb, {
    className: F2.message
  }, p || /*#__PURE__*/t.createElement(Tb, null, d)), f && /*#__PURE__*/t.createElement(sb, {
    className: F2.buttonsWrapper,
    gap: "xs",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row-reverse"
  }, f.map(function (e, n) {
    return "link" === e.type ? /*#__PURE__*/t.createElement(KJ, {
      key: "action-".concat(n),
      href: e.href,
      size: "dense",
      variation: e.variation || "secondary",
      appearance: e.appearance || "outline",
      openNewTab: e.openNewTab,
      prependIcon: e.prependIcon,
      appendIcon: e.appendIcon
    }, e.label) : /*#__PURE__*/t.createElement(jC, {
      key: "action-".concat(n),
      onClick: e.onClick,
      size: "dense",
      variation: e.variation || "secondary",
      appearance: e.appearance || "outline",
      prependIcon: e.prependIcon,
      appendIcon: e.appendIcon
    }, e.label);
  })))), /*#__PURE__*/t.createElement(sb, {
    style: {
      flexShrink: 0
    }
  }, /*#__PURE__*/t.createElement(Qb, {
    size: "s",
    direction: "horizontal"
  })), /*#__PURE__*/t.createElement(sb, null, /*#__PURE__*/t.createElement(sb, {
    className: F2.avatar,
    justifyContent: "center",
    alignItems: "center"
  }, /*#__PURE__*/t.createElement(u4, {
    source: "direct"
  }))));
};
d4.propTypes = {
  isGuest: g.bool,
  status: g.oneOf(["neutral", "positive", "warning", "negative", "admin"]),
  headerIcon: g.node,
  headerTitle: g.string,
  messageDate: g.string,
  messageImageSrc: g.string,
  messageTitle: g.string,
  messageSubtitle: g.string,
  messageBody: g.oneOfType([g.string, g.node]),
  children: g.any,
  footerActions: g.array
}, d4.defaultProps = {
  status: "neutral",
  isGuest: !1
};
var f4 = {
  wizardWrapper: "Stepper-module_wizardWrapper__6blju",
  contentWrapper: "Stepper-module_contentWrapper__YpU4-",
  content: "Stepper-module_content__6EiCM",
  isScrollable: "Stepper-module_isScrollable__DUYFS",
  "contentSize-s": "Stepper-module_contentSize-s__KwlbY",
  "contentSize-m": "Stepper-module_contentSize-m__CVem7",
  stepDisplay: "Stepper-module_stepDisplay__MVwoS",
  stepLabel: "Stepper-module_stepLabel__1fO64",
  progress: "Stepper-module_progress__qTFOo",
  progressIndicator: "Stepper-module_progressIndicator__mDPGr",
  stepContent: "Stepper-module_stepContent__2arGT"
};
const p4 = () => window,
  m4 = /*#__PURE__*/t.createContext(null),
  h4 = function () {
    let _ref185 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref185$initialStepIn = _ref185.initialStepIndex,
      e = _ref185$initialStepIn === void 0 ? 0 : _ref185$initialStepIn,
      n = _ref185.onChange;
    const _t$useState = t.useState(e),
      _t$useState2 = _slicedToArray(_t$useState, 2),
      r = _t$useState2[0],
      o = _t$useState2[1],
      _t$useState3 = t.useState(e - 1),
      _t$useState4 = _slicedToArray(_t$useState3, 2),
      i = _t$useState4[0],
      a = _t$useState4[1],
      c = [];
    let s = 0;
    t.useEffect(() => {
      const e = p4() ? p4().location.hash.replace("#", "") : void 0,
        t = c.indexOf(e);
      t >= 0 && l(t);
    }, []), t.useEffect(() => {
      if (0 === s) return;
      const e = c.filter(e => !!e),
        t = e.length === s,
        n = 0 === e.length;
      if (t) {
        const e = c[r];
        return o = e, void (p4() && (p4().location.hash = o));
      }
      var o;
      if (n) ;else {
        const e = c.map((e, t) => e ? null : t).filter(e => null !== e);
        console.warn(`You have not specified a title for the steps with the indices: ${e.join(", ")}`);
      }
    }, [r]);
    const l = function (e) {
      let _ref186 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref186$resetMaxStepI = _ref186.resetMaxStepIndex,
        t = _ref186$resetMaxStepI === void 0 ? !1 : _ref186$resetMaxStepI,
        _ref186$skipOnChangeH = _ref186.skipOnChangeHandler,
        c = _ref186$skipOnChangeH === void 0 ? !1 : _ref186$skipOnChangeH;
      if (r !== e) {
        const s = t ? e - 1 : Math.max(r, i);
        n && !c && n({
          previousStepIndex: r,
          newStepIndex: e,
          maxActivatedStepIndex: s
        }), o(e), a(s);
      }
    };
    return {
      activeStepIndex: r,
      maxActivatedStepIndex: i,
      goToStep: l,
      nextStep: () => {
        l(r + 1);
      },
      previousStep: () => {
        l(Math.max(r - 1, 0));
      },
      getStep: function () {
        let _ref187 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          e = _ref187.routeTitle;
        const t = s;
        c.push(e);
        const n = {
          index: t,
          isActive: r === s,
          hasBeenActive: i >= s,
          nextStep: () => l(t + 1),
          previousStep: () => l(Math.max(t - 1, 0)),
          resetToStep: () => l(t, {
            resetMaxStepIndex: !0
          }),
          moveToStep: () => l(t),
          goToStep: e => l(e)
        };
        return s++, n;
      },
      moveToStep: (e, t) => {
        l(e, Object.assign({}, t));
      },
      resetToStep: (e, t) => {
        l(e, Object.assign({
          resetMaxStepIndex: !0
        }, t));
      }
    };
  },
  A4 = e => {
    const n = h4({
      initialStepIndex: e.initialStepIndex,
      onChange: e.onChange
    });
    return /*#__PURE__*/t.createElement(m4.Provider, {
      value: Object.assign({}, n)
    }, "function" == typeof e.children ? e.children(n) : e.children);
  },
  g4 = e => e.children(function () {
    let _ref188 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      e = _ref188.routeTitle;
    const n = t.useContext(m4);
    if (null === n) throw new Error("Wizard Step must be used as a child within a Wizard Component");
    const r = t.useRef(null),
      o = t.useRef(null);
    return r.current !== n && (r.current = n, o.current = n.getStep({
      routeTitle: e
    })), o.current;
  }({
    routeTitle: e.routeTitle
  }));
var v4 = function (e) {
  var n = e.beforeOnNext,
    r = e.beforeOnSkip,
    o = e.beforeOnBack,
    i = e.stepCanBeSkipped,
    a = e.nextStepIndex,
    c = e.previousStepIndex,
    s = e.children;
  return /*#__PURE__*/t.createElement(g4, {
    beforeOnNext: n,
    beforeOnSkip: r,
    beforeOnBack: o,
    stepCanBeSkipped: i,
    nextStepIndex: a,
    previousStepIndex: c
  }, function (e) {
    return e.isActive && /*#__PURE__*/t.createElement(nb, {
      className: f4.stepContent
    }, s);
  });
};
v4.propTypes = {
  beforeOnNext: g.func,
  beforeOnBack: g.func,
  stepCanBeSkipped: g.bool,
  nextStepIndex: g.number,
  previousStepIndex: g.number,
  beforeOnSkip: g.func,
  children: g.node
}, v4.defaultProps = {};
var C4 = function (e) {
  var o = e.activeStepIndex,
    i = e.stepCount,
    a = e.horizontalPadding,
    c = V(n(0), 2),
    s = c[0],
    l = c[1];
  return r(function () {
    var e = (o + 1) / i * 100;
    0 === s ? setTimeout(function () {
      l(e);
    }, 300) : l(e);
  }, [o]), /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    paddingVertical: "s",
    paddingHorizontal: a,
    className: f4.stepDisplay
  }, /*#__PURE__*/t.createElement(nb, {
    className: f4.stepLabel
  }, "".concat(o + 1, " of ").concat(i)), /*#__PURE__*/t.createElement(Qb, {
    direction: "horizontal"
  }), /*#__PURE__*/t.createElement(sb, {
    flexGrow: 1
  }, /*#__PURE__*/t.createElement(nb, {
    className: f4.progress
  }, /*#__PURE__*/t.createElement(nb, {
    className: f4.progressIndicator,
    style: {
      width: "".concat(s, "%")
    }
  }))));
};
C4.propTypes = {
  horizontalPadding: g.oneOf(["s", "m"])
}, C4.defaultProps = {
  horizontalPadding: "s"
};
var b4 = "WizardActionBar-module_footer__3MSJX",
  E4 = "WizardActionBar-module_addShadow__2p8Mb",
  y4 = "WizardActionBar-module_progressWrapper__13vqh",
  I4 = function (e) {
    var n = e.backButtonLabel,
      r = e.backButtonOnClick,
      o = e.backButtonIsDisabled,
      i = e.nextButtonLabel,
      a = e.nextButtonOnClick,
      c = e.nextButtonIsDisabled,
      s = e.showSkipButton,
      l = e.skipButtonLabel,
      u = e.skipButtonOnClick,
      d = e.showFinishButton,
      f = e.finishButtonLabel,
      p = e.finishButtonOnClick,
      m = e.finishButtonIsDisabled,
      h = e.addShadow,
      A = e.emphasizeButtons,
      g = e.horizontalPadding,
      v = e.verticalPadding,
      C = e.stepProgress;
    return /*#__PURE__*/t.createElement(sb, {
      justifyContent: "space-between",
      paddingVertical: v,
      paddingHorizontal: g,
      className: tC(b4, k({}, E4, h))
    }, C && /*#__PURE__*/t.createElement(nb, {
      className: y4
    }, /*#__PURE__*/t.createElement(lb, {
      progress: C
    })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(jC, {
      onClick: r,
      variation: "secondary",
      appearance: "outline",
      isDisabled: o,
      size: A ? "large" : "default"
    }, n)), /*#__PURE__*/t.createElement(sb, null, s && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(jC, {
      onClick: u,
      appearance: "ghost",
      variation: "secondary",
      size: A ? "large" : "default"
    }, l), /*#__PURE__*/t.createElement(Qb, {
      size: "xs",
      direction: "horizontal"
    })), d ? /*#__PURE__*/t.createElement(jC, {
      onClick: p,
      isDisabled: m,
      size: A ? "large" : "default"
    }, f) : /*#__PURE__*/t.createElement(jC, {
      onClick: a,
      isDisabled: c,
      size: A ? "large" : "default"
    }, i)));
  };
I4.propTypes = {
  backButtonLabel: g.string,
  backButtonOnClick: g.func,
  backButtonIsDisabled: g.bool,
  nextButtonLabel: g.string,
  nextButtonOnClick: g.func,
  nextButtonIsDisabled: g.bool,
  showSkipButton: g.bool,
  skipButtonLabel: g.string,
  skipButtonOnClick: g.func,
  showFinishButton: g.bool,
  finishButtonLabel: g.string,
  finishButtonOnClick: g.func,
  finishButtonIsDisabled: g.bool,
  addShadow: g.bool,
  emphasizeButtons: g.bool,
  horizontalPadding: g.oneOf(["s", "m"]),
  verticalPadding: g.oneOf(["xs", "s"]),
  stepProgress: g.number
}, I4.defaultProps = {
  backButtonLabel: "Back",
  skipButtonLabel: "Skip",
  nextButtonLabel: "Next",
  finishButtonLabel: "Finish",
  showSkipButton: !1,
  showFinishButton: !1,
  verticalPadding: "xs",
  horizontalPadding: "s"
};
var B4 = function (e) {
  var n = e.initialStepIndex,
    r = e.onChange,
    o = e.backLabel,
    i = e.nextLabel,
    a = e.finishLabel,
    c = e.onFinish,
    s = e.disableAdvanceButton,
    l = e.contentIsScrollable,
    u = e.children,
    d = e.removeProgress,
    f = e.contentSize,
    p = e.footerHorizontalPadding,
    m = e.progressHorizontalPadding,
    h = e.contentHorizontalPadding,
    A = t.Children.count(u),
    g = t.Children.toArray(u);
  return /*#__PURE__*/t.createElement(A4, {
    initialStepIndex: n,
    onChange: r
  }, function (e) {
    var n,
      r = e.activeStepIndex,
      v = e.previousStep,
      C = e.nextStep,
      b = e.goToStep,
      E = g[r].props,
      y = E.nextStepIndex,
      I = E.previousStepIndex,
      B = E.beforeOnNext,
      x = E.beforeOnPrev,
      w = E.beforeOnSkip,
      Q = E.stepCanBeSkipped;
    return /*#__PURE__*/t.createElement(sb, {
      flexDirection: "column",
      className: f4.wizardWrapper
    }, !d && /*#__PURE__*/t.createElement(C4, {
      activeStepIndex: r,
      stepCount: A,
      horizontalPadding: m
    }), /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1,
      className: f4.contentWrapper,
      flexDirection: "column"
    }, /*#__PURE__*/t.createElement(sb, {
      flexGrow: 1,
      paddingHorizontal: h,
      flexDirection: "column",
      alignItems: "flex-start",
      className: tC(f4.content, (n = {}, k(n, f4.isScrollable, l), k(n, f4["size-".concat(f)], f), n))
    }, "auto" === f ? /*#__PURE__*/t.createElement(t.Fragment, null, u) : /*#__PURE__*/t.createElement(nb, {
      className: f4["contentSize-".concat(f)]
    }, u))), /*#__PURE__*/t.createElement(I4, {
      backButtonOnClick: function () {
        x && x(), I || 0 === I ? b(I) : v();
      },
      backButtonIsDisabled: 0 === r,
      backButtonLabel: o,
      showSkipButton: Q,
      skipButtonOnClick: function () {
        w && w(), C();
      },
      showFinishButton: r === A - 1,
      finishButtonOnClick: c,
      finishButtonIsDisabled: s,
      finishButtonLabel: a,
      nextButtonOnClick: function () {
        B && B(), y ? b(y) : C();
      },
      nextButtonIsDisabled: s,
      nextButtonLabel: i,
      addShadow: !0,
      horizontalPadding: p
    }));
  });
};
B4.propTypes = {
  initialStepIndex: g.number,
  onChange: g.func,
  onFinish: g.func,
  backLabel: g.string,
  nextLabel: g.string,
  finishLabel: g.string,
  contentIsScrollable: g.bool,
  children: g.node,
  disableAdvanceButton: g.bool,
  removeProgress: g.bool,
  contentSize: g.oneOf(["auto", "s", "m"]),
  footerHorizontalPadding: g.oneOf(["s", "m"]),
  progressHorizontalPadding: g.oneOf(["s", "m"]),
  contentHorizontalPadding: g.oneOf(["s", "m"])
}, B4.defaultProps = {
  backLabel: "Back",
  nextLabel: "Next",
  finishLabel: "Finish",
  contentIsScrollable: !1,
  contentSize: "auto",
  footerHorizontalPadding: "s",
  progressHorizontalPadding: "s",
  contentHorizontalPadding: "s"
}, B4.Step = v4;
var x4 = "FinancialLineItems-module_lineItem__12W3c",
  w4 = "FinancialLineItems-module_isTotal__13R7X",
  Q4 = "FinancialLineItems-module_isSubItem__gwHxu",
  H4 = "FinancialLineItems-module_controlWrapper__1dqhN",
  z4 = "FinancialLineItems-module_controlButton__YpcC0",
  M4 = "FinancialLineItems-module_label__24agq",
  k4 = "FinancialLineItems-module_value__1LdZY",
  N4 = "FinancialLineItems-module_negative__1X4Y4",
  S4 = function (e, t, n) {
    return new Intl.NumberFormat(n || void 0, {
      style: "currency",
      currency: t || "USD"
    }).format(e);
  },
  V4 = function (e) {
    var r = e.lineItem,
      o = e.currencyOptions,
      i = e.alignControls,
      a = V(n(!1), 2),
      c = a[0],
      s = a[1],
      l = Vb,
      u = Tb;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
      className: tC(x4, k({}, w4, r.isTotal)),
      gap: "xs",
      flexDirection: "left" === i ? "row" : "row-reverse",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(nb, {
      className: tC(H4)
    }, r.subItems && /*#__PURE__*/t.createElement(RC, {
      renderAs: "button",
      type: "button",
      className: tC(z4),
      onClick: function () {
        s(!c);
      }
    }, /*#__PURE__*/t.createElement(qv, {
      name: "chevronDown",
      rotation: c ? 180 : 0
    }))), /*#__PURE__*/t.createElement(sb, {
      flex: "1",
      alignItems: "center",
      gap: "xs"
    }, /*#__PURE__*/t.createElement(sb, {
      flex: "1"
    }, /*#__PURE__*/t.createElement(l, {
      className: tC(M4, k({}, w4, r.isTotal)),
      weight: r.isTotal ? "semibold" : "regular"
    }, r.label)), r.isNegative && /*#__PURE__*/t.createElement(nb, {
      className: N4
    }, /*#__PURE__*/t.createElement(qv, {
      name: "minus",
      iconStyle: "regular"
    })), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(u, {
      weight: "monospace",
      className: tC(k4, k({}, w4, r.isTotal))
    }, S4(r.value, null == o ? void 0 : o.code, null == o ? void 0 : o.locale))))), r.subItems && c && /*#__PURE__*/t.createElement(t.Fragment, null, r.subItems.map(function (e, n) {
      return /*#__PURE__*/t.createElement(sb, {
        key: "sub-item-".concat(n),
        className: tC(x4, Q4),
        paddingLeft: "m",
        alignItems: "center"
      }, /*#__PURE__*/t.createElement(Qb, {
        size: "xxs",
        direction: "horizontal"
      }), /*#__PURE__*/t.createElement(sb, {
        flex: "1",
        paddingLeft: "xs"
      }, /*#__PURE__*/t.createElement(l, {
        weight: "regular",
        className: M4
      }, e.label)), /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(u, {
        weight: "monospace",
        className: k4
      }, S4(e.value, null == o ? void 0 : o.code, null == o ? void 0 : o.locale))));
    })));
  };
V4.propTypes = {
  lineItem: g.object.isRequired,
  currencyOptions: g.object,
  alignControls: g.oneOf(["left", "right"])
};
var L4 = function (e) {
  var n = e.lineItems,
    r = e.currencyOptions,
    o = e.alignControls;
  return n.map(function (e, n) {
    return /*#__PURE__*/t.createElement(V4, {
      key: "line-item-".concat(n),
      lineItem: e,
      currencyOptions: r,
      alignControls: o
    });
  });
};
L4.propTypes = {
  lineItems: g.array.isRequired,
  currencyOptions: g.object,
  alignControls: g.oneOf(["left", "right"])
}, L4.defaultProps = {
  alignControls: "left"
};
var P4 = {
    navbarWrapper: "Navbar-module_navbarWrapper__2Ewos",
    navbar: "Navbar-module_navbar__xJML3",
    navbarRight: "Navbar-module_navbarRight__wndw2",
    linkMenuColumn: "Navbar-module_linkMenuColumn__2Yf6g",
    rightBorder: "Navbar-module_rightBorder__24tdB",
    linkMenuGroup: "Navbar-module_linkMenuGroup__CpFnd",
    removeBottomMargin: "Navbar-module_removeBottomMargin__2i2Ky",
    groupTitle: "Navbar-module_groupTitle__21trF",
    mobileMenuButton: "Navbar-module_mobileMenuButton__3hhBU",
    mobileNavBarPanel: "Navbar-module_mobileNavBarPanel__Eery0",
    addShadow: "Navbar-module_addShadow__1hbEb",
    scrollContent: "Navbar-module_scrollContent__mebRi"
  },
  O4 = {
    navbarIconLink: "NavbarIconLink-module_navbarIconLink__7Exxo",
    "icon-size-m": "NavbarIconLink-module_icon-size-m__37bmh",
    "icon-size-l": "NavbarIconLink-module_icon-size-l__thEAs",
    isActive: "NavbarIconLink-module_isActive__NsLX7",
    isButton: "NavbarIconLink-module_isButton__2VM3C",
    isBrand: "NavbarIconLink-module_isBrand__1L2DQ",
    brand: "NavbarIconLink-module_brand__T0elG"
  },
  T4 = function (e) {
    var n,
      i = e.iconName,
      a = e.iconStyle,
      c = e.iconSize,
      s = e.type,
      l = e.href,
      u = e.isBrand,
      d = e.onClick,
      f = e.onClickOutside,
      p = e.openInNewTab,
      m = e.isActive,
      h = e.id,
      A = e.className,
      g = o(null),
      v = GC(g).isOutsideClick;
    r(function () {
      f && f(v);
    }, [v]);
    var C,
      b,
      E,
      y = u ? /*#__PURE__*/t.createElement(oC, {
        className: O4.brand
      }) : /*#__PURE__*/t.createElement(qv, {
        name: i,
        iconStyle: a
      });
    return "button" === s ? /*#__PURE__*/t.createElement(RC, {
      id: h,
      renderAs: "button",
      type: "button",
      domRef: g,
      className: tC(O4.navbarIconLink, O4.isButton, (C = {}, k(C, O4.isActive, m), k(C, O4["icon-size-".concat(c)], c), k(C, O4.isBrand, u), C), A),
      onClick: d
    }, y) : "router-hash-link" === s ? /*#__PURE__*/t.createElement(hZ, {
      id: h,
      to: l,
      onClick: d || null,
      className: tC(O4.navbarIconLink, (b = {}, k(b, O4["icon-size-".concat(c)], c), k(b, O4.isBrand, u), b), A),
      activeClassName: O4.isActive,
      isActive: m || null
    }, y) : "link" === s ? /*#__PURE__*/t.createElement(RC, {
      renderAs: "a",
      id: h,
      href: l,
      className: tC(O4.navbarIconLink, (E = {}, k(E, O4.isActive, m), k(E, O4["icon-size-".concat(c)], c), k(E, O4.isBrand, u), E), A),
      target: p ? "_blank" : void 0,
      rel: p ? "noreferrer nofollow" : void 0
    }, y) : /*#__PURE__*/t.createElement(w, {
      id: h,
      to: l,
      onClick: d || null,
      className: tC(O4.navbarIconLink, (n = {}, k(n, O4.isActive, m), k(n, O4["icon-size-".concat(c)], c), k(n, O4.isBrand, u), n), A)
    }, y);
  };
T4.propTypes = {
  iconName: g.string,
  iconStyle: g.oneOf(["solid", "regular", "light", "duotone"]),
  iconSize: g.oneOf(["m", "l"]),
  type: g.oneOf(["link", "router-link", "button", "router-hash-link"]),
  href: g.string,
  isBrand: g.bool,
  onClick: g.func,
  onClickOutside: g.func,
  openInNewTab: g.bool,
  isActive: g.bool,
  id: g.string,
  className: g.string
}, T4.defaultProps = {
  iconSize: "m",
  iconStyle: "solid"
};
var D4 = function (e) {
  var n = e.children,
    r = e.homeLink,
    o = e.homeLinkOnClick,
    i = Lb().isLargeDesktop;
  return /*#__PURE__*/t.createElement(sb, {
    className: P4.navbarLeft,
    gap: "xxs"
  }, /*#__PURE__*/t.createElement(T4, {
    href: r,
    onClick: o,
    isBrand: !0
  }), i && /*#__PURE__*/t.createElement(t.Fragment, null, n));
};
D4.propTypes = {
  children: g.any,
  homeLink: g.string,
  homeLinkOnClick: g.func
}, D4.defaultProps = {
  homeLink: "/"
};
var R4 = function (e) {
  var n = e.children,
    r = e.onMobileClick,
    o = e.toggleMobileIcon,
    i = Lb().isLargeDesktop;
  return /*#__PURE__*/t.createElement(sb, {
    justifyContent: "flex-end",
    className: P4.navbarRight
  }, n, !i && /*#__PURE__*/t.createElement(T4, {
    className: P4.mobileMenuButton,
    type: "button",
    iconName: o ? "times" : "bars",
    onClick: r
  }));
};
R4.propTypes = {
  children: g.any,
  onMobileClick: g.func,
  toggleMobileIcon: g.bool
};
var G4 = {
    navbarLink: "NavbarLink-module_navbarLink__1X7v1",
    "variation-primary": "NavbarLink-module_variation-primary__28RkT",
    isActive: "NavbarLink-module_isActive__14ptX",
    "variation-secondary": "NavbarLink-module_variation-secondary__3DvNy",
    "variation-featured": "NavbarLink-module_variation-featured__2t1of",
    featuredIcon: "NavbarLink-module_featuredIcon__B20bg",
    featuredLabel: "NavbarLink-module_featuredLabel__2Mmq6",
    featuredCaption: "NavbarLink-module_featuredCaption__24Rz2",
    isButton: "NavbarLink-module_isButton__2BvNT"
  },
  F4 = function (e) {
    var n,
      i,
      a,
      c = e.children,
      s = e.linkType,
      l = e.variation,
      u = e.featuredProps,
      d = e.href,
      f = e.onClick,
      p = e.onClickOutside,
      m = e.openInNewTab,
      h = e.isActive,
      A = e.id,
      g = e.className,
      v = o(null),
      C = GC(v).isOutsideClick,
      b = function () {
        return /*#__PURE__*/t.createElement(sb, {
          alignItems: "center"
        }, u.iconName && /*#__PURE__*/t.createElement(nb, {
          className: G4.featuredIcon
        }, /*#__PURE__*/t.createElement(qv, {
          name: u.iconName,
          iconStyle: "duotone"
        })), /*#__PURE__*/t.createElement(nb, {
          flex: "1"
        }, /*#__PURE__*/t.createElement(Vb, {
          className: G4.featuredLabel,
          weight: "semibold",
          isFullWidth: !0
        }, c), u.description && /*#__PURE__*/t.createElement(MJ, {
          className: G4.featuredCaption,
          isFullWidth: !0
        }, u.description)));
      };
    return r(function () {
      p && p(C);
    }, [C]), "button" === s ? /*#__PURE__*/t.createElement(RC, {
      id: A,
      renderAs: "button",
      type: "button",
      domRef: v,
      className: tC(G4.navbarLink, G4.isButton, g, (i = {}, k(i, G4.isActive, h), k(i, G4["variation-".concat(l)], l), i)),
      onClick: f
    }, "featured" === l ? b() : /*#__PURE__*/t.createElement(t.Fragment, null, c)) : "router-hash-link" === s ? /*#__PURE__*/t.createElement(hZ, {
      id: A,
      to: d,
      onClick: f || null,
      className: tC(G4.navbarLink, k({}, G4["variation-".concat(l)], l), g),
      activeClassName: G4.isActive,
      isActive: h || null
    }, "featured" === l ? b() : /*#__PURE__*/t.createElement(t.Fragment, null, c)) : "link" === s ? /*#__PURE__*/t.createElement(RC, {
      renderAs: "a",
      id: A,
      href: d,
      className: tC(G4.navbarLink, g, (a = {}, k(a, G4.isActive, h), k(a, G4["variation-".concat(l)], l), a)),
      target: m ? "_blank" : void 0,
      rel: m ? "noreferrer nofollow" : void 0
    }, "featured" === l ? b() : /*#__PURE__*/t.createElement(t.Fragment, null, c)) : /*#__PURE__*/t.createElement(w, {
      id: A,
      to: d,
      onClick: f || null,
      className: tC(G4.navbarLink, g, (n = {}, k(n, G4.isActive, h), k(n, G4["variation-".concat(l)], l), n))
    }, "featured" === l ? b() : /*#__PURE__*/t.createElement(t.Fragment, null, c));
  };
F4.propTypes = {
  children: g.any,
  linkType: g.oneOf(["link", "router-link", "button", "router-hash-link"]),
  variation: g.oneOf(["primary", "secondary", "featured"]),
  featuredProps: g.object,
  href: g.string,
  onClick: g.func,
  onClickOutside: g.func,
  openInNewTab: g.bool,
  isActive: g.bool,
  id: g.string,
  className: g.string
}, F4.defaultProps = {
  linkType: "router-link",
  isActive: !1,
  variation: "primary"
};
var j4 = {
    linkMenu: "NavbarLinkMenu-module_linkMenu__3Zg_N",
    linkMenuHoverController: "NavbarLinkMenu-module_linkMenuHoverController__3Roha",
    linkMenuPanel: "NavbarLinkMenu-module_linkMenuPanel__3WwZt",
    "align-left": "NavbarLinkMenu-module_align-left__pEmzV",
    "align-right": "NavbarLinkMenu-module_align-right__2ZBRc",
    "align-center": "NavbarLinkMenu-module_align-center__2LD8a",
    primaryIcon: "NavbarLinkMenu-module_primaryIcon__15uVI",
    activeState: "NavbarLinkMenu-module_activeState__3s4fl"
  },
  J4 = function (e) {
    var o = e.primaryLinkType,
      i = e.primaryLinkText,
      a = e.primaryLinkProps,
      c = e.children,
      s = e.menuTrigger,
      l = e.alignPanel,
      u = e.showMenuPanel,
      d = e.onPanelClickOutside,
      f = V(n(u || !1), 2),
      p = f[0],
      m = f[1],
      h = V(n(!1), 2),
      A = h[0],
      g = h[1],
      v = Lb().isLargeDesktop;
    r(function () {
      m(u);
    }, [u]);
    return /*#__PURE__*/t.createElement(RC, {
      className: j4.linkMenu
    }, "navbarIconLink" === o ? /*#__PURE__*/t.createElement(T4, a) : /*#__PURE__*/t.createElement(F4, N({}, a, {
      className: tC(a.className, k({}, j4.activeState, p)),
      linkType: "click" === s ? "button" : null == a ? void 0 : a.type,
      onClickOutside: function (e) {
        g(e);
      }
    }), i, /*#__PURE__*/t.createElement(nb, {
      renderAs: "span",
      display: "inline-block",
      paddingLeft: "xs",
      className: j4.primaryIcon
    }, /*#__PURE__*/t.createElement(qv, {
      name: "chevronDown"
    }))), "hover" === s && /*#__PURE__*/t.createElement(ob, {
      className: tC(j4.linkMenuPanel, j4.linkMenuHoverController, k({}, j4["align-".concat(l)], l)),
      addShadow: !0,
      paddingLeft: "s"
    }, c), "click" === s && p && /*#__PURE__*/t.createElement(ob, {
      className: tC(j4.linkMenuPanel, k({}, j4["align-".concat(l)], l)),
      onClickOutside: function () {
        A && d && d();
      },
      addShadow: !0,
      paddingLeft: v ? "s" : "xxs",
      paddingRight: v ? null : "xxs"
    }, c));
  };
J4.propTypes = {
  primaryLinkText: g.string,
  primaryLinkType: v(["navbarLink", "navbarIconLink"]),
  primaryLinkProps: g.any,
  children: g.any,
  menuTrigger: g.oneOf(["hover", "click"]),
  alignPanel: g.oneOf(["left", "right", "center"]),
  showMenuPanel: g.bool,
  onPanelClickOutside: g.func
}, J4.defaultProps = {
  primaryLinkType: "navbarLink",
  menuTrigger: "click",
  alignPanel: "left"
};
var Z4 = function (e) {
  var n = e.children,
    r = e.addRightBorder;
  return /*#__PURE__*/t.createElement(nb, {
    className: tC(P4.linkMenuColumn, k({}, P4.rightBorder, r))
  }, n);
};
Z4.propTypes = {
  children: g.any,
  addRightBorder: g.bool
};
var W4 = function (e) {
  var n = e.groupTitle,
    r = e.children,
    o = e.removeBottomMargin;
  return /*#__PURE__*/t.createElement(t.Fragment, null, n && /*#__PURE__*/t.createElement(MJ, {
    textTransform: "uppercase",
    className: P4.groupTitle
  }, n), /*#__PURE__*/t.createElement(nb, {
    className: tC(P4.linkMenuGroup, k({}, P4.removeBottomMargin, o))
  }, r));
};
W4.propTypes = {
  groupTitle: g.string,
  children: g.node,
  removeBottomMargin: g.bool
};
var X4 = function (e) {
  var n = e.reveal,
    r = e.children,
    o = Lb(),
    i = o.isLargeDesktop,
    a = o.height,
    c = o.isMobile,
    s = o.width;
  return !i && n ? /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    className: tC(P4.mobileNavBarPanel, k({}, P4.addShadow, n)),
    style: c ? {
      height: a - 56,
      width: s
    } : {
      height: a - 56
    }
  }, /*#__PURE__*/t.createElement(sb, {
    padding: "s",
    flexDirection: "column",
    className: P4.scrollContent
  }, r)) : /*#__PURE__*/t.createElement(t.Fragment, null);
};
X4.propTypes = {
  children: g.any,
  reveal: g.bool
};
var U4 = "NavbarSearch-module_wrapper__1R3QW",
  K4 = "NavbarSearch-module_resultsWrapper__LheJt",
  Y4 = "NavbarSearch-module_reveal__kdrUo",
  q4 = "NavbarSearch-module_searchItem__icon__3phe3",
  _4 = "NavbarSearch-module_makeBlue__BETky",
  $4 = "NavbarSearch-module_small__35Vce",
  e3 = "NavbarSearch-module_searchItem__item__3OUji",
  t3 = "NavbarSearch-module_button__2SUY7",
  n3 = "NavbarSearch-module_subduedState__KnBIX",
  r3 = "NavbarSearch-module_mobileSearchNavCover__3n1oq",
  o3 = "NavbarSearch-module_mobileSearch__31g8j",
  i3 = "NavbarSearch-module_mobileSearchContent__2xYRv",
  a3 = "NavbarSearch-module_addShadow__1f5sk",
  c3 = function (e) {
    var n = e.iconName,
      r = e.headline,
      o = e.description,
      i = e.type,
      a = e.href,
      c = e.onClick,
      s = e.openNewTab,
      l = e.title,
      u = function () {
        return /*#__PURE__*/t.createElement(sb, {
          alignItems: "center",
          gap: "xs",
          paddingVertical: "xs",
          paddingHorizontal: "xs"
        }, /*#__PURE__*/t.createElement(sb, {
          className: tC(q4, k({}, _4, "button" === i || "link" === i)),
          justifyContent: "center",
          alignItems: "center"
        }, /*#__PURE__*/t.createElement(qv, {
          name: n,
          iconStyle: "duotone"
        })), /*#__PURE__*/t.createElement(sb, {
          flex: "1",
          flexDirection: "column",
          style: {
            minWidth: 0
          }
        }, /*#__PURE__*/t.createElement(Vb, {
          textColor: "dark-gray",
          weight: "semibold",
          truncate: !0
        }, r), o && /*#__PURE__*/t.createElement(MJ, {
          textColor: "light-gray"
        }, o)), a && /*#__PURE__*/t.createElement(sb, {
          className: tC(q4, _4, $4),
          justifyContent: "center",
          alignItems: "center"
        }, /*#__PURE__*/t.createElement(qv, {
          name: "chevronRight"
        })));
      };
    return "router-link" === i ? /*#__PURE__*/t.createElement(w, {
      to: a,
      className: tC(e3, k({}, t3, "button" === i)),
      onClick: c
    }, u()) : "button" === i ? /*#__PURE__*/t.createElement(RC, {
      renderAs: "button",
      onClick: c,
      className: tC(e3, t3)
    }, u()) : "link" === i ? /*#__PURE__*/t.createElement(RC, {
      renderAs: "a",
      className: e3,
      href: a,
      target: s ? "_blank" : void 0,
      rel: s ? "noreferrer nofollow" : void 0,
      title: l
    }, u()) : u();
  };
c3.propTypes = {
  iconName: g.string,
  headline: g.string,
  description: g.string,
  type: g.oneOf(["router-link", "link", "button", "item"]),
  openNewTab: g.bool,
  title: g.string
};
var s3 = function (e) {
  var n = e.tips;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(rk, {
    title: "Search Tips"
  }), /*#__PURE__*/t.createElement(nb, {
    paddingHorizontal: "xxs",
    paddingBottom: "s",
    style: {
      marginTop: -8
    }
  }, n.map(function (e, n) {
    return /*#__PURE__*/t.createElement(c3, {
      key: "search-item-".concat(n),
      iconName: e.iconName,
      headline: e.headline,
      description: e.description
    });
  })));
};
s3.propTypes = {
  tips: g.array
};
var l3 = function (e) {
  var n = e.tips;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
    paddingHorizontal: "s",
    paddingTop: "s",
    paddingBottom: "xs"
  }, /*#__PURE__*/t.createElement(Vb, null, "Filter your search above and use the tips below to fine tune your search")), /*#__PURE__*/t.createElement(s3, {
    tips: n
  }));
};
l3.propTypes = {
  tips: g.array
};
var u3 = function (e) {
  var n = e.results,
    r = e.searchTerm,
    o = e.closePanel;
  return n ? 0 === n.length ? /*#__PURE__*/t.createElement(nb, {
    padding: "xs"
  }, /*#__PURE__*/t.createElement(H1, {
    iconProps: {
      name: "emptySet"
    },
    headline: 'No Results Found for "'.concat(r, '"'),
    description: "Please check your spelling or try the hints below"
  })) : n.map(function (e, n) {
    return /*#__PURE__*/t.createElement(t.Fragment, {
      key: "result-".concat(n)
    }, /*#__PURE__*/t.createElement(rk, {
      title: "".concat(e.category, " | ").concat(e.totalCount, " Result(s)"),
      removeTopMargin: !0,
      removeTopBorder: 0 === n
    }), /*#__PURE__*/t.createElement(nb, {
      paddingHorizontal: "xxs",
      paddingBottom: "s",
      style: {
        marginTop: -8
      }
    }, e.results.map(function (n, r) {
      return /*#__PURE__*/t.createElement(c3, {
        key: r,
        headline: n.headline,
        description: n.description,
        iconName: e.iconName,
        type: n.type,
        href: n.href,
        onClick: function () {
          n.onClick && n.onClick(), o();
        }
      });
    }), e.totalCount > 5 && /*#__PURE__*/t.createElement(KJ, {
      href: e.seeAllHref,
      appearance: "ghost",
      appendIcon: /*#__PURE__*/t.createElement(qv, {
        name: "longArrowRight"
      }),
      isFullWidth: !0,
      textAlign: "left",
      onClick: o
    }, "See All Results")));
  }) : null;
};
u3.propTypes = {
  results: g.array,
  searchTerm: g.string
};
var d3 = function (e) {
  var i = e.inputTextProps,
    a = e.inputSelectProps,
    c = e.tips,
    s = e.results,
    l = e.searchTerm,
    u = e.isSearching,
    d = e.onSearchClose,
    f = o(null),
    p = V(n(!1), 2),
    m = p[0],
    h = p[1],
    A = GC(f).isOutsideClick;
  return r(function () {
    !m && d && d();
  }, [m]), r(function () {
    m && h(!1);
  }, [A]), /*#__PURE__*/t.createElement(sb, {
    flex: "1",
    className: U4,
    flexDirection: "column",
    justifyContent: "center",
    setPositionRelative: !0,
    domRef: f
  }, /*#__PURE__*/t.createElement(W$, {
    selectWidth: 130,
    isDense: !0,
    inputSelectProps: m ? a : null,
    inputTextProps: z(z({}, i), {}, {
      placeholder: "Search...",
      onFocus: function (e) {
        h(!0), i.onFocus && i.onFocus(e);
      }
    }),
    width: "auto",
    removeBottomSpacer: !0,
    containerClassName: m ? null : n3,
    isSubtle: !m
  }), /*#__PURE__*/t.createElement(ob, {
    addShadow: !0,
    className: tC(K4, k({}, Y4, m))
  }, /*#__PURE__*/t.createElement(nb, {
    flexDirection: "column"
  }, !u && !s && c && /*#__PURE__*/t.createElement(l3, {
    tips: c
  }), u && /*#__PURE__*/t.createElement(nb, {
    padding: "xs"
  }, /*#__PURE__*/t.createElement(H1, {
    iconProps: {
      name: "spinner",
      spin: !0
    },
    headline: "Searching for ".concat(l),
    description: "We’ll display your results momentarily"
  })), !u && s && /*#__PURE__*/t.createElement(u3, {
    results: s,
    searchTerm: l,
    closePanel: function () {
      h(!1);
    }
  }))));
};
d3.propTypes = {};
var f3 = function (e) {
  var o = e.inputTextProps,
    i = e.inputSelectProps,
    a = e.tips,
    c = e.results,
    s = e.searchTerm,
    l = e.isSearching,
    u = e.onMobileClick,
    d = e.onSearchClose,
    f = V(n(!1), 2),
    p = f[0],
    m = f[1];
  return r(function () {
    !p && d && d();
  }, [p]), /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(T4, {
    onClick: function () {
      m(!0), u && u();
    },
    iconName: "search",
    type: "button"
  }), p && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    justifyContent: "space-between",
    className: r3,
    paddingLeft: "s",
    paddingRight: "xs"
  }, /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(TW, {
    textColor: "disabled"
  }, "Global Search")), /*#__PURE__*/t.createElement(T4, {
    type: "button",
    onClick: function () {
      m(!1), u && u();
    },
    iconName: "times"
  })), /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    className: o3
  }, /*#__PURE__*/t.createElement(nb, {
    padding: "s",
    setPositionRelative: !0,
    className: a3
  }, /*#__PURE__*/t.createElement(W$, {
    selectWidth: 125,
    isDense: !0,
    inputSelectProps: p ? i : null,
    inputTextProps: z(z({}, o), {}, {
      placeholder: "Search...",
      onFocus: function (e) {
        m(!0), o.onFocus && o.onFocus(e);
      }
    }),
    width: "auto",
    removeBottomSpacer: !0,
    containerClassName: p ? null : n3,
    isSubtle: !p
  })), /*#__PURE__*/t.createElement(Hb, null), /*#__PURE__*/t.createElement(nb, {
    flex: "1",
    flexDirection: "column",
    className: i3
  }, !l && !c && a && /*#__PURE__*/t.createElement(l3, {
    tips: a
  }), l && /*#__PURE__*/t.createElement(nb, {
    padding: "xs"
  }, /*#__PURE__*/t.createElement(H1, {
    iconProps: {
      name: "spinner",
      spin: !0
    },
    headline: "Searching for ".concat(s),
    description: "We’ll display your results momentarily"
  })), !l && c && /*#__PURE__*/t.createElement(u3, {
    results: c,
    searchTerm: s,
    closePanel: function () {
      m(!1);
    }
  })))));
};
f3.propTypes = {};
var p3 = function (e) {
  return Lb().isMobile ? /*#__PURE__*/t.createElement(f3, e) : /*#__PURE__*/t.createElement(d3, e);
};
p3.propTypes = {
  searchTerm: g.string,
  inputSelectProps: g.object,
  inputTextProps: g.object,
  tips: g.array,
  results: g.array,
  isSearching: g.bool,
  onMobileClick: g.func,
  onSearchClose: g.func
}, p3.defaultProps = {};
var m3 = function (e) {
  var n = e.children,
    r = Lb(),
    o = r.isMobile,
    i = r.width;
  return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
    renderAs: "nav",
    className: P4.navbarWrapper,
    style: o ? {
      width: i
    } : {}
  }, /*#__PURE__*/t.createElement(RJ, {
    variation: "fluid"
  }, /*#__PURE__*/t.createElement(sb, {
    alignItems: "center",
    className: P4.navbar,
    gap: "s"
  }, n))), /*#__PURE__*/t.createElement(Qb, {
    size: "s"
  }), /*#__PURE__*/t.createElement(Qb, {
    size: "l"
  }));
};
m3.propTypes = {
  children: g.any
}, m3.Left = D4, m3.Right = R4, m3.Mobile = X4, m3.Link = F4, m3.IconLink = T4, m3.LinkMenu = J4, m3.LinkMenuColumn = Z4, m3.LinkMenuGroup = W4, m3.Search = p3;
var h3 = "Wizard-module_wizard__Osiq4",
  A3 = "Wizard-module_navPanel__1BJeV",
  g3 = "Wizard-module_mobileReveal__1QG8Q",
  v3 = "Wizard-module_logo__3eQKG",
  C3 = "Wizard-module_headline__1F95n",
  b3 = "Wizard-module_navPanelContent__-cKua",
  E3 = "Wizard-module_stepPanel__2OJAG",
  y3 = "Wizard-module_stepContentWrapper__3ptpZ",
  I3 = "Wizard-module_stepContentHeader__31jXg",
  B3 = "Wizard-module_stepContent__Gegl9",
  x3 = "Wizard-module_asidePanel__3lN-R",
  w3 = "Wizard-module_hideAside__1eJNZ",
  Q3 = function (e) {
    var n = e.children;
    return /*#__PURE__*/t.createElement(t.Fragment, null, n);
  };
Q3.propTypes = {
  children: g.any
}, Q3.displayName = "AsidePanel";
var H3 = function (e) {
  var n = e.children,
    r = e.beforeOnNext,
    o = e.beforeOnSkip,
    i = e.beforeOnBack,
    a = e.stepCanBeSkipped,
    c = e.nextStepIndex,
    s = e.previousStepIndex;
  return /*#__PURE__*/t.createElement(B4.Step, {
    beforeOnBack: i,
    beforeOnNext: r,
    beforeOnSkip: o,
    nextStepIndex: c,
    previousStepIndex: s,
    stepCanBeSkipped: a
  }, /*#__PURE__*/t.createElement(nb, null, n));
};
H3.propTypes = {
  children: g.any,
  groupTitle: g.string,
  stepTitle: g.string,
  asidePanelIndex: g.number,
  beforeOnNext: g.func,
  beforeOnBack: g.func,
  stepCanBeSkipped: g.bool,
  nextStepIndex: g.number,
  previousStepIndex: g.number,
  beforeOnSkip: g.func
}, H3.defaultProps = {};
var z3 = "WizardNavLink-module_navLink__1JXay",
  M3 = "WizardNavLink-module_isDisabled__WgF2k",
  k3 = "WizardNavLink-module_isActive__2kObV",
  N3 = "WizardNavLink-module_iconChevron__oC-ec",
  S3 = "WizardNavLink-module_iconProgress__3DL4y",
  V3 = "WizardNavLink-module_isComplete__ZPhy5",
  L3 = function (e) {
    var o,
      i,
      a = e.variation,
      c = e.label,
      s = e.isDisabled,
      l = e.isActive,
      u = e.isComplete,
      d = e.onClick,
      f = e.groupIsOpen,
      p = V(n(null), 2),
      m = p[0],
      h = p[1];
    return r(function () {
      h("group-link" === a ? u ? "circleCheck" : "lock" : u ? "circleCheck" : "exclamationTriangle");
    }, [u]), /*#__PURE__*/t.createElement(RC, {
      renderAs: "button",
      className: tC(z3, (o = {}, k(o, M3, s), k(o, k3, l), o)),
      onClick: d,
      disabled: s
    }, /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      gap: "xs"
    }, "group-link" === a && /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(nb, {
      className: tC(N3)
    }, /*#__PURE__*/t.createElement(qv, {
      name: "chevronDown"
    })), /*#__PURE__*/t.createElement(Qb, {
      size: "xxs"
    })), /*#__PURE__*/t.createElement(nb, {
      flex: "1"
    }, /*#__PURE__*/t.createElement(Tb, {
      weight: "semibold"
    }, c)), m && !f && /*#__PURE__*/t.createElement(nb, {
      className: tC(S3, (i = {}, k(i, M3, s), k(i, V3, u), i))
    }, /*#__PURE__*/t.createElement(qv, {
      name: m
    }))));
  };
L3.propTypes = {
  variation: g.oneOf(["group-link", "link"]),
  label: g.string,
  isDisabled: g.bool,
  isActive: g.bool,
  isComplete: g.bool,
  onClick: g.func,
  groupIsOpen: g.bool
}, L3.defaultProps = {
  variation: "link"
};
var P3 = function (e) {
  var o = e.children,
    i = e.groupTitle,
    a = e.groupSteps,
    c = e.completedSteps,
    s = e.currentStep,
    l = V(n(!1), 2),
    u = l[0],
    d = l[1],
    f = V(n(!1), 2),
    p = f[0],
    m = f[1],
    h = V(n(!0), 2),
    A = h[0],
    g = h[1];
  return r(function () {
    a.includes(s) && !u && d(!0);
  }, [s]), r(function () {
    var e = a.length,
      t = 0;
    a.forEach(function (e) {
      c.includes(e) && t++;
    }), m(e === t);
  }, [c]), r(function () {
    (c.includes(s) || a.includes(s)) && g(!1);
  }, [s, c]), /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(L3, {
    variation: "group-link",
    label: i,
    onClick: function () {
      return d(!u);
    },
    isComplete: p,
    groupIsOpen: u,
    isDisabled: A
  }), u && /*#__PURE__*/t.createElement(nb, {
    style: {
      paddingLeft: 28
    }
  }, o));
};
P3.propTypes = {
  children: g.any,
  groupTitle: g.string,
  groupSteps: g.array,
  completedSteps: g.array,
  currentStep: g.number
}, P3.defaultProps = {};
var O3 = function (e) {
  var n = e.saveAndExitOnClick,
    r = e.title,
    o = e.currentStep,
    i = e.stepNavLinks,
    a = e.onClick,
    c = e.completedSteps,
    s = e.openNavPanelMobile,
    l = e.logoLink,
    u = function (e, n) {
      return /*#__PURE__*/t.createElement(L3, {
        key: "wizard-nav-link-".concat(n),
        label: e.label,
        isActive: o === e.stepIndex,
        isDisabled: o < e.stepIndex && !c.includes(e.stepIndex),
        isComplete: c.includes(e.stepIndex),
        onClick: function () {
          return a(e.stepIndex);
        }
      });
    };
  return /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    className: tC(A3, k({}, g3, s))
  }, /*#__PURE__*/t.createElement(sb, {
    flexDirection: "column",
    className: b3
  }, /*#__PURE__*/t.createElement(sb, {
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: "xs",
    paddingLeft: "m",
    paddingRight: "s"
  }, /*#__PURE__*/t.createElement(nb, null, "link" === (null == l ? void 0 : l.type) ? /*#__PURE__*/t.createElement("a", {
    href: (null == l ? void 0 : l.href) || "/"
  }, /*#__PURE__*/t.createElement(sb, {
    justifyContent: "center",
    alignItems: "center",
    className: v3
  }, /*#__PURE__*/t.createElement(oC, {
    appearance: "purple"
  }))) : /*#__PURE__*/t.createElement(w, {
    to: (null == l ? void 0 : l.href) || "/"
  }, /*#__PURE__*/t.createElement(sb, {
    justifyContent: "center",
    alignItems: "center",
    className: v3
  }, /*#__PURE__*/t.createElement(oC, {
    appearance: "purple"
  })))), n && /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(jC, {
    onClick: function () {},
    variation: "secondary",
    appearance: "ghost"
  }, "Save & Exit"))), /*#__PURE__*/t.createElement(Qb, null), /*#__PURE__*/t.createElement(nb, {
    paddingHorizontal: "m"
  }, /*#__PURE__*/t.createElement(TW, {
    className: C3
  }, r)), /*#__PURE__*/t.createElement(Qb, {
    size: "m"
  }), /*#__PURE__*/t.createElement(nb, {
    paddingHorizontal: "s"
  }, i.length > 0 && i.map(function (e, n) {
    return e.subLinks ? /*#__PURE__*/t.createElement(P3, {
      key: "group-".concat(n),
      groupTitle: e.groupTitle,
      groupSteps: e.subLinks.map(function (e) {
        return e.stepIndex;
      }),
      completedSteps: c,
      currentStep: o
    }, e.subLinks.map(function (e, t) {
      return u(e, t);
    })) : u(e, n);
  }))));
};
O3.propTypes = {
  saveAndExitOnClick: g.func,
  title: g.string,
  currentStep: g.number,
  stepNavLinks: g.array,
  onClick: g.func,
  completedSteps: g.array,
  openNavPanelMobile: g.bool,
  logoLink: g.object
}, O3.defaultProps = {};
var T3 = function (e) {
  return /*#__PURE__*/t.createElement(t.Fragment, null, e.children);
};
T3.displayName = "StepPanel";
var D3 = function (e) {
  return /*#__PURE__*/t.createElement(t.Fragment, null, e.children);
};
D3.displayName = "WizardAside";
var R3 = function (e) {
  var o = e.wizardOnChange,
    i = e.wizardTitle,
    a = e.wizardOnFinish,
    c = e.initialStepIndex,
    s = e.currentStep,
    l = e.completedSteps,
    u = e.navLinkOnClick,
    d = e.navSaveAndExitOnClick,
    f = e.logoLinkProps,
    p = e.disableNextButton,
    m = e.finishButtonLabel,
    h = e.children,
    A = Lb().isLargeDesktop,
    g = V(n([]), 2),
    v = g[0],
    C = g[1],
    b = V(n([]), 2),
    E = b[0],
    y = b[1],
    I = V(n(null), 2),
    B = I[0],
    x = I[1],
    w = V(n(!1), 2),
    Q = w[0],
    H = w[1],
    z = V(n(!1), 2),
    M = z[0],
    N = z[1];
  return r(function () {
    t.Children.toArray(h).forEach(function (e) {
      if ("StepPanel" === e.type.displayName && e.props.children) {
        y(e.props.children);
        var t = [];
        e.props.children.forEach(function (e, n) {
          if (e.props.groupTitle) {
            var r = e.props.groupTitle,
              o = null;
            t.filter(function (e, t) {
              if (e.groupTitle === r) return o = t, !0;
            }).length > 0 ? t[o] = {
              groupTitle: r,
              subLinks: [].concat(L(t[o].subLinks), [{
                stepIndex: n,
                label: e.props.stepTitle
              }])
            } : t.push({
              groupTitle: r,
              subLinks: [{
                stepIndex: n,
                label: e.props.stepTitle
              }]
            });
          } else t.push({
            stepIndex: n,
            label: e.props.stepTitle
          });
        }), C(t);
      }
      "AsidePanel" === e.type.displayName && x(e.props.children);
    });
  }, []), E.length > 0 ? /*#__PURE__*/t.createElement(A4, {
    initialStepIndex: c,
    onChange: o
  }, function (e) {
    var n = e.activeStepIndex,
      r = e.previousStep,
      o = e.nextStep,
      c = e.goToStep,
      h = E.length,
      g = E[n].props,
      C = g.nextStepIndex,
      b = g.previousStepIndex,
      y = g.beforeOnNext,
      I = g.beforeOnPrev,
      x = g.beforeOnSkip,
      w = g.stepCanBeSkipped,
      z = g.stepTitle,
      S = g.asidePanelIndex;
    return /*#__PURE__*/t.createElement(t.Fragment, null, /*#__PURE__*/t.createElement(sb, {
      className: h3
    }, /*#__PURE__*/t.createElement(O3, {
      logoLink: f,
      currentStep: s,
      saveAndExitOnClick: d,
      title: i,
      stepNavLinks: v,
      completedSteps: l,
      onClick: function (e) {
        u && u(e), c(e);
      },
      openNavPanelMobile: Q
    }), /*#__PURE__*/t.createElement(sb, {
      className: tC(E3, k({}, g3, Q)),
      flex: "1",
      flexDirection: "column"
    }, /*#__PURE__*/t.createElement(sb, {
      flex: "1",
      flexDirection: "column",
      className: y3
    }, /*#__PURE__*/t.createElement(sb, {
      className: I3,
      justifyContent: "space-between",
      alignItems: "center"
    }, /*#__PURE__*/t.createElement(sb, {
      alignItems: "center",
      gap: "s"
    }, /*#__PURE__*/t.createElement(GJ, {
      hideStartingFrom: "tablet"
    }, /*#__PURE__*/t.createElement(WC, {
      onClick: function () {
        H(!Q);
      },
      variation: "secondary",
      appearance: "outline"
    }, /*#__PURE__*/t.createElement(qv, {
      name: "bars"
    }))), /*#__PURE__*/t.createElement(Vb, {
      weight: "bold",
      textColor: "disabled"
    }, "".concat(n + 1, ":  ").concat(z))), B && A && /*#__PURE__*/t.createElement(nb, null, /*#__PURE__*/t.createElement(WC, {
      onClick: function () {
        N(!M);
      },
      variation: "secondary",
      appearance: "ghost",
      size: "dense"
    }, /*#__PURE__*/t.createElement(qv, {
      name: M ? "chevronLeft" : "chevronRight"
    })))), /*#__PURE__*/t.createElement(nb, {
      className: B3
    }, E)), /*#__PURE__*/t.createElement(I4, {
      backButtonOnClick: function () {
        I && I(), b || 0 === b ? c(b) : r();
      },
      backButtonIsDisabled: 0 === n,
      showSkipButton: w,
      skipButtonOnClick: function () {
        x && x(), o();
      },
      showFinishButton: n === h - 1,
      finishButtonOnClick: a,
      nextButtonOnClick: function () {
        y && y(), C ? c(C) : o();
      },
      emphasizeButtons: !0,
      verticalPadding: "s",
      horizontalPadding: "m",
      stepProgress: (s + 1) / h * 100,
      nextButtonIsDisabled: p,
      finishButtonIsDisabled: p,
      finishButtonLabel: m
    })), B && A && /*#__PURE__*/t.createElement(sb, {
      className: tC(x3, k({}, w3, M)),
      flexDirection: "column"
    }, B.length > 0 ? S ? B[S] : B[0] : B)));
  }) : /*#__PURE__*/t.createElement(t.Fragment, null);
};
R3.propTypes = {
  wizardOnChange: g.func,
  wizardTitle: g.string,
  wizardOnFinish: g.func,
  initialStepIndex: g.number,
  currentStep: g.number,
  completedSteps: g.array,
  navLinkOnClick: g.func,
  navSaveAndExitOnClick: g.func,
  logoLinkProps: g.object,
  disableNextButton: g.bool,
  finishButtonLabel: g.string,
  children: g.any
}, R3.defaultProps = {}, R3.AsidePanel = Q3, R3.Aside = D3, R3.StepPanel = T3, R3.Step = H3, R3.StepGroup = P3;
export { XJ as AspectRatioBox, UC as Avatar, QZ as Badge, __ as BottomSheet, nb as Box, b$ as CallToActionBar, jC as CallToActionButton, KJ as CallToActionLink, PC as ChannelLogo, e$ as CheckboxGrid, i$ as ConfirmDialog, RJ as Container, Db as DisplayLineItem, Hb as Divider, u$ as Dropdown, v1 as EditableInlineInput, g1 as EditableLineItem, x1 as FileUploadTray, L4 as FinancialLineItems, sb as FlexBox, JJ as FlexBoxGrid, f$ as FormField, p$ as FormFieldGridRow, rk as FormGroupHeader, U1 as GlobalSearch, Bb as IconBadge, WC as IconButton, qv as IconFontAwesome, xZ as IconLink, d4 as InboxActionMessage, i2 as InboxAttachmentPreview, a2 as InboxChatBubble, B2 as InboxConversationItem, P2 as InboxConversationItemEmpty, u4 as InboxSource, I2 as InboxStatus, G2 as InboxTextarea, zZ as InfoPanel, A$ as InputButtonGroup, dk as InputButtonSelect, Xb as InputCheckbox, mE as InputCurrency, pk as InputDate, AE as InputDateRange, xE as InputIncrementer, SE as InputNumber, px as InputPhoneNumber, VM as InputRadioButton, Dj as InputRichTextarea, lM as InputSelect, kJ as InputSlider, tk as InputSwitch, vM as InputText, kM as InputTextarea, yk as InputTime, qb as InputWrapper, YM as Label, qJ as ListItemLink, nC as Logo, oC as Logomark, y$ as Modal, B$ as NavBar, IZ as NavIconLink, m3 as Navbar, YC as Overlay, J$ as PageHeader, H1 as PageStateMessage, ob as Panel, Yb as Pill, h1 as PopoverForm, lb as ProgressBar, vb as ProgressCircle, N$ as RadioButtonGrid, W$ as SearchBar, R$ as SideTabBar, f1 as SlideoutPanel, Qb as Spacer, m1 as StandByOverlay, B4 as Stepper, vZ as Tab, M$ as TabBar, yb as Table, Vb as TextBody, MJ as TextCaption, Tb as TextDense, SW as TextH1, PW as TextH2, MW as TextMicro, TW as TextTitle, QW as Toast, Pj as Tooltip, GJ as VisibilityHelper, R3 as Wizard };